//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, o) => (o = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function f(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var p = {}, m = [], h = () => {}, g = () => !1, _ = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), v = (e) => e.startsWith("onUpdate:"), y = Object.assign, b = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, x = Object.prototype.hasOwnProperty, S = (e, t) => x.call(e, t), C = Array.isArray, w = (e) => ie(e) === "[object Map]", T = (e) => ie(e) === "[object Set]", E = (e) => ie(e) === "[object Date]", ee = (e) => ie(e) === "[object RegExp]", D = (e) => typeof e == "function", O = (e) => typeof e == "string", te = (e) => typeof e == "symbol", k = (e) => typeof e == "object" && !!e, ne = (e) => (k(e) || D(e)) && D(e.then) && D(e.catch), re = Object.prototype.toString, ie = (e) => re.call(e), ae = (e) => ie(e).slice(8, -1), A = (e) => ie(e) === "[object Object]", oe = (e) => O(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, se = /* @__PURE__ */ f(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"), ce = (e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
}, le = /-\w/g, j = ce((e) => e.replace(le, (e) => e.slice(1).toUpperCase())), ue = /\B([A-Z])/g, de = ce((e) => e.replace(ue, "-$1").toLowerCase()), fe = ce((e) => e.charAt(0).toUpperCase() + e.slice(1)), pe = ce((e) => e ? `on${fe(e)}` : ""), me = (e, t) => !Object.is(e, t), he = (e, ...t) => {
	for (let n = 0; n < e.length; n++) e[n](...t);
}, ge = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, _e = (e) => {
	let t = parseFloat(e);
	return isNaN(t) ? e : t;
}, ve = (e) => {
	let t = O(e) ? Number(e) : NaN;
	return isNaN(t) ? e : t;
}, ye, be = () => ye ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}, xe = /* @__PURE__ */ f("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol");
function Se(e) {
	if (C(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = O(r) ? Ee(r) : Se(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	}
	if (O(e) || k(e)) return e;
}
var Ce = /;(?![^(]*\))/g, we = /:([^]+)/, Te = /\/\*[^]*?\*\//g;
function Ee(e) {
	let t = {};
	return e.replace(Te, "").split(Ce).forEach((e) => {
		if (e) {
			let n = e.split(we);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function M(e) {
	let t = "";
	if (O(e)) t = e;
	else if (C(e)) for (let n = 0; n < e.length; n++) {
		let r = M(e[n]);
		r && (t += r + " ");
	}
	else if (k(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
function De(e) {
	if (!e) return null;
	let { class: t, style: n } = e;
	return t && !O(t) && (e.class = M(t)), n && (e.style = Se(n)), e;
}
var Oe = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", ke = /* @__PURE__ */ f(Oe);
Oe + "";
function Ae(e) {
	return !!e || e === "";
}
function je(e, t) {
	if (e.length !== t.length) return !1;
	let n = !0;
	for (let r = 0; n && r < e.length; r++) n = Me(e[r], t[r]);
	return n;
}
function Me(e, t) {
	if (e === t) return !0;
	let n = E(e), r = E(t);
	if (n || r) return n && r ? e.getTime() === t.getTime() : !1;
	if (n = te(e), r = te(t), n || r) return e === t;
	if (n = C(e), r = C(t), n || r) return n && r ? je(e, t) : !1;
	if (n = k(e), r = k(t), n || r) {
		if (!n || !r || Object.keys(e).length !== Object.keys(t).length) return !1;
		for (let n in e) {
			let r = e.hasOwnProperty(n), i = t.hasOwnProperty(n);
			if (r && !i || !r && i || !Me(e[n], t[n])) return !1;
		}
	}
	return String(e) === String(t);
}
function Ne(e, t) {
	return e.findIndex((e) => Me(e, t));
}
var Pe = (e) => !!(e && e.__v_isRef === !0), N = (e) => O(e) ? e : e == null ? "" : C(e) || k(e) && (e.toString === re || !D(e.toString)) ? Pe(e) ? N(e.value) : JSON.stringify(e, Fe, 2) : String(e), Fe = (e, t) => Pe(t) ? Fe(e, t.value) : w(t) ? { [`Map(${t.size})`]: [...t.entries()].reduce((e, [t, n], r) => (e[Ie(t, r) + " =>"] = n, e), {}) } : T(t) ? { [`Set(${t.size})`]: [...t.values()].map((e) => Ie(e)) } : te(t) ? Ie(t) : k(t) && !C(t) && !A(t) ? String(t) : t, Ie = (e, t = "") => te(e) ? `Symbol(${e.description ?? t})` : e;
function Le(e) {
	return e == null ? "initial" : typeof e == "string" ? e === "" ? " " : e : String(e);
}
//#endregion
//#region node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var Re, ze = class {
	constructor(e = !1) {
		this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e && Re && (Re.active ? (this.parent = Re, this.index = (Re.scopes || (Re.scopes = [])).push(this) - 1) : (this._active = !1, this._warnOnRun = !1));
	}
	get active() {
		return this._active;
	}
	pause() {
		if (this._active) {
			this._isPaused = !0;
			let e, t;
			if (this.scopes) {
				let n = this.scopes.slice();
				for (e = 0, t = n.length; e < t; e++) n[e].pause();
			}
			for (e = 0, t = this.effects.length; e < t; e++) this.effects[e].pause();
		}
	}
	resume() {
		if (this._active && this._isPaused) {
			this._isPaused = !1;
			let e, t;
			if (this.scopes) {
				let n = this.scopes.slice();
				for (e = 0, t = n.length; e < t; e++) n[e].resume();
			}
			let n = this.effects.slice();
			for (e = 0, t = n.length; e < t; e++) n[e].resume();
		}
	}
	run(e) {
		if (this._active) {
			let t = Re;
			try {
				return Re = this, e();
			} finally {
				Re = t;
			}
		}
	}
	on() {
		++this._on === 1 && (this.prevScope = Re, Re = this);
	}
	off() {
		if (this._on > 0 && --this._on === 0) {
			if (Re === this) Re = this.prevScope;
			else {
				let e = Re;
				for (; e;) {
					if (e.prevScope === this) {
						e.prevScope = this.prevScope;
						break;
					}
					e = e.prevScope;
				}
			}
			this.prevScope = void 0;
		}
	}
	stop(e) {
		if (this._active) {
			this._active = !1;
			let t, n;
			for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].stop();
			for (this.effects.length = 0, t = 0, n = this.cleanups.length; t < n; t++) this.cleanups[t]();
			if (this.cleanups.length = 0, this.scopes) {
				let e = this.scopes.slice();
				for (t = 0, n = e.length; t < n; t++) e[t].stop(!0);
				this.scopes.length = 0;
			}
			if (!this.detached && this.parent && !e) {
				let e = this.parent.scopes.pop();
				e && e !== this && (this.parent.scopes[this.index] = e, e.index = this.index);
			}
			this.parent = void 0;
		}
	}
};
function Be(e) {
	return new ze(e);
}
function Ve() {
	return Re;
}
function He(e, t = !1) {
	Re && Re.cleanups.push(e);
}
var Ue, We = /* @__PURE__ */ new WeakSet(), Ge = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Re && (Re.active ? Re.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, We.has(this) && (We.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Ye(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, ut(this), Qe(this);
		let e = Ue, t = ot;
		Ue = this, ot = !0;
		try {
			return this.fn();
		} finally {
			$e(this), Ue = e, ot = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) nt(e);
			this.deps = this.depsTail = void 0, ut(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? We.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		et(this) && this.run();
	}
	get dirty() {
		return et(this);
	}
}, Ke = 0, qe, Je;
function Ye(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Je, Je = e;
		return;
	}
	e.next = qe, qe = e;
}
function Xe() {
	Ke++;
}
function Ze() {
	if (--Ke > 0) return;
	if (Je) {
		let e = Je;
		for (Je = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; qe;) {
		let t = qe;
		for (qe = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function Qe(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function $e(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), nt(r), rt(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function et(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (tt(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function tt(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === dt) || (e.globalVersion = dt, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !et(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = Ue, r = ot;
	Ue = e, ot = !0;
	try {
		Qe(e);
		let n = e.fn(e._value);
		(t.version === 0 || me(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		Ue = n, ot = r, $e(e), e.flags &= -3;
	}
}
function nt(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) nt(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function rt(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
function it(e, t) {
	e.effect instanceof Ge && (e = e.effect.fn);
	let n = new Ge(e);
	t && y(n, t);
	try {
		n.run();
	} catch (e) {
		throw n.stop(), e;
	}
	let r = n.run.bind(n);
	return r.effect = n, r;
}
function at(e) {
	e.effect.stop();
}
var ot = !0, st = [];
function ct() {
	st.push(ot), ot = !1;
}
function lt() {
	let e = st.pop();
	ot = e === void 0 || e;
}
function ut(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = Ue;
		Ue = void 0;
		try {
			t();
		} finally {
			Ue = e;
		}
	}
}
var dt = 0, ft = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, pt = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
	}
	track(e) {
		if (!Ue || !ot || Ue === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== Ue) t = this.activeLink = new ft(Ue, this), Ue.deps ? (t.prevDep = Ue.depsTail, Ue.depsTail.nextDep = t, Ue.depsTail = t) : Ue.deps = Ue.depsTail = t, mt(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = Ue.depsTail, t.nextDep = void 0, Ue.depsTail.nextDep = t, Ue.depsTail = t, Ue.deps === t && (Ue.deps = e);
		}
		return t;
	}
	trigger(e) {
		this.version++, dt++, this.notify(e);
	}
	notify(e) {
		Xe();
		try {
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Ze();
		}
	}
};
function mt(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) mt(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
	}
}
var ht = /* @__PURE__ */ new WeakMap(), gt = /* @__PURE__ */ Symbol(""), _t = /* @__PURE__ */ Symbol(""), vt = /* @__PURE__ */ Symbol("");
function yt(e, t, n) {
	if (ot && Ue) {
		let t = ht.get(e);
		t || ht.set(e, t = /* @__PURE__ */ new Map());
		let r = t.get(n);
		r || (t.set(n, r = new pt()), r.map = t, r.key = n), r.track();
	}
}
function bt(e, t, n, r, i, a) {
	let o = ht.get(e);
	if (!o) {
		dt++;
		return;
	}
	let s = (e) => {
		e && e.trigger();
	};
	if (Xe(), t === "clear") o.forEach(s);
	else {
		let i = C(e), a = i && oe(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === vt || !te(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(vt)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(gt)), w(e) && s(o.get(_t)));
				break;
			case "delete":
				i || (s(o.get(gt)), w(e) && s(o.get(_t)));
				break;
			case "set": w(e) && s(o.get(gt));
		}
	}
	Ze();
}
function xt(e, t) {
	let n = ht.get(e);
	return n && n.get(t);
}
function St(e) {
	let t = /* @__PURE__ */ pn(e);
	return t === e ? t : (yt(t, "iterate", vt), /* @__PURE__ */ dn(e) ? t : t.map(hn));
}
function Ct(e) {
	return yt(e = /* @__PURE__ */ pn(e), "iterate", vt), e;
}
function wt(e, t) {
	return /* @__PURE__ */ un(e) ? gn(/* @__PURE__ */ ln(e) ? hn(t) : t) : hn(t);
}
var Tt = {
	__proto__: null,
	[Symbol.iterator]() {
		return Et(this, Symbol.iterator, (e) => wt(this, e));
	},
	concat(...e) {
		return St(this).concat(...e.map((e) => C(e) ? St(e) : e));
	},
	entries() {
		return Et(this, "entries", (e) => (e[1] = wt(this, e[1]), e));
	},
	every(e, t) {
		return Ot(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return Ot(this, "filter", e, t, (e) => e.map((e) => wt(this, e)), arguments);
	},
	find(e, t) {
		return Ot(this, "find", e, t, (e) => wt(this, e), arguments);
	},
	findIndex(e, t) {
		return Ot(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return Ot(this, "findLast", e, t, (e) => wt(this, e), arguments);
	},
	findLastIndex(e, t) {
		return Ot(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return Ot(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return At(this, "includes", e);
	},
	indexOf(...e) {
		return At(this, "indexOf", e);
	},
	join(e) {
		return St(this).join(e);
	},
	lastIndexOf(...e) {
		return At(this, "lastIndexOf", e);
	},
	map(e, t) {
		return Ot(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return jt(this, "pop");
	},
	push(...e) {
		return jt(this, "push", e);
	},
	reduce(e, ...t) {
		return kt(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return kt(this, "reduceRight", e, t);
	},
	shift() {
		return jt(this, "shift");
	},
	some(e, t) {
		return Ot(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return jt(this, "splice", e);
	},
	toReversed() {
		return St(this).toReversed();
	},
	toSorted(e) {
		return St(this).toSorted(e);
	},
	toSpliced(...e) {
		return St(this).toSpliced(...e);
	},
	unshift(...e) {
		return jt(this, "unshift", e);
	},
	values() {
		return Et(this, "values", (e) => wt(this, e));
	}
};
function Et(e, t, n) {
	let r = Ct(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ dn(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var Dt = Array.prototype;
function Ot(e, t, n, r, i, a) {
	let o = Ct(e), s = o !== e && !/* @__PURE__ */ dn(e), c = o[t];
	if (c !== Dt[t]) {
		let t = c.apply(e, a);
		return s ? hn(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, wt(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function kt(e, t, n, r) {
	let i = Ct(e), a = i !== e && !/* @__PURE__ */ dn(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = wt(e, t)), n.call(this, t, wt(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? wt(e, c) : c;
}
function At(e, t, n) {
	let r = /* @__PURE__ */ pn(e);
	yt(r, "iterate", vt);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ fn(n[0]) ? (n[0] = /* @__PURE__ */ pn(n[0]), r[t](...n)) : i;
}
function jt(e, t, n = []) {
	ct(), Xe();
	let r = (/* @__PURE__ */ pn(e))[t].apply(e, n);
	return Ze(), lt(), r;
}
var Mt = /* @__PURE__ */ f("__proto__,__v_isRef,__isVue"), Nt = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(te));
function Pt(e) {
	te(e) || (e = String(e));
	let t = /* @__PURE__ */ pn(this);
	return yt(t, "has", e), t.hasOwnProperty(e);
}
var Ft = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? tn : en : i ? $t : Qt).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = C(e);
		if (!r) {
			let e;
			if (a && (e = Tt[t])) return e;
			if (t === "hasOwnProperty") return Pt;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ _n(e) ? e : n);
		if ((te(t) ? Nt.has(t) : Mt(t)) || (r || yt(e, "get", t), i)) return o;
		if (/* @__PURE__ */ _n(o)) {
			let e = a && oe(t) ? o : o.value;
			return r && k(e) ? /* @__PURE__ */ on(e) : e;
		}
		return k(o) ? r ? /* @__PURE__ */ on(o) : /* @__PURE__ */ rn(o) : o;
	}
}, It = class extends Ft {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = C(e) && oe(t);
		if (!this._isShallow) {
			let e = /* @__PURE__ */ un(i);
			if (!/* @__PURE__ */ dn(n) && !/* @__PURE__ */ un(n) && (i = /* @__PURE__ */ pn(i), n = /* @__PURE__ */ pn(n)), !a && /* @__PURE__ */ _n(i) && !/* @__PURE__ */ _n(n)) return e || (i.value = n), !0;
		}
		let o = a ? Number(t) < e.length : S(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ _n(e) ? e : r);
		return e === /* @__PURE__ */ pn(r) && s && (o ? me(n, i) && bt(e, "set", t, n, i) : bt(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = S(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && bt(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!te(t) || !Nt.has(t)) && yt(e, "has", t), n;
	}
	ownKeys(e) {
		return yt(e, "iterate", C(e) ? "length" : gt), Reflect.ownKeys(e);
	}
}, Lt = class extends Ft {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return !0;
	}
	deleteProperty(e, t) {
		return !0;
	}
}, Rt = /* @__PURE__ */ new It(), zt = /* @__PURE__ */ new Lt(), Bt = /* @__PURE__ */ new It(!0), Vt = /* @__PURE__ */ new Lt(!0), Ht = (e) => e, Ut = (e) => Reflect.getPrototypeOf(e);
function Wt(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ pn(i), o = w(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? Ht : t ? gn : hn;
		return !t && yt(a, "iterate", c ? _t : gt), y(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function Gt(e) {
	return function(...t) {
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function Kt(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ pn(r), a = /* @__PURE__ */ pn(n);
			e || (me(n, a) && yt(i, "get", n), yt(i, "get", a));
			let { has: o } = Ut(i), s = t ? Ht : e ? gn : hn;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && yt(/* @__PURE__ */ pn(t), "iterate", gt), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ pn(n), i = /* @__PURE__ */ pn(t);
			return e || (me(t, i) && yt(r, "has", t), yt(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ pn(a), s = t ? Ht : e ? gn : hn;
			return !e && yt(o, "iterate", gt), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return y(n, e ? {
		add: Gt("add"),
		set: Gt("set"),
		delete: Gt("delete"),
		clear: Gt("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ pn(this), r = Ut(n), i = /* @__PURE__ */ pn(e), a = !t && !/* @__PURE__ */ dn(e) && !/* @__PURE__ */ un(e) ? i : e;
			return r.has.call(n, a) || me(e, a) && r.has.call(n, e) || me(i, a) && r.has.call(n, i) || (n.add(a), bt(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ dn(n) && !/* @__PURE__ */ un(n) && (n = /* @__PURE__ */ pn(n));
			let r = /* @__PURE__ */ pn(this), { has: i, get: a } = Ut(r), o = i.call(r, e);
			o ||= (e = /* @__PURE__ */ pn(e), i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? me(n, s) && bt(r, "set", e, n, s) : bt(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ pn(this), { has: n, get: r } = Ut(t), i = n.call(t, e);
			i ||= (e = /* @__PURE__ */ pn(e), n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && bt(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ pn(this), t = e.size !== 0, n = e.clear();
			return t && bt(e, "clear", void 0, void 0, void 0), n;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = Wt(r, e, t);
	}), n;
}
function qt(e, t) {
	let n = Kt(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(S(n, r) && r in t ? n : t, r, i);
}
var Jt = { get: /* @__PURE__ */ qt(!1, !1) }, Yt = { get: /* @__PURE__ */ qt(!1, !0) }, Xt = { get: /* @__PURE__ */ qt(!0, !1) }, Zt = { get: /* @__PURE__ */ qt(!0, !0) }, Qt = /* @__PURE__ */ new WeakMap(), $t = /* @__PURE__ */ new WeakMap(), en = /* @__PURE__ */ new WeakMap(), tn = /* @__PURE__ */ new WeakMap();
function nn(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function rn(e) {
	return /* @__PURE__ */ un(e) ? e : cn(e, !1, Rt, Jt, Qt);
}
// @__NO_SIDE_EFFECTS__
function an(e) {
	return cn(e, !1, Bt, Yt, $t);
}
// @__NO_SIDE_EFFECTS__
function on(e) {
	return cn(e, !0, zt, Xt, en);
}
// @__NO_SIDE_EFFECTS__
function sn(e) {
	return cn(e, !0, Vt, Zt, tn);
}
function cn(e, t, n, r, i) {
	if (!k(e) || e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = nn(ae(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function ln(e) {
	return /* @__PURE__ */ un(e) ? /* @__PURE__ */ ln(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function un(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function dn(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function fn(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function pn(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ pn(t) : e;
}
function mn(e) {
	return !S(e, "__v_skip") && Object.isExtensible(e) && ge(e, "__v_skip", !0), e;
}
var hn = (e) => k(e) ? /* @__PURE__ */ rn(e) : e, gn = (e) => k(e) ? /* @__PURE__ */ on(e) : e;
// @__NO_SIDE_EFFECTS__
function _n(e) {
	return e ? e.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function P(e) {
	return yn(e, !1);
}
// @__NO_SIDE_EFFECTS__
function vn(e) {
	return yn(e, !0);
}
function yn(e, t) {
	return /* @__PURE__ */ _n(e) ? e : new bn(e, t);
}
var bn = class {
	constructor(e, t) {
		this.dep = new pt(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : /* @__PURE__ */ pn(e), this._value = t ? e : hn(e), this.__v_isShallow = t;
	}
	get value() {
		return this.dep.track(), this._value;
	}
	set value(e) {
		let t = this._rawValue, n = this.__v_isShallow || /* @__PURE__ */ dn(e) || /* @__PURE__ */ un(e);
		e = n ? e : /* @__PURE__ */ pn(e), me(e, t) && (this._rawValue = e, this._value = n ? e : hn(e), this.dep.trigger());
	}
};
function xn(e) {
	e.dep && e.dep.trigger();
}
function F(e) {
	return /* @__PURE__ */ _n(e) ? e.value : e;
}
function Sn(e) {
	return D(e) ? e() : F(e);
}
var Cn = {
	get: (e, t, n) => t === "__v_raw" ? e : F(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ _n(i) && !/* @__PURE__ */ _n(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function wn(e) {
	return /* @__PURE__ */ ln(e) ? e : new Proxy(e, Cn);
}
var Tn = class {
	constructor(e) {
		this.__v_isRef = !0, this._value = void 0;
		let t = this.dep = new pt(), { get: n, set: r } = e(t.track.bind(t), t.trigger.bind(t));
		this._get = n, this._set = r;
	}
	get value() {
		return this._value = this._get();
	}
	set value(e) {
		this._set(e);
	}
};
function En(e) {
	return new Tn(e);
}
// @__NO_SIDE_EFFECTS__
function Dn(e) {
	let t = C(e) ? Array(e.length) : {};
	for (let n in e) t[n] = jn(e, n);
	return t;
}
var On = class {
	constructor(e, t, n) {
		this._object = e, this._defaultValue = n, this.__v_isRef = !0, this._value = void 0, this._key = te(t) ? t : String(t), this._raw = /* @__PURE__ */ pn(e);
		let r = !0, i = e;
		if (!C(e) || te(this._key) || !oe(this._key)) do
			r = !/* @__PURE__ */ fn(i) || /* @__PURE__ */ dn(i);
		while (r && (i = i.__v_raw));
		this._shallow = r;
	}
	get value() {
		let e = this._object[this._key];
		return this._shallow && (e = F(e)), this._value = e === void 0 ? this._defaultValue : e;
	}
	set value(e) {
		if (this._shallow && /* @__PURE__ */ _n(this._raw[this._key])) {
			let t = this._object[this._key];
			if (/* @__PURE__ */ _n(t)) {
				t.value = e;
				return;
			}
		}
		this._object[this._key] = e;
	}
	get dep() {
		return xt(this._raw, this._key);
	}
}, kn = class {
	constructor(e) {
		this._getter = e, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
	}
	get value() {
		return this._value = this._getter();
	}
};
// @__NO_SIDE_EFFECTS__
function An(e, t, n) {
	return /* @__PURE__ */ _n(e) ? e : D(e) ? new kn(e) : k(e) && arguments.length > 1 ? jn(e, t, n) : /* @__PURE__ */ P(e);
}
function jn(e, t, n) {
	return new On(e, t, n);
}
var Mn = class {
	constructor(e, t, n) {
		this.fn = e, this.setter = t, this._value = void 0, this.dep = new pt(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = dt - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = n;
	}
	notify() {
		if (this.flags |= 16, !(this.flags & 8) && Ue !== this) return Ye(this, !0), !0;
	}
	get value() {
		let e = this.dep.track();
		return tt(this), e && (e.version = this.dep.version), this._value;
	}
	set value(e) {
		this.setter && this.setter(e);
	}
};
// @__NO_SIDE_EFFECTS__
function Nn(e, t, n = !1) {
	let r, i;
	return D(e) ? r = e : (r = e.get, i = e.set), new Mn(r, i, n);
}
var Pn = {
	GET: "get",
	HAS: "has",
	ITERATE: "iterate"
}, Fn = {
	SET: "set",
	ADD: "add",
	DELETE: "delete",
	CLEAR: "clear"
}, In = {}, Ln = /* @__PURE__ */ new WeakMap(), Rn = void 0;
function zn() {
	return Rn;
}
function Bn(e, t = !1, n = Rn) {
	if (n) {
		let t = Ln.get(n);
		t || Ln.set(n, t = []), t.push(e);
	}
}
function Vn(e, t, n = p) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: c } = n, l = (e) => i ? e : /* @__PURE__ */ dn(e) || i === !1 || i === 0 ? Hn(e, 1) : Hn(e), u, d, f, m, g = !1, _ = !1;
	if (/* @__PURE__ */ _n(e) ? (d = () => e.value, g = /* @__PURE__ */ dn(e)) : /* @__PURE__ */ ln(e) ? (d = () => l(e), g = !0) : C(e) ? (_ = !0, g = e.some((e) => /* @__PURE__ */ ln(e) || /* @__PURE__ */ dn(e)), d = () => e.map((e) => {
		if (/* @__PURE__ */ _n(e)) return e.value;
		if (/* @__PURE__ */ ln(e)) return l(e);
		if (D(e)) return c ? c(e, 2) : e();
	})) : d = D(e) ? t ? c ? () => c(e, 2) : e : () => {
		if (f) {
			ct();
			try {
				f();
			} finally {
				lt();
			}
		}
		let t = Rn;
		Rn = u;
		try {
			return c ? c(e, 3, [m]) : e(m);
		} finally {
			Rn = t;
		}
	} : h, t && i) {
		let e = d, t = i === !0 ? Infinity : i;
		d = () => Hn(e(), t);
	}
	let v = Ve(), y = () => {
		u.stop(), v && v.active && b(v.effects, u);
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return y(), n;
		};
	}
	let x = _ ? Array(e.length).fill(In) : In, S = (e) => {
		if (!(!(u.flags & 1) || !u.dirty && !e)) if (t) {
			let n = u.run();
			if (e || i || g || (_ ? n.some((e, t) => me(e, x[t])) : me(n, x))) {
				f && f();
				let e = Rn;
				Rn = u;
				try {
					let e = [
						n,
						x === In ? void 0 : _ && x[0] === In ? [] : x,
						m
					];
					x = n, c ? c(t, 3, e) : t(...e);
				} finally {
					Rn = e;
				}
			}
		} else u.run();
	};
	return s && s(S), u = new Ge(d), u.scheduler = o ? () => o(S, !1) : S, m = (e) => Bn(e, !1, u), f = u.onStop = () => {
		let e = Ln.get(u);
		if (e) {
			if (c) c(e, 4);
			else for (let t of e) t();
			Ln.delete(u);
		}
	}, t ? r ? S(!0) : x = u.run() : o ? o(S.bind(null, !0), !0) : u.run(), y.pause = u.pause.bind(u), y.resume = u.resume.bind(u), y.stop = y, y;
}
function Hn(e, t = Infinity, n) {
	if (t <= 0 || !k(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ _n(e)) Hn(e.value, t, n);
	else if (C(e)) for (let r = 0; r < e.length; r++) Hn(e[r], t, n);
	else if (T(e) || w(e)) e.forEach((e) => {
		Hn(e, t, n);
	});
	else if (A(e)) {
		for (let r in e) Hn(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && Hn(e[r], t, n);
	}
	return e;
}
//#endregion
//#region node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var Un = [];
function Wn(e) {
	Un.push(e);
}
function Gn() {
	Un.pop();
}
function Kn(e, t) {}
var qn = {
	SETUP_FUNCTION: 0,
	0: "SETUP_FUNCTION",
	RENDER_FUNCTION: 1,
	1: "RENDER_FUNCTION",
	NATIVE_EVENT_HANDLER: 5,
	5: "NATIVE_EVENT_HANDLER",
	COMPONENT_EVENT_HANDLER: 6,
	6: "COMPONENT_EVENT_HANDLER",
	VNODE_HOOK: 7,
	7: "VNODE_HOOK",
	DIRECTIVE_HOOK: 8,
	8: "DIRECTIVE_HOOK",
	TRANSITION_HOOK: 9,
	9: "TRANSITION_HOOK",
	APP_ERROR_HANDLER: 10,
	10: "APP_ERROR_HANDLER",
	APP_WARN_HANDLER: 11,
	11: "APP_WARN_HANDLER",
	FUNCTION_REF: 12,
	12: "FUNCTION_REF",
	ASYNC_COMPONENT_LOADER: 13,
	13: "ASYNC_COMPONENT_LOADER",
	SCHEDULER: 14,
	14: "SCHEDULER",
	COMPONENT_UPDATE: 15,
	15: "COMPONENT_UPDATE",
	APP_UNMOUNT_CLEANUP: 16,
	16: "APP_UNMOUNT_CLEANUP"
}, Jn = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function Yn(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		Zn(e, t, n);
	}
}
function Xn(e, t, n, r) {
	if (D(e)) {
		let i = Yn(e, t, n, r);
		return i && ne(i) && i.catch((e) => {
			Zn(e, t, n);
		}), i;
	}
	if (C(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(Xn(e[a], t, n, r));
		return i;
	}
}
function Zn(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || p;
	if (t) {
		let r = t.parent, i = t.proxy, o = `https://vuejs.org/error-reference/#runtime-${n}`;
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			ct(), Yn(a, null, 10, [
				e,
				i,
				o
			]), lt();
			return;
		}
	}
	Qn(e, n, i, r, o);
}
function Qn(e, t, n, r = !0, i = !1) {
	if (i) throw e;
	console.error(e);
}
var $n = [], er = -1, tr = [], nr = null, rr = 0, ir = /* @__PURE__ */ Promise.resolve(), ar = null;
function or(e) {
	let t = ar || ir;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function sr(e) {
	let t = er + 1, n = $n.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = $n[r], a = pr(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function cr(e) {
	if (!(e.flags & 1)) {
		let t = pr(e), n = $n[$n.length - 1];
		!n || !(e.flags & 2) && t >= pr(n) ? $n.push(e) : $n.splice(sr(t), 0, e), e.flags |= 1, lr();
	}
}
function lr() {
	ar ||= ir.then(mr);
}
function ur(e) {
	if (!C(e)) nr && e.id === -1 ? nr.splice(rr + 1, 0, e) : e.flags & 1 || (tr.push(e), e.flags |= 1);
	else for (let t = 0; t < e.length; t++) tr.push(e[t]);
	lr();
}
function dr(e, t, n = er + 1) {
	for (; n < $n.length; n++) {
		let t = $n[n];
		if (t && t.flags & 2) {
			if (e && t.id !== e.uid) continue;
			$n.splice(n, 1), n--, t.flags & 4 && (t.flags &= -2), t(), t.flags & 4 || (t.flags &= -2);
		}
	}
}
function fr(e) {
	if (tr.length) {
		let e = [...new Set(tr)].sort((e, t) => pr(e) - pr(t));
		if (tr.length = 0, nr) {
			for (let t = 0; t < e.length; t++) nr.push(e[t]);
			return;
		}
		for (nr = e, rr = 0; rr < nr.length; rr++) {
			let e = nr[rr];
			e.flags & 4 && (e.flags &= -2), e.flags & 8 || e(), e.flags &= -2;
		}
		nr = null, rr = 0;
	}
}
var pr = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function mr(e) {
	try {
		for (er = 0; er < $n.length; er++) {
			let e = $n[er];
			e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), Yn(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2));
		}
	} finally {
		for (; er < $n.length; er++) {
			let e = $n[er];
			e && (e.flags &= -2);
		}
		er = -1, $n.length = 0, fr(e), ar = null, ($n.length || tr.length) && mr(e);
	}
}
var hr, gr = [];
function _r(e, t) {
	hr = e, hr ? (hr.enabled = !0, gr.forEach(({ event: e, args: t }) => hr.emit(e, ...t)), gr = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		_r(e, t);
	}), setTimeout(() => {
		hr || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, gr = []);
	}, 3e3)) : gr = [];
}
var vr = null, yr = null;
function br(e) {
	let t = vr;
	return vr = e, yr = e && e.type.__scopeId || null, t;
}
function xr(e) {
	yr = e;
}
function Sr() {
	yr = null;
}
var Cr = (e) => I;
function I(e, t = vr, n) {
	if (!t || e._n) return e;
	let r = (...n) => {
		r._d && ns(-1);
		let i = br(t), a = Qo.length, o;
		try {
			o = e(...n);
		} finally {
			for (let e = Qo.length; e > a; e--) es();
			br(i), r._d && ns(1);
		}
		return o;
	};
	return r._n = !0, r._c = !0, r._d = !0, r;
}
function wr(e, t) {
	if (vr === null) return e;
	let n = zs(vr), r = e.dirs ||= [];
	for (let e = 0; e < t.length; e++) {
		let [i, a, o, s = p] = t[e];
		i && (D(i) && (i = {
			mounted: i,
			updated: i
		}), i.deep && Hn(a), r.push({
			dir: i,
			instance: n,
			value: a,
			oldValue: void 0,
			arg: o,
			modifiers: s
		}));
	}
	return e;
}
function Tr(e, t, n, r) {
	let i = e.dirs, a = t && t.dirs;
	for (let o = 0; o < i.length; o++) {
		let s = i[o];
		a && (s.oldValue = a[o].value);
		let c = s.dir[r];
		c && (ct(), Xn(c, n, 8, [
			e.el,
			s,
			e,
			t
		]), lt());
	}
}
function Er(e, t) {
	if (xs) {
		let n = xs.provides, r = xs.parent && xs.parent.provides;
		r === n && (n = xs.provides = Object.create(r)), n[e] = t;
	}
}
function Dr(e, t, n = !1) {
	let r = Ss();
	if (r || Ka) {
		let i = Ka ? Ka._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && D(t) ? t.call(r && r.proxy) : t;
	}
}
function Or() {
	return !!(Ss() || Ka);
}
var kr = /* @__PURE__ */ Symbol.for("v-scx"), Ar = () => Dr(kr);
function jr(e, t) {
	return Fr(e, null, t);
}
function Mr(e, t) {
	return Fr(e, null, { flush: "post" });
}
function Nr(e, t) {
	return Fr(e, null, { flush: "sync" });
}
function Pr(e, t, n) {
	return Fr(e, t, n);
}
function Fr(e, t, n = p) {
	let { immediate: r, deep: i, flush: a, once: o } = n, s = y({}, n), c = t && r || !t && a !== "post", l;
	if (Os) {
		if (a === "sync") {
			let e = Ar();
			l = e.__watcherHandles ||= [];
		} else if (!c) {
			let e = () => {};
			return e.stop = h, e.resume = h, e.pause = h, e;
		}
	}
	let u = xs;
	s.call = (e, t, n) => Xn(e, u, t, n);
	let d = !1;
	a === "post" ? s.scheduler = (e) => {
		wo(e, u && u.suspense);
	} : a !== "sync" && (d = !0, s.scheduler = (e, t) => {
		t ? e() : cr(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), d && (e.flags |= 2, u && (e.id = u.uid, e.i = u));
	};
	let f = Vn(e, t, s);
	return Os && (l ? l.push(f) : c && f()), f;
}
var Ir = /* @__PURE__ */ new WeakMap(), Lr = /* @__PURE__ */ Symbol("_vte"), Rr = (e) => e.__isTeleport, zr = (e) => e && (e.disabled || e.disabled === ""), Br = (e) => e && (e.defer || e.defer === ""), Vr = (e) => typeof SVGElement < "u" && e instanceof SVGElement, Hr = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, Ur = (e, t) => {
	let n = e && e.to;
	return O(n) ? t ? t(n) : null : n;
}, Wr = {
	name: "Teleport",
	__isTeleport: !0,
	process(e, t, n, r, i, a, o, s, c, l) {
		let { mc: u, pc: d, pbc: f, o: { insert: p, querySelector: m, createText: h, createComment: g, parentNode: _ } } = l, v = zr(t.props), { dynamicChildren: y } = t, b = (e, t, n) => {
			e.shapeFlag & 16 && u(e.children, t, n, i, a, o, s, c);
		}, x = (e = t) => {
			let n = zr(e.props), r = e.target = Ur(e.props, m), a = Yr(r, e, h, p);
			r && (o !== "svg" && Vr(r) ? o = "svg" : o !== "mathml" && Hr(r) && (o = "mathml"), i && i.isCE && (i.ce._teleportTargets || (i.ce._teleportTargets = /* @__PURE__ */ new Set())).add(r), n || (b(e, r, a), Jr(e, !1)));
		}, S = (e) => {
			let t = () => {
				if (Ir.get(e) === t) {
					if (Ir.delete(e), zr(e.props)) {
						let t = _(e.el) || n;
						b(e, t, e.anchor), Jr(e, !0);
					}
					x(e);
				}
			};
			Ir.set(e, t), wo(t, a);
		};
		if (e == null) {
			let e = t.el = h(""), i = t.anchor = h("");
			if (p(e, n, r), p(i, n, r), Br(t.props) || a && a.pendingBranch) {
				S(t);
				return;
			}
			v && (b(t, n, i), Jr(t, !0)), x();
		} else {
			t.el = e.el;
			let r = t.anchor = e.anchor, u = Ir.get(e);
			if (u) {
				u.flags |= 8, Ir.delete(e), S(t);
				return;
			}
			t.targetStart = e.targetStart;
			let p = t.target = e.target, h = t.targetAnchor = e.targetAnchor, g = zr(e.props), _ = g ? n : p, b = g ? r : h;
			if (o === "svg" || Vr(p) ? o = "svg" : (o === "mathml" || Hr(p)) && (o = "mathml"), y ? (f(e.dynamicChildren, y, _, i, a, o, s), jo(e, t, !0)) : c || d(e, t, _, b, i, a, o, s, !1), v) g ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : Gr(t, n, r, l, 1);
			else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
				let e = Ur(t.props, m);
				e && (t.target = e, Gr(t, e, null, l, 0));
			} else g && Gr(t, p, h, l, 1);
			Jr(t, v);
		}
	},
	remove(e, t, n, { um: r, o: { remove: i } }, a) {
		let { shapeFlag: o, children: s, anchor: c, targetStart: l, targetAnchor: u, target: d, props: f } = e, p = zr(f), m = a || !p, h = Ir.get(e);
		if (h && (h.flags |= 8, Ir.delete(e)), d && (i(l), i(u)), a && i(c), !h && (p || d) && o & 16) for (let e = 0; e < s.length; e++) {
			let i = s[e];
			r(i, t, n, m, !!i.dynamicChildren);
		}
	},
	move: Gr,
	hydrate: Kr
};
function Gr(e, t, n, { o: { insert: r }, m: i }, a = 2) {
	a === 0 && r(e.targetAnchor, t, n);
	let { el: o, anchor: s, shapeFlag: c, children: l, props: u } = e, d = a === 2;
	if (d && r(o, t, n), !Ir.has(e) && (!d || zr(u)) && c & 16) for (let e = 0; e < l.length; e++) i(l[e], t, n, 2);
	d && r(s, t, n);
}
function Kr(e, t, n, r, i, a, { o: { nextSibling: o, parentNode: s, querySelector: c, insert: l, createText: u } }, d) {
	function f(e, n) {
		let r = n;
		for (; r;) {
			if (r && r.nodeType === 8) {
				if (r.data === "teleport start anchor") t.targetStart = r;
				else if (r.data === "teleport anchor") {
					t.targetAnchor = r, e._lpa = t.targetAnchor && o(t.targetAnchor);
					break;
				}
			}
			r = o(r);
		}
	}
	function p(e, t) {
		t.anchor = d(o(e), t, s(e), n, r, i, a);
	}
	let m = t.target = Ur(t.props, c), h = zr(t.props);
	if (m) {
		let c = m._lpa || m.firstChild;
		t.shapeFlag & 16 && (h ? (p(e, t), f(m, c), t.targetAnchor || Yr(m, t, u, l, s(e) === m ? e : null)) : (t.anchor = o(e), f(m, c), t.targetAnchor || Yr(m, t, u, l), d(c && o(c), t, m, n, r, i, a))), Jr(t, h);
	} else h && t.shapeFlag & 16 && (p(e, t), t.targetStart = e, t.targetAnchor = o(e));
	return t.anchor && o(t.anchor);
}
var qr = Wr;
function Jr(e, t) {
	let n = e.ctx;
	if (n && n.ut) {
		let r, i;
		for (t ? (r = e.el, i = e.anchor) : (r = e.targetStart, i = e.targetAnchor); r && r !== i;) r.nodeType === 1 && r.setAttribute("data-v-owner", n.uid), r = r.nextSibling;
		n.ut();
	}
}
function Yr(e, t, n, r, i = null) {
	let a = t.targetStart = n(""), o = t.targetAnchor = n("");
	return a[Lr] = o, e && (r(a, e, i), r(o, e, i)), o;
}
var Xr = /* @__PURE__ */ Symbol("_leaveCb"), Zr = /* @__PURE__ */ Symbol("_enterCb");
function Qr() {
	let e = {
		isMounted: !1,
		isLeaving: !1,
		isUnmounting: !1,
		leavingVNodes: /* @__PURE__ */ new Map()
	};
	return ra(() => {
		e.isMounted = !0;
	}), oa(() => {
		e.isUnmounting = !0;
	}), e;
}
var $r = [Function, Array], ei = {
	mode: String,
	appear: Boolean,
	persisted: Boolean,
	onBeforeEnter: $r,
	onEnter: $r,
	onAfterEnter: $r,
	onEnterCancelled: $r,
	onBeforeLeave: $r,
	onLeave: $r,
	onAfterLeave: $r,
	onLeaveCancelled: $r,
	onBeforeAppear: $r,
	onAppear: $r,
	onAfterAppear: $r,
	onAppearCancelled: $r
}, ti = (e) => {
	let t = e.subTree;
	return t.component ? ti(t.component) : t;
}, ni = {
	name: "BaseTransition",
	props: ei,
	setup(e, { slots: t }) {
		let n = Ss(), r = Qr();
		return () => {
			let i = t.default && ui(t.default(), !0), a = i && i.length ? ri(i) : n.subTree ? q() : void 0;
			if (!a) return;
			let o = /* @__PURE__ */ pn(e), { mode: s } = o;
			if (r.isLeaving) return si(a);
			let c = ci(a);
			if (!c) return si(a);
			let l = oi(c, o, r, n, (e) => l = e);
			c.type !== Xo && li(c, l);
			let u = n.subTree && ci(n.subTree);
			if (u && u.type !== Xo && !as(u, c) && ti(n).type !== Xo) {
				let e = oi(u, o, r, n);
				if (li(u, e), s === "out-in" && c.type !== Xo) return r.isLeaving = !0, e.afterLeave = () => {
					r.isLeaving = !1, n.job.flags & 8 || n.update(), delete e.afterLeave, u = void 0;
				}, si(a);
				s === "in-out" && c.type !== Xo ? e.delayLeave = (e, t, n) => {
					let i = ai(r, u);
					i[String(u.key)] = u, e[Xr] = () => {
						t(), e[Xr] = void 0, delete l.delayedLeave, u = void 0;
					}, l.delayedLeave = () => {
						n(), delete l.delayedLeave, u = void 0;
					};
				} : u = void 0;
			} else u &&= void 0;
			return a;
		};
	}
};
function ri(e) {
	let t = e[0];
	if (e.length > 1) {
		for (let n of e) if (n.type !== Xo) {
			t = n;
			break;
		}
	}
	return t;
}
var ii = ni;
function ai(e, t) {
	let { leavingVNodes: n } = e, r = n.get(t.type);
	return r || (r = /* @__PURE__ */ Object.create(null), n.set(t.type, r)), r;
}
function oi(e, t, n, r, i) {
	let { appear: a, mode: o, persisted: s = !1, onBeforeEnter: c, onEnter: l, onAfterEnter: u, onEnterCancelled: d, onBeforeLeave: f, onLeave: p, onAfterLeave: m, onLeaveCancelled: h, onBeforeAppear: g, onAppear: _, onAfterAppear: v, onAppearCancelled: y } = t, b = String(e.key), x = ai(n, e), S = (e, t) => {
		e && Xn(e, r, 9, t);
	}, w = (e, t) => {
		let n = t[1];
		S(e, t), C(e) ? e.every((e) => e.length <= 1) && n() : e.length <= 1 && n();
	}, T = {
		mode: o,
		persisted: s,
		beforeEnter(t) {
			let r = c;
			if (!n.isMounted) if (a) r = g || c;
			else return;
			t[Xr] && t[Xr](!0);
			let i = x[b];
			i && as(e, i) && i.el[Xr] && i.el[Xr](), S(r, [t]);
		},
		enter(t) {
			if (x[b] === e) return;
			let r = l, i = u, o = d;
			if (!n.isMounted) if (a) r = _ || l, i = v || u, o = y || d;
			else return;
			let s = !1;
			t[Zr] = (e) => {
				s || (s = !0, S(e ? o : i, [t]), T.delayedLeave && T.delayedLeave(), t[Zr] = void 0);
			};
			let c = t[Zr].bind(null, !1);
			r ? w(r, [t, c]) : c();
		},
		leave(t, r) {
			let i = String(e.key);
			if (t[Zr] && t[Zr](!0), n.isUnmounting) return r();
			S(f, [t]);
			let a = !1;
			t[Xr] = (n) => {
				a || (a = !0, r(), S(n ? h : m, [t]), t[Xr] = void 0, x[i] === e && delete x[i]);
			};
			let o = t[Xr].bind(null, !1);
			x[i] = e, p ? w(p, [t, o]) : o();
		},
		clone(e) {
			let a = oi(e, t, n, r, i);
			return i && i(a), a;
		}
	};
	return T;
}
function si(e) {
	if (Gi(e)) return e = ds(e), e.children = null, e;
}
function ci(e) {
	if (!Gi(e)) return Rr(e.type) && e.children ? ri(e.children) : e;
	if (e.component) return e.component.subTree;
	let { shapeFlag: t, children: n } = e;
	if (n) {
		if (t & 16) return n[0];
		if (t & 32 && D(n.default)) return n.default();
	}
}
function li(e, t) {
	if (e.shapeFlag & 6 && e.component) {
		e.transition = t;
		let n = e.component.subTree;
		li(Rr(n.type) && ci(n) || n, t);
	} else e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function ui(e, t = !1, n) {
	let r = [], i = 0;
	for (let a = 0; a < e.length; a++) {
		let o = e[a], s = n == null ? o.key : String(n) + String(o.key == null ? a : o.key);
		o.type === B ? (o.patchFlag & 128 && i++, r = r.concat(ui(o.children, t, s))) : (t || o.type !== Xo) && r.push(s == null ? o : ds(o, { key: s }));
	}
	if (i > 1) for (let e = 0; e < r.length; e++) r[e].patchFlag = -2;
	return r;
}
// @__NO_SIDE_EFFECTS__
function L(e, t) {
	return D(e) ? /* @__PURE__ */ y({ name: e.name }, t, { setup: e }) : e;
}
function di() {
	let e = Ss();
	return e ? (e.appContext.config.idPrefix || "v") + "-" + e.ids[0] + e.ids[1]++ : "";
}
function fi(e) {
	e.ids = [
		e.ids[0] + e.ids[2]++ + "-",
		0,
		0
	];
}
function pi(e) {
	let t = Ss(), n = /* @__PURE__ */ vn(null);
	if (t) {
		let r = t.refs === p ? t.refs = {} : t.refs;
		Object.defineProperty(r, e, {
			enumerable: !0,
			get: () => n.value,
			set: (e) => n.value = e
		});
	}
	return n;
}
function mi(e, t) {
	let n;
	return !!((n = Object.getOwnPropertyDescriptor(e, t)) && !n.configurable);
}
var hi = /* @__PURE__ */ new WeakMap();
function gi(e, t, n, r, i = !1) {
	if (C(e)) {
		e.forEach((e, a) => gi(e, t && (C(t) ? t[a] : t), n, r, i));
		return;
	}
	if (Hi(r) && !i) {
		r.shapeFlag & 512 && r.type.__asyncResolved && r.component.subTree.component && gi(e, t, n, r.component.subTree);
		return;
	}
	let a = r.shapeFlag & 4 ? zs(r.component) : r.el, o = i ? null : a, { i: s, r: c } = e, l = t && t.r, u = s.refs === p ? s.refs = {} : s.refs, d = s.setupState, f = /* @__PURE__ */ pn(d), m = d === p ? g : (e) => !mi(u, e) && S(f, e), h = (e, t) => !(t && mi(u, t));
	if (l != null && l !== c) {
		if (_i(t), O(l)) u[l] = null, m(l) && (d[l] = null);
		else if (/* @__PURE__ */ _n(l)) {
			let e = t;
			h(l, e.k) && (l.value = null), e.k && (u[e.k] = null);
		}
	}
	if (D(c)) Yn(c, s, 12, [o, u]);
	else {
		let t = O(c), r = /* @__PURE__ */ _n(c);
		if (t || r) {
			let s = () => {
				if (e.f) {
					let n = t ? m(c) ? d[c] : u[c] : h(c) || !e.k ? c.value : u[e.k];
					if (i) C(n) && b(n, a);
					else if (C(n)) n.includes(a) || n.push(a);
					else if (t) u[c] = [a], m(c) && (d[c] = u[c]);
					else {
						let t = [a];
						h(c, e.k) && (c.value = t), e.k && (u[e.k] = t);
					}
				} else t ? (u[c] = o, m(c) && (d[c] = o)) : r && (h(c, e.k) && (c.value = o), e.k && (u[e.k] = o));
			};
			if (o) {
				let t = () => {
					s(), hi.delete(e);
				};
				t.id = -1, hi.set(e, t), wo(t, n);
			} else _i(e), s();
		}
	}
}
function _i(e) {
	let t = hi.get(e);
	t && (t.flags |= 8, hi.delete(e));
}
var vi = !1, yi = () => {
	vi ||= (console.error("Hydration completed but contains mismatches."), !0);
}, bi = (e) => e.namespaceURI.includes("svg") && e.tagName !== "foreignObject", xi = (e) => e.namespaceURI.includes("MathML"), Si = (e) => {
	if (e.nodeType === 1) {
		if (bi(e)) return "svg";
		if (xi(e)) return "mathml";
	}
}, Ci = (e) => e.nodeType === 8;
function wi(e) {
	let { mt: t, p: n, o: { patchProp: r, createText: i, nextSibling: a, parentNode: o, remove: s, insert: c, createComment: l } } = e, u = (e, t) => {
		if (!t.hasChildNodes()) {
			n(null, e, t), fr(), t._vnode = e;
			return;
		}
		d(t.firstChild, e, null, null, null), fr(), t._vnode = e;
	}, d = (n, r, s, l, u, _ = !1) => {
		_ ||= !!r.dynamicChildren;
		let b = Ci(n) && n.data === "[", x = () => h(n, r, s, l, u, b), { type: S, ref: C, shapeFlag: w, patchFlag: T } = r, E = n.nodeType;
		r.el = n, T === -2 && (_ = !1, r.dynamicChildren = null);
		let ee = null;
		switch (S) {
			case Yo:
				E === 3 ? (n.data !== r.children && (yi(), n.data = r.children), ee = a(n)) : r.children === "" ? (c(r.el = i(""), o(n), n), ee = n) : ee = x();
				break;
			case Xo:
				y(n) ? (ee = a(n), v(r.el = n.content.firstChild, n, s)) : ee = E !== 8 || b ? x() : a(n);
				break;
			case Zo:
				if (b && (n = a(n), E = n.nodeType), E === 1 || E === 3) {
					ee = n;
					let e = !r.children.length;
					for (let t = 0; t < r.staticCount; t++) e && (r.children += ee.nodeType === 1 ? ee.outerHTML : ee.data), t === r.staticCount - 1 && (r.anchor = ee), ee = a(ee);
					return b ? a(ee) : ee;
				}
				x();
				break;
			case B:
				ee = b ? m(n, r, s, l, u, _) : x();
				break;
			default: if (w & 1) ee = (E !== 1 || r.type.toLowerCase() !== n.tagName.toLowerCase()) && !y(n) ? x() : f(n, r, s, l, u, _);
			else if (w & 6) {
				r.slotScopeIds = u;
				let e = o(n);
				if (ee = b ? g(n) : Ci(n) && n.data === "teleport start" ? g(n, n.data, "teleport end") : a(n), t(r, e, null, s, l, Si(e), _), Hi(r) && !r.type.__asyncResolved) {
					let t;
					b ? (t = G(B), t.anchor = ee ? ee.previousSibling : e.lastChild) : t = n.nodeType === 3 ? K("") : G("div"), t.el = n, r.component.subTree = t;
				}
			} else w & 64 ? ee = E === 8 ? r.type.hydrate(n, r, s, l, u, _, e, p) : x() : w & 128 && (ee = r.type.hydrate(n, r, s, l, Si(o(n)), u, _, e, d));
		}
		return C != null && gi(C, null, l, r), ee;
	}, f = (e, t, n, i, a, o) => {
		o ||= !!t.dynamicChildren;
		let { type: c, dynamicProps: l, props: u, patchFlag: d, shapeFlag: f, dirs: m, transition: h } = t, g = c === "input" || c === "option", b = !!l;
		if (g || b || d !== -1) {
			m && Tr(t, null, n, "created");
			let c = !1;
			if (y(e)) {
				c = Ao(null, h) && n && n.vnode.props && n.vnode.props.appear;
				let r = e.content.firstChild;
				if (c) {
					let e = r.getAttribute("class");
					e && (r.$cls = e), h.beforeEnter(r);
				}
				v(r, e, n), t.el = e = r;
			}
			if (f & 16 && !(u && (u.innerHTML || u.textContent))) {
				let r = p(e.firstChild, t, e, n, i, a, o);
				for (r && !ki(e, 1) && yi(); r;) {
					let e = r;
					r = r.nextSibling, s(e);
				}
			} else if (f & 8) {
				let n = t.children;
				n[0] === "\n" && (e.tagName === "PRE" || e.tagName === "TEXTAREA") && (n = n.slice(1));
				let { textContent: r } = e;
				r !== n && r !== n.replace(/\r\n|\r/g, "\n") && (ki(e, 0) || yi(), e.textContent = t.children);
			}
			if (u) {
				if (g || b || !o || d & 48) {
					let t = e.tagName.includes("-"), i = e.namespaceURI.includes("svg") ? "svg" : e.namespaceURI.includes("MathML") ? "mathml" : void 0;
					for (let a in u) if (g && (a.endsWith("value") || a === "indeterminate") || _(a) && !se(a) || a[0] === "." || t && !se(a) || l && l.includes(a)) {
						if (Ei(e, a, u[a])) continue;
						r(e, a, null, u[a], i, n);
					}
				} else if (u.onClick) r(e, "onClick", null, u.onClick, void 0, n);
				else if (d & 4 && /* @__PURE__ */ ln(u.style)) for (let e in u.style) u.style[e];
			}
			let x;
			(x = u && u.onVnodeBeforeMount) && _s(x, n, t), m && Tr(t, null, n, "beforeMount"), ((x = u && u.onVnodeMounted) || m || c) && Ko(() => {
				x && _s(x, n, t), c && h.enter(e), m && Tr(t, null, n, "mounted");
			}, i);
		}
		return e.nextSibling;
	}, p = (e, t, r, o, s, l, u) => {
		u ||= !!t.dynamicChildren;
		let f = t.children, p = f.length, m = !1;
		for (let t = 0; t < p; t++) {
			let h = u ? f[t] : f[t] = ps(f[t]), g = h.type === Yo;
			e ? (g && !u && t + 1 < p && ps(f[t + 1]).type === Yo && (c(i(e.data.slice(h.children.length)), r, a(e)), e.data = h.children), e = d(e, h, o, s, l, u)) : g && !h.children ? c(h.el = i(""), r) : (m || (m = !0, ki(r, 1) || yi()), n(null, h, r, null, o, s, Si(r), l));
		}
		return e;
	}, m = (e, t, n, r, i, s) => {
		let { slotScopeIds: u } = t;
		u && (i = i ? i.concat(u) : u);
		let d = o(e), f = p(a(e), t, d, n, r, i, s);
		return f && Ci(f) && f.data === "]" ? a(t.anchor = f) : (yi(), c(t.anchor = l("]"), d, f), f);
	}, h = (e, t, r, i, c, l) => {
		if (ji(e, t) || yi(), t.el = null, l) {
			let t = g(e);
			for (;;) {
				let n = a(e);
				if (n && n !== t) s(n);
				else break;
			}
		}
		let u = a(e), d = o(e);
		return s(e), n(null, t, d, u, r, i, Si(d), c), r && (r.vnode.el = t.el, ao(r, t.el)), u;
	}, g = (e, t = "[", n = "]") => {
		let r = 0;
		for (; e;) if (e = a(e), e && Ci(e) && (e.data === t && r++, e.data === n)) {
			if (r === 0) return a(e);
			r--;
		}
		return e;
	}, v = (e, t, n) => {
		let r = t.parentNode;
		r && r.replaceChild(e, t);
		let i = n;
		for (; i;) i.vnode.el === t && (i.vnode.el = i.subTree.el = e), i = i.parent;
	}, y = (e) => e.nodeType === 1 && e.tagName === "TEMPLATE";
	return [u, d];
}
var Ti = /* @__PURE__ */ new Set([
	"src",
	"srcset",
	"href",
	"poster"
]);
function Ei(e, t, n) {
	return Ti.has(t) ? e.getAttribute(t) === (n == null ? null : `${n}`) : !1;
}
var Di = "data-allow-mismatch", Oi = {
	0: "text",
	1: "children",
	2: "class",
	3: "style",
	4: "attribute"
};
function ki(e, t) {
	if (t === 0 || t === 1) for (; e && !e.hasAttribute(Di);) e = e.parentElement;
	return Ai(e && e.getAttribute(Di), t);
}
function Ai(e, t) {
	if (e == null) return !1;
	if (e === "") return !0;
	{
		let n = e.split(",");
		return t === 0 && n.includes("children") ? !0 : n.includes(Oi[t]);
	}
}
function ji(e, t) {
	return ki(e.parentElement, 1) || Mi(e) || Ni(t);
}
function Mi(e) {
	return e.nodeType === 1 && Ai(e.getAttribute(Di), 1);
}
function Ni({ props: e }) {
	let t = e && e[Di];
	return typeof t == "string" && Ai(t, 1);
}
var Pi = be().requestIdleCallback || ((e) => setTimeout(e, 1)), Fi = be().cancelIdleCallback || ((e) => clearTimeout(e)), Ii = (e = 1e4) => (t) => {
	let n = Pi(t, { timeout: e });
	return () => Fi(n);
};
function Li(e) {
	let { top: t, left: n, bottom: r, right: i } = e.getBoundingClientRect(), { innerHeight: a, innerWidth: o } = window;
	return (t > 0 && t < a || r > 0 && r < a) && (n > 0 && n < o || i > 0 && i < o);
}
var Ri = (e) => (t, n) => {
	let r = new IntersectionObserver((e) => {
		for (let n of e) if (n.isIntersecting) {
			r.disconnect(), t();
			break;
		}
	}, e);
	return n((e) => {
		if (e instanceof Element) {
			if (Li(e)) return t(), r.disconnect(), !1;
			r.observe(e);
		}
	}), () => r.disconnect();
}, zi = (e) => (t) => {
	if (e) {
		let n = matchMedia(e);
		if (n.matches) t();
		else return n.addEventListener("change", t, { once: !0 }), () => n.removeEventListener("change", t);
	}
}, Bi = (e = []) => (t, n) => {
	O(e) && (e = [e]);
	let r = !1, i = (e) => {
		r || (r = !0, a(), t(), e.target.dispatchEvent(new e.constructor(e.type, e)));
	}, a = () => {
		n((t) => {
			for (let n of e) t.removeEventListener(n, i);
		});
	};
	return n((t) => {
		for (let n of e) t.addEventListener(n, i, { once: !0 });
	}), a;
};
function Vi(e, t) {
	if (Ci(e) && e.data === "[") {
		let n = 1, r = e.nextSibling;
		for (; r;) {
			if (r.nodeType === 1) {
				if (t(r) === !1) break;
			} else if (Ci(r)) if (r.data === "]") {
				if (--n === 0) break;
			} else r.data === "[" && n++;
			r = r.nextSibling;
		}
	} else t(e);
}
var Hi = (e) => !!e.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function Ui(e) {
	D(e) && (e = { loader: e });
	let { loader: t, loadingComponent: n, errorComponent: r, delay: i = 200, hydrate: a, timeout: o, suspensible: s = !0, onError: c } = e, l = null, u, d = 0, f = () => (d++, l = null, p()), p = () => {
		let e;
		return l || (e = l = t().catch((e) => {
			if (e = e instanceof Error ? e : Error(String(e)), c) return new Promise((t, n) => {
				c(e, () => t(f()), () => n(e), d + 1);
			});
			throw e;
		}).then((t) => e !== l && l ? l : (t && (t.__esModule || t[Symbol.toStringTag] === "Module") && (t = t.default), u = t, t)));
	};
	return /* @__PURE__ */ L({
		name: "AsyncComponentWrapper",
		__asyncLoader: p,
		__asyncHydrate(e, t, n) {
			let r = e.isConnected, i = !1;
			(t.bu ||= []).push(() => i = !0);
			let o = () => {
				i || !e.parentNode || r && !e.isConnected || n();
			}, s = a ? () => {
				let n = a(o, (t) => Vi(e, t));
				n && (t.bum ||= []).push(n);
			} : o;
			u ? s() : p().then(() => !t.isUnmounted && s());
		},
		get __asyncResolved() {
			return u;
		},
		setup() {
			let e = xs;
			if (fi(e), u) return () => Wi(u, e);
			let t = (t) => {
				l = null, Zn(t, e, 13, !r);
			};
			if (s && e.suspense || Os) return p().then((t) => () => Wi(t, e)).catch((e) => (t(e), () => r ? G(r, { error: e }) : null));
			let a = /* @__PURE__ */ P(!1), c = /* @__PURE__ */ P(), d = /* @__PURE__ */ P(!!i), f, m;
			return sa(() => {
				f != null && clearTimeout(f), m != null && clearTimeout(m);
			}), i && (m = setTimeout(() => {
				e.isUnmounted || (d.value = !1);
			}, i)), o != null && (f = setTimeout(() => {
				if (!e.isUnmounted && !a.value && !c.value) {
					let e = /* @__PURE__ */ Error(`Async component timed out after ${o}ms.`);
					t(e), c.value = e;
				}
			}, o)), p().then(() => {
				e.isUnmounted || (a.value = !0, e.parent && Gi(e.parent.vnode) && e.parent.update());
			}).catch((n) => {
				if (e.isUnmounted) {
					l = null;
					return;
				}
				t(n), c.value = n;
			}), () => {
				if (a.value && u) return Wi(u, e);
				if (c.value && r) return G(r, { error: c.value });
				if (n && !d.value) return Wi(n, e);
			};
		}
	});
}
function Wi(e, t) {
	let { ref: n, props: r, children: i, ce: a } = t.vnode, o = G(e, r, i);
	return o.ref = n, o.ce = a, delete t.vnode.ce, o;
}
var Gi = (e) => e.type.__isKeepAlive, Ki = {
	name: "KeepAlive",
	__isKeepAlive: !0,
	props: {
		include: [
			String,
			RegExp,
			Array
		],
		exclude: [
			String,
			RegExp,
			Array
		],
		max: [String, Number]
	},
	setup(e, { slots: t }) {
		let n = Ss(), r = n.ctx;
		if (!r.renderer) return () => {
			let e = t.default && t.default();
			return e && e.length === 1 ? e[0] : e;
		};
		let i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), o = null, s = n.suspense, { renderer: { p: c, m: l, um: u, o: { createElement: d } } } = r, f = d("div");
		r.activate = (e, t, n, r, i) => {
			let a = e.component;
			l(e, t, n, 0, s), c(a.vnode, e, t, n, a, s, r, e.slotScopeIds, i), wo(() => {
				a.isDeactivated = !1, a.a && he(a.a);
				let t = e.props && e.props.onVnodeMounted;
				t && _s(t, a.parent, e);
			}, s);
		}, r.deactivate = (e) => {
			let t = e.component;
			Po(t.m), Po(t.a), l(e, f, null, 1, s), wo(() => {
				t.da && he(t.da);
				let n = e.props && e.props.onVnodeUnmounted;
				n && _s(n, t.parent, e), t.isDeactivated = !0;
			}, s);
		};
		function p(e) {
			Qi(e), u(e, n, s, !0);
		}
		function m(e) {
			i.forEach((t, n) => {
				let r = Bs(Hi(t) ? t.type.__asyncResolved || {} : t.type);
				r && !e(r) && h(n);
			});
		}
		function h(e) {
			let t = i.get(e);
			t && (!o || !as(t, o)) ? p(t) : o && Qi(o), i.delete(e), a.delete(e);
		}
		Pr(() => [e.include, e.exclude], ([e, t]) => {
			e && m((t) => qi(e, t)), t && m((e) => !qi(t, e));
		}, {
			flush: "post",
			deep: !0
		});
		let g = null, _ = () => {
			g != null && (Io(n.subTree.type) ? wo(() => {
				i.set(g, $i(n.subTree));
			}, n.subTree.suspense) : i.set(g, $i(n.subTree)));
		};
		return ra(_), aa(_), oa(() => {
			i.forEach((e) => {
				let { subTree: t, suspense: r } = n, i = $i(t);
				if (e.type === i.type && e.key === i.key) {
					Qi(i);
					let e = i.component.da;
					e && wo(e, r);
					return;
				}
				p(e);
			});
		}), () => {
			if (g = null, !t.default) return o = null;
			let n = t.default(), r = n[0];
			if (n.length > 1) return o = null, n;
			if (!is(r) || !(r.shapeFlag & 4) && !(r.shapeFlag & 128)) return o = null, r;
			let s = $i(r);
			if (s.type === Xo) return o = null, s;
			let c = s.type, l = Bs(Hi(s) ? s.type.__asyncResolved || {} : c), { include: u, exclude: d, max: f } = e;
			if (u && (!l || !qi(u, l)) || d && l && qi(d, l)) return s.shapeFlag &= -257, o = s, r;
			let p = s.key == null ? c : s.key, m = i.get(p);
			return s.el && (s = ds(s), r.shapeFlag & 128 && (r.ssContent = s)), g = p, m ? (s.el = m.el, s.component = m.component, s.transition && li(s, s.transition), s.shapeFlag |= 512, a.delete(p), a.add(p)) : (a.add(p), f && a.size > parseInt(f, 10) && h(a.values().next().value)), s.shapeFlag |= 256, o = s, Io(r.type) ? r : s;
		};
	}
};
function qi(e, t) {
	return C(e) ? e.some((e) => qi(e, t)) : O(e) ? e.split(",").includes(t) : ee(e) ? (e.lastIndex = 0, e.test(t)) : !1;
}
function Ji(e, t) {
	Xi(e, "a", t);
}
function Yi(e, t) {
	Xi(e, "da", t);
}
function Xi(e, t, n = xs) {
	let r = e.__wdc ||= () => {
		let t = n;
		for (; t;) {
			if (t.isDeactivated) return;
			t = t.parent;
		}
		return e();
	};
	if (ea(t, r, n), n) {
		let e = n.parent;
		for (; e && e.parent;) Gi(e.parent.vnode) && Zi(r, t, n, e), e = e.parent;
	}
}
function Zi(e, t, n, r) {
	let i = ea(t, e, r, !0);
	sa(() => {
		b(r[t], i);
	}, n);
}
function Qi(e) {
	e.shapeFlag &= -257, e.shapeFlag &= -513;
}
function $i(e) {
	return e.shapeFlag & 128 ? e.ssContent : e;
}
function ea(e, t, n = xs, r = !1) {
	if (n) {
		let i = n[e] || (n[e] = []), a = t.__weh ||= (...r) => {
			ct();
			let i = Ts(n), a = Xn(t, n, e, r);
			return i(), lt(), a;
		};
		return r ? i.unshift(a) : i.push(a), a;
	}
}
var ta = (e) => (t, n = xs) => {
	(!Os || e === "sp") && ea(e, (...e) => t(...e), n);
}, na = ta("bm"), ra = ta("m"), ia = ta("bu"), aa = ta("u"), oa = ta("bum"), sa = ta("um"), ca = ta("sp"), la = ta("rtg"), ua = ta("rtc");
function da(e, t = xs) {
	ea("ec", e, t);
}
var fa = "components", pa = "directives";
function ma(e, t) {
	return va(fa, e, !0, t) || e;
}
var ha = /* @__PURE__ */ Symbol.for("v-ndc");
function ga(e) {
	return O(e) ? va(fa, e, !1) || e : e || ha;
}
function _a(e) {
	return va(pa, e);
}
function va(e, t, n = !0, r = !1) {
	let i = vr || xs;
	if (i) {
		let n = i.type;
		if (e === fa) {
			let e = Bs(n, !1);
			if (e && (e === t || e === j(t) || e === fe(j(t)))) return n;
		}
		let a = ya(i[e] || n[e], t) || ya(i.appContext[e], t);
		return !a && r ? n : a;
	}
}
function ya(e, t) {
	return e && (e[t] || e[j(t)] || e[fe(j(t))]);
}
function R(e, t, n, r) {
	let i, a = n && n[r], o = C(e);
	if (o || O(e)) {
		let n = o && /* @__PURE__ */ ln(e), r = !1, s = !1;
		n && (r = !/* @__PURE__ */ dn(e), s = /* @__PURE__ */ un(e), e = Ct(e)), i = Array(e.length);
		for (let n = 0, o = e.length; n < o; n++) i[n] = t(r ? s ? gn(hn(e[n])) : hn(e[n]) : e[n], n, void 0, a && a[n]);
	} else if (typeof e == "number") {
		i = Array(e);
		for (let n = 0; n < e; n++) i[n] = t(n + 1, n, void 0, a && a[n]);
	} else if (k(e)) if (e[Symbol.iterator]) i = Array.from(e, (e, n) => t(e, n, void 0, a && a[n]));
	else {
		let n = Object.keys(e);
		i = Array(n.length);
		for (let r = 0, o = n.length; r < o; r++) {
			let o = n[r];
			i[r] = t(e[o], o, r, a && a[r]);
		}
	}
	else i = [];
	return n && (n[r] = i), i;
}
function ba(e, t) {
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		if (C(r)) for (let t = 0; t < r.length; t++) e[r[t].name] = r[t].fn;
		else r && (e[r.name] = r.key ? (...e) => {
			let t = r.fn(...e);
			return t && (t.key = r.key), t;
		} : r.fn);
	}
	return e;
}
function z(e, t, n, r, i, a) {
	if (n ??= {}, vr.ce || vr.parent && Hi(vr.parent) && vr.parent.ce) {
		let e = a != null && n.key == null ? y({}, n, { key: a }) : n, i = Object.keys(e).length > 0;
		return t !== "default" && (e.name = t), V(), U(B, null, [G("slot", e, r && r())], i ? -2 : 64);
	}
	let o = e[t];
	o && o._c && (o._d = !1);
	let s = Qo.length;
	V();
	let c;
	try {
		let i = o && xa(o(n)), s = n.key || a || i && i.key;
		c = U(B, { key: (s && !te(s) ? s : `_${t}`) + (!i && r ? "_fb" : "") }, i || (r ? r() : []), i && e._ === 1 ? 64 : -2);
	} catch (e) {
		for (let e = Qo.length; e > s; e--) es();
		throw e;
	} finally {
		o && o._c && (o._d = !0);
	}
	return !i && c.scopeId && (c.slotScopeIds = [c.scopeId + "-s"]), c;
}
function xa(e) {
	return e.some((e) => !is(e) || !(e.type === Xo || e.type === B && !xa(e.children))) ? e : null;
}
function Sa(e, t) {
	let n = {};
	for (let r in e) n[t && /[A-Z]/.test(r) ? `on:${r}` : pe(r)] = e[r];
	return n;
}
var Ca = (e) => e ? Ds(e) ? zs(e) : Ca(e.parent) : null, wa = /* @__PURE__ */ y(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => e.props,
	$attrs: (e) => e.attrs,
	$slots: (e) => e.slots,
	$refs: (e) => e.refs,
	$parent: (e) => Ca(e.parent),
	$root: (e) => Ca(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => e.type,
	$forceUpdate: (e) => e.f ||= () => {
		cr(e.update);
	},
	$nextTick: (e) => e.n ||= or.bind(e.proxy),
	$watch: (e) => h
}), Ta = (e, t) => e !== p && !e.__isScriptSetup && S(e, t), Ea = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: i, props: a, accessCache: o, type: s, appContext: c } = e;
		if (t[0] !== "$") {
			let e = o[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return i[t];
				case 4: return n[t];
				case 3: return a[t];
			}
			else if (Ta(r, t)) return o[t] = 1, r[t];
			else if (S(a, t)) return o[t] = 3, a[t];
			else if (n !== p && S(n, t)) return o[t] = 4, n[t];
			else o[t] = 0;
		}
		let l = wa[t], u, d;
		if (l) return t === "$attrs" && yt(e.attrs, "get", ""), l(e);
		if ((u = s.__cssModules) && (u = u[t])) return u;
		if (n !== p && S(n, t)) return o[t] = 4, n[t];
		if (d = c.config.globalProperties, S(d, t)) return d[t];
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: i, ctx: a } = e;
		return Ta(i, t) ? (i[t] = n, !0) : S(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (a[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, props: a, type: o } }, s) {
		let c;
		return !!(n[s] || Ta(t, s) || S(a, s) || S(r, s) || S(wa, s) || S(i.config.globalProperties, s) || (c = o.__cssModules) && c[s]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? S(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
}, Da = /* @__PURE__ */ y({}, Ea, {
	get(e, t) {
		if (t !== Symbol.unscopables) return Ea.get(e, t, e);
	},
	has(e, t) {
		return t[0] !== "_" && !xe(t);
	}
});
function Oa() {
	return null;
}
function ka() {
	return null;
}
function Aa(e) {}
function ja(e) {}
function Ma() {
	return null;
}
function Na() {}
function Pa(e, t) {
	return null;
}
function Fa() {
	return La("useSlots").slots;
}
function Ia() {
	return La("useAttrs").attrs;
}
function La(e) {
	let t = Ss();
	return t.setupContext ||= Rs(t);
}
function Ra(e) {
	return C(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
function za(e, t) {
	let n = Ra(e);
	for (let e in t) {
		if (e.startsWith("__skip")) continue;
		let r = n[e];
		r ? C(r) || D(r) ? r = n[e] = {
			type: r,
			default: t[e]
		} : r.default = t[e] : r === null && (r = n[e] = { default: t[e] }), r && t[`__skip_${e}`] && (r.skipFactory = !0);
	}
	return n;
}
function Ba(e, t) {
	return !e || !t ? e || t : C(e) && C(t) ? e.concat(t) : y({}, Ra(e), Ra(t));
}
function Va(e, t) {
	let n = {};
	for (let r in e) t.includes(r) || Object.defineProperty(n, r, {
		enumerable: !0,
		get: () => e[r]
	});
	return n;
}
function Ha(e) {
	let t = Ss(), n = Os, r = e();
	Es(), n && ws(!1);
	let i = () => {
		Ts(t), n && ws(!0);
	}, a = () => {
		Ss() !== t && t.scope.off(), Es(), n && ws(!1);
	};
	return ne(r) && (r = r.catch((e) => {
		throw i(), Promise.resolve().then(() => Promise.resolve().then(a)), e;
	})), [r, () => {
		i(), Promise.resolve().then(a);
	}];
}
function Ua() {
	return {
		app: null,
		config: {
			isNativeTag: g,
			performance: !1,
			globalProperties: {},
			optionMergeStrategies: {},
			errorHandler: void 0,
			warnHandler: void 0,
			compilerOptions: {}
		},
		mixins: [],
		components: {},
		directives: {},
		provides: /* @__PURE__ */ Object.create(null),
		optionsCache: /* @__PURE__ */ new WeakMap(),
		propsCache: /* @__PURE__ */ new WeakMap(),
		emitsCache: /* @__PURE__ */ new WeakMap()
	};
}
var Wa = 0;
function Ga(e, t) {
	return function(n, r = null) {
		D(n) || (n = y({}, n)), r != null && !k(r) && (r = null);
		let i = Ua(), a = /* @__PURE__ */ new WeakSet(), o = [], s = !1, c = i.app = {
			_uid: Wa++,
			_component: n,
			_props: r,
			_container: null,
			_context: i,
			_instance: null,
			version: Ks,
			get config() {
				return i.config;
			},
			set config(e) {},
			use(e, ...t) {
				return a.has(e) || (e && D(e.install) ? (a.add(e), e.install(c, ...t)) : D(e) && (a.add(e), e(c, ...t))), c;
			},
			mixin(e) {
				return c;
			},
			component(e, t) {
				return t ? (i.components[e] = t, c) : i.components[e];
			},
			directive(e, t) {
				return t ? (i.directives[e] = t, c) : i.directives[e];
			},
			mount(a, o, l) {
				if (!s) {
					let u = c._ceVNode || G(n, r);
					return u.appContext = i, l === !0 ? l = "svg" : l === !1 && (l = void 0), o && t ? t(u, a) : e(u, a, l), s = !0, c._container = a, a.__vue_app__ = c, zs(u.component);
				}
			},
			onUnmount(e) {
				o.push(e);
			},
			unmount() {
				s && (Xn(o, c._instance, 16), e(null, c._container), delete c._container.__vue_app__);
			},
			provide(e, t) {
				return i.provides[e] = t, c;
			},
			runWithContext(e) {
				let t = Ka;
				Ka = c;
				try {
					return e();
				} finally {
					Ka = t;
				}
			}
		};
		return c;
	};
}
var Ka = null;
function qa(e, t, n = p) {
	let r = Ss(), i = j(t), a = de(t), o = Ja(e, i), s = En((o, s) => {
		let c, l = p, u;
		return Nr(() => {
			let t = e[i];
			me(c, t) && (c = t, s());
		}), {
			get() {
				return o(), n.get ? n.get(c) : c;
			},
			set(e) {
				let o = n.set ? n.set(e) : e;
				if (!me(o, c) && !(l !== p && me(e, l))) return;
				let d = r.vnode.props, f = !!(d && (t in d || i in d || a in d) && (`onUpdate:${t}` in d || `onUpdate:${i}` in d || `onUpdate:${a}` in d));
				f || (c = e, s()), r.emit(`update:${t}`, o), me(e, l) && (me(e, o) && !me(o, u) || f && l !== p && !me(o, c)) && s(), l = e, u = o;
			}
		};
	});
	return s[Symbol.iterator] = () => {
		let e = 0;
		return { next() {
			return e < 2 ? {
				value: e++ ? o || p : s,
				done: !1
			} : { done: !0 };
		} };
	}, s;
}
var Ja = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${j(t)}Modifiers`] || e[`${de(t)}Modifiers`];
function Ya(e, t, ...n) {
	if (e.isUnmounted) return;
	let r = e.vnode.props || p, i = n, a = t.startsWith("update:"), o = a && Ja(r, t.slice(7));
	o && (o.trim && (i = n.map((e) => O(e) ? e.trim() : e)), o.number && (i = n.map(_e)));
	let s, c = r[s = pe(t)] || r[s = pe(j(t))];
	!c && a && (c = r[s = pe(de(t))]), c && Xn(c, e, 6, i);
	let l = r[s + "Once"];
	if (l) {
		if (!e.emitted) e.emitted = {};
		else if (e.emitted[s]) return;
		e.emitted[s] = !0, Xn(l, e, 6, i);
	}
}
function Xa(e, t, n = !1) {
	let r = t.emitsCache, i = r.get(e);
	if (i !== void 0) return i;
	let a = e.emits, o = {};
	return a ? (C(a) ? a.forEach((e) => o[e] = null) : y(o, a), k(e) && r.set(e, o), o) : (k(e) && r.set(e, null), null);
}
function Za(e, t) {
	return !e || !_(t) ? !1 : (t = t.slice(2), t = t === "Once" ? t : t.replace(/Once$/, ""), S(e, t[0].toLowerCase() + t.slice(1)) || S(e, de(t)) || S(e, t));
}
function Qa(e) {
	let { type: t, vnode: n, proxy: r, withProxy: i, propsOptions: [a], slots: o, attrs: s, emit: c, render: l, renderCache: u, props: d, data: f, setupState: p, ctx: m, inheritAttrs: h } = e, g = br(e), _, y;
	try {
		if (n.shapeFlag & 4) {
			let e = i || r, t = e;
			_ = ps(l.call(t, e, u, d, p, f, m)), y = s;
		} else {
			let e = t;
			_ = ps(e.length > 1 ? e(d, {
				attrs: s,
				slots: o,
				emit: c
			}) : e(d, null)), y = t.props ? s : eo(s);
		}
	} catch (t) {
		Qo.length = 0, Zn(t, e, 1), _ = G(Xo);
	}
	let b = _;
	if (y && h !== !1) {
		let e = Object.keys(y), { shapeFlag: t } = b;
		e.length && t & 7 && (a && e.some(v) && (y = to(y, a)), b = ds(b, y, !1, !0));
	}
	return n.dirs && (b = ds(b, null, !1, !0), b.dirs = b.dirs ? b.dirs.concat(n.dirs) : n.dirs), n.transition && li(Rr(b.type) && ci(b) || b, n.transition), _ = b, br(g), _;
}
function $a(e, t = !0) {
	let n;
	for (let t = 0; t < e.length; t++) {
		let r = e[t];
		if (is(r)) {
			if (r.type !== Xo || r.children === "v-if") {
				if (n) return;
				n = r;
			}
		} else return;
	}
	return n;
}
var eo = (e) => {
	let t;
	for (let n in e) (n === "class" || n === "style" || _(n)) && ((t ||= {})[n] = e[n]);
	return t;
}, to = (e, t) => {
	let n = {};
	for (let r in e) (!v(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
	return n;
};
function no(e, t, n) {
	let { props: r, children: i, component: a } = e, { props: o, children: s, patchFlag: c } = t, l = a.emitsOptions;
	if (t.dirs || t.transition) return !0;
	if (n && c >= 0) {
		if (c & 1024) return !0;
		if (c & 16) return r ? ro(r, o, l) : !!o;
		if (c & 8) {
			let e = t.dynamicProps;
			for (let t = 0; t < e.length; t++) {
				let n = e[t];
				if (io(o, r, n) && !Za(l, n)) return !0;
			}
		}
	} else return (i || s) && (!s || !s.$stable) ? !0 : r === o ? !1 : r ? !o || ro(r, o, l) : !!o;
	return !1;
}
function ro(e, t, n) {
	let r = Object.keys(t);
	if (r.length !== Object.keys(e).length) return !0;
	for (let i = 0; i < r.length; i++) {
		let a = r[i];
		if (io(t, e, a) && !Za(n, a)) return !0;
	}
	return !1;
}
function io(e, t, n) {
	let r = e[n], i = t[n];
	return n === "style" && k(r) && k(i) ? !Me(r, i) : r !== i;
}
function ao({ vnode: e, parent: t, suspense: n }, r) {
	for (; t;) {
		let n = t.subTree;
		if (n.suspense && n.suspense.activeBranch === e && (n.suspense.vnode.el = n.el = r, e = n), n === e) (e = t.vnode).el = r, t = t.parent;
		else break;
	}
	n && n.activeBranch === e && (n.vnode.el = r);
}
var oo = {}, so = () => Object.create(oo), co = (e) => Object.getPrototypeOf(e) === oo;
function lo(e, t, n, r = !1) {
	let i = {}, a = so();
	e.propsDefaults = /* @__PURE__ */ Object.create(null), fo(e, t, i, a);
	for (let t in e.propsOptions[0]) t in i || (i[t] = void 0);
	e.props = n ? r ? i : /* @__PURE__ */ an(i) : e.type.props ? i : a, e.attrs = a;
}
function uo(e, t, n, r) {
	let { props: i, attrs: a, vnode: { patchFlag: o } } = e, s = /* @__PURE__ */ pn(i), [c] = e.propsOptions, l = !1;
	if ((r || o > 0) && !(o & 16)) {
		if (o & 8) {
			let n = e.vnode.dynamicProps;
			for (let r = 0; r < n.length; r++) {
				let o = n[r];
				if (Za(e.emitsOptions, o)) continue;
				let u = t[o];
				if (c) if (S(a, o)) u !== a[o] && (a[o] = u, l = !0);
				else {
					let t = j(o);
					i[t] = po(c, s, t, u, e, !1);
				}
				else u !== a[o] && (a[o] = u, l = !0);
			}
		}
	} else {
		fo(e, t, i, a) && (l = !0);
		let r;
		for (let a in s) (!t || !S(t, a) && ((r = de(a)) === a || !S(t, r))) && (c ? n && (n[a] !== void 0 || n[r] !== void 0) && (i[a] = po(c, s, a, void 0, e, !0)) : delete i[a]);
		if (a !== s) for (let e in a) (!t || !S(t, e)) && (delete a[e], l = !0);
	}
	l && bt(e.attrs, "set", "");
}
function fo(e, t, n, r) {
	let [i, a] = e.propsOptions, o = !1, s;
	if (t) for (let c in t) {
		if (se(c)) continue;
		let l = t[c], u;
		i && S(i, u = j(c)) ? !a || !a.includes(u) ? n[u] = l : (s ||= {})[u] = l : Za(e.emitsOptions, c) || (!(c in r) || l !== r[c]) && (r[c] = l, o = !0);
	}
	if (a) {
		let t = /* @__PURE__ */ pn(n), r = s || p;
		for (let o = 0; o < a.length; o++) {
			let s = a[o];
			n[s] = po(i, t, s, r[s], e, !S(r, s));
		}
	}
	return o;
}
function po(e, t, n, r, i, a) {
	let o = e[n];
	if (o != null) {
		let e = S(o, "default");
		if (e && r === void 0) {
			let e = o.default;
			if (o.type !== Function && !o.skipFactory && D(e)) {
				let { propsDefaults: a } = i;
				if (n in a) r = a[n];
				else {
					let o = Ts(i);
					r = a[n] = e.call(null, t), o();
				}
			} else r = e;
			i.ce && i.ce._setProp(n, r);
		}
		o[0] && (a && !e ? r = !1 : o[1] && (r === "" || r === de(n)) && (r = !0));
	}
	return r;
}
function mo(e, t, n = !1) {
	let r = t.propsCache, i = r.get(e);
	if (i) return i;
	let a = e.props, o = {}, s = [];
	if (!a) return k(e) && r.set(e, m), m;
	if (C(a)) for (let e = 0; e < a.length; e++) {
		let t = j(a[e]);
		ho(t) && (o[t] = p);
	}
	else if (a) for (let e in a) {
		let t = j(e);
		if (ho(t)) {
			let n = a[e], r = o[t] = C(n) || D(n) ? { type: n } : y({}, n), i = r.type, c = !1, l = !0;
			if (C(i)) for (let e = 0; e < i.length; ++e) {
				let t = i[e], n = D(t) && t.name;
				if (n === "Boolean") {
					c = !0;
					break;
				}
				n === "String" && (l = !1);
			}
			else c = D(i) && i.name === "Boolean";
			r[0] = c, r[1] = l, (c || S(r, "default")) && s.push(t);
		}
	}
	let c = [o, s];
	return k(e) && r.set(e, c), c;
}
function ho(e) {
	return e[0] !== "$" && !se(e);
}
var go = (e) => e === "_" || e === "_ctx" || e === "$stable", _o = (e) => C(e) ? e.map(ps) : [ps(e)], vo = (e, t, n) => {
	if (t._n) return t;
	let r = I((...e) => _o(t(...e)), n);
	return r._c = !1, r;
}, yo = (e, t, n) => {
	let r = e._ctx;
	for (let n in e) {
		if (go(n)) continue;
		let i = e[n];
		if (D(i)) t[n] = vo(n, i, r);
		else if (i != null) {
			let e = _o(i);
			t[n] = () => e;
		}
	}
}, bo = (e, t) => {
	let n = _o(t);
	e.slots.default = () => n;
}, xo = (e, t, n) => {
	for (let r in t) (n || !go(r)) && (e[r] = t[r]);
}, So = (e, t, n) => {
	let r = e.slots = so();
	if (e.vnode.shapeFlag & 32) {
		let e = t._;
		e ? (xo(r, t, n), n && ge(r, "_", e, !0)) : yo(t, r);
	} else t && bo(e, t);
}, Co = (e, t, n) => {
	let { vnode: r, slots: i } = e, a = !0, o = p;
	if (r.shapeFlag & 32) {
		let e = t._;
		e ? n && e === 1 ? a = !1 : xo(i, t, n) : (a = !t.$stable, yo(t, i)), o = t;
	} else t && (bo(e, t), o = { default: 1 });
	if (a) for (let e in i) !go(e) && o[e] == null && delete i[e];
}, wo = Ko;
function To(e) {
	return Do(e);
}
function Eo(e) {
	return Do(e, wi);
}
function Do(e, t) {
	let n = be();
	n.__VUE__ = !0;
	let { insert: r, remove: i, patchProp: a, createElement: o, createText: s, createComment: c, setText: l, setElementText: u, parentNode: d, nextSibling: f, setScopeId: g = h, insertStaticContent: _ } = e, v = (e, t, n, r = null, i = null, a = null, o = void 0, s = null, c = !!t.dynamicChildren) => {
		if (e === t) return;
		e && !as(e, t) && (r = ge(e), ue(e, i, a, !0), e = null), t.patchFlag === -2 && (c = !1, t.dynamicChildren = null);
		let { type: l, ref: u, shapeFlag: d } = t;
		switch (l) {
			case Yo:
				y(e, t, n, r);
				break;
			case Xo:
				b(e, t, n, r);
				break;
			case Zo:
				e ?? x(t, n, r, o);
				break;
			case B:
				k(e, t, n, r, i, a, o, s, c);
				break;
			default: d & 1 ? w(e, t, n, r, i, a, o, s, c) : d & 6 ? ne(e, t, n, r, i, a, o, s, c) : (d & 64 || d & 128) && l.process(e, t, n, r, i, a, o, s, c, ye);
		}
		u != null && i ? gi(u, e && e.ref, a, t || e, !t) : u == null && e && e.ref != null && gi(e.ref, null, a, e, !0);
	}, y = (e, t, n, i) => {
		if (e == null) r(t.el = s(t.children), n, i);
		else {
			let n = t.el = e.el;
			t.children !== e.children && l(n, t.children);
		}
	}, b = (e, t, n, i) => {
		e == null ? r(t.el = c(t.children || ""), n, i) : t.el = e.el;
	}, x = (e, t, n, r) => {
		[e.el, e.anchor] = _(e.children, t, n, r, e.el, e.anchor);
	}, S = ({ el: e, anchor: t }, n, i) => {
		let a;
		for (; e && e !== t;) a = f(e), r(e, n, i), e = a;
		r(t, n, i);
	}, C = ({ el: e, anchor: t }) => {
		let n;
		for (; e && e !== t;) n = f(e), i(e), e = n;
		i(t);
	}, w = (e, t, n, r, i, a, o, s, c) => {
		if (t.type === "svg" ? o = "svg" : t.type === "math" && (o = "mathml"), e == null) T(t, n, r, i, a, o, s, c);
		else {
			let n = e.el && e.el._isVueCE ? e.el : null;
			try {
				n && n._beginPatch(), D(e, t, i, a, o, s, c);
			} finally {
				n && n._endPatch();
			}
		}
	}, T = (e, t, n, i, s, c, l, d) => {
		let f, p, { props: m, shapeFlag: h, transition: g, dirs: _ } = e;
		if (f = e.el = o(e.type, c, m && m.is, m), h & 8 ? u(f, e.children) : h & 16 && ee(e.children, f, null, i, s, Oo(e, c), l, d), _ && Tr(e, null, i, "created"), E(f, e, e.scopeId, l, i), m) {
			for (let e in m) e !== "value" && !se(e) && a(f, e, null, m[e], c, i);
			"value" in m && a(f, "value", null, m.value, c), (p = m.onVnodeBeforeMount) && _s(p, i, e);
		}
		_ && Tr(e, null, i, "beforeMount");
		let v = Ao(s, g);
		v && g.beforeEnter(f), r(f, t, n), ((p = m && m.onVnodeMounted) || v || _) && wo(() => {
			try {
				p && _s(p, i, e), v && g.enter(f), _ && Tr(e, null, i, "mounted");
			} finally {}
		}, s);
	}, E = (e, t, n, r, i) => {
		if (n && g(e, n), r) for (let t = 0; t < r.length; t++) g(e, r[t]);
		if (i) {
			let n = i.subTree;
			if (t === n || Io(n.type) && (n.ssContent === t || n.ssFallback === t)) {
				let t = i.vnode;
				E(e, t, t.scopeId, t.slotScopeIds, i.parent);
			}
		}
	}, ee = (e, t, n, r, i, a, o, s, c = 0) => {
		for (let l = c; l < e.length; l++) {
			let c = e[l] = s ? ms(e[l]) : ps(e[l]);
			v(null, c, t, n, r, i, a, o, s);
		}
	}, D = (e, t, n, r, i, o, s) => {
		let c = t.el = e.el, { patchFlag: l, dynamicChildren: d, dirs: f } = t;
		l |= e.patchFlag & 16;
		let m = e.props || p, h = t.props || p, g;
		if (n && ko(n, !1), (g = h.onVnodeBeforeUpdate) && _s(g, n, t, e), f && Tr(t, e, n, "beforeUpdate"), n && ko(n, !0), d && (!e.dynamicChildren || e.dynamicChildren.length !== d.length) && (l = 0, s = !1, d = null), (m.innerHTML && h.innerHTML == null || m.textContent && h.textContent == null) && u(c, ""), d ? O(e.dynamicChildren, d, c, n, r, Oo(t, i), o) : s || oe(e, t, c, null, n, r, Oo(t, i), o, !1), l > 0) {
			if (l & 16) te(c, m, h, n, i);
			else if (l & 2 && m.class !== h.class && a(c, "class", null, h.class, i), l & 4 && a(c, "style", m.style, h.style, i), l & 8) {
				let e = t.dynamicProps;
				for (let t = 0; t < e.length; t++) {
					let r = e[t], o = m[r], s = h[r];
					(s !== o || r === "value") && a(c, r, o, s, i, n);
				}
			}
			l & 1 && e.children !== t.children && u(c, t.children);
		} else !s && d == null && te(c, m, h, n, i);
		((g = h.onVnodeUpdated) || f) && wo(() => {
			g && _s(g, n, t, e), f && Tr(t, e, n, "updated");
		}, r);
	}, O = (e, t, n, r, i, a, o) => {
		for (let s = 0; s < t.length; s++) {
			let c = e[s], l = t[s], u = c.el && (c.type === B || !as(c, l) || c.shapeFlag & 198) ? d(c.el) : n;
			v(c, l, u, null, r, i, a, o, !0);
		}
	}, te = (e, t, n, r, i) => {
		if (t !== n) {
			if (t !== p) for (let o in t) !se(o) && !(o in n) && a(e, o, t[o], null, i, r);
			for (let o in n) {
				if (se(o)) continue;
				let s = n[o], c = t[o];
				s !== c && o !== "value" && a(e, o, c, s, i, r);
			}
			"value" in n && a(e, "value", t.value, n.value, i);
		}
	}, k = (e, t, n, i, a, o, c, l, u) => {
		let d = t.el = e ? e.el : s(""), f = t.anchor = e ? e.anchor : s(""), { patchFlag: p, dynamicChildren: m, slotScopeIds: h } = t;
		h && (l = l ? l.concat(h) : h), e == null ? (r(d, n, i), r(f, n, i), ee(t.children || [], n, f, a, o, c, l, u)) : p > 0 && p & 64 && m && e.dynamicChildren && e.dynamicChildren.length === m.length ? (O(e.dynamicChildren, m, n, a, o, c, l), (t.key != null || a && t === a.subTree) && jo(e, t, !0)) : oe(e, t, n, f, a, o, c, l, u);
	}, ne = (e, t, n, r, i, a, o, s, c) => {
		t.slotScopeIds = s, e == null ? t.shapeFlag & 512 ? i.ctx.activate(t, n, r, o, c) : re(t, n, r, i, a, o, c) : ie(e, t, c);
	}, re = (e, t, n, r, i, a, o) => {
		let s = e.component = bs(e, r, i);
		if (Gi(e) && (s.ctx.renderer = ye), ks(s, !1, o), s.asyncDep) {
			if (i && i.registerDep(s, ae, o), !e.el) {
				let r = s.subTree = G(Xo);
				b(null, r, t, n), e.placeholder = r.el;
			}
		} else ae(s, e, t, n, i, a, o);
	}, ie = (e, t, n) => {
		let r = t.component = e.component;
		if (no(e, t, n)) if (r.asyncDep && !r.asyncResolved) {
			A(r, t, n);
			return;
		} else r.next = t, r.update();
		else t.el = e.el, r.vnode = t;
	}, ae = (e, t, n, r, i, a, o) => {
		let s = () => {
			if (e.isMounted) {
				let { next: t, bu: n, u: r, parent: s, vnode: c } = e;
				{
					let n = No(e);
					if (n) {
						t && (t.el = c.el, A(e, t, o)), n.asyncDep.then(() => {
							wo(() => {
								e.isUnmounted || l();
							}, i);
						});
						return;
					}
				}
				let u = t, f;
				ko(e, !1), t ? (t.el = c.el, A(e, t, o)) : t = c, n && he(n), (f = t.props && t.props.onVnodeBeforeUpdate) && _s(f, s, t, c), ko(e, !0);
				let p = Qa(e), m = e.subTree;
				e.subTree = p, v(m, p, d(m.el), ge(m), e, i, a), t.el = p.el, u === null && ao(e, p.el), r && wo(r, i), (f = t.props && t.props.onVnodeUpdated) && wo(() => _s(f, s, t, c), i);
			} else {
				let o, { el: s, props: c } = t, { bm: l, m: u, parent: d, root: f, type: p } = e, m = Hi(t);
				if (ko(e, !1), l && he(l), !m && (o = c && c.onVnodeBeforeMount) && _s(o, d, t), ko(e, !0), s && Se) {
					let t = () => {
						e.subTree = Qa(e), Se(s, e.subTree, e, i, null);
					};
					m && p.__asyncHydrate ? p.__asyncHydrate(s, e, t) : t();
				} else {
					f.ce && f.ce._hasShadowRoot() && f.ce._injectChildStyle(p, e.parent ? e.parent.type : void 0);
					let o = e.subTree = Qa(e);
					v(null, o, n, r, e, i, a), t.el = o.el;
				}
				if (u && wo(u, i), !m && (o = c && c.onVnodeMounted)) {
					let e = t;
					wo(() => _s(o, d, e), i);
				}
				(t.shapeFlag & 256 || d && Hi(d.vnode) && d.vnode.shapeFlag & 256) && e.a && wo(e.a, i), e.isMounted = !0, t = n = r = null;
			}
		};
		e.scope.on();
		let c = e.effect = new Ge(s);
		e.scope.off();
		let l = e.update = c.run.bind(c), u = e.job = c.runIfDirty.bind(c);
		u.i = e, u.id = e.uid, c.scheduler = () => cr(u), ko(e, !0), l();
	}, A = (e, t, n) => {
		t.component = e;
		let r = e.vnode.props;
		e.vnode = t, e.next = null, uo(e, t.props, r, n), Co(e, t.children, n), ct(), dr(e), lt();
	}, oe = (e, t, n, r, i, a, o, s, c = !1) => {
		let l = e && e.children, d = e ? e.shapeFlag : 0, f = t.children, { patchFlag: p, shapeFlag: m } = t;
		if (p > 0) {
			if (p & 128) {
				le(l, f, n, r, i, a, o, s, c);
				return;
			}
			if (p & 256) {
				ce(l, f, n, r, i, a, o, s, c);
				return;
			}
		}
		m & 8 ? (d & 16 && me(l, i, a), f !== l && u(n, f)) : d & 16 ? m & 16 ? le(l, f, n, r, i, a, o, s, c) : me(l, i, a, !0) : (d & 8 && u(n, ""), m & 16 && ee(f, n, r, i, a, o, s, c));
	}, ce = (e, t, n, r, i, a, o, s, c) => {
		e ||= m, t ||= m;
		let l = e.length, u = t.length, d = Math.min(l, u), f;
		for (f = 0; f < d; f++) {
			let r = t[f] = c ? ms(t[f]) : ps(t[f]);
			v(e[f], r, n, null, i, a, o, s, c);
		}
		l > u ? me(e, i, a, !0, !1, d) : ee(t, n, r, i, a, o, s, c, d);
	}, le = (e, t, n, r, i, a, o, s, c) => {
		let l = 0, u = t.length, d = e.length - 1, f = u - 1;
		for (; l <= d && l <= f;) {
			let r = e[l], u = t[l] = c ? ms(t[l]) : ps(t[l]);
			if (as(r, u)) v(r, u, n, null, i, a, o, s, c);
			else break;
			l++;
		}
		for (; l <= d && l <= f;) {
			let r = e[d], l = t[f] = c ? ms(t[f]) : ps(t[f]);
			if (as(r, l)) v(r, l, n, null, i, a, o, s, c);
			else break;
			d--, f--;
		}
		if (l > d) {
			if (l <= f) {
				let e = f + 1, d = e < u ? t[e].el : r;
				for (; l <= f;) v(null, t[l] = c ? ms(t[l]) : ps(t[l]), n, d, i, a, o, s, c), l++;
			}
		} else if (l > f) for (; l <= d;) ue(e[l], i, a, !0), l++;
		else {
			let p = l, h = l, g = /* @__PURE__ */ new Map();
			for (l = h; l <= f; l++) {
				let e = t[l] = c ? ms(t[l]) : ps(t[l]);
				e.key != null && g.set(e.key, l);
			}
			let _, y = 0, b = f - h + 1, x = !1, S = 0, C = Array(b);
			for (l = 0; l < b; l++) C[l] = 0;
			for (l = p; l <= d; l++) {
				let r = e[l];
				if (y >= b) {
					ue(r, i, a, !0);
					continue;
				}
				let u;
				if (r.key != null) u = g.get(r.key);
				else for (_ = h; _ <= f; _++) if (C[_ - h] === 0 && as(r, t[_])) {
					u = _;
					break;
				}
				u === void 0 ? ue(r, i, a, !0) : (C[u - h] = l + 1, u >= S ? S = u : x = !0, v(r, t[u], n, null, i, a, o, s, c), y++);
			}
			let w = x ? Mo(C) : m;
			for (_ = w.length - 1, l = b - 1; l >= 0; l--) {
				let e = h + l, d = t[e], f = t[e + 1], p = e + 1 < u ? f.el || Fo(f) : r;
				C[l] === 0 ? v(null, d, n, p, i, a, o, s, c) : x && (_ < 0 || l !== w[_] ? j(d, n, p, 2) : _--);
			}
		}
	}, j = (e, t, n, a, o = null) => {
		let { el: s, type: c, transition: l, children: u, shapeFlag: d } = e;
		if (d & 6) {
			j(e.component.subTree, t, n, a);
			return;
		}
		if (d & 128) {
			e.suspense.move(t, n, a);
			return;
		}
		if (d & 64) {
			c.move(e, t, n, ye);
			return;
		}
		if (c === B) {
			r(s, t, n);
			for (let e = 0; e < u.length; e++) j(u[e], t, n, a);
			r(e.anchor, t, n);
			return;
		}
		if (c === Zo) {
			S(e, t, n);
			return;
		}
		if (a !== 2 && d & 1 && l) if (a === 0) l.persisted && !s[Xr] ? r(s, t, n) : (l.beforeEnter(s), r(s, t, n), wo(() => l.enter(s), o));
		else {
			let { leave: a, delayLeave: o, afterLeave: c } = l, u = () => {
				e.ctx.isUnmounted ? i(s) : r(s, t, n);
			}, d = () => {
				let e = s._isLeaving || !!s[Xr];
				s._isLeaving && s[Xr](!0), l.persisted && !e ? u() : a(s, () => {
					u(), c && c();
				});
			};
			o ? o(s, u, d) : d();
		}
		else r(s, t, n);
	}, ue = (e, t, n, r = !1, i = !1) => {
		let { type: a, props: o, ref: s, children: c, dynamicChildren: l, shapeFlag: u, patchFlag: d, dirs: f, cacheIndex: p, memo: m } = e;
		if (d === -2 && (i = !1), s != null && (ct(), gi(s, null, n, e, !0), lt()), p != null && (t.renderCache[p] = void 0), u & 256) {
			t.ctx.deactivate(e);
			return;
		}
		let h = u & 1 && f, g = !Hi(e), _;
		if (g && (_ = o && o.onVnodeBeforeUnmount) && _s(_, t, e), u & 6) pe(e.component, n, r);
		else {
			if (u & 128) {
				e.suspense.unmount(n, r);
				return;
			}
			h && Tr(e, null, t, "beforeUnmount"), u & 64 ? e.type.remove(e, t, n, ye, r) : l && !l.hasOnce && (a !== B || d > 0 && d & 64) ? me(l, t, n, !1, !0) : (a === B && d & 384 || !i && u & 16) && me(c, t, n), r && de(e);
		}
		let v = m != null && p == null;
		(g && (_ = o && o.onVnodeUnmounted) || h || v) && wo(() => {
			_ && _s(_, t, e), h && Tr(e, null, t, "unmounted"), v && (e.el = null);
		}, n);
	}, de = (e) => {
		let { type: t, el: n, anchor: r, transition: a } = e;
		if (t === B) {
			fe(n, r);
			return;
		}
		if (t === Zo) {
			C(e);
			return;
		}
		let o = () => {
			i(n), a && !a.persisted && a.afterLeave && a.afterLeave();
		};
		if (e.shapeFlag & 1 && a && !a.persisted) {
			let { leave: t, delayLeave: r } = a, i = () => t(n, o);
			r ? r(e.el, o, i) : i();
		} else o();
	}, fe = (e, t) => {
		let n;
		for (; e !== t;) n = f(e), i(e), e = n;
		i(t);
	}, pe = (e, t, n) => {
		let { bum: r, scope: i, job: a, subTree: o, um: s, m: c, a: l } = e;
		Po(c), Po(l), r && he(r), i.stop(), a && (a.flags |= 8, ue(o, e, t, n)), s && wo(s, t), wo(() => {
			e.isUnmounted = !0;
		}, t);
	}, me = (e, t, n, r = !1, i = !1, a = 0) => {
		for (let o = a; o < e.length; o++) ue(e[o], t, n, r, i);
	}, ge = (e) => {
		if (e.shapeFlag & 6) return ge(e.component.subTree);
		if (e.shapeFlag & 128) return e.suspense.next();
		let t = f(e.anchor || e.el), n = t && t[Lr];
		return n ? f(n) : t;
	}, _e = !1, ve = (e, t, n) => {
		let r;
		e == null ? t._vnode && (ue(t._vnode, null, null, !0), r = t._vnode.component) : v(t._vnode || null, e, t, null, null, null, n), t._vnode = e, _e ||= (_e = !0, dr(r), fr(), !1);
	}, ye = {
		p: v,
		um: ue,
		m: j,
		r: de,
		mt: re,
		mc: ee,
		pc: oe,
		pbc: O,
		n: ge,
		o: e
	}, xe, Se;
	return t && ([xe, Se] = t(ye)), {
		render: ve,
		hydrate: xe,
		createApp: Ga(ve, xe)
	};
}
function Oo({ type: e, props: t }, n) {
	return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function ko({ effect: e, job: t }, n) {
	n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function Ao(e, t) {
	return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function jo(e, t, n = !1) {
	let r = e.children, i = t.children;
	if (C(r) && C(i)) for (let e = 0; e < r.length; e++) {
		let t = r[e], a = i[e];
		a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = i[e] = ms(i[e]), a.el = t.el), !n && a.patchFlag !== -2 && jo(t, a)), a.type === Yo && (a.patchFlag === -1 && (a = i[e] = ms(a)), a.el = t.el), a.type === Xo && !a.el && (a.el = t.el);
	}
}
function Mo(e) {
	let t = e.slice(), n = [0], r, i, a, o, s, c = e.length;
	for (r = 0; r < c; r++) {
		let c = e[r];
		if (c !== 0) {
			if (i = n[n.length - 1], e[i] < c) {
				t[r] = i, n.push(r);
				continue;
			}
			for (a = 0, o = n.length - 1; a < o;) s = a + o >> 1, e[n[s]] < c ? a = s + 1 : o = s;
			c < e[n[a]] && (a > 0 && (t[r] = n[a - 1]), n[a] = r);
		}
	}
	for (a = n.length, o = n[a - 1]; a-- > 0;) n[a] = o, o = t[o];
	return n;
}
function No(e) {
	let t = e.subTree.component;
	if (t) return t.asyncDep && !t.asyncResolved ? t : No(t);
}
function Po(e) {
	if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
}
function Fo(e) {
	if (e.placeholder) return e.placeholder;
	let t = e.component;
	return t ? Fo(t.subTree) : null;
}
var Io = (e) => e.__isSuspense, Lo = 0, Ro = {
	name: "Suspense",
	__isSuspense: !0,
	process(e, t, n, r, i, a, o, s, c, l) {
		if (e == null) Bo(t, n, r, i, a, o, s, c, l);
		else {
			if (a && a.deps > 0 && !e.suspense.isInFallback) {
				t.suspense = e.suspense, t.suspense.vnode = t, t.el = e.el;
				return;
			}
			Vo(e, t, n, r, i, o, s, c, l);
		}
	},
	hydrate: Uo,
	normalize: Wo
};
function zo(e, t) {
	let n = e.props && e.props[t];
	D(n) && n();
}
function Bo(e, t, n, r, i, a, o, s, c) {
	let { p: l, o: { createElement: u } } = c, d = u("div"), f = e.suspense = Ho(e, i, r, t, d, n, a, o, s, c);
	l(null, f.pendingBranch = e.ssContent, d, null, r, f, a, o), f.deps > 0 ? (zo(e, "onPending"), zo(e, "onFallback"), l(null, e.ssFallback, t, n, r, null, a, o), qo(f, e.ssFallback)) : f.resolve(!1, !0);
}
function Vo(e, t, n, r, i, a, o, s, { p: c, um: l, o: { createElement: u } }) {
	let d = t.suspense = e.suspense;
	d.vnode = t, t.el = e.el;
	let f = t.ssContent, p = t.ssFallback, { activeBranch: m, pendingBranch: h, isInFallback: g, isHydrating: _ } = d;
	if (h) d.pendingBranch = f, as(h, f) ? (c(h, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0 ? d.resolve() : g && (_ || (c(m, p, n, r, i, null, a, o, s), qo(d, p)))) : (d.pendingId = Lo++, _ ? (d.isHydrating = !1, d.activeBranch = h) : l(h, i, d), d.deps = 0, d.effects.length = 0, d.hiddenContainer = u("div"), g ? (c(null, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0 ? d.resolve() : (c(m, p, n, r, i, null, a, o, s), qo(d, p))) : m && as(m, f) ? (c(m, f, n, r, i, d, a, o, s), d.resolve(!0)) : (c(null, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0 && d.resolve()));
	else if (m && as(m, f)) c(m, f, n, r, i, d, a, o, s), qo(d, f);
	else if (zo(t, "onPending"), d.pendingBranch = f, d.pendingId = f.shapeFlag & 512 ? f.component.suspenseId : Lo++, c(null, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0) d.resolve();
	else {
		let { timeout: e, pendingId: t } = d;
		e > 0 ? setTimeout(() => {
			d.pendingId === t && d.fallback(p);
		}, e) : e === 0 && d.fallback(p);
	}
}
function Ho(e, t, n, r, i, a, o, s, c, l, u = !1) {
	let { p: d, m: f, um: p, n: m, o: { parentNode: h, remove: g } } = l, _, v = Jo(e);
	v && t && t.pendingBranch && (_ = t.pendingId, t.deps++);
	let y = e.props ? ve(e.props.timeout) : void 0, b = a, x = {
		vnode: e,
		parent: t,
		parentComponent: n,
		namespace: o,
		container: r,
		hiddenContainer: i,
		deps: 0,
		pendingId: Lo++,
		timeout: typeof y == "number" ? y : -1,
		activeBranch: null,
		isFallbackMountPending: !1,
		pendingBranch: null,
		isInFallback: !u,
		isHydrating: u,
		isUnmounted: !1,
		effects: [],
		resolve(e = !1, n = !1) {
			let { vnode: r, activeBranch: i, pendingBranch: o, pendingId: s, effects: c, parentComponent: l, container: u, isInFallback: d } = x, g = !1;
			if (x.isHydrating) x.isHydrating = !1;
			else if (!e) {
				g = i && o.transition && o.transition.mode === "out-in";
				let e = !1;
				g && (i.transition.afterLeave = () => {
					s === x.pendingId && (f(o, u, a === b && !e ? m(i) : a, 0), ur(c), d && r.ssFallback && (r.ssFallback.el = null));
				}), i && !x.isFallbackMountPending && (h(i.el) === u && (a = m(i), e = !0), p(i, l, x, !0), !g && d && r.ssFallback && wo(() => r.ssFallback.el = null, x)), g || f(o, u, a, 0);
			}
			x.isFallbackMountPending = !1, qo(x, o), x.pendingBranch = null, x.isInFallback = !1;
			let y = x.parent, S = !1;
			for (; y;) {
				if (y.pendingBranch) {
					for (let e = 0; e < c.length; e++) y.effects.push(c[e]);
					S = !0;
					break;
				}
				y = y.parent;
			}
			!S && !g && ur(c), x.effects = [], v && t && t.pendingBranch && _ === t.pendingId && (t.deps--, t.deps === 0 && !n && t.resolve()), zo(r, "onResolve");
		},
		fallback(e) {
			if (!x.pendingBranch) return;
			let { vnode: t, activeBranch: n, parentComponent: r, container: i, namespace: a } = x;
			zo(t, "onFallback");
			let o = m(n), l = () => {
				x.isFallbackMountPending = !1, x.isInFallback && (d(null, e, i, o, r, null, a, s, c), qo(x, e));
			}, u = e.transition && e.transition.mode === "out-in";
			u && (x.isFallbackMountPending = !0, n.transition.afterLeave = l), x.isInFallback = !0, p(n, r, null, !0), u || l();
		},
		move(e, t, n) {
			x.activeBranch && f(x.activeBranch, e, t, n), x.container = e;
		},
		next() {
			return x.activeBranch && m(x.activeBranch);
		},
		registerDep(e, t, n) {
			let r = !!x.pendingBranch;
			r && x.deps++;
			let i = e.vnode.el;
			e.asyncDep.catch((t) => {
				Zn(t, e, 0);
			}).then((a) => {
				if (e.isUnmounted || x.isUnmounted || x.pendingId !== e.suspenseId) return;
				Es(), e.asyncResolved = !0;
				let { vnode: s } = e;
				js(e, a, !1), i && (s.el = i);
				let c = !i && e.subTree.el;
				t(e, s, h(i || e.subTree.el), i ? null : m(e.subTree), x, o, n), c && (s.placeholder = null, g(c)), ao(e, s.el), r && --x.deps === 0 && x.resolve();
			});
		},
		unmount(e, t) {
			x.isUnmounted = !0, x.activeBranch && p(x.activeBranch, n, e, t), x.pendingBranch && p(x.pendingBranch, n, e, t);
		}
	};
	return x;
}
function Uo(e, t, n, r, i, a, o, s, c) {
	let l = t.suspense = Ho(t, r, n, e.parentNode, document.createElement("div"), null, i, a, o, s, !0), u = c(e, l.pendingBranch = t.ssContent, n, l, a, o);
	return l.deps === 0 && l.resolve(!1, !0), u;
}
function Wo(e) {
	let { shapeFlag: t, children: n } = e, r = t & 32;
	e.ssContent = Go(r ? n.default : n), e.ssFallback = r ? Go(n.fallback) : G(Xo);
}
function Go(e) {
	let t;
	if (D(e)) {
		let n = ts && e._c;
		n && (e._d = !1, V()), e = e(), n && (e._d = !0, t = $o, es());
	}
	return C(e) && (e = $a(e)), e = ps(e), t && !e.dynamicChildren && (e.dynamicChildren = t.filter((t) => t !== e)), e;
}
function Ko(e, t) {
	t && t.pendingBranch ? C(e) ? t.effects.push(...e) : t.effects.push(e) : ur(e);
}
function qo(e, t) {
	e.activeBranch = t;
	let { vnode: n, parentComponent: r } = e, i = t.el;
	for (; !i && t.component;) t = t.component.subTree, i = t.el;
	n.el = i, r && r.subTree === n && (r.vnode.el = i, ao(r, i));
}
function Jo(e) {
	let t = e.props && e.props.suspensible;
	return t != null && t !== !1;
}
var B = /* @__PURE__ */ Symbol.for("v-fgt"), Yo = /* @__PURE__ */ Symbol.for("v-txt"), Xo = /* @__PURE__ */ Symbol.for("v-cmt"), Zo = /* @__PURE__ */ Symbol.for("v-stc"), Qo = [], $o = null;
function V(e = !1) {
	Qo.push($o = e ? null : []);
}
function es() {
	Qo.pop(), $o = Qo[Qo.length - 1] || null;
}
var ts = 1;
function ns(e, t = !1) {
	ts += e, e < 0 && $o && t && ($o.hasOnce = !0);
}
function rs(e) {
	return e.dynamicChildren = ts > 0 ? $o || m : null, es(), ts > 0 && $o && $o.push(e), e;
}
function H(e, t, n, r, i, a) {
	return rs(W(e, t, n, r, i, a, !0));
}
function U(e, t, n, r, i) {
	return rs(G(e, t, n, r, i, !0));
}
function is(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
function as(e, t) {
	return e.type === t.type && e.key === t.key;
}
function os(e) {}
var ss = ({ key: e }) => e ?? null, cs = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : O(e) || /* @__PURE__ */ _n(e) || D(e) ? {
	i: vr,
	r: e,
	k: t,
	f: !!n
} : e);
function W(e, t = null, n = null, r = 0, i = null, a = e === B ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && ss(t),
		ref: t && cs(t),
		scopeId: yr,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: vr
	};
	return s ? (hs(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= O(n) ? 8 : 16), ts > 0 && !o && $o && (c.patchFlag > 0 || a & 6) && c.patchFlag !== 32 && $o.push(c), c;
}
var G = ls;
function ls(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === ha) && (e = Xo), is(e)) {
		let r = ds(e, t, !0);
		return n && hs(r, n), ts > 0 && !a && $o && (r.shapeFlag & 6 ? $o[$o.indexOf(e)] = r : $o.push(r)), r.patchFlag = -2, r;
	}
	if (Vs(e) && (e = e.__vccOpts), t) {
		t = us(t);
		let { class: e, style: n } = t;
		e && !O(e) && (t.class = M(e)), k(n) && (/* @__PURE__ */ fn(n) && !C(n) && (n = y({}, n)), t.style = Se(n));
	}
	let o = O(e) ? 1 : Io(e) ? 128 : Rr(e) ? 64 : k(e) ? 4 : D(e) ? 2 : 0;
	return W(e, t, n, r, i, o, a, !0);
}
function us(e) {
	return e ? /* @__PURE__ */ fn(e) || co(e) ? y({}, e) : e : null;
}
function ds(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? gs(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && ss(l),
		ref: t && t.ref ? n && a ? C(a) ? a.concat(cs(t)) : [a, cs(t)] : cs(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== B ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && ds(e.ssContent),
		ssFallback: e.ssFallback && ds(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && li(u, c.clone(u)), u;
}
function K(e = " ", t = 0) {
	return G(Yo, null, e, t);
}
function fs(e, t) {
	let n = G(Zo, null, e);
	return n.staticCount = t, n;
}
function q(e = "", t = !1) {
	return t ? (V(), U(Xo, null, e)) : G(Xo, null, e);
}
function ps(e) {
	return e == null || typeof e == "boolean" ? G(Xo) : C(e) ? G(B, null, e.slice()) : is(e) ? ms(e) : G(Yo, null, String(e));
}
function ms(e) {
	return e.el === null && e.patchFlag !== -1 || e.memo ? e : ds(e);
}
function hs(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (C(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), hs(e, n()), n._c && (n._d = !0));
		return;
	} else {
		n = 32;
		let r = t._;
		!r && !co(t) ? t._ctx = vr : r === 3 && vr && (vr.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
	}
	else if (D(t)) {
		if (r & 65) {
			hs(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: vr
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [K(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function gs(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = M([t.class, r.class]));
		else if (e === "style") t.style = Se([t.style, r.style]);
		else if (_(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(C(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !v(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
function _s(e, t, n, r = null) {
	Xn(e, t, 7, [n, r]);
}
var vs = Ua(), ys = 0;
function bs(e, t, n) {
	let r = e.type, i = (t ? t.appContext : e.appContext) || vs, a = {
		uid: ys++,
		vnode: e,
		type: r,
		parent: t,
		appContext: i,
		root: null,
		next: null,
		subTree: null,
		effect: null,
		update: null,
		job: null,
		scope: new ze(!0),
		render: null,
		proxy: null,
		exposed: null,
		exposeProxy: null,
		withProxy: null,
		provides: t ? t.provides : Object.create(i.provides),
		ids: t ? t.ids : [
			"",
			0,
			0
		],
		accessCache: null,
		renderCache: [],
		components: null,
		directives: null,
		propsOptions: mo(r, i),
		emitsOptions: Xa(r, i),
		emit: null,
		emitted: null,
		propsDefaults: p,
		inheritAttrs: r.inheritAttrs,
		ctx: p,
		data: p,
		props: p,
		attrs: p,
		slots: p,
		refs: p,
		setupState: p,
		setupContext: null,
		suspense: n,
		suspenseId: n ? n.pendingId : 0,
		asyncDep: null,
		asyncResolved: !1,
		isMounted: !1,
		isUnmounted: !1,
		isDeactivated: !1,
		bc: null,
		c: null,
		bm: null,
		m: null,
		bu: null,
		u: null,
		um: null,
		bum: null,
		da: null,
		a: null,
		rtg: null,
		rtc: null,
		ec: null,
		sp: null
	};
	return a.ctx = { _: a }, a.root = t ? t.root : a, a.emit = Ya.bind(null, a), e.ce && e.ce(a), a;
}
var xs = null, Ss = () => xs || vr, Cs, ws;
{
	let e = be(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	Cs = t("__VUE_INSTANCE_SETTERS__", (e) => xs = e), ws = t("__VUE_SSR_SETTERS__", (e) => Os = e);
}
var Ts = (e) => {
	let t = xs;
	return Cs(e), e.scope.on(), () => {
		e.scope.off(), Cs(t);
	};
}, Es = () => {
	xs && xs.scope.off(), Cs(null);
};
function Ds(e) {
	return e.vnode.shapeFlag & 4;
}
var Os = !1;
function ks(e, t = !1, n = !1) {
	t && ws(t);
	let { props: r, children: i } = e.vnode, a = Ds(e);
	lo(e, r, a, t), So(e, i, n || t);
	let o = a ? As(e, t) : void 0;
	return t && ws(!1), o;
}
function As(e, t) {
	let n = e.type;
	e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Ea);
	let { setup: r } = n;
	if (r) {
		ct();
		let n = e.setupContext = r.length > 1 ? Rs(e) : null, i = Ts(e), a = Yn(r, e, 0, [e.props, n]), o = ne(a);
		if (lt(), i(), (o || e.sp) && !Hi(e) && fi(e), o) {
			if (a.then(Es, Es), t) return a.then((n) => {
				ws(!0);
				try {
					js(e, n, t);
				} finally {
					ws(!1);
				}
			}).catch((t) => {
				Zn(t, e, 0);
			});
			e.asyncDep = a;
		} else js(e, a, t);
	} else Is(e, t);
}
function js(e, t, n) {
	D(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : k(t) && (e.setupState = wn(t)), Is(e, n);
}
var Ms, Ns;
function Ps(e) {
	Ms = e, Ns = (e) => {
		e.render._rc && (e.withProxy = new Proxy(e.ctx, Da));
	};
}
var Fs = () => !Ms;
function Is(e, t, n) {
	let r = e.type;
	if (!e.render) {
		if (!t && Ms && !r.render) {
			let t = r.template || !1;
			if (t) {
				let { isCustomElement: n, compilerOptions: i } = e.appContext.config, { delimiters: a, compilerOptions: o } = r, s = y(y({
					isCustomElement: n,
					delimiters: a
				}, i), o);
				r.render = Ms(t, s);
			}
		}
		e.render = r.render || h, Ns && Ns(e);
	}
}
var Ls = { get(e, t) {
	return yt(e, "get", ""), e[t];
} };
function Rs(e) {
	return {
		attrs: new Proxy(e.attrs, Ls),
		slots: e.slots,
		emit: e.emit,
		expose: (t) => {
			e.exposed = t || {};
		}
	};
}
function zs(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(wn(mn(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in wa) return wa[n](e);
		},
		has(e, t) {
			return t in e || t in wa;
		}
	}) : e.proxy;
}
function Bs(e, t = !0) {
	return D(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Vs(e) {
	return D(e) && "__vccOpts" in e;
}
var J = (e, t) => /* @__PURE__ */ Nn(e, t, Os);
function Hs(e, t, n) {
	try {
		ns(-1);
		let r = arguments.length;
		return r === 2 ? k(t) && !C(t) ? is(t) ? G(e, null, [t]) : G(e, t) : G(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && is(n) && (n = [n]), G(e, t, n));
	} finally {
		ns(1);
	}
}
function Us() {}
function Ws(e, t, n, r) {
	let i = n[r];
	if (i && Gs(i, e)) return i;
	let a = t();
	return a.memo = e.slice(), a.cacheIndex = r, n[r] = a;
}
function Gs(e, t) {
	let n = e.memo;
	if (n.length != t.length) return !1;
	for (let e = 0; e < n.length; e++) if (me(n[e], t[e])) return !1;
	return ts > 0 && $o && $o.push(e), !0;
}
var Ks = "3.5.41", qs = h, Js = Jn, Ys = hr, Xs = _r, Zs = {
	createComponentInstance: bs,
	setupComponent: ks,
	renderComponentRoot: Qa,
	setCurrentRenderingInstance: br,
	isVNode: is,
	normalizeVNode: ps,
	getComponentPublicInstance: zs,
	ensureValidVNode: xa,
	pushWarningContext: Wn,
	popWarningContext: Gn
}, Qs = void 0, $s = typeof window < "u" && window.trustedTypes;
if ($s) try {
	Qs = /* @__PURE__ */ $s.createPolicy("vue", { createHTML: (e) => e });
} catch {}
var ec = Qs ? (e) => Qs.createHTML(e) : (e) => e, tc = "http://www.w3.org/2000/svg", nc = "http://www.w3.org/1998/Math/MathML", rc = typeof document < "u" ? document : null, ic = rc && /* @__PURE__ */ rc.createElement("template"), ac = {
	insert: (e, t, n) => {
		t.insertBefore(e, n || null);
	},
	remove: (e) => {
		let t = e.parentNode;
		t && t.removeChild(e);
	},
	createElement: (e, t, n, r) => {
		let i = t === "svg" ? rc.createElementNS(tc, e) : t === "mathml" ? rc.createElementNS(nc, e) : n ? rc.createElement(e, { is: n }) : rc.createElement(e);
		return e === "select" && r && r.multiple != null && i.setAttribute("multiple", r.multiple), i;
	},
	createText: (e) => rc.createTextNode(e),
	createComment: (e) => rc.createComment(e),
	setText: (e, t) => {
		e.nodeValue = t;
	},
	setElementText: (e, t) => {
		e.textContent = t;
	},
	parentNode: (e) => e.parentNode,
	nextSibling: (e) => e.nextSibling,
	querySelector: (e) => rc.querySelector(e),
	setScopeId(e, t) {
		e.setAttribute(t, "");
	},
	insertStaticContent(e, t, n, r, i, a) {
		let o = n ? n.previousSibling : t.lastChild;
		if (i && (i === a || i.nextSibling)) for (; t.insertBefore(i.cloneNode(!0), n), !(i === a || !(i = i.nextSibling)););
		else {
			ic.innerHTML = ec(r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e);
			let i = ic.content;
			if (r === "svg" || r === "mathml") {
				let e = i.firstChild;
				for (; e.firstChild;) i.appendChild(e.firstChild);
				i.removeChild(e);
			}
			t.insertBefore(i, n);
		}
		return [o ? o.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
	}
}, oc = "transition", sc = "animation", cc = /* @__PURE__ */ Symbol("_vtc"), lc = {
	name: String,
	type: String,
	css: {
		type: Boolean,
		default: !0
	},
	duration: [
		String,
		Number,
		Object
	],
	enterFromClass: String,
	enterActiveClass: String,
	enterToClass: String,
	appearFromClass: String,
	appearActiveClass: String,
	appearToClass: String,
	leaveFromClass: String,
	leaveActiveClass: String,
	leaveToClass: String
}, uc = /* @__PURE__ */ y({}, ei, lc), dc = /* @__PURE__ */ ((e) => (e.displayName = "Transition", e.props = uc, e))((e, { slots: t }) => Hs(ii, mc(e), t)), fc = (e, t = []) => {
	C(e) ? e.forEach((e) => e(...t)) : e && e(...t);
}, pc = (e) => e ? C(e) ? e.some((e) => e.length > 1) : e.length > 1 : !1;
function mc(e) {
	let t = {};
	for (let n in e) n in lc || (t[n] = e[n]);
	if (e.css === !1) return t;
	let { name: n = "v", type: r, duration: i, enterFromClass: a = `${n}-enter-from`, enterActiveClass: o = `${n}-enter-active`, enterToClass: s = `${n}-enter-to`, appearFromClass: c = a, appearActiveClass: l = o, appearToClass: u = s, leaveFromClass: d = `${n}-leave-from`, leaveActiveClass: f = `${n}-leave-active`, leaveToClass: p = `${n}-leave-to` } = e, m = hc(i), h = m && m[0], g = m && m[1], { onBeforeEnter: _, onEnter: v, onEnterCancelled: b, onLeave: x, onLeaveCancelled: S, onBeforeAppear: C = _, onAppear: w = v, onAppearCancelled: T = b } = t, E = (e, t, n, r) => {
		e._enterCancelled = r, vc(e, t ? u : s), vc(e, t ? l : o), n && n();
	}, ee = (e, t) => {
		e._isLeaving = !1, vc(e, d), vc(e, p), vc(e, f), t && t();
	}, D = (e) => (t, n) => {
		let i = e ? w : v, o = () => E(t, e, n);
		fc(i, [t, o]), yc(() => {
			vc(t, e ? c : a), _c(t, e ? u : s), pc(i) || xc(t, r, h, o);
		});
	};
	return y(t, {
		onBeforeEnter(e) {
			fc(_, [e]), _c(e, a), _c(e, o);
		},
		onBeforeAppear(e) {
			fc(C, [e]), _c(e, c), _c(e, l);
		},
		onEnter: D(!1),
		onAppear: D(!0),
		onLeave(e, t) {
			e._isLeaving = !0;
			let n = () => ee(e, t);
			_c(e, d), e._enterCancelled ? (_c(e, f), Tc(e)) : (Tc(e), _c(e, f)), yc(() => {
				e._isLeaving && (vc(e, d), _c(e, p), pc(x) || xc(e, r, g, n));
			}), fc(x, [e, n]);
		},
		onEnterCancelled(e) {
			E(e, !1, void 0, !0), fc(b, [e]);
		},
		onAppearCancelled(e) {
			E(e, !0, void 0, !0), fc(T, [e]);
		},
		onLeaveCancelled(e) {
			ee(e), fc(S, [e]);
		}
	});
}
function hc(e) {
	if (e == null) return null;
	if (k(e)) return [gc(e.enter), gc(e.leave)];
	{
		let t = gc(e);
		return [t, t];
	}
}
function gc(e) {
	return ve(e);
}
function _c(e, t) {
	t.split(/\s+/).forEach((t) => t && e.classList.add(t)), (e[cc] || (e[cc] = /* @__PURE__ */ new Set())).add(t);
}
function vc(e, t) {
	t.split(/\s+/).forEach((t) => t && e.classList.remove(t));
	let n = e[cc];
	n && (n.delete(t), n.size || (e[cc] = void 0));
}
function yc(e) {
	requestAnimationFrame(() => {
		requestAnimationFrame(e);
	});
}
var bc = 0;
function xc(e, t, n, r) {
	let i = e._endId = ++bc, a = () => {
		i === e._endId && r();
	};
	if (n != null) return setTimeout(a, n);
	let { type: o, timeout: s, propCount: c } = Sc(e, t);
	if (!o) return r();
	let l = o + "end", u = 0, d = () => {
		e.removeEventListener(l, f), a();
	}, f = (t) => {
		t.target === e && ++u >= c && d();
	};
	setTimeout(() => {
		u < c && d();
	}, s + 1), e.addEventListener(l, f);
}
function Sc(e, t) {
	let n = window.getComputedStyle(e), r = (e) => (n[e] || "").split(", "), i = r(`${oc}Delay`), a = r(`${oc}Duration`), o = Cc(i, a), s = r(`${sc}Delay`), c = r(`${sc}Duration`), l = Cc(s, c), u = null, d = 0, f = 0;
	t === oc ? o > 0 && (u = oc, d = o, f = a.length) : t === sc ? l > 0 && (u = sc, d = l, f = c.length) : (d = Math.max(o, l), u = d > 0 ? o > l ? oc : sc : null, f = u ? u === oc ? a.length : c.length : 0);
	let p = u === oc && /\b(?:transform|all)(?:,|$)/.test(r(`${oc}Property`).toString());
	return {
		type: u,
		timeout: d,
		propCount: f,
		hasTransform: p
	};
}
function Cc(e, t) {
	for (; e.length < t.length;) e = e.concat(e);
	return Math.max(...t.map((t, n) => wc(t) + wc(e[n])));
}
function wc(e) {
	return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function Tc(e) {
	return (e ? e.ownerDocument : document).body.offsetHeight;
}
function Ec(e, t, n) {
	let r = e[cc];
	r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
var Dc = /* @__PURE__ */ Symbol("_vod"), Oc = /* @__PURE__ */ Symbol("_vsh"), kc = {
	name: "show",
	beforeMount(e, { value: t }, { transition: n }) {
		e[Dc] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : Ac(e, t);
	},
	mounted(e, { value: t }, { transition: n }) {
		n && t && n.enter(e);
	},
	updated(e, { value: t, oldValue: n }, { transition: r }) {
		!t != !n && (r ? t ? (r.beforeEnter(e), Ac(e, !0), r.enter(e)) : r.leave(e, () => {
			Ac(e, !1);
		}) : Ac(e, t));
	},
	beforeUnmount(e, { value: t }) {
		Ac(e, t);
	}
};
function Ac(e, t) {
	e.style.display = t ? e[Dc] : "none", e[Oc] = !t;
}
function jc() {
	kc.getSSRProps = ({ value: e }) => {
		if (!e) return { style: { display: "none" } };
	};
}
var Mc = /* @__PURE__ */ Symbol("");
function Nc(e) {
	let t = Ss();
	if (!t) return;
	let n = t.ut = (n = e(t.proxy)) => {
		Array.from(document.querySelectorAll(`[data-v-owner="${t.uid}"]`)).forEach((e) => Fc(e, n));
	}, r = () => {
		let r = e(t.proxy);
		t.ce ? Fc(t.ce, r) : Pc(t.subTree, r), n(r);
	};
	ia(() => {
		ur(r);
	}), ra(() => {
		Pr(r, h, { flush: "post" });
		let e = new MutationObserver(r);
		e.observe(t.subTree.el.parentNode, { childList: !0 }), sa(() => e.disconnect());
	});
}
function Pc(e, t) {
	if (e.shapeFlag & 128) {
		let n = e.suspense;
		e = n.activeBranch, n.pendingBranch && !n.isHydrating && n.effects.push(() => {
			Pc(n.activeBranch, t);
		});
	}
	for (; e.component;) e = e.component.subTree;
	if (e.shapeFlag & 1 && e.el) Fc(e.el, t);
	else if (e.type === B) e.children.forEach((e) => Pc(e, t));
	else if (e.type === Zo) {
		let { el: n, anchor: r } = e;
		for (; n && (Fc(n, t), n !== r);) n = n.nextSibling;
	}
}
function Fc(e, t) {
	if (e.nodeType === 1) {
		let n = e.style, r = "";
		for (let e in t) {
			let i = Le(t[e]);
			n.setProperty(`--${e}`, i), r += `--${e}: ${i};`;
		}
		n[Mc] = r;
	}
}
var Ic = /(?:^|;)\s*display\s*:/;
function Lc(e, t, n) {
	let r = e.style, i = O(n), a = !1;
	if (n && !i) {
		if (t) if (O(t)) for (let e of t.split(";")) {
			let t = e.slice(0, e.indexOf(":")).trim();
			n[t] ?? zc(r, t, "");
		}
		else for (let e in t) n[e] ?? zc(r, e, "");
		for (let i in n) {
			i === "display" && (a = !0);
			let o = n[i];
			o == null ? zc(r, i, "") : Uc(e, i, !O(t) && t ? t[i] : void 0, o) || zc(r, i, o);
		}
	} else if (i) {
		if (t !== n) {
			let e = r[Mc];
			e && (n += ";" + e), r.cssText = n, a = Ic.test(n);
		}
	} else t && e.removeAttribute("style");
	Dc in e && (e[Dc] = a ? r.display : "", e[Oc] && (r.display = "none"));
}
var Rc = /\s*!important$/;
function zc(e, t, n) {
	if (C(n)) n.forEach((n) => zc(e, t, n));
	else if (n ??= "", t.startsWith("--")) e.setProperty(t, n);
	else {
		let r = Hc(e, t);
		Rc.test(n) ? e.setProperty(de(r), n.replace(Rc, ""), "important") : e[r] = n;
	}
}
var Bc = [
	"Webkit",
	"Moz",
	"ms"
], Vc = {};
function Hc(e, t) {
	let n = Vc[t];
	if (n) return n;
	let r = j(t);
	if (r !== "filter" && r in e) return Vc[t] = r;
	r = fe(r);
	for (let n = 0; n < Bc.length; n++) {
		let i = Bc[n] + r;
		if (i in e) return Vc[t] = i;
	}
	return t;
}
function Uc(e, t, n, r) {
	return e.tagName === "TEXTAREA" && (t === "width" || t === "height") && O(r) && n === r;
}
var Wc = "http://www.w3.org/1999/xlink";
function Gc(e, t, n, r, i, a = ke(t)) {
	r && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(Wc, t.slice(6, t.length)) : e.setAttributeNS(Wc, t, n) : n == null || a && !Ae(n) ? e.removeAttribute(t) : e.setAttribute(t, a ? "" : te(n) ? String(n) : n);
}
function Kc(e, t, n, r, i) {
	if (t === "innerHTML" || t === "textContent") {
		n != null && (e[t] = t === "innerHTML" ? ec(n) : n);
		return;
	}
	let a = e.tagName;
	if (t === "value" && a !== "PROGRESS" && !a.includes("-")) {
		let r = a === "OPTION" ? e.getAttribute("value") || "" : e.value, i = n == null ? e.type === "checkbox" ? "on" : "" : String(n);
		(r !== i || !("_value" in e)) && (e.value = i), n ?? e.removeAttribute(t), e._value = n;
		return;
	}
	let o = !1;
	if (n === "" || n == null) {
		let r = typeof e[t];
		r === "boolean" ? n = Ae(n) : n == null && r === "string" ? (n = "", o = !0) : r === "number" && (n = 0, o = !0);
	}
	try {
		e[t] = n;
	} catch {}
	o && e.removeAttribute(i || t);
}
function qc(e, t, n, r) {
	e.addEventListener(t, n, r);
}
function Jc(e, t, n, r) {
	e.removeEventListener(t, n, r);
}
var Yc = /* @__PURE__ */ Symbol("_vei");
function Xc(e, t, n, r, i = null) {
	let a = e[Yc] || (e[Yc] = {}), o = a[t];
	if (r && o) o.value = r;
	else {
		let [n, s] = $c(t);
		r ? qc(e, n, a[t] = rl(r, i), s) : o && (Jc(e, n, o, s), a[t] = void 0);
	}
}
var Zc = /(Once|Passive|Capture)$/, Qc = /^on:?(?:Once|Passive|Capture)$/;
function $c(e) {
	let t, n;
	for (; (n = e.match(Zc)) && !Qc.test(e);) t ||= {}, e = e.slice(0, e.length - n[1].length), t[n[1].toLowerCase()] = !0;
	return [e[2] === ":" ? e.slice(3) : de(e.slice(2)), t];
}
var el = 0, tl = /* @__PURE__ */ Promise.resolve(), nl = () => el ||= (tl.then(() => el = 0), Date.now());
function rl(e, t) {
	let n = (e) => {
		if (!e._vts) e._vts = Date.now();
		else if (e._vts <= n.attached) return;
		let r = n.value;
		if (C(r)) {
			let n = e.stopImmediatePropagation;
			e.stopImmediatePropagation = () => {
				n.call(e), e._stopped = !0;
			};
			let i = r.slice(), a = [e];
			for (let n = 0; n < i.length && !e._stopped; n++) {
				let e = i[n];
				e && Xn(e, t, 5, a);
			}
		} else Xn(r, t, 5, [e]);
	};
	return n.value = e, n.attached = nl(), n;
}
var il = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, al = (e, t, n, r, i, a) => {
	let o = i === "svg";
	t === "class" ? Ec(e, r, o) : t === "style" ? Lc(e, n, r) : _(t) ? v(t) || Xc(e, t, n, r, a) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : ol(e, t, r, o)) ? (Kc(e, t, r), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Gc(e, t, r, o, a, t !== "value")) : e._isVueCE && (sl(e, t) || e._def.__asyncLoader && (/[A-Z]/.test(t) || !O(r))) ? Kc(e, j(t), r, a, t) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), Gc(e, t, r, o));
};
function ol(e, t, n, r) {
	if (r) return !!(t === "innerHTML" || t === "textContent" || t in e && il(t) && D(n));
	if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "sandbox" && e.tagName === "IFRAME" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA") return !1;
	if (t === "width" || t === "height") {
		let t = e.tagName;
		if (t === "IMG" || t === "VIDEO" || t === "CANVAS" || t === "SOURCE") return !1;
	}
	return il(t) && O(n) ? !1 : t in e;
}
function sl(e, t) {
	let n = e._def.props;
	if (!n) return !1;
	let r = j(t);
	return Array.isArray(n) ? n.some((e) => j(e) === r) : Object.keys(n).some((e) => j(e) === r);
}
var cl = {};
// @__NO_SIDE_EFFECTS__
function ll(e, t, n) {
	let r = /* @__PURE__ */ L(e, t);
	A(r) && (r = y({}, r, t));
	class i extends fl {
		constructor(e) {
			super(r, e, n);
		}
	}
	return i.def = r, i;
}
var ul = /* @__NO_SIDE_EFFECTS__ */ ((e, t) => /* @__PURE__ */ ll(e, t, ru)), dl = typeof HTMLElement < "u" ? HTMLElement : class {}, fl = class e extends dl {
	constructor(e, t = {}, n = nu) {
		super(), this._def = e, this._props = t, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._patching = !1, this._dirty = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._styleAnchors = /* @__PURE__ */ new WeakMap(), this._ob = null, this.shadowRoot && n !== nu ? this._root = this.shadowRoot : e.shadowRoot === !1 ? this._root = this : (this.attachShadow(y({}, e.shadowRootOptions, { mode: "open" })), this._root = this.shadowRoot);
	}
	connectedCallback() {
		if (!this.isConnected) return;
		!this.shadowRoot && !this._resolved && this._parseSlots(), this._connected = !0;
		let t = this;
		for (; t &&= t.assignedSlot || t.parentNode || t.host;) if (t instanceof e) {
			this._parent = t;
			break;
		}
		this._instance || (this._resolved ? this._mount(this._def) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
			if (this._pendingResolve = void 0, this.isConnected) return this._resolveDef();
		}) : this._resolveDef());
	}
	_setParent(e = this._parent) {
		e && (this._instance.parent = e._instance, this._inheritParentContext(e));
	}
	_inheritParentContext(e = this._parent) {
		e && this._app && Object.setPrototypeOf(this._app._context.provides, e._instance.provides);
	}
	disconnectedCallback() {
		this._connected = !1, or(() => {
			this._connected || (this._ob &&= (this._ob.disconnect(), null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null, this._teleportTargets &&= (this._teleportTargets.clear(), void 0));
		});
	}
	_processMutations(e) {
		for (let t of e) this._setAttr(t.attributeName);
	}
	_resolveDef() {
		if (this._pendingResolve) return this._pendingResolve;
		for (let e = 0; e < this.attributes.length; e++) this._setAttr(this.attributes[e].name);
		this._ob = new MutationObserver(this._processMutations.bind(this)), this._ob.observe(this, { attributes: !0 });
		let e = (e, t = !1) => {
			this._resolved = !0, this._pendingResolve = void 0;
			let { props: n, styles: r } = e, i;
			if (n && !C(n)) for (let e in n) {
				let t = n[e];
				(t === Number || t && t.type === Number) && (e in this._props && (this._props[e] = ve(this._props[e])), (i ||= /* @__PURE__ */ Object.create(null))[j(e)] = !0);
			}
			this._numberProps = i, this._resolveProps(e), this.shadowRoot && this._applyStyles(r), this._mount(e);
		}, t = this._def.__asyncLoader;
		if (t) return this._pendingResolve = t().then((t) => {
			t.configureApp = this._def.configureApp, e(this._def = t, !0);
		}), this._pendingResolve;
		e(this._def);
	}
	_mount(e) {
		this._app = this._createApp(e), this._inheritParentContext(), e.configureApp && e.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
		let t = this._instance && this._instance.exposed;
		if (t) for (let e in t) S(this, e) || Object.defineProperty(this, e, { get: () => F(t[e]) });
	}
	_resolveProps(e) {
		let { props: t } = e, n = C(t) ? t : Object.keys(t || {});
		for (let e of Object.keys(this)) e[0] !== "_" && n.includes(e) && this._setProp(e, this[e]);
		for (let e of n.map(j)) Object.defineProperty(this, e, {
			get() {
				return this._getProp(e);
			},
			set(t) {
				this._setProp(e, t, !0, !this._patching);
			}
		});
	}
	_setAttr(e) {
		if (e.startsWith("data-v-")) return;
		let t = this.hasAttribute(e), n = t ? this.getAttribute(e) : cl, r = j(e);
		t && this._numberProps && this._numberProps[r] && (n = ve(n)), this._setProp(r, n, !1, !0);
	}
	_getProp(e) {
		return this._props[e];
	}
	_setProp(e, t, n = !0, r = !1) {
		if (t !== this._props[e] && (this._dirty = !0, t === cl ? delete this._props[e] : (this._props[e] = t, e === "key" && this._app && (this._app._ceVNode.key = t)), r && this._instance && this._update(), n)) {
			let n = this._ob;
			n && (this._processMutations(n.takeRecords()), n.disconnect()), t === !0 ? this.setAttribute(de(e), "") : typeof t == "string" || typeof t == "number" ? this.setAttribute(de(e), t + "") : t || this.removeAttribute(de(e)), n && n.observe(this, { attributes: !0 });
		}
	}
	_update() {
		let e = this._createVNode();
		this._app && (e.appContext = this._app._context), eu(e, this._root);
	}
	_createVNode() {
		let e = {};
		this.shadowRoot || (e.onVnodeMounted = e.onVnodeUpdated = this._renderSlots.bind(this));
		let t = G(this._def, y(e, this._props));
		return this._instance || (t.ce = (e) => {
			this._instance = e, e.ce = this, e.isCE = !0;
			let t = (e, t) => {
				this.dispatchEvent(new CustomEvent(e, A(t[0]) ? y({ detail: t }, t[0]) : { detail: t }));
			};
			e.emit = (e, ...n) => {
				t(e, n), de(e) !== e && t(de(e), n);
			}, this._setParent();
		}), t;
	}
	_applyStyles(e, t, n) {
		if (!e) return;
		if (t) {
			if (t === this._def || this._styleChildren.has(t)) return;
			this._styleChildren.add(t);
		}
		let r = this._nonce, i = this.shadowRoot, a = n ? this._getStyleAnchor(n) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(i), o = null;
		for (let s = e.length - 1; s >= 0; s--) {
			let c = document.createElement("style");
			r && c.setAttribute("nonce", r), c.textContent = e[s], i.insertBefore(c, o || a), o = c, s === 0 && (n || this._styleAnchors.set(this._def, c), t && this._styleAnchors.set(t, c));
		}
	}
	_getStyleAnchor(e) {
		if (!e) return null;
		let t = this._styleAnchors.get(e);
		return t && t.parentNode === this.shadowRoot ? t : (t && this._styleAnchors.delete(e), null);
	}
	_getRootStyleInsertionAnchor(e) {
		for (let t = 0; t < e.childNodes.length; t++) {
			let n = e.childNodes[t];
			if (!(n instanceof HTMLStyleElement)) return n;
		}
		return null;
	}
	_parseSlots() {
		let e = this._slots = {}, t;
		for (; t = this.firstChild;) {
			let n = t.nodeType === 1 && t.getAttribute("slot") || "default";
			(e[n] || (e[n] = [])).push(t), this.removeChild(t);
		}
	}
	_renderSlots() {
		let e = this._getSlots(), t = this._instance.type.__scopeId;
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = r.getAttribute("name") || "default", a = this._slots[i], o = r.parentNode;
			if (a) for (let e of a) {
				if (t && e.nodeType === 1) {
					let n = t + "-s", r = document.createTreeWalker(e, 1);
					e.setAttribute(n, "");
					let i;
					for (; i = r.nextNode();) i.setAttribute(n, "");
				}
				o.insertBefore(e, r);
			}
			else for (; r.firstChild;) o.insertBefore(r.firstChild, r);
			o.removeChild(r);
		}
	}
	_getSlots() {
		let e = [this];
		this._teleportTargets && e.push(...this._teleportTargets);
		let t = /* @__PURE__ */ new Set();
		for (let n of e) {
			let e = n.querySelectorAll("slot");
			for (let n = 0; n < e.length; n++) t.add(e[n]);
		}
		return Array.from(t);
	}
	_injectChildStyle(e, t) {
		this._applyStyles(e.styles, e, t);
	}
	_beginPatch() {
		this._patching = !0, this._dirty = !1;
	}
	_endPatch() {
		this._patching = !1, this._dirty && this._instance && this._update();
	}
	_hasShadowRoot() {
		return this._def.shadowRoot !== !1;
	}
	_removeChildStyle(e) {}
};
function pl(e) {
	let t = Ss();
	return t && t.ce || null;
}
function ml() {
	let e = pl();
	return e && e.shadowRoot;
}
function hl(e = "$style") {
	{
		let t = Ss();
		if (!t) return p;
		let n = t.type.__cssModules;
		return n && n[e] || p;
	}
}
var gl = /* @__PURE__ */ new WeakMap(), _l = /* @__PURE__ */ new WeakMap(), vl = /* @__PURE__ */ Symbol("_moveCb"), yl = /* @__PURE__ */ Symbol("_enterCb"), bl = /* @__PURE__ */ ((e) => (delete e.props.mode, e))({
	name: "TransitionGroup",
	props: /* @__PURE__ */ y({}, uc, {
		tag: String,
		moveClass: String
	}),
	setup(e, { slots: t }) {
		let n = Ss(), r = Qr(), i, a;
		return aa(() => {
			if (!i.length) return;
			let t = e.moveClass || `${e.name || "v"}-move`;
			if (!Tl(i[0].el, n.vnode.el, t)) {
				i = [];
				return;
			}
			i.forEach(xl), i.forEach(Sl);
			let r = i.filter(Cl);
			Tc(n.vnode.el), r.forEach((e) => {
				let n = e.el, r = n.style;
				_c(n, t), r.transform = r.webkitTransform = r.transitionDuration = "";
				let i = n[vl] = (e) => {
					e && e.target !== n || (!e || e.propertyName.endsWith("transform")) && (n.removeEventListener("transitionend", i), n[vl] = null, vc(n, t));
				};
				n.addEventListener("transitionend", i);
			}), i = [];
		}), () => {
			let o = /* @__PURE__ */ pn(e), s = mc(o), c = o.tag || B;
			if (i = [], a) for (let e = 0; e < a.length; e++) {
				let t = a[e];
				t.el && t.el instanceof Element && !t.el[Oc] && (i.push(t), li(t, oi(t, s, r, n)), gl.set(t, wl(t.el)));
			}
			a = t.default ? ui(t.default()) : [];
			for (let e = 0; e < a.length; e++) {
				let t = a[e];
				t.key != null && li(t, oi(t, s, r, n));
			}
			return G(c, null, a);
		};
	}
});
function xl(e) {
	let t = e.el;
	t[vl] && t[vl](), t[yl] && t[yl]();
}
function Sl(e) {
	_l.set(e, wl(e.el));
}
function Cl(e) {
	let t = gl.get(e), n = _l.get(e), r = t.left - n.left, i = t.top - n.top;
	if (r || i) {
		let t = e.el, n = t.style, a = t.getBoundingClientRect(), o = 1, s = 1;
		return t.offsetWidth && (o = a.width / t.offsetWidth), t.offsetHeight && (s = a.height / t.offsetHeight), (!Number.isFinite(o) || o === 0) && (o = 1), (!Number.isFinite(s) || s === 0) && (s = 1), Math.abs(o - 1) < .01 && (o = 1), Math.abs(s - 1) < .01 && (s = 1), n.transform = n.webkitTransform = `translate(${r / o}px,${i / s}px)`, n.transitionDuration = "0s", e;
	}
}
function wl(e) {
	let t = e.getBoundingClientRect();
	return {
		left: t.left,
		top: t.top
	};
}
function Tl(e, t, n) {
	let r = e.cloneNode(), i = e[cc];
	i && i.forEach((e) => {
		e.split(/\s+/).forEach((e) => e && r.classList.remove(e));
	}), n.split(/\s+/).forEach((e) => e && r.classList.add(e)), r.style.display = "none";
	let a = t.nodeType === 1 ? t : t.parentNode;
	a.appendChild(r);
	let { hasTransform: o } = Sc(r);
	return a.removeChild(r), o;
}
var El = (e) => {
	let t = e.props["onUpdate:modelValue"] || !1;
	return C(t) ? (e) => he(t, e) : t;
};
function Dl(e) {
	e.target.composing = !0;
}
function Ol(e) {
	let t = e.target;
	t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
var kl = /* @__PURE__ */ Symbol("_assign"), Al = /* @__PURE__ */ Symbol("_initialValue");
function jl(e, t, n) {
	return t && (e = e.trim()), n && (e = _e(e)), e;
}
var Ml = {
	created(e, { modifiers: { lazy: t, trim: n, number: r } }, i) {
		e.parentNode && (e.type === "text" ? e[Al] = e.defaultValue.replace(/[\r\n]/g, "") : e.type === "textarea" && (e[Al] = e.defaultValue.replace(/\r\n?/g, "\n"))), e[kl] = El(i);
		let a = r || i.props && i.props.type === "number";
		qc(e, t ? "change" : "input", (t) => {
			t.target.composing || e[kl](jl(e.value, n, a));
		}), (n || a) && qc(e, "change", () => {
			e.value = jl(e.value, n, a);
		}), t || (qc(e, "compositionstart", Dl), qc(e, "compositionend", Ol), qc(e, "change", Ol));
	},
	mounted(e, { value: t, modifiers: { trim: n, number: r } }) {
		let i = t ?? "", a = e[Al];
		delete e[Al], a !== void 0 && (e.type === "text" || e.type === "textarea") && e.value !== a ? e[kl](jl(e.value, n, r)) : e.value = i;
	},
	beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: r, trim: i, number: a } }, o) {
		if (e[kl] = El(o), e.composing) return;
		let s = (a || e.type === "number") && !/^0\d/.test(e.value) ? _e(e.value) : e.value, c = t ?? "";
		if (s === c) return;
		let l = e.getRootNode();
		(l instanceof Document || l instanceof ShadowRoot) && l.activeElement === e && e.type !== "range" && (r && t === n || i && e.value.trim() === c) || (e.value = c);
	}
}, Nl = {
	deep: !0,
	created(e, t, n) {
		e[kl] = El(n), qc(e, "change", () => {
			let t = e._modelValue, n = Rl(e), r = e.checked, i = e[kl];
			if (C(t)) {
				let e = Ne(t, n), a = e !== -1;
				if (r && !a) i(t.concat(n));
				else if (!r && a) {
					let n = [...t];
					n.splice(e, 1), i(n);
				}
			} else if (T(t)) {
				let e = new Set(t);
				r ? e.add(n) : e.delete(n), i(e);
			} else i(zl(e, r));
		});
	},
	mounted: Pl,
	beforeUpdate(e, t, n) {
		e[kl] = El(n), Pl(e, t, n);
	}
};
function Pl(e, { value: t, oldValue: n }, r) {
	e._modelValue = t;
	let i;
	if (C(t)) i = Ne(t, r.props.value) > -1;
	else if (T(t)) i = t.has(r.props.value);
	else {
		if (t === n) return;
		i = Me(t, zl(e, !0));
	}
	e.checked !== i && (e.checked = i);
}
var Fl = {
	created(e, { value: t }, n) {
		e.checked = Me(t, n.props.value), e[kl] = El(n), qc(e, "change", () => {
			e[kl](Rl(e));
		});
	},
	beforeUpdate(e, { value: t, oldValue: n }, r) {
		e[kl] = El(r), t !== n && (e.checked = Me(t, r.props.value));
	}
}, Il = {
	deep: !0,
	created(e, { value: t, modifiers: { number: n } }, r) {
		e._modelValue = t, qc(e, "change", () => {
			let t = Array.prototype.filter.call(e.options, (e) => e.selected).map((e) => n ? _e(Rl(e)) : Rl(e));
			e[kl](e.multiple ? T(e._modelValue) ? new Set(t) : t : t[0]), e._assigning = !0, or(() => {
				e._assigning = !1;
			});
		}), e[kl] = El(r);
	},
	mounted(e, { value: t }) {
		Ll(e, t);
	},
	beforeUpdate(e, { value: t }, n) {
		e._modelValue = t, e[kl] = El(n);
	},
	updated(e, { value: t }) {
		e._assigning || Ll(e, t);
	}
};
function Ll(e, t) {
	let n = e.multiple, r = C(t);
	if (!(n && !r && !T(t))) {
		for (let i = 0, a = e.options.length; i < a; i++) {
			let a = e.options[i], o = Rl(a);
			if (n) if (r) {
				let e = typeof o;
				a.selected = e === "string" || e === "number" ? t.some((e) => String(e) === String(o)) : Ne(t, o) > -1;
			} else a.selected = t.has(o);
			else if (Me(Rl(a), t)) {
				e.selectedIndex !== i && (e.selectedIndex = i);
				return;
			}
		}
		!n && e.selectedIndex !== -1 && (e.selectedIndex = -1);
	}
}
function Rl(e) {
	return "_value" in e ? e._value : e.value;
}
function zl(e, t) {
	let n = t ? "_trueValue" : "_falseValue";
	return n in e ? e[n] : t;
}
var Bl = {
	created(e, t, n) {
		Hl(e, t, n, null, "created");
	},
	mounted(e, t, n) {
		Hl(e, t, n, null, "mounted");
	},
	beforeUpdate(e, t, n, r) {
		Hl(e, t, n, r, "beforeUpdate");
	},
	updated(e, t, n, r) {
		Hl(e, t, n, r, "updated");
	}
};
function Vl(e, t) {
	switch (e) {
		case "SELECT": return Il;
		case "TEXTAREA": return Ml;
		default: switch (t) {
			case "checkbox": return Nl;
			case "radio": return Fl;
			default: return Ml;
		}
	}
}
function Hl(e, t, n, r, i) {
	let a = Vl(e.tagName, n.props && n.props.type)[i];
	a && a(e, t, n, r);
}
function Ul() {
	Ml.getSSRProps = ({ value: e }) => ({ value: e }), Fl.getSSRProps = ({ value: e }, t) => {
		if (t.props && Me(t.props.value, e)) return { checked: !0 };
	}, Nl.getSSRProps = ({ value: e }, t) => {
		if (C(e)) {
			if (t.props && Ne(e, t.props.value) > -1) return { checked: !0 };
		} else if (T(e)) {
			if (t.props && e.has(t.props.value)) return { checked: !0 };
		} else if (e) return { checked: !0 };
	}, Bl.getSSRProps = (e, t) => {
		if (typeof t.type != "string") return;
		let n = Vl(t.type.toUpperCase(), t.props && t.props.type);
		if (n.getSSRProps) return n.getSSRProps(e, t);
	};
}
var Wl = [
	"ctrl",
	"shift",
	"alt",
	"meta"
], Gl = {
	stop: (e) => e.stopPropagation(),
	prevent: (e) => e.preventDefault(),
	self: (e) => e.target !== e.currentTarget,
	ctrl: (e) => !e.ctrlKey,
	shift: (e) => !e.shiftKey,
	alt: (e) => !e.altKey,
	meta: (e) => !e.metaKey,
	left: (e) => "button" in e && e.button !== 0,
	middle: (e) => "button" in e && e.button !== 1,
	right: (e) => "button" in e && e.button !== 2,
	exact: (e, t) => Wl.some((n) => e[`${n}Key`] && !t.includes(n))
}, Kl = (e, t) => {
	if (!e) return e;
	let n = e._withMods ||= {}, r = t.join(".");
	return n[r] || (n[r] = ((n, ...r) => {
		for (let e = 0; e < t.length; e++) {
			let r = Gl[t[e]];
			if (r && r(n, t)) return;
		}
		return e(n, ...r);
	}));
}, ql = {
	esc: "escape",
	space: " ",
	up: "arrow-up",
	left: "arrow-left",
	right: "arrow-right",
	down: "arrow-down",
	delete: "backspace"
}, Jl = (e, t) => {
	let n = e._withKeys ||= {}, r = t.join(".");
	return n[r] || (n[r] = ((n) => {
		if (!("key" in n)) return;
		let r = de(n.key);
		if (t.some((e) => e === r || ql[e] === r)) return e(n);
	}));
}, Yl = /* @__PURE__ */ y({ patchProp: al }, ac), Xl, Zl = !1;
function Ql() {
	return Xl ||= To(Yl);
}
function $l() {
	return Xl = Zl ? Xl : Eo(Yl), Zl = !0, Xl;
}
var eu = ((...e) => {
	Ql().render(...e);
}), tu = ((...e) => {
	$l().hydrate(...e);
}), nu = ((...e) => {
	let t = Ql().createApp(...e), { mount: n } = t;
	return t.mount = (e) => {
		let r = au(e);
		if (!r) return;
		let i = t._component;
		!D(i) && !i.render && !i.template && (i.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
		let a = n(r, !1, iu(r));
		return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), a;
	}, t;
}), ru = ((...e) => {
	let t = $l().createApp(...e), { mount: n } = t;
	return t.mount = (e) => {
		let t = au(e);
		if (t) return n(t, !0, iu(t));
	}, t;
});
function iu(e) {
	if (e instanceof SVGElement) return "svg";
	if (typeof MathMLElement == "function" && e instanceof MathMLElement) return "mathml";
}
function au(e) {
	return O(e) ? document.querySelector(e) : e;
}
var ou = !1, su = () => {
	ou || (ou = !0, Ul(), jc());
}, cu = /* @__PURE__ */ c({
	BaseTransition: () => ii,
	BaseTransitionPropsValidators: () => ei,
	Comment: () => Xo,
	DeprecationTypes: () => null,
	EffectScope: () => ze,
	ErrorCodes: () => qn,
	ErrorTypeStrings: () => Js,
	Fragment: () => B,
	KeepAlive: () => Ki,
	ReactiveEffect: () => Ge,
	Static: () => Zo,
	Suspense: () => Ro,
	Teleport: () => qr,
	Text: () => Yo,
	TrackOpTypes: () => Pn,
	Transition: () => dc,
	TransitionGroup: () => bl,
	TriggerOpTypes: () => Fn,
	VueElement: () => fl,
	assertNumber: () => Kn,
	callWithAsyncErrorHandling: () => Xn,
	callWithErrorHandling: () => Yn,
	camelize: () => j,
	capitalize: () => fe,
	cloneVNode: () => ds,
	compatUtils: () => null,
	compile: () => lu,
	computed: () => J,
	createApp: () => nu,
	createBlock: () => U,
	createCommentVNode: () => q,
	createElementBlock: () => H,
	createElementVNode: () => W,
	createHydrationRenderer: () => Eo,
	createPropsRestProxy: () => Va,
	createRenderer: () => To,
	createSSRApp: () => ru,
	createSlots: () => ba,
	createStaticVNode: () => fs,
	createTextVNode: () => K,
	createVNode: () => G,
	customRef: () => En,
	defineAsyncComponent: () => Ui,
	defineComponent: () => L,
	defineCustomElement: () => ll,
	defineEmits: () => ka,
	defineExpose: () => Aa,
	defineModel: () => Na,
	defineOptions: () => ja,
	defineProps: () => Oa,
	defineSSRCustomElement: () => ul,
	defineSlots: () => Ma,
	devtools: () => Ys,
	effect: () => it,
	effectScope: () => Be,
	getCurrentInstance: () => Ss,
	getCurrentScope: () => Ve,
	getCurrentWatcher: () => zn,
	getTransitionRawChildren: () => ui,
	guardReactiveProps: () => us,
	h: () => Hs,
	handleError: () => Zn,
	hasInjectionContext: () => Or,
	hydrate: () => tu,
	hydrateOnIdle: () => Ii,
	hydrateOnInteraction: () => Bi,
	hydrateOnMediaQuery: () => zi,
	hydrateOnVisible: () => Ri,
	initCustomFormatter: () => Us,
	initDirectivesForSSR: () => su,
	inject: () => Dr,
	isMemoSame: () => Gs,
	isProxy: () => fn,
	isReactive: () => ln,
	isReadonly: () => un,
	isRef: () => _n,
	isRuntimeOnly: () => Fs,
	isShallow: () => dn,
	isVNode: () => is,
	markRaw: () => mn,
	mergeDefaults: () => za,
	mergeModels: () => Ba,
	mergeProps: () => gs,
	nextTick: () => or,
	nodeOps: () => ac,
	normalizeClass: () => M,
	normalizeProps: () => De,
	normalizeStyle: () => Se,
	onActivated: () => Ji,
	onBeforeMount: () => na,
	onBeforeUnmount: () => oa,
	onBeforeUpdate: () => ia,
	onDeactivated: () => Yi,
	onErrorCaptured: () => da,
	onMounted: () => ra,
	onRenderTracked: () => ua,
	onRenderTriggered: () => la,
	onScopeDispose: () => He,
	onServerPrefetch: () => ca,
	onUnmounted: () => sa,
	onUpdated: () => aa,
	onWatcherCleanup: () => Bn,
	openBlock: () => V,
	patchProp: () => al,
	popScopeId: () => Sr,
	provide: () => Er,
	proxyRefs: () => wn,
	pushScopeId: () => xr,
	queuePostFlushCb: () => ur,
	reactive: () => rn,
	readonly: () => on,
	ref: () => P,
	registerRuntimeCompiler: () => Ps,
	render: () => eu,
	renderList: () => R,
	renderSlot: () => z,
	resolveComponent: () => ma,
	resolveDirective: () => _a,
	resolveDynamicComponent: () => ga,
	resolveFilter: () => null,
	resolveTransitionHooks: () => oi,
	setBlockTracking: () => ns,
	setDevtoolsHook: () => Xs,
	setTransitionHooks: () => li,
	shallowReactive: () => an,
	shallowReadonly: () => sn,
	shallowRef: () => vn,
	ssrContextKey: () => kr,
	ssrUtils: () => Zs,
	stop: () => at,
	toDisplayString: () => N,
	toHandlerKey: () => pe,
	toHandlers: () => Sa,
	toRaw: () => pn,
	toRef: () => An,
	toRefs: () => Dn,
	toValue: () => Sn,
	transformVNodeArgs: () => os,
	triggerRef: () => xn,
	unref: () => F,
	useAttrs: () => Ia,
	useCssModule: () => hl,
	useCssVars: () => Nc,
	useHost: () => pl,
	useId: () => di,
	useModel: () => qa,
	useSSRContext: () => Ar,
	useShadowRoot: () => ml,
	useSlots: () => Fa,
	useTemplateRef: () => pi,
	useTransitionState: () => Qr,
	vModelCheckbox: () => Nl,
	vModelDynamic: () => Bl,
	vModelRadio: () => Fl,
	vModelSelect: () => Il,
	vModelText: () => Ml,
	vShow: () => kc,
	version: () => Ks,
	warn: () => qs,
	watch: () => Pr,
	watchEffect: () => jr,
	watchPostEffect: () => Mr,
	watchSyncEffect: () => Nr,
	withAsyncContext: () => Ha,
	withCtx: () => I,
	withDefaults: () => Pa,
	withDirectives: () => wr,
	withKeys: () => Jl,
	withMemo: () => Ws,
	withModifiers: () => Kl,
	withScopeId: () => Cr
}), lu = () => {}, uu = class {
	constructor() {
		this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
	}
	subscribe(e) {
		return this.listeners.add(e), this.onSubscribe(), () => {
			this.listeners.delete(e), this.onUnsubscribe();
		};
	}
	hasListeners() {
		return this.listeners.size > 0;
	}
	onSubscribe() {}
	onUnsubscribe() {}
}, du = new class extends uu {
	#e;
	#t;
	#n;
	constructor() {
		super(), this.#n = (e) => {
			if (typeof window < "u" && window.addEventListener) {
				let t = () => e();
				return window.addEventListener("visibilitychange", t, !1), () => {
					window.removeEventListener("visibilitychange", t);
				};
			}
		};
	}
	onSubscribe() {
		this.#t || this.setEventListener(this.#n);
	}
	onUnsubscribe() {
		this.hasListeners() || (this.#t?.(), this.#t = void 0);
	}
	setEventListener(e) {
		this.#n = e, this.#t?.(), this.#t = e((e) => {
			typeof e == "boolean" ? this.setFocused(e) : this.onFocus();
		});
	}
	setFocused(e) {
		this.#e !== e && (this.#e = e, this.onFocus());
	}
	onFocus() {
		let e = this.isFocused();
		this.listeners.forEach((t) => {
			t(e);
		});
	}
	isFocused() {
		return typeof this.#e == "boolean" ? this.#e : globalThis.document?.visibilityState !== "hidden";
	}
}(), fu = {
	setTimeout: (e, t) => setTimeout(e, t),
	clearTimeout: (e) => clearTimeout(e),
	setInterval: (e, t) => setInterval(e, t),
	clearInterval: (e) => clearInterval(e)
}, pu = new class {
	#e = fu;
	setTimeoutProvider(e) {
		this.#e = e;
	}
	setTimeout(e, t) {
		return this.#e.setTimeout(e, t);
	}
	clearTimeout(e) {
		this.#e.clearTimeout(e);
	}
	setInterval(e, t) {
		return this.#e.setInterval(e, t);
	}
	clearInterval(e) {
		this.#e.clearInterval(e);
	}
}();
function mu(e) {
	setTimeout(e, 0);
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/utils.js
var hu = typeof window > "u" || "Deno" in globalThis;
function gu() {}
function _u(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function vu(e) {
	return typeof e == "number" && e >= 0 && e !== Infinity;
}
function yu(e, t) {
	return Math.max(e + (t || 0) - Date.now(), 0);
}
function bu(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function xu(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Su(e, t) {
	let { type: n = "all", exact: r, fetchStatus: i, predicate: a, queryKey: o, stale: s } = e;
	if (o) {
		if (r) {
			if (t.queryHash !== wu(o, t.options)) return !1;
		} else if (!Eu(t.queryKey, o)) return !1;
	}
	if (n !== "all") {
		let e = t.isActive();
		if (n === "active" && !e || n === "inactive" && e) return !1;
	}
	return !(typeof s == "boolean" && t.isStale() !== s || i && i !== t.state.fetchStatus || a && !a(t));
}
function Cu(e, t) {
	let { exact: n, status: r, predicate: i, mutationKey: a } = e;
	if (a) {
		if (!t.options.mutationKey) return !1;
		if (n) {
			if (Tu(t.options.mutationKey) !== Tu(a)) return !1;
		} else if (!Eu(t.options.mutationKey, a)) return !1;
	}
	return !(r && t.state.status !== r || i && !i(t));
}
function wu(e, t) {
	return (t?.queryKeyHashFn || Tu)(e);
}
function Tu(e) {
	return JSON.stringify(e, (e, t) => ju(t) ? Object.keys(t).sort().reduce((e, n) => (e[n] = t[n], e), {}) : t);
}
function Eu(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (e && t && typeof e == "object" && typeof t == "object") {
		if (Array.isArray(e) && Array.isArray(t)) {
			for (let n = 0; n < t.length; n++) if (!Eu(e[n], t[n])) return !1;
			return !0;
		}
		let n = Object.keys(t);
		for (let r of n) if (!Eu(e[r], t[r])) return !1;
		return !0;
	}
	return !1;
}
var Du = Object.prototype.hasOwnProperty;
function Ou(e, t, n = 0) {
	if (e === t) return e;
	if (n > 500) return t;
	let r = Au(e) && Au(t);
	if (!r && !(ju(e) && ju(t))) return t;
	let i = (r ? e : Object.keys(e)).length, a = r ? t : Object.keys(t), o = a.length, s = r ? Array(o) : {}, c = 0;
	for (let l = 0; l < o; l++) {
		let o = r ? l : a[l], u = e[o], d = t[o];
		if (u === d) {
			s[o] = u, (r ? l < i : Du.call(e, o)) && c++;
			continue;
		}
		if (u === null || d === null || typeof u != "object" || typeof d != "object") {
			s[o] = d;
			continue;
		}
		let f = Ou(u, d, n + 1);
		s[o] = f, f === u && c++;
	}
	return i === o && c === i ? e : s;
}
function ku(e, t) {
	if (!t || Object.keys(e).length !== Object.keys(t).length) return !1;
	for (let n in e) if (e[n] !== t[n]) return !1;
	return !0;
}
function Au(e) {
	return Array.isArray(e) && e.length === Object.keys(e).length;
}
function ju(e) {
	if (!Mu(e)) return !1;
	let t = e.constructor;
	if (t === void 0) return !0;
	let n = t.prototype;
	return !(!Mu(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function Mu(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Nu(e) {
	return new Promise((t) => {
		pu.setTimeout(t, e);
	});
}
function Pu(e, t, n) {
	return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing === !1 ? t : Ou(e, t);
}
function Fu(e, t, n = 0) {
	let r = [...e, t];
	return n && r.length > n ? r.slice(1) : r;
}
function Iu(e, t, n = 0) {
	let r = [t, ...e];
	return n && r.length > n ? r.slice(0, -1) : r;
}
var Lu = /* @__PURE__ */ Symbol();
function Ru(e, t) {
	return !e.queryFn && t?.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === Lu ? () => Promise.reject(/* @__PURE__ */ Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function zu(e, t) {
	return typeof e == "function" ? e(...t) : !!e;
}
function Bu(e, t, n) {
	let r = !1, i;
	return Object.defineProperty(e, "signal", {
		enumerable: !0,
		get: () => (i ??= t(), r ? i : (r = !0, i.aborted ? n() : i.addEventListener("abort", n, { once: !0 }), i))
	}), e;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/environmentManager.js
var Vu = /* @__PURE__ */ (() => {
	let e = () => hu;
	return {
		isServer() {
			return e();
		},
		setIsServer(t) {
			e = t;
		}
	};
})();
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/thenable.js
function Hu() {
	let e, t, n = new Promise((n, r) => {
		e = n, t = r;
	});
	n.status = "pending", n.catch(() => {});
	function r(e) {
		Object.assign(n, e), delete n.resolve, delete n.reject;
	}
	return n.resolve = (t) => {
		r({
			status: "fulfilled",
			value: t
		}), e(t);
	}, n.reject = (e) => {
		r({
			status: "rejected",
			reason: e
		}), t(e);
	}, n;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/notifyManager.js
var Uu = mu;
function Wu() {
	let e = [], t = 0, n = (e) => {
		e();
	}, r = (e) => {
		e();
	}, i = Uu, a = (r) => {
		t ? e.push(r) : i(() => {
			n(r);
		});
	}, o = () => {
		let t = e;
		e = [], t.length && i(() => {
			r(() => {
				t.forEach((e) => {
					n(e);
				});
			});
		});
	};
	return {
		batch: (e) => {
			let n;
			t++;
			try {
				n = e();
			} finally {
				t--, t || o();
			}
			return n;
		},
		batchCalls: (e) => (...t) => {
			a(() => {
				e(...t);
			});
		},
		schedule: a,
		setNotifyFunction: (e) => {
			n = e;
		},
		setBatchNotifyFunction: (e) => {
			r = e;
		},
		setScheduler: (e) => {
			i = e;
		}
	};
}
var Gu = Wu(), Ku = new class extends uu {
	#e = !0;
	#t;
	#n;
	constructor() {
		super(), this.#n = (e) => {
			if (typeof window < "u" && window.addEventListener) {
				let t = () => e(!0), n = () => e(!1);
				return window.addEventListener("online", t, !1), window.addEventListener("offline", n, !1), () => {
					window.removeEventListener("online", t), window.removeEventListener("offline", n);
				};
			}
		};
	}
	onSubscribe() {
		this.#t || this.setEventListener(this.#n);
	}
	onUnsubscribe() {
		this.hasListeners() || (this.#t?.(), this.#t = void 0);
	}
	setEventListener(e) {
		this.#n = e, this.#t?.(), this.#t = e(this.setOnline.bind(this));
	}
	setOnline(e) {
		this.#e !== e && (this.#e = e, this.listeners.forEach((t) => {
			t(e);
		}));
	}
	isOnline() {
		return this.#e;
	}
}();
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/retryer.js
function qu(e) {
	return Math.min(1e3 * 2 ** e, 3e4);
}
function Ju(e) {
	return (e ?? "online") !== "online" || Ku.isOnline();
}
var Yu = class extends Error {
	constructor(e) {
		super("CancelledError"), this.revert = e?.revert, this.silent = e?.silent;
	}
};
function Xu(e) {
	let t = !1, n = 0, r, i = Hu(), a = () => i.status !== "pending", o = (t) => {
		if (!a()) {
			let n = new Yu(t);
			f(n), e.onCancel?.(n);
		}
	}, s = () => {
		t = !0;
	}, c = () => {
		t = !1;
	}, l = () => du.isFocused() && (e.networkMode === "always" || Ku.isOnline()) && e.canRun(), u = () => Ju(e.networkMode) && e.canRun(), d = (e) => {
		a() || (r?.(), i.resolve(e));
	}, f = (e) => {
		a() || (r?.(), i.reject(e));
	}, p = () => new Promise((t) => {
		r = (e) => {
			(a() || l()) && t(e);
		}, e.onPause?.();
	}).then(() => {
		r = void 0, a() || e.onContinue?.();
	}), m = () => {
		if (a()) return;
		let r, i = n === 0 ? e.initialPromise : void 0;
		try {
			r = i ?? e.fn();
		} catch (e) {
			r = Promise.reject(e);
		}
		Promise.resolve(r).then(d).catch((r) => {
			if (a()) return;
			let i = e.retry ?? (Vu.isServer() ? 0 : 3), o = e.retryDelay ?? qu, s = typeof o == "function" ? o(n, r) : o, c = i === !0 || typeof i == "number" && n < i || typeof i == "function" && i(n, r);
			if (t || !c) {
				f(r);
				return;
			}
			n++, e.onFail?.(n, r), Nu(s).then(() => l() ? void 0 : p()).then(() => {
				t ? f(r) : m();
			});
		});
	};
	return {
		promise: i,
		status: () => i.status,
		cancel: o,
		continue: () => (r?.(), i),
		cancelRetry: s,
		continueRetry: c,
		canStart: u,
		start: () => (u() ? m() : p().then(m), i)
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/removable.js
var Zu = class {
	#e;
	destroy() {
		this.clearGcTimeout();
	}
	scheduleGc() {
		this.clearGcTimeout(), vu(this.gcTime) && (this.#e = pu.setTimeout(() => {
			this.optionalRemove();
		}, this.gcTime));
	}
	updateGcTime(e) {
		this.gcTime = Math.max(this.gcTime || 0, e ?? (Vu.isServer() ? Infinity : 3e5));
	}
	clearGcTimeout() {
		this.#e !== void 0 && (pu.clearTimeout(this.#e), this.#e = void 0);
	}
};
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/infiniteQueryBehavior.js
function Qu(e) {
	return { onFetch: (t, n) => {
		let r = t.options, i = t.fetchOptions?.meta?.fetchMore?.direction, a = t.state.data?.pages || [], o = t.state.data?.pageParams || [], s = {
			pages: [],
			pageParams: []
		}, c = 0, l = async () => {
			let n = !1, l = (e) => {
				Bu(e, () => t.signal, () => n = !0);
			}, u = Ru(t.options, t.fetchOptions), d = async (e, r, i) => {
				if (n) return Promise.reject(t.signal.reason);
				if (r == null && e.pages.length) return Promise.resolve(e);
				let a = (() => {
					let e = {
						client: t.client,
						queryKey: t.queryKey,
						pageParam: r,
						direction: i ? "backward" : "forward",
						meta: t.options.meta
					};
					return l(e), e;
				})(), o = await u(a), { maxPages: s } = t.options, c = i ? Iu : Fu;
				return {
					pages: c(e.pages, o, s),
					pageParams: c(e.pageParams, r, s)
				};
			};
			if (i && a.length) {
				let e = i === "backward", t = e ? ed : $u, n = {
					pages: a,
					pageParams: o
				};
				s = await d(n, t(r, n), e);
			} else {
				let t = e ?? a.length;
				do {
					let e = c === 0 ? o[0] ?? r.initialPageParam : $u(r, s);
					if (c > 0 && e == null) break;
					s = await d(s, e), c++;
				} while (c < t);
			}
			return s;
		};
		t.fetchFn = t.options.persister ? () => t.options.persister?.(l, {
			client: t.client,
			queryKey: t.queryKey,
			meta: t.options.meta,
			signal: t.signal
		}, n) : l;
	} };
}
function $u(e, { pages: t, pageParams: n }) {
	let r = t.length - 1;
	return t.length > 0 ? e.getNextPageParam(t[r], t, n[r], n) : void 0;
}
function ed(e, { pages: t, pageParams: n }) {
	return t.length > 0 ? e.getPreviousPageParam?.(t[0], t, n[0], n) : void 0;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/query.js
var td = class extends Zu {
	#e;
	#t;
	#n;
	#r;
	#i;
	#a;
	#o;
	#s;
	constructor(e) {
		super(), this.#s = !1, this.#o = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.#i = e.client, this.#r = this.#i.getQueryCache(), this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.#t = id(this.options), this.state = e.state ?? this.#t, this.scheduleGc();
	}
	get meta() {
		return this.options.meta;
	}
	get queryType() {
		return this.#e;
	}
	get promise() {
		return this.#a?.promise;
	}
	setOptions(e) {
		if (this.options = {
			...this.#o,
			...e
		}, e?._type && (this.#e = e._type), this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
			let e = id(this.options);
			e.data !== void 0 && (this.setState(rd(e.data, e.dataUpdatedAt)), this.#t = e);
		}
	}
	optionalRemove() {
		!this.observers.length && this.state.fetchStatus === "idle" && this.#r.remove(this);
	}
	setData(e, t) {
		let n = Pu(this.state.data, e, this.options);
		return this.#l({
			data: n,
			type: "success",
			dataUpdatedAt: t?.updatedAt,
			manual: t?.manual
		}), n;
	}
	setState(e) {
		this.#l({
			type: "setState",
			state: e
		});
	}
	cancel(e) {
		let t = this.#a?.promise;
		return this.#a?.cancel(e), t ? t.then(gu).catch(gu) : Promise.resolve();
	}
	destroy() {
		super.destroy(), this.cancel({ silent: !0 });
	}
	get resetState() {
		return this.#t;
	}
	reset() {
		this.destroy(), this.setState(this.resetState);
	}
	isActive() {
		return this.observers.some((e) => xu(e.options.enabled, this) !== !1);
	}
	isDisabled() {
		return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Lu || !this.isFetched();
	}
	isFetched() {
		return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
	}
	isStatic() {
		return this.getObserversCount() > 0 && this.observers.some((e) => bu(e.options.staleTime, this) === "static");
	}
	isStale() {
		return this.getObserversCount() > 0 ? this.observers.some((e) => e.getCurrentResult().isStale) : this.state.data === void 0 || this.state.isInvalidated;
	}
	isStaleByTime(e = 0) {
		return this.state.data === void 0 ? !0 : e === "static" ? !1 : this.state.isInvalidated ? !0 : !yu(this.state.dataUpdatedAt, e);
	}
	onFocus() {
		this.observers.find((e) => e.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#a?.continue();
	}
	onOnline() {
		this.observers.find((e) => e.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#a?.continue();
	}
	addObserver(e) {
		this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.#r.notify({
			type: "observerAdded",
			query: this,
			observer: e
		}));
	}
	removeObserver(e) {
		this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (this.#a && (this.#s || this.#c() ? this.#a.cancel({ revert: !0 }) : this.#a.cancelRetry()), this.scheduleGc()), this.#r.notify({
			type: "observerRemoved",
			query: this,
			observer: e
		}));
	}
	getObserversCount() {
		return this.observers.length;
	}
	#c() {
		return this.state.fetchStatus === "paused" && this.state.status === "pending";
	}
	invalidate() {
		this.state.isInvalidated || this.#l({ type: "invalidate" });
	}
	async fetch(e, t) {
		if (this.state.fetchStatus !== "idle" && this.#a?.status() !== "rejected") {
			if (this.state.data !== void 0 && t?.cancelRefetch) this.cancel({ silent: !0 });
			else if (this.#a) return this.#a.continueRetry(), this.#a.promise;
		}
		if (e && this.setOptions(e), !this.options.queryFn) {
			let e = this.observers.find((e) => e.options.queryFn);
			e && this.setOptions(e.options);
		}
		let n = new AbortController(), r = (e) => {
			Object.defineProperty(e, "signal", {
				enumerable: !0,
				get: () => (this.#s = !0, n.signal)
			});
		}, i = () => {
			let e = Ru(this.options, t), n = (() => {
				let e = {
					client: this.#i,
					queryKey: this.queryKey,
					meta: this.meta
				};
				return r(e), e;
			})();
			return this.#s = !1, this.options.persister ? this.options.persister(e, n, this) : e(n);
		}, a = (() => {
			let e = {
				fetchOptions: t,
				options: this.options,
				queryKey: this.queryKey,
				client: this.#i,
				state: this.state,
				fetchFn: i
			};
			return r(e), e;
		})();
		(this.#e === "infinite" ? Qu(this.options.pages) : this.options.behavior)?.onFetch(a, this), this.#n = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== a.fetchOptions?.meta) && this.#l({
			type: "fetch",
			meta: a.fetchOptions?.meta
		}), this.#a = Xu({
			initialPromise: t?.initialPromise,
			fn: a.fetchFn,
			onCancel: (e) => {
				e instanceof Yu && e.revert && this.setState({
					...this.#n,
					fetchStatus: "idle"
				}), n.abort();
			},
			onFail: (e, t) => {
				this.#l({
					type: "failed",
					failureCount: e,
					error: t
				});
			},
			onPause: () => {
				this.#l({ type: "pause" });
			},
			onContinue: () => {
				this.#l({ type: "continue" });
			},
			retry: a.options.retry,
			retryDelay: a.options.retryDelay,
			networkMode: a.options.networkMode,
			canRun: () => !0
		});
		try {
			let e = await this.#a.start();
			if (e === void 0) throw Error(`${this.queryHash} data is undefined`);
			return this.setData(e), this.#r.config.onSuccess?.(e, this), this.#r.config.onSettled?.(e, this.state.error, this), e;
		} catch (e) {
			if (e instanceof Yu) {
				if (e.silent) return this.#a.promise;
				if (e.revert) {
					if (this.state.data === void 0) throw e;
					return this.state.data;
				}
			}
			throw this.#l({
				type: "error",
				error: e
			}), this.#r.config.onError?.(e, this), this.#r.config.onSettled?.(this.state.data, e, this), e;
		} finally {
			this.scheduleGc();
		}
	}
	#l(e) {
		let t = (t) => {
			switch (e.type) {
				case "failed": return {
					...t,
					fetchFailureCount: e.failureCount,
					fetchFailureReason: e.error
				};
				case "pause": return {
					...t,
					fetchStatus: "paused"
				};
				case "continue": return {
					...t,
					fetchStatus: "fetching"
				};
				case "fetch": return {
					...t,
					...nd(t.data, this.options),
					fetchMeta: e.meta ?? null
				};
				case "success":
					let n = {
						...t,
						...rd(e.data, e.dataUpdatedAt),
						dataUpdateCount: t.dataUpdateCount + 1,
						...!e.manual && {
							fetchStatus: "idle",
							fetchFailureCount: 0,
							fetchFailureReason: null
						}
					};
					return this.#n = e.manual ? n : void 0, n;
				case "error":
					let r = e.error;
					return {
						...t,
						error: r,
						errorUpdateCount: t.errorUpdateCount + 1,
						errorUpdatedAt: Date.now(),
						fetchFailureCount: t.fetchFailureCount + 1,
						fetchFailureReason: r,
						fetchStatus: "idle",
						status: "error",
						isInvalidated: !0
					};
				case "invalidate": return {
					...t,
					isInvalidated: !0
				};
				case "setState": return {
					...t,
					...e.state
				};
			}
		};
		this.state = t(this.state), Gu.batch(() => {
			this.observers.forEach((e) => {
				e.onQueryUpdate();
			}), this.#r.notify({
				query: this,
				type: "updated",
				action: e
			});
		});
	}
};
function nd(e, t) {
	return {
		fetchFailureCount: 0,
		fetchFailureReason: null,
		fetchStatus: Ju(t.networkMode) ? "fetching" : "paused",
		...e === void 0 && {
			error: null,
			status: "pending"
		}
	};
}
function rd(e, t) {
	return {
		data: e,
		dataUpdatedAt: t ?? Date.now(),
		error: null,
		isInvalidated: !1,
		status: "success"
	};
}
function id(e) {
	let t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
	return {
		data: t,
		dataUpdateCount: 0,
		dataUpdatedAt: n ? r ?? Date.now() : 0,
		error: null,
		errorUpdateCount: 0,
		errorUpdatedAt: 0,
		fetchFailureCount: 0,
		fetchFailureReason: null,
		fetchMeta: null,
		isInvalidated: !1,
		status: n ? "success" : "pending",
		fetchStatus: "idle"
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/queryObserver.js
var ad = class extends uu {
	constructor(e, t) {
		super(), this.options = t, this.#e = e, this.#s = null, this.#o = Hu(), this.bindMethods(), this.setOptions(t);
	}
	#e;
	#t = void 0;
	#n = void 0;
	#r = void 0;
	#i;
	#a;
	#o;
	#s;
	#c;
	#l;
	#u;
	#d;
	#f;
	#p;
	#m = /* @__PURE__ */ new Set();
	bindMethods() {
		this.refetch = this.refetch.bind(this);
	}
	onSubscribe() {
		this.listeners.size === 1 && (this.#t.addObserver(this), sd(this.#t, this.options) ? this.#h() : this.updateResult(), this.#y());
	}
	onUnsubscribe() {
		this.hasListeners() || this.destroy();
	}
	shouldFetchOnReconnect() {
		return cd(this.#t, this.options, this.options.refetchOnReconnect);
	}
	shouldFetchOnWindowFocus() {
		return cd(this.#t, this.options, this.options.refetchOnWindowFocus);
	}
	destroy() {
		this.listeners = /* @__PURE__ */ new Set(), this.#b(), this.#x(), this.#t.removeObserver(this);
	}
	setOptions(e) {
		let t = this.options, n = this.#t;
		if (this.options = this.#e.defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof xu(this.options.enabled, this.#t) != "boolean") throw Error("Expected enabled to be a boolean or a callback that returns a boolean");
		this.#S(), this.#t.setOptions(this.options), t._defaulted && !ku(this.options, t) && this.#e.getQueryCache().notify({
			type: "observerOptionsUpdated",
			query: this.#t,
			observer: this
		});
		let r = this.hasListeners();
		r && ld(this.#t, n, this.options, t) && this.#h(), this.updateResult(), r && (this.#t !== n || xu(this.options.enabled, this.#t) !== xu(t.enabled, this.#t) || bu(this.options.staleTime, this.#t) !== bu(t.staleTime, this.#t)) && this.#g();
		let i = this.#_();
		r && (this.#t !== n || xu(this.options.enabled, this.#t) !== xu(t.enabled, this.#t) || i !== this.#p) && this.#v(i);
	}
	getOptimisticResult(e) {
		let t = this.#e.getQueryCache().build(this.#e, e), n = this.createResult(t, e);
		return dd(this, n) && (this.#r = n, this.#a = this.options, this.#i = this.#t.state), n;
	}
	getCurrentResult() {
		return this.#r;
	}
	trackResult(e, t) {
		return new Proxy(e, { get: (e, n) => (this.trackProp(n), t?.(n), n === "promise" && (this.trackProp("data"), !this.options.experimental_prefetchInRender && this.#o.status === "pending" && this.#o.reject(/* @__PURE__ */ Error("experimental_prefetchInRender feature flag is not enabled"))), Reflect.get(e, n)) });
	}
	trackProp(e) {
		this.#m.add(e);
	}
	getCurrentQuery() {
		return this.#t;
	}
	refetch({ ...e } = {}) {
		return this.fetch({ ...e });
	}
	fetchOptimistic(e) {
		let t = this.#e.defaultQueryOptions(e), n = this.#e.getQueryCache().build(this.#e, t);
		return n.fetch().then(() => this.createResult(n, t));
	}
	fetch(e) {
		return this.#h({
			...e,
			cancelRefetch: e.cancelRefetch ?? !0
		}).then(() => (this.updateResult(), this.#r));
	}
	#h(e) {
		this.#S();
		let t = this.#t.fetch(this.options, e);
		return e?.throwOnError || (t = t.catch(gu)), t;
	}
	#g() {
		this.#b();
		let e = bu(this.options.staleTime, this.#t);
		if (Vu.isServer() || this.#r.isStale || !vu(e)) return;
		let t = yu(this.#r.dataUpdatedAt, e) + 1;
		this.#d = pu.setTimeout(() => {
			this.#r.isStale || this.updateResult();
		}, t);
	}
	#_() {
		return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.#t) : this.options.refetchInterval) ?? !1;
	}
	#v(e) {
		this.#x(), this.#p = e, !(Vu.isServer() || xu(this.options.enabled, this.#t) === !1 || !vu(this.#p) || this.#p === 0) && (this.#f = pu.setInterval(() => {
			(this.options.refetchIntervalInBackground || du.isFocused()) && this.#h();
		}, this.#p));
	}
	#y() {
		this.#g(), this.#v(this.#_());
	}
	#b() {
		this.#d !== void 0 && (pu.clearTimeout(this.#d), this.#d = void 0);
	}
	#x() {
		this.#f !== void 0 && (pu.clearInterval(this.#f), this.#f = void 0);
	}
	createResult(e, t) {
		let n = this.#t, r = this.options, i = this.#r, a = this.#i, o = this.#a, s = e === n ? this.#n : e.state, { state: c } = e, l = { ...c }, u = !1, d;
		if (t._optimisticResults) {
			let i = this.hasListeners(), a = !i && sd(e, t), o = i && ld(e, n, t, r);
			(a || o) && (l = {
				...l,
				...nd(c.data, e.options)
			}), t._optimisticResults === "isRestoring" && (l.fetchStatus = "idle");
		}
		let { error: f, errorUpdatedAt: p, status: m } = l;
		d = l.data;
		let h = !1;
		if (t.placeholderData !== void 0 && d === void 0 && m === "pending") {
			let e;
			i?.isPlaceholderData && t.placeholderData === o?.placeholderData ? (e = i.data, h = !0) : e = typeof t.placeholderData == "function" ? t.placeholderData(this.#u?.state.data, this.#u) : t.placeholderData, e !== void 0 && (m = "success", d = Pu(i?.data, e, t), u = !0);
		}
		if (t.select && d !== void 0 && !h) if (i && d === a?.data && t.select === this.#c) d = this.#l;
		else try {
			this.#c = t.select, d = t.select(d), d = Pu(i?.data, d, t), this.#l = d, this.#s = null;
		} catch (e) {
			this.#s = e;
		}
		this.#s && (f = this.#s, d = this.#l, p = Date.now(), m = "error");
		let g = l.fetchStatus === "fetching", _ = m === "pending", v = m === "error", y = _ && g, b = d !== void 0, x = {
			status: m,
			fetchStatus: l.fetchStatus,
			isPending: _,
			isSuccess: m === "success",
			isError: v,
			isInitialLoading: y,
			isLoading: y,
			data: d,
			dataUpdatedAt: l.dataUpdatedAt,
			error: f,
			errorUpdatedAt: p,
			failureCount: l.fetchFailureCount,
			failureReason: l.fetchFailureReason,
			errorUpdateCount: l.errorUpdateCount,
			isFetched: e.isFetched(),
			isFetchedAfterMount: l.dataUpdateCount > s.dataUpdateCount || l.errorUpdateCount > s.errorUpdateCount,
			isFetching: g,
			isRefetching: g && !_,
			isLoadingError: v && !b,
			isPaused: l.fetchStatus === "paused",
			isPlaceholderData: u,
			isRefetchError: v && b,
			isStale: ud(e, t),
			refetch: this.refetch,
			promise: this.#o,
			isEnabled: xu(t.enabled, e) !== !1
		};
		if (this.options.experimental_prefetchInRender) {
			let t = x.data !== void 0, r = x.status === "error" && !t, i = (e) => {
				r ? e.reject(x.error) : t && e.resolve(x.data);
			}, a = () => {
				let e = this.#o = x.promise = Hu();
				i(e);
			}, o = this.#o;
			switch (o.status) {
				case "pending":
					e.queryHash === n.queryHash && i(o);
					break;
				case "fulfilled":
					(r || x.data !== o.value) && a();
					break;
				case "rejected": (!r || x.error !== o.reason) && a();
			}
		}
		return x;
	}
	updateResult() {
		let e = this.#r, t = this.createResult(this.#t, this.options);
		this.#i = this.#t.state, this.#a = this.options, this.#i.data !== void 0 && (this.#u = this.#t), !ku(t, e) && (this.#r = t, this.#C({ listeners: (() => {
			if (!e) return !0;
			let { notifyOnChangeProps: t } = this.options, n = typeof t == "function" ? t() : t;
			if (n === "all" || !n && !this.#m.size) return !0;
			let r = new Set(n ?? this.#m);
			return this.options.throwOnError && r.add("error"), Object.keys(this.#r).some((t) => {
				let n = t;
				return this.#r[n] !== e[n] && r.has(n);
			});
		})() }));
	}
	#S() {
		let e = this.#e.getQueryCache().build(this.#e, this.options);
		if (e === this.#t) return;
		let t = this.#t;
		this.#t = e, this.#n = e.state, this.hasListeners() && (t?.removeObserver(this), e.addObserver(this));
	}
	onQueryUpdate() {
		this.updateResult(), this.hasListeners() && this.#y();
	}
	#C(e) {
		Gu.batch(() => {
			e.listeners && this.listeners.forEach((e) => {
				e(this.#r);
			}), this.#e.getQueryCache().notify({
				query: this.#t,
				type: "observerResultsUpdated"
			});
		});
	}
};
function od(e, t) {
	return xu(t.enabled, e) !== !1 && e.state.data === void 0 && (e.state.status !== "error" || xu(t.retryOnMount, e) !== !1);
}
function sd(e, t) {
	return od(e, t) || e.state.data !== void 0 && cd(e, t, t.refetchOnMount);
}
function cd(e, t, n) {
	if (xu(t.enabled, e) !== !1 && bu(t.staleTime, e) !== "static") {
		let r = typeof n == "function" ? n(e) : n;
		return r === "always" || r !== !1 && ud(e, t);
	}
	return !1;
}
function ld(e, t, n, r) {
	return (e !== t || xu(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && ud(e, n);
}
function ud(e, t) {
	return xu(t.enabled, e) !== !1 && e.isStaleByTime(bu(t.staleTime, e));
}
function dd(e, t) {
	return !ku(e.getCurrentResult(), t);
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/mutation.js
var fd = class extends Zu {
	#e;
	#t;
	#n;
	#r;
	constructor(e) {
		super(), this.#e = e.client, this.mutationId = e.mutationId, this.#n = e.mutationCache, this.#t = [], this.state = e.state || pd(), this.setOptions(e.options), this.scheduleGc();
	}
	setOptions(e) {
		this.options = e, this.updateGcTime(this.options.gcTime);
	}
	get meta() {
		return this.options.meta;
	}
	addObserver(e) {
		this.#t.includes(e) || (this.#t.push(e), this.clearGcTimeout(), this.#n.notify({
			type: "observerAdded",
			mutation: this,
			observer: e
		}));
	}
	removeObserver(e) {
		this.#t = this.#t.filter((t) => t !== e), this.scheduleGc(), this.#n.notify({
			type: "observerRemoved",
			mutation: this,
			observer: e
		});
	}
	optionalRemove() {
		this.#t.length || (this.state.status === "pending" ? this.scheduleGc() : this.#n.remove(this));
	}
	continue() {
		return this.#r?.continue() ?? this.execute(this.state.variables);
	}
	async execute(e) {
		let t = () => {
			this.#i({ type: "continue" });
		}, n = {
			client: this.#e,
			meta: this.options.meta,
			mutationKey: this.options.mutationKey
		};
		this.#r = Xu({
			fn: () => this.options.mutationFn ? this.options.mutationFn(e, n) : Promise.reject(/* @__PURE__ */ Error("No mutationFn found")),
			onFail: (e, t) => {
				this.#i({
					type: "failed",
					failureCount: e,
					error: t
				});
			},
			onPause: () => {
				this.#i({ type: "pause" });
			},
			onContinue: t,
			retry: this.options.retry ?? 0,
			retryDelay: this.options.retryDelay,
			networkMode: this.options.networkMode,
			canRun: () => this.#n.canRun(this)
		});
		let r = this.state.status === "pending", i = !this.#r.canStart();
		try {
			if (r) t();
			else {
				this.#i({
					type: "pending",
					variables: e,
					isPaused: i
				}), this.#n.config.onMutate && await this.#n.config.onMutate(e, this, n);
				let t = await this.options.onMutate?.(e, n);
				t !== this.state.context && this.#i({
					type: "pending",
					context: t,
					variables: e,
					isPaused: i
				});
			}
			let a = await this.#r.start();
			return await this.#n.config.onSuccess?.(a, e, this.state.context, this, n), await this.options.onSuccess?.(a, e, this.state.context, n), await this.#n.config.onSettled?.(a, null, this.state.variables, this.state.context, this, n), await this.options.onSettled?.(a, null, e, this.state.context, n), this.#i({
				type: "success",
				data: a
			}), a;
		} catch (t) {
			try {
				await this.#n.config.onError?.(t, e, this.state.context, this, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.options.onError?.(t, e, this.state.context, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.#n.config.onSettled?.(void 0, t, this.state.variables, this.state.context, this, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.options.onSettled?.(void 0, t, e, this.state.context, n);
			} catch (e) {
				Promise.reject(e);
			}
			throw this.#i({
				type: "error",
				error: t
			}), t;
		} finally {
			this.#n.runNext(this);
		}
	}
	#i(e) {
		let t = (t) => {
			switch (e.type) {
				case "failed": return {
					...t,
					failureCount: e.failureCount,
					failureReason: e.error
				};
				case "pause": return {
					...t,
					isPaused: !0
				};
				case "continue": return {
					...t,
					isPaused: !1
				};
				case "pending": return {
					...t,
					context: e.context,
					data: void 0,
					failureCount: 0,
					failureReason: null,
					error: null,
					isPaused: e.isPaused,
					status: "pending",
					variables: e.variables,
					submittedAt: Date.now()
				};
				case "success": return {
					...t,
					data: e.data,
					failureCount: 0,
					failureReason: null,
					error: null,
					status: "success",
					isPaused: !1
				};
				case "error": return {
					...t,
					data: void 0,
					error: e.error,
					failureCount: t.failureCount + 1,
					failureReason: e.error,
					isPaused: !1,
					status: "error"
				};
			}
		};
		this.state = t(this.state), Gu.batch(() => {
			this.#t.forEach((t) => {
				t.onMutationUpdate(e);
			}), this.#n.notify({
				mutation: this,
				type: "updated",
				action: e
			});
		});
	}
};
function pd() {
	return {
		context: void 0,
		data: void 0,
		error: null,
		failureCount: 0,
		failureReason: null,
		isPaused: !1,
		status: "idle",
		variables: void 0,
		submittedAt: 0
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/mutationCache.js
var md = class extends uu {
	constructor(e = {}) {
		super(), this.config = e, this.#e = /* @__PURE__ */ new Set(), this.#t = /* @__PURE__ */ new Map(), this.#n = 0;
	}
	#e;
	#t;
	#n;
	build(e, t, n) {
		let r = new fd({
			client: e,
			mutationCache: this,
			mutationId: ++this.#n,
			options: e.defaultMutationOptions(t),
			state: n
		});
		return this.add(r), r;
	}
	add(e) {
		this.#e.add(e);
		let t = hd(e);
		if (typeof t == "string") {
			let n = this.#t.get(t);
			n ? n.push(e) : this.#t.set(t, [e]);
		}
		this.notify({
			type: "added",
			mutation: e
		});
	}
	remove(e) {
		if (this.#e.delete(e)) {
			let t = hd(e);
			if (typeof t == "string") {
				let n = this.#t.get(t);
				if (n) if (n.length > 1) {
					let t = n.indexOf(e);
					t !== -1 && n.splice(t, 1);
				} else n[0] === e && this.#t.delete(t);
			}
		}
		this.notify({
			type: "removed",
			mutation: e
		});
	}
	canRun(e) {
		let t = hd(e);
		if (typeof t == "string") {
			let n = this.#t.get(t)?.find((e) => e.state.status === "pending");
			return !n || n === e;
		}
		return !0;
	}
	runNext(e) {
		let t = hd(e);
		return typeof t == "string" ? (this.#t.get(t)?.find((t) => t !== e && t.state.isPaused))?.continue() ?? Promise.resolve() : Promise.resolve();
	}
	clear() {
		Gu.batch(() => {
			this.#e.forEach((e) => {
				this.notify({
					type: "removed",
					mutation: e
				});
			}), this.#e.clear(), this.#t.clear();
		});
	}
	getAll() {
		return Array.from(this.#e);
	}
	find(e) {
		let t = {
			exact: !0,
			...e
		};
		return this.getAll().find((e) => Cu(t, e));
	}
	findAll(e = {}) {
		return this.getAll().filter((t) => Cu(e, t));
	}
	notify(e) {
		Gu.batch(() => {
			this.listeners.forEach((t) => {
				t(e);
			});
		});
	}
	resumePausedMutations() {
		let e = this.getAll().filter((e) => e.state.isPaused);
		return Gu.batch(() => Promise.all(e.map((e) => e.continue().catch(gu))));
	}
};
function hd(e) {
	return e.options.scope?.id;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/queryCache.js
var gd = class extends uu {
	constructor(e = {}) {
		super(), this.config = e, this.#e = /* @__PURE__ */ new Map();
	}
	#e;
	build(e, t, n) {
		let r = t.queryKey, i = t.queryHash ?? wu(r, t), a = this.get(i);
		return a || (a = new td({
			client: e,
			queryKey: r,
			queryHash: i,
			options: e.defaultQueryOptions(t),
			state: n,
			defaultOptions: e.getQueryDefaults(r)
		}), this.add(a)), a;
	}
	add(e) {
		this.#e.has(e.queryHash) || (this.#e.set(e.queryHash, e), this.notify({
			type: "added",
			query: e
		}));
	}
	remove(e) {
		let t = this.#e.get(e.queryHash);
		t && (e.destroy(), t === e && this.#e.delete(e.queryHash), this.notify({
			type: "removed",
			query: e
		}));
	}
	clear() {
		Gu.batch(() => {
			this.getAll().forEach((e) => {
				this.remove(e);
			});
		});
	}
	get(e) {
		return this.#e.get(e);
	}
	getAll() {
		return [...this.#e.values()];
	}
	find(e) {
		let t = {
			exact: !0,
			...e
		};
		return this.getAll().find((e) => Su(t, e));
	}
	findAll(e = {}) {
		let t = this.getAll();
		return Object.keys(e).length > 0 ? t.filter((t) => Su(e, t)) : t;
	}
	notify(e) {
		Gu.batch(() => {
			this.listeners.forEach((t) => {
				t(e);
			});
		});
	}
	onFocus() {
		Gu.batch(() => {
			this.getAll().forEach((e) => {
				e.onFocus();
			});
		});
	}
	onOnline() {
		Gu.batch(() => {
			this.getAll().forEach((e) => {
				e.onOnline();
			});
		});
	}
}, _d = class {
	#e;
	#t;
	#n;
	#r;
	#i;
	#a;
	#o;
	#s;
	constructor(e = {}) {
		this.#e = e.queryCache || new gd(), this.#t = e.mutationCache || new md(), this.#n = e.defaultOptions || {}, this.#r = /* @__PURE__ */ new Map(), this.#i = /* @__PURE__ */ new Map(), this.#a = 0;
	}
	mount() {
		this.#a++, this.#a === 1 && (this.#o = du.subscribe(async (e) => {
			e && (await this.resumePausedMutations(), this.#e.onFocus());
		}), this.#s = Ku.subscribe(async (e) => {
			e && (await this.resumePausedMutations(), this.#e.onOnline());
		}));
	}
	unmount() {
		this.#a--, this.#a === 0 && (this.#o?.(), this.#o = void 0, this.#s?.(), this.#s = void 0);
	}
	isFetching(e) {
		return this.#e.findAll({
			...e,
			fetchStatus: "fetching"
		}).length;
	}
	isMutating(e) {
		return this.#t.findAll({
			...e,
			status: "pending"
		}).length;
	}
	getQueryData(e) {
		let t = this.defaultQueryOptions({ queryKey: e });
		return this.#e.get(t.queryHash)?.state.data;
	}
	ensureQueryData(e) {
		let t = this.defaultQueryOptions(e), n = this.#e.build(this, t), r = n.state.data;
		return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(bu(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
	}
	getQueriesData(e) {
		return this.#e.findAll(e).map(({ queryKey: e, state: t }) => [e, t.data]);
	}
	setQueryData(e, t, n) {
		let r = this.defaultQueryOptions({ queryKey: e }), i = this.#e.get(r.queryHash)?.state.data, a = _u(t, i);
		if (a !== void 0) return this.#e.build(this, r).setData(a, {
			...n,
			manual: !0
		});
	}
	setQueriesData(e, t, n) {
		return Gu.batch(() => this.#e.findAll(e).map(({ queryKey: e }) => [e, this.setQueryData(e, t, n)]));
	}
	getQueryState(e) {
		let t = this.defaultQueryOptions({ queryKey: e });
		return this.#e.get(t.queryHash)?.state;
	}
	removeQueries(e) {
		let t = this.#e;
		Gu.batch(() => {
			t.findAll(e).forEach((e) => {
				t.remove(e);
			});
		});
	}
	resetQueries(e, t) {
		let n = this.#e;
		return Gu.batch(() => (n.findAll(e).forEach((e) => {
			e.reset();
		}), this.refetchQueries({
			type: "active",
			...e
		}, t)));
	}
	cancelQueries(e, t = {}) {
		let n = {
			revert: !0,
			...t
		}, r = Gu.batch(() => this.#e.findAll(e).map((e) => e.cancel(n)));
		return Promise.all(r).then(gu).catch(gu);
	}
	invalidateQueries(e, t = {}) {
		return Gu.batch(() => (this.#e.findAll(e).forEach((e) => {
			e.invalidate();
		}), e?.refetchType === "none" ? Promise.resolve() : this.refetchQueries({
			...e,
			type: e?.refetchType ?? e?.type ?? "active"
		}, t)));
	}
	refetchQueries(e, t = {}) {
		let n = {
			...t,
			cancelRefetch: t.cancelRefetch ?? !0
		}, r = Gu.batch(() => this.#e.findAll(e).filter((e) => !e.isDisabled() && !e.isStatic()).map((e) => {
			let t = e.fetch(void 0, n);
			return n.throwOnError || (t = t.catch(gu)), e.state.fetchStatus === "paused" ? Promise.resolve() : t;
		}));
		return Promise.all(r).then(gu);
	}
	fetchQuery(e) {
		let t = this.defaultQueryOptions(e);
		t.retry === void 0 && (t.retry = !1);
		let n = this.#e.build(this, t);
		return n.isStaleByTime(bu(t.staleTime, n)) ? n.fetch(t) : Promise.resolve(n.state.data);
	}
	prefetchQuery(e) {
		return this.fetchQuery(e).then(gu).catch(gu);
	}
	fetchInfiniteQuery(e) {
		return e._type = "infinite", this.fetchQuery(e);
	}
	prefetchInfiniteQuery(e) {
		return this.fetchInfiniteQuery(e).then(gu).catch(gu);
	}
	ensureInfiniteQueryData(e) {
		return e._type = "infinite", this.ensureQueryData(e);
	}
	resumePausedMutations() {
		return Ku.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
	}
	getQueryCache() {
		return this.#e;
	}
	getMutationCache() {
		return this.#t;
	}
	getDefaultOptions() {
		return this.#n;
	}
	setDefaultOptions(e) {
		this.#n = e;
	}
	setQueryDefaults(e, t) {
		this.#r.set(Tu(e), {
			queryKey: e,
			defaultOptions: t
		});
	}
	getQueryDefaults(e) {
		let t = [...this.#r.values()], n = {};
		return t.forEach((t) => {
			Eu(e, t.queryKey) && Object.assign(n, t.defaultOptions);
		}), n;
	}
	setMutationDefaults(e, t) {
		this.#i.set(Tu(e), {
			mutationKey: e,
			defaultOptions: t
		});
	}
	getMutationDefaults(e) {
		let t = [...this.#i.values()], n = {};
		return t.forEach((t) => {
			Eu(e, t.mutationKey) && Object.assign(n, t.defaultOptions);
		}), n;
	}
	defaultQueryOptions(e) {
		if (e._defaulted) return e;
		let t = {
			...this.#n.queries,
			...this.getQueryDefaults(e.queryKey),
			...e,
			_defaulted: !0
		};
		return t.queryHash ||= wu(t.queryKey, t), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Lu && (t.enabled = !1), t;
	}
	defaultMutationOptions(e) {
		return e?._defaulted ? e : {
			...this.#n.mutations,
			...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
			...e,
			_defaulted: !0
		};
	}
	clear() {
		this.#e.clear(), this.#t.clear();
	}
}, vd = "VUE_QUERY_CLIENT";
function yd(e) {
	return `${vd}${e ? `:${e}` : ""}`;
}
function bd(e, t) {
	Object.keys(e).forEach((n) => {
		e[n] = t[n];
	});
}
function xd(e, t, n = "", r = 0) {
	if (t) {
		let i = t(e, n, r);
		if (i === void 0 && /* @__PURE__ */ _n(e) || i !== void 0) return i;
	}
	if (Array.isArray(e)) return e.map((e, n) => xd(e, t, String(n), r + 1));
	if (typeof e == "object" && wd(e)) {
		let n = Object.entries(e).map(([e, n]) => [e, xd(n, t, e, r + 1)]);
		return Object.fromEntries(n);
	}
	return e;
}
function Sd(e, t) {
	return xd(e, t);
}
function Cd(e, t = !1) {
	return Sd(e, (e, n, r) => {
		if (r === 1 && n === "queryKey") return Cd(e, !0);
		if (t && Td(e)) return Cd(e(), t);
		if (/* @__PURE__ */ _n(e)) return Cd(F(e), t);
	});
}
function wd(e) {
	if (Object.prototype.toString.call(e) !== "[object Object]") return !1;
	let t = Object.getPrototypeOf(e);
	return t === null || t === Object.prototype;
}
function Td(e) {
	return typeof e == "function";
}
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/useQueryClient.js
function Ed(e = "") {
	if (!Or()) throw Error("vue-query hooks can only be used inside setup() function or functions that support injection context.");
	let t = Dr(yd(e));
	if (!t) throw Error("No 'queryClient' found in Vue context, use 'VueQueryPlugin' to properly initialize the library.");
	return t;
}
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/queryCache.js
var Dd = class extends gd {
	find(e) {
		return super.find(Cd(e));
	}
	findAll(e = {}) {
		return super.findAll(Cd(e));
	}
}, Od = class extends md {
	find(e) {
		return super.find(Cd(e));
	}
	findAll(e = {}) {
		return super.findAll(Cd(e));
	}
}, kd = class extends _d {
	constructor(e = {}) {
		let t = {
			defaultOptions: e.defaultOptions,
			queryCache: e.queryCache || new Dd(),
			mutationCache: e.mutationCache || new Od()
		};
		super(t), this.isRestoring = /* @__PURE__ */ P(!1);
	}
	isFetching(e = {}) {
		return super.isFetching(Cd(e));
	}
	isMutating(e = {}) {
		return super.isMutating(Cd(e));
	}
	getQueryData(e) {
		return super.getQueryData(Cd(e));
	}
	ensureQueryData(e) {
		return super.ensureQueryData(Cd(e));
	}
	getQueriesData(e) {
		return super.getQueriesData(Cd(e));
	}
	setQueryData(e, t, n = {}) {
		return super.setQueryData(Cd(e), t, Cd(n));
	}
	setQueriesData(e, t, n = {}) {
		return super.setQueriesData(Cd(e), t, Cd(n));
	}
	getQueryState(e) {
		return super.getQueryState(Cd(e));
	}
	removeQueries(e = {}) {
		return super.removeQueries(Cd(e));
	}
	resetQueries(e = {}, t = {}) {
		return super.resetQueries(Cd(e), Cd(t));
	}
	cancelQueries(e = {}, t = {}) {
		return super.cancelQueries(Cd(e), Cd(t));
	}
	invalidateQueries(e = {}, t = {}) {
		let n = Cd(e), r = Cd(t);
		if (super.invalidateQueries({
			...n,
			refetchType: "none"
		}, r), n.refetchType === "none") return Promise.resolve();
		let i = {
			...n,
			type: n.refetchType ?? n.type ?? "active"
		};
		return or().then(() => super.refetchQueries(i, r));
	}
	refetchQueries(e = {}, t = {}) {
		return super.refetchQueries(Cd(e), Cd(t));
	}
	fetchQuery(e) {
		return super.fetchQuery(Cd(e));
	}
	prefetchQuery(e) {
		return super.prefetchQuery(Cd(e));
	}
	fetchInfiniteQuery(e) {
		return super.fetchInfiniteQuery(Cd(e));
	}
	prefetchInfiniteQuery(e) {
		return super.prefetchInfiniteQuery(Cd(e));
	}
	setDefaultOptions(e) {
		super.setDefaultOptions(Cd(e));
	}
	setQueryDefaults(e, t) {
		super.setQueryDefaults(Cd(e), Cd(t));
	}
	getQueryDefaults(e) {
		return super.getQueryDefaults(Cd(e));
	}
	setMutationDefaults(e, t) {
		super.setMutationDefaults(Cd(e), Cd(t));
	}
	getMutationDefaults(e) {
		return super.getMutationDefaults(Cd(e));
	}
}, Ad = { install: (e, t = {}) => {
	let n = yd(t.queryClientKey), r;
	r = "queryClient" in t && t.queryClient ? t.queryClient : new kd("queryClientConfig" in t ? t.queryClientConfig : void 0), Vu.isServer() || r.mount();
	let i = () => {};
	if (t.clientPersister) {
		r.isRestoring && (r.isRestoring.value = !0);
		let [e, n] = t.clientPersister(r);
		i = e, n.then(() => {
			r.isRestoring && (r.isRestoring.value = !1), t.clientPersisterOnSuccess?.(r);
		});
	}
	let a = () => {
		r.unmount(), i();
	};
	if (e.onUnmount) e.onUnmount(a);
	else {
		let t = e.unmount;
		e.unmount = function() {
			a(), t();
		};
	}
	e.provide(n, r);
} };
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/useBaseQuery.js
function jd(e, t, n) {
	let r = n || Ed(), i = J(() => {
		let e = t;
		typeof e == "function" && (e = e());
		let n = Cd(e);
		typeof n.enabled == "function" && (n.enabled = n.enabled());
		let i = r.defaultQueryOptions(n);
		return i._optimisticResults = r.isRestoring?.value ? "isRestoring" : "optimistic", i;
	}), a = new e(r, i.value), o = i.value.shallow ? /* @__PURE__ */ an(a.getCurrentResult()) : /* @__PURE__ */ rn(a.getCurrentResult()), s = () => {};
	r.isRestoring && Pr(r.isRestoring, (e) => {
		e || (s(), s = a.subscribe((e) => {
			bd(o, e);
		}));
	}, { immediate: !0 });
	let c = () => {
		a.setOptions(i.value), bd(o, a.getCurrentResult());
	};
	Pr(i, c), He(() => {
		s();
	});
	let l = (...e) => (c(), o.refetch(...e)), u = () => new Promise((e, t) => {
		let n = () => {}, r = () => {
			if (i.value.enabled !== !1) {
				a.setOptions(i.value);
				let r = a.getOptimisticResult(i.value);
				r.isStale ? (n(), a.fetchOptimistic(i.value).then(e, (n) => {
					zu(i.value.throwOnError, [n, a.getCurrentQuery()]) ? t(n) : e(a.getCurrentResult());
				})) : (n(), e(r));
			}
		};
		r(), n = Pr(i, r);
	});
	Pr(() => o.error, (e) => {
		if (o.isError && !o.isFetching && zu(i.value.throwOnError, [e, a.getCurrentQuery()])) throw e;
	});
	let d = /* @__PURE__ */ Dn(i.value.shallow ? /* @__PURE__ */ sn(o) : /* @__PURE__ */ on(o));
	for (let e in o) typeof o[e] == "function" && (d[e] = o[e]);
	return d.suspense = u, d.refetch = l, d;
}
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/useQuery.js
function Md(e, t) {
	return jd(ad, e, t);
}
//#endregion
//#region src/lib/widget-portal.js
var Nd = Symbol("crosschq-widget-portal-target");
function Pd() {
	return Dr(Nd, void 0);
}
//#endregion
//#region node_modules/lucide-vue-next/dist/esm/shared/src/utils/hasA11yProp.js
var Fd = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, Id = (e) => e === "", Ld = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), Rd = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), zd = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), Bd = (e) => {
	let t = zd(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, Vd = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": 2,
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
}, Hd = ({ name: e, iconNode: t, absoluteStrokeWidth: n, "absolute-stroke-width": r, strokeWidth: i, "stroke-width": a, size: o = Vd.width, color: s = Vd.stroke, ...c }, { slots: l }) => Hs("svg", {
	...Vd,
	...c,
	width: o,
	height: o,
	stroke: s,
	"stroke-width": Id(n) || Id(r) || n === !0 || r === !0 ? Number(i || a || Vd["stroke-width"]) * 24 / Number(o) : i || a || Vd["stroke-width"],
	class: Ld("lucide", c.class, ...e ? [`lucide-${Rd(Bd(e))}-icon`, `lucide-${Rd(e)}`] : ["lucide-icon"]),
	...!l.default && !Fd(c) && { "aria-hidden": "true" }
}, [...t.map((e) => Hs(...e)), ...l.default ? [l.default()] : []]), Ud = (e, t) => (n, { slots: r, attrs: i }) => Hs(Hd, {
	...i,
	...n,
	iconNode: t,
	name: e
}, r), Wd = Ud("arrow-up", [["path", {
	d: "m5 12 7-7 7 7",
	key: "hav0vg"
}], ["path", {
	d: "M12 19V5",
	key: "x0mq9r"
}]]), Gd = Ud("award", [["path", {
	d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
	key: "1yiouv"
}], ["circle", {
	cx: "12",
	cy: "8",
	r: "6",
	key: "1vp47v"
}]]), Kd = Ud("calendar", [
	["path", {
		d: "M8 2v4",
		key: "1cmpym"
	}],
	["path", {
		d: "M16 2v4",
		key: "4m81vk"
	}],
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "4",
		rx: "2",
		key: "1hopcy"
	}],
	["path", {
		d: "M3 10h18",
		key: "8toen8"
	}]
]), qd = Ud("chart-column", [
	["path", {
		d: "M3 3v16a2 2 0 0 0 2 2h16",
		key: "c24i48"
	}],
	["path", {
		d: "M18 17V9",
		key: "2bz60n"
	}],
	["path", {
		d: "M13 17V5",
		key: "1frdt8"
	}],
	["path", {
		d: "M8 17v-3",
		key: "17ska0"
	}]
]), Jd = Ud("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), Yd = Ud("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), Xd = Ud("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), Zd = Ud("chevron-up", [["path", {
	d: "m18 15-6-6-6 6",
	key: "153udz"
}]]), Qd = Ud("circle-alert", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["line", {
		x1: "12",
		x2: "12",
		y1: "8",
		y2: "12",
		key: "1pkeuh"
	}],
	["line", {
		x1: "12",
		x2: "12.01",
		y1: "16",
		y2: "16",
		key: "4dfq90"
	}]
]), $d = Ud("circle-check-big", [["path", {
	d: "M21.801 10A10 10 0 1 1 17 3.335",
	key: "yps3ct"
}], ["path", {
	d: "m9 11 3 3L22 4",
	key: "1pflzl"
}]]), ef = Ud("circle-check", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), tf = Ud("circle-dot", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "1",
	key: "41hilf"
}]]), nf = Ud("circle-question-mark", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
		key: "1u773s"
	}],
	["path", {
		d: "M12 17h.01",
		key: "p32p05"
	}]
]), rf = Ud("circle-x", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "m15 9-6 6",
		key: "1uzhvr"
	}],
	["path", {
		d: "m9 9 6 6",
		key: "z0biqf"
	}]
]), af = Ud("circle", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}]]), of = Ud("clipboard-check", [
	["rect", {
		width: "8",
		height: "4",
		x: "8",
		y: "2",
		rx: "1",
		ry: "1",
		key: "tgr4d6"
	}],
	["path", {
		d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
		key: "116196"
	}],
	["path", {
		d: "m9 14 2 2 4-4",
		key: "df797q"
	}]
]), sf = Ud("clipboard-list", [
	["rect", {
		width: "8",
		height: "4",
		x: "8",
		y: "2",
		rx: "1",
		ry: "1",
		key: "tgr4d6"
	}],
	["path", {
		d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
		key: "116196"
	}],
	["path", {
		d: "M12 11h4",
		key: "1jrz19"
	}],
	["path", {
		d: "M12 16h4",
		key: "n85exb"
	}],
	["path", {
		d: "M8 11h.01",
		key: "1dfujw"
	}],
	["path", {
		d: "M8 16h.01",
		key: "18s6g9"
	}]
]), cf = Ud("clock", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "M12 6v6l4 2",
	key: "mmk7yg"
}]]), lf = Ud("coffee", [
	["path", {
		d: "M10 2v2",
		key: "7u0qdc"
	}],
	["path", {
		d: "M14 2v2",
		key: "6buw04"
	}],
	["path", {
		d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
		key: "pwadti"
	}],
	["path", {
		d: "M6 2v2",
		key: "colzsn"
	}]
]), uf = Ud("eye", [["path", {
	d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
	key: "1nclc0"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "3",
	key: "1v7zrd"
}]]), df = Ud("file-text", [
	["path", {
		d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		key: "1oefj6"
	}],
	["path", {
		d: "M14 2v5a1 1 0 0 0 1 1h5",
		key: "wfsgrz"
	}],
	["path", {
		d: "M10 9H8",
		key: "b1mrlr"
	}],
	["path", {
		d: "M16 13H8",
		key: "t4e002"
	}],
	["path", {
		d: "M16 17H8",
		key: "z1uh3a"
	}]
]), ff = Ud("fingerprint-pattern", [
	["path", {
		d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4",
		key: "1nerag"
	}],
	["path", {
		d: "M14 13.12c0 2.38 0 6.38-1 8.88",
		key: "o46ks0"
	}],
	["path", {
		d: "M17.29 21.02c.12-.6.43-2.3.5-3.02",
		key: "ptglia"
	}],
	["path", {
		d: "M2 12a10 10 0 0 1 18-6",
		key: "ydlgp0"
	}],
	["path", {
		d: "M2 16h.01",
		key: "1gqxmh"
	}],
	["path", {
		d: "M21.8 16c.2-2 .131-5.354 0-6",
		key: "drycrb"
	}],
	["path", {
		d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2",
		key: "1tidbn"
	}],
	["path", {
		d: "M8.65 22c.21-.66.45-1.32.57-2",
		key: "13wd9y"
	}],
	["path", {
		d: "M9 6.8a6 6 0 0 1 9 5.2v2",
		key: "1fr1j5"
	}]
]), pf = Ud("flag", [["path", {
	d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
	key: "1jaruq"
}]]), mf = Ud("globe", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
		key: "13o1zl"
	}],
	["path", {
		d: "M2 12h20",
		key: "9i4pu4"
	}]
]), hf = Ud("info", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 16v-4",
		key: "1dtifu"
	}],
	["path", {
		d: "M12 8h.01",
		key: "e9boi3"
	}]
]), gf = Ud("lightbulb", [
	["path", {
		d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
		key: "1gvzjb"
	}],
	["path", {
		d: "M9 18h6",
		key: "x1upvd"
	}],
	["path", {
		d: "M10 22h4",
		key: "ceow96"
	}]
]), _f = Ud("loader-circle", [["path", {
	d: "M21 12a9 9 0 1 1-6.219-8.56",
	key: "13zald"
}]]), vf = Ud("message-circle", [["path", {
	d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
	key: "1sd12s"
}]]), yf = Ud("message-square-off", [
	["path", {
		d: "M19 19H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 1.184-1.826",
		key: "1wyg69"
	}],
	["path", {
		d: "m2 2 20 20",
		key: "1ooewy"
	}],
	["path", {
		d: "M8.656 3H20a2 2 0 0 1 2 2v11.344",
		key: "mhl4k6"
	}]
]), bf = Ud("message-square-text", [
	["path", {
		d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		key: "18887p"
	}],
	["path", {
		d: "M7 11h10",
		key: "1twpyw"
	}],
	["path", {
		d: "M7 15h6",
		key: "d9of3u"
	}],
	["path", {
		d: "M7 7h8",
		key: "af5zfr"
	}]
]), xf = Ud("message-square", [["path", {
	d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
	key: "18887p"
}]]), Sf = Ud("minus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}]]), Cf = Ud("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), wf = Ud("shield-alert", [
	["path", {
		d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		key: "oel41y"
	}],
	["path", {
		d: "M12 8v4",
		key: "1got3b"
	}],
	["path", {
		d: "M12 16h.01",
		key: "1drbdi"
	}]
]), Tf = Ud("shield-check", [["path", {
	d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
	key: "oel41y"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), Ef = Ud("star", [["path", {
	d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
	key: "r04s7s"
}]]), Df = Ud("target", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["circle", {
		cx: "12",
		cy: "12",
		r: "6",
		key: "1vlfrh"
	}],
	["circle", {
		cx: "12",
		cy: "12",
		r: "2",
		key: "1c9p78"
	}]
]), Of = Ud("thumbs-down", [["path", {
	d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
	key: "m61m77"
}], ["path", {
	d: "M17 14V2",
	key: "8ymqnk"
}]]), kf = Ud("thumbs-up", [["path", {
	d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
	key: "emmmcr"
}], ["path", {
	d: "M7 10v12",
	key: "1qc93n"
}]]), Af = Ud("trending-up", [["path", {
	d: "M16 7h6v6",
	key: "box55l"
}], ["path", {
	d: "m22 7-8.5 8.5-5-5L2 17",
	key: "1t1m79"
}]]), jf = Ud("triangle-alert", [
	["path", {
		d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
		key: "wmoenq"
	}],
	["path", {
		d: "M12 9v4",
		key: "juzpu7"
	}],
	["path", {
		d: "M12 17h.01",
		key: "p32p05"
	}]
]), Mf = Ud("user", [["path", {
	d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
	key: "975kel"
}], ["circle", {
	cx: "12",
	cy: "7",
	r: "4",
	key: "17ys0d"
}]]), Nf = Ud("users", [
	["path", {
		d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
		key: "1yyitq"
	}],
	["path", {
		d: "M16 3.128a4 4 0 0 1 0 7.744",
		key: "16gr8j"
	}],
	["path", {
		d: "M22 21v-2a4 4 0 0 0-3-3.87",
		key: "kshegd"
	}],
	["circle", {
		cx: "9",
		cy: "7",
		r: "4",
		key: "nufk8"
	}]
]), Pf = Ud("video", [["path", {
	d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
	key: "ftymec"
}], ["rect", {
	x: "2",
	y: "6",
	width: "14",
	height: "12",
	rx: "2",
	key: "158x01"
}]]), Ff = Ud("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]), If = ["fill"], Lf = ["fill", "opacity"], Rf = {
	__name: "AiSparkle",
	props: {
		class: {
			type: null,
			required: !1
		},
		mono: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		return (t, n) => (V(), H("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 20 20",
			class: M(t.$props.class)
		}, [W("path", {
			fill: e.mono ? "currentColor" : "var(--color-ai-sparkle, #00B1FF)",
			d: "M12.7017 6.79384L11.8307 3.55964C11.8074 3.47361 11.6854 3.47361 11.6621 3.55964L10.7911 6.79384C10.266 8.74416 8.74227 10.2676 6.79143 10.7927L3.55671 11.6635C3.47068 11.6867 3.47068 11.8087 3.55671 11.8319L6.79143 12.7027C8.74227 13.2278 10.266 14.7513 10.7911 16.7016L11.6621 19.9358C11.6854 20.0218 11.8074 20.0218 11.8307 19.9358L12.7017 16.7016C13.2269 14.7513 14.7506 13.2278 16.7014 12.7027L19.9361 11.8319C20.0224 11.8087 20.0224 11.6867 19.9361 11.6635L16.7014 10.7927C14.7506 10.2676 13.2269 8.74416 12.7017 6.79384Z"
		}, null, 8, If), W("path", {
			fill: e.mono ? "currentColor" : "var(--color-ai-sparkle-soft, #77D2FA)",
			opacity: e.mono ? .5 : 1,
			d: "M4.7393 1.69749L4.29091 0.0331905C4.27916 -0.0110635 4.21614 -0.0110635 4.20439 0.0331905L3.75625 1.69749C3.48592 2.70111 2.70168 3.48505 1.69788 3.75528L0.033385 4.2034C-0.0111283 4.21532 -0.0111283 4.27813 0.033385 4.29003L1.69788 4.73814C2.70168 5.00837 3.48592 5.79232 3.75625 6.79593L4.20439 8.46023C4.21614 8.50451 4.27916 8.50451 4.29091 8.46023L4.7393 6.79593C5.00938 5.79232 5.79361 5.00837 6.79741 4.73814L8.46217 4.29003C8.50643 4.27813 8.50643 4.21532 8.46217 4.2034L6.79741 3.75528C5.79361 3.48505 5.00938 2.70111 4.7393 1.69749Z"
		}, null, 8, Lf)], 2));
	}
};
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function zf(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = zf(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function Bf() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = zf(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var Vf = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, Hf = (e, t) => ({
	classGroupId: e,
	validator: t
}), Uf = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), Wf = "-", Gf = [], Kf = "arbitrary..", qf = (e) => {
	let t = Xf(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return Yf(e);
			let n = e.split(Wf);
			return Jf(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? Vf(i, t) : t : i || Gf;
			}
			return n[e] || Gf;
		}
	};
}, Jf = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = Jf(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(Wf) : e.slice(t).join(Wf), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, Yf = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? Kf + r : void 0;
})(), Xf = (e) => {
	let { theme: t, classGroups: n } = e;
	return Zf(n, t);
}, Zf = (e, t) => {
	let n = Uf();
	for (let r in e) {
		let i = e[r];
		Qf(i, n, r, t);
	}
	return n;
}, Qf = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		$f(i, t, n, r);
	}
}, $f = (e, t, n, r) => {
	if (typeof e == "string") {
		ep(e, t, n);
		return;
	}
	if (typeof e == "function") {
		tp(e, t, n, r);
		return;
	}
	np(e, t, n, r);
}, ep = (e, t, n) => {
	let r = e === "" ? t : rp(t, e);
	r.classGroupId = n;
}, tp = (e, t, n, r) => {
	if (ip(e)) {
		Qf(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(Hf(n, e));
}, np = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Qf(o, rp(t, a), n, r);
	}
}, rp = (e, t) => {
	let n = e, r = t.split(Wf), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = Uf(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, ip = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, ap = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, op = "!", sp = ":", cp = [], lp = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), up = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === sp) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(op) ? (c = s.slice(0, -1), l = !0) : s.startsWith(op) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return lp(t, l, c, u);
	};
	if (t) {
		let e = t + sp, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : lp(cp, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, dp = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, fp = (e) => ({
	cache: ap(e.cacheSize),
	parseClassName: up(e),
	sortModifiers: dp(e),
	postfixLookupClassGroupIds: pp(e),
	...qf(e)
}), pp = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, mp = /\s+/, hp = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(mp), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + op : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, gp = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = _p(n)) && (i && (i += " "), i += r);
	return i;
}, _p = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = _p(e[r])) && (n && (n += " "), n += t);
	return n;
}, vp = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = fp(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = hp(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(gp(...e));
}, yp = [], bp = (e) => {
	let t = (t) => t[e] || yp;
	return t.isThemeGetter = !0, t;
}, xp = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Sp = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Cp = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, wp = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Tp = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ep = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Dp = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Op = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, kp = (e) => Cp.test(e), Ap = (e) => !!e && !Number.isNaN(Number(e)), jp = (e) => !!e && Number.isInteger(Number(e)), Mp = (e) => e.endsWith("%") && Ap(e.slice(0, -1)), Np = (e) => wp.test(e), Pp = () => !0, Fp = (e) => Tp.test(e) && !Ep.test(e), Ip = () => !1, Lp = (e) => Dp.test(e), Rp = (e) => Op.test(e), zp = (e) => !Hp(e) && !Xp(e), Bp = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Vp = (e) => im(e, cm, Ip), Hp = (e) => xp.test(e), Up = (e) => im(e, lm, Fp), Wp = (e) => im(e, um, Ap), Gp = (e) => im(e, fm, Pp), Kp = (e) => im(e, dm, Ip), qp = (e) => im(e, om, Ip), Jp = (e) => im(e, sm, Rp), Yp = (e) => im(e, pm, Lp), Xp = (e) => Sp.test(e), Zp = (e) => am(e, lm), Qp = (e) => am(e, dm), $p = (e) => am(e, om), em = (e) => am(e, cm), tm = (e) => am(e, sm), nm = (e) => am(e, pm, !0), rm = (e) => am(e, fm, !0), im = (e, t, n) => {
	let r = xp.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, am = (e, t, n = !1) => {
	let r = Sp.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, om = (e) => e === "position" || e === "percentage", sm = (e) => e === "image" || e === "url", cm = (e) => e === "length" || e === "size" || e === "bg-size", lm = (e) => e === "length", um = (e) => e === "number", dm = (e) => e === "family-name", fm = (e) => e === "number" || e === "weight", pm = (e) => e === "shadow", mm = /*#__PURE__*/ vp(() => {
	let e = bp("color"), t = bp("font"), n = bp("text"), r = bp("font-weight"), i = bp("tracking"), a = bp("leading"), o = bp("breakpoint"), s = bp("container"), c = bp("spacing"), l = bp("radius"), u = bp("shadow"), d = bp("inset-shadow"), f = bp("text-shadow"), p = bp("drop-shadow"), m = bp("blur"), h = bp("perspective"), g = bp("aspect"), _ = bp("ease"), v = bp("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		Xp,
		Hp
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		Xp,
		Hp,
		c
	], T = () => [
		kp,
		"full",
		"auto",
		...w()
	], E = () => [
		jp,
		"none",
		"subgrid",
		Xp,
		Hp
	], ee = () => [
		"auto",
		{ span: [
			"full",
			jp,
			Xp,
			Hp
		] },
		jp,
		Xp,
		Hp
	], D = () => [
		jp,
		"auto",
		Xp,
		Hp
	], O = () => [
		"auto",
		"min",
		"max",
		"fr",
		Xp,
		Hp
	], te = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], k = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], ne = () => ["auto", ...w()], re = () => [
		kp,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], ie = () => [
		kp,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], ae = () => [
		kp,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], A = () => [
		e,
		Xp,
		Hp
	], oe = () => [
		...b(),
		$p,
		qp,
		{ position: [Xp, Hp] }
	], se = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ce = () => [
		"auto",
		"cover",
		"contain",
		em,
		Vp,
		{ size: [Xp, Hp] }
	], le = () => [
		Mp,
		Zp,
		Up
	], j = () => [
		"",
		"none",
		"full",
		l,
		Xp,
		Hp
	], ue = () => [
		"",
		Ap,
		Zp,
		Up
	], de = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], fe = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], pe = () => [
		Ap,
		Mp,
		$p,
		qp
	], me = () => [
		"",
		"none",
		m,
		Xp,
		Hp
	], he = () => [
		"none",
		Ap,
		Xp,
		Hp
	], ge = () => [
		"none",
		Ap,
		Xp,
		Hp
	], _e = () => [
		Ap,
		Xp,
		Hp
	], ve = () => [
		kp,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [Np],
			breakpoint: [Np],
			color: [Pp],
			container: [Np],
			"drop-shadow": [Np],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [zp],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [Np],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [Np],
			shadow: [Np],
			spacing: ["px", Ap],
			text: [Np],
			"text-shadow": [Np],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				kp,
				Hp,
				Xp,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				Xp,
				Hp
			] }],
			"container-named": [Bp],
			columns: [{ columns: [
				Ap,
				Hp,
				Xp,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				jp,
				"auto",
				Xp,
				Hp
			] }],
			basis: [{ basis: [
				kp,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				Ap,
				kp,
				"auto",
				"initial",
				"none",
				Hp
			] }],
			grow: [{ grow: [
				"",
				Ap,
				Xp,
				Hp
			] }],
			shrink: [{ shrink: [
				"",
				Ap,
				Xp,
				Hp
			] }],
			order: [{ order: [
				jp,
				"first",
				"last",
				"none",
				Xp,
				Hp
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: ee() }],
			"col-start": [{ "col-start": D() }],
			"col-end": [{ "col-end": D() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: ee() }],
			"row-start": [{ "row-start": D() }],
			"row-end": [{ "row-end": D() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": O() }],
			"auto-rows": [{ "auto-rows": O() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...te(), "normal"] }],
			"justify-items": [{ "justify-items": [...k(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...k()] }],
			"align-content": [{ content: ["normal", ...te()] }],
			"align-items": [{ items: [...k(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...k(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": te() }],
			"place-items": [{ "place-items": [...k(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...k()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: ne() }],
			mx: [{ mx: ne() }],
			my: [{ my: ne() }],
			ms: [{ ms: ne() }],
			me: [{ me: ne() }],
			mbs: [{ mbs: ne() }],
			mbe: [{ mbe: ne() }],
			mt: [{ mt: ne() }],
			mr: [{ mr: ne() }],
			mb: [{ mb: ne() }],
			ml: [{ ml: ne() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: re() }],
			"inline-size": [{ inline: ["auto", ...ie()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...ie()] }],
			"max-inline-size": [{ "max-inline": ["none", ...ie()] }],
			"block-size": [{ block: ["auto", ...ae()] }],
			"min-block-size": [{ "min-block": ["auto", ...ae()] }],
			"max-block-size": [{ "max-block": ["none", ...ae()] }],
			w: [{ w: [
				s,
				"screen",
				...re()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...re()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...re()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...re()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...re()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...re()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Zp,
				Up
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				rm,
				Gp
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				Mp,
				Hp
			] }],
			"font-family": [{ font: [
				Qp,
				Kp,
				t
			] }],
			"font-features": [{ "font-features": [Hp] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				Xp,
				Hp
			] }],
			"line-clamp": [{ "line-clamp": [
				Ap,
				"none",
				Xp,
				Wp
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				Xp,
				Hp
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				Xp,
				Hp
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: A() }],
			"text-color": [{ text: A() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...de(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				Ap,
				"from-font",
				"auto",
				Xp,
				Up
			] }],
			"text-decoration-color": [{ decoration: A() }],
			"underline-offset": [{ "underline-offset": [
				Ap,
				"auto",
				Xp,
				Hp
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				jp,
				Xp,
				Hp
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				Xp,
				Hp
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				Xp,
				Hp
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: oe() }],
			"bg-repeat": [{ bg: se() }],
			"bg-size": [{ bg: ce() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						jp,
						Xp,
						Hp
					],
					radial: [
						"",
						Xp,
						Hp
					],
					conic: [
						jp,
						Xp,
						Hp
					]
				},
				tm,
				Jp
			] }],
			"bg-color": [{ bg: A() }],
			"gradient-from-pos": [{ from: le() }],
			"gradient-via-pos": [{ via: le() }],
			"gradient-to-pos": [{ to: le() }],
			"gradient-from": [{ from: A() }],
			"gradient-via": [{ via: A() }],
			"gradient-to": [{ to: A() }],
			rounded: [{ rounded: j() }],
			"rounded-s": [{ "rounded-s": j() }],
			"rounded-e": [{ "rounded-e": j() }],
			"rounded-t": [{ "rounded-t": j() }],
			"rounded-r": [{ "rounded-r": j() }],
			"rounded-b": [{ "rounded-b": j() }],
			"rounded-l": [{ "rounded-l": j() }],
			"rounded-ss": [{ "rounded-ss": j() }],
			"rounded-se": [{ "rounded-se": j() }],
			"rounded-ee": [{ "rounded-ee": j() }],
			"rounded-es": [{ "rounded-es": j() }],
			"rounded-tl": [{ "rounded-tl": j() }],
			"rounded-tr": [{ "rounded-tr": j() }],
			"rounded-br": [{ "rounded-br": j() }],
			"rounded-bl": [{ "rounded-bl": j() }],
			"border-w": [{ border: ue() }],
			"border-w-x": [{ "border-x": ue() }],
			"border-w-y": [{ "border-y": ue() }],
			"border-w-s": [{ "border-s": ue() }],
			"border-w-e": [{ "border-e": ue() }],
			"border-w-bs": [{ "border-bs": ue() }],
			"border-w-be": [{ "border-be": ue() }],
			"border-w-t": [{ "border-t": ue() }],
			"border-w-r": [{ "border-r": ue() }],
			"border-w-b": [{ "border-b": ue() }],
			"border-w-l": [{ "border-l": ue() }],
			"divide-x": [{ "divide-x": ue() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": ue() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...de(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...de(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: A() }],
			"border-color-x": [{ "border-x": A() }],
			"border-color-y": [{ "border-y": A() }],
			"border-color-s": [{ "border-s": A() }],
			"border-color-e": [{ "border-e": A() }],
			"border-color-bs": [{ "border-bs": A() }],
			"border-color-be": [{ "border-be": A() }],
			"border-color-t": [{ "border-t": A() }],
			"border-color-r": [{ "border-r": A() }],
			"border-color-b": [{ "border-b": A() }],
			"border-color-l": [{ "border-l": A() }],
			"divide-color": [{ divide: A() }],
			"outline-style": [{ outline: [
				...de(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				Ap,
				Xp,
				Hp
			] }],
			"outline-w": [{ outline: [
				"",
				Ap,
				Zp,
				Up
			] }],
			"outline-color": [{ outline: A() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				nm,
				Yp
			] }],
			"shadow-color": [{ shadow: A() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				nm,
				Yp
			] }],
			"inset-shadow-color": [{ "inset-shadow": A() }],
			"ring-w": [{ ring: ue() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: A() }],
			"ring-offset-w": [{ "ring-offset": [Ap, Up] }],
			"ring-offset-color": [{ "ring-offset": A() }],
			"inset-ring-w": [{ "inset-ring": ue() }],
			"inset-ring-color": [{ "inset-ring": A() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				nm,
				Yp
			] }],
			"text-shadow-color": [{ "text-shadow": A() }],
			opacity: [{ opacity: [
				Ap,
				Xp,
				Hp
			] }],
			"mix-blend": [{ "mix-blend": [
				...fe(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": fe() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [Ap] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": pe() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": pe() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": A() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": A() }],
			"mask-image-t-from-pos": [{ "mask-t-from": pe() }],
			"mask-image-t-to-pos": [{ "mask-t-to": pe() }],
			"mask-image-t-from-color": [{ "mask-t-from": A() }],
			"mask-image-t-to-color": [{ "mask-t-to": A() }],
			"mask-image-r-from-pos": [{ "mask-r-from": pe() }],
			"mask-image-r-to-pos": [{ "mask-r-to": pe() }],
			"mask-image-r-from-color": [{ "mask-r-from": A() }],
			"mask-image-r-to-color": [{ "mask-r-to": A() }],
			"mask-image-b-from-pos": [{ "mask-b-from": pe() }],
			"mask-image-b-to-pos": [{ "mask-b-to": pe() }],
			"mask-image-b-from-color": [{ "mask-b-from": A() }],
			"mask-image-b-to-color": [{ "mask-b-to": A() }],
			"mask-image-l-from-pos": [{ "mask-l-from": pe() }],
			"mask-image-l-to-pos": [{ "mask-l-to": pe() }],
			"mask-image-l-from-color": [{ "mask-l-from": A() }],
			"mask-image-l-to-color": [{ "mask-l-to": A() }],
			"mask-image-x-from-pos": [{ "mask-x-from": pe() }],
			"mask-image-x-to-pos": [{ "mask-x-to": pe() }],
			"mask-image-x-from-color": [{ "mask-x-from": A() }],
			"mask-image-x-to-color": [{ "mask-x-to": A() }],
			"mask-image-y-from-pos": [{ "mask-y-from": pe() }],
			"mask-image-y-to-pos": [{ "mask-y-to": pe() }],
			"mask-image-y-from-color": [{ "mask-y-from": A() }],
			"mask-image-y-to-color": [{ "mask-y-to": A() }],
			"mask-image-radial": [{ "mask-radial": [Xp, Hp] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": pe() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": pe() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": A() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": A() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [Ap] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": pe() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": pe() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": A() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": A() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: oe() }],
			"mask-repeat": [{ mask: se() }],
			"mask-size": [{ mask: ce() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				Xp,
				Hp
			] }],
			filter: [{ filter: [
				"",
				"none",
				Xp,
				Hp
			] }],
			blur: [{ blur: me() }],
			brightness: [{ brightness: [
				Ap,
				Xp,
				Hp
			] }],
			contrast: [{ contrast: [
				Ap,
				Xp,
				Hp
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				nm,
				Yp
			] }],
			"drop-shadow-color": [{ "drop-shadow": A() }],
			grayscale: [{ grayscale: [
				"",
				Ap,
				Xp,
				Hp
			] }],
			"hue-rotate": [{ "hue-rotate": [
				Ap,
				Xp,
				Hp
			] }],
			invert: [{ invert: [
				"",
				Ap,
				Xp,
				Hp
			] }],
			saturate: [{ saturate: [
				Ap,
				Xp,
				Hp
			] }],
			sepia: [{ sepia: [
				"",
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				Xp,
				Hp
			] }],
			"backdrop-blur": [{ "backdrop-blur": me() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				Ap,
				Xp,
				Hp
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				Ap,
				Xp,
				Hp
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				Xp,
				Hp
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				Ap,
				"initial",
				Xp,
				Hp
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				Xp,
				Hp
			] }],
			delay: [{ delay: [
				Ap,
				Xp,
				Hp
			] }],
			animate: [{ animate: [
				"none",
				v,
				Xp,
				Hp
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				Xp,
				Hp
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: he() }],
			"rotate-x": [{ "rotate-x": he() }],
			"rotate-y": [{ "rotate-y": he() }],
			"rotate-z": [{ "rotate-z": he() }],
			scale: [{ scale: ge() }],
			"scale-x": [{ "scale-x": ge() }],
			"scale-y": [{ "scale-y": ge() }],
			"scale-z": [{ "scale-z": ge() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: _e() }],
			"skew-x": [{ "skew-x": _e() }],
			"skew-y": [{ "skew-y": _e() }],
			transform: [{ transform: [
				Xp,
				Hp,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: ve() }],
			"translate-x": [{ "translate-x": ve() }],
			"translate-y": [{ "translate-y": ve() }],
			"translate-z": [{ "translate-z": ve() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				jp,
				Xp,
				Hp
			] }],
			accent: [{ accent: A() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: A() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				Xp,
				Hp
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": A() }],
			"scrollbar-track-color": [{ "scrollbar-track": A() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				Xp,
				Hp
			] }],
			fill: [{ fill: ["none", ...A()] }],
			"stroke-w": [{ stroke: [
				Ap,
				Zp,
				Up,
				Wp
			] }],
			stroke: [{ stroke: ["none", ...A()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/lib/utils.js
function hm(...e) {
	return mm(Bf(e));
}
//#endregion
//#region src/components/ui/card/Card.vue
var gm = {
	key: 0,
	class: "absolute top-4 right-4 flex h-5 w-5 items-center justify-center rounded-full bg-primary"
}, _m = {
	__name: "Card",
	props: {
		class: {
			type: null,
			required: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => [
				"default",
				"light",
				"elevated",
				"outline",
				"muted",
				"subtle",
				"ghost",
				"destructive",
				"success",
				"warning",
				"info",
				"selected"
			].includes(e)
		},
		shadow: {
			type: [String, Boolean],
			default: "none"
		},
		bordered: {
			type: Boolean,
			default: void 0
		},
		hoverable: {
			type: Boolean,
			default: !1
		},
		clickable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["click"],
	setup(e, { emit: t }) {
		let n = {
			default: "bg-card",
			light: "bg-card",
			elevated: "bg-card",
			outline: "bg-transparent",
			muted: "bg-muted",
			subtle: "bg-neutral-50",
			ghost: "bg-transparent",
			destructive: "bg-destructive/10",
			success: "bg-success-muted",
			warning: "bg-warning/10",
			info: "bg-info/10",
			selected: "bg-primary/5"
		}, r = {
			default: "border-border",
			light: "border-border-light",
			elevated: "border-border-strong",
			outline: "border-border",
			muted: "border-border",
			subtle: "border-neutral-200",
			ghost: "border-border",
			destructive: "border-destructive/30",
			success: "border-success/30",
			warning: "border-warning/30",
			info: "border-info/30",
			selected: "border-primary"
		}, i = {
			none: "",
			sm: "shadow-sm",
			default: "shadow",
			md: "shadow-md",
			lg: "shadow-lg"
		}, a = ["muted", "ghost"], o = e, s = t, c = J(() => typeof o.shadow == "boolean" ? o.shadow ? "default" : "none" : o.shadow), l = J(() => o.bordered === void 0 ? !a.includes(o.variant) : o.bordered), u = J(() => o.variant === "selected"), d = J(() => {
			let e = [
				"rounded-xl",
				n[o.variant],
				i[c.value] || ""
			];
			return u.value || e.push("text-card-foreground"), l.value && e.push("border", r[o.variant]), u.value && e.push("ring-1 ring-primary"), o.hoverable && e.push("transition-colors", "hover:border-foreground/25"), o.clickable ? (e.push("relative text-left w-full transition-colors cursor-pointer", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"), u.value || e.push("hover:border-foreground/25")) : u.value && e.push("relative"), e.filter(Boolean).join(" ");
		});
		function f(e) {
			o.clickable && s("click", e);
		}
		return (t, n) => (V(), U(ga(e.clickable ? "button" : "div"), {
			type: e.clickable ? "button" : void 0,
			"aria-pressed": e.clickable ? u.value : void 0,
			class: M(F(hm)(d.value, o.class)),
			onClick: f
		}, {
			default: I(() => [z(t.$slots, "default"), u.value ? (V(), H("span", gm, [G(F(Jd), { class: "size-3 text-primary-foreground" })])) : q("", !0)]),
			_: 3
		}, 8, [
			"type",
			"aria-pressed",
			"class"
		]));
	}
}, vm = {
	__name: "CardContent",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (V(), H("div", { class: M(F(hm)("p-4", t.class)) }, [z(e.$slots, "default")], 2));
	}
}, ym = {
	__name: "CardDescription",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (V(), H("p", { class: M(F(hm)("text-sm text-body", t.class)) }, [z(e.$slots, "default")], 2));
	}
}, bm = {
	__name: "CardTitle",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (V(), H("h3", { class: M(F(hm)("font-semibold leading-none tracking-tight truncate", t.class)) }, [z(e.$slots, "default")], 2));
	}
}, xm = {
	__name: "Skeleton",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (V(), H("div", { class: M(F(hm)("animate-pulse rounded-md bg-muted", t.class)) }, null, 2));
	}
}, Sm = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Cm = Bf, wm = (e, t) => (n) => {
	if (t?.variants == null) return Cm(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = Sm(t) || Sm(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return Cm(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
};
//#endregion
//#region node_modules/ohash/dist/shared/ohash.D__AXeF1.mjs
function Tm(e) {
	return typeof e == "string" ? `'${e}'` : new Em().serialize(e);
}
var Em = /*@__PURE__*/ function() {
	class e {
		#e = /* @__PURE__ */ new Map();
		compare(e, t) {
			let n = typeof e, r = typeof t;
			return n === "string" && r === "string" ? e.localeCompare(t) : n === "number" && r === "number" ? e - t : String.prototype.localeCompare.call(this.serialize(e, !0), this.serialize(t, !0));
		}
		serialize(e, t) {
			if (e === null) return "null";
			switch (typeof e) {
				case "string": return t ? e : `'${e}'`;
				case "bigint": return `${e}n`;
				case "object": return this.$object(e);
				case "function": return this.$function(e);
			}
			return String(e);
		}
		serializeObject(e) {
			let t = Object.prototype.toString.call(e);
			if (t !== "[object Object]") return this.serializeBuiltInType(t.length < 10 ? `unknown:${t}` : t.slice(8, -1), e);
			let n = e.constructor, r = n === Object || n === void 0 ? "" : n.name;
			if (r !== "" && globalThis[r] === n) return this.serializeBuiltInType(r, e);
			if (typeof e.toJSON == "function") {
				let t = e.toJSON();
				return r + (typeof t == "object" && t ? this.$object(t) : `(${this.serialize(t)})`);
			}
			return this.serializeObjectEntries(r, Object.entries(e));
		}
		serializeBuiltInType(e, t) {
			let n = this["$" + e];
			if (n) return n.call(this, t);
			if (typeof t?.entries == "function") return this.serializeObjectEntries(e, t.entries());
			throw Error(`Cannot serialize ${e}`);
		}
		serializeObjectEntries(e, t) {
			let n = Array.from(t).sort((e, t) => this.compare(e[0], t[0])), r = `${e}{`;
			for (let e = 0; e < n.length; e++) {
				let [t, i] = n[e];
				r += `${this.serialize(t, !0)}:${this.serialize(i)}`, e < n.length - 1 && (r += ",");
			}
			return r + "}";
		}
		$object(e) {
			let t = this.#e.get(e);
			return t === void 0 && (this.#e.set(e, `#${this.#e.size}`), t = this.serializeObject(e), this.#e.set(e, t)), t;
		}
		$function(e) {
			let t = Function.prototype.toString.call(e);
			return t.slice(-15) === "[native code] }" ? `${e.name || ""}()[native]` : `${e.name}(${e.length})${t.replace(/\s*\n\s*/g, "")}`;
		}
		$Array(e) {
			let t = "[";
			for (let n = 0; n < e.length; n++) t += this.serialize(e[n]), n < e.length - 1 && (t += ",");
			return t + "]";
		}
		$Date(e) {
			try {
				return `Date(${e.toISOString()})`;
			} catch {
				return "Date(null)";
			}
		}
		$ArrayBuffer(e) {
			return `ArrayBuffer[${new Uint8Array(e).join(",")}]`;
		}
		$Set(e) {
			return `Set${this.$Array(Array.from(e).sort((e, t) => this.compare(e, t)))}`;
		}
		$Map(e) {
			return this.serializeObjectEntries("Map", e.entries());
		}
	}
	for (let t of [
		"Error",
		"RegExp",
		"URL"
	]) e.prototype["$" + t] = function(e) {
		return `${t}(${e})`;
	};
	for (let t of [
		"Int8Array",
		"Uint8Array",
		"Uint8ClampedArray",
		"Int16Array",
		"Uint16Array",
		"Int32Array",
		"Uint32Array",
		"Float32Array",
		"Float64Array"
	]) e.prototype["$" + t] = function(e) {
		return `${t}[${e.join(",")}]`;
	};
	for (let t of ["BigInt64Array", "BigUint64Array"]) e.prototype["$" + t] = function(e) {
		return `${t}[${e.join("n,")}${e.length > 0 ? "n" : ""}]`;
	};
	return e;
}();
function Dm(e, t) {
	return e === t || Tm(e) === Tm(t);
}
//#endregion
//#region node_modules/reka-ui/dist/shared/clamp.js
function Om(e, t = -Infinity, n = Infinity) {
	return Math.min(n, Math.max(t, e));
}
//#endregion
//#region node_modules/reka-ui/dist/shared/createContext.js
function km(e, t) {
	let n = typeof e == "string" && !t ? `${e}Context` : t, r = Symbol(n);
	return [(t) => {
		let n = Dr(r, t);
		if (n || n === null) return n;
		throw Error(`Injection \`${r.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(", ")}` : `\`${e}\``}`);
	}, (e) => (Er(r, e), e)];
}
//#endregion
//#region node_modules/reka-ui/dist/shared/getActiveElement.js
function Am() {
	let e = document.activeElement;
	if (e == null) return null;
	for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null;) e = e.shadowRoot.activeElement;
	return e;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/handleAndDispatchCustomEvent.js
function jm(e, t, n) {
	let r = n.originalEvent.target, i = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && r.addEventListener(e, t, { once: !0 }), r.dispatchEvent(i);
}
//#endregion
//#region node_modules/reka-ui/dist/shared/nullish.js
function Mm(e) {
	return e == null;
}
//#endregion
//#region node_modules/@vueuse/shared/dist/index.js
function Nm(e, t) {
	let n = /* @__PURE__ */ vn();
	return jr(() => {
		n.value = e();
	}, {
		...t,
		flush: t?.flush ?? "sync"
	}), /* @__PURE__ */ on(n);
}
function Pm(e, t) {
	return Ve() ? (He(e, t), !0) : !1;
}
function Fm() {
	let e = /* @__PURE__ */ new Set(), t = (t) => {
		e.delete(t);
	};
	return {
		on: (n) => {
			e.add(n);
			let r = () => t(n);
			return Pm(r), { off: r };
		},
		off: t,
		trigger: (...t) => Promise.all(Array.from(e).map((e) => e(...t))),
		clear: () => {
			e.clear();
		}
	};
}
function Im(e) {
	let t = !1, n, r = Be(!0);
	return ((...i) => (t ||= (n = r.run(() => e(...i)), !0), n));
}
var Lm = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var Rm = (e) => e !== void 0, zm = Object.prototype.toString, Bm = (e) => zm.call(e) === "[object Object]", Vm = () => {}, Hm = /* #__PURE__ */ Um();
function Um() {
	var e, t;
	return Lm && !!((e = window) != null && (e = e.navigator) != null && e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window) == null || (t = t.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function Wm(...e) {
	if (e.length !== 1) return /* @__PURE__ */ An(...e);
	let t = e[0];
	return typeof t == "function" ? /* @__PURE__ */ on(En(() => ({
		get: t,
		set: Vm
	}))) : /* @__PURE__ */ P(t);
}
function Gm(e, t) {
	function n(...n) {
		return new Promise((r, i) => {
			Promise.resolve(e(() => t.apply(this, n), {
				fn: t,
				thisArg: this,
				args: n
			})).then(r).catch(i);
		});
	}
	return "cancel" in e && Object.assign(n, {
		cancel: e.cancel,
		flush: e.flush,
		isPending: e.isPending
	}), n;
}
var Km = (e) => e();
function qm(e, t = {}) {
	let n, r, i = Vm, a = Vm, o = /* @__PURE__ */ vn(!1), s = (e) => {
		clearTimeout(e), i(), i = Vm;
	}, c;
	return Object.assign((l) => {
		let u = Sn(e), d = Sn(t.maxWait);
		return n && s(n), u <= 0 || d !== void 0 && d <= 0 ? (r &&= (s(r), void 0), o.value = !1, Promise.resolve(l())) : (o.value = !0, new Promise((e, f) => {
			i = t.rejectOnCancel ? f : e, a = e, c = l, d && !r && (r = setTimeout(() => {
				n && s(n), r = void 0, o.value = !1, e(c());
			}, d)), n = setTimeout(() => {
				r && s(r), r = void 0, o.value = !1, e(l());
			}, u);
		}));
	}, {
		cancel: () => {
			n &&= (s(n), void 0), r &&= (s(r), void 0), o.value = !1, a = Vm;
		},
		flush: () => {
			if (o.value) {
				n &&= (clearTimeout(n), void 0), r &&= (clearTimeout(r), void 0), o.value = !1;
				let e = a;
				i = Vm, a = Vm, e(c());
			}
		},
		isPending: /* @__PURE__ */ sn(o)
	});
}
function Jm(e = Km, t = {}) {
	let { initialState: n = "active" } = t, r = Wm(n === "active");
	function i() {
		r.value = !1;
	}
	function a() {
		r.value = !0;
	}
	return {
		isActive: /* @__PURE__ */ sn(r),
		pause: i,
		resume: a,
		eventFilter: (...t) => {
			r.value && e(...t);
		}
	};
}
function Ym(e) {
	return Array.isArray(e) ? e : [e];
}
function Xm(e) {
	return e || Ss();
}
function Zm(e) {
	if (!Lm) return e;
	let t = 0, n, r, i = () => {
		--t, r && t <= 0 && (r.stop(), n = void 0, r = void 0);
	};
	return ((...a) => (t += 1, r || (r = Be(!0), n = r.run(() => e(...a))), Pm(i), n));
}
function Qm(e) {
	return /* @__PURE__ */ rn(/* @__PURE__ */ _n(e) ? new Proxy({}, {
		get(t, n, r) {
			return F(Reflect.get(e.value, n, r));
		},
		set(t, n, r) {
			return /* @__PURE__ */ _n(e.value[n]) && !/* @__PURE__ */ _n(r) ? e.value[n].value = r : e.value[n] = r, !0;
		},
		deleteProperty(t, n) {
			return Reflect.deleteProperty(e.value, n);
		},
		has(t, n) {
			return Reflect.has(e.value, n);
		},
		ownKeys() {
			return Object.keys(e.value);
		},
		getOwnPropertyDescriptor() {
			return {
				enumerable: !0,
				configurable: !0
			};
		}
	}) : e);
}
function $m(e) {
	return Qm(J(e));
}
function eh(e, ...t) {
	let n = t.flat(), r = n[0];
	return $m(() => Object.fromEntries(typeof r == "function" ? Object.entries(/* @__PURE__ */ Dn(e)).filter(([e, t]) => !r(Sn(t), e)) : Object.entries(/* @__PURE__ */ Dn(e)).filter((e) => !n.includes(e[0]))));
}
function th(e, t = 1e4) {
	return En((n, r) => {
		let i = Sn(e), a, o = () => setTimeout(() => {
			i = Sn(e), r();
		}, Sn(t));
		return Pm(() => {
			clearTimeout(a);
		}), {
			get() {
				return n(), i;
			},
			set(e) {
				i = e, r(), clearTimeout(a), a = o();
			}
		};
	});
}
function nh(e, t = 200, n = {}) {
	return Gm(qm(t, n), e);
}
function rh(e, t, n = {}) {
	let { eventFilter: r = Km, ...i } = n;
	return Pr(e, Gm(r, t), i);
}
function ih(e, t, n = {}) {
	let { eventFilter: r, initialState: i = "active", ...a } = n, { eventFilter: o, pause: s, resume: c, isActive: l } = Jm(r, { initialState: i });
	return {
		stop: rh(e, t, {
			...a,
			eventFilter: o
		}),
		pause: s,
		resume: c,
		isActive: l
	};
}
function ah(e, t) {
	Xm(t) && oa(e, t);
}
function oh(e, t = !0, n) {
	Xm(n) ? ra(e, n) : t ? e() : or(e);
}
function sh(e, t, n = {}) {
	let { immediate: r = !0, immediateCallback: i = !1 } = n, a = /* @__PURE__ */ vn(!1), o;
	function s() {
		o &&= (clearTimeout(o), void 0);
	}
	function c() {
		a.value = !1, s();
	}
	function l(...n) {
		i && e(), s(), a.value = !0, o = setTimeout(() => {
			a.value = !1, o = void 0, e(...n);
		}, Sn(t));
	}
	return r && (a.value = !0, Lm && l()), Pm(c), {
		isPending: /* @__PURE__ */ sn(a),
		start: l,
		stop: c
	};
}
function ch(e, t, n) {
	return Pr(e, t, {
		...n,
		immediate: !0
	});
}
function lh(e, t, n) {
	return Pr(e, t, {
		...n,
		once: !0
	});
}
//#endregion
//#region node_modules/@vueuse/core/dist/index.js
var uh = Lm ? window : void 0;
Lm && window.document, Lm && window.navigator, Lm && window.location;
function dh(e) {
	let t = Sn(e);
	return t?.$el ?? t;
}
function fh(...e) {
	let t = (e, t, n, r) => (e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r)), n = J(() => {
		let t = Ym(Sn(e[0])).filter((e) => e != null);
		return t.every((e) => typeof e != "string") ? t : void 0;
	});
	return ch(() => [
		n.value?.map((e) => dh(e)) ?? [uh].filter((e) => e != null),
		Ym(Sn(n.value ? e[1] : e[0])),
		Ym(F(n.value ? e[2] : e[1])),
		Sn(n.value ? e[3] : e[2])
	], ([e, n, r, i], a, o) => {
		if (!e?.length || !n?.length || !r?.length) return;
		let s = Bm(i) ? { ...i } : i, c = e.flatMap((e) => n.flatMap((n) => r.map((r) => t(e, n, r, s))));
		o(() => {
			c.forEach((e) => e());
		});
	}, { flush: "post" });
}
function ph() {
	let e = /* @__PURE__ */ vn(!1), t = Ss();
	return t && ra(() => {
		e.value = !0;
	}, t), e;
}
/* @__NO_SIDE_EFFECTS__ */
function mh(e) {
	let t = ph();
	return J(() => (t.value, !!e()));
}
function hh(e) {
	return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function gh(...e) {
	let t, n, r = {};
	e.length === 3 ? (t = e[0], n = e[1], r = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], r = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
	let { target: i = uh, eventName: a = "keydown", passive: o = !1, dedupe: s = !1 } = r, c = hh(t);
	return fh(i, a, (e) => {
		e.repeat && Sn(s) || c(e) && n(e);
	}, o);
}
function _h(e) {
	return JSON.parse(JSON.stringify(e));
}
var vh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, yh = "__vueuse_ssr_handlers__", bh = /* #__PURE__ */ xh();
function xh() {
	return yh in vh || (vh[yh] = vh[yh] || {}), vh[yh];
}
function Sh(e, t) {
	return bh[e] || t;
}
function Ch(e) {
	return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
var wh = {
	boolean: {
		read: (e) => e === "true",
		write: (e) => String(e)
	},
	object: {
		read: (e) => JSON.parse(e),
		write: (e) => JSON.stringify(e)
	},
	number: {
		read: (e) => Number.parseFloat(e),
		write: (e) => String(e)
	},
	any: {
		read: (e) => e,
		write: (e) => String(e)
	},
	string: {
		read: (e) => e,
		write: (e) => String(e)
	},
	map: {
		read: (e) => new Map(JSON.parse(e)),
		write: (e) => JSON.stringify(Array.from(e.entries()))
	},
	set: {
		read: (e) => new Set(JSON.parse(e)),
		write: (e) => JSON.stringify(Array.from(e))
	},
	date: {
		read: (e) => new Date(e),
		write: (e) => e.toISOString()
	}
}, Th = "vueuse-storage";
function Eh(e, t, n, r = {}) {
	let { flush: i = "pre", deep: a = !0, listenToStorageChanges: o = !0, writeDefaults: s = !0, mergeDefaults: c = !1, shallow: l, window: u = uh, eventFilter: d, onError: f = (e) => {
		console.error(e);
	}, initOnMounted: p } = r, m = (l ? vn : P)(typeof t == "function" ? t() : t), h = J(() => Sn(e));
	if (!n) try {
		n = Sh("getDefaultStorage", () => uh?.localStorage)();
	} catch (e) {
		f(e);
	}
	if (!n) return m;
	let g = Sn(t), _ = Ch(g), v = r.serializer ?? wh[_], { pause: y, resume: b } = ih(m, (e) => C(e), {
		flush: i,
		deep: a,
		eventFilter: d
	});
	Pr(h, () => T(), { flush: i });
	let x = !1;
	u && o && (n instanceof Storage ? fh(u, "storage", (e) => {
		p && !x || T(e);
	}, { passive: !0 }) : fh(u, Th, (e) => {
		p && !x || E(e);
	})), p ? oh(() => {
		x = !0, T();
	}) : T();
	function S(e, t) {
		if (u) {
			let r = {
				key: h.value,
				oldValue: e,
				newValue: t,
				storageArea: n
			};
			u.dispatchEvent(n instanceof Storage ? new StorageEvent("storage", r) : new CustomEvent(Th, { detail: r }));
		}
	}
	function C(e) {
		try {
			let t = n.getItem(h.value);
			if (e == null) S(t, null), n.removeItem(h.value);
			else {
				let r = v.write(e);
				t !== r && (n.setItem(h.value, r), S(t, r));
			}
		} catch (e) {
			f(e);
		}
	}
	function w(e) {
		let t = e ? e.newValue : n.getItem(h.value);
		if (t == null) return s && g != null && n.setItem(h.value, v.write(g)), g;
		if (!e && c) {
			let e = v.read(t);
			return typeof c == "function" ? c(e, g) : _ === "object" && !Array.isArray(e) ? {
				...g,
				...e
			} : e;
		}
		return typeof t == "string" ? v.read(t) : t;
	}
	function T(e) {
		if (!(e && e.storageArea !== n)) {
			if (e && e.key == null) {
				m.value = g;
				return;
			}
			if (!(e && e.key !== h.value)) {
				y();
				try {
					let t = v.write(m.value);
					(e === void 0 || e?.newValue !== t) && (m.value = w(e));
				} catch (e) {
					f(e);
				} finally {
					e ? or(b) : b();
				}
			}
		}
	}
	function E(e) {
		T(e.detail);
	}
	return m;
}
function Dh(e, t, n = {}) {
	let { window: r = uh, ...i } = n, a, o = /* @__PURE__ */ mh(() => r && "ResizeObserver" in r), s = () => {
		a &&= (a.disconnect(), void 0);
	}, c = Pr(J(() => {
		let t = Sn(e);
		return Array.isArray(t) ? t.map((e) => dh(e)) : [dh(t)];
	}), (e) => {
		if (s(), o.value && r) {
			a = new ResizeObserver(t);
			for (let t of e) t && a.observe(t, i);
		}
	}, {
		immediate: !0,
		flush: "post"
	}), l = () => {
		s(), c();
	};
	return Pm(l), {
		isSupported: o,
		stop: l
	};
}
function Oh(e, t, n = {}) {
	let { window: r = uh } = n;
	return Eh(e, t, r?.localStorage, n);
}
function kh(e, t, n, r = {}) {
	var i, a;
	let { clone: o = !1, passive: s = !1, eventName: c, deep: l = !1, defaultValue: u, shouldEmit: d } = r, f = Ss(), p = n || f?.emit || (f == null || (i = f.$emit) == null ? void 0 : i.bind(f)) || (f == null || (a = f.proxy) == null || (a = a.$emit) == null ? void 0 : a.bind(f?.proxy)), m = c;
	t ||= "modelValue", m ||= `update:${t.toString()}`;
	let h = (e) => o ? typeof o == "function" ? o(e) : _h(e) : e, g = () => Rm(e[t]) ? h(e[t]) : u, _ = (e) => {
		d ? d(e) && p(m, e) : p(m, e);
	};
	if (s) {
		let n = /* @__PURE__ */ P(g()), r = !1;
		return Pr(() => e[t], (e) => {
			r || (r = !0, n.value = h(e), or(() => r = !1));
		}), Pr(n, (n) => {
			!r && (n !== e[t] || l) && _(n);
		}, { deep: l }), n;
	}
	return J({
		get() {
			return g();
		},
		set(e) {
			_(e);
		}
	});
}
//#endregion
//#region node_modules/reka-ui/dist/shared/renderSlotFragments.js
function Ah(e) {
	return e ? e.flatMap((e) => e.type === B ? Ah(e.children) : [e]) : [];
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useArrowNavigation.js
var jh = ["INPUT", "TEXTAREA"];
function Mh(e, t, n, r = {}) {
	if (!t || r.enableIgnoredElement && jh.includes(t.nodeName)) return null;
	let { arrowKeyOptions: i = "both", attributeName: a = "[data-reka-collection-item]", itemsArray: o = [], loop: s = !0, dir: c = "ltr", preventScroll: l = !0, focus: u = !1 } = r, [d, f, p, m, h, g] = [
		e.key === "ArrowRight",
		e.key === "ArrowLeft",
		e.key === "ArrowUp",
		e.key === "ArrowDown",
		e.key === "Home",
		e.key === "End"
	], _ = p || m, v = d || f;
	if (!h && !g && (!_ && !v || i === "vertical" && v || i === "horizontal" && _)) return null;
	let y = n ? Array.from(n.querySelectorAll(a)) : o;
	if (!y.length) return null;
	l && e.preventDefault();
	let b = null;
	return v || _ ? b = Nh(y, t, {
		goForward: _ ? m : c === "ltr" ? d : f,
		loop: s
	}) : h ? b = y.at(0) || null : g && (b = y.at(-1) || null), u && b?.focus(), b;
}
function Nh(e, t, n, r = e.includes(t) ? e.length : e.length + 1) {
	if (--r === 0) return null;
	let i = e.indexOf(t), a;
	if (a = i === -1 ? n.goForward ? 0 : e.length - 1 : n.goForward ? i + 1 : i - 1, !n.loop && (a < 0 || a >= e.length)) return null;
	let o = e[(a + e.length) % e.length];
	return o ? o.hasAttribute("disabled") && o.getAttribute("disabled") !== "false" ? Nh(e, o, n, r) : o : null;
}
//#endregion
//#region node_modules/reka-ui/dist/ConfigProvider/ConfigProvider.js
var [Ph, Fh] = /*#__PURE__*/ km("ConfigProvider");
//#endregion
//#region node_modules/defu/dist/defu.mjs
function Ih(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function Lh(e, t, n = ".", r) {
	if (!Ih(t)) return Lh(e, {}, n, r);
	let i = { ...t };
	for (let t of Object.keys(e)) {
		if (t === "__proto__" || t === "constructor") continue;
		let a = e[t];
		a != null && (r && r(i, t, a, n) || (i[t] = Array.isArray(a) && Array.isArray(i[t]) ? [...a, ...i[t]] : Ih(a) && Ih(i[t]) ? Lh(a, i[t], (n ? `${n}.` : "") + t.toString(), r) : a));
	}
	return i;
}
function Rh(e) {
	return (...t) => t.reduce((t, n) => Lh(t, n, "", e), {});
}
var zh = Rh(), Bh = Zm(() => {
	let e = /* @__PURE__ */ P(/* @__PURE__ */ new Map()), t = /* @__PURE__ */ P(), n = J(() => {
		for (let t of e.value.values()) if (t) return !0;
		return !1;
	}), r = Ph({ scrollBody: /* @__PURE__ */ P(!0) }), i = null, a = () => {
		document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.documentElement.style.removeProperty("--scrollbar-width"), document.body.style.overflow = t.value ?? "", Hm && i?.(), t.value = void 0;
	};
	return Pr(n, (e, o) => {
		if (!Lm) return;
		if (!e) {
			o && a();
			return;
		}
		t.value === void 0 && (t.value = document.body.style.overflow);
		let s = window.innerWidth - document.documentElement.clientWidth, c = {
			padding: s,
			margin: 0
		}, l = r.scrollBody?.value ? typeof r.scrollBody.value == "object" ? zh({
			padding: r.scrollBody.value.padding === !0 ? s : r.scrollBody.value.padding,
			margin: r.scrollBody.value.margin === !0 ? s : r.scrollBody.value.margin
		}, c) : c : {
			padding: 0,
			margin: 0
		};
		s > 0 && (document.body.style.paddingRight = typeof l.padding == "number" ? `${l.padding}px` : String(l.padding), document.body.style.marginRight = typeof l.margin == "number" ? `${l.margin}px` : String(l.margin), document.documentElement.style.setProperty("--scrollbar-width", `${s}px`), document.body.style.overflow = "hidden"), Hm && (i = fh(document, "touchmove", (e) => Uh(e), { passive: !1 })), or(() => {
			n.value && (document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden");
		});
	}, {
		immediate: !0,
		flush: "sync"
	}), e;
});
function Vh(e) {
	let t = Math.random().toString(36).substring(2, 7), n = Bh();
	n.value.set(t, e ?? !1);
	let r = J({
		get: () => n.value.get(t) ?? !1,
		set: (e) => n.value.set(t, e)
	});
	return ah(() => {
		n.value.delete(t);
	}), r;
}
function Hh(e) {
	let t = window.getComputedStyle(e);
	if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight) return !0;
	{
		let t = e.parentNode;
		return !(t instanceof Element) || t.tagName === "BODY" ? !1 : Hh(t);
	}
}
function Uh(e) {
	let t = e || window.event, n = t.target;
	return n instanceof Element && Hh(n) ? !1 : t.touches.length > 1 || (t.preventDefault && t.cancelable && t.preventDefault(), !1);
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useDirection.js
function Wh(e) {
	let t = Ph({ dir: /* @__PURE__ */ P("ltr") });
	return J(() => e?.value || t.dir?.value || "ltr");
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useEmitAsProps.js
function Gh(e) {
	let t = Ss(), n = t?.type.emits, r = {};
	return n?.length || console.warn(`No emitted event found. Please check component: ${t?.type.__name}`), n?.forEach((t) => {
		r[pe(j(t))] = (...n) => e(t, ...n);
	}), r;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useFocusGuards.js
var Kh = 0;
function qh() {
	jr((e) => {
		if (!Lm) return;
		let t = document.querySelectorAll("[data-reka-focus-guard]");
		document.body.insertAdjacentElement("afterbegin", t[0] ?? Jh()), document.body.insertAdjacentElement("beforeend", t[1] ?? Jh()), Kh++, e(() => {
			Kh === 1 && document.querySelectorAll("[data-reka-focus-guard]").forEach((e) => e.remove()), Kh--;
		});
	});
}
function Jh() {
	let e = document.createElement("span");
	return e.setAttribute("data-reka-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useFormControl.js
function Yh(e) {
	return J(() => !Sn(e) || !!dh(e)?.closest("form"));
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useForwardExpose.js
function Xh() {
	let e = Ss(), t = /* @__PURE__ */ P(), n = J(() => r());
	aa(() => {
		n.value !== r() && xn(t);
	});
	function r() {
		return t.value && "$el" in t.value && ["#text", "#comment"].includes(t.value.$el.nodeName) ? t.value.$el.nextElementSibling : dh(t);
	}
	let i = Object.assign({}, e.exposed), a = {};
	for (let t in e.props) Object.defineProperty(a, t, {
		enumerable: !0,
		configurable: !0,
		get: () => e.props[t]
	});
	if (Object.keys(i).length > 0) for (let e in i) Object.defineProperty(a, e, {
		enumerable: !0,
		configurable: !0,
		get: () => i[e]
	});
	Object.defineProperty(a, "$el", {
		enumerable: !0,
		configurable: !0,
		get: () => e.vnode.el
	}), e.exposed = a;
	function o(n) {
		if (t.value = n, n && (Object.defineProperty(a, "$el", {
			enumerable: !0,
			configurable: !0,
			get: () => n instanceof Element ? n : n.$el
		}), !(n instanceof Element) && !Object.hasOwn(n, "$el"))) {
			let t = n.$.exposed, r = Object.assign({}, a);
			for (let e in t) Object.defineProperty(r, e, {
				enumerable: !0,
				configurable: !0,
				get: () => t[e]
			});
			e.exposed = r;
		}
	}
	return {
		forwardRef: o,
		currentRef: t,
		currentElement: n
	};
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useForwardProps.js
function Zh(e) {
	let t = Ss(), n = Object.keys(t?.type.props ?? {}).reduce((e, n) => {
		let r = (t?.type.props[n]).default;
		return r !== void 0 && (e[n] = r), e;
	}, {}), r = /* @__PURE__ */ An(e);
	return J(() => {
		let e = {}, i = t?.vnode.props ?? {};
		return Object.keys(i).forEach((t) => {
			e[j(t)] = i[t];
		}), Object.keys({
			...n,
			...e
		}).reduce((e, t) => (r.value[t] !== void 0 && (e[t] = r.value[t]), e), {});
	});
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useForwardPropsEmits.js
function Qh(e, t) {
	let n = Zh(e), r = t ? Gh(t) : {};
	return J(() => ({
		...n.value,
		...r
	}));
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useGraceArea.js
function $h(e, t) {
	let n = th(!1, 300);
	Pm(() => {
		n.value = !1;
	});
	let r = /* @__PURE__ */ P(null), i = Fm();
	function a() {
		r.value = null, n.value = !1;
	}
	function o(e, t) {
		if (!t) return;
		let i = e.currentTarget, a = {
			x: e.clientX,
			y: e.clientY
		}, o = tg(a, eg(a, i.getBoundingClientRect()), 1), s = ng(t.getBoundingClientRect()), c = ig([...o, ...s]);
		r.value = c, n.value = !0;
	}
	return jr((n) => {
		if (e.value && t.value) {
			let r = (e) => o(e, t.value), i = (t) => o(t, e.value);
			e.value.addEventListener("pointerleave", r), t.value.addEventListener("pointerleave", i), n(() => {
				e.value?.removeEventListener("pointerleave", r), t.value?.removeEventListener("pointerleave", i);
			});
		}
	}), jr((n) => {
		if (r.value) {
			let o = (n) => {
				if (!r.value || !(n.target instanceof Element)) return;
				let o = n.target, s = {
					x: n.clientX,
					y: n.clientY
				}, c = e.value?.contains(o) || t.value?.contains(o), l = !rg(s, r.value), u = !!o.closest("[data-grace-area-trigger]");
				c ? a() : (l || u) && (a(), i.trigger());
			};
			e.value?.ownerDocument.addEventListener("pointermove", o), n(() => e.value?.ownerDocument.removeEventListener("pointermove", o));
		}
	}), {
		isPointerInTransit: n,
		onPointerExit: i.on
	};
}
function eg(e, t) {
	let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
	switch (Math.min(n, r, i, a)) {
		case a: return "left";
		case i: return "right";
		case n: return "top";
		case r: return "bottom";
		default: throw Error("unreachable");
	}
}
function tg(e, t, n = 5) {
	let r = [];
	switch (t) {
		case "top":
			r.push({
				x: e.x - n,
				y: e.y + n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "bottom":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y - n
			});
			break;
		case "left":
			r.push({
				x: e.x + n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "right": r.push({
			x: e.x - n,
			y: e.y - n
		}, {
			x: e.x - n,
			y: e.y + n
		});
	}
	return r;
}
function ng(e) {
	let { top: t, right: n, bottom: r, left: i } = e;
	return [
		{
			x: i,
			y: t
		},
		{
			x: n,
			y: t
		},
		{
			x: n,
			y: r
		},
		{
			x: i,
			y: r
		}
	];
}
function rg(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e].x, s = t[e].y, c = t[a].x, l = t[a].y;
		s > r != l > r && n < (c - o) * (r - s) / (l - s) + o && (i = !i);
	}
	return i;
}
function ig(e) {
	let t = e.slice();
	return t.sort((e, t) => e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), ag(t);
}
function ag(e) {
	if (e.length <= 1) return e.slice();
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (; t.length >= 2;) {
			let e = t.at(-1), n = t[t.length - 2];
			if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
			else break;
		}
		t.push(r);
	}
	t.pop();
	let n = [];
	for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		for (; n.length >= 2;) {
			let e = n.at(-1), t = n[n.length - 2];
			if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
			else break;
		}
		n.push(r);
	}
	return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
//#endregion
//#region node_modules/aria-hidden/dist/es2015/index.js
var og = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, sg = /* @__PURE__ */ new WeakMap(), cg = /* @__PURE__ */ new WeakMap(), lg = {}, ug = 0, dg = function(e) {
	return e && (e.host || dg(e.parentNode));
}, fg = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = dg(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, pg = function(e, t, n, r) {
	var i = fg(t, Array.isArray(e) ? e : [e]);
	lg[n] || (lg[n] = /* @__PURE__ */ new WeakMap());
	var a = lg[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (sg.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				sg.set(e, c), a.set(e, l), o.push(e), c === 1 && i && cg.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), ug++, function() {
		o.forEach(function(e) {
			var t = sg.get(e) - 1, i = a.get(e) - 1;
			sg.set(e, t), a.set(e, i), t || (cg.has(e) || e.removeAttribute(r), cg.delete(e)), i || e.removeAttribute(n);
		}), ug--, ug || (sg = /* @__PURE__ */ new WeakMap(), sg = /* @__PURE__ */ new WeakMap(), cg = /* @__PURE__ */ new WeakMap(), lg = {});
	};
}, mg = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || og(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), pg(r, i, n, "aria-hidden")) : function() {
		return null;
	};
};
//#endregion
//#region node_modules/reka-ui/dist/shared/useHideOthers.js
function hg(e) {
	let t;
	Pr(() => dh(e), (e) => {
		let n = !1;
		try {
			n = !!e?.closest("[popover]:not(:popover-open)");
		} catch {}
		e && !n ? t = mg(e) : t && t();
	}), sa(() => {
		t && t();
	});
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useId.js
var gg = 0;
function _g(e, t = "reka") {
	if (e) return e;
	let n, r = Ph({ useId: void 0 });
	return n = r.useId ? r.useId() : "useId" in cu ? di?.() : `${++gg}`, t ? `${t}-${n}` : n;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useSize.js
function vg(e) {
	let t = /* @__PURE__ */ P(), n = J(() => t.value?.width ?? 0), r = J(() => t.value?.height ?? 0);
	return ra(() => {
		let n = dh(e);
		if (n) {
			t.value = {
				width: n.offsetWidth,
				height: n.offsetHeight
			};
			let e = new ResizeObserver((e) => {
				if (!Array.isArray(e) || !e.length) return;
				let r = e[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = n.offsetWidth, a = n.offsetHeight;
				t.value = {
					width: i,
					height: a
				};
			});
			return e.observe(n, { box: "border-box" }), () => e.unobserve(n);
		}
		t.value = void 0;
	}), {
		width: n,
		height: r
	};
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useStateMachine.js
function yg(e, t) {
	let n = /* @__PURE__ */ P(e);
	function r(e) {
		return t[n.value][e] ?? n.value;
	}
	return {
		state: n,
		dispatch: (e) => {
			n.value = r(e);
		}
	};
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useTypeahead.js
function bg(e) {
	let t = th("", 1e3);
	return {
		search: t,
		handleTypeaheadSearch: (n, r) => {
			if (t.value += n, e) e(n);
			else {
				let e = Am(), n = r.map((e) => ({
					...e,
					textValue: e.value?.textValue ?? e.ref.textContent?.trim() ?? ""
				})), i = n.find((t) => t.ref === e), a = Sg(n.map((e) => e.textValue), t.value, i?.textValue), o = n.find((e) => e.textValue === a);
				return o && o.ref.focus(), o?.ref;
			}
		},
		resetTypeahead: () => {
			t.value = "";
		}
	};
}
function xg(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
function Sg(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = xg(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
//#endregion
//#region node_modules/reka-ui/dist/Presence/usePresence.js
function Cg(e, t) {
	let n = /* @__PURE__ */ P({}), r = /* @__PURE__ */ P("none"), i = /* @__PURE__ */ P(e), a = e.value ? "mounted" : "unmounted", o, s = t.value?.ownerDocument.defaultView ?? uh, { state: c, dispatch: l } = yg(a, {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	}), u = (e) => {
		if (Lm) {
			let n = new CustomEvent(e, {
				bubbles: !1,
				cancelable: !1
			});
			t.value?.dispatchEvent(n);
		}
	};
	Pr(e, async (e, i) => {
		let a = i !== e;
		if (await or(), a) {
			let a = r.value, o = wg(t.value);
			e ? (l("MOUNT"), u("enter"), o === "none" && u("after-enter")) : o === "none" || o === "undefined" || n.value?.display === "none" ? (l("UNMOUNT"), u("leave"), u("after-leave")) : i && a !== o ? (l("ANIMATION_OUT"), u("leave")) : (l("UNMOUNT"), u("after-leave"));
		}
	}, { immediate: !0 });
	let d = (e) => {
		let n = wg(t.value), r = n.includes(CSS.escape(e.animationName)), a = c.value === "mounted" ? "enter" : "leave";
		if (e.target === t.value && r && (u(`after-${a}`), l("ANIMATION_END"), !i.value)) {
			let e = t.value.style.animationFillMode;
			t.value.style.animationFillMode = "forwards", o = s?.setTimeout(() => {
				t.value?.style.animationFillMode === "forwards" && (t.value.style.animationFillMode = e);
			});
		}
		e.target === t.value && n === "none" && l("ANIMATION_END");
	}, f = (e) => {
		e.target === t.value && (r.value = wg(t.value));
	}, p = Pr(t, (e, t) => {
		e ? (n.value = getComputedStyle(e), e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d)) : (l("ANIMATION_END"), o !== void 0 && s?.clearTimeout(o), t?.removeEventListener("animationstart", f), t?.removeEventListener("animationcancel", d), t?.removeEventListener("animationend", d));
	}, { immediate: !0 }), m = Pr(c, () => {
		let e = wg(t.value);
		r.value = c.value === "mounted" ? e : "none";
	});
	return sa(() => {
		p(), m();
	}), { isPresent: J(() => ["mounted", "unmountSuspended"].includes(c.value)) };
}
function wg(e) {
	return e && getComputedStyle(e).animationName || "none";
}
//#endregion
//#region node_modules/reka-ui/dist/Presence/Presence.js
var Tg = /*#__PURE__*/ L({
	name: "Presence",
	props: {
		present: {
			type: Boolean,
			required: !0
		},
		forceMount: { type: Boolean }
	},
	slots: {},
	setup(e, { slots: t, expose: n }) {
		let { present: r, forceMount: i } = /* @__PURE__ */ Dn(e), a = /* @__PURE__ */ P(), { isPresent: o } = Cg(r, a);
		n({ present: o });
		let s = t.default({ present: o.value });
		s = Ah(s || []);
		let c = Ss();
		if (s && s?.length > 1) {
			let e = c?.parent?.type.name ? `<${c.parent.type.name} />` : "component";
			throw Error([
				`Detected an invalid children for \`${e}\` for  \`Presence\` component.`,
				"",
				"Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
				"You can apply a few solutions:",
				["Provide a single child element so that `presence` directive attach correctly.", "Ensure the first child is an actual element instead of a raw text node or comment node."].map((e) => `  - ${e}`).join("\n")
			].join("\n"));
		}
		return () => i.value || r.value || o.value ? Hs(t.default({ present: o.value })[0], { ref: (e) => {
			let t = dh(e);
			return t?.hasAttribute === void 0 || (t?.hasAttribute("data-reka-popper-content-wrapper") ? a.value = t.firstElementChild : a.value = t), t;
		} }) : null;
	}
}), Eg = /*#__PURE__*/ L({
	name: "PrimitiveSlot",
	inheritAttrs: !1,
	setup(e, { attrs: t, slots: n }) {
		return () => {
			if (!n.default) return null;
			let e = Ah(n.default()), r = e.findIndex((e) => e.type !== Xo);
			if (r === -1) return e;
			let i = e[r];
			delete i.props?.ref;
			let a = i.props ? gs(t, i.props) : t, o = ds({
				...i,
				props: {}
			}, a);
			return e.length === 1 ? o : (e[r] = o, e);
		};
	}
}), Dg = [
	"area",
	"img",
	"input"
], Og = /*#__PURE__*/ L({
	name: "Primitive",
	inheritAttrs: !1,
	props: {
		asChild: {
			type: Boolean,
			default: !1
		},
		as: {
			type: [String, Object],
			default: "div"
		}
	},
	setup(e, { attrs: t, slots: n }) {
		let r = e.asChild ? "template" : e.as;
		return typeof r == "string" && Dg.includes(r) ? () => Hs(r, t) : r === "template" ? () => Hs(Eg, t, { default: n.default }) : () => Hs(e.as, t, { default: n.default });
	}
});
//#endregion
//#region node_modules/reka-ui/dist/Primitive/usePrimitiveElement.js
function kg() {
	let e = /* @__PURE__ */ P();
	return {
		primitiveElement: e,
		currentElement: J(() => ["#text", "#comment"].includes(e.value?.$el.nodeName) ? e.value?.$el.nextElementSibling : dh(e))
	};
}
//#endregion
//#region node_modules/reka-ui/dist/Collapsible/CollapsibleRoot.js
var [Ag, jg] = /*#__PURE__*/ km("CollapsibleRoot"), Mg = /* @__PURE__ */ L({
	__name: "CollapsibleRoot",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1,
			default: !1
		},
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = kh(r, "open", n, {
			defaultValue: r.defaultOpen,
			passive: r.open === void 0
		}), { disabled: a, unmountOnHide: o } = /* @__PURE__ */ Dn(r);
		return jg({
			contentId: "",
			disabled: a,
			open: i,
			unmountOnHide: o,
			onOpenToggle: () => {
				a.value || (i.value = !i.value);
			}
		}), t({ open: i }), Xh(), (e, t) => (V(), U(F(Og), {
			as: e.as,
			"as-child": r.asChild,
			"data-state": F(i) ? "open" : "closed",
			"data-disabled": F(a) ? "" : void 0
		}, {
			default: I(() => [z(e.$slots, "default", { open: F(i) })]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"data-state",
			"data-disabled"
		]));
	}
}), Ng = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "CollapsibleContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["contentFound"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Ag();
		i.contentId ||= _g(void 0, "reka-collapsible-content");
		let a = /* @__PURE__ */ P(), { forwardRef: o, currentElement: s } = Xh(), c = /* @__PURE__ */ P(0), l = /* @__PURE__ */ P(0), u = J(() => i.open.value), d = /* @__PURE__ */ P(u.value), f = /* @__PURE__ */ P();
		Pr(() => [u.value, a.value?.present], async () => {
			await or();
			let e = s.value;
			if (!e) return;
			f.value = f.value || {
				transitionDuration: e.style.transitionDuration,
				animationName: e.style.animationName
			}, e.style.transitionDuration = "0s", e.style.animationName = "none";
			let t = e.getBoundingClientRect();
			l.value = t.height, c.value = t.width, d.value || (e.style.transitionDuration = f.value.transitionDuration, e.style.animationName = f.value.animationName);
		}, { immediate: !0 });
		let p = J(() => d.value && i.open.value);
		return ra(() => {
			requestAnimationFrame(() => {
				d.value = !1;
			});
		}), fh(s, "beforematch", (e) => {
			requestAnimationFrame(() => {
				i.onOpenToggle(), r("contentFound");
			});
		}), (e, t) => (V(), U(F(Tg), {
			ref_key: "presentRef",
			ref: a,
			present: e.forceMount || F(i).open.value,
			"force-mount": !0
		}, {
			default: I(({ present: t }) => [G(F(Og), gs(e.$attrs, {
				id: F(i).contentId,
				ref: F(o),
				"as-child": n.asChild,
				as: e.as,
				hidden: t ? void 0 : F(i).unmountOnHide.value ? "" : "until-found",
				"data-state": p.value ? void 0 : F(i).open.value ? "open" : "closed",
				"data-disabled": F(i).disabled?.value ? "" : void 0,
				style: {
					"--reka-collapsible-content-height": `${l.value}px`,
					"--reka-collapsible-content-width": `${c.value}px`
				}
			}), {
				default: I(() => [!F(i).unmountOnHide.value || t ? z(e.$slots, "default", { key: 0 }) : q("v-if", !0)]),
				_: 2
			}, 1040, [
				"id",
				"as-child",
				"as",
				"hidden",
				"data-state",
				"data-disabled",
				"style"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), Pg = /* @__PURE__ */ L({
	__name: "CollapsibleTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e;
		Xh();
		let n = Ag();
		return (e, r) => (V(), U(F(Og), {
			type: e.as === "button" ? "button" : void 0,
			as: e.as,
			"as-child": t.asChild,
			"aria-controls": F(n).contentId,
			"aria-expanded": F(n).open.value,
			"data-state": F(n).open.value ? "open" : "closed",
			"data-disabled": F(n).disabled?.value ? "" : void 0,
			disabled: F(n).disabled?.value,
			onClick: F(n).onOpenToggle
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"type",
			"as",
			"as-child",
			"aria-controls",
			"aria-expanded",
			"data-state",
			"data-disabled",
			"disabled",
			"onClick"
		]));
	}
}), [Fg, Ig] = /*#__PURE__*/ km("DialogRoot"), Lg = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "DialogRoot",
	props: {
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		defaultOpen: {
			type: Boolean,
			required: !1,
			default: !1
		},
		modal: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = kh(n, "open", t, {
			defaultValue: n.defaultOpen,
			passive: n.open === void 0
		}), i = /* @__PURE__ */ P(), a = /* @__PURE__ */ P(), { modal: o } = /* @__PURE__ */ Dn(n);
		return Ig({
			open: r,
			modal: o,
			openModal: () => {
				r.value = !0;
			},
			onOpenChange: (e) => {
				r.value = e;
			},
			onOpenToggle: () => {
				r.value = !r.value;
			},
			contentId: "",
			titleId: "",
			descriptionId: "",
			triggerElement: i,
			contentElement: a
		}), (e, t) => z(e.$slots, "default", {
			open: F(r),
			close: () => r.value = !1
		});
	}
}), Rg = /* @__PURE__ */ L({
	__name: "DialogClose",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e;
		Xh();
		let n = Fg();
		return (e, r) => (V(), U(F(Og), gs(t, {
			type: e.as === "button" ? "button" : void 0,
			onClick: r[0] ||= (e) => F(n).onOpenChange(!1)
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["type"]));
	}
}), zg = "dismissableLayer.pointerDownOutside", Bg = "dismissableLayer.focusOutside";
function Vg(e, t) {
	if (!(t instanceof Element)) return !1;
	let n = t.closest("[data-dismissable-layer]"), r = e.dataset.dismissableLayer === "" ? e : e.querySelector("[data-dismissable-layer]"), i = Array.from(e.ownerDocument.querySelectorAll("[data-dismissable-layer]"));
	return !!(n && (r === n || i.indexOf(r) < i.indexOf(n)));
}
function Hg(e, t, n = !0) {
	let r = t?.value?.ownerDocument ?? globalThis?.document, i = /* @__PURE__ */ P(!1), a = /* @__PURE__ */ P(() => {});
	return jr((o) => {
		if (!Lm || !Sn(n)) return;
		let s = async (n) => {
			let o = n.target;
			if (!(!t?.value || !o)) {
				if (Vg(t.value, o)) {
					i.value = !1;
					return;
				}
				if (n.target && !i.value) {
					let t = { originalEvent: n };
					function i() {
						jm(zg, e, t);
					}
					n.pointerType === "touch" ? (r.removeEventListener("click", a.value), a.value = i, r.addEventListener("click", a.value, { once: !0 })) : i();
				} else r.removeEventListener("click", a.value);
				i.value = !1;
			}
		}, c = window.setTimeout(() => {
			r.addEventListener("pointerdown", s);
		}, 0);
		o(() => {
			window.clearTimeout(c), r.removeEventListener("pointerdown", s), r.removeEventListener("click", a.value);
		});
	}), { onPointerDownCapture: () => {
		Sn(n) && (i.value = !0);
	} };
}
function Ug(e, t, n = !0) {
	let r = t?.value?.ownerDocument ?? globalThis?.document, i = /* @__PURE__ */ P(!1);
	return jr((a) => {
		if (!Lm || !Sn(n)) return;
		let o = async (n) => {
			if (!t?.value) return;
			await or(), await or();
			let r = n.target;
			!t.value || !r || Vg(t.value, r) || n.target && !i.value && jm(Bg, e, { originalEvent: n });
		};
		r.addEventListener("focusin", o), a(() => r.removeEventListener("focusin", o));
	}), {
		onFocusCapture: () => {
			Sn(n) && (i.value = !0);
		},
		onBlurCapture: () => {
			Sn(n) && (i.value = !1);
		}
	};
}
//#endregion
//#region node_modules/reka-ui/dist/DismissableLayer/DismissableLayer.js
var Wg = /*#__PURE__*/ rn({
	layersRoot: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	originalBodyPointerEvents: void 0,
	branches: /* @__PURE__ */ new Set()
}), Gg = /* @__PURE__ */ L({
	__name: "DismissableLayer",
	props: {
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"dismiss"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Xh(), o = J(() => a.value?.ownerDocument ?? globalThis.document), s = J(() => Wg.layersRoot), c = J(() => a.value ? Array.from(s.value).indexOf(a.value) : -1), l = J(() => Wg.layersWithOutsidePointerEventsDisabled.size > 0), u = J(() => {
			let e = Array.from(s.value), [t] = [...Wg.layersWithOutsidePointerEventsDisabled].slice(-1), n = e.indexOf(t);
			return c.value >= n;
		}), d = Hg(async (e) => {
			let t = [...Wg.branches].some((t) => t?.contains(e.target));
			!u.value || t || (r("pointerDownOutside", e), r("interactOutside", e), await or(), e.defaultPrevented || r("dismiss"));
		}, a), f = Ug((e) => {
			[...Wg.branches].some((t) => t?.contains(e.target)) || (r("focusOutside", e), r("interactOutside", e), e.defaultPrevented || r("dismiss"));
		}, a);
		return gh("Escape", (e) => {
			c.value === s.value.size - 1 && (r("escapeKeyDown", e), e.defaultPrevented || r("dismiss"));
		}), Pr([a, () => n.disableOutsidePointerEvents], ([e, t], n, r) => {
			e && (t && (Wg.layersWithOutsidePointerEventsDisabled.size === 0 && (Wg.originalBodyPointerEvents = o.value.body.style.pointerEvents, o.value.body.style.pointerEvents = "none"), Wg.layersWithOutsidePointerEventsDisabled.add(e), r(() => {
				Wg.layersWithOutsidePointerEventsDisabled.delete(e), Wg.layersWithOutsidePointerEventsDisabled.size === 0 && !Mm(Wg.originalBodyPointerEvents) && (o.value.body.style.pointerEvents = Wg.originalBodyPointerEvents);
			})), s.value.add(e));
		}, { immediate: !0 }), jr((e) => {
			e(() => {
				a.value && (s.value.delete(a.value), Wg.layersWithOutsidePointerEventsDisabled.delete(a.value));
			});
		}), (e, t) => (V(), U(F(Og), {
			ref: F(i),
			"as-child": e.asChild,
			as: e.as,
			"data-dismissable-layer": "",
			style: Se({ pointerEvents: l.value ? u.value ? "auto" : "none" : void 0 }),
			onFocusCapture: F(f).onFocusCapture,
			onBlurCapture: F(f).onBlurCapture,
			onPointerdownCapture: F(d).onPointerDownCapture
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as-child",
			"as",
			"style",
			"onFocusCapture",
			"onBlurCapture",
			"onPointerdownCapture"
		]));
	}
}), Kg = Im(() => /* @__PURE__ */ P([]));
function qg() {
	let e = Kg();
	return {
		add(t) {
			let n = e.value[0];
			t !== n && n?.pause(), e.value = Jg(e.value, t), e.value.unshift(t);
		},
		remove(t) {
			e.value = Jg(e.value, t), e.value[0]?.resume();
		}
	};
}
function Jg(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
//#endregion
//#region node_modules/reka-ui/dist/FocusScope/utils.js
var Yg = "focusScope.autoFocusOnMount", Xg = "focusScope.autoFocusOnUnmount", Zg = {
	bubbles: !1,
	cancelable: !0
};
function Qg(e, { select: t = !1 } = {}) {
	let n = Am();
	for (let r of e) if (i_(r, { select: t }), Am() !== n) return !0;
}
function $g(e) {
	let t = e_(e);
	return [t_(t, e), t_(t.reverse(), e)];
}
function e_(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
function t_(e, t) {
	for (let n of e) if (!n_(n, { upTo: t })) return n;
}
function n_(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
function r_(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
function i_(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = Am();
		e.focus({ preventScroll: !0 }), e !== n && r_(e) && t && e.select();
	}
}
//#endregion
//#region node_modules/reka-ui/dist/FocusScope/FocusScope.js
var a_ = /* @__PURE__ */ L({
	__name: "FocusScope",
	props: {
		loop: {
			type: Boolean,
			required: !1,
			default: !1
		},
		trapped: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["mountAutoFocus", "unmountAutoFocus"],
	setup(e, { emit: t }) {
		let n = e, r = t, { currentRef: i, currentElement: a } = Xh(), o = /* @__PURE__ */ P(null), s = qg(), c = /*#__PURE__*/ rn({
			paused: !1,
			pause() {
				this.paused = !0;
			},
			resume() {
				this.paused = !1;
			}
		});
		jr((e) => {
			if (!Lm) return;
			let t = a.value;
			if (!n.trapped) return;
			function r(e) {
				if (c.paused || !t) return;
				let n = e.target;
				t.contains(n) ? o.value = n : i_(o.value, { select: !0 });
			}
			function i(e) {
				if (c.paused || !t) return;
				let n = e.relatedTarget;
				n !== null && (t.contains(n) || i_(o.value, { select: !0 }));
			}
			function s(e) {
				let n = o.value;
				n !== null && e.some((e) => e.removedNodes.length > 0) && (t.contains(n) || i_(t));
			}
			document.addEventListener("focusin", r), document.addEventListener("focusout", i);
			let l = new MutationObserver(s);
			t && l.observe(t, {
				childList: !0,
				subtree: !0
			}), e(() => {
				document.removeEventListener("focusin", r), document.removeEventListener("focusout", i), l.disconnect();
			});
		}), jr(async (e) => {
			let t = a.value;
			if (await or(), !t) return;
			s.add(c);
			let n = Am();
			if (!t.contains(n)) {
				let e = new CustomEvent(Yg, Zg);
				t.addEventListener(Yg, (e) => r("mountAutoFocus", e)), t.dispatchEvent(e), e.defaultPrevented || (Qg(e_(t), { select: !0 }), Am() === n && i_(t));
			}
			e(() => {
				t.removeEventListener(Yg, (e) => r("mountAutoFocus", e));
				let e = new CustomEvent(Xg, Zg), i = (e) => {
					r("unmountAutoFocus", e);
				};
				t.addEventListener(Xg, i), t.dispatchEvent(e), t.setAttribute("data-focus-scope-unmounting", ""), setTimeout(() => {
					e.defaultPrevented || i_(n ?? document.body, { select: !0 }), t.removeEventListener(Xg, i), s.remove(c), t.removeAttribute("data-focus-scope-unmounting");
				}, 0);
			});
		});
		function l(e) {
			if (!n.loop && !n.trapped || c.paused) return;
			let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, r = Am();
			if (t && r) {
				let t = e.currentTarget, [i, a] = $g(t);
				i && a ? !e.shiftKey && r === a ? (e.preventDefault(), n.loop && i_(i, { select: !0 })) : e.shiftKey && r === i && (e.preventDefault(), n.loop && i_(a, { select: !0 })) : r === t && e.preventDefault();
			}
		}
		return (e, t) => (V(), U(F(Og), {
			ref_key: "currentRef",
			ref: i,
			tabindex: "-1",
			"as-child": e.asChild,
			as: e.as,
			onKeydown: l
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, ["as-child", "as"]));
	}
}), o_ = "menu.itemSelect", s_ = ["Enter", " "], c_ = [
	"ArrowDown",
	"PageUp",
	"Home"
], l_ = [
	"ArrowUp",
	"PageDown",
	"End"
], u_ = [...c_, ...l_];
[...s_], [...s_];
function d_(e) {
	return e ? "open" : "closed";
}
function f_(e) {
	return e === "indeterminate";
}
function p_(e) {
	return f_(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function m_(e) {
	let t = Am();
	for (let n of e) if (n === t || (n.focus(), Am() !== t)) return;
}
function h_(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e].x, s = t[e].y, c = t[a].x, l = t[a].y;
		s > r != l > r && n < (c - o) * (r - s) / (l - s) + o && (i = !i);
	}
	return i;
}
function g_(e, t) {
	return t ? h_({
		x: e.clientX,
		y: e.clientY
	}, t) : !1;
}
function __(e) {
	return e.pointerType === "mouse";
}
//#endregion
//#region node_modules/reka-ui/dist/Dialog/DialogContentImpl.js
var v_ = /* @__PURE__ */ L({
	__name: "DialogContentImpl",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Fg(), { forwardRef: a, currentElement: o } = Xh();
		return i.titleId ||= _g(void 0, "reka-dialog-title"), i.descriptionId ||= _g(void 0, "reka-dialog-description"), ra(() => {
			i.contentElement = o, Am() !== document.body && (i.triggerElement.value = Am());
		}), (e, t) => (V(), U(F(a_), {
			"as-child": "",
			loop: "",
			trapped: n.trapFocus,
			onMountAutoFocus: t[5] ||= (e) => r("openAutoFocus", e),
			onUnmountAutoFocus: t[6] ||= (e) => r("closeAutoFocus", e)
		}, {
			default: I(() => [G(F(Gg), gs({
				id: F(i).contentId,
				ref: F(a),
				as: e.as,
				"as-child": e.asChild,
				"disable-outside-pointer-events": e.disableOutsidePointerEvents,
				role: "dialog",
				"aria-describedby": F(i).descriptionId,
				"aria-labelledby": F(i).titleId,
				"data-state": F(d_)(F(i).open.value)
			}, e.$attrs, {
				onDismiss: t[0] ||= (e) => F(i).onOpenChange(!1),
				onEscapeKeyDown: t[1] ||= (e) => r("escapeKeyDown", e),
				onFocusOutside: t[2] ||= (e) => r("focusOutside", e),
				onInteractOutside: t[3] ||= (e) => r("interactOutside", e),
				onPointerDownOutside: t[4] ||= (e) => r("pointerDownOutside", e)
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, [
				"id",
				"as",
				"as-child",
				"disable-outside-pointer-events",
				"aria-describedby",
				"aria-labelledby",
				"data-state"
			])]),
			_: 3
		}, 8, ["trapped"]));
	}
}), y_ = /* @__PURE__ */ L({
	__name: "DialogContentModal",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Fg(), a = Gh(r), { forwardRef: o, currentElement: s } = Xh();
		return hg(s), (e, t) => (V(), U(v_, gs({
			...n,
			...F(a)
		}, {
			ref: F(o),
			"trap-focus": F(i).open.value,
			"disable-outside-pointer-events": n.disableOutsidePointerEvents,
			onCloseAutoFocus: t[0] ||= (e) => {
				e.defaultPrevented || (e.preventDefault(), F(i).triggerElement.value?.focus());
			},
			onPointerDownOutside: t[1] ||= (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
				(t.button === 2 || n) && e.preventDefault();
			},
			onFocusOutside: t[2] ||= (e) => {
				e.preventDefault();
			}
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["trap-focus", "disable-outside-pointer-events"]));
	}
}), b_ = /* @__PURE__ */ L({
	__name: "DialogContentNonModal",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = Gh(t);
		Xh();
		let i = Fg(), a = /* @__PURE__ */ P(!1), o = /* @__PURE__ */ P(!1);
		return (e, t) => (V(), U(v_, gs({
			...n,
			...F(r)
		}, {
			"trap-focus": !1,
			"disable-outside-pointer-events": !1,
			onCloseAutoFocus: t[0] ||= (e) => {
				e.defaultPrevented || (a.value || F(i).triggerElement.value?.focus(), e.preventDefault()), a.value = !1, o.value = !1;
			},
			onInteractOutside: t[1] ||= (e) => {
				e.defaultPrevented || (a.value = !0, e.detail.originalEvent.type === "pointerdown" && (o.value = !0));
				let t = e.target;
				F(i).triggerElement.value?.contains(t) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && o.value && e.preventDefault();
			}
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), x_ = /* @__PURE__ */ L({
	__name: "DialogContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Fg(), a = Gh(r), { forwardRef: o } = Xh();
		return (e, t) => (V(), U(F(Tg), { present: e.forceMount || F(i).open.value }, {
			default: I(() => [F(i).modal.value ? (V(), U(y_, gs({
				key: 0,
				ref: F(o)
			}, {
				...n,
				...F(a),
				...e.$attrs
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16)) : (V(), U(b_, gs({
				key: 1,
				ref: F(o)
			}, {
				...n,
				...F(a),
				...e.$attrs
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16))]),
			_: 3
		}, 8, ["present"]));
	}
}), S_ = /* @__PURE__ */ L({
	__name: "DialogDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "p"
		}
	},
	setup(e) {
		let t = e;
		Xh();
		let n = Fg();
		return (e, r) => (V(), U(F(Og), gs(t, { id: F(n).descriptionId }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["id"]));
	}
}), C_ = /* @__PURE__ */ L({
	__name: "DialogOverlayImpl",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = Fg();
		return Vh(!0), Xh(), (e, n) => (V(), U(F(Og), {
			as: e.as,
			"as-child": e.asChild,
			"data-state": F(t).open.value ? "open" : "closed",
			style: { "pointer-events": "auto" },
			onPointerdown: n[0] ||= Kl(() => {}, [
				"left",
				"self",
				"prevent"
			])
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"data-state"
		]));
	}
}), w_ = /* @__PURE__ */ L({
	__name: "DialogOverlay",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = Fg(), { forwardRef: n } = Xh();
		return (e, r) => F(t)?.modal.value ? (V(), U(F(Tg), {
			key: 0,
			present: e.forceMount || F(t).open.value
		}, {
			default: I(() => [G(C_, gs(e.$attrs, {
				ref: F(n),
				as: e.as,
				"as-child": e.asChild
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["as", "as-child"])]),
			_: 3
		}, 8, ["present"])) : q("v-if", !0);
	}
}), T_ = /* @__PURE__ */ L({
	__name: "Teleport",
	props: {
		to: {
			type: null,
			required: !1,
			default: "body"
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = ph();
		return (e, n) => F(t) || e.forceMount ? (V(), U(qr, {
			key: 0,
			to: e.to,
			disabled: e.disabled,
			defer: e.defer
		}, [z(e.$slots, "default")], 8, [
			"to",
			"disabled",
			"defer"
		])) : q("v-if", !0);
	}
}), E_ = /* @__PURE__ */ L({
	__name: "DialogPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(T_), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), D_ = /* @__PURE__ */ L({
	__name: "DialogTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "h2"
		}
	},
	setup(e) {
		let t = e, n = Fg();
		return Xh(), (e, r) => (V(), U(F(Og), gs(t, { id: F(n).titleId }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["id"]));
	}
}), O_ = "data-reka-collection-item";
function k_(e = {}) {
	let { key: t = "", isProvider: n = !1 } = e, r = `${t}CollectionProvider`, i;
	n ? (i = {
		collectionRef: /* @__PURE__ */ P(),
		itemMap: /* @__PURE__ */ P(/* @__PURE__ */ new Map())
	}, Er(r, i)) : i = Dr(r);
	let a = (e = !1) => {
		let t = i.collectionRef.value;
		if (!t) return [];
		let n = Array.from(t.querySelectorAll(`[${O_}]`)), r = Array.from(i.itemMap.value.values()).sort((e, t) => n.indexOf(e.ref) - n.indexOf(t.ref));
		return e ? r : r.filter((e) => e.ref.dataset.disabled !== "");
	}, o = /*#__PURE__*/ L({
		name: "CollectionSlot",
		inheritAttrs: !1,
		setup(e, { slots: t, attrs: n }) {
			let { primitiveElement: r, currentElement: a } = kg();
			return Pr(a, () => {
				i.collectionRef.value = a.value;
			}), () => Hs(Eg, {
				ref: r,
				...n
			}, t);
		}
	}), s = /*#__PURE__*/ L({
		name: "CollectionItem",
		inheritAttrs: !1,
		props: { value: { validator: () => !0 } },
		setup(e, { slots: t, attrs: n }) {
			let { primitiveElement: r, currentElement: a } = kg();
			return jr((t) => {
				if (a.value) {
					let n = mn(a.value);
					i.itemMap.value.set(n, {
						ref: a.value,
						value: e.value
					}), t(() => i.itemMap.value.delete(n));
				}
			}), () => Hs(Eg, {
				...n,
				[O_]: "",
				ref: r
			}, t);
		}
	});
	return {
		getItems: a,
		reactiveItems: J(() => Array.from(i.itemMap.value.values())),
		itemMapSize: J(() => i.itemMap.value.size),
		CollectionSlot: o,
		CollectionItem: s
	};
}
//#endregion
//#region node_modules/reka-ui/dist/VisuallyHidden/VisuallyHidden.js
var A_ = /* @__PURE__ */ L({
	__name: "VisuallyHidden",
	props: {
		feature: {
			type: String,
			required: !1,
			default: "focusable"
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		return (e, t) => (V(), U(F(Og), {
			as: e.as,
			"as-child": e.asChild,
			"aria-hidden": e.feature === "focusable" ? "true" : void 0,
			"data-hidden": e.feature === "fully-hidden" ? "" : void 0,
			tabindex: e.feature === "fully-hidden" ? "-1" : void 0,
			style: {
				position: "absolute",
				border: 0,
				width: "1px",
				height: "1px",
				padding: 0,
				margin: "-1px",
				overflow: "hidden",
				clip: "rect(0, 0, 0, 0)",
				clipPath: "inset(50%)",
				whiteSpace: "nowrap",
				wordWrap: "normal",
				top: "-1px",
				left: "-1px"
			}
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"aria-hidden",
			"data-hidden",
			"tabindex"
		]));
	}
}), j_ = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "VisuallyHiddenInputBubble",
	props: {
		name: {
			type: String,
			required: !0
		},
		value: {
			type: null,
			required: !0
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		required: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		feature: {
			type: String,
			required: !1,
			default: "fully-hidden"
		}
	},
	setup(e) {
		let t = e, { primitiveElement: n, currentElement: r } = kg();
		return Pr(J(() => t.checked ?? t.value), (e, t) => {
			if (!r.value) return;
			let n = r.value, i = window.HTMLInputElement.prototype, a = Object.getOwnPropertyDescriptor(i, "value").set;
			if (a && e !== t) {
				let t = new Event("input", { bubbles: !0 }), r = new Event("change", { bubbles: !0 });
				a.call(n, e), n.dispatchEvent(t), n.dispatchEvent(r);
			}
		}), (e, r) => (V(), U(A_, gs({
			ref_key: "primitiveElement",
			ref: n
		}, {
			...t,
			...e.$attrs
		}, { as: "input" }), null, 16));
	}
}), M_ = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "VisuallyHiddenInput",
	props: {
		name: {
			type: String,
			required: !0
		},
		value: {
			type: null,
			required: !0
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		required: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		feature: {
			type: String,
			required: !1,
			default: "fully-hidden"
		}
	},
	setup(e) {
		let t = e, n = J(() => typeof t.value == "object" && Array.isArray(t.value) && t.value.length === 0 && t.required), r = J(() => typeof t.value == "string" || typeof t.value == "number" || typeof t.value == "boolean" || t.value === null || t.value === void 0 ? [{
			name: t.name,
			value: t.value
		}] : typeof t.value == "object" && Array.isArray(t.value) ? t.value.flatMap((e, n) => typeof e == "object" ? Object.entries(e).map(([e, r]) => ({
			name: `${t.name}[${n}][${e}]`,
			value: r
		})) : {
			name: `${t.name}[${n}]`,
			value: e
		}) : t.value !== null && typeof t.value == "object" && !Array.isArray(t.value) ? Object.entries(t.value).map(([e, n]) => ({
			name: `${t.name}[${e}]`,
			value: n
		})) : []);
		return (e, i) => (V(), H(B, null, [q(" We render single input if it's required "), n.value ? (V(), U(j_, gs({ key: e.name }, {
			...t,
			...e.$attrs
		}, {
			name: e.name,
			value: e.value
		}), null, 16, ["name", "value"])) : (V(!0), H(B, { key: 1 }, R(r.value, (n) => (V(), U(j_, gs({ key: n.name }, { ref_for: !0 }, {
			...t,
			...e.$attrs
		}, {
			name: n.name,
			value: n.value
		}), null, 16, ["name", "value"]))), 128))], 2112));
	}
}), N_ = "rovingFocusGroup.onEntryFocus", P_ = {
	bubbles: !1,
	cancelable: !0
}, F_ = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function I_(e, t) {
	return t === "rtl" ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
function L_(e, t, n) {
	let r = I_(e.key, n);
	if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return F_[r];
}
function R_(e, t = !1) {
	let n = Am();
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), Am() !== n)) return;
}
function z_(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
//#endregion
//#region node_modules/reka-ui/dist/Popper/PopperRoot.js
var [B_, V_] = /*#__PURE__*/ km("PopperRoot"), H_ = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "PopperRoot",
	setup(e) {
		let t = /* @__PURE__ */ P();
		return V_({
			anchor: t,
			onAnchorChange: (e) => t.value = e
		}), (e, t) => z(e.$slots, "default");
	}
}), U_ = /* @__PURE__ */ L({
	__name: "PopperAnchor",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, { forwardRef: n, currentElement: r } = Xh(), i = B_();
		return Mr(() => {
			i.onAnchorChange(t.reference ?? r.value);
		}), (e, t) => (V(), U(F(Og), {
			ref: F(n),
			as: e.as,
			"as-child": e.asChild
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, ["as", "as-child"]));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/Popper/utils.js
function W_(e) {
	return e !== null;
}
function G_(e) {
	return {
		name: "transformOrigin",
		options: e,
		fn(t) {
			let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = K_(n), u = {
				start: "0%",
				center: "50%",
				end: "100%"
			}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
			return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
				x: p,
				y: m
			} };
		}
	};
}
function K_(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var q_ = [
	"top",
	"right",
	"bottom",
	"left"
], J_ = Math.min, Y_ = Math.max, X_ = Math.round, Z_ = Math.floor, Q_ = (e) => ({
	x: e,
	y: e
}), $_ = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, ev = {
	start: "end",
	end: "start"
};
function tv(e, t, n) {
	return Y_(e, J_(t, n));
}
function nv(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function rv(e) {
	return e.split("-")[0];
}
function iv(e) {
	return e.split("-")[1];
}
function av(e) {
	return e === "x" ? "y" : "x";
}
function ov(e) {
	return e === "y" ? "height" : "width";
}
var sv = /*#__PURE__*/ new Set(["top", "bottom"]);
function cv(e) {
	return sv.has(rv(e)) ? "y" : "x";
}
function lv(e) {
	return av(cv(e));
}
function uv(e, t, n) {
	n === void 0 && (n = !1);
	let r = iv(e), i = lv(e), a = ov(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = yv(o)), [o, yv(o)];
}
function dv(e) {
	let t = yv(e);
	return [
		fv(e),
		t,
		fv(t)
	];
}
function fv(e) {
	return e.replace(/start|end/g, (e) => ev[e]);
}
var pv = ["left", "right"], mv = ["right", "left"], hv = ["top", "bottom"], gv = ["bottom", "top"];
function _v(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? mv : pv : t ? pv : mv;
		case "left":
		case "right": return t ? hv : gv;
		default: return [];
	}
}
function vv(e, t, n, r) {
	let i = iv(e), a = _v(rv(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(fv)))), a;
}
function yv(e) {
	return e.replace(/left|right|bottom|top/g, (e) => $_[e]);
}
function bv(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function xv(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : bv(e);
}
function Sv(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Cv(e, t, n) {
	let { reference: r, floating: i } = e, a = cv(t), o = lv(t), s = ov(o), c = rv(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (iv(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end": p[o] += f * (n && l ? -1 : 1);
	}
	return p;
}
var wv = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Cv(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = Cv(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function Tv(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = nv(t, e), p = xv(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Sv(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Sv(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Ev = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = nv(e, t) || {};
		if (l == null) return {};
		let d = xv(u), f = {
			x: n,
			y: r
		}, p = lv(i), m = ov(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = J_(d[_], T), ee = J_(d[v], T), D = E, O = C - h[m] - ee, te = C / 2 - h[m] / 2 + w, k = tv(D, te, O), ne = !c.arrow && iv(i) != null && te !== k && a.reference[m] / 2 - (te < D ? E : ee) - h[m] / 2 < 0, re = ne ? te < D ? te - D : te - O : 0;
		return {
			[p]: f[p] + re,
			data: {
				[p]: k,
				centerOffset: te - k - re,
				...ne && { alignmentOffset: re }
			},
			reset: ne
		};
	}
}), Dv = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = nv(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = rv(r), _ = cv(o), v = rv(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [yv(o)] : dv(o)), x = p !== "none";
			!d && x && b.push(...vv(o, m, p, y));
			let S = [o, ...b], C = await Tv(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = uv(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === cv(t) || T.every((e) => cv(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = cv(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function Ov(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function kv(e) {
	return q_.some((t) => e[t] >= 0);
}
var Av = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = nv(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = Ov(await Tv(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: kv(e)
					} };
				}
				case "escaped": {
					let e = Ov(await Tv(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: kv(e)
					} };
				}
				default: return {};
			}
		}
	};
}, jv = /*#__PURE__*/ new Set(["left", "top"]);
async function Mv(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = rv(n), s = iv(n), c = cv(n) === "y", l = jv.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = nv(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Nv = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Mv(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Pv = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = nv(e, t), l = {
				x: n,
				y: r
			}, u = await Tv(t, c), d = cv(rv(i)), f = av(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = tv(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = tv(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
}, Fv = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = nv(e, t), u = {
				x: n,
				y: r
			}, d = cv(i), f = av(d), p = u[f], m = u[d], h = nv(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = jv.has(rv(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Iv = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = nv(e, t), u = await Tv(t, l), d = rv(i), f = iv(i), p = cv(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = J_(h - u[g], v), x = J_(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = Y_(u.left, 0), t = Y_(u.right, 0), n = Y_(u.top, 0), r = Y_(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : Y_(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : Y_(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Lv() {
	return typeof window < "u";
}
function Rv(e) {
	return Vv(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function zv(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Bv(e) {
	return ((Vv(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Vv(e) {
	return Lv() ? e instanceof Node || e instanceof zv(e).Node : !1;
}
function Hv(e) {
	return Lv() ? e instanceof Element || e instanceof zv(e).Element : !1;
}
function Uv(e) {
	return Lv() ? e instanceof HTMLElement || e instanceof zv(e).HTMLElement : !1;
}
function Wv(e) {
	return !Lv() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof zv(e).ShadowRoot;
}
var Gv = /*#__PURE__*/ new Set(["inline", "contents"]);
function Kv(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = ay(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Gv.has(i);
}
var qv = /*#__PURE__*/ new Set([
	"table",
	"td",
	"th"
]);
function Jv(e) {
	return qv.has(Rv(e));
}
var Yv = [":popover-open", ":modal"];
function Xv(e) {
	return Yv.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var Zv = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Qv = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], $v = [
	"paint",
	"layout",
	"strict",
	"content"
];
function ey(e) {
	let t = ny(), n = Hv(e) ? ay(e) : e;
	return Zv.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Qv.some((e) => (n.willChange || "").includes(e)) || $v.some((e) => (n.contain || "").includes(e));
}
function ty(e) {
	let t = sy(e);
	for (; Uv(t) && !iy(t);) {
		if (ey(t)) return t;
		if (Xv(t)) return null;
		t = sy(t);
	}
	return null;
}
function ny() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var ry = /*#__PURE__*/ new Set([
	"html",
	"body",
	"#document"
]);
function iy(e) {
	return ry.has(Rv(e));
}
function ay(e) {
	return zv(e).getComputedStyle(e);
}
function oy(e) {
	return Hv(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function sy(e) {
	if (Rv(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Wv(e) && e.host || Bv(e);
	return Wv(t) ? t.host : t;
}
function cy(e) {
	let t = sy(e);
	return iy(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Uv(t) && Kv(t) ? t : cy(t);
}
function ly(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = cy(e), i = r === e.ownerDocument?.body, a = zv(r);
	if (i) {
		let e = uy(a);
		return t.concat(a, a.visualViewport || [], Kv(r) ? r : [], e && n ? ly(e) : []);
	}
	return t.concat(r, ly(r, [], n));
}
function uy(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function dy(e) {
	let t = ay(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Uv(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = X_(n) !== a || X_(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function fy(e) {
	return Hv(e) ? e : e.contextElement;
}
function py(e) {
	let t = fy(e);
	if (!Uv(t)) return Q_(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = dy(t), o = (a ? X_(n.width) : n.width) / r, s = (a ? X_(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var my = /*#__PURE__*/ Q_(0);
function hy(e) {
	let t = zv(e);
	return !ny() || !t.visualViewport ? my : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function gy(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== zv(e) ? !1 : t;
}
function _y(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = fy(e), o = Q_(1);
	t && (r ? Hv(r) && (o = py(r)) : o = py(e));
	let s = gy(a, n, r) ? hy(a) : Q_(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = zv(a), t = r && Hv(r) ? zv(r) : r, n = e, i = uy(n);
		for (; i && r && t !== n;) {
			let e = py(i), t = i.getBoundingClientRect(), r = ay(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = zv(i), i = uy(n);
		}
	}
	return Sv({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function vy(e, t) {
	let n = oy(e).scrollLeft;
	return t ? t.left + n : _y(Bv(e)).left + n;
}
function yy(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - vy(e, n),
		y: n.top + t.scrollTop
	};
}
function by(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Bv(r), s = t ? Xv(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = Q_(1), u = Q_(0), d = Uv(r);
	if ((d || !d && !a) && ((Rv(r) !== "body" || Kv(o)) && (c = oy(r)), Uv(r))) {
		let e = _y(r);
		l = py(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? yy(o, c) : Q_(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function xy(e) {
	return Array.from(e.getClientRects());
}
function Sy(e) {
	let t = Bv(e), n = oy(e), r = e.ownerDocument.body, i = Y_(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Y_(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + vy(e), s = -n.scrollTop;
	return ay(r).direction === "rtl" && (o += Y_(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var Cy = 25;
function wy(e, t) {
	let n = zv(e), r = Bv(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = ny();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = vy(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= Cy && (a -= o);
	} else l <= Cy && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var Ty = /*#__PURE__*/ new Set(["absolute", "fixed"]);
function Ey(e, t) {
	let n = _y(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Uv(e) ? py(e) : Q_(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Dy(e, t, n) {
	let r;
	if (t === "viewport") r = wy(e, n);
	else if (t === "document") r = Sy(Bv(e));
	else if (Hv(t)) r = Ey(t, n);
	else {
		let n = hy(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Sv(r);
}
function Oy(e, t) {
	let n = sy(e);
	return n === t || !Hv(n) || iy(n) ? !1 : ay(n).position === "fixed" || Oy(n, t);
}
function ky(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = ly(e, [], !1).filter((e) => Hv(e) && Rv(e) !== "body"), i = null, a = ay(e).position === "fixed", o = a ? sy(e) : e;
	for (; Hv(o) && !iy(o);) {
		let t = ay(o), n = ey(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && Ty.has(i.position) || Kv(o) && !n && Oy(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = sy(o);
	}
	return t.set(e, r), r;
}
function Ay(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Xv(t) ? [] : ky(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = Dy(t, n, i);
		return e.top = Y_(r.top, e.top), e.right = J_(r.right, e.right), e.bottom = J_(r.bottom, e.bottom), e.left = Y_(r.left, e.left), e;
	}, Dy(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function jy(e) {
	let { width: t, height: n } = dy(e);
	return {
		width: t,
		height: n
	};
}
function My(e, t, n) {
	let r = Uv(t), i = Bv(t), a = n === "fixed", o = _y(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = Q_(0);
	function l() {
		c.x = vy(i);
	}
	if (r || !r && !a) if ((Rv(t) !== "body" || Kv(i)) && (s = oy(t)), r) {
		let e = _y(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? yy(i, s) : Q_(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function Ny(e) {
	return ay(e).position === "static";
}
function Py(e, t) {
	if (!Uv(e) || ay(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Bv(e) === n && (n = n.ownerDocument.body), n;
}
function Fy(e, t) {
	let n = zv(e);
	if (Xv(e)) return n;
	if (!Uv(e)) {
		let t = sy(e);
		for (; t && !iy(t);) {
			if (Hv(t) && !Ny(t)) return t;
			t = sy(t);
		}
		return n;
	}
	let r = Py(e, t);
	for (; r && Jv(r) && Ny(r);) r = Py(r, t);
	return r && iy(r) && Ny(r) && !ey(r) ? n : r || ty(e) || n;
}
var Iy = async function(e) {
	let t = this.getOffsetParent || Fy, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: My(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function Ly(e) {
	return ay(e).direction === "rtl";
}
var Ry = {
	convertOffsetParentRelativeRectToViewportRelativeRect: by,
	getDocumentElement: Bv,
	getClippingRect: Ay,
	getOffsetParent: Fy,
	getElementRects: Iy,
	getClientRects: xy,
	getDimensions: jy,
	getScale: py,
	isElement: Hv,
	isRTL: Ly
};
function zy(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function By(e, t) {
	let n = null, r, i = Bv(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = Z_(d), h = Z_(i.clientWidth - (u + f)), g = Z_(i.clientHeight - (d + p)), _ = Z_(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: Y_(0, J_(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !zy(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function Vy(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = fy(e), u = i || a ? [...l ? ly(l) : [], ...ly(t)] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? By(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), p.observe(t));
	let m, h = c ? _y(e) : null;
	c && g();
	function g() {
		let t = _y(e);
		h && !zy(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Hy = Nv, Uy = Pv, Wy = Dv, Gy = Iv, Ky = Av, qy = Ev, Jy = Fv, Yy = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Ry,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return wv(e, t, {
		...i,
		platform: a
	});
};
//#endregion
//#region node_modules/@floating-ui/vue/dist/floating-ui.vue.mjs
function Xy(e) {
	return typeof e == "object" && !!e && "$el" in e;
}
function Zy(e) {
	if (Xy(e)) {
		let t = e.$el;
		return Vv(t) && Rv(t) === "#comment" ? null : t;
	}
	return e;
}
function Qy(e) {
	return typeof e == "function" ? e() : F(e);
}
function $y(e) {
	return {
		name: "arrow",
		options: e,
		fn(t) {
			let n = Zy(Qy(e.element));
			return n == null ? {} : qy({
				element: n,
				padding: e.padding
			}).fn(t);
		}
	};
}
function eb(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function tb(e, t) {
	let n = eb(e);
	return Math.round(t * n) / n;
}
function nb(e, t, n) {
	n === void 0 && (n = {});
	let r = n.whileElementsMounted, i = J(() => Qy(n.open) ?? !0), a = J(() => Qy(n.middleware)), o = J(() => Qy(n.placement) ?? "bottom"), s = J(() => Qy(n.strategy) ?? "absolute"), c = J(() => Qy(n.transform) ?? !0), l = J(() => Zy(e.value)), u = J(() => Zy(t.value)), d = /* @__PURE__ */ P(0), f = /* @__PURE__ */ P(0), p = /* @__PURE__ */ P(s.value), m = /* @__PURE__ */ P(o.value), h = /* @__PURE__ */ vn({}), g = /* @__PURE__ */ P(!1), _ = J(() => {
		let e = {
			position: p.value,
			left: "0",
			top: "0"
		};
		if (!u.value) return e;
		let t = tb(u.value, d.value), n = tb(u.value, f.value);
		return c.value ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...eb(u.value) >= 1.5 && { willChange: "transform" }
		} : {
			position: p.value,
			left: t + "px",
			top: n + "px"
		};
	}), v;
	function y() {
		if (l.value == null || u.value == null) return;
		let e = i.value;
		Yy(l.value, u.value, {
			middleware: a.value,
			placement: o.value,
			strategy: s.value
		}).then((t) => {
			d.value = t.x, f.value = t.y, p.value = t.strategy, m.value = t.placement, h.value = t.middlewareData, g.value = e !== !1;
		});
	}
	function b() {
		typeof v == "function" && (v(), v = void 0);
	}
	function x() {
		if (b(), r === void 0) {
			y();
			return;
		}
		if (l.value != null && u.value != null) {
			v = r(l.value, u.value, y);
			return;
		}
	}
	function S() {
		i.value || (g.value = !1);
	}
	return Pr([
		a,
		o,
		s,
		i
	], y, { flush: "sync" }), Pr([l, u], x, { flush: "sync" }), Pr(i, S, { flush: "sync" }), Ve() && He(b), {
		x: /* @__PURE__ */ sn(d),
		y: /* @__PURE__ */ sn(f),
		strategy: /* @__PURE__ */ sn(p),
		placement: /* @__PURE__ */ sn(m),
		middlewareData: /* @__PURE__ */ sn(h),
		isPositioned: /* @__PURE__ */ sn(g),
		floatingStyles: _,
		update: y
	};
}
//#endregion
//#region node_modules/reka-ui/dist/Popper/PopperContent.js
var rb = {
	side: "bottom",
	sideOffset: 0,
	sideFlip: !0,
	align: "center",
	alignOffset: 0,
	alignFlip: !0,
	arrowPadding: 0,
	hideShiftedArrow: !0,
	avoidCollisions: !0,
	collisionBoundary: () => [],
	collisionPadding: 0,
	sticky: "partial",
	hideWhenDetached: !1,
	positionStrategy: "fixed",
	updatePositionStrategy: "optimized",
	prioritizePosition: !1
}, [ib, ab] = /*#__PURE__*/ km("PopperContent"), ob = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "PopperContent",
	props: /* @__PURE__ */ za({
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	}, { ...rb }),
	emits: ["placed"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = B_(), { forwardRef: a, currentElement: o } = Xh(), s = /* @__PURE__ */ P(), c = /* @__PURE__ */ P(), { width: l, height: u } = vg(c), d = J(() => n.side + (n.align === "center" ? "" : `-${n.align}`)), f = J(() => typeof n.collisionPadding == "number" ? n.collisionPadding : {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			...n.collisionPadding
		}), p = J(() => Array.isArray(n.collisionBoundary) ? n.collisionBoundary : [n.collisionBoundary]), m = J(() => ({
			padding: f.value,
			boundary: p.value.filter(W_),
			altBoundary: p.value.length > 0
		})), h = J(() => ({
			mainAxis: n.sideFlip,
			crossAxis: n.alignFlip
		})), g = Nm(() => [
			Hy({
				mainAxis: n.sideOffset + u.value,
				alignmentAxis: n.alignOffset
			}),
			n.prioritizePosition && n.avoidCollisions && Wy({
				...m.value,
				...h.value
			}),
			n.avoidCollisions && Uy({
				mainAxis: !0,
				crossAxis: !!n.prioritizePosition,
				limiter: n.sticky === "partial" ? Jy() : void 0,
				...m.value
			}),
			!n.prioritizePosition && n.avoidCollisions && Wy({
				...m.value,
				...h.value
			}),
			Gy({
				...m.value,
				apply: ({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--reka-popper-available-width", `${n}px`), o.setProperty("--reka-popper-available-height", `${r}px`), o.setProperty("--reka-popper-anchor-width", `${i}px`), o.setProperty("--reka-popper-anchor-height", `${a}px`);
				}
			}),
			c.value && $y({
				element: c.value,
				padding: n.arrowPadding
			}),
			G_({
				arrowWidth: l.value,
				arrowHeight: u.value
			}),
			n.hideWhenDetached && Ky({
				strategy: "referenceHidden",
				...m.value
			})
		]), { floatingStyles: _, placement: v, isPositioned: y, middlewareData: b, update: x } = nb(J(() => n.reference ?? i.anchor.value), s, {
			strategy: n.positionStrategy,
			placement: d,
			whileElementsMounted: (...e) => Vy(...e, {
				layoutShift: !n.disableUpdateOnLayoutShift,
				animationFrame: n.updatePositionStrategy === "always"
			}),
			middleware: g
		}), S = J(() => K_(v.value)[0]), C = J(() => K_(v.value)[1]);
		Mr(() => {
			y.value && r("placed");
		});
		let w = J(() => {
			let e = b.value.arrow?.centerOffset !== 0;
			return n.hideShiftedArrow && e;
		}), T = /* @__PURE__ */ P("");
		return jr(() => {
			o.value && (T.value = window.getComputedStyle(o.value).zIndex);
		}), ab({
			placedSide: S,
			onArrowChange: (e) => c.value = e,
			arrowX: J(() => b.value.arrow?.x ?? 0),
			arrowY: J(() => b.value.arrow?.y ?? 0),
			shouldHideArrow: w
		}), (e, t) => (V(), H("div", {
			ref_key: "floatingRef",
			ref: s,
			"data-reka-popper-content-wrapper": "",
			style: Se({
				...F(_),
				transform: F(y) ? F(_).transform : "translate(0, -200%)",
				minWidth: "max-content",
				zIndex: T.value,
				"--reka-popper-transform-origin": [F(b).transformOrigin?.x, F(b).transformOrigin?.y].join(" "),
				...F(b).hide?.referenceHidden && {
					visibility: "hidden",
					pointerEvents: "none"
				}
			})
		}, [G(F(Og), gs({ ref: F(a) }, e.$attrs, {
			"as-child": n.asChild,
			as: e.as,
			"data-side": S.value,
			"data-align": C.value,
			style: { animation: F(y) ? void 0 : "none" }
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, [
			"as-child",
			"as",
			"data-side",
			"data-align",
			"style"
		])], 4));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/shared/useNonce.js
function sb(e) {
	let t = Ph({ nonce: /* @__PURE__ */ P() });
	return J(() => e?.value || t.nonce?.value);
}
//#endregion
//#region node_modules/reka-ui/dist/RovingFocus/RovingFocusGroup.js
var [cb, lb] = /*#__PURE__*/ km("RovingFocusGroup"), ub = /* @__PURE__ */ L({
	__name: "RovingFocusGroup",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: void 0
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1,
			default: !1
		},
		currentTabStopId: {
			type: [String, null],
			required: !1
		},
		defaultCurrentTabStopId: {
			type: String,
			required: !1
		},
		preventScrollOnEntryFocus: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["entryFocus", "update:currentTabStopId"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, { loop: a, orientation: o, dir: s } = /* @__PURE__ */ Dn(r), c = Wh(s), l = kh(r, "currentTabStopId", i, {
			defaultValue: r.defaultCurrentTabStopId,
			passive: r.currentTabStopId === void 0
		}), u = /* @__PURE__ */ P(!1), d = /* @__PURE__ */ P(!1), f = /* @__PURE__ */ P(0), { getItems: p, CollectionSlot: m } = k_({ isProvider: !0 });
		function h(e) {
			let t = !d.value;
			if (e.currentTarget && e.target === e.currentTarget && t && !u.value) {
				let t = new CustomEvent(N_, P_);
				if (e.currentTarget.dispatchEvent(t), i("entryFocus", t), !t.defaultPrevented) {
					let e = p().map((e) => e.ref).filter((e) => e.dataset.disabled !== "");
					R_([
						e.find((e) => e.getAttribute("data-active") === ""),
						e.find((e) => e.getAttribute("data-highlighted") === ""),
						e.find((e) => e.id === l.value),
						...e
					].filter(Boolean), r.preventScrollOnEntryFocus);
				}
			}
			d.value = !1;
		}
		function g() {
			setTimeout(() => {
				d.value = !1;
			}, 1);
		}
		return t({ getItems: p }), lb({
			loop: a,
			dir: c,
			orientation: o,
			currentTabStopId: l,
			onItemFocus: (e) => {
				l.value = e;
			},
			onItemShiftTab: () => {
				u.value = !0;
			},
			onFocusableItemAdd: () => {
				f.value++;
			},
			onFocusableItemRemove: () => {
				f.value--;
			}
		}), (e, t) => (V(), U(F(m), null, {
			default: I(() => [G(F(Og), {
				tabindex: u.value || f.value === 0 ? -1 : 0,
				"data-orientation": F(o),
				as: e.as,
				"as-child": e.asChild,
				dir: F(c),
				style: { outline: "none" },
				onMousedown: t[0] ||= (e) => d.value = !0,
				onMouseup: g,
				onFocus: h,
				onBlur: t[1] ||= (e) => u.value = !1
			}, {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 8, [
				"tabindex",
				"data-orientation",
				"as",
				"as-child",
				"dir"
			])]),
			_: 3
		}));
	}
}), db = /* @__PURE__ */ L({
	__name: "RovingFocusItem",
	props: {
		tabStopId: {
			type: String,
			required: !1
		},
		focusable: {
			type: Boolean,
			required: !1,
			default: !0
		},
		active: {
			type: Boolean,
			required: !1
		},
		allowShiftKey: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let t = e, n = cb(), r = _g(), i = J(() => t.tabStopId || r), a = J(() => n.currentTabStopId.value === i.value), { getItems: o, CollectionItem: s } = k_();
		ra(() => {
			t.focusable && n.onFocusableItemAdd();
		}), sa(() => {
			t.focusable && n.onFocusableItemRemove();
		});
		function c(e) {
			if (e.key === "Tab" && e.shiftKey) {
				n.onItemShiftTab();
				return;
			}
			if (e.target !== e.currentTarget) return;
			let r = L_(e, n.orientation.value, n.dir.value);
			if (r !== void 0) {
				if (e.metaKey || e.ctrlKey || e.altKey || !t.allowShiftKey && e.shiftKey) return;
				e.preventDefault();
				let i = [...o().map((e) => e.ref).filter((e) => e.dataset.disabled !== "")];
				if (r === "last") i.reverse();
				else if (r === "prev" || r === "next") {
					r === "prev" && i.reverse();
					let t = i.indexOf(e.currentTarget);
					i = n.loop.value ? z_(i, t + 1) : i.slice(t + 1);
				}
				or(() => R_(i));
			}
		}
		return (e, t) => (V(), U(F(s), null, {
			default: I(() => [G(F(Og), {
				tabindex: a.value ? 0 : -1,
				"data-orientation": F(n).orientation.value,
				"data-active": e.active ? "" : void 0,
				"data-disabled": e.focusable ? void 0 : "",
				as: e.as,
				"as-child": e.asChild,
				onMousedown: t[0] ||= (t) => {
					e.focusable ? F(n).onItemFocus(i.value) : t.preventDefault();
				},
				onFocus: t[1] ||= (e) => F(n).onItemFocus(i.value),
				onKeydown: c
			}, {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 8, [
				"tabindex",
				"data-orientation",
				"data-active",
				"data-disabled",
				"as",
				"as-child"
			])]),
			_: 3
		}));
	}
}), fb = /* @__PURE__ */ L({
	__name: "MenuAnchor",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(U_), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/shared/useIsUsingKeyboard.js
function pb() {
	let e = /* @__PURE__ */ P(!1);
	return ra(() => {
		fh("keydown", () => {
			e.value = !0;
		}, {
			capture: !0,
			passive: !0
		}), fh(["pointerdown", "pointermove"], () => {
			e.value = !1;
		}, {
			capture: !0,
			passive: !0
		});
	}), e;
}
var mb = Zm(pb), [hb, gb] = /*#__PURE__*/ km(["MenuRoot", "MenuSub"], "MenuContext"), [_b, vb] = /*#__PURE__*/ km("MenuRoot"), yb = /* @__PURE__ */ L({
	__name: "MenuRoot",
	props: {
		open: {
			type: Boolean,
			required: !1,
			default: !1
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t, { modal: i, dir: a } = /* @__PURE__ */ Dn(n), o = Wh(a), s = kh(n, "open", r), c = /* @__PURE__ */ P(), l = mb();
		return gb({
			open: s,
			onOpenChange: (e) => {
				s.value = e;
			},
			content: c,
			onContentChange: (e) => {
				c.value = e;
			}
		}), vb({
			onClose: () => {
				s.value = !1;
			},
			isUsingKeyboardRef: l,
			dir: o,
			modal: i
		}), (e, t) => (V(), U(F(H_), null, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}));
	}
}), [bb, xb] = /*#__PURE__*/ km("MenuContent"), Sb = /* @__PURE__ */ L({
	__name: "MenuContentImpl",
	props: /* @__PURE__ */ za({
		loop: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		disableOutsideScroll: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	}, { ...rb }),
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus",
		"dismiss"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = hb(), a = _b(), { trapFocus: o, disableOutsidePointerEvents: s, loop: c } = /* @__PURE__ */ Dn(n);
		qh(), Vh(s.value);
		let l = /* @__PURE__ */ P(""), u = /* @__PURE__ */ P(0), d = /* @__PURE__ */ P(0), f = /* @__PURE__ */ P(null), p = /* @__PURE__ */ P("right"), m = /* @__PURE__ */ P(0), h = /* @__PURE__ */ P(null), g = /* @__PURE__ */ P(), { forwardRef: _, currentElement: v } = Xh(), { handleTypeaheadSearch: y } = bg(), b = /* @__PURE__ */ P();
		function x(e) {
			let t = Mh(e, b.value || Am(), v.value, {
				loop: c.value,
				arrowKeyOptions: "vertical",
				dir: a?.dir.value,
				focus: !1,
				attributeName: "[data-reka-collection-item]:not([data-disabled])"
			});
			t && (b.value = t, t.scrollIntoView({ block: "nearest" }));
		}
		function S() {
			b.value && b.value.click();
		}
		let C = /* @__PURE__ */ P(), w = /* @__PURE__ */ P();
		Pr(b, (e) => {
			w.value && (e === void 0 || e !== w.value.trigger.value) && (w.value.onOpenChange(!1), w.value = void 0);
		}), Pr(v, (e) => {
			i.onContentChange(e);
		}), sa(() => {
			window.clearTimeout(u.value);
		});
		function T(e) {
			return p.value === f.value?.side && g_(e, f.value?.area);
		}
		async function E(e) {
			r("openAutoFocus", e), !e.defaultPrevented && (e.preventDefault(), v.value?.focus({ preventScroll: !0 }));
		}
		function ee(e) {
			if (e.defaultPrevented) return;
			let t = e.target, n = t.closest("[data-reka-menu-content]") === e.currentTarget, r = ["input", "textarea"].includes(t.tagName.toLowerCase()), i = e.ctrlKey || e.altKey || e.metaKey, o = e.key.length === 1, s = Mh(e, Am(), v.value, {
				loop: c.value,
				arrowKeyOptions: "vertical",
				dir: a?.dir.value,
				focus: !0,
				attributeName: "[data-reka-collection-item]:not([data-disabled])"
			});
			if (s) return s?.focus();
			if (e.code === "Space") return;
			let l = g.value?.getItems() ?? [];
			if (n && (e.key === "Tab" && e.preventDefault(), !i && o && !r && y(e.key, l)), e.target !== v.value || !u_.includes(e.key)) return;
			e.preventDefault();
			let u = [...l.map((e) => e.ref)];
			l_.includes(e.key) && u.reverse(), m_(u);
		}
		function D(e) {
			e?.currentTarget?.contains?.(e.target) || (window.clearTimeout(u.value), l.value = "");
		}
		function O(e) {
			if (!__(e)) return;
			let t = e.target, n = m.value !== e.clientX;
			if ((e?.currentTarget)?.contains(t) && n) {
				let t = e.clientX > m.value ? "right" : "left";
				p.value = t, m.value = e.clientX;
			}
		}
		function te(e) {
			__(e) && C.value && C.value.focus();
		}
		return xb({
			onItemEnter: (e) => !!T(e),
			onItemLeave: (e) => T(e) ? !0 : (["INPUT", "TEXTAREA"].includes(Am()?.tagName || "") || v.value?.focus(), h.value = null, !1),
			onTriggerLeave: (e) => !!T(e),
			searchRef: l,
			highlightedElement: b,
			onKeydownNavigation: x,
			onKeydownEnter: S,
			filterElement: C,
			onFilterElementChange: (e) => {
				C.value = e;
			},
			activeSubmenuContext: w,
			pointerGraceTimerRef: d,
			onPointerGraceIntentChange: (e) => {
				f.value = e;
			}
		}), (e, t) => (V(), U(F(a_), {
			"as-child": "",
			trapped: F(o),
			onMountAutoFocus: E,
			onUnmountAutoFocus: t[7] ||= (e) => r("closeAutoFocus", e)
		}, {
			default: I(() => [G(F(Gg), {
				"as-child": "",
				"disable-outside-pointer-events": F(s),
				onEscapeKeyDown: t[2] ||= (e) => r("escapeKeyDown", e),
				onPointerDownOutside: t[3] ||= (e) => r("pointerDownOutside", e),
				onFocusOutside: t[4] ||= (e) => r("focusOutside", e),
				onInteractOutside: t[5] ||= (e) => r("interactOutside", e),
				onDismiss: t[6] ||= (e) => r("dismiss")
			}, {
				default: I(() => [G(F(ub), {
					ref_key: "rovingFocusGroupRef",
					ref: g,
					"current-tab-stop-id": h.value,
					"onUpdate:currentTabStopId": t[0] ||= (e) => h.value = e,
					"as-child": "",
					orientation: "vertical",
					dir: F(a).dir.value,
					loop: F(c),
					onEntryFocus: t[1] ||= (e) => {
						r("entryFocus", e), F(a).isUsingKeyboardRef.value || e.preventDefault();
					}
				}, {
					default: I(() => [G(F(ob), {
						ref: F(_),
						role: "menu",
						as: e.as,
						"as-child": e.asChild,
						"aria-orientation": "vertical",
						"data-reka-menu-content": "",
						"data-state": F(d_)(F(i).open.value),
						dir: F(a).dir.value,
						side: e.side,
						"side-offset": e.sideOffset,
						align: e.align,
						"align-offset": e.alignOffset,
						"avoid-collisions": e.avoidCollisions,
						"collision-boundary": e.collisionBoundary,
						"collision-padding": e.collisionPadding,
						"arrow-padding": e.arrowPadding,
						"prioritize-position": e.prioritizePosition,
						"position-strategy": e.positionStrategy,
						"update-position-strategy": e.updatePositionStrategy,
						sticky: e.sticky,
						"hide-when-detached": e.hideWhenDetached,
						reference: e.reference,
						onKeydown: ee,
						onBlur: D,
						onPointermove: O,
						onPointerenter: te
					}, {
						default: I(() => [z(e.$slots, "default")]),
						_: 3
					}, 8, [
						"as",
						"as-child",
						"data-state",
						"dir",
						"side",
						"side-offset",
						"align",
						"align-offset",
						"avoid-collisions",
						"collision-boundary",
						"collision-padding",
						"arrow-padding",
						"prioritize-position",
						"position-strategy",
						"update-position-strategy",
						"sticky",
						"hide-when-detached",
						"reference"
					])]),
					_: 3
				}, 8, [
					"current-tab-stop-id",
					"dir",
					"loop"
				])]),
				_: 3
			}, 8, ["disable-outside-pointer-events"])]),
			_: 3
		}, 8, ["trapped"]));
	}
}), Cb = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "MenuItemImpl",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = bb(), { forwardRef: r, currentElement: i } = Xh(), { CollectionItem: a } = k_(), o = /* @__PURE__ */ P(!1), s = J(() => o.value || i.value != null && n.highlightedElement.value === i.value);
		async function c(e) {
			if (!(e.defaultPrevented || !__(e))) {
				if (t.disabled) n.onItemLeave(e);
				else if (!n.onItemEnter(e)) {
					let t = e.currentTarget;
					n.highlightedElement.value = t, ["INPUT", "TEXTAREA"].includes(Am()?.tagName || "") || t.focus({ preventScroll: !0 });
				}
			}
		}
		async function l(e) {
			await or(), !e.defaultPrevented && __(e) && n.highlightedElement.value === i.value && !n.onItemLeave(e) && n.highlightedElement.value === i.value && (n.highlightedElement.value = void 0);
		}
		return (e, t) => (V(), U(F(a), { value: { textValue: e.textValue } }, {
			default: I(() => [G(F(Og), gs({
				ref: F(r),
				role: "menuitem",
				tabindex: "-1"
			}, e.$attrs, {
				as: e.as,
				"as-child": e.asChild,
				"aria-disabled": e.disabled || void 0,
				"data-disabled": e.disabled ? "" : void 0,
				"data-highlighted": s.value ? "" : void 0,
				onPointermove: c,
				onPointerleave: l,
				onFocus: t[0] ||= async (t) => {
					await or(), !(t.defaultPrevented || e.disabled) && (o.value = !0, F(n).highlightedElement.value = t.currentTarget);
				},
				onBlur: t[1] ||= async (e) => {
					await or(), !e.defaultPrevented && (o.value = !1);
				}
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, [
				"as",
				"as-child",
				"aria-disabled",
				"data-disabled",
				"data-highlighted"
			])]),
			_: 3
		}, 8, ["value"]));
	}
}), wb = /* @__PURE__ */ L({
	__name: "MenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Xh(), o = _b(), s = bb(), c = /* @__PURE__ */ P(!1);
		async function l() {
			let e = a.value;
			if (!n.disabled && e) {
				let e = new CustomEvent(o_, {
					bubbles: !0,
					cancelable: !0
				});
				r("select", e), await or(), e.defaultPrevented ? c.value = !1 : o.onClose();
			}
		}
		return (e, t) => (V(), U(Cb, gs(n, {
			ref: F(i),
			onClick: l,
			onPointerdown: t[0] ||= () => {
				c.value = !0;
			},
			onPointerup: t[1] ||= async (e) => {
				await or(), !e.defaultPrevented && (c.value || e.currentTarget?.click());
			},
			onKeydown: t[2] ||= async (t) => {
				let n = F(s).searchRef.value !== "";
				e.disabled || n && t.key === " " || F(s_).includes(t.key) && (t.currentTarget?.click(), t.preventDefault());
			}
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [Tb, Eb] = /*#__PURE__*/ km(["MenuCheckboxItem", "MenuRadioItem"], "MenuItemIndicatorContext"), Db = /* @__PURE__ */ L({
	__name: "MenuItemIndicator",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let t = Tb({ modelValue: /* @__PURE__ */ P(!1) });
		return (e, n) => (V(), U(F(Tg), { present: e.forceMount || F(f_)(F(t).modelValue.value) || F(t).modelValue.value === !0 }, {
			default: I(() => [G(F(Og), {
				as: e.as,
				"as-child": e.asChild,
				"data-state": F(p_)(F(t).modelValue.value)
			}, {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 8, [
				"as",
				"as-child",
				"data-state"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), Ob = /* @__PURE__ */ L({
	__name: "MenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1,
			default: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Zh(eh(n, ["modelValue"])), a = kh(n, "modelValue", r);
		return Eb({ modelValue: a }), (e, t) => (V(), U(wb, gs({ role: "menuitemcheckbox" }, F(i), {
			"aria-checked": F(f_)(F(a)) ? "mixed" : F(a),
			"data-state": F(p_)(F(a)),
			onSelect: t[0] ||= async (e) => {
				r("select", e), F(f_)(F(a)) ? a.value = !0 : a.value = !F(a);
			}
		}), {
			default: I(() => [z(e.$slots, "default", { modelValue: F(a) })]),
			_: 3
		}, 16, ["aria-checked", "data-state"]));
	}
}), kb = /* @__PURE__ */ L({
	__name: "MenuRootContentModal",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qh(n, r), a = hb(), { forwardRef: o, currentElement: s } = Xh();
		return hg(s), (e, t) => (V(), U(Sb, gs(F(i), {
			ref: F(o),
			"trap-focus": F(a).open.value,
			"disable-outside-pointer-events": F(a).open.value,
			"disable-outside-scroll": !0,
			onDismiss: t[0] ||= (e) => F(a).onOpenChange(!1),
			onFocusOutside: t[1] ||= Kl((e) => r("focusOutside", e), ["prevent"])
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["trap-focus", "disable-outside-pointer-events"]));
	}
}), Ab = /* @__PURE__ */ L({
	__name: "MenuRootContentNonModal",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = Qh(e, t), r = hb();
		return (e, t) => (V(), U(Sb, gs(F(n), {
			"trap-focus": !1,
			"disable-outside-pointer-events": !1,
			"disable-outside-scroll": !1,
			onDismiss: t[0] ||= (e) => F(r).onOpenChange(!1)
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), jb = /* @__PURE__ */ L({
	__name: "MenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = Qh(e, t), r = hb(), i = _b();
		return (e, t) => (V(), U(F(Tg), { present: e.forceMount || F(r).open.value }, {
			default: I(() => [F(i).modal.value ? (V(), U(kb, De(gs({ key: 0 }, {
				...e.$attrs,
				...F(n)
			})), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16)) : (V(), U(Ab, De(gs({ key: 1 }, {
				...e.$attrs,
				...F(n)
			})), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16))]),
			_: 3
		}, 8, ["present"]));
	}
}), Mb = /* @__PURE__ */ L({
	__name: "MenuPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(T_), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Nb = /* @__PURE__ */ L({
	__name: "DropdownMenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = Gh(t);
		return Xh(), (e, t) => (V(), U(F(Ob), De(us({
			...n,
			...F(r)
		})), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [Pb, Fb] = /*#__PURE__*/ km("DropdownMenuRoot"), Ib = /* @__PURE__ */ L({
	__name: "DropdownMenuRoot",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t;
		Xh();
		let i = kh(n, "open", r, {
			defaultValue: n.defaultOpen,
			passive: n.open === void 0
		}), a = /* @__PURE__ */ P(), { modal: o, dir: s } = /* @__PURE__ */ Dn(n), c = Wh(s);
		return Fb({
			open: i,
			onOpenChange: (e) => {
				i.value = e;
			},
			onOpenToggle: () => {
				i.value = !i.value;
			},
			triggerId: "",
			triggerElement: a,
			contentId: "",
			modal: o,
			dir: c
		}), (e, t) => (V(), U(F(yb), {
			open: F(i),
			"onUpdate:open": t[0] ||= (e) => /* @__PURE__ */ _n(i) ? i.value = e : null,
			dir: F(c),
			modal: F(o)
		}, {
			default: I(() => [z(e.$slots, "default", { open: F(i) })]),
			_: 3
		}, 8, [
			"open",
			"dir",
			"modal"
		]));
	}
}), Lb = /* @__PURE__ */ L({
	__name: "DropdownMenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = Qh(e, t);
		Xh();
		let r = Pb(), i = /* @__PURE__ */ P(!1);
		function a(e) {
			e.defaultPrevented || (i.value || setTimeout(() => {
				r.triggerElement.value?.focus();
			}, 0), i.value = !1, e.preventDefault());
		}
		return r.contentId ||= _g(void 0, "reka-dropdown-menu-content"), (e, t) => (V(), U(F(jb), gs(F(n), {
			id: F(r).contentId,
			"aria-labelledby": F(r)?.triggerId,
			style: {
				"--reka-dropdown-menu-content-transform-origin": "var(--reka-popper-transform-origin)",
				"--reka-dropdown-menu-content-available-width": "var(--reka-popper-available-width)",
				"--reka-dropdown-menu-content-available-height": "var(--reka-popper-available-height)",
				"--reka-dropdown-menu-trigger-width": "var(--reka-popper-anchor-width)",
				"--reka-dropdown-menu-trigger-height": "var(--reka-popper-anchor-height)"
			},
			onCloseAutoFocus: a,
			onInteractOutside: t[0] ||= (e) => {
				if (e.defaultPrevented) return;
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, a = t.button === 2 || n;
				(!F(r).modal.value || a) && (i.value = !0), F(r).triggerElement.value?.contains(e.target) && e.preventDefault();
			}
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["id", "aria-labelledby"]));
	}
}), Rb = /* @__PURE__ */ L({
	__name: "DropdownMenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, r = Gh(t);
		return Xh(), (e, t) => (V(), U(F(wb), De(us({
			...n,
			...F(r)
		})), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), zb = /* @__PURE__ */ L({
	__name: "DropdownMenuItemIndicator",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return Xh(), (e, n) => (V(), U(F(Db), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Bb = /* @__PURE__ */ L({
	__name: "DropdownMenuPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(Mb), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Vb = /* @__PURE__ */ L({
	__name: "DropdownMenuTrigger",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e, n = Pb(), { forwardRef: r, currentElement: i } = Xh();
		return ra(() => {
			n.triggerElement = i;
		}), n.triggerId ||= _g(void 0, "reka-dropdown-menu-trigger"), (e, i) => (V(), U(F(fb), { "as-child": "" }, {
			default: I(() => [G(F(Og), {
				id: F(n).triggerId,
				ref: F(r),
				type: e.as === "button" ? "button" : void 0,
				"as-child": t.asChild,
				as: e.as,
				"aria-haspopup": "menu",
				"aria-expanded": F(n).open.value,
				"aria-controls": F(n).open.value ? F(n).contentId : void 0,
				"data-disabled": e.disabled ? "" : void 0,
				disabled: e.disabled,
				"data-state": F(n).open.value ? "open" : "closed",
				onClick: i[0] ||= async (t) => {
					!e.disabled && t.button === 0 && t.ctrlKey === !1 && (F(n)?.onOpenToggle(), await or(), F(n).open.value && t.preventDefault());
				},
				onKeydown: i[1] ||= Jl((t) => {
					e.disabled || (["Enter", " "].includes(t.key) && F(n).onOpenToggle(), t.key === "ArrowDown" && F(n).onOpenChange(!0), [
						"Enter",
						" ",
						"ArrowDown"
					].includes(t.key) && t.preventDefault());
				}, [
					"enter",
					"space",
					"arrow-down"
				])
			}, {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 8, [
				"id",
				"type",
				"as-child",
				"as",
				"aria-expanded",
				"aria-controls",
				"data-disabled",
				"disabled",
				"data-state"
			])]),
			_: 3
		}));
	}
}), Hb = "radio.select";
function Ub(e, t, n) {
	jm(Hb, n, {
		originalEvent: e,
		value: t
	});
}
//#endregion
//#region node_modules/reka-ui/dist/RadioGroup/Radio.js
var Wb = /* @__PURE__ */ L({
	__name: "Radio",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:checked", "select"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = kh(n, "checked", r, { passive: n.checked === void 0 }), { value: a } = /* @__PURE__ */ Dn(n), { forwardRef: o, currentElement: s } = Xh(), c = Yh(s), l = J(() => n.id && s.value ? document.querySelector(`[for="${n.id}"]`)?.innerText ?? n.value : void 0);
		function u(e) {
			n.disabled || Ub(e, n.value, (e) => {
				r("select", e), !e?.defaultPrevented && (i.value = !0, c.value && e.stopPropagation());
			});
		}
		return (e, t) => (V(), U(F(Og), gs(e.$attrs, {
			id: e.id,
			ref: F(o),
			role: "radio",
			type: e.as === "button" ? "button" : void 0,
			as: e.as,
			"aria-checked": F(i),
			"aria-label": l.value,
			"as-child": e.asChild,
			disabled: e.disabled ? "" : void 0,
			"data-state": F(i) ? "checked" : "unchecked",
			"data-disabled": e.disabled ? "" : void 0,
			value: F(a),
			required: e.required,
			name: e.name,
			onClick: Kl(u, ["stop"])
		}), {
			default: I(() => [z(e.$slots, "default", { checked: F(i) }), F(c) && e.name ? (V(), U(F(M_), {
				key: 0,
				type: "radio",
				tabindex: "-1",
				value: F(a),
				checked: !!F(i),
				name: e.name,
				disabled: e.disabled,
				required: e.required
			}, null, 8, [
				"value",
				"checked",
				"name",
				"disabled",
				"required"
			])) : q("v-if", !0)]),
			_: 3
		}, 16, [
			"id",
			"type",
			"as",
			"aria-checked",
			"aria-label",
			"as-child",
			"disabled",
			"data-state",
			"data-disabled",
			"value",
			"required",
			"name"
		]));
	}
}), [Gb, Kb] = /*#__PURE__*/ km("RadioGroupRoot"), qb = /* @__PURE__ */ L({
	__name: "RadioGroupRoot",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		orientation: {
			type: String,
			required: !1,
			default: void 0
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Xh(), o = kh(n, "modelValue", r, {
			defaultValue: n.defaultValue,
			passive: n.modelValue === void 0
		}), { disabled: s, loop: c, orientation: l, name: u, required: d, dir: f } = /* @__PURE__ */ Dn(n), p = Wh(f), m = Yh(a);
		return Kb({
			modelValue: o,
			changeModelValue: (e) => {
				o.value = e;
			},
			disabled: s,
			loop: c,
			orientation: l,
			name: u?.value,
			required: d
		}), (e, t) => (V(), U(F(ub), {
			"as-child": "",
			orientation: F(l),
			dir: F(p),
			loop: F(c)
		}, {
			default: I(() => [G(F(Og), {
				ref: F(i),
				role: "radiogroup",
				"data-disabled": F(s) ? "" : void 0,
				"as-child": e.asChild,
				as: e.as,
				"aria-orientation": F(l),
				"aria-required": F(d),
				dir: F(p)
			}, {
				default: I(() => [z(e.$slots, "default", { modelValue: F(o) }), F(m) && F(u) ? (V(), U(F(M_), {
					key: 0,
					required: F(d),
					disabled: F(s),
					value: F(o),
					name: F(u)
				}, null, 8, [
					"required",
					"disabled",
					"value",
					"name"
				])) : q("v-if", !0)]),
				_: 3
			}, 8, [
				"data-disabled",
				"as-child",
				"as",
				"aria-orientation",
				"aria-required",
				"dir"
			])]),
			_: 3
		}, 8, [
			"orientation",
			"dir",
			"loop"
		]));
	}
}), [Jb, Yb] = /*#__PURE__*/ km("RadioGroupItem"), Xb = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "RadioGroupItem",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Xh(), o = Gb(), s = J(() => o.disabled.value || n.disabled), c = J(() => o.required.value || n.required), l = J(() => Dm(o.modelValue?.value, n.value));
		Yb({
			disabled: s,
			checked: l
		});
		let u = /* @__PURE__ */ P(!1), d = [
			"ArrowUp",
			"ArrowDown",
			"ArrowLeft",
			"ArrowRight"
		];
		fh("keydown", (e) => {
			d.includes(e.key) && (u.value = !0);
		}), fh("keyup", () => {
			u.value = !1;
		});
		function f() {
			setTimeout(() => {
				u.value && a.value?.click();
			}, 0);
		}
		return (e, t) => (V(), U(F(db), {
			checked: l.value,
			disabled: s.value,
			"as-child": "",
			focusable: !s.value,
			active: l.value
		}, {
			default: I(() => [G(Wb, gs({
				...e.$attrs,
				...n
			}, {
				ref: F(i),
				checked: l.value,
				required: c.value,
				disabled: s.value,
				"onUpdate:checked": t[0] ||= (t) => F(o).changeModelValue(e.value),
				onSelect: t[1] ||= (e) => r("select", e),
				onKeydown: t[2] ||= Jl(Kl(() => {}, ["prevent"]), ["enter"]),
				onFocus: f
			}), {
				default: I(() => [z(e.$slots, "default", {
					checked: l.value,
					required: c.value,
					disabled: s.value
				})]),
				_: 3
			}, 16, [
				"checked",
				"required",
				"disabled"
			])]),
			_: 3
		}, 8, [
			"checked",
			"disabled",
			"focusable",
			"active"
		]));
	}
}), Zb = /* @__PURE__ */ L({
	__name: "RadioGroupIndicator",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let { forwardRef: t } = Xh(), n = Jb();
		return (e, r) => (V(), U(F(Tg), { present: e.forceMount || F(n).checked.value }, {
			default: I(() => [G(F(Og), gs({
				ref: F(t),
				"data-state": F(n).checked.value ? "checked" : "unchecked",
				"data-disabled": F(n).disabled.value ? "" : void 0,
				"as-child": e.asChild,
				as: e.as
			}, e.$attrs), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, [
				"data-state",
				"data-disabled",
				"as-child",
				"as"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), [Qb, $b] = /*#__PURE__*/ km("ScrollAreaRoot"), ex = /* @__PURE__ */ L({
	__name: "ScrollAreaRoot",
	props: {
		type: {
			type: String,
			required: !1,
			default: "hover"
		},
		dir: {
			type: String,
			required: !1
		},
		scrollHideDelay: {
			type: Number,
			required: !1,
			default: 600
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		let n = e, r = /* @__PURE__ */ P(0), i = /* @__PURE__ */ P(0), a = /* @__PURE__ */ P(), o = /* @__PURE__ */ P(), s = /* @__PURE__ */ P(), c = /* @__PURE__ */ P(), l = /* @__PURE__ */ P(!1), u = /* @__PURE__ */ P(!1), { type: d, dir: f, scrollHideDelay: p } = /* @__PURE__ */ Dn(n), m = Wh(f);
		function h() {
			a.value?.scrollTo({ top: 0 });
		}
		function g() {
			a.value?.scrollTo({
				top: 0,
				left: 0
			});
		}
		t({
			viewport: a,
			scrollTop: h,
			scrollTopLeft: g
		});
		let { forwardRef: _, currentElement: v } = Xh();
		return $b({
			type: d,
			dir: m,
			scrollHideDelay: p,
			scrollArea: v,
			viewport: a,
			onViewportChange: (e) => {
				a.value = e || void 0;
			},
			content: o,
			onContentChange: (e) => {
				o.value = e;
			},
			scrollbarX: s,
			scrollbarXEnabled: l,
			scrollbarY: c,
			scrollbarYEnabled: u,
			onScrollbarXChange: (e) => {
				s.value = e || void 0;
			},
			onScrollbarYChange: (e) => {
				c.value = e || void 0;
			},
			onScrollbarXEnabledChange: (e) => {
				l.value = e;
			},
			onScrollbarYEnabledChange: (e) => {
				u.value = e;
			},
			onCornerWidthChange: (e) => {
				r.value = e;
			},
			onCornerHeightChange: (e) => {
				i.value = e;
			}
		}), (e, t) => (V(), U(F(Og), {
			ref: F(_),
			"as-child": n.asChild,
			as: e.as,
			dir: F(m),
			style: Se({
				position: "relative",
				"--reka-scroll-area-corner-width": `${r.value}px`,
				"--reka-scroll-area-corner-height": `${i.value}px`
			})
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as-child",
			"as",
			"dir",
			"style"
		]));
	}
}), tx = /* @__PURE__ */ L({
	__name: "ScrollAreaCornerImpl",
	setup(e) {
		let t = Qb(), n = /* @__PURE__ */ P(0), r = /* @__PURE__ */ P(0), i = J(() => !!n.value && !!r.value);
		function a() {
			let e = t.scrollbarX.value?.offsetHeight || 0;
			t.onCornerHeightChange(e), r.value = e;
		}
		function o() {
			let e = t.scrollbarY.value?.offsetWidth || 0;
			t.onCornerWidthChange(e), n.value = e;
		}
		return Dh(t.scrollbarX.value, a), Dh(t.scrollbarY.value, o), Pr(() => t.scrollbarX.value, a), Pr(() => t.scrollbarY.value, o), (e, a) => i.value ? (V(), U(F(Og), gs({
			key: 0,
			style: {
				width: `${n.value}px`,
				height: `${r.value}px`,
				position: "absolute",
				right: F(t).dir.value === "ltr" ? 0 : void 0,
				left: F(t).dir.value === "rtl" ? 0 : void 0,
				bottom: 0
			}
		}, e.$parent?.$props), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["style"])) : q("v-if", !0);
	}
}), nx = /* @__PURE__ */ L({
	__name: "ScrollAreaCorner",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Xh(), r = Qb(), i = J(() => !!r.scrollbarX.value && !!r.scrollbarY.value), a = J(() => r.type.value !== "scroll" && i.value);
		return (e, r) => a.value ? (V(), U(tx, gs({ key: 0 }, t, { ref: F(n) }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16)) : q("v-if", !0);
	}
});
//#endregion
//#region node_modules/reka-ui/dist/ScrollArea/utils.js
function rx(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
function ix(e) {
	let t = ax(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
	return Math.max(r, 18);
}
function ax(e, t) {
	let n = e / t;
	return Number.isNaN(n) ? 0 : n;
}
function ox(e, t = () => {}) {
	let n = {
		left: e.scrollLeft,
		top: e.scrollTop
	}, r = 0;
	return (function i() {
		let a = {
			left: e.scrollLeft,
			top: e.scrollTop
		}, o = n.left !== a.left, s = n.top !== a.top;
		(o || s) && t(), n = a, r = window.requestAnimationFrame(i);
	})(), () => window.cancelAnimationFrame(r);
}
function sx(e, t, n = "ltr") {
	let r = ix(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - i, o = t.content - t.viewport, s = a - r, c = n === "ltr" ? [0, o] : [o * -1, 0], l = Om(e, c[0], c[1]);
	return rx([0, o], [0, s])(l);
}
function cx(e) {
	return e ? Number.parseInt(e, 10) : 0;
}
function lx(e, t, n, r = "ltr") {
	let i = ix(n), a = i / 2, o = t || a, s = i - o, c = n.scrollbar.paddingStart + o, l = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
	return rx([c, l], d)(e);
}
function ux(e, t) {
	return e > 0 && e < t;
}
//#endregion
//#region node_modules/reka-ui/dist/ScrollArea/ScrollAreaScrollbarX.js
var dx = /* @__PURE__ */ L({
	__name: "ScrollAreaScrollbarX",
	setup(e) {
		let t = Qb(), n = bx(), { forwardRef: r, currentElement: i } = Xh();
		ra(() => {
			i.value && t.onScrollbarXChange(i.value);
		}), sa(() => {
			t.onScrollbarXChange(null);
		});
		let a = J(() => n.sizes.value);
		return (e, i) => (V(), U(Cx, {
			ref: F(r),
			"is-horizontal": !0,
			"data-orientation": "horizontal",
			style: Se({
				bottom: 0,
				left: F(t).dir.value === "rtl" ? "var(--reka-scroll-area-corner-width)" : 0,
				right: F(t).dir.value === "ltr" ? "var(--reka-scroll-area-corner-width)" : 0,
				"--reka-scroll-area-thumb-width": a.value ? `${F(ix)(a.value)}px` : void 0
			}),
			onOnDragScroll: i[0] ||= (e) => F(n).onDragScroll(e.x)
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, ["style"]));
	}
}), fx = /* @__PURE__ */ L({
	__name: "ScrollAreaScrollbarY",
	setup(e) {
		let t = Qb(), n = bx(), { forwardRef: r, currentElement: i } = Xh();
		ra(() => {
			i.value && t.onScrollbarYChange(i.value);
		}), sa(() => {
			t.onScrollbarYChange(null);
		});
		let a = J(() => n.sizes.value);
		return (e, i) => (V(), U(Cx, {
			ref: F(r),
			"is-horizontal": !1,
			"data-orientation": "vertical",
			style: Se({
				top: 0,
				right: F(t).dir.value === "ltr" ? 0 : void 0,
				left: F(t).dir.value === "rtl" ? 0 : void 0,
				bottom: "var(--reka-scroll-area-corner-height)",
				"--reka-scroll-area-thumb-height": a.value ? `${F(ix)(a.value)}px` : void 0
			}),
			onOnDragScroll: i[0] ||= (e) => F(n).onDragScroll(e.y)
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, ["style"]));
	}
}), px = /* @__PURE__ */ L({
	__name: "ScrollAreaScrollbarAuto",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Qb(), n = _x(), { forwardRef: r } = Xh(), i = /* @__PURE__ */ P(!1), a = nh(() => {
			if (t.viewport.value) {
				let e = t.viewport.value.offsetWidth < t.viewport.value.scrollWidth, r = t.viewport.value.offsetHeight < t.viewport.value.scrollHeight;
				i.value = n.isHorizontal.value ? e : r;
			}
		}, 10);
		return ra(() => a()), Dh(t.viewport, a), Dh(t.content, a), (e, t) => (V(), U(F(Tg), { present: e.forceMount || i.value }, {
			default: I(() => [G(Sx, gs(e.$attrs, {
				ref: F(r),
				"data-state": i.value ? "visible" : "hidden"
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), mx = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "ScrollAreaScrollbarGlimpse",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Qb(), n = _x(), { forwardRef: r } = Xh(), { state: i, dispatch: a } = yg("hidden", {
			hidden: {
				POINTER_ENTER: "glimpse",
				SCROLL: "scrolling"
			},
			glimpse: {
				HIDE: "hidden",
				POINTER_LEAVE: "hidden",
				SCROLL: "scrolling",
				POINTER_ENTER: "glimpse"
			},
			scrolling: {
				SCROLL_END: "idle",
				POINTER_ENTER: "interacting"
			},
			interacting: {
				SCROLL: "interacting",
				POINTER_LEAVE: "idle"
			},
			idle: {
				HIDE: "hidden",
				SCROLL: "scrolling",
				POINTER_ENTER: "interacting"
			}
		}), o = J(() => i.value !== "hidden");
		function s() {
			a("POINTER_ENTER");
		}
		function c() {
			a("POINTER_LEAVE");
		}
		let l = nh(() => a("SCROLL_END"), 100);
		return jr((e) => {
			if (i.value === "glimpse") {
				let n = window.setTimeout(a, t.scrollHideDelay.value, "HIDE");
				e(() => {
					window.clearTimeout(n);
				});
			}
		}), jr((e) => {
			if (i.value === "idle") {
				let n = window.setTimeout(a, t.scrollHideDelay.value, "HIDE");
				e(() => {
					window.clearTimeout(n);
				});
			}
		}), jr((e) => {
			let r = t.viewport.value, i = n.isHorizontal.value ? "scrollLeft" : "scrollTop";
			if (r) {
				let t = r[i], n = () => {
					let e = r[i];
					t !== e && (a("SCROLL"), l()), t = e;
				};
				r.addEventListener("scroll", n), e(() => {
					r.removeEventListener("scroll", n);
				});
			}
		}), ra(() => {
			let e = t.scrollArea.value;
			e && (e.addEventListener("pointerenter", s), e.addEventListener("pointerleave", c));
		}), sa(() => {
			let e = t.scrollArea.value;
			e && (e.removeEventListener("pointerenter", s), e.removeEventListener("pointerleave", c));
		}), (e, t) => (V(), U(F(Tg), { present: e.forceMount || o.value }, {
			default: I(() => [G(px, gs(e.$attrs, {
				ref: F(r),
				"data-state": o.value ? "visible" : "hidden"
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), hx = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "ScrollAreaScrollbarHover",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Qb(), { forwardRef: n } = Xh(), r, i = /* @__PURE__ */ P(!1);
		function a() {
			window.clearTimeout(r), i.value = !0;
		}
		function o() {
			r = window.setTimeout(() => {
				i.value = !1;
			}, t.scrollHideDelay.value);
		}
		return ra(() => {
			let e = t.scrollArea.value;
			e && (e.addEventListener("pointerenter", a), e.addEventListener("pointerleave", o));
		}), sa(() => {
			let e = t.scrollArea.value;
			e && (window.clearTimeout(r), e.removeEventListener("pointerenter", a), e.removeEventListener("pointerleave", o));
		}), (e, t) => (V(), U(F(Tg), { present: e.forceMount || i.value }, {
			default: I(() => [G(px, gs(e.$attrs, {
				ref: F(n),
				"data-state": i.value ? "visible" : "hidden"
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), gx = /* @__PURE__ */ L({
	__name: "ScrollAreaScrollbarScroll",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Qb(), n = _x(), { forwardRef: r } = Xh(), { state: i, dispatch: a } = yg("hidden", {
			hidden: { SCROLL: "scrolling" },
			scrolling: {
				SCROLL_END: "idle",
				POINTER_ENTER: "interacting"
			},
			interacting: {
				SCROLL: "interacting",
				POINTER_LEAVE: "idle"
			},
			idle: {
				HIDE: "hidden",
				SCROLL: "scrolling",
				POINTER_ENTER: "interacting"
			}
		}), o = J(() => i.value !== "hidden");
		jr((e) => {
			if (i.value === "idle") {
				let n = window.setTimeout(a, t.scrollHideDelay.value, "HIDE");
				e(() => {
					window.clearTimeout(n);
				});
			}
		});
		let s = nh(() => a("SCROLL_END"), 100);
		return jr((e) => {
			let r = t.viewport.value, i = n.isHorizontal.value ? "scrollLeft" : "scrollTop";
			if (r) {
				let t = r[i], n = () => {
					let e = r[i];
					t !== e && (a("SCROLL"), s()), t = e;
				};
				r.addEventListener("scroll", n), e(() => {
					r.removeEventListener("scroll", n);
				});
			}
		}), (e, t) => (V(), U(F(Tg), { present: e.forceMount || o.value }, {
			default: I(() => [G(Sx, gs(e.$attrs, {
				ref: F(r),
				"data-state": o.value ? "visible" : "hidden"
			}), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), [_x, vx] = /*#__PURE__*/ km("ScrollAreaScrollbar"), yx = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "ScrollAreaScrollbar",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "vertical"
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "div"
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Xh(), r = Qb(), i = J(() => t.orientation === "horizontal");
		Pr(i, () => {
			i.value ? r.onScrollbarXEnabledChange(!0) : r.onScrollbarYEnabledChange(!0);
		}, { immediate: !0 }), sa(() => {
			r.onScrollbarXEnabledChange(!1), r.onScrollbarYEnabledChange(!1);
		});
		let { orientation: a, forceMount: o, asChild: s, as: c } = /* @__PURE__ */ Dn(t);
		return vx({
			orientation: a,
			forceMount: o,
			isHorizontal: i,
			as: c,
			asChild: s
		}), (e, t) => F(r).type.value === "hover" ? (V(), U(hx, gs({ key: 0 }, e.$attrs, {
			ref: F(n),
			"force-mount": F(o)
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : F(r).type.value === "scroll" ? (V(), U(gx, gs({ key: 1 }, e.$attrs, {
			ref: F(n),
			"force-mount": F(o)
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : F(r).type.value === "glimpse" ? (V(), U(mx, gs({ key: 2 }, e.$attrs, {
			ref: F(n),
			"force-mount": F(o)
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : F(r).type.value === "auto" ? (V(), U(px, gs({ key: 3 }, e.$attrs, {
			ref: F(n),
			"force-mount": F(o)
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : F(r).type.value === "always" ? (V(), U(Sx, gs({ key: 4 }, e.$attrs, {
			ref: F(n),
			"data-state": "visible"
		}), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16)) : q("v-if", !0);
	}
}), [bx, xx] = /*#__PURE__*/ km("ScrollAreaScrollbarVisible"), Sx = /* @__PURE__ */ L({
	__name: "ScrollAreaScrollbarVisible",
	setup(e) {
		let t = Qb(), n = _x(), { forwardRef: r } = Xh(), i = /* @__PURE__ */ P({
			content: 0,
			viewport: 0,
			scrollbar: {
				size: 0,
				paddingStart: 0,
				paddingEnd: 0
			}
		}), a = J(() => {
			let e = ax(i.value.viewport, i.value.content);
			return e > 0 && e < 1;
		}), o = /* @__PURE__ */ P(), s = /* @__PURE__ */ P(0);
		function c(e, n) {
			if (p.value) {
				let r = t.viewport.value.scrollLeft + e.deltaY;
				t.viewport.value.scrollLeft = r, ux(r, n) && e.preventDefault();
			} else {
				let r = t.viewport.value.scrollTop + e.deltaY;
				t.viewport.value.scrollTop = r, ux(r, n) && e.preventDefault();
			}
		}
		function l(e, t) {
			p.value ? s.value = t.x : s.value = t.y;
		}
		function u(e) {
			s.value = 0;
		}
		function d(e) {
			i.value = e;
		}
		function f(e, t) {
			return lx(e, s.value, i.value, t);
		}
		let p = J(() => n.isHorizontal.value);
		function m(e) {
			p.value ? t.viewport.value.scrollLeft = f(e, t.dir.value) : t.viewport.value.scrollTop = f(e);
		}
		function h() {
			if (p.value) {
				if (t.viewport.value && o.value) {
					let e = t.viewport.value.scrollLeft, n = sx(e, i.value, t.dir.value);
					o.value.style.transform = `translate3d(${n}px, 0, 0)`;
				}
			} else if (t.viewport.value && o.value) {
				let e = t.viewport.value.scrollTop, n = sx(e, i.value);
				o.value.style.transform = `translate3d(0, ${n}px, 0)`;
			}
		}
		function g(e) {
			o.value = e;
		}
		return xx({
			sizes: i,
			hasThumb: a,
			handleWheelScroll: c,
			handleThumbDown: l,
			handleThumbUp: u,
			handleSizeChange: d,
			onThumbPositionChange: h,
			onThumbChange: g,
			onDragScroll: m
		}), (e, t) => p.value ? (V(), U(dx, gs({ key: 0 }, e.$attrs, { ref: F(r) }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16)) : (V(), U(fx, gs({ key: 1 }, e.$attrs, { ref: F(r) }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Cx = /* @__PURE__ */ L({
	__name: "ScrollAreaScrollbarImpl",
	props: { isHorizontal: {
		type: Boolean,
		required: !0
	} },
	emits: [
		"onDragScroll",
		"onWheelScroll",
		"onThumbPointerDown"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qb(), a = bx(), o = _x(), { forwardRef: s, currentElement: c } = Xh(), l = /* @__PURE__ */ P(""), u = /* @__PURE__ */ P();
		function d(e) {
			if (u.value) {
				let t = e.clientX - u.value?.left, n = e.clientY - u.value?.top;
				r("onDragScroll", {
					x: t,
					y: n
				});
			}
		}
		function f(e) {
			e.button === 0 && (e.target.setPointerCapture(e.pointerId), u.value = c.value.getBoundingClientRect(), l.value = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", i.viewport && (i.viewport.value.style.scrollBehavior = "auto"), d(e));
		}
		function p(e) {
			d(e);
		}
		function m(e) {
			let t = e.target;
			t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), document.body.style.webkitUserSelect = l.value, i.viewport && (i.viewport.value.style.scrollBehavior = ""), u.value = void 0;
		}
		function h(e) {
			let t = e.target, n = c.value?.contains(t), r = a.sizes.value.content - a.sizes.value.viewport;
			n && a.handleWheelScroll(e, r);
		}
		ra(() => {
			document.addEventListener("wheel", h, { passive: !1 });
		}), sa(() => {
			document.removeEventListener("wheel", h);
		});
		function g() {
			c.value && (n.isHorizontal ? a.handleSizeChange({
				content: i.viewport.value?.scrollWidth ?? 0,
				viewport: i.viewport.value?.offsetWidth ?? 0,
				scrollbar: {
					size: c.value.clientWidth ?? 0,
					paddingStart: cx(getComputedStyle(c.value).paddingLeft),
					paddingEnd: cx(getComputedStyle(c.value).paddingRight)
				}
			}) : a.handleSizeChange({
				content: i.viewport.value?.scrollHeight ?? 0,
				viewport: i.viewport.value?.offsetHeight ?? 0,
				scrollbar: {
					size: c.value?.clientHeight ?? 0,
					paddingStart: cx(getComputedStyle(c.value).paddingTop),
					paddingEnd: cx(getComputedStyle(c.value).paddingBottom)
				}
			}), a.onThumbPositionChange());
		}
		return Dh(c, g), Dh(i.content, g), (e, t) => (V(), U(F(Og), {
			ref: F(s),
			style: { position: "absolute" },
			"data-scrollbarimpl": "",
			as: F(o).as.value,
			"as-child": F(o).asChild.value,
			onPointerdown: f,
			onPointermove: p,
			onPointerup: m
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, ["as", "as-child"]));
	}
}), wx = /* @__PURE__ */ L({
	__name: "ScrollAreaThumb",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Qb(), r = bx();
		function i(e) {
			let t = e.target.getBoundingClientRect(), n = e.clientX - t.left, i = e.clientY - t.top;
			r.handleThumbDown(e, {
				x: n,
				y: i
			});
		}
		function a(e) {
			r.handleThumbUp(e);
		}
		let { forwardRef: o, currentElement: s } = Xh(), c = /* @__PURE__ */ P(), l = J(() => n.viewport.value);
		function u() {
			if (!c.value) {
				let e = ox(l.value, r.onThumbPositionChange);
				c.value = e, r.onThumbPositionChange();
			}
		}
		return lh(J(() => r.sizes.value), () => {
			r.onThumbChange(s.value), l.value && (r.onThumbPositionChange(), l.value.addEventListener("scroll", u));
		}), sa(() => {
			l.value.removeEventListener("scroll", u), n.viewport.value?.removeEventListener("scroll", u);
		}), (e, n) => (V(), U(F(Og), {
			ref: F(o),
			"data-state": F(r).hasThumb ? "visible" : "hidden",
			style: {
				width: "var(--reka-scroll-area-thumb-width)",
				height: "var(--reka-scroll-area-thumb-height)"
			},
			"as-child": t.asChild,
			as: e.as,
			onPointerdown: i,
			onPointerup: a
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"data-state",
			"as-child",
			"as"
		]));
	}
}), Tx = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "ScrollAreaViewport",
	props: {
		nonce: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		let n = e, { nonce: r } = /* @__PURE__ */ Dn(n), i = sb(r), a = Qb(), o = /* @__PURE__ */ P();
		ra(() => {
			a.onViewportChange(o.value), a.onContentChange(c.value);
		}), t({ viewportElement: o });
		let { forwardRef: s, currentElement: c } = Xh();
		return (e, t) => (V(), H(B, null, [W("div", gs({
			ref_key: "viewportElement",
			ref: o,
			"data-reka-scroll-area-viewport": "",
			style: {
				overflowX: F(a).scrollbarXEnabled.value ? "scroll" : "hidden",
				overflowY: F(a).scrollbarYEnabled.value ? "scroll" : "hidden"
			}
		}, e.$attrs, { tabindex: 0 }), [G(F(Og), {
			ref: F(s),
			style: Se({ minWidth: F(a).scrollbarXEnabled.value ? "fit-content" : void 0 }),
			"as-child": n.asChild,
			as: e.as
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"style",
			"as-child",
			"as"
		])], 16), G(F(Og), {
			as: "style",
			nonce: F(i)
		}, {
			default: I(() => t[0] ||= [K(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-reka-scroll-area-viewport] { scrollbar-width:none; -ms-overflow-style:none; -webkit-overflow-scrolling:touch; } [data-reka-scroll-area-viewport]::-webkit-scrollbar { display:none; } ")]),
			_: 1,
			__: [0]
		}, 8, ["nonce"])], 64));
	}
}), Ex = /* @__PURE__ */ L({
	__name: "BaseSeparator",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = ["horizontal", "vertical"];
		function r(e) {
			return n.includes(e);
		}
		let i = J(() => r(t.orientation) ? t.orientation : "horizontal"), a = J(() => i.value === "vertical" ? t.orientation : void 0), o = J(() => t.decorative ? { role: "none" } : {
			"aria-orientation": a.value,
			role: "separator"
		});
		return (e, t) => (V(), U(F(Og), gs({
			as: e.as,
			"as-child": e.asChild,
			"data-orientation": i.value
		}, o.value), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, [
			"as",
			"as-child",
			"data-orientation"
		]));
	}
}), Dx = /* @__PURE__ */ L({
	__name: "Separator",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(Ex, De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [Ox, kx] = /*#__PURE__*/ km("TabsRoot"), Ax = /* @__PURE__ */ L({
	__name: "TabsRoot",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		dir: {
			type: String,
			required: !1
		},
		activationMode: {
			type: String,
			required: !1,
			default: "automatic"
		},
		modelValue: {
			type: null,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, { orientation: i, unmountOnHide: a, dir: o } = /* @__PURE__ */ Dn(n), s = Wh(o);
		Xh();
		let c = kh(n, "modelValue", r, {
			defaultValue: n.defaultValue,
			passive: n.modelValue === void 0
		}), l = /* @__PURE__ */ P(), u = /* @__PURE__ */ vn(/* @__PURE__ */ new Set());
		return kx({
			modelValue: c,
			changeModelValue: (e) => {
				c.value = e;
			},
			orientation: i,
			dir: s,
			unmountOnHide: a,
			activationMode: n.activationMode,
			baseId: _g(void 0, "reka-tabs"),
			tabsList: l,
			contentIds: u,
			registerContent: (e) => {
				u.value = /* @__PURE__ */ new Set([...u.value, e]);
			},
			unregisterContent: (e) => {
				let t = new Set(u.value);
				t.delete(e), u.value = t;
			}
		}), (e, t) => (V(), U(F(Og), {
			dir: F(s),
			"data-orientation": F(i),
			"as-child": e.asChild,
			as: e.as
		}, {
			default: I(() => [z(e.$slots, "default", { modelValue: F(c) })]),
			_: 3
		}, 8, [
			"dir",
			"data-orientation",
			"as-child",
			"as"
		]));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/Tabs/utils.js
function jx(e, t) {
	return `${e}-trigger-${t}`;
}
function Mx(e, t) {
	return `${e}-content-${t}`;
}
//#endregion
//#region node_modules/reka-ui/dist/Tabs/TabsContent.js
var Nx = /* @__PURE__ */ L({
	__name: "TabsContent",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Xh(), r = Ox(), i = J(() => jx(r.baseId, t.value)), a = J(() => Mx(r.baseId, t.value)), o = J(() => t.value === r.modelValue.value), s = /* @__PURE__ */ P(o.value);
		return ra(() => {
			r.registerContent(t.value), requestAnimationFrame(() => {
				s.value = !1;
			});
		}), oa(() => {
			r.unregisterContent(t.value);
		}), (e, t) => (V(), U(F(Tg), {
			present: e.forceMount || o.value,
			"force-mount": ""
		}, {
			default: I(({ present: t }) => [G(F(Og), {
				id: a.value,
				ref: F(n),
				"as-child": e.asChild,
				as: e.as,
				role: "tabpanel",
				"data-state": o.value ? "active" : "inactive",
				"data-orientation": F(r).orientation.value,
				"aria-labelledby": i.value,
				hidden: !t,
				tabindex: "0",
				style: Se({ animationDuration: s.value ? "0s" : void 0 })
			}, {
				default: I(() => [!F(r).unmountOnHide.value || t ? z(e.$slots, "default", { key: 0 }) : q("v-if", !0)]),
				_: 2
			}, 1032, [
				"id",
				"as-child",
				"as",
				"data-state",
				"data-orientation",
				"aria-labelledby",
				"hidden",
				"style"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), Px = /* @__PURE__ */ L({
	__name: "TabsList",
	props: {
		loop: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let { loop: t } = /* @__PURE__ */ Dn(e), { forwardRef: n, currentElement: r } = Xh(), i = Ox();
		return i.tabsList = r, (e, r) => (V(), U(F(ub), {
			"as-child": "",
			orientation: F(i).orientation.value,
			dir: F(i).dir.value,
			loop: F(t)
		}, {
			default: I(() => [G(F(Og), {
				ref: F(n),
				role: "tablist",
				"as-child": e.asChild,
				as: e.as,
				"aria-orientation": F(i).orientation.value
			}, {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 8, [
				"as-child",
				"as",
				"aria-orientation"
			])]),
			_: 3
		}, 8, [
			"orientation",
			"dir",
			"loop"
		]));
	}
}), Fx = /* @__PURE__ */ L({
	__name: "TabsTrigger",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Xh(), r = Ox(), i = J(() => jx(r.baseId, t.value)), a = J(() => r.contentIds.value.has(t.value) ? Mx(r.baseId, t.value) : void 0), o = J(() => t.value === r.modelValue.value);
		return (e, t) => (V(), U(F(db), {
			"as-child": "",
			focusable: !e.disabled,
			active: o.value
		}, {
			default: I(() => [G(F(Og), {
				id: i.value,
				ref: F(n),
				role: "tab",
				type: e.as === "button" ? "button" : void 0,
				as: e.as,
				"as-child": e.asChild,
				"aria-selected": o.value ? "true" : "false",
				"aria-controls": a.value,
				"data-state": o.value ? "active" : "inactive",
				disabled: e.disabled,
				"data-disabled": e.disabled ? "" : void 0,
				"data-orientation": F(r).orientation.value,
				onMousedown: t[0] ||= Kl((t) => {
					!e.disabled && t.ctrlKey === !1 ? F(r).changeModelValue(e.value) : t.preventDefault();
				}, ["left"]),
				onKeydown: t[1] ||= Jl((t) => F(r).changeModelValue(e.value), ["enter", "space"]),
				onFocus: t[2] ||= () => {
					let t = F(r).activationMode !== "manual";
					!o.value && !e.disabled && t && F(r).changeModelValue(e.value);
				}
			}, {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 8, [
				"id",
				"type",
				"as",
				"as-child",
				"aria-selected",
				"aria-controls",
				"data-state",
				"disabled",
				"data-disabled",
				"data-orientation"
			])]),
			_: 3
		}, 8, ["focusable", "active"]));
	}
}), [Ix, Lx] = /*#__PURE__*/ km("TooltipProvider"), Rx = /* @__PURE__ */ L({
	inheritAttrs: !1,
	__name: "TooltipProvider",
	props: {
		delayDuration: {
			type: Number,
			required: !1,
			default: 700
		},
		skipDelayDuration: {
			type: Number,
			required: !1,
			default: 300
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1,
			default: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1,
			default: !1
		},
		content: {
			type: Object,
			required: !1
		}
	},
	setup(e) {
		let { delayDuration: t, skipDelayDuration: n, disableHoverableContent: r, disableClosingTrigger: i, ignoreNonKeyboardFocus: a, disabled: o, content: s } = /* @__PURE__ */ Dn(e);
		Xh();
		let c = /* @__PURE__ */ P(!0), l = /* @__PURE__ */ P(!1), { start: u, stop: d } = sh(() => {
			c.value = !0;
		}, n, { immediate: !1 });
		return Lx({
			isOpenDelayed: c,
			delayDuration: t,
			onOpen() {
				d(), c.value = !1;
			},
			onClose() {
				u();
			},
			isPointerInTransitRef: l,
			disableHoverableContent: r,
			disableClosingTrigger: i,
			disabled: o,
			ignoreNonKeyboardFocus: a,
			content: s
		}), (e, t) => z(e.$slots, "default");
	}
}), zx = "tooltip.open", [Bx, Vx] = /*#__PURE__*/ km("TooltipRoot"), Hx = /* @__PURE__ */ L({
	__name: "TooltipRoot",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1,
			default: !1
		},
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		delayDuration: {
			type: Number,
			required: !1,
			default: void 0
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1,
			default: void 0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t;
		Xh();
		let i = Ix(), a = J(() => n.disableHoverableContent ?? i.disableHoverableContent.value), o = J(() => n.disableClosingTrigger ?? i.disableClosingTrigger.value), s = J(() => n.disabled ?? i.disabled.value), c = J(() => n.delayDuration ?? i.delayDuration.value), l = J(() => n.ignoreNonKeyboardFocus ?? i.ignoreNonKeyboardFocus.value), u = kh(n, "open", r, {
			defaultValue: n.defaultOpen,
			passive: n.open === void 0
		});
		Pr(u, (e) => {
			i.onClose && (e ? (i.onOpen(), document.dispatchEvent(new CustomEvent(zx))) : i.onClose());
		});
		let d = /* @__PURE__ */ P(!1), f = /* @__PURE__ */ P(), p = J(() => u.value ? d.value ? "delayed-open" : "instant-open" : "closed"), { start: m, stop: h } = sh(() => {
			d.value = !0, u.value = !0;
		}, c, { immediate: !1 });
		function g() {
			h(), d.value = !1, u.value = !0;
		}
		function _() {
			h(), u.value = !1;
		}
		function v() {
			m();
		}
		return Vx({
			contentId: "",
			open: u,
			stateAttribute: p,
			trigger: f,
			onTriggerChange(e) {
				f.value = e;
			},
			onTriggerEnter() {
				i.isOpenDelayed.value ? v() : g();
			},
			onTriggerLeave() {
				a.value ? _() : h();
			},
			onOpen: g,
			onClose: _,
			disableHoverableContent: a,
			disableClosingTrigger: o,
			disabled: s,
			ignoreNonKeyboardFocus: l
		}), (e, t) => (V(), U(F(H_), null, {
			default: I(() => [z(e.$slots, "default", { open: F(u) })]),
			_: 3
		}));
	}
}), Ux = /* @__PURE__ */ L({
	__name: "TooltipContentImpl",
	props: {
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Bx(), a = Ix(), { forwardRef: o, currentElement: s } = Xh(), c = J(() => n.ariaLabel || s.value?.textContent), l = J(() => {
			let { ariaLabel: e, ...t } = n;
			return zh(t, a.content.value ?? {}, {
				side: "top",
				sideOffset: 0,
				align: "center",
				avoidCollisions: !0,
				collisionBoundary: [],
				collisionPadding: 0,
				arrowPadding: 0,
				sticky: "partial",
				hideWhenDetached: !1
			});
		});
		return ra(() => {
			fh(window, "scroll", (e) => {
				e.target?.contains(i.trigger.value) && i.onClose();
			}, { capture: !0 }), fh(window, zx, i.onClose);
		}), (e, t) => (V(), U(F(Gg), {
			"as-child": "",
			"disable-outside-pointer-events": !1,
			onEscapeKeyDown: t[0] ||= (e) => r("escapeKeyDown", e),
			onPointerDownOutside: t[1] ||= (e) => {
				F(i).disableClosingTrigger.value && F(i).trigger.value?.contains(e.target) && e.preventDefault(), r("pointerDownOutside", e);
			},
			onFocusOutside: t[2] ||= Kl(() => {}, ["prevent"]),
			onDismiss: t[3] ||= (e) => F(i).onClose()
		}, {
			default: I(() => [G(F(ob), gs({
				ref: F(o),
				"data-state": F(i).stateAttribute.value
			}, {
				...e.$attrs,
				...l.value
			}, { style: {
				"--reka-tooltip-content-transform-origin": "var(--reka-popper-transform-origin)",
				"--reka-tooltip-content-available-width": "var(--reka-popper-available-width)",
				"--reka-tooltip-content-available-height": "var(--reka-popper-available-height)",
				"--reka-tooltip-trigger-width": "var(--reka-popper-anchor-width)",
				"--reka-tooltip-trigger-height": "var(--reka-popper-anchor-height)"
			} }), {
				default: I(() => [z(e.$slots, "default"), G(F(A_), {
					id: F(i).contentId,
					role: "tooltip"
				}, {
					default: I(() => [K(N(c.value), 1)]),
					_: 1
				}, 8, ["id"])]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}));
	}
}), Wx = /* @__PURE__ */ L({
	__name: "TooltipContentHoverable",
	props: {
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		}
	},
	setup(e) {
		let t = Zh(e), { forwardRef: n, currentElement: r } = Xh(), { trigger: i, onClose: a } = Bx(), o = Ix(), { isPointerInTransit: s, onPointerExit: c } = $h(i, r);
		return o.isPointerInTransitRef = s, c(() => {
			a();
		}), (e, r) => (V(), U(Ux, gs({ ref: F(n) }, F(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Gx = /* @__PURE__ */ L({
	__name: "TooltipContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Bx(), a = Qh(n, r), { forwardRef: o } = Xh();
		return (e, t) => (V(), U(F(Tg), { present: e.forceMount || F(i).open.value }, {
			default: I(() => [(V(), U(ga(F(i).disableHoverableContent.value ? Ux : Wx), gs({ ref: F(o) }, F(a)), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16))]),
			_: 3
		}, 8, ["present"]));
	}
}), Kx = /* @__PURE__ */ L({
	__name: "TooltipPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(T_), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), qx = /* @__PURE__ */ L({
	__name: "TooltipTrigger",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e, n = Bx(), r = Ix();
		n.contentId ||= _g(void 0, "reka-tooltip-content");
		let { forwardRef: i, currentElement: a } = Xh(), o = /* @__PURE__ */ P(!1), s = /* @__PURE__ */ P(!1), c = J(() => n.disabled.value ? {} : {
			click: h,
			focus: p,
			pointermove: d,
			pointerleave: f,
			pointerdown: u,
			blur: m
		});
		ra(() => {
			n.onTriggerChange(a.value);
		});
		function l() {
			setTimeout(() => {
				o.value = !1;
			}, 1);
		}
		function u() {
			n.open && !n.disableClosingTrigger.value && n.onClose(), o.value = !0, document.addEventListener("pointerup", l, { once: !0 });
		}
		function d(e) {
			e.pointerType !== "touch" && !s.value && !r.isPointerInTransitRef.value && (n.onTriggerEnter(), s.value = !0);
		}
		function f() {
			n.onTriggerLeave(), s.value = !1;
		}
		function p(e) {
			o.value || n.ignoreNonKeyboardFocus.value && !e.target.matches?.(":focus-visible") || n.onOpen();
		}
		function m() {
			n.onClose();
		}
		function h() {
			n.disableClosingTrigger.value || n.onClose();
		}
		return (e, r) => (V(), U(F(U_), {
			"as-child": "",
			reference: e.reference
		}, {
			default: I(() => [G(F(Og), gs({
				ref: F(i),
				"aria-describedby": F(n).open.value ? F(n).contentId : void 0,
				"data-state": F(n).stateAttribute.value,
				as: e.as,
				"as-child": t.asChild,
				"data-grace-area-trigger": ""
			}, Sa(c.value)), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, [
				"aria-describedby",
				"data-state",
				"as",
				"as-child"
			])]),
			_: 3
		}, 8, ["reference"]));
	}
}), Jx = {
	__name: "Button",
	props: {
		variant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		title: {
			type: String,
			required: !1
		},
		disableTooltip: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	setup(e) {
		let t = e, n = Fa(), r = J(() => {
			if (t.disableTooltip) return;
			if (t.title) return t.title;
			let e = n.default?.();
			if (!e) return;
			let r = (e) => {
				let t = "";
				for (let n of e) if (n.type !== Xo) {
					if (n.type === Yo) {
						typeof n.children == "string" && (t += n.children);
						continue;
					}
					if (n.type === B && Array.isArray(n.children)) {
						t += r(n.children);
						continue;
					}
					typeof n.children == "string" ? t += n.children : Array.isArray(n.children) && (t += r(n.children));
				}
				return t;
			};
			return r(e).trim() || void 0;
		});
		return (n, i) => (V(), U(F(Og), {
			"data-slot": "button",
			"data-variant": e.variant,
			as: e.as,
			"as-child": e.asChild,
			class: M(F(hm)(F(Yx)({
				variant: e.variant,
				size: e.size
			}), t.class)),
			title: r.value
		}, {
			default: I(() => [z(n.$slots, "default")]),
			_: 3
		}, 8, [
			"data-variant",
			"as",
			"as-child",
			"class",
			"title"
		]));
	}
}, Yx = wm("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
	variants: {
		variant: {
			default: "bg-button-primary text-button-primary-foreground hover:bg-button-primary-hover hover:text-button-primary-hover-foreground",
			destructive: "bg-destructive text-white hover:bg-destructive-hover focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
			outline: "border bg-background text-body hover:bg-accent hover:text-foreground shadow-none dark:bg-card",
			secondary: "bg-secondary text-secondary-foreground hover:bg-[var(--color-secondary-hover)]",
			selected: "relative z-10 border bg-[var(--color-selected)] text-[var(--color-selected-foreground)] border-[var(--color-selected-border)] hover:bg-[var(--color-selected-hover)]",
			ghost: "text-body hover:bg-accent hover:text-foreground dark:hover:bg-accent/50",
			link: "text-[var(--color-link)] underline-offset-4 hover:underline hover:text-foreground",
			info: "bg-sky-100 text-sky-700 hover:bg-sky-200 focus-visible:ring-sky-400/30 focus-visible:border-sky-300",
			success: "bg-success-muted text-success-muted-foreground hover:bg-green-200 focus-visible:ring-green-400/30 focus-visible:border-green-300",
			warning: "bg-warning text-warning-foreground hover:bg-amber-200 focus-visible:ring-amber-400/30 focus-visible:border-amber-300",
			"destructive-subtle": "bg-red-100 text-destructive hover:bg-red-200 focus-visible:ring-red-400/30 focus-visible:border-red-300",
			variable: "bg-[var(--color-variable)] text-[var(--color-variable-foreground)] hover:bg-[var(--color-variable-hover)]",
			teams: "bg-[var(--color-teams-button-bg)] text-[var(--color-teams-button-foreground)] hover:bg-[var(--color-teams-button-hover)]"
		},
		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			link: "h-auto p-0",
			icon: "size-9",
			"icon-sm": "size-8",
			"icon-lg": "size-10",
			"icon-round": "size-9 rounded-full",
			"icon-round-sm": "size-8 rounded-full"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), Xx = {
	__name: "Tabs",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		activationMode: {
			type: String,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = Qh(e, t);
		return (e, t) => (V(), U(F(Ax), De(us(F(n))), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, Zx = {
	__name: "TabsContent",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = eh(t, "class");
		return (e, r) => (V(), U(F(Nx), gs({ class: F(hm)("mt-2 focus-visible:outline-none", t.class) }, F(n)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, Qx = {
	__name: "TabsList",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = eh(t, "class");
		return (e, r) => (V(), U(F(Px), gs(F(n), { class: F(hm)("inline-flex items-center justify-center rounded-lg bg-muted p-1 text-body", t.class) }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, $x = { class: "truncate" }, eS = {
	__name: "TabsTrigger",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		icon: {
			type: [Object, Function],
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Zh(eh(t, "class", "icon"));
		return (r, i) => (V(), U(F(Fx), gs(F(n), { class: F(hm)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow", t.class) }), {
			default: I(() => [e.icon ? (V(), U(ga(e.icon), {
				key: 0,
				class: "size-4 shrink-0"
			})) : q("", !0), W("span", $x, [z(r.$slots, "default")])]),
			_: 3
		}, 16, ["class"]));
	}
}, tS = {
	__name: "Separator",
	props: {
		variant: {
			type: String,
			required: !1
		},
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = eh(t, "class", "variant");
		return (e, r) => (V(), U(F(Dx), gs(F(n), { class: F(hm)(F(nS)({
			variant: t.variant,
			orientation: t.orientation
		}), t.class) }), null, 16, ["class"]));
	}
}, nS = wm("shrink-0", {
	variants: {
		variant: {
			default: "bg-divider",
			strong: "bg-border",
			pattern: "bg-muted/50 pattern-diagonal-stripes border-border"
		},
		orientation: {
			horizontal: "h-px w-full",
			vertical: "w-px h-full"
		}
	},
	compoundVariants: [{
		variant: "pattern",
		orientation: "horizontal",
		class: "h-6 w-full border-y"
	}, {
		variant: "pattern",
		orientation: "vertical",
		class: "w-6 h-full border-x"
	}],
	defaultVariants: {
		variant: "default",
		orientation: "horizontal"
	}
}), rS = {
	key: 1,
	class: "text-xl leading-none"
}, iS = { class: "text-base font-semibold font-title text-foreground" }, aS = { class: "flex items-center gap-2" }, oS = {
	key: 1,
	class: "text-xl leading-none"
}, sS = {
	key: 3,
	class: "text-base font-semibold font-title text-foreground"
}, cS = "flex flex-col gap-3 mb-3", lS = {
	__name: "ReportSectionHeader",
	props: {
		title: {
			type: String,
			default: ""
		},
		icon: {
			type: String,
			default: ""
		},
		bordered: {
			type: Boolean,
			default: !0
		},
		columns: {
			type: Array,
			default: () => []
		}
	},
	setup(e) {
		let t = e, n = {
			clipboard: sf,
			"clipboard list": sf,
			comment: xf,
			comments: xf,
			lightbulb: gf,
			idea: gf,
			warning: jf,
			"warning sign": jf,
			check: ef,
			"check circle": ef,
			user: Mf,
			star: Ef,
			"thumbs up": kf,
			"thumbs down": Of,
			calendar: Kd,
			clock: cf,
			file: df,
			"file text": df,
			question: nf,
			help: nf
		}, r = J(() => t.columns.length > 0);
		function i(e) {
			if (!e) return null;
			let t = e.toLowerCase().trim();
			return n[t] || null;
		}
		function a(e) {
			return e ? /\p{Extended_Pictographic}/u.test(e) : !1;
		}
		function o(e) {
			return e === "ai_icon";
		}
		let s = J(() => i(t.icon)), c = J(() => a(t.icon)), l = J(() => o(t.icon));
		return (t, n) => r.value ? (V(), H("div", {
			key: 0,
			class: M(cS)
		}, [W("div", {
			class: "grid gap-4",
			style: Se({ gridTemplateColumns: `repeat(${e.columns.length}, 1fr)` })
		}, [(V(!0), H(B, null, R(e.columns, (e, t) => (V(), H("div", {
			key: t,
			class: "flex items-center gap-2"
		}, [o(e.icon) ? (V(), U(F(Rf), {
			key: 0,
			class: "size-5"
		})) : a(e.icon) ? (V(), H("span", rS, N(e.icon), 1)) : i(e.icon) ? (V(), U(ga(i(e.icon)), {
			key: 2,
			class: "size-5"
		})) : q("", !0), W("h3", iS, N(e.title), 1)]))), 128))], 4), e.bordered ? (V(), U(F(tS), { key: 0 })) : q("", !0)])) : e.title || e.icon ? (V(), H("div", {
			key: 1,
			class: M(cS)
		}, [W("div", aS, [l.value ? (V(), U(F(Rf), {
			key: 0,
			class: "size-5"
		})) : c.value ? (V(), H("span", oS, N(e.icon), 1)) : s.value ? (V(), U(ga(s.value), {
			key: 2,
			class: "size-5"
		})) : q("", !0), e.title ? (V(), H("h3", sS, N(e.title), 1)) : q("", !0)]), e.bordered ? (V(), U(F(tS), { key: 0 })) : q("", !0)])) : q("", !0);
	}
}, uS = {
	__name: "Tooltip",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		delayDuration: {
			type: Number,
			required: !1
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Qh(e, t);
		return (e, t) => (V(), U(F(Hx), De(us(F(n))), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, dS = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "TooltipContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qh(eh(n, "class"), r), a = Pd();
		return (e, t) => (V(), U(F(Kx), { to: F(a) }, {
			default: I(() => [G(F(Gx), gs({
				...F(i),
				...e.$attrs
			}, { class: F(hm)("z-99999 overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-xs text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", n.class) }), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["class"])]),
			_: 3
		}, 8, ["to"]));
	}
}), fS = {
	__name: "TooltipProvider",
	props: {
		delayDuration: {
			type: Number,
			required: !1
		},
		skipDelayDuration: {
			type: Number,
			required: !1
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(Rx), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, pS = {
	__name: "TooltipTrigger",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(qx), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
};
//#endregion
//#region node_modules/marked/lib/marked.esm.js
function mS() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var hS = mS();
function gS(e) {
	hS = e;
}
var _S = { exec: () => null };
function vS(e, t = "") {
	let n = typeof e == "string" ? e : e.source, r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(bS.caret, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
var yS = (() => {
	try {
		return !0;
	} catch {
		return !1;
	}
})(), bS = {
	codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
	outputLinkReplace: /\\([\[\]])/g,
	indentCodeCompensation: /^(\s+)(?:```)/,
	beginningSpace: /^\s+/,
	endingHash: /#$/,
	startingSpaceChar: /^ /,
	endingSpaceChar: / $/,
	nonSpaceChar: /[^ ]/,
	newLineCharGlobal: /\n/g,
	tabCharGlobal: /\t/g,
	multipleSpaceGlobal: /\s+/g,
	blankLine: /^[ \t]*$/,
	doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
	blockquoteStart: /^ {0,3}>/,
	blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
	blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
	listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
	listIsTask: /^\[[ xX]\] +\S/,
	listReplaceTask: /^\[[ xX]\] +/,
	listTaskCheckbox: /\[[ xX]\]/,
	anyLine: /\n.*\n/,
	hrefBrackets: /^<(.*)>$/,
	tableDelimiter: /[:|]/,
	tableAlignChars: /^\||\| *$/g,
	tableRowBlankLine: /\n[ \t]*$/,
	tableAlignRight: /^ *-+: *$/,
	tableAlignCenter: /^ *:-+: *$/,
	tableAlignLeft: /^ *:-+ *$/,
	startATag: /^<a /i,
	endATag: /^<\/a>/i,
	startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
	endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
	startAngleBracket: /^</,
	endAngleBracket: />$/,
	pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
	unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
	escapeTest: /[&<>"']/,
	escapeReplace: /[&<>"']/g,
	escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
	escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
	caret: /(^|[^\[])\^/g,
	percentDecode: /%25/g,
	findPipe: /\|/g,
	splitPipe: / \|/,
	slashPipe: /\\\|/g,
	carriageReturn: /\r\n|\r/g,
	spaceLine: /^ +$/gm,
	notSpaceStart: /^\S*/,
	endingNewline: /\n$/,
	listItemRegex: (e) => RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
	nextBulletRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
	hrRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
	fencesBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
	headingBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
	htmlBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, "i"),
	blockquoteBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}>`)
}, xS = /^(?:[ \t]*(?:\n|$))+/, SS = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, CS = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, wS = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, TS = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, ES = / {0,3}(?:[*+-]|\d{1,9}[.)])/, DS = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, OS = vS(DS).replace(/bull/g, ES).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), kS = vS(DS).replace(/bull/g, ES).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), AS = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, jS = /^[^\n]+/, MS = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, NS = vS(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", MS).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), PS = vS(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, ES).getRegex(), FS = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", IS = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, LS = vS("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", IS).replace("tag", FS).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), RS = vS(AS).replace("hr", wS).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", FS).getRegex(), zS = {
	blockquote: vS(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", RS).getRegex(),
	code: SS,
	def: NS,
	fences: CS,
	heading: TS,
	hr: wS,
	html: LS,
	lheading: OS,
	list: PS,
	newline: xS,
	paragraph: RS,
	table: _S,
	text: jS
}, BS = vS("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", wS).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", FS).getRegex(), VS = {
	...zS,
	lheading: kS,
	table: BS,
	paragraph: vS(AS).replace("hr", wS).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", BS).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", FS).getRegex()
}, HS = {
	...zS,
	html: vS("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", IS).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: _S,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: vS(AS).replace("hr", wS).replace("heading", " *#{1,6} *[^\n]").replace("lheading", OS).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, US = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, WS = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, GS = /^( {2,}|\\)\n(?!\s*$)/, KS = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, qS = /[\p{P}\p{S}]/u, JS = /[\s\p{P}\p{S}]/u, YS = /[^\s\p{P}\p{S}]/u, XS = vS(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, JS).getRegex(), ZS = /(?!~)[\p{P}\p{S}]/u, QS = /(?!~)[\s\p{P}\p{S}]/u, $S = /(?:[^\s\p{P}\p{S}]|~)/u, eC = vS(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", yS ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), tC = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, nC = vS(tC, "u").replace(/punct/g, qS).getRegex(), rC = vS(tC, "u").replace(/punct/g, ZS).getRegex(), iC = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", aC = vS(iC, "gu").replace(/notPunctSpace/g, YS).replace(/punctSpace/g, JS).replace(/punct/g, qS).getRegex(), oC = vS(iC, "gu").replace(/notPunctSpace/g, $S).replace(/punctSpace/g, QS).replace(/punct/g, ZS).getRegex(), sC = vS("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, YS).replace(/punctSpace/g, JS).replace(/punct/g, qS).getRegex(), cC = vS(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, qS).getRegex(), lC = vS("^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, YS).replace(/punctSpace/g, JS).replace(/punct/g, qS).getRegex(), uC = vS(/\\(punct)/, "gu").replace(/punct/g, qS).getRegex(), dC = vS(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), fC = vS(IS).replace("(?:-->|$)", "-->").getRegex(), pC = vS("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", fC).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), mC = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, hC = vS(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", mC).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), gC = vS(/^!?\[(label)\]\[(ref)\]/).replace("label", mC).replace("ref", MS).getRegex(), _C = vS(/^!?\[(ref)\](?:\[\])?/).replace("ref", MS).getRegex(), vC = vS("reflink|nolink(?!\\()", "g").replace("reflink", gC).replace("nolink", _C).getRegex(), yC = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, bC = {
	_backpedal: _S,
	anyPunctuation: uC,
	autolink: dC,
	blockSkip: eC,
	br: GS,
	code: WS,
	del: _S,
	delLDelim: _S,
	delRDelim: _S,
	emStrongLDelim: nC,
	emStrongRDelimAst: aC,
	emStrongRDelimUnd: sC,
	escape: US,
	link: hC,
	nolink: _C,
	punctuation: XS,
	reflink: gC,
	reflinkSearch: vC,
	tag: pC,
	text: KS,
	url: _S
}, xC = {
	...bC,
	link: vS(/^!?\[(label)\]\((.*?)\)/).replace("label", mC).getRegex(),
	reflink: vS(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", mC).getRegex()
}, SC = {
	...bC,
	emStrongRDelimAst: oC,
	emStrongLDelim: rC,
	delLDelim: cC,
	delRDelim: lC,
	url: vS(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", yC).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
	text: vS(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", yC).getRegex()
}, CC = {
	...SC,
	br: vS(GS).replace("{2,}", "*").getRegex(),
	text: vS(SC.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, wC = {
	normal: zS,
	gfm: VS,
	pedantic: HS
}, TC = {
	normal: bC,
	gfm: SC,
	breaks: CC,
	pedantic: xC
}, EC = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, DC = (e) => EC[e];
function OC(e, t) {
	if (t) {
		if (bS.escapeTest.test(e)) return e.replace(bS.escapeReplace, DC);
	} else if (bS.escapeTestNoEncode.test(e)) return e.replace(bS.escapeReplaceNoEncode, DC);
	return e;
}
function kC(e) {
	try {
		e = encodeURI(e).replace(bS.percentDecode, "%");
	} catch {
		return null;
	}
	return e;
}
function AC(e, t) {
	let n = e.replace(bS.findPipe, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(bS.splitPipe), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(bS.slashPipe, "|");
	return n;
}
function jC(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function MC(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return n > 0 ? -2 : -1;
}
function NC(e, t = 0) {
	let n = t, r = "";
	for (let t of e) if (t === "	") {
		let e = 4 - n % 4;
		r += " ".repeat(e), n += e;
	} else r += t, n++;
	return r;
}
function PC(e, t, n, r, i) {
	let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, "$1");
	r.state.inLink = !0;
	let c = {
		type: e[0].charAt(0) === "!" ? "image" : "link",
		raw: n,
		href: a,
		title: o,
		text: s,
		tokens: r.inlineTokens(s)
	};
	return r.state.inLink = !1, c;
}
function FC(e, t, n) {
	let r = e.match(n.other.indentCodeCompensation);
	if (r === null) return t;
	let i = r[1];
	return t.split("\n").map((e) => {
		let t = e.match(n.other.beginningSpace);
		if (t === null) return e;
		let [r] = t;
		return r.length >= i.length ? e.slice(i.length) : e;
	}).join("\n");
}
var IC = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || hS;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = t[0].replace(this.rules.other.codeRemoveIndent, "");
			return {
				type: "code",
				raw: t[0],
				codeBlockStyle: "indented",
				text: this.options.pedantic ? e : jC(e, "\n")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = FC(e, t[3] || "", this.rules);
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (this.rules.other.endingHash.test(e)) {
				let t = jC(e, "#");
				(this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: t[0],
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: jC(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = jC(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
				n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i.at(-1);
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.blockquote(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
					break;
				}
				if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = this.rules.other.listItemRegex(n), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = NC(t[2].split("\n", 1)[0], t[1].length), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), f = this.rules.other.blockquoteBeginRegex(d);
					for (; e;) {
						let p = e.split("\n", 1)[0], m;
						if (l = p, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, "  "), m = l) : m = l.replace(this.rules.other.tabCharGlobal, "    "), i.test(l) || a.test(l) || o.test(l) || f.test(l) || t.test(l) || n.test(l)) break;
						if (m.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += "\n" + m.slice(d);
						else {
							if (u || c.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						u = !l.trim(), r += p + "\n", e = e.substring(p.length + 1), c = m.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
					type: "list_item",
					raw: r,
					task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			let s = i.items.at(-1);
			if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
			else return;
			i.raw = i.raw.trimEnd();
			for (let e of i.items) {
				if (this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []), e.task) {
					if (e.text = e.text.replace(this.rules.other.listReplaceTask, ""), e.tokens[0]?.type === "text" || e.tokens[0]?.type === "paragraph") {
						e.tokens[0].raw = e.tokens[0].raw.replace(this.rules.other.listReplaceTask, ""), e.tokens[0].text = e.tokens[0].text.replace(this.rules.other.listReplaceTask, "");
						for (let e = this.lexer.inlineQueue.length - 1; e >= 0; e--) if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
							this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, "");
							break;
						}
					}
					let t = this.rules.other.listTaskCheckbox.exec(e.raw);
					if (t) {
						let n = {
							type: "checkbox",
							raw: t[0] + " ",
							checked: t[0] !== "[ ]"
						};
						e.checked = n.checked, i.loose ? e.tokens[0] && ["paragraph", "text"].includes(e.tokens[0].type) && "tokens" in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = n.raw + e.tokens[0].raw, e.tokens[0].text = n.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(n)) : e.tokens.unshift({
							type: "paragraph",
							raw: n.raw,
							text: n.raw,
							tokens: [n]
						}) : e.tokens.unshift(n);
					}
				}
				if (!i.loose) {
					let t = e.tokens.filter((e) => e.type === "space");
					i.loose = t.length > 0 && t.some((e) => this.rules.other.anyLine.test(e.raw));
				}
			}
			if (i.loose) for (let e of i.items) {
				e.loose = !0;
				for (let t of e.tokens) t.type === "text" && (t.type = "paragraph");
			}
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) return {
			type: "html",
			block: !0,
			raw: t[0],
			pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
			text: t[0]
		};
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: t[0],
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
		let n = AC(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [], a = {
			type: "table",
			raw: t[0],
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) this.rules.other.tableAlignRight.test(e) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(e) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(AC(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) {
			let e = t[1].trim();
			return {
				type: "heading",
				raw: t[0],
				depth: t[2].charAt(0) === "=" ? 1 : 2,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: t[1]
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
				if (!this.rules.other.endAngleBracket.test(e)) return;
				let t = jC(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = MC(t[2], "()");
				if (e === -2) return;
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = this.rules.other.pedanticHrefTitle.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), PC(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer, this.rules);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return PC(n, e, n[0], this.lexer, this.rules);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				}
				if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e, t, n = "") {
		let r = this.rules.inline.delLDelim.exec(e);
		if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
			for (s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [...i].length, a !== n)) continue;
				if (r[3] || r[4]) {
					o += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o);
				let t = [...r[0]][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
				return {
					type: "del",
					raw: s,
					text: c,
					tokens: this.lexer.inlineTokens(c)
				};
			}
		}
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = t[1], n = "mailto:" + e) : (e = t[1], n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = t[0], n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = t[0], n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e = this.lexer.state.inRawBlock;
			return {
				type: "text",
				raw: t[0],
				text: t[0],
				escaped: e
			};
		}
	}
}, LC = class e {
	tokens;
	options;
	state;
	inlineQueue;
	tokenizer;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || hS, this.options.tokenizer = this.options.tokenizer || new IC(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			other: bS,
			block: wC.normal,
			inline: TC.normal
		};
		this.options.pedantic ? (t.block = wC.pedantic, t.inline = TC.pedantic) : this.options.gfm && (t.block = wC.gfm, t.inline = this.options.breaks ? TC.breaks : TC.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: wC,
			inline: TC
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(bS.carriageReturn, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		for (this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(bS.tabCharGlobal, "    ").replace(bS.spaceLine, "")); e;) {
			let r;
			if (this.options.extensions?.block?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.space(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.raw.length === 1 && n !== void 0 ? n.raw += "\n" : t.push(r);
				continue;
			}
			if (r = this.tokenizer.code(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + r.raw, n.text += "\n" + r.text, this.inlineQueue.at(-1).src = n.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.fences(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.heading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.hr(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.blockquote(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.list(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.html(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.def(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + r.raw, n.text += "\n" + r.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
					href: r.href,
					title: r.title
				}, t.push(r));
				continue;
			}
			if (r = this.tokenizer.table(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.lheading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (this.state.top && (r = this.tokenizer.paragraph(i))) {
				let a = t.at(-1);
				n && a?.type === "paragraph" ? (a.raw += (a.raw.endsWith("\n") ? "" : "\n") + r.raw, a.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
				continue;
			}
			if (r = this.tokenizer.text(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				}
				throw Error(t);
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		this.tokenizer.lexer = this;
		let n = e, r = null;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;) e.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;) n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		let i;
		for (; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;) i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		n = this.options.hooks?.emStrongMask?.call({ lexer: this }, n) ?? n;
		let a = !1, o = "";
		for (; e;) {
			a || (o = ""), a = !1;
			let r;
			if (this.options.extensions?.inline?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.escape(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.tag(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.link(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.type === "text" && n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.emStrong(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.codespan(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.br(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.del(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.autolink(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (!this.state.inLink && (r = this.tokenizer.url(e))) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (r = this.tokenizer.inlineText(i)) {
				e = e.substring(r.raw.length), r.raw.slice(-1) !== "_" && (o = r.raw.slice(-1)), a = !0;
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				}
				throw Error(t);
			}
		}
		return t;
	}
}, RC = class {
	options;
	parser;
	constructor(e) {
		this.options = e || hS;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(bS.notSpaceStart)?.[0], i = e.replace(bS.endingNewline, "") + "\n";
		return r ? "<pre><code class=\"language-" + OC(r) + "\">" + (n ? i : OC(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : OC(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
	}
	html({ text: e }) {
		return e;
	}
	def(e) {
		return "";
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		return `<li>${this.parser.parse(e.tokens)}</li>
`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\"> ";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>
`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r &&= `<tbody>${r}</tbody>`, "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>
${e}</tr>
`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${OC(e, !0)}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, tokens: n }) {
		let r = this.parser.parseInline(n), i = kC(e);
		if (i === null) return r;
		e = i;
		let a = "<a href=\"" + e + "\"";
		return t && (a += " title=\"" + OC(t) + "\""), a += ">" + r + "</a>", a;
	}
	image({ href: e, title: t, text: n, tokens: r }) {
		r && (n = this.parser.parseInline(r, this.parser.textRenderer));
		let i = kC(e);
		if (i === null) return OC(n);
		e = i;
		let a = `<img src="${e}" alt="${OC(n)}"`;
		return t && (a += ` title="${OC(t)}"`), a += ">", a;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : OC(e.text);
	}
}, zC = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
	checkbox({ raw: e }) {
		return e;
	}
}, BC = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || hS, this.options.renderer = this.options.renderer || new RC(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new zC();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e) {
		this.renderer.parser = this;
		let t = "";
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (this.options.extensions?.renderers?.[r.type]) {
				let e = r, n = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (n !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"def",
					"paragraph",
					"text"
				].includes(e.type)) {
					t += n || "";
					continue;
				}
			}
			let i = r;
			switch (i.type) {
				case "space":
					t += this.renderer.space(i);
					break;
				case "hr":
					t += this.renderer.hr(i);
					break;
				case "heading":
					t += this.renderer.heading(i);
					break;
				case "code":
					t += this.renderer.code(i);
					break;
				case "table":
					t += this.renderer.table(i);
					break;
				case "blockquote":
					t += this.renderer.blockquote(i);
					break;
				case "list":
					t += this.renderer.list(i);
					break;
				case "checkbox":
					t += this.renderer.checkbox(i);
					break;
				case "html":
					t += this.renderer.html(i);
					break;
				case "def":
					t += this.renderer.def(i);
					break;
				case "paragraph":
					t += this.renderer.paragraph(i);
					break;
				case "text":
					t += this.renderer.text(i);
					break;
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return t;
	}
	parseInline(e, t = this.renderer) {
		this.renderer.parser = this;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "checkbox":
					n += t.checkbox(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, VC = class {
	options;
	block;
	constructor(e) {
		this.options = e || hS;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens",
		"emStrongMask"
	]);
	static passThroughHooksRespectAsync = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
	emStrongMask(e) {
		return e;
	}
	provideLexer(e = this.block) {
		return e ? LC.lex : LC.lexInline;
	}
	provideParser(e = this.block) {
		return e ? BC.parse : BC.parseInline;
	}
}, HC = new class {
	defaults = mS();
	options = this.setOptions;
	parse = this.parseMarkdown(!0);
	parseInline = this.parseMarkdown(!1);
	Parser = BC;
	Renderer = RC;
	TextRenderer = zC;
	Lexer = LC;
	Tokenizer = IC;
	Hooks = VC;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new RC(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new IC(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new VC();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (["options", "block"].includes(n)) continue;
					let r = n, i = e.hooks[r], a = t[r];
					t[r] = VC.passThroughHooks.has(n) ? (e) => {
						if (this.defaults.async && VC.passThroughHooksRespectAsync.has(n)) return (async () => {
							let n = await i.call(t, e);
							return a.call(t, n);
						})();
						let r = i.call(t, e);
						return a.call(t, r);
					} : (...e) => {
						if (this.defaults.async) return (async () => {
							let n = await i.apply(t, e);
							return n === !1 && (n = await a.apply(t, e)), n;
						})();
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return LC.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return BC.parse(e, t ?? this.defaults);
	}
	parseMarkdown(e) {
		return (t, n) => {
			let r = { ...n }, i = {
				...this.defaults,
				...r
			}, a = this.onError(!!i.silent, !!i.async);
			if (this.defaults.async === !0 && r.async === !1) return a(/* @__PURE__ */ Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (typeof t > "u" || t === null) return a(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof t != "string") return a(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
			if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async () => {
				let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer(e) : e ? LC.lex : LC.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
				i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
				let o = await (i.hooks ? await i.hooks.provideParser(e) : e ? BC.parse : BC.parseInline)(a, i);
				return i.hooks ? await i.hooks.postprocess(o) : o;
			})().catch(a);
			try {
				i.hooks && (t = i.hooks.preprocess(t));
				let n = (i.hooks ? i.hooks.provideLexer(e) : e ? LC.lex : LC.lexInline)(t, i);
				i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
				let r = (i.hooks ? i.hooks.provideParser(e) : e ? BC.parse : BC.parseInline)(n, i);
				return i.hooks && (r = i.hooks.postprocess(r)), r;
			} catch (e) {
				return a(e);
			}
		};
	}
	onError(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + OC(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}();
function UC(e, t) {
	return HC.parse(e, t);
}
UC.options = UC.setOptions = function(e) {
	return HC.setOptions(e), UC.defaults = HC.defaults, gS(UC.defaults), UC;
}, UC.getDefaults = mS, UC.defaults = hS, UC.use = function(...e) {
	return HC.use(...e), UC.defaults = HC.defaults, gS(UC.defaults), UC;
}, UC.walkTokens = function(e, t) {
	return HC.walkTokens(e, t);
}, UC.parseInline = HC.parseInline, UC.Parser = BC, UC.parser = BC.parse, UC.Renderer = RC, UC.TextRenderer = zC, UC.Lexer = LC, UC.lexer = LC.lex, UC.Tokenizer = IC, UC.Hooks = VC, UC.parse = UC, UC.options, UC.setOptions, UC.use, UC.walkTokens, UC.parseInline, BC.parse, LC.lex;
//#endregion
//#region node_modules/dompurify/dist/purify.es.mjs
function WC(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function GC(e) {
	if (Array.isArray(e)) return e;
}
function KC(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function qC() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function JC(e, t) {
	return GC(e) || KC(e, t) || YC(e, t) || qC();
}
function YC(e, t) {
	if (e) {
		if (typeof e == "string") return WC(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? WC(e, t) : void 0;
	}
}
var XC = Object.entries, ZC = Object.setPrototypeOf, QC = Object.isFrozen, $C = Object.getPrototypeOf, ew = Object.getOwnPropertyDescriptor, tw = Object.freeze, nw = Object.seal, rw = Object.create, iw = typeof Reflect < "u" && Reflect, aw = iw.apply, ow = iw.construct;
tw ||= function(e) {
	return e;
}, nw ||= function(e) {
	return e;
}, aw ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, ow ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var sw = Dw(Array.prototype.forEach), cw = Dw(Array.prototype.lastIndexOf), lw = Dw(Array.prototype.pop), uw = Dw(Array.prototype.push), dw = Dw(Array.prototype.splice), fw = Array.isArray, pw = Dw(String.prototype.toLowerCase), mw = Dw(String.prototype.toString), hw = Dw(String.prototype.match), gw = Dw(String.prototype.replace), _w = Dw(String.prototype.indexOf), vw = Dw(String.prototype.trim), yw = Dw(Number.prototype.toString), bw = Dw(Boolean.prototype.toString), xw = typeof BigInt > "u" ? null : Dw(BigInt.prototype.toString), Sw = typeof Symbol > "u" ? null : Dw(Symbol.prototype.toString), Cw = Dw(Object.prototype.hasOwnProperty), ww = Dw(Object.prototype.toString), Tw = Dw(RegExp.prototype.test), Ew = Ow(TypeError);
function Dw(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return aw(e, t, n);
	};
}
function Ow(e) {
	return function() {
		return ow(e, [...arguments]);
	};
}
function kw(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : pw;
	if (ZC && ZC(e, null), !fw(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (QC(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function Aw(e) {
	for (let t = 0; t < e.length; t++) Cw(e, t) || (e[t] = null);
	return e;
}
function jw(e) {
	let t = rw(null);
	for (let r of XC(e)) {
		var n = JC(r, 2);
		let i = n[0], a = n[1];
		Cw(e, i) && (t[i] = fw(a) ? Aw(a) : a && typeof a == "object" && a.constructor === Object ? jw(a) : a);
	}
	return t;
}
function Mw(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return yw(e);
		case "boolean": return bw(e);
		case "bigint": return xw ? xw(e) : "0";
		case "symbol": return Sw ? Sw(e) : "Symbol()";
		case "undefined": return ww(e);
		case "function":
		case "object": {
			if (e === null) return ww(e);
			let t = e, n = Nw(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : ww(e);
			}
			return ww(e);
		}
		default: return ww(e);
	}
}
function Nw(e, t) {
	for (; e !== null;) {
		let n = ew(e, t);
		if (n) {
			if (n.get) return Dw(n.get);
			if (typeof n.value == "function") return Dw(n.value);
		}
		e = $C(e);
	}
	function n() {
		return null;
	}
	return n;
}
function Pw(e) {
	try {
		return Tw(e, ""), !0;
	} catch {
		return !1;
	}
}
var Fw = tw(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), Iw = tw(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), Lw = tw([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), Rw = tw([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), zw = tw(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), Bw = tw([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), Vw = tw(["#text"]), Hw = tw(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), Uw = tw(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), Ww = tw(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), Gw = tw([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), Kw = nw(/{{[\w\W]*|^[\w\W]*}}/g), qw = nw(/<%[\w\W]*|^[\w\W]*%>/g), Jw = nw(/\${[\w\W]*/g), Yw = nw(/^data-[\-\w.\u00B7-\uFFFF]+$/), Xw = nw(/^aria-[\-\w]+$/), Zw = nw(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Qw = nw(/^(?:\w+script|data):/i), $w = nw(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), eT = nw(/^html$/i), tT = nw(/^[a-z][.\w]*(-[.\w]+)+$/i), nT = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	progressingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, rT = function() {
	return typeof window > "u" ? null : window;
}, iT = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, aT = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
};
function oT() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : rT(), t = (e) => oT(e);
	if (t.version = "3.4.7", t.removed = [], !e || !e.document || e.document.nodeType !== nT.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = Nw(d, "cloneNode"), p = Nw(d, "remove"), m = Nw(d, "nextSibling"), h = Nw(d, "childNodes"), g = Nw(d, "parentNode"), _ = Nw(d, "shadowRoot"), v = Nw(d, "attributes"), y = o && o.prototype ? Nw(o.prototype, "nodeType") : null, b = o && o.prototype ? Nw(o.prototype, "nodeName") : null;
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let x, S = "", C = n, w = C.implementation, T = C.createNodeIterator, E = C.createDocumentFragment, ee = C.getElementsByTagName, D = r.importNode, O = aT();
	t.isSupported = typeof XC == "function" && typeof g == "function" && w && w.createHTMLDocument !== void 0;
	let te = Kw, k = qw, ne = Jw, re = Yw, ie = Xw, ae = Qw, A = $w, oe = tT, se = Zw, ce = null, le = kw({}, [
		...Fw,
		...Iw,
		...Lw,
		...zw,
		...Vw
	]), j = null, ue = kw({}, [
		...Hw,
		...Uw,
		...Ww,
		...Gw
	]), de = Object.seal(rw(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), fe = null, pe = null, me = Object.seal(rw(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), he = !0, ge = !0, _e = !1, ve = !0, ye = !1, be = !0, xe = !1, Se = !1, Ce = !1, we = !1, Te = !1, Ee = !1, M = !0, De = !1, Oe = "user-content-", ke = !0, Ae = !1, je = {}, Me = null, Ne = kw({}, [
		"annotation-xml",
		"audio",
		"colgroup",
		"desc",
		"foreignobject",
		"head",
		"iframe",
		"math",
		"mi",
		"mn",
		"mo",
		"ms",
		"mtext",
		"noembed",
		"noframes",
		"noscript",
		"plaintext",
		"script",
		"style",
		"svg",
		"template",
		"thead",
		"title",
		"video",
		"xmp"
	]), Pe = null, N = kw({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), Fe = null, Ie = kw({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), Le = "http://www.w3.org/1998/Math/MathML", Re = "http://www.w3.org/2000/svg", ze = "http://www.w3.org/1999/xhtml", Be = ze, Ve = !1, He = null, Ue = kw({}, [
		Le,
		Re,
		ze
	], mw), We = kw({}, [
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), Ge = kw({}, ["annotation-xml"]), Ke = kw({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), qe = null, Je = ["application/xhtml+xml", "text/html"], Ye = null, Xe = null, Ze = n.createElement("form"), Qe = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, $e = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (Xe && Xe === e) return;
		(!e || typeof e != "object") && (e = {}), e = jw(e), qe = Je.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, Ye = qe === "application/xhtml+xml" ? mw : pw, ce = Cw(e, "ALLOWED_TAGS") && fw(e.ALLOWED_TAGS) ? kw({}, e.ALLOWED_TAGS, Ye) : le, j = Cw(e, "ALLOWED_ATTR") && fw(e.ALLOWED_ATTR) ? kw({}, e.ALLOWED_ATTR, Ye) : ue, He = Cw(e, "ALLOWED_NAMESPACES") && fw(e.ALLOWED_NAMESPACES) ? kw({}, e.ALLOWED_NAMESPACES, mw) : Ue, Fe = Cw(e, "ADD_URI_SAFE_ATTR") && fw(e.ADD_URI_SAFE_ATTR) ? kw(jw(Ie), e.ADD_URI_SAFE_ATTR, Ye) : Ie, Pe = Cw(e, "ADD_DATA_URI_TAGS") && fw(e.ADD_DATA_URI_TAGS) ? kw(jw(N), e.ADD_DATA_URI_TAGS, Ye) : N, Me = Cw(e, "FORBID_CONTENTS") && fw(e.FORBID_CONTENTS) ? kw({}, e.FORBID_CONTENTS, Ye) : Ne, fe = Cw(e, "FORBID_TAGS") && fw(e.FORBID_TAGS) ? kw({}, e.FORBID_TAGS, Ye) : jw({}), pe = Cw(e, "FORBID_ATTR") && fw(e.FORBID_ATTR) ? kw({}, e.FORBID_ATTR, Ye) : jw({}), je = Cw(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? jw(e.USE_PROFILES) : e.USE_PROFILES : !1, he = e.ALLOW_ARIA_ATTR !== !1, ge = e.ALLOW_DATA_ATTR !== !1, _e = e.ALLOW_UNKNOWN_PROTOCOLS || !1, ve = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ye = e.SAFE_FOR_TEMPLATES || !1, be = e.SAFE_FOR_XML !== !1, xe = e.WHOLE_DOCUMENT || !1, we = e.RETURN_DOM || !1, Te = e.RETURN_DOM_FRAGMENT || !1, Ee = e.RETURN_TRUSTED_TYPE || !1, Ce = e.FORCE_BODY || !1, M = e.SANITIZE_DOM !== !1, De = e.SANITIZE_NAMED_PROPS || !1, ke = e.KEEP_CONTENT !== !1, Ae = e.IN_PLACE || !1, se = Pw(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : Zw, Be = typeof e.NAMESPACE == "string" ? e.NAMESPACE : ze, We = Cw(e, "MATHML_TEXT_INTEGRATION_POINTS") && e.MATHML_TEXT_INTEGRATION_POINTS && typeof e.MATHML_TEXT_INTEGRATION_POINTS == "object" ? jw(e.MATHML_TEXT_INTEGRATION_POINTS) : kw({}, [
			"mi",
			"mo",
			"mn",
			"ms",
			"mtext"
		]), Ge = Cw(e, "HTML_INTEGRATION_POINTS") && e.HTML_INTEGRATION_POINTS && typeof e.HTML_INTEGRATION_POINTS == "object" ? jw(e.HTML_INTEGRATION_POINTS) : kw({}, ["annotation-xml"]);
		let t = Cw(e, "CUSTOM_ELEMENT_HANDLING") && e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING == "object" ? jw(e.CUSTOM_ELEMENT_HANDLING) : rw(null);
		if (de = rw(null), Cw(t, "tagNameCheck") && Qe(t.tagNameCheck) && (de.tagNameCheck = t.tagNameCheck), Cw(t, "attributeNameCheck") && Qe(t.attributeNameCheck) && (de.attributeNameCheck = t.attributeNameCheck), Cw(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (de.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), ye && (ge = !1), Te && (we = !0), je && (ce = kw({}, Vw), j = rw(null), je.html === !0 && (kw(ce, Fw), kw(j, Hw)), je.svg === !0 && (kw(ce, Iw), kw(j, Uw), kw(j, Gw)), je.svgFilters === !0 && (kw(ce, Lw), kw(j, Uw), kw(j, Gw)), je.mathMl === !0 && (kw(ce, zw), kw(j, Ww), kw(j, Gw))), me.tagCheck = null, me.attributeCheck = null, Cw(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? me.tagCheck = e.ADD_TAGS : fw(e.ADD_TAGS) && (ce === le && (ce = jw(ce)), kw(ce, e.ADD_TAGS, Ye))), Cw(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? me.attributeCheck = e.ADD_ATTR : fw(e.ADD_ATTR) && (j === ue && (j = jw(j)), kw(j, e.ADD_ATTR, Ye))), Cw(e, "ADD_URI_SAFE_ATTR") && fw(e.ADD_URI_SAFE_ATTR) && kw(Fe, e.ADD_URI_SAFE_ATTR, Ye), Cw(e, "FORBID_CONTENTS") && fw(e.FORBID_CONTENTS) && (Me === Ne && (Me = jw(Me)), kw(Me, e.FORBID_CONTENTS, Ye)), Cw(e, "ADD_FORBID_CONTENTS") && fw(e.ADD_FORBID_CONTENTS) && (Me === Ne && (Me = jw(Me)), kw(Me, e.ADD_FORBID_CONTENTS, Ye)), ke && (ce["#text"] = !0), xe && kw(ce, [
			"html",
			"head",
			"body"
		]), ce.table && (kw(ce, ["tbody"]), delete fe.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw Ew("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw Ew("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			x = e.TRUSTED_TYPES_POLICY, S = x.createHTML("");
		} else x === void 0 && (x = iT(u, i)), x !== null && typeof S == "string" && (S = x.createHTML(""));
		(O.uponSanitizeElement.length > 0 || O.uponSanitizeAttribute.length > 0) && ce === le && (ce = jw(ce)), O.uponSanitizeAttribute.length > 0 && j === ue && (j = jw(j)), tw && tw(e), Xe = e;
	}, et = kw({}, [
		...Iw,
		...Lw,
		...Rw
	]), tt = kw({}, [...zw, ...Bw]), nt = function(e) {
		let t = g(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Be,
			tagName: "template"
		});
		let n = pw(e.tagName), r = pw(t.tagName);
		return He[e.namespaceURI] ? e.namespaceURI === Re ? t.namespaceURI === ze ? n === "svg" : t.namespaceURI === Le ? n === "svg" && (r === "annotation-xml" || We[r]) : !!et[n] : e.namespaceURI === Le ? t.namespaceURI === ze ? n === "math" : t.namespaceURI === Re ? n === "math" && Ge[r] : !!tt[n] : e.namespaceURI === ze ? t.namespaceURI === Re && !Ge[r] || t.namespaceURI === Le && !We[r] ? !1 : !tt[n] && (Ke[n] || !et[n]) : !!(qe === "application/xhtml+xml" && He[e.namespaceURI]) : !1;
	}, rt = function(e) {
		uw(t.removed, { element: e });
		try {
			g(e).removeChild(e);
		} catch {
			p(e);
		}
	}, it = function(e, n) {
		try {
			uw(t.removed, {
				attribute: n.getAttributeNode(e),
				from: n
			});
		} catch {
			uw(t.removed, {
				attribute: null,
				from: n
			});
		}
		if (n.removeAttribute(e), e === "is") if (we || Te) try {
			rt(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, at = function(e) {
		let t = null, r = null;
		if (Ce) e = "<remove></remove>" + e;
		else {
			let t = hw(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		qe === "application/xhtml+xml" && Be === ze && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = x ? x.createHTML(e) : e;
		if (Be === ze) try {
			t = new l().parseFromString(i, qe);
		} catch {}
		if (!t || !t.documentElement) {
			t = w.createDocument(Be, "template", null);
			try {
				t.documentElement.innerHTML = Ve ? S : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Be === ze ? ee.call(t, xe ? "html" : "body")[0] : xe ? t.documentElement : a;
	}, ot = function(e) {
		return T.call(e.ownerDocument || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, st = function(e) {
		e.normalize();
		let t = T.call(e.ownerDocument || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), n = t.nextNode();
		for (; n;) {
			let e = n.data;
			sw([
				te,
				k,
				ne
			], (t) => {
				e = gw(e, t, " ");
			}), n.data = e, n = t.nextNode();
		}
	}, ct = function(e) {
		let t = b ? b(e) : null;
		return typeof t != "string" || Ye(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== v(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== y(e) || e.childNodes !== h(e);
	}, lt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return y(e) === nT.documentFragment;
		} catch {
			return !1;
		}
	}, ut = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return typeof y(e) == "number";
		} catch {
			return !1;
		}
	};
	function dt(e, n, r) {
		sw(e, (e) => {
			e.call(t, n, r, Xe);
		});
	}
	let ft = function(e) {
		let n = null;
		if (dt(O.beforeSanitizeElements, e, null), ct(e)) return rt(e), !0;
		let r = Ye(e.nodeName);
		if (dt(O.uponSanitizeElement, e, {
			tagName: r,
			allowedTags: ce
		}), be && e.hasChildNodes() && !ut(e.firstElementChild) && Tw(/<[/\w!]/g, e.innerHTML) && Tw(/<[/\w!]/g, e.textContent) || be && e.namespaceURI === ze && r === "style" && ut(e.firstElementChild) || e.nodeType === nT.progressingInstruction || be && e.nodeType === nT.comment && Tw(/<[/\w]/g, e.data)) return rt(e), !0;
		if (fe[r] || !(me.tagCheck instanceof Function && me.tagCheck(r)) && !ce[r]) {
			if (!fe[r] && ht(r) && (de.tagNameCheck instanceof RegExp && Tw(de.tagNameCheck, r) || de.tagNameCheck instanceof Function && de.tagNameCheck(r))) return !1;
			if (ke && !Me[r]) {
				let t = g(e), n = h(e);
				if (n && t) {
					let r = n.length;
					for (let i = r - 1; i >= 0; --i) {
						let r = f(n[i], !0);
						t.insertBefore(r, m(e));
					}
				}
			}
			return rt(e), !0;
		}
		return (y ? y(e) : e.nodeType) === nT.element && !nt(e) || (r === "noscript" || r === "noembed" || r === "noframes") && Tw(/<\/no(script|embed|frames)/i, e.innerHTML) ? (rt(e), !0) : (ye && e.nodeType === nT.text && (n = e.textContent, sw([
			te,
			k,
			ne
		], (e) => {
			n = gw(n, e, " ");
		}), e.textContent !== n && (uw(t.removed, { element: e.cloneNode() }), e.textContent = n)), dt(O.afterSanitizeElements, e, null), !1);
	}, pt = function(e, t, r) {
		if (pe[t] || M && (t === "id" || t === "name") && (r in n || r in Ze)) return !1;
		let i = j[t] || me.attributeCheck instanceof Function && me.attributeCheck(t, e);
		if (!(ge && !pe[t] && Tw(re, t)) && !(he && Tw(ie, t))) {
			if (!i || pe[t]) {
				if (!(ht(e) && (de.tagNameCheck instanceof RegExp && Tw(de.tagNameCheck, e) || de.tagNameCheck instanceof Function && de.tagNameCheck(e)) && (de.attributeNameCheck instanceof RegExp && Tw(de.attributeNameCheck, t) || de.attributeNameCheck instanceof Function && de.attributeNameCheck(t, e)) || t === "is" && de.allowCustomizedBuiltInElements && (de.tagNameCheck instanceof RegExp && Tw(de.tagNameCheck, r) || de.tagNameCheck instanceof Function && de.tagNameCheck(r)))) return !1;
			} else if (!Fe[t] && !Tw(se, gw(r, A, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && _w(r, "data:") === 0 && Pe[e]) && !(_e && !Tw(ae, gw(r, A, ""))) && r) return !1;
		}
		return !0;
	}, mt = kw({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), ht = function(e) {
		return !mt[pw(e)] && Tw(oe, e);
	}, gt = function(e) {
		dt(O.beforeSanitizeAttributes, e, null);
		let n = e.attributes;
		if (!n || ct(e)) return;
		let r = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: j,
			forceKeepAttr: void 0
		}, i = n.length;
		for (; i--;) {
			let a = n[i], o = a.name, s = a.namespaceURI, c = a.value, l = Ye(o), d = c, f = o === "value" ? d : vw(d);
			if (r.attrName = l, r.attrValue = f, r.keepAttr = !0, r.forceKeepAttr = void 0, dt(O.uponSanitizeAttribute, e, r), f = r.attrValue, De && (l === "id" || l === "name") && _w(f, Oe) !== 0 && (it(o, e), f = Oe + f), be && Tw(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, f)) {
				it(o, e);
				continue;
			}
			if (l === "attributename" && hw(f, "href")) {
				it(o, e);
				continue;
			}
			if (r.forceKeepAttr) continue;
			if (!r.keepAttr) {
				it(o, e);
				continue;
			}
			if (!ve && Tw(/\/>/i, f)) {
				it(o, e);
				continue;
			}
			ye && sw([
				te,
				k,
				ne
			], (e) => {
				f = gw(f, e, " ");
			});
			let p = Ye(e.nodeName);
			if (!pt(p, l, f)) {
				it(o, e);
				continue;
			}
			if (x && typeof u == "object" && typeof u.getAttributeType == "function" && !s) switch (u.getAttributeType(p, l)) {
				case "TrustedHTML":
					f = x.createHTML(f);
					break;
				case "TrustedScriptURL": f = x.createScriptURL(f);
			}
			if (f !== d) try {
				s ? e.setAttributeNS(s, o, f) : e.setAttribute(o, f), ct(e) ? rt(e) : lw(t.removed);
			} catch {
				it(o, e);
			}
		}
		dt(O.afterSanitizeAttributes, e, null);
	}, _t = function(e) {
		let t = null, n = ot(e);
		for (dt(O.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (dt(O.uponSanitizeShadowNode, t, null), ft(t), gt(t), lt(t.content) && _t(t.content), (y ? y(t) : t.nodeType) === nT.element) {
			let e = _ ? _(t) : t.shadowRoot;
			lt(e) && (vt(e), _t(e));
		}
		dt(O.afterSanitizeShadowDOM, e, null);
	}, vt = function(e) {
		let t = y ? y(e) : e.nodeType;
		if (t === nT.element) {
			let t = _ ? _(e) : e.shadowRoot;
			lt(t) && (vt(t), _t(t));
		}
		let n = h ? h(e) : e.childNodes;
		if (!n) return;
		let r = [];
		sw(n, (e) => {
			uw(r, e);
		});
		for (let e of r) vt(e);
		if (t === nT.element) {
			let t = b ? b(e) : null;
			if (typeof t == "string" && Ye(t) === "template") {
				let t = e.content;
				lt(t) && vt(t);
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (Ve = !e, Ve && (e = "<!-->"), typeof e != "string" && !ut(e) && (e = Mw(e), typeof e != "string")) throw Ew("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		if (Se || $e(n), t.removed = [], typeof e == "string" && (Ae = !1), Ae) {
			let t = b ? b(e) : e.nodeName;
			if (typeof t == "string") {
				let e = Ye(t);
				if (!ce[e] || fe[e]) throw Ew("root node is forbidden and cannot be sanitized in-place");
			}
			if (ct(e)) throw Ew("root node is clobbered and cannot be sanitized in-place");
			vt(e);
		} else if (ut(e)) i = at("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === nT.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), vt(a);
		else {
			if (!we && !ye && !xe && e.indexOf("<") === -1) return x && Ee ? x.createHTML(e) : e;
			if (i = at(e), !i) return we ? null : Ee ? S : "";
		}
		i && Ce && rt(i.firstChild);
		let c = ot(Ae ? e : i);
		for (; o = c.nextNode();) ft(o), gt(o), lt(o.content) && _t(o.content);
		if (Ae) return ye && st(e), e;
		if (we) {
			if (ye && st(i), Te) for (s = E.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (j.shadowroot || j.shadowrootmode) && (s = D.call(r, s, !0)), s;
		}
		let l = xe ? i.outerHTML : i.innerHTML;
		return xe && ce["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && Tw(eT, i.ownerDocument.doctype.name) && (l = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + l), ye && sw([
			te,
			k,
			ne
		], (e) => {
			l = gw(l, e, " ");
		}), x && Ee ? x.createHTML(l) : l;
	}, t.setConfig = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		$e(e), Se = !0;
	}, t.clearConfig = function() {
		Xe = null, Se = !1;
	}, t.isValidAttribute = function(e, t, n) {
		Xe || $e({});
		let r = Ye(e), i = Ye(t);
		return pt(r, i, n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && uw(O[e], t);
	}, t.removeHook = function(e, t) {
		if (t !== void 0) {
			let n = cw(O[e], t);
			return n === -1 ? void 0 : dw(O[e], n, 1)[0];
		}
		return lw(O[e]);
	}, t.removeHooks = function(e) {
		O[e] = [];
	}, t.removeAllHooks = function() {
		O = aT();
	}, t;
}
var sT = oT(), cT = {
	breaks: !0,
	gfm: !0
}, lT = {
	ALLOWED_TAGS: [
		"p",
		"br",
		"span",
		"strong",
		"b",
		"em",
		"i",
		"u",
		"ul",
		"ol",
		"li",
		"a",
		"code"
	],
	ALLOWED_ATTR: ["href", "title"],
	ALLOW_DATA_ATTR: !1
}, uT = {
	ALLOWED_TAGS: /* @__PURE__ */ "h1.h2.h3.h4.h5.h6.p.br.span.div.strong.b.em.i.u.ul.ol.li.a.code.pre.blockquote.hr.table.thead.tbody.tr.th.td".split("."),
	ALLOWED_ATTR: [
		"href",
		"class",
		"title"
	],
	ALLOW_DATA_ATTR: !1
};
function dT(e, t = {}) {
	if (!e) return "";
	let { fullDocument: n = !1, markedOptions: r = {}, sanitizeConfig: i = null } = t, a = String(e), o = i || (n ? uT : lT);
	try {
		let e = UC.parse(a, {
			...cT,
			...r
		});
		return sT.sanitize(e, o);
	} catch (e) {
		return console.warn("Markdown parsing failed:", e), sT.sanitize(a, o);
	}
}
function fT(e) {
	return dT(e, { fullDocument: !1 });
}
//#endregion
//#region \0plugin-vue:export-helper
var pT = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, mT = { class: "relative w-full py-0.5" }, hT = /*#__PURE__*/ pT({
	__name: "FraudGauge",
	props: { score: {
		type: Number,
		required: !0
	} },
	setup(e) {
		let t = e, n = [
			18,
			183,
			106
		], r = [
			253,
			226,
			114
		], i = [
			240,
			68,
			56
		];
		function a(e, t, n) {
			return e.map((e, r) => Math.round(e + (t[r] - e) * n));
		}
		function o(e) {
			let t = Math.max(0, Math.min(100, e));
			return t <= 50 ? a(n, r, t / 50) : a(r, i, (t - 50) / 50);
		}
		let s = J(() => `${Math.max(0, Math.min(100, t.score))}%`), c = J(() => {
			let [e, n, r] = o(t.score);
			return `rgb(${e},${n},${r})`;
		});
		return (e, t) => (V(), H("div", mT, [t[0] ||= W("div", { class: "h-2.5 rounded-full w-full fraud-gradient" }, null, -1), W("div", {
			class: "absolute top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full",
			style: Se({
				left: s.value,
				width: "4px",
				height: "16px",
				backgroundColor: c.value,
				boxShadow: "0 0 0 2px white"
			})
		}, null, 4)]));
	}
}, [["__scopeId", "data-v-b83362d1"]]), gT = {
	key: 0,
	class: "flex items-stretch"
}, _T = { class: "flex flex-col justify-between flex-1 min-w-0 gap-3" }, vT = { class: "text-sm text-foreground flex items-center gap-1.5 min-w-0" }, yT = { class: "truncate" }, bT = ["innerHTML"], xT = { class: "flex flex-col gap-1.5 min-w-0" }, ST = { class: "min-w-0" }, CT = {
	key: 0,
	class: "flex items-center h-12"
}, wT = {
	key: 1,
	class: "flex items-center gap-2 h-12"
}, TT = { class: "text-3xl font-bold tabular-nums text-foreground" }, ET = {
	key: 2,
	class: "flex items-center"
}, DT = {
	key: 3,
	class: "text-3xl font-bold tabular-nums text-foreground truncate"
}, OT = {
	key: 0,
	class: "text-sm font-normal text-body"
}, kT = {
	key: 0,
	class: "text-xs text-body flex items-center gap-1.5 truncate"
}, AT = { class: "truncate" }, jT = {
	key: 2,
	class: "h-4"
}, MT = {
	key: 1,
	class: "text-body italic"
}, NT = /*#__PURE__*/ pT({
	__name: "ScoreRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = {
			"thumbs up": kf,
			"thumbs-up": kf,
			"thumbs down": Of,
			"thumbs-down": Of,
			thumbs: Sf,
			minus: Sf,
			clock: cf,
			time: cf,
			calendar: Kd,
			award: Gd,
			trophy: Gd,
			target: Df,
			bullseye: Df,
			"trending up": Af,
			chart: Af,
			"shield-alert": wf,
			"shield alert": wf
		}, r = J(() => (t.component.scores || []).map((e) => {
			let t = e.score;
			try {
				typeof e.score == "string" && (t = JSON.parse(e.score));
			} catch {}
			let r = typeof t == "object" && t?.type === "fraud_gauge", i = null, a = null;
			if (typeof t == "object" && t?.icon ? i = t.icon : e.icon && (i = e.icon), i) {
				let e = i.toLowerCase().trim().replace(/_/g, " ");
				a = n[e];
			}
			let o = "";
			o = t && typeof t == "object" ? t.value ?? t.text ?? "" : String(t ?? "-");
			let s = i === "thumbs up" || i === "thumbs-up", c = i === "thumbs down" || i === "thumbs-down", l = i === "minus" || i === "thumbs", u = s || c || l, d = "bg-muted", f = "text-body";
			s ? (d = "bg-success", f = "text-success-foreground") : c ? (d = "bg-destructive", f = "text-destructive-foreground") : l && (d = "bg-warning", f = "text-warning-foreground");
			let p = e.sub_headings ? e.sub_headings.replace(/[\r\n]+/g, " ").trim() : "", m = (e.title || "").toLowerCase().includes("language") ? mf : Nf, h = t == null || typeof t == "string" && t.trim() === "", g = e.tooltip ? fT(e.tooltip) : "";
			return {
				...e,
				displayValue: o,
				iconComponent: a,
				iconBgClass: d,
				iconColorClass: f,
				isRecommendation: u,
				isFraudGauge: r,
				fraudData: r ? t : null,
				isEmpty: h,
				hasIcon: !!a,
				cleanSubHeadings: p,
				subHeadingIcon: m,
				tooltipHtml: g
			};
		}));
		return (e, t) => r.value.length ? (V(), H("div", gT, [(V(!0), H(B, null, R(r.value, (e, n) => (V(), H(B, { key: n }, [n > 0 ? (V(), U(F(tS), {
			key: 0,
			orientation: "vertical",
			class: "h-auto mx-4 shrink-0"
		})) : q("", !0), W("div", _T, [W("p", vT, [W("span", yT, N(e.title), 1), e.tooltip ? (V(), U(F(fS), {
			key: 0,
			"delay-duration": 350
		}, {
			default: I(() => [G(F(uS), null, {
				default: I(() => [G(F(pS), { "as-child": "" }, {
					default: I(() => [G(F(nf), { class: "size-4 text-muted-foreground/60 shrink-0 cursor-help" })]),
					_: 1
				}), G(F(dS), {
					side: "top",
					class: "max-w-sm"
				}, {
					default: I(() => [W("div", {
						class: "tooltip-markdown",
						innerHTML: e.tooltipHtml
					}, null, 8, bT)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024)) : q("", !0)]), W("div", xT, [W("div", ST, [e.isEmpty ? (V(), H("div", CT, [G(F(fS), { "delay-duration": 300 }, {
			default: I(() => [G(F(uS), null, {
				default: I(() => [G(F(pS), { "as-child": "" }, {
					default: I(() => [...t[0] ||= [W("span", {
						class: "text-xl text-muted-foreground cursor-help",
						tabindex: "0",
						"aria-label": "There is no score because no scored questions were asked in this interview."
					}, "--", -1)]]),
					_: 1
				}), G(F(dS), {
					side: "top",
					class: "max-w-xs"
				}, {
					default: I(() => [...t[1] ||= [W("p", null, "There is no score because no scored questions were asked in this interview.", -1)]]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		})])) : e.isFraudGauge ? (V(), H("div", wT, [W("span", TT, N(e.fraudData.risk_level), 1), e.fraudData.risk_level === "High" ? (V(), U(F(jf), {
			key: 0,
			class: "size-4 text-destructive shrink-0"
		})) : e.fraudData.risk_level === "Medium" ? (V(), U(F(jf), {
			key: 1,
			class: "size-4 text-chart-5 shrink-0"
		})) : q("", !0)])) : e.isRecommendation && e.iconComponent ? (V(), H("div", ET, [W("div", { class: M(["flex size-12 items-center justify-center rounded-full", e.iconBgClass]) }, [(V(), U(ga(e.iconComponent), { class: M(["size-6", e.iconColorClass]) }, null, 8, ["class"]))], 2)])) : (V(), H("p", DT, [K(N(e.displayValue) + " ", 1), e.unit ? (V(), H("span", OT, N(e.unit), 1)) : q("", !0)]))]), e.cleanSubHeadings && !e.isEmpty ? (V(), H("p", kT, [e.isRecommendation ? q("", !0) : (V(), U(ga(e.subHeadingIcon), {
			key: 0,
			class: "size-4 shrink-0"
		})), W("span", AT, N(e.cleanSubHeadings), 1)])) : e.isFraudGauge ? (V(), U(hT, {
			key: 1,
			score: e.fraudData.score
		}, null, 8, ["score"])) : (V(), H("div", jT))])])], 64))), 128))])) : (V(), H("p", MT, "-"));
	}
}, [["__scopeId", "data-v-4fbc7d74"]]), PT = ["data-variant"], FT = /*#__PURE__*/ pT({
	__name: "Table",
	props: {
		class: {
			type: null,
			required: !1
		},
		wrapperClass: {
			type: null,
			required: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => [
				"default",
				"borderless",
				"transparent",
				"borderless-transparent"
			].includes(e)
		},
		equalColumns: {
			type: Boolean,
			default: !1
		},
		comfort: {
			type: Boolean,
			default: !1
		},
		compact: {
			type: Boolean,
			default: !1
		},
		fitColumns: {
			type: Boolean,
			default: !1
		},
		size: {
			type: String,
			default: "sm",
			validator: (e) => ["sm", "base"].includes(e)
		},
		dividers: {
			type: Boolean,
			default: !0
		}
	},
	setup(e) {
		let t = e, n = {
			sm: "text-sm",
			base: "text-base"
		}, r = J(() => hm("w-full caption-bottom", n[t.size], (t.equalColumns || t.fitColumns) && "table-fixed", t.class)), i = J(() => hm("relative w-full", t.fitColumns ? "overflow-hidden" : "overflow-auto", t.wrapperClass));
		return Er("tableVariant", t.variant), Er("tableSize", t.size), Er("tablePadding", t.compact ? "compact" : t.comfort ? "comfort" : "default"), Er("tableDividers", t.dividers), (t, n) => (V(), H("div", {
			class: M(i.value),
			"data-variant": e.variant
		}, [W("table", { class: M(r.value) }, [z(t.$slots, "default", {}, void 0, !0)], 2)], 10, PT));
	}
}, [["__scopeId", "data-v-7ca394a8"]]), IT = {
	__name: "TableBody",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (V(), H("tbody", { class: M(F(hm)("[&_tr:last-child]:border-0", t.class)) }, [z(e.$slots, "default")], 2));
	}
}, LT = {
	__name: "TableCell",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e, n = Dr("tableSize", "sm"), r = Dr("tablePadding", "default"), i = {
			compact: "px-2 py-1",
			default: "p-2",
			comfort: "p-4"
		};
		return (e, a) => (V(), H("td", { class: M(F(hm)("align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-0.5", i[F(r)], F(n) === "base" && "text-base text-foreground", t.class)) }, [z(e.$slots, "default")], 2));
	}
}, RT = {
	__name: "TableRow",
	props: {
		class: {
			type: null,
			required: !1
		},
		clickable: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, n = Dr("tableSize", "sm"), r = Dr("tableDividers", !0);
		return (i, a) => (V(), H("tr", {
			class: M(F(hm)("transition-colors data-[state=selected]:bg-muted", F(r) ? "border-b hover:bg-muted/50" : "border-0 hover:bg-transparent", F(n) === "base" && "text-base", e.clickable && "cursor-pointer", t.class)),
			style: Se(F(r) ? "border-color: var(--color-table-row-border)" : void 0)
		}, [z(i.$slots, "default")], 6));
	}
}, zT = {
	__name: "TableHead",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e, n = Dr("tablePadding", "default"), r = {
			compact: "px-2 py-1",
			default: "px-2",
			comfort: "px-4"
		};
		return (e, i) => (V(), H("th", { class: M(F(hm)("h-10 text-left align-middle font-medium text-body truncate [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-0.5", r[F(n)], t.class)) }, [z(e.$slots, "default")], 2));
	}
}, BT = {
	__name: "TableHeader",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e, n = Dr("tableVariant", "default"), r = J(() => hm("[&_tr]:border-b", !n.includes("transparent") && "bg-muted/50", t.class));
		return (e, t) => (V(), H("thead", {
			class: M(r.value),
			style: { "--color-table-row-border": "var(--color-border)" }
		}, [z(e.$slots, "default")], 2));
	}
}, VT = {
	__name: "Collapsible",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Qh(e, t);
		return (e, t) => (V(), U(F(Mg), De(us(F(n))), {
			default: I(({ open: t }) => [z(e.$slots, "default", { open: t })]),
			_: 3
		}, 16));
	}
}, HT = {
	__name: "CollapsibleContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(Ng), gs(t, { class: "overflow-hidden transition-all data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down" }), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, UT = {
	__name: "CollapsibleTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(Pg), De(us(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, WT = {
	key: 0,
	class: "w-full text-base"
}, GT = { class: "flex items-center gap-1.5" }, KT = { class: "flex items-center gap-2" }, qT = { class: "flex-1 h-10 bg-muted rounded-sm overflow-hidden" }, JT = { class: "font-semibold tabular-nums text-foreground w-10 text-right shrink-0" }, YT = { class: "flex items-center gap-2 pl-6" }, XT = { class: "text-sm text-muted-foreground truncate" }, ZT = { class: "flex items-center gap-2" }, QT = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, $T = { class: "text-sm tabular-nums text-muted-foreground w-10 text-right shrink-0" }, eE = { class: "flex items-center gap-2 pl-6" }, tE = { class: "flex items-center gap-2" }, nE = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, rE = { class: "text-sm tabular-nums text-muted-foreground w-10 text-right shrink-0" }, iE = { class: "flex items-center justify-between" }, aE = { class: "inline-flex items-center gap-1.5 text-sm text-muted-foreground cursor-default" }, oE = { class: "flex flex-col gap-1.5 mt-2" }, sE = { class: "text-sm text-body leading-relaxed whitespace-pre-wrap" }, cE = {
	key: 0,
	class: "text-xs text-body text-center leading-snug px-1 mt-0.5"
}, lE = {
	key: 1,
	class: "text-body italic"
}, uE = "size-3 fill-neutral-300 text-neutral-300", dE = "border-neutral-300", fE = {
	__name: "RatingRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.params?.max_rating || 5), r = /* @__PURE__ */ P(/* @__PURE__ */ new Set());
		function i(e) {
			let t = new Set(r.value);
			t.has(e) ? t.delete(e) : t.add(e), r.value = t;
		}
		let a = J(() => {
			let e = t.component.params?.colors || [];
			return (t.component.ratings || []).map((t) => {
				let n = t.raw_value ?? (parseFloat(t.value) || 0), r = e.find((e) => n >= e.min_rating && n <= e.max_rating);
				return !r && e.length > 0 && (r = e.reduce((e, t) => e.max_rating > t.max_rating ? e : t)), {
					...t,
					color: r?.color || "hsl(var(--muted-foreground))",
					rawValue: n
				};
			});
		});
		function o(e) {
			let t = e / n.value * 100;
			return Math.min(100, Math.max(0, t));
		}
		function s(e) {
			let n = t.component.params?.colors || [], r = n.find((t) => e >= t.min_rating && e <= t.max_rating);
			return !r && n.length > 0 && (r = n.reduce((e, t) => e.max_rating > t.max_rating ? e : t)), r?.color || "hsl(var(--muted-foreground))";
		}
		function c(e) {
			return e == null ? "hsl(var(--muted))" : e < 2.5 ? "hsl(195 65% 78%)" : e < 3.5 ? "hsl(200 80% 60%)" : "hsl(205 90% 37%)";
		}
		function l(e) {
			let t = e.interviewerRatings?.length > 1, n = e.aiRating != null || e.notes?.length > 0, r = e.anchors && Object.keys(e.anchors).length > 0;
			return t || n || r;
		}
		function u(e) {
			return e.anchors && Object.keys(e.anchors).length > 0;
		}
		function d(e) {
			let t = e.anchors || {}, r = n.value;
			return Array.from({ length: r }, (e, n) => t[n + 1] ? "3fr" : "1fr").join(" ");
		}
		let f = /* @__PURE__ */ rn({});
		function p(e, t) {
			t && or(() => {
				let n = t.querySelector(".rounded-full");
				if (n) {
					let r = t.getBoundingClientRect(), i = n.getBoundingClientRect();
					f[e] = i.top - r.top + i.height / 2;
				}
			});
		}
		return (e, t) => a.value.length ? (V(), H("div", WT, [G(F(FT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			compact: "",
			size: "base",
			dividers: !1
		}, {
			default: I(() => [G(F(IT), null, {
				default: I(() => [(V(!0), H(B, null, R(a.value, (e, a) => (V(), H(B, { key: a }, [G(F(RT), {
					class: M(l(e) ? "cursor-pointer" : ""),
					onClick: (t) => l(e) && i(a)
				}, {
					default: I(() => [G(F(LT), { class: "align-middle text-foreground px-0 pr-2" }, {
						default: I(() => [W("div", GT, [l(e) ? (V(), U(F(Xd), {
							key: 0,
							class: M(["size-4 shrink-0 transition-all duration-200", r.value.has(a) ? "rotate-90 text-primary" : "text-muted-foreground"])
						}, null, 8, ["class"])) : q("", !0), W("span", null, N(e.name), 1)])]),
						_: 2
					}, 1024), G(F(LT), { class: "align-middle px-0 pl-2" }, {
						default: I(() => [W("div", KT, [W("div", qT, [W("div", {
							class: "h-full rounded-sm",
							style: Se({
								width: `${o(e.rawValue)}%`,
								backgroundColor: e.color
							})
						}, null, 4)]), W("span", JT, N(e.value), 1)])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, ["class", "onClick"]), r.value.has(a) ? (V(), H(B, { key: 0 }, [
					(V(!0), H(B, null, R(e.interviewerRatings || [], (e, t) => (V(), U(F(RT), {
						key: `${a}-ir-${t}`,
						class: "hover:bg-transparent"
					}, {
						default: I(() => [G(F(LT), { class: "align-middle px-0 pr-2 py-1" }, {
							default: I(() => [W("div", YT, [G(F(Mf), { class: "size-4 text-body shrink-0" }), W("span", XT, N(e.name), 1)])]),
							_: 2
						}, 1024), G(F(LT), { class: "align-middle px-0 pl-2 py-1" }, {
							default: I(() => [W("div", ZT, [W("div", QT, [W("div", {
								class: "h-full rounded-sm",
								style: Se({
									width: `${o(e.rating)}%`,
									backgroundColor: s(e.rating)
								})
							}, null, 4)]), W("span", $T, N(Math.round(e.rating)), 1)])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024))), 128)),
					e.aiRating == null ? q("", !0) : (V(), U(F(RT), {
						key: 0,
						class: "hover:bg-transparent"
					}, {
						default: I(() => [G(F(LT), { class: "align-middle px-0 pr-2 py-1" }, {
							default: I(() => [W("div", eE, [G(F(Rf), { class: "size-4 shrink-0" }), t[0] ||= W("span", { class: "text-sm text-muted-foreground truncate" }, "AI Suggested", -1)])]),
							_: 1
						}), G(F(LT), { class: "align-middle px-0 pl-2 py-1" }, {
							default: I(() => [W("div", tE, [W("div", nE, [W("div", {
								class: "h-full rounded-sm",
								style: Se({
									width: `${o(e.aiRating)}%`,
									backgroundColor: c(e.aiRating)
								})
							}, null, 4)]), W("span", rE, N(Math.round(e.aiRating)), 1)])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)),
					e.notes?.length > 0 ? (V(), U(F(RT), {
						key: 1,
						class: "hover:bg-transparent"
					}, {
						default: I(() => [G(F(LT), {
							colspan: "2",
							class: "px-0 py-2"
						}, {
							default: I(() => [G(F(VT), { "default-open": !1 }, {
								default: I(({ open: n }) => [G(F(_m), { class: "px-6 py-4" }, {
									default: I(() => [
										W("div", iE, [t[3] ||= W("span", { class: "text-sm text-body" }, "AI Summary:", -1), e.aiRating == null ? q("", !0) : (V(), U(F(fS), {
											key: 0,
											"delay-duration": 200
										}, {
											default: I(() => [G(F(uS), null, {
												default: I(() => [G(F(pS), { "as-child": "" }, {
													default: I(() => [W("span", aE, [t[1] ||= W("span", { class: "size-3 rounded-full bg-info" }, null, -1), K(" " + N(Math.round(e.aiRating)) + "/5 ", 1)])]),
													_: 2
												}, 1024), G(F(dS), {
													side: "top",
													class: "text-xs"
												}, {
													default: I(() => [...t[2] ||= [K(" AI Suggested ", -1)]]),
													_: 1
												})]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024))]),
										W("ul", oE, [(V(!0), H(B, null, R(e.notes, (e, t) => (V(), H("li", {
											key: t,
											class: "flex items-start gap-2 text-sm text-body"
										}, [e.sentiment === "positive" ? (V(), U(F(kf), {
											key: 0,
											class: "size-4 shrink-0 mt-0.5 text-success"
										})) : e.sentiment === "negative" ? (V(), U(F(Of), {
											key: 1,
											class: "size-4 shrink-0 mt-0.5 text-destructive"
										})) : (V(), U(F(Sf), {
											key: 2,
											class: "size-4 shrink-0 mt-0.5 text-muted-foreground"
										})), W("span", null, N(e.text), 1)]))), 128))]),
										e.transcript ? (V(), H(B, { key: 0 }, [G(F(UT), { "as-child": "" }, {
											default: I(() => [G(F(Jx), {
												variant: "ghost",
												size: "sm",
												class: "gap-1 text-muted-foreground -ml-3 mt-2"
											}, {
												default: I(() => [t[4] ||= W("span", null, "View Candidate Response", -1), G(F(Yd), { class: M(["size-4 transition-transform shrink-0", n && "rotate-180"]) }, null, 8, ["class"])]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024), G(F(HT), null, {
											default: I(() => [W("p", sE, N(e.transcript), 1)]),
											_: 2
										}, 1024)], 64)) : q("", !0)
									]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : q("", !0),
					u(e) ? (V(), U(F(RT), {
						key: 2,
						class: "hover:bg-transparent"
					}, {
						default: I(() => [G(F(LT), {
							colspan: "2",
							class: "px-0 py-2"
						}, {
							default: I(() => [G(F(_m), { class: "px-6 py-4 flex flex-col gap-3" }, {
								default: I(() => [t[5] ||= W("span", { class: "text-sm text-body" }, "Scoring Rubric:", -1), W("div", {
									ref_for: !0,
									ref: (e) => p(a, e),
									class: "relative grid",
									style: Se({ gridTemplateColumns: d(e) })
								}, [W("div", {
									class: "absolute inset-x-0 pointer-events-none h-px bg-[linear-gradient(to_right,transparent_2%,var(--color-border)_10%,var(--color-border)_90%,transparent_98%)]",
									style: Se({ top: (f[a] ?? 0) + "px" })
								}, null, 4), (V(!0), H(B, null, R(n.value, (t) => (V(), H("div", {
									key: t,
									class: "flex flex-col items-center gap-1.5 z-10"
								}, [
									W("span", { class: M(e.anchors?.[t] ? "text-xs font-medium text-foreground" : "text-xs text-neutral-400") }, N(t), 3),
									W("span", {
										class: M(["size-5 rounded-full flex items-center justify-center ring-2 ring-background bg-background", e.anchors?.[t] ? "border-2 border-primary" : `border-2 ${dE}`]),
										"aria-hidden": "true"
									}, [e.anchors?.[t] ? (V(), U(F(af), {
										key: 0,
										class: "size-3 fill-(--module-icon-sparkle-secondary) text-(--module-icon-sparkle-secondary)"
									})) : (V(), U(F(af), {
										key: 1,
										class: M(uE)
									}))], 2),
									e.anchors?.[t] ? (V(), H("span", cE, N(e.anchors[t]), 1)) : q("", !0)
								]))), 128))], 4)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : q("", !0)
				], 64)) : q("", !0)], 64))), 128))]),
				_: 1
			})]),
			_: 1
		})])) : (V(), H("p", lE, "-"));
	}
}, pE = { class: "w-full h-2 bg-muted rounded-full overflow-hidden" }, mE = {
	__name: "RatingScale",
	props: {
		value: {
			type: Number,
			required: !0
		},
		max: {
			type: Number,
			default: 10
		},
		color: {
			type: String,
			default: "var(--color-primary)"
		}
	},
	setup(e) {
		let t = e, n = J(() => {
			let e = t.value / t.max * 100;
			return Math.min(100, Math.max(0, e));
		});
		return (t, r) => (V(), H("div", pE, [W("div", {
			class: "h-full rounded-full transition-all duration-300",
			style: Se({
				width: `${n.value}%`,
				backgroundColor: e.color
			})
		}, null, 4)]));
	}
}, hE = {
	key: 0,
	class: "w-full text-base"
}, gE = {
	key: 0,
	class: "flex flex-col gap-2"
}, _E = {
	key: 1,
	class: "flex items-center gap-2"
}, vE = { class: "font-medium tabular-nums text-foreground" }, yE = {
	key: 1,
	class: "text-body italic"
}, bE = {
	__name: "TableRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.headers || []), r = J(() => t.component.rows || []), i = J(() => r.value.some((e) => e.some((e) => a(e))));
		function a(e) {
			return e && typeof e == "object" && e.component_type === "column";
		}
		function o(e) {
			return e ? typeof e == "string" ? e : e.content === void 0 ? e.value === void 0 ? e.text === void 0 ? "-" : e.text : e.value : e.content : "-";
		}
		function s(e) {
			return e && typeof e == "object" && (e.rating !== void 0 || e.score !== void 0);
		}
		function c(e) {
			return e.rating ?? e.score ?? 0;
		}
		function l(e) {
			let t = c(e) / (e.max_rating || 10);
			return t >= .7 ? "var(--color-success)" : t >= .5 ? "var(--color-warning)" : "var(--color-destructive)";
		}
		let u = {
			"violet-250": "#F2D0F8",
			"violet-300": "#E9D5FF",
			"violet-400": "#DDD6FE",
			purple: "#E9D5FF",
			"neutral-lavender": "#E8D5E8",
			"neutral-gray": "#E5E7EB",
			gray: "#E5E7EB",
			blue: "#DBEAFE",
			green: "#D1FAE5",
			red: "#FEE2E2",
			orange: "#FFEDD5",
			yellow: "#FEF3C7",
			pink: "#FCE7F3",
			teal: "#CCFBF1"
		};
		function d(e) {
			let t = e?.color || "";
			if (!t) return "#E9D5FF";
			if (t.startsWith("#") || t.startsWith("rgb")) return t;
			let n = t.toLowerCase();
			return u[n] ? u[n] : /^[0-9A-Fa-f]{6}$/.test(t) ? `#${t}` : "#E9D5FF";
		}
		return (e, t) => n.value.length ? (V(), H("div", hE, [G(F(FT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			size: "base",
			dividers: i.value
		}, {
			default: I(() => [G(F(IT), null, {
				default: I(() => [(V(!0), H(B, null, R(r.value, (e, t) => (V(), U(F(RT), { key: `row-${t}` }, {
					default: I(() => [(V(!0), H(B, null, R(e, (e, n) => (V(), U(F(LT), {
						key: `cell-${t}-${n}`,
						class: M(["align-top px-0", n === 0 ? "pr-2" : "pl-2"])
					}, {
						default: I(() => [a(e) ? (V(), H("div", gE, [e.badge?.text ? (V(), H("span", {
							key: 0,
							class: "self-start inline-flex items-center rounded-sm px-2.5 py-1 text-sm leading-none font-medium",
							style: Se({
								backgroundColor: d(e.badge),
								color: "var(--color-foreground)"
							})
						}, N(e.badge.text), 5)) : q("", !0), W("span", { class: M(e.name === "Question" ? "font-semibold text-foreground" : "text-foreground") }, N(o(e)), 3)])) : s(e) ? (V(), H("div", _E, [W("span", vE, N(c(e)), 1), G(mE, {
							value: Math.round(c(e)),
							max: e.max_rating || 10,
							color: l(e)
						}, null, 8, [
							"value",
							"max",
							"color"
						])])) : (V(), H("span", {
							key: 2,
							class: M(n === 0 ? "font-medium text-foreground" : "text-foreground")
						}, N(o(e)), 3))]),
						_: 2
					}, 1032, ["class"]))), 128))]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["dividers"])])) : (V(), H("p", yE, "-"));
	}
}, xE = /* @__PURE__ */ L({
	__name: "Alert",
	props: {
		variant: {
			type: String,
			default: "default"
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = {
			default: "bg-muted text-foreground",
			info: "bg-info text-info-foreground",
			success: "bg-success-muted text-success-muted-foreground",
			warning: "bg-warning text-warning-foreground",
			destructive: "bg-destructive/10 text-destructive"
		}, n = e, r = J(() => t[n.variant] || t.default);
		return (e, t) => (V(), H("div", {
			role: "alert",
			class: M(F(hm)("flex w-full gap-3 rounded-xl px-4 py-4 text-sm [&>svg]:shrink-0 [&>svg]:translate-y-0.5", r.value, n.class))
		}, [z(e.$slots, "default")], 2));
	}
}), SE = {
	key: 0,
	class: "w-full text-sm"
}, CE = { class: "font-medium text-foreground" }, wE = {
	key: 0,
	class: "text-body"
}, TE = { class: "flex flex-col items-start gap-1" }, EE = {
	key: 1,
	class: "flex items-center gap-2"
}, DE = {
	key: 1,
	class: "text-body italic"
}, OE = {
	__name: "ScreeningRenderer",
	props: {
		component: {
			type: Object,
			required: !0
		},
		valueWeight: {
			type: String,
			default: "medium",
			validator: (e) => ["regular", "medium"].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => t.valueWeight === "medium" ? "font-medium" : ""), r = J(() => t.component.questions || []), i = {
			"check circle": ef,
			check: ef,
			"warning sign": Qd,
			warning: Qd,
			"times circle": rf,
			times: rf,
			question: nf
		};
		function a(e) {
			if (!e?.icon) return null;
			let t = e.icon.toLowerCase().trim();
			return i[t] || Qd;
		}
		function o(e) {
			return e?.color && {
				green: "text-success",
				red: "text-destructive",
				yellow: "text-warning",
				warning: "text-warning",
				orange: "text-warning",
				blue: "text-info",
				gray: "text-body",
				grey: "text-body"
			}[e.color] || "text-body";
		}
		return (e, t) => r.value.length ? (V(), H("div", SE, [G(F(FT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			size: "sm",
			compact: "",
			dividers: !1
		}, {
			default: I(() => [G(F(IT), null, {
				default: I(() => [(V(!0), H(B, null, R(r.value, (e, r) => (V(), U(F(RT), { key: r }, {
					default: I(() => [G(F(LT), { class: "align-top px-0 pr-2" }, {
						default: I(() => [W("div", { class: M(["flex flex-col gap-0.5", e.skipped ? "opacity-60" : ""]) }, [W("span", CE, N(e.title), 1), e.question ? (V(), H("span", wE, N(e.question), 1)) : q("", !0)], 2)]),
						_: 2
					}, 1024), G(F(LT), { class: "align-top px-0 pl-2" }, {
						default: I(() => [W("div", TE, [e.skipped ? (V(), U(F(xE), {
							key: 0,
							variant: "default",
							role: "presentation",
							class: "py-2 rounded-lg w-auto"
						}, {
							default: I(() => [G(F(yf), {
								class: "size-4",
								"aria-hidden": "true"
							}), t[0] ||= W("div", { class: "min-w-0 whitespace-normal" }, [W("span", null, "Not asked"), W("span", { class: "text-muted-foreground" }, " · Conditional rules were not met")], -1)]),
							_: 1
						})) : q("", !0), e.skipped ? q("", !0) : (V(), H("div", EE, [W("span", { class: M(["text-foreground", n.value]) }, N(e.value || e.description || "-"), 3), e.flag ? (V(), U(F(fS), {
							key: 0,
							"delay-duration": 350
						}, {
							default: I(() => [G(F(uS), null, {
								default: I(() => [G(F(pS), null, {
									default: I(() => [(V(), U(ga(a(e.flag)), { class: M(["size-4", o(e.flag)]) }, null, 8, ["class"]))]),
									_: 2
								}, 1024), e.flag.tooltip ? (V(), U(F(dS), {
									key: 0,
									side: "top",
									class: "max-w-sm"
								}, {
									default: I(() => [K(N(e.flag.tooltip), 1)]),
									_: 2
								}, 1024)) : q("", !0)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)) : q("", !0)]))])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		})])) : (V(), H("p", DE, "-"));
	}
}, kE = ["innerHTML"], AE = {
	key: 1,
	class: "text-body italic"
}, jE = {
	__name: "TextRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = {
			ALLOWED_TAGS: [
				"strong",
				"em",
				"br"
			],
			ALLOWED_ATTR: []
		}, r = J(() => {
			let e = (t.component.text || "").replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>").replace(/\*(.*?)\*/g, "<em>$1</em>").replace(/\n/g, "<br>");
			return sT.sanitize(e, n);
		});
		return (t, n) => e.component.text ? (V(), H("div", {
			key: 0,
			class: "prose max-w-none leading-relaxed text-foreground",
			innerHTML: r.value
		}, null, 8, kE)) : (V(), H("p", AE, "-"));
	}
}, ME = {
	key: 0,
	class: "space-y-1"
}, NE = {
	key: 1,
	class: "w-1.5 h-1.5 rounded-full bg-current shrink-0 mt-2 text-foreground"
}, PE = { class: "text-foreground" }, FE = {
	key: 1,
	class: "text-body italic"
}, IE = {
	__name: "BulletRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.bullets || []), r = J(() => t.component.params?.bullet_icon), i = {
			"check circle": ef,
			check: ef,
			"times circle": rf,
			times: rf,
			x: rf,
			star: Ef,
			circle: af
		}, a = J(() => {
			if (!r.value?.name) return null;
			let e = r.value.name.toLowerCase().trim();
			return i[e] || null;
		}), o = J(() => {
			let e = r.value?.color;
			return e && {
				green: "text-success",
				red: "text-destructive",
				yellow: "text-warning",
				blue: "text-info",
				gray: "text-body",
				grey: "text-body"
			}[e] || "text-body";
		});
		return (e, t) => n.value.length ? (V(), H("ul", ME, [(V(!0), H(B, null, R(n.value, (e, t) => (V(), H("li", {
			key: t,
			class: "flex items-start gap-2"
		}, [a.value ? (V(), U(ga(a.value), {
			key: 0,
			class: M(["size-4 shrink-0 mt-0.5", o.value])
		}, null, 8, ["class"])) : (V(), H("span", NE)), W("span", PE, N(e), 1)]))), 128))])) : (V(), H("p", FE, "-"));
	}
}, LE = {
	__name: "Sheet",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Qh(e, t);
		return (e, t) => (V(), U(F(Lg), De(us(F(n))), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, RE = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "SheetContent",
	props: {
		class: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		hideCloseButton: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qh(eh(n, "class", "side", "size", "hideCloseButton"), r);
		function a(e) {
			e.preventDefault();
		}
		let o = Pd();
		return (t, r) => (V(), U(F(E_), { to: F(o) }, {
			default: I(() => [G(F(w_), { class: "fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=open]:duration-300 data-[state=closed]:duration-200" }), G(F(x_), gs({
				class: F(hm)(F(HE)({
					side: e.side,
					size: e.size
				}), n.class),
				"data-side": e.side || "right"
			}, {
				...F(i),
				...t.$attrs
			}, { onCloseAutoFocus: a }), {
				default: I(() => [z(t.$slots, "default"), e.hideCloseButton ? q("", !0) : (V(), U(F(Rg), {
					key: 0,
					class: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary"
				}, {
					default: I(() => [G(F(Ff), { class: "w-4 h-4" })]),
					_: 1
				}))]),
				_: 3
			}, 16, ["class", "data-side"])]),
			_: 3
		}, 8, ["to"]));
	}
}), zE = {
	__name: "SheetDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = eh(t, "class");
		return (e, r) => (V(), U(F(S_), gs({ class: F(hm)("text-sm text-muted-foreground", t.class) }, F(n)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, BE = {
	__name: "SheetHeader",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (V(), H("div", { class: M(F(hm)("flex flex-col pt-4 text-center sm:text-left", t.class)) }, [z(e.$slots, "default")], 2));
	}
}, VE = {
	__name: "SheetTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = eh(t, "class");
		return (e, r) => (V(), U(F(D_), gs({ class: F(hm)("text-lg font-semibold text-foreground", t.class) }, F(n)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, HE = wm("fixed z-50 bg-background px-4 shadow-lg data-[state=open]:animate-in data-[state=open]:fill-mode-backwards data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-350 m-2 rounded-lg", {
	variants: {
		side: {
			top: "top-0 left-0 right-0 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
			bottom: "bottom-0 left-0 right-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
			left: "top-0 bottom-0 left-0 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
			right: "top-0 bottom-0 right-0 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right"
		},
		size: {
			default: "w-full max-w-[min(520px,calc(100vw_-_1rem))]",
			sm: "w-full max-w-[min(24rem,calc(100vw_-_1rem))]",
			md: "w-full max-w-[min(32rem,calc(100vw_-_1rem))]",
			lg: "w-full max-w-[min(48rem,calc(100vw_-_1rem))]",
			xl: "w-full max-w-[min(64rem,calc(100vw_-_1rem))]",
			"2xl": "w-full max-w-[min(72rem,calc(100vw_-_1rem))]",
			half: "w-full max-w-[calc(100vw_-_1rem)] sm:w-1/2",
			sidebar: "w-full max-w-[calc(100vw_-_1rem)] sm:w-[500px]"
		}
	},
	defaultVariants: {
		side: "right",
		size: "default"
	}
}), UE = {
	__name: "Badge",
	props: {
		variant: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		icon: {
			type: [Object, Function],
			required: !1
		},
		iconClass: {
			type: String,
			required: !1
		},
		textClass: {
			type: String,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Fa(), r = J(() => t.icon && !n.default), i = /* @__PURE__ */ P(null), a = /* @__PURE__ */ P(!1);
		function o() {
			or(() => {
				i.value && (a.value = i.value.scrollWidth > i.value.clientWidth);
			});
		}
		return ra(o), aa(o), (n, o) => (V(), U(F(fS), null, {
			default: I(() => [G(F(uS), { disabled: !a.value }, {
				default: I(() => [G(F(pS), { "as-child": "" }, {
					default: I(() => [W("span", { class: M(F(hm)(F(WE)({ variant: e.variant }), r.value && "w-5.5 px-0", t.class)) }, [e.icon ? (V(), U(ga(e.icon), {
						key: 0,
						class: M(F(hm)("h-3.5 w-3.5 shrink-0", e.iconClass))
					}, null, 8, ["class"])) : q("", !0), n.$slots.default ? (V(), H("span", {
						key: 1,
						ref_key: "textRef",
						ref: i,
						class: M(F(hm)("truncate capitalize font-medium", e.textClass))
					}, [z(n.$slots, "default")], 2)) : q("", !0)], 2)]),
					_: 3
				}), a.value ? (V(), U(F(dS), { key: 0 }, {
					default: I(() => [z(n.$slots, "default")]),
					_: 3
				})) : q("", !0)]),
				_: 3
			}, 8, ["disabled"])]),
			_: 3
		}));
	}
}, WE = wm("inline-flex items-center justify-center gap-1.5 h-[22px] rounded-[6px] border border-border px-2.5 text-[13px] leading-[14px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
	variants: { variant: {
		default: "border-transparent bg-neutral-200 text-body",
		secondary: "border-transparent bg-neutral-100 text-body",
		success: "border-transparent bg-success-muted text-success-muted-foreground",
		warning: "border-transparent bg-warning text-warning-foreground",
		destructive: "border-transparent bg-destructive/10 text-destructive",
		info: "border-transparent bg-info text-info-foreground",
		"info-subtle": "border-transparent bg-info-subtle text-info-subtle-foreground",
		"success-subtle": "border-transparent bg-green-50 text-green-600",
		"warning-subtle": "border-transparent bg-amber-50 text-amber-600",
		"destructive-subtle": "border-transparent bg-red-50 text-red-600",
		variable: "border-transparent bg-[var(--color-variable)] text-[var(--color-variable-foreground)] hover:bg-[var(--color-variable-hover)]",
		outline: "text-body",
		"text-success": "border-transparent bg-transparent text-success-muted-foreground",
		"text-warning": "border-transparent bg-transparent text-warning-foreground",
		"text-muted": "border-transparent bg-transparent text-muted-foreground",
		custom: "border-transparent bg-[var(--badge-bg)] text-white",
		"category-introduction": "border-transparent bg-[var(--color-category-introduction)] text-[var(--color-category-introduction-foreground)]",
		"category-motivation": "border-transparent bg-[var(--color-category-motivation)] text-[var(--color-category-motivation-foreground)]",
		"category-skills": "border-transparent bg-[var(--color-category-skills)] text-[var(--color-category-skills-foreground)]",
		"category-general": "border-transparent bg-[var(--color-category-general)] text-[var(--color-category-general-foreground)]",
		"category-wrapup": "border-transparent bg-[var(--color-category-wrapup)] text-[var(--color-category-wrapup-foreground)]",
		"category-experience": "border-transparent bg-[var(--color-category-experience)] text-[var(--color-category-experience-foreground)]",
		"category-culture": "border-transparent bg-[var(--color-category-culture)] text-[var(--color-category-culture-foreground)]",
		"category-screening": "border-transparent bg-[var(--color-category-screening)] text-[var(--color-category-screening-foreground)]",
		"category-qualifications": "border-transparent bg-[var(--color-category-qualifications)] text-[var(--color-category-qualifications-foreground)]",
		"category-custom": "border-transparent bg-[var(--color-category-custom)] text-[var(--color-category-custom-foreground)]"
	} },
	defaultVariants: { variant: "default" }
}), GE = {
	key: 0,
	class: "space-y-3"
}, KE = { class: "flex items-center justify-between px-3 py-2 border-b border-border bg-card" }, qE = {
	key: 0,
	"data-testid": "instance-header",
	class: "flex items-center gap-2"
}, JE = {
	key: 0,
	class: "text-xs tabular-nums text-placeholder"
}, YE = {
	key: 1,
	class: "text-xs text-muted-foreground"
}, XE = { class: "p-3 space-y-3" }, ZE = {
	key: 0,
	class: "text-sm text-muted-foreground"
}, QE = { class: "text-sm text-foreground" }, $E = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, eD = {
	__name: "AlertBehavioralInstances",
	props: {
		alert: {
			type: Object,
			required: !0
		},
		semanticVariant: {
			type: String,
			default: "destructive-subtle"
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.alert.details?.instances || []), a = J(() => n.semanticVariant === "warning-subtle"), o = J(() => a.value ? "border-warning" : "border-destructive"), s = J(() => a.value ? "bg-warning/5" : "bg-destructive/5");
		function c(e) {
			let t = (e || "").toLowerCase();
			return [
				"offensive",
				"hostile",
				"aggressive"
			].includes(t) ? "destructive" : [
				"rude",
				"disruptive",
				"derailing"
			].includes(t) ? "warning" : [
				"language switch",
				"language request",
				"visa status",
				"sponsorship need"
			].includes(t) ? "secondary" : ["end request"].includes(t) ? "outline" : "default";
		}
		function l(e) {
			return !isNaN(parseFloat(e.start_seconds));
		}
		function u(e) {
			let t = parseFloat(e.start_seconds);
			isNaN(t) || r("jump", t);
		}
		return (e, t) => i.value.length ? (V(), H("div", GE, [(V(!0), H(B, null, R(i.value, (e, n) => (V(), H("div", {
			key: e.transcription_chunk_id || n,
			class: "rounded-lg border border-border overflow-hidden"
		}, [W("div", KE, [G(F(UE), { variant: c(e.subtype) }, {
			default: I(() => [K(N(e.subtype), 1)]),
			_: 2
		}, 1032, ["variant"]), e.timestamp || e.candidate_name ? (V(), H("div", qE, [e.timestamp ? (V(), H("span", JE, N(e.timestamp), 1)) : q("", !0), e.candidate_name ? (V(), H("span", YE, N(e.candidate_name), 1)) : q("", !0)])) : q("", !0)]), W("div", XE, [e.context ? (V(), H("p", ZE, N(e.context), 1)) : q("", !0), W("div", { class: M(["border-l-2 px-3 py-3 rounded-r-md space-y-3", [o.value, s.value]]) }, [W("p", QE, " \"" + N(e.quote) + "\" ", 1), G(F(Jx), {
			variant: "outline",
			size: "sm",
			class: "gap-1.5",
			disabled: !l(e),
			onClick: (t) => u(e)
		}, {
			default: I(() => [G(F(Rf), {
				mono: !0,
				class: "size-4"
			}), t[0] ||= K(" View in transcript ", -1)]),
			_: 1
		}, 8, ["disabled", "onClick"])], 2)])]))), 128))])) : (V(), H("p", $E, "No instances available."));
	}
}, tD = {
	key: 0,
	class: "rounded-lg border border-border overflow-hidden"
}, nD = { class: "flex items-center justify-between px-3 py-2 border-b border-border bg-card" }, rD = { key: 1 }, iD = {
	key: 2,
	"data-testid": "instance-header",
	class: "flex items-center gap-2"
}, aD = {
	key: 0,
	class: "text-xs tabular-nums text-placeholder"
}, oD = {
	key: 1,
	class: "text-xs text-muted-foreground"
}, sD = { class: "p-3 space-y-1 text-sm" }, cD = { key: 0 }, lD = {
	key: 1,
	class: "whitespace-pre-wrap"
}, uD = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, dD = {
	__name: "AlertCancellationDetails",
	props: { alert: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.alert.details?.instances?.[0] || null), r = J(() => {
			let e = t.alert.details?.cancellation_reason;
			return typeof e == "string" && e.trim() ? e.trim() : null;
		}), i = J(() => {
			let e = t.alert.details?.cancellation_notes;
			return typeof e == "string" && e.trim() ? e.trim() : null;
		}), a = J(() => !!r.value || !!i.value);
		return (e, t) => a.value ? (V(), H("div", tD, [W("div", nD, [n.value?.subtype ? (V(), U(F(UE), {
			key: 0,
			variant: "outline"
		}, {
			default: I(() => [K(N(n.value.subtype), 1)]),
			_: 1
		})) : (V(), H("span", rD)), n.value?.timestamp || n.value?.candidate_name ? (V(), H("div", iD, [n.value.timestamp ? (V(), H("span", aD, N(n.value.timestamp), 1)) : q("", !0), n.value.candidate_name ? (V(), H("span", oD, N(n.value.candidate_name), 1)) : q("", !0)])) : q("", !0)]), W("div", sD, [r.value ? (V(), H("p", cD, [t[0] ||= W("span", { class: "font-medium" }, "Reason:", -1), K(" " + N(r.value), 1)])) : q("", !0), i.value ? (V(), H("p", lD, [t[1] ||= W("span", { class: "font-medium" }, "Notes:", -1), K(" " + N(i.value), 1)])) : q("", !0)])])) : (V(), H("p", uD, "No details available for this alert."));
	}
}, fD = { class: "space-y-4 p-4" }, pD = {
	key: 0,
	class: "text-base text-foreground leading-relaxed"
}, mD = {
	key: 1,
	"data-testid": "screening-data-card",
	"aria-label": "Screening response",
	class: "bg-muted rounded-lg px-4 py-3 space-y-2"
}, hD = { class: "text-sm text-foreground italic leading-relaxed" }, gD = {
	key: 0,
	class: "text-sm text-muted-foreground"
}, _D = {
	__name: "AlertJustificationDetails",
	props: { alert: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.alert.details?.justification || ""), r = J(() => t.alert.details?.screening_data);
		return (e, t) => (V(), H("div", fD, [n.value ? (V(), H("p", pD, N(n.value), 1)) : q("", !0), r.value ? (V(), H("section", mD, [
			t[0] ||= W("p", { class: "text-xs text-muted-foreground uppercase tracking-wider" }, "Candidate's response", -1),
			W("p", hD, N(r.value.justification), 1),
			r.value.answer_found ? (V(), H("p", gD, " Answer: " + N(r.value.answer_found), 1)) : q("", !0)
		])) : q("", !0)]));
	}
}, vD = Object.freeze({
	REQUESTED: "Requested",
	SCHEDULED: "Scheduled",
	ACCEPTED: "Accepted",
	IN_PROGRESS: "In Progress",
	AWAITING_RETAKE: "Awaiting Retake",
	PARTIAL: "Partial",
	COMPLETED: "Completed",
	GENERATING_REPORT: "Generating Report",
	PENDING_CONFIRMATION: "Pending Confirmation",
	DECLINED: "Declined",
	CANCELED: "Canceled",
	AUTO_CANCELED: "Auto-canceled"
}), yD = Object.freeze({
	REQUESTED: "requested",
	SCHEDULED: "scheduled",
	ACCEPTED: "accepted",
	IN_PROGRESS: "in_progress",
	AWAITING_RETAKE: "awaiting_retake",
	PARTIAL: "partial",
	COMPLETED: "completed",
	GENERATING_REPORT: "generating_report",
	PENDING_CONFIRMATION: "pending_confirmation",
	DECLINED: "declined",
	CANCELED: "canceled",
	AUTO_CANCELED: "auto_canceled"
});
Object.freeze({
	[yD.REQUESTED]: vD.REQUESTED,
	[yD.SCHEDULED]: vD.SCHEDULED,
	[yD.ACCEPTED]: vD.ACCEPTED,
	[yD.IN_PROGRESS]: vD.IN_PROGRESS,
	[yD.AWAITING_RETAKE]: vD.AWAITING_RETAKE,
	[yD.PARTIAL]: vD.PARTIAL,
	[yD.COMPLETED]: vD.COMPLETED,
	[yD.GENERATING_REPORT]: vD.GENERATING_REPORT,
	[yD.PENDING_CONFIRMATION]: vD.PENDING_CONFIRMATION,
	[yD.DECLINED]: vD.DECLINED,
	[yD.CANCELED]: vD.CANCELED,
	[yD.AUTO_CANCELED]: vD.AUTO_CANCELED,
	cancelled: vD.CANCELED,
	pending: "Pending",
	archived: "Archived"
}), yD.COMPLETED, yD.PARTIAL;
//#endregion
//#region src/utils/formatters.js
var bD = /^(\d{4})-(\d{2})-(\d{2})$/;
function xD(e) {
	let t = typeof e == "string" ? bD.exec(e.trim()) : null;
	if (!t) return new Date(e);
	let [, n, r, i] = t.map(Number), a = new Date(n, r - 1, i);
	return a.getMonth() === r - 1 && a.getDate() === i ? a : /* @__PURE__ */ new Date(NaN);
}
function SD(e, t = {}) {
	let { fallback: n = "—", format: r = "short", withTime: i = !1 } = t;
	if (!e) return n;
	try {
		let t = xD(e);
		if (isNaN(t.getTime())) return n;
		let a = r === "long" ? {
			year: "numeric",
			month: "long",
			day: "numeric"
		} : {
			month: "short",
			day: "numeric",
			year: "numeric"
		}, o = t.toLocaleDateString("en-US", a);
		return i ? `${o} - ${t.toLocaleTimeString("en-US", {
			hour: "numeric",
			minute: "2-digit",
			hour12: !0
		})}` : o;
	} catch {
		return n;
	}
}
function CD(e) {
	if (!e) return {
		dateStr: "—",
		timeStr: "—"
	};
	let t = new Date(e), n = /* @__PURE__ */ new Date(), r = new Date(n);
	r.setDate(r.getDate() + 1);
	let i;
	if (t.toDateString() === n.toDateString()) i = "Today";
	else if (t.toDateString() === r.toDateString()) i = "Tomorrow";
	else {
		let e = t.getFullYear() === n.getFullYear();
		i = t.toLocaleDateString("en-US", {
			month: "short",
			day: "numeric",
			...e ? {} : { year: "numeric" }
		});
	}
	let a = t.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
		hour12: !0
	});
	return {
		dateStr: i,
		timeStr: a
	};
}
//#endregion
//#region src/components/interview/report/renderers/alert-details/AlertRetakesDetails.vue
var wD = {
	key: 0,
	class: "space-y-2"
}, TD = { class: "flex items-center justify-between px-3 py-2 border-b border-border bg-card" }, ED = { key: 1 }, DD = {
	key: 2,
	class: "text-xs tabular-nums text-muted-foreground"
}, OD = { class: "p-3 text-sm" }, kD = {
	key: 0,
	class: "whitespace-pre-wrap"
}, AD = {
	key: 1,
	class: "text-muted-foreground italic"
}, jD = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, MD = {
	__name: "AlertRetakesDetails",
	props: { alert: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e;
		function n(e) {
			if (!e) return null;
			let { dateStr: t, timeStr: n } = CD(e);
			return `${t} · ${n}`;
		}
		let r = J(() => (t.alert.details?.instances || []).map((e, t) => ({
			key: e.occurred_at || `retake-${t}`,
			when: n(e.occurred_at),
			reason: typeof e.context == "string" && e.context.trim() ? e.context.trim() : null,
			subtype: e.subtype || null
		})));
		return (e, t) => r.value.length ? (V(), H("div", wD, [(V(!0), H(B, null, R(r.value, (e, n) => (V(), H("div", {
			key: `${e.key}-${n}`,
			class: "rounded-lg border border-border overflow-hidden"
		}, [W("div", TD, [e.subtype ? (V(), U(F(UE), {
			key: 0,
			variant: "outline"
		}, {
			default: I(() => [K(N(e.subtype), 1)]),
			_: 2
		}, 1024)) : (V(), H("span", ED)), e.when ? (V(), H("span", DD, N(e.when), 1)) : q("", !0)]), W("div", OD, [e.reason ? (V(), H("p", kD, [t[0] ||= W("span", { class: "font-medium" }, "Reason:", -1), K(" " + N(e.reason), 1)])) : (V(), H("p", AD, "No reason recorded."))])]))), 128))])) : (V(), H("p", jD, "No details available for this alert."));
	}
}, ND = [
	"rude",
	"hostile",
	"disruptive"
], PD = /* @__PURE__ */ new Set(["wants_end"]), FD = "retakes";
function ID(e) {
	if (e) {
		if (e.type) return e.type;
		if (Array.isArray(e.instances)) return "behavioral";
	}
}
//#endregion
//#region src/components/interview/report/renderers/alert-details/AlertDetailsSheet.vue
var LD = { class: "flex-1 overflow-y-auto px-4 py-4" }, RD = {
	key: 4,
	class: "text-sm text-muted-foreground"
}, zD = {
	__name: "AlertDetailsSheet",
	props: {
		open: {
			type: Boolean,
			default: !1
		},
		alert: {
			type: Object,
			default: null
		}
	},
	emits: ["update:open", "jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => ID(n.alert?.details)), a = J(() => n.alert?.details?.instance_count || 0), o = J(() => PD.has(n.alert?.codename)), s = J(() => n.alert?.codename === FD), c = J(() => i.value === "behavioral" && a.value > 0 && ND.includes(n.alert?.codename)), l = J(() => n.alert?.severity === "warning" ? "warning-subtle" : "destructive-subtle");
		function u(e) {
			r("jump", e), r("update:open", !1);
		}
		return (t, n) => (V(), U(F(LE), {
			open: e.open,
			"onUpdate:open": n[0] ||= (e) => r("update:open", e)
		}, {
			default: I(() => [G(F(RE), {
				side: "right",
				class: "flex flex-col gap-0 p-0"
			}, {
				default: I(() => [G(F(BE), { class: "shrink-0 px-4 pt-4 pb-4" }, {
					default: I(() => [G(F(VE), { class: "flex items-start gap-2 pr-6" }, {
						default: I(() => [(V(), U(ga(e.alert?.style?.icon), { class: M(["size-4 shrink-0 mt-[5px]", e.alert?.style?.iconClass]) }, null, 8, ["class"])), K(" " + N(e.alert?.text), 1)]),
						_: 1
					}), c.value ? (V(), U(F(zE), {
						key: 0,
						class: "mt-1 pl-6"
					}, {
						default: I(() => [K(N(a.value) + " " + N(a.value === 1 ? "instance" : "instances") + " detected", 1)]),
						_: 1
					})) : q("", !0)]),
					_: 1
				}), W("div", LD, [o.value ? (V(), U(dD, {
					key: 0,
					alert: e.alert
				}, null, 8, ["alert"])) : s.value ? (V(), U(MD, {
					key: 1,
					alert: e.alert
				}, null, 8, ["alert"])) : i.value === "behavioral" ? (V(), U(eD, {
					key: 2,
					alert: e.alert,
					"semantic-variant": l.value,
					onJump: u
				}, null, 8, ["alert", "semantic-variant"])) : i.value === "justification" ? (V(), U(_D, {
					key: 3,
					alert: e.alert
				}, null, 8, ["alert"])) : (V(), H("p", RD, "No details available for this alert."))])]),
				_: 1
			})]),
			_: 1
		}, 8, ["open"]));
	}
}, BD = {
	key: 0,
	class: "flex flex-col gap-2"
}, VD = { class: "text-foreground flex-1 text-sm font-semibold" }, HD = {
	key: 0,
	class: "grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2"
}, UD = ["onClick"], WD = { key: 0 }, GD = { key: 0 }, KD = {
	key: 1,
	class: "list-disc pl-4 space-y-0.5"
}, qD = ["innerHTML"], JD = {
	key: 1,
	class: "text-foreground group-hover:underline underline-offset-2 decoration-1"
}, YD = { key: 0 }, XD = {
	__name: "AlertsRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = /* @__PURE__ */ P(null), a = J(() => !!i.value);
		function o(e) {
			i.value = e;
		}
		function s(e) {
			e || (i.value = null);
		}
		function c(e) {
			r("jump", e);
		}
		let l = Dr("cq:report-print", !1), u = /* @__PURE__ */ P(!0), d = J(() => l || u.value), f = (e) => (e.severity || "alert") === "warning" ? {
			icon: jf,
			iconClass: "text-warning-strong",
			textClass: "text-warning-strong"
		} : {
			icon: jf,
			iconClass: "text-destructive-strong",
			textClass: "text-destructive-strong"
		}, p = J(() => (n.component.alerts || []).map((e) => {
			let t = e.tooltip, n = null, r = null;
			typeof t == "string" ? r = t : t && Array.isArray(t.description) && t.description.length > 0 && (n = t.description);
			let i = r ? fT(r) : null, a = f(e), o = !!e.details, s = ID(e.details) === "behavioral" && e.details?.instance_count > 0 && ND.includes(e.codename);
			return {
				...e,
				tooltipItems: n,
				tooltipText: r,
				tooltipHtml: i,
				style: a,
				clickable: o,
				showInstanceCount: s
			};
		}));
		return (e, t) => (V(), H(B, null, [p.value.length ? (V(), H("div", BD, [W("div", { class: M(["flex items-center gap-2", d.value && "mb-1"]) }, [W("p", VD, N(p.value.length === 1 ? "1 alert" : `${p.value.length} alerts`), 1), F(l) ? q("", !0) : (V(), U(F(Jx), {
			key: 0,
			variant: "link",
			size: "link",
			class: "text-foreground hover:text-foreground shrink-0 gap-1",
			"aria-expanded": u.value,
			"aria-label": u.value ? "Collapse alerts" : "Expand alerts",
			onClick: t[0] ||= (e) => u.value = !u.value
		}, {
			default: I(() => [K(N(u.value ? "Less" : "More") + " ", 1), G(F(Yd), { class: M(["size-3.5 transition-transform", u.value && "rotate-180"]) }, null, 8, ["class"])]),
			_: 1
		}, 8, ["aria-expanded", "aria-label"]))], 2), d.value ? (V(), H("div", HD, [(V(!0), H(B, null, R(p.value, (e, t) => (V(), H("div", {
			key: t,
			class: M(["group flex items-start gap-2 text-sm", { "cursor-pointer": e.clickable }]),
			onClick: (t) => e.clickable && o(e)
		}, [(V(), U(ga(e.style.icon), { class: M(["size-4 shrink-0 mt-0.5", e.style.iconClass]) }, null, 8, ["class"])), e.tooltipItems || e.tooltipText ? (V(), U(F(fS), {
			key: 0,
			"delay-duration": 350
		}, {
			default: I(() => [G(F(uS), null, {
				default: I(() => [G(F(pS), { "as-child": "" }, {
					default: I(() => [W("span", { class: M(["text-foreground group-hover:underline underline-offset-2 decoration-1", e.clickable ? "cursor-pointer" : "cursor-help"]) }, [K(N(e.text) + " ", 1), e.showInstanceCount ? (V(), H("span", WD, " (" + N(e.details.instance_count) + ")", 1)) : q("", !0)], 2)]),
					_: 2
				}, 1024), G(F(dS), {
					side: "top",
					class: "max-w-sm"
				}, {
					default: I(() => [e.tooltipItems ? (V(), H(B, { key: 0 }, [e.tooltipItems.length === 1 ? (V(), H("span", GD, N(e.tooltipItems[0].value), 1)) : (V(), H("ul", KD, [(V(!0), H(B, null, R(e.tooltipItems, (e, t) => (V(), H("li", { key: t }, N(e.value), 1))), 128))]))], 64)) : e.tooltipHtml ? (V(), H("div", {
						key: 1,
						class: "tooltip-markdown",
						innerHTML: e.tooltipHtml
					}, null, 8, qD)) : q("", !0)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024)) : (V(), H("span", JD, [K(N(e.text) + " ", 1), e.showInstanceCount ? (V(), H("span", YD, " (" + N(e.details.instance_count) + ")", 1)) : q("", !0)]))], 10, UD))), 128))])) : q("", !0)])) : q("", !0), G(zD, {
			open: a.value,
			alert: i.value,
			"onUpdate:open": s,
			onJump: c
		}, null, 8, ["open", "alert"])], 64));
	}
}, ZD = {
	key: 0,
	class: "space-y-4"
}, QD = {
	key: 0,
	class: "flex items-start gap-2"
}, $D = { class: "text-base leading-relaxed text-foreground" }, eO = { class: "space-y-4" }, tO = { class: "flex flex-col items-center pt-3" }, nO = {
	key: 1,
	class: "size-4 shrink-0 rounded-full bg-background border-2 border-border"
}, rO = { class: "mb-3" }, iO = { class: "text-sm text-muted-foreground" }, aO = { class: "text-lg font-semibold text-foreground mb-3" }, oO = { class: "text-base text-body leading-relaxed" }, sO = {
	key: 1,
	class: "text-body italic"
}, cO = {
	__name: "CandidateQuestionsRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.component.questions || []), a = J(() => n.component.summary);
		function o(e) {
			if (typeof e == "string") return e;
			let t = Math.floor(e), n = Math.floor(t / 3600), r = Math.floor(t % 3600 / 60), i = t % 60;
			return n > 0 ? `${n}:${r.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}` : `${r}:${i.toString().padStart(2, "0")}`;
		}
		function s(e) {
			if (typeof e == "number") return e;
			if (typeof e == "string") {
				let t = e.split(":").map(Number);
				if (t.length === 2) {
					let [e, n] = t;
					return e * 60 + n;
				}
				if (t.length === 3) {
					let [e, n, r] = t;
					return e * 3600 + n * 60 + r;
				}
			}
			return NaN;
		}
		function c(e) {
			if (e == null) return;
			let t = s(e);
			if (!Number.isFinite(t)) {
				console.warn("Invalid timestamp for jump:", e);
				return;
			}
			console.log("[CandidateQuestionsRenderer] Jumping to timestamp:", e, "→", t, "seconds"), r("jump", t);
		}
		return (e, t) => i.value.length ? (V(), H("div", ZD, [a.value ? (V(), H("div", QD, [W("p", $D, N(a.value), 1)])) : q("", !0), W("div", eO, [(V(!0), H(B, null, R(i.value, (e, n) => (V(), H("div", {
			key: e.transcription_chunk_id || n,
			class: "flex gap-3"
		}, [W("div", tO, [e.agent_could_not_answer ? (V(), U(F(Qd), {
			key: 0,
			class: "size-4 shrink-0 text-warning-foreground"
		})) : (V(), H("div", nO)), t[0] ||= W("div", { class: "flex-1 w-px bg-border min-h-8" }, null, -1)]), W("div", { class: M(["flex-1 min-w-0 rounded-lg p-3", e.agent_could_not_answer ? "bg-warning/10" : ""]) }, [
			W("div", rO, [W("span", iO, N(o(e.timestamp)), 1)]),
			W("h4", aO, N(e.question_text), 1),
			W("div", { class: M(["rounded-lg px-3 py-2 mb-3", e.agent_could_not_answer ? "" : "bg-muted"]) }, [t[1] ||= W("div", { class: "mb-2" }, [W("span", { class: "text-sm font-medium text-body" }, "Interviewer")], -1), W("div", oO, N(e.answer_text || "--"), 1)], 2),
			e.transcription_chunk_id ? (V(), U(F(Jx), {
				key: 0,
				variant: "link",
				size: "sm",
				class: "h-auto p-0 text-sm underline",
				onClick: (t) => c(e.timestamp)
			}, {
				default: I(() => [G(F(Rf), {
					mono: !0,
					class: "size-4 mr-1"
				}), t[2] ||= K(" View in transcript ", -1)]),
				_: 1
			}, 8, ["onClick"])) : q("", !0)
		], 2)]))), 128))])])) : (V(), H("p", sO, "No questions asked"));
	}
}, lO = { class: "space-y-5" }, uO = {
	key: 0,
	class: "text-[15px] text-foreground leading-relaxed"
}, dO = {
	key: 1,
	class: "rounded-lg border border-border"
}, fO = {
	key: 0,
	class: "-mt-4 mb-4 border-t border-border/50"
}, pO = { class: "flex items-center justify-between gap-3 mb-3" }, mO = { class: "text-foreground" }, hO = { class: "bg-muted rounded-lg px-4 py-3" }, gO = { class: "flex items-start gap-2" }, _O = { class: "text-[17px] text-foreground leading-relaxed" }, vO = { key: 2 }, yO = { class: "bg-muted rounded-lg px-5 py-4 flex items-center gap-3" }, bO = ["src"], xO = {
	key: 1,
	class: "size-8 rounded-full bg-border shrink-0 flex items-center justify-center"
}, SO = { class: "text-[15px] text-foreground leading-relaxed" }, CO = {
	__name: "QuestionSectionRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.summary || null), r = J(() => t.component.questions || []), i = J(() => t.component.candidate_highlight || null), a = J(() => t.component.candidate_image || null);
		return (e, t) => (V(), H("div", lO, [
			n.value ? (V(), H("p", uO, N(n.value), 1)) : q("", !0),
			r.value.length ? (V(), H("div", dO, [(V(!0), H(B, null, R(r.value, (e, t) => (V(), H("div", {
				key: `${e.question}-${t}`,
				class: "px-5 py-4"
			}, [
				t > 0 ? (V(), H("div", fO)) : q("", !0),
				W("div", pO, [W("h4", mO, N(e.question), 1), G(F(bf), { class: "size-5 text-muted-foreground shrink-0" })]),
				W("div", hO, [W("div", gO, [G(F(Rf), { class: "size-4 shrink-0 mt-0.5" }), W("p", _O, N(e.analysis), 1)])])
			]))), 128))])) : q("", !0),
			i.value ? (V(), H("div", vO, [t[0] ||= W("p", { class: "text-[12px] font-medium text-muted-foreground uppercase tracking-wide mb-3" }, "Candidate's highlight", -1), W("div", yO, [a.value ? (V(), H("img", {
				key: 0,
				src: a.value,
				alt: "Candidate",
				class: "size-8 rounded-full shrink-0 object-cover"
			}, null, 8, bO)) : (V(), H("div", xO, [G(F(Mf), { class: "size-4 text-muted-foreground" })])), W("p", SO, " \"" + N(i.value) + "\" ", 1)])])) : q("", !0)
		]));
	}
}, wO = { class: "flex items-center gap-2" }, TO = { class: "text-foreground" }, EO = {
	key: 1,
	class: "text-body italic"
}, DO = {
	__name: "HiringRecommendationsRenderer",
	props: {
		component: {
			type: Object,
			required: !0
		},
		size: {
			type: String,
			default: "base",
			validator: (e) => ["sm", "base"].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => t.size === "sm" ? "w-full text-sm" : "w-full text-base");
		function r(e) {
			switch (e) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return "success";
				case "no_decision":
				case "neutral": return "warning";
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return "destructive";
				default: return "outline";
			}
		}
		function i(e) {
			switch (e) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return kf;
				case "no_decision":
				case "neutral": return Sf;
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return Of;
				default: return null;
			}
		}
		return (t, a) => e.component.recommendations?.length ? (V(), H("div", {
			key: 0,
			class: M(n.value)
		}, [G(F(FT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			size: e.size,
			dividers: !0
		}, {
			default: I(() => [G(F(IT), null, {
				default: I(() => [(V(!0), H(B, null, R(e.component.recommendations, (e) => (V(), U(F(RT), { key: e.name }, {
					default: I(() => [G(F(LT), { class: "align-top text-foreground px-0 pr-2" }, {
						default: I(() => [W("div", wO, [
							G(F(Mf), { class: "size-4 text-body shrink-0" }),
							W("span", null, N(e.name), 1),
							e.recommendation ? (V(), U(F(UE), {
								key: 0,
								variant: r(e.recommendation),
								icon: i(e.recommendation)
							}, {
								default: I(() => [K(N(e.label), 1)]),
								_: 2
							}, 1032, ["variant", "icon"])) : q("", !0)
						])]),
						_: 2
					}, 1024), G(F(LT), { class: "align-top px-0 pl-2" }, {
						default: I(() => [W("span", TO, N(e.feedback || "-"), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["size"])], 2)) : (V(), H("p", EO, "No recommendations submitted yet"));
	}
}, OO = { class: "flex flex-col items-start gap-2 min-w-0 w-full" }, kO = { class: "w-full min-w-0 text-sm text-foreground leading-tight break-words lg:truncate" }, AO = {
	__name: "KpiCell",
	props: {
		label: {
			type: String,
			default: ""
		},
		as: {
			type: String,
			default: "div"
		}
	},
	setup(e) {
		return (t, n) => (V(), U(ga(e.as), { class: "flex flex-col justify-between items-start min-w-0 flex-1" }, {
			default: I(() => [W("div", OO, [W("span", kO, [z(t.$slots, "label", {}, () => [K(N(e.label), 1)])]), z(t.$slots, "default")]), z(t.$slots, "footer")]),
			_: 3
		}));
	}
}, jO = {
	hire: {
		up: "Hire",
		neutral: "No Decision",
		down: "No Hire"
	},
	fit: {
		up: "Fit",
		neutral: "Potential fit",
		down: "Not a fit"
	}
};
function MO(e, t = "hire") {
	return (jO[t] || jO.hire)[e] || "";
}
//#endregion
//#region src/components/interview/report/ScorecardOverviewStrip.vue
var NO = { class: "grid grid-cols-2 sm:grid-cols-4 lg:flex lg:items-stretch lg:justify-between gap-4 min-w-0" }, PO = { class: "flex flex-col gap-2" }, FO = {
	key: 0,
	class: "flex flex-col gap-1.5 text-sm text-body"
}, IO = { class: "truncate" }, LO = {
	key: 1,
	class: "text-sm text-body leading-snug"
}, RO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, zO = { class: "tabular-nums" }, BO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, VO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, HO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, UO = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, WO = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, GO = {
	key: 0,
	class: "text-base text-foreground"
}, KO = {
	key: 1,
	class: "text-base text-placeholder italic leading-6"
}, qO = { key: 2 }, JO = {
	__name: "ScorecardOverviewStrip",
	props: {
		recommendation: {
			type: String,
			default: ""
		},
		averageRating: {
			type: Number,
			default: null
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		durationMinutes: {
			type: Number,
			default: null
		},
		interviewerFeedback: {
			type: String,
			default: ""
		},
		mockSeed: {
			type: [String, Number],
			default: "default"
		},
		screeningOverride: {
			type: Object,
			default: null
		},
		guideCoverageOverride: {
			type: Object,
			default: null
		},
		fraud: {
			type: Object,
			default: null
		},
		fraudLoading: {
			type: Boolean,
			default: !1
		},
		talkTime: {
			type: Object,
			default: null
		},
		showInterviewScore: {
			type: Boolean,
			default: !0
		},
		showFraudKpi: {
			type: Boolean,
			default: !0
		},
		showRecommendation: {
			type: Boolean,
			default: !0
		},
		showScreening: {
			type: Boolean,
			default: !0
		},
		showGuideCoverage: {
			type: Boolean,
			default: !0
		},
		screeningEnabled: {
			type: Boolean,
			default: !0
		},
		feedbackEnabled: {
			type: Boolean,
			default: !0
		},
		recommendationVocabulary: {
			type: String,
			default: "hire",
			validator: (e) => ["hire", "fit"].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => {
			let e = (t.recommendation?.toLowerCase() || "").replace(/-/g, "_");
			return e.includes("no_hire") || e.includes("no_recommend") || e.includes("reject") || e.includes("do_not") || e.includes("not_recommend") ? "down" : e === "no_decision" || e === "neutral" || e === "mixed" ? "neutral" : e.includes("hire") || e.includes("recommend") || e.includes("yes") ? "up" : "neutral";
		}), r = J(() => MO(n.value, t.recommendationVocabulary)), i = J(() => {
			let e = Number(t.averageRating);
			return Number.isFinite(e) ? e.toFixed(1) : "-";
		}), a = J(() => t.durationMinutes != null && t.durationMinutes > 0), o = J(() => {
			if (!a.value) return "—";
			let e = Math.round(t.durationMinutes);
			if (e < 60) return `${e}m`;
			let n = Math.floor(e / 60), r = e % 60;
			return r === 0 ? `${n}h` : `${n}h${r}`;
		});
		function s(e) {
			let t = String(e ?? "seed"), n = 0;
			for (let e = 0; e < t.length; e += 1) n = (n << 5) - n + t.charCodeAt(e), n |= 0;
			return Math.abs(n);
		}
		let c = J(() => {
			let e = s(t.mockSeed), n = e % 10 < 7, r = 12 + (e >> 5) % 14, i = Math.floor(r / 2) + (e >> 7) % Math.ceil(r / 2);
			return {
				screeningPassed: n,
				guideTotal: r,
				guideCovered: i,
				guideCoveragePct: Math.round(i / r * 100)
			};
		}), l = J(() => {
			let e = t.guideCoverageOverride;
			return !!e && Number.isFinite(Number(e.total)) && Number(e.total) > 0;
		}), u = J(() => {
			if (!l.value) return null;
			let e = Number(t.guideCoverageOverride?.covered) || 0, n = Number(t.guideCoverageOverride?.total) || 0;
			return Math.round(e / n * 100);
		}), d = J(() => {
			let e = t.talkTime;
			return !!e && Number.isFinite(Number(e.interviewerPercent)) && Number.isFinite(Number(e.candidatePercent));
		}), f = J(() => d.value ? Math.round(Number(t.talkTime.interviewerPercent)) : null), p = J(() => d.value ? Math.round(Number(t.talkTime.candidatePercent)) : null), m = [
			"screening",
			"recommendation",
			"score",
			"fraud",
			"duration",
			"guide",
			"talkTime"
		], h = J(() => ({
			screening: t.screeningEnabled,
			recommendation: t.showRecommendation,
			score: t.showInterviewScore,
			fraud: t.showFraudKpi,
			duration: a.value,
			guide: t.showGuideCoverage,
			talkTime: d.value
		})), g = (e) => m.slice(0, m.indexOf(e)).some((e) => h.value[e]), _ = J(() => {
			let e = t.screeningOverride;
			return e ? Number(e.failed) > 0 ? "fail" : Number(e.undetermined) > 0 ? "undetermined" : Number(e.passed) > 0 ? "pass" : "undetermined" : c.value.screeningPassed ? "pass" : "fail";
		}), v = J(() => _.value === "pass" ? "Pass" : _.value === "fail" ? "Fail" : "Indeterminate"), y = J(() => _.value === "pass" ? "text-success-strong" : _.value === "fail" ? "text-destructive-strong" : "text-warning-strong"), b = {
			pass: {
				label: "Pass",
				icon: ef,
				color: "text-success-strong"
			},
			fail: {
				label: "Fail",
				icon: rf,
				color: "text-destructive-strong"
			},
			undetermined: {
				label: "Indeterminate",
				icon: Sf,
				color: "text-warning-strong"
			}
		}, x = J(() => {
			let e = t.screeningOverride?.items;
			return Array.isArray(e) ? e.map((e) => {
				let t = b[e.verdict] || b.undetermined;
				return {
					title: e.title,
					...t
				};
			}) : [];
		}), S = {
			low: "Low",
			medium: "Medium",
			high: "High"
		}, C = {
			low: "text-success-strong",
			medium: "text-warning-strong",
			high: "text-destructive-strong"
		}, w = J(() => {
			let e = t.fraud?.risk_level?.toLowerCase();
			return e && S[e] ? e : null;
		}), T = J(() => S[w.value] || "—"), E = J(() => C[w.value] || "text-foreground"), ee = J(() => T.value), D = J(() => !!t.interviewerFeedback?.trim());
		return (t, s) => (V(), U(F(_m), {
			variant: "ghost",
			class: "p-4 pt-2 flex flex-col gap-6"
		}, {
			default: I(() => [
				W("div", NO, [
					e.screeningEnabled ? (V(), H(B, { key: 0 }, [e.showScreening ? (V(), U(F(fS), {
						key: 0,
						"delay-duration": 200
					}, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(AO), {
									label: "Screening",
									class: "cursor-help"
								}, {
									default: I(() => [W("span", { class: M(["text-2xl font-medium truncate", y.value]) }, N(v.value), 3)]),
									_: 1
								})]),
								_: 1
							}), G(F(dS), {
								side: "bottom",
								class: "w-96 max-w-96 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: I(() => [W("div", PO, [s[0] ||= W("span", { class: "text-base font-medium text-foreground" }, "Screening checklist", -1), x.value.length ? (V(), H("ul", FO, [(V(!0), H(B, null, R(x.value, (e) => (V(), H("li", {
									key: e.title,
									class: "flex items-center justify-between gap-4"
								}, [W("span", IO, N(e.title), 1), G(F(UE), {
									variant: "outline",
									icon: e.icon,
									"icon-class": e.color,
									class: "shrink-0"
								}, {
									default: I(() => [K(N(e.label), 1)]),
									_: 2
								}, 1032, ["icon", "icon-class"])]))), 128))])) : (V(), H("p", LO, " Aggregated pass/fail across all screening items. "))])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					})) : (V(), U(F(AO), {
						key: 1,
						label: "Screening"
					}, {
						default: I(() => [...s[1] ||= [W("span", { class: "text-2xl font-medium truncate text-muted-foreground" }, "--", -1)]]),
						_: 1
					}))], 64)) : q("", !0),
					e.showRecommendation ? (V(), H(B, { key: 1 }, [g("recommendation") ? (V(), U(F(tS), {
						key: 0,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : q("", !0), G(F(AO), { label: "Recommendation" }, {
						default: I(() => [W("span", { class: M(["text-2xl font-medium truncate", {
							"text-success-strong": n.value === "up",
							"text-destructive-strong": n.value === "down",
							"text-muted-foreground": n.value === "neutral"
						}]) }, N(r.value), 3)]),
						_: 1
					})], 64)) : q("", !0),
					e.showInterviewScore ? (V(), H(B, { key: 2 }, [g("score") ? (V(), U(F(tS), {
						key: 0,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : q("", !0), G(F(AO), null, {
						default: I(() => [W("span", RO, N(i.value), 1)]),
						label: I(() => [s[2] ||= K(" Interview Score ", -1), W("span", zO, "/" + N(e.scaleLength), 1)]),
						_: 1
					})], 64)) : q("", !0),
					e.showFraudKpi ? (V(), H(B, { key: 3 }, [g("fraud") ? (V(), U(F(tS), {
						key: 0,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : q("", !0), G(F(AO), { label: "Fraud Analysis" }, {
						default: I(() => [e.fraudLoading ? (V(), U(F(xm), {
							key: 0,
							class: "h-7 w-16"
						})) : (V(), H("span", {
							key: 1,
							class: M(["text-2xl font-medium tabular-nums truncate", E.value])
						}, N(ee.value), 3))]),
						_: 1
					})], 64)) : q("", !0),
					a.value ? (V(), H(B, { key: 4 }, [g("duration") ? (V(), U(F(tS), {
						key: 0,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : q("", !0), G(F(AO), { label: "Duration" }, {
						default: I(() => [W("span", BO, N(o.value), 1)]),
						_: 1
					})], 64)) : q("", !0),
					e.showGuideCoverage && g("guide") ? (V(), U(F(tS), {
						key: 5,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : q("", !0),
					e.showGuideCoverage ? (V(), U(F(AO), {
						key: 6,
						label: l.value ? "Questions covered" : "Guide covered"
					}, {
						default: I(() => [W("span", VO, N(l.value ? u.value : c.value.guideCoveragePct) + "% ", 1)]),
						_: 1
					}, 8, ["label"])) : q("", !0),
					d.value && g("talkTime") ? (V(), U(F(tS), {
						key: 7,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : q("", !0),
					d.value ? (V(), U(F(AO), { key: 8 }, {
						label: I(() => [G(F(fS), { "delay-duration": 200 }, {
							default: I(() => [G(F(uS), null, {
								default: I(() => [G(F(pS), { "as-child": "" }, {
									default: I(() => [...s[3] ||= [W("span", { class: "cursor-help" }, "Interviewer/Candidate Talk %", -1)]]),
									_: 1
								}), G(F(dS), {
									side: "bottom",
									class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
								}, {
									default: I(() => [...s[4] ||= [W("div", { class: "flex flex-col gap-2" }, [W("span", { class: "text-base font-medium text-foreground" }, "Talk time share"), W("p", { class: "text-sm text-body leading-snug" }, " We measure how much of the conversation each side spoke. The share combines speaking duration with pace (words per minute) and word density, so a fast talker doesn't skew higher than someone who simply spoke for longer. ")], -1)]]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						default: I(() => [W("span", HO, [
							G(F(fS), { "delay-duration": 200 }, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", UO, N(f.value), 1)]),
										_: 1
									}), G(F(dS), { side: "bottom" }, {
										default: I(() => [...s[5] ||= [K(" Interviewer ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							}),
							s[7] ||= W("span", { class: "text-muted-foreground font-normal" }, " / ", -1),
							G(F(fS), { "delay-duration": 200 }, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", WO, N(p.value), 1)]),
										_: 1
									}), G(F(dS), { side: "bottom" }, {
										default: I(() => [...s[6] ||= [K(" Candidate ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							})
						])]),
						_: 1
					})) : q("", !0)
				]),
				e.feedbackEnabled || t.$slots.expanded ? (V(), U(F(tS), { key: 0 })) : q("", !0),
				e.feedbackEnabled ? (V(), H(B, { key: 1 }, [D.value ? (V(), H("p", GO, [
					s[8] ||= W("span", {
						class: "text-muted-foreground select-none",
						"aria-hidden": "true"
					}, "“", -1),
					K(N(e.interviewerFeedback), 1),
					s[9] ||= W("span", {
						class: "text-muted-foreground select-none",
						"aria-hidden": "true"
					}, "”", -1)
				])) : (V(), H("p", KO, " - The interviewer did not provide feedback - "))], 64)) : q("", !0),
				t.$slots.expanded ? (V(), H("div", qO, [z(t.$slots, "expanded")])) : q("", !0)
			]),
			_: 3
		}));
	}
};
//#endregion
//#region src/utils/report/agentReportProjections.js
function YO(e) {
	return !!e?.skipped;
}
var XO = {
	screening: 0,
	observable: 1,
	competency: 2,
	main: 2,
	skills: 2,
	brand_fit: 3,
	brandfit: 3,
	other: 4
};
function ZO(e) {
	let t = XO[String(e?.id || "").toLowerCase()];
	if (t != null) return t;
	let n = e?.competencies || [];
	return n.some((e) => e.is_observable) ? 1 : n.some((e) => e.is_brand_fit) ? 3 : 2;
}
function QO(e, t) {
	let n = [], r = e?.questions || [];
	if (r.length && n.push({
		id: "screening",
		title: e?.title || "",
		scale: e?.scale || {
			length: 3,
			labels: null
		},
		competencies: r.map((e) => ({
			id: e.id,
			name: e.title,
			question: e.question || e.title,
			isScreening: !0,
			anchors: e.anchors || void 0,
			conditional: e.conditional || null,
			skipped: e.skipped || null,
			_screeningResponse: YO(e) ? "" : e.response || ""
		}))
	}), t?.sections?.length) {
		let e = t.sections.map((e, t) => ({
			section: e,
			index: t
		})).sort((e, t) => {
			let n = ZO(e.section) - ZO(t.section);
			return n === 0 ? e.index - t.index : n;
		});
		for (let { section: r } of e) r.competencies?.length && n.push({
			id: r.id,
			title: r.title || "",
			scale: t.scale || {
				length: 5,
				labels: null
			},
			competencies: r.competencies
		});
	}
	return n.map((e) => ({
		id: `table_${e.id}`,
		title: e.title,
		scale: e.scale,
		sections: [{
			id: e.id,
			title: e.title,
			competencies: e.competencies
		}]
	}));
}
function $O(e, t) {
	let n = {};
	for (let t of e?.questions || []) YO(t) || typeof t.rating == "number" && (n[t.id] = t.rating);
	let r = {
		...n,
		...t?.ratings || {}
	};
	for (let e of t?.sections || []) for (let t of e.competencies || []) YO(t) && delete r[t.id];
	return r;
}
function ek(e, t) {
	let n = {};
	for (let t of e?.questions || []) !YO(t) && t.notes && (n[t.id] = t.notes);
	let r = {
		...n,
		...t?.feedback || {}
	};
	for (let e of t?.sections || []) for (let t of e.competencies || []) YO(t) && delete r[t.id];
	return r;
}
function tk(e, t) {
	let n = {};
	for (let e of t?.sections || []) for (let r of e.competencies || []) {
		if (YO(r)) continue;
		let e = t?.feedback?.[r.id], i = t?.transcripts?.[r.id];
		(e || i) && (n[r.id] = [{
			notes: e ? [{
				text: e,
				sentiment: "neutral"
			}] : [],
			transcript: i || ""
		}]);
	}
	for (let t of e?.questions || []) !YO(t) && t.response && (n[t.id] = [{
		notes: [],
		transcript: t.response
	}]);
	return Object.keys(n).length ? {
		entriesPerCompetency: n,
		ratings: {}
	} : null;
}
function nk(e) {
	let t = e?.questions || [];
	if (!t.length) return null;
	let n = 0, r = 0, i = 0, a = [];
	for (let e of t) {
		if (YO(e)) continue;
		let t = rk(e?.flag?.color);
		t === "pass" ? n += 1 : t === "undetermined" ? i += 1 : r += 1, a.push({
			title: e.title,
			verdict: t
		});
	}
	return {
		passed: n,
		failed: r,
		undetermined: i,
		total: a.length,
		items: a
	};
}
function rk(e) {
	return e === "green" ? "pass" : e === "gray" ? "undetermined" : "fail";
}
//#endregion
//#region src/components/interview/report/renderers/KpiStripRenderer.vue
var ik = { class: "flex flex-col gap-4 px-8 min-w-0 agent-strip" }, ak = { class: "grid gap-x-4 gap-y-4 md:grid-cols-2 text-sm" }, ok = { class: "flex flex-col gap-3" }, sk = {
	key: 0,
	class: "space-y-1"
}, ck = {
	key: 1,
	class: "text-muted-foreground"
}, lk = { class: "flex flex-col gap-3" }, uk = {
	key: 0,
	class: "space-y-1"
}, dk = {
	key: 1,
	class: "text-muted-foreground"
}, fk = /*#__PURE__*/ pT({
	__name: "KpiStripRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = /^(none|n\/?a|null|-{1,2})$/i;
		function r(e) {
			return (Array.isArray(e) ? e : e == null ? [] : [e]).filter((e) => {
				let t = String(e ?? "").trim();
				return t && !n.test(t);
			});
		}
		let i = J(() => r(t.component.strengths)), a = J(() => r(t.component.considerations)), o = J(() => nk(t.component.screening)), s = J(() => t.component.averageRating != null), c = J(() => !!t.component.fraud), l = J(() => !!t.component.recommendation), u = J(() => o.value != null), d = J(() => t.component.guideCoverage != null), f = J(() => t.component.displayFlags || {}), p = J(() => f.value.show_screening !== !1), m = J(() => f.value.show_ai_summary !== !1);
		return (t, n) => (V(), H("div", ik, [G(JO, {
			"mock-seed": e.component.mockSeed || "agent",
			recommendation: e.component.recommendation || "",
			"recommendation-vocabulary": "fit",
			"average-rating": e.component.averageRating ?? null,
			"scale-length": e.component.scaleLength || 5,
			"duration-minutes": e.component.durationMinutes ?? null,
			"interviewer-feedback": e.component.summary || "",
			"screening-override": o.value,
			"guide-coverage-override": e.component.guideCoverage || null,
			fraud: e.component.fraud || null,
			"talk-time": e.component.talkTime || null,
			"show-interview-score": s.value,
			"show-fraud-kpi": c.value,
			"show-recommendation": l.value,
			"show-screening": u.value,
			"show-guide-coverage": d.value,
			"screening-enabled": p.value,
			"feedback-enabled": m.value
		}, ba({ _: 2 }, [i.value.length || a.value.length ? {
			name: "expanded",
			fn: I(() => [W("div", ak, [W("div", ok, [
				n[0] ||= W("h3", { class: "text-base font-semibold font-title text-foreground" }, "Strengths", -1),
				G(F(tS)),
				i.value.length ? (V(), H("ul", sk, [(V(!0), H(B, null, R(i.value, (e, t) => (V(), H("li", {
					key: `s-${t}`,
					class: "flex items-start gap-2 text-foreground"
				}, [G(F(Jd), { class: "size-4 shrink-0 mt-0.5" }), W("span", null, N(e), 1)]))), 128))])) : (V(), H("p", ck, "No strengths identified"))
			]), W("div", lk, [
				n[1] ||= W("h3", { class: "text-base font-semibold font-title text-foreground" }, "Considerations", -1),
				G(F(tS)),
				a.value.length ? (V(), H("ul", uk, [(V(!0), H(B, null, R(a.value, (e, t) => (V(), H("li", {
					key: `c-${t}`,
					class: "flex items-start gap-2 text-foreground"
				}, [G(F(Ff), { class: "size-4 shrink-0 mt-0.5" }), W("span", null, N(e), 1)]))), 128))])) : (V(), H("p", dk, "No considerations identified"))
			])])]),
			key: "0"
		} : void 0]), 1032, [
			"mock-seed",
			"recommendation",
			"average-rating",
			"scale-length",
			"duration-minutes",
			"interviewer-feedback",
			"screening-override",
			"guide-coverage-override",
			"fraud",
			"talk-time",
			"show-interview-score",
			"show-fraud-kpi",
			"show-recommendation",
			"show-screening",
			"show-guide-coverage",
			"screening-enabled",
			"feedback-enabled"
		])]));
	}
}, [["__scopeId", "data-v-f12875d7"]]), pk = {
	__name: "ButtonGroup",
	props: {
		orientation: {
			type: String,
			default: "horizontal",
			validator: (e) => ["horizontal", "vertical"].includes(e)
		},
		class: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "div"
		}
	},
	setup(e) {
		let t = e;
		return (n, r) => (V(), U(F(Og), {
			role: "group",
			as: e.as,
			"as-child": e.asChild,
			class: M(F(hm)("inline-flex", e.orientation === "vertical" ? "flex-col" : "flex-row", "*:relative", "[&>*:first-child:not(:last-child)]:rounded-r-none", "[&>*:last-child:not(:first-child)]:rounded-l-none", "[&>*:not(:first-child):not(:last-child)]:rounded-none", "[&>*:not(:first-child)]:-ml-px", e.orientation === "vertical" && [
				"[&>*:first-child:not(:last-child)]:rounded-b-none [&>*:first-child:not(:last-child)]:rounded-r-md",
				"[&>*:last-child:not(:first-child)]:rounded-t-none [&>*:last-child:not(:first-child)]:rounded-l-md",
				"[&>*:not(:first-child)]:ml-0 [&>*:not(:first-child)]:-mt-px"
			], t.class))
		}, {
			default: I(() => [z(n.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"class"
		]));
	}
}, mk = {
	__name: "RadioGroup",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qh(eh(n, "class"), r);
		return (e, t) => (V(), U(F(qb), gs({ class: F(hm)("grid gap-2", n.class) }, F(i)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, hk = {
	__name: "RadioGroupItem",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => [
				"default",
				"muted",
				"success"
			].includes(e)
		},
		size: {
			type: String,
			default: "default",
			validator: (e) => [
				"sm",
				"default",
				"lg"
			].includes(e)
		}
	},
	setup(e) {
		let t = e, n = Zh(eh(t, "class", "variant", "size")), r = J(() => {
			let e = {
				default: "data-[state=checked]:border-primary data-[state=checked]:text-primary",
				muted: "data-[state=checked]:border-muted-foreground data-[state=checked]:text-muted-foreground",
				success: "data-[state=checked]:border-success data-[state=checked]:text-success"
			}, n = e[t.variant] || e.default;
			return `${t.size === "lg" ? "border-placeholder/80 text-placeholder/80" : "border-placeholder text-placeholder"} ${n}`;
		}), i = J(() => {
			switch (t.size) {
				case "sm": return {
					container: "h-3.5 w-3.5 border",
					indicator: "size-2"
				};
				case "lg": return {
					container: "h-5 w-5 border-2",
					indicator: "size-3"
				};
				default: return {
					container: "h-4 w-4 border",
					indicator: "size-2.5"
				};
			}
		});
		return (e, a) => (V(), U(F(Xb), gs(F(n), { class: F(hm)("peer aspect-square rounded-full focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed", i.value.container, r.value, t.class) }), {
			default: I(() => [G(F(Zb), { class: "flex items-center justify-center" }, {
				default: I(() => [G(F(af), { class: M(F(hm)("fill-current text-current", i.value.indicator)) }, null, 8, ["class"])]),
				_: 1
			})]),
			_: 1
		}, 16, ["class"]));
	}
}, gk = {
	__name: "DropdownMenu",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Qh(e, t);
		return (e, t) => (V(), U(F(Ib), De(us(F(n))), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, _k = { class: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center" }, vk = {
	__name: "DropdownMenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qh(eh(n, "class"), r);
		return (e, t) => (V(), U(F(Nb), gs(F(i), { class: F(hm)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm text-body outline-none transition-colors focus:bg-accent focus:text-foreground data-[state=checked]:text-foreground data-[state=checked]:font-medium data-[disabled]:pointer-events-none data-[disabled]:opacity-50", n.class) }), {
			default: I(() => [W("span", _k, [G(F(zb), null, {
				default: I(() => [G(F(Jd), { class: "w-4 h-4" })]),
				_: 1
			})]), z(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, yk = {
	__name: "DropdownMenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Qh(eh(n, "class"), r), a = Pd();
		return (e, t) => (V(), U(F(Bb), { to: F(a) }, {
			default: I(() => [G(F(Lb), gs(F(i), { class: F(hm)("z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", n.class) }), {
				default: I(() => [z(e.$slots, "default")]),
				_: 3
			}, 16, ["class"])]),
			_: 3
		}, 8, ["to"]));
	}
}, bk = {
	__name: "DropdownMenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		inset: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Zh(eh(t, "class"));
		return (r, i) => (V(), U(F(Rb), gs(F(n), { class: F(hm)("relative flex cursor-default select-none items-center rounded-sm gap-2 px-2 py-1.5 text-sm text-body outline-none transition-colors focus:bg-accent focus:text-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0", e.inset && "pl-8", t.class) }), {
			default: I(() => [z(r.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, xk = {
	__name: "DropdownMenuTrigger",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = Zh(e);
		return (e, n) => (V(), U(F(Vb), gs({ class: "outline-none" }, F(t)), {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, Sk = {
	__name: "InputGroup",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		function n(e) {
			e.target === e.currentTarget && e.currentTarget?.querySelector("[data-slot=input-group-control]")?.focus();
		}
		return (e, r) => (V(), H("div", {
			"data-slot": "input-group",
			role: "group",
			class: M(F(hm)("group/input-group relative flex w-full items-center rounded-md outline-none transition-[color,box-shadow] cursor-text", "h-9 min-w-0 has-[>textarea]:h-auto", "has-[>[data-align=inline-start]]:[&>input]:pl-0", "has-[>[data-align=inline-end]]:[&>input]:pr-0", "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3", "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3", "has-[[data-slot=input-group-control]:focus-visible]:ring-2 has-[[data-slot=input-group-control]:focus-visible]:ring-ring", t.class)),
			style: {
				"background-color": "var(--color-form-background)",
				border: "var(--form-border-width) solid var(--color-form-border)",
				"--tw-ring-offset-width": "var(--color-form-focus-ring-offset)"
			},
			onClick: n
		}, [z(e.$slots, "default")], 2));
	}
}, Ck = ["data-align"], wk = {
	__name: "InputGroupAddon",
	props: {
		align: {
			type: null,
			required: !1,
			default: "inline-start"
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		function n(e) {
			let t = e.currentTarget, n = e.target;
			n && n.closest("button") || t && t?.parentElement && t.parentElement?.querySelector("[data-slot=input-group-control]")?.focus();
		}
		return (e, r) => (V(), H("div", {
			role: "group",
			"data-slot": "input-group-addon",
			"data-align": t.align,
			class: M(F(hm)(F(Ok)({ align: t.align }), t.class)),
			onClick: n
		}, [z(e.$slots, "default")], 10, Ck));
	}
}, Tk = {
	__name: "InputGroupButton",
	props: {
		variant: {
			type: String,
			default: "ghost"
		},
		size: {
			type: String,
			default: "sm"
		},
		class: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		type: {
			type: String,
			default: "button"
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (V(), U(F(Jx), {
			type: t.type,
			variant: t.variant,
			size: t.size,
			disabled: t.disabled,
			class: M(t.class)
		}, {
			default: I(() => [z(e.$slots, "default")]),
			_: 3
		}, 8, [
			"type",
			"variant",
			"size",
			"disabled",
			"class"
		]));
	}
}, Ek = ["value"], Dk = {
	__name: "InputGroupTextarea",
	props: {
		class: {
			type: null,
			required: !1
		},
		modelValue: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: "lg"
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = wm("field-sizing-content w-full min-w-0 resize-none bg-transparent px-3 py-2 text-sm text-foreground shadow-none outline-none placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50", {
			variants: { size: {
				default: "min-h-9",
				sm: "min-h-8",
				lg: "min-h-24"
			} },
			defaultVariants: { size: "lg" }
		}), r = e, i = t, a = Ia();
		function o(e) {
			i("update:modelValue", e.target.value);
		}
		return (t, i) => (V(), H("textarea", gs({
			"data-slot": "input-group-control",
			value: e.modelValue,
			class: F(hm)(F(n)({ size: e.size }), r.class)
		}, F(a), { onInput: o }), null, 16, Ek));
	}
}, Ok = wm("text-muted-foreground flex shrink-0 items-center gap-1 px-1.5 [&>svg]:size-4", {
	variants: { align: {
		"inline-start": "order-first pl-3",
		"inline-end": "order-last pr-3",
		"block-start": "w-full order-first py-2",
		"block-end": "w-full order-last py-2"
	} },
	defaultVariants: { align: "inline-start" }
}), kk = { class: "text-sm font-medium text-body" }, Ak = { class: "flex items-start gap-1" }, jk = {
	key: 0,
	class: "text-base font-medium leading-snug text-foreground whitespace-normal"
}, Mk = { class: "text-sm text-body leading-snug whitespace-normal decoration-dotted decoration-body underline-offset-4 group-hover/q:underline" }, Nk = {
	key: 2,
	class: "text-sm text-body leading-snug whitespace-normal"
}, Pk = { class: "flex w-full h-8 gap-1" }, Fk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--right",
	"aria-hidden": "true"
}, Ik = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Lk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--left",
	"aria-hidden": "true"
}, Rk = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, zk = {
	key: 0,
	class: "flex w-full h-8"
}, Bk = { class: "w-full h-full flex items-center justify-center text-sm bg-muted text-muted-foreground rounded-sm" }, Vk = { class: "font-medium" }, Hk = {
	key: 1,
	class: "flex w-full h-8 gap-1"
}, Uk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--right",
	"aria-hidden": "true"
}, Wk = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Gk = { class: "font-medium" }, Kk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--left",
	"aria-hidden": "true"
}, qk = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Jk = { class: "font-medium" }, Yk = { class: "text-sm text-muted-foreground" }, Xk = { class: "flex-1 h-8 bg-muted rounded-sm overflow-hidden" }, Zk = { class: "w-8 text-right text-sm font-semibold tabular-nums text-foreground shrink-0" }, Qk = { class: "relative inline-flex" }, $k = {
	key: 0,
	class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}, eA = { class: "flex flex-col gap-2.5" }, tA = { class: "text-base font-medium text-foreground" }, nA = {
	key: 0,
	class: "flex flex-col gap-1.5"
}, rA = {
	key: 0,
	class: "text-xs text-body text-center leading-snug break-words px-2"
}, iA = { class: "text-xs text-body text-center leading-snug break-words line-clamp-2 px-2 transition-colors group-hover/cell:text-foreground" }, aA = { class: "flex flex-col gap-1.5" }, oA = {
	key: 0,
	class: "text-sm text-body"
}, sA = {
	key: 1,
	class: "flex items-stretch gap-3 text-sm text-body whitespace-pre-wrap"
}, cA = {
	key: 0,
	class: "flex flex-col gap-0.5"
}, lA = {
	key: 0,
	class: "text-body"
}, uA = { key: 1 }, dA = {
	key: 2,
	class: "text-sm text-muted-foreground"
}, fA = { class: "text-sm text-body leading-relaxed whitespace-pre-wrap pt-1" }, pA = {
	__name: "CompetencySection",
	props: {
		title: {
			type: String,
			required: !0
		},
		competencies: {
			type: Array,
			required: !0
		},
		ratings: {
			type: Object,
			required: !0
		},
		clarifications: {
			type: Object,
			default: () => ({})
		},
		showClarificationColumns: {
			type: Boolean,
			default: !1
		},
		clarificationsEnabled: {
			type: Boolean,
			default: !1
		},
		clarificationColumns: {
			type: Array,
			default: () => []
		},
		isReadOnly: {
			type: Boolean,
			default: !1
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		scaleLabels: {
			type: Array,
			default: null
		},
		feedback: {
			type: Object,
			default: () => ({})
		},
		isFirst: {
			type: Boolean,
			default: !1
		},
		selectedQuestionIds: {
			type: Object,
			default: () => ({})
		},
		guideQuestions: {
			type: Object,
			default: () => ({})
		},
		aiSuggestions: {
			type: Object,
			default: null
		},
		aiEnabled: {
			type: Boolean,
			default: !1
		},
		showScoringRubric: {
			type: Boolean,
			default: !1
		},
		showNotes: {
			type: Boolean,
			default: !1
		},
		questionsEditable: {
			type: Boolean,
			default: !1
		},
		showBars: {
			type: Boolean,
			default: !1
		},
		showInlineNotesIcon: {
			type: Boolean,
			default: !0
		},
		showNotesLabel: {
			type: Boolean,
			default: !0
		},
		hideSectionHeader: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:rating",
		"update:feedback",
		"update:selectedQuestion"
	],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = J(() => r.showBars ? 2 : r.scaleLength + 1 + (r.showClarificationColumns ? r.clarificationColumns.length : 0)), o = J(() => r.showClarificationColumns ? r.clarificationColumns : []);
		function s(e) {
			let t = r.clarifications[e];
			return t !== "not_covered" && t !== "weak_data" ? "" : r.clarificationColumns.find((e) => e.value === t)?.full || "";
		}
		function c(e) {
			return !!e?.skipped;
		}
		function l(e, t) {
			return r.showScoringRubric && !!e.anchors?.[t] && !c(e);
		}
		function u(e) {
			let t = r.selectedQuestionIds[e];
			if (!t) return null;
			let n = r.guideQuestions[e];
			if (n) {
				let e = n.find((e) => e.id === t);
				if (e) return e.text;
			}
			return null;
		}
		let d = /* @__PURE__ */ P(/* @__PURE__ */ new Set()), f = /* @__PURE__ */ P(null), p = Dr("cq:report-print", !1), m = /* @__PURE__ */ rn({}), h = /* @__PURE__ */ rn({}), g = /* @__PURE__ */ new Map();
		function _(e, t) {
			if (!t) return;
			let n = t.getBoundingClientRect().height;
			n && h[e] !== n && (h[e] = n);
		}
		function v(e, t) {
			if (t) {
				if (or(() => _(e, t)), !g.has(t) && typeof ResizeObserver < "u") {
					let n = new ResizeObserver(() => _(e, t));
					n.observe(t), g.set(t, n);
				}
			} else for (let [e, t] of g) e.isConnected || (t.disconnect(), g.delete(e));
		}
		oa(() => {
			for (let e of g.values()) e.disconnect();
			g.clear();
		});
		function y(e) {
			return se(e.id) || e.description ? !0 : !r.isReadOnly || ne(e.id);
		}
		function b(e) {
			return d.value.has(e);
		}
		function x(e) {
			if (!y(e)) return;
			let t = new Set(d.value);
			t.has(e.id) ? t.delete(e.id) : t.add(e.id), d.value = t;
		}
		function S(e) {
			return b(e.id) ? w(e.id) : !1;
		}
		function C(e) {
			return d.value.has(e.id) ? w(e.id) : !1;
		}
		function w(e) {
			return d.value.has(e);
		}
		function T(e) {
			let t = u(e.id);
			if (t) return t;
			let n = ce(e.id);
			return n.length > 0 && n[0].question ? n[0].question : e.question || e.description || "";
		}
		function E(e) {
			return e.name || T(e) || "";
		}
		function ee(e) {
			let t = T(e);
			return t && t !== E(e) ? t : "";
		}
		function D(e) {
			return r.guideQuestions[e.id] || [];
		}
		function O(e) {
			return !r.questionsEditable || e.is_observable ? !1 : D(e).length > 1;
		}
		function te(e, t) {
			let n = r.selectedQuestionIds[e.id];
			return n ? n === t.id : T(e) === t.text;
		}
		function k(e, t) {
			i("update:selectedQuestion", e.id, {
				questionId: t.id,
				questionText: t.text
			});
		}
		function ne(e) {
			return !!r.feedback[e]?.trim();
		}
		function re(e) {
			return (r.feedback[e] || "").split("\n").filter((e) => e.length > 0);
		}
		function ie(e) {
			return re(e)[0] || "";
		}
		function ae(e) {
			return re(e).slice(1);
		}
		function A(e) {
			return !!ne(e.id);
		}
		function oe(e) {
			return (m[e] ?? "") !== (r.feedback[e] || "");
		}
		function se(e) {
			return (r.aiSuggestions?.entriesPerCompetency?.[e]?.length || 0) > 0;
		}
		function ce(e) {
			return r.aiSuggestions?.entriesPerCompetency?.[e] || [];
		}
		function le(e, t) {
			return r.aiSuggestions?.ratings?.[e] === t;
		}
		function j(e) {
			let t = ce(e);
			for (let e of t) if (e?.transcript) return e.transcript;
			return "";
		}
		function ue(e) {
			let t = ce(e), n = [];
			for (let e of t) for (let t of e.notes || []) t?.text && n.push(`• ${t.text}`);
			return n.join("\n");
		}
		function de(e) {
			let t = m[e] || "";
			t !== (r.feedback[e] || "") && i("update:feedback", e, t);
		}
		function fe(e) {
			m[e] = "";
		}
		function pe(e) {
			de(e);
		}
		function me(e, t) {
			t?.relatedTarget?.closest?.("[data-slot=\"input-group-addon\"]") || de(e);
		}
		function he() {
			for (let e of r.competencies) de(e.id);
		}
		let ge = J(() => r.competencies.filter((e) => y(e)).map((e) => e.id)), _e = J(() => ge.value.length !== 0 && ge.value.every((e) => d.value.has(e))), ve = J(() => ge.value.every((e) => !d.value.has(e)));
		function ye() {
			d.value = new Set(ge.value);
		}
		function be() {
			d.value = /* @__PURE__ */ new Set();
		}
		let xe = [
			{
				min: 0,
				max: 1.5,
				color: "var(--color-destructive)"
			},
			{
				min: 1.5,
				max: 2.5,
				color: "hsl(25 95% 53%)"
			},
			{
				min: 2.5,
				max: 3.5,
				color: "hsl(45 93% 47%)"
			},
			{
				min: 3.5,
				max: 4.5,
				color: "hsl(142 71% 45%)"
			},
			{
				min: 4.5,
				max: 5.01,
				color: "var(--color-success)"
			}
		];
		function Ce(e) {
			if (e == null) return "0%";
			let t = e / r.scaleLength * 100;
			return `${Math.min(100, Math.max(0, t))}%`;
		}
		let we = J(() => r.scaleLength === 2 && Array.isArray(r.scaleLabels) && r.scaleLabels.length === 2), Te = J(() => r.scaleLength === 3 && Array.isArray(r.scaleLabels) && r.scaleLabels.length === 3 && String(r.scaleLabels[0]).toLowerCase() === "fail" && String(r.scaleLabels[2]).toLowerCase() === "pass");
		function Ee(e) {
			return e == null ? "hsl(var(--color-muted-foreground))" : we.value || Te.value ? e === 1 ? xe[0].color : xe[xe.length - 1].color : xe.find((t) => e >= t.min && e < t.max)?.color || xe[xe.length - 1].color;
		}
		function De(e) {
			return e == null ? "-" : r.scaleLabels && Number.isInteger(e) && r.scaleLabels[e - 1] ? r.scaleLabels[e - 1] : Number.isInteger(e) ? e : e.toFixed(1);
		}
		function Oe(e) {
			return r.scaleLabels && r.scaleLabels[e - 1] ? r.scaleLabels[e - 1] : `${e}/${r.scaleLength}`;
		}
		return Pr([
			() => r.showNotes,
			() => r.competencies,
			() => r.aiSuggestions?.entriesPerCompetency,
			() => r.feedback
		], () => {
			r.competencies.forEach((e) => {
				let t = r.feedback[e.id];
				if (t) m[e.id] = t;
				else if (r.showNotes && !r.isReadOnly && se(e.id)) {
					let t = ue(e.id);
					t && m[e.id] !== t && (m[e.id] = t, i("update:feedback", e.id, t));
				} else m[e.id] ?? (m[e.id] = "");
			});
		}, {
			immediate: !0,
			deep: !0
		}), t({
			expandAll: ye,
			collapseAll: be,
			allExpanded: _e,
			allCollapsed: ve,
			flushPendingFeedback: he
		}), (t, n) => (V(), H(B, null, [e.hideSectionHeader ? q("", !0) : (V(), U(F(RT), {
			key: 0,
			class: "bg-muted/50 border-b-0!"
		}, {
			default: I(() => [G(F(LT), {
				colspan: a.value,
				class: M(["pl-4 border-b border-b-border", { "border-t border-t-border": !e.isFirst }])
			}, {
				default: I(() => [W("span", kk, N(e.title), 1)]),
				_: 1
			}, 8, ["colspan", "class"])]),
			_: 1
		})), (V(!0), H(B, null, R(e.competencies, (r) => (V(), H(B, { key: r.id }, [G(F(RT), {
			class: M(["transition-colors group", [
				S(r) ? "bg-background border-b-0!" : "",
				f.value === r.id ? "bg-muted/50" : "hover:bg-muted/50",
				y(r) && "cursor-pointer"
			]]),
			onMouseenter: (e) => f.value = r.id,
			onMouseleave: n[5] ||= (e) => f.value = null,
			onClick: (e) => x(r)
		}, {
			default: I(() => [
				G(F(LT), { class: M(["pl-4 py-3 align-top", e.showBars ? "pr-4" : "pr-12 max-w-50"]) }, {
					default: I(() => [W("div", Ak, [W("div", {
						ref_for: !0,
						ref: (e) => v(r.id, e),
						class: M(["flex flex-col flex-1 min-w-0", [O(r) ? "group/q" : "", c(r) && e.isReadOnly ? "opacity-60" : ""]])
					}, [E(r) ? (V(), H("span", jk, [K(N(E(r)), 1), e.showInlineNotesIcon && ne(r.id) && !ee(r) ? (V(), U(F(fS), {
						key: 0,
						"delay-duration": 200
					}, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(xf), { class: "size-3.5 ml-1.5 inline-block align-middle text-muted-foreground" })]),
								_: 1
							}), G(F(dS), {
								side: "bottom",
								class: "text-xs max-w-64"
							}, {
								default: I(() => [K(N(e.feedback[r.id]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : q("", !0)])) : q("", !0), O(r) && ee(r) ? (V(), U(F(gk), { key: 1 }, {
						default: I(() => [G(F(xk), { "as-child": "" }, {
							default: I(() => [W("button", {
								class: "text-left cursor-pointer",
								onClick: n[0] ||= Kl(() => {}, ["stop"])
							}, [W("span", Mk, N(T(r)), 1), G(F(Yd), { class: "size-4 inline-block align-middle ml-1 text-body opacity-0 group-hover/q:opacity-100 transition-opacity" })])]),
							_: 2
						}, 1024), G(F(yk), {
							align: "start",
							class: "w-xl max-w-(--radix-popper-available-width) max-h-64 overflow-y-auto"
						}, {
							default: I(() => [(V(!0), H(B, null, R(D(r), (e) => (V(), U(F(vk), {
								key: e.id,
								"model-value": te(r, e),
								onSelect: (t) => k(r, e)
							}, {
								default: I(() => [K(N(e.text), 1)]),
								_: 2
							}, 1032, ["model-value", "onSelect"]))), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : ee(r) ? (V(), H("span", Nk, [K(N(ee(r)), 1), e.showInlineNotesIcon && ne(r.id) ? (V(), U(F(fS), {
						key: 0,
						"delay-duration": 200
					}, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(xf), { class: "size-3.5 ml-1.5 inline-block align-middle text-muted-foreground" })]),
								_: 1
							}), G(F(dS), {
								side: "bottom",
								class: "text-xs max-w-64"
							}, {
								default: I(() => [K(N(e.feedback[r.id]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : q("", !0)])) : q("", !0)], 2)])]),
					_: 2
				}, 1032, ["class"]),
				e.showBars ? (V(), U(F(LT), {
					key: 0,
					class: "align-top py-3 pl-2 pr-4",
					onClick: n[1] ||= Kl(() => {}, ["stop"])
				}, {
					default: I(() => [c(r) ? (V(), H("div", {
						key: 0,
						class: "flex items-center",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [G(F(xE), {
						variant: "default",
						role: "presentation",
						class: "py-2 rounded-lg"
					}, {
						default: I(() => [G(F(yf), {
							class: "size-4",
							"aria-hidden": "true"
						}), n[7] ||= W("div", { class: "min-w-0 whitespace-normal" }, [W("span", null, "Not asked"), W("span", { class: "text-muted-foreground" }, " · Conditional rules were not met")], -1)]),
						_: 1
					})], 4)) : we.value ? (V(), H("div", {
						key: 1,
						class: "flex items-center gap-2",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [W("div", Pk, [W("div", {
						class: M(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 1 ? "text-destructive-foreground" : "text-muted-foreground"]),
						style: Se(e.ratings[r.id] === 1 ? { "--pass-fail-fill-color": "var(--color-destructive)" } : void 0)
					}, [e.ratings[r.id] === 1 ? (V(), H("span", Fk)) : q("", !0), W("span", Ik, [e.ratings[r.id] === 1 ? (V(), U(F(Ff), {
						key: 0,
						class: "size-4"
					})) : q("", !0), n[8] ||= W("span", { class: "font-medium" }, "Fail", -1)])], 6), W("div", {
						class: M(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 2 ? "text-success-foreground" : "text-muted-foreground"]),
						style: Se(e.ratings[r.id] === 2 ? { "--pass-fail-fill-color": "var(--color-success)" } : void 0)
					}, [e.ratings[r.id] === 2 ? (V(), H("span", Lk)) : q("", !0), W("span", Rk, [e.ratings[r.id] === 2 ? (V(), U(F(Jd), {
						key: 0,
						class: "size-4"
					})) : q("", !0), n[9] ||= W("span", { class: "font-medium" }, "Pass", -1)])], 6)])], 4)) : Te.value ? (V(), H("div", {
						key: 2,
						class: "flex items-center gap-2",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [e.ratings[r.id] === 2 ? (V(), H("div", zk, [W("div", Bk, [W("span", Vk, N(e.scaleLabels[1]), 1)])])) : (V(), H("div", Hk, [W("div", {
						class: M(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 1 ? "text-destructive-foreground" : "text-muted-foreground"]),
						style: Se(e.ratings[r.id] === 1 ? { "--pass-fail-fill-color": "var(--color-destructive)" } : void 0)
					}, [e.ratings[r.id] === 1 ? (V(), H("span", Uk)) : q("", !0), W("span", Wk, [e.ratings[r.id] === 1 ? (V(), U(F(Ff), {
						key: 0,
						class: "size-4"
					})) : q("", !0), W("span", Gk, N(e.scaleLabels[0]), 1)])], 6), W("div", {
						class: M(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 3 ? "text-success-foreground" : "text-muted-foreground"]),
						style: Se(e.ratings[r.id] === 3 ? { "--pass-fail-fill-color": "var(--color-success)" } : void 0)
					}, [e.ratings[r.id] === 3 ? (V(), H("span", Kk)) : q("", !0), W("span", qk, [e.ratings[r.id] === 3 ? (V(), U(F(Jd), {
						key: 0,
						class: "size-4"
					})) : q("", !0), W("span", Jk, N(e.scaleLabels[2]), 1)])], 6)]))], 4)) : s(r.id) ? (V(), H("div", {
						key: 3,
						class: "flex items-center",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [W("span", Yk, N(s(r.id)), 1)], 4)) : (V(), H("div", {
						key: 4,
						class: "flex items-center gap-2",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [W("div", Xk, [W("div", {
						class: "h-full rounded-sm transition-all duration-300 animate-rating-bar",
						style: Se({
							width: Ce(e.ratings[r.id]),
							backgroundColor: Ee(e.ratings[r.id])
						})
					}, null, 4)]), W("span", Zk, N(De(e.ratings[r.id])), 1)], 4))]),
					_: 2
				}, 1024)) : q("", !0),
				!e.showBars && c(r) && e.isReadOnly ? (V(), U(F(LT), {
					key: 1,
					colspan: e.scaleLength,
					class: "align-top py-3 px-0",
					onClick: n[2] ||= Kl(() => {}, ["stop"])
				}, {
					default: I(() => [W("div", {
						class: "flex items-center",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [G(F(xE), {
						variant: "default",
						role: "presentation",
						class: "py-2 rounded-lg"
					}, {
						default: I(() => [G(F(yf), {
							class: "size-4",
							"aria-hidden": "true"
						}), n[10] ||= W("div", { class: "min-w-0 whitespace-normal" }, [W("span", null, "Not asked"), W("span", { class: "text-muted-foreground" }, " · Conditional rules were not met")], -1)]),
						_: 1
					})], 4)]),
					_: 2
				}, 1032, ["colspan"])) : q("", !0),
				(V(!0), H(B, null, R(e.showBars || c(r) && e.isReadOnly ? 0 : e.scaleLength, (i) => (V(), U(F(LT), {
					key: i,
					class: "text-center align-top py-3 px-0 group/cell",
					onClick: n[3] ||= Kl(() => {}, ["stop"])
				}, {
					default: I(() => [W("div", {
						class: "flex items-center justify-center",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [c(r) ? q("", !0) : (V(), U(F(mk), {
						key: 0,
						"model-value": e.ratings[r.id],
						disabled: e.isReadOnly,
						class: "flex justify-center",
						"onUpdate:modelValue": (e) => t.$emit("update:rating", r.id, e)
					}, {
						default: I(() => [le(r.id, i) ? (V(), U(F(fS), {
							key: 0,
							"delay-duration": 300
						}, {
							default: I(() => [G(F(uS), null, {
								default: I(() => [G(F(pS), { "as-child": "" }, {
									default: I(() => [W("span", Qk, [G(F(hk), {
										value: i,
										size: "lg"
									}, null, 8, ["value"]), e.ratings[r.id] === i ? q("", !0) : (V(), H("span", $k, [...n[11] ||= [W("span", { class: "size-3 rounded-full bg-info ai-dot" }, null, -1)]]))])]),
									_: 2
								}, 1024), G(F(dS), {
									side: "left",
									class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
								}, {
									default: I(() => [W("div", eA, [W("span", tA, "AI Suggested: " + N(Oe(i)), 1), ce(r.id)?.[0]?.notes?.length ? (V(), H("ul", nA, [(V(!0), H(B, null, R(ce(r.id)[0].notes, (e, t) => (V(), H("li", {
										key: t,
										class: "flex items-start gap-2 text-sm text-body"
									}, [e.sentiment === "positive" ? (V(), U(F(kf), {
										key: 0,
										class: "size-4 shrink-0 mt-0.5 text-success"
									})) : e.sentiment === "negative" ? (V(), U(F(Of), {
										key: 1,
										class: "size-4 shrink-0 mt-0.5 text-destructive"
									})) : (V(), U(F(Sf), {
										key: 2,
										class: "size-4 shrink-0 mt-0.5 text-muted-foreground"
									})), W("span", null, N(e.text), 1)]))), 128))])) : q("", !0)])]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)) : (V(), U(F(hk), {
							key: 1,
							value: i,
							size: "lg"
						}, null, 8, ["value"]))]),
						_: 2
					}, 1032, [
						"model-value",
						"disabled",
						"onUpdate:modelValue"
					]))], 4), l(r, i) && F(p) ? (V(), H("div", rA, N(r.anchors[i]), 1)) : l(r, i) ? (V(), U(F(fS), {
						key: 1,
						"delay-duration": 300
					}, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [W("div", iA, N(r.anchors[i]), 1)]),
								_: 2
							}, 1024), G(F(dS), {
								side: "bottom",
								class: "max-w-63 text-xs"
							}, {
								default: I(() => [K(N(r.anchors[i]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : q("", !0)]),
					_: 2
				}, 1024))), 128)),
				(V(!0), H(B, null, R(e.showBars ? [] : o.value, (i) => (V(), U(F(LT), {
					key: i.value,
					class: "text-center align-top py-3 px-0",
					onClick: n[4] ||= Kl(() => {}, ["stop"])
				}, {
					default: I(() => [W("div", {
						class: "flex items-center justify-center",
						style: Se({ minHeight: (h[r.id] || 36) + "px" })
					}, [G(F(mk), {
						"model-value": e.clarifications[r.id] || "rated",
						disabled: e.isReadOnly || !e.clarificationsEnabled,
						class: "flex justify-center",
						"onUpdate:modelValue": (e) => t.$emit("update:rating", r.id, e)
					}, {
						default: I(() => [G(F(fS), { "delay-duration": 300 }, {
							default: I(() => [G(F(uS), null, {
								default: I(() => [G(F(pS), { "as-child": "" }, {
									default: I(() => [G(F(hk), {
										value: i.value,
										size: "lg",
										"aria-label": i.full
									}, null, 8, ["value", "aria-label"])]),
									_: 2
								}, 1024), G(F(dS), { side: "top" }, {
									default: I(() => [K(N(i.full), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, [
						"model-value",
						"disabled",
						"onUpdate:modelValue"
					])], 4)]),
					_: 2
				}, 1024))), 128))
			]),
			_: 2
		}, 1032, [
			"class",
			"onMouseenter",
			"onClick"
		]), C(r) ? (V(), U(F(RT), {
			key: 0,
			class: M(["border-t-0! bg-background transition-colors", f.value === r.id && "bg-muted/50"]),
			onMouseenter: (e) => f.value = r.id,
			onMouseleave: n[6] ||= (e) => f.value = null
		}, {
			default: I(() => [G(F(LT), {
				colspan: a.value,
				class: "pt-0 pb-3 pr-4 pl-4"
			}, {
				default: I(() => [W("div", aA, [
					e.showNotesLabel && !e.isReadOnly ? (V(), H("span", oA, "Notes:")) : q("", !0),
					e.isReadOnly && A(r) ? (V(), H("div", sA, [n[12] ||= W("div", {
						class: "w-0.75 shrink-0 rounded-full bg-border",
						"aria-hidden": "true"
					}, null, -1), r.isScreening ? (V(), H("div", cA, [ie(r.id) ? (V(), H("span", lA, N(ie(r.id)), 1)) : q("", !0), (V(!0), H(B, null, R(ae(r.id), (e, t) => (V(), H("span", {
						key: t,
						class: "text-muted-foreground"
					}, N(e), 1))), 128))])) : (V(), H("span", uA, N(e.feedback[r.id]), 1))])) : e.isReadOnly ? (V(), H("p", dA, " -- ")) : (V(), U(F(Sk), { key: 3 }, {
						default: I(() => [G(F(Dk), {
							"model-value": m[r.id] ?? "",
							placeholder: "Add notes here...",
							size: "default",
							"onUpdate:modelValue": (e) => m[r.id] = e,
							onBlur: (e) => me(r.id, e)
						}, null, 8, [
							"model-value",
							"onUpdate:modelValue",
							"onBlur"
						]), G(F(wk), {
							align: "block-end",
							class: "justify-end"
						}, {
							default: I(() => [G(F(Tk), {
								variant: "ghost",
								size: "sm",
								disabled: !m[r.id],
								onClick: (e) => fe(r.id)
							}, {
								default: I(() => [...n[13] ||= [K(" Clear ", -1)]]),
								_: 1
							}, 8, ["disabled", "onClick"]), G(F(Tk), {
								variant: "default",
								size: "icon-round-sm",
								disabled: !oe(r.id),
								onClick: (e) => pe(r.id)
							}, {
								default: I(() => [G(F(Wd))]),
								_: 1
							}, 8, ["disabled", "onClick"])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)),
					j(r.id) ? (V(), U(F(VT), {
						key: 4,
						"default-open": !1,
						class: "mt-1"
					}, {
						default: I(({ open: e }) => [G(F(UT), { "as-child": "" }, {
							default: I(() => [G(F(Jx), {
								variant: "link",
								size: "link",
								class: "gap-1 self-start"
							}, {
								default: I(() => [n[14] ||= W("span", null, "View Candidate Response", -1), G(F(Yd), { class: M(["size-4 transition-transform shrink-0", e && "rotate-180"]) }, null, 8, ["class"])]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024), G(F(HT), null, {
							default: I(() => [W("p", fA, N(j(r.id)), 1)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : q("", !0)
				])]),
				_: 2
			}, 1032, ["colspan"])]),
			_: 2
		}, 1032, ["class", "onMouseenter"])) : q("", !0)], 64))), 128))], 64));
	}
}, mA = { class: "flex flex-col" }, hA = { class: "flex items-center gap-2" }, gA = { class: "flex items-center gap-3" }, _A = { class: "cursor-default" }, vA = { class: "cursor-default" }, yA = !1, bA = {
	__name: "ScorecardRatingsTable",
	props: {
		competencies: {
			type: Array,
			default: () => []
		},
		ratings: {
			type: Object,
			required: !0
		},
		clarifications: {
			type: Object,
			default: () => ({})
		},
		clarificationsEnabled: {
			type: Boolean,
			default: !1
		},
		feedback: {
			type: Object,
			default: () => ({})
		},
		isReadOnly: {
			type: Boolean,
			default: !1
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		aiSuggestions: {
			type: Object,
			default: null
		},
		aiEnabled: {
			type: Boolean,
			default: !1
		},
		selectedQuestionIds: {
			type: Object,
			default: () => ({})
		},
		guideQuestions: {
			type: Object,
			default: () => ({})
		},
		questionsEditable: {
			type: Boolean,
			default: !1
		},
		tableVariant: {
			type: String,
			default: "transparent"
		},
		tableSize: {
			type: String,
			default: "sm"
		},
		showToolbar: {
			type: Boolean,
			default: !1
		},
		showScoringRubric: {
			type: Boolean,
			default: !1
		},
		showNotes: {
			type: Boolean,
			default: !1
		},
		showBars: {
			type: Boolean,
			default: !1
		},
		showBarsToggle: {
			type: Boolean,
			default: !1
		},
		showRubricToggle: {
			type: Boolean,
			default: !0
		},
		showHeaderDivider: {
			type: Boolean,
			default: !1
		},
		showNotesLabel: {
			type: Boolean,
			default: !0
		},
		showInlineNotesIcon: {
			type: Boolean,
			default: !0
		},
		brandFitLabel: {
			type: String,
			default: "Brand Fit"
		},
		tableContainerClass: {
			type: String,
			default: ""
		},
		tables: {
			type: Array,
			default: null
		},
		otherRows: {
			type: Array,
			default: () => []
		}
	},
	emits: [
		"update:rating",
		"update:feedback",
		"update:selectedQuestion"
	],
	setup(e, { expose: t }) {
		let n = e, r = [{
			value: "not_covered",
			short: "N/C",
			full: "Not Covered"
		}, {
			value: "weak_data",
			short: "Weak",
			full: "Weak Data"
		}], i = /* @__PURE__ */ P(!1), a = J({
			get: () => i.value,
			set: (e) => {
				i.value = e;
			}
		}), o = /* @__PURE__ */ P(!1), s = J({
			get: () => o.value,
			set: (e) => {
				o.value = e;
			}
		}), c = /* @__PURE__ */ P(!1), l = J({
			get: () => c.value,
			set: (e) => {
				c.value = e;
			}
		});
		Pr(() => n.showScoringRubric, (e) => {
			n.showToolbar || (i.value = e);
		}, { immediate: !0 }), Pr(() => n.showBars, (e) => {
			n.showToolbar || (c.value = e);
		}, { immediate: !0 }), Pr(() => n.showNotes, (e) => {
			n.showToolbar || (o.value = e, or(() => e ? E() : ee()));
		}, { immediate: !0 });
		let u = J(() => {
			let e = n.aiSuggestions?.entriesPerCompetency;
			return e ? Object.values(e).some((e) => e?.length > 0) : !1;
		}), d = J(() => Object.values(n.feedback).some((e) => e?.trim())), f = J(() => Object.values(n.feedback).filter((e) => e?.trim()).length), p = J(() => `Notes (${f.value})`), m = J(() => xf), h = J(() => u.value && (d.value || !n.isReadOnly) ? "Show notes and AI summary" : u.value ? "Show AI summary" : "Show notes");
		function g() {
			let e = !a.value;
			a.value = e, e && (l.value = !1);
		}
		function _() {
			let e = !s.value;
			s.value = e, or(e ? () => E() : () => ee());
		}
		function v() {
			let e = !l.value;
			l.value = e, e && (a.value = !1);
		}
		let y = /* @__PURE__ */ P(null), b = /* @__PURE__ */ P(null), x = /* @__PURE__ */ P(null), S = /* @__PURE__ */ P(null), C = /* @__PURE__ */ P({});
		function w(e, t) {
			t ? C.value[e] = t : delete C.value[e];
		}
		let T = J(() => n.tables ? Object.values(C.value).filter(Boolean) : [
			b.value,
			y.value,
			x.value,
			S.value
		].filter(Boolean));
		function E() {
			T.value.forEach((e) => e.expandAll());
		}
		function ee() {
			T.value.forEach((e) => e.collapseAll());
		}
		function D() {
			T.value.forEach((e) => e.flushPendingFeedback?.());
		}
		t({
			expandAll: E,
			collapseAll: ee,
			flushPendingFeedback: D,
			barsEnabled: l,
			notesEnabled: s,
			scoringRubricEnabled: a,
			toggleBars: v,
			toggleNotes: _,
			toggleRubric: g
		});
		let O = J(() => n.competencies.filter((e) => e.is_observable)), te = J(() => n.competencies.filter((e) => !e.is_observable && !e.is_brand_fit)), k = J(() => n.competencies.filter((e) => e.is_brand_fit));
		function ne(e) {
			let t = Number(e?.scale?.length) || 0;
			return e?.scale?.labels && e.scale.labels.length === t ? e.scale.labels : Array.from({ length: t }, (e, t) => String(t + 1));
		}
		let re = J(() => yA), ie = J(() => !1), ae = J(() => {
			let e = /* @__PURE__ */ new Set();
			for (let t of [...n.competencies, ...n.otherRows]) if (t.anchors) for (let n of Object.keys(t.anchors)) e.add(Number(n));
			return e;
		}), A = J(() => l.value ? { width: "50%" } : { width: a.value && ae.value.size > 0 ? "72%" : "60%" }), oe = J(() => O.value.length > 0 ? "observable" : te.value.length > 0 ? "main" : k.value.length > 0 ? "brandFit" : n.otherRows.length > 0 ? "other" : null);
		return (t, n) => (V(), H("div", mA, [e.showToolbar ? (V(), H("div", {
			key: 0,
			class: M(["flex items-center justify-between", e.showHeaderDivider ? "pb-3 mb-3 border-b border-border" : "mb-3"])
		}, [W("div", hA, [z(t.$slots, "header")]), W("div", gA, [
			z(t.$slots, "toolbar-start"),
			G(F(fS), null, {
				default: I(() => [G(F(pk), null, {
					default: I(() => [
						e.showRubricToggle ? (V(), U(F(uS), { key: 0 }, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(Jx), {
									variant: a.value ? "selected" : "outline",
									size: "sm",
									onClick: g
								}, {
									default: I(() => [a.value ? (V(), U(F(Jd), {
										key: 0,
										class: "size-4"
									})) : (V(), U(F(tf), {
										key: 1,
										class: "size-4"
									})), n[15] ||= K(" Rubric ", -1)]),
									_: 1
								}, 8, ["variant"])]),
								_: 1
							}), G(F(dS), null, {
								default: I(() => [K(N(a.value ? "Hide scoring rubric" : "Show scoring rubric"), 1)]),
								_: 1
							})]),
							_: 1
						})) : q("", !0),
						G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(Jx), {
									variant: s.value ? "selected" : "outline",
									size: "sm",
									onClick: _
								}, {
									default: I(() => [s.value ? (V(), U(F(Jd), {
										key: 0,
										class: "size-4"
									})) : (V(), U(ga(m.value), {
										key: 1,
										class: "size-4"
									})), K(" " + N(p.value), 1)]),
									_: 1
								}, 8, ["variant"])]),
								_: 1
							}), G(F(dS), null, {
								default: I(() => [K(N(h.value), 1)]),
								_: 1
							})]),
							_: 1
						}),
						e.showBarsToggle ? (V(), U(F(uS), { key: 1 }, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(Jx), {
									variant: l.value ? "selected" : "outline",
									size: "sm",
									onClick: v
								}, {
									default: I(() => [l.value ? (V(), U(F(Jd), {
										key: 0,
										class: "size-4"
									})) : (V(), U(F(qd), {
										key: 1,
										class: "size-4"
									})), n[16] ||= K(" Bar Chart ", -1)]),
									_: 1
								}, 8, ["variant"])]),
								_: 1
							}), G(F(dS), null, {
								default: I(() => [K(N(l.value ? "Hide bar chart" : "Show bar chart"), 1)]),
								_: 1
							})]),
							_: 1
						})) : q("", !0)
					]),
					_: 1
				})]),
				_: 1
			}),
			z(t.$slots, "toolbar-end")
		])], 2)) : q("", !0), W("div", { class: M(e.tableContainerClass || void 0) }, [e.tables ? (V(!0), H(B, { key: 0 }, R(e.tables, (i, o) => (V(), H(B, { key: i.id }, [o > 0 ? (V(), U(F(tS), {
			key: 0,
			class: "my-4"
		})) : q("", !0), W("div", null, [G(F(FT), {
			variant: e.tableVariant,
			size: e.tableSize,
			"fit-columns": ""
		}, {
			default: I(() => [
				W("colgroup", null, [W("col", { style: Se(l.value ? { width: "50%" } : { width: "60%" }) }, null, 4), l.value ? q("", !0) : (V(), H(B, { key: 0 }, [(V(!0), H(B, null, R(i.scale.length, (e) => (V(), H("col", {
					key: e,
					style: { width: "20px" }
				}))), 128)), ie.value ? (V(), H(B, { key: 0 }, [n[17] ||= W("col", { style: { width: "44px" } }, null, -1), n[18] ||= W("col", { style: { width: "44px" } }, null, -1)], 64)) : q("", !0)], 64))]),
				G(F(BT), null, {
					default: I(() => [G(F(RT), null, {
						default: I(() => [G(F(zT), { class: M(["pl-4", l.value ? "pr-4" : "pr-12"]) }, {
							default: I(() => [K(N(i.title || "Competency"), 1)]),
							_: 2
						}, 1032, ["class"]), l.value ? (V(), U(F(zT), { key: 0 })) : (V(), H(B, { key: 1 }, [(V(!0), H(B, null, R(ne(i), (e, t) => (V(), U(F(zT), {
							key: t,
							class: "text-center px-0"
						}, {
							default: I(() => [K(N(e), 1)]),
							_: 2
						}, 1024))), 128)), ie.value ? (V(), H(B, { key: 0 }, R(r, (e) => G(F(zT), {
							key: e.value,
							class: "text-center px-0"
						}, {
							default: I(() => [G(F(fS), { "delay-duration": 200 }, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", _A, N(e.short), 1)]),
										_: 2
									}, 1024), G(F(dS), null, {
										default: I(() => [K(N(e.full), 1)]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)), 64)) : q("", !0)], 64))]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024),
				G(F(IT), null, {
					default: I(() => [(V(!0), H(B, null, R(i.sections, (c, u) => (V(), U(pA, {
						key: c.id,
						ref_for: !0,
						ref: (e) => w(`${o}-${u}`, e),
						title: c.title,
						"hide-section-header": !0,
						competencies: c.competencies,
						ratings: e.ratings,
						clarifications: e.clarifications,
						"show-clarification-columns": ie.value,
						"clarifications-enabled": re.value,
						"clarification-columns": r,
						feedback: e.feedback,
						"scale-length": i.scale.length,
						"scale-labels": i.scale.labels,
						"is-read-only": e.isReadOnly,
						"is-first": u === 0,
						"ai-suggestions": e.aiSuggestions,
						"ai-enabled": e.aiEnabled,
						"selected-question-ids": e.selectedQuestionIds,
						"guide-questions": e.guideQuestions,
						"questions-editable": e.questionsEditable,
						"show-scoring-rubric": a.value,
						"show-notes": s.value,
						"show-bars": l.value,
						"show-notes-label": e.showNotesLabel,
						"show-inline-notes-icon": e.showInlineNotesIcon,
						"onUpdate:rating": n[0] ||= (e, n) => t.$emit("update:rating", e, n),
						"onUpdate:feedback": n[1] ||= (e, n) => t.$emit("update:feedback", e, n),
						"onUpdate:selectedQuestion": n[2] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
					}, null, 8, [
						"title",
						"competencies",
						"ratings",
						"clarifications",
						"show-clarification-columns",
						"clarifications-enabled",
						"feedback",
						"scale-length",
						"scale-labels",
						"is-read-only",
						"is-first",
						"ai-suggestions",
						"ai-enabled",
						"selected-question-ids",
						"guide-questions",
						"questions-editable",
						"show-scoring-rubric",
						"show-notes",
						"show-bars",
						"show-notes-label",
						"show-inline-notes-icon"
					]))), 128))]),
					_: 2
				}, 1024)
			]),
			_: 2
		}, 1032, ["variant", "size"])])], 64))), 128)) : (V(), U(F(FT), {
			key: 1,
			variant: e.tableVariant,
			size: e.tableSize,
			"fit-columns": ""
		}, {
			default: I(() => [
				W("colgroup", null, [W("col", { style: Se(A.value) }, null, 4), l.value ? q("", !0) : (V(), H(B, { key: 0 }, [(V(!0), H(B, null, R(e.scaleLength, (e) => (V(), H("col", {
					key: e,
					style: Se(ae.value.has(e) ? {} : { width: "20px" })
				}, null, 4))), 128)), ie.value ? (V(), H(B, { key: 0 }, [n[19] ||= W("col", { style: { width: "44px" } }, null, -1), n[20] ||= W("col", { style: { width: "44px" } }, null, -1)], 64)) : q("", !0)], 64))]),
				G(F(BT), null, {
					default: I(() => [G(F(RT), null, {
						default: I(() => [G(F(zT), { class: M(["pl-4", l.value ? "pr-4" : "pr-12"]) }, {
							default: I(() => [...n[21] ||= [K(" Competency ", -1)]]),
							_: 1
						}, 8, ["class"]), l.value ? (V(), U(F(zT), { key: 0 })) : (V(), H(B, { key: 1 }, [(V(!0), H(B, null, R(e.scaleLength, (e) => (V(), U(F(zT), {
							key: e,
							class: "text-center px-0"
						}, {
							default: I(() => [K(N(e), 1)]),
							_: 2
						}, 1024))), 128)), ie.value ? (V(), H(B, { key: 0 }, R(r, (e) => G(F(zT), {
							key: e.value,
							class: "text-center px-0"
						}, {
							default: I(() => [G(F(fS), { "delay-duration": 200 }, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", vA, N(e.short), 1)]),
										_: 2
									}, 1024), G(F(dS), null, {
										default: I(() => [K(N(e.full), 1)]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)), 64)) : q("", !0)], 64))]),
						_: 1
					})]),
					_: 1
				}),
				G(F(IT), null, {
					default: I(() => [
						O.value.length > 0 ? (V(), U(pA, {
							key: 0,
							ref_key: "observableRef",
							ref: y,
							title: "Observable Competencies",
							competencies: O.value,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "observable",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[3] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[4] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[5] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : q("", !0),
						te.value.length > 0 ? (V(), U(pA, {
							key: 1,
							ref_key: "mainRef",
							ref: b,
							title: "Competencies",
							competencies: te.value,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "main",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[6] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[7] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[8] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : q("", !0),
						k.value.length > 0 ? (V(), U(pA, {
							key: 2,
							ref_key: "brandFitRef",
							ref: x,
							title: e.brandFitLabel,
							competencies: k.value,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "brandFit",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[9] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[10] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[11] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"title",
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : q("", !0),
						e.otherRows.length > 0 ? (V(), U(pA, {
							key: 3,
							ref_key: "otherRef",
							ref: S,
							title: "Other",
							competencies: e.otherRows,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "other",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[12] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[13] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[14] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : q("", !0)
					]),
					_: 1
				})
			]),
			_: 1
		}, 8, ["variant", "size"]))], 2)]));
	}
}, xA = {
	key: 0,
	class: "flex flex-col gap-4 px-8"
}, SA = { class: "scorecard-heading flex items-center justify-between gap-4" }, CA = { class: "text-2xl font-title text-foreground" }, wA = /*#__PURE__*/ pT({
	__name: "ScorecardRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.screening || null), r = J(() => t.component.scorecard || null), i = J(() => QO(n.value, r.value)), a = J(() => $O(n.value, r.value)), o = J(() => ek(n.value, r.value)), s = J(() => {
			let e = tk(n.value, r.value), i = t.component.aiSuggestionsOverride;
			return i ? {
				ratings: i.ratings || {},
				entriesPerCompetency: {
					...e?.entriesPerCompetency || {},
					...i.entriesPerCompetency || {}
				}
			} : e;
		}), c = J(() => r.value?.scale?.length || 5), l = J(() => t.component.title || r.value?.title || "Interview Scorecard"), u = Dr("cq:report-print", !1), d = Dr("cq:report-print-scorecard-style", "rubric"), f = Dr("cq:report-print-include-responses", !1), p = J(() => u && d === "rubric"), m = J(() => u && d === "bar_chart"), h = J(() => u && f), g = /* @__PURE__ */ P(null), _ = J(() => g.value?.barsEnabled ?? !1), v = J(() => g.value?.notesEnabled ?? !1), y = J(() => u ? p.value : g.value?.scoringRubricEnabled ?? !1), b = J(() => Object.values(o.value || {}).filter((e) => e?.trim?.()).length);
		return (e, t) => i.value.length ? (V(), H("div", xA, [W("div", SA, [W("h3", CA, N(l.value), 1), F(u) ? q("", !0) : (V(), U(F(fS), { key: 0 }, {
			default: I(() => [G(F(pk), null, {
				default: I(() => [
					G(F(uS), null, {
						default: I(() => [G(F(pS), { "as-child": "" }, {
							default: I(() => [G(F(Jx), {
								variant: y.value ? "selected" : "outline",
								size: "sm",
								onClick: t[0] ||= (e) => g.value?.toggleRubric()
							}, {
								default: I(() => [y.value ? (V(), U(F(Jd), {
									key: 0,
									class: "size-4"
								})) : (V(), U(F(tf), {
									key: 1,
									class: "size-4"
								})), t[3] ||= K(" Rubric ", -1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), G(F(dS), null, {
							default: I(() => [K(N(y.value ? "Hide scoring rubric" : "Show scoring rubric"), 1)]),
							_: 1
						})]),
						_: 1
					}),
					G(F(uS), null, {
						default: I(() => [G(F(pS), { "as-child": "" }, {
							default: I(() => [G(F(Jx), {
								variant: v.value ? "selected" : "outline",
								size: "sm",
								onClick: t[1] ||= (e) => g.value?.toggleNotes()
							}, {
								default: I(() => [v.value ? (V(), U(F(Jd), {
									key: 0,
									class: "size-4"
								})) : (V(), U(F(xf), {
									key: 1,
									class: "size-4"
								})), K(" Notes (" + N(b.value) + ") ", 1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), G(F(dS), null, {
							default: I(() => [K(N(v.value ? "Hide notes" : "Show notes"), 1)]),
							_: 1
						})]),
						_: 1
					}),
					G(F(uS), null, {
						default: I(() => [G(F(pS), { "as-child": "" }, {
							default: I(() => [G(F(Jx), {
								variant: _.value ? "selected" : "outline",
								size: "sm",
								onClick: t[2] ||= (e) => g.value?.toggleBars()
							}, {
								default: I(() => [_.value ? (V(), U(F(Jd), {
									key: 0,
									class: "size-4"
								})) : (V(), U(F(qd), {
									key: 1,
									class: "size-4"
								})), t[4] ||= K(" Bar Chart ", -1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), G(F(dS), null, {
							default: I(() => [K(N(_.value ? "Hide bar chart" : "Show bar chart"), 1)]),
							_: 1
						})]),
						_: 1
					})
				]),
				_: 1
			})]),
			_: 1
		}))]), W("div", { class: M(["agent-scorecard", { "agent-scorecard--rubric": y.value }]) }, [G(bA, {
			ref_key: "scorecardRef",
			ref: g,
			tables: i.value,
			ratings: a.value,
			feedback: o.value,
			"ai-suggestions": s.value,
			"is-read-only": !0,
			"scale-length": c.value,
			"table-variant": "borderless-transparent",
			"show-toolbar": !1,
			"show-scoring-rubric": p.value,
			"show-notes": h.value,
			"show-bars": m.value,
			"show-rubric-toggle": !1,
			"show-notes-label": !1,
			"show-inline-notes-icon": !1
		}, null, 8, [
			"tables",
			"ratings",
			"feedback",
			"ai-suggestions",
			"scale-length",
			"show-scoring-rubric",
			"show-notes",
			"show-bars"
		])], 2)])) : q("", !0);
	}
}, [["__scopeId", "data-v-b46b483f"]]), TA = {
	key: 0,
	class: "flex flex-col gap-4"
}, EA = { class: "hidden md:grid md:grid-cols-2 gap-x-4 pb-2 border-b border-border" }, DA = { class: "inline-flex items-center gap-1.5 text-sm text-body" }, OA = { class: "flex flex-col" }, kA = { class: "flex flex-col" }, AA = { class: "text-base font-medium leading-snug text-foreground" }, jA = { class: "text-sm text-body leading-snug" }, MA = { class: "text-foreground leading-relaxed text-base" }, NA = { class: "md:hidden inline-flex items-center gap-1.5 text-sm text-body mb-1" }, PA = {
	__name: "AgentAdditionalQuestions",
	props: { questions: {
		type: Array,
		default: () => []
	} },
	setup(e) {
		return (t, n) => e.questions.length ? (V(), H("div", TA, [
			n[3] ||= W("h3", { class: "text-2xl font-title text-foreground" }, "Additional Interview Questions", -1),
			W("div", EA, [n[1] ||= W("span", { class: "text-sm text-body" }, "Questions", -1), W("span", DA, [G(F(Rf), { class: "size-4 shrink-0" }), n[0] ||= K(" Summary ", -1)])]),
			W("div", OA, [(V(!0), H(B, null, R(e.questions, (e, t) => (V(), H("div", {
				key: `q-${t}`,
				class: "grid grid-cols-1 md:grid-cols-2 gap-y-2 md:gap-x-4 py-3 border-b border-border last:border-b-0"
			}, [W("div", kA, [W("span", AA, N(e.category || "General"), 1), W("span", jA, N(e.question), 1)]), W("div", MA, [W("span", NA, [G(F(Rf), { class: "size-4 shrink-0" }), n[2] ||= K(" Summary ", -1)]), W("p", null, N(e.summary), 1)])]))), 128))])
		])) : q("", !0);
	}
}, FA = {
	key: 0,
	class: "px-8"
}, IA = {
	__name: "AdditionalQuestionsRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.questions || []);
		return (e, t) => n.value.length ? (V(), H("div", FA, [G(PA, { questions: n.value }, null, 8, ["questions"])])) : q("", !0);
	}
}, LA = {
	key: 0,
	class: "flex flex-col gap-4"
}, RA = { class: "flex flex-col" }, zA = { class: "flex flex-col" }, BA = { class: "inline-flex items-center gap-1.5 text-sm text-body" }, VA = { class: "text-base font-medium leading-snug text-foreground" }, HA = { class: "text-foreground leading-relaxed text-base" }, UA = {
	__name: "AgentCandidateQuestions",
	props: { questions: {
		type: Array,
		default: () => []
	} },
	setup(e) {
		return (t, n) => e.questions.length ? (V(), H("div", LA, [
			n[1] ||= W("h3", { class: "text-2xl font-title text-foreground" }, "Questions Asked by the Candidate", -1),
			n[2] ||= W("div", { class: "hidden md:grid md:grid-cols-2 gap-x-4 pb-2 border-b border-border" }, [W("span", { class: "text-sm text-body" }, "Questions"), W("span", { class: "text-sm text-body" }, "Response")], -1),
			W("div", RA, [(V(!0), H(B, null, R(e.questions, (e, t) => (V(), H("div", {
				key: `cq-${t}`,
				class: "grid grid-cols-1 md:grid-cols-2 gap-y-2 md:gap-x-4 py-3 border-b border-border last:border-b-0"
			}, [W("div", zA, [W("span", BA, [G(F(cf), { class: "size-4 shrink-0" }), K(" " + N(e.timestamp), 1)]), W("span", VA, N(e.question), 1)]), W("div", HA, [n[0] ||= W("span", { class: "md:hidden text-sm text-body mb-1 block" }, "Response", -1), W("p", null, N(e.response), 1)])]))), 128))])
		])) : q("", !0);
	}
}, WA = {
	key: 0,
	class: "px-8"
}, GA = {
	__name: "CandidateQuestionsPanelRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.questions || []);
		return (e, t) => n.value.length ? (V(), H("div", WA, [G(UA, { questions: n.value }, null, 8, ["questions"])])) : q("", !0);
	}
}, KA = {
	__name: "ConditionRuleBadge",
	props: { rule: {
		type: String,
		default: ""
	} },
	setup(e) {
		return (t, n) => e.rule ? (V(), U(F(UE), {
			key: 0,
			variant: "info-subtle",
			icon: F(uf),
			"text-class": "normal-case"
		}, {
			default: I(() => [K(N(e.rule), 1)]),
			_: 1
		}, 8, ["icon"])) : q("", !0);
	}
}, qA = /\{\{\s*([\w.]+)\s*\}\}/g, JA = /\{([a-z_]+)\}/gi;
function YA(e, t = []) {
	let n = t.find((t) => (t?.value || t?.env || "").replace(/^\{|\}$/g, "") === e);
	return n?.label ? n.label : e.split(/[._]/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function XA(e) {
	return e.replace(/[&<>"']/g, (e) => ({
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		"\"": "&quot;",
		"'": "&#39;"
	})[e]);
}
function ZA(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function QA(e, t) {
	let n = e === "mustache" ? qA.source : JA.source, r = e === "mustache" ? "g" : "gi";
	if (!t.length) return {
		re: new RegExp(n, r),
		slotGroup: -1
	};
	let i = `\\{(${t.map(ZA).join("|")})\\}`;
	return {
		re: RegExp(`(?:${i})|(?:${n})`, r),
		slotGroup: 1
	};
}
function $A(e, t = "") {
	return `<span class="${t ? `variable-badge ${t}` : "variable-badge"}"><span class="variable-label">${XA(e)}</span></span>`;
}
function ej(e, t) {
	if (e?.input_type === "date") return SD(t, { fallback: t });
	if (e?.input_type === "number") {
		let e = Number(t);
		return Number.isFinite(e) ? e.toLocaleString("en-US", {
			minimumFractionDigits: Number.isInteger(e) ? 0 : 2,
			maximumFractionDigits: 2
		}) : t;
	}
	return t;
}
function tj(e) {
	let t = (e?.value || "").trim();
	return t ? $A(ej(e, t), "variable-badge--filled") : $A(e?.label || YA(e?.token || ""), "variable-badge--needs-info");
}
function nj(e, { tokenFormat: t = "mustache", variables: n = [], fillSlots: r = [] } = {}) {
	if (!e) return "";
	let i = (r || []).filter((e) => e?.token), a = new Map(i.map((e) => [e.token, e])), { re: o, slotGroup: s } = QA(t, [...a.keys()]), c = "", l = 0, u;
	for (; (u = o.exec(e)) !== null;) {
		c += XA(e.slice(l, u.index));
		let t = s >= 0 ? u[s] : void 0;
		if (t !== void 0) c += tj(a.get(t));
		else {
			let e = s >= 0 ? u[s + 1] : u[1];
			c += $A(YA(e, n));
		}
		l = u.index + u[0].length;
	}
	return c += XA(e.slice(l)), c;
}
//#endregion
//#region src/utils/interview/planVariables.js
var rj = [
	{
		value: "candidate.first_name",
		label: "Candidate first name",
		description: "The candidate’s first name."
	},
	{
		value: "candidate.last_name",
		label: "Candidate last name",
		description: "The candidate’s last name."
	},
	{
		value: "job_title",
		label: "Job title",
		description: "Title of the role being interviewed for."
	},
	{
		value: "organization_name",
		label: "Company",
		description: "Your organization’s name."
	}
], ij = { class: "text-sm text-body" }, aj = {
	key: 0,
	class: "text-sm text-body"
}, oj = { class: "text-left cursor-pointer" }, sj = { class: "text-sm text-body leading-snug decoration-dotted decoration-body underline-offset-4 group-hover/q:underline" }, cj = ["innerHTML"], lj = {
	key: 3,
	class: "text-sm text-body leading-snug"
}, uj = { class: "text-sm text-body" }, dj = {
	key: 0,
	class: "flex items-stretch gap-3 text-sm text-body whitespace-pre-wrap"
}, fj = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, pj = {
	key: 2,
	class: "text-sm text-muted-foreground"
}, mj = { class: "text-xs text-body text-center leading-snug px-2 mt-0.5 line-clamp-2" }, hj = "size-3 fill-neutral-300 text-neutral-300", gj = "border-neutral-300", _j = /*#__PURE__*/ pT({
	__name: "CompetencyCard",
	props: {
		competency: {
			type: Object,
			required: !0
		},
		rating: {
			type: Number,
			default: null
		},
		selectedQuestion: {
			type: String,
			default: ""
		},
		questions: {
			type: Array,
			default: () => []
		},
		showQuestion: {
			type: Boolean,
			default: !0
		},
		showRating: {
			type: Boolean,
			default: !0
		},
		alternativeQuestions: {
			type: Array,
			default: () => []
		},
		isObservable: {
			type: Boolean,
			default: !1
		},
		isBrandFit: {
			type: Boolean,
			default: !1
		},
		isOpening: {
			type: Boolean,
			default: !1
		},
		questionsEditable: {
			type: Boolean,
			default: !0
		},
		ratingsEditable: {
			type: Boolean,
			default: !0
		},
		readOnly: {
			type: Boolean,
			default: !1
		},
		compact: {
			type: Boolean,
			default: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => ["default", "wip"].includes(e)
		},
		showNotes: {
			type: Boolean,
			default: !1
		},
		feedback: {
			type: String,
			default: ""
		},
		notesLabel: {
			type: String,
			default: "Notes"
		},
		iconOverride: {
			type: [Object, Function],
			default: null
		},
		iconClassOverride: {
			type: String,
			default: ""
		},
		renderChips: {
			type: Boolean,
			default: !1
		},
		conditionRule: {
			type: String,
			default: ""
		}
	},
	emits: [
		"update:rating",
		"update:selectedQuestion",
		"update:feedback"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.variant === "wip"), a = /* @__PURE__ */ P(n.feedback || "");
		Pr(() => n.showNotes, (e) => {
			e && (a.value = n.feedback || "");
		}), Pr(() => n.feedback, (e) => {
			o.value || (a.value = e || "");
		});
		let o = J(() => (a.value || "") !== (n.feedback || "")), s = J(() => !!n.feedback?.trim());
		function c() {
			a.value = "";
		}
		function l() {
			o.value && r("update:feedback", a.value);
		}
		let u = J(() => n.questions.length > 0), d = J(() => {
			if (u.value && n.selectedQuestion) {
				let e = n.questions.find((e) => e.id === n.selectedQuestion);
				if (e) return e.text;
			}
			return n.selectedQuestion || n.competency.question || "";
		}), f = J(() => `"${nj(d.value, {
			tokenFormat: "mustache",
			variables: rj
		})}"`), p = J(() => {
			let e = Object.keys(n.competency.anchors || {}).map(Number);
			return e.length > 0 ? Math.max(...e) : 5;
		}), m = J(() => {
			let e = n.competency.anchors || {};
			return Object.keys(e).map(Number).sort((e, t) => e - t).filter((t) => e[t]).map((t) => ({
				value: t,
				text: e[t]
			}));
		}), h = /* @__PURE__ */ P(null), g = /* @__PURE__ */ P(0);
		ra(() => {
			or(() => {
				if (h.value) {
					let e = h.value.querySelector(".rounded-full");
					if (e) {
						let t = h.value.getBoundingClientRect(), n = e.getBoundingClientRect();
						g.value = n.top - t.top + n.height / 2;
					}
				}
			});
		});
		let _ = J(() => {
			let e = n.competency.anchors || {}, t = p.value;
			return Array.from({ length: t }, (t, n) => e[n + 1] ? "3fr" : "1fr").join(" ");
		}), v = J(() => n.iconOverride ? {
			icon: n.iconOverride,
			iconClass: n.iconClassOverride || "text-primary"
		} : n.isOpening ? {
			icon: lf,
			iconClass: "text-amber-500"
		} : n.isObservable || n.competency?.is_observable ? {
			icon: uf,
			iconClass: "text-destructive"
		} : n.isBrandFit || n.competency?.is_brand_fit ? {
			icon: ff,
			iconClass: "text-success"
		} : {
			icon: xf,
			iconClass: "text-primary"
		}), y = J(() => {
			if (u.value) return n.questions;
			let e = [];
			return n.competency.question && e.push(n.competency.question), n.alternativeQuestions?.length && n.alternativeQuestions.forEach((t) => {
				e.includes(t) || e.push(t);
			}), e;
		}), b = J(() => n.showQuestion && n.questionsEditable && y.value.length > 1), x = J({
			get() {
				return u.value ? n.selectedQuestion : d.value;
			},
			set(e) {
				if (u.value) {
					let t = n.questions.find((t) => t.id === e);
					r("update:selectedQuestion", {
						questionId: e,
						questionText: t?.text || ""
					});
				} else r("update:selectedQuestion", e);
			}
		});
		return (t, n) => (V(), U(F(_m), {
			shadow: "none",
			hoverable: !e.readOnly,
			class: M(b.value ? "group/q" : "")
		}, {
			default: I(() => [G(F(vm), { class: M(["flex flex-col p-6", i.value ? "gap-1" : "gap-4"]) }, {
				default: I(() => [
					W("div", { class: M(["flex", i.value ? "" : "gap-3"]) }, [i.value ? q("", !0) : (V(), U(ga(v.value.icon), {
						key: 0,
						class: M(["size-5 shrink-0", v.value.iconClass])
					}, null, 8, ["class"])), W("div", null, [G(F(bm), { class: "text-base font-medium text-foreground leading-snug" }, {
						default: I(() => [K(N(e.competency.name), 1)]),
						_: 1
					}), e.competency.description && !i.value ? (V(), U(F(ym), { key: 0 }, {
						default: I(() => [W("p", ij, N(e.competency.description), 1)]),
						_: 1
					})) : q("", !0)])], 2),
					d.value ? (V(), H("div", {
						key: 0,
						class: M(["flex flex-col gap-1", i.value ? "pl-0" : "pl-8"])
					}, [
						i.value ? q("", !0) : (V(), H("p", aj, N(b.value ? `Questions (${y.value.length}):` : "Question:"), 1)),
						b.value ? (V(), U(F(gk), { key: 1 }, {
							default: I(() => [G(F(xk), { "as-child": "" }, {
								default: I(() => [W("button", oj, [W("span", sj, " \"" + N(d.value) + "\" ", 1), G(F(Yd), { class: "size-4 inline-block align-middle ml-1 text-body opacity-0 group-hover/q:opacity-100 transition-opacity" })])]),
								_: 1
							}), G(F(yk), {
								align: "start",
								class: "w-xl max-w-(--radix-popper-available-width) max-h-64 overflow-y-auto"
							}, {
								default: I(() => [(V(!0), H(B, null, R(y.value, (e) => (V(), U(F(vk), {
									key: typeof e == "object" ? e.id : e,
									"model-value": typeof e == "object" ? x.value === e.id : d.value === e,
									onSelect: (t) => x.value = typeof e == "object" ? e.id : e
								}, {
									default: I(() => [K(N(typeof e == "object" ? e.text : e), 1)]),
									_: 2
								}, 1032, ["model-value", "onSelect"]))), 128))]),
								_: 1
							})]),
							_: 1
						})) : e.renderChips ? (V(), H("p", {
							key: 2,
							class: "text-sm text-body leading-snug",
							innerHTML: f.value
						}, null, 8, cj)) : (V(), H("p", lj, " \"" + N(d.value) + "\" ", 1)),
						G(KA, {
							rule: e.conditionRule,
							class: "self-start"
						}, null, 8, ["rule"])
					], 2)) : q("", !0),
					e.showNotes ? (V(), H("div", {
						key: 1,
						class: M(["flex flex-col gap-1.5", i.value ? "pl-0" : "pl-8"])
					}, [W("span", uj, N(e.notesLabel) + ":", 1), e.readOnly && s.value ? (V(), H("div", dj, [n[1] ||= W("div", {
						class: "w-0.75 shrink-0 rounded-full bg-border",
						"aria-hidden": "true"
					}, null, -1), W("span", null, N(e.feedback), 1)])) : e.readOnly ? (V(), H("p", fj, " -- ")) : e.showRating && e.rating == null ? (V(), H("p", pj, " Rate this competency to add notes. ")) : (V(), U(F(Sk), { key: 3 }, {
						default: I(() => [G(F(Dk), {
							modelValue: a.value,
							"onUpdate:modelValue": n[0] ||= (e) => a.value = e,
							placeholder: "Add notes here...",
							size: "default"
						}, null, 8, ["modelValue"]), G(F(wk), {
							align: "block-end",
							class: "justify-end"
						}, {
							default: I(() => [G(F(Tk), {
								variant: "ghost",
								size: "sm",
								disabled: !a.value,
								onClick: c
							}, {
								default: I(() => [...n[2] ||= [K(" Clear ", -1)]]),
								_: 1
							}, 8, ["disabled"]), G(F(Tk), {
								variant: "default",
								size: "icon-round-sm",
								disabled: !o.value,
								onClick: l
							}, {
								default: I(() => [G(F(Wd))]),
								_: 1
							}, 8, ["disabled"])]),
							_: 1
						})]),
						_: 1
					}))], 2)) : q("", !0),
					e.showRating && m.value.length > 0 && !e.compact ? (V(), H("div", {
						key: 2,
						class: M(["flex flex-col gap-3", i.value ? "pl-0" : "pl-8"])
					}, [n[3] ||= W("span", { class: "text-xs text-muted-foreground" }, "Scoring Rubric:", -1), W("div", {
						ref_key: "rubricGridRef",
						ref: h,
						class: "relative grid",
						style: Se({ gridTemplateColumns: _.value })
					}, [W("div", {
						class: "absolute inset-x-0 pointer-events-none h-px bg-[linear-gradient(to_right,transparent_2%,var(--color-border)_10%,var(--color-border)_90%,transparent_98%)]",
						style: Se({ top: g.value + "px" })
					}, null, 4), (V(!0), H(B, null, R(p.value, (t) => (V(), H("div", {
						key: t,
						class: "flex flex-col items-center gap-1.5 z-10"
					}, [
						W("span", { class: M(e.competency.anchors[t] ? "text-xs font-medium text-foreground" : "text-xs text-neutral-400") }, N(e.competency.anchorLabels?.[t] ?? t), 3),
						W("span", {
							class: M(["size-5 rounded-full flex items-center justify-center ring-2 ring-background bg-background", e.competency.anchors[t] ? "border-2 border-primary" : `border-2 ${gj}`]),
							"aria-hidden": "true"
						}, [e.competency.anchors[t] ? (V(), U(F(af), {
							key: 0,
							class: "size-3 fill-(--module-icon-sparkle-secondary) text-(--module-icon-sparkle-secondary)"
						})) : (V(), U(F(af), {
							key: 1,
							class: M(hj)
						}))], 2),
						e.competency.anchors[t] ? (V(), U(F(fS), {
							key: 0,
							"delay-duration": 300
						}, {
							default: I(() => [G(F(uS), null, {
								default: I(() => [G(F(pS), { "as-child": "" }, {
									default: I(() => [W("span", mj, N(e.competency.anchors[t]), 1)]),
									_: 2
								}, 1024), G(F(dS), {
									side: "bottom",
									class: "max-w-63 text-xs"
								}, {
									default: I(() => [K(N(e.competency.anchors[t]), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)) : q("", !0)
					]))), 128))], 4)], 2)) : q("", !0)
				]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["hoverable", "class"]));
	}
}, [["__scopeId", "data-v-7fc0c47d"]]);
[
	{
		name: "brand-blue",
		class: "bg-[var(--color-avatar-secondary-blue)]"
	},
	{
		name: "brand-purple",
		class: "bg-[var(--color-avatar-secondary-purple)]"
	},
	{
		name: "brand-green",
		class: "bg-[var(--color-avatar-secondary-green)]"
	},
	{
		name: "brand-orange",
		class: "bg-[var(--color-avatar-secondary-orange)]"
	},
	{
		name: "brand-red",
		class: "bg-[var(--color-avatar-secondary-red)]"
	},
	{
		name: "brand-coral",
		class: "bg-[var(--color-avatar-secondary-coral)]"
	},
	{
		name: "brand-rose",
		class: "bg-[var(--color-avatar-secondary-rose)]"
	},
	{
		name: "brand-pink",
		class: "bg-[var(--color-avatar-secondary-pink)]"
	},
	{
		name: "brand-magenta",
		class: "bg-[var(--color-avatar-secondary-magenta)]"
	},
	{
		name: "brand-orchid",
		class: "bg-[var(--color-avatar-secondary-orchid)]"
	},
	{
		name: "brand-lavender",
		class: "bg-[var(--color-avatar-secondary-lavender)]"
	},
	{
		name: "brand-violet",
		class: "bg-[var(--color-avatar-secondary-violet)]"
	},
	{
		name: "brand-iris",
		class: "bg-[var(--color-avatar-secondary-iris)]"
	},
	{
		name: "brand-periwinkle",
		class: "bg-[var(--color-avatar-secondary-periwinkle)]"
	},
	{
		name: "brand-steel",
		class: "bg-[var(--color-avatar-secondary-steel)]"
	},
	{
		name: "brand-slate",
		class: "bg-[var(--color-avatar-secondary-slate)]"
	},
	{
		name: "brand-cyan",
		class: "bg-[var(--color-avatar-secondary-cyan)]"
	},
	{
		name: "brand-teal",
		class: "bg-[var(--color-avatar-secondary-teal)]"
	},
	{
		name: "brand-mint",
		class: "bg-[var(--color-avatar-secondary-mint)]"
	},
	{
		name: "brand-jade",
		class: "bg-[var(--color-avatar-secondary-jade)]"
	},
	{
		name: "brand-moss",
		class: "bg-[var(--color-avatar-secondary-moss)]"
	},
	{
		name: "brand-olive",
		class: "bg-[var(--color-avatar-secondary-olive)]"
	},
	{
		name: "brand-citron",
		class: "bg-[var(--color-avatar-secondary-citron)]"
	},
	{
		name: "brand-sand",
		class: "bg-[var(--color-avatar-secondary-sand)]"
	},
	{
		name: "brand-taupe",
		class: "bg-[var(--color-avatar-secondary-taupe)]"
	}
].map((e) => e.class), [{
	name: "zinc-400",
	class: "bg-zinc-400"
}].map((e) => e.class);
//#endregion
//#region src/utils/interview/questionConditions.js
function vj(e) {
	return e === "yes" ? "Yes" : "No";
}
function yj(e = [], t) {
	let n = t?.condition;
	if (!n?.questionId || !n?.answer) return "";
	let r = e.find((e) => e.id === n.questionId);
	if (!r) return "";
	let i = r.competencyName || r.label || bj(r.question);
	return i ? `Only asked if "${i}" = ${vj(n.answer)}` : "";
}
function bj(e, t = 56) {
	let n = (e || "").trim();
	return n.length <= t ? n : `${n.slice(0, t - 1)}…`;
}
//#endregion
//#region src/components/interview/tabs/InterviewPlanTab.vue
var xj = { class: "flex flex-col gap-2" }, Sj = {
	key: 0,
	class: "flex items-center justify-between min-h-9"
}, Cj = { class: "flex items-center gap-2" }, wj = { class: "flex items-center gap-0.5" }, Tj = {
	key: 1,
	class: "flex items-center justify-between min-h-9"
}, Ej = { class: "flex items-center gap-2" }, Dj = { class: "bg-muted rounded-xl p-3" }, Oj = {
	key: 0,
	class: "flex flex-col gap-3"
}, kj = { class: "flex flex-col gap-4 p-6" }, Aj = { class: "flex gap-3" }, jj = { class: "flex flex-col gap-1.5 flex-1" }, Mj = {
	key: 0,
	class: "flex flex-col gap-1 pl-8"
}, Nj = { class: "flex flex-col gap-3 pl-8" }, Pj = { class: "flex items-start justify-between" }, Fj = {
	key: 1,
	class: "flex items-center justify-center py-8"
}, Ij = { class: "text-center" }, Lj = {
	key: 2,
	class: "flex flex-col gap-3"
}, Rj = {
	key: 3,
	class: "text-center py-8 text-muted-foreground"
}, zj = {
	key: 4,
	class: "flex flex-col gap-3"
}, Bj = {
	key: 0,
	class: "text-sm font-medium text-muted-foreground"
}, Vj = {
	key: 1,
	class: "text-sm font-medium text-muted-foreground"
}, Hj = {
	key: 2,
	class: "text-sm font-medium text-muted-foreground"
}, Uj = {
	key: 3,
	class: "text-sm font-medium text-muted-foreground"
}, Wj = {
	key: 4,
	class: "text-sm font-medium text-muted-foreground"
}, Gj = {
	__name: "InterviewPlanTab",
	props: {
		guideData: {
			type: Object,
			default: null
		},
		isLoading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: String,
			default: null
		},
		questionsEditable: {
			type: Boolean,
			default: !0
		},
		ratingsEditable: {
			type: Boolean,
			default: !0
		},
		planRatings: {
			type: Object,
			required: !0
		},
		selectedQuestions: {
			type: Object,
			required: !0
		},
		selectedQuestionIds: {
			type: Object,
			default: () => ({})
		},
		selectedQuestionIdsByGroup: {
			type: Object,
			default: () => ({})
		},
		readOnly: {
			type: Boolean,
			default: !1
		},
		planFeedback: {
			type: Object,
			default: () => ({})
		},
		notesLabel: {
			type: String,
			default: "Notes"
		},
		hideRubricToggle: {
			type: Boolean,
			default: !1
		},
		hideNotesToggle: {
			type: Boolean,
			default: !1
		},
		flatOrdered: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:planRating",
		"update:selectedQuestion",
		"update:planFeedback",
		"retry"
	],
	setup(e, { emit: t }) {
		let n = Oh("interview-plan-rubric-on", !1), r = Oh("interview-plan-notes-on", !1), i = e, a = t, o = J(() => i.hideRubricToggle || !n.value), s = J(() => !i.hideNotesToggle && r.value), c = J(() => Object.values(i.planFeedback || {}).filter((e) => e?.trim()).length);
		function l(e) {
			return e.question && e.question.length > 0;
		}
		let u = J(() => i.guideData?.flatItems || []), d = J(() => i.flatOrdered && u.value.length > 0), f = J(() => {
			let e = [], t = /* @__PURE__ */ new Map();
			for (let n of u.value) {
				if (!n.groupId) {
					e.push(n);
					continue;
				}
				let r = t.get(n.groupId);
				if (!r) {
					let r = {
						...n,
						groupMembers: [n]
					};
					t.set(n.groupId, r), e.push(r);
					continue;
				}
				r.groupMembers.push(n), n.isPrimary && !r.isPrimary && Object.assign(r, {
					id: n.id,
					question: n.question,
					isPrimary: !0
				});
			}
			return e.map(({ groupMembers: e, ...t }) => !e || e.length < 2 ? t : {
				...t,
				questions: [t, ...e.filter((e) => e.id !== t.id)].map((e) => ({
					id: e.id,
					text: e.question,
					isPrimary: e.id === t.id
				})),
				alternativeQuestions: e.filter((e) => e.id !== t.id).map((e) => e.question)
			});
		});
		function p(e) {
			return e.groupId || e.competencyId || e.id;
		}
		function m(e) {
			return !i.readOnly && (e.questions?.length ?? 0) > 1 && !!e.competencyId;
		}
		function h(e) {
			let t = e.questions;
			if (!t?.length) return e.question;
			let n = p(e), r = e.competencyId || n, a = (e.groupId ? i.selectedQuestionIdsByGroup?.[e.groupId] : void 0) ?? i.selectedQuestionIds?.[r];
			if (a && t.some((e) => e.id === a)) return a;
			let o = i.selectedQuestions?.[n] ?? i.selectedQuestions?.[r], s = o && t.find((e) => e.text === o);
			return s ? s.id : e.id;
		}
		function g(e) {
			return e.competencyName || e.label || e.category || "Question";
		}
		return (t, i) => (V(), H("div", xj, [e.isLoading || !e.guideData ? (V(), H("div", Sj, [W("div", Cj, [G(F(xm), { class: "size-5 rounded" }), G(F(xm), { class: "h-5 w-40" })]), W("div", wj, [G(F(xm), { class: "h-8 w-20 rounded-md" }), G(F(xm), { class: "h-8 w-20 rounded-md" })])])) : (V(), H("div", Tj, [W("div", Ej, [G(F(sf), { class: "size-5 text-foreground" }), i[3] ||= W("h2", { class: "text-base text-foreground" }, "Interview Questions", -1)]), G(F(fS), null, {
			default: I(() => [G(F(pk), null, {
				default: I(() => [e.hideRubricToggle ? q("", !0) : (V(), U(F(uS), { key: 0 }, {
					default: I(() => [G(F(pS), { "as-child": "" }, {
						default: I(() => [G(F(Jx), {
							variant: F(n) ? "selected" : "outline",
							size: "sm",
							onClick: i[0] ||= (e) => n.value = !F(n)
						}, {
							default: I(() => [F(n) ? (V(), U(F(Jd), {
								key: 0,
								class: "size-4"
							})) : (V(), U(F(tf), {
								key: 1,
								class: "size-4"
							})), i[4] ||= K(" Rubric ", -1)]),
							_: 1
						}, 8, ["variant"])]),
						_: 1
					}), G(F(dS), null, {
						default: I(() => [K(N(F(n) ? "Hide scoring rubric" : "Show scoring rubric"), 1)]),
						_: 1
					})]),
					_: 1
				})), e.hideNotesToggle ? q("", !0) : (V(), U(F(uS), { key: 1 }, {
					default: I(() => [G(F(pS), { "as-child": "" }, {
						default: I(() => [G(F(Jx), {
							variant: F(r) ? "selected" : "outline",
							size: "sm",
							onClick: i[1] ||= (e) => r.value = !F(r)
						}, {
							default: I(() => [F(r) ? (V(), U(F(Jd), {
								key: 0,
								class: "size-4"
							})) : (V(), U(F(xf), {
								key: 1,
								class: "size-4"
							})), K(" " + N(e.notesLabel) + " (" + N(c.value) + ") ", 1)]),
							_: 1
						}, 8, ["variant"])]),
						_: 1
					}), G(F(dS), null, {
						default: I(() => [K(N(F(r) ? `Hide ${e.notesLabel.toLowerCase()}` : `Show ${e.notesLabel.toLowerCase()}`), 1)]),
						_: 1
					})]),
					_: 1
				}))]),
				_: 1
			})]),
			_: 1
		})])), W("div", Dj, [e.isLoading || !e.guideData ? (V(), H("div", Oj, [(V(), H(B, null, R(5, (e) => G(F(_m), {
			key: e,
			shadow: "none"
		}, {
			default: I(() => [W("div", kj, [
				W("div", Aj, [G(F(xm), { class: "size-5 rounded-full shrink-0" }), W("div", jj, [G(F(xm), { class: "h-4 w-40" }), G(F(xm), { class: "h-3.5 w-full max-w-80" })])]),
				e % 2 == 0 ? q("", !0) : (V(), H("div", Mj, [G(F(xm), { class: "h-5 w-24 rounded-full" }), G(F(xm), { class: "h-6 w-full max-w-md" })])),
				W("div", Nj, [G(F(xm), { class: "h-3 w-24" }), W("div", Pj, [(V(), H(B, null, R(5, (e) => W("div", {
					key: e,
					class: M(["flex flex-col items-center gap-1.5", e % 2 == 0 ? "opacity-50" : ""])
				}, [
					G(F(xm), { class: "h-3 w-3" }),
					G(F(xm), { class: "size-5 rounded-full" }),
					e % 2 == 0 ? q("", !0) : (V(), U(F(xm), {
						key: 0,
						class: "h-3 w-20 mt-0.5"
					}))
				], 2)), 64))])])
			])]),
			_: 2
		}, 1024)), 64))])) : e.error ? (V(), H("div", Fj, [W("div", Ij, [i[6] ||= W("p", { class: "text-sm text-destructive mb-2" }, "Failed to load interview assistant", -1), G(F(Jx), {
			size: "sm",
			variant: "outline",
			onClick: i[2] ||= (e) => t.$emit("retry")
		}, {
			default: I(() => [...i[5] ||= [K(" Retry ", -1)]]),
			_: 1
		})])])) : d.value ? (V(), H("div", Lj, [(V(!0), H(B, null, R(f.value, (t) => (V(), U(F(_j), {
			key: t.id,
			competency: {
				name: g(t),
				description: t.isObservable ? "Evaluated throughout the interview" : "",
				question: t.question,
				anchors: t.anchors,
				anchorLabels: t.anchorLabels
			},
			"show-question": !t.isObservable && !!t.question,
			"show-rating": !!t.anchors,
			"is-observable": t.isObservable,
			"ratings-editable": !1,
			compact: o.value,
			"read-only": e.readOnly,
			"render-chips": !0,
			"condition-rule": F(yj)(u.value, t),
			questions: t.questions || [],
			"alternative-questions": t.alternativeQuestions || [],
			"selected-question": h(t),
			"questions-editable": m(t),
			"show-notes": s.value,
			"notes-label": e.notesLabel,
			feedback: e.planFeedback[t.id] || "",
			"onUpdate:selectedQuestion": (e) => a("update:selectedQuestion", p(t), e, {
				competencyId: t.competencyId,
				groupId: t.groupId
			}),
			"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
		}, null, 8, [
			"competency",
			"show-question",
			"show-rating",
			"is-observable",
			"compact",
			"read-only",
			"condition-rule",
			"questions",
			"alternative-questions",
			"selected-question",
			"questions-editable",
			"show-notes",
			"notes-label",
			"feedback",
			"onUpdate:selectedQuestion",
			"onUpdate:feedback"
		]))), 128))])) : !e.guideData?.interviewOpening?.length && !e.guideData?.labelGroups?.length && !e.guideData?.observedCompetencies?.length && !e.guideData?.competencies?.length && !e.guideData?.brandFitCompetencies?.length ? (V(), H("div", Rj, " No competencies or questions defined for this guide. ")) : (V(), H("div", zj, [
			(e.guideData?.interviewOpening || []).length ? (V(), H("h3", Bj, "Opening")) : q("", !0),
			(V(!0), H(B, null, R(e.guideData?.interviewOpening || [], (t) => (V(), U(F(_j), {
				key: t.id,
				competency: {
					name: t.name || t.category,
					description: t.description || "",
					question: t.question
				},
				"show-question": !0,
				"show-rating": !1,
				"is-opening": !0,
				compact: o.value,
				"read-only": e.readOnly,
				"alternative-questions": t.alternativeQuestions || [],
				"selected-question": e.selectedQuestions[t.id] || t.question,
				"questions-editable": e.questionsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"icon-override": t.icon || null,
				"icon-class-override": t.iconClass || "",
				"onUpdate:selectedQuestion": (e) => a("update:selectedQuestion", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"compact",
				"read-only",
				"alternative-questions",
				"selected-question",
				"questions-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"icon-override",
				"icon-class-override",
				"onUpdate:selectedQuestion",
				"onUpdate:feedback"
			]))), 128)),
			(e.guideData?.labelGroups || []).length ? (V(), H("h3", Vj, "Screening & Qualification")) : q("", !0),
			(V(!0), H(B, null, R(e.guideData?.labelGroups || [], (t) => (V(), U(F(_j), {
				key: t.id,
				competency: {
					name: t.name,
					description: t.evaluationGuidance || "",
					question: t.question,
					anchors: t.anchors
				},
				"show-question": !!t.question,
				"show-rating": !0,
				"ratings-editable": !1,
				compact: o.value,
				"read-only": e.readOnly,
				questions: t.questions || [],
				"selected-question": t.questions?.[0]?.id || t.question,
				"questions-editable": !1,
				"show-notes": !1
			}, null, 8, [
				"competency",
				"show-question",
				"compact",
				"read-only",
				"questions",
				"selected-question"
			]))), 128)),
			(e.guideData?.observedCompetencies || []).length ? (V(), H("h3", Hj, "Observable Competencies")) : q("", !0),
			(V(!0), H(B, null, R(e.guideData?.observedCompetencies || [], (t) => (V(), U(F(_j), {
				key: t.id,
				competency: t,
				"show-question": !1,
				"show-rating": !0,
				"is-observable": !0,
				compact: o.value,
				"read-only": e.readOnly,
				rating: e.planRatings[t.id],
				"ratings-editable": e.ratingsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"onUpdate:rating": (e) => a("update:planRating", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"compact",
				"read-only",
				"rating",
				"ratings-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"onUpdate:rating",
				"onUpdate:feedback"
			]))), 128)),
			(e.guideData?.competencies || []).length ? (V(), H("h3", Uj, "Skills & Competencies")) : q("", !0),
			(V(!0), H(B, null, R(e.guideData?.competencies || [], (t) => (V(), U(F(_j), {
				key: t.id,
				competency: t,
				"show-question": l(t),
				"show-rating": t.showRating !== !1,
				"is-opening": t.isOpening || !1,
				"is-brand-fit": t.isBrandFit || !1,
				compact: o.value,
				"read-only": e.readOnly,
				questions: t.questions || [],
				"alternative-questions": t.alternativeQuestions || [],
				rating: e.planRatings[t.id],
				"selected-question": e.selectedQuestionIds[t.id] || e.selectedQuestions[t.id] || t.question,
				"questions-editable": e.questionsEditable,
				"ratings-editable": e.ratingsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"icon-override": t.iconOverride || null,
				"icon-class-override": t.iconClassOverride || "",
				"onUpdate:rating": (e) => a("update:planRating", t.id, e),
				"onUpdate:selectedQuestion": (e) => a("update:selectedQuestion", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"show-question",
				"show-rating",
				"is-opening",
				"is-brand-fit",
				"compact",
				"read-only",
				"questions",
				"alternative-questions",
				"rating",
				"selected-question",
				"questions-editable",
				"ratings-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"icon-override",
				"icon-class-override",
				"onUpdate:rating",
				"onUpdate:selectedQuestion",
				"onUpdate:feedback"
			]))), 128)),
			(e.guideData?.brandFitCompetencies || []).length ? (V(), H("h3", Wj, "Brand Fit")) : q("", !0),
			(V(!0), H(B, null, R(e.guideData?.brandFitCompetencies || [], (t) => (V(), U(F(_j), {
				key: t.id,
				competency: t,
				"show-question": !1,
				"show-rating": !0,
				"is-brand-fit": !0,
				compact: o.value,
				"read-only": e.readOnly,
				rating: e.planRatings[t.id],
				"ratings-editable": e.ratingsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"onUpdate:rating": (e) => a("update:planRating", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"compact",
				"read-only",
				"rating",
				"ratings-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"onUpdate:rating",
				"onUpdate:feedback"
			]))), 128))
		]))])]));
	}
}, Kj = {
	key: 0,
	class: "px-8"
}, qj = {
	__name: "InterviewGuideRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.interviewPlan || []), r = J(() => t.component.scorecard || null), i = {
			Introduction: {
				icon: vf,
				iconClass: "text-info-foreground",
				subtitle: "Opening"
			},
			Screening: {
				icon: of,
				iconClass: "text-success",
				subtitle: "Screening"
			},
			"Wrap-Up": {
				icon: pf,
				iconClass: "text-amber-600",
				subtitle: "Closing"
			}
		};
		function a(e) {
			let t = i[e.category];
			return t ? {
				id: e.id,
				name: e.tag || e.category,
				description: t.subtitle,
				question: e.question || "",
				showRating: !1,
				iconOverride: t.icon,
				iconClassOverride: t.iconClass
			} : {
				id: e.id,
				name: e.tag || e.category,
				description: e.tag ? e.category : "",
				question: e.question || "",
				isBrandFit: !!e.isBrandFit
			};
		}
		let o = J(() => {
			let e = n.value;
			return e.length ? {
				interviewOpening: [],
				observedCompetencies: [],
				competencies: e.map(a),
				brandFitCompetencies: [],
				scorecardSettings: { scaleLength: r.value?.scale?.length || 5 }
			} : null;
		}), s = J(() => r.value?.ratings || {}), c = J(() => {
			let e = {};
			for (let t of n.value) t.evaluationInstructions && (e[t.id] = t.evaluationInstructions);
			return e;
		});
		return (e, t) => o.value ? (V(), H("div", Kj, [G(Gj, {
			"guide-data": o.value,
			"plan-ratings": s.value,
			"plan-feedback": c.value,
			"selected-questions": {},
			"read-only": !0,
			"questions-editable": !1,
			"ratings-editable": !1,
			"notes-label": "Evaluation Instructions",
			"hide-rubric-toggle": !0
		}, null, 8, [
			"guide-data",
			"plan-ratings",
			"plan-feedback"
		])])) : q("", !0);
	}
};
//#endregion
//#region src/utils/fraudSignals.js
function Jj(e) {
	if (e.error) return "error";
	if (!e.signal_explanations?.length) return "clean";
	let t = e.signal_explanations;
	return t.some((e) => e.level === "high") ? "high" : t.some((e) => e.level === "medium") ? "medium" : "low";
}
var Yj = {
	high: 0,
	medium: 1,
	low: 2,
	clean: 3,
	error: 4
};
function Xj(e) {
	return Yj[Jj(e)];
}
function Zj(e) {
	return Array.isArray(e) ? [...e].sort((e, t) => Xj(e) - Xj(t)) : [];
}
function Qj(e) {
	return Jj(e) === "clean" ? 0 : e.signal_explanations?.length || 0;
}
function $j(e) {
	return Jj(e) === "error" ? e.not_verified_copy || e.error || null : e.no_signals_copy || null;
}
function eM(e) {
	return Array.isArray(e.no_risk_summary) ? e.no_risk_summary.filter(Boolean) : [];
}
function tM(e) {
	return !!e.signal_explanations?.length || !!$j(e) || eM(e).length > 0;
}
//#endregion
//#region src/components/interview/agent-report/AgentFraudKpiStrip.vue
var nM = { class: "flex items-stretch justify-between gap-4 min-w-0" }, rM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, iM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, aM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, oM = {
	__name: "AgentFraudKpiStrip",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e, n = J(() => Zj(t.fraud?.score_details)), r = J(() => {
			let e = Number(t.fraud?.score);
			return Number.isFinite(e) ? Math.round(e) : null;
		}), i = J(() => (t.fraud?.risk_level || "").toLowerCase()), a = J(() => t.fraud?.risk_level || "—"), o = {
			low: "text-success-strong",
			medium: "text-warning-strong",
			high: "text-destructive-strong"
		}, s = J(() => o[i.value] || "text-foreground"), c = J(() => n.value.reduce((e, t) => {
			let n = Jj(t);
			return n === "high" || n === "medium" || n === "low" ? e + (t.signal_explanations?.length || 0) : e;
		}, 0)), l = J(() => n.value.reduce((e, t) => Jj(t) === "high" ? e + (t.signal_explanations?.length || 0) : e, 0)), u = J(() => {
			let e = n.value.length;
			return {
				notVerified: n.value.filter((e) => Jj(e) === "error").length,
				total: e
			};
		});
		return (e, t) => (V(), H("div", nM, [
			G(F(AO), { label: "Risk level" }, {
				default: I(() => [W("span", { class: M(["text-2xl font-medium truncate", s.value]) }, N(a.value), 3)]),
				_: 1
			}),
			G(F(tS), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			G(F(AO), { label: "Fraud Analysis" }, {
				default: I(() => [W("span", rM, N(r.value ?? "—"), 1)]),
				_: 1
			}),
			G(F(tS), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			G(F(AO), { label: "Signals detected" }, {
				default: I(() => [W("span", iM, N(c.value), 1)]),
				_: 1
			}),
			G(F(tS), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			G(F(AO), { label: "High-risk signals" }, {
				default: I(() => [W("span", { class: M(["text-2xl font-medium tabular-nums truncate", l.value > 0 ? "text-destructive-strong" : "text-foreground"]) }, N(l.value), 3)]),
				_: 1
			}),
			G(F(tS), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			G(F(AO), { label: "Not verified" }, {
				default: I(() => [W("span", aM, N(u.value.notVerified) + " / " + N(u.value.total), 1)]),
				_: 1
			})
		]));
	}
}, sM = { class: "flex flex-col gap-4" }, cM = { class: "flex flex-col gap-4" }, lM = { class: "flex items-center min-w-0 gap-2" }, uM = {
	"data-testid": "fraud-group-name",
	class: "text-base font-medium text-foreground truncate"
}, dM = {
	key: 0,
	class: "text-sm text-muted-foreground shrink-0"
}, fM = { class: "inline-flex items-center gap-1.5 shrink-0 text-sm text-foreground" }, pM = { class: "flex items-start gap-2 min-w-0" }, mM = {
	class: "flex items-center justify-center size-4 shrink-0 mt-0.5",
	"aria-hidden": "true"
}, hM = { class: "flex flex-col gap-1 min-w-0" }, gM = { class: "text-sm text-foreground" }, _M = { class: "text-sm text-muted-foreground leading-snug" }, vM = {
	key: 0,
	class: "text-xs text-muted-foreground"
}, yM = {
	key: 0,
	class: "shrink-0 text-right tabular-nums text-sm text-muted-foreground w-16"
}, bM = {
	key: 1,
	"data-testid": "fraud-group-notice",
	class: "flex items-start gap-2 rounded-lg bg-muted/70 px-3 py-2.5"
}, xM = {
	class: "flex items-center justify-center size-4 shrink-0 mt-0.5",
	"aria-hidden": "true"
}, SM = { class: "text-sm text-muted-foreground" }, CM = {
	class: "flex items-center justify-center size-4 shrink-0 mt-0.5",
	"aria-hidden": "true"
}, wM = { class: "text-sm text-muted-foreground" }, TM = {
	__name: "AgentFraudReport",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e;
		function n(e) {
			let t = Qj(e);
			return t === 1 ? "(1 signal)" : `(${t} signals)`;
		}
		function r(e) {
			let t = e || "", n = t.split(/\s*\*\s*/).filter(Boolean);
			return n.length <= 1 ? {
				text: t,
				bullets: []
			} : {
				text: n[0],
				bullets: n.slice(1)
			};
		}
		function i(e) {
			return e?.extra?.confidence === void 0 ? null : `confidence: ${Number(e.extra.confidence).toFixed(2)}%`;
		}
		let a = J(() => Zj(t.fraud?.score_details)), o = {
			high: {
				icon: jf,
				label: "High Risk",
				iconClass: "text-destructive"
			},
			medium: {
				icon: jf,
				label: "Medium Risk",
				iconClass: "text-amber-500"
			},
			low: {
				icon: jf,
				label: "Low Risk",
				iconClass: "text-amber-300"
			},
			clean: {
				icon: $d,
				label: "No Fraud Detected",
				iconClass: "text-success"
			},
			error: {
				icon: hf,
				label: "Not Verified",
				iconClass: "text-muted-foreground"
			}
		};
		function s(e) {
			return o[Jj(e)] || o.error;
		}
		let c = {
			high: "bg-destructive",
			medium: "bg-amber-500",
			low: "bg-amber-300",
			clean: "bg-success",
			error: "bg-muted-foreground"
		};
		function l(e) {
			return c[Jj(e)] || "bg-muted-foreground";
		}
		let u = Dr("cq:report-print", !1);
		function d(e) {
			return u ? !0 : [
				"high",
				"medium",
				"low"
			].includes(Jj(e));
		}
		return (e, t) => (V(), H("div", sM, [t[0] ||= W("h3", { class: "text-2xl font-title text-foreground" }, "Fraud Analysis Report", -1), W("div", cM, [(V(!0), H(B, null, R(a.value, (e, t) => (V(), H(B, { key: e.signal_name }, [t > 0 ? (V(), U(F(tS), { key: 0 })) : q("", !0), G(F(VT), {
			"default-open": d(e) && F(tM)(e),
			disabled: !F(tM)(e),
			class: "flex flex-col gap-3"
		}, {
			default: I(() => [G(F(UT), { class: M(["group/fraud flex items-center justify-between w-full gap-3 text-left", F(tM)(e) ? "cursor-pointer" : "cursor-default"]) }, {
				default: I(() => [W("div", lM, [
					G(F(Yd), { class: M(["size-4 shrink-0 text-muted-foreground transition-transform group-data-[state=closed]/fraud:-rotate-90", !F(tM)(e) && "opacity-40"]) }, null, 8, ["class"]),
					W("span", uM, N(e.display_name || e.signal_name), 1),
					F(Qj)(e) ? (V(), H("span", dM, N(n(e)), 1)) : q("", !0)
				]), W("span", fM, [(V(), U(ga(s(e).icon), { class: M(["size-4", s(e).iconClass]) }, null, 8, ["class"])), K(" " + N(s(e).label), 1)])]),
				_: 2
			}, 1032, ["class"]), G(F(HT), { class: "flex flex-col gap-3" }, {
				default: I(() => [e.signal_explanations?.length ? (V(!0), H(B, { key: 0 }, R(e.signal_explanations, (t, n) => (V(), H("div", {
					key: t.signal_codename || n,
					class: "flex items-start justify-between gap-2 rounded-lg bg-muted/70 px-3 py-2.5"
				}, [W("div", pM, [W("span", mM, [W("span", { class: M(["size-1.5 rounded-full", l(e)]) }, null, 2)]), W("div", hM, [
					W("span", gM, N(t.title), 1),
					W("p", _M, N(r(t.explanation).text), 1),
					i(t) ? (V(), H("span", vM, N(i(t)), 1)) : q("", !0)
				])]), t.points == null ? q("", !0) : (V(), H("span", yM, N(t.points) + "/100 ", 1))]))), 128)) : F($j)(e) ? (V(), H("div", bM, [W("span", xM, [W("span", { class: M(["size-1.5 rounded-full", l(e)]) }, null, 2)]), W("p", SM, N(F($j)(e)), 1)])) : q("", !0), (V(!0), H(B, null, R(F(eM)(e), (t, n) => (V(), H("div", {
					key: `observation-${n}`,
					"data-testid": "fraud-group-observation",
					class: "flex items-start gap-2 rounded-lg bg-muted/70 px-3 py-2.5"
				}, [W("span", CM, [W("span", { class: M(["size-1.5 rounded-full", l(e)]) }, null, 2)]), W("p", wM, N(t), 1)]))), 128))]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1032, ["default-open", "disabled"])], 64))), 128))])]));
	}
}, EM = { class: "flex flex-col gap-3" }, DM = { class: "flex flex-col gap-2" }, OM = { class: "text-sm text-foreground truncate min-w-0" }, kM = { class: "flex items-center gap-1.5 shrink-0" }, AM = {
	key: 0,
	class: "text-sm text-muted-foreground tabular-nums"
}, jM = {
	__name: "AgentFraudSidebar",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e, n = J(() => Zj(t.fraud?.score_details).map((e) => ({
			group: e,
			status: Jj(e)
		}))), r = {
			high: jf,
			medium: jf,
			low: jf,
			clean: Tf,
			error: hf
		}, i = {
			high: "text-destructive",
			medium: "text-amber-500",
			low: "text-amber-300",
			clean: "text-success",
			error: "text-muted-foreground"
		};
		function a(e) {
			return r[e] || hf;
		}
		function o(e) {
			return i[e] || "text-muted-foreground";
		}
		return (e, t) => (V(), H("div", EM, [t[0] ||= W("h3", { class: "text-base text-foreground" }, "Signal summary", -1), W("ul", DM, [(V(!0), H(B, null, R(n.value, (e) => (V(), H("li", {
			key: e.group.signal_name,
			class: "flex items-center justify-between gap-2"
		}, [W("span", OM, N(e.group.display_name || e.group.signal_name), 1), W("span", kM, [F(Qj)(e.group) ? (V(), H("span", AM, N(F(Qj)(e.group)), 1)) : q("", !0), (V(), U(ga(a(e.status)), { class: M(["size-4", o(e.status)]) }, null, 8, ["class"]))])]))), 128))])]));
	}
}, MM = {
	key: 0,
	class: "flex flex-col gap-8"
}, NM = { class: "grid grid-cols-1 lg:grid-cols-[1fr_280px] gap-12" }, PM = { class: "lg:sticky lg:top-4 lg:self-start" }, FM = {
	__name: "AgentFraudAnalysis",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e, n = J(() => !!t.fraud?.score_details?.length);
		return (t, r) => n.value ? (V(), H("div", MM, [
			G(oM, { fraud: e.fraud }, null, 8, ["fraud"]),
			G(F(tS), {
				variant: "pattern",
				class: "-mx-8 w-auto"
			}),
			W("div", NM, [G(TM, { fraud: e.fraud }, null, 8, ["fraud"]), W("div", PM, [G(jM, { fraud: e.fraud }, null, 8, ["fraud"])])])
		])) : (V(), U(F(_m), {
			key: 1,
			variant: "ghost"
		}, {
			default: I(() => [G(F(vm), null, {
				default: I(() => [...r[0] ||= [W("p", { class: "text-sm text-muted-foreground" }, "Fraud analysis not available for this interview.", -1)]]),
				_: 1
			})]),
			_: 1
		}));
	}
}, IM = {
	key: 0,
	class: "px-8"
}, LM = {
	__name: "FraudAnalysisRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.fraud || null);
		return (e, t) => n.value ? (V(), H("div", IM, [G(FM, { fraud: n.value }, null, 8, ["fraud"])])) : q("", !0);
	}
}, RM = {
	strong_positive: ["strong_hire", "strongly_recommend"],
	positive: ["hire", "recommend"],
	neutral: ["neutral", "no_decision"],
	negative: ["no_hire", "do_not_recommend"],
	strong_negative: ["strong_no_hire", "strongly_no_hire"]
}, zM = {
	strongly_recommend: "Strongly Recommend",
	recommend: "Recommend",
	strong_hire: "Strong Hire",
	hire: "Hire",
	no_decision: "No Decision",
	neutral: "Neutral",
	no_hire: "No Hire",
	do_not_recommend: "Do Not Recommend",
	strong_no_hire: "Strong No Hire",
	strongly_no_hire: "Strongly No Hire",
	mixed: "Mixed Opinions"
};
function BM(e) {
	if (!e) return null;
	for (let [t, n] of Object.entries(RM)) if (n.includes(e)) return t;
	return null;
}
function VM(e) {
	return e ? zM[e] || e.replace(/_/g, " ").replace(/\b\w/g, (e) => e.toUpperCase()) : "";
}
function HM(e) {
	let t = {};
	if (!Array.isArray(e)) return t;
	for (let n of e) {
		let e = n?.recommendation;
		e && (t[e] = (t[e] || 0) + 1);
	}
	return t;
}
function UM(e) {
	if (!Array.isArray(e) || e.length === 0) return null;
	let t = {
		strong_positive: 0,
		positive: 0,
		neutral: 0,
		negative: 0,
		strong_negative: 0
	};
	for (let n of e) {
		let e = BM(n?.recommendation);
		e && t[e]++;
	}
	let n = t.strong_positive + t.positive, r = t.strong_negative + t.negative, i = t.neutral;
	return n === 0 && r === 0 && i === 0 ? null : n >= 2 && r >= 2 || n > 0 && n === r ? "mixed" : i >= n && i >= r ? "neutral" : n > r ? t.strong_positive > t.positive ? "strong_hire" : "hire" : t.strong_negative > t.negative ? "strong_no_hire" : "no_hire";
}
//#endregion
//#region src/components/interview/tabs/consensus/ConsensusOverviewStrip.vue
var WM = { class: "grid grid-cols-2 sm:grid-cols-4 lg:flex lg:items-stretch lg:justify-between gap-4 min-w-0" }, GM = { class: "flex flex-col gap-2" }, KM = {
	key: 0,
	class: "text-sm text-body leading-snug"
}, qM = {
	key: 1,
	class: "flex flex-col gap-1.5 text-sm text-body"
}, JM = { class: "truncate" }, YM = {
	key: 2,
	class: "text-sm text-body leading-snug"
}, XM = { class: "tabular-nums" }, ZM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, QM = { class: "flex flex-col gap-2" }, $M = { class: "text-sm text-body leading-snug" }, eN = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, tN = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, nN = { class: "flex flex-col gap-2" }, rN = { class: "text-sm text-body leading-snug" }, iN = { class: "flex flex-col gap-2" }, aN = { class: "text-sm text-body leading-snug" }, oN = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, sN = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, cN = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, lN = { key: 0 }, uN = { key: 1 }, dN = {
	__name: "ConsensusOverviewStrip",
	props: {
		recommendation: {
			type: String,
			default: null
		},
		allRecommendations: {
			type: Array,
			default: () => []
		},
		averageRating: {
			type: Number,
			default: null
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		durationMinutes: {
			type: Number,
			default: null
		},
		mockSeed: {
			type: [String, Number],
			default: "consensus"
		},
		interviewerCount: {
			type: Number,
			default: 1
		}
	},
	setup(e) {
		let t = e;
		function n(e) {
			switch (e) {
				case "strong_hire":
				case "hire": return kf;
				case "strong_no_hire":
				case "no_hire": return Of;
				case "mixed": return jf;
				default: return Sf;
			}
		}
		function r(e) {
			switch (e) {
				case "strong_hire":
				case "hire": return "text-success";
				case "strong_no_hire":
				case "no_hire": return "text-destructive";
				case "mixed": return "text-warning-foreground";
				default: return "text-muted-foreground";
			}
		}
		let i = J(() => r(t.recommendation)), a = J(() => {
			switch (t.recommendation) {
				case "strong_hire":
				case "hire": return "Hire";
				case "strong_no_hire":
				case "no_hire": return "No Hire";
				case "mixed": return "Mixed";
				case "neutral": return "No Decision";
				default: return "Pending";
			}
		}), o = J(() => (t.allRecommendations || []).filter((e) => e.recommendation).map((e) => ({
			name: e.name,
			code: e.recommendation,
			label: e.label || VM(e.recommendation),
			icon: n(e.recommendation),
			color: r(e.recommendation)
		}))), s = J(() => t.averageRating == null ? "-" : t.averageRating.toFixed(1)), c = J(() => t.durationMinutes != null && t.durationMinutes > 0), l = J(() => {
			if (!c.value) return "—";
			let e = Math.round(t.durationMinutes);
			if (e < 60) return `${e}m`;
			let n = Math.floor(e / 60), r = e % 60;
			return r === 0 ? `${n}h` : `${n}h${r}`;
		});
		function u(e) {
			let t = String(e ?? "seed"), n = 0;
			for (let e = 0; e < t.length; e += 1) n = (n << 5) - n + t.charCodeAt(e), n |= 0;
			return Math.abs(n);
		}
		let d = [
			38,
			42,
			47,
			52,
			56,
			61
		], f = J(() => {
			let e = u(t.mockSeed), n = 78 + (e >> 6) % 22, r = d[(e >> 9) % d.length];
			return {
				guideCoveragePct: n,
				talkInterviewerPct: r,
				talkCandidatePct: 100 - r
			};
		}), p = J(() => {
			let e = t.interviewerCount;
			return e === 1 ? "1 interviewer" : `${e} interviewers`;
		});
		return (t, n) => (V(), U(F(_m), {
			variant: "ghost",
			class: "p-4 pt-2 flex flex-col gap-6"
		}, {
			default: I(() => [
				W("div", WM, [
					G(F(fS), { "delay-duration": 200 }, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(AO), {
									label: "Recommendation",
									class: "cursor-help"
								}, {
									default: I(() => [W("span", { class: M(["text-2xl font-medium truncate", i.value]) }, N(a.value), 3)]),
									_: 1
								})]),
								_: 1
							}), G(F(dS), {
								side: "bottom",
								class: "w-96 max-w-96 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: I(() => [W("div", GM, [
									n[0] ||= W("span", { class: "text-base font-medium text-foreground" }, "Consensus recommendation", -1),
									o.value.length ? (V(), H("p", KM, " Breakdown across " + N(p.value) + ": ", 1)) : q("", !0),
									o.value.length ? (V(), H("ul", qM, [(V(!0), H(B, null, R(o.value, (e) => (V(), H("li", {
										key: e.name,
										class: "flex items-center justify-between gap-4"
									}, [W("span", JM, N(e.name), 1), G(F(UE), {
										variant: "outline",
										icon: e.icon,
										"icon-class": e.color,
										class: "shrink-0"
									}, {
										default: I(() => [K(N(e.label), 1)]),
										_: 2
									}, 1032, ["icon", "icon-class"])]))), 128))])) : (V(), H("p", YM, " Aggregated hire recommendation across " + N(p.value) + ". ", 1))
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}),
					G(F(tS), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}),
					G(F(fS), { "delay-duration": 200 }, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(AO), { class: "cursor-help" }, {
									label: I(() => [n[1] ||= K(" Interview Score ", -1), W("span", XM, "/" + N(e.scaleLength), 1)]),
									default: I(() => [W("span", ZM, N(s.value), 1)]),
									_: 1
								})]),
								_: 1
							}), G(F(dS), {
								side: "bottom",
								class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: I(() => [W("div", QM, [n[2] ||= W("span", { class: "text-base font-medium text-foreground" }, "Average score", -1), W("p", $M, " Mean rating across every competency from every submitted scorecard (" + N(p.value) + "). ", 1)])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}),
					c.value ? (V(), H(B, { key: 0 }, [G(F(tS), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}), G(F(AO), { label: "Duration" }, {
						default: I(() => [W("span", eN, N(l.value), 1)]),
						_: 1
					})], 64)) : q("", !0),
					G(F(tS), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}),
					G(F(fS), { "delay-duration": 200 }, {
						default: I(() => [G(F(uS), null, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [G(F(AO), {
									label: "Guide covered avg",
									class: "cursor-help"
								}, {
									default: I(() => [W("span", tN, N(f.value.guideCoveragePct) + "%", 1)]),
									_: 1
								})]),
								_: 1
							}), G(F(dS), {
								side: "bottom",
								class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: I(() => [W("div", nN, [n[3] ||= W("span", { class: "text-base font-medium text-foreground" }, "Guide coverage", -1), W("p", rN, " Average percentage of guide questions covered per interviewer, across " + N(p.value) + ". ", 1)])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}),
					G(F(tS), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}),
					G(F(AO), null, {
						label: I(() => [G(F(fS), { "delay-duration": 200 }, {
							default: I(() => [G(F(uS), null, {
								default: I(() => [G(F(pS), { "as-child": "" }, {
									default: I(() => [...n[4] ||= [W("span", { class: "cursor-help" }, "Interviewer/Candidate Talk avg %", -1)]]),
									_: 1
								}), G(F(dS), {
									side: "bottom",
									class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
								}, {
									default: I(() => [W("div", iN, [n[5] ||= W("span", { class: "text-base font-medium text-foreground" }, "Talk time share (avg)", -1), W("p", aN, " Average conversation split across " + N(p.value) + ". Combines speaking duration with pace (words per minute) and word density, so a fast talker doesn't skew higher than someone who simply spoke for longer. ", 1)])]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						default: I(() => [W("span", oN, [
							G(F(fS), { "delay-duration": 200 }, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", sN, N(f.value.talkInterviewerPct), 1)]),
										_: 1
									}), G(F(dS), { side: "bottom" }, {
										default: I(() => [...n[6] ||= [K(" Interviewer ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							}),
							n[8] ||= W("span", { class: "text-muted-foreground font-normal" }, " / ", -1),
							G(F(fS), { "delay-duration": 200 }, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", cN, N(f.value.talkCandidatePct), 1)]),
										_: 1
									}), G(F(dS), { side: "bottom" }, {
										default: I(() => [...n[7] ||= [K(" Candidate ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							})
						])]),
						_: 1
					})
				]),
				G(F(tS)),
				t.$slots.reviews ? (V(), H("div", lN, [z(t.$slots, "reviews")])) : q("", !0),
				t.$slots.expanded ? (V(), H("div", uN, [z(t.$slots, "expanded")])) : q("", !0)
			]),
			_: 3
		}));
	}
}, fN = { class: "flex flex-col" }, pN = { class: "flex items-center gap-2" }, mN = { class: "flex items-center gap-3" }, hN = { class: "text-sm" }, gN = { class: "font-medium" }, _N = {
	key: 0,
	class: "text-background/60"
}, vN = {
	key: 1,
	class: "text-warning mt-1"
}, yN = { class: "flex items-start gap-1" }, bN = { class: "flex flex-col flex-1 min-w-0" }, xN = { class: "text-sm text-body flex items-center gap-2" }, SN = {
	key: 0,
	class: "text-base font-medium leading-snug text-foreground whitespace-normal"
}, CN = { class: "min-h-10 flex items-center gap-2" }, wN = { class: "flex-1 h-8 bg-muted rounded-sm overflow-hidden" }, TN = { class: "w-8 text-right text-sm font-semibold tabular-nums text-foreground shrink-0" }, EN = ["title"], DN = { class: "flex flex-col gap-1" }, ON = {
	"data-emphasis": "",
	class: "text-body shrink-0"
}, kN = { class: "text-body whitespace-pre-wrap" }, AN = { class: "flex items-center gap-2" }, jN = { class: "text-sm text-body truncate" }, MN = { class: "flex items-center gap-2" }, NN = { class: "flex-1 h-6 bg-muted rounded-sm overflow-hidden" }, PN = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, FN = { class: "flex items-center gap-2" }, IN = { class: "text-sm text-body truncate" }, LN = { class: "flex items-center gap-2" }, RN = { class: "flex-1 h-6 bg-muted rounded-sm overflow-hidden" }, zN = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, BN = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, VN = { class: "md:hidden flex flex-col gap-6" }, HN = { class: "text-sm font-medium text-foreground" }, UN = { class: "flex flex-col gap-4" }, WN = ["onClick"], GN = { class: "flex flex-col flex-1 min-w-0" }, KN = { class: "text-sm text-body" }, qN = {
	key: 0,
	class: "text-base font-medium leading-snug text-foreground"
}, JN = {
	key: 0,
	class: "flex flex-col"
}, YN = { class: "flex items-center gap-2 min-w-0 flex-1" }, XN = { class: "text-sm text-body truncate" }, ZN = { class: "flex items-center gap-2 min-w-0 flex-1" }, QN = { class: "text-sm text-body truncate" }, $N = { class: "text-sm tabular-nums shrink-0" }, eP = { class: "flex justify-between items-center gap-2 pt-2 mt-1 border-t border-border" }, tP = {
	key: 1,
	class: "text-sm font-semibold tabular-nums text-foreground shrink-0"
}, nP = {
	key: 2,
	class: "flex flex-col gap-2 pt-2 mt-1 border-t border-border"
}, rP = {
	"data-emphasis": "",
	class: "text-sm text-body"
}, iP = { class: "text-sm text-body whitespace-pre-wrap" }, aP = {
	key: 1,
	class: "flex flex-col gap-2"
}, oP = { class: "flex items-center gap-2" }, sP = { class: "flex-1 h-6 bg-muted rounded-sm overflow-hidden" }, cP = { class: "w-8 text-right text-sm font-semibold tabular-nums text-foreground shrink-0" }, lP = {
	key: 0,
	class: "flex flex-col gap-1 pt-1"
}, uP = { class: "text-sm text-body w-20 truncate shrink-0" }, dP = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, fP = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, pP = { class: "text-sm text-body w-20 truncate shrink-0" }, mP = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, hP = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, gP = {
	key: 1,
	class: "text-sm text-muted-foreground ml-auto"
}, _P = {
	__name: "ConsensusRatingsTable",
	props: {
		currentUserId: {
			type: String,
			default: null
		},
		observableCompetencies: {
			type: Array,
			default: () => []
		},
		mainCompetencies: {
			type: Array,
			default: () => []
		},
		brandFitCompetencies: {
			type: Array,
			default: () => []
		},
		submittedScorecards: {
			type: Array,
			default: () => []
		},
		consensusAverageRatings: {
			type: Object,
			default: () => ({})
		},
		ratingsMatrix: {
			type: Object,
			default: null
		},
		tableVariant: {
			type: String,
			default: "transparent"
		},
		tableSize: {
			type: String,
			default: "sm"
		},
		showToolbar: {
			type: Boolean,
			default: !1
		},
		showBarsToggle: {
			type: Boolean,
			default: !1
		},
		showHeaderDivider: {
			type: Boolean,
			default: !1
		},
		tableContainerClass: {
			type: String,
			default: ""
		}
	},
	setup(e, { expose: t }) {
		let n = e, r = /* @__PURE__ */ P(!1), i = J(() => n.showBarsToggle && r.value);
		function a(e) {
			r.value = e === "bars";
		}
		let o = [
			"hsl(0, 72%, 51%)",
			"hsl(25, 95%, 53%)",
			"hsl(45, 93%, 47%)",
			"hsl(142, 71%, 45%)",
			"hsl(142, 76%, 36%)"
		];
		function s(e) {
			return e == null || e <= 0 ? "0%" : `${Math.min(e / 5 * 100, 100)}%`;
		}
		function c(e) {
			if (e == null || e <= 0) return o[0];
			let t = Math.min(Math.round(e) - 1, 4);
			return o[Math.max(0, t)];
		}
		let l = /* @__PURE__ */ P(/* @__PURE__ */ new Set()), u = /* @__PURE__ */ P(null);
		function d(e) {
			let t = new Set(l.value);
			t.has(e) ? t.delete(e) : t.add(e), l.value = t;
		}
		let f = /* @__PURE__ */ P(!1);
		function p() {
			f.value = !f.value;
		}
		let m = J(() => {
			let e = 0;
			for (let t of T.value) for (let n of t.competencies) e += n.notes?.length || 0;
			return e;
		}), h = J(() => i.value ? 2 : 1 + (g.value ? _.value.length : n.submittedScorecards.length) + 1);
		t({
			toggleNotes: p,
			notesEnabled: f,
			notesCount: m
		});
		let g = J(() => n.ratingsMatrix != null && n.ratingsMatrix.competencies?.length > 0), _ = J(() => n.ratingsMatrix?.interviewers || []), v = J(() => {
			let e = {};
			for (let t of n.observableCompetencies) e[t.id] = {
				is_observable: !0,
				is_brand_fit: !1
			};
			for (let t of n.mainCompetencies) e[t.id] = {
				is_observable: !1,
				is_brand_fit: !1
			};
			for (let t of n.brandFitCompetencies) e[t.id] = {
				is_observable: !1,
				is_brand_fit: !0
			};
			return e;
		}), y = J(() => (n.ratingsMatrix?.competencies || []).map((e) => {
			let t = v.value[e.id];
			return t ? {
				...e,
				is_observable: t.is_observable,
				is_brand_fit: t.is_brand_fit
			} : e;
		}).sort((e, t) => {
			let n = (e) => e.is_observable ? 0 : e.is_brand_fit ? 2 : 1;
			return n(e) - n(t);
		})), b = [
			{
				id: "screening",
				title: "Screening & Qualification"
			},
			{
				id: "observable",
				title: "Observable Competencies"
			},
			{
				id: "competency",
				title: "Competencies"
			},
			{
				id: "brand_fit",
				title: "Brand Fit"
			},
			{
				id: "other",
				title: "Other"
			}
		];
		function x(e) {
			if (e.section) return e.section;
			let t = v.value[e.id];
			return e.is_observable || t?.is_observable ? "observable" : e.is_brand_fit || t?.is_brand_fit ? "brand_fit" : "competency";
		}
		function S(e) {
			return {
				...e,
				id: e.label,
				name: e.unit_label || e.label
			};
		}
		let C = J(() => {
			let e = {
				screening: [],
				observable: [],
				competency: [],
				brand_fit: [],
				other: []
			};
			for (let t of y.value) e[x(t)].push(t);
			for (let t of n.ratingsMatrix?.label_groups || []) e[t.kind === "screening" ? "screening" : "other"].push(S(t));
			return b.map((t) => ({
				id: t.id,
				title: t.title,
				competencies: e[t.id]
			})).filter((e) => e.competencies.length > 0);
		}), w = J(() => [
			{
				id: "observable",
				title: "Observable Competencies",
				competencies: n.observableCompetencies
			},
			{
				id: "main",
				title: "Competencies",
				competencies: n.mainCompetencies
			},
			{
				id: "brandFit",
				title: "Brand Fit",
				competencies: n.brandFitCompetencies
			}
		].filter((e) => e.competencies.length > 0)), T = J(() => g.value ? C.value : w.value);
		function E(e) {
			return e.rating_scale_type === "pass_fail";
		}
		function ee(e) {
			return e === "Pass" ? "success" : e === "Fail" ? "destructive" : "secondary";
		}
		function D(e) {
			return E(e) ? null : e.consensus_rating === void 0 ? n.consensusAverageRatings[e.id] : e.consensus_rating;
		}
		let O = J(() => {
			let e = {}, t = [
				...n.observableCompetencies,
				...n.mainCompetencies,
				...n.brandFitCompetencies
			];
			for (let n of t) e[n.id] = n.question || n.description || "";
			return e;
		});
		function te(e) {
			return O.value[e.id] ? O.value[e.id] : e.description || "";
		}
		function k(e) {
			let t = _.value.find((t) => t.id === e);
			return t?.is_current_user == null ? !!(n.currentUserId && e === n.currentUserId) : t.is_current_user;
		}
		function ne(e) {
			if (!e) return !0;
			let t = e.toUpperCase();
			return t === "PENDING" || t === "DRAFT";
		}
		function re(e) {
			if (e.verdict) return e.verdict;
			if (e.rating != null) return e.rating.toFixed(1);
			switch (e.clarification) {
				case "NOT_COVERED": return "N/C";
				case "WEAK_DATA": return "W/D";
				default: return "—";
			}
		}
		function ie(e) {
			return e == null ? "—" : e.toFixed(1);
		}
		function ae(e) {
			return e.clarification === "NOT_COVERED" ? "text-muted-foreground italic" : e.clarification === "WEAK_DATA" ? "text-warning italic" : e.status === "PENDING" ? "text-muted-foreground" : "";
		}
		function A(e) {
			switch (e.clarification) {
				case "NOT_COVERED": return "Not covered in this interview";
				case "WEAK_DATA": return "Insufficient data to rate";
				default: return "";
			}
		}
		return (t, n) => (V(), H("div", fN, [
			e.showToolbar ? (V(), H("div", {
				key: 0,
				class: M(["flex items-center justify-between", e.showHeaderDivider ? "pb-3 mb-3 border-b border-border" : "mb-3"])
			}, [W("div", pN, [z(t.$slots, "header")]), W("div", mN, [e.showBarsToggle ? (V(), U(F(fS), { key: 0 }, {
				default: I(() => [G(F(pk), null, {
					default: I(() => [G(F(uS), null, {
						default: I(() => [G(F(pS), { "as-child": "" }, {
							default: I(() => [G(F(Jx), {
								variant: i.value ? "selected" : "outline",
								size: "sm",
								onClick: n[0] ||= (e) => a(i.value ? "score" : "bars")
							}, {
								default: I(() => [i.value ? (V(), U(F(Jd), {
									key: 0,
									class: "size-4"
								})) : (V(), U(F(qd), {
									key: 1,
									class: "size-4"
								})), n[4] ||= K(" Bar Chart ", -1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), G(F(dS), null, {
							default: I(() => [K(N(i.value ? "Hide bar chart" : "Show bar chart"), 1)]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})) : q("", !0)])], 2)) : q("", !0),
			W("div", { class: M([e.tableContainerClass || void 0, "hidden md:flex flex-col gap-2"]) }, [(V(!0), H(B, null, R(T.value, (t) => (V(), U(F(FT), {
				key: t.id,
				variant: e.tableVariant,
				size: e.tableSize,
				"fit-columns": ""
			}, {
				default: I(() => [
					W("colgroup", null, [W("col", { style: Se(i.value ? { width: "50%" } : { width: "55%" }) }, null, 4), i.value ? q("", !0) : (V(), H(B, { key: 0 }, [g.value ? (V(!0), H(B, { key: 0 }, R(_.value, (e) => (V(), H("col", { key: e.interview_id }))), 128)) : (V(!0), H(B, { key: 1 }, R(e.submittedScorecards, (e) => (V(), H("col", { key: e.id }))), 128)), n[5] ||= W("col", null, null, -1)], 64))]),
					G(F(BT), null, {
						default: I(() => [G(F(RT), null, {
							default: I(() => [G(F(zT), { class: M(["pl-4", i.value ? "pr-4" : "pr-12"]) }, {
								default: I(() => [K(N(t.title), 1)]),
								_: 2
							}, 1032, ["class"]), i.value ? (V(), U(F(zT), { key: 0 })) : (V(), H(B, { key: 1 }, [g.value ? (V(!0), H(B, { key: 0 }, R(_.value, (e) => (V(), U(F(zT), {
								key: e.interview_id,
								class: M([
									"text-center",
									e.is_current_user && !ne(e.status) && "bg-info",
									ne(e.status) && "bg-muted/20"
								])
							}, {
								default: I(() => [G(F(uS), null, {
									default: I(() => [G(F(pS), { "as-child": "" }, {
										default: I(() => [W("span", { class: M([e.is_current_user && !ne(e.status) && "text-info-foreground", ne(e.status) && "text-muted-foreground"]) }, N(e.name) + N(e.is_current_user ? " (You)" : ""), 3)]),
										_: 2
									}, 1024), G(F(dS), null, {
										default: I(() => [W("div", hN, [
											W("div", gN, N(e.name), 1),
											e.interview_name ? (V(), H("div", _N, N(e.interview_name), 1)) : q("", !0),
											ne(e.status) ? (V(), H("div", vN, " Scorecard not submitted ")) : q("", !0)
										])]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["class"]))), 128)) : (V(!0), H(B, { key: 1 }, R(e.submittedScorecards, (e) => (V(), U(F(zT), {
								key: e.id,
								class: M(["text-center", e.name === "My Scorecard" && "bg-info"])
							}, {
								default: I(() => [W("span", { class: M(e.name === "My Scorecard" && "text-info-foreground") }, N(e.name) + N(e.name === "My Scorecard" ? " (You)" : ""), 3)]),
								_: 2
							}, 1032, ["class"]))), 128)), G(F(zT), { class: "text-center pr-4 bg-muted" }, {
								default: I(() => [...n[6] ||= [K(" Consensus ", -1)]]),
								_: 1
							})], 64))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024),
					G(F(IT), null, {
						default: I(() => [(V(!0), H(B, null, R(t.competencies, (t) => (V(), H(B, { key: t.id }, [
							G(F(RT), {
								class: M(["transition-colors", [
									i.value && "cursor-pointer",
									u.value === t.id ? "bg-muted/50" : "hover:bg-muted/50",
									i.value && l.value.has(t.id) && "border-b-0!"
								]]),
								onClick: (e) => i.value && d(t.id),
								onMouseenter: (e) => u.value = t.id,
								onMouseleave: n[1] ||= (e) => u.value = null
							}, {
								default: I(() => [
									G(F(LT), { class: M(["py-3 align-top", i.value ? "pl-2 pr-4" : "pl-4 pr-12 max-w-50"]) }, {
										default: I(() => [W("div", yN, [i.value ? (V(), U(F(Xd), {
											key: 0,
											class: M(["size-4 transition-transform shrink-0 mt-0.5", l.value.has(t.id) ? "rotate-90 text-primary" : "text-muted-foreground"])
										}, null, 8, ["class"])) : q("", !0), W("div", bN, [W("span", xN, [K(N(t.name) + " ", 1), g.value && t.agreement_score != null && t.agreement_score < 60 ? (V(), U(F(uS), { key: 0 }, {
											default: I(() => [G(F(pS), null, {
												default: I(() => [G(F(Qd), { class: "size-4 text-warning" })]),
												_: 1
											}), G(F(dS), null, {
												default: I(() => [K(" Low agreement (" + N(Math.round(t.agreement_score)) + "%) ", 1)]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024)) : q("", !0)]), te(t) ? (V(), H("span", SN, N(te(t)), 1)) : q("", !0)])])]),
										_: 2
									}, 1032, ["class"]),
									i.value ? (V(), U(F(LT), {
										key: 0,
										class: "align-top py-3 px-2"
									}, {
										default: I(() => [W("div", CN, [E(t) ? (V(), U(F(UE), {
											key: 0,
											variant: ee(t.consensus_verdict)
										}, {
											default: I(() => [K(N(t.consensus_verdict || "—"), 1)]),
											_: 2
										}, 1032, ["variant"])) : (V(), H(B, { key: 1 }, [W("div", wN, [W("div", {
											class: "h-full rounded-sm transition-all duration-300 animate-rating-bar",
											style: Se({
												width: s(D(t)),
												backgroundColor: c(D(t))
											})
										}, null, 4)]), W("span", TN, N(ie(D(t))), 1)], 64))])]),
										_: 2
									}, 1024)) : q("", !0),
									i.value ? q("", !0) : (V(), H(B, { key: 1 }, [g.value ? (V(!0), H(B, { key: 0 }, R(t.ratings, (e) => (V(), U(F(LT), {
										key: `${e.interviewer_id}-${e.interview_id}`,
										class: M(["text-center align-middle py-3", [k(e.interviewer_id) && !ne(e.status) && "bg-info", ne(e.status) && "bg-muted/20"]])
									}, {
										default: I(() => [W("span", {
											class: M([ae(e), k(e.interviewer_id) && !ne(e.status) && "text-info-foreground"]),
											title: A(e)
										}, N(re(e)), 11, EN)]),
										_: 2
									}, 1032, ["class"]))), 128)) : (V(!0), H(B, { key: 1 }, R(e.submittedScorecards, (e) => (V(), U(F(LT), {
										key: e.id,
										class: M(["text-center align-middle py-3", [e.name === "My Scorecard" && "bg-info"]])
									}, {
										default: I(() => [W("span", { class: M(e.name === "My Scorecard" && "text-info-foreground") }, N(e.ratings?.[t.id] || "—"), 3)]),
										_: 2
									}, 1032, ["class"]))), 128)), G(F(LT), { class: "text-center font-semibold pr-4 bg-muted align-middle py-3" }, {
										default: I(() => [E(t) ? (V(), U(F(UE), {
											key: 0,
											variant: ee(t.consensus_verdict)
										}, {
											default: I(() => [K(N(t.consensus_verdict || "—"), 1)]),
											_: 2
										}, 1032, ["variant"])) : (V(), H(B, { key: 1 }, [K(N(ie(D(t))), 1)], 64))]),
										_: 2
									}, 1024)], 64))
								]),
								_: 2
							}, 1032, [
								"class",
								"onClick",
								"onMouseenter"
							]),
							f.value && t.notes?.length ? (V(), U(F(RT), {
								key: `notes-${t.id}`,
								class: "border-t-0! bg-muted/30"
							}, {
								default: I(() => [G(F(LT), {
									colspan: h.value,
									class: "py-2 pl-4 pr-4 align-top"
								}, {
									default: I(() => [W("div", DN, [(V(!0), H(B, null, R(t.notes, (e) => (V(), H("div", {
										key: e.interviewer_id,
										class: "flex gap-2 text-sm"
									}, [W("span", ON, N(e.interviewer_name) + ":", 1), W("span", kN, N(e.notes), 1)]))), 128))])]),
									_: 2
								}, 1032, ["colspan"])]),
								_: 2
							}, 1024)) : q("", !0),
							i.value && l.value.has(t.id) ? (V(), H(B, { key: 1 }, [g.value ? (V(!0), H(B, { key: 0 }, R(t.ratings, (e) => (V(), U(F(RT), {
								key: `bar-${e.interviewer_id}`,
								class: M(["border-t-0! bg-background transition-colors", u.value === t.id && "bg-muted/50"]),
								onMouseenter: (e) => u.value = t.id,
								onMouseleave: n[2] ||= (e) => u.value = null
							}, {
								default: I(() => [G(F(LT), { class: "py-1 pl-7 pr-4 align-middle" }, {
									default: I(() => [W("div", AN, [G(F(Mf), { class: "size-4 text-muted-foreground shrink-0" }), W("span", jN, N(e.interviewer_name) + N(k(e.interviewer_id) ? " (You)" : ""), 1)])]),
									_: 2
								}, 1024), G(F(LT), { class: "py-1 px-2 align-middle" }, {
									default: I(() => [W("div", MN, [e.rating == null ? (V(), H("span", {
										key: 1,
										class: M([ae(e), "text-sm"])
									}, N(re(e)), 3)) : (V(), H(B, { key: 0 }, [W("div", NN, [W("div", {
										class: "h-full rounded-sm transition-all duration-300 animate-rating-bar",
										style: Se({
											width: s(e.rating),
											backgroundColor: c(e.rating)
										})
									}, null, 4)]), W("span", PN, N(Math.round(e.rating)), 1)], 64))])]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["class", "onMouseenter"]))), 128)) : (V(!0), H(B, { key: 1 }, R(e.submittedScorecards, (e) => (V(), U(F(RT), {
								key: `bar-${e.id}`,
								class: M(["border-t-0! bg-background transition-colors", u.value === t.id && "bg-muted/50"]),
								onMouseenter: (e) => u.value = t.id,
								onMouseleave: n[3] ||= (e) => u.value = null
							}, {
								default: I(() => [G(F(LT), { class: "py-1 pl-7 pr-4 align-middle" }, {
									default: I(() => [W("div", FN, [G(F(Mf), { class: "size-4 text-muted-foreground shrink-0" }), W("span", IN, N(e.name) + N(e.name === "My Scorecard" ? " (You)" : ""), 1)])]),
									_: 2
								}, 1024), G(F(LT), { class: "py-1 px-2 align-middle" }, {
									default: I(() => [W("div", LN, [e.ratings?.[t.id] ? (V(), H(B, { key: 0 }, [W("div", RN, [W("div", {
										class: "h-full rounded-sm transition-all duration-300",
										style: Se({
											width: s(e.ratings[t.id]),
											backgroundColor: c(e.ratings[t.id])
										})
									}, null, 4)]), W("span", zN, N(Math.round(Number(e.ratings[t.id]))), 1)], 64)) : (V(), H("span", BN, "—"))])]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["class", "onMouseenter"]))), 128))], 64)) : q("", !0)
						], 64))), 128))]),
						_: 2
					}, 1024)
				]),
				_: 2
			}, 1032, ["variant", "size"]))), 128))], 2),
			W("div", VN, [(V(!0), H(B, null, R(T.value, (t) => (V(), H("div", {
				key: `m-${t.id}`,
				class: "flex flex-col gap-3"
			}, [W("h4", HN, N(t.title), 1), W("div", UN, [(V(!0), H(B, null, R(t.competencies, (t) => (V(), H("div", {
				key: `m-${t.id}`,
				class: "flex flex-col gap-2 pb-4 border-b border-border last:border-b-0"
			}, [W("div", {
				class: M(["flex items-start gap-1", i.value && "cursor-pointer"]),
				onClick: (e) => i.value && d(t.id)
			}, [i.value ? (V(), U(F(Xd), {
				key: 0,
				class: M(["size-4 transition-transform shrink-0 mt-0.5", l.value.has(t.id) ? "rotate-90 text-primary" : "text-muted-foreground"])
			}, null, 8, ["class"])) : q("", !0), W("div", GN, [W("span", KN, N(t.name), 1), te(t) ? (V(), H("span", qN, N(te(t)), 1)) : q("", !0)])], 10, WN), i.value ? (V(), H("div", aP, [W("div", oP, [
				G(F(Nf), { class: "size-4 text-muted-foreground shrink-0" }),
				n[8] ||= W("span", { class: "text-sm font-medium text-foreground w-20 shrink-0" }, "Consensus", -1),
				E(t) ? (V(), U(F(UE), {
					key: 0,
					variant: ee(t.consensus_verdict)
				}, {
					default: I(() => [K(N(t.consensus_verdict || "—"), 1)]),
					_: 2
				}, 1032, ["variant"])) : (V(), H(B, { key: 1 }, [W("div", sP, [W("div", {
					class: "h-full rounded-sm transition-all duration-300",
					style: Se({
						width: s(D(t)),
						backgroundColor: c(D(t))
					})
				}, null, 4)]), W("span", cP, N(ie(D(t))), 1)], 64))
			]), l.value.has(t.id) ? (V(), H("div", lP, [g.value ? (V(!0), H(B, { key: 0 }, R(t.ratings, (e) => (V(), H("div", {
				key: `m-b-${e.interviewer_id}`,
				class: "flex items-center gap-2"
			}, [
				G(F(Mf), { class: "size-4 text-muted-foreground shrink-0" }),
				W("span", uP, N(e.interviewer_name) + N(k(e.interviewer_id) ? " (You)" : ""), 1),
				e.rating == null ? (V(), H("span", {
					key: 1,
					class: M([ae(e), "text-sm ml-auto"])
				}, N(re(e)), 3)) : (V(), H(B, { key: 0 }, [W("div", dP, [W("div", {
					class: "h-full rounded-sm transition-all duration-300",
					style: Se({
						width: s(e.rating),
						backgroundColor: c(e.rating)
					})
				}, null, 4)]), W("span", fP, N(Math.round(e.rating)), 1)], 64))
			]))), 128)) : (V(!0), H(B, { key: 1 }, R(e.submittedScorecards, (e) => (V(), H("div", {
				key: `m-b-sc-${e.id}`,
				class: "flex items-center gap-2"
			}, [
				G(F(Mf), { class: "size-4 text-muted-foreground shrink-0" }),
				W("span", pP, N(e.name) + N(e.name === "My Scorecard" ? " (You)" : ""), 1),
				e.ratings?.[t.id] ? (V(), H(B, { key: 0 }, [W("div", mP, [W("div", {
					class: "h-full rounded-sm transition-all duration-300",
					style: Se({
						width: s(e.ratings[t.id]),
						backgroundColor: c(e.ratings[t.id])
					})
				}, null, 4)]), W("span", hP, N(Math.round(Number(e.ratings[t.id]))), 1)], 64)) : (V(), H("span", gP, "—"))
			]))), 128))])) : q("", !0)])) : (V(), H("div", JN, [
				g.value ? (V(!0), H(B, { key: 0 }, R(t.ratings, (e) => (V(), H("div", {
					key: `m-r-${e.interviewer_id}`,
					class: "flex justify-between items-center gap-2 py-1"
				}, [W("div", YN, [G(F(Mf), { class: "size-4 text-muted-foreground shrink-0" }), W("span", XN, N(e.interviewer_name) + N(k(e.interviewer_id) ? " (You)" : ""), 1)]), W("span", { class: M([ae(e), "text-sm tabular-nums shrink-0"]) }, N(re(e)), 3)]))), 128)) : (V(!0), H(B, { key: 1 }, R(e.submittedScorecards, (e) => (V(), H("div", {
					key: `m-sc-${e.id}`,
					class: "flex justify-between items-center gap-2 py-1"
				}, [W("div", ZN, [G(F(Mf), { class: "size-4 text-muted-foreground shrink-0" }), W("span", QN, N(e.name) + N(e.name === "My Scorecard" ? " (You)" : ""), 1)]), W("span", $N, N(e.ratings?.[t.id] || "—"), 1)]))), 128)),
				W("div", eP, [n[7] ||= W("span", { class: "text-sm font-medium text-foreground" }, "Consensus", -1), E(t) ? (V(), U(F(UE), {
					key: 0,
					variant: ee(t.consensus_verdict)
				}, {
					default: I(() => [K(N(t.consensus_verdict || "—"), 1)]),
					_: 2
				}, 1032, ["variant"])) : (V(), H("span", tP, N(ie(D(t))), 1))]),
				f.value && t.notes?.length ? (V(), H("div", nP, [(V(!0), H(B, null, R(t.notes, (e) => (V(), H("div", {
					key: `m-note-${e.interviewer_id}`,
					class: "flex flex-col"
				}, [W("span", rP, N(e.interviewer_name), 1), W("span", iP, N(e.notes), 1)]))), 128))])) : q("", !0)
			]))]))), 128))])]))), 128))])
		]));
	}
}, vP = { class: "space-y-1" }, yP = {
	key: 0,
	class: "text-base text-foreground leading-6"
}, bP = {
	key: 1,
	class: "text-sm text-placeholder italic leading-6"
}, xP = { class: "flex items-center gap-2 text-sm text-body flex-wrap" }, SP = { class: "flex items-center gap-1.5" }, CP = { class: "flex items-center gap-0.5" }, wP = { class: "tabular-nums" }, TP = { class: "text-foreground font-medium" }, EP = {
	__name: "InterviewerReviewCard",
	props: {
		name: {
			type: String,
			required: !0
		},
		recommendation: {
			type: String,
			default: null
		},
		recommendationLabel: {
			type: String,
			default: ""
		},
		feedback: {
			type: String,
			default: ""
		},
		rating: {
			type: Number,
			default: null
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		isCurrentUser: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, n = J(() => {
			switch (t.recommendation) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return "text-success";
				case "no_decision":
				case "neutral": return "text-warning-foreground";
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return "text-destructive";
				default: return "";
			}
		}), r = J(() => {
			switch (t.recommendation) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return kf;
				case "no_decision":
				case "neutral": return Sf;
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return Of;
				default: return null;
			}
		}), i = J(() => Math.round(t.rating ?? 0));
		return (t, a) => (V(), H("div", vP, [e.feedback ? (V(), H("p", yP, [
			a[0] ||= W("span", {
				class: "text-muted-foreground select-none",
				"aria-hidden": "true"
			}, "“", -1),
			K(N(e.feedback), 1),
			a[1] ||= W("span", {
				class: "text-muted-foreground select-none",
				"aria-hidden": "true"
			}, "”", -1)
		])) : (V(), H("p", bP, " - The interviewer did not provide feedback - ")), W("div", xP, [
			W("div", SP, [G(F(Mf), { class: "size-4 shrink-0" }), W("span", null, N(e.name) + N(e.isCurrentUser ? " (You)" : ""), 1)]),
			e.rating == null ? q("", !0) : (V(), H(B, { key: 0 }, [
				a[2] ||= W("span", { "aria-hidden": "true" }, "·", -1),
				W("div", CP, [(V(!0), H(B, null, R(e.scaleLength, (e) => (V(), U(F(Ef), {
					key: e,
					class: M(["size-3.5", e <= i.value ? "fill-current" : "fill-none text-muted-foreground/40"])
				}, null, 8, ["class"]))), 128))]),
				W("span", wP, [W("span", TP, N(e.rating.toFixed(1)), 1), K("/" + N(e.scaleLength), 1)])
			], 64)),
			e.recommendation ? (V(), U(F(UE), {
				key: 1,
				variant: "outline",
				icon: r.value,
				"icon-class": n.value
			}, {
				default: I(() => [K(N(e.recommendationLabel), 1)]),
				_: 1
			}, 8, ["icon", "icon-class"])) : q("", !0)
		])]));
	}
}, DP = { class: "space-y-2" }, OP = { class: "flex items-center gap-2" }, kP = { class: "text-foreground cursor-help group-hover:underline underline-offset-2 decoration-1" }, AP = {
	key: 0,
	class: "font-medium"
}, jP = ["innerHTML"], MP = {
	key: 1,
	class: "text-foreground"
}, NP = { class: "text-foreground cursor-help group-hover:underline underline-offset-2 decoration-1" }, PP = {
	key: 0,
	class: "font-medium"
}, FP = ["innerHTML"], IP = {
	key: 1,
	class: "text-foreground"
}, LP = {
	__name: "AlertsCard",
	props: { alerts: {
		type: Array,
		default: () => []
	} },
	setup(e) {
		let t = e, n = /* @__PURE__ */ P(!1), r = J(() => t.alerts.map((e) => {
			let t = e.tooltip, n = null, r = null;
			typeof t == "string" ? r = t : t && Array.isArray(t.description) && t.description.length > 0 && (n = t.description);
			let i = r ? fT(r) : null, a = !!n || !!i || !!e.interviewerName;
			return {
				...e,
				tooltipItems: n,
				tooltipHtml: i,
				hasTooltip: a
			};
		})), i = J(() => r.value.length), a = J(() => r.value[0] || null), o = J(() => r.value.slice(1)), s = J(() => i.value > 1);
		function c(e) {
			return e?.severity === "warning" ? "text-warning-strong" : "text-destructive-strong";
		}
		return (e, t) => i.value > 0 ? (V(), U(F(_m), {
			key: 0,
			variant: "destructive",
			bordered: !1,
			class: "text-sm"
		}, {
			default: I(() => [G(F(vm), null, {
				default: I(() => [G(F(fS), { "delay-duration": 350 }, {
					default: I(() => [W("div", DP, [W("div", OP, [
						G(F(jf), { class: M(["size-4 shrink-0", c(a.value)]) }, null, 8, ["class"]),
						a.value.hasTooltip ? (V(), U(F(uS), { key: 0 }, {
							default: I(() => [G(F(pS), { "as-child": "" }, {
								default: I(() => [W("span", kP, N(a.value.text), 1)]),
								_: 1
							}), G(F(dS), {
								side: "top",
								class: "max-w-sm"
							}, {
								default: I(() => [a.value.interviewerName ? (V(), H("div", AP, N(a.value.interviewerName), 1)) : q("", !0), a.value.tooltipItems ? (V(), H(B, { key: 1 }, [a.value.tooltipItems.length === 1 ? (V(), H("span", {
									key: 0,
									class: M(a.value.interviewerName ? "text-background/60" : "")
								}, N(a.value.tooltipItems[0].value), 3)) : (V(), H("ul", {
									key: 1,
									class: M(["list-disc pl-4 space-y-0.5", [a.value.interviewerName ? "mt-1 text-background/60" : ""]])
								}, [(V(!0), H(B, null, R(a.value.tooltipItems, (e, t) => (V(), H("li", { key: t }, N(e.value), 1))), 128))], 2))], 64)) : a.value.tooltipHtml ? (V(), H("div", {
									key: 2,
									class: M(["tooltip-markdown", a.value.interviewerName ? "mt-1 text-background/60" : ""]),
									innerHTML: a.value.tooltipHtml
								}, null, 10, jP)) : q("", !0)]),
								_: 1
							})]),
							_: 1
						})) : (V(), H("span", MP, N(a.value.text), 1)),
						s.value ? (V(), U(F(Jx), {
							key: 2,
							variant: "link",
							size: "sm",
							class: "ml-auto shrink-0 h-6 p-0 gap-1 text-muted-foreground",
							onClick: t[0] ||= (e) => n.value = !n.value
						}, {
							default: I(() => [
								n.value ? q("", !0) : (V(), U(F(jf), {
									key: 0,
									class: "size-4 text-destructive-strong"
								})),
								K(" " + N(n.value ? "Less" : `+${i.value - 1} more`) + " ", 1),
								G(F(Yd), { class: M(["size-3.5 transition-transform", n.value ? "rotate-180" : ""]) }, null, 8, ["class"])
							]),
							_: 1
						})) : q("", !0)
					]), n.value ? (V(!0), H(B, { key: 0 }, R(o.value, (e, t) => (V(), H("div", {
						key: t,
						class: "flex items-center gap-2"
					}, [G(F(jf), { class: M(["size-4 shrink-0", c(e)]) }, null, 8, ["class"]), e.hasTooltip ? (V(), U(F(uS), { key: 0 }, {
						default: I(() => [G(F(pS), { "as-child": "" }, {
							default: I(() => [W("span", NP, N(e.text), 1)]),
							_: 2
						}, 1024), G(F(dS), {
							side: "top",
							class: "max-w-sm"
						}, {
							default: I(() => [e.interviewerName ? (V(), H("div", PP, N(e.interviewerName), 1)) : q("", !0), e.tooltipItems ? (V(), H(B, { key: 1 }, [e.tooltipItems.length === 1 ? (V(), H("span", {
								key: 0,
								class: M(e.interviewerName ? "text-background/60" : "")
							}, N(e.tooltipItems[0].value), 3)) : (V(), H("ul", {
								key: 1,
								class: M(["list-disc pl-4 space-y-0.5", [e.interviewerName ? "mt-1 text-background/60" : ""]])
							}, [(V(!0), H(B, null, R(e.tooltipItems, (e, t) => (V(), H("li", { key: t }, N(e.value), 1))), 128))], 2))], 64)) : e.tooltipHtml ? (V(), H("div", {
								key: 2,
								class: M(["tooltip-markdown", e.interviewerName ? "mt-1 text-background/60" : ""]),
								innerHTML: e.tooltipHtml
							}, null, 10, FP)) : q("", !0)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : (V(), H("span", IP, N(e.text), 1))]))), 128)) : q("", !0)])]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		})) : q("", !0);
	}
}, RP = {
	COMPLETED: "completed",
	DRAFT: "draft",
	PENDING: "pending",
	SUBMITTED: "submitted"
}, zP = {
	CURRENT_USER: "current-user",
	CONSENSUS: "consensus"
};
//#endregion
//#region src/composables/useConsensusData.js
function BP(e, t, n, r = null) {
	let i = J(() => {
		if (!r?.ratingsMatrix) return !1;
		let e = Sn(r.ratingsMatrix);
		return e != null && e.competencies?.length > 0;
	}), a = J(() => i.value ? VP(Sn(r.ratingsMatrix)) : HP(t.value, e.value)), o = J(() => {
		let e = Object.values(a.value).filter((e) => e != null && !isNaN(Number(e)));
		return e.length === 0 ? null : e.reduce((e, t) => e + Number(t), 0) / e.length;
	}), s = J(() => {
		let e = r?.ratingsMatrix ? Sn(r.ratingsMatrix) : null;
		return e?.interviewers?.length ? e.interviewers : t.value.map((e) => ({
			id: e.id,
			name: e.name,
			recommendation: e.recommendation,
			recommendation_display: null,
			feedback: e.feedback || "",
			status: e.status
		}));
	});
	return {
		consensusAverageRatings: a,
		consensusAverageRating: o,
		allRecommendations: J(() => i.value ? (Sn(r.ratingsMatrix)?.interviewers || []).filter((e) => e.recommendation || e.feedback).map((e) => ({
			name: e.name,
			recommendation: e.recommendation,
			label: e.recommendation_display || VM(e.recommendation),
			feedback: e.feedback || ""
		})) : t.value.filter((e) => e.recommendation || e.feedback).map((t) => ({
			name: t.name,
			recommendation: t.recommendation,
			label: e.value.hiringRecommendationOptions?.find((e) => e.value === t.recommendation)?.label || t.recommendation,
			feedback: t.feedback || ""
		}))),
		consensusRecommendation: J(() => UM(s.value)),
		recommendationCounts: J(() => HM(s.value)),
		combinedSummaryEntries: J(() => s.value.filter((e) => e.feedback && e.feedback.trim()).map((e) => ({
			name: e.name,
			feedback: e.feedback.trim()
		}))),
		llmConsensusSummary: J(() => r?.consolidatedScorecard && Sn(r.consolidatedScorecard)?.consensus_summary || null),
		consolidatedStrengths: J(() => {
			if (!r?.consolidatedScorecard) return [];
			let e = Sn(r.consolidatedScorecard);
			return Array.isArray(e?.strengths) ? e.strengths : [];
		}),
		consolidatedConcerns: J(() => {
			if (!r?.consolidatedScorecard) return [];
			let e = Sn(r.consolidatedScorecard);
			return Array.isArray(e?.concerns) ? e.concerns : [];
		}),
		consensusStatus: J(() => {
			if (r?.completionStatus) {
				let e = Sn(r.completionStatus);
				if (e) {
					let t = e.submitted, n = e.total_expected;
					return t === n ? {
						label: "Completed",
						variant: "success",
						percentage: 100
					} : {
						label: `${t}/${n} Completed`,
						variant: "default",
						percentage: e.completion_percentage
					};
				}
			}
			let e = n.value.filter((e) => e.id !== zP.CONSENSUS), t = e.filter((e) => e.status === RP.SUBMITTED).length, i = e.length;
			if (t === i && i > 0) return {
				label: "Completed",
				variant: "success",
				percentage: 100
			};
			let a = i > 0 ? t / i * 100 : 0;
			return {
				label: `${t}/${i} Completed`,
				variant: "default",
				percentage: a
			};
		}),
		consensusInterviewers: s,
		useBatchMode: i
	};
}
function VP(e) {
	if (!e?.competencies) return {};
	let t = {};
	return e.competencies.forEach((e) => {
		e.consensus_rating != null && (t[e.id] = e.consensus_rating);
	}), t;
}
function HP(e, t) {
	if (!e || e.length === 0 || !t) return {};
	let n = {};
	return [
		...(t.observedCompetencies || []).map((e) => e.id),
		...(t.competencies || []).map((e) => e.id),
		...(t.brandFitCompetencies || []).map((e) => e.id)
	].forEach((t) => {
		let r = e.filter((e) => e.ratings && e.ratings[t] !== void 0).map((e) => e.ratings[t]);
		r.length > 0 && (n[t] = r.reduce((e, t) => e + t, 0) / r.length);
	}), n;
}
//#endregion
//#region src/utils/scorecard/scorecardTransformers.js
function UP(e) {
	if (!e?.interviewers || !e?.competencies) return [];
	let t = /* @__PURE__ */ new Map();
	for (let n of e.competencies) if (n.ratings) for (let e of n.ratings) {
		if (e?.rating == null) continue;
		t.has(e.interviewer_id) || t.set(e.interviewer_id, {
			ratings: {},
			competencyFeedback: {}
		});
		let r = t.get(e.interviewer_id);
		r.ratings[n.id] = e.rating, e.notes && (r.competencyFeedback[n.id] = e.notes);
	}
	return e.interviewers.map((e) => {
		let n = t.get(e.id), r = n !== void 0;
		return {
			id: e.id,
			name: e.name,
			status: (typeof e.status == "string" ? e.status.toLowerCase() : null) || "pending",
			ratings: r ? n.ratings : null,
			competencyFeedback: r ? n.competencyFeedback : {},
			recommendation: e.recommendation || null,
			feedback: e.feedback || "",
			is_current_user: e.is_current_user || !1
		};
	});
}
//#endregion
//#region src/components/interview/report/renderers/ConsensusRenderer.vue
var WP = { class: "flex flex-col gap-8" }, GP = { class: "flex flex-col gap-4 px-8 min-w-0 agent-strip" }, KP = {
	key: 0,
	class: "grid gap-x-8 gap-y-6 md:grid-cols-2"
}, qP = { class: "grid gap-x-4 gap-y-4 md:grid-cols-2 text-sm" }, JP = { class: "flex flex-col gap-3" }, YP = {
	key: 0,
	class: "space-y-1"
}, XP = {
	key: 1,
	class: "text-muted-foreground"
}, ZP = { class: "flex flex-col gap-3" }, QP = {
	key: 0,
	class: "space-y-1"
}, $P = {
	key: 1,
	class: "text-muted-foreground"
}, eF = { class: "flex flex-col gap-4 px-8" }, tF = { class: "agent-consensus" }, nF = {
	score: NT,
	rating: fE,
	table: bE,
	screening_question: OE,
	text: jE,
	bullet: IE,
	alerts: XD,
	candidate_questions: cO,
	question_section: CO,
	hiring_recommendations: DO,
	kpi_strip: fk,
	scorecard: wA,
	additional_questions: IA,
	candidate_questions_panel: GA,
	interview_guide: qj,
	fraud_analysis: LM,
	consensus: {
		__name: "ConsensusRenderer",
		props: { component: {
			type: Object,
			required: !0
		} },
		setup(e) {
			let t = e, n = J(() => t.component?.ratings_matrix || null), r = J(() => t.component?.consolidated || null), i = J(() => t.component?.scale_length ?? 5), a = J(() => t.component?.duration_minutes ?? null), o = J(() => t.component?.alerts || []), s = J(() => n.value?.competencies || []), c = J(() => s.value.filter((e) => e.is_observable)), l = J(() => s.value.filter((e) => e.is_brand_fit)), u = J(() => s.value.filter((e) => !e.is_observable && !e.is_brand_fit)), d = J(() => UP(n.value)), f = J(() => d.value.filter((e) => e.id !== zP.CONSENSUS && e.status === RP.SUBMITTED)), { consensusAverageRatings: p, consensusAverageRating: m, allRecommendations: h, consensusRecommendation: g, consolidatedStrengths: _, consolidatedConcerns: v } = BP(J(() => ({
				observedCompetencies: c.value,
				competencies: u.value,
				brandFitCompetencies: l.value,
				scorecardSettings: { scaleLength: i.value }
			})), f, d, {
				ratingsMatrix: n,
				completionStatus: J(() => null),
				consolidatedScorecard: r
			}), y = J(() => n.value?.interviewers || []), b = J(() => y.value[0]?.interview_id || "consensus"), x = J(() => {
				let e = n.value;
				return e?.interviewers?.length ? e.interviewers.filter((e) => e.recommendation || e.feedback).map((t) => {
					let n = [];
					e.competencies?.forEach((e) => {
						let r = e.ratings?.find((e) => e.interviewer_id === t.id);
						r?.rating != null && n.push(r.rating);
					});
					let r = n.length ? n.reduce((e, t) => e + t, 0) / n.length : null;
					return {
						id: t.id,
						name: t.name,
						isCurrentUser: !!t.is_current_user,
						recommendation: t.recommendation || null,
						recommendationLabel: t.recommendation_display || VM(t.recommendation),
						feedback: t.feedback || "",
						rating: r
					};
				}) : [];
			});
			return (e, t) => (V(), H("div", WP, [
				W("div", GP, [G(dN, {
					"mock-seed": b.value,
					recommendation: F(g),
					"all-recommendations": F(h),
					"average-rating": F(m),
					"scale-length": i.value,
					"duration-minutes": a.value,
					"interviewer-count": y.value.length
				}, ba({
					reviews: I(() => [x.value.length ? (V(), H("div", KP, [(V(!0), H(B, null, R(x.value, (e) => (V(), U(EP, {
						key: e.id,
						name: e.name,
						recommendation: e.recommendation,
						"recommendation-label": e.recommendationLabel,
						feedback: e.feedback,
						rating: e.rating,
						"scale-length": i.value,
						"is-current-user": e.isCurrentUser
					}, null, 8, [
						"name",
						"recommendation",
						"recommendation-label",
						"feedback",
						"rating",
						"scale-length",
						"is-current-user"
					]))), 128))])) : q("", !0)]),
					_: 2
				}, [F(_).length || F(v).length ? {
					name: "expanded",
					fn: I(() => [W("div", qP, [W("div", JP, [
						t[0] ||= W("h3", { class: "text-base font-semibold font-title text-foreground" }, "Strengths", -1),
						G(F(tS)),
						F(_).length ? (V(), H("ul", YP, [(V(!0), H(B, null, R(F(_), (e, t) => (V(), H("li", {
							key: `s-${t}`,
							class: "flex items-start gap-2 text-foreground"
						}, [G(F(Jd), { class: "size-4 shrink-0 mt-0.5 text-foreground" }), W("span", null, N(e), 1)]))), 128))])) : (V(), H("p", XP, "--"))
					]), W("div", ZP, [
						t[1] ||= W("h3", { class: "text-base font-semibold font-title text-foreground" }, "Considerations", -1),
						G(F(tS)),
						F(v).length ? (V(), H("ul", QP, [(V(!0), H(B, null, R(F(v), (e, t) => (V(), H("li", {
							key: `c-${t}`,
							class: "flex items-start gap-2 text-foreground"
						}, [G(F(Ff), { class: "size-4 shrink-0 mt-0.5 text-foreground" }), W("span", null, N(e), 1)]))), 128))])) : (V(), H("p", $P, "--"))
					])])]),
					key: "0"
				} : void 0]), 1032, [
					"mock-seed",
					"recommendation",
					"all-recommendations",
					"average-rating",
					"scale-length",
					"duration-minutes",
					"interviewer-count"
				]), o.value.length ? (V(), U(LP, {
					key: 0,
					alerts: o.value
				}, null, 8, ["alerts"])) : q("", !0)]),
				G(F(tS), { variant: "pattern" }),
				W("div", eF, [W("div", tF, [G(_P, {
					"observable-competencies": c.value,
					"main-competencies": u.value,
					"brand-fit-competencies": l.value,
					"submitted-scorecards": d.value.filter((e) => e.id !== F(zP).CONSENSUS),
					"consensus-average-ratings": F(p),
					"ratings-matrix": n.value,
					"table-variant": "borderless-transparent",
					"show-toolbar": "",
					"show-bars-toggle": ""
				}, {
					header: I(() => [...t[2] ||= [W("h3", { class: "text-2xl font-title text-foreground" }, "Consensus Rating", -1)]]),
					_: 1
				}, 8, [
					"observable-competencies",
					"main-competencies",
					"brand-fit-competencies",
					"submitted-scorecards",
					"consensus-average-ratings",
					"ratings-matrix"
				])])])
			]));
		}
	}
};
function rF(e) {
	return nF[e] || null;
}
//#endregion
//#region src/components/interview/report/ReportSectionContent.vue
var iF = {
	key: 1,
	class: "flex gap-4 w-full"
}, aF = {
	key: 2,
	class: "flex gap-4"
}, oF = {
	key: 1,
	class: "text-sm text-body italic"
}, sF = {
	key: 1,
	class: "text-sm text-body italic"
}, cF = {
	key: 4,
	class: "space-y-4"
}, lF = {
	__name: "ReportSectionContent",
	props: {
		section: {
			type: Object,
			required: !0
		},
		visibleSubSections: {
			type: Array,
			default: () => []
		},
		showSectionHeader: {
			type: Boolean,
			default: !0
		},
		headerBordered: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t;
		function i(e) {
			return rF(e);
		}
		let a = J(() => {
			let e = n.section.components || [];
			return e.length === 2 && e.every((e) => e.component_type === "bullet");
		}), o = J(() => a.value ? n.section.components.map((e) => e.bullets || []) : []), s = J(() => {
			if (n.section.title) return n.section.title;
			let e = n.section.components || [];
			if (a.value) return "";
			let t = e[0];
			if (t?.component_type === "table" && t.headers?.length > 1) return "";
			if (t?.title) return t.title;
			if (t?.component_type === "table" && t.headers?.length === 1) {
				let e = t.headers[0];
				return typeof e == "object" ? e.title : e;
			}
			return "";
		}), c = J(() => {
			if (n.section.codename === "alerts") return "";
			if (n.section.icon) return n.section.icon;
			let e = n.section.components?.[0];
			return e?.icon ? e.icon : "💬";
		}), l = J(() => {
			let e = n.section.components || [];
			if (n.section.headers?.length > 1) return n.section.headers;
			if (a.value) return e.map((e) => ({
				title: e.title || "",
				icon: e.icon || ""
			}));
			let t = e[0];
			return t?.component_type === "table" && t.headers?.length > 1 ? t.headers.map((e, n) => ({
				title: typeof e == "object" ? e.title : e,
				icon: typeof e == "object" && e.icon ? e.icon : n === 0 && t.icon ? t.icon : "💬"
			})) : [];
		});
		function u(e) {
			return e === 2;
		}
		function d(e) {
			return e === 1 ? "grid-cols-1" : e === 3 ? "grid-cols-3" : "grid-cols-4";
		}
		return (t, n) => (V(), H(B, null, [
			(s.value || l.value.length) && e.showSectionHeader ? (V(), U(lS, {
				key: 0,
				title: s.value,
				icon: c.value,
				columns: l.value,
				bordered: e.headerBordered
			}, null, 8, [
				"title",
				"icon",
				"columns",
				"bordered"
			])) : q("", !0),
			a.value ? (V(), H("div", iF, [(V(!0), H(B, null, R(o.value, (e, t) => (V(), H("ul", {
				key: t,
				class: "flex-1 min-w-0 space-y-2"
			}, [(V(!0), H(B, null, R(e, (e, t) => (V(), H("li", {
				key: t,
				class: "flex items-start gap-2 text-foreground"
			}, [n[2] ||= W("span", { class: "size-5 shrink-0 flex items-center justify-center mt-0.5" }, [W("span", { class: "w-1.5 h-1.5 rounded-full bg-current" })], -1), W("span", null, N(e), 1)]))), 128))]))), 128))])) : e.section.components?.length && u(e.section.components.length) ? (V(), H("div", aF, [(V(!0), H(B, null, R(e.section.components, (t, a) => (V(), H("div", {
				key: a,
				class: "flex-1 min-w-0"
			}, [i(t.component_type) ? (V(), U(ga(i(t.component_type)), {
				key: 0,
				component: {
					...t,
					title: t.title || e.section.title,
					icon: t.icon || e.section.icon
				},
				onJump: n[0] ||= (e) => r("jump", e)
			}, null, 40, ["component"])) : (V(), H("div", oF, " Unknown component: " + N(t.component_type), 1))]))), 128))])) : e.section.components?.length ? (V(), H("div", {
				key: 3,
				class: M(["grid gap-4", d(e.section.components.length)])
			}, [(V(!0), H(B, null, R(e.section.components, (t, a) => (V(), H("div", { key: a }, [i(t.component_type) ? (V(), U(ga(i(t.component_type)), {
				key: 0,
				component: {
					...t,
					title: t.title || e.section.title,
					icon: t.icon || e.section.icon
				},
				onJump: n[1] ||= (e) => r("jump", e)
			}, null, 40, ["component"])) : (V(), H("div", sF, " Unknown component: " + N(t.component_type), 1))]))), 128))], 2)) : q("", !0),
			e.visibleSubSections.length ? (V(), H("div", cF, [z(t.$slots, "sub-sections")])) : q("", !0)
		], 64));
	}
}, uF = {
	__name: "ReportSection",
	props: {
		section: {
			type: Object,
			required: !0
		},
		isChild: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.section.codename === "divider"), a = J(() => i.value && n.section.params?.hide), o = J(() => !!n.section.params?.plain), s = J(() => o.value ? "" : "px-4"), c = J(() => {
			let e = (n.section.sub_sections || []).filter((e) => e.shouldHide ? !1 : e.codename !== "alerts" || (e.components?.find((e) => e.component_type === "alerts"))?.alerts?.length > 0), t = [
				"summary",
				"interview_summary",
				"ai_summary"
			];
			return e.sort((e, n) => !t.includes(e.codename) - +!t.includes(n.codename));
		}), l = [
			"alerts",
			"summary",
			"interview_summary",
			"ai_summary",
			"divider"
		], u = J(() => {
			let e = n.section.components || [];
			return e.length > 0 && e.every((e) => e.component_type === "score");
		}), d = J(() => {
			let e = n.section.components || [];
			return e.length === 2 && e.every((e) => e.component_type === "bullet");
		}), f = J(() => o.value || u.value || d.value ? !1 : !l.includes(n.section.codename) || n.section.show_border || n.section.params?.["background-color"] || [
			"alerts",
			"summary",
			"interview_summary"
		].includes(n.section.codename)), p = J(() => {
			let e = n.section.params?.["background-color"], t = n.section.codename, r = {
				alerts: "destructive",
				summary: "muted",
				interview_summary: "muted",
				ai_summary: "muted"
			}, i = {
				green: "success",
				red: "destructive",
				yellow: "warning",
				blue: "info",
				gray: "muted",
				grey: "muted"
			};
			if (e && i[e]) return i[e];
			if (t && r[t]) return r[t];
			let a = (n.section.sub_sections || []).map((e) => e.codename);
			return a.includes("alerts") || a.includes("interview_summary") || a.includes("summary") ? "elevated" : "default";
		}), m = J(() => !["default", "elevated"].includes(p.value)), h = J(() => m.value ? !1 : !l.includes(n.section.codename) || n.section.show_border), g = J(() => ""), _ = [
			"screening_question",
			"table",
			"alerts"
		], v = J(() => !m.value), y = J(() => o.value ? !1 : !l.includes(n.section.codename) || !n.section.components?.length || !n.section.components.every((e) => _.includes(e.component_type)));
		return (t, n) => {
			let o = ma("ReportSection", !0);
			return i.value ? (V(), U(F(tS), {
				key: 0,
				variant: e.section.params?.variant,
				class: M([{ invisible: a.value }, e.section.params?.variant === "pattern" ? "" : "my-4"])
			}, null, 8, ["variant", "class"])) : f.value ? (V(), U(F(_m), {
				key: 1,
				variant: p.value,
				bordered: h.value,
				class: "text-base"
			}, {
				default: I(() => [G(F(vm), { class: M(g.value) }, {
					default: I(() => [G(lF, {
						section: e.section,
						"visible-sub-sections": c.value,
						"show-section-header": y.value,
						"header-bordered": v.value,
						onJump: n[1] ||= (e) => r("jump", e)
					}, {
						"sub-sections": I(() => [(V(!0), H(B, null, R(c.value, (e, t) => (V(), U(o, {
							key: `sub-${t}`,
							section: e,
							"is-child": !0,
							onJump: n[0] ||= (e) => r("jump", e)
						}, null, 8, ["section"]))), 128))]),
						_: 1
					}, 8, [
						"section",
						"visible-sub-sections",
						"show-section-header",
						"header-bordered"
					])]),
					_: 1
				}, 8, ["class"])]),
				_: 1
			}, 8, ["variant", "bordered"])) : u.value ? (V(), U(F(_m), {
				key: 2,
				variant: "ghost",
				class: "text-base"
			}, {
				default: I(() => [G(F(vm), null, {
					default: I(() => [G(lF, {
						section: e.section,
						"visible-sub-sections": c.value,
						"show-section-header": y.value,
						"header-bordered": v.value,
						onJump: n[3] ||= (e) => r("jump", e)
					}, {
						"sub-sections": I(() => [(V(!0), H(B, null, R(c.value, (e, t) => (V(), U(o, {
							key: `sub-${t}`,
							section: e,
							"is-child": !0,
							onJump: n[2] ||= (e) => r("jump", e)
						}, null, 8, ["section"]))), 128))]),
						_: 1
					}, 8, [
						"section",
						"visible-sub-sections",
						"show-section-header",
						"header-bordered"
					])]),
					_: 1
				})]),
				_: 1
			})) : (V(), H("div", {
				key: 3,
				class: M(["text-base", s.value])
			}, [G(lF, {
				section: e.section,
				"visible-sub-sections": c.value,
				"show-section-header": y.value,
				"header-bordered": v.value,
				onJump: n[5] ||= (e) => r("jump", e)
			}, {
				"sub-sections": I(() => [(V(!0), H(B, null, R(c.value, (e, t) => (V(), U(o, {
					key: `sub-${t}`,
					section: e,
					"is-child": !0,
					onJump: n[4] ||= (e) => r("jump", e)
				}, null, 8, ["section"]))), 128))]),
				_: 1
			}, 8, [
				"section",
				"visible-sub-sections",
				"show-section-header",
				"header-bordered"
			])], 2));
		};
	}
}, dF = /* @__PURE__ */ s(((e, t) => {
	t.exports = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
})), fF = /* @__PURE__ */ s(((e, t) => {
	t.exports = {};
})), pF = /* @__PURE__ */ s(((e, t) => {
	var n = typeof global < "u" ? global : typeof window < "u" ? window : {}, r = fF(), i;
	typeof document < "u" ? i = document : (i = n["__GLOBAL_DOCUMENT_CACHE@4"], i ||= n["__GLOBAL_DOCUMENT_CACHE@4"] = r), t.exports = i;
})), mF = /* @__PURE__ */ s(((e, t) => {
	function n() {
		return t.exports = n = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, t.exports.__esModule = !0, t.exports.default = t.exports, n.apply(null, arguments);
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), hF = /* @__PURE__ */ s(((e, t) => {
	t.exports = r;
	var n = Object.prototype.toString;
	function r(e) {
		if (!e) return !1;
		var t = n.call(e);
		return t === "[object Function]" || typeof e == "function" && t !== "[object RegExp]" || typeof window < "u" && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt);
	}
})), gF = /* @__PURE__ */ s(((e, t) => {
	function n(e, t) {
		var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (n) return (n = n.call(e)).next.bind(n);
		if (Array.isArray(e) || (n = r(e)) || t && e && typeof e.length == "number") {
			n && (e = n);
			var i = 0;
			return function() {
				return i >= e.length ? { done: !0 } : {
					done: !1,
					value: e[i++]
				};
			};
		}
		throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function r(e, t) {
		if (e) {
			if (typeof e == "string") return i(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
		}
	}
	function i(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	t.exports = /* @__PURE__ */ function() {
		function e() {
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
		}
		var t = e.prototype;
		return t.getIsEnabled = function() {
			return this.enabled_;
		}, t.enable = function() {
			this.enabled_ = !0;
		}, t.disable = function() {
			this.enabled_ = !1;
		}, t.reset = function() {
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
		}, t.addInterceptor = function(e, t) {
			this.typeToInterceptorsMap_.has(e) || this.typeToInterceptorsMap_.set(e, /* @__PURE__ */ new Set());
			var n = this.typeToInterceptorsMap_.get(e);
			return !n.has(t) && (n.add(t), !0);
		}, t.removeInterceptor = function(e, t) {
			var n = this.typeToInterceptorsMap_.get(e);
			return n && n.has(t) ? (n.delete(t), !0) : !1;
		}, t.clearInterceptorsByType = function(e) {
			return this.typeToInterceptorsMap_.get(e) ? (this.typeToInterceptorsMap_.delete(e), this.typeToInterceptorsMap_.set(e, /* @__PURE__ */ new Set()), !0) : !1;
		}, t.clear = function() {
			return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
		}, t.getForType = function(e) {
			return this.typeToInterceptorsMap_.get(e) || /* @__PURE__ */ new Set();
		}, t.execute = function(e, t) {
			for (var r = n(this.getForType(e)), i; !(i = r()).done;) {
				var a = i.value;
				try {
					t = a(t);
				} catch {}
			}
			return t;
		}, e;
	}();
})), _F = /* @__PURE__ */ s(((e, t) => {
	var n = /*#__PURE__*/ function() {
		function e() {
			this.maxAttempts_ = 1, this.delayFactor_ = .1, this.fuzzFactor_ = .1, this.initialDelay_ = 1e3, this.enabled_ = !1;
		}
		var t = e.prototype;
		return t.getIsEnabled = function() {
			return this.enabled_;
		}, t.enable = function() {
			this.enabled_ = !0;
		}, t.disable = function() {
			this.enabled_ = !1;
		}, t.reset = function() {
			this.maxAttempts_ = 1, this.delayFactor_ = .1, this.fuzzFactor_ = .1, this.initialDelay_ = 1e3, this.enabled_ = !1;
		}, t.getMaxAttempts = function() {
			return this.maxAttempts_;
		}, t.setMaxAttempts = function(e) {
			this.maxAttempts_ = e;
		}, t.getDelayFactor = function() {
			return this.delayFactor_;
		}, t.setDelayFactor = function(e) {
			this.delayFactor_ = e;
		}, t.getFuzzFactor = function() {
			return this.fuzzFactor_;
		}, t.setFuzzFactor = function(e) {
			this.fuzzFactor_ = e;
		}, t.getInitialDelay = function() {
			return this.initialDelay_;
		}, t.setInitialDelay = function(e) {
			this.initialDelay_ = e;
		}, t.createRetry = function(e) {
			var t = e === void 0 ? {} : e, n = t.maxAttempts, i = t.delayFactor, a = t.fuzzFactor, o = t.initialDelay;
			return new r({
				maxAttempts: n || this.maxAttempts_,
				delayFactor: i || this.delayFactor_,
				fuzzFactor: a || this.fuzzFactor_,
				initialDelay: o || this.initialDelay_
			});
		}, e;
	}(), r = /*#__PURE__*/ function() {
		function e(e) {
			this.maxAttempts_ = e.maxAttempts, this.delayFactor_ = e.delayFactor, this.fuzzFactor_ = e.fuzzFactor, this.currentDelay_ = e.initialDelay, this.currentAttempt_ = 1;
		}
		var t = e.prototype;
		return t.moveToNextAttempt = function() {
			this.currentAttempt_++;
			var e = this.currentDelay_ * this.delayFactor_;
			this.currentDelay_ += e;
		}, t.shouldRetry = function() {
			return this.currentAttempt_ < this.maxAttempts_;
		}, t.getCurrentDelay = function() {
			return this.currentDelay_;
		}, t.getCurrentMinPossibleDelay = function() {
			return (1 - this.fuzzFactor_) * this.currentDelay_;
		}, t.getCurrentMaxPossibleDelay = function() {
			return (1 + this.fuzzFactor_) * this.currentDelay_;
		}, t.getCurrentFuzzedDelay = function() {
			var e = this.getCurrentMinPossibleDelay(), t = this.getCurrentMaxPossibleDelay();
			return e + Math.random() * (t - e);
		}, e;
	}();
	t.exports = n;
})), vF = /* @__PURE__ */ s(((e, t) => {
	var n = dF(), r = function(e, t) {
		return t === void 0 && (t = !1), function(r, a, o) {
			if (r) {
				e(r);
				return;
			}
			if (a.statusCode >= 400 && a.statusCode <= 599) {
				var s = o;
				if (t) if (n.TextDecoder) {
					var c = i(a.headers && a.headers["content-type"]);
					try {
						s = new TextDecoder(c).decode(o);
					} catch {}
				} else s = String.fromCharCode.apply(null, new Uint8Array(o));
				e({ cause: s });
				return;
			}
			e(null, o);
		};
	};
	function i(e) {
		return e === void 0 && (e = ""), e.toLowerCase().split(";").reduce(function(e, t) {
			var n = t.split("="), r = n[0], i = n[1];
			return r.trim() === "charset" ? i.trim() : e;
		}, "utf-8");
	}
	t.exports = r;
})), yF = /* @__PURE__ */ s(((e, t) => {
	var n = dF(), r = mF(), i = hF(), a = gF(), o = _F();
	d.httpHandler = vF(), d.requestInterceptorsStorage = new a(), d.responseInterceptorsStorage = new a(), d.retryManager = new o();
	var s = function(e) {
		var t = {};
		return e && e.trim().split("\n").forEach(function(e) {
			var n = e.indexOf(":"), r = e.slice(0, n).trim().toLowerCase(), i = e.slice(n + 1).trim();
			t[r] === void 0 ? t[r] = i : Array.isArray(t[r]) ? t[r].push(i) : t[r] = [t[r], i];
		}), t;
	};
	t.exports = d, t.exports.default = d, d.XMLHttpRequest = n.XMLHttpRequest || m, d.XDomainRequest = "withCredentials" in new d.XMLHttpRequest() ? d.XMLHttpRequest : n.XDomainRequest, c([
		"get",
		"put",
		"post",
		"patch",
		"head",
		"delete"
	], function(e) {
		d[e === "delete" ? "del" : e] = function(t, n, r) {
			return n = u(t, n, r), n.method = e.toUpperCase(), f(n);
		};
	});
	function c(e, t) {
		for (var n = 0; n < e.length; n++) t(e[n]);
	}
	function l(e) {
		for (var t in e) if (e.hasOwnProperty(t)) return !1;
		return !0;
	}
	function u(e, t, n) {
		var a = e;
		return i(t) ? (n = t, typeof e == "string" && (a = { uri: e })) : a = r({}, t, { uri: e }), a.callback = n, a;
	}
	function d(e, t, n) {
		return t = u(e, t, n), f(t);
	}
	function f(e) {
		if (e.callback === void 0) throw Error("callback argument missing");
		if (e.requestType && d.requestInterceptorsStorage.getIsEnabled()) {
			var t = {
				uri: e.uri || e.url,
				headers: e.headers || {},
				body: e.body,
				metadata: e.metadata || {},
				retry: e.retry,
				timeout: e.timeout
			}, n = d.requestInterceptorsStorage.execute(e.requestType, t);
			e.uri = n.uri, e.headers = n.headers, e.body = n.body, e.metadata = n.metadata, e.retry = n.retry, e.timeout = n.timeout;
		}
		var r = !1, i = function(t, n, i) {
			r || (r = !0, e.callback(t, n, i));
		};
		function a() {
			m.readyState === 4 && !d.responseInterceptorsStorage.getIsEnabled() && setTimeout(u, 0);
		}
		function o() {
			var e = void 0;
			if (e = m.response ? m.response : m.responseText || p(m), S) try {
				e = JSON.parse(e);
			} catch {}
			return e;
		}
		function c(t) {
			if (clearTimeout(C), clearTimeout(e.retryTimeout), t instanceof Error || (t = /* @__PURE__ */ Error("" + (t || "Unknown XMLHttpRequest Error"))), t.statusCode = 0, !g && d.retryManager.getIsEnabled() && e.retry && e.retry.shouldRetry()) {
				e.retryTimeout = setTimeout(function() {
					e.retry.moveToNextAttempt(), e.xhr = m, f(e);
				}, e.retry.getCurrentFuzzedDelay());
				return;
			}
			if (e.requestType && d.responseInterceptorsStorage.getIsEnabled()) {
				var n = {
					headers: w.headers || {},
					body: w.body,
					responseUrl: m.responseURL,
					responseType: m.responseType
				}, r = d.responseInterceptorsStorage.execute(e.requestType, n);
				w.body = r.body, w.headers = r.headers;
			}
			return i(t, w);
		}
		function u() {
			if (!g) {
				var t;
				clearTimeout(C), clearTimeout(e.retryTimeout), t = e.useXDR && m.status === void 0 ? 200 : m.status === 1223 ? 204 : m.status;
				var n = w, r = null;
				if (t === 0 ? r = /* @__PURE__ */ Error("Internal XMLHttpRequest Error") : (n = {
					body: o(),
					statusCode: t,
					method: v,
					headers: {},
					url: _,
					rawRequest: m
				}, m.getAllResponseHeaders && (n.headers = s(m.getAllResponseHeaders()))), e.requestType && d.responseInterceptorsStorage.getIsEnabled()) {
					var a = {
						headers: n.headers || {},
						body: n.body,
						responseUrl: m.responseURL,
						responseType: m.responseType
					}, c = d.responseInterceptorsStorage.execute(e.requestType, a);
					n.body = c.body, n.headers = c.headers;
				}
				return i(r, n, n.body);
			}
		}
		var m = e.xhr || null;
		m ||= e.cors || e.useXDR ? new d.XDomainRequest() : new d.XMLHttpRequest();
		var h, g, _ = m.url = e.uri || e.url, v = m.method = e.method || "GET", y = e.body || e.data, b = m.headers = e.headers || {}, x = !!e.sync, S = !1, C, w = {
			body: void 0,
			headers: {},
			statusCode: 0,
			method: v,
			url: _,
			rawRequest: m
		};
		if ("json" in e && e.json !== !1 && (S = !0, b.accept || b.Accept || (b.Accept = "application/json"), v !== "GET" && v !== "HEAD" && (b["content-type"] || b["Content-Type"] || (b["Content-Type"] = "application/json"), y = JSON.stringify(e.json === !0 ? y : e.json))), m.onreadystatechange = a, m.onload = u, m.onerror = c, m.onprogress = function() {}, m.onabort = function() {
			g = !0, clearTimeout(e.retryTimeout);
		}, m.ontimeout = c, m.open(v, _, !x, e.username, e.password), x || (m.withCredentials = !!e.withCredentials), !x && e.timeout > 0 && (C = setTimeout(function() {
			if (!g) {
				g = !0, m.abort("timeout");
				var e = /* @__PURE__ */ Error("XMLHttpRequest timeout");
				e.code = "ETIMEDOUT", c(e);
			}
		}, e.timeout)), m.setRequestHeader) for (h in b) b.hasOwnProperty(h) && m.setRequestHeader(h, b[h]);
		else if (e.headers && !l(e.headers)) throw Error("Headers cannot be set on an XDomainRequest object");
		return "responseType" in e && (m.responseType = e.responseType), "beforeSend" in e && typeof e.beforeSend == "function" && e.beforeSend(m), m.send(y || null), m;
	}
	function p(e) {
		try {
			if (e.responseType === "document") return e.responseXML;
			var t = e.responseXML && e.responseXML.documentElement.nodeName === "parsererror";
			if (e.responseType === "" && !t) return e.responseXML;
		} catch {}
		return null;
	}
	function m() {}
})), bF = /* @__PURE__ */ s(((e, t) => {
	var n = pF(), r = Object.create || (function() {
		function e() {}
		return function(t) {
			if (arguments.length !== 1) throw Error("Object.create shim only accepts one parameter.");
			return e.prototype = t, new e();
		};
	})();
	function i(e, t) {
		this.name = "ParsingError", this.code = e.code, this.message = t || e.message;
	}
	i.prototype = r(Error.prototype), i.prototype.constructor = i, i.Errors = {
		BadSignature: {
			code: 0,
			message: "Malformed WebVTT signature."
		},
		BadTimeStamp: {
			code: 1,
			message: "Malformed time stamp."
		}
	};
	function a(e) {
		function t(e, t, n, r) {
			return (e | 0) * 3600 + (t | 0) * 60 + (n | 0) + (r | 0) / 1e3;
		}
		var n = e.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
		return n ? n[3] ? t(n[1], n[2], n[3].replace(":", ""), n[4]) : n[1] > 59 ? t(n[1], n[2], 0, n[4]) : t(0, n[1], n[2], n[4]) : null;
	}
	function o() {
		this.values = r(null);
	}
	o.prototype = {
		set: function(e, t) {
			!this.get(e) && t !== "" && (this.values[e] = t);
		},
		get: function(e, t, n) {
			return n ? this.has(e) ? this.values[e] : t[n] : this.has(e) ? this.values[e] : t;
		},
		has: function(e) {
			return e in this.values;
		},
		alt: function(e, t, n) {
			for (var r = 0; r < n.length; ++r) if (t === n[r]) {
				this.set(e, t);
				break;
			}
		},
		integer: function(e, t) {
			/^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
		},
		percent: function(e, t) {
			return t.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (t = parseFloat(t), t >= 0 && t <= 100) ? (this.set(e, t), !0) : !1;
		}
	};
	function s(e, t, n, r) {
		var i = r ? e.split(r) : [e];
		for (var a in i) if (typeof i[a] == "string") {
			var o = i[a].split(n);
			o.length === 2 && t(o[0].trim(), o[1].trim());
		}
	}
	function c(e, t, n) {
		var r = e;
		function c() {
			var t = a(e);
			if (t === null) throw new i(i.Errors.BadTimeStamp, "Malformed timestamp: " + r);
			return e = e.replace(/^[^\sa-zA-Z-]+/, ""), t;
		}
		function l(e, t) {
			var r = new o();
			s(e, function(e, t) {
				switch (e) {
					case "region":
						for (var i = n.length - 1; i >= 0; i--) if (n[i].id === t) {
							r.set(e, n[i].region);
							break;
						}
						break;
					case "vertical":
						r.alt(e, t, ["rl", "lr"]);
						break;
					case "line":
						var a = t.split(","), o = a[0];
						r.integer(e, o), r.percent(e, o) && r.set("snapToLines", !1), r.alt(e, o, ["auto"]), a.length === 2 && r.alt("lineAlign", a[1], [
							"start",
							"center",
							"end"
						]);
						break;
					case "position":
						a = t.split(","), r.percent(e, a[0]), a.length === 2 && r.alt("positionAlign", a[1], [
							"start",
							"center",
							"end"
						]);
						break;
					case "size":
						r.percent(e, t);
						break;
					case "align": r.alt(e, t, [
						"start",
						"center",
						"end",
						"left",
						"right"
					]);
				}
			}, /:/, /\s/), t.region = r.get("region", null), t.vertical = r.get("vertical", "");
			try {
				t.line = r.get("line", "auto");
			} catch {}
			t.lineAlign = r.get("lineAlign", "start"), t.snapToLines = r.get("snapToLines", !0), t.size = r.get("size", 100);
			try {
				t.align = r.get("align", "center");
			} catch {
				t.align = r.get("align", "middle");
			}
			try {
				t.position = r.get("position", "auto");
			} catch {
				t.position = r.get("position", {
					start: 0,
					left: 0,
					center: 50,
					middle: 50,
					end: 100,
					right: 100
				}, t.align);
			}
			t.positionAlign = r.get("positionAlign", {
				start: "start",
				left: "start",
				center: "center",
				middle: "center",
				end: "end",
				right: "end"
			}, t.align);
		}
		function u() {
			e = e.replace(/^\s+/, "");
		}
		if (u(), t.startTime = c(), u(), e.substr(0, 3) !== "-->") throw new i(i.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + r);
		e = e.substr(3), u(), t.endTime = c(), u(), l(e, t);
	}
	var l = n.createElement && n.createElement("textarea"), u = {
		c: "span",
		i: "i",
		b: "b",
		u: "u",
		ruby: "ruby",
		rt: "rt",
		v: "span",
		lang: "span"
	}, d = {
		white: "rgba(255,255,255,1)",
		lime: "rgba(0,255,0,1)",
		cyan: "rgba(0,255,255,1)",
		red: "rgba(255,0,0,1)",
		yellow: "rgba(255,255,0,1)",
		magenta: "rgba(255,0,255,1)",
		blue: "rgba(0,0,255,1)",
		black: "rgba(0,0,0,1)"
	}, f = {
		v: "title",
		lang: "lang"
	}, p = { rt: "ruby" };
	function m(e, t) {
		function n() {
			if (!t) return null;
			function e(e) {
				return t = t.substr(e.length), e;
			}
			var n = t.match(/^([^<]*)(<[^>]*>?)?/);
			return e(n[1] ? n[1] : n[2]);
		}
		function r(e) {
			return l.innerHTML = e, e = l.textContent, l.textContent = "", e;
		}
		function i(e, t) {
			return !p[t.localName] || p[t.localName] === e.localName;
		}
		function o(t, n) {
			var r = u[t];
			if (!r) return null;
			var i = e.document.createElement(r), a = f[t];
			return a && n && (i[a] = n.trim()), i;
		}
		for (var s = e.document.createElement("div"), c = s, m, h = []; (m = n()) !== null;) {
			if (m[0] === "<") {
				if (m[1] === "/") {
					h.length && h[h.length - 1] === m.substr(2).replace(">", "") && (h.pop(), c = c.parentNode);
					continue;
				}
				var g = a(m.substr(1, m.length - 2)), _;
				if (g) {
					_ = e.document.createProcessingInstruction("timestamp", g), c.appendChild(_);
					continue;
				}
				var v = m.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
				if (!v || (_ = o(v[1], v[3]), !_) || !i(c, _)) continue;
				if (v[2]) {
					var y = v[2].split(".");
					y.forEach(function(e) {
						var t = /^bg_/.test(e), n = t ? e.slice(3) : e;
						if (d.hasOwnProperty(n)) {
							var r = t ? "background-color" : "color", i = d[n];
							_.style[r] = i;
						}
					}), _.className = y.join(" ");
				}
				h.push(v[1]), c.appendChild(_), c = _;
				continue;
			}
			c.appendChild(e.document.createTextNode(r(m)));
		}
		return s;
	}
	var h = [
		[1470, 1470],
		[1472, 1472],
		[1475, 1475],
		[1478, 1478],
		[1488, 1514],
		[1520, 1524],
		[1544, 1544],
		[1547, 1547],
		[1549, 1549],
		[1563, 1563],
		[1566, 1610],
		[1645, 1647],
		[1649, 1749],
		[1765, 1766],
		[1774, 1775],
		[1786, 1805],
		[1807, 1808],
		[1810, 1839],
		[1869, 1957],
		[1969, 1969],
		[1984, 2026],
		[2036, 2037],
		[2042, 2042],
		[2048, 2069],
		[2074, 2074],
		[2084, 2084],
		[2088, 2088],
		[2096, 2110],
		[2112, 2136],
		[2142, 2142],
		[2208, 2208],
		[2210, 2220],
		[8207, 8207],
		[64285, 64285],
		[64287, 64296],
		[64298, 64310],
		[64312, 64316],
		[64318, 64318],
		[64320, 64321],
		[64323, 64324],
		[64326, 64449],
		[64467, 64829],
		[64848, 64911],
		[64914, 64967],
		[65008, 65020],
		[65136, 65140],
		[65142, 65276],
		[67584, 67589],
		[67592, 67592],
		[67594, 67637],
		[67639, 67640],
		[67644, 67644],
		[67647, 67669],
		[67671, 67679],
		[67840, 67867],
		[67872, 67897],
		[67903, 67903],
		[67968, 68023],
		[68030, 68031],
		[68096, 68096],
		[68112, 68115],
		[68117, 68119],
		[68121, 68147],
		[68160, 68167],
		[68176, 68184],
		[68192, 68223],
		[68352, 68405],
		[68416, 68437],
		[68440, 68466],
		[68472, 68479],
		[68608, 68680],
		[126464, 126467],
		[126469, 126495],
		[126497, 126498],
		[126500, 126500],
		[126503, 126503],
		[126505, 126514],
		[126516, 126519],
		[126521, 126521],
		[126523, 126523],
		[126530, 126530],
		[126535, 126535],
		[126537, 126537],
		[126539, 126539],
		[126541, 126543],
		[126545, 126546],
		[126548, 126548],
		[126551, 126551],
		[126553, 126553],
		[126555, 126555],
		[126557, 126557],
		[126559, 126559],
		[126561, 126562],
		[126564, 126564],
		[126567, 126570],
		[126572, 126578],
		[126580, 126583],
		[126585, 126588],
		[126590, 126590],
		[126592, 126601],
		[126603, 126619],
		[126625, 126627],
		[126629, 126633],
		[126635, 126651],
		[1114109, 1114109]
	];
	function g(e) {
		for (var t = 0; t < h.length; t++) {
			var n = h[t];
			if (e >= n[0] && e <= n[1]) return !0;
		}
		return !1;
	}
	function _(e) {
		var t = [], n = "", r;
		if (!e || !e.childNodes) return "ltr";
		function i(e, t) {
			for (var n = t.childNodes.length - 1; n >= 0; n--) e.push(t.childNodes[n]);
		}
		function a(e) {
			if (!e || !e.length) return null;
			var t = e.pop(), n = t.textContent || t.innerText;
			if (n) {
				var r = n.match(/^.*(\n|\r)/);
				return r ? (e.length = 0, r[0]) : n;
			}
			if (t.tagName === "ruby") return a(e);
			if (t.childNodes) return i(e, t), a(e);
		}
		for (i(t, e); n = a(t);) for (var o = 0; o < n.length; o++) if (r = n.charCodeAt(o), g(r)) return "rtl";
		return "ltr";
	}
	function v(e) {
		if (typeof e.line == "number" && (e.snapToLines || e.line >= 0 && e.line <= 100)) return e.line;
		if (!e.track || !e.track.textTrackList || !e.track.textTrackList.mediaElement) return -1;
		for (var t = e.track, n = t.textTrackList, r = 0, i = 0; i < n.length && n[i] !== t; i++) n[i].mode === "showing" && r++;
		return ++r * -1;
	}
	function y() {}
	y.prototype.applyStyles = function(e, t) {
		for (var n in t ||= this.div, e) e.hasOwnProperty(n) && (t.style[n] = e[n]);
	}, y.prototype.formatStyle = function(e, t) {
		return e === 0 ? 0 : e + t;
	};
	function b(e, t, n) {
		y.call(this), this.cue = t, this.cueDiv = m(e, t.text);
		var r = {
			color: "rgba(255, 255, 255, 1)",
			backgroundColor: "rgba(0, 0, 0, 0.8)",
			position: "relative",
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			display: "inline",
			writingMode: t.vertical === "" ? "horizontal-tb" : t.vertical === "lr" ? "vertical-lr" : "vertical-rl",
			unicodeBidi: "plaintext"
		};
		this.applyStyles(r, this.cueDiv), this.div = e.document.createElement("div"), r = {
			direction: _(this.cueDiv),
			writingMode: t.vertical === "" ? "horizontal-tb" : t.vertical === "lr" ? "vertical-lr" : "vertical-rl",
			unicodeBidi: "plaintext",
			textAlign: t.align === "middle" ? "center" : t.align,
			font: n.font,
			whiteSpace: "pre-line",
			position: "absolute"
		}, this.applyStyles(r), this.div.appendChild(this.cueDiv);
		var i = 0;
		switch (t.positionAlign) {
			case "start":
			case "line-left":
				i = t.position;
				break;
			case "center":
				i = t.position - t.size / 2;
				break;
			case "end":
			case "line-right": i = t.position - t.size;
		}
		t.vertical === "" ? this.applyStyles({
			left: this.formatStyle(i, "%"),
			width: this.formatStyle(t.size, "%")
		}) : this.applyStyles({
			top: this.formatStyle(i, "%"),
			height: this.formatStyle(t.size, "%")
		}), this.move = function(e) {
			this.applyStyles({
				top: this.formatStyle(e.top, "px"),
				bottom: this.formatStyle(e.bottom, "px"),
				left: this.formatStyle(e.left, "px"),
				right: this.formatStyle(e.right, "px"),
				height: this.formatStyle(e.height, "px"),
				width: this.formatStyle(e.width, "px")
			});
		};
	}
	b.prototype = r(y.prototype), b.prototype.constructor = b;
	function x(e) {
		var t, n, r, i;
		if (e.div) {
			n = e.div.offsetHeight, r = e.div.offsetWidth, i = e.div.offsetTop;
			var a = (a = e.div.childNodes) && (a = a[0]) && a.getClientRects && a.getClientRects();
			e = e.div.getBoundingClientRect(), t = a ? Math.max(a[0] && a[0].height || 0, e.height / a.length) : 0;
		}
		this.left = e.left, this.right = e.right, this.top = e.top || i, this.height = e.height || n, this.bottom = e.bottom || i + (e.height || n), this.width = e.width || r, this.lineHeight = t === void 0 ? e.lineHeight : t;
	}
	x.prototype.move = function(e, t) {
		switch (t = t === void 0 ? this.lineHeight : t, e) {
			case "+x":
				this.left += t, this.right += t;
				break;
			case "-x":
				this.left -= t, this.right -= t;
				break;
			case "+y":
				this.top += t, this.bottom += t;
				break;
			case "-y": this.top -= t, this.bottom -= t;
		}
	}, x.prototype.overlaps = function(e) {
		return this.left < e.right && this.right > e.left && this.top < e.bottom && this.bottom > e.top;
	}, x.prototype.overlapsAny = function(e) {
		for (var t = 0; t < e.length; t++) if (this.overlaps(e[t])) return !0;
		return !1;
	}, x.prototype.within = function(e) {
		return this.top >= e.top && this.bottom <= e.bottom && this.left >= e.left && this.right <= e.right;
	}, x.prototype.overlapsOppositeAxis = function(e, t) {
		switch (t) {
			case "+x": return this.left < e.left;
			case "-x": return this.right > e.right;
			case "+y": return this.top < e.top;
			case "-y": return this.bottom > e.bottom;
		}
	}, x.prototype.intersectPercentage = function(e) {
		return Math.max(0, Math.min(this.right, e.right) - Math.max(this.left, e.left)) * Math.max(0, Math.min(this.bottom, e.bottom) - Math.max(this.top, e.top)) / (this.height * this.width);
	}, x.prototype.toCSSCompatValues = function(e) {
		return {
			top: this.top - e.top,
			bottom: e.bottom - this.bottom,
			left: this.left - e.left,
			right: e.right - this.right,
			height: this.height,
			width: this.width
		};
	}, x.getSimpleBoxPosition = function(e) {
		var t = e.div ? e.div.offsetHeight : e.tagName ? e.offsetHeight : 0, n = e.div ? e.div.offsetWidth : e.tagName ? e.offsetWidth : 0, r = e.div ? e.div.offsetTop : e.tagName ? e.offsetTop : 0;
		return e = e.div ? e.div.getBoundingClientRect() : e.tagName ? e.getBoundingClientRect() : e, {
			left: e.left,
			right: e.right,
			top: e.top || r,
			height: e.height || t,
			bottom: e.bottom || r + (e.height || t),
			width: e.width || n
		};
	};
	function S(e, t, n, r) {
		function i(e, t) {
			for (var i, a = new x(e), o = 1, s = 0; s < t.length; s++) {
				for (; e.overlapsOppositeAxis(n, t[s]) || e.within(n) && e.overlapsAny(r);) e.move(t[s]);
				if (e.within(n)) return e;
				var c = e.intersectPercentage(n);
				o > c && (i = new x(e), o = c), e = new x(a);
			}
			return i || a;
		}
		var a = new x(t), o = t.cue, s = v(o), c = [];
		if (o.snapToLines) {
			var l;
			switch (o.vertical) {
				case "":
					c = ["+y", "-y"], l = "height";
					break;
				case "rl":
					c = ["+x", "-x"], l = "width";
					break;
				case "lr": c = ["-x", "+x"], l = "width";
			}
			var u = a.lineHeight, d = u * Math.round(s), f = n[l] + u, p = c[0];
			Math.abs(d) > f && (d = d < 0 ? -1 : 1, d *= Math.ceil(f / u) * u), s < 0 && (d += o.vertical === "" ? n.height : n.width, c = c.reverse()), a.move(p, d);
		} else {
			var m = a.lineHeight / n.height * 100;
			switch (o.lineAlign) {
				case "center":
					s -= m / 2;
					break;
				case "end": s -= m;
			}
			switch (o.vertical) {
				case "":
					t.applyStyles({ top: t.formatStyle(s, "%") });
					break;
				case "rl":
					t.applyStyles({ left: t.formatStyle(s, "%") });
					break;
				case "lr": t.applyStyles({ right: t.formatStyle(s, "%") });
			}
			c = [
				"+y",
				"-x",
				"+x",
				"-y"
			], a = new x(t);
		}
		var h = i(a, c);
		t.move(h.toCSSCompatValues(n));
	}
	function C() {}
	C.StringDecoder = function() {
		return { decode: function(e) {
			if (!e) return "";
			if (typeof e != "string") throw Error("Error - expected string data.");
			return decodeURIComponent(encodeURIComponent(e));
		} };
	}, C.convertCueToDOMTree = function(e, t) {
		return !e || !t ? null : m(e, t);
	};
	var w = .05, T = "sans-serif", E = "1.5%";
	C.processCues = function(e, t, n) {
		if (!e || !t || !n) return null;
		for (; n.firstChild;) n.removeChild(n.firstChild);
		var r = e.document.createElement("div");
		r.style.position = "absolute", r.style.left = "0", r.style.right = "0", r.style.top = "0", r.style.bottom = "0", r.style.margin = E, n.appendChild(r);
		function i(e) {
			for (var t = 0; t < e.length; t++) if (e[t].hasBeenReset || !e[t].displayState) return !0;
			return !1;
		}
		if (!i(t)) {
			for (var a = 0; a < t.length; a++) r.appendChild(t[a].displayState);
			return;
		}
		var o = [], s = x.getSimpleBoxPosition(r), c = { font: Math.round(s.height * w * 100) / 100 + "px " + T };
		(function() {
			for (var n, i, a = 0; a < t.length; a++) i = t[a], n = new b(e, i, c), r.appendChild(n.div), S(e, n, s, o), i.displayState = n.div, o.push(x.getSimpleBoxPosition(n));
		})();
	}, C.Parser = function(e, t, n) {
		n || (n = t, t = {}), t ||= {}, this.window = e, this.vttjs = t, this.state = "INITIAL", this.buffer = "", this.decoder = n || new TextDecoder("utf8"), this.regionList = [];
	}, C.Parser.prototype = {
		reportOrThrowError: function(e) {
			if (e instanceof i) this.onparsingerror && this.onparsingerror(e);
			else throw e;
		},
		parse: function(e) {
			var t = this;
			e && (t.buffer += t.decoder.decode(e, { stream: !0 }));
			function n() {
				for (var e = t.buffer, n = 0; n < e.length && e[n] !== "\r" && e[n] !== "\n";) ++n;
				var r = e.substr(0, n);
				return e[n] === "\r" && ++n, e[n] === "\n" && ++n, t.buffer = e.substr(n), r;
			}
			function r(e) {
				var n = new o();
				if (s(e, function(e, t) {
					switch (e) {
						case "id":
							n.set(e, t);
							break;
						case "width":
							n.percent(e, t);
							break;
						case "lines":
							n.integer(e, t);
							break;
						case "regionanchor":
						case "viewportanchor":
							var r = t.split(",");
							if (r.length !== 2) break;
							var i = new o();
							if (i.percent("x", r[0]), i.percent("y", r[1]), !i.has("x") || !i.has("y")) break;
							n.set(e + "X", i.get("x")), n.set(e + "Y", i.get("y"));
							break;
						case "scroll": n.alt(e, t, ["up"]);
					}
				}, /=/, /\s/), n.has("id")) {
					var r = new (t.vttjs.VTTRegion || t.window.VTTRegion)();
					r.width = n.get("width", 100), r.lines = n.get("lines", 3), r.regionAnchorX = n.get("regionanchorX", 0), r.regionAnchorY = n.get("regionanchorY", 100), r.viewportAnchorX = n.get("viewportanchorX", 0), r.viewportAnchorY = n.get("viewportanchorY", 100), r.scroll = n.get("scroll", ""), t.onregion && t.onregion(r), t.regionList.push({
						id: n.get("id"),
						region: r
					});
				}
			}
			function l(e) {
				var n = new o();
				s(e, function(e, t) {
					switch (e) {
						case "MPEGT":
							n.integer(e + "S", t);
							break;
						case "LOCA": n.set(e + "L", a(t));
					}
				}, /[^\d]:/, /,/), t.ontimestampmap && t.ontimestampmap({
					MPEGTS: n.get("MPEGTS"),
					LOCAL: n.get("LOCAL")
				});
			}
			function u(e) {
				e.match(/X-TIMESTAMP-MAP/) ? s(e, function(e, t) {
					e === "X-TIMESTAMP-MAP" && l(t);
				}, /=/) : s(e, function(e, t) {
					e === "Region" && r(t);
				}, /:/);
			}
			try {
				var d;
				if (t.state === "INITIAL") {
					if (!/\r\n|\n/.test(t.buffer)) return this;
					d = n();
					var f = d.match(/^WEBVTT([ \t].*)?$/);
					if (!f || !f[0]) throw new i(i.Errors.BadSignature);
					t.state = "HEADER";
				}
				for (var p = !1; t.buffer;) {
					if (!/\r\n|\n/.test(t.buffer)) return this;
					switch (p ? p = !1 : d = n(), t.state) {
						case "HEADER":
							/:/.test(d) ? u(d) : d || (t.state = "ID");
							continue;
						case "NOTE":
							d || (t.state = "ID");
							continue;
						case "ID":
							if (/^NOTE($|[ \t])/.test(d)) {
								t.state = "NOTE";
								break;
							}
							if (!d) continue;
							t.cue = new (t.vttjs.VTTCue || t.window.VTTCue)(0, 0, "");
							try {
								t.cue.align = "center";
							} catch {
								t.cue.align = "middle";
							}
							if (t.state = "CUE", d.indexOf("-->") === -1) {
								t.cue.id = d;
								continue;
							}
						case "CUE":
							try {
								c(d, t.cue, t.regionList);
							} catch (e) {
								t.reportOrThrowError(e), t.cue = null, t.state = "BADCUE";
								continue;
							}
							t.state = "CUETEXT";
							continue;
						case "CUETEXT":
							var m = d.indexOf("-->") !== -1;
							if (!d || m && (p = !0)) {
								t.oncue && t.oncue(t.cue), t.cue = null, t.state = "ID";
								continue;
							}
							t.cue.text && (t.cue.text += "\n"), t.cue.text += d.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
							continue;
						case "BADCUE":
							d || (t.state = "ID");
							continue;
					}
				}
			} catch (e) {
				t.reportOrThrowError(e), t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
			}
			return this;
		},
		flush: function() {
			var e = this;
			try {
				if (e.buffer += e.decoder.decode(), (e.cue || e.state === "HEADER") && (e.buffer += "\n\n", e.parse()), e.state === "INITIAL") throw new i(i.Errors.BadSignature);
			} catch (t) {
				e.reportOrThrowError(t);
			}
			return e.onflush && e.onflush(), this;
		}
	}, t.exports = C;
})), xF = /* @__PURE__ */ s(((e, t) => {
	var n = {
		"": 1,
		lr: 1,
		rl: 1
	}, r = {
		start: 1,
		center: 1,
		end: 1,
		left: 1,
		right: 1,
		auto: 1,
		"line-left": 1,
		"line-right": 1
	};
	function i(e) {
		return typeof e == "string" && n[e.toLowerCase()] ? e.toLowerCase() : !1;
	}
	function a(e) {
		return typeof e == "string" && r[e.toLowerCase()] ? e.toLowerCase() : !1;
	}
	function o(e, t, n) {
		this.hasBeenReset = !1;
		var r = "", o = !1, s = e, c = t, l = n, u = null, d = "", f = !0, p = "auto", m = "start", h = "auto", g = "auto", _ = 100, v = "center";
		Object.defineProperties(this, {
			id: {
				enumerable: !0,
				get: function() {
					return r;
				},
				set: function(e) {
					r = "" + e;
				}
			},
			pauseOnExit: {
				enumerable: !0,
				get: function() {
					return o;
				},
				set: function(e) {
					o = !!e;
				}
			},
			startTime: {
				enumerable: !0,
				get: function() {
					return s;
				},
				set: function(e) {
					if (typeof e != "number") throw TypeError("Start time must be set to a number.");
					s = e, this.hasBeenReset = !0;
				}
			},
			endTime: {
				enumerable: !0,
				get: function() {
					return c;
				},
				set: function(e) {
					if (typeof e != "number") throw TypeError("End time must be set to a number.");
					c = e, this.hasBeenReset = !0;
				}
			},
			text: {
				enumerable: !0,
				get: function() {
					return l;
				},
				set: function(e) {
					l = "" + e, this.hasBeenReset = !0;
				}
			},
			region: {
				enumerable: !0,
				get: function() {
					return u;
				},
				set: function(e) {
					u = e, this.hasBeenReset = !0;
				}
			},
			vertical: {
				enumerable: !0,
				get: function() {
					return d;
				},
				set: function(e) {
					var t = i(e);
					if (t === !1) throw SyntaxError("Vertical: an invalid or illegal direction string was specified.");
					d = t, this.hasBeenReset = !0;
				}
			},
			snapToLines: {
				enumerable: !0,
				get: function() {
					return f;
				},
				set: function(e) {
					f = !!e, this.hasBeenReset = !0;
				}
			},
			line: {
				enumerable: !0,
				get: function() {
					return p;
				},
				set: function(e) {
					if (typeof e != "number" && e !== "auto") throw SyntaxError("Line: an invalid number or illegal string was specified.");
					p = e, this.hasBeenReset = !0;
				}
			},
			lineAlign: {
				enumerable: !0,
				get: function() {
					return m;
				},
				set: function(e) {
					var t = a(e);
					t ? (m = t, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
				}
			},
			position: {
				enumerable: !0,
				get: function() {
					return h;
				},
				set: function(e) {
					if (e < 0 || e > 100) throw Error("Position must be between 0 and 100.");
					h = e, this.hasBeenReset = !0;
				}
			},
			positionAlign: {
				enumerable: !0,
				get: function() {
					return g;
				},
				set: function(e) {
					var t = a(e);
					t ? (g = t, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
				}
			},
			size: {
				enumerable: !0,
				get: function() {
					return _;
				},
				set: function(e) {
					if (e < 0 || e > 100) throw Error("Size must be between 0 and 100.");
					_ = e, this.hasBeenReset = !0;
				}
			},
			align: {
				enumerable: !0,
				get: function() {
					return v;
				},
				set: function(e) {
					var t = a(e);
					if (!t) throw SyntaxError("align: an invalid or illegal alignment string was specified.");
					v = t, this.hasBeenReset = !0;
				}
			}
		}), this.displayState = void 0;
	}
	o.prototype.getCueAsHTML = function() {
		return WebVTT.convertCueToDOMTree(window, this.text);
	}, t.exports = o;
})), SF = /* @__PURE__ */ s(((e, t) => {
	var n = {
		"": !0,
		up: !0
	};
	function r(e) {
		return typeof e == "string" && n[e.toLowerCase()] ? e.toLowerCase() : !1;
	}
	function i(e) {
		return typeof e == "number" && e >= 0 && e <= 100;
	}
	function a() {
		var e = 100, t = 3, n = 0, a = 100, o = 0, s = 100, c = "";
		Object.defineProperties(this, {
			width: {
				enumerable: !0,
				get: function() {
					return e;
				},
				set: function(t) {
					if (!i(t)) throw Error("Width must be between 0 and 100.");
					e = t;
				}
			},
			lines: {
				enumerable: !0,
				get: function() {
					return t;
				},
				set: function(e) {
					if (typeof e != "number") throw TypeError("Lines must be set to a number.");
					t = e;
				}
			},
			regionAnchorY: {
				enumerable: !0,
				get: function() {
					return a;
				},
				set: function(e) {
					if (!i(e)) throw Error("RegionAnchorX must be between 0 and 100.");
					a = e;
				}
			},
			regionAnchorX: {
				enumerable: !0,
				get: function() {
					return n;
				},
				set: function(e) {
					if (!i(e)) throw Error("RegionAnchorY must be between 0 and 100.");
					n = e;
				}
			},
			viewportAnchorY: {
				enumerable: !0,
				get: function() {
					return s;
				},
				set: function(e) {
					if (!i(e)) throw Error("ViewportAnchorY must be between 0 and 100.");
					s = e;
				}
			},
			viewportAnchorX: {
				enumerable: !0,
				get: function() {
					return o;
				},
				set: function(e) {
					if (!i(e)) throw Error("ViewportAnchorX must be between 0 and 100.");
					o = e;
				}
			},
			scroll: {
				enumerable: !0,
				get: function() {
					return c;
				},
				set: function(e) {
					var t = r(e);
					t === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : c = t;
				}
			}
		});
	}
	t.exports = a;
})), CF = /* @__PURE__ */ s(((e, t) => {
	var n = dF(), r = t.exports = {
		WebVTT: bF(),
		VTTCue: xF(),
		VTTRegion: SF()
	};
	n.vttjs = r, n.WebVTT = r.WebVTT;
	var i = r.VTTCue, a = r.VTTRegion, o = n.VTTCue, s = n.VTTRegion;
	r.shim = function() {
		n.VTTCue = i, n.VTTRegion = a;
	}, r.restore = function() {
		n.VTTCue = o, n.VTTRegion = s;
	}, n.VTTCue || r.shim();
}));
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/extends.js
function wF() {
	return wF = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, wF.apply(null, arguments);
}
var TF = o((() => {})), EF, DF, OF, kF = o((() => {
	EF = /* @__PURE__ */ u(dF()), DF = "https://example.com", OF = function(e, t) {
		if (/^[a-z]+:/i.test(t)) return t;
		/^data:/.test(e) && (e = EF.default.location && EF.default.location.href || "");
		var n = /^\/\//.test(e), r = !EF.default.location && !/\/\//i.test(e);
		e = new EF.default.URL(e, EF.default.location || DF);
		var i = new URL(t, e);
		return r ? i.href.slice(DF.length) : n ? i.href.slice(i.protocol.length) : i.href;
	};
})), AF, jF = o((() => {
	AF = /*#__PURE__*/ function() {
		function e() {
			this.listeners = {};
		}
		var t = e.prototype;
		return t.on = function(e, t) {
			this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
		}, t.off = function(e, t) {
			if (!this.listeners[e]) return !1;
			var n = this.listeners[e].indexOf(t);
			return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(n, 1), n > -1;
		}, t.trigger = function(e) {
			var t = this.listeners[e];
			if (t) if (arguments.length === 2) for (var n = t.length, r = 0; r < n; ++r) t[r].call(this, arguments[1]);
			else for (var i = Array.prototype.slice.call(arguments, 1), a = t.length, o = 0; o < a; ++o) t[o].apply(this, i);
		}, t.dispose = function() {
			this.listeners = {};
		}, t.pipe = function(e) {
			this.on("data", function(t) {
				e.push(t);
			});
		}, e;
	}();
}));
//#endregion
//#region node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js
function MF(e) {
	for (var t = PF(e), n = new Uint8Array(t.length), r = 0; r < t.length; r++) n[r] = t.charCodeAt(r);
	return n;
}
var NF, PF, FF = o((() => {
	NF = /* @__PURE__ */ u(dF()), PF = function(e) {
		return NF.default.atob ? NF.default.atob(e) : Buffer.from(e, "base64").toString("binary");
	};
})), IF, LF, RF, zF, BF, VF, HF, UF, WF, GF, KF, qF = o((() => {
	jF(), TF(), FF(), IF = class extends AF {
		constructor() {
			super(), this.buffer = "";
		}
		push(e) {
			let t;
			for (this.buffer += e, t = this.buffer.indexOf("\n"); t > -1; t = this.buffer.indexOf("\n")) this.trigger("data", this.buffer.substring(0, t)), this.buffer = this.buffer.substring(t + 1);
		}
	}, LF = "	", RF = function(e) {
		let t = /([0-9.]*)?@?([0-9.]*)?/.exec(e || ""), n = {};
		return t[1] && (n.length = parseInt(t[1], 10)), t[2] && (n.offset = parseInt(t[2], 10)), n;
	}, zF = function() {
		return /* @__PURE__ */ RegExp("(?:^|,)((?:[^=]*)=(?:\"[^\"]*\"|[^,]*))");
	}, BF = function(e) {
		let t = {};
		if (!e) return t;
		let n = e.split(zF()), r = n.length, i;
		for (; r--;) n[r] !== "" && (i = /([^=]*)=(.*)/.exec(n[r]).slice(1), i[0] = i[0].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^['"](.*)['"]$/g, "$1"), t[i[0]] = i[1]);
		return t;
	}, VF = (e) => {
		let t = e.split("x"), n = {};
		return t[0] && (n.width = parseInt(t[0], 10)), t[1] && (n.height = parseInt(t[1], 10)), n;
	}, HF = class extends AF {
		constructor() {
			super(), this.customParsers = [], this.tagMappers = [];
		}
		push(e) {
			let t, n;
			if (e = e.trim(), e.length !== 0) {
				if (e[0] !== "#") {
					this.trigger("data", {
						type: "uri",
						uri: e
					});
					return;
				}
				this.tagMappers.reduce((t, n) => {
					let r = n(e);
					return r === e ? t : t.concat([r]);
				}, [e]).forEach((e) => {
					for (let t = 0; t < this.customParsers.length; t++) if (this.customParsers[t].call(this, e)) return;
					if (e.indexOf("#EXT") !== 0) {
						this.trigger("data", {
							type: "comment",
							text: e.slice(1)
						});
						return;
					}
					if (e = e.replace("\r", ""), t = /^#EXTM3U/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "m3u"
						});
						return;
					}
					if (t = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "inf"
						}, t[1] && (n.duration = parseFloat(t[1])), t[2] && (n.title = t[2]), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "targetduration"
						}, t[1] && (n.duration = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-VERSION:([0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "version"
						}, t[1] && (n.version = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "media-sequence"
						}, t[1] && (n.number = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "discontinuity-sequence"
						}, t[1] && (n.number = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "playlist-type"
						}, t[1] && (n.playlistType = t[1]), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-BYTERANGE:(.*)?$/.exec(e), t) {
						n = wF(RF(t[1]), {
							type: "tag",
							tagType: "byterange"
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "allow-cache"
						}, t[1] && (n.allowed = !/NO/.test(t[1])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-MAP:(.*)$/.exec(e), t) {
						if (n = {
							type: "tag",
							tagType: "map"
						}, t[1]) {
							let e = BF(t[1]);
							e.URI && (n.uri = e.URI), e.BYTERANGE && (n.byterange = RF(e.BYTERANGE));
						}
						this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-STREAM-INF:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "stream-inf"
						}, t[1] && (n.attributes = BF(t[1]), n.attributes.RESOLUTION && (n.attributes.RESOLUTION = VF(n.attributes.RESOLUTION)), n.attributes.BANDWIDTH && (n.attributes.BANDWIDTH = parseInt(n.attributes.BANDWIDTH, 10)), n.attributes["FRAME-RATE"] && (n.attributes["FRAME-RATE"] = parseFloat(n.attributes["FRAME-RATE"])), n.attributes["PROGRAM-ID"] && (n.attributes["PROGRAM-ID"] = parseInt(n.attributes["PROGRAM-ID"], 10))), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-MEDIA:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "media"
						}, t[1] && (n.attributes = BF(t[1])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-ENDLIST/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "endlist"
						});
						return;
					}
					if (t = /^#EXT-X-DISCONTINUITY/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "discontinuity"
						});
						return;
					}
					if (t = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "program-date-time"
						}, t[1] && (n.dateTimeString = t[1], n.dateTimeObject = new Date(t[1])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-KEY:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "key"
						}, t[1] && (n.attributes = BF(t[1]), n.attributes.IV && (n.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (n.attributes.IV = n.attributes.IV.substring(2)), n.attributes.IV = n.attributes.IV.match(/.{8}/g), n.attributes.IV[0] = parseInt(n.attributes.IV[0], 16), n.attributes.IV[1] = parseInt(n.attributes.IV[1], 16), n.attributes.IV[2] = parseInt(n.attributes.IV[2], 16), n.attributes.IV[3] = parseInt(n.attributes.IV[3], 16), n.attributes.IV = new Uint32Array(n.attributes.IV))), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-START:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "start"
						}, t[1] && (n.attributes = BF(t[1]), n.attributes["TIME-OFFSET"] = parseFloat(n.attributes["TIME-OFFSET"]), n.attributes.PRECISE = /YES/.test(n.attributes.PRECISE)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "cue-out-cont"
						}, t[1] ? n.data = t[1] : n.data = "", this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-CUE-OUT:(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "cue-out"
						}, t[1] ? n.data = t[1] : n.data = "", this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-CUE-IN:?(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "cue-in"
						}, t[1] ? n.data = t[1] : n.data = "", this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-SKIP:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "skip"
						}, n.attributes = BF(t[1]), n.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (n.attributes["SKIPPED-SEGMENTS"] = parseInt(n.attributes["SKIPPED-SEGMENTS"], 10)), n.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (n.attributes["RECENTLY-REMOVED-DATERANGES"] = n.attributes["RECENTLY-REMOVED-DATERANGES"].split(LF)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PART:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "part"
						}, n.attributes = BF(t[1]), ["DURATION"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), ["INDEPENDENT", "GAP"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = /YES/.test(n.attributes[e]));
						}), n.attributes.hasOwnProperty("BYTERANGE") && (n.attributes.byterange = RF(n.attributes.BYTERANGE)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "server-control"
						}, n.attributes = BF(t[1]), [
							"CAN-SKIP-UNTIL",
							"PART-HOLD-BACK",
							"HOLD-BACK"
						].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = /YES/.test(n.attributes[e]));
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PART-INF:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "part-inf"
						}, n.attributes = BF(t[1]), ["PART-TARGET"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "preload-hint"
						}, n.attributes = BF(t[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(e) {
							if (n.attributes.hasOwnProperty(e)) {
								n.attributes[e] = parseInt(n.attributes[e], 10);
								let t = e === "BYTERANGE-LENGTH" ? "length" : "offset";
								n.attributes.byterange = n.attributes.byterange || {}, n.attributes.byterange[t] = n.attributes[e], delete n.attributes[e];
							}
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "rendition-report"
						}, n.attributes = BF(t[1]), ["LAST-MSN", "LAST-PART"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseInt(n.attributes[e], 10));
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-DATERANGE:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "daterange"
						}, n.attributes = BF(t[1]), ["ID", "CLASS"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = String(n.attributes[e]));
						}), ["START-DATE", "END-DATE"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = new Date(n.attributes[e]));
						}), ["DURATION", "PLANNED-DURATION"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), ["END-ON-NEXT"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = /YES/i.test(n.attributes[e]));
						}), [
							"SCTE35-CMD",
							" SCTE35-OUT",
							"SCTE35-IN"
						].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = n.attributes[e].toString(16));
						});
						let e = /^X-([A-Z]+-)+[A-Z]+$/;
						for (let t in n.attributes) {
							if (!e.test(t)) continue;
							let r = /[0-9A-Fa-f]{6}/g.test(n.attributes[t]), i = /^\d+(\.\d+)?$/.test(n.attributes[t]);
							n.attributes[t] = r ? n.attributes[t].toString(16) : i ? parseFloat(n.attributes[t]) : String(n.attributes[t]);
						}
						this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "independent-segments"
						});
						return;
					}
					if (t = /^#EXT-X-I-FRAMES-ONLY/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "i-frames-only"
						});
						return;
					}
					if (t = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "content-steering"
						}, n.attributes = BF(t[1]), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "i-frame-playlist"
						}, n.attributes = BF(t[1]), n.attributes.URI && (n.uri = n.attributes.URI), n.attributes.BANDWIDTH && (n.attributes.BANDWIDTH = parseInt(n.attributes.BANDWIDTH, 10)), n.attributes.RESOLUTION && (n.attributes.RESOLUTION = VF(n.attributes.RESOLUTION)), n.attributes["AVERAGE-BANDWIDTH"] && (n.attributes["AVERAGE-BANDWIDTH"] = parseInt(n.attributes["AVERAGE-BANDWIDTH"], 10)), n.attributes["FRAME-RATE"] && (n.attributes["FRAME-RATE"] = parseFloat(n.attributes["FRAME-RATE"])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-DEFINE:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "define"
						}, n.attributes = BF(t[1]), this.trigger("data", n);
						return;
					}
					this.trigger("data", {
						type: "tag",
						data: e.slice(4)
					});
				});
			}
		}
		addParser({ expression: e, customType: t, dataParser: n, segment: r }) {
			typeof n != "function" && (n = (e) => e), this.customParsers.push((i) => {
				if (e.exec(i)) return this.trigger("data", {
					type: "custom",
					data: n(i),
					customType: t,
					segment: r
				}), !0;
			});
		}
		addTagMapper({ expression: e, map: t }) {
			this.tagMappers.push((n) => e.test(n) ? t(n) : n);
		}
	}, UF = (e) => e.toLowerCase().replace(/-(\w)/g, (e) => e[1].toUpperCase()), WF = function(e) {
		let t = {};
		return Object.keys(e).forEach(function(n) {
			t[UF(n)] = e[n];
		}), t;
	}, GF = function(e) {
		let { serverControl: t, targetDuration: n, partTargetDuration: r } = e;
		if (!t) return;
		let i = "#EXT-X-SERVER-CONTROL", a = "holdBack", o = "partHoldBack", s = n && n * 3, c = r && r * 2;
		n && !t.hasOwnProperty(a) && (t[a] = s, this.trigger("info", { message: `${i} defaulting HOLD-BACK to targetDuration * 3 (${s}).` })), s && t[a] < s && (this.trigger("warn", { message: `${i} clamping HOLD-BACK (${t[a]}) to targetDuration * 3 (${s})` }), t[a] = s), r && !t.hasOwnProperty(o) && (t[o] = r * 3, this.trigger("info", { message: `${i} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${t[o]}).` })), r && t[o] < c && (this.trigger("warn", { message: `${i} clamping PART-HOLD-BACK (${t[o]}) to partTargetDuration * 2 (${c}).` }), t[o] = c);
	}, KF = class extends AF {
		constructor(e = {}) {
			super(), this.lineStream = new IF(), this.parseStream = new HF(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = e.mainDefinitions || {}, this.params = new URL(e.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
			let t = this, n = [], r = {}, i, a, o = !1, s = function() {}, c = {
				AUDIO: {},
				VIDEO: {},
				"CLOSED-CAPTIONS": {},
				SUBTITLES: {}
			}, l = 0;
			this.manifest = {
				allowCache: !0,
				discontinuityStarts: [],
				dateRanges: [],
				iFramePlaylists: [],
				segments: []
			};
			let u = 0, d = 0, f = {};
			this.on("end", () => {
				r.uri || !r.parts && !r.preloadHints || (!r.map && i && (r.map = i), !r.key && a && (r.key = a), !r.timeline && typeof l == "number" && (r.timeline = l), this.manifest.preloadSegment = r);
			}), this.parseStream.on("data", function(e) {
				let p, m;
				if (t.manifest.definitions) {
					for (let n in t.manifest.definitions) if (e.uri &&= e.uri.replace(`{$${n}}`, t.manifest.definitions[n]), e.attributes) for (let r in e.attributes) typeof e.attributes[r] == "string" && (e.attributes[r] = e.attributes[r].replace(`{$${n}}`, t.manifest.definitions[n]));
				}
				({
					tag() {
						({
							version() {
								e.version && (this.manifest.version = e.version);
							},
							"allow-cache"() {
								this.manifest.allowCache = e.allowed, "allowed" in e || (this.trigger("info", { message: "defaulting allowCache to YES" }), this.manifest.allowCache = !0);
							},
							byterange() {
								let t = {};
								"length" in e && (r.byterange = t, t.length = e.length, "offset" in e || (e.offset = u)), "offset" in e && (r.byterange = t, t.offset = e.offset), u = t.offset + t.length;
							},
							endlist() {
								this.manifest.endList = !0;
							},
							inf() {
								"mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", { message: "defaulting media sequence to zero" })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", { message: "defaulting discontinuity sequence to zero" })), e.title && (r.title = e.title), e.duration > 0 && (r.duration = e.duration), e.duration === 0 && (r.duration = .01, this.trigger("info", { message: "updating zero segment duration to a small value" })), this.manifest.segments = n;
							},
							key() {
								if (!e.attributes) {
									this.trigger("warn", { message: "ignoring key declaration without attribute list" });
									return;
								}
								if (e.attributes.METHOD === "NONE") {
									a = null;
									return;
								}
								if (!e.attributes.URI) {
									this.trigger("warn", { message: "ignoring key declaration without URI" });
									return;
								}
								if (e.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
									this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = { attributes: e.attributes };
									return;
								}
								if (e.attributes.KEYFORMAT === "com.microsoft.playready") {
									this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = { uri: e.attributes.URI };
									return;
								}
								if (e.attributes.KEYFORMAT === "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed") {
									if ([
										"SAMPLE-AES",
										"SAMPLE-AES-CTR",
										"SAMPLE-AES-CENC"
									].indexOf(e.attributes.METHOD) === -1) {
										this.trigger("warn", { message: "invalid key method provided for Widevine" });
										return;
									}
									if (e.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", { message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead" }), e.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
										this.trigger("warn", { message: "invalid key URI provided for Widevine" });
										return;
									}
									if (!(e.attributes.KEYID && e.attributes.KEYID.substring(0, 2) === "0x")) {
										this.trigger("warn", { message: "invalid key ID provided for Widevine" });
										return;
									}
									this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
										attributes: {
											schemeIdUri: e.attributes.KEYFORMAT,
											keyId: e.attributes.KEYID.substring(2)
										},
										pssh: MF(e.attributes.URI.split(",")[1])
									};
									return;
								}
								e.attributes.METHOD || this.trigger("warn", { message: "defaulting key method to AES-128" }), a = {
									method: e.attributes.METHOD || "AES-128",
									uri: e.attributes.URI
								}, e.attributes.IV !== void 0 && (a.iv = e.attributes.IV);
							},
							"media-sequence"() {
								if (!isFinite(e.number)) {
									this.trigger("warn", { message: "ignoring invalid media sequence: " + e.number });
									return;
								}
								this.manifest.mediaSequence = e.number;
							},
							"discontinuity-sequence"() {
								if (!isFinite(e.number)) {
									this.trigger("warn", { message: "ignoring invalid discontinuity sequence: " + e.number });
									return;
								}
								this.manifest.discontinuitySequence = e.number, l = e.number;
							},
							"playlist-type"() {
								if (!/VOD|EVENT/.test(e.playlistType)) {
									this.trigger("warn", { message: "ignoring unknown playlist type: " + e.playlist });
									return;
								}
								this.manifest.playlistType = e.playlistType;
							},
							map() {
								i = {}, e.uri && (i.uri = e.uri), e.byterange && (i.byterange = e.byterange), a && (i.key = a);
							},
							"stream-inf"() {
								if (this.manifest.playlists = n, this.manifest.mediaGroups = this.manifest.mediaGroups || c, !e.attributes) {
									this.trigger("warn", { message: "ignoring empty stream-inf attributes" });
									return;
								}
								r.attributes || (r.attributes = {}), wF(r.attributes, e.attributes);
							},
							media() {
								if (this.manifest.mediaGroups = this.manifest.mediaGroups || c, !(e.attributes && e.attributes.TYPE && e.attributes["GROUP-ID"] && e.attributes.NAME)) {
									this.trigger("warn", { message: "ignoring incomplete or missing media group" });
									return;
								}
								let t = this.manifest.mediaGroups[e.attributes.TYPE];
								t[e.attributes["GROUP-ID"]] = t[e.attributes["GROUP-ID"]] || {}, p = t[e.attributes["GROUP-ID"]], m = { default: /yes/i.test(e.attributes.DEFAULT) }, m.default ? m.autoselect = !0 : m.autoselect = /yes/i.test(e.attributes.AUTOSELECT), e.attributes.LANGUAGE && (m.language = e.attributes.LANGUAGE), e.attributes.URI && (m.uri = e.attributes.URI), e.attributes["INSTREAM-ID"] && (m.instreamId = e.attributes["INSTREAM-ID"]), e.attributes.CHARACTERISTICS && (m.characteristics = e.attributes.CHARACTERISTICS), e.attributes.FORCED && (m.forced = /yes/i.test(e.attributes.FORCED)), p[e.attributes.NAME] = m;
							},
							discontinuity() {
								l += 1, r.discontinuity = !0, this.manifest.discontinuityStarts.push(n.length);
							},
							"program-date-time"() {
								this.manifest.dateTimeString === void 0 && (this.manifest.dateTimeString = e.dateTimeString, this.manifest.dateTimeObject = e.dateTimeObject), r.dateTimeString = e.dateTimeString, r.dateTimeObject = e.dateTimeObject;
								let { lastProgramDateTime: t } = this;
								this.lastProgramDateTime = new Date(e.dateTimeString).getTime(), t === null && this.manifest.segments.reduceRight((e, t) => (t.programDateTime = e - t.duration * 1e3, t.programDateTime), this.lastProgramDateTime);
							},
							targetduration() {
								if (!isFinite(e.duration) || e.duration < 0) {
									this.trigger("warn", { message: "ignoring invalid target duration: " + e.duration });
									return;
								}
								this.manifest.targetDuration = e.duration, GF.call(this, this.manifest);
							},
							start() {
								if (!e.attributes || isNaN(e.attributes["TIME-OFFSET"])) {
									this.trigger("warn", { message: "ignoring start declaration without appropriate attribute list" });
									return;
								}
								this.manifest.start = {
									timeOffset: e.attributes["TIME-OFFSET"],
									precise: e.attributes.PRECISE
								};
							},
							"cue-out"() {
								r.cueOut = e.data;
							},
							"cue-out-cont"() {
								r.cueOutCont = e.data;
							},
							"cue-in"() {
								r.cueIn = e.data;
							},
							skip() {
								this.manifest.skip = WF(e.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", e.attributes, ["SKIPPED-SEGMENTS"]);
							},
							part() {
								o = !0;
								let t = this.manifest.segments.length, n = WF(e.attributes);
								r.parts = r.parts || [], r.parts.push(n), n.byterange && (n.byterange.hasOwnProperty("offset") || (n.byterange.offset = d), d = n.byterange.offset + n.byterange.length);
								let i = r.parts.length - 1;
								this.warnOnMissingAttributes_(`#EXT-X-PART #${i} for segment #${t}`, e.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((e, t) => {
									e.hasOwnProperty("lastPart") || this.trigger("warn", { message: `#EXT-X-RENDITION-REPORT #${t} lacks required attribute(s): LAST-PART` });
								});
							},
							"server-control"() {
								let t = this.manifest.serverControl = WF(e.attributes);
								t.hasOwnProperty("canBlockReload") || (t.canBlockReload = !1, this.trigger("info", { message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false" })), GF.call(this, this.manifest), t.canSkipDateranges && !t.hasOwnProperty("canSkipUntil") && this.trigger("warn", { message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set" });
							},
							"preload-hint"() {
								let t = this.manifest.segments.length, n = WF(e.attributes), i = n.type && n.type === "PART";
								r.preloadHints = r.preloadHints || [], r.preloadHints.push(n), n.byterange && (n.byterange.hasOwnProperty("offset") || (n.byterange.offset = i ? d : 0, i && (d = n.byterange.offset + n.byterange.length)));
								let a = r.preloadHints.length - 1;
								if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${a} for segment #${t}`, e.attributes, ["TYPE", "URI"]), n.type) for (let e = 0; e < r.preloadHints.length - 1; e++) {
									let i = r.preloadHints[e];
									i.type && i.type === n.type && this.trigger("warn", { message: `#EXT-X-PRELOAD-HINT #${a} for segment #${t} has the same TYPE ${n.type} as preload hint #${e}` });
								}
							},
							"rendition-report"() {
								let t = WF(e.attributes);
								this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(t);
								let n = this.manifest.renditionReports.length - 1, r = ["LAST-MSN", "URI"];
								o && r.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${n}`, e.attributes, r);
							},
							"part-inf"() {
								this.manifest.partInf = WF(e.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", e.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), GF.call(this, this.manifest);
							},
							daterange() {
								this.manifest.dateRanges.push(WF(e.attributes));
								let t = this.manifest.dateRanges.length - 1;
								this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${t}`, e.attributes, ["ID", "START-DATE"]);
								let n = this.manifest.dateRanges[t];
								n.endDate && n.startDate && new Date(n.endDate) < new Date(n.startDate) && this.trigger("warn", { message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE" }), n.duration && n.duration < 0 && this.trigger("warn", { message: "EXT-X-DATERANGE DURATION must not be negative" }), n.plannedDuration && n.plannedDuration < 0 && this.trigger("warn", { message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative" });
								let r = !!n.endOnNext;
								if (r && !n.class && this.trigger("warn", { message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute" }), r && (n.duration || n.endDate) && this.trigger("warn", { message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes" }), n.duration && n.endDate) {
									let e = n.startDate.getTime() + n.duration * 1e3;
									this.manifest.dateRanges[t].endDate = new Date(e);
								}
								if (!f[n.id]) f[n.id] = n;
								else {
									for (let e in f[n.id]) if (n[e] && JSON.stringify(f[n.id][e]) !== JSON.stringify(n[e])) {
										this.trigger("warn", { message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values" });
										break;
									}
									let e = this.manifest.dateRanges.findIndex((e) => e.id === n.id);
									this.manifest.dateRanges[e] = wF(this.manifest.dateRanges[e], n), f[n.id] = wF(f[n.id], n), this.manifest.dateRanges.pop();
								}
							},
							"independent-segments"() {
								this.manifest.independentSegments = !0;
							},
							"i-frames-only"() {
								this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
							},
							"content-steering"() {
								this.manifest.contentSteering = WF(e.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", e.attributes, ["SERVER-URI"]);
							},
							define() {
								this.manifest.definitions = this.manifest.definitions || {};
								let t = (e, t) => {
									if (e in this.manifest.definitions) {
										this.trigger("error", { message: `EXT-X-DEFINE: Duplicate name ${e}` });
										return;
									}
									this.manifest.definitions[e] = t;
								};
								if ("QUERYPARAM" in e.attributes) {
									if ("NAME" in e.attributes || "IMPORT" in e.attributes) {
										this.trigger("error", { message: "EXT-X-DEFINE: Invalid attributes" });
										return;
									}
									let n = this.params.get(e.attributes.QUERYPARAM);
									if (!n) {
										this.trigger("error", { message: `EXT-X-DEFINE: No query param ${e.attributes.QUERYPARAM}` });
										return;
									}
									t(e.attributes.QUERYPARAM, decodeURIComponent(n));
									return;
								}
								if ("NAME" in e.attributes) {
									if ("IMPORT" in e.attributes) {
										this.trigger("error", { message: "EXT-X-DEFINE: Invalid attributes" });
										return;
									}
									if (!("VALUE" in e.attributes) || typeof e.attributes.VALUE != "string") {
										this.trigger("error", { message: `EXT-X-DEFINE: No value for ${e.attributes.NAME}` });
										return;
									}
									t(e.attributes.NAME, e.attributes.VALUE);
									return;
								}
								if ("IMPORT" in e.attributes) {
									if (!this.mainDefinitions[e.attributes.IMPORT]) {
										this.trigger("error", { message: `EXT-X-DEFINE: No value ${e.attributes.IMPORT} to import, or IMPORT used on main playlist` });
										return;
									}
									t(e.attributes.IMPORT, this.mainDefinitions[e.attributes.IMPORT]);
									return;
								}
								this.trigger("error", { message: "EXT-X-DEFINE: No attribute" });
							},
							"i-frame-playlist"() {
								this.manifest.iFramePlaylists.push({
									attributes: e.attributes,
									uri: e.uri,
									timeline: l
								}), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", e.attributes, ["BANDWIDTH", "URI"]);
							}
						}[e.tagType] || s).call(t);
					},
					uri() {
						r.uri = e.uri, n.push(r), this.manifest.targetDuration && !("duration" in r) && (this.trigger("warn", { message: "defaulting segment duration to the target duration" }), r.duration = this.manifest.targetDuration), a && (r.key = a), r.timeline = l, i && (r.map = i), d = 0, this.lastProgramDateTime !== null && (r.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += r.duration * 1e3), r = {};
					},
					comment() {},
					custom() {
						e.segment ? (r.custom = r.custom || {}, r.custom[e.customType] = e.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[e.customType] = e.data);
					}
				})[e.type].call(t);
			});
		}
		requiredCompatibilityversion(e, t) {
			(e < t || !e) && this.trigger("warn", { message: `manifest must be at least version ${t}` });
		}
		warnOnMissingAttributes_(e, t, n) {
			let r = [];
			n.forEach(function(e) {
				t.hasOwnProperty(e) || r.push(e);
			}), r.length && this.trigger("warn", { message: `${e} lacks required attribute(s): ${r.join(", ")}` });
		}
		push(e) {
			this.lineStream.push(e);
		}
		end() {
			this.lineStream.push("\n"), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", { message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag" }), this.lastProgramDateTime = null, this.trigger("end");
		}
		addParser(e) {
			this.parseStream.addParser(e);
		}
		addTagMapper(e) {
			this.parseStream.addTagMapper(e);
		}
	};
})), JF, YF, XF, ZF, QF, $F, eI, tI, nI, rI, iI, aI, oI = o((() => {
	JF = /* @__PURE__ */ u(dF()), YF = {
		mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
		webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
		ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
		video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
		audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
		text: /^(stpp.ttml.im1t)/,
		muxerVideo: /^(avc0?1)/,
		muxerAudio: /^(mp4a)/,
		muxerText: /a^/
	}, XF = [
		"video",
		"audio",
		"text"
	], ZF = [
		"Video",
		"Audio",
		"Text"
	], QF = function(e) {
		return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(e, t, n) {
			var r = ("00" + Number(t).toString(16)).slice(-2), i = ("00" + Number(n).toString(16)).slice(-2);
			return "avc1." + r + "00" + i;
		});
	}, $F = function(e) {
		e === void 0 && (e = "");
		var t = e.split(","), n = [];
		return t.forEach(function(e) {
			e = e.trim();
			var t;
			XF.forEach(function(r) {
				var i = YF[r].exec(e.toLowerCase());
				if (!(!i || i.length <= 1)) {
					t = r;
					var a = e.substring(0, i[1].length), o = e.replace(a, "");
					n.push({
						type: a,
						details: o,
						mediaType: r
					});
				}
			}), t || n.push({
				type: e,
				details: "",
				mediaType: "unknown"
			});
		}), n;
	}, eI = function(e, t) {
		if (!e.mediaGroups.AUDIO || !t) return null;
		var n = e.mediaGroups.AUDIO[t];
		if (!n) return null;
		for (var r in n) {
			var i = n[r];
			if (i.default && i.playlists) return $F(i.playlists[0].attributes.CODECS);
		}
		return null;
	}, tI = function(e) {
		return e === void 0 && (e = ""), YF.audio.test(e.trim().toLowerCase());
	}, nI = function(e) {
		return e === void 0 && (e = ""), YF.text.test(e.trim().toLowerCase());
	}, rI = function(e) {
		if (!(!e || typeof e != "string")) {
			var t = e.toLowerCase().split(",").map(function(e) {
				return QF(e.trim());
			}), n = "video";
			t.length === 1 && tI(t[0]) ? n = "audio" : t.length === 1 && nI(t[0]) && (n = "application");
			var r = "mp4";
			return t.every(function(e) {
				return YF.mp4.test(e);
			}) ? r = "mp4" : t.every(function(e) {
				return YF.webm.test(e);
			}) ? r = "webm" : t.every(function(e) {
				return YF.ogg.test(e);
			}) && (r = "ogg"), n + "/" + r + ";codecs=\"" + e + "\"";
		}
	}, iI = function(e, t) {
		return e === void 0 && (e = ""), t === void 0 && (t = !1), JF.default.MediaSource && JF.default.MediaSource.isTypeSupported && JF.default.MediaSource.isTypeSupported(rI(e)) || t && JF.default.ManagedMediaSource && JF.default.ManagedMediaSource.isTypeSupported && JF.default.ManagedMediaSource.isTypeSupported(rI(e)) || !1;
	}, aI = function(e) {
		return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(e) {
			e = e.trim();
			for (var t = 0; t < ZF.length; t++) if (YF["muxer" + ZF[t]].test(e)) return !0;
			return !1;
		});
	};
})), sI, cI, lI, uI = o((() => {
	sI = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, cI = /^application\/dash\+xml/i, lI = function(e) {
		return sI.test(e) ? "hls" : cI.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
	};
})), dI, fI, pI, mI, hI, gI, _I, vI, yI, bI, xI, SI, CI, wI, TI = o((() => {
	dI = /* @__PURE__ */ u(dF()), fI = function(e) {
		return e.toString(2).length;
	}, pI = function(e) {
		return Math.ceil(fI(e) / 8);
	}, mI = function(e) {
		return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
	}, hI = function(e) {
		return mI(e);
	}, gI = function(e) {
		return e instanceof Uint8Array ? e : (!Array.isArray(e) && !hI(e) && !(e instanceof ArrayBuffer) && (e = typeof e != "number" || typeof e == "number" && e !== e ? 0 : [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
	}, _I = dI.default.BigInt || Number, vI = [
		_I("0x1"),
		_I("0x100"),
		_I("0x10000"),
		_I("0x1000000"),
		_I("0x100000000"),
		_I("0x10000000000"),
		_I("0x1000000000000"),
		_I("0x100000000000000"),
		_I("0x10000000000000000")
	], function() {
		var e = new Uint16Array([65484]), t = new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
		return t[0] === 255 ? "big" : t[0] === 204 ? "little" : "unknown";
	}(), yI = function(e, t) {
		var n = t === void 0 ? {} : t, r = n.signed, i = r !== void 0 && r, a = n.le, o = a !== void 0 && a;
		e = gI(e);
		var s = o ? "reduce" : "reduceRight", c = (e[s] ? e[s] : Array.prototype[s]).call(e, function(t, n, r) {
			var i = o ? r : Math.abs(r + 1 - e.length);
			return t + _I(n) * vI[i];
		}, _I(0));
		if (i) {
			var l = vI[e.length] / _I(2) - _I(1);
			c = _I(c), c > l && (c -= l, c -= l, c -= _I(2));
		}
		return Number(c);
	}, bI = function(e, t) {
		var n = (t === void 0 ? {} : t).le, r = n !== void 0 && n;
		(typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = _I(e);
		for (var i = pI(e), a = new Uint8Array(new ArrayBuffer(i)), o = 0; o < i; o++) {
			var s = r ? o : Math.abs(o + 1 - a.length);
			a[s] = Number(e / vI[o] & _I(255)), e < 0 && (a[s] = Math.abs(~a[s]), a[s] -= o === 0 ? 1 : 2);
		}
		return a;
	}, xI = function(e) {
		if (!e) return "";
		e = Array.prototype.slice.call(e);
		var t = String.fromCharCode.apply(null, gI(e));
		try {
			return decodeURIComponent(escape(t));
		} catch {}
		return t;
	}, SI = function(e, t) {
		if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string") return /* @__PURE__ */ new Uint8Array();
		t || (e = unescape(encodeURIComponent(e)));
		for (var n = new Uint8Array(e.length), r = 0; r < e.length; r++) n[r] = e.charCodeAt(r);
		return n;
	}, CI = function() {
		var e = [...arguments];
		if (e = e.filter(function(e) {
			return e && (e.byteLength || e.length) && typeof e != "string";
		}), e.length <= 1) return gI(e[0]);
		var t = e.reduce(function(e, t, n) {
			return e + (t.byteLength || t.length);
		}, 0), n = new Uint8Array(t), r = 0;
		return e.forEach(function(e) {
			e = gI(e), n.set(e, r), r += e.byteLength;
		}), n;
	}, wI = function(e, t, n) {
		var r = n === void 0 ? {} : n, i = r.offset, a = i === void 0 ? 0 : i, o = r.mask, s = o === void 0 ? [] : o;
		e = gI(e), t = gI(t);
		var c = t.every ? t.every : Array.prototype.every;
		return t.length && e.length - a >= t.length && c.call(t, function(t, n) {
			return t === (s[n] ? s[n] & e[a + n] : e[a + n]);
		});
	};
})), EI, DI = o((() => {
	EI = function(e, t, n) {
		t.forEach(function(t) {
			for (var r in e.mediaGroups[t]) for (var i in e.mediaGroups[t][r]) {
				var a = e.mediaGroups[t][r][i];
				n(a, t, r, i);
			}
		});
	};
})), OI = /* @__PURE__ */ s(((e) => {
	function t(e, t, n) {
		if (n === void 0 && (n = Array.prototype), e && typeof n.find == "function") return n.find.call(e, t);
		for (var r = 0; r < e.length; r++) if (Object.prototype.hasOwnProperty.call(e, r)) {
			var i = e[r];
			if (t.call(void 0, i, r, e)) return i;
		}
	}
	function n(e, t) {
		return t === void 0 && (t = Object), t && typeof t.freeze == "function" ? t.freeze(e) : e;
	}
	function r(e, t) {
		if (typeof e != "object" || !e) throw TypeError("target is not an object");
		for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
		return e;
	}
	var i = n({
		HTML: "text/html",
		isHTML: function(e) {
			return e === i.HTML;
		},
		XML_APPLICATION: "application/xml",
		XML_TEXT: "text/xml",
		XML_XHTML_APPLICATION: "application/xhtml+xml",
		XML_SVG_IMAGE: "image/svg+xml"
	}), a = n({
		HTML: "http://www.w3.org/1999/xhtml",
		isHTML: function(e) {
			return e === a.HTML;
		},
		SVG: "http://www.w3.org/2000/svg",
		XML: "http://www.w3.org/XML/1998/namespace",
		XMLNS: "http://www.w3.org/2000/xmlns/"
	});
	e.assign = r, e.find = t, e.freeze = n, e.MIME_TYPE = i, e.NAMESPACE = a;
})), kI = /* @__PURE__ */ s(((e) => {
	var t = OI(), n = t.find, r = t.NAMESPACE;
	function i(e) {
		return e !== "";
	}
	function a(e) {
		return e ? e.split(/[\t\n\f\r ]+/).filter(i) : [];
	}
	function o(e, t) {
		return e.hasOwnProperty(t) || (e[t] = !0), e;
	}
	function s(e) {
		if (!e) return [];
		var t = a(e);
		return Object.keys(t.reduce(o, {}));
	}
	function c(e) {
		return function(t) {
			return e && e.indexOf(t) !== -1;
		};
	}
	function l(e, t) {
		for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
	}
	function u(e, t) {
		var n = e.prototype;
		if (!(n instanceof t)) {
			function r() {}
			r.prototype = t.prototype, r = new r(), l(n, r), e.prototype = n = r;
		}
		n.constructor != e && (typeof e != "function" && console.error("unknown Class:" + e), n.constructor = e);
	}
	var d = {}, f = d.ELEMENT_NODE = 1, p = d.ATTRIBUTE_NODE = 2, m = d.TEXT_NODE = 3, h = d.CDATA_SECTION_NODE = 4, g = d.ENTITY_REFERENCE_NODE = 5, _ = d.ENTITY_NODE = 6, v = d.PROCESSING_INSTRUCTION_NODE = 7, y = d.COMMENT_NODE = 8, b = d.DOCUMENT_NODE = 9, x = d.DOCUMENT_TYPE_NODE = 10, S = d.DOCUMENT_FRAGMENT_NODE = 11, C = d.NOTATION_NODE = 12, w = {}, T = {};
	w.INDEX_SIZE_ERR = (T[1] = "Index size error", 1), w.DOMSTRING_SIZE_ERR = (T[2] = "DOMString size error", 2);
	var E = w.HIERARCHY_REQUEST_ERR = (T[3] = "Hierarchy request error", 3);
	w.WRONG_DOCUMENT_ERR = (T[4] = "Wrong document", 4);
	var ee = w.INVALID_CHARACTER_ERR = (T[5] = "Invalid character", 5);
	w.NO_DATA_ALLOWED_ERR = (T[6] = "No data allowed", 6), w.NO_MODIFICATION_ALLOWED_ERR = (T[7] = "No modification allowed", 7);
	var D = w.NOT_FOUND_ERR = (T[8] = "Not found", 8);
	w.NOT_SUPPORTED_ERR = (T[9] = "Not supported", 9);
	var O = w.INUSE_ATTRIBUTE_ERR = (T[10] = "Attribute in use", 10), te = w.INVALID_STATE_ERR = (T[11] = "Invalid state", 11);
	w.SYNTAX_ERR = (T[12] = "Syntax error", 12), w.INVALID_MODIFICATION_ERR = (T[13] = "Invalid modification", 13), w.NAMESPACE_ERR = (T[14] = "Invalid namespace", 14), w.INVALID_ACCESS_ERR = (T[15] = "Invalid access", 15);
	function k(e, t) {
		if (t instanceof Error) var n = t;
		else n = this, Error.call(this, T[e]), this.message = T[e], Error.captureStackTrace && Error.captureStackTrace(this, k);
		return n.code = e, t && (this.message = this.message + ": " + t), n;
	}
	k.prototype = Error.prototype, l(w, k);
	function ne() {}
	ne.prototype = {
		length: 0,
		item: function(e) {
			return e >= 0 && e < this.length ? this[e] : null;
		},
		toString: function(e, t, n) {
			for (var r = !!n && !!n.requireWellFormed, i = [], a = 0; a < this.length; a++) We(this[a], i, e, t, null, r);
			return i.join("");
		},
		filter: function(e) {
			return Array.prototype.filter.call(this, e);
		},
		indexOf: function(e) {
			return Array.prototype.indexOf.call(this, e);
		}
	};
	function re(e, t) {
		this._node = e, this._refresh = t, ie(this);
	}
	function ie(e) {
		var t = e._node._inc || e._node.ownerDocument._inc;
		if (e._inc !== t) {
			var n = e._refresh(e._node);
			if (qe(e, "length", n.length), !e.$$length || n.length < e.$$length) for (var r = n.length; r in e; r++) Object.prototype.hasOwnProperty.call(e, r) && delete e[r];
			l(n, e), e._inc = t;
		}
	}
	re.prototype.item = function(e) {
		return ie(this), this[e] || null;
	}, u(re, ne);
	function ae() {}
	function A(e, t) {
		for (var n = e.length; n--;) if (e[n] === t) return n;
	}
	function oe(e, t, n, r) {
		if (r ? t[A(t, r)] = n : t[t.length++] = n, e) {
			n.ownerElement = e;
			var i = e.ownerDocument;
			i && (r && me(i, e, r), pe(i, e, n));
		}
	}
	function se(e, t, n) {
		var r = A(t, n);
		if (r >= 0) {
			for (var i = t.length - 1; r < i;) t[r] = t[++r];
			if (t.length = i, e) {
				var a = e.ownerDocument;
				a && (me(a, e, n), n.ownerElement = null);
			}
		} else throw new k(D, /* @__PURE__ */ Error(e.tagName + "@" + n));
	}
	ae.prototype = {
		length: 0,
		item: ne.prototype.item,
		getNamedItem: function(e) {
			for (var t = this.length; t--;) {
				var n = this[t];
				if (n.nodeName == e) return n;
			}
		},
		setNamedItem: function(e) {
			var t = e.ownerElement;
			if (t && t != this._ownerElement) throw new k(O);
			var n = this.getNamedItem(e.nodeName);
			return oe(this._ownerElement, this, e, n), n;
		},
		setNamedItemNS: function(e) {
			var t = e.ownerElement, n;
			if (t && t != this._ownerElement) throw new k(O);
			return n = this.getNamedItemNS(e.namespaceURI, e.localName), oe(this._ownerElement, this, e, n), n;
		},
		removeNamedItem: function(e) {
			var t = this.getNamedItem(e);
			return se(this._ownerElement, this, t), t;
		},
		removeNamedItemNS: function(e, t) {
			var n = this.getNamedItemNS(e, t);
			return se(this._ownerElement, this, n), n;
		},
		getNamedItemNS: function(e, t) {
			for (var n = this.length; n--;) {
				var r = this[n];
				if (r.localName == t && r.namespaceURI == e) return r;
			}
			return null;
		}
	};
	function ce() {}
	ce.prototype = {
		hasFeature: function(e, t) {
			return !0;
		},
		createDocument: function(e, t, n) {
			var r = new fe();
			if (r.implementation = this, r.childNodes = new ne(), r.doctype = n || null, n && r.appendChild(n), t) {
				var i = r.createElementNS(e, t);
				r.appendChild(i);
			}
			return r;
		},
		createDocumentType: function(e, t, n) {
			var r = new N();
			return r.name = e, r.nodeName = e, r.publicId = t || "", r.systemId = n || "", r;
		}
	};
	function le() {}
	le.prototype = {
		firstChild: null,
		lastChild: null,
		previousSibling: null,
		nextSibling: null,
		attributes: null,
		parentNode: null,
		childNodes: null,
		ownerDocument: null,
		nodeValue: null,
		namespaceURI: null,
		prefix: null,
		localName: null,
		insertBefore: function(e, t) {
			return M(this, e, t);
		},
		replaceChild: function(e, t) {
			M(this, e, t, Ee), t && this.removeChild(t);
		},
		removeChild: function(e) {
			return ge(this, e);
		},
		appendChild: function(e) {
			return this.insertBefore(e, null);
		},
		hasChildNodes: function() {
			return this.firstChild != null;
		},
		cloneNode: function(e) {
			return Ke(this.ownerDocument || this, this, e);
		},
		normalize: function() {
			de(this, null, { enter: function(e) {
				for (var t = e.firstChild; t;) {
					var n = t.nextSibling;
					n !== null && n.nodeType === m && t.nodeType === m ? (e.removeChild(n), t.appendData(n.data)) : t = n;
				}
				return !0;
			} });
		},
		isSupported: function(e, t) {
			return this.ownerDocument.implementation.hasFeature(e, t);
		},
		hasAttributes: function() {
			return this.attributes.length > 0;
		},
		lookupPrefix: function(e) {
			for (var t = this; t;) {
				var n = t._nsMap;
				if (n) {
					for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r) && n[r] === e) return r;
				}
				t = t.nodeType == p ? t.ownerDocument : t.parentNode;
			}
			return null;
		},
		lookupNamespaceURI: function(e) {
			for (var t = this; t;) {
				var n = t._nsMap;
				if (n && Object.prototype.hasOwnProperty.call(n, e)) return n[e];
				t = t.nodeType == p ? t.ownerDocument : t.parentNode;
			}
			return null;
		},
		isDefaultNamespace: function(e) {
			return this.lookupPrefix(e) == null;
		}
	};
	function j(e) {
		return e == "<" && "&lt;" || e == ">" && "&gt;" || e == "&" && "&amp;" || e == "\"" && "&quot;" || "&#" + e.charCodeAt() + ";";
	}
	l(d, le), l(d, le.prototype);
	function ue(e, t) {
		return de(e, null, { enter: function(e) {
			return !t(e) || de.STOP;
		} }) === de.STOP;
	}
	function de(e, t, n) {
		for (var r = [{
			node: e,
			context: t,
			phase: de.ENTER
		}]; r.length > 0;) {
			var i = r.pop();
			if (i.phase === de.ENTER) {
				var a = n.enter(i.node, i.context);
				if (a === de.STOP) return de.STOP;
				if (r.push({
					node: i.node,
					context: a,
					phase: de.EXIT
				}), a == null) continue;
				for (var o = i.node.lastChild; o;) r.push({
					node: o,
					context: a,
					phase: de.ENTER
				}), o = o.previousSibling;
			} else n.exit && n.exit(i.node, i.context);
		}
	}
	de.STOP = Symbol("walkDOM.STOP"), de.ENTER = 0, de.EXIT = 1;
	function fe() {
		this.ownerDocument = this;
	}
	function pe(e, t, n) {
		e && e._inc++, n.namespaceURI === r.XMLNS && (t._nsMap[n.prefix ? n.localName : ""] = n.value);
	}
	function me(e, t, n, i) {
		e && e._inc++, n.namespaceURI === r.XMLNS && delete t._nsMap[n.prefix ? n.localName : ""];
	}
	function he(e, t, n) {
		if (e && e._inc) {
			e._inc++;
			var r = t.childNodes;
			if (n) r[r.length++] = n;
			else {
				for (var i = t.firstChild, a = 0; i;) r[a++] = i, i = i.nextSibling;
				r.length = a, delete r[r.length];
			}
		}
	}
	function ge(e, t) {
		var n = t.previousSibling, r = t.nextSibling;
		return n ? n.nextSibling = r : e.firstChild = r, r ? r.previousSibling = n : e.lastChild = n, t.parentNode = null, t.previousSibling = null, t.nextSibling = null, he(e.ownerDocument, e), t;
	}
	function _e(e) {
		return e && (e.nodeType === le.DOCUMENT_NODE || e.nodeType === le.DOCUMENT_FRAGMENT_NODE || e.nodeType === le.ELEMENT_NODE);
	}
	function ve(e) {
		return e && (be(e) || xe(e) || ye(e) || e.nodeType === le.DOCUMENT_FRAGMENT_NODE || e.nodeType === le.COMMENT_NODE || e.nodeType === le.PROCESSING_INSTRUCTION_NODE);
	}
	function ye(e) {
		return e && e.nodeType === le.DOCUMENT_TYPE_NODE;
	}
	function be(e) {
		return e && e.nodeType === le.ELEMENT_NODE;
	}
	function xe(e) {
		return e && e.nodeType === le.TEXT_NODE;
	}
	function Se(e, t) {
		var r = e.childNodes || [];
		if (n(r, be) || ye(t)) return !1;
		var i = n(r, ye);
		return !(t && i && r.indexOf(i) > r.indexOf(t));
	}
	function Ce(e, t) {
		var r = e.childNodes || [];
		function i(e) {
			return be(e) && e !== t;
		}
		if (n(r, i)) return !1;
		var a = n(r, ye);
		return !(t && a && r.indexOf(a) > r.indexOf(t));
	}
	function we(e, t, n) {
		if (!_e(e)) throw new k(E, "Unexpected parent node type " + e.nodeType);
		if (n && n.parentNode !== e) throw new k(D, "child not in parent");
		if (!ve(t) || ye(t) && e.nodeType !== le.DOCUMENT_NODE) throw new k(E, "Unexpected node type " + t.nodeType + " for parent node type " + e.nodeType);
	}
	function Te(e, t, r) {
		var i = e.childNodes || [], a = t.childNodes || [];
		if (t.nodeType === le.DOCUMENT_FRAGMENT_NODE) {
			var o = a.filter(be);
			if (o.length > 1 || n(a, xe)) throw new k(E, "More than one element or text in fragment");
			if (o.length === 1 && !Se(e, r)) throw new k(E, "Element in fragment can not be inserted before doctype");
		}
		if (be(t) && !Se(e, r)) throw new k(E, "Only one element can be added and only after doctype");
		if (ye(t)) {
			if (n(i, ye)) throw new k(E, "Only one doctype is allowed");
			var s = n(i, be);
			if (r && i.indexOf(s) < i.indexOf(r)) throw new k(E, "Doctype can only be inserted before an element");
			if (!r && s) throw new k(E, "Doctype can not be appended since element is present");
		}
	}
	function Ee(e, t, r) {
		var i = e.childNodes || [], a = t.childNodes || [];
		if (t.nodeType === le.DOCUMENT_FRAGMENT_NODE) {
			var o = a.filter(be);
			if (o.length > 1 || n(a, xe)) throw new k(E, "More than one element or text in fragment");
			if (o.length === 1 && !Ce(e, r)) throw new k(E, "Element in fragment can not be inserted before doctype");
		}
		if (be(t) && !Ce(e, r)) throw new k(E, "Only one element can be added and only after doctype");
		if (ye(t)) {
			function e(e) {
				return ye(e) && e !== r;
			}
			if (n(i, e)) throw new k(E, "Only one doctype is allowed");
			var s = n(i, be);
			if (r && i.indexOf(s) < i.indexOf(r)) throw new k(E, "Doctype can only be inserted before an element");
		}
	}
	function M(e, t, n, r) {
		we(e, t, n), e.nodeType === le.DOCUMENT_NODE && (r || Te)(e, t, n);
		var i = t.parentNode;
		if (i && i.removeChild(t), t.nodeType === S) {
			var a = t.firstChild;
			if (a == null) return t;
			var o = t.lastChild;
		} else a = o = t;
		var s = n ? n.previousSibling : e.lastChild;
		a.previousSibling = s, o.nextSibling = n, s ? s.nextSibling = a : e.firstChild = a, n == null ? e.lastChild = o : n.previousSibling = o;
		do {
			a.parentNode = e;
			var c = e.ownerDocument || e;
			De(a, c);
		} while (a !== o && (a = a.nextSibling));
		return he(e.ownerDocument || e, e), t.nodeType == S && (t.firstChild = t.lastChild = null), t;
	}
	function De(e, t) {
		if (e.ownerDocument !== t) {
			if (e.ownerDocument = t, e.nodeType === f && e.attributes) for (var n = 0; n < e.attributes.length; n++) {
				var r = e.attributes.item(n);
				r && (r.ownerDocument = t);
			}
			for (var i = e.firstChild; i;) De(i, t), i = i.nextSibling;
		}
	}
	function Oe(e, t) {
		return t.parentNode && t.parentNode.removeChild(t), t.parentNode = e, t.previousSibling = e.lastChild, t.nextSibling = null, t.previousSibling ? t.previousSibling.nextSibling = t : e.firstChild = t, e.lastChild = t, he(e.ownerDocument, e, t), De(t, e.ownerDocument || e), t;
	}
	fe.prototype = {
		nodeName: "#document",
		nodeType: b,
		doctype: null,
		documentElement: null,
		_inc: 1,
		insertBefore: function(e, t) {
			if (e.nodeType == S) {
				for (var n = e.firstChild; n;) {
					var r = n.nextSibling;
					this.insertBefore(n, t), n = r;
				}
				return e;
			}
			return M(this, e, t), De(e, this), this.documentElement === null && e.nodeType === f && (this.documentElement = e), e;
		},
		removeChild: function(e) {
			return this.documentElement == e && (this.documentElement = null), ge(this, e);
		},
		replaceChild: function(e, t) {
			M(this, e, t, Ee), De(e, this), t && this.removeChild(t), be(e) && (this.documentElement = e);
		},
		importNode: function(e, t) {
			return Ge(this, e, t);
		},
		getElementById: function(e) {
			var t = null;
			return ue(this.documentElement, function(n) {
				if (n.nodeType == f && n.getAttribute("id") == e) return t = n, !0;
			}), t;
		},
		getElementsByClassName: function(e) {
			var t = s(e);
			return new re(this, function(n) {
				var r = [];
				return t.length > 0 && ue(n.documentElement, function(i) {
					if (i !== n && i.nodeType === f) {
						var a = i.getAttribute("class");
						if (a) {
							var o = e === a;
							if (!o) {
								var l = s(a);
								o = t.every(c(l));
							}
							o && r.push(i);
						}
					}
				}), r;
			});
		},
		createElement: function(e) {
			var t = new ke();
			t.ownerDocument = this, t.nodeName = e, t.tagName = e, t.localName = e, t.childNodes = new ne();
			var n = t.attributes = new ae();
			return n._ownerElement = t, t;
		},
		createDocumentFragment: function() {
			var e = new Re();
			return e.ownerDocument = this, e.childNodes = new ne(), e;
		},
		createTextNode: function(e) {
			var t = new Me();
			return t.ownerDocument = this, t.appendData(e), t;
		},
		createComment: function(e) {
			var t = new Ne();
			return t.ownerDocument = this, t.appendData(e), t;
		},
		createCDATASection: function(e) {
			if (e.indexOf("]]>") !== -1) throw new k(ee, "data contains \"]]>\"");
			var t = new Pe();
			return t.ownerDocument = this, t.appendData(e), t;
		},
		createProcessingInstruction: function(e, t) {
			var n = new ze();
			return n.ownerDocument = this, n.tagName = n.nodeName = n.target = e, n.nodeValue = n.data = t, n;
		},
		createAttribute: function(e) {
			var t = new Ae();
			return t.ownerDocument = this, t.name = e, t.nodeName = e, t.localName = e, t.specified = !0, t;
		},
		createEntityReference: function(e) {
			var t = new Le();
			return t.ownerDocument = this, t.nodeName = e, t;
		},
		createElementNS: function(e, t) {
			var n = new ke(), r = t.split(":"), i = n.attributes = new ae();
			return n.childNodes = new ne(), n.ownerDocument = this, n.nodeName = t, n.tagName = t, n.namespaceURI = e, r.length == 2 ? (n.prefix = r[0], n.localName = r[1]) : n.localName = t, i._ownerElement = n, n;
		},
		createAttributeNS: function(e, t) {
			var n = new Ae(), r = t.split(":");
			return n.ownerDocument = this, n.nodeName = t, n.name = t, n.namespaceURI = e, n.specified = !0, r.length == 2 ? (n.prefix = r[0], n.localName = r[1]) : n.localName = t, n;
		}
	}, u(fe, le);
	function ke() {
		this._nsMap = {};
	}
	ke.prototype = {
		nodeType: f,
		hasAttribute: function(e) {
			return this.getAttributeNode(e) != null;
		},
		getAttribute: function(e) {
			var t = this.getAttributeNode(e);
			return t && t.value || "";
		},
		getAttributeNode: function(e) {
			return this.attributes.getNamedItem(e);
		},
		setAttribute: function(e, t) {
			var n = this.ownerDocument.createAttribute(e);
			n.value = n.nodeValue = "" + t, this.setAttributeNode(n);
		},
		removeAttribute: function(e) {
			var t = this.getAttributeNode(e);
			t && this.removeAttributeNode(t);
		},
		appendChild: function(e) {
			return e.nodeType === S ? this.insertBefore(e, null) : Oe(this, e);
		},
		setAttributeNode: function(e) {
			return this.attributes.setNamedItem(e);
		},
		setAttributeNodeNS: function(e) {
			return this.attributes.setNamedItemNS(e);
		},
		removeAttributeNode: function(e) {
			return this.attributes.removeNamedItem(e.nodeName);
		},
		removeAttributeNS: function(e, t) {
			var n = this.getAttributeNodeNS(e, t);
			n && this.removeAttributeNode(n);
		},
		hasAttributeNS: function(e, t) {
			return this.getAttributeNodeNS(e, t) != null;
		},
		getAttributeNS: function(e, t) {
			var n = this.getAttributeNodeNS(e, t);
			return n && n.value || "";
		},
		setAttributeNS: function(e, t, n) {
			var r = this.ownerDocument.createAttributeNS(e, t);
			r.value = r.nodeValue = "" + n, this.setAttributeNode(r);
		},
		getAttributeNodeNS: function(e, t) {
			return this.attributes.getNamedItemNS(e, t);
		},
		getElementsByTagName: function(e) {
			return new re(this, function(t) {
				var n = [];
				return ue(t, function(r) {
					r !== t && r.nodeType == f && (e === "*" || r.tagName == e) && n.push(r);
				}), n;
			});
		},
		getElementsByTagNameNS: function(e, t) {
			return new re(this, function(n) {
				var r = [];
				return ue(n, function(i) {
					i !== n && i.nodeType === f && (e === "*" || i.namespaceURI === e) && (t === "*" || i.localName == t) && r.push(i);
				}), r;
			});
		}
	}, fe.prototype.getElementsByTagName = ke.prototype.getElementsByTagName, fe.prototype.getElementsByTagNameNS = ke.prototype.getElementsByTagNameNS, u(ke, le);
	function Ae() {}
	Ae.prototype.nodeType = p, u(Ae, le);
	function je() {}
	je.prototype = {
		data: "",
		substringData: function(e, t) {
			return this.data.substring(e, e + t);
		},
		appendData: function(e) {
			e = this.data + e, this.nodeValue = this.data = e, this.length = e.length;
		},
		insertData: function(e, t) {
			this.replaceData(e, 0, t);
		},
		appendChild: function(e) {
			throw Error(T[E]);
		},
		deleteData: function(e, t) {
			this.replaceData(e, t, "");
		},
		replaceData: function(e, t, n) {
			var r = this.data.substring(0, e), i = this.data.substring(e + t);
			n = r + n + i, this.nodeValue = this.data = n, this.length = n.length;
		}
	}, u(je, le);
	function Me() {}
	Me.prototype = {
		nodeName: "#text",
		nodeType: m,
		splitText: function(e) {
			var t = this.data, n = t.substring(e);
			t = t.substring(0, e), this.data = this.nodeValue = t, this.length = t.length;
			var r = this.ownerDocument.createTextNode(n);
			return this.parentNode && this.parentNode.insertBefore(r, this.nextSibling), r;
		}
	}, u(Me, je);
	function Ne() {}
	Ne.prototype = {
		nodeName: "#comment",
		nodeType: y
	}, u(Ne, je);
	function Pe() {}
	Pe.prototype = {
		nodeName: "#cdata-section",
		nodeType: h
	}, u(Pe, je);
	function N() {}
	N.prototype.nodeType = x, u(N, le);
	function Fe() {}
	Fe.prototype.nodeType = C, u(Fe, le);
	function Ie() {}
	Ie.prototype.nodeType = _, u(Ie, le);
	function Le() {}
	Le.prototype.nodeType = g, u(Le, le);
	function Re() {}
	Re.prototype.nodeName = "#document-fragment", Re.prototype.nodeType = S, u(Re, le);
	function ze() {}
	ze.prototype.nodeType = v, u(ze, le);
	function Be() {}
	Be.prototype.serializeToString = function(e, t, n, r) {
		return Ve.call(e, t, n, r);
	}, le.prototype.toString = Ve;
	function Ve(e, t, n) {
		var r = !!n && !!n.requireWellFormed, i = [], a = this.nodeType == 9 && this.documentElement || this, o = a.prefix, s = a.namespaceURI;
		if (s && o == null) {
			var o = a.lookupPrefix(s);
			if (o == null) var c = [{
				namespace: s,
				prefix: null
			}];
		}
		return We(this, i, e, t, c, r), i.join("");
	}
	function He(e, t, n) {
		var i = e.prefix || "", a = e.namespaceURI;
		if (!a || i === "xml" && a === r.XML || a === r.XMLNS) return !1;
		for (var o = n.length; o--;) {
			var s = n[o];
			if (s.prefix === i) return s.namespace !== a;
		}
		return !0;
	}
	function Ue(e, t, n) {
		e.push(" ", t, "=\"", n.replace(/[<>&"\t\n\r]/g, j), "\"");
	}
	function We(e, t, n, i, a, o) {
		a ||= [], de(e, {
			ns: a,
			isHTML: n
		}, {
			enter: function(e, n) {
				var a = n.ns, s = n.isHTML;
				if (i) if (e = i(e), e) {
					if (typeof e == "string") return t.push(e), null;
				} else return null;
				switch (e.nodeType) {
					case f:
						var c = e.attributes, l = c.length, u = e.tagName;
						s = r.isHTML(e.namespaceURI) || s;
						var d = u;
						if (!s && !e.prefix && e.namespaceURI) {
							for (var _, C = 0; C < c.length; C++) if (c.item(C).name === "xmlns") {
								_ = c.item(C).value;
								break;
							}
							if (!_) for (var w = a.length - 1; w >= 0; w--) {
								var T = a[w];
								if (T.prefix === "" && T.namespace === e.namespaceURI) {
									_ = T.namespace;
									break;
								}
							}
							if (_ !== e.namespaceURI) for (var w = a.length - 1; w >= 0; w--) {
								var T = a[w];
								if (T.namespace === e.namespaceURI) {
									T.prefix && (d = T.prefix + ":" + u);
									break;
								}
							}
						}
						t.push("<", d);
						for (var E = a.slice(), ee = 0; ee < l; ee++) {
							var D = c.item(ee);
							D.prefix == "xmlns" ? E.push({
								prefix: D.localName,
								namespace: D.value
							}) : D.nodeName == "xmlns" && E.push({
								prefix: "",
								namespace: D.value
							});
						}
						for (var ee = 0; ee < l; ee++) {
							var D = c.item(ee);
							if (He(D, s, E)) {
								var O = D.prefix || "", ne = D.namespaceURI;
								Ue(t, O ? "xmlns:" + O : "xmlns", ne), E.push({
									prefix: O,
									namespace: ne
								});
							}
							var re = i ? i(D) : D;
							re && (typeof re == "string" ? t.push(re) : Ue(t, re.name, re.value));
						}
						if (u === d && He(e, s, E)) {
							var ie = e.prefix || "", ne = e.namespaceURI;
							Ue(t, ie ? "xmlns:" + ie : "xmlns", ne), E.push({
								prefix: ie,
								namespace: ne
							});
						}
						var ae = e.firstChild;
						if (ae || s && !/^(?:meta|link|img|br|hr|input)$/i.test(u)) {
							if (t.push(">"), s && /^script$/i.test(u)) {
								for (; ae;) ae.data ? t.push(ae.data) : We(ae, t, s, i, E.slice(), o), ae = ae.nextSibling;
								return t.push("</", u, ">"), null;
							}
							return {
								ns: E,
								isHTML: s,
								tag: d
							};
						}
						return t.push("/>"), null;
					case b:
					case S: return {
						ns: a.slice(),
						isHTML: s,
						tag: null
					};
					case p: return Ue(t, e.name, e.value), null;
					case m: return t.push(e.data.replace(/[<&>]/g, j)), null;
					case h:
						if (o && e.data.indexOf("]]>") !== -1) throw new k(te, "The CDATASection data contains \"]]>\"");
						return t.push("<![CDATA[", e.data.replace(/]]>/g, "]]]]><![CDATA[>"), "]]>"), null;
					case y:
						if (o && e.data.indexOf("-->") !== -1) throw new k(te, "The comment node data contains \"-->\"");
						return t.push("<!--", e.data, "-->"), null;
					case x:
						if (o) {
							if (e.publicId && !/^("[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%']*"|'[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%'"]*')$/.test(e.publicId)) throw new k(te, "DocumentType publicId is not a valid PubidLiteral");
							if (e.systemId && !/^("[^"]*"|'[^']*')$/.test(e.systemId)) throw new k(te, "DocumentType systemId is not a valid SystemLiteral");
							if (e.internalSubset && e.internalSubset.indexOf("]>") !== -1) throw new k(te, "DocumentType internalSubset contains \"]>\"");
						}
						var A = e.publicId, oe = e.systemId;
						if (t.push("<!DOCTYPE ", e.name), A) t.push(" PUBLIC ", A), oe && oe != "." && t.push(" ", oe), t.push(">");
						else if (oe && oe != ".") t.push(" SYSTEM ", oe, ">");
						else {
							var se = e.internalSubset;
							se && t.push(" [", se, "]"), t.push(">");
						}
						return null;
					case v:
						if (o && e.data.indexOf("?>") !== -1) throw new k(te, "The ProcessingInstruction data contains \"?>\"");
						return t.push("<?", e.target, " ", e.data, "?>"), null;
					case g: return t.push("&", e.nodeName, ";"), null;
					default: return t.push("??", e.nodeName), null;
				}
			},
			exit: function(e, n) {
				n && n.tag && t.push("</", n.tag, ">");
			}
		});
	}
	function Ge(e, t, n) {
		var r;
		return de(t, null, { enter: function(t, i) {
			var a = t.cloneNode(!1);
			return a.ownerDocument = e, a.parentNode = null, i === null ? r = a : i.appendChild(a), t.nodeType === p || n ? a : null;
		} }), r;
	}
	function Ke(e, t, n) {
		var r;
		return de(t, null, { enter: function(t, i) {
			var a = new t.constructor();
			for (var o in t) if (Object.prototype.hasOwnProperty.call(t, o)) {
				var s = t[o];
				typeof s != "object" && s != a[o] && (a[o] = s);
			}
			t.childNodes && (a.childNodes = new ne()), a.ownerDocument = e;
			var c = n;
			switch (a.nodeType) {
				case f:
					var l = t.attributes, u = a.attributes = new ae(), d = l.length;
					u._ownerElement = a;
					for (var m = 0; m < d; m++) a.setAttributeNode(Ke(e, l.item(m), !0));
					break;
				case p: c = !0;
			}
			return i === null ? r = a : i.appendChild(a), c ? a : null;
		} }), r;
	}
	function qe(e, t, n) {
		e[t] = n;
	}
	try {
		Object.defineProperty && (Object.defineProperty(re.prototype, "length", { get: function() {
			return ie(this), this.$$length;
		} }), Object.defineProperty(le.prototype, "textContent", {
			get: function() {
				if (this.nodeType === f || this.nodeType === S) {
					var e = [];
					return de(this, null, { enter: function(t) {
						if (t.nodeType === f || t.nodeType === S) return !0;
						if (t.nodeType === v || t.nodeType === y) return null;
						e.push(t.nodeValue);
					} }), e.join("");
				}
				return this.nodeValue;
			},
			set: function(e) {
				switch (this.nodeType) {
					case f:
					case S:
						for (; this.firstChild;) this.removeChild(this.firstChild);
						(e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
						break;
					default: this.data = e, this.value = e, this.nodeValue = e;
				}
			}
		}), qe = function(e, t, n) {
			e["$$" + t] = n;
		});
	} catch {}
	e.DocumentType = N, e.DOMException = k, e.DOMImplementation = ce, e.Element = ke, e.Node = le, e.NodeList = ne, e.walkDOM = de, e.XMLSerializer = Be;
})), AI = /* @__PURE__ */ s(((e) => {
	var t = OI().freeze;
	e.XML_ENTITIES = t({
		amp: "&",
		apos: "'",
		gt: ">",
		lt: "<",
		quot: "\""
	}), e.HTML_ENTITIES = t({
		Aacute: "Á",
		aacute: "á",
		Abreve: "Ă",
		abreve: "ă",
		ac: "∾",
		acd: "∿",
		acE: "∾̳",
		Acirc: "Â",
		acirc: "â",
		acute: "´",
		Acy: "А",
		acy: "а",
		AElig: "Æ",
		aelig: "æ",
		af: "⁡",
		Afr: "𝔄",
		afr: "𝔞",
		Agrave: "À",
		agrave: "à",
		alefsym: "ℵ",
		aleph: "ℵ",
		Alpha: "Α",
		alpha: "α",
		Amacr: "Ā",
		amacr: "ā",
		amalg: "⨿",
		AMP: "&",
		amp: "&",
		And: "⩓",
		and: "∧",
		andand: "⩕",
		andd: "⩜",
		andslope: "⩘",
		andv: "⩚",
		ang: "∠",
		ange: "⦤",
		angle: "∠",
		angmsd: "∡",
		angmsdaa: "⦨",
		angmsdab: "⦩",
		angmsdac: "⦪",
		angmsdad: "⦫",
		angmsdae: "⦬",
		angmsdaf: "⦭",
		angmsdag: "⦮",
		angmsdah: "⦯",
		angrt: "∟",
		angrtvb: "⊾",
		angrtvbd: "⦝",
		angsph: "∢",
		angst: "Å",
		angzarr: "⍼",
		Aogon: "Ą",
		aogon: "ą",
		Aopf: "𝔸",
		aopf: "𝕒",
		ap: "≈",
		apacir: "⩯",
		apE: "⩰",
		ape: "≊",
		apid: "≋",
		apos: "'",
		ApplyFunction: "⁡",
		approx: "≈",
		approxeq: "≊",
		Aring: "Å",
		aring: "å",
		Ascr: "𝒜",
		ascr: "𝒶",
		Assign: "≔",
		ast: "*",
		asymp: "≈",
		asympeq: "≍",
		Atilde: "Ã",
		atilde: "ã",
		Auml: "Ä",
		auml: "ä",
		awconint: "∳",
		awint: "⨑",
		backcong: "≌",
		backepsilon: "϶",
		backprime: "‵",
		backsim: "∽",
		backsimeq: "⋍",
		Backslash: "∖",
		Barv: "⫧",
		barvee: "⊽",
		Barwed: "⌆",
		barwed: "⌅",
		barwedge: "⌅",
		bbrk: "⎵",
		bbrktbrk: "⎶",
		bcong: "≌",
		Bcy: "Б",
		bcy: "б",
		bdquo: "„",
		becaus: "∵",
		Because: "∵",
		because: "∵",
		bemptyv: "⦰",
		bepsi: "϶",
		bernou: "ℬ",
		Bernoullis: "ℬ",
		Beta: "Β",
		beta: "β",
		beth: "ℶ",
		between: "≬",
		Bfr: "𝔅",
		bfr: "𝔟",
		bigcap: "⋂",
		bigcirc: "◯",
		bigcup: "⋃",
		bigodot: "⨀",
		bigoplus: "⨁",
		bigotimes: "⨂",
		bigsqcup: "⨆",
		bigstar: "★",
		bigtriangledown: "▽",
		bigtriangleup: "△",
		biguplus: "⨄",
		bigvee: "⋁",
		bigwedge: "⋀",
		bkarow: "⤍",
		blacklozenge: "⧫",
		blacksquare: "▪",
		blacktriangle: "▴",
		blacktriangledown: "▾",
		blacktriangleleft: "◂",
		blacktriangleright: "▸",
		blank: "␣",
		blk12: "▒",
		blk14: "░",
		blk34: "▓",
		block: "█",
		bne: "=⃥",
		bnequiv: "≡⃥",
		bNot: "⫭",
		bnot: "⌐",
		Bopf: "𝔹",
		bopf: "𝕓",
		bot: "⊥",
		bottom: "⊥",
		bowtie: "⋈",
		boxbox: "⧉",
		boxDL: "╗",
		boxDl: "╖",
		boxdL: "╕",
		boxdl: "┐",
		boxDR: "╔",
		boxDr: "╓",
		boxdR: "╒",
		boxdr: "┌",
		boxH: "═",
		boxh: "─",
		boxHD: "╦",
		boxHd: "╤",
		boxhD: "╥",
		boxhd: "┬",
		boxHU: "╩",
		boxHu: "╧",
		boxhU: "╨",
		boxhu: "┴",
		boxminus: "⊟",
		boxplus: "⊞",
		boxtimes: "⊠",
		boxUL: "╝",
		boxUl: "╜",
		boxuL: "╛",
		boxul: "┘",
		boxUR: "╚",
		boxUr: "╙",
		boxuR: "╘",
		boxur: "└",
		boxV: "║",
		boxv: "│",
		boxVH: "╬",
		boxVh: "╫",
		boxvH: "╪",
		boxvh: "┼",
		boxVL: "╣",
		boxVl: "╢",
		boxvL: "╡",
		boxvl: "┤",
		boxVR: "╠",
		boxVr: "╟",
		boxvR: "╞",
		boxvr: "├",
		bprime: "‵",
		Breve: "˘",
		breve: "˘",
		brvbar: "¦",
		Bscr: "ℬ",
		bscr: "𝒷",
		bsemi: "⁏",
		bsim: "∽",
		bsime: "⋍",
		bsol: "\\",
		bsolb: "⧅",
		bsolhsub: "⟈",
		bull: "•",
		bullet: "•",
		bump: "≎",
		bumpE: "⪮",
		bumpe: "≏",
		Bumpeq: "≎",
		bumpeq: "≏",
		Cacute: "Ć",
		cacute: "ć",
		Cap: "⋒",
		cap: "∩",
		capand: "⩄",
		capbrcup: "⩉",
		capcap: "⩋",
		capcup: "⩇",
		capdot: "⩀",
		CapitalDifferentialD: "ⅅ",
		caps: "∩︀",
		caret: "⁁",
		caron: "ˇ",
		Cayleys: "ℭ",
		ccaps: "⩍",
		Ccaron: "Č",
		ccaron: "č",
		Ccedil: "Ç",
		ccedil: "ç",
		Ccirc: "Ĉ",
		ccirc: "ĉ",
		Cconint: "∰",
		ccups: "⩌",
		ccupssm: "⩐",
		Cdot: "Ċ",
		cdot: "ċ",
		cedil: "¸",
		Cedilla: "¸",
		cemptyv: "⦲",
		cent: "¢",
		CenterDot: "·",
		centerdot: "·",
		Cfr: "ℭ",
		cfr: "𝔠",
		CHcy: "Ч",
		chcy: "ч",
		check: "✓",
		checkmark: "✓",
		Chi: "Χ",
		chi: "χ",
		cir: "○",
		circ: "ˆ",
		circeq: "≗",
		circlearrowleft: "↺",
		circlearrowright: "↻",
		circledast: "⊛",
		circledcirc: "⊚",
		circleddash: "⊝",
		CircleDot: "⊙",
		circledR: "®",
		circledS: "Ⓢ",
		CircleMinus: "⊖",
		CirclePlus: "⊕",
		CircleTimes: "⊗",
		cirE: "⧃",
		cire: "≗",
		cirfnint: "⨐",
		cirmid: "⫯",
		cirscir: "⧂",
		ClockwiseContourIntegral: "∲",
		CloseCurlyDoubleQuote: "”",
		CloseCurlyQuote: "’",
		clubs: "♣",
		clubsuit: "♣",
		Colon: "∷",
		colon: ":",
		Colone: "⩴",
		colone: "≔",
		coloneq: "≔",
		comma: ",",
		commat: "@",
		comp: "∁",
		compfn: "∘",
		complement: "∁",
		complexes: "ℂ",
		cong: "≅",
		congdot: "⩭",
		Congruent: "≡",
		Conint: "∯",
		conint: "∮",
		ContourIntegral: "∮",
		Copf: "ℂ",
		copf: "𝕔",
		coprod: "∐",
		Coproduct: "∐",
		COPY: "©",
		copy: "©",
		copysr: "℗",
		CounterClockwiseContourIntegral: "∳",
		crarr: "↵",
		Cross: "⨯",
		cross: "✗",
		Cscr: "𝒞",
		cscr: "𝒸",
		csub: "⫏",
		csube: "⫑",
		csup: "⫐",
		csupe: "⫒",
		ctdot: "⋯",
		cudarrl: "⤸",
		cudarrr: "⤵",
		cuepr: "⋞",
		cuesc: "⋟",
		cularr: "↶",
		cularrp: "⤽",
		Cup: "⋓",
		cup: "∪",
		cupbrcap: "⩈",
		CupCap: "≍",
		cupcap: "⩆",
		cupcup: "⩊",
		cupdot: "⊍",
		cupor: "⩅",
		cups: "∪︀",
		curarr: "↷",
		curarrm: "⤼",
		curlyeqprec: "⋞",
		curlyeqsucc: "⋟",
		curlyvee: "⋎",
		curlywedge: "⋏",
		curren: "¤",
		curvearrowleft: "↶",
		curvearrowright: "↷",
		cuvee: "⋎",
		cuwed: "⋏",
		cwconint: "∲",
		cwint: "∱",
		cylcty: "⌭",
		Dagger: "‡",
		dagger: "†",
		daleth: "ℸ",
		Darr: "↡",
		dArr: "⇓",
		darr: "↓",
		dash: "‐",
		Dashv: "⫤",
		dashv: "⊣",
		dbkarow: "⤏",
		dblac: "˝",
		Dcaron: "Ď",
		dcaron: "ď",
		Dcy: "Д",
		dcy: "д",
		DD: "ⅅ",
		dd: "ⅆ",
		ddagger: "‡",
		ddarr: "⇊",
		DDotrahd: "⤑",
		ddotseq: "⩷",
		deg: "°",
		Del: "∇",
		Delta: "Δ",
		delta: "δ",
		demptyv: "⦱",
		dfisht: "⥿",
		Dfr: "𝔇",
		dfr: "𝔡",
		dHar: "⥥",
		dharl: "⇃",
		dharr: "⇂",
		DiacriticalAcute: "´",
		DiacriticalDot: "˙",
		DiacriticalDoubleAcute: "˝",
		DiacriticalGrave: "`",
		DiacriticalTilde: "˜",
		diam: "⋄",
		Diamond: "⋄",
		diamond: "⋄",
		diamondsuit: "♦",
		diams: "♦",
		die: "¨",
		DifferentialD: "ⅆ",
		digamma: "ϝ",
		disin: "⋲",
		div: "÷",
		divide: "÷",
		divideontimes: "⋇",
		divonx: "⋇",
		DJcy: "Ђ",
		djcy: "ђ",
		dlcorn: "⌞",
		dlcrop: "⌍",
		dollar: "$",
		Dopf: "𝔻",
		dopf: "𝕕",
		Dot: "¨",
		dot: "˙",
		DotDot: "⃜",
		doteq: "≐",
		doteqdot: "≑",
		DotEqual: "≐",
		dotminus: "∸",
		dotplus: "∔",
		dotsquare: "⊡",
		doublebarwedge: "⌆",
		DoubleContourIntegral: "∯",
		DoubleDot: "¨",
		DoubleDownArrow: "⇓",
		DoubleLeftArrow: "⇐",
		DoubleLeftRightArrow: "⇔",
		DoubleLeftTee: "⫤",
		DoubleLongLeftArrow: "⟸",
		DoubleLongLeftRightArrow: "⟺",
		DoubleLongRightArrow: "⟹",
		DoubleRightArrow: "⇒",
		DoubleRightTee: "⊨",
		DoubleUpArrow: "⇑",
		DoubleUpDownArrow: "⇕",
		DoubleVerticalBar: "∥",
		DownArrow: "↓",
		Downarrow: "⇓",
		downarrow: "↓",
		DownArrowBar: "⤓",
		DownArrowUpArrow: "⇵",
		DownBreve: "̑",
		downdownarrows: "⇊",
		downharpoonleft: "⇃",
		downharpoonright: "⇂",
		DownLeftRightVector: "⥐",
		DownLeftTeeVector: "⥞",
		DownLeftVector: "↽",
		DownLeftVectorBar: "⥖",
		DownRightTeeVector: "⥟",
		DownRightVector: "⇁",
		DownRightVectorBar: "⥗",
		DownTee: "⊤",
		DownTeeArrow: "↧",
		drbkarow: "⤐",
		drcorn: "⌟",
		drcrop: "⌌",
		Dscr: "𝒟",
		dscr: "𝒹",
		DScy: "Ѕ",
		dscy: "ѕ",
		dsol: "⧶",
		Dstrok: "Đ",
		dstrok: "đ",
		dtdot: "⋱",
		dtri: "▿",
		dtrif: "▾",
		duarr: "⇵",
		duhar: "⥯",
		dwangle: "⦦",
		DZcy: "Џ",
		dzcy: "џ",
		dzigrarr: "⟿",
		Eacute: "É",
		eacute: "é",
		easter: "⩮",
		Ecaron: "Ě",
		ecaron: "ě",
		ecir: "≖",
		Ecirc: "Ê",
		ecirc: "ê",
		ecolon: "≕",
		Ecy: "Э",
		ecy: "э",
		eDDot: "⩷",
		Edot: "Ė",
		eDot: "≑",
		edot: "ė",
		ee: "ⅇ",
		efDot: "≒",
		Efr: "𝔈",
		efr: "𝔢",
		eg: "⪚",
		Egrave: "È",
		egrave: "è",
		egs: "⪖",
		egsdot: "⪘",
		el: "⪙",
		Element: "∈",
		elinters: "⏧",
		ell: "ℓ",
		els: "⪕",
		elsdot: "⪗",
		Emacr: "Ē",
		emacr: "ē",
		empty: "∅",
		emptyset: "∅",
		EmptySmallSquare: "◻",
		emptyv: "∅",
		EmptyVerySmallSquare: "▫",
		emsp: " ",
		emsp13: " ",
		emsp14: " ",
		ENG: "Ŋ",
		eng: "ŋ",
		ensp: " ",
		Eogon: "Ę",
		eogon: "ę",
		Eopf: "𝔼",
		eopf: "𝕖",
		epar: "⋕",
		eparsl: "⧣",
		eplus: "⩱",
		epsi: "ε",
		Epsilon: "Ε",
		epsilon: "ε",
		epsiv: "ϵ",
		eqcirc: "≖",
		eqcolon: "≕",
		eqsim: "≂",
		eqslantgtr: "⪖",
		eqslantless: "⪕",
		Equal: "⩵",
		equals: "=",
		EqualTilde: "≂",
		equest: "≟",
		Equilibrium: "⇌",
		equiv: "≡",
		equivDD: "⩸",
		eqvparsl: "⧥",
		erarr: "⥱",
		erDot: "≓",
		Escr: "ℰ",
		escr: "ℯ",
		esdot: "≐",
		Esim: "⩳",
		esim: "≂",
		Eta: "Η",
		eta: "η",
		ETH: "Ð",
		eth: "ð",
		Euml: "Ë",
		euml: "ë",
		euro: "€",
		excl: "!",
		exist: "∃",
		Exists: "∃",
		expectation: "ℰ",
		ExponentialE: "ⅇ",
		exponentiale: "ⅇ",
		fallingdotseq: "≒",
		Fcy: "Ф",
		fcy: "ф",
		female: "♀",
		ffilig: "ﬃ",
		fflig: "ﬀ",
		ffllig: "ﬄ",
		Ffr: "𝔉",
		ffr: "𝔣",
		filig: "ﬁ",
		FilledSmallSquare: "◼",
		FilledVerySmallSquare: "▪",
		fjlig: "fj",
		flat: "♭",
		fllig: "ﬂ",
		fltns: "▱",
		fnof: "ƒ",
		Fopf: "𝔽",
		fopf: "𝕗",
		ForAll: "∀",
		forall: "∀",
		fork: "⋔",
		forkv: "⫙",
		Fouriertrf: "ℱ",
		fpartint: "⨍",
		frac12: "½",
		frac13: "⅓",
		frac14: "¼",
		frac15: "⅕",
		frac16: "⅙",
		frac18: "⅛",
		frac23: "⅔",
		frac25: "⅖",
		frac34: "¾",
		frac35: "⅗",
		frac38: "⅜",
		frac45: "⅘",
		frac56: "⅚",
		frac58: "⅝",
		frac78: "⅞",
		frasl: "⁄",
		frown: "⌢",
		Fscr: "ℱ",
		fscr: "𝒻",
		gacute: "ǵ",
		Gamma: "Γ",
		gamma: "γ",
		Gammad: "Ϝ",
		gammad: "ϝ",
		gap: "⪆",
		Gbreve: "Ğ",
		gbreve: "ğ",
		Gcedil: "Ģ",
		Gcirc: "Ĝ",
		gcirc: "ĝ",
		Gcy: "Г",
		gcy: "г",
		Gdot: "Ġ",
		gdot: "ġ",
		gE: "≧",
		ge: "≥",
		gEl: "⪌",
		gel: "⋛",
		geq: "≥",
		geqq: "≧",
		geqslant: "⩾",
		ges: "⩾",
		gescc: "⪩",
		gesdot: "⪀",
		gesdoto: "⪂",
		gesdotol: "⪄",
		gesl: "⋛︀",
		gesles: "⪔",
		Gfr: "𝔊",
		gfr: "𝔤",
		Gg: "⋙",
		gg: "≫",
		ggg: "⋙",
		gimel: "ℷ",
		GJcy: "Ѓ",
		gjcy: "ѓ",
		gl: "≷",
		gla: "⪥",
		glE: "⪒",
		glj: "⪤",
		gnap: "⪊",
		gnapprox: "⪊",
		gnE: "≩",
		gne: "⪈",
		gneq: "⪈",
		gneqq: "≩",
		gnsim: "⋧",
		Gopf: "𝔾",
		gopf: "𝕘",
		grave: "`",
		GreaterEqual: "≥",
		GreaterEqualLess: "⋛",
		GreaterFullEqual: "≧",
		GreaterGreater: "⪢",
		GreaterLess: "≷",
		GreaterSlantEqual: "⩾",
		GreaterTilde: "≳",
		Gscr: "𝒢",
		gscr: "ℊ",
		gsim: "≳",
		gsime: "⪎",
		gsiml: "⪐",
		Gt: "≫",
		GT: ">",
		gt: ">",
		gtcc: "⪧",
		gtcir: "⩺",
		gtdot: "⋗",
		gtlPar: "⦕",
		gtquest: "⩼",
		gtrapprox: "⪆",
		gtrarr: "⥸",
		gtrdot: "⋗",
		gtreqless: "⋛",
		gtreqqless: "⪌",
		gtrless: "≷",
		gtrsim: "≳",
		gvertneqq: "≩︀",
		gvnE: "≩︀",
		Hacek: "ˇ",
		hairsp: " ",
		half: "½",
		hamilt: "ℋ",
		HARDcy: "Ъ",
		hardcy: "ъ",
		hArr: "⇔",
		harr: "↔",
		harrcir: "⥈",
		harrw: "↭",
		Hat: "^",
		hbar: "ℏ",
		Hcirc: "Ĥ",
		hcirc: "ĥ",
		hearts: "♥",
		heartsuit: "♥",
		hellip: "…",
		hercon: "⊹",
		Hfr: "ℌ",
		hfr: "𝔥",
		HilbertSpace: "ℋ",
		hksearow: "⤥",
		hkswarow: "⤦",
		hoarr: "⇿",
		homtht: "∻",
		hookleftarrow: "↩",
		hookrightarrow: "↪",
		Hopf: "ℍ",
		hopf: "𝕙",
		horbar: "―",
		HorizontalLine: "─",
		Hscr: "ℋ",
		hscr: "𝒽",
		hslash: "ℏ",
		Hstrok: "Ħ",
		hstrok: "ħ",
		HumpDownHump: "≎",
		HumpEqual: "≏",
		hybull: "⁃",
		hyphen: "‐",
		Iacute: "Í",
		iacute: "í",
		ic: "⁣",
		Icirc: "Î",
		icirc: "î",
		Icy: "И",
		icy: "и",
		Idot: "İ",
		IEcy: "Е",
		iecy: "е",
		iexcl: "¡",
		iff: "⇔",
		Ifr: "ℑ",
		ifr: "𝔦",
		Igrave: "Ì",
		igrave: "ì",
		ii: "ⅈ",
		iiiint: "⨌",
		iiint: "∭",
		iinfin: "⧜",
		iiota: "℩",
		IJlig: "Ĳ",
		ijlig: "ĳ",
		Im: "ℑ",
		Imacr: "Ī",
		imacr: "ī",
		image: "ℑ",
		ImaginaryI: "ⅈ",
		imagline: "ℐ",
		imagpart: "ℑ",
		imath: "ı",
		imof: "⊷",
		imped: "Ƶ",
		Implies: "⇒",
		in: "∈",
		incare: "℅",
		infin: "∞",
		infintie: "⧝",
		inodot: "ı",
		Int: "∬",
		int: "∫",
		intcal: "⊺",
		integers: "ℤ",
		Integral: "∫",
		intercal: "⊺",
		Intersection: "⋂",
		intlarhk: "⨗",
		intprod: "⨼",
		InvisibleComma: "⁣",
		InvisibleTimes: "⁢",
		IOcy: "Ё",
		iocy: "ё",
		Iogon: "Į",
		iogon: "į",
		Iopf: "𝕀",
		iopf: "𝕚",
		Iota: "Ι",
		iota: "ι",
		iprod: "⨼",
		iquest: "¿",
		Iscr: "ℐ",
		iscr: "𝒾",
		isin: "∈",
		isindot: "⋵",
		isinE: "⋹",
		isins: "⋴",
		isinsv: "⋳",
		isinv: "∈",
		it: "⁢",
		Itilde: "Ĩ",
		itilde: "ĩ",
		Iukcy: "І",
		iukcy: "і",
		Iuml: "Ï",
		iuml: "ï",
		Jcirc: "Ĵ",
		jcirc: "ĵ",
		Jcy: "Й",
		jcy: "й",
		Jfr: "𝔍",
		jfr: "𝔧",
		jmath: "ȷ",
		Jopf: "𝕁",
		jopf: "𝕛",
		Jscr: "𝒥",
		jscr: "𝒿",
		Jsercy: "Ј",
		jsercy: "ј",
		Jukcy: "Є",
		jukcy: "є",
		Kappa: "Κ",
		kappa: "κ",
		kappav: "ϰ",
		Kcedil: "Ķ",
		kcedil: "ķ",
		Kcy: "К",
		kcy: "к",
		Kfr: "𝔎",
		kfr: "𝔨",
		kgreen: "ĸ",
		KHcy: "Х",
		khcy: "х",
		KJcy: "Ќ",
		kjcy: "ќ",
		Kopf: "𝕂",
		kopf: "𝕜",
		Kscr: "𝒦",
		kscr: "𝓀",
		lAarr: "⇚",
		Lacute: "Ĺ",
		lacute: "ĺ",
		laemptyv: "⦴",
		lagran: "ℒ",
		Lambda: "Λ",
		lambda: "λ",
		Lang: "⟪",
		lang: "⟨",
		langd: "⦑",
		langle: "⟨",
		lap: "⪅",
		Laplacetrf: "ℒ",
		laquo: "«",
		Larr: "↞",
		lArr: "⇐",
		larr: "←",
		larrb: "⇤",
		larrbfs: "⤟",
		larrfs: "⤝",
		larrhk: "↩",
		larrlp: "↫",
		larrpl: "⤹",
		larrsim: "⥳",
		larrtl: "↢",
		lat: "⪫",
		lAtail: "⤛",
		latail: "⤙",
		late: "⪭",
		lates: "⪭︀",
		lBarr: "⤎",
		lbarr: "⤌",
		lbbrk: "❲",
		lbrace: "{",
		lbrack: "[",
		lbrke: "⦋",
		lbrksld: "⦏",
		lbrkslu: "⦍",
		Lcaron: "Ľ",
		lcaron: "ľ",
		Lcedil: "Ļ",
		lcedil: "ļ",
		lceil: "⌈",
		lcub: "{",
		Lcy: "Л",
		lcy: "л",
		ldca: "⤶",
		ldquo: "“",
		ldquor: "„",
		ldrdhar: "⥧",
		ldrushar: "⥋",
		ldsh: "↲",
		lE: "≦",
		le: "≤",
		LeftAngleBracket: "⟨",
		LeftArrow: "←",
		Leftarrow: "⇐",
		leftarrow: "←",
		LeftArrowBar: "⇤",
		LeftArrowRightArrow: "⇆",
		leftarrowtail: "↢",
		LeftCeiling: "⌈",
		LeftDoubleBracket: "⟦",
		LeftDownTeeVector: "⥡",
		LeftDownVector: "⇃",
		LeftDownVectorBar: "⥙",
		LeftFloor: "⌊",
		leftharpoondown: "↽",
		leftharpoonup: "↼",
		leftleftarrows: "⇇",
		LeftRightArrow: "↔",
		Leftrightarrow: "⇔",
		leftrightarrow: "↔",
		leftrightarrows: "⇆",
		leftrightharpoons: "⇋",
		leftrightsquigarrow: "↭",
		LeftRightVector: "⥎",
		LeftTee: "⊣",
		LeftTeeArrow: "↤",
		LeftTeeVector: "⥚",
		leftthreetimes: "⋋",
		LeftTriangle: "⊲",
		LeftTriangleBar: "⧏",
		LeftTriangleEqual: "⊴",
		LeftUpDownVector: "⥑",
		LeftUpTeeVector: "⥠",
		LeftUpVector: "↿",
		LeftUpVectorBar: "⥘",
		LeftVector: "↼",
		LeftVectorBar: "⥒",
		lEg: "⪋",
		leg: "⋚",
		leq: "≤",
		leqq: "≦",
		leqslant: "⩽",
		les: "⩽",
		lescc: "⪨",
		lesdot: "⩿",
		lesdoto: "⪁",
		lesdotor: "⪃",
		lesg: "⋚︀",
		lesges: "⪓",
		lessapprox: "⪅",
		lessdot: "⋖",
		lesseqgtr: "⋚",
		lesseqqgtr: "⪋",
		LessEqualGreater: "⋚",
		LessFullEqual: "≦",
		LessGreater: "≶",
		lessgtr: "≶",
		LessLess: "⪡",
		lesssim: "≲",
		LessSlantEqual: "⩽",
		LessTilde: "≲",
		lfisht: "⥼",
		lfloor: "⌊",
		Lfr: "𝔏",
		lfr: "𝔩",
		lg: "≶",
		lgE: "⪑",
		lHar: "⥢",
		lhard: "↽",
		lharu: "↼",
		lharul: "⥪",
		lhblk: "▄",
		LJcy: "Љ",
		ljcy: "љ",
		Ll: "⋘",
		ll: "≪",
		llarr: "⇇",
		llcorner: "⌞",
		Lleftarrow: "⇚",
		llhard: "⥫",
		lltri: "◺",
		Lmidot: "Ŀ",
		lmidot: "ŀ",
		lmoust: "⎰",
		lmoustache: "⎰",
		lnap: "⪉",
		lnapprox: "⪉",
		lnE: "≨",
		lne: "⪇",
		lneq: "⪇",
		lneqq: "≨",
		lnsim: "⋦",
		loang: "⟬",
		loarr: "⇽",
		lobrk: "⟦",
		LongLeftArrow: "⟵",
		Longleftarrow: "⟸",
		longleftarrow: "⟵",
		LongLeftRightArrow: "⟷",
		Longleftrightarrow: "⟺",
		longleftrightarrow: "⟷",
		longmapsto: "⟼",
		LongRightArrow: "⟶",
		Longrightarrow: "⟹",
		longrightarrow: "⟶",
		looparrowleft: "↫",
		looparrowright: "↬",
		lopar: "⦅",
		Lopf: "𝕃",
		lopf: "𝕝",
		loplus: "⨭",
		lotimes: "⨴",
		lowast: "∗",
		lowbar: "_",
		LowerLeftArrow: "↙",
		LowerRightArrow: "↘",
		loz: "◊",
		lozenge: "◊",
		lozf: "⧫",
		lpar: "(",
		lparlt: "⦓",
		lrarr: "⇆",
		lrcorner: "⌟",
		lrhar: "⇋",
		lrhard: "⥭",
		lrm: "‎",
		lrtri: "⊿",
		lsaquo: "‹",
		Lscr: "ℒ",
		lscr: "𝓁",
		Lsh: "↰",
		lsh: "↰",
		lsim: "≲",
		lsime: "⪍",
		lsimg: "⪏",
		lsqb: "[",
		lsquo: "‘",
		lsquor: "‚",
		Lstrok: "Ł",
		lstrok: "ł",
		Lt: "≪",
		LT: "<",
		lt: "<",
		ltcc: "⪦",
		ltcir: "⩹",
		ltdot: "⋖",
		lthree: "⋋",
		ltimes: "⋉",
		ltlarr: "⥶",
		ltquest: "⩻",
		ltri: "◃",
		ltrie: "⊴",
		ltrif: "◂",
		ltrPar: "⦖",
		lurdshar: "⥊",
		luruhar: "⥦",
		lvertneqq: "≨︀",
		lvnE: "≨︀",
		macr: "¯",
		male: "♂",
		malt: "✠",
		maltese: "✠",
		Map: "⤅",
		map: "↦",
		mapsto: "↦",
		mapstodown: "↧",
		mapstoleft: "↤",
		mapstoup: "↥",
		marker: "▮",
		mcomma: "⨩",
		Mcy: "М",
		mcy: "м",
		mdash: "—",
		mDDot: "∺",
		measuredangle: "∡",
		MediumSpace: " ",
		Mellintrf: "ℳ",
		Mfr: "𝔐",
		mfr: "𝔪",
		mho: "℧",
		micro: "µ",
		mid: "∣",
		midast: "*",
		midcir: "⫰",
		middot: "·",
		minus: "−",
		minusb: "⊟",
		minusd: "∸",
		minusdu: "⨪",
		MinusPlus: "∓",
		mlcp: "⫛",
		mldr: "…",
		mnplus: "∓",
		models: "⊧",
		Mopf: "𝕄",
		mopf: "𝕞",
		mp: "∓",
		Mscr: "ℳ",
		mscr: "𝓂",
		mstpos: "∾",
		Mu: "Μ",
		mu: "μ",
		multimap: "⊸",
		mumap: "⊸",
		nabla: "∇",
		Nacute: "Ń",
		nacute: "ń",
		nang: "∠⃒",
		nap: "≉",
		napE: "⩰̸",
		napid: "≋̸",
		napos: "ŉ",
		napprox: "≉",
		natur: "♮",
		natural: "♮",
		naturals: "ℕ",
		nbsp: "\xA0",
		nbump: "≎̸",
		nbumpe: "≏̸",
		ncap: "⩃",
		Ncaron: "Ň",
		ncaron: "ň",
		Ncedil: "Ņ",
		ncedil: "ņ",
		ncong: "≇",
		ncongdot: "⩭̸",
		ncup: "⩂",
		Ncy: "Н",
		ncy: "н",
		ndash: "–",
		ne: "≠",
		nearhk: "⤤",
		neArr: "⇗",
		nearr: "↗",
		nearrow: "↗",
		nedot: "≐̸",
		NegativeMediumSpace: "​",
		NegativeThickSpace: "​",
		NegativeThinSpace: "​",
		NegativeVeryThinSpace: "​",
		nequiv: "≢",
		nesear: "⤨",
		nesim: "≂̸",
		NestedGreaterGreater: "≫",
		NestedLessLess: "≪",
		NewLine: "\n",
		nexist: "∄",
		nexists: "∄",
		Nfr: "𝔑",
		nfr: "𝔫",
		ngE: "≧̸",
		nge: "≱",
		ngeq: "≱",
		ngeqq: "≧̸",
		ngeqslant: "⩾̸",
		nges: "⩾̸",
		nGg: "⋙̸",
		ngsim: "≵",
		nGt: "≫⃒",
		ngt: "≯",
		ngtr: "≯",
		nGtv: "≫̸",
		nhArr: "⇎",
		nharr: "↮",
		nhpar: "⫲",
		ni: "∋",
		nis: "⋼",
		nisd: "⋺",
		niv: "∋",
		NJcy: "Њ",
		njcy: "њ",
		nlArr: "⇍",
		nlarr: "↚",
		nldr: "‥",
		nlE: "≦̸",
		nle: "≰",
		nLeftarrow: "⇍",
		nleftarrow: "↚",
		nLeftrightarrow: "⇎",
		nleftrightarrow: "↮",
		nleq: "≰",
		nleqq: "≦̸",
		nleqslant: "⩽̸",
		nles: "⩽̸",
		nless: "≮",
		nLl: "⋘̸",
		nlsim: "≴",
		nLt: "≪⃒",
		nlt: "≮",
		nltri: "⋪",
		nltrie: "⋬",
		nLtv: "≪̸",
		nmid: "∤",
		NoBreak: "⁠",
		NonBreakingSpace: "\xA0",
		Nopf: "ℕ",
		nopf: "𝕟",
		Not: "⫬",
		not: "¬",
		NotCongruent: "≢",
		NotCupCap: "≭",
		NotDoubleVerticalBar: "∦",
		NotElement: "∉",
		NotEqual: "≠",
		NotEqualTilde: "≂̸",
		NotExists: "∄",
		NotGreater: "≯",
		NotGreaterEqual: "≱",
		NotGreaterFullEqual: "≧̸",
		NotGreaterGreater: "≫̸",
		NotGreaterLess: "≹",
		NotGreaterSlantEqual: "⩾̸",
		NotGreaterTilde: "≵",
		NotHumpDownHump: "≎̸",
		NotHumpEqual: "≏̸",
		notin: "∉",
		notindot: "⋵̸",
		notinE: "⋹̸",
		notinva: "∉",
		notinvb: "⋷",
		notinvc: "⋶",
		NotLeftTriangle: "⋪",
		NotLeftTriangleBar: "⧏̸",
		NotLeftTriangleEqual: "⋬",
		NotLess: "≮",
		NotLessEqual: "≰",
		NotLessGreater: "≸",
		NotLessLess: "≪̸",
		NotLessSlantEqual: "⩽̸",
		NotLessTilde: "≴",
		NotNestedGreaterGreater: "⪢̸",
		NotNestedLessLess: "⪡̸",
		notni: "∌",
		notniva: "∌",
		notnivb: "⋾",
		notnivc: "⋽",
		NotPrecedes: "⊀",
		NotPrecedesEqual: "⪯̸",
		NotPrecedesSlantEqual: "⋠",
		NotReverseElement: "∌",
		NotRightTriangle: "⋫",
		NotRightTriangleBar: "⧐̸",
		NotRightTriangleEqual: "⋭",
		NotSquareSubset: "⊏̸",
		NotSquareSubsetEqual: "⋢",
		NotSquareSuperset: "⊐̸",
		NotSquareSupersetEqual: "⋣",
		NotSubset: "⊂⃒",
		NotSubsetEqual: "⊈",
		NotSucceeds: "⊁",
		NotSucceedsEqual: "⪰̸",
		NotSucceedsSlantEqual: "⋡",
		NotSucceedsTilde: "≿̸",
		NotSuperset: "⊃⃒",
		NotSupersetEqual: "⊉",
		NotTilde: "≁",
		NotTildeEqual: "≄",
		NotTildeFullEqual: "≇",
		NotTildeTilde: "≉",
		NotVerticalBar: "∤",
		npar: "∦",
		nparallel: "∦",
		nparsl: "⫽⃥",
		npart: "∂̸",
		npolint: "⨔",
		npr: "⊀",
		nprcue: "⋠",
		npre: "⪯̸",
		nprec: "⊀",
		npreceq: "⪯̸",
		nrArr: "⇏",
		nrarr: "↛",
		nrarrc: "⤳̸",
		nrarrw: "↝̸",
		nRightarrow: "⇏",
		nrightarrow: "↛",
		nrtri: "⋫",
		nrtrie: "⋭",
		nsc: "⊁",
		nsccue: "⋡",
		nsce: "⪰̸",
		Nscr: "𝒩",
		nscr: "𝓃",
		nshortmid: "∤",
		nshortparallel: "∦",
		nsim: "≁",
		nsime: "≄",
		nsimeq: "≄",
		nsmid: "∤",
		nspar: "∦",
		nsqsube: "⋢",
		nsqsupe: "⋣",
		nsub: "⊄",
		nsubE: "⫅̸",
		nsube: "⊈",
		nsubset: "⊂⃒",
		nsubseteq: "⊈",
		nsubseteqq: "⫅̸",
		nsucc: "⊁",
		nsucceq: "⪰̸",
		nsup: "⊅",
		nsupE: "⫆̸",
		nsupe: "⊉",
		nsupset: "⊃⃒",
		nsupseteq: "⊉",
		nsupseteqq: "⫆̸",
		ntgl: "≹",
		Ntilde: "Ñ",
		ntilde: "ñ",
		ntlg: "≸",
		ntriangleleft: "⋪",
		ntrianglelefteq: "⋬",
		ntriangleright: "⋫",
		ntrianglerighteq: "⋭",
		Nu: "Ν",
		nu: "ν",
		num: "#",
		numero: "№",
		numsp: " ",
		nvap: "≍⃒",
		nVDash: "⊯",
		nVdash: "⊮",
		nvDash: "⊭",
		nvdash: "⊬",
		nvge: "≥⃒",
		nvgt: ">⃒",
		nvHarr: "⤄",
		nvinfin: "⧞",
		nvlArr: "⤂",
		nvle: "≤⃒",
		nvlt: "<⃒",
		nvltrie: "⊴⃒",
		nvrArr: "⤃",
		nvrtrie: "⊵⃒",
		nvsim: "∼⃒",
		nwarhk: "⤣",
		nwArr: "⇖",
		nwarr: "↖",
		nwarrow: "↖",
		nwnear: "⤧",
		Oacute: "Ó",
		oacute: "ó",
		oast: "⊛",
		ocir: "⊚",
		Ocirc: "Ô",
		ocirc: "ô",
		Ocy: "О",
		ocy: "о",
		odash: "⊝",
		Odblac: "Ő",
		odblac: "ő",
		odiv: "⨸",
		odot: "⊙",
		odsold: "⦼",
		OElig: "Œ",
		oelig: "œ",
		ofcir: "⦿",
		Ofr: "𝔒",
		ofr: "𝔬",
		ogon: "˛",
		Ograve: "Ò",
		ograve: "ò",
		ogt: "⧁",
		ohbar: "⦵",
		ohm: "Ω",
		oint: "∮",
		olarr: "↺",
		olcir: "⦾",
		olcross: "⦻",
		oline: "‾",
		olt: "⧀",
		Omacr: "Ō",
		omacr: "ō",
		Omega: "Ω",
		omega: "ω",
		Omicron: "Ο",
		omicron: "ο",
		omid: "⦶",
		ominus: "⊖",
		Oopf: "𝕆",
		oopf: "𝕠",
		opar: "⦷",
		OpenCurlyDoubleQuote: "“",
		OpenCurlyQuote: "‘",
		operp: "⦹",
		oplus: "⊕",
		Or: "⩔",
		or: "∨",
		orarr: "↻",
		ord: "⩝",
		order: "ℴ",
		orderof: "ℴ",
		ordf: "ª",
		ordm: "º",
		origof: "⊶",
		oror: "⩖",
		orslope: "⩗",
		orv: "⩛",
		oS: "Ⓢ",
		Oscr: "𝒪",
		oscr: "ℴ",
		Oslash: "Ø",
		oslash: "ø",
		osol: "⊘",
		Otilde: "Õ",
		otilde: "õ",
		Otimes: "⨷",
		otimes: "⊗",
		otimesas: "⨶",
		Ouml: "Ö",
		ouml: "ö",
		ovbar: "⌽",
		OverBar: "‾",
		OverBrace: "⏞",
		OverBracket: "⎴",
		OverParenthesis: "⏜",
		par: "∥",
		para: "¶",
		parallel: "∥",
		parsim: "⫳",
		parsl: "⫽",
		part: "∂",
		PartialD: "∂",
		Pcy: "П",
		pcy: "п",
		percnt: "%",
		period: ".",
		permil: "‰",
		perp: "⊥",
		pertenk: "‱",
		Pfr: "𝔓",
		pfr: "𝔭",
		Phi: "Φ",
		phi: "φ",
		phiv: "ϕ",
		phmmat: "ℳ",
		phone: "☎",
		Pi: "Π",
		pi: "π",
		pitchfork: "⋔",
		piv: "ϖ",
		planck: "ℏ",
		planckh: "ℎ",
		plankv: "ℏ",
		plus: "+",
		plusacir: "⨣",
		plusb: "⊞",
		pluscir: "⨢",
		plusdo: "∔",
		plusdu: "⨥",
		pluse: "⩲",
		PlusMinus: "±",
		plusmn: "±",
		plussim: "⨦",
		plustwo: "⨧",
		pm: "±",
		Poincareplane: "ℌ",
		pointint: "⨕",
		Popf: "ℙ",
		popf: "𝕡",
		pound: "£",
		Pr: "⪻",
		pr: "≺",
		prap: "⪷",
		prcue: "≼",
		prE: "⪳",
		pre: "⪯",
		prec: "≺",
		precapprox: "⪷",
		preccurlyeq: "≼",
		Precedes: "≺",
		PrecedesEqual: "⪯",
		PrecedesSlantEqual: "≼",
		PrecedesTilde: "≾",
		preceq: "⪯",
		precnapprox: "⪹",
		precneqq: "⪵",
		precnsim: "⋨",
		precsim: "≾",
		Prime: "″",
		prime: "′",
		primes: "ℙ",
		prnap: "⪹",
		prnE: "⪵",
		prnsim: "⋨",
		prod: "∏",
		Product: "∏",
		profalar: "⌮",
		profline: "⌒",
		profsurf: "⌓",
		prop: "∝",
		Proportion: "∷",
		Proportional: "∝",
		propto: "∝",
		prsim: "≾",
		prurel: "⊰",
		Pscr: "𝒫",
		pscr: "𝓅",
		Psi: "Ψ",
		psi: "ψ",
		puncsp: " ",
		Qfr: "𝔔",
		qfr: "𝔮",
		qint: "⨌",
		Qopf: "ℚ",
		qopf: "𝕢",
		qprime: "⁗",
		Qscr: "𝒬",
		qscr: "𝓆",
		quaternions: "ℍ",
		quatint: "⨖",
		quest: "?",
		questeq: "≟",
		QUOT: "\"",
		quot: "\"",
		rAarr: "⇛",
		race: "∽̱",
		Racute: "Ŕ",
		racute: "ŕ",
		radic: "√",
		raemptyv: "⦳",
		Rang: "⟫",
		rang: "⟩",
		rangd: "⦒",
		range: "⦥",
		rangle: "⟩",
		raquo: "»",
		Rarr: "↠",
		rArr: "⇒",
		rarr: "→",
		rarrap: "⥵",
		rarrb: "⇥",
		rarrbfs: "⤠",
		rarrc: "⤳",
		rarrfs: "⤞",
		rarrhk: "↪",
		rarrlp: "↬",
		rarrpl: "⥅",
		rarrsim: "⥴",
		Rarrtl: "⤖",
		rarrtl: "↣",
		rarrw: "↝",
		rAtail: "⤜",
		ratail: "⤚",
		ratio: "∶",
		rationals: "ℚ",
		RBarr: "⤐",
		rBarr: "⤏",
		rbarr: "⤍",
		rbbrk: "❳",
		rbrace: "}",
		rbrack: "]",
		rbrke: "⦌",
		rbrksld: "⦎",
		rbrkslu: "⦐",
		Rcaron: "Ř",
		rcaron: "ř",
		Rcedil: "Ŗ",
		rcedil: "ŗ",
		rceil: "⌉",
		rcub: "}",
		Rcy: "Р",
		rcy: "р",
		rdca: "⤷",
		rdldhar: "⥩",
		rdquo: "”",
		rdquor: "”",
		rdsh: "↳",
		Re: "ℜ",
		real: "ℜ",
		realine: "ℛ",
		realpart: "ℜ",
		reals: "ℝ",
		rect: "▭",
		REG: "®",
		reg: "®",
		ReverseElement: "∋",
		ReverseEquilibrium: "⇋",
		ReverseUpEquilibrium: "⥯",
		rfisht: "⥽",
		rfloor: "⌋",
		Rfr: "ℜ",
		rfr: "𝔯",
		rHar: "⥤",
		rhard: "⇁",
		rharu: "⇀",
		rharul: "⥬",
		Rho: "Ρ",
		rho: "ρ",
		rhov: "ϱ",
		RightAngleBracket: "⟩",
		RightArrow: "→",
		Rightarrow: "⇒",
		rightarrow: "→",
		RightArrowBar: "⇥",
		RightArrowLeftArrow: "⇄",
		rightarrowtail: "↣",
		RightCeiling: "⌉",
		RightDoubleBracket: "⟧",
		RightDownTeeVector: "⥝",
		RightDownVector: "⇂",
		RightDownVectorBar: "⥕",
		RightFloor: "⌋",
		rightharpoondown: "⇁",
		rightharpoonup: "⇀",
		rightleftarrows: "⇄",
		rightleftharpoons: "⇌",
		rightrightarrows: "⇉",
		rightsquigarrow: "↝",
		RightTee: "⊢",
		RightTeeArrow: "↦",
		RightTeeVector: "⥛",
		rightthreetimes: "⋌",
		RightTriangle: "⊳",
		RightTriangleBar: "⧐",
		RightTriangleEqual: "⊵",
		RightUpDownVector: "⥏",
		RightUpTeeVector: "⥜",
		RightUpVector: "↾",
		RightUpVectorBar: "⥔",
		RightVector: "⇀",
		RightVectorBar: "⥓",
		ring: "˚",
		risingdotseq: "≓",
		rlarr: "⇄",
		rlhar: "⇌",
		rlm: "‏",
		rmoust: "⎱",
		rmoustache: "⎱",
		rnmid: "⫮",
		roang: "⟭",
		roarr: "⇾",
		robrk: "⟧",
		ropar: "⦆",
		Ropf: "ℝ",
		ropf: "𝕣",
		roplus: "⨮",
		rotimes: "⨵",
		RoundImplies: "⥰",
		rpar: ")",
		rpargt: "⦔",
		rppolint: "⨒",
		rrarr: "⇉",
		Rrightarrow: "⇛",
		rsaquo: "›",
		Rscr: "ℛ",
		rscr: "𝓇",
		Rsh: "↱",
		rsh: "↱",
		rsqb: "]",
		rsquo: "’",
		rsquor: "’",
		rthree: "⋌",
		rtimes: "⋊",
		rtri: "▹",
		rtrie: "⊵",
		rtrif: "▸",
		rtriltri: "⧎",
		RuleDelayed: "⧴",
		ruluhar: "⥨",
		rx: "℞",
		Sacute: "Ś",
		sacute: "ś",
		sbquo: "‚",
		Sc: "⪼",
		sc: "≻",
		scap: "⪸",
		Scaron: "Š",
		scaron: "š",
		sccue: "≽",
		scE: "⪴",
		sce: "⪰",
		Scedil: "Ş",
		scedil: "ş",
		Scirc: "Ŝ",
		scirc: "ŝ",
		scnap: "⪺",
		scnE: "⪶",
		scnsim: "⋩",
		scpolint: "⨓",
		scsim: "≿",
		Scy: "С",
		scy: "с",
		sdot: "⋅",
		sdotb: "⊡",
		sdote: "⩦",
		searhk: "⤥",
		seArr: "⇘",
		searr: "↘",
		searrow: "↘",
		sect: "§",
		semi: ";",
		seswar: "⤩",
		setminus: "∖",
		setmn: "∖",
		sext: "✶",
		Sfr: "𝔖",
		sfr: "𝔰",
		sfrown: "⌢",
		sharp: "♯",
		SHCHcy: "Щ",
		shchcy: "щ",
		SHcy: "Ш",
		shcy: "ш",
		ShortDownArrow: "↓",
		ShortLeftArrow: "←",
		shortmid: "∣",
		shortparallel: "∥",
		ShortRightArrow: "→",
		ShortUpArrow: "↑",
		shy: "­",
		Sigma: "Σ",
		sigma: "σ",
		sigmaf: "ς",
		sigmav: "ς",
		sim: "∼",
		simdot: "⩪",
		sime: "≃",
		simeq: "≃",
		simg: "⪞",
		simgE: "⪠",
		siml: "⪝",
		simlE: "⪟",
		simne: "≆",
		simplus: "⨤",
		simrarr: "⥲",
		slarr: "←",
		SmallCircle: "∘",
		smallsetminus: "∖",
		smashp: "⨳",
		smeparsl: "⧤",
		smid: "∣",
		smile: "⌣",
		smt: "⪪",
		smte: "⪬",
		smtes: "⪬︀",
		SOFTcy: "Ь",
		softcy: "ь",
		sol: "/",
		solb: "⧄",
		solbar: "⌿",
		Sopf: "𝕊",
		sopf: "𝕤",
		spades: "♠",
		spadesuit: "♠",
		spar: "∥",
		sqcap: "⊓",
		sqcaps: "⊓︀",
		sqcup: "⊔",
		sqcups: "⊔︀",
		Sqrt: "√",
		sqsub: "⊏",
		sqsube: "⊑",
		sqsubset: "⊏",
		sqsubseteq: "⊑",
		sqsup: "⊐",
		sqsupe: "⊒",
		sqsupset: "⊐",
		sqsupseteq: "⊒",
		squ: "□",
		Square: "□",
		square: "□",
		SquareIntersection: "⊓",
		SquareSubset: "⊏",
		SquareSubsetEqual: "⊑",
		SquareSuperset: "⊐",
		SquareSupersetEqual: "⊒",
		SquareUnion: "⊔",
		squarf: "▪",
		squf: "▪",
		srarr: "→",
		Sscr: "𝒮",
		sscr: "𝓈",
		ssetmn: "∖",
		ssmile: "⌣",
		sstarf: "⋆",
		Star: "⋆",
		star: "☆",
		starf: "★",
		straightepsilon: "ϵ",
		straightphi: "ϕ",
		strns: "¯",
		Sub: "⋐",
		sub: "⊂",
		subdot: "⪽",
		subE: "⫅",
		sube: "⊆",
		subedot: "⫃",
		submult: "⫁",
		subnE: "⫋",
		subne: "⊊",
		subplus: "⪿",
		subrarr: "⥹",
		Subset: "⋐",
		subset: "⊂",
		subseteq: "⊆",
		subseteqq: "⫅",
		SubsetEqual: "⊆",
		subsetneq: "⊊",
		subsetneqq: "⫋",
		subsim: "⫇",
		subsub: "⫕",
		subsup: "⫓",
		succ: "≻",
		succapprox: "⪸",
		succcurlyeq: "≽",
		Succeeds: "≻",
		SucceedsEqual: "⪰",
		SucceedsSlantEqual: "≽",
		SucceedsTilde: "≿",
		succeq: "⪰",
		succnapprox: "⪺",
		succneqq: "⪶",
		succnsim: "⋩",
		succsim: "≿",
		SuchThat: "∋",
		Sum: "∑",
		sum: "∑",
		sung: "♪",
		Sup: "⋑",
		sup: "⊃",
		sup1: "¹",
		sup2: "²",
		sup3: "³",
		supdot: "⪾",
		supdsub: "⫘",
		supE: "⫆",
		supe: "⊇",
		supedot: "⫄",
		Superset: "⊃",
		SupersetEqual: "⊇",
		suphsol: "⟉",
		suphsub: "⫗",
		suplarr: "⥻",
		supmult: "⫂",
		supnE: "⫌",
		supne: "⊋",
		supplus: "⫀",
		Supset: "⋑",
		supset: "⊃",
		supseteq: "⊇",
		supseteqq: "⫆",
		supsetneq: "⊋",
		supsetneqq: "⫌",
		supsim: "⫈",
		supsub: "⫔",
		supsup: "⫖",
		swarhk: "⤦",
		swArr: "⇙",
		swarr: "↙",
		swarrow: "↙",
		swnwar: "⤪",
		szlig: "ß",
		Tab: "	",
		target: "⌖",
		Tau: "Τ",
		tau: "τ",
		tbrk: "⎴",
		Tcaron: "Ť",
		tcaron: "ť",
		Tcedil: "Ţ",
		tcedil: "ţ",
		Tcy: "Т",
		tcy: "т",
		tdot: "⃛",
		telrec: "⌕",
		Tfr: "𝔗",
		tfr: "𝔱",
		there4: "∴",
		Therefore: "∴",
		therefore: "∴",
		Theta: "Θ",
		theta: "θ",
		thetasym: "ϑ",
		thetav: "ϑ",
		thickapprox: "≈",
		thicksim: "∼",
		ThickSpace: "  ",
		thinsp: " ",
		ThinSpace: " ",
		thkap: "≈",
		thksim: "∼",
		THORN: "Þ",
		thorn: "þ",
		Tilde: "∼",
		tilde: "˜",
		TildeEqual: "≃",
		TildeFullEqual: "≅",
		TildeTilde: "≈",
		times: "×",
		timesb: "⊠",
		timesbar: "⨱",
		timesd: "⨰",
		tint: "∭",
		toea: "⤨",
		top: "⊤",
		topbot: "⌶",
		topcir: "⫱",
		Topf: "𝕋",
		topf: "𝕥",
		topfork: "⫚",
		tosa: "⤩",
		tprime: "‴",
		TRADE: "™",
		trade: "™",
		triangle: "▵",
		triangledown: "▿",
		triangleleft: "◃",
		trianglelefteq: "⊴",
		triangleq: "≜",
		triangleright: "▹",
		trianglerighteq: "⊵",
		tridot: "◬",
		trie: "≜",
		triminus: "⨺",
		TripleDot: "⃛",
		triplus: "⨹",
		trisb: "⧍",
		tritime: "⨻",
		trpezium: "⏢",
		Tscr: "𝒯",
		tscr: "𝓉",
		TScy: "Ц",
		tscy: "ц",
		TSHcy: "Ћ",
		tshcy: "ћ",
		Tstrok: "Ŧ",
		tstrok: "ŧ",
		twixt: "≬",
		twoheadleftarrow: "↞",
		twoheadrightarrow: "↠",
		Uacute: "Ú",
		uacute: "ú",
		Uarr: "↟",
		uArr: "⇑",
		uarr: "↑",
		Uarrocir: "⥉",
		Ubrcy: "Ў",
		ubrcy: "ў",
		Ubreve: "Ŭ",
		ubreve: "ŭ",
		Ucirc: "Û",
		ucirc: "û",
		Ucy: "У",
		ucy: "у",
		udarr: "⇅",
		Udblac: "Ű",
		udblac: "ű",
		udhar: "⥮",
		ufisht: "⥾",
		Ufr: "𝔘",
		ufr: "𝔲",
		Ugrave: "Ù",
		ugrave: "ù",
		uHar: "⥣",
		uharl: "↿",
		uharr: "↾",
		uhblk: "▀",
		ulcorn: "⌜",
		ulcorner: "⌜",
		ulcrop: "⌏",
		ultri: "◸",
		Umacr: "Ū",
		umacr: "ū",
		uml: "¨",
		UnderBar: "_",
		UnderBrace: "⏟",
		UnderBracket: "⎵",
		UnderParenthesis: "⏝",
		Union: "⋃",
		UnionPlus: "⊎",
		Uogon: "Ų",
		uogon: "ų",
		Uopf: "𝕌",
		uopf: "𝕦",
		UpArrow: "↑",
		Uparrow: "⇑",
		uparrow: "↑",
		UpArrowBar: "⤒",
		UpArrowDownArrow: "⇅",
		UpDownArrow: "↕",
		Updownarrow: "⇕",
		updownarrow: "↕",
		UpEquilibrium: "⥮",
		upharpoonleft: "↿",
		upharpoonright: "↾",
		uplus: "⊎",
		UpperLeftArrow: "↖",
		UpperRightArrow: "↗",
		Upsi: "ϒ",
		upsi: "υ",
		upsih: "ϒ",
		Upsilon: "Υ",
		upsilon: "υ",
		UpTee: "⊥",
		UpTeeArrow: "↥",
		upuparrows: "⇈",
		urcorn: "⌝",
		urcorner: "⌝",
		urcrop: "⌎",
		Uring: "Ů",
		uring: "ů",
		urtri: "◹",
		Uscr: "𝒰",
		uscr: "𝓊",
		utdot: "⋰",
		Utilde: "Ũ",
		utilde: "ũ",
		utri: "▵",
		utrif: "▴",
		uuarr: "⇈",
		Uuml: "Ü",
		uuml: "ü",
		uwangle: "⦧",
		vangrt: "⦜",
		varepsilon: "ϵ",
		varkappa: "ϰ",
		varnothing: "∅",
		varphi: "ϕ",
		varpi: "ϖ",
		varpropto: "∝",
		vArr: "⇕",
		varr: "↕",
		varrho: "ϱ",
		varsigma: "ς",
		varsubsetneq: "⊊︀",
		varsubsetneqq: "⫋︀",
		varsupsetneq: "⊋︀",
		varsupsetneqq: "⫌︀",
		vartheta: "ϑ",
		vartriangleleft: "⊲",
		vartriangleright: "⊳",
		Vbar: "⫫",
		vBar: "⫨",
		vBarv: "⫩",
		Vcy: "В",
		vcy: "в",
		VDash: "⊫",
		Vdash: "⊩",
		vDash: "⊨",
		vdash: "⊢",
		Vdashl: "⫦",
		Vee: "⋁",
		vee: "∨",
		veebar: "⊻",
		veeeq: "≚",
		vellip: "⋮",
		Verbar: "‖",
		verbar: "|",
		Vert: "‖",
		vert: "|",
		VerticalBar: "∣",
		VerticalLine: "|",
		VerticalSeparator: "❘",
		VerticalTilde: "≀",
		VeryThinSpace: " ",
		Vfr: "𝔙",
		vfr: "𝔳",
		vltri: "⊲",
		vnsub: "⊂⃒",
		vnsup: "⊃⃒",
		Vopf: "𝕍",
		vopf: "𝕧",
		vprop: "∝",
		vrtri: "⊳",
		Vscr: "𝒱",
		vscr: "𝓋",
		vsubnE: "⫋︀",
		vsubne: "⊊︀",
		vsupnE: "⫌︀",
		vsupne: "⊋︀",
		Vvdash: "⊪",
		vzigzag: "⦚",
		Wcirc: "Ŵ",
		wcirc: "ŵ",
		wedbar: "⩟",
		Wedge: "⋀",
		wedge: "∧",
		wedgeq: "≙",
		weierp: "℘",
		Wfr: "𝔚",
		wfr: "𝔴",
		Wopf: "𝕎",
		wopf: "𝕨",
		wp: "℘",
		wr: "≀",
		wreath: "≀",
		Wscr: "𝒲",
		wscr: "𝓌",
		xcap: "⋂",
		xcirc: "◯",
		xcup: "⋃",
		xdtri: "▽",
		Xfr: "𝔛",
		xfr: "𝔵",
		xhArr: "⟺",
		xharr: "⟷",
		Xi: "Ξ",
		xi: "ξ",
		xlArr: "⟸",
		xlarr: "⟵",
		xmap: "⟼",
		xnis: "⋻",
		xodot: "⨀",
		Xopf: "𝕏",
		xopf: "𝕩",
		xoplus: "⨁",
		xotime: "⨂",
		xrArr: "⟹",
		xrarr: "⟶",
		Xscr: "𝒳",
		xscr: "𝓍",
		xsqcup: "⨆",
		xuplus: "⨄",
		xutri: "△",
		xvee: "⋁",
		xwedge: "⋀",
		Yacute: "Ý",
		yacute: "ý",
		YAcy: "Я",
		yacy: "я",
		Ycirc: "Ŷ",
		ycirc: "ŷ",
		Ycy: "Ы",
		ycy: "ы",
		yen: "¥",
		Yfr: "𝔜",
		yfr: "𝔶",
		YIcy: "Ї",
		yicy: "ї",
		Yopf: "𝕐",
		yopf: "𝕪",
		Yscr: "𝒴",
		yscr: "𝓎",
		YUcy: "Ю",
		yucy: "ю",
		Yuml: "Ÿ",
		yuml: "ÿ",
		Zacute: "Ź",
		zacute: "ź",
		Zcaron: "Ž",
		zcaron: "ž",
		Zcy: "З",
		zcy: "з",
		Zdot: "Ż",
		zdot: "ż",
		zeetrf: "ℨ",
		ZeroWidthSpace: "​",
		Zeta: "Ζ",
		zeta: "ζ",
		Zfr: "ℨ",
		zfr: "𝔷",
		ZHcy: "Ж",
		zhcy: "ж",
		zigrarr: "⇝",
		Zopf: "ℤ",
		zopf: "𝕫",
		Zscr: "𝒵",
		zscr: "𝓏",
		zwj: "‍",
		zwnj: "‌"
	}), e.entityMap = e.HTML_ENTITIES;
})), jI = /* @__PURE__ */ s(((e) => {
	var t = OI().NAMESPACE, n = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, r = RegExp("[\\-\\.0-9" + n.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), i = RegExp("^" + n.source + r.source + "*(?::" + n.source + r.source + "*)?$"), a = 0, o = 1, s = 2, c = 3, l = 4, u = 5, d = 6, f = 7;
	function p(e, t) {
		this.message = e, this.locator = t, Error.captureStackTrace && Error.captureStackTrace(this, p);
	}
	p.prototype = /* @__PURE__ */ Error(), p.prototype.name = p.name;
	function m() {}
	m.prototype = { parse: function(e, t, n) {
		var r = this.domBuilder;
		r.startDocument(), x(t, t = {}), h(e, t, n, r, this.errorHandler), r.endDocument();
	} };
	function h(e, n, r, i, a) {
		function o(e) {
			if (e > 65535) {
				e -= 65536;
				var t = 55296 + (e >> 10), n = 56320 + (e & 1023);
				return String.fromCharCode(t, n);
			}
			return String.fromCharCode(e);
		}
		function s(e) {
			var t = e.slice(1, -1);
			return Object.hasOwnProperty.call(r, t) ? r[t] : t.charAt(0) === "#" ? o(parseInt(t.substr(1).replace("x", "0x"))) : (a.error("entity not found:" + e), e);
		}
		function c(t) {
			if (t > T) {
				var n = e.substring(T, t).replace(/&#?\w+;/g, s);
				m && l(T), i.characters(n, 0, t - T), T = t;
			}
		}
		function l(t, n) {
			for (; t >= d && (n = f.exec(e));) u = n.index, d = u + n[0].length, m.lineNumber++;
			m.columnNumber = t - u + 1;
		}
		for (var u = 0, d = 0, f = /.*(?:\r\n?|\n)|.*$/g, m = i.locator, h = [{ currentNSMap: n }], x = {}, T = 0;;) {
			try {
				var E = e.indexOf("<", T);
				if (E < 0) {
					if (!e.substr(T).match(/^\s*$/)) {
						var ee = i.doc, D = ee.createTextNode(e.substr(T));
						ee.appendChild(D), i.currentElement = D;
					}
					return;
				}
				switch (E > T && c(E), e.charAt(E + 1)) {
					case "/":
						var O = e.indexOf(">", E + 3), te = e.substring(E + 2, O).replace(/[ \t\n\r]+$/g, ""), k = h.pop();
						O < 0 ? (te = e.substring(E + 2).replace(/[\s<].*/, ""), a.error("end tag name: " + te + " is not complete:" + k.tagName), O = E + 1 + te.length) : te.match(/\s</) && (te = te.replace(/[\s<].*/, ""), a.error("end tag name: " + te + " maybe not complete"), O = E + 1 + te.length);
						var ne = k.localNSMap, re = k.tagName == te;
						if (re || k.tagName && k.tagName.toLowerCase() == te.toLowerCase()) {
							if (i.endElement(k.uri, k.localName, te), ne) for (var ie in ne) Object.prototype.hasOwnProperty.call(ne, ie) && i.endPrefixMapping(ie);
							re || a.fatalError("end tag name: " + te + " is not match the current start tagName:" + k.tagName);
						} else h.push(k);
						O++;
						break;
					case "?":
						m && l(E), O = C(e, E, i);
						break;
					case "!":
						m && l(E), O = S(e, E, i, a);
						break;
					default:
						m && l(E);
						var ae = new w(), A = h[h.length - 1].currentNSMap, O = _(e, E, ae, A, s, a), oe = ae.length;
						if (!ae.closed && b(e, O, ae.tagName, x) && (ae.closed = !0, r.nbsp || a.warning("unclosed xml attribute")), m && oe) {
							for (var se = g(m, {}), ce = 0; ce < oe; ce++) {
								var le = ae[ce];
								l(le.offset), le.locator = g(m, {});
							}
							i.locator = se, v(ae, i, A) && h.push(ae), i.locator = m;
						} else v(ae, i, A) && h.push(ae);
						t.isHTML(ae.uri) && !ae.closed ? O = y(e, O, ae.tagName, s, i) : O++;
				}
			} catch (e) {
				if (e instanceof p) throw e;
				a.error("element parse error: " + e), O = -1;
			}
			O > T ? T = O : c(Math.max(E, T) + 1);
		}
	}
	function g(e, t) {
		return t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber, t;
	}
	function _(e, n, r, i, p, m) {
		function h(e, t, n) {
			r.attributeNames.hasOwnProperty(e) && m.fatalError("Attribute " + e + " redefined"), r.addValue(e, t.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, p), n);
		}
		for (var g, _, v = ++n, y = a;;) {
			var b = e.charAt(v);
			switch (b) {
				case "=":
					if (y === o) g = e.slice(n, v), y = c;
					else if (y === s) y = c;
					else throw Error("attribute equal must after attrName");
					break;
				case "'":
				case "\"":
					if (y === c || y === o) if (y === o && (m.warning("attribute value must after \"=\""), g = e.slice(n, v)), n = v + 1, v = e.indexOf(b, n), v > 0) _ = e.slice(n, v), h(g, _, n - 1), y = u;
					else throw Error("attribute value no end '" + b + "' match");
					else if (y == l) _ = e.slice(n, v), h(g, _, n), m.warning("attribute \"" + g + "\" missed start quot(" + b + ")!!"), n = v + 1, y = u;
					else throw Error("attribute value must after \"=\"");
					break;
				case "/":
					switch (y) {
						case a: r.setTagName(e.slice(n, v));
						case u:
						case d:
						case f: y = f, r.closed = !0;
						case l:
						case o: break;
						case s:
							r.closed = !0;
							break;
						default: throw Error("attribute invalid close char('/')");
					}
					break;
				case "": return m.error("unexpected end of input"), y == a && r.setTagName(e.slice(n, v)), v;
				case ">":
					switch (y) {
						case a: r.setTagName(e.slice(n, v));
						case u:
						case d:
						case f: break;
						case l:
						case o: _ = e.slice(n, v), _.slice(-1) === "/" && (r.closed = !0, _ = _.slice(0, -1));
						case s:
							y === s && (_ = g), y == l ? (m.warning("attribute \"" + _ + "\" missed quot(\")!"), h(g, _, n)) : ((!t.isHTML(i[""]) || !_.match(/^(?:disabled|checked|selected)$/i)) && m.warning("attribute \"" + _ + "\" missed value!! \"" + _ + "\" instead!!"), h(_, _, n));
							break;
						case c: throw Error("attribute value missed!!");
					}
					return v;
				case "": b = " ";
				default: if (b <= " ") switch (y) {
					case a:
						r.setTagName(e.slice(n, v)), y = d;
						break;
					case o:
						g = e.slice(n, v), y = s;
						break;
					case l:
						var _ = e.slice(n, v);
						m.warning("attribute \"" + _ + "\" missed quot(\")!!"), h(g, _, n);
					case u: y = d;
				}
				else switch (y) {
					case s:
						r.tagName, (!t.isHTML(i[""]) || !g.match(/^(?:disabled|checked|selected)$/i)) && m.warning("attribute \"" + g + "\" missed value!! \"" + g + "\" instead2!!"), h(g, g, n), n = v, y = o;
						break;
					case u: m.warning("attribute space is required\"" + g + "\"!!");
					case d:
						y = o, n = v;
						break;
					case c:
						y = l, n = v;
						break;
					case f: throw Error("elements closed character '/' and '>' must be connected to");
				}
			}
			v++;
		}
	}
	function v(e, n, r) {
		for (var i = e.tagName, a = null, o = e.length; o--;) {
			var s = e[o], c = s.qName, l = s.value, u = c.indexOf(":");
			if (u > 0) var d = s.prefix = c.slice(0, u), f = c.slice(u + 1), p = d === "xmlns" && f;
			else f = c, d = null, p = c === "xmlns" && "";
			s.localName = f, p !== !1 && (a ?? (a = {}, x(r, r = {})), r[p] = a[p] = l, s.uri = t.XMLNS, n.startPrefixMapping(p, l));
		}
		for (var o = e.length; o--;) {
			s = e[o];
			var d = s.prefix;
			d && (d === "xml" && (s.uri = t.XML), d !== "xmlns" && (s.uri = r[d || ""]));
		}
		var u = i.indexOf(":");
		u > 0 ? (d = e.prefix = i.slice(0, u), f = e.localName = i.slice(u + 1)) : (d = null, f = e.localName = i);
		var m = e.uri = r[d || ""];
		if (n.startElement(m, f, i, e), e.closed) {
			if (n.endElement(m, f, i), a) for (d in a) Object.prototype.hasOwnProperty.call(a, d) && n.endPrefixMapping(d);
		} else return e.currentNSMap = r, e.localNSMap = a, !0;
	}
	function y(e, t, n, r, i) {
		if (/^(?:script|textarea)$/i.test(n)) {
			var a = e.indexOf("</" + n + ">", t), o = e.substring(t + 1, a);
			if (/[&<]/.test(o)) return /^script$/i.test(n) ? (i.characters(o, 0, o.length), a) : (o = o.replace(/&#?\w+;/g, r), i.characters(o, 0, o.length), a);
		}
		return t + 1;
	}
	function b(e, t, n, r) {
		var i = r[n];
		return i ?? (i = e.lastIndexOf("</" + n + ">"), i < t && (i = e.lastIndexOf("</" + n)), r[n] = i), i < t;
	}
	function x(e, t) {
		for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
	}
	function S(e, t, n, r) {
		switch (e.charAt(t + 2)) {
			case "-":
				if (e.charAt(t + 3) === "-") {
					var i = e.indexOf("-->", t + 4);
					return i > t ? (n.comment(e, t + 4, i - t - 4), i + 3) : (r.error("Unclosed comment"), -1);
				}
				return -1;
			default:
				if (e.substr(t + 3, 6) == "CDATA[") {
					var i = e.indexOf("]]>", t + 9);
					return n.startCDATA(), n.characters(e, t + 9, i - t - 9), n.endCDATA(), i + 3;
				}
				var a = T(e, t), o = a.length;
				if (o > 1 && /!doctype/i.test(a[0][0])) {
					var s = a[1][0], c = !1, l = !1;
					o > 3 && (/^public$/i.test(a[2][0]) ? (c = a[3][0], l = o > 4 && a[4][0]) : /^system$/i.test(a[2][0]) && (l = a[3][0]));
					var u = a[o - 1];
					return n.startDTD(s, c, l), n.endDTD(), u.index + u[0].length;
				}
		}
		return -1;
	}
	function C(e, t, n) {
		var r = e.indexOf("?>", t);
		if (r) {
			var i = e.substring(t, r).match(/^<\?(\S*)\s*([\s\S]*?)$/);
			return i ? (i[0].length, n.processingInstruction(i[1], i[2]), r + 2) : -1;
		}
		return -1;
	}
	function w() {
		this.attributeNames = {};
	}
	w.prototype = {
		setTagName: function(e) {
			if (!i.test(e)) throw Error("invalid tagName:" + e);
			this.tagName = e;
		},
		addValue: function(e, t, n) {
			if (!i.test(e)) throw Error("invalid attribute:" + e);
			this.attributeNames[e] = this.length, this[this.length++] = {
				qName: e,
				value: t,
				offset: n
			};
		},
		length: 0,
		getLocalName: function(e) {
			return this[e].localName;
		},
		getLocator: function(e) {
			return this[e].locator;
		},
		getQName: function(e) {
			return this[e].qName;
		},
		getURI: function(e) {
			return this[e].uri;
		},
		getValue: function(e) {
			return this[e].value;
		}
	};
	function T(e, t) {
		var n, r = [], i = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		for (i.lastIndex = t, i.exec(e); n = i.exec(e);) if (r.push(n), n[1]) return r;
	}
	e.XMLReader = m, e.ParseError = p;
})), MI = /* @__PURE__ */ s(((e) => {
	var t = OI(), n = kI(), r = AI(), i = jI(), a = n.DOMImplementation, o = t.NAMESPACE, s = i.ParseError, c = i.XMLReader;
	function l(e) {
		return e.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
	}
	function u(e) {
		this.options = e || { locator: {} };
	}
	u.prototype.parseFromString = function(e, t) {
		var n = this.options, i = new c(), a = n.domBuilder || new f(), s = n.errorHandler, u = n.locator, p = n.xmlns || {}, m = /\/x?html?$/.test(t), h = m ? r.HTML_ENTITIES : r.XML_ENTITIES;
		u && a.setDocumentLocator(u), i.errorHandler = d(s, a, u), i.domBuilder = n.domBuilder || a, m && (p[""] = o.HTML), p.xml = p.xml || o.XML;
		var g = n.normalizeLineEndings || l;
		return e && typeof e == "string" ? i.parse(g(e), p, h) : i.errorHandler.error("invalid doc source"), a.doc;
	};
	function d(e, t, n) {
		if (!e) {
			if (t instanceof f) return t;
			e = t;
		}
		var r = {}, i = e instanceof Function;
		n ||= {};
		function a(t) {
			var a = e[t];
			!a && i && (a = e.length == 2 ? function(n) {
				e(t, n);
			} : e), r[t] = a && function(e) {
				a("[xmldom " + t + "]	" + e + m(n));
			} || function() {};
		}
		return a("warning"), a("error"), a("fatalError"), r;
	}
	function f() {
		this.cdata = !1;
	}
	function p(e, t) {
		t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber;
	}
	f.prototype = {
		startDocument: function() {
			this.doc = new a().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
		},
		startElement: function(e, t, n, r) {
			var i = this.doc, a = i.createElementNS(e, n || t), o = r.length;
			g(this, a), this.currentElement = a, this.locator && p(this.locator, a);
			for (var s = 0; s < o; s++) {
				var e = r.getURI(s), c = r.getValue(s), n = r.getQName(s), l = i.createAttributeNS(e, n);
				this.locator && p(r.getLocator(s), l), l.value = l.nodeValue = c, a.setAttributeNode(l);
			}
		},
		endElement: function(e, t, n) {
			var r = this.currentElement;
			r.tagName, this.currentElement = r.parentNode;
		},
		startPrefixMapping: function(e, t) {},
		endPrefixMapping: function(e) {},
		processingInstruction: function(e, t) {
			var n = this.doc.createProcessingInstruction(e, t);
			this.locator && p(this.locator, n), g(this, n);
		},
		ignorableWhitespace: function(e, t, n) {},
		characters: function(e, t, n) {
			if (e = h.apply(this, arguments), e) {
				if (this.cdata) var r = this.doc.createCDATASection(e);
				else var r = this.doc.createTextNode(e);
				this.currentElement ? this.currentElement.appendChild(r) : /^\s*$/.test(e) && this.doc.appendChild(r), this.locator && p(this.locator, r);
			}
		},
		skippedEntity: function(e) {},
		endDocument: function() {
			this.doc.normalize();
		},
		setDocumentLocator: function(e) {
			(this.locator = e) && (e.lineNumber = 0);
		},
		comment: function(e, t, n) {
			e = h.apply(this, arguments);
			var r = this.doc.createComment(e);
			this.locator && p(this.locator, r), g(this, r);
		},
		startCDATA: function() {
			this.cdata = !0;
		},
		endCDATA: function() {
			this.cdata = !1;
		},
		startDTD: function(e, t, n) {
			var r = this.doc.implementation;
			if (r && r.createDocumentType) {
				var i = r.createDocumentType(e, t, n);
				this.locator && p(this.locator, i), g(this, i), this.doc.doctype = i;
			}
		},
		warning: function(e) {
			console.warn("[xmldom warning]	" + e, m(this.locator));
		},
		error: function(e) {
			console.error("[xmldom error]	" + e, m(this.locator));
		},
		fatalError: function(e) {
			throw new s(e, this.locator);
		}
	};
	function m(e) {
		if (e) return "\n@" + (e.systemId || "") + "#[line:" + e.lineNumber + ",col:" + e.columnNumber + "]";
	}
	function h(e, t, n) {
		return typeof e == "string" ? e.substr(t, n) : e.length >= t + n || t ? new java.lang.String(e, t, n) + "" : e;
	}
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(e) {
		f.prototype[e] = function() {
			return null;
		};
	});
	function g(e, t) {
		e.currentElement ? e.currentElement.appendChild(t) : e.doc.appendChild(t);
	}
	e.__DOMHandler = f, e.normalizeLineEndings = l, e.DOMParser = u;
})), NI = /* @__PURE__ */ s(((e) => {
	var t = kI();
	e.DOMImplementation = t.DOMImplementation, e.XMLSerializer = t.XMLSerializer, e.DOMParser = MI().DOMParser;
})), PI, FI, II, LI, RI, zI, BI, VI, HI, UI, WI, GI, KI, qI, JI, YI, XI, ZI, QI, $I, eL, tL, nL, rL, iL, aL, oL, sL, cL, lL, uL, dL, fL, pL, mL, hL, gL, _L, vL, yL, bL, xL, SL, CL, wL, TL, EL, DL, OL, kL, AL, jL, ML, NL, PL, FL, IL, LL, RL, zL, BL, VL, HL, UL, WL, GL, KL, qL, JL, YL, XL, ZL, QL, $L, eR, tR, nR, rR, iR = o((() => {
	kF(), PI = /* @__PURE__ */ u(dF()), DI(), FF(), FI = NI(), II = (e) => !!e && typeof e == "object", LI = (...e) => e.reduce((e, t) => (typeof t == "object" && Object.keys(t).forEach((n) => {
		e[n] = Array.isArray(e[n]) && Array.isArray(t[n]) ? e[n].concat(t[n]) : II(e[n]) && II(t[n]) ? LI(e[n], t[n]) : t[n];
	}), e), {}), RI = (e) => Object.keys(e).map((t) => e[t]), zI = (e, t) => {
		let n = [];
		for (let r = e; r < t; r++) n.push(r);
		return n;
	}, BI = (e) => e.reduce((e, t) => e.concat(t), []), VI = (e) => {
		if (!e.length) return [];
		let t = [];
		for (let n = 0; n < e.length; n++) t.push(e[n]);
		return t;
	}, HI = (e, t) => e.reduce((e, n, r) => (n[t] && e.push(r), e), []), UI = (e, t) => RI(e.reduce((e, n) => (n.forEach((n) => {
		e[t(n)] = n;
	}), e), {})), WI = {
		INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
		INVALID_NUMBER_OF_CONTENT_STEERING: "INVALID_NUMBER_OF_CONTENT_STEERING",
		DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
		DASH_INVALID_XML: "DASH_INVALID_XML",
		NO_BASE_URL: "NO_BASE_URL",
		MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
		SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
		UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
	}, GI = ({ baseUrl: e = "", source: t = "", range: n = "", indexRange: r = "" }) => {
		let i = {
			uri: t,
			resolvedUri: OF(e || "", t)
		};
		if (n || r) {
			let e = (n || r).split("-"), t = PI.default.BigInt ? PI.default.BigInt(e[0]) : parseInt(e[0], 10), a = PI.default.BigInt ? PI.default.BigInt(e[1]) : parseInt(e[1], 10);
			t < 2 ** 53 - 1 && typeof t == "bigint" && (t = Number(t)), a < 2 ** 53 - 1 && typeof a == "bigint" && (a = Number(a));
			let o;
			o = typeof a == "bigint" || typeof t == "bigint" ? PI.default.BigInt(a) - PI.default.BigInt(t) + PI.default.BigInt(1) : a - t + 1, typeof o == "bigint" && o < 2 ** 53 - 1 && (o = Number(o)), i.byterange = {
				length: o,
				offset: t
			};
		}
		return i;
	}, KI = (e) => {
		let t;
		return t = typeof e.offset == "bigint" || typeof e.length == "bigint" ? PI.default.BigInt(e.offset) + PI.default.BigInt(e.length) - PI.default.BigInt(1) : e.offset + e.length - 1, `${e.offset}-${t}`;
	}, qI = (e) => (e && typeof e != "number" && (e = parseInt(e, 10)), isNaN(e) ? null : e), JI = {
		static(e) {
			let { duration: t, timescale: n = 1, sourceDuration: r, periodDuration: i } = e, a = qI(e.endNumber), o = t / n;
			return typeof a == "number" ? {
				start: 0,
				end: a
			} : typeof i == "number" ? {
				start: 0,
				end: i / o
			} : {
				start: 0,
				end: r / o
			};
		},
		dynamic(e) {
			let { NOW: t, clientOffset: n, availabilityStartTime: r, timescale: i = 1, duration: a, periodStart: o = 0, minimumUpdatePeriod: s = 0, timeShiftBufferDepth: c = Infinity } = e, l = qI(e.endNumber), u = (t + n) / 1e3, d = r + o, f = u + s - d, p = Math.ceil(f * i / a), m = Math.floor((u - d - c) * i / a), h = Math.floor((u - d) * i / a);
			return {
				start: Math.max(0, m),
				end: typeof l == "number" ? l : Math.min(p, h)
			};
		}
	}, YI = (e) => (t) => {
		let { duration: n, timescale: r = 1, periodStart: i, startNumber: a = 1 } = e;
		return {
			number: a + t,
			duration: n / r,
			timeline: i,
			time: t * n
		};
	}, XI = (e) => {
		let { type: t, duration: n, timescale: r = 1, periodDuration: i, sourceDuration: a } = e, { start: o, end: s } = JI[t](e), c = zI(o, s).map(YI(e));
		if (t === "static") {
			let e = c.length - 1, t = typeof i == "number" ? i : a;
			c[e].duration = t - n / r * e;
		}
		return c;
	}, ZI = (e) => {
		let { baseUrl: t, initialization: n = {}, sourceDuration: r, indexRange: i = "", periodStart: a, presentationTime: o, number: s = 0, duration: c } = e;
		if (!t) throw Error(WI.NO_BASE_URL);
		let l = GI({
			baseUrl: t,
			source: n.sourceURL,
			range: n.range
		}), u = GI({
			baseUrl: t,
			source: t,
			indexRange: i
		});
		if (u.map = l, c) {
			let t = XI(e);
			t.length && (u.duration = t[0].duration, u.timeline = t[0].timeline);
		} else r && (u.duration = r, u.timeline = a);
		return u.presentationTime = o || a, u.number = s, [u];
	}, QI = (e, t, n) => {
		let r = e.sidx.map ? e.sidx.map : null, i = e.sidx.duration, a = e.timeline || 0, o = e.sidx.byterange, s = o.offset + o.length, c = t.timescale, l = t.references.filter((e) => e.referenceType !== 1), u = [], d = e.endList ? "static" : "dynamic", f = e.sidx.timeline, p = f, m = e.mediaSequence || 0, h;
		h = typeof t.firstOffset == "bigint" ? PI.default.BigInt(s) + t.firstOffset : s + t.firstOffset;
		for (let e = 0; e < l.length; e++) {
			let o = t.references[e], s = o.referencedSize, l = o.subsegmentDuration, g;
			g = typeof h == "bigint" ? h + PI.default.BigInt(s) - PI.default.BigInt(1) : h + s - 1;
			let _ = `${h}-${g}`, v = ZI({
				baseUrl: n,
				timescale: c,
				timeline: a,
				periodStart: f,
				presentationTime: p,
				number: m,
				duration: l,
				sourceDuration: i,
				indexRange: _,
				type: d
			})[0];
			r && (v.map = r), u.push(v), h += typeof h == "bigint" ? PI.default.BigInt(s) : s, p += l / c, m++;
		}
		return e.segments = u, e;
	}, $I = ["AUDIO", "SUBTITLES"], eL = 1 / 60, tL = (e) => UI(e, ({ timeline: e }) => e).sort((e, t) => e.timeline > t.timeline ? 1 : -1), nL = (e, t) => {
		for (let n = 0; n < e.length; n++) if (e[n].attributes.NAME === t) return e[n];
		return null;
	}, rL = (e) => {
		let t = [];
		return EI(e, $I, (e, n, r, i) => {
			t = t.concat(e.playlists || []);
		}), t;
	}, iL = ({ playlist: e, mediaSequence: t }) => {
		e.mediaSequence = t, e.segments.forEach((t, n) => {
			t.number = e.mediaSequence + n;
		});
	}, aL = ({ oldPlaylists: e, newPlaylists: t, timelineStarts: n }) => {
		t.forEach((t) => {
			t.discontinuitySequence = n.findIndex(function({ timeline: e }) {
				return e === t.timeline;
			});
			let r = nL(e, t.attributes.NAME);
			if (!r || t.sidx) return;
			let i = t.segments[0], a = r.segments.findIndex(function(e) {
				return Math.abs(e.presentationTime - i.presentationTime) < eL;
			});
			if (a === -1) {
				iL({
					playlist: t,
					mediaSequence: r.mediaSequence + r.segments.length
				}), t.segments[0].discontinuity = !0, t.discontinuityStarts.unshift(0), (!r.segments.length && t.timeline > r.timeline || r.segments.length && t.timeline > r.segments[r.segments.length - 1].timeline) && t.discontinuitySequence--;
				return;
			}
			r.segments[a].discontinuity && !i.discontinuity && (i.discontinuity = !0, t.discontinuityStarts.unshift(0), t.discontinuitySequence--), iL({
				playlist: t,
				mediaSequence: r.segments[a].number
			});
		});
	}, oL = ({ oldManifest: e, newManifest: t }) => {
		let n = e.playlists.concat(rL(e)), r = t.playlists.concat(rL(t));
		return t.timelineStarts = tL([e.timelineStarts, t.timelineStarts]), aL({
			oldPlaylists: n,
			newPlaylists: r,
			timelineStarts: t.timelineStarts
		}), t;
	}, sL = (e) => e && e.uri + "-" + KI(e.byterange), cL = (e) => {
		let t = e.reduce(function(e, t) {
			return e[t.attributes.baseUrl] || (e[t.attributes.baseUrl] = []), e[t.attributes.baseUrl].push(t), e;
		}, {}), n = [];
		return Object.values(t).forEach((e) => {
			let t = RI(e.reduce((e, t) => {
				let n = t.attributes.id + (t.attributes.lang || "");
				return e[n] ? (t.segments && (t.segments[0] && (t.segments[0].discontinuity = !0), e[n].segments.push(...t.segments)), t.attributes.contentProtection && (e[n].attributes.contentProtection = t.attributes.contentProtection)) : (e[n] = t, e[n].attributes.timelineStarts = []), e[n].attributes.timelineStarts.push({
					start: t.attributes.periodStart,
					timeline: t.attributes.periodStart
				}), e;
			}, {}));
			n = n.concat(t);
		}), n.map((e) => (e.discontinuityStarts = HI(e.segments || [], "discontinuity"), e));
	}, lL = (e, t) => {
		let n = sL(e.sidx), r = n && t[n] && t[n].sidx;
		return r && QI(e, r, e.sidx.resolvedUri), e;
	}, uL = (e, t = {}) => {
		if (!Object.keys(t).length) return e;
		for (let n in e) e[n] = lL(e[n], t);
		return e;
	}, dL = ({ attributes: e, segments: t, sidx: n, mediaSequence: r, discontinuitySequence: i, discontinuityStarts: a }, o) => {
		let s = {
			attributes: {
				NAME: e.id,
				BANDWIDTH: e.bandwidth,
				CODECS: e.codecs,
				"PROGRAM-ID": 1
			},
			uri: "",
			endList: e.type === "static",
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			targetDuration: e.duration,
			discontinuitySequence: i,
			discontinuityStarts: a,
			timelineStarts: e.timelineStarts,
			mediaSequence: r,
			segments: t
		};
		return e.contentProtection && (s.contentProtection = e.contentProtection), e.serviceLocation && (s.attributes.serviceLocation = e.serviceLocation), n && (s.sidx = n), o && (s.attributes.AUDIO = "audio", s.attributes.SUBTITLES = "subs"), s;
	}, fL = ({ attributes: e, segments: t, mediaSequence: n, discontinuityStarts: r, discontinuitySequence: i }) => {
		t === void 0 && (t = [{
			uri: e.baseUrl,
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			duration: e.sourceDuration,
			number: 0
		}], e.duration = e.sourceDuration);
		let a = {
			NAME: e.id,
			BANDWIDTH: e.bandwidth,
			"PROGRAM-ID": 1
		};
		e.codecs && (a.CODECS = e.codecs);
		let o = {
			attributes: a,
			uri: "",
			endList: e.type === "static",
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			targetDuration: e.duration,
			timelineStarts: e.timelineStarts,
			discontinuityStarts: r,
			discontinuitySequence: i,
			mediaSequence: n,
			segments: t
		};
		return e.serviceLocation && (o.attributes.serviceLocation = e.serviceLocation), o;
	}, pL = (e, t = {}, n = !1) => {
		let r, i = e.reduce((e, i) => {
			let a = i.attributes.role && i.attributes.role.value || "", o = i.attributes.lang || "", s = i.attributes.label || "main";
			if (o && !i.attributes.label) {
				let e = a ? ` (${a})` : "";
				s = `${i.attributes.lang}${e}`;
			}
			e[s] || (e[s] = {
				language: o,
				autoselect: !0,
				default: a === "main",
				playlists: [],
				uri: ""
			});
			let c = lL(dL(i, n), t);
			return e[s].playlists.push(c), r === void 0 && a === "main" && (r = i, r.default = !0), e;
		}, {});
		if (!r) {
			let e = Object.keys(i)[0];
			i[e].default = !0;
		}
		return i;
	}, mL = (e, t = {}) => e.reduce((e, n) => {
		let r = n.attributes.label || n.attributes.lang || "text", i = n.attributes.lang || "und";
		return e[r] || (e[r] = {
			language: i,
			default: !1,
			autoselect: !1,
			playlists: [],
			uri: ""
		}), e[r].playlists.push(lL(fL(n), t)), e;
	}, {}), hL = (e) => e.reduce((e, t) => (t && t.forEach((t) => {
		let { channel: n, language: r } = t;
		e[r] = {
			autoselect: !1,
			default: !1,
			instreamId: n,
			language: r
		}, t.hasOwnProperty("aspectRatio") && (e[r].aspectRatio = t.aspectRatio), t.hasOwnProperty("easyReader") && (e[r].easyReader = t.easyReader), t.hasOwnProperty("3D") && (e[r]["3D"] = t["3D"]);
	}), e), {}), gL = ({ attributes: e, segments: t, sidx: n, discontinuityStarts: r }) => {
		let i = {
			attributes: {
				NAME: e.id,
				AUDIO: "audio",
				SUBTITLES: "subs",
				RESOLUTION: {
					width: e.width,
					height: e.height
				},
				CODECS: e.codecs,
				BANDWIDTH: e.bandwidth,
				"PROGRAM-ID": 1
			},
			uri: "",
			endList: e.type === "static",
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			targetDuration: e.duration,
			discontinuityStarts: r,
			timelineStarts: e.timelineStarts,
			segments: t
		};
		return e.frameRate && (i.attributes["FRAME-RATE"] = e.frameRate), e.qualityRanking !== void 0 && (i.attributes.SCORE = 1 / (e.qualityRanking + 1)), e.contentProtection && (i.contentProtection = e.contentProtection), e.serviceLocation && (i.attributes.serviceLocation = e.serviceLocation), n && (i.sidx = n), i;
	}, _L = ({ attributes: e }) => e.mimeType === "video/mp4" || e.mimeType === "video/webm" || e.contentType === "video", vL = ({ attributes: e }) => e.mimeType === "audio/mp4" || e.mimeType === "audio/webm" || e.contentType === "audio", yL = ({ attributes: e }) => e.mimeType === "text/vtt" || e.contentType === "text", bL = (e, t) => {
		e.forEach((e) => {
			e.mediaSequence = 0, e.discontinuitySequence = t.findIndex(function({ timeline: t }) {
				return t === e.timeline;
			}), e.segments && e.segments.forEach((e, t) => {
				e.number = t;
			});
		});
	}, xL = (e) => e ? Object.keys(e).reduce((t, n) => {
		let r = e[n];
		return t.concat(r.playlists);
	}, []) : [], SL = ({ dashPlaylists: e, locations: t, contentSteering: n, sidxMapping: r = {}, previousManifest: i, eventStream: a }) => {
		if (!e.length) return {};
		let { sourceDuration: o, type: s, suggestedPresentationDelay: c, minimumUpdatePeriod: l } = e[0].attributes, u = cL(e.filter(_L)).map(gL), d = cL(e.filter(vL)), f = cL(e.filter(yL)), p = e.map((e) => e.attributes.captionServices).filter(Boolean), m = {
			allowCache: !0,
			discontinuityStarts: [],
			segments: [],
			endList: !0,
			mediaGroups: {
				AUDIO: {},
				VIDEO: {},
				"CLOSED-CAPTIONS": {},
				SUBTITLES: {}
			},
			uri: "",
			duration: o,
			playlists: uL(u, r)
		};
		l >= 0 && (m.minimumUpdatePeriod = l * 1e3), t && (m.locations = t), n && (m.contentSteering = n), s === "dynamic" && (m.suggestedPresentationDelay = c), a && a.length > 0 && (m.eventStream = a);
		let h = m.playlists.length === 0, g = d.length ? pL(d, r, h) : null, _ = f.length ? mL(f, r) : null, v = u.concat(xL(g), xL(_)), y = v.map(({ timelineStarts: e }) => e);
		return m.timelineStarts = tL(y), bL(v, m.timelineStarts), g && (m.mediaGroups.AUDIO.audio = g), _ && (m.mediaGroups.SUBTITLES.subs = _), p.length && (m.mediaGroups["CLOSED-CAPTIONS"].cc = hL(p)), i ? oL({
			oldManifest: i,
			newManifest: m
		}) : m;
	}, CL = (e, t, n) => {
		let { NOW: r, clientOffset: i, availabilityStartTime: a, timescale: o = 1, periodStart: s = 0, minimumUpdatePeriod: c = 0 } = e, l = (r + i) / 1e3, u = a + s, d = l + c - u;
		return Math.ceil((d * o - t) / n);
	}, wL = (e, t) => {
		let { type: n, minimumUpdatePeriod: r = 0, media: i = "", sourceDuration: a, timescale: o = 1, startNumber: s = 1, periodStart: c } = e, l = [], u = -1;
		for (let d = 0; d < t.length; d++) {
			let f = t[d], p = f.d, m = f.r || 0, h = f.t || 0;
			u < 0 && (u = h), h && h > u && (u = h);
			let g;
			if (m < 0) {
				let s = d + 1;
				g = s === t.length ? n === "dynamic" && r > 0 && i.indexOf("$Number$") > 0 ? CL(e, u, p) : (a * o - u) / p : (t[s].t - u) / p;
			} else g = m + 1;
			let _ = s + l.length + g, v = s + l.length;
			for (; v < _;) l.push({
				number: v,
				duration: p / o,
				time: u,
				timeline: c
			}), u += p, v++;
		}
		return l;
	}, TL = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, EL = (e) => (t, n, r, i) => {
		if (t === "$$") return "$";
		if (e[n] === void 0) return t;
		let a = "" + e[n];
		return n === "RepresentationID" || (i = r ? parseInt(i, 10) : 1, a.length >= i) ? a : `${Array(i - a.length + 1).join("0")}${a}`;
	}, DL = (e, t) => e.replace(TL, EL(t)), OL = (e, t) => !e.duration && !t ? [{
		number: e.startNumber || 1,
		duration: e.sourceDuration,
		time: 0,
		timeline: e.periodStart
	}] : e.duration ? XI(e) : wL(e, t), kL = (e, t) => {
		let n = {
			RepresentationID: e.id,
			Bandwidth: e.bandwidth || 0
		}, { initialization: r = {
			sourceURL: "",
			range: ""
		} } = e, i = GI({
			baseUrl: e.baseUrl,
			source: DL(r.sourceURL, n),
			range: r.range
		});
		return OL(e, t).map((t) => {
			n.Number = t.number, n.Time = t.time;
			let r = DL(e.media || "", n), a = e.timescale || 1, o = e.presentationTimeOffset || 0, s = e.periodStart + (t.time - o) / a;
			return {
				uri: r,
				timeline: t.timeline,
				duration: t.duration,
				resolvedUri: OF(e.baseUrl || "", r),
				map: i,
				number: t.number,
				presentationTime: s
			};
		});
	}, AL = (e, t) => {
		let { baseUrl: n, initialization: r = {} } = e, i = GI({
			baseUrl: n,
			source: r.sourceURL,
			range: r.range
		}), a = GI({
			baseUrl: n,
			source: t.media,
			range: t.mediaRange
		});
		return a.map = i, a;
	}, jL = (e, t) => {
		let { duration: n, segmentUrls: r = [], periodStart: i } = e;
		if (!n && !t || n && t) throw Error(WI.SEGMENT_TIME_UNSPECIFIED);
		let a = r.map((t) => AL(e, t)), o;
		return n && (o = XI(e)), t && (o = wL(e, t)), o.map((t, n) => {
			if (a[n]) {
				let r = a[n], o = e.timescale || 1, s = e.presentationTimeOffset || 0;
				return r.timeline = t.timeline, r.duration = t.duration, r.number = t.number, r.presentationTime = i + (t.time - s) / o, r;
			}
		}).filter((e) => e);
	}, ML = ({ attributes: e, segmentInfo: t }) => {
		let n, r;
		t.template ? (r = kL, n = LI(e, t.template)) : t.base ? (r = ZI, n = LI(e, t.base)) : t.list && (r = jL, n = LI(e, t.list));
		let i = { attributes: e };
		if (!r) return i;
		let a = r(n, t.segmentTimeline);
		if (n.duration) {
			let { duration: e, timescale: t = 1 } = n;
			n.duration = e / t;
		} else a.length ? n.duration = a.reduce((e, t) => Math.max(e, Math.ceil(t.duration)), 0) : n.duration = 0;
		return i.attributes = n, i.segments = a, t.base && n.indexRange && (i.sidx = a[0], i.segments = []), i;
	}, NL = (e) => e.map(ML), PL = (e, t) => VI(e.childNodes).filter(({ tagName: e }) => e === t), FL = (e) => e.textContent.trim(), IL = (e) => parseFloat(e.split("/").reduce((e, t) => e / t)), LL = (e) => {
		let t = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(e);
		if (!t) return 0;
		let [n, r, i, a, o, s] = t.slice(1);
		return parseFloat(n || 0) * 31536e3 + parseFloat(r || 0) * 2592e3 + parseFloat(i || 0) * 86400 + parseFloat(a || 0) * 3600 + parseFloat(o || 0) * 60 + parseFloat(s || 0);
	}, RL = (e) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(e) && (e += "Z"), Date.parse(e)), zL = {
		mediaPresentationDuration(e) {
			return LL(e);
		},
		availabilityStartTime(e) {
			return RL(e) / 1e3;
		},
		minimumUpdatePeriod(e) {
			return LL(e);
		},
		suggestedPresentationDelay(e) {
			return LL(e);
		},
		type(e) {
			return e;
		},
		timeShiftBufferDepth(e) {
			return LL(e);
		},
		start(e) {
			return LL(e);
		},
		width(e) {
			return parseInt(e, 10);
		},
		height(e) {
			return parseInt(e, 10);
		},
		bandwidth(e) {
			return parseInt(e, 10);
		},
		frameRate(e) {
			return IL(e);
		},
		startNumber(e) {
			return parseInt(e, 10);
		},
		timescale(e) {
			return parseInt(e, 10);
		},
		presentationTimeOffset(e) {
			return parseInt(e, 10);
		},
		duration(e) {
			let t = parseInt(e, 10);
			return isNaN(t) ? LL(e) : t;
		},
		d(e) {
			return parseInt(e, 10);
		},
		t(e) {
			return parseInt(e, 10);
		},
		r(e) {
			return parseInt(e, 10);
		},
		presentationTime(e) {
			return parseInt(e, 10);
		},
		qualityRanking(e) {
			return parseInt(e, 10);
		},
		qualityranking(e) {
			return parseInt(e, 10);
		},
		DEFAULT(e) {
			return e;
		}
	}, BL = { qualityranking: "qualityRanking" }, VL = (e) => e && e.attributes ? VI(e.attributes).reduce((e, t) => {
		let n = zL[t.name] || zL.DEFAULT, r = BL[t.name] || t.name;
		return e[r] = n(t.value), e;
	}, {}) : {}, HL = {
		"urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
		"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
		"urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
		"urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
		"urn:mpeg:dash:mp4protection:2011": "mp4protection"
	}, UL = (e, t) => t.length ? BI(e.map(function(e) {
		return t.map(function(t) {
			let n = FL(t), r = OF(e.baseUrl, n), i = LI(VL(t), { baseUrl: r });
			return r !== n && !i.serviceLocation && e.serviceLocation && (i.serviceLocation = e.serviceLocation), i;
		});
	})) : e, WL = (e) => {
		let t = PL(e, "SegmentTemplate")[0], n = PL(e, "SegmentList")[0], r = n && PL(n, "SegmentURL").map((e) => LI({ tag: "SegmentURL" }, VL(e))), i = PL(e, "SegmentBase")[0], a = n || t, o = a && PL(a, "SegmentTimeline")[0], s = n || i || t, c = s && PL(s, "Initialization")[0], l = t && VL(t);
		l && c ? l.initialization = c && VL(c) : l && l.initialization && (l.initialization = { sourceURL: l.initialization });
		let u = {
			template: l,
			segmentTimeline: o && PL(o, "S").map((e) => VL(e)),
			list: n && LI(VL(n), {
				segmentUrls: r,
				initialization: VL(c)
			}),
			base: i && LI(VL(i), { initialization: VL(c) })
		};
		return Object.keys(u).forEach((e) => {
			u[e] || delete u[e];
		}), u;
	}, GL = (e, t, n) => (r) => {
		let i = PL(r, "BaseURL"), a = UL(t, i), o = LI(e, VL(r)), s = WL(r);
		return a.map((e) => ({
			segmentInfo: LI(n, s),
			attributes: LI(o, e)
		}));
	}, KL = (e) => e.reduce((e, t) => {
		let n = VL(t);
		n.schemeIdUri &&= n.schemeIdUri.toLowerCase();
		let r = HL[n.schemeIdUri];
		if (r) {
			e[r] = { attributes: n };
			let i = PL(t, "cenc:pssh")[0];
			if (i) {
				let t = FL(i);
				e[r].pssh = t && MF(t);
			}
		}
		return e;
	}, {}), qL = (e) => {
		if (e.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") return (typeof e.value == "string" ? e.value.split(";") : []).map((e) => {
			let t, n;
			return n = e, /^CC\d=/.test(e) ? [t, n] = e.split("=") : /^CC\d$/.test(e) && (t = e), {
				channel: t,
				language: n
			};
		});
		if (e.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") return (typeof e.value == "string" ? e.value.split(";") : []).map((e) => {
			let t = {
				channel: void 0,
				language: void 0,
				aspectRatio: 1,
				easyReader: 0,
				"3D": 0
			};
			if (/=/.test(e)) {
				let [n, r = ""] = e.split("=");
				t.channel = n, t.language = e, r.split(",").forEach((e) => {
					let [n, r] = e.split(":");
					n === "lang" ? t.language = r : n === "er" ? t.easyReader = Number(r) : n === "war" ? t.aspectRatio = Number(r) : n === "3D" && (t["3D"] = Number(r));
				});
			} else t.language = e;
			return t.channel &&= "SERVICE" + t.channel, t;
		});
	}, JL = (e) => BI(PL(e.node, "EventStream").map((t) => {
		let n = VL(t), r = n.schemeIdUri;
		return PL(t, "Event").map((t) => {
			let i = VL(t), a = i.presentationTime || 0, o = n.timescale || 1, s = i.duration || 0, c = a / o + e.attributes.start;
			return {
				schemeIdUri: r,
				value: n.value,
				id: i.id,
				start: c,
				end: c + s / o,
				messageData: FL(t) || i.messageData,
				contentEncoding: n.contentEncoding,
				presentationTimeOffset: n.presentationTimeOffset || 0
			};
		});
	})), YL = (e, t, n) => (r) => {
		let i = VL(r), a = UL(t, PL(r, "BaseURL")), o = PL(r, "Role")[0], s = { role: VL(o) }, c = LI(e, i, s), l = PL(r, "Accessibility")[0], u = qL(VL(l));
		u && (c = LI(c, { captionServices: u }));
		let d = PL(r, "Label")[0];
		if (d && d.childNodes.length) {
			let e = d.childNodes[0].nodeValue.trim();
			c = LI(c, { label: e });
		}
		let f = KL(PL(r, "ContentProtection"));
		Object.keys(f).length && (c = LI(c, { contentProtection: f }));
		let p = WL(r), m = PL(r, "Representation"), h = LI(n, p);
		return BI(m.map(GL(c, a, h)));
	}, XL = (e, t) => (n, r) => {
		let i = UL(t, PL(n.node, "BaseURL")), a = LI(e, { periodStart: n.attributes.start });
		typeof n.attributes.duration == "number" && (a.periodDuration = n.attributes.duration);
		let o = PL(n.node, "AdaptationSet"), s = WL(n.node);
		return BI(o.map(YL(a, i, s)));
	}, ZL = (e, t) => {
		if (e.length > 1 && t({
			type: "warn",
			message: "The MPD manifest should contain no more than one ContentSteering tag"
		}), !e.length) return null;
		let n = LI({ serverURL: FL(e[0]) }, VL(e[0]));
		return n.queryBeforeStart = n.queryBeforeStart === "true", n;
	}, QL = ({ attributes: e, priorPeriodAttributes: t, mpdType: n }) => typeof e.start == "number" ? e.start : t && typeof t.start == "number" && typeof t.duration == "number" ? t.start + t.duration : !t && n === "static" ? 0 : null, $L = (e, t = {}) => {
		let { manifestUri: n = "", NOW: r = Date.now(), clientOffset: i = 0, eventHandler: a = function() {} } = t, o = PL(e, "Period");
		if (!o.length) throw Error(WI.INVALID_NUMBER_OF_PERIOD);
		let s = PL(e, "Location"), c = VL(e), l = UL([{ baseUrl: n }], PL(e, "BaseURL")), u = PL(e, "ContentSteering");
		c.type = c.type || "static", c.sourceDuration = c.mediaPresentationDuration || 0, c.NOW = r, c.clientOffset = i, s.length && (c.locations = s.map(FL));
		let d = [];
		return o.forEach((e, t) => {
			let n = VL(e), r = d[t - 1];
			n.start = QL({
				attributes: n,
				priorPeriodAttributes: r ? r.attributes : null,
				mpdType: c.type
			}), d.push({
				node: e,
				attributes: n
			});
		}), {
			locations: c.locations,
			contentSteeringInfo: ZL(u, a),
			representationInfo: BI(d.map(XL(c, l))),
			eventStream: BI(d.map(JL))
		};
	}, eR = (e) => {
		if (e === "") throw Error(WI.DASH_EMPTY_MANIFEST);
		let t = new FI.DOMParser(), n, r;
		try {
			n = t.parseFromString(e, "application/xml"), r = n && n.documentElement.tagName === "MPD" ? n.documentElement : null;
		} catch {}
		if (!r || r && r.getElementsByTagName("parsererror").length > 0) throw Error(WI.DASH_INVALID_XML);
		return r;
	}, tR = (e) => {
		let t = PL(e, "UTCTiming")[0];
		if (!t) return null;
		let n = VL(t);
		switch (n.schemeIdUri) {
			case "urn:mpeg:dash:utc:http-head:2014":
			case "urn:mpeg:dash:utc:http-head:2012":
				n.method = "HEAD";
				break;
			case "urn:mpeg:dash:utc:http-xsdate:2014":
			case "urn:mpeg:dash:utc:http-iso:2014":
			case "urn:mpeg:dash:utc:http-xsdate:2012":
			case "urn:mpeg:dash:utc:http-iso:2012":
				n.method = "GET";
				break;
			case "urn:mpeg:dash:utc:direct:2014":
			case "urn:mpeg:dash:utc:direct:2012":
				n.method = "DIRECT", n.value = Date.parse(n.value);
				break;
			default: throw Error(WI.UNSUPPORTED_UTC_TIMING_SCHEME);
		}
		return n;
	}, nR = (e, t = {}) => {
		let n = $L(eR(e), t), r = NL(n.representationInfo);
		return SL({
			dashPlaylists: r,
			locations: n.locations,
			contentSteering: n.contentSteeringInfo,
			sidxMapping: t.sidxMapping,
			previousManifest: t.previousManifest,
			eventStream: n.eventStream
		});
	}, rR = (e) => tR(eR(e));
})), aR = /* @__PURE__ */ s(((e, t) => {
	var n = 2 ** 32;
	t.exports = {
		getUint64: function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), r;
			return t.getBigUint64 ? (r = t.getBigUint64(0), r < 2 ** 53 - 1 ? Number(r) : r) : t.getUint32(0) * n + t.getUint32(4);
		},
		MAX_UINT32: n
	};
})), oR = /* @__PURE__ */ s(((e, t) => {
	var n = aR().getUint64;
	t.exports = function(e) {
		var t = new DataView(e.buffer, e.byteOffset, e.byteLength), r = {
			version: e[0],
			flags: new Uint8Array(e.subarray(1, 4)),
			references: [],
			referenceId: t.getUint32(4),
			timescale: t.getUint32(8)
		}, i = 12;
		r.version === 0 ? (r.earliestPresentationTime = t.getUint32(i), r.firstOffset = t.getUint32(i + 4), i += 8) : (r.earliestPresentationTime = n(e.subarray(i)), r.firstOffset = n(e.subarray(i + 8)), i += 16), i += 2;
		var a = t.getUint16(i);
		for (i += 2; a > 0; i += 12, a--) r.references.push({
			referenceType: (e[i] & 128) >>> 7,
			referencedSize: t.getUint32(i) & 2147483647,
			subsegmentDuration: t.getUint32(i + 4),
			startsWithSap: !!(e[i + 8] & 128),
			sapType: (e[i + 8] & 112) >>> 4,
			sapDeltaTime: t.getUint32(i + 8) & 268435455
		});
		return r;
	};
})), sR, cR, lR, uR = o((() => {
	TI(), sR = gI([
		73,
		68,
		51
	]), cR = function(e, t) {
		t === void 0 && (t = 0), e = gI(e);
		var n = e[t + 5], r = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9];
		return (n & 16) >> 4 ? r + 20 : r + 10;
	}, lR = function e(t, n) {
		return n === void 0 && (n = 0), t = gI(t), t.length - n < 10 || !wI(t, sR, { offset: n }) ? n : (n += cR(t, n), e(t, n));
	};
})), dR = o((() => {
	TI();
})), fR = o((() => {
	new Uint8Array([
		79,
		112,
		117,
		115,
		72,
		101,
		97,
		100
	]);
})), pR, mR, hR, gR, _R, vR = o((() => {
	TI(), dR(), fR(), pR = function(e) {
		return typeof e == "string" ? SI(e) : e;
	}, mR = function(e) {
		return Array.isArray(e) ? e.map(function(e) {
			return pR(e);
		}) : [pR(e)];
	}, gR = function(e) {
		e = gI(e);
		for (var t = [], n = 0; e.length > n;) {
			var r = e[n], i = 0, a = 0;
			a++;
			var o = e[a];
			for (a++; o & 128;) i = (o & 127) << 7, o = e[a], a++;
			i += o & 127;
			for (var s = 0; s < hR.length; s++) {
				var c = hR[s], l = c.id, u = c.parser;
				if (r === l) {
					t.push(u(e.subarray(a, a + i)));
					break;
				}
			}
			n += i + a;
		}
		return t;
	}, hR = [
		{
			id: 3,
			parser: function(e) {
				var t = {
					tag: 3,
					id: e[0] << 8 | e[1],
					flags: e[2],
					size: 3,
					dependsOnEsId: 0,
					ocrEsId: 0,
					descriptors: [],
					url: ""
				};
				if (t.flags & 128 && (t.dependsOnEsId = e[t.size] << 8 | e[t.size + 1], t.size += 2), t.flags & 64) {
					var n = e[t.size];
					t.url = xI(e.subarray(t.size + 1, t.size + 1 + n)), t.size += n;
				}
				return t.flags & 32 && (t.ocrEsId = e[t.size] << 8 | e[t.size + 1], t.size += 2), t.descriptors = gR(e.subarray(t.size)) || [], t;
			}
		},
		{
			id: 4,
			parser: function(e) {
				return {
					tag: 4,
					oti: e[0],
					streamType: e[1],
					bufferSize: e[2] << 16 | e[3] << 8 | e[4],
					maxBitrate: e[5] << 24 | e[6] << 16 | e[7] << 8 | e[8],
					avgBitrate: e[9] << 24 | e[10] << 16 | e[11] << 8 | e[12],
					descriptors: gR(e.subarray(13))
				};
			}
		},
		{
			id: 5,
			parser: function(e) {
				return {
					tag: 5,
					bytes: e
				};
			}
		},
		{
			id: 6,
			parser: function(e) {
				return {
					tag: 6,
					bytes: e
				};
			}
		}
	], _R = function e(t, n, r) {
		r === void 0 && (r = !1), n = mR(n), t = gI(t);
		var i = [];
		if (!n.length) return i;
		for (var a = 0; a < t.length;) {
			var o = (t[a] << 24 | t[a + 1] << 16 | t[a + 2] << 8 | t[a + 3]) >>> 0, s = t.subarray(a + 4, a + 8);
			if (o === 0) break;
			var c = a + o;
			if (c > t.length) {
				if (r) break;
				c = t.length;
			}
			var l = t.subarray(a + 8, c);
			wI(s, n[0]) && (n.length === 1 ? i.push(l) : i.push.apply(i, e(l, n.slice(1), r))), a = c;
		}
		return i;
	};
})), yR, bR, xR, SR, CR, wR, TR, ER, DR = o((() => {
	TI(), dR(), yR = {
		EBML: gI([
			26,
			69,
			223,
			163
		]),
		DocType: gI([66, 130]),
		Segment: gI([
			24,
			83,
			128,
			103
		]),
		SegmentInfo: gI([
			21,
			73,
			169,
			102
		]),
		Tracks: gI([
			22,
			84,
			174,
			107
		]),
		Track: gI([174]),
		TrackNumber: gI([215]),
		DefaultDuration: gI([
			35,
			227,
			131
		]),
		TrackEntry: gI([174]),
		TrackType: gI([131]),
		FlagDefault: gI([136]),
		CodecID: gI([134]),
		CodecPrivate: gI([99, 162]),
		VideoTrack: gI([224]),
		AudioTrack: gI([225]),
		Cluster: gI([
			31,
			67,
			182,
			117
		]),
		Timestamp: gI([231]),
		TimestampScale: gI([
			42,
			215,
			177
		]),
		BlockGroup: gI([160]),
		BlockDuration: gI([155]),
		Block: gI([161]),
		SimpleBlock: gI([163])
	}, bR = [
		128,
		64,
		32,
		16,
		8,
		4,
		2,
		1
	], xR = function(e) {
		for (var t = 1, n = 0; n < bR.length && !(e & bR[n]); n++) t++;
		return t;
	}, SR = function(e, t, n, r) {
		n === void 0 && (n = !0), r === void 0 && (r = !1);
		var i = xR(e[t]), a = e.subarray(t, t + i);
		return n && (a = Array.prototype.slice.call(e, t, t + i), a[0] ^= bR[i - 1]), {
			length: i,
			value: yI(a, { signed: r }),
			bytes: a
		};
	}, CR = function e(t) {
		return typeof t == "string" ? t.match(/.{1,2}/g).map(function(t) {
			return e(t);
		}) : typeof t == "number" ? bI(t) : t;
	}, wR = function(e) {
		return Array.isArray(e) ? e.map(function(e) {
			return CR(e);
		}) : [CR(e)];
	}, TR = function e(t, n, r) {
		if (r >= n.length) return n.length;
		var i = SR(n, r, !1);
		if (wI(t.bytes, i.bytes)) return r;
		var a = SR(n, r + i.length);
		return e(t, n, r + a.length + a.value + i.length);
	}, ER = function e(t, n) {
		n = wR(n), t = gI(t);
		var r = [];
		if (!n.length) return r;
		for (var i = 0; i < t.length;) {
			var a = SR(t, i, !1), o = SR(t, i + a.length), s = i + a.length + o.length;
			o.value === 127 && (o.value = TR(a, t, s), o.value !== t.length && (o.value -= s));
			var c = s + o.value > t.length ? t.length : s + o.value, l = t.subarray(s, c);
			wI(n[0], a.bytes) && (n.length === 1 ? r.push(l) : r = r.concat(e(l, n.slice(1))));
			var u = a.length + o.length + l.length;
			i += u;
		}
		return r;
	};
})), OR, kR, AR, jR, MR, NR, PR, FR = o((() => {
	TI(), OR = gI([
		0,
		0,
		0,
		1
	]), kR = gI([
		0,
		0,
		1
	]), AR = gI([
		0,
		0,
		3
	]), jR = function(e) {
		for (var t = [], n = 1; n < e.length - 2;) wI(e.subarray(n, n + 3), AR) && (t.push(n + 2), n++), n++;
		if (t.length === 0) return e;
		var r = e.length - t.length, i = new Uint8Array(r), a = 0;
		for (n = 0; n < r; a++, n++) a === t[0] && (a++, t.shift()), i[n] = e[a];
		return i;
	}, MR = function(e, t, n, r) {
		r === void 0 && (r = Infinity), e = gI(e), n = [].concat(n);
		for (var i = 0, a, o = 0; i < e.length && (o < r || a);) {
			var s = void 0;
			if (wI(e.subarray(i), OR) ? s = 4 : wI(e.subarray(i), kR) && (s = 3), !s) {
				i++;
				continue;
			}
			if (o++, a) return jR(e.subarray(a, i));
			var c = void 0;
			t === "h264" ? c = e[i + s] & 31 : t === "h265" && (c = e[i + s] >> 1 & 63), n.indexOf(c) !== -1 && (a = i + s), i += s + (t === "h264" ? 1 : 2);
		}
		return e.subarray(0, 0);
	}, NR = function(e, t, n) {
		return MR(e, "h264", t, n);
	}, PR = function(e, t, n) {
		return MR(e, "h265", t, n);
	};
})), IR, LR, RR, zR, BR, VR, HR = o((() => {
	TI(), vR(), DR(), uR(), FR(), IR = {
		webm: gI([
			119,
			101,
			98,
			109
		]),
		matroska: gI([
			109,
			97,
			116,
			114,
			111,
			115,
			107,
			97
		]),
		flac: gI([
			102,
			76,
			97,
			67
		]),
		ogg: gI([
			79,
			103,
			103,
			83
		]),
		ac3: gI([11, 119]),
		riff: gI([
			82,
			73,
			70,
			70
		]),
		avi: gI([
			65,
			86,
			73
		]),
		wav: gI([
			87,
			65,
			86,
			69
		]),
		"3gp": gI([
			102,
			116,
			121,
			112,
			51,
			103
		]),
		mp4: gI([
			102,
			116,
			121,
			112
		]),
		fmp4: gI([
			115,
			116,
			121,
			112
		]),
		mov: gI([
			102,
			116,
			121,
			112,
			113,
			116
		]),
		moov: gI([
			109,
			111,
			111,
			118
		]),
		moof: gI([
			109,
			111,
			111,
			102
		]),
		vtt: gI([
			87,
			69,
			66,
			86,
			84,
			84
		])
	}, LR = {
		aac: function(e) {
			var t = lR(e);
			return wI(e, [255, 16], {
				offset: t,
				mask: [255, 22]
			});
		},
		mp3: function(e) {
			var t = lR(e);
			return wI(e, [255, 2], {
				offset: t,
				mask: [255, 6]
			});
		},
		webm: function(e) {
			var t = ER(e, [yR.EBML, yR.DocType])[0];
			return wI(t, IR.webm);
		},
		mkv: function(e) {
			var t = ER(e, [yR.EBML, yR.DocType])[0];
			return wI(t, IR.matroska);
		},
		mp4: function(e) {
			if (LR["3gp"](e) || LR.mov(e)) return !1;
			if (wI(e, IR.mp4, { offset: 4 }) || wI(e, IR.fmp4, { offset: 4 }) || wI(e, IR.moof, { offset: 4 }) || wI(e, IR.moov, { offset: 4 })) return !0;
		},
		mov: function(e) {
			return wI(e, IR.mov, { offset: 4 });
		},
		"3gp": function(e) {
			return wI(e, IR["3gp"], { offset: 4 });
		},
		ac3: function(e) {
			var t = lR(e);
			return wI(e, IR.ac3, { offset: t });
		},
		vtt: function(e) {
			return wI(e, IR.vtt);
		},
		ts: function(e) {
			if (e.length < 189 && e.length >= 1) return e[0] === 71;
			for (var t = 0; t + 188 < e.length && t < 188;) {
				if (e[t] === 71 && e[t + 188] === 71) return !0;
				t += 1;
			}
			return !1;
		},
		flac: function(e) {
			var t = lR(e);
			return wI(e, IR.flac, { offset: t });
		},
		ogg: function(e) {
			return wI(e, IR.ogg);
		},
		avi: function(e) {
			return wI(e, IR.riff) && wI(e, IR.avi, { offset: 8 });
		},
		wav: function(e) {
			return wI(e, IR.riff) && wI(e, IR.wav, { offset: 8 });
		},
		h264: function(e) {
			return NR(e, 7, 3).length;
		},
		h265: function(e) {
			return PR(e, [32, 33], 3).length;
		}
	}, RR = Object.keys(LR).filter(function(e) {
		return e !== "ts" && e !== "h264" && e !== "h265";
	}).concat([
		"ts",
		"h264",
		"h265"
	]), RR.forEach(function(e) {
		var t = LR[e];
		LR[e] = function(e) {
			return t(gI(e));
		};
	}), zR = LR, BR = function(e) {
		e = gI(e);
		for (var t = 0; t < RR.length; t++) {
			var n = RR[t];
			if (zR[n](e)) return n;
		}
		return "";
	}, VR = function(e) {
		return _R(e, ["moof"]).length > 0;
	};
})), UR = /* @__PURE__ */ s(((e, t) => {
	var n = 9e4, r = function(e) {
		return e * n;
	}, i = function(e, t) {
		return e * t;
	}, a = function(e) {
		return e / n;
	}, o = function(e, t) {
		return e / t;
	};
	t.exports = {
		ONE_SECOND_IN_TS: n,
		secondsToVideoTs: r,
		secondsToAudioTs: i,
		videoTsToSeconds: a,
		audioTsToSeconds: o,
		audioTsToVideoTs: function(e, t) {
			return r(o(e, t));
		},
		videoTsToAudioTs: function(e, t) {
			return i(a(e), t);
		},
		metadataTsToSeconds: function(e, t, n) {
			return a(n ? e : e - t);
		}
	};
})), WR = /* @__PURE__ */ c({ default: () => Y });
function GR(e, t = ":", n = "") {
	let r = "info", i;
	function a(...e) {
		i("log", r, e);
	}
	return i = HB(e, a, n), a.createLogger = (r, i, a) => {
		let o = i === void 0 ? t : i, s = a === void 0 ? n : a;
		return GR(`${e} ${o} ${r}`, o, s);
	}, a.createNewLogger = (e, t, n) => GR(e, t, n), a.levels = {
		all: "debug|log|warn|error",
		off: "",
		debug: "debug|log|warn|error",
		info: "log|warn|error",
		warn: "warn|error",
		error: "error",
		DEFAULT: r
	}, a.level = (e) => {
		if (typeof e == "string") {
			if (!a.levels.hasOwnProperty(e)) throw Error(`"${e}" in not a valid log level`);
			r = e;
		}
		return r;
	}, a.history = () => VB ? [].concat(VB) : [], a.history.filter = (e) => (VB || []).filter((t) => RegExp(`.*${e}.*`).test(t[0])), a.history.clear = () => {
		VB && (VB.length = 0);
	}, a.history.disable = () => {
		VB !== null && (VB.length = 0, VB = null);
	}, a.history.enable = () => {
		VB === null && (VB = []);
	}, a.error = (...e) => i("error", r, e), a.warn = (...e) => i("warn", r, e), a.debug = (...e) => i("debug", r, e), a;
}
function KR(e, t) {
	KB(e).forEach((n) => t(e[n], n));
}
function qR(e, t, n = 0) {
	return KB(e).reduce((n, r) => t(n, e[r], r), n);
}
function JR(e) {
	return !!e && typeof e == "object";
}
function YR(e) {
	return JR(e) && GB.call(e) === "[object Object]" && e.constructor === Object;
}
function XR(...e) {
	let t = {};
	return e.forEach((e) => {
		e && KR(e, (e, n) => {
			if (!YR(e)) {
				t[n] = e;
				return;
			}
			YR(t[n]) || (t[n] = {}), t[n] = XR(t[n], e);
		});
	}), t;
}
function ZR(e = {}) {
	let t = [];
	for (let n in e) if (e.hasOwnProperty(n)) {
		let r = e[n];
		t.push(r);
	}
	return t;
}
function QR(e, t, n, r = !0) {
	let i = (n) => Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		writable: !0
	}), a = {
		configurable: !0,
		enumerable: !0,
		get() {
			let e = n();
			return i(e), e;
		}
	};
	return r && (a.set = i), Object.defineProperty(e, t, a);
}
function $R(e) {
	return typeof e == "string" && !!e.trim();
}
function ez(e) {
	if (e.indexOf(" ") >= 0) throw Error("class has illegal whitespace characters");
}
function tz() {
	return Z.default === X.default.document;
}
function nz(e) {
	return JR(e) && e.nodeType === 1;
}
function rz() {
	try {
		return X.default.parent !== X.default.self;
	} catch {
		return !0;
	}
}
function iz(e) {
	return function(t, n) {
		if (!$R(t)) return Z.default[e](null);
		$R(n) && (n = Z.default.querySelector(n));
		let r = nz(n) ? n : Z.default;
		return r[e] && r[e](t);
	};
}
function az(e = "div", t = {}, n = {}, r) {
	let i = Z.default.createElement(e);
	return Object.getOwnPropertyNames(t).forEach(function(e) {
		let n = t[e];
		e === "textContent" ? oz(i, n) : (i[e] !== n || e === "tabIndex") && (i[e] = n);
	}), Object.getOwnPropertyNames(n).forEach(function(e) {
		i.setAttribute(e, n[e]);
	}), r && Tz(i, r), i;
}
function oz(e, t) {
	return e.textContent === void 0 ? e.innerText = t : e.textContent = t, e;
}
function sz(e, t) {
	t.firstChild ? t.insertBefore(e, t.firstChild) : t.appendChild(e);
}
function cz(e, t) {
	return ez(t), e.classList.contains(t);
}
function lz(e, ...t) {
	return e.classList.add(...t.reduce((e, t) => e.concat(t.split(/\s+/)), [])), e;
}
function uz(e, ...t) {
	return e ? (e.classList.remove(...t.reduce((e, t) => e.concat(t.split(/\s+/)), [])), e) : (UB.warn("removeClass was called with an element that doesn't exist"), null);
}
function dz(e, t, n) {
	return typeof n == "function" && (n = n(e, t)), typeof n != "boolean" && (n = void 0), t.split(/\s+/).forEach((t) => e.classList.toggle(t, n)), e;
}
function fz(e, t) {
	Object.getOwnPropertyNames(t).forEach(function(n) {
		let r = t[n];
		r == null || r === !1 ? e.removeAttribute(n) : e.setAttribute(n, r === !0 ? "" : r);
	});
}
function pz(e) {
	let t = {}, n = [
		"autoplay",
		"controls",
		"playsinline",
		"loop",
		"muted",
		"default",
		"defaultMuted"
	];
	if (e && e.attributes && e.attributes.length > 0) {
		let r = e.attributes;
		for (let e = r.length - 1; e >= 0; e--) {
			let i = r[e].name, a = r[e].value;
			n.includes(i) && (a = a !== null), t[i] = a;
		}
	}
	return t;
}
function mz(e, t) {
	return e.getAttribute(t);
}
function hz(e, t, n) {
	e.setAttribute(t, n);
}
function gz(e, t) {
	e.removeAttribute(t);
}
function _z() {
	Z.default.body.focus(), Z.default.onselectstart = function() {
		return !1;
	};
}
function vz() {
	Z.default.onselectstart = function() {
		return !0;
	};
}
function yz(e) {
	if (e && e.getBoundingClientRect && e.parentNode) {
		let t = e.getBoundingClientRect(), n = {};
		return [
			"bottom",
			"height",
			"left",
			"right",
			"top",
			"width"
		].forEach((e) => {
			t[e] !== void 0 && (n[e] = t[e]);
		}), n.height ||= parseFloat(Oz(e, "height")), n.width ||= parseFloat(Oz(e, "width")), n;
	}
}
function bz(e) {
	if (!e || e && !e.offsetParent) return {
		left: 0,
		top: 0,
		width: 0,
		height: 0
	};
	let t = e.offsetWidth, n = e.offsetHeight, r = 0, i = 0;
	for (; e.offsetParent && e !== Z.default[LB.fullscreenElement];) r += e.offsetLeft, i += e.offsetTop, e = e.offsetParent;
	return {
		left: r,
		top: i,
		width: t,
		height: n
	};
}
function xz(e, t) {
	let n = {
		x: 0,
		y: 0
	};
	if (hV) {
		let t = e;
		for (; t && t.nodeName.toLowerCase() !== "html";) {
			let e = Oz(t, "transform");
			if (/^matrix/.test(e)) {
				let t = e.slice(7, -1).split(/,\s/).map(Number);
				n.x += t[4], n.y += t[5];
			} else if (/^matrix3d/.test(e)) {
				let t = e.slice(9, -1).split(/,\s/).map(Number);
				n.x += t[12], n.y += t[13];
			}
			if (t.assignedSlot && t.assignedSlot.parentElement && X.default.WebKitCSSMatrix) {
				let e = X.default.getComputedStyle(t.assignedSlot.parentElement).transform, r = new X.default.WebKitCSSMatrix(e);
				n.x += r.m41, n.y += r.m42;
			}
			t = t.parentNode || t.host;
		}
	}
	let r = {}, i = bz(t.target), a = bz(e), o = a.width, s = a.height, c = t.offsetY - (a.top - i.top), l = t.offsetX - (a.left - i.left);
	return t.changedTouches && (l = t.changedTouches[0].pageX - a.left, c = t.changedTouches[0].pageY + a.top, hV && (l -= n.x, c -= n.y)), r.y = 1 - Math.max(0, Math.min(1, c / s)), r.x = Math.max(0, Math.min(1, l / o)), r;
}
function Sz(e) {
	return JR(e) && e.nodeType === 3;
}
function Cz(e) {
	for (; e.firstChild;) e.removeChild(e.firstChild);
	return e;
}
function wz(e) {
	return typeof e == "function" && (e = e()), (Array.isArray(e) ? e : [e]).map((e) => {
		if (typeof e == "function" && (e = e()), nz(e) || Sz(e)) return e;
		if (typeof e == "string" && /\S/.test(e)) return Z.default.createTextNode(e);
	}).filter((e) => e);
}
function Tz(e, t) {
	return wz(t).forEach((t) => e.appendChild(t)), e;
}
function Ez(e, t) {
	return Tz(Cz(e), t);
}
function Dz(e) {
	return e.button === void 0 && e.buttons === void 0 || e.button === 0 && e.buttons === void 0 || e.type === "mouseup" && e.button === 0 && e.buttons === 0 || e.type === "mousedown" && e.button === 0 && e.buttons === 0 || e.button === 0 && e.buttons === 1;
}
function Oz(e, t) {
	if (!e || !t) return "";
	if (typeof X.default.getComputedStyle == "function") {
		let n;
		try {
			n = X.default.getComputedStyle(e);
		} catch {
			return "";
		}
		return n ? n.getPropertyValue(t) || n[t] : "";
	}
	return "";
}
function kz(e) {
	[...Z.default.styleSheets].forEach((t) => {
		try {
			let n = [...t.cssRules].map((e) => e.cssText).join(""), r = Z.default.createElement("style");
			r.textContent = n, e.document.head.appendChild(r);
		} catch {
			let n = Z.default.createElement("link");
			n.rel = "stylesheet", n.type = t.type, n.media = t.media.mediaText, n.href = t.href, e.document.head.appendChild(n);
		}
	});
}
function Az(e, t) {
	tz() && (t && (SV = t), X.default.setTimeout(CV, e));
}
function jz() {
	xV = !0, X.default.removeEventListener("load", jz);
}
function Mz() {
	return DV++;
}
function Nz(e, t) {
	if (!EV.has(e)) return;
	let n = EV.get(e);
	n.handlers[t].length === 0 && (delete n.handlers[t], e.removeEventListener ? e.removeEventListener(t, n.dispatcher, !1) : e.detachEvent && e.detachEvent("on" + t, n.dispatcher)), Object.getOwnPropertyNames(n.handlers).length <= 0 && (delete n.handlers, delete n.dispatcher, delete n.disabled), Object.getOwnPropertyNames(n).length === 0 && EV.delete(e);
}
function Pz(e, t, n, r) {
	n.forEach(function(n) {
		e(t, n, r);
	});
}
function Fz(e) {
	if (e.fixed_) return e;
	function t() {
		return !0;
	}
	function n() {
		return !1;
	}
	if (!e || !e.isPropagationStopped || !e.isImmediatePropagationStopped) {
		let r = e || X.default.event;
		e = {};
		let i = [
			"layerX",
			"layerY",
			"keyLocation",
			"path",
			"webkitMovementX",
			"webkitMovementY",
			"mozPressure",
			"mozInputSource"
		];
		for (let t in r) i.includes(t) || t === "returnValue" && r.preventDefault || (e[t] = r[t]);
		if (e.target || (e.target = e.srcElement || Z.default), e.relatedTarget || (e.relatedTarget = e.fromElement === e.target ? e.toElement : e.fromElement), e.preventDefault = function() {
			r.preventDefault && r.preventDefault(), e.returnValue = !1, r.returnValue = !1, e.defaultPrevented = !0;
		}, e.defaultPrevented = !1, e.stopPropagation = function() {
			r.stopPropagation && r.stopPropagation(), e.cancelBubble = !0, r.cancelBubble = !0, e.isPropagationStopped = t;
		}, e.isPropagationStopped = n, e.stopImmediatePropagation = function() {
			r.stopImmediatePropagation && r.stopImmediatePropagation(), e.isImmediatePropagationStopped = t, e.stopPropagation();
		}, e.isImmediatePropagationStopped = n, e.clientX !== null && e.clientX !== void 0) {
			let t = Z.default.documentElement, n = Z.default.body;
			e.pageX = e.clientX + (t && t.scrollLeft || n && n.scrollLeft || 0) - (t && t.clientLeft || n && n.clientLeft || 0), e.pageY = e.clientY + (t && t.scrollTop || n && n.scrollTop || 0) - (t && t.clientTop || n && n.clientTop || 0);
		}
		e.which = e.charCode || e.keyCode, e.button !== null && e.button !== void 0 && (e.button = e.button & 1 ? 0 : e.button & 4 ? 1 : e.button & 2 ? 2 : 0);
	}
	return e.fixed_ = !0, e;
}
function Iz(e, t, n) {
	if (Array.isArray(t)) return Pz(Iz, e, t, n);
	EV.has(e) || EV.set(e, {});
	let r = EV.get(e);
	if (r.handlers ||= {}, r.handlers[t] || (r.handlers[t] = []), n.guid ||= Mz(), r.handlers[t].push(n), r.dispatcher ||= (r.disabled = !1, function(t, n) {
		if (r.disabled) return;
		t = Fz(t);
		let i = r.handlers[t.type];
		if (i) {
			let r = i.slice(0);
			for (let i = 0, a = r.length; i < a && !t.isImmediatePropagationStopped(); i++) try {
				r[i].call(e, t, n);
			} catch (e) {
				UB.error(e);
			}
		}
	}), r.handlers[t].length === 1) if (e.addEventListener) {
		let n = !1;
		kV() && AV.indexOf(t) > -1 && (n = { passive: !0 }), e.addEventListener(t, r.dispatcher, n);
	} else e.attachEvent && e.attachEvent("on" + t, r.dispatcher);
}
function Lz(e, t, n) {
	if (!EV.has(e)) return;
	let r = EV.get(e);
	if (!r.handlers) return;
	if (Array.isArray(t)) return Pz(Lz, e, t, n);
	let i = function(e, t) {
		r.handlers[t] = [], Nz(e, t);
	};
	if (t === void 0) {
		for (let t in r.handlers) Object.prototype.hasOwnProperty.call(r.handlers || {}, t) && i(e, t);
		return;
	}
	let a = r.handlers[t];
	if (a) {
		if (!n) {
			i(e, t);
			return;
		}
		if (n.guid) for (let e = 0; e < a.length; e++) a[e].guid === n.guid && a.splice(e--, 1);
		Nz(e, t);
	}
}
function Rz(e, t, n) {
	let r = EV.has(e) ? EV.get(e) : {}, i = e.parentNode || e.ownerDocument;
	if (typeof t == "string" ? t = {
		type: t,
		target: e
	} : t.target || (t.target = e), t = Fz(t), r.dispatcher && r.dispatcher.call(e, t, n), i && !t.isPropagationStopped() && t.bubbles === !0) Rz.call(null, i, t, n);
	else if (!i && !t.defaultPrevented && t.target && t.target[t.type]) {
		EV.has(t.target) || EV.set(t.target, {});
		let e = EV.get(t.target);
		t.target[t.type] && (e.disabled = !0, typeof t.target[t.type] == "function" && t.target[t.type](), e.disabled = !1);
	}
	return !t.defaultPrevented;
}
function zz(e, t, n) {
	if (Array.isArray(t)) return Pz(zz, e, t, n);
	let r = function() {
		Lz(e, t, r), n.apply(this, arguments);
	};
	r.guid = n.guid = n.guid || Mz(), Iz(e, t, r);
}
function Bz(e, t, n) {
	let r = function() {
		Lz(e, t, r), n.apply(this, arguments);
	};
	r.guid = n.guid = n.guid || Mz(), Iz(e, t, r);
}
function Vz(e, t = {}) {
	let { eventBusKey: n } = t;
	if (n) {
		if (!e[n].nodeName) throw Error(`The eventBusKey "${n}" does not refer to an element.`);
		e.eventBusEl_ = e[n];
	} else e.eventBusEl_ = az("span", { className: "vjs-event-bus" });
	return Object.assign(e, JV), e.eventedCallbacks && e.eventedCallbacks.forEach((e) => {
		e();
	}), e.on("dispose", () => {
		e.off(), [
			e,
			e.el_,
			e.eventBusEl_
		].forEach(function(e) {
			e && EV.has(e) && EV.delete(e);
		}), X.default.setTimeout(() => {
			e.eventBusEl_ = null;
		}, 0);
	}), e;
}
function Hz(e, t) {
	return Object.assign(e, YV), e.state = Object.assign({}, e.state, t), typeof e.handleStateChanged == "function" && BV(e) && e.on("statechanged", e.handleStateChanged), e;
}
function Uz(e, t, n) {
	if (typeof t != "number" || t < 0 || t > n) throw Error(`Failed to execute '${e}' on 'TimeRanges': The index provided (${t}) is non-numeric or out of bounds (0-${n}).`);
}
function Wz(e, t, n, r) {
	return Uz(e, r, n.length - 1), n[r][t];
}
function Gz(e) {
	let t;
	return t = e === void 0 || e.length === 0 ? {
		length: 0,
		start() {
			throw Error("This TimeRanges object is empty");
		},
		end() {
			throw Error("This TimeRanges object is empty");
		}
	} : {
		length: e.length,
		start: Wz.bind(null, "start", 0, e),
		end: Wz.bind(null, "end", 1, e)
	}, X.default.Symbol && X.default.Symbol.iterator && (t[X.default.Symbol.iterator] = () => (e || []).values()), t;
}
function Kz(e, t) {
	return Array.isArray(e) ? Gz(e) : e === void 0 || t === void 0 ? Gz() : Gz([[e, t]]);
}
function qz(e) {
	tH = e;
}
function Jz() {
	tH = eH;
}
function Yz(e, t = e) {
	return tH(e, t);
}
function Xz(e, t) {
	let n = 0, r, i;
	if (!t) return 0;
	(!e || !e.length) && (e = Kz(0, 0));
	for (let a = 0; a < e.length; a++) r = e.start(a), i = e.end(a), i > t && (i = t), n += i - r;
	return n / t;
}
function Zz(e) {
	if (e instanceof Zz) return e;
	typeof e == "number" ? this.code = e : typeof e == "string" ? this.message = e : JR(e) && (typeof e.code == "number" && (this.code = e.code), Object.assign(this, e)), this.message ||= Zz.defaultMessages[this.code] || "";
}
function Qz(e) {
	return e != null && typeof e.then == "function";
}
function $z(e) {
	Qz(e) && e.then(null, (e) => {});
}
function eB(e, t, n, r, i = {}) {
	let a = e.textTracks();
	i.kind = t, n && (i.label = n), r && (i.language = r), i.tech = e;
	let o = new FH.text.TrackClass(i);
	return a.addTrack(o), o;
}
function tB(e, t) {
	LH[e] = LH[e] || [], LH[e].push(t);
}
function nB(e, t, n) {
	e.setTimeout(() => dB(t, LH[t.type], n, e), 1);
}
function rB(e, t) {
	e.forEach((e) => e.setTech && e.setTech(t));
}
function iB(e, t, n) {
	return e.reduceRight(sB(n), t[n]());
}
function aB(e, t, n, r) {
	return t[n](e.reduce(sB(n), r));
}
function oB(e, t, n, r = null) {
	let i = "call" + ZV(n), a = e.reduce(sB(i), r), o = a === zH, s = o ? null : t[n](a);
	return cB(e, n, s, o), s;
}
function sB(e) {
	return (t, n) => t === zH ? zH : n[e] ? n[e](t) : t;
}
function cB(e, t, n, r) {
	for (let i = e.length - 1; i >= 0; i--) {
		let a = e[i];
		a[t] && a[t](r, n);
	}
}
function lB(e) {
	RH.hasOwnProperty(e.id()) && delete RH[e.id()];
}
function uB(e, t) {
	let n = RH[e.id()], r = null;
	if (n == null) return r = t(e), RH[e.id()] = [[t, r]], r;
	for (let e = 0; e < n.length; e++) {
		let [i, a] = n[e];
		i === t && (r = a);
	}
	return r === null && (r = t(e), n.push([t, r])), r;
}
function dB(e = {}, t = [], n, r, i = [], a = !1) {
	let [o, ...s] = t;
	if (typeof o == "string") dB(e, LH[o], n, r, i, a);
	else if (o) {
		let t = uB(r, o);
		if (!t.setSource) return i.push(t), dB(e, s, n, r, i, a);
		t.setSource(Object.assign({}, e), function(o, c) {
			if (o) return dB(e, s, n, r, i, a);
			i.push(t), dB(c, e.type === c.type ? s : LH[c.type], n, r, i, a);
		});
	} else s.length ? dB(e, s, n, r, i, a) : a ? n(e, i) : dB(e, LH["*"], n, r, i, !0);
}
function fB(e) {
	if (!e.type) {
		let t = WH(e.src);
		t && (e.type = t);
	}
	return e;
}
function pB(e, t) {
	let n;
	if (e.length === 4) n = e[1] + e[1] + e[2] + e[2] + e[3] + e[3];
	else if (e.length === 7) n = e.slice(1);
	else throw Error("Invalid color code provided, " + e + "; must be formatted as e.g. #f0e or #f604e2.");
	return "rgba(" + parseInt(n.slice(0, 2), 16) + "," + parseInt(n.slice(2, 4), 16) + "," + parseInt(n.slice(4, 6), 16) + "," + t + ")";
}
function mB(e, t, n) {
	try {
		e.style[t] = n;
	} catch {
		return;
	}
}
function hB(e) {
	return e ? `${e}px` : "";
}
function gB(e, t, n) {
	return e = Number(e), Math.min(n, Math.max(t, isNaN(e) ? t : e));
}
function _B(e, t) {
	if (t && (e = t(e)), e && e !== "none") return e;
}
function vB(e, t) {
	let n = e.options[e.options.selectedIndex].value;
	return _B(n, t);
}
function yB(e, t, n) {
	if (t) {
		for (let r = 0; r < e.options.length; r++) if (_B(e.options[r].value, n) === t) {
			e.selectedIndex = r;
			break;
		}
	}
}
function bB(e, t) {
	let n = !1;
	return function(...r) {
		return n || UB.warn(e), n = !0, t.apply(this, r);
	};
}
function xB(e, t, n, r) {
	return bB(`${t} is deprecated and will be removed in ${e}.0; please use ${n} instead.`, r);
}
function Y(e, t, n) {
	let r = Y.getPlayer(e);
	if (r) return t && UB.warn(`Player "${e}" is already initialised. Options will not be applied.`), n && r.ready(n), r;
	let i = typeof e == "string" ? vV("#" + aG(e)) : e;
	if (!nz(i)) throw TypeError("The element or ID supplied is not valid. (videojs)");
	let a = "getRootNode" in i && i.getRootNode() instanceof X.default.ShadowRoot ? i.getRootNode() : i.ownerDocument.body;
	return (!i.ownerDocument.defaultView || !a.contains(i)) && UB.warn("The element supplied is not included in the DOM"), t ||= {}, t.restoreEl === !0 && (t.restoreEl = (i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player") ? i.parentNode : i).cloneNode(!0)), NB("beforesetup").forEach((e) => {
		let n = e(i, XR(t));
		if (!JR(n) || Array.isArray(n)) {
			UB.error("please return an object in beforesetup hooks");
			return;
		}
		t = XR(t, n);
	}), r = new (Q.getComponent("Player"))(i, t, n), NB("setup").forEach((e) => e(r)), r;
}
function SB(...e) {
	let t = Y.obj || Y;
	return (t.merge || t.mergeOptions).apply(t, e);
}
function CB(...e) {
	let t = Y.time || Y;
	return (t.createTimeRanges || t.createTimeRanges).apply(t, e);
}
function wB(e) {
	if (e.length === 0) return "Buffered Ranges are empty";
	let t = "Buffered Ranges: \n";
	for (let n = 0; n < e.length; n++) {
		let r = e.start(n), i = e.end(n);
		t += `${r} --> ${i}. Duration (${i - r})\n`;
	}
	return t;
}
function TB(e) {
	try {
		return new URL(e).pathname.split("/").slice(-2).join("/");
	} catch {
		return "";
	}
}
function EB() {}
var X, Z, DB, OB, kB, AB, jB, MB, NB, PB, FB, IB, LB, RB, zB, BB, VB, HB, UB, WB, GB, KB, qB, JB, YB, XB, ZB, QB, $B, eV, tV, nV, rV, iV, aV, oV, sV, cV, lV, uV, dV, fV, pV, mV, hV, gV, _V, vV, yV, bV, xV, SV, CV, wV, TV, EV, DV, OV, kV, AV, jV, MV, NV, PV, FV, IV, LV, RV, zV, BV, VV, HV, UV, WV, GV, KV, qV, JV, YV, XV, ZV, QV, $V, Q, eH, tH, nH, rH, iH, aH, oH, sH, cH, lH, uH, dH, fH, pH, mH, hH, gH, _H, vH, yH, bH, xH, SH, CH, wH, TH, EH, DH, OH, kH, AH, jH, MH, NH, PH, FH, IH, LH, RH, zH, BH, VH, HH, UH, WH, GH, KH, qH, JH, YH, XH, ZH, QH, $H, eU, tU, nU, rU, iU, aU, oU, sU, cU, lU, uU, dU, fU, pU, mU, hU, gU, _U, vU, yU, bU, xU, SU, CU, wU, TU, EU, DU, OU, kU, AU, jU, MU, NU, PU, FU, IU, LU, RU, zU, BU, VU, HU, UU, WU, GU, KU, qU, JU, YU, XU, ZU, QU, $U, eW, tW, nW, rW, iW, aW, oW, sW, cW, lW, uW, dW, fW, pW, mW, hW, gW, _W, vW, yW, bW, xW, SW, CW, wW, TW, EW, DW, OW, kW, AW, jW, MW, NW, PW, FW, IW, LW, RW, zW, BW, $, VW, HW, UW, WW, GW, KW, qW, JW, YW, XW, ZW, QW, $W, eG, tG, nG, rG, iG, aG, oG, sG, cG, lG, uG, dG, fG, pG, mG, hG, gG, _G, vG, yG, bG, xG, SG, CG, wG, TG, EG, DG, OG, kG, AG, jG, MG, NG, PG, FG, IG, LG, RG, zG, BG, VG, HG, UG, WG, GG, KG, qG, JG, YG, XG, ZG, QG, $G, eK, tK, nK, rK, iK, aK, oK, sK, cK, lK, uK, dK, fK, pK, mK, hK, gK, _K, vK, yK, bK, xK, SK, CK, wK, TK, EK, DK, OK, kK, AK, jK, MK, NK, PK, FK, IK, LK, RK, zK, BK, VK, HK, UK, WK, GK, KK, qK, JK, YK, XK, ZK, QK, $K, eq, tq, nq, rq, iq, aq, oq, sq, cq, lq, uq, dq, fq, pq, mq, hq, gq, _q, vq, yq, bq, xq, Sq, Cq, wq, Tq, Eq, Dq, Oq, kq, Aq, jq, Mq, Nq, Pq, Fq, Iq, Lq, Rq, zq, Bq, Vq, Hq, Uq, Wq, Gq, Kq, qq, Jq, Yq, Xq, Zq, Qq, $q, eJ, tJ, nJ, rJ, iJ, aJ, oJ, sJ, cJ, lJ, uJ, dJ, fJ, pJ, mJ, hJ, gJ, _J, vJ, yJ, bJ, xJ, SJ, CJ, wJ, TJ, EJ, DJ, OJ, kJ, AJ, jJ, MJ, NJ, PJ, FJ, IJ, LJ, RJ, zJ, BJ, VJ, HJ, UJ, WJ, GJ, KJ, qJ, JJ, YJ, XJ, ZJ, QJ, $J, eY, tY, nY, rY, iY, aY, oY, sY, cY, lY, uY, dY, fY, pY, mY, hY, gY, _Y, vY, yY, bY, xY, SY, CY, wY, TY, EY, DY, OY, kY, AY, jY, MY, NY, PY, FY, IY, LY, RY, zY, BY, VY, HY, UY, WY, GY, KY, qY, JY, YY, XY, ZY, QY, $Y, eX, tX, nX, rX, iX, aX, oX, sX, cX, lX, uX, dX, fX, pX, mX, hX, gX, _X, vX, yX = o((() => {
	X = /* @__PURE__ */ u(dF()), Z = /* @__PURE__ */ u(pF()), DB = /* @__PURE__ */ u(yF()), OB = /* @__PURE__ */ u(CF()), TF(), kF(), qF(), oI(), uI(), TI(), iR(), kB = /* @__PURE__ */ u(oR()), uR(), HR(), AB = UR(), jB = "8.24.0", MB = {}, NB = function(e, t) {
		return MB[e] = MB[e] || [], t && (MB[e] = MB[e].concat(t)), MB[e];
	}, PB = function(e, t) {
		NB(e, t);
	}, FB = function(e, t) {
		let n = NB(e).indexOf(t);
		return n <= -1 ? !1 : (MB[e] = MB[e].slice(), MB[e].splice(n, 1), !0);
	}, IB = function(e, t) {
		NB(e, [].concat(t).map((t) => {
			let n = (...r) => (FB(e, n), t(...r));
			return n;
		}));
	}, LB = { prefixed: !0 }, RB = [[
		"requestFullscreen",
		"exitFullscreen",
		"fullscreenElement",
		"fullscreenEnabled",
		"fullscreenchange",
		"fullscreenerror",
		"fullscreen"
	], [
		"webkitRequestFullscreen",
		"webkitExitFullscreen",
		"webkitFullscreenElement",
		"webkitFullscreenEnabled",
		"webkitfullscreenchange",
		"webkitfullscreenerror",
		"-webkit-full-screen"
	]], zB = RB[0];
	for (let e = 0; e < RB.length; e++) if (RB[e][1] in Z.default) {
		BB = RB[e];
		break;
	}
	if (BB) {
		for (let e = 0; e < BB.length; e++) LB[zB[e]] = BB[e];
		LB.prefixed = BB[0] !== zB[0];
	}
	if (VB = [], HB = (e, t, n) => (r, i, a) => {
		let o = t.levels[i], s = RegExp(`^(${o})$`), c = e;
		if (r !== "log" && a.unshift(r.toUpperCase() + ":"), n && (c = `%c${e}`, a.unshift(n)), a.unshift(c + ":"), VB) {
			VB.push([].concat(a));
			let e = VB.length - 1e3;
			VB.splice(0, e > 0 ? e : 0);
		}
		if (!X.default.console) return;
		let l = X.default.console[r];
		!l && r === "debug" && (l = X.default.console.info || X.default.console.log), !(!l || !o || !s.test(r)) && l[Array.isArray(a) ? "apply" : "call"](X.default.console, a);
	}, UB = GR("VIDEOJS"), WB = UB.createLogger, GB = Object.prototype.toString, KB = function(e) {
		return JR(e) ? Object.keys(e) : [];
	}, qB = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		each: KR,
		reduce: qR,
		isObject: JR,
		isPlain: YR,
		merge: XR,
		values: ZR,
		defineLazyProperty: QR
	}), JB = !1, YB = null, XB = !1, QB = !1, $B = !1, eV = !1, tV = !1, nV = null, rV = null, iV = !!(X.default.cast && X.default.cast.framework && X.default.cast.framework.CastReceiverContext), aV = null, oV = !1, sV = !1, cV = !1, lV = !1, uV = !1, dV = !1, fV = !1, pV = !!(tz() && ("ontouchstart" in X.default || X.default.navigator.maxTouchPoints || X.default.DocumentTouch && X.default.document instanceof X.default.DocumentTouch)), mV = X.default.navigator && X.default.navigator.userAgentData, mV && mV.platform && mV.brands && (XB = mV.platform === "Android", $B = !!mV.brands.find((e) => e.brand === "Microsoft Edge"), eV = !!mV.brands.find((e) => e.brand === "Chromium"), tV = !$B && eV, nV = rV = (mV.brands.find((e) => e.brand === "Chromium") || {}).version || null, sV = mV.platform === "Windows"), !eV) {
		let e = X.default.navigator && X.default.navigator.userAgent || "";
		JB = /iPod/i.test(e), YB = function() {
			let t = e.match(/OS (\d+)_/i);
			return t && t[1] ? t[1] : null;
		}(), XB = /Android/i.test(e), ZB = function() {
			let t = e.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
			if (!t) return null;
			let n = t[1] && parseFloat(t[1]), r = t[2] && parseFloat(t[2]);
			return n && r ? parseFloat(t[1] + "." + t[2]) : n || null;
		}(), QB = /Firefox/i.test(e), $B = /Edg/i.test(e), eV = /Chrome/i.test(e) || /CriOS/i.test(e), tV = !$B && eV, nV = rV = function() {
			let t = e.match(/(Chrome|CriOS)\/(\d+)/);
			return t && t[2] ? parseFloat(t[2]) : null;
		}(), aV = function() {
			let t = /MSIE\s(\d+)\.\d/.exec(e), n = t && parseFloat(t[1]);
			return !n && /Trident\/7.0/i.test(e) && /rv:11.0/.test(e) && (n = 11), n;
		}(), uV = /Tizen/i.test(e), dV = /Web0S/i.test(e), fV = uV || dV, oV = /Safari/i.test(e) && !tV && !XB && !$B && !fV, sV = /Windows/i.test(e), cV = /iPad/i.test(e) || oV && pV && !/iPhone/i.test(e), lV = /iPhone/i.test(e) && !cV;
	}
	hV = lV || cV || JB, gV = (oV || hV) && !tV, _V = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		get IS_IPOD() {
			return JB;
		},
		get IOS_VERSION() {
			return YB;
		},
		get IS_ANDROID() {
			return XB;
		},
		get ANDROID_VERSION() {
			return ZB;
		},
		get IS_FIREFOX() {
			return QB;
		},
		get IS_EDGE() {
			return $B;
		},
		get IS_CHROMIUM() {
			return eV;
		},
		get IS_CHROME() {
			return tV;
		},
		get CHROMIUM_VERSION() {
			return nV;
		},
		get CHROME_VERSION() {
			return rV;
		},
		IS_CHROMECAST_RECEIVER: iV,
		get IE_VERSION() {
			return aV;
		},
		get IS_SAFARI() {
			return oV;
		},
		get IS_WINDOWS() {
			return sV;
		},
		get IS_IPAD() {
			return cV;
		},
		get IS_IPHONE() {
			return lV;
		},
		get IS_TIZEN() {
			return uV;
		},
		get IS_WEBOS() {
			return dV;
		},
		get IS_SMART_TV() {
			return fV;
		},
		TOUCH_ENABLED: pV,
		IS_IOS: hV,
		IS_ANY_SAFARI: gV
	}), vV = iz("querySelector"), yV = iz("querySelectorAll"), bV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		isReal: tz,
		isEl: nz,
		isInFrame: rz,
		createEl: az,
		textContent: oz,
		prependTo: sz,
		hasClass: cz,
		addClass: lz,
		removeClass: uz,
		toggleClass: dz,
		setAttributes: fz,
		getAttributes: pz,
		getAttribute: mz,
		setAttribute: hz,
		removeAttribute: gz,
		blockTextSelection: _z,
		unblockTextSelection: vz,
		getBoundingClientRect: yz,
		findPosition: bz,
		getPointerPosition: xz,
		isTextNode: Sz,
		emptyEl: Cz,
		normalizeContent: wz,
		appendContent: Tz,
		insertContent: Ez,
		isSingleLeftClick: Dz,
		$: vV,
		$$: yV,
		computedStyle: Oz,
		copyStyleSheetsToWindow: kz
	}), xV = !1, CV = function() {
		if (SV.options.autoSetup === !1) return;
		let e = Array.prototype.slice.call(Z.default.getElementsByTagName("video")), t = Array.prototype.slice.call(Z.default.getElementsByTagName("audio")), n = Array.prototype.slice.call(Z.default.getElementsByTagName("video-js")), r = e.concat(t, n);
		if (r && r.length > 0) for (let e = 0, t = r.length; e < t; e++) {
			let t = r[e];
			if (t && t.getAttribute) t.player === void 0 && t.getAttribute("data-setup") !== null && SV(t);
			else {
				Az(1);
				break;
			}
		}
		else xV || Az(1);
	}, tz() && (Z.default.readyState === "complete" ? jz() : X.default.addEventListener("load", jz)), wV = function(e) {
		let t = Z.default.createElement("style");
		return t.className = e, t;
	}, TV = function(e, t) {
		e.styleSheet ? e.styleSheet.cssText = t : e.textContent = t;
	}, EV = /* @__PURE__ */ new WeakMap(), DV = 3, kV = function() {
		if (typeof OV != "boolean") {
			OV = !1;
			try {
				let e = Object.defineProperty({}, "passive", { get() {
					OV = !0;
				} });
				X.default.addEventListener("test", null, e), X.default.removeEventListener("test", null, e);
			} catch {}
		}
		return OV;
	}, AV = ["touchstart", "touchmove"], jV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		fixEvent: Fz,
		on: Iz,
		off: Lz,
		trigger: Rz,
		one: zz,
		any: Bz
	}), MV = 30, NV = function(e, t, n) {
		t.guid ||= Mz();
		let r = t.bind(e);
		return r.guid = n ? n + "_" + t.guid : t.guid, r;
	}, PV = function(e, t) {
		let n = X.default.performance.now();
		return function(...r) {
			let i = X.default.performance.now();
			i - n >= t && (e(...r), n = i);
		};
	}, FV = function(e, t, n, r = X.default) {
		let i, a = () => {
			r.clearTimeout(i), i = null;
		}, o = function() {
			let a = this, o = arguments, s = function() {
				i = null, s = null, n || e.apply(a, o);
			};
			!i && n && e.apply(a, o), r.clearTimeout(i), i = r.setTimeout(s, t);
		};
		return o.cancel = a, o;
	}, IV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		UPDATE_REFRESH_INTERVAL: MV,
		bind_: NV,
		throttle: PV,
		debounce: FV
	}), RV = class {
		on(e, t) {
			let n = this.addEventListener;
			this.addEventListener = () => {}, Iz(this, e, t), this.addEventListener = n;
		}
		off(e, t) {
			Lz(this, e, t);
		}
		one(e, t) {
			let n = this.addEventListener;
			this.addEventListener = () => {}, zz(this, e, t), this.addEventListener = n;
		}
		any(e, t) {
			let n = this.addEventListener;
			this.addEventListener = () => {}, Bz(this, e, t), this.addEventListener = n;
		}
		trigger(e) {
			let t = e.type || e;
			typeof e == "string" && (e = { type: t }), e = Fz(e), this.allowedEvents_[t] && this["on" + t] && this["on" + t](e), Rz(this, e);
		}
		queueTrigger(e) {
			LV ||= /* @__PURE__ */ new Map();
			let t = e.type || e, n = LV.get(this);
			n || (n = /* @__PURE__ */ new Map(), LV.set(this, n));
			let r = n.get(t);
			n.delete(t), X.default.clearTimeout(r);
			let i = X.default.setTimeout(() => {
				n.delete(t), n.size === 0 && (n = null, LV.delete(this)), this.trigger(e);
			}, 0);
			n.set(t, i);
		}
	}, RV.prototype.allowedEvents_ = {}, RV.prototype.addEventListener = RV.prototype.on, RV.prototype.removeEventListener = RV.prototype.off, RV.prototype.dispatchEvent = RV.prototype.trigger, zV = (e) => typeof e.name == "function" ? e.name() : typeof e.name == "string" ? e.name : e.name_ ? e.name_ : e.constructor && e.constructor.name ? e.constructor.name : typeof e, BV = (e) => e instanceof RV || !!e.eventBusEl_ && [
		"on",
		"one",
		"off",
		"trigger"
	].every((t) => typeof e[t] == "function"), VV = (e, t) => {
		BV(e) ? t() : (e.eventedCallbacks ||= [], e.eventedCallbacks.push(t));
	}, HV = (e) => typeof e == "string" && /\S/.test(e) || Array.isArray(e) && !!e.length, UV = (e, t, n) => {
		if (!e || !e.nodeName && !BV(e)) throw Error(`Invalid target for ${zV(t)}#${n}; must be a DOM node or evented object.`);
	}, WV = (e, t, n) => {
		if (!HV(e)) throw Error(`Invalid event type for ${zV(t)}#${n}; must be a non-empty string or array.`);
	}, GV = (e, t, n) => {
		if (typeof e != "function") throw Error(`Invalid listener for ${zV(t)}#${n}; must be a function.`);
	}, KV = (e, t, n) => {
		let r = t.length < 3 || t[0] === e || t[0] === e.eventBusEl_, i, a, o;
		return r ? (i = e.eventBusEl_, t.length >= 3 && t.shift(), [a, o] = t) : (i = t[0], a = t[1], o = t[2]), UV(i, e, n), WV(a, e, n), GV(o, e, n), o = NV(e, o), {
			isTargetingSelf: r,
			target: i,
			type: a,
			listener: o
		};
	}, qV = (e, t, n, r) => {
		UV(e, e, t), e.nodeName ? jV[t](e, n, r) : e[t](n, r);
	}, JV = {
		on(...e) {
			let { isTargetingSelf: t, target: n, type: r, listener: i } = KV(this, e, "on");
			if (qV(n, "on", r, i), !t) {
				let e = () => this.off(n, r, i);
				e.guid = i.guid;
				let t = () => this.off("dispose", e);
				t.guid = i.guid, qV(this, "on", "dispose", e), qV(n, "on", "dispose", t);
			}
		},
		one(...e) {
			let { isTargetingSelf: t, target: n, type: r, listener: i } = KV(this, e, "one");
			if (t) qV(n, "one", r, i);
			else {
				let e = (...t) => {
					this.off(n, r, e), i.apply(null, t);
				};
				e.guid = i.guid, qV(n, "one", r, e);
			}
		},
		any(...e) {
			let { isTargetingSelf: t, target: n, type: r, listener: i } = KV(this, e, "any");
			if (t) qV(n, "any", r, i);
			else {
				let e = (...t) => {
					this.off(n, r, e), i.apply(null, t);
				};
				e.guid = i.guid, qV(n, "any", r, e);
			}
		},
		off(e, t, n) {
			if (!e || HV(e)) Lz(this.eventBusEl_, e, t);
			else {
				let r = e, i = t;
				UV(r, this, "off"), WV(i, this, "off"), GV(n, this, "off"), n = NV(this, n), this.off("dispose", n), r.nodeName ? (Lz(r, i, n), Lz(r, "dispose", n)) : BV(r) && (r.off(i, n), r.off("dispose", n));
			}
		},
		trigger(e, t) {
			UV(this.eventBusEl_, this, "trigger");
			let n = e && typeof e != "string" ? e.type : e;
			if (!HV(n)) throw Error(`Invalid event type for ${zV(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
			return Rz(this.eventBusEl_, e, t);
		}
	}, YV = {
		state: {},
		setState(e) {
			typeof e == "function" && (e = e());
			let t;
			return KR(e, (e, n) => {
				this.state[n] !== e && (t ||= {}, t[n] = {
					from: this.state[n],
					to: e
				}), this.state[n] = e;
			}), t && BV(this) && this.trigger({
				changes: t,
				type: "statechanged"
			}), t;
		}
	}, XV = function(e) {
		return typeof e == "string" ? e.replace(/./, (e) => e.toLowerCase()) : e;
	}, ZV = function(e) {
		return typeof e == "string" ? e.replace(/./, (e) => e.toUpperCase()) : e;
	}, QV = function(e, t) {
		return ZV(e) === ZV(t);
	}, $V = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		toLowerCase: XV,
		toTitleCase: ZV,
		titleCaseEquals: QV
	}), Q = class e {
		constructor(e, t, n) {
			if (this.player_ = !e && this.play ? e = this : e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = XR({}, this.options_), t = this.options_ = XR(this.options_, t), this.id_ = t.id || t.el && t.el.id, !this.id_) {
				let t = e && e.id && e.id() || "no_player";
				this.id_ = `${t}_component_${Mz()}`;
			}
			this.name_ = t.name || null, t.el ? this.el_ = t.el : t.createEl !== !1 && (this.el_ = this.createEl()), t.className && this.el_ && t.className.split(" ").forEach((e) => this.addClass(e)), [
				"on",
				"off",
				"one",
				"any",
				"trigger"
			].forEach((e) => {
				this[e] = void 0;
			}), t.evented !== !1 && (Vz(this, { eventBusKey: this.el_ ? "el_" : null }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), Hz(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, t.initChildren !== !1 && this.initChildren(), this.ready(n), t.reportTouchActivity !== !1 && this.enableTouchActivity();
		}
		dispose(e = {}) {
			if (!this.isDisposed_) {
				if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
					type: "dispose",
					bubbles: !1
				}), this.isDisposed_ = !0, this.children_) for (let e = this.children_.length - 1; e >= 0; e--) this.children_[e].dispose && this.children_[e].dispose();
				this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ &&= (this.el_.parentNode && (e.restoreEl ? this.el_.parentNode.replaceChild(e.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), null), this.player_ = null;
			}
		}
		isDisposed() {
			return !!this.isDisposed_;
		}
		player() {
			return this.player_;
		}
		options(e) {
			return e && (this.options_ = XR(this.options_, e)), this.options_;
		}
		el() {
			return this.el_;
		}
		createEl(e, t, n) {
			return az(e, t, n);
		}
		localize(e, t, n = e) {
			let r = this.player_.language && this.player_.language(), i = this.player_.languages && this.player_.languages(), a = i && i[r], o = r && r.split("-")[0], s = i && i[o], c = n;
			return a && a[e] ? c = a[e] : s && s[e] && (c = s[e]), t && (c = c.replace(/\{(\d+)\}/g, function(e, n) {
				let r = t[n - 1], i = r;
				return r === void 0 && (i = e), i;
			})), c;
		}
		handleLanguagechange() {}
		contentEl() {
			return this.contentEl_ || this.el_;
		}
		id() {
			return this.id_;
		}
		name() {
			return this.name_;
		}
		children() {
			return this.children_;
		}
		getChildById(e) {
			return this.childIndex_[e];
		}
		getChild(e) {
			if (e) return this.childNameIndex_[e];
		}
		getDescendant(...e) {
			e = e.reduce((e, t) => e.concat(t), []);
			let t = this;
			for (let n = 0; n < e.length; n++) if (t = t.getChild(e[n]), !t || !t.getChild) return;
			return t;
		}
		setIcon(e, t = this.el()) {
			if (!this.player_.options_.experimentalSvgIcons) return;
			let n = "http://www.w3.org/2000/svg", r = az("span", { className: "vjs-icon-placeholder vjs-svg-icon" }, { "aria-hidden": "true" }), i = Z.default.createElementNS(n, "svg");
			i.setAttributeNS(null, "viewBox", "0 0 512 512");
			let a = Z.default.createElementNS(n, "use");
			return i.appendChild(a), a.setAttributeNS(null, "href", `#vjs-icon-${e}`), r.appendChild(i), this.iconIsSet_ ? t.replaceChild(r, t.querySelector(".vjs-icon-placeholder")) : t.appendChild(r), this.iconIsSet_ = !0, r;
		}
		addChild(t, n = {}, r = this.children_.length) {
			let i, a;
			if (typeof t == "string") {
				a = ZV(t);
				let r = n.componentClass || a;
				n.name = a;
				let o = e.getComponent(r);
				if (!o) throw Error(`Component ${r} does not exist`);
				if (typeof o != "function") return null;
				i = new o(this.player_ || this, n);
			} else i = t;
			if (i.parentComponent_ && i.parentComponent_.removeChild(i), this.children_.splice(r, 0, i), i.parentComponent_ = this, typeof i.id == "function" && (this.childIndex_[i.id()] = i), a ||= i.name && ZV(i.name()), a && (this.childNameIndex_[a] = i, this.childNameIndex_[XV(a)] = i), typeof i.el == "function" && i.el()) {
				let e = null;
				this.children_[r + 1] && (this.children_[r + 1].el_ ? e = this.children_[r + 1].el_ : nz(this.children_[r + 1]) && (e = this.children_[r + 1])), this.contentEl().insertBefore(i.el(), e);
			}
			return i;
		}
		removeChild(e) {
			if (typeof e == "string" && (e = this.getChild(e)), !e || !this.children_) return;
			let t = !1;
			for (let n = this.children_.length - 1; n >= 0; n--) if (this.children_[n] === e) {
				t = !0, this.children_.splice(n, 1);
				break;
			}
			if (!t) return;
			e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[ZV(e.name())] = null, this.childNameIndex_[XV(e.name())] = null;
			let n = e.el();
			n && n.parentNode === this.contentEl() && this.contentEl().removeChild(e.el());
		}
		initChildren() {
			let t = this.options_.children;
			if (t) {
				let n = this.options_, r = (e) => {
					let t = e.name, r = e.opts;
					if (n[t] !== void 0 && (r = n[t]), r === !1) return;
					r === !0 && (r = {}), r.playerOptions = this.options_.playerOptions;
					let i = this.addChild(t, r);
					i && (this[t] = i);
				}, i, a = e.getComponent("Tech");
				i = Array.isArray(t) ? t : Object.keys(t), i.concat(Object.keys(this.options_).filter(function(e) {
					return !i.some(function(t) {
						return typeof t == "string" ? e === t : e === t.name;
					});
				})).map((e) => {
					let n, r;
					return typeof e == "string" ? (n = e, r = t[n] || this.options_[n] || {}) : (n = e.name, r = e), {
						name: n,
						opts: r
					};
				}).filter((t) => {
					let n = e.getComponent(t.opts.componentClass || ZV(t.name));
					return n && !a.isTech(n);
				}).forEach(r);
			}
		}
		buildCSSClass() {
			return "";
		}
		ready(e, t = !1) {
			if (e) {
				if (!this.isReady_) {
					this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(e);
					return;
				}
				t ? e.call(this) : this.setTimeout(e, 1);
			}
		}
		triggerReady() {
			this.isReady_ = !0, this.setTimeout(function() {
				let e = this.readyQueue_;
				this.readyQueue_ = [], e && e.length > 0 && e.forEach(function(e) {
					e.call(this);
				}, this), this.trigger("ready");
			}, 1);
		}
		$(e, t) {
			return vV(e, t || this.contentEl());
		}
		$$(e, t) {
			return yV(e, t || this.contentEl());
		}
		hasClass(e) {
			return cz(this.el_, e);
		}
		addClass(...e) {
			lz(this.el_, ...e);
		}
		removeClass(...e) {
			uz(this.el_, ...e);
		}
		toggleClass(e, t) {
			dz(this.el_, e, t);
		}
		show() {
			this.removeClass("vjs-hidden");
		}
		hide() {
			this.addClass("vjs-hidden");
		}
		lockShowing() {
			this.addClass("vjs-lock-showing");
		}
		unlockShowing() {
			this.removeClass("vjs-lock-showing");
		}
		getAttribute(e) {
			return mz(this.el_, e);
		}
		setAttribute(e, t) {
			hz(this.el_, e, t);
		}
		removeAttribute(e) {
			gz(this.el_, e);
		}
		width(e, t) {
			return this.dimension("width", e, t);
		}
		height(e, t) {
			return this.dimension("height", e, t);
		}
		dimensions(e, t) {
			this.width(e, !0), this.height(t);
		}
		dimension(e, t, n) {
			if (t !== void 0) {
				(t === null || t !== t) && (t = 0), ("" + t).indexOf("%") !== -1 || ("" + t).indexOf("px") !== -1 ? this.el_.style[e] = t : t === "auto" ? this.el_.style[e] = "" : this.el_.style[e] = t + "px", n || this.trigger("componentresize");
				return;
			}
			if (!this.el_) return 0;
			let r = this.el_.style[e], i = r.indexOf("px");
			return parseInt(i === -1 ? this.el_["offset" + ZV(e)] : r.slice(0, i), 10);
		}
		currentDimension(e) {
			let t = 0;
			if (e !== "width" && e !== "height") throw Error("currentDimension only accepts width or height value");
			if (t = Oz(this.el_, e), t = parseFloat(t), t === 0 || isNaN(t)) {
				let n = `offset${ZV(e)}`;
				t = this.el_[n];
			}
			return t;
		}
		currentDimensions() {
			return {
				width: this.currentDimension("width"),
				height: this.currentDimension("height")
			};
		}
		currentWidth() {
			return this.currentDimension("width");
		}
		currentHeight() {
			return this.currentDimension("height");
		}
		getPositions() {
			let e = this.el_.getBoundingClientRect();
			return {
				boundingClientRect: {
					x: e.x,
					y: e.y,
					width: e.width,
					height: e.height,
					top: e.top,
					right: e.right,
					bottom: e.bottom,
					left: e.left
				},
				center: {
					x: e.left + e.width / 2,
					y: e.top + e.height / 2,
					width: 0,
					height: 0,
					top: e.top + e.height / 2,
					right: e.left + e.width / 2,
					bottom: e.top + e.height / 2,
					left: e.left + e.width / 2
				}
			};
		}
		focus() {
			this.el_.focus();
		}
		blur() {
			this.el_.blur();
		}
		handleKeyDown(e) {
			this.player_ && (e.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && e.stopPropagation(), this.player_.handleKeyDown(e));
		}
		handleKeyPress(e) {
			this.handleKeyDown(e);
		}
		emitTapEvents() {
			let e = 0, t = null, n;
			this.on("touchstart", function(r) {
				r.touches.length === 1 && (t = {
					pageX: r.touches[0].pageX,
					pageY: r.touches[0].pageY
				}, e = X.default.performance.now(), n = !0);
			}), this.on("touchmove", function(e) {
				if (e.touches.length > 1) n = !1;
				else if (t) {
					let r = e.touches[0].pageX - t.pageX, i = e.touches[0].pageY - t.pageY;
					Math.sqrt(r * r + i * i) > 10 && (n = !1);
				}
			});
			let r = function() {
				n = !1;
			};
			this.on("touchleave", r), this.on("touchcancel", r), this.on("touchend", function(r) {
				t = null, n === !0 && X.default.performance.now() - e < 200 && (r.preventDefault(), this.trigger("tap"));
			});
		}
		enableTouchActivity() {
			if (!this.player() || !this.player().reportUserActivity) return;
			let e = NV(this.player(), this.player().reportUserActivity), t;
			this.on("touchstart", function() {
				e(), this.clearInterval(t), t = this.setInterval(e, 250);
			});
			let n = function(n) {
				e(), this.clearInterval(t);
			};
			this.on("touchmove", e), this.on("touchend", n), this.on("touchcancel", n);
		}
		setTimeout(e, t) {
			var n;
			return e = NV(this, e), this.clearTimersOnDispose_(), n = X.default.setTimeout(() => {
				this.setTimeoutIds_.has(n) && this.setTimeoutIds_.delete(n), e();
			}, t), this.setTimeoutIds_.add(n), n;
		}
		clearTimeout(e) {
			return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), X.default.clearTimeout(e)), e;
		}
		setInterval(e, t) {
			e = NV(this, e), this.clearTimersOnDispose_();
			let n = X.default.setInterval(e, t);
			return this.setIntervalIds_.add(n), n;
		}
		clearInterval(e) {
			return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), X.default.clearInterval(e)), e;
		}
		requestAnimationFrame(e) {
			this.clearTimersOnDispose_();
			var t;
			return e = NV(this, e), t = X.default.requestAnimationFrame(() => {
				this.rafIds_.has(t) && this.rafIds_.delete(t), e();
			}), this.rafIds_.add(t), t;
		}
		requestNamedAnimationFrame(e, t) {
			this.namedRafs_.has(e) && this.cancelNamedAnimationFrame(e), this.clearTimersOnDispose_(), t = NV(this, t);
			let n = this.requestAnimationFrame(() => {
				t(), this.namedRafs_.has(e) && this.namedRafs_.delete(e);
			});
			return this.namedRafs_.set(e, n), e;
		}
		cancelNamedAnimationFrame(e) {
			this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e));
		}
		cancelAnimationFrame(e) {
			return this.rafIds_.has(e) && (this.rafIds_.delete(e), X.default.cancelAnimationFrame(e)), e;
		}
		clearTimersOnDispose_() {
			this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
				[
					["namedRafs_", "cancelNamedAnimationFrame"],
					["rafIds_", "cancelAnimationFrame"],
					["setTimeoutIds_", "clearTimeout"],
					["setIntervalIds_", "clearInterval"]
				].forEach(([e, t]) => {
					this[e].forEach((e, n) => this[t](n));
				}), this.clearingTimersOnDispose_ = !1;
			}));
		}
		getIsDisabled() {
			return !!this.el_.disabled;
		}
		getIsExpresslyInert() {
			return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
		}
		getIsFocusable(e) {
			return (e || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
		}
		getIsAvailableToBeFocused(e) {
			function t(e) {
				let t = X.default.getComputedStyle(e, null), n = t.getPropertyValue("visibility");
				return t.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(n);
			}
			function n(e) {
				return !(!t(e.parentElement) || !t(e) || e.style.opacity === "0" || X.default.getComputedStyle(e).height === "0px" || X.default.getComputedStyle(e).width === "0px");
			}
			function r(e) {
				if (e.offsetWidth + e.offsetHeight + e.getBoundingClientRect().height + e.getBoundingClientRect().width === 0) return !1;
				let t = {
					x: e.getBoundingClientRect().left + e.offsetWidth / 2,
					y: e.getBoundingClientRect().top + e.offsetHeight / 2
				};
				if (t.x < 0 || t.x > (Z.default.documentElement.clientWidth || X.default.innerWidth) || t.y < 0 || t.y > (Z.default.documentElement.clientHeight || X.default.innerHeight)) return !1;
				let n = Z.default.elementFromPoint(t.x, t.y);
				for (; n;) {
					if (n === e) return !0;
					if (n.parentNode) n = n.parentNode;
					else return !1;
				}
			}
			return e ||= this.el(), !!(r(e) && n(e) && (!e.parentElement || e.tabIndex >= 0));
		}
		static registerComponent(t, n) {
			if (typeof t != "string" || !t) throw Error(`Illegal component name, "${t}"; must be a non-empty string.`);
			let r = e.getComponent("Tech"), i = r && r.isTech(n), a = e === n || e.prototype.isPrototypeOf(n.prototype);
			if (i || !a) {
				let e;
				throw e = i ? "techs must be registered using Tech.registerTech()" : "must be a Component subclass", Error(`Illegal component, "${t}"; ${e}.`);
			}
			t = ZV(t), e.components_ ||= {};
			let o = e.getComponent("Player");
			if (t === "Player" && o && o.players) {
				let e = o.players, t = Object.keys(e);
				if (e && t.length > 0) {
					for (let n = 0; n < t.length; n++) if (e[t[n]] !== null) throw Error("Can not register Player component after player has been created.");
				}
			}
			return e.components_[t] = n, e.components_[XV(t)] = n, n;
		}
		static getComponent(t) {
			if (!(!t || !e.components_)) return e.components_[t];
		}
	}, Q.registerComponent("Component", Q), eH = function(e, t) {
		e = e < 0 ? 0 : e;
		let n = Math.floor(e % 60), r = Math.floor(e / 60 % 60), i = Math.floor(e / 3600), a = Math.floor(t / 60 % 60), o = Math.floor(t / 3600);
		return (isNaN(e) || e === Infinity) && (i = r = n = "-"), i = i > 0 || o > 0 ? i + ":" : "", r = ((i || a >= 10) && r < 10 ? "0" + r : r) + ":", n = n < 10 ? "0" + n : n, i + r + n;
	}, tH = eH, nH = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		createTimeRanges: Kz,
		createTimeRange: Kz,
		setFormatTime: qz,
		resetFormatTime: Jz,
		formatTime: Yz
	}), Zz.prototype.code = 0, Zz.prototype.message = "", Zz.prototype.status = null, Zz.prototype.metadata = null, Zz.errorTypes = [
		"MEDIA_ERR_CUSTOM",
		"MEDIA_ERR_ABORTED",
		"MEDIA_ERR_NETWORK",
		"MEDIA_ERR_DECODE",
		"MEDIA_ERR_SRC_NOT_SUPPORTED",
		"MEDIA_ERR_ENCRYPTED"
	], Zz.defaultMessages = {
		1: "You aborted the media playback",
		2: "A network error caused the media download to fail part-way.",
		3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
		4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
		5: "The media is encrypted and we do not have the keys to decrypt it."
	}, Zz.MEDIA_ERR_CUSTOM = 0, Zz.prototype.MEDIA_ERR_CUSTOM = 0, Zz.MEDIA_ERR_ABORTED = 1, Zz.prototype.MEDIA_ERR_ABORTED = 1, Zz.MEDIA_ERR_NETWORK = 2, Zz.prototype.MEDIA_ERR_NETWORK = 2, Zz.MEDIA_ERR_DECODE = 3, Zz.prototype.MEDIA_ERR_DECODE = 3, Zz.MEDIA_ERR_SRC_NOT_SUPPORTED = 4, Zz.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4, Zz.MEDIA_ERR_ENCRYPTED = 5, Zz.prototype.MEDIA_ERR_ENCRYPTED = 5, rH = function(e) {
		return [
			"kind",
			"label",
			"language",
			"id",
			"inBandMetadataTrackDispatchType",
			"mode",
			"src"
		].reduce((t, n, r) => (e[n] && (t[n] = e[n]), t), { cues: e.cues && Array.prototype.map.call(e.cues, function(e) {
			return {
				startTime: e.startTime,
				endTime: e.endTime,
				text: e.text,
				id: e.id
			};
		}) });
	}, iH = function(e) {
		let t = e.$$("track"), n = Array.prototype.map.call(t, (e) => e.track);
		return Array.prototype.map.call(t, function(e) {
			let t = rH(e.track);
			return e.src && (t.src = e.src), t;
		}).concat(Array.prototype.filter.call(e.textTracks(), function(e) {
			return n.indexOf(e) === -1;
		}).map(rH));
	}, aH = function(e, t) {
		return e.forEach(function(e) {
			let n = t.addRemoteTextTrack(e).track;
			!e.src && e.cues && e.cues.forEach((e) => n.addCue(e));
		}), t.textTracks();
	}, oH = {
		textTracksToJson: iH,
		jsonToTextTracks: aH,
		trackToJson: rH
	}, sH = "vjs-modal-dialog", cH = class extends Q {
		constructor(e, t) {
			super(e, t), this.handleKeyDown_ = (e) => this.handleKeyDown(e), this.close_ = (e) => this.close(e), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = az("div", { className: `${sH}-content` }, { role: "document" }), this.descEl_ = az("p", {
				className: `${sH}-description vjs-control-text`,
				id: this.el().getAttribute("aria-describedby")
			}), oz(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
		}
		createEl() {
			return super.createEl("div", {
				className: this.buildCSSClass(),
				tabIndex: -1
			}, {
				"aria-describedby": `${this.id()}_description`,
				"aria-hidden": "true",
				"aria-label": this.label(),
				role: "dialog",
				"aria-live": "polite"
			});
		}
		dispose() {
			this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
		}
		buildCSSClass() {
			return `${sH} vjs-hidden ${super.buildCSSClass()}`;
		}
		label() {
			return this.localize(this.options_.label || "Modal Window");
		}
		description() {
			let e = this.options_.description || this.localize("This is a modal window.");
			return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
		}
		open() {
			if (this.opened_) {
				this.options_.fillAlways && this.fill();
				return;
			}
			let e = this.player();
			this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
		}
		opened(e) {
			return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
		}
		close() {
			if (!this.opened_) return;
			let e = this.player();
			this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
				type: "modalclose",
				bubbles: !0
			}), this.conditionalBlur_(), this.options_.temporary && this.dispose();
		}
		closeable(e) {
			if (typeof e == "boolean") {
				let t = this.closeable_ = !!e, n = this.getChild("closeButton");
				if (t && !n) {
					let e = this.contentEl_;
					this.contentEl_ = this.el_, n = this.addChild("closeButton", { controlText: "Close Modal Dialog" }), this.contentEl_ = e, this.on(n, "close", this.close_);
				}
				!t && n && (this.off(n, "close", this.close_), this.removeChild(n), n.dispose());
			}
			return this.closeable_;
		}
		fill() {
			this.fillWith(this.content());
		}
		fillWith(e) {
			let t = this.contentEl(), n = t.parentNode, r = t.nextSibling;
			this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, n.removeChild(t), this.empty(), Ez(t, e), this.trigger("modalfill"), r ? n.insertBefore(t, r) : n.appendChild(t);
			let i = this.getChild("closeButton");
			i && n.appendChild(i.el_), this.trigger("aftermodalfill");
		}
		empty() {
			this.trigger("beforemodalempty"), Cz(this.contentEl()), this.trigger("modalempty");
		}
		content(e) {
			return e !== void 0 && (this.content_ = e), this.content_;
		}
		conditionalFocus_() {
			let e = Z.default.activeElement, t = this.player_.el_;
			this.previouslyActiveEl_ = null, (t.contains(e) || t === e) && (this.previouslyActiveEl_ = e, this.focus());
		}
		conditionalBlur_() {
			this.previouslyActiveEl_ &&= (this.previouslyActiveEl_.focus(), null);
		}
		handleKeyDown(e) {
			if (this.trigger({
				type: "modalKeydown",
				originalEvent: e,
				target: this,
				bubbles: !0
			}), e.stopPropagation(), e.key === "Escape" && this.closeable()) {
				e.preventDefault(), this.close();
				return;
			}
			if (e.key !== "Tab") return;
			let t = this.focusableEls_(), n = this.el_.querySelector(":focus"), r;
			for (let e = 0; e < t.length; e++) if (n === t[e]) {
				r = e;
				break;
			}
			Z.default.activeElement === this.el_ && (r = 0), e.shiftKey && r === 0 ? (t[t.length - 1].focus(), e.preventDefault()) : !e.shiftKey && r === t.length - 1 && (t[0].focus(), e.preventDefault());
		}
		focusableEls_() {
			let e = this.el_.querySelectorAll("*");
			return Array.prototype.filter.call(e, (e) => (e instanceof X.default.HTMLAnchorElement || e instanceof X.default.HTMLAreaElement) && e.hasAttribute("href") || (e instanceof X.default.HTMLInputElement || e instanceof X.default.HTMLSelectElement || e instanceof X.default.HTMLTextAreaElement || e instanceof X.default.HTMLButtonElement) && !e.hasAttribute("disabled") || e instanceof X.default.HTMLIFrameElement || e instanceof X.default.HTMLObjectElement || e instanceof X.default.HTMLEmbedElement || e.hasAttribute("tabindex") && e.getAttribute("tabindex") !== -1 || e.hasAttribute("contenteditable"));
		}
	}, cH.prototype.options_ = {
		pauseOnOpen: !0,
		temporary: !0
	}, Q.registerComponent("ModalDialog", cH), lH = class extends RV {
		constructor(e = []) {
			super(), this.tracks_ = [];
			for (let t = 0; t < e.length; t++) this.addTrack(e[t]);
		}
		get length() {
			return this.tracks_.length;
		}
		addTrack(e) {
			let t = this.tracks_.length;
			"" + t in this || Object.defineProperty(this, t, { get() {
				return this.tracks_[t];
			} }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
				track: e,
				type: "addtrack",
				target: this
			})), e.labelchange_ = () => {
				this.trigger({
					track: e,
					type: "labelchange",
					target: this
				});
			}, BV(e) && e.addEventListener("labelchange", e.labelchange_);
		}
		removeTrack(e) {
			let t;
			for (let n = 0, r = this.length; n < r; n++) if (this[n] === e) {
				t = this[n], t.off && t.off(), this.tracks_.splice(n, 1);
				break;
			}
			t && this.trigger({
				track: t,
				type: "removetrack",
				target: this
			});
		}
		getTrackById(e) {
			let t = null;
			for (let n = 0, r = this.length; n < r; n++) {
				let r = this[n];
				if (r.id === e) {
					t = r;
					break;
				}
			}
			return t;
		}
	}, lH.prototype.allowedEvents_ = {
		change: "change",
		addtrack: "addtrack",
		removetrack: "removetrack",
		labelchange: "labelchange"
	};
	for (let e in lH.prototype.allowedEvents_) lH.prototype["on" + e] = null;
	if (uH = function(e, t) {
		for (let n = 0; n < e.length; n++) !Object.keys(e[n]).length || t.id === e[n].id || (e[n].enabled = !1);
	}, dH = class extends lH {
		constructor(e = []) {
			for (let t = e.length - 1; t >= 0; t--) if (e[t].enabled) {
				uH(e, e[t]);
				break;
			}
			super(e), this.changing_ = !1;
		}
		addTrack(e) {
			e.enabled && uH(this, e), super.addTrack(e), e.addEventListener && (e.enabledChange_ = () => {
				this.changing_ || (this.changing_ = !0, uH(this, e), this.changing_ = !1, this.trigger("change"));
			}, e.addEventListener("enabledchange", e.enabledChange_));
		}
		removeTrack(e) {
			super.removeTrack(e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
		}
	}, fH = function(e, t) {
		for (let n = 0; n < e.length; n++) !Object.keys(e[n]).length || t.id === e[n].id || (e[n].selected = !1);
	}, pH = class extends lH {
		constructor(e = []) {
			for (let t = e.length - 1; t >= 0; t--) if (e[t].selected) {
				fH(e, e[t]);
				break;
			}
			super(e), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
				get() {
					for (let e = 0; e < this.length; e++) if (this[e].selected) return e;
					return -1;
				},
				set() {}
			});
		}
		addTrack(e) {
			e.selected && fH(this, e), super.addTrack(e), e.addEventListener && (e.selectedChange_ = () => {
				this.changing_ || (this.changing_ = !0, fH(this, e), this.changing_ = !1, this.trigger("change"));
			}, e.addEventListener("selectedchange", e.selectedChange_));
		}
		removeTrack(e) {
			super.removeTrack(e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
		}
	}, mH = class extends lH {
		addTrack(e) {
			super.addTrack(e), this.queueChange_ ||= () => this.queueTrigger("change"), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), e.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
		}
		removeTrack(e) {
			super.removeTrack(e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
		}
		toJSON() {
			return this.tracks_.map((e) => e.toJSON());
		}
	}, hH = class {
		constructor(e = []) {
			this.trackElements_ = [], Object.defineProperty(this, "length", { get() {
				return this.trackElements_.length;
			} });
			for (let t = 0, n = e.length; t < n; t++) this.addTrackElement_(e[t]);
		}
		addTrackElement_(e) {
			let t = this.trackElements_.length;
			"" + t in this || Object.defineProperty(this, t, { get() {
				return this.trackElements_[t];
			} }), this.trackElements_.indexOf(e) === -1 && this.trackElements_.push(e);
		}
		getTrackElementByTrack_(e) {
			let t;
			for (let n = 0, r = this.trackElements_.length; n < r; n++) if (e === this.trackElements_[n].track) {
				t = this.trackElements_[n];
				break;
			}
			return t;
		}
		removeTrackElement_(e) {
			for (let t = 0, n = this.trackElements_.length; t < n; t++) if (e === this.trackElements_[t]) {
				this.trackElements_[t].track && typeof this.trackElements_[t].track.off == "function" && this.trackElements_[t].track.off(), typeof this.trackElements_[t].off == "function" && this.trackElements_[t].off(), this.trackElements_.splice(t, 1);
				break;
			}
		}
	}, gH = class e {
		constructor(t) {
			e.prototype.setCues_.call(this, t), Object.defineProperty(this, "length", { get() {
				return this.length_;
			} });
		}
		setCues_(e) {
			let t = this.length || 0, n = 0, r = e.length;
			this.cues_ = e, this.length_ = e.length;
			let i = function(e) {
				"" + e in this || Object.defineProperty(this, "" + e, { get() {
					return this.cues_[e];
				} });
			};
			if (t < r) for (n = t; n < r; n++) i.call(this, n);
		}
		getCueById(e) {
			let t = null;
			for (let n = 0, r = this.length; n < r; n++) {
				let r = this[n];
				if (r.id === e) {
					t = r;
					break;
				}
			}
			return t;
		}
	}, _H = {
		alternative: "alternative",
		captions: "captions",
		main: "main",
		sign: "sign",
		subtitles: "subtitles",
		commentary: "commentary"
	}, vH = {
		alternative: "alternative",
		descriptions: "descriptions",
		main: "main",
		"main-desc": "main-desc",
		translation: "translation",
		commentary: "commentary"
	}, yH = {
		subtitles: "subtitles",
		captions: "captions",
		descriptions: "descriptions",
		chapters: "chapters",
		metadata: "metadata"
	}, bH = {
		disabled: "disabled",
		hidden: "hidden",
		showing: "showing"
	}, xH = class extends RV {
		constructor(e = {}) {
			super();
			let t = {
				id: e.id || "vjs_track_" + Mz(),
				kind: e.kind || "",
				language: e.language || ""
			}, n = e.label || "";
			for (let e in t) Object.defineProperty(this, e, {
				get() {
					return t[e];
				},
				set() {}
			});
			Object.defineProperty(this, "label", {
				get() {
					return n;
				},
				set(e) {
					e !== n && (n = e, this.trigger("labelchange"));
				}
			});
		}
	}, SH = function(e) {
		return new URL(e, Z.default.baseURI);
	}, CH = function(e) {
		return new URL(e, Z.default.baseURI).href;
	}, wH = function(e) {
		if (typeof e == "string") {
			let t = e.split("?")[0].replace(/\/+$/, "").match(/\.([^.\/]+)$/);
			return t ? t[1].toLowerCase() : "";
		}
		return "";
	}, TH = function(e, t = X.default.location) {
		return SH(e).origin !== t.origin;
	}, EH = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		parseUrl: SH,
		getAbsoluteURL: CH,
		getFileExtension: wH,
		isCrossOrigin: TH
	}), DH = function(e, t) {
		let n = new X.default.WebVTT.Parser(X.default, X.default.vttjs, X.default.WebVTT.StringDecoder()), r = [];
		n.oncue = function(e) {
			t.addCue(e);
		}, n.onparsingerror = function(e) {
			r.push(e);
		}, n.onflush = function() {
			t.trigger({
				type: "loadeddata",
				target: t
			});
		}, n.parse(e), r.length > 0 && (X.default.console && X.default.console.groupCollapsed && X.default.console.groupCollapsed(`Text Track parsing errors for ${t.src}`), r.forEach((e) => UB.error(e)), X.default.console && X.default.console.groupEnd && X.default.console.groupEnd()), n.flush();
	}, OH = function(e, t) {
		let n = { uri: e }, r = TH(e);
		r && (n.cors = r);
		let i = t.tech_.crossOrigin() === "use-credentials";
		i && (n.withCredentials = i), (0, DB.default)(n, NV(this, function(e, n, r) {
			if (e) return UB.error(e, n);
			t.loaded_ = !0, typeof X.default.WebVTT == "function" ? DH(r, t) : t.tech_ && t.tech_.any(["vttjsloaded", "vttjserror"], (e) => {
				if (e.type === "vttjserror") {
					UB.error(`vttjs failed to load, stopping trying to process ${t.src}`);
					return;
				}
				return DH(r, t);
			});
		}));
	}, kH = class extends xH {
		constructor(e = {}) {
			if (!e.tech) throw Error("A tech was not provided.");
			let t = XR(e, {
				kind: yH[e.kind] || "subtitles",
				language: e.language || e.srclang || ""
			}), n = bH[t.mode] || "disabled", r = t.default;
			(t.kind === "metadata" || t.kind === "chapters") && (n = "hidden"), super(t), this.tech_ = t.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
			let i = new gH(this.cues_), a = new gH(this.activeCues_), o = !1;
			this.timeupdateHandler = NV(this, function(e = {}) {
				if (!this.tech_.isDisposed()) {
					if (!this.tech_.isReady_) {
						e.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
						return;
					}
					this.activeCues = this.activeCues, o &&= (this.trigger("cuechange"), !1), e.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
				}
			}), this.tech_.one("dispose", () => {
				this.stopTracking();
			}), n !== "disabled" && this.startTracking(), Object.defineProperties(this, {
				default: {
					get() {
						return r;
					},
					set() {}
				},
				mode: {
					get() {
						return n;
					},
					set(e) {
						bH[e] && n !== e && (n = e, !this.preload_ && n !== "disabled" && this.cues.length === 0 && OH(this.src, this), this.stopTracking(), n !== "disabled" && this.startTracking(), this.trigger("modechange"));
					}
				},
				cues: {
					get() {
						return this.loaded_ ? i : null;
					},
					set() {}
				},
				activeCues: {
					get() {
						if (!this.loaded_) return null;
						if (this.cues.length === 0) return a;
						let e = this.tech_.currentTime(), t = [];
						for (let n = 0, r = this.cues.length; n < r; n++) {
							let r = this.cues[n];
							r.startTime <= e && r.endTime >= e && t.push(r);
						}
						if (o = !1, t.length !== this.activeCues_.length) o = !0;
						else for (let e = 0; e < t.length; e++) this.activeCues_.indexOf(t[e]) === -1 && (o = !0);
						return this.activeCues_ = t, a.setCues_(this.activeCues_), a;
					},
					set() {}
				}
			}), t.src ? (this.src = t.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || t.kind !== "subtitles" && t.kind !== "captions") && OH(this.src, this)) : this.loaded_ = !0;
		}
		startTracking() {
			this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
		}
		stopTracking() {
			this.rvf_ &&= (this.tech_.cancelVideoFrameCallback(this.rvf_), void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
		}
		addCue(e) {
			let t = e;
			if (!("getCueAsHTML" in t)) {
				t = new X.default.vttjs.VTTCue(e.startTime, e.endTime, e.text);
				for (let n in e) n in t || (t[n] = e[n]);
				t.id = e.id, t.originalCue_ = e;
			}
			let n = this.tech_.textTracks();
			for (let e = 0; e < n.length; e++) n[e] !== this && n[e].removeCue(t);
			this.cues_.push(t), this.cues.setCues_(this.cues_);
		}
		toJSON() {
			return oH.trackToJson(this);
		}
		removeCue(e) {
			let t = this.cues_.length;
			for (; t--;) {
				let n = this.cues_[t];
				if (n === e || n.originalCue_ && n.originalCue_ === e) {
					this.cues_.splice(t, 1), this.cues.setCues_(this.cues_);
					break;
				}
			}
		}
	}, kH.prototype.allowedEvents_ = { cuechange: "cuechange" }, AH = class extends xH {
		constructor(e = {}) {
			let t = XR(e, { kind: vH[e.kind] || "" });
			super(t);
			let n = !1;
			Object.defineProperty(this, "enabled", {
				get() {
					return n;
				},
				set(e) {
					typeof e == "boolean" && e !== n && (n = e, this.trigger("enabledchange"));
				}
			}), t.enabled && (this.enabled = t.enabled), this.loaded_ = !0;
		}
	}, jH = class extends xH {
		constructor(e = {}) {
			let t = XR(e, { kind: _H[e.kind] || "" });
			super(t);
			let n = !1;
			Object.defineProperty(this, "selected", {
				get() {
					return n;
				},
				set(e) {
					typeof e == "boolean" && e !== n && (n = e, this.trigger("selectedchange"));
				}
			}), t.selected && (this.selected = t.selected);
		}
	}, MH = class e extends RV {
		constructor(t = {}) {
			super();
			let n, r = new kH(t);
			this.kind = r.kind, this.src = r.src, this.srclang = r.language, this.label = r.label, this.default = r.default, Object.defineProperties(this, {
				readyState: { get() {
					return n;
				} },
				track: { get() {
					return r;
				} }
			}), n = e.NONE, r.addEventListener("loadeddata", () => {
				n = e.LOADED, this.trigger({
					type: "load",
					target: this
				});
			});
		}
	}, MH.prototype.allowedEvents_ = { load: "load" }, MH.NONE = 0, MH.LOADING = 1, MH.LOADED = 2, MH.ERROR = 3, NH = {
		audio: {
			ListClass: dH,
			TrackClass: AH,
			capitalName: "Audio"
		},
		video: {
			ListClass: pH,
			TrackClass: jH,
			capitalName: "Video"
		},
		text: {
			ListClass: mH,
			TrackClass: kH,
			capitalName: "Text"
		}
	}, Object.keys(NH).forEach(function(e) {
		NH[e].getterName = `${e}Tracks`, NH[e].privateName = `${e}Tracks_`;
	}), PH = {
		remoteText: {
			ListClass: mH,
			TrackClass: kH,
			capitalName: "RemoteText",
			getterName: "remoteTextTracks",
			privateName: "remoteTextTracks_"
		},
		remoteTextEl: {
			ListClass: hH,
			TrackClass: MH,
			capitalName: "RemoteTextTrackEls",
			getterName: "remoteTextTrackEls",
			privateName: "remoteTextTrackEls_"
		}
	}, FH = Object.assign({}, NH, PH), PH.names = Object.keys(PH), NH.names = Object.keys(NH), FH.names = [].concat(PH.names, NH.names), IH = class e extends Q {
		constructor(e = {}, t = function() {}) {
			e.reportTouchActivity = !1, super(null, e, t), this.onDurationChange_ = (e) => this.onDurationChange(e), this.trackProgress_ = (e) => this.trackProgress(e), this.trackCurrentTime_ = (e) => this.trackCurrentTime(e), this.stopTrackingCurrentTime_ = (e) => this.stopTrackingCurrentTime(e), this.disposeSourceHandler_ = (e) => this.disposeSourceHandler(e), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
				this.hasStarted_ = !0;
			}), this.on("loadstart", function() {
				this.hasStarted_ = !1;
			}), FH.names.forEach((t) => {
				let n = FH[t];
				e && e[n.getterName] && (this[n.privateName] = e[n.getterName]);
			}), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), [
				"Text",
				"Audio",
				"Video"
			].forEach((t) => {
				e[`native${t}Tracks`] === !1 && (this[`featuresNative${t}Tracks`] = !1);
			}), e.nativeCaptions === !1 || e.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (e.nativeCaptions === !0 || e.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = e.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new FH.text.ListClass(), this.initTrackListeners(), e.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
		}
		triggerSourceset(e) {
			this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(e), 1)), this.trigger({
				src: e,
				type: "sourceset"
			});
		}
		manualProgressOn() {
			this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
		}
		manualProgressOff() {
			this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
		}
		trackProgress(e) {
			this.stopTrackingProgress(), this.progressInterval = this.setInterval(NV(this, function() {
				let e = this.bufferedPercent();
				this.bufferedPercent_ !== e && this.trigger("progress"), this.bufferedPercent_ = e, e === 1 && this.stopTrackingProgress();
			}), 500);
		}
		onDurationChange(e) {
			this.duration_ = this.duration();
		}
		buffered() {
			return Kz(0, 0);
		}
		bufferedPercent() {
			return Xz(this.buffered(), this.duration_);
		}
		stopTrackingProgress() {
			this.clearInterval(this.progressInterval);
		}
		manualTimeUpdatesOn() {
			this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
		}
		manualTimeUpdatesOff() {
			this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
		}
		trackCurrentTime() {
			this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
				this.trigger({
					type: "timeupdate",
					target: this,
					manuallyTriggered: !0
				});
			}, 250);
		}
		stopTrackingCurrentTime() {
			this.clearInterval(this.currentTimeInterval), this.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			});
		}
		dispose() {
			this.clearTracks(NH.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
		}
		clearTracks(e) {
			e = [].concat(e), e.forEach((e) => {
				let t = this[`${e}Tracks`]() || [], n = t.length;
				for (; n--;) {
					let r = t[n];
					e === "text" && this.removeRemoteTextTrack(r), t.removeTrack(r);
				}
			});
		}
		cleanupAutoTextTracks() {
			let e = this.autoRemoteTextTracks_ || [], t = e.length;
			for (; t--;) {
				let n = e[t];
				this.removeRemoteTextTrack(n);
			}
		}
		reset() {}
		crossOrigin() {}
		setCrossOrigin() {}
		error(e) {
			return e !== void 0 && (this.error_ = new Zz(e), this.trigger("error")), this.error_;
		}
		played() {
			return this.hasStarted_ ? Kz(0, 0) : Kz();
		}
		play() {}
		setScrubbing(e) {}
		scrubbing() {}
		setCurrentTime(e) {
			this.manualTimeUpdates && this.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			});
		}
		initTrackListeners() {
			NH.names.forEach((e) => {
				let t = NH[e], n = () => {
					this.trigger(`${e}trackchange`);
				}, r = this[t.getterName]();
				r.addEventListener("removetrack", n), r.addEventListener("addtrack", n), this.on("dispose", () => {
					r.removeEventListener("removetrack", n), r.removeEventListener("addtrack", n);
				});
			});
		}
		addWebVttScript_() {
			if (!X.default.WebVTT) if (Z.default.body.contains(this.el())) {
				if (!this.options_["vtt.js"] && YR(OB.default) && Object.keys(OB.default).length > 0) {
					this.trigger("vttjsloaded");
					return;
				}
				let e = Z.default.createElement("script");
				e.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", e.onload = () => {
					this.trigger("vttjsloaded");
				}, e.onerror = () => {
					this.trigger("vttjserror");
				}, this.on("dispose", () => {
					e.onload = null, e.onerror = null;
				}), X.default.WebVTT = !0, this.el().parentNode.appendChild(e);
			} else this.ready(this.addWebVttScript_);
		}
		emulateTextTracks() {
			let e = this.textTracks(), t = this.remoteTextTracks(), n = (t) => e.addTrack(t.track), r = (t) => e.removeTrack(t.track);
			t.on("addtrack", n), t.on("removetrack", r), this.addWebVttScript_();
			let i = () => this.trigger("texttrackchange"), a = () => {
				i();
				for (let t = 0; t < e.length; t++) {
					let n = e[t];
					n.removeEventListener("cuechange", i), n.mode === "showing" && n.addEventListener("cuechange", i);
				}
			};
			a(), e.addEventListener("change", a), e.addEventListener("addtrack", a), e.addEventListener("removetrack", a), this.on("dispose", function() {
				t.off("addtrack", n), t.off("removetrack", r), e.removeEventListener("change", a), e.removeEventListener("addtrack", a), e.removeEventListener("removetrack", a);
				for (let t = 0; t < e.length; t++) e[t].removeEventListener("cuechange", i);
			});
		}
		addTextTrack(e, t, n) {
			if (!e) throw Error("TextTrack kind is required but was not provided");
			return eB(this, e, t, n);
		}
		createRemoteTextTrack(e) {
			let t = XR(e, { tech: this });
			return new PH.remoteTextEl.TrackClass(t);
		}
		addRemoteTextTrack(e = {}, t) {
			let n = this.createRemoteTextTrack(e);
			return typeof t != "boolean" && (t = !1), this.remoteTextTrackEls().addTrackElement_(n), this.remoteTextTracks().addTrack(n.track), t === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(n.track)), n;
		}
		removeRemoteTextTrack(e) {
			let t = this.remoteTextTrackEls().getTrackElementByTrack_(e);
			this.remoteTextTrackEls().removeTrackElement_(t), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
		}
		getVideoPlaybackQuality() {
			return {};
		}
		requestPictureInPicture() {
			return Promise.reject();
		}
		disablePictureInPicture() {
			return !0;
		}
		setDisablePictureInPicture() {}
		requestVideoFrameCallback(e) {
			let t = Mz();
			return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(t), this.one("playing", () => {
				this.queuedHanders_.has(t) && (this.queuedHanders_.delete(t), e());
			})) : this.requestNamedAnimationFrame(t, e), t;
		}
		cancelVideoFrameCallback(e) {
			this.queuedHanders_.has(e) ? this.queuedHanders_.delete(e) : this.cancelNamedAnimationFrame(e);
		}
		setPoster() {}
		playsinline() {}
		setPlaysinline() {}
		overrideNativeAudioTracks(e) {}
		overrideNativeVideoTracks(e) {}
		canPlayType(e) {
			return "";
		}
		static canPlayType(e) {
			return "";
		}
		static canPlaySource(t, n) {
			return e.canPlayType(t.type);
		}
		static isTech(t) {
			return t.prototype instanceof e || t instanceof e || t === e;
		}
		static registerTech(t, n) {
			if (e.techs_ ||= {}, !e.isTech(n)) throw Error(`Tech ${t} must be a Tech`);
			if (!e.canPlayType) throw Error("Techs must have a static canPlayType method on them");
			if (!e.canPlaySource) throw Error("Techs must have a static canPlaySource method on them");
			return t = ZV(t), e.techs_[t] = n, e.techs_[XV(t)] = n, t !== "Tech" && e.defaultTechOrder_.push(t), n;
		}
		static getTech(t) {
			if (t) {
				if (e.techs_ && e.techs_[t]) return e.techs_[t];
				if (t = ZV(t), X.default && X.default.videojs && X.default.videojs[t]) return UB.warn(`The ${t} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), X.default.videojs[t];
			}
		}
	}, FH.names.forEach(function(e) {
		let t = FH[e];
		IH.prototype[t.getterName] = function() {
			return this[t.privateName] = this[t.privateName] || new t.ListClass(), this[t.privateName];
		};
	}), IH.prototype.featuresVolumeControl = !0, IH.prototype.featuresMuteControl = !0, IH.prototype.featuresFullscreenResize = !1, IH.prototype.featuresPlaybackRate = !1, IH.prototype.featuresProgressEvents = !1, IH.prototype.featuresSourceset = !1, IH.prototype.featuresTimeupdateEvents = !1, IH.prototype.featuresNativeTextTracks = !1, IH.prototype.featuresVideoFrameCallback = !1, IH.withSourceHandlers = function(e) {
		e.registerSourceHandler = function(t, n) {
			let r = e.sourceHandlers;
			r ||= e.sourceHandlers = [], n === void 0 && (n = r.length), r.splice(n, 0, t);
		}, e.canPlayType = function(t) {
			let n = e.sourceHandlers || [], r;
			for (let e = 0; e < n.length; e++) if (r = n[e].canPlayType(t), r) return r;
			return "";
		}, e.selectSourceHandler = function(t, n) {
			let r = e.sourceHandlers || [], i;
			for (let e = 0; e < r.length; e++) if (i = r[e].canHandleSource(t, n), i) return r[e];
			return null;
		}, e.canPlaySource = function(t, n) {
			let r = e.selectSourceHandler(t, n);
			return r ? r.canHandleSource(t, n) : "";
		}, [
			"seekable",
			"seeking",
			"duration"
		].forEach(function(e) {
			let t = this[e];
			typeof t == "function" && (this[e] = function() {
				return this.sourceHandler_ && this.sourceHandler_[e] ? this.sourceHandler_[e].apply(this.sourceHandler_, arguments) : t.apply(this, arguments);
			});
		}, e.prototype), e.prototype.setSource = function(t) {
			let n = e.selectSourceHandler(t, this.options_);
			n || (e.nativeSourceHandler ? n = e.nativeSourceHandler : UB.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), n !== e.nativeSourceHandler && (this.currentSource_ = t), this.sourceHandler_ = n.handleSource(t, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
		}, e.prototype.disposeSourceHandler = function() {
			this.currentSource_ &&= (this.clearTracks(["audio", "video"]), null), this.cleanupAutoTextTracks(), this.sourceHandler_ &&= (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), null);
		};
	}, Q.registerComponent("Tech", IH), IH.registerTech("Tech", IH), IH.defaultTechOrder_ = [], LH = {}, RH = {}, zH = {}, BH = {
		buffered: 1,
		currentTime: 1,
		duration: 1,
		muted: 1,
		played: 1,
		paused: 1,
		seekable: 1,
		volume: 1,
		ended: 1
	}, VH = {
		setCurrentTime: 1,
		setMuted: 1,
		setVolume: 1
	}, HH = {
		play: 1,
		pause: 1
	}, UH = {
		opus: "video/ogg",
		ogv: "video/ogg",
		mp4: "video/mp4",
		mov: "video/mp4",
		m4v: "video/mp4",
		mkv: "video/x-matroska",
		m4a: "audio/mp4",
		mp3: "audio/mpeg",
		aac: "audio/aac",
		caf: "audio/x-caf",
		flac: "audio/flac",
		oga: "audio/ogg",
		wav: "audio/wav",
		m3u8: "application/x-mpegURL",
		mpd: "application/dash+xml",
		jpg: "image/jpeg",
		jpeg: "image/jpeg",
		gif: "image/gif",
		png: "image/png",
		svg: "image/svg+xml",
		webp: "image/webp"
	}, WH = function(e = "") {
		let t = wH(e);
		return UH[t.toLowerCase()] || "";
	}, GH = (e, t) => {
		if (!t) return "";
		if (e.cache_.source.src === t && e.cache_.source.type) return e.cache_.source.type;
		let n = e.cache_.sources.filter((e) => e.src === t);
		if (n.length) return n[0].type;
		let r = e.$$("source");
		for (let e = 0; e < r.length; e++) {
			let n = r[e];
			if (n.type && n.src && n.src === t) return n.type;
		}
		return WH(t);
	}, KH = function(e) {
		if (Array.isArray(e)) {
			let t = [];
			e.forEach(function(e) {
				e = KH(e), Array.isArray(e) ? t = t.concat(e) : JR(e) && t.push(e);
			}), e = t;
		} else e = typeof e == "string" && e.trim() ? [fB({ src: e })] : JR(e) && typeof e.src == "string" && e.src && e.src.trim() ? [fB(e)] : [];
		return e;
	}, qH = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play\">\n      <path d=\"M16 10v28l22-14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-pause\">\n      <path d=\"M12 38h8V10h-8v28zm16-28v28h8V10h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-audio\">\n      <path d=\"M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-captions\">\n      <path d=\"M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-subtitles\">\n      <path d=\"M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-enter\">\n      <path d=\"M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-exit\">\n      <path d=\"M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play-circle\">\n      <path d=\"M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-mute\">\n      <path d=\"M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-low\">\n      <path d=\"M14 18v12h8l10 10V8L22 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-medium\">\n      <path d=\"M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-high\">\n      <path d=\"M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-spinner\">\n      <path d=\"M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 24 24\" id=\"vjs-icon-hd\">\n      <path d=\"M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-chapters\">\n      <path d=\"M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 40 40\" id=\"vjs-icon-downloading\">\n      <path d=\"M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download\">\n      <path d=\"M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-done\">\n      <path d=\"M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-off\">\n      <path d=\"M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-share\">\n      <path d=\"M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cog\">\n      <path d=\"M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-square\">\n      <path d=\"M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle\">\n      <circle cx=\"24\" cy=\"24\" r=\"20\"></circle>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-outline\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-inner-circle\">\n      <path d=\"M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cancel\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-replay\">\n      <path d=\"M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-repeat\">\n      <path d=\"M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-5\">\n      <path d=\"M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-10\">\n      <path d=\"M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-30\">\n      <path d=\"M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-5\">\n      <path d=\"M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-10\">\n      <path d=\"M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-30\">\n      <path d=\"M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 512 512\" id=\"vjs-icon-audio-description\">\n      <g fill-rule=\"evenodd\"><path d=\"M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57\"></path><path d=\"M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z\"></path></g>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-next-item\">\n      <path d=\"M12 36l17-12-17-12v24zm20-24v24h4V12h-4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-previous-item\">\n      <path d=\"M12 12h4v24h-4zm7 12l17 12V12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-shuffle\">\n      <path d=\"M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cast\">\n      <path d=\"M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-picture-in-picture-enter\">\n      <path d=\"M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 22 18\" id=\"vjs-icon-picture-in-picture-exit\">\n      <path d=\"M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z\"></path>\n      <path fill=\"none\" d=\"M-1-3h24v24H-1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-facebook\">\n      <path d=\"M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-linkedin\">\n      <path d=\"M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1200 1227\" id=\"vjs-icon-twitter\">\n      <path d=\"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z\"/>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-tumblr\">\n      <path d=\"M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-pinterest\">\n      <path d=\"M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z\"></path>\n    </symbol>\n  </defs>\n</svg>", JH = uV ? 10009 : dV ? 461 : 8, YH = {
		codes: {
			play: 415,
			pause: 19,
			ff: 417,
			rw: 412,
			back: JH
		},
		names: {
			415: "play",
			19: "pause",
			417: "ff",
			412: "rw",
			[JH]: "back"
		},
		isEventKey(e, t) {
			return t = t.toLowerCase(), !!(this.names[e.keyCode] && this.names[e.keyCode] === t);
		},
		getEventName(e) {
			if (this.names[e.keyCode]) return this.names[e.keyCode];
			if (this.codes[e.code]) {
				let t = this.codes[e.code];
				return this.names[t];
			}
			return null;
		}
	}, XH = 5, ZH = class extends RV {
		constructor(e) {
			super(), this.player_ = e, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
		}
		start() {
			this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
				this.focus(this.updateFocusableComponents()[0]);
			}), this.player_.on("modalclose", () => {
				this.refocusComponent();
			}), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
				this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
			}));
		}
		stop() {
			this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
		}
		onKeyDown_(e) {
			let t = e.originalEvent ? e.originalEvent : e;
			if ([
				"ArrowLeft",
				"ArrowRight",
				"ArrowUp",
				"ArrowDown"
			].includes(t.key)) {
				if (this.isPaused_) return;
				t.preventDefault();
				let e = t.key.substring(5).toLowerCase();
				this.move(e);
			} else if (YH.isEventKey(t, "play") || YH.isEventKey(t, "pause") || YH.isEventKey(t, "ff") || YH.isEventKey(t, "rw")) {
				t.preventDefault();
				let e = YH.getEventName(t);
				this.performMediaAction_(e);
			} else YH.isEventKey(t, "Back") && e.target && typeof e.target.closeable == "function" && e.target.closeable() && (t.preventDefault(), e.target.close());
		}
		performMediaAction_(e) {
			if (this.player_) switch (e) {
				case "play":
					this.player_.paused() && this.player_.play();
					break;
				case "pause":
					this.player_.paused() || this.player_.pause();
					break;
				case "ff":
					this.userSeek_(this.player_.currentTime() + XH);
					break;
				case "rw": this.userSeek_(this.player_.currentTime() - XH);
			}
		}
		userSeek_(e) {
			this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
		}
		pause() {
			this.isPaused_ = !0;
		}
		resume() {
			this.isPaused_ = !1;
		}
		handlePlayerBlur_(e) {
			let t = e.relatedTarget, n = null, r = this.getCurrentComponent(e.target);
			t && (n = !!t.closest(".video-js"), t.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!e.currentTarget.contains(e.relatedTarget) && !n || !t) && (r && r.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), r && r.el() && (this.lastFocusedComponent_ = r)));
		}
		handlePlayerFocus_() {
			this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
		}
		updateFocusableComponents() {
			let e = this.player_, t = [];
			function n(e) {
				for (let r of e) r.hasOwnProperty("el_") && r.getIsFocusable() && r.getIsAvailableToBeFocused(r.el()) && t.push(r), r.hasOwnProperty("children_") && r.children_.length > 0 && n(r.children_);
			}
			return e.children_.forEach((e) => {
				if (e.hasOwnProperty("el_")) {
					if (e.getIsFocusable && e.getIsAvailableToBeFocused && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el())) {
						t.push(e);
						return;
					}
					e.hasOwnProperty("children_") && e.children_.length > 0 ? n(e.children_) : e.hasOwnProperty("items") && e.items.length > 0 ? n(e.items) : this.findSuitableDOMChild(e) && t.push(e);
				}
				if (e.name_ === "ErrorDisplay" && e.opened_) {
					let n = e.el_.querySelector(".vjs-errors-ok-button-container");
					n && n.querySelectorAll("button").forEach((e, n) => {
						t.push({
							name: () => "ModalButton" + (n + 1),
							el: () => e,
							getPositions: () => {
								let t = e.getBoundingClientRect();
								return {
									boundingClientRect: {
										x: t.x,
										y: t.y,
										width: t.width,
										height: t.height,
										top: t.top,
										right: t.right,
										bottom: t.bottom,
										left: t.left
									},
									center: {
										x: t.left + t.width / 2,
										y: t.top + t.height / 2,
										width: 0,
										height: 0,
										top: t.top + t.height / 2,
										right: t.left + t.width / 2,
										bottom: t.top + t.height / 2,
										left: t.left + t.width / 2
									}
								};
							},
							getIsAvailableToBeFocused: () => !0,
							getIsFocusable: (e) => !0,
							focus: () => e.focus()
						});
					});
				}
			}), this.focusableComponents = t, this.focusableComponents;
		}
		findSuitableDOMChild(e) {
			function t(n) {
				if (e.getIsFocusable(n) && e.getIsAvailableToBeFocused(n)) return n;
				for (let e = 0; e < n.children.length; e++) {
					let r = n.children[e], i = t(r);
					if (i) return i;
				}
				return null;
			}
			return e.el() ? t(e.el()) : null;
		}
		getCurrentComponent(e) {
			this.updateFocusableComponents();
			let t = e || document.activeElement;
			if (this.focusableComponents.length) {
				for (let e of this.focusableComponents) if (e.el() === t) return e;
			}
		}
		add(e) {
			let t = [...this.focusableComponents];
			e.hasOwnProperty("el_") && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el()) && t.push(e), this.focusableComponents = t, this.trigger({
				type: "focusableComponentsChanged",
				focusableComponents: this.focusableComponents
			});
		}
		remove(e) {
			for (let t = 0; t < this.focusableComponents.length; t++) if (this.focusableComponents[t].name() === e.name()) {
				this.focusableComponents.splice(t, 1), this.trigger({
					type: "focusableComponentsChanged",
					focusableComponents: this.focusableComponents
				});
				return;
			}
		}
		clear() {
			this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
				type: "focusableComponentsChanged",
				focusableComponents: this.focusableComponents
			}));
		}
		move(e) {
			let t = this.getCurrentComponent();
			if (!t) return;
			let n = t.getPositions(), r = this.focusableComponents.filter((r) => r !== t && this.isInDirection_(n.boundingClientRect, r.getPositions().boundingClientRect, e)), i = this.findBestCandidate_(n.center, r, e);
			i ? this.focus(i) : this.trigger({
				type: "endOfFocusableComponents",
				direction: e,
				focusedComponent: t
			});
		}
		findBestCandidate_(e, t, n) {
			let r = Infinity, i = null;
			for (let a of t) {
				let t = a.getPositions().center, o = this.calculateDistance_(e, t, n);
				o < r && (r = o, i = a);
			}
			return i;
		}
		isInDirection_(e, t, n) {
			switch (n) {
				case "right": return t.left >= e.right;
				case "left": return t.right <= e.left;
				case "down": return t.top >= e.bottom;
				case "up": return t.bottom <= e.top;
				default: return !1;
			}
		}
		refocusComponent() {
			if (this.lastFocusedComponent_) {
				this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
				for (let e = 0; e < this.focusableComponents.length; e++) if (this.focusableComponents[e].name() === this.lastFocusedComponent_.name()) {
					this.focus(this.focusableComponents[e]);
					return;
				}
			} else this.focus(this.updateFocusableComponents()[0]);
		}
		focus(e) {
			typeof e == "object" && (e.getIsAvailableToBeFocused(e.el()) ? e.focus() : this.findSuitableDOMChild(e) && this.findSuitableDOMChild(e).focus());
		}
		calculateDistance_(e, t, n) {
			let r = Math.abs(e.x - t.x), i = Math.abs(e.y - t.y), a;
			switch (n) {
				case "right":
				case "left":
					a = r + i * 100;
					break;
				case "up":
					a = i * 2 + r * .5;
					break;
				case "down":
					a = i * 5 + r;
					break;
				default: a = r + i;
			}
			return a;
		}
		searchForTrackSelect_() {
			let e = this;
			for (let t of e.updateFocusableComponents()) if (t.constructor.name === "TextTrackSelect") {
				e.focus(t);
				break;
			}
		}
	}, QH = class extends Q {
		constructor(e, t, n) {
			let r = XR({ createEl: !1 }, t);
			if (super(e, r, n), !t.playerOptions.sources || t.playerOptions.sources.length === 0) for (let n = 0, r = t.playerOptions.techOrder; n < r.length; n++) {
				let t = ZV(r[n]), i = IH.getTech(t);
				if (t || (i = Q.getComponent(t)), i && i.isSupported()) {
					e.loadTech_(t);
					break;
				}
			}
			else e.src(t.playerOptions.sources);
		}
	}, Q.registerComponent("MediaLoader", QH), $H = class extends Q {
		constructor(e, t) {
			super(e, t), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (e) => this.handleMouseOver(e), this.handleMouseOut_ = (e) => this.handleMouseOut(e), this.handleClick_ = (e) => this.handleClick(e), this.handleKeyDown_ = (e) => this.handleKeyDown(e), this.emitTapEvents(), this.enable();
		}
		createEl(e = "div", t = {}, n = {}) {
			t = Object.assign({
				className: this.buildCSSClass(),
				tabIndex: 0
			}, t), e === "button" && UB.error(`Creating a ClickableComponent with an HTML element of ${e} is not supported; use a Button instead.`), n = Object.assign({ role: "button" }, n), this.tabIndex_ = t.tabIndex;
			let r = az(e, t, n);
			return this.player_.options_.experimentalSvgIcons || r.appendChild(az("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), this.createControlTextEl(r), r;
		}
		dispose() {
			this.controlTextEl_ = null, super.dispose();
		}
		createControlTextEl(e) {
			return this.controlTextEl_ = az("span", { className: "vjs-control-text" }, { "aria-live": "polite" }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
		}
		controlText(e, t = this.el()) {
			if (e === void 0) return this.controlText_ || "Need Text";
			let n = this.localize(e);
			this.controlText_ = e, oz(this.controlTextEl_, n), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && t.setAttribute("title", n);
		}
		buildCSSClass() {
			return `vjs-control vjs-button ${super.buildCSSClass()}`;
		}
		enable() {
			this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), this.tabIndex_ !== void 0 && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
		}
		disable() {
			this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), this.tabIndex_ !== void 0 && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
		}
		handleLanguagechange() {
			this.controlText(this.controlText_);
		}
		handleClick(e) {
			this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
		}
		handleKeyDown(e) {
			e.key === " " || e.key === "Enter" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
		}
	}, Q.registerComponent("ClickableComponent", $H), eU = class extends $H {
		constructor(e, t) {
			super(e, t);
			let { mainContent: n } = t && t.playerOptions || {};
			this.isMainContent = n, this.update(), this.update_ = (e) => this.update(e), e.on("posterchange", this.update_);
		}
		dispose() {
			this.player().off("posterchange", this.update_), super.dispose();
		}
		createEl() {
			return az("div", { className: "vjs-poster" });
		}
		crossOrigin(e) {
			if (e === void 0) return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
			if (e !== null && e !== "anonymous" && e !== "use-credentials") {
				this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
				return;
			}
			this.$("img") && (this.$("img").crossOrigin = e);
		}
		update(e) {
			let t = this.player().poster();
			this.setSrc(t), t ? this.show() : this.hide();
		}
		setSrc(e) {
			if (!e) {
				this.el_.textContent = "";
				return;
			}
			this.$("img") || this.el_.appendChild(az("picture", {
				className: "vjs-poster",
				tabIndex: -1
			}, {}, az("img", {
				loading: this.isMainContent ? "eager" : "lazy",
				fetchPriority: this.isMainContent ? "high" : "auto",
				crossOrigin: this.crossOrigin()
			}, { alt: "" }))), this.$("img").src = e;
		}
		handleClick(e) {
			if (!this.player_.controls()) return;
			let t = this.player_.getChild("controlBar"), n = t && t.getChild("playToggle");
			$B ? (n || this.player_).focus() : this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? $z(this.player_.play()) : this.player_.pause();
		}
	}, eU.prototype.crossorigin = eU.prototype.crossOrigin, Q.registerComponent("PosterImage", eU), tU = "#222", nU = "#ccc", rU = {
		monospace: "monospace",
		sansSerif: "sans-serif",
		serif: "serif",
		monospaceSansSerif: "\"Andale Mono\", \"Lucida Console\", monospace",
		monospaceSerif: "\"Courier New\", monospace",
		proportionalSansSerif: "sans-serif",
		proportionalSerif: "serif",
		casual: "\"Comic Sans MS\", Impact, fantasy",
		script: "\"Monotype Corsiva\", cursive",
		smallcaps: "\"Andale Mono\", \"Lucida Console\", monospace, sans-serif"
	}, iU = class extends Q {
		constructor(e, t, n) {
			super(e, t, n);
			let r = (e) => this.updateDisplay(e), i = (e) => {
				this.updateDisplayOverlay(), this.updateDisplay(e);
			};
			e.on("loadstart", (e) => this.toggleDisplay(e)), e.on("useractive", r), e.on("userinactive", r), e.on("texttrackchange", r), e.on("loadedmetadata", (e) => {
				this.updateDisplayOverlay(), this.preselectTrack(e);
			}), e.ready(NV(this, function() {
				if (e.tech_ && e.tech_.featuresNativeTextTracks) {
					this.hide();
					return;
				}
				e.on("fullscreenchange", i), e.on("playerresize", i);
				let t = X.default.screen.orientation || X.default, n = X.default.screen.orientation ? "change" : "orientationchange";
				t.addEventListener(n, i), e.on("dispose", () => t.removeEventListener(n, i));
				let r = this.options_.playerOptions.tracks || [];
				for (let e = 0; e < r.length; e++) this.player_.addRemoteTextTrack(r[e], !0);
				this.preselectTrack();
			}));
		}
		preselectTrack() {
			let e = {
				captions: 1,
				subtitles: 1
			}, t = this.player_.textTracks(), n = this.player_.cache_.selectedLanguage, r, i, a;
			for (let o = 0; o < t.length; o++) {
				let s = t[o];
				n && n.enabled && n.language && n.language === s.language && s.kind in e ? s.kind === n.kind ? a = s : a ||= s : n && !n.enabled ? (a = null, r = null, i = null) : s.default && (s.kind === "descriptions" && !r ? r = s : s.kind in e && !i && (i = s));
			}
			a ? a.mode = "showing" : i ? i.mode = "showing" : r && (r.mode = "showing");
		}
		toggleDisplay() {
			this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
		}
		createEl() {
			return super.createEl("div", { className: "vjs-text-track-display" }, {
				translate: "yes",
				"aria-live": "off",
				"aria-atomic": "true"
			});
		}
		clearDisplay() {
			typeof X.default.WebVTT == "function" && X.default.WebVTT.processCues(X.default, [], this.el_);
		}
		updateDisplay() {
			let e = this.player_.textTracks(), t = this.options_.allowMultipleShowingTracks;
			if (this.clearDisplay(), t) {
				let t = [];
				for (let n = 0; n < e.length; ++n) {
					let r = e[n];
					r.mode === "showing" && t.push(r);
				}
				this.updateForTrack(t);
				return;
			}
			let n = null, r = null, i = e.length;
			for (; i--;) {
				let t = e[i];
				t.mode === "showing" && (t.kind === "descriptions" ? n = t : r = t);
			}
			if (r ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(r)) : n && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(n)), !(X.default.CSS !== void 0 && X.default.CSS.supports("inset", "10px"))) {
				let e = this.el_, t = e.querySelectorAll(".vjs-text-track-cue"), n = this.player_.controlBar.el_.getBoundingClientRect().height, r = this.player_.el_.getBoundingClientRect().height;
				e.style = "", mB(e, "position", "relative"), mB(e, "height", r - n + "px"), mB(e, "top", "unset"), fV ? mB(e, "bottom", r + "px") : mB(e, "bottom", "0px"), t.length > 0 && t.forEach((e) => {
					if (e.style.inset) {
						let t = e.style.inset.split(" ");
						t.length === 3 && Object.assign(e.style, {
							top: t[0],
							right: t[1],
							bottom: t[2],
							left: "unset"
						});
					}
				});
			}
		}
		updateDisplayOverlay() {
			if (!this.player_.videoHeight() || !(X.default.CSS !== void 0 && X.default.CSS.supports("inset-inline: 10px"))) return;
			let e = this.player_.currentWidth(), t = this.player_.currentHeight(), n = e / t, r = this.player_.videoWidth() / this.player_.videoHeight(), i = 0, a = 0;
			Math.abs(n - r) > .1 && (n > r ? i = Math.round((e - t * r) / 2) : a = Math.round((t - e / r) / 2)), mB(this.el_, "insetInline", hB(i)), mB(this.el_, "insetBlock", hB(a));
		}
		updateDisplayState(e) {
			let t = this.player_.textTrackSettings.getValues(), n = e.activeCues, r = n.length;
			for (; r--;) {
				let e = n[r];
				if (!e) continue;
				let i = e.displayState;
				if (t.color && (i.firstChild.style.color = t.color), t.textOpacity && mB(i.firstChild, "color", pB(t.color || "#fff", t.textOpacity)), t.backgroundColor && (i.firstChild.style.backgroundColor = t.backgroundColor), t.backgroundOpacity && mB(i.firstChild, "backgroundColor", pB(t.backgroundColor || "#000", t.backgroundOpacity)), t.windowColor && (t.windowOpacity ? mB(i, "backgroundColor", pB(t.windowColor, t.windowOpacity)) : i.style.backgroundColor = t.windowColor), t.edgeStyle && (t.edgeStyle === "dropshadow" ? i.firstChild.style.textShadow = `2px 2px 3px ${tU}, 2px 2px 4px ${tU}, 2px 2px 5px ${tU}` : t.edgeStyle === "raised" ? i.firstChild.style.textShadow = `1px 1px ${tU}, 2px 2px ${tU}, 3px 3px ${tU}` : t.edgeStyle === "depressed" ? i.firstChild.style.textShadow = `1px 1px ${nU}, 0 1px ${nU}, -1px -1px ${tU}, 0 -1px ${tU}` : t.edgeStyle === "uniform" && (i.firstChild.style.textShadow = `0 0 4px ${tU}, 0 0 4px ${tU}, 0 0 4px ${tU}, 0 0 4px ${tU}`)), t.fontPercent && t.fontPercent !== 1) {
					let e = X.default.parseFloat(i.style.fontSize);
					i.style.fontSize = e * t.fontPercent + "px", i.style.height = "auto", i.style.top = "auto";
				}
				t.fontFamily && t.fontFamily !== "default" && (t.fontFamily === "small-caps" ? i.firstChild.style.fontVariant = "small-caps" : i.firstChild.style.fontFamily = rU[t.fontFamily]);
			}
		}
		updateForTrack(e) {
			if (Array.isArray(e) || (e = [e]), typeof X.default.WebVTT != "function" || e.every((e) => !e.activeCues)) return;
			let t = [];
			for (let n = 0; n < e.length; ++n) {
				let r = e[n];
				for (let e = 0; e < r.activeCues.length; ++e) t.push(r.activeCues[e]);
			}
			X.default.WebVTT.processCues(X.default, t, this.el_);
			for (let t = 0; t < e.length; ++t) {
				let n = e[t];
				for (let e = 0; e < n.activeCues.length; ++e) {
					let r = n.activeCues[e].displayState;
					lz(r, "vjs-text-track-cue", "vjs-text-track-cue-" + (n.language ? n.language : t)), n.language && hz(r, "lang", n.language);
				}
				this.player_.textTrackSettings && this.updateDisplayState(n);
			}
		}
	}, Q.registerComponent("TextTrackDisplay", iU), aU = class extends Q {
		createEl() {
			let e = this.player_.isAudio(), t = this.localize(e ? "Audio Player" : "Video Player"), n = az("span", {
				className: "vjs-control-text",
				textContent: this.localize("{1} is loading.", [t])
			}), r = super.createEl("div", {
				className: "vjs-loading-spinner",
				dir: "ltr"
			});
			return r.appendChild(n), r;
		}
		handleLanguagechange() {
			this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
		}
	}, Q.registerComponent("LoadingSpinner", aU), oU = class extends $H {
		createEl(e, t = {}, n = {}) {
			e = "button", t = Object.assign({ className: this.buildCSSClass() }, t), n = Object.assign({ type: "button" }, n);
			let r = az(e, t, n);
			return this.player_.options_.experimentalSvgIcons || r.appendChild(az("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), this.createControlTextEl(r), r;
		}
		addChild(e, t = {}) {
			let n = this.constructor.name;
			return UB.warn(`Adding an actionable (user controllable) child to a Button (${n}) is not supported; use a ClickableComponent instead.`), Q.prototype.addChild.call(this, e, t);
		}
		enable() {
			super.enable(), this.el_.removeAttribute("disabled");
		}
		disable() {
			super.disable(), this.el_.setAttribute("disabled", "disabled");
		}
		handleKeyDown(e) {
			if (e.key === " " || e.key === "Enter") {
				e.stopPropagation();
				return;
			}
			super.handleKeyDown(e);
		}
	}, Q.registerComponent("Button", oU), sU = class extends oU {
		constructor(e, t) {
			super(e, t), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (e) => this.handleMouseDown(e));
		}
		buildCSSClass() {
			return "vjs-big-play-button";
		}
		handleClick(e) {
			let t = this.player_.play(), n = this.player_.getChild("controlBar"), r = n && n.getChild("playToggle");
			if (e.type === "tap" || this.mouseused_ && "clientX" in e && "clientY" in e) {
				$z(t), $B ? (r || this.player_).focus() : this.player_.tech(!0) && this.player_.tech(!0).focus();
				return;
			}
			if (!r) {
				this.player_.tech(!0).focus();
				return;
			}
			let i = () => r.focus();
			Qz(t) ? t.then(i, () => {}) : this.setTimeout(i, 1);
		}
		handleKeyDown(e) {
			this.mouseused_ = !1, super.handleKeyDown(e);
		}
		handleMouseDown(e) {
			this.mouseused_ = !0;
		}
	}, sU.prototype.controlText_ = "Play Video", Q.registerComponent("BigPlayButton", sU), cU = class extends oU {
		constructor(e, t) {
			super(e, t), this.setIcon("cancel"), this.controlText(t && t.controlText || this.localize("Close"));
		}
		buildCSSClass() {
			return `vjs-close-button ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			this.trigger({
				type: "close",
				bubbles: !1
			});
		}
		handleKeyDown(e) {
			e.key === "Escape" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
		}
	}, Q.registerComponent("CloseButton", cU), lU = class extends oU {
		constructor(e, t = {}) {
			super(e, t), t.replay = t.replay === void 0 || t.replay, this.setIcon("play"), this.on(e, "play", (e) => this.handlePlay(e)), this.on(e, "pause", (e) => this.handlePause(e)), t.replay && this.on(e, "ended", (e) => this.handleEnded(e));
		}
		buildCSSClass() {
			return `vjs-play-control ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			this.player_.paused() ? $z(this.player_.play()) : this.player_.pause();
		}
		handleSeeked(e) {
			this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
		}
		handlePlay(e) {
			this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
		}
		handlePause(e) {
			this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
		}
		handleEnded(e) {
			this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (e) => this.handleSeeked(e));
		}
	}, lU.prototype.controlText_ = "Play", Q.registerComponent("PlayToggle", lU), uU = class extends Q {
		constructor(e, t) {
			super(e, t), this.on(e, [
				"timeupdate",
				"ended",
				"seeking"
			], (e) => this.update(e)), this.updateTextNode_();
		}
		createEl() {
			let e = this.buildCSSClass(), t = super.createEl("div", { className: `${e} vjs-time-control vjs-control` }), n = az("span", {
				className: "vjs-control-text",
				textContent: `${this.localize(this.labelText_)}\u00a0`
			}, { role: "presentation" });
			return t.appendChild(n), this.contentEl_ = az("span", { className: `${e}-display` }, { role: "presentation" }), t.appendChild(this.contentEl_), t;
		}
		dispose() {
			this.contentEl_ = null, this.textNode_ = null, super.dispose();
		}
		update(e) {
			!this.player_.options_.enableSmoothSeeking && e.type === "seeking" || this.updateContent(e);
		}
		updateTextNode_(e = 0) {
			e = Yz(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
				if (!this.contentEl_) return;
				let e = this.textNode_;
				e && this.contentEl_.firstChild !== e && (e = null, UB.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = Z.default.createTextNode(this.formattedTime_), this.textNode_ && (e ? this.contentEl_.replaceChild(this.textNode_, e) : this.contentEl_.appendChild(this.textNode_));
			}));
		}
		updateContent(e) {}
	}, uU.prototype.labelText_ = "Time", uU.prototype.controlText_ = "Time", Q.registerComponent("TimeDisplay", uU), dU = class extends uU {
		buildCSSClass() {
			return "vjs-current-time";
		}
		updateContent(e) {
			let t;
			t = this.player_.ended() ? this.player_.duration() : e && e.target && typeof e.target.pendingSeekTime == "function" && e.target.pendingSeekTime() !== null ? e.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(t);
		}
	}, dU.prototype.labelText_ = "Current Time", dU.prototype.controlText_ = "Current Time", Q.registerComponent("CurrentTimeDisplay", dU), fU = class extends uU {
		constructor(e, t) {
			super(e, t);
			let n = (e) => this.updateContent(e);
			this.on(e, "durationchange", n), this.on(e, "loadstart", n), this.on(e, "loadedmetadata", n);
		}
		buildCSSClass() {
			return "vjs-duration";
		}
		updateContent(e) {
			let t = this.player_.duration();
			this.updateTextNode_(t);
		}
	}, fU.prototype.labelText_ = "Duration", fU.prototype.controlText_ = "Duration", Q.registerComponent("DurationDisplay", fU), pU = class extends Q {
		createEl() {
			let e = super.createEl("div", { className: "vjs-time-control vjs-time-divider" }, { "aria-hidden": !0 }), t = super.createEl("div"), n = super.createEl("span", { textContent: "/" });
			return t.appendChild(n), e.appendChild(t), e;
		}
	}, Q.registerComponent("TimeDivider", pU), mU = class extends uU {
		constructor(e, t) {
			super(e, t), this.on(e, "durationchange", (e) => this.updateContent(e));
		}
		buildCSSClass() {
			return "vjs-remaining-time";
		}
		createEl() {
			let e = super.createEl();
			return this.options_.displayNegative !== !1 && e.insertBefore(az("span", {}, { "aria-hidden": !0 }, "-"), this.contentEl_), e;
		}
		updateContent(e) {
			if (typeof this.player_.duration() != "number") return;
			let t;
			t = this.player_.ended() ? 0 : this.player_.remainingTimeDisplay ? this.player_.remainingTimeDisplay() : this.player_.remainingTime(), this.updateTextNode_(t);
		}
	}, mU.prototype.labelText_ = "Remaining Time", mU.prototype.controlText_ = "Remaining Time", Q.registerComponent("RemainingTimeDisplay", mU), hU = class extends Q {
		constructor(e, t) {
			super(e, t), this.updateShowing(), this.on(this.player(), "durationchange", (e) => this.updateShowing(e));
		}
		createEl() {
			let e = super.createEl("div", { className: "vjs-live-control vjs-control" });
			return this.contentEl_ = az("div", { className: "vjs-live-display" }, { "aria-live": "off" }), this.contentEl_.appendChild(az("span", {
				className: "vjs-control-text",
				textContent: `${this.localize("Stream Type")}\u00a0`
			})), this.contentEl_.appendChild(Z.default.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
		}
		dispose() {
			this.contentEl_ = null, super.dispose();
		}
		updateShowing(e) {
			this.player().duration() === Infinity ? this.show() : this.hide();
		}
	}, Q.registerComponent("LiveDisplay", hU), gU = class extends oU {
		constructor(e, t) {
			super(e, t), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (e) => this.updateLiveEdgeStatus(e), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
		}
		createEl() {
			let e = super.createEl("button", { className: "vjs-seek-to-live-control vjs-control" });
			return this.setIcon("circle", e), this.textEl_ = az("span", {
				className: "vjs-seek-to-live-text",
				textContent: this.localize("LIVE")
			}, { "aria-hidden": "true" }), e.appendChild(this.textEl_), e;
		}
		updateLiveEdgeStatus() {
			!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
		}
		handleClick() {
			this.player_.liveTracker.seekToLiveEdge();
		}
		dispose() {
			this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
		}
	}, gU.prototype.controlText_ = "Seek to live, currently playing live", Q.registerComponent("SeekToLive", gU), _U = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		clamp: gB
	}), vU = class extends Q {
		constructor(e, t) {
			super(e, t), this.handleMouseDown_ = (e) => this.handleMouseDown(e), this.handleMouseUp_ = (e) => this.handleMouseUp(e), this.handleKeyDown_ = (e) => this.handleKeyDown(e), this.handleClick_ = (e) => this.handleClick(e), this.handleMouseMove_ = (e) => this.handleMouseMove(e), this.update_ = (e) => this.update(e), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
		}
		enabled() {
			return this.enabled_;
		}
		enable() {
			this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
		}
		disable() {
			if (!this.enabled()) return;
			let e = this.bar.el_.ownerDocument;
			this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
		}
		createEl(e, t = {}, n = {}) {
			return t.className += " vjs-slider", t = Object.assign({ tabIndex: 0 }, t), n = Object.assign({
				role: "slider",
				"aria-valuenow": 0,
				"aria-valuemin": 0,
				"aria-valuemax": 100
			}, n), super.createEl(e, t, n);
		}
		handleMouseDown(e) {
			let t = this.bar.el_.ownerDocument;
			e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !tV && e.preventDefault(), _z(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(t, "mousemove", this.handleMouseMove_), this.on(t, "mouseup", this.handleMouseUp_), this.on(t, "touchmove", this.handleMouseMove_), this.on(t, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
		}
		handleMouseMove(e) {}
		handleMouseUp(e) {
			let t = this.bar.el_.ownerDocument;
			vz(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(t, "mousemove", this.handleMouseMove_), this.off(t, "mouseup", this.handleMouseUp_), this.off(t, "touchmove", this.handleMouseMove_), this.off(t, "touchend", this.handleMouseUp_), this.update();
		}
		update() {
			if (!this.el_ || !this.bar) return;
			let e = this.getProgress();
			return e === this.progress_ ? e : (this.progress_ = e, this.requestNamedAnimationFrame("Slider#update", () => {
				let t = this.vertical() ? "height" : "width";
				this.bar.el().style[t] = (e * 100).toFixed(2) + "%";
			}), e);
		}
		getProgress() {
			return Number(gB(this.getPercent(), 0, 1).toFixed(4));
		}
		calculateDistance(e) {
			let t = xz(this.el_, e);
			return this.vertical() ? t.y : t.x;
		}
		handleKeyDown(e) {
			let t = this.options_.playerOptions.spatialNavigation, n = t && t.enabled, r = t && t.horizontalSeek;
			n ? r && e.key === "ArrowLeft" || !r && e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : r && e.key === "ArrowRight" || !r && e.key === "ArrowUp" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (this.pendingSeekTime() && (this.pendingSeekTime(null), this.userSeek_(this.player_.currentTime())), super.handleKeyDown(e)) : e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : e.key === "ArrowUp" || e.key === "ArrowRight" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e);
		}
		handleClick(e) {
			e.stopPropagation(), e.preventDefault();
		}
		vertical(e) {
			if (e === void 0) return this.vertical_ || !1;
			this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
		}
	}, Q.registerComponent("Slider", vU), yU = (e, t) => gB(e / t * 100, 0, 100).toFixed(2) + "%", bU = class extends Q {
		constructor(e, t) {
			super(e, t), this.partEls_ = [], this.on(e, "progress", (e) => this.update(e));
		}
		createEl() {
			let e = super.createEl("div", { className: "vjs-load-progress" }), t = az("span", { className: "vjs-control-text" }), n = az("span", { textContent: this.localize("Loaded") }), r = Z.default.createTextNode(": ");
			return this.percentageEl_ = az("span", {
				className: "vjs-control-text-loaded-percentage",
				textContent: "0%"
			}), e.appendChild(t), t.appendChild(n), t.appendChild(r), t.appendChild(this.percentageEl_), e;
		}
		dispose() {
			this.partEls_ = null, this.percentageEl_ = null, super.dispose();
		}
		update(e) {
			this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
				let e = this.player_.liveTracker, t = this.player_.buffered(), n = e && e.isLive() ? e.seekableEnd() : this.player_.duration(), r = this.player_.bufferedEnd(), i = this.partEls_, a = yU(r, n);
				this.percent_ !== a && (this.el_.style.width = a, oz(this.percentageEl_, a), this.percent_ = a);
				for (let e = 0; e < t.length; e++) {
					let n = t.start(e), a = t.end(e), o = i[e];
					o || (o = this.el_.appendChild(az()), i[e] = o), (o.dataset.start !== n || o.dataset.end !== a) && (o.dataset.start = n, o.dataset.end = a, o.style.left = yU(n, r), o.style.width = yU(a - n, r));
				}
				for (let e = i.length; e > t.length; e--) this.el_.removeChild(i[e - 1]);
				i.length = t.length;
			});
		}
	}, Q.registerComponent("LoadProgressBar", bU), xU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = PV(NV(this, this.update), MV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-time-tooltip" }, { "aria-hidden": "true" });
		}
		update(e, t, n) {
			let r = bz(this.el_), i = yz(this.player_.el()), a = e.width * t;
			if (!i || !r) return;
			let o = e.left - i.left + a, s = e.width - a + (i.right - e.right);
			s || (s = e.width - a, o = a);
			let c = r.width / 2;
			o < c ? c += c - o : s < c && (c = s), c < 0 ? c = 0 : c > r.width && (c = r.width), c = Math.round(c), this.el_.style.right = `-${c}px`, this.write(n);
		}
		write(e) {
			oz(this.el_, e);
		}
		updateTime(e, t, n, r) {
			this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
				let i, a = this.player_.duration();
				if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
					let e = this.player_.liveTracker.liveWindow(), n = e - t * e;
					i = (n < 1 ? "" : "-") + Yz(n, e);
				} else i = Yz(n, a);
				this.update(e, t, i), r && r();
			});
		}
	}, Q.registerComponent("TimeTooltip", xU), SU = class extends Q {
		constructor(e, t) {
			super(e, t), this.setIcon("circle"), this.update = PV(NV(this, this.update), MV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-play-progress vjs-slider-bar" }, { "aria-hidden": "true" });
		}
		update(e, t, n) {
			let r = this.getChild("timeTooltip");
			if (!r) return;
			let i = n && n.target && typeof n.target.pendingSeekTime == "function" ? n.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
			r.updateTime(e, t, i);
		}
	}, SU.prototype.options_ = { children: [] }, !hV && !XB && SU.prototype.options_.children.push("timeTooltip"), Q.registerComponent("PlayProgressBar", SU), CU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = PV(NV(this, this.update), MV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-mouse-display" });
		}
		update(e, t) {
			let n = t * this.player_.duration();
			this.getChild("timeTooltip").updateTime(e, t, n, () => {
				this.el_.style.left = `${e.width * t}px`;
			});
		}
	}, CU.prototype.options_ = { children: ["timeTooltip"] }, Q.registerComponent("MouseTimeDisplay", CU), wU = class e extends vU {
		constructor(t, n) {
			n = XR(e.prototype.options_, n), n.children = [...n.children];
			let r = t.options_.disableSeekWhileScrubbingOnMobile && (hV || XB) || t.options_.disableSeekWhileScrubbingOnSTV;
			(!hV && !XB || r) && n.children.splice(1, 0, "mouseTimeDisplay"), super(t, n), this.shouldDisableSeekWhileScrubbing_ = r, this.pendingSeekTime_ = null, this.setEventHandlers_();
		}
		setEventHandlers_() {
			this.update_ = NV(this, this.update), this.update = PV(this.update_, MV), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (e) => this.enableInterval_(e), this.disableIntervalHandler_ = (e) => this.disableInterval_(e), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, [
				"ended",
				"pause",
				"waiting"
			], this.disableIntervalHandler_), "hidden" in Z.default && "visibilityState" in Z.default && this.on(Z.default, "visibilitychange", this.toggleVisibility_);
		}
		toggleVisibility_(e) {
			Z.default.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
		}
		enableInterval_() {
			this.updateInterval ||= this.setInterval(this.update, MV);
		}
		disableInterval_(e) {
			this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || (this.updateInterval &&= (this.clearInterval(this.updateInterval), null));
		}
		createEl() {
			return super.createEl("div", { className: "vjs-progress-holder" }, { "aria-label": this.localize("Progress Bar") });
		}
		update(e) {
			if (Z.default.visibilityState === "hidden") return;
			let t = super.update();
			return this.requestNamedAnimationFrame("SeekBar#update", () => {
				let n = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), r = this.player_.liveTracker, i = this.player_.duration();
				r && r.isLive() && (i = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== t && (this.el_.setAttribute("aria-valuenow", (t * 100).toFixed(2)), this.percent_ = t), (this.currentTime_ !== n || this.duration_ !== i) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [Yz(n, i), Yz(i, i)], "{1} of {2}")), this.currentTime_ = n, this.duration_ = i), this.bar && this.bar.update(yz(this.el()), this.getProgress(), e);
			}), t;
		}
		userSeek_(e) {
			this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
		}
		getCurrentTime_() {
			return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
		}
		pendingSeekTime(e) {
			if (e !== void 0) if (e !== null) {
				let t = this.player_.duration();
				this.pendingSeekTime_ = Math.max(0, Math.min(e, t));
			} else this.pendingSeekTime_ = null;
			return this.pendingSeekTime_;
		}
		getPercent() {
			if (this.pendingSeekTime() !== null) return this.pendingSeekTime() / this.player_.duration();
			let e = this.getCurrentTime_(), t, n = this.player_.liveTracker;
			return n && n.isLive() ? (t = (e - n.seekableStart()) / n.liveWindow(), n.atLiveEdge() && (t = 1)) : t = e / this.player_.duration(), t;
		}
		handleMouseDown(e) {
			Dz(e) && (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.shouldDisableSeekWhileScrubbing_ || this.player_.pause(), super.handleMouseDown(e));
		}
		handleMouseMove(e, t = !1) {
			if (!Dz(e) || isNaN(this.player_.duration())) return;
			!t && !this.player_.scrubbing() && this.player_.scrubbing(!0);
			let n, r = this.calculateDistance(e), i = this.player_.liveTracker;
			if (!i || !i.isLive()) n = r * this.player_.duration(), n === this.player_.duration() && (n -= .1);
			else {
				if (r >= .99) {
					i.seekToLiveEdge();
					return;
				}
				let e = i.seekableStart(), t = i.liveCurrentTime();
				if (n = e + r * i.liveWindow(), n >= t && (n = t), n <= e && (n = e + .1), n === Infinity) return;
			}
			this.shouldDisableSeekWhileScrubbing_ ? this.pendingSeekTime(n) : this.userSeek_(n), this.player_.options_.enableSmoothSeeking && this.update();
		}
		enable() {
			super.enable();
			let e = this.getChild("mouseTimeDisplay");
			e && e.show();
		}
		disable() {
			super.disable();
			let e = this.getChild("mouseTimeDisplay");
			e && e.hide();
		}
		handleMouseUp(e) {
			super.handleMouseUp(e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.pendingSeekTime() !== null && (this.userSeek_(this.pendingSeekTime()), this.pendingSeekTime(null)), this.player_.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			}), this.videoWasPlaying ? $z(this.player_.play()) : this.update_();
		}
		handlePendingSeek_(e) {
			this.player_.paused() || this.player_.pause();
			let t = this.pendingSeekTime() === null ? this.player_.currentTime() : this.pendingSeekTime();
			this.pendingSeekTime(t + e), this.player_.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			});
		}
		stepForward() {
			this.shouldDisableSeekWhileScrubbing_ ? this.handlePendingSeek_(this.options().stepSeconds) : this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
		}
		stepBack() {
			this.shouldDisableSeekWhileScrubbing_ ? this.handlePendingSeek_(-this.options().stepSeconds) : this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
		}
		handleAction(e) {
			this.pendingSeekTime() !== null && (this.userSeek_(this.pendingSeekTime()), this.pendingSeekTime(null)), this.player_.paused() ? this.player_.play() : this.player_.pause();
		}
		handleKeyDown(e) {
			let t = this.player_.liveTracker;
			if (e.key === " " || e.key === "Enter") e.preventDefault(), e.stopPropagation(), this.handleAction(e);
			else if (e.key === "Home") e.preventDefault(), e.stopPropagation(), this.userSeek_(0);
			else if (e.key === "End") e.preventDefault(), e.stopPropagation(), t && t.isLive() ? this.userSeek_(t.liveCurrentTime()) : this.userSeek_(this.player_.duration());
			else if (/^[0-9]$/.test(e.key)) {
				e.preventDefault(), e.stopPropagation();
				let n = parseInt(e.key, 10) * .1;
				t && t.isLive() ? this.userSeek_(t.seekableStart() + t.liveWindow() * n) : this.userSeek_(this.player_.duration() * n);
			} else e.key === "PageDown" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier)) : e.key === "PageUp" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier)) : super.handleKeyDown(e);
		}
		dispose() {
			this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, [
				"ended",
				"pause",
				"waiting"
			], this.disableIntervalHandler_), "hidden" in Z.default && "visibilityState" in Z.default && this.off(Z.default, "visibilitychange", this.toggleVisibility_), super.dispose();
		}
	}, wU.prototype.options_ = {
		children: ["loadProgressBar", "playProgressBar"],
		barName: "playProgressBar",
		stepSeconds: 5,
		pageMultiplier: 12
	}, Q.registerComponent("SeekBar", wU), TU = class extends Q {
		constructor(e, t) {
			super(e, t), this.handleMouseMove = PV(NV(this, this.handleMouseMove), MV), this.throttledHandleMouseSeek = PV(NV(this, this.handleMouseSeek), MV), this.handleMouseUpHandler_ = (e) => this.handleMouseUp(e), this.handleMouseDownHandler_ = (e) => this.handleMouseDown(e), this.enable();
		}
		createEl() {
			return super.createEl("div", { className: "vjs-progress-control vjs-control" });
		}
		handleMouseMove(e) {
			let t = this.getChild("seekBar");
			if (!t) return;
			let n = t.getChild("playProgressBar"), r = t.getChild("mouseTimeDisplay");
			if (!n && !r) return;
			let i = t.el(), a = bz(i), o = xz(i, e).x;
			o = gB(o, 0, 1), r && r.update(a, o), n && n.update(a, t.getProgress());
		}
		handleMouseSeek(e) {
			let t = this.getChild("seekBar");
			t && t.handleMouseMove(e);
		}
		enabled() {
			return this.enabled_;
		}
		disable() {
			if (this.children().forEach((e) => e.disable && e.disable()), this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
				let e = this.getChild("seekBar");
				this.player_.scrubbing(!1), e.videoWasPlaying && $z(this.player_.play());
			}
		}
		enable() {
			this.children().forEach((e) => e.enable && e.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
		}
		removeListenersAddedOnMousedownAndTouchstart() {
			let e = this.el_.ownerDocument;
			this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseDown(e) {
			let t = this.el_.ownerDocument, n = this.getChild("seekBar");
			n && n.handleMouseDown(e), this.on(t, "mousemove", this.throttledHandleMouseSeek), this.on(t, "touchmove", this.throttledHandleMouseSeek), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseUp(e) {
			let t = this.getChild("seekBar");
			t && t.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
		}
	}, TU.prototype.options_ = { children: ["seekBar"] }, Q.registerComponent("ProgressControl", TU), EU = class extends oU {
		constructor(e, t) {
			super(e, t), this.setIcon("picture-in-picture-enter"), this.on(e, ["enterpictureinpicture", "leavepictureinpicture"], (e) => this.handlePictureInPictureChange(e)), this.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], (e) => this.handlePictureInPictureEnabledChange(e)), this.on(e, [
				"loadedmetadata",
				"audioonlymodechange",
				"audiopostermodechange"
			], () => this.handlePictureInPictureAudioModeChange()), this.disable();
		}
		buildCSSClass() {
			return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
		}
		handlePictureInPictureAudioModeChange() {
			if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
				this.show();
				return;
			}
			this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
		}
		handlePictureInPictureEnabledChange() {
			Z.default.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in X.default ? this.enable() : this.disable();
		}
		handlePictureInPictureChange(e) {
			this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
		}
		handleClick(e) {
			this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
		}
		show() {
			typeof Z.default.exitPictureInPicture == "function" && super.show();
		}
	}, EU.prototype.controlText_ = "Picture-in-Picture", Q.registerComponent("PictureInPictureToggle", EU), DU = class extends oU {
		constructor(e, t) {
			super(e, t), this.setIcon("fullscreen-enter"), this.on(e, "fullscreenchange", (e) => this.handleFullscreenChange(e)), Z.default[e.fsApi_.fullscreenEnabled] === !1 && this.disable();
		}
		buildCSSClass() {
			return `vjs-fullscreen-control ${super.buildCSSClass()}`;
		}
		handleFullscreenChange(e) {
			this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
		}
		handleClick(e) {
			this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
		}
	}, DU.prototype.controlText_ = "Fullscreen", Q.registerComponent("FullscreenToggle", DU), OU = function(e, t) {
		t.tech_ && !t.tech_.featuresVolumeControl && e.addClass("vjs-hidden"), e.on(t, "loadstart", function() {
			t.tech_.featuresVolumeControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden");
		});
	}, kU = class extends Q {
		createEl() {
			let e = super.createEl("div", { className: "vjs-volume-level" });
			return this.setIcon("circle", e), e.appendChild(super.createEl("span", { className: "vjs-control-text" })), e;
		}
	}, Q.registerComponent("VolumeLevel", kU), AU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = PV(NV(this, this.update), MV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-volume-tooltip" }, { "aria-hidden": "true" });
		}
		update(e, t, n, r) {
			if (!n) {
				let n = yz(this.el_), r = yz(this.player_.el()), i = e.width * t;
				if (!r || !n) return;
				let a = e.left - r.left + i, o = e.width - i + (r.right - e.right), s = n.width / 2;
				a < s ? s += s - a : o < s && (s = o), s < 0 ? s = 0 : s > n.width && (s = n.width), this.el_.style.right = `-${s}px`;
			}
			this.write(`${r}%`);
		}
		write(e) {
			oz(this.el_, e);
		}
		updateVolume(e, t, n, r, i) {
			this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
				this.update(e, t, n, r.toFixed(0)), i && i();
			});
		}
	}, Q.registerComponent("VolumeLevelTooltip", AU), jU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = PV(NV(this, this.update), MV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-mouse-display" });
		}
		update(e, t, n) {
			let r = 100 * t;
			this.getChild("volumeLevelTooltip").updateVolume(e, t, n, r, () => {
				n ? this.el_.style.bottom = `${e.height * t}px` : this.el_.style.left = `${e.width * t}px`;
			});
		}
	}, jU.prototype.options_ = { children: ["volumeLevelTooltip"] }, Q.registerComponent("MouseVolumeLevelDisplay", jU), MU = class extends vU {
		constructor(e, t) {
			super(e, t), this.on("slideractive", (e) => this.updateLastVolume_(e)), this.on(e, "volumechange", (e) => this.updateARIAAttributes(e)), e.ready(() => this.updateARIAAttributes());
		}
		createEl() {
			return super.createEl("div", { className: "vjs-volume-bar vjs-slider-bar" }, {
				"aria-label": this.localize("Volume Level"),
				"aria-live": "polite"
			});
		}
		handleMouseDown(e) {
			Dz(e) && super.handleMouseDown(e);
		}
		handleMouseMove(e) {
			let t = this.getChild("mouseVolumeLevelDisplay");
			if (t) {
				let n = this.el(), r = yz(n), i = this.vertical(), a = xz(n, e);
				a = i ? a.y : a.x, a = gB(a, 0, 1), t.update(r, a, i);
			}
			Dz(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
		}
		checkMuted() {
			this.player_.muted() && this.player_.muted(!1);
		}
		getPercent() {
			return this.player_.muted() ? 0 : this.player_.volume();
		}
		stepForward() {
			this.checkMuted(), this.player_.volume(this.player_.volume() + .1);
		}
		stepBack() {
			this.checkMuted(), this.player_.volume(this.player_.volume() - .1);
		}
		updateARIAAttributes(e) {
			let t = this.player_.muted() ? 0 : this.volumeAsPercentage_();
			this.el_.setAttribute("aria-valuenow", t), this.el_.setAttribute("aria-valuetext", t + "%");
		}
		volumeAsPercentage_() {
			return Math.round(this.player_.volume() * 100);
		}
		updateLastVolume_() {
			let e = this.player_.volume();
			this.one("sliderinactive", () => {
				this.player_.volume() === 0 && this.player_.lastVolume_(e);
			});
		}
	}, MU.prototype.options_ = {
		children: ["volumeLevel"],
		barName: "volumeLevel"
	}, !hV && !XB && MU.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay"), MU.prototype.playerEvent = "volumechange", Q.registerComponent("VolumeBar", MU), NU = class extends Q {
		constructor(e, t = {}) {
			t.vertical = t.vertical || !1, (t.volumeBar === void 0 || YR(t.volumeBar)) && (t.volumeBar = t.volumeBar || {}, t.volumeBar.vertical = t.vertical), super(e, t), OU(this, e), this.throttledHandleMouseMove = PV(NV(this, this.handleMouseMove), MV), this.handleMouseUpHandler_ = (e) => this.handleMouseUp(e), this.on("mousedown", (e) => this.handleMouseDown(e)), this.on("touchstart", (e) => this.handleMouseDown(e)), this.on("mousemove", (e) => this.handleMouseMove(e)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
				this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
			}), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
				this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
			});
		}
		createEl() {
			let e = "vjs-volume-horizontal";
			return this.options_.vertical && (e = "vjs-volume-vertical"), super.createEl("div", { className: `vjs-volume-control vjs-control ${e}` });
		}
		handleMouseDown(e) {
			let t = this.el_.ownerDocument;
			this.on(t, "mousemove", this.throttledHandleMouseMove), this.on(t, "touchmove", this.throttledHandleMouseMove), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseUp(e) {
			let t = this.el_.ownerDocument;
			this.off(t, "mousemove", this.throttledHandleMouseMove), this.off(t, "touchmove", this.throttledHandleMouseMove), this.off(t, "mouseup", this.handleMouseUpHandler_), this.off(t, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseMove(e) {
			this.volumeBar.handleMouseMove(e);
		}
	}, NU.prototype.options_ = { children: ["volumeBar"] }, Q.registerComponent("VolumeControl", NU), PU = function(e, t) {
		t.tech_ && !t.tech_.featuresMuteControl && e.addClass("vjs-hidden"), e.on(t, "loadstart", function() {
			t.tech_.featuresMuteControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden");
		});
	}, FU = class extends oU {
		constructor(e, t) {
			super(e, t), PU(this, e), this.on(e, ["loadstart", "volumechange"], (e) => this.update(e));
		}
		buildCSSClass() {
			return `vjs-mute-control ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			let t = this.player_.volume(), n = this.player_.lastVolume_();
			if (t === 0) {
				let e = n < .1 ? .1 : n;
				this.player_.volume(e), this.player_.muted(!1);
			} else this.player_.muted(!this.player_.muted());
		}
		update(e) {
			this.updateIcon_(), this.updateControlText_();
		}
		updateIcon_() {
			let e = this.player_.volume(), t = 3;
			this.setIcon("volume-high"), hV && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), t = 0) : e < .33 ? (this.setIcon("volume-low"), t = 1) : e < .67 && (this.setIcon("volume-medium"), t = 2), uz(this.el_, [
				0,
				1,
				2,
				3
			].reduce((e, t) => e + `${t ? " " : ""}vjs-vol-${t}`, "")), lz(this.el_, `vjs-vol-${t}`);
		}
		updateControlText_() {
			let e = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
			this.controlText() !== e && this.controlText(e);
		}
	}, FU.prototype.controlText_ = "Mute", Q.registerComponent("MuteToggle", FU), IU = class extends Q {
		constructor(e, t = {}) {
			t.inline = t.inline === void 0 || t.inline, (t.volumeControl === void 0 || YR(t.volumeControl)) && (t.volumeControl = t.volumeControl || {}, t.volumeControl.vertical = !t.inline), super(e, t), this.handleKeyPressHandler_ = (e) => this.handleKeyPress(e), this.on(e, ["loadstart"], (e) => this.volumePanelState_(e)), this.on(this.muteToggle, "keyup", (e) => this.handleKeyPress(e)), this.on(this.volumeControl, "keyup", (e) => this.handleVolumeControlKeyUp(e)), this.on("keydown", (e) => this.handleKeyPress(e)), this.on("mouseover", (e) => this.handleMouseOver(e)), this.on("mouseout", (e) => this.handleMouseOut(e)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
		}
		sliderActive_() {
			this.addClass("vjs-slider-active");
		}
		sliderInactive_() {
			this.removeClass("vjs-slider-active");
		}
		volumePanelState_() {
			this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
		}
		createEl() {
			let e = "vjs-volume-panel-horizontal";
			return this.options_.inline || (e = "vjs-volume-panel-vertical"), super.createEl("div", { className: `vjs-volume-panel vjs-control ${e}` });
		}
		dispose() {
			this.handleMouseOut(), super.dispose();
		}
		handleVolumeControlKeyUp(e) {
			e.key === "Escape" && this.muteToggle.focus();
		}
		handleMouseOver(e) {
			this.addClass("vjs-hover"), Iz(Z.default, "keyup", this.handleKeyPressHandler_);
		}
		handleMouseOut(e) {
			this.removeClass("vjs-hover"), Lz(Z.default, "keyup", this.handleKeyPressHandler_);
		}
		handleKeyPress(e) {
			e.key === "Escape" && this.handleMouseOut();
		}
	}, IU.prototype.options_ = { children: ["muteToggle", "volumeControl"] }, Q.registerComponent("VolumePanel", IU), LU = class extends oU {
		constructor(e, t) {
			super(e, t), this.validOptions = [
				5,
				10,
				30
			], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
		}
		getSkipForwardTime() {
			let e = this.options_.playerOptions;
			return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.forward;
		}
		buildCSSClass() {
			return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			if (isNaN(this.player_.duration())) return;
			let t = this.player_.currentTime(), n = this.player_.liveTracker, r = n && n.isLive() ? n.seekableEnd() : this.player_.duration(), i;
			i = t + this.skipTime <= r ? t + this.skipTime : r, this.player_.currentTime(i);
		}
		handleLanguagechange() {
			this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
		}
	}, LU.prototype.controlText_ = "Skip Forward", Q.registerComponent("SkipForward", LU), RU = class extends oU {
		constructor(e, t) {
			super(e, t), this.validOptions = [
				5,
				10,
				30
			], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
		}
		getSkipBackwardTime() {
			let e = this.options_.playerOptions;
			return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.backward;
		}
		buildCSSClass() {
			return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			let t = this.player_.currentTime(), n = this.player_.liveTracker, r = n && n.isLive() && n.seekableStart(), i;
			i = r && t - this.skipTime <= r ? r : t >= this.skipTime ? t - this.skipTime : 0, this.player_.currentTime(i);
		}
		handleLanguagechange() {
			this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
		}
	}, RU.prototype.controlText_ = "Skip Backward", Q.registerComponent("SkipBackward", RU), zU = class extends Q {
		constructor(e, t) {
			super(e, t), t && (this.menuButton_ = t.menuButton), this.focusedChild_ = -1, this.on("keydown", (e) => this.handleKeyDown(e)), this.boundHandleBlur_ = (e) => this.handleBlur(e), this.boundHandleTapClick_ = (e) => this.handleTapClick(e);
		}
		addEventListenerForItem(e) {
			e instanceof Q && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
		}
		removeEventListenerForItem(e) {
			e instanceof Q && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
		}
		removeChild(e) {
			typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), super.removeChild(e);
		}
		addItem(e) {
			let t = this.addChild(e);
			t && this.addEventListenerForItem(t);
		}
		createEl() {
			let e = this.options_.contentElType || "ul";
			this.contentEl_ = az(e, { className: "vjs-menu-content" }), this.contentEl_.setAttribute("role", "menu");
			let t = super.createEl("div", {
				append: this.contentEl_,
				className: "vjs-menu"
			});
			return t.appendChild(this.contentEl_), Iz(t, "click", function(e) {
				e.preventDefault(), e.stopImmediatePropagation();
			}), t;
		}
		dispose() {
			this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
		}
		handleBlur(e) {
			let t = e.relatedTarget || Z.default.activeElement;
			if (!this.children().some((e) => e.el() === t)) {
				let e = this.menuButton_;
				e && e.buttonPressed_ && t !== e.el().firstChild && e.unpressButton();
			}
		}
		handleTapClick(e) {
			if (this.menuButton_) {
				this.menuButton_.unpressButton();
				let t = this.children();
				if (!Array.isArray(t)) return;
				let n = t.filter((t) => t.el() === e.target)[0];
				if (!n) return;
				n.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
			}
		}
		handleKeyDown(e) {
			e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (e.key === "ArrowRight" || e.key === "ArrowUp") && (e.preventDefault(), e.stopPropagation(), this.stepBack());
		}
		stepForward() {
			let e = 0;
			this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
		}
		stepBack() {
			let e = 0;
			this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
		}
		focus(e = 0) {
			let t = this.children().slice();
			t.length && t[0].hasClass("vjs-menu-title") && t.shift(), t.length > 0 && (e < 0 ? e = 0 : e >= t.length && (e = t.length - 1), this.focusedChild_ = e, t[e].el_.focus());
		}
	}, Q.registerComponent("Menu", zU), BU = class extends Q {
		constructor(e, t = {}) {
			super(e, t), this.menuButton_ = new oU(e, t), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
			let n = oU.prototype.buildCSSClass();
			this.menuButton_.el_.className = this.buildCSSClass() + " " + n, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
			let r = (e) => this.handleClick(e);
			this.handleMenuKeyUp_ = (e) => this.handleMenuKeyUp(e), this.on(this.menuButton_, "tap", r), this.on(this.menuButton_, "click", r), this.on(this.menuButton_, "keydown", (e) => this.handleKeyDown(e)), this.on(this.menuButton_, "mouseenter", () => {
				this.addClass("vjs-hover"), this.menu.show(), Iz(Z.default, "keyup", this.handleMenuKeyUp_);
			}), this.on("mouseleave", (e) => this.handleMouseLeave(e)), this.on("keydown", (e) => this.handleSubmenuKeyDown(e));
		}
		update() {
			let e = this.createMenu();
			this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
		}
		createMenu() {
			let e = new zU(this.player_, { menuButton: this });
			if (this.hideThreshold_ = 0, this.options_.title) {
				let t = az("li", {
					className: "vjs-menu-title",
					textContent: ZV(this.options_.title),
					tabIndex: -1
				}), n = new Q(this.player_, { el: t });
				e.addItem(n);
			}
			if (this.items = this.createItems(), this.items) for (let t = 0; t < this.items.length; t++) e.addItem(this.items[t]);
			return e;
		}
		createItems() {}
		createEl() {
			return super.createEl("div", { className: this.buildWrapperCSSClass() }, {});
		}
		setIcon(e) {
			return super.setIcon(e, this.menuButton_.el_);
		}
		buildWrapperCSSClass() {
			let e = "vjs-menu-button";
			this.options_.inline === !0 ? e += "-inline" : e += "-popup";
			let t = oU.prototype.buildCSSClass();
			return `vjs-menu-button ${e} ${t} ${super.buildCSSClass()}`;
		}
		buildCSSClass() {
			let e = "vjs-menu-button";
			return this.options_.inline === !0 ? e += "-inline" : e += "-popup", `vjs-menu-button ${e} ${super.buildCSSClass()}`;
		}
		controlText(e, t = this.menuButton_.el()) {
			return this.menuButton_.controlText(e, t);
		}
		dispose() {
			this.handleMouseLeave(), super.dispose();
		}
		handleClick(e) {
			this.buttonPressed_ ? this.unpressButton() : this.pressButton();
		}
		handleMouseLeave(e) {
			this.removeClass("vjs-hover"), Lz(Z.default, "keyup", this.handleMenuKeyUp_);
		}
		focus() {
			this.menuButton_.focus();
		}
		blur() {
			this.menuButton_.blur();
		}
		handleKeyDown(e) {
			e.key === "Escape" || e.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus())) : (e.key === "Up" || e.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
		}
		handleMenuKeyUp(e) {
			(e.key === "Escape" || e.key === "Tab") && this.removeClass("vjs-hover");
		}
		handleSubmenuKeyPress(e) {
			this.handleSubmenuKeyDown(e);
		}
		handleSubmenuKeyDown(e) {
			(e.key === "Escape" || e.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus()));
		}
		pressButton() {
			if (this.enabled_) {
				if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), hV && rz()) return;
				this.menu.focus();
			}
		}
		unpressButton() {
			this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
		}
		disable() {
			this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
		}
		enable() {
			this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
		}
	}, Q.registerComponent("MenuButton", BU), VU = class extends BU {
		constructor(e, t) {
			let n = t.tracks;
			super(e, t), this.items.length <= 1 && this.hide(), n && (this.updateHandler_ = NV(this, this.update), this.cleanupHandler_ = NV(this, this.cleanupTrackListeners_), n.addEventListener("removetrack", this.updateHandler_), n.addEventListener("addtrack", this.updateHandler_), n.addEventListener("labelchange", this.updateHandler_), this.player_.on("ready", this.updateHandler_), this.player_.on("dispose", this.cleanupHandler_));
		}
		cleanupTrackListeners_() {
			if (!this.updateHandler_) return;
			let e = this.options_.tracks;
			e && (e.removeEventListener("removetrack", this.updateHandler_), e.removeEventListener("addtrack", this.updateHandler_), e.removeEventListener("labelchange", this.updateHandler_)), this.player_ && (this.player_.off("ready", this.updateHandler_), this.player_.off("dispose", this.cleanupHandler_)), this.updateHandler_ = null, this.cleanupHandler_ = null;
		}
		dispose() {
			this.cleanupTrackListeners_(), super.dispose();
		}
	}, Q.registerComponent("TrackButton", VU), HU = class extends $H {
		constructor(e, t) {
			super(e, t), this.selectable = t.selectable, this.isSelected_ = t.selected || !1, this.multiSelectable = t.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
		}
		createEl(e, t, n) {
			this.nonIconControl = !0;
			let r = super.createEl("li", Object.assign({
				className: "vjs-menu-item",
				tabIndex: -1
			}, t), n), i = az("span", {
				className: "vjs-menu-item-text",
				textContent: this.localize(this.options_.label)
			});
			return this.player_.options_.experimentalSvgIcons ? r.appendChild(i) : r.replaceChild(i, r.querySelector(".vjs-icon-placeholder")), r;
		}
		handleKeyDown(e) {
			[
				"Tab",
				"Escape",
				"ArrowUp",
				"ArrowLeft",
				"ArrowRight",
				"ArrowDown"
			].includes(e.key) || super.handleKeyDown(e);
		}
		handleClick(e) {
			this.selected(!0);
		}
		selected(e) {
			this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
		}
	}, Q.registerComponent("MenuItem", HU), UU = class extends HU {
		constructor(e, t) {
			let n = t.track, r = e.textTracks();
			t.label = n.label || n.language || "Unknown", t.selected = n.mode === "showing", super(e, t), this.track = n, this.kinds = (t.kinds || [t.kind || this.track.kind]).filter(Boolean);
			let i = (...e) => {
				this.handleTracksChange.apply(this, e);
			}, a = (...e) => {
				this.handleSelectedLanguageChange.apply(this, e);
			};
			if (e.on(["loadstart", "texttrackchange"], i), r.addEventListener("change", i), r.addEventListener("selectedlanguagechange", a), this.on("dispose", function() {
				e.off(["loadstart", "texttrackchange"], i), r.removeEventListener("change", i), r.removeEventListener("selectedlanguagechange", a);
			}), r.onchange === void 0) {
				let e;
				this.on(["tap", "click"], function() {
					if (typeof X.default.Event != "object") try {
						e = new X.default.Event("change");
					} catch {}
					e || (e = Z.default.createEvent("Event"), e.initEvent("change", !0, !0)), r.dispatchEvent(e);
				});
			}
			this.handleTracksChange();
		}
		handleClick(e) {
			let t = this.track, n = this.player_.textTracks();
			if (super.handleClick(e), n) for (let e = 0; e < n.length; e++) {
				let r = n[e];
				this.kinds.indexOf(r.kind) !== -1 && (r === t ? r.mode !== "showing" && (r.mode = "showing") : r.mode !== "disabled" && (r.mode = "disabled"));
			}
		}
		handleTracksChange(e) {
			let t = this.track.mode === "showing";
			t !== this.isSelected_ && this.selected(t);
		}
		handleSelectedLanguageChange(e) {
			if (this.track.mode === "showing") {
				let e = this.player_.cache_.selectedLanguage;
				if (e && e.enabled && e.language === this.track.language && e.kind !== this.track.kind) return;
				this.player_.cache_.selectedLanguage = {
					enabled: !0,
					language: this.track.language,
					kind: this.track.kind
				};
			}
		}
		dispose() {
			this.track = null, super.dispose();
		}
	}, Q.registerComponent("TextTrackMenuItem", UU), WU = class extends UU {
		constructor(e, t) {
			t.track = {
				player: e,
				kind: t.kind,
				kinds: t.kinds,
				default: !1,
				mode: "disabled"
			}, t.kinds ||= [t.kind], t.label ? t.track.label = t.label : t.track.label = t.kinds.join(" and ") + " off", t.selectable = !0, t.multiSelectable = !1, super(e, t);
		}
		handleTracksChange(e) {
			let t = this.player().textTracks(), n = !0;
			for (let e = 0, r = t.length; e < r; e++) {
				let r = t[e];
				if (this.options_.kinds.indexOf(r.kind) > -1 && r.mode === "showing") {
					n = !1;
					break;
				}
			}
			n !== this.isSelected_ && this.selected(n);
		}
		handleSelectedLanguageChange(e) {
			let t = this.player().textTracks(), n = !0;
			for (let e = 0, r = t.length; e < r; e++) {
				let r = t[e];
				if ([
					"captions",
					"descriptions",
					"subtitles"
				].indexOf(r.kind) > -1 && r.mode === "showing") {
					n = !1;
					break;
				}
			}
			n && (this.player_.cache_.selectedLanguage = { enabled: !1 });
		}
		handleLanguagechange() {
			this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
		}
	}, Q.registerComponent("OffTextTrackMenuItem", WU), GU = class extends VU {
		constructor(e, t = {}) {
			t.tracks = e.textTracks(), super(e, t);
		}
		createItems(e = [], t = UU) {
			let n;
			this.label_ && (n = `${this.label_} off`), e.push(new WU(this.player_, {
				kinds: this.kinds_,
				kind: this.kind_,
				label: n
			})), this.hideThreshold_ += 1;
			let r = this.player_.textTracks();
			Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
			for (let n = 0; n < r.length; n++) {
				let i = r[n];
				if (this.kinds_.indexOf(i.kind) > -1) {
					let n = new t(this.player_, {
						track: i,
						kinds: this.kinds_,
						kind: this.kind_,
						selectable: !0,
						multiSelectable: !1
					});
					n.addClass(`vjs-${i.kind}-menu-item`), e.push(n);
				}
			}
			return e;
		}
	}, Q.registerComponent("TextTrackButton", GU), KU = class extends HU {
		constructor(e, t) {
			let n = t.track, r = t.cue, i = e.currentTime();
			t.selectable = !0, t.multiSelectable = !1, t.label = r.text, t.selected = r.startTime <= i && i < r.endTime, super(e, t), this.track = n, this.cue = r;
		}
		handleClick(e) {
			super.handleClick(), this.player_.currentTime(this.cue.startTime);
		}
	}, Q.registerComponent("ChaptersTrackMenuItem", KU), qU = class extends GU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
				this.items.forEach((e) => {
					e.selected(this.track_.activeCues[0] === e.cue);
				});
			};
		}
		buildCSSClass() {
			return `vjs-chapters-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
		}
		update(e) {
			if (e && e.track && e.track.kind !== "chapters") return;
			let t = this.findChaptersTrack();
			t === this.track_ ? (!this.items || t && t.cues && t.cues.length !== this.items.length) && super.update() : (this.setTrack(t), super.update());
		}
		setTrack(e) {
			if (this.track_ !== e) {
				if (this.updateHandler_ ||= this.update.bind(this), this.track_) {
					let e = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
					e && e.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
				}
				if (this.track_ = e, this.track_) {
					this.track_.mode = "hidden";
					let e = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
					e && e.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
				}
			}
		}
		findChaptersTrack() {
			let e = this.player_.textTracks() || [];
			for (let t = e.length - 1; t >= 0; t--) {
				let n = e[t];
				if (n.kind === this.kind_) return n;
			}
		}
		getMenuCaption() {
			return this.track_ && this.track_.label ? this.track_.label : this.localize(ZV(this.kind_));
		}
		createMenu() {
			return this.options_.title = this.getMenuCaption(), super.createMenu();
		}
		createItems() {
			let e = [];
			if (!this.track_) return e;
			let t = this.track_.cues;
			if (!t) return e;
			for (let n = 0, r = t.length; n < r; n++) {
				let r = t[n], i = new KU(this.player_, {
					track: this.track_,
					cue: r
				});
				e.push(i);
			}
			return e;
		}
	}, qU.prototype.kind_ = "chapters", qU.prototype.controlText_ = "Chapters", Q.registerComponent("ChaptersButton", qU), JU = class extends GU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("audio-description");
			let r = e.textTracks(), i = NV(this, this.handleTracksChange);
			r.addEventListener("change", i), this.on("dispose", function() {
				r.removeEventListener("change", i);
			});
		}
		handleTracksChange(e) {
			let t = this.player().textTracks(), n = !1;
			for (let e = 0, r = t.length; e < r; e++) {
				let r = t[e];
				if (r.kind !== this.kind_ && r.mode === "showing") {
					n = !0;
					break;
				}
			}
			n ? this.disable() : this.enable();
		}
		buildCSSClass() {
			return `vjs-descriptions-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
		}
	}, JU.prototype.kind_ = "descriptions", JU.prototype.controlText_ = "Descriptions", Q.registerComponent("DescriptionsButton", JU), YU = class extends GU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("subtitles");
		}
		buildCSSClass() {
			return `vjs-subtitles-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
		}
	}, YU.prototype.kind_ = "subtitles", YU.prototype.controlText_ = "Subtitles", Q.registerComponent("SubtitlesButton", YU), XU = class extends UU {
		constructor(e, t) {
			t.track = {
				player: e,
				kind: t.kind,
				label: t.kind + " settings",
				selectable: !1,
				default: !1,
				mode: "disabled"
			}, t.selectable = !1, t.name = "CaptionSettingsMenuItem", super(e, t), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + t.kind + " settings dialog");
		}
		handleClick(e) {
			this.player().getChild("textTrackSettings").open();
		}
		handleLanguagechange() {
			this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
		}
	}, Q.registerComponent("CaptionSettingsMenuItem", XU), ZU = class extends GU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("captions");
		}
		buildCSSClass() {
			return `vjs-captions-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
		}
		createItems() {
			let e = [];
			return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new XU(this.player_, { kind: this.kind_ })), this.hideThreshold_ += 1), super.createItems(e);
		}
	}, ZU.prototype.kind_ = "captions", ZU.prototype.controlText_ = "Captions", Q.registerComponent("CaptionsButton", ZU), QU = class extends UU {
		createEl(e, t, n) {
			let r = super.createEl(e, t, n), i = r.querySelector(".vjs-menu-item-text");
			return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", r) : i.appendChild(az("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), i.appendChild(az("span", {
				className: "vjs-control-text",
				textContent: ` ${this.localize("Captions")}`
			}))), r;
		}
	}, Q.registerComponent("SubsCapsMenuItem", QU), $U = class extends GU {
		constructor(e, t = {}) {
			super(e, t), this.label_ = "subtitles", this.setIcon("subtitles"), [
				"en",
				"en-us",
				"en-ca",
				"fr-ca"
			].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(ZV(this.label_));
		}
		buildCSSClass() {
			return `vjs-subs-caps-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
		}
		createItems() {
			let e = [];
			return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new XU(this.player_, { kind: this.label_ })), this.hideThreshold_ += 1), e = super.createItems(e, QU), e;
		}
	}, $U.prototype.kinds_ = ["captions", "subtitles"], $U.prototype.controlText_ = "Subtitles", Q.registerComponent("SubsCapsButton", $U), eW = class extends HU {
		constructor(e, t) {
			let n = t.track, r = e.audioTracks();
			t.label = n.label || n.language || "Unknown", t.selected = n.enabled, super(e, t), this.track = n, this.addClass(`vjs-${n.kind}-menu-item`);
			let i = (...e) => {
				this.handleTracksChange.apply(this, e);
			};
			r.addEventListener("change", i), this.on("dispose", () => {
				r.removeEventListener("change", i);
			});
		}
		createEl(e, t, n) {
			let r = super.createEl(e, t, n), i = r.querySelector(".vjs-menu-item-text");
			return [
				"main-desc",
				"descriptions",
				"description"
			].indexOf(this.options_.track.kind) >= 0 && (i.appendChild(az("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), i.appendChild(az("span", {
				className: "vjs-control-text",
				textContent: " " + this.localize("Descriptions")
			}))), r;
		}
		handleClick(e) {
			if (super.handleClick(e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
				let e = this.player_.audioTracks();
				for (let t = 0; t < e.length; t++) {
					let n = e[t];
					n !== this.track && (n.enabled = n === this.track);
				}
			}
		}
		handleTracksChange(e) {
			this.selected(this.track.enabled);
		}
	}, Q.registerComponent("AudioTrackMenuItem", eW), tW = class extends VU {
		constructor(e, t = {}) {
			t.tracks = e.audioTracks(), super(e, t), this.setIcon("audio");
		}
		buildCSSClass() {
			return `vjs-audio-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
		}
		createItems(e = []) {
			this.hideThreshold_ = 1;
			let t = this.player_.audioTracks();
			for (let n = 0; n < t.length; n++) {
				let r = t[n];
				e.push(new eW(this.player_, {
					track: r,
					selectable: !0,
					multiSelectable: !1
				}));
			}
			return e;
		}
	}, tW.prototype.controlText_ = "Audio Track", Q.registerComponent("AudioTrackButton", tW), nW = class extends HU {
		constructor(e, t) {
			let n = t.rate, r = parseFloat(n, 10);
			t.label = n, t.selected = r === e.playbackRate(), t.selectable = !0, t.multiSelectable = !1, super(e, t), this.label = n, this.rate = r, this.on(e, "ratechange", (e) => this.update(e));
		}
		handleClick(e) {
			super.handleClick(), this.player().playbackRate(this.rate);
		}
		update(e) {
			this.selected(this.player().playbackRate() === this.rate);
		}
	}, nW.prototype.contentElType = "button", Q.registerComponent("PlaybackRateMenuItem", nW), rW = class extends BU {
		constructor(e, t) {
			super(e, t), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(e, "loadstart", (e) => this.updateVisibility(e)), this.on(e, "ratechange", (e) => this.updateLabel(e)), this.on(e, "playbackrateschange", (e) => this.handlePlaybackRateschange(e));
		}
		createEl() {
			let e = super.createEl();
			return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = az("div", {
				className: "vjs-playback-rate-value",
				id: this.labelElId_,
				textContent: "1x"
			}), e.appendChild(this.labelEl_), e;
		}
		dispose() {
			this.labelEl_ = null, super.dispose();
		}
		buildCSSClass() {
			return `vjs-playback-rate ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
		}
		createItems() {
			let e = this.playbackRates(), t = [];
			for (let n = e.length - 1; n >= 0; n--) t.push(new nW(this.player(), { rate: e[n] + "x" }));
			return t;
		}
		handlePlaybackRateschange(e) {
			this.update();
		}
		playbackRates() {
			let e = this.player();
			return e.playbackRates && e.playbackRates() || [];
		}
		playbackRateSupported() {
			return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
		}
		updateVisibility(e) {
			this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
		}
		updateLabel(e) {
			this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
		}
	}, rW.prototype.controlText_ = "Playback Rate", Q.registerComponent("PlaybackRateMenuButton", rW), iW = class extends Q {
		buildCSSClass() {
			return `vjs-spacer ${super.buildCSSClass()}`;
		}
		createEl(e = "div", t = {}, n = {}) {
			return t.className ||= this.buildCSSClass(), super.createEl(e, t, n);
		}
	}, Q.registerComponent("Spacer", iW), aW = class extends iW {
		buildCSSClass() {
			return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
		}
		createEl() {
			return super.createEl("div", {
				className: this.buildCSSClass(),
				textContent: "\xA0"
			});
		}
	}, Q.registerComponent("CustomControlSpacer", aW), oW = class extends Q {
		createEl() {
			return super.createEl("div", {
				className: "vjs-control-bar",
				dir: "ltr"
			});
		}
	}, oW.prototype.options_ = { children: [
		"playToggle",
		"skipBackward",
		"skipForward",
		"volumePanel",
		"currentTimeDisplay",
		"timeDivider",
		"durationDisplay",
		"progressControl",
		"liveDisplay",
		"seekToLive",
		"remainingTimeDisplay",
		"customControlSpacer",
		"playbackRateMenuButton",
		"chaptersButton",
		"descriptionsButton",
		"subsCapsButton",
		"audioTrackButton",
		"pictureInPictureToggle",
		"fullscreenToggle"
	] }, Q.registerComponent("ControlBar", oW), sW = class extends cH {
		constructor(e, t) {
			super(e, t), this.on(e, "error", (e) => {
				this.open(e);
			});
		}
		buildCSSClass() {
			return `vjs-error-display ${super.buildCSSClass()}`;
		}
		content() {
			let e = this.player().error();
			return e ? this.localize(e.message) : "";
		}
	}, sW.prototype.options_ = Object.assign({}, cH.prototype.options_, {
		pauseOnOpen: !1,
		fillAlways: !0,
		temporary: !1,
		uncloseable: !0
	}), Q.registerComponent("ErrorDisplay", sW), cW = class extends Q {
		constructor(e, t = {}) {
			super(e, t), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
		}
		createEl() {
			return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), az("select", { id: this.options_.id }, {}, this.options_.SelectOptions.map((e) => {
				let t = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${Mz()}`) + "-" + e[1].replace(/\W+/g, ""), n = az("option", {
					id: t,
					value: this.localize(e[0]),
					textContent: this.localize(e[1])
				});
				return n.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${t}`), n;
			}));
		}
	}, Q.registerComponent("TextTrackSelect", cW), lW = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = az("legend", {
				textContent: this.localize(this.options_.legendText),
				id: this.options_.legendId
			});
			this.el().appendChild(n);
			let r = this.options_.selects;
			for (let t of r) {
				let n = this.options_.selectConfigs[t], r = n.className, i = n.id.replace("%s", this.options_.id_), a = null, o = `vjs_select_${Mz()}`;
				if (this.options_.type === "colors") {
					a = az("span", { className: r });
					let e = az("label", {
						id: i,
						className: "vjs-label",
						textContent: this.localize(n.label)
					});
					e.setAttribute("for", o), a.appendChild(e);
				}
				let s = new cW(e, {
					SelectOptions: n.options,
					legendId: this.options_.legendId,
					id: o,
					labelId: i
				});
				this.addChild(s), this.options_.type === "colors" && (a.appendChild(s.el()), this.el().appendChild(a));
			}
		}
		createEl() {
			return az("fieldset", { className: this.options_.className });
		}
	}, Q.registerComponent("TextTrackFieldset", lW), uW = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = this.options_.textTrackComponentid, r = new lW(e, {
				id_: n,
				legendId: `captions-text-legend-${n}`,
				legendText: this.localize("Text"),
				className: "vjs-fg vjs-track-setting",
				selects: this.options_.fieldSets[0],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(r);
			let i = new lW(e, {
				id_: n,
				legendId: `captions-background-${n}`,
				legendText: this.localize("Text Background"),
				className: "vjs-bg vjs-track-setting",
				selects: this.options_.fieldSets[1],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(i);
			let a = new lW(e, {
				id_: n,
				legendId: `captions-window-${n}`,
				legendText: this.localize("Caption Area Background"),
				className: "vjs-window vjs-track-setting",
				selects: this.options_.fieldSets[2],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(a);
		}
		createEl() {
			return az("div", { className: "vjs-track-settings-colors" });
		}
	}, Q.registerComponent("TextTrackSettingsColors", uW), dW = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = this.options_.textTrackComponentid, r = new lW(e, {
				id_: n,
				legendId: `captions-font-size-${n}`,
				legendText: "Font Size",
				className: "vjs-font-percent vjs-track-setting",
				selects: this.options_.fieldSets[0],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(r);
			let i = new lW(e, {
				id_: n,
				legendId: `captions-edge-style-${n}`,
				legendText: this.localize("Text Edge Style"),
				className: "vjs-edge-style vjs-track-setting",
				selects: this.options_.fieldSets[1],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(i);
			let a = new lW(e, {
				id_: n,
				legendId: `captions-font-family-${n}`,
				legendText: this.localize("Font Family"),
				className: "vjs-font-family vjs-track-setting",
				selects: this.options_.fieldSets[2],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(a);
		}
		createEl() {
			return az("div", { className: "vjs-track-settings-font" });
		}
	}, Q.registerComponent("TextTrackSettingsFont", dW), fW = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = new oU(e, {
				controlText: this.localize("restore all settings to the default values"),
				className: "vjs-default-button"
			});
			n.el().classList.remove("vjs-control", "vjs-button"), n.el().textContent = this.localize("Reset"), this.addChild(n);
			let r = this.localize("Done"), i = new oU(e, {
				controlText: r,
				className: "vjs-done-button"
			});
			i.el().classList.remove("vjs-control", "vjs-button"), i.el().textContent = r, this.addChild(i);
		}
		createEl() {
			return az("div", { className: "vjs-track-settings-controls" });
		}
	}, Q.registerComponent("TrackSettingsControls", fW), pW = "vjs-text-track-settings", mW = ["#000", "Black"], hW = ["#00F", "Blue"], gW = ["#0FF", "Cyan"], _W = ["#0F0", "Green"], vW = ["#F0F", "Magenta"], yW = ["#F00", "Red"], bW = ["#FFF", "White"], xW = ["#FF0", "Yellow"], SW = ["1", "Opaque"], CW = ["0.5", "Semi-Transparent"], wW = ["0", "Transparent"], TW = {
		backgroundColor: {
			selector: ".vjs-bg-color > select",
			id: "captions-background-color-%s",
			label: "Color",
			options: [
				mW,
				bW,
				yW,
				_W,
				hW,
				xW,
				vW,
				gW
			],
			className: "vjs-bg-color"
		},
		backgroundOpacity: {
			selector: ".vjs-bg-opacity > select",
			id: "captions-background-opacity-%s",
			label: "Opacity",
			options: [
				SW,
				CW,
				wW
			],
			className: "vjs-bg-opacity vjs-opacity"
		},
		color: {
			selector: ".vjs-text-color > select",
			id: "captions-foreground-color-%s",
			label: "Color",
			options: [
				bW,
				mW,
				yW,
				_W,
				hW,
				xW,
				vW,
				gW
			],
			className: "vjs-text-color"
		},
		edgeStyle: {
			selector: ".vjs-edge-style > select",
			id: "",
			label: "Text Edge Style",
			options: [
				["none", "None"],
				["raised", "Raised"],
				["depressed", "Depressed"],
				["uniform", "Uniform"],
				["dropshadow", "Drop shadow"]
			]
		},
		fontFamily: {
			selector: ".vjs-font-family > select",
			id: "",
			label: "Font Family",
			options: [
				["proportionalSansSerif", "Proportional Sans-Serif"],
				["monospaceSansSerif", "Monospace Sans-Serif"],
				["proportionalSerif", "Proportional Serif"],
				["monospaceSerif", "Monospace Serif"],
				["casual", "Casual"],
				["script", "Script"],
				["small-caps", "Small Caps"]
			]
		},
		fontPercent: {
			selector: ".vjs-font-percent > select",
			id: "",
			label: "Font Size",
			options: [
				["0.50", "50%"],
				["0.75", "75%"],
				["1.00", "100%"],
				["1.25", "125%"],
				["1.50", "150%"],
				["1.75", "175%"],
				["2.00", "200%"],
				["3.00", "300%"],
				["4.00", "400%"]
			],
			default: 2,
			parser: (e) => e === "1.00" ? null : Number(e)
		},
		textOpacity: {
			selector: ".vjs-text-opacity > select",
			id: "captions-foreground-opacity-%s",
			label: "Opacity",
			options: [SW, CW],
			className: "vjs-text-opacity vjs-opacity"
		},
		windowColor: {
			selector: ".vjs-window-color > select",
			id: "captions-window-color-%s",
			label: "Color",
			className: "vjs-window-color"
		},
		windowOpacity: {
			selector: ".vjs-window-opacity > select",
			id: "captions-window-opacity-%s",
			label: "Opacity",
			options: [
				wW,
				CW,
				SW
			],
			className: "vjs-window-opacity vjs-opacity"
		}
	}, TW.windowColor.options = TW.backgroundColor.options, EW = class extends cH {
		constructor(e, t) {
			t.temporary = !1, super(e, t), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(e), this.endDialog = az("p", {
				className: "vjs-control-text",
				textContent: this.localize("End of dialog window.")
			}), this.el().appendChild(this.endDialog), this.setDefaults(), t.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
		}
		renderModalComponents(e) {
			let t = new uW(e, {
				textTrackComponentid: this.id_,
				selectConfigs: TW,
				fieldSets: [
					["color", "textOpacity"],
					["backgroundColor", "backgroundOpacity"],
					["windowColor", "windowOpacity"]
				]
			});
			this.addChild(t);
			let n = new dW(e, {
				textTrackComponentid: this.id_,
				selectConfigs: TW,
				fieldSets: [
					["fontPercent"],
					["edgeStyle"],
					["fontFamily"]
				]
			});
			this.addChild(n);
			let r = new fW(e);
			this.addChild(r);
		}
		bindFunctionsToSelectsAndButtons() {
			this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
				this.saveSettings(), this.close();
			}), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
				this.setDefaults(), this.updateDisplay();
			}), KR(TW, (e) => {
				this.on(this.$(e.selector), "change", this.updateDisplay);
			});
		}
		dispose() {
			this.endDialog = null, super.dispose();
		}
		label() {
			return this.localize("Caption Settings Dialog");
		}
		description() {
			return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
		}
		buildCSSClass() {
			return super.buildCSSClass() + " vjs-text-track-settings";
		}
		getValues() {
			return qR(TW, (e, t, n) => {
				let r = vB(this.$(t.selector), t.parser);
				return r !== void 0 && (e[n] = r), e;
			}, {});
		}
		setValues(e) {
			KR(TW, (t, n) => {
				yB(this.$(t.selector), e[n], t.parser);
			});
		}
		setDefaults() {
			KR(TW, (e) => {
				let t = e.hasOwnProperty("default") ? e.default : 0;
				this.$(e.selector).selectedIndex = t;
			});
		}
		restoreSettings() {
			let e;
			try {
				e = JSON.parse(X.default.localStorage.getItem(pW));
			} catch (e) {
				UB.warn(e);
			}
			e && this.setValues(e);
		}
		saveSettings() {
			if (!this.options_.persistTextTrackSettings) return;
			let e = this.getValues();
			try {
				Object.keys(e).length ? X.default.localStorage.setItem(pW, JSON.stringify(e)) : X.default.localStorage.removeItem(pW);
			} catch (e) {
				UB.warn(e);
			}
		}
		updateDisplay() {
			let e = this.player_.getChild("textTrackDisplay");
			e && e.updateDisplay();
		}
		handleLanguagechange() {
			this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
		}
	}, Q.registerComponent("TextTrackSettings", EW), DW = class extends Q {
		constructor(e, t) {
			let n = t.ResizeObserver || X.default.ResizeObserver;
			t.ResizeObserver === null && (n = !1);
			let r = XR({
				createEl: !n,
				reportTouchActivity: !1
			}, t);
			super(e, r), this.ResizeObserver = t.ResizeObserver || X.default.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = FV(() => {
				this.resizeHandler();
			}, 100, !1, this), n ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(e.el())) : (this.loadListener_ = () => {
				if (!this.el_ || !this.el_.contentWindow) return;
				let e = this.debouncedHandler_, t = this.unloadListener_ = function() {
					Lz(this, "resize", e), Lz(this, "unload", t), t = null;
				};
				Iz(this.el_.contentWindow, "unload", t), Iz(this.el_.contentWindow, "resize", e);
			}, this.one("load", this.loadListener_));
		}
		createEl() {
			return super.createEl("iframe", {
				className: "vjs-resize-manager",
				tabIndex: -1,
				title: this.localize("No content")
			}, { "aria-hidden": "true" });
		}
		resizeHandler() {
			!this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
		}
		dispose() {
			this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
		}
	}, Q.registerComponent("ResizeManager", DW), OW = {
		trackingThreshold: 20,
		liveTolerance: 15
	}, kW = class extends Q {
		constructor(e, t) {
			let n = XR(OW, t, { createEl: !1 });
			super(e, n), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (e) => this.handlePlay(e), this.handleFirstTimeupdate_ = (e) => this.handleFirstTimeupdate(e), this.handleSeeked_ = (e) => this.handleSeeked(e), this.seekToLiveEdge_ = (e) => this.seekToLiveEdge(e), this.reset_(), this.on(this.player_, "durationchange", (e) => this.handleDurationchange(e)), this.on(this.player_, "canplay", () => this.toggleTracking());
		}
		trackLive_() {
			let e = this.player_.seekable();
			if (!e || !e.length) return;
			let t = Number(X.default.performance.now().toFixed(4)), n = this.lastTime_ === -1 ? 0 : (t - this.lastTime_) / 1e3;
			this.lastTime_ = t, this.pastSeekEnd_ = this.pastSeekEnd() + n;
			let r = this.liveCurrentTime(), i = this.player_.currentTime(), a = this.player_.paused() || this.seekedBehindLive_ || Math.abs(r - i) > this.options_.liveTolerance;
			(!this.timeupdateSeen_ || r === Infinity) && (a = !1), a !== this.behindLiveEdge_ && (this.behindLiveEdge_ = a, this.trigger("liveedgechange"));
		}
		handleDurationchange() {
			this.toggleTracking();
		}
		toggleTracking() {
			this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
		}
		startTracking() {
			this.isTracking() || (this.timeupdateSeen_ ||= this.player_.hasStarted(), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, MV), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
		}
		handleFirstTimeupdate() {
			this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
		}
		handleSeeked() {
			let e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
			this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
		}
		handlePlay() {
			this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
		}
		reset_() {
			this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
		}
		nextSeekedFromUser() {
			this.nextSeekedFromUser_ = !0;
		}
		stopTracking() {
			this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
		}
		seekableEnd() {
			let e = this.player_.seekable(), t = [], n = e ? e.length : 0;
			for (; n--;) t.push(e.end(n));
			return t.length ? t.sort()[t.length - 1] : Infinity;
		}
		seekableStart() {
			let e = this.player_.seekable(), t = [], n = e ? e.length : 0;
			for (; n--;) t.push(e.start(n));
			return t.length ? t.sort()[0] : 0;
		}
		liveWindow() {
			let e = this.liveCurrentTime();
			return e === Infinity ? 0 : e - this.seekableStart();
		}
		isLive() {
			return this.isTracking();
		}
		atLiveEdge() {
			return !this.behindLiveEdge();
		}
		liveCurrentTime() {
			return this.pastSeekEnd() + this.seekableEnd();
		}
		pastSeekEnd() {
			let e = this.seekableEnd();
			return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
		}
		behindLiveEdge() {
			return this.behindLiveEdge_;
		}
		isTracking() {
			return typeof this.trackingInterval_ == "number";
		}
		seekToLiveEdge() {
			this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
		}
		dispose() {
			this.stopTracking(), super.dispose();
		}
	}, Q.registerComponent("LiveTracker", kW), AW = class extends Q {
		constructor(e, t) {
			super(e, t), this.on("statechanged", (e) => this.updateDom_()), this.updateDom_();
		}
		createEl() {
			return this.els = {
				title: az("div", {
					className: "vjs-title-bar-title",
					id: `vjs-title-bar-title-${Mz()}`
				}),
				description: az("div", {
					className: "vjs-title-bar-description",
					id: `vjs-title-bar-description-${Mz()}`
				})
			}, az("div", { className: "vjs-title-bar" }, {}, ZR(this.els));
		}
		updateDom_() {
			let e = this.player_.tech_, t = e && e.el_, n = {
				title: "aria-labelledby",
				description: "aria-describedby"
			};
			["title", "description"].forEach((e) => {
				let r = this.state[e], i = this.els[e], a = n[e];
				Cz(i), r && oz(i, r), t && (t.removeAttribute(a), r && t.setAttribute(a, i.id));
			}), this.state.title || this.state.description ? this.show() : this.hide();
		}
		update(e) {
			this.setState(e);
		}
		dispose() {
			let e = this.player_.tech_, t = e && e.el_;
			t && (t.removeAttribute("aria-labelledby"), t.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
		}
	}, Q.registerComponent("TitleBar", AW), jW = {
		initialDisplay: 4e3,
		position: [],
		takeFocus: !1
	}, MW = class extends oU {
		constructor(e, t) {
			t = XR(jW, t), super(e, t), this.controlText(t.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (e) => {
				this.removeClass("force-display");
			});
		}
		buildCSSClass() {
			return `vjs-transient-button focus-visible ${this.options_.position.map((e) => `vjs-${e}`).join(" ")}`;
		}
		createEl() {
			let e = az("button", {}, {
				type: "button",
				class: this.buildCSSClass()
			}, az("span"));
			return this.controlTextEl_ = e.querySelector("span"), e;
		}
		show() {
			super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({ preventScroll: !0 }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
				this.removeClass("force-display");
			}, this.options_.initialDisplay);
		}
		hide() {
			this.removeClass("force-display"), super.hide();
		}
		dispose() {
			this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
		}
	}, Q.registerComponent("TransientButton", MW), NW = (e) => {
		let t = e.el();
		if (t.hasAttribute("src")) return e.triggerSourceset(t.src), !0;
		let n = e.$$("source"), r = [], i = "";
		if (!n.length) return !1;
		for (let e = 0; e < n.length; e++) {
			let t = n[e].src;
			t && r.indexOf(t) === -1 && r.push(t);
		}
		return r.length ? (r.length === 1 && (i = r[0]), e.triggerSourceset(i), !0) : !1;
	}, PW = Object.defineProperty({}, "innerHTML", {
		get() {
			return this.cloneNode(!0).innerHTML;
		},
		set(e) {
			let t = Z.default.createElement(this.nodeName.toLowerCase());
			t.innerHTML = e;
			let n = Z.default.createDocumentFragment();
			for (; t.childNodes.length;) n.appendChild(t.childNodes[0]);
			return this.innerText = "", X.default.Element.prototype.appendChild.call(this, n), this.innerHTML;
		}
	}), FW = (e, t) => {
		let n = {};
		for (let r = 0; r < e.length && (n = Object.getOwnPropertyDescriptor(e[r], t), !(n && n.set && n.get)); r++);
		return n.enumerable = !0, n.configurable = !0, n;
	}, IW = (e) => FW([
		e.el(),
		X.default.HTMLMediaElement.prototype,
		X.default.Element.prototype,
		PW
	], "innerHTML"), LW = function(e) {
		let t = e.el();
		if (t.resetSourceWatch_) return;
		let n = {}, r = IW(e), i = (n) => (...r) => {
			let i = n.apply(t, r);
			return NW(e), i;
		};
		[
			"append",
			"appendChild",
			"insertAdjacentHTML"
		].forEach((e) => {
			t[e] && (n[e] = t[e], t[e] = i(n[e]));
		}), Object.defineProperty(t, "innerHTML", XR(r, { set: i(r.set) })), t.resetSourceWatch_ = () => {
			t.resetSourceWatch_ = null, Object.keys(n).forEach((e) => {
				t[e] = n[e];
			}), Object.defineProperty(t, "innerHTML", r);
		}, e.one("sourceset", t.resetSourceWatch_);
	}, RW = Object.defineProperty({}, "src", {
		get() {
			return this.hasAttribute("src") ? CH(X.default.Element.prototype.getAttribute.call(this, "src")) : "";
		},
		set(e) {
			return X.default.Element.prototype.setAttribute.call(this, "src", e), e;
		}
	}), zW = (e) => FW([
		e.el(),
		X.default.HTMLMediaElement.prototype,
		RW
	], "src"), BW = function(e) {
		if (!e.featuresSourceset) return;
		let t = e.el();
		if (t.resetSourceset_) return;
		let n = zW(e), r = t.setAttribute, i = t.load;
		Object.defineProperty(t, "src", XR(n, { set: (r) => {
			let i = n.set.call(t, r);
			return e.triggerSourceset(t.src), i;
		} })), t.setAttribute = (n, i) => {
			let a = r.call(t, n, i);
			return /src/i.test(n) && e.triggerSourceset(t.src), a;
		}, t.load = () => {
			let n = i.call(t);
			return NW(e) || (e.triggerSourceset(""), LW(e)), n;
		}, t.currentSrc ? e.triggerSourceset(t.currentSrc) : NW(e) || LW(e), t.resetSourceset_ = () => {
			t.resetSourceset_ = null, t.load = i, t.setAttribute = r, Object.defineProperty(t, "src", n), t.resetSourceWatch_ && t.resetSourceWatch_();
		};
	}, $ = class e extends IH {
		constructor(e, t) {
			super(e, t);
			let n = e.source, r = !1;
			if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", n && (this.el_.currentSrc !== n.src || e.tag && e.tag.initNetworkState_ === 3) ? this.setSource(n) : this.handleLateInit_(this.el_), e.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
				let e = this.el_.childNodes, t = e.length, n = [];
				for (; t--;) {
					let i = e[t];
					i.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(i), this.remoteTextTracks().addTrack(i.track), this.textTracks().addTrack(i.track), !r && !this.el_.hasAttribute("crossorigin") && TH(i.src) && (r = !0)) : n.push(i));
				}
				for (let e = 0; e < n.length; e++) this.el_.removeChild(n[e]);
			}
			this.proxyNativeTracks_(), this.featuresNativeTextTracks && r && UB.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading."), this.restoreMetadataTracksInIOSNativePlayer_(), (pV || lV) && e.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
		}
		dispose() {
			this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), e.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
		}
		setupSourcesetHandling_() {
			BW(this);
		}
		restoreMetadataTracksInIOSNativePlayer_() {
			let e = this.textTracks(), t, n = () => {
				t = [];
				for (let n = 0; n < e.length; n++) {
					let r = e[n];
					r.kind === "metadata" && t.push({
						track: r,
						storedMode: r.mode
					});
				}
			};
			n(), e.addEventListener("change", n), this.on("dispose", () => e.removeEventListener("change", n));
			let r = () => {
				for (let e = 0; e < t.length; e++) {
					let n = t[e];
					n.track.mode === "disabled" && n.track.mode !== n.storedMode && (n.track.mode = n.storedMode);
				}
				e.removeEventListener("change", r);
			};
			this.on("webkitbeginfullscreen", () => {
				e.removeEventListener("change", n), e.removeEventListener("change", r), e.addEventListener("change", r);
			}), this.on("webkitendfullscreen", () => {
				e.removeEventListener("change", n), e.addEventListener("change", n), e.removeEventListener("change", r);
			});
		}
		overrideNative_(e, t) {
			if (t !== this[`featuresNative${e}Tracks`]) return;
			let n = e.toLowerCase();
			this[`${n}TracksListeners_`] && Object.keys(this[`${n}TracksListeners_`]).forEach((e) => {
				this.el()[`${n}Tracks`].removeEventListener(e, this[`${n}TracksListeners_`][e]);
			}), this[`featuresNative${e}Tracks`] = !t, this[`${n}TracksListeners_`] = null, this.proxyNativeTracksForType_(n);
		}
		overrideNativeAudioTracks(e) {
			this.overrideNative_("Audio", e);
		}
		overrideNativeVideoTracks(e) {
			this.overrideNative_("Video", e);
		}
		proxyNativeTracksForType_(e) {
			let t = NH[e], n = this.el()[t.getterName], r = this[t.getterName]();
			if (!this[`featuresNative${t.capitalName}Tracks`] || !n || !n.addEventListener) return;
			let i = {
				change: (t) => {
					let n = {
						type: "change",
						target: r,
						currentTarget: r,
						srcElement: r
					};
					r.trigger(n), e === "text" && this[PH.remoteText.getterName]().trigger(n);
				},
				addtrack(e) {
					r.addTrack(e.track);
				},
				removetrack(e) {
					r.removeTrack(e.track);
				}
			}, a = function() {
				let e = [];
				for (let t = 0; t < r.length; t++) {
					let i = !1;
					for (let e = 0; e < n.length; e++) if (n[e] === r[t]) {
						i = !0;
						break;
					}
					i || e.push(r[t]);
				}
				for (; e.length;) r.removeTrack(e.shift());
			};
			this[t.getterName + "Listeners_"] = i, Object.keys(i).forEach((e) => {
				let t = i[e];
				n.addEventListener(e, t), this.on("dispose", (r) => n.removeEventListener(e, t));
			}), this.on("loadstart", a), this.on("dispose", (e) => this.off("loadstart", a));
		}
		proxyNativeTracks_() {
			NH.names.forEach((e) => {
				this.proxyNativeTracksForType_(e);
			});
		}
		createEl() {
			let t = this.options_.tag;
			if (!t || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
				if (t) {
					let n = t.cloneNode(!0);
					t.parentNode && t.parentNode.insertBefore(n, t), e.disposeMediaElement(t), t = n;
				} else {
					t = Z.default.createElement("video");
					let e = XR({}, this.options_.tag && pz(this.options_.tag));
					(!pV || this.options_.nativeControlsForTouch !== !0) && delete e.controls, fz(t, Object.assign(e, {
						id: this.options_.techId,
						class: "vjs-tech"
					}));
				}
				t.playerId = this.options_.playerId;
			}
			this.options_.preload !== void 0 && hz(t, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (t.disablePictureInPicture = this.options_.disablePictureInPicture);
			let n = [
				"loop",
				"muted",
				"playsinline",
				"autoplay"
			];
			for (let e = 0; e < n.length; e++) {
				let r = n[e], i = this.options_[r];
				i !== void 0 && (i ? hz(t, r, r) : gz(t, r), t[r] = i);
			}
			return t;
		}
		handleLateInit_(e) {
			if (e.networkState === 0 || e.networkState === 3) return;
			if (e.readyState === 0) {
				let e = !1, t = function() {
					e = !0;
				};
				this.on("loadstart", t);
				let n = function() {
					e || this.trigger("loadstart");
				};
				this.on("loadedmetadata", n), this.ready(function() {
					this.off("loadstart", t), this.off("loadedmetadata", n), e || this.trigger("loadstart");
				});
				return;
			}
			let t = ["loadstart"];
			t.push("loadedmetadata"), e.readyState >= 2 && t.push("loadeddata"), e.readyState >= 3 && t.push("canplay"), e.readyState >= 4 && t.push("canplaythrough"), this.ready(function() {
				t.forEach(function(e) {
					this.trigger(e);
				}, this);
			});
		}
		setScrubbing(e) {
			this.isScrubbing_ = e;
		}
		scrubbing() {
			return this.isScrubbing_;
		}
		setCurrentTime(e) {
			try {
				this.isScrubbing_ && this.el_.fastSeek && gV ? this.el_.fastSeek(e) : this.el_.currentTime = e;
			} catch (e) {
				UB(e, "Video is not ready. (Video.js)");
			}
		}
		duration() {
			if (this.el_.duration === Infinity && XB && tV && this.el_.currentTime === 0) {
				let e = () => {
					this.el_.currentTime > 0 && (this.el_.duration === Infinity && this.trigger("durationchange"), this.off("timeupdate", e));
				};
				return this.on("timeupdate", e), NaN;
			}
			return this.el_.duration || NaN;
		}
		width() {
			return this.el_.offsetWidth;
		}
		height() {
			return this.el_.offsetHeight;
		}
		proxyWebkitFullscreen_() {
			if (!("webkitDisplayingFullscreen" in this.el_)) return;
			let e = function() {
				this.trigger("fullscreenchange", { isFullscreen: !1 }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
			}, t = function() {
				"webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", e), this.trigger("fullscreenchange", {
					isFullscreen: !0,
					nativeIOSFullscreen: !0
				}));
			};
			this.on("webkitbeginfullscreen", t), this.on("dispose", () => {
				this.off("webkitbeginfullscreen", t), this.off("webkitendfullscreen", e);
			});
		}
		supportsFullScreen() {
			return typeof this.el_.webkitEnterFullScreen == "function";
		}
		enterFullScreen() {
			let e = this.el_;
			if (e.paused && e.networkState <= e.HAVE_METADATA) $z(this.el_.play()), this.setTimeout(function() {
				e.pause();
				try {
					e.webkitEnterFullScreen();
				} catch (e) {
					this.trigger("fullscreenerror", e);
				}
			}, 0);
			else try {
				e.webkitEnterFullScreen();
			} catch (e) {
				this.trigger("fullscreenerror", e);
			}
		}
		exitFullScreen() {
			if (!this.el_.webkitDisplayingFullscreen) {
				this.trigger("fullscreenerror", /* @__PURE__ */ Error("The video is not fullscreen"));
				return;
			}
			this.el_.webkitExitFullScreen();
		}
		requestPictureInPicture() {
			return this.el_.requestPictureInPicture();
		}
		requestVideoFrameCallback(e) {
			return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(e) : super.requestVideoFrameCallback(e);
		}
		cancelVideoFrameCallback(e) {
			this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(e) : super.cancelVideoFrameCallback(e);
		}
		src(e) {
			if (e === void 0) return this.el_.src;
			this.setSrc(e);
		}
		addSourceElement(e, t) {
			if (!e) return UB.error("Invalid source URL."), !1;
			let n = { src: e };
			t && (n.type = t);
			let r = az("source", {}, n);
			return this.el_.appendChild(r), !0;
		}
		removeSourceElement(e) {
			if (!e) return UB.error("Source URL is required to remove the source element."), !1;
			let t = this.el_.querySelectorAll("source");
			for (let n of t) if (n.src === e) return this.el_.removeChild(n), !0;
			return UB.warn(`No matching source element found with src: ${e}`), !1;
		}
		reset() {
			e.resetMediaElement(this.el_);
		}
		currentSrc() {
			return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
		}
		setControls(e) {
			this.el_.controls = !!e;
		}
		addTextTrack(e, t, n) {
			return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, t, n) : super.addTextTrack(e, t, n);
		}
		createRemoteTextTrack(e) {
			if (!this.featuresNativeTextTracks) return super.createRemoteTextTrack(e);
			let t = Z.default.createElement("track");
			return e.kind && (t.kind = e.kind), e.label && (t.label = e.label), (e.language || e.srclang) && (t.srclang = e.language || e.srclang), e.default && (t.default = e.default), e.id && (t.id = e.id), e.src && (t.src = e.src), t;
		}
		addRemoteTextTrack(e, t) {
			let n = super.addRemoteTextTrack(e, t);
			return this.featuresNativeTextTracks && this.el().appendChild(n), n;
		}
		removeRemoteTextTrack(e) {
			if (super.removeRemoteTextTrack(e), this.featuresNativeTextTracks) {
				let t = this.$$("track"), n = t.length;
				for (; n--;) (e === t[n] || e === t[n].track) && this.el().removeChild(t[n]);
			}
		}
		getVideoPlaybackQuality() {
			if (typeof this.el().getVideoPlaybackQuality == "function") return this.el().getVideoPlaybackQuality();
			let e = {};
			return this.el().webkitDroppedFrameCount !== void 0 && this.el().webkitDecodedFrameCount !== void 0 && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), X.default.performance && (e.creationTime = X.default.performance.now()), e;
		}
	}, QR($, "TEST_VID", function() {
		if (!tz()) return;
		let e = Z.default.createElement("video"), t = Z.default.createElement("track");
		return t.kind = "captions", t.srclang = "en", t.label = "English", e.appendChild(t), e;
	}), $.isSupported = function() {
		try {
			$.TEST_VID.volume = .5;
		} catch {
			return !1;
		}
		return !!($.TEST_VID && $.TEST_VID.canPlayType);
	}, $.canPlayType = function(e) {
		return $.TEST_VID.canPlayType(e);
	}, $.canPlaySource = function(e, t) {
		return $.canPlayType(e.type);
	}, $.canControlVolume = function() {
		try {
			let e = $.TEST_VID.volume;
			$.TEST_VID.volume = e / 2 + .1;
			let t = e !== $.TEST_VID.volume;
			return t && hV ? (X.default.setTimeout(() => {
				$ && $.prototype && ($.prototype.featuresVolumeControl = e !== $.TEST_VID.volume);
			}), !1) : t;
		} catch {
			return !1;
		}
	}, $.canMuteVolume = function() {
		try {
			let e = $.TEST_VID.muted;
			return $.TEST_VID.muted = !e, $.TEST_VID.muted ? hz($.TEST_VID, "muted", "muted") : gz($.TEST_VID, "muted", "muted"), e !== $.TEST_VID.muted;
		} catch {
			return !1;
		}
	}, $.canControlPlaybackRate = function() {
		if (XB && tV && rV < 58) return !1;
		try {
			let e = $.TEST_VID.playbackRate;
			return $.TEST_VID.playbackRate = e / 2 + .1, e !== $.TEST_VID.playbackRate;
		} catch {
			return !1;
		}
	}, $.canOverrideAttributes = function() {
		try {
			let e = () => {};
			Object.defineProperty(Z.default.createElement("video"), "src", {
				get: e,
				set: e
			}), Object.defineProperty(Z.default.createElement("audio"), "src", {
				get: e,
				set: e
			}), Object.defineProperty(Z.default.createElement("video"), "innerHTML", {
				get: e,
				set: e
			}), Object.defineProperty(Z.default.createElement("audio"), "innerHTML", {
				get: e,
				set: e
			});
		} catch {
			return !1;
		}
		return !0;
	}, $.supportsNativeTextTracks = function() {
		return gV || hV && tV;
	}, $.supportsNativeVideoTracks = function() {
		return !!($.TEST_VID && $.TEST_VID.videoTracks);
	}, $.supportsNativeAudioTracks = function() {
		return !!($.TEST_VID && $.TEST_VID.audioTracks);
	}, $.Events = [
		"loadstart",
		"suspend",
		"abort",
		"error",
		"emptied",
		"stalled",
		"loadedmetadata",
		"loadeddata",
		"canplay",
		"canplaythrough",
		"playing",
		"waiting",
		"seeking",
		"seeked",
		"ended",
		"durationchange",
		"timeupdate",
		"progress",
		"play",
		"pause",
		"ratechange",
		"resize",
		"volumechange"
	], [
		["featuresMuteControl", "canMuteVolume"],
		["featuresPlaybackRate", "canControlPlaybackRate"],
		["featuresSourceset", "canOverrideAttributes"],
		["featuresNativeTextTracks", "supportsNativeTextTracks"],
		["featuresNativeVideoTracks", "supportsNativeVideoTracks"],
		["featuresNativeAudioTracks", "supportsNativeAudioTracks"]
	].forEach(function([e, t]) {
		QR($.prototype, e, () => $[t](), !0);
	}), $.prototype.featuresVolumeControl = $.canControlVolume(), $.prototype.movingMediaElementInDOM = !hV, $.prototype.featuresFullscreenResize = !0, $.prototype.featuresProgressEvents = !0, $.prototype.featuresTimeupdateEvents = !0, $.prototype.featuresVideoFrameCallback = !!($.TEST_VID && $.TEST_VID.requestVideoFrameCallback), $.disposeMediaElement = function(e) {
		if (e) {
			for (e.parentNode && e.parentNode.removeChild(e); e.hasChildNodes();) e.removeChild(e.firstChild);
			e.removeAttribute("src"), typeof e.load == "function" && (function() {
				try {
					e.load();
				} catch {}
			})();
		}
	}, $.resetMediaElement = function(e) {
		if (!e) return;
		let t = e.querySelectorAll("source"), n = t.length;
		for (; n--;) e.removeChild(t[n]);
		e.removeAttribute("src"), typeof e.load == "function" && (function() {
			try {
				e.load();
			} catch {}
		})();
	}, [
		"muted",
		"defaultMuted",
		"autoplay",
		"controls",
		"loop",
		"playsinline"
	].forEach(function(e) {
		$.prototype[e] = function() {
			return this.el_[e] || this.el_.hasAttribute(e);
		};
	}), [
		"muted",
		"defaultMuted",
		"autoplay",
		"loop",
		"playsinline"
	].forEach(function(e) {
		$.prototype["set" + ZV(e)] = function(t) {
			this.el_[e] = t, t ? this.el_.setAttribute(e, e) : this.el_.removeAttribute(e);
		};
	}), [
		"paused",
		"currentTime",
		"buffered",
		"volume",
		"poster",
		"preload",
		"error",
		"seeking",
		"seekable",
		"ended",
		"playbackRate",
		"defaultPlaybackRate",
		"disablePictureInPicture",
		"played",
		"networkState",
		"readyState",
		"videoWidth",
		"videoHeight",
		"crossOrigin"
	].forEach(function(e) {
		$.prototype[e] = function() {
			return this.el_[e];
		};
	}), [
		"volume",
		"src",
		"poster",
		"preload",
		"playbackRate",
		"defaultPlaybackRate",
		"disablePictureInPicture",
		"crossOrigin"
	].forEach(function(e) {
		$.prototype["set" + ZV(e)] = function(t) {
			this.el_[e] = t;
		};
	}), [
		"pause",
		"load",
		"play"
	].forEach(function(e) {
		$.prototype[e] = function() {
			return this.el_[e]();
		};
	}), IH.withSourceHandlers($), $.nativeSourceHandler = {}, $.nativeSourceHandler.canPlayType = function(e) {
		try {
			return $.TEST_VID.canPlayType(e);
		} catch {
			return "";
		}
	}, $.nativeSourceHandler.canHandleSource = function(e, t) {
		if (e.type) return $.nativeSourceHandler.canPlayType(e.type);
		if (e.src) {
			let t = wH(e.src);
			return $.nativeSourceHandler.canPlayType(`video/${t}`);
		}
		return "";
	}, $.nativeSourceHandler.handleSource = function(e, t, n) {
		t.setSrc(e.src);
	}, $.nativeSourceHandler.dispose = function() {}, $.registerSourceHandler($.nativeSourceHandler), IH.registerTech("Html5", $), VW = [
		"progress",
		"abort",
		"suspend",
		"emptied",
		"stalled",
		"loadedmetadata",
		"loadeddata",
		"timeupdate",
		"resize",
		"volumechange",
		"texttrackchange"
	], HW = {
		canplay: "CanPlay",
		canplaythrough: "CanPlayThrough",
		playing: "Playing",
		seeked: "Seeked"
	}, UW = [
		"tiny",
		"xsmall",
		"small",
		"medium",
		"large",
		"xlarge",
		"huge"
	], WW = {}, UW.forEach((e) => {
		let t = e.charAt(0) === "x" ? `x-${e.substring(1)}` : e;
		WW[e] = `vjs-layout-${t}`;
	}), GW = {
		tiny: 210,
		xsmall: 320,
		small: 425,
		medium: 768,
		large: 1440,
		xlarge: 2560,
		huge: Infinity
	}, KW = class e extends Q {
		constructor(t, n, r) {
			if (t.id = t.id || n.id || `vjs_video_${Mz()}`, n = Object.assign(e.getTagSettings(t), n), n.initChildren = !1, n.createEl = !1, n.evented = !1, n.reportTouchActivity = !1, !n.language) {
				let e = t.closest("[lang]");
				e && (n.language = e.getAttribute("lang"));
			}
			if (super(null, n, r), this.boundDocumentFullscreenChange_ = (e) => this.documentFullscreenChange_(e), this.boundFullWindowOnEscKey_ = (e) => this.fullWindowOnEscKey(e), this.boundUpdateStyleEl_ = (e) => this.updateStyleEl_(e), this.boundApplyInitTime_ = (e) => this.applyInitTime_(e), this.boundUpdateCurrentBreakpoint_ = (e) => this.updateCurrentBreakpoint_(e), this.boundHandleTechClick_ = (e) => this.handleTechClick_(e), this.boundHandleTechDoubleClick_ = (e) => this.handleTechDoubleClick_(e), this.boundHandleTechTouchStart_ = (e) => this.handleTechTouchStart_(e), this.boundHandleTechTouchMove_ = (e) => this.handleTechTouchMove_(e), this.boundHandleTechTouchEnd_ = (e) => this.handleTechTouchEnd_(e), this.boundHandleTechTap_ = (e) => this.handleTechTap_(e), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (e) => this.updatePlayerHeightOnAudioOnlyMode_(e), this.isFullscreen_ = !1, this.log = WB(this.id_), this.fsApi_ = LB, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
				controlBarHeight: null,
				playerHeight: null,
				hiddenChildren: []
			}, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length) throw Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
			if (this.tag = t, this.tagAttributes = t && pz(t), this.language(this.options_.language), n.languages) {
				let e = {};
				Object.getOwnPropertyNames(n.languages).forEach(function(t) {
					e[t.toLowerCase()] = n.languages[t];
				}), this.languages_ = e;
			} else this.languages_ = e.prototype.options_.languages;
			this.resetCache_(), this.poster_ = n.poster || "", this.controls_ = !!n.controls, t.controls = !1, t.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], t.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), n.plugins && Object.keys(n.plugins).forEach((e) => {
				if (typeof this[e] != "function") throw Error(`plugin "${e}" does not exist`);
			}), this.scrubbing_ = !1, this.el_ = this.createEl(), Vz(this, { eventBusKey: "el_" }), this.fsApi_.requestFullscreen && (Iz(Z.default, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
			let i = XR(this.options_);
			if (n.plugins && Object.keys(n.plugins).forEach((e) => {
				this[e](n.plugins[e]);
			}), n.debug && this.debug(!0), this.options_.playerOptions = i, this.middleware_ = [], this.playbackRates(n.playbackRates), n.experimentalSvgIcons) {
				let e = new X.default.DOMParser().parseFromString(qH, "image/svg+xml");
				if (e.querySelector("parsererror")) UB.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
				else {
					let t = e.documentElement;
					t.style.display = "none", this.el_.appendChild(t), this.addClass("vjs-svg-icons-enabled");
				}
			}
			this.initChildren(), this.isAudio(t.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), n.spatialNavigation && n.spatialNavigation.enabled && (this.spatialNavigation = new ZH(this), this.addClass("vjs-spatial-navigation-enabled")), pV && this.addClass("vjs-touch-enabled"), hV || this.addClass("vjs-workinghover"), e.players[this.id_] = this;
			let a = jB.split(".")[0];
			this.addClass(`vjs-v${a}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (e) => this.listenForUserActivity_(e)), this.on("keydown", (e) => this.handleKeyDown(e)), this.on("languagechange", (e) => this.handleLanguagechange(e)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
				this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
			});
		}
		dispose() {
			this.trigger("dispose"), this.off("dispose"), Lz(Z.default, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Lz(Z.default, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), e.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ &&= null, this.tag &&= null, lB(this), FH.names.forEach((e) => {
				let t = FH[e], n = this[t.getterName]();
				n && n.off && n.off();
			}), super.dispose({ restoreEl: this.options_.restoreEl });
		}
		createEl() {
			let e = this.tag, t, n = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player"), r = this.tag.tagName.toLowerCase() === "video-js";
			n ? t = this.el_ = e.parentNode : r || (t = this.el_ = super.createEl("div"));
			let i = pz(e);
			if (r) {
				for (t = this.el_ = e, e = this.tag = Z.default.createElement("video"); t.children.length;) e.appendChild(t.firstChild);
				cz(t, "video-js") || lz(t, "video-js"), t.appendChild(e), n = this.playerElIngest_ = t, Object.keys(t).forEach((n) => {
					try {
						e[n] = t[n];
					} catch {}
				});
			}
			e.setAttribute("tabindex", "-1"), i.tabindex = "-1", tV && sV && (e.setAttribute("role", "application"), i.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in i && delete i.width, "height" in i && delete i.height, Object.getOwnPropertyNames(i).forEach(function(n) {
				r && n === "class" || t.setAttribute(n, i[n]), r && e.setAttribute(n, i[n]);
			}), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = t.player = this, this.addClass("vjs-paused");
			let a = [
				"IS_SMART_TV",
				"IS_TIZEN",
				"IS_WEBOS",
				"IS_ANDROID",
				"IS_IPAD",
				"IS_IPHONE",
				"IS_CHROMECAST_RECEIVER"
			].filter((e) => _V[e]).map((e) => "vjs-device-" + e.substring(3).toLowerCase().replace(/\_/g, "-"));
			if (this.addClass(...a), X.default.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
				this.styleEl_ = wV("vjs-styles-dimensions");
				let e = vV(".vjs-styles-defaults"), t = vV("head");
				t.insertBefore(this.styleEl_, e ? e.nextSibling : t.firstChild);
			}
			this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
			let o = e.getElementsByTagName("a");
			for (let e = 0; e < o.length; e++) {
				let t = o.item(e);
				lz(t, "vjs-hidden"), t.setAttribute("hidden", "hidden");
			}
			return e.initNetworkState_ = e.networkState, e.parentNode && !n && e.parentNode.insertBefore(t, e), sz(e, t), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = t, t;
		}
		crossOrigin(e) {
			if (e === void 0) return this.techGet_("crossOrigin");
			if (e !== null && e !== "anonymous" && e !== "use-credentials") {
				UB.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
				return;
			}
			this.techCall_("setCrossOrigin", e), this.posterImage && this.posterImage.crossOrigin(e);
		}
		width(e) {
			return this.dimension("width", e);
		}
		height(e) {
			return this.dimension("height", e);
		}
		dimension(e, t) {
			let n = e + "_";
			if (t === void 0) return this[n] || 0;
			if (t === "" || t === "auto") {
				this[n] = void 0, this.updateStyleEl_();
				return;
			}
			let r = parseFloat(t);
			if (isNaN(r)) {
				UB.error(`Improper value "${t}" supplied for for ${e}`);
				return;
			}
			this[n] = r, this.updateStyleEl_();
		}
		fluid(e) {
			if (e === void 0) return !!this.fluid_;
			this.fluid_ = !!e, BV(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), VV(this, () => {
				this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
			})) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
		}
		fill(e) {
			if (e === void 0) return !!this.fill_;
			this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
		}
		aspectRatio(e) {
			if (e === void 0) return this.aspectRatio_;
			if (!/^\d+\:\d+$/.test(e)) throw Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
			this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
		}
		updateStyleEl_() {
			if (X.default.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
				let e = typeof this.width_ == "number" ? this.width_ : this.options_.width, t = typeof this.height_ == "number" ? this.height_ : this.options_.height, n = this.tech_ && this.tech_.el();
				n && (e >= 0 && (n.width = e), t >= 0 && (n.height = t));
				return;
			}
			let e, t, n, r;
			n = this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? this.aspectRatio_ : this.videoWidth() > 0 ? this.videoWidth() + ":" + this.videoHeight() : "16:9";
			let i = n.split(":"), a = i[1] / i[0];
			e = this.width_ === void 0 ? this.height_ === void 0 ? this.videoWidth() || 300 : this.height_ / a : this.width_, t = this.height_ === void 0 ? e * a : this.height_, r = /^[^a-zA-Z]/.test(this.id()) ? "dimensions-" + this.id() : this.id() + "-dimensions", this.addClass(r), TV(this.styleEl_, `
      .${r} {
        width: ${e}px;
        height: ${t}px;
      }

      .${r}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${a * 100}%;
      }
    `);
		}
		loadTech_(e, t) {
			this.tech_ && this.unloadTech_();
			let n = ZV(e), r = e.charAt(0).toLowerCase() + e.slice(1);
			n !== "Html5" && this.tag && (IH.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = n, this.isReady_ = !1;
			let i = this.autoplay();
			(typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (i = !1);
			let a = {
				source: t,
				autoplay: i,
				nativeControlsForTouch: this.options_.nativeControlsForTouch,
				playerId: this.id(),
				techId: `${this.id()}_${r}_api`,
				playsinline: this.options_.playsinline,
				preload: this.options_.preload,
				loop: this.options_.loop,
				disablePictureInPicture: this.options_.disablePictureInPicture,
				muted: this.options_.muted,
				poster: this.poster(),
				language: this.language(),
				playerElIngest: this.playerElIngest_ || !1,
				"vtt.js": this.options_["vtt.js"],
				canOverridePoster: !!this.options_.techCanOverridePoster,
				enableSourceset: this.options_.enableSourceset
			};
			FH.names.forEach((e) => {
				let t = FH[e];
				a[t.getterName] = this[t.privateName];
			}), Object.assign(a, this.options_[n]), Object.assign(a, this.options_[r]), Object.assign(a, this.options_[e.toLowerCase()]), this.tag && (a.tag = this.tag), t && t.src === this.cache_.src && this.cache_.currentTime > 0 && (a.startTime = this.cache_.currentTime);
			let o = IH.getTech(e);
			if (!o) throw Error(`No Tech named '${n}' exists! '${n}' should be registered using videojs.registerTech()'`);
			this.tech_ = new o(a), this.tech_.ready(NV(this, this.handleTechReady_), !0), oH.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), VW.forEach((e) => {
				this.on(this.tech_, e, (t) => this[`handleTech${ZV(e)}_`](t));
			}), Object.keys(HW).forEach((e) => {
				this.on(this.tech_, e, (t) => {
					if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
						this.queuedCallbacks_.push({
							callback: this[`handleTech${HW[e]}_`].bind(this),
							event: t
						});
						return;
					}
					this[`handleTech${HW[e]}_`](t);
				});
			}), this.on(this.tech_, "loadstart", (e) => this.handleTechLoadStart_(e)), this.on(this.tech_, "sourceset", (e) => this.handleTechSourceset_(e)), this.on(this.tech_, "waiting", (e) => this.handleTechWaiting_(e)), this.on(this.tech_, "ended", (e) => this.handleTechEnded_(e)), this.on(this.tech_, "seeking", (e) => this.handleTechSeeking_(e)), this.on(this.tech_, "play", (e) => this.handleTechPlay_(e)), this.on(this.tech_, "pause", (e) => this.handleTechPause_(e)), this.on(this.tech_, "durationchange", (e) => this.handleTechDurationChange_(e)), this.on(this.tech_, "fullscreenchange", (e, t) => this.handleTechFullscreenChange_(e, t)), this.on(this.tech_, "fullscreenerror", (e, t) => this.handleTechFullscreenError_(e, t)), this.on(this.tech_, "enterpictureinpicture", (e) => this.handleTechEnterPictureInPicture_(e)), this.on(this.tech_, "leavepictureinpicture", (e) => this.handleTechLeavePictureInPicture_(e)), this.on(this.tech_, "error", (e) => this.handleTechError_(e)), this.on(this.tech_, "posterchange", (e) => this.handleTechPosterChange_(e)), this.on(this.tech_, "textdata", (e) => this.handleTechTextData_(e)), this.on(this.tech_, "ratechange", (e) => this.handleTechRateChange_(e)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (n !== "Html5" || !this.tag) && sz(this.tech_.el(), this.el()), this.tag &&= (this.tag.player = null, null);
		}
		unloadTech_() {
			FH.names.forEach((e) => {
				let t = FH[e];
				this[t.privateName] = this[t.getterName]();
			}), this.textTracksJson_ = oH.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
		}
		tech(e) {
			return e === void 0 && UB.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n"), this.tech_;
		}
		version() {
			return { "video.js": jB };
		}
		addTechControlsListeners_() {
			this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
		}
		removeTechControlsListeners_() {
			this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
		}
		handleTechReady_() {
			this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
		}
		handleTechLoadStart_() {
			this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() && this.hasStarted(!1), this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
		}
		manualAutoplay_(e) {
			if (!this.tech_ || typeof e != "string") return;
			let t = () => {
				let e = this.muted();
				this.muted(!0);
				let t = () => {
					this.muted(e);
				};
				this.playTerminatedQueue_.push(t);
				let n = this.play();
				if (Qz(n)) return n.catch((e) => {
					throw t(), Error(`Rejection at manualAutoplay. Restoring muted value. ${e || ""}`);
				});
			}, n;
			if (e === "any" && !this.muted() ? (n = this.play(), Qz(n) && (n = n.catch(t))) : n = e === "muted" && !this.muted() ? t() : this.play(), Qz(n)) return n.then(() => {
				this.trigger({
					type: "autoplay-success",
					autoplay: e
				});
			}).catch(() => {
				this.trigger({
					type: "autoplay-failure",
					autoplay: e
				});
			});
		}
		updateSourceCaches_(e = "") {
			let t = e, n = "";
			typeof t != "string" && (t = e.src, n = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], t && !n && (n = GH(this, t)), this.cache_.source = XR({}, e, {
				src: t,
				type: n
			});
			let r = this.cache_.sources.filter((e) => e.src && e.src === t), i = [], a = this.$$("source"), o = [];
			for (let e = 0; e < a.length; e++) {
				let n = pz(a[e]);
				i.push(n), n.src && n.src === t && o.push(n.src);
			}
			o.length && !r.length ? this.cache_.sources = i : r.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = t;
		}
		handleTechSourceset_(e) {
			if (!this.changingSrc_) {
				let t = (e) => this.updateSourceCaches_(e), n = this.currentSource().src, r = e.src;
				n && !/^blob:/.test(n) && /^blob:/.test(r) && (!this.lastSource_ || this.lastSource_.tech !== r && this.lastSource_.player !== n) && (t = () => {}), t(r), e.src || this.tech_.any(["sourceset", "loadstart"], (e) => {
					if (e.type === "sourceset") return;
					let t = this.techGet_("currentSrc");
					this.lastSource_.tech = t, this.updateSourceCaches_(t);
				});
			}
			this.lastSource_ = {
				player: this.currentSource().src,
				tech: e.src
			}, this.trigger({
				src: e.src,
				type: "sourceset"
			});
		}
		hasStarted(e) {
			if (e === void 0) return this.hasStarted_;
			e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
		}
		handleTechPlay_() {
			this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
		}
		handleTechRateChange_() {
			this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((e) => e.callback(e.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
		}
		handleTechWaiting_() {
			this.addClass("vjs-waiting"), this.trigger("waiting");
			let e = this.currentTime(), t = () => {
				e !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", t));
			};
			this.on("timeupdate", t);
		}
		handleTechCanPlay_() {
			this.removeClass("vjs-waiting"), this.trigger("canplay");
		}
		handleTechCanPlayThrough_() {
			this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
		}
		handleTechPlaying_() {
			this.removeClass("vjs-waiting"), this.trigger("playing");
		}
		handleTechSeeking_() {
			this.addClass("vjs-seeking"), this.trigger("seeking");
		}
		handleTechSeeked_() {
			this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
		}
		handleTechPause_() {
			this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
		}
		handleTechEnded_() {
			this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
		}
		handleTechDurationChange_() {
			this.duration(this.techGet_("duration"));
		}
		handleTechClick_(e) {
			this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? $z(this.play()) : this.pause());
		}
		handleTechDoubleClick_(e) {
			this.controls_ && (Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (t) => t.contains(e.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isInPictureInPicture() && !Z.default.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen()));
		}
		handleTechTap_() {
			this.userActive(!this.userActive());
		}
		handleTechTouchStart_() {
			this.userWasActive = this.userActive();
		}
		handleTechTouchMove_() {
			this.userWasActive && this.reportUserActivity();
		}
		handleTechTouchEnd_(e) {
			e.cancelable && e.preventDefault();
		}
		toggleFullscreenClass_() {
			this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
		}
		documentFullscreenChange_(e) {
			let t = e.target.player;
			if (t && t !== this) return;
			let n = this.el(), r = Z.default[this.fsApi_.fullscreenElement] === n;
			!r && n.matches && (r = n.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(r);
		}
		handleTechFullscreenChange_(e, t) {
			t && (t.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
				this.removeClass("vjs-ios-native-fs");
			})), this.isFullscreen(t.isFullscreen));
		}
		handleTechFullscreenError_(e, t) {
			this.trigger("fullscreenerror", t);
		}
		togglePictureInPictureClass_() {
			this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
		}
		handleTechEnterPictureInPicture_(e) {
			this.isInPictureInPicture(!0);
		}
		handleTechLeavePictureInPicture_(e) {
			this.isInPictureInPicture(!1);
		}
		handleTechError_() {
			let e = this.tech_.error();
			e && this.error(e);
		}
		handleTechTextData_() {
			let e = null;
			arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
		}
		getCache() {
			return this.cache_;
		}
		resetCache_() {
			this.cache_ = {
				currentTime: 0,
				initTime: 0,
				inactivityTimeout: this.options_.inactivityTimeout,
				duration: NaN,
				lastVolume: 1,
				lastPlaybackRate: this.defaultPlaybackRate(),
				media: null,
				src: "",
				source: {},
				sources: [],
				playbackRates: [],
				volume: 1
			};
		}
		techCall_(e, t) {
			this.ready(function() {
				if (e in VH) return aB(this.middleware_, this.tech_, e, t);
				if (e in HH) return oB(this.middleware_, this.tech_, e, t);
				try {
					this.tech_ && this.tech_[e](t);
				} catch (e) {
					throw UB(e), e;
				}
			}, !0);
		}
		techGet_(e) {
			if (!(!this.tech_ || !this.tech_.isReady_)) {
				if (e in BH) return iB(this.middleware_, this.tech_, e);
				if (e in HH) return oB(this.middleware_, this.tech_, e);
				try {
					return this.tech_[e]();
				} catch (t) {
					throw this.tech_[e] === void 0 ? (UB(`Video.js: ${e} method not defined for ${this.techName_} playback technology.`, t), t) : t.name === "TypeError" ? (UB(`Video.js: ${e} unavailable on ${this.techName_} playback technology element.`, t), this.tech_.isReady_ = !1, t) : (UB(t), t);
				}
			}
		}
		play() {
			return new Promise((e) => {
				this.play_(e);
			});
		}
		play_(e = $z) {
			this.playCallbacks_.push(e);
			let t = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), n = !!(gV || hV);
			if (this.waitToPlay_ &&= (this.off(["ready", "loadstart"], this.waitToPlay_), null), !this.isReady_ || !t) {
				this.waitToPlay_ = (e) => {
					this.play_();
				}, this.one(["ready", "loadstart"], this.waitToPlay_), !t && n && this.load();
				return;
			}
			let r = this.techGet_("play");
			n && this.hasClass("vjs-ended") && this.resetProgressBar_(), r === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(r);
		}
		runPlayTerminatedQueue_() {
			let e = this.playTerminatedQueue_.slice(0);
			this.playTerminatedQueue_ = [], e.forEach(function(e) {
				e();
			});
		}
		runPlayCallbacks_(e) {
			let t = this.playCallbacks_.slice(0);
			this.playCallbacks_ = [], this.playTerminatedQueue_ = [], t.forEach(function(t) {
				t(e);
			});
		}
		pause() {
			this.techCall_("pause");
		}
		paused() {
			return this.techGet_("paused") !== !1;
		}
		played() {
			return this.techGet_("played") || Kz(0, 0);
		}
		scrubbing(e) {
			if (e === void 0) return this.scrubbing_;
			this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
		}
		currentTime(e) {
			if (e === void 0) return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
			if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
				this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
				return;
			}
			this.techCall_("setCurrentTime", e), this.cache_.initTime = 0, isFinite(e) && (this.cache_.currentTime = Number(e));
		}
		applyInitTime_() {
			this.currentTime(this.cache_.initTime);
		}
		duration(e) {
			if (e === void 0) return this.cache_.duration === void 0 ? NaN : this.cache_.duration;
			e = parseFloat(e), e < 0 && (e = Infinity), e !== this.cache_.duration && (this.cache_.duration = e, e === Infinity ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
		}
		remainingTime() {
			return this.duration() - this.currentTime();
		}
		remainingTimeDisplay() {
			return Math.floor(this.duration()) - Math.floor(this.currentTime());
		}
		buffered() {
			let e = this.techGet_("buffered");
			return (!e || !e.length) && (e = Kz(0, 0)), e;
		}
		seekable() {
			let e = this.techGet_("seekable");
			return (!e || !e.length) && (e = Kz(0, 0)), e;
		}
		seeking() {
			return this.techGet_("seeking");
		}
		ended() {
			return this.techGet_("ended");
		}
		networkState() {
			return this.techGet_("networkState");
		}
		readyState() {
			return this.techGet_("readyState");
		}
		bufferedPercent() {
			return Xz(this.buffered(), this.duration());
		}
		bufferedEnd() {
			let e = this.buffered(), t = this.duration(), n = e.end(e.length - 1);
			return n > t && (n = t), n;
		}
		volume(e) {
			let t;
			if (e !== void 0) {
				t = Math.max(0, Math.min(1, e)), this.cache_.volume = t, this.techCall_("setVolume", t), t > 0 && this.lastVolume_(t);
				return;
			}
			return t = parseFloat(this.techGet_("volume")), isNaN(t) ? 1 : t;
		}
		muted(e) {
			if (e !== void 0) {
				this.techCall_("setMuted", e);
				return;
			}
			return this.techGet_("muted") || !1;
		}
		defaultMuted(e) {
			return e !== void 0 && this.techCall_("setDefaultMuted", e), this.techGet_("defaultMuted") || !1;
		}
		lastVolume_(e) {
			if (e !== void 0 && e !== 0) {
				this.cache_.lastVolume = e;
				return;
			}
			return this.cache_.lastVolume;
		}
		supportsFullScreen() {
			return this.techGet_("supportsFullScreen") || !1;
		}
		isFullscreen(e) {
			if (e !== void 0) {
				let t = this.isFullscreen_;
				this.isFullscreen_ = !!e, this.isFullscreen_ !== t && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
				return;
			}
			return this.isFullscreen_;
		}
		requestFullscreen(e) {
			this.isInPictureInPicture() && this.exitPictureInPicture();
			let t = this;
			return new Promise((n, r) => {
				function i() {
					t.off("fullscreenerror", o), t.off("fullscreenchange", a);
				}
				function a() {
					i(), n();
				}
				function o(e, t) {
					i(), r(t);
				}
				t.one("fullscreenchange", a), t.one("fullscreenerror", o);
				let s = t.requestFullscreenHelper_(e);
				s && (s.then(i, i), s.then(n, r));
			});
		}
		requestFullscreenHelper_(e) {
			let t;
			if (this.fsApi_.prefixed || (t = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (t = e)), this.fsApi_.requestFullscreen) {
				let e = this.el_[this.fsApi_.requestFullscreen](t);
				return e && e.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), e;
			}
			this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
		}
		exitFullscreen() {
			let e = this;
			return new Promise((t, n) => {
				function r() {
					e.off("fullscreenerror", a), e.off("fullscreenchange", i);
				}
				function i() {
					r(), t();
				}
				function a(e, t) {
					r(), n(t);
				}
				e.one("fullscreenchange", i), e.one("fullscreenerror", a);
				let o = e.exitFullscreenHelper_();
				o && (o.then(r, r), o.then(t, n));
			});
		}
		exitFullscreenHelper_() {
			if (this.fsApi_.requestFullscreen) {
				let e = Z.default[this.fsApi_.exitFullscreen]();
				return e && $z(e.then(() => this.isFullscreen(!1))), e;
			}
			this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
		}
		enterFullWindow() {
			this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = Z.default.documentElement.style.overflow, Iz(Z.default, "keydown", this.boundFullWindowOnEscKey_), Z.default.documentElement.style.overflow = "hidden", lz(Z.default.body, "vjs-full-window"), this.trigger("enterFullWindow");
		}
		fullWindowOnEscKey(e) {
			e.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
		}
		exitFullWindow() {
			this.isFullscreen(!1), this.isFullWindow = !1, Lz(Z.default, "keydown", this.boundFullWindowOnEscKey_), Z.default.documentElement.style.overflow = this.docOrigOverflow, uz(Z.default.body, "vjs-full-window"), this.trigger("exitFullWindow");
		}
		disablePictureInPicture(e) {
			if (e === void 0) return this.techGet_("disablePictureInPicture");
			this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
		}
		isInPictureInPicture(e) {
			if (e !== void 0) {
				this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
				return;
			}
			return !!this.isInPictureInPicture_;
		}
		requestPictureInPicture() {
			if (this.options_.enableDocumentPictureInPicture && X.default.documentPictureInPicture) {
				let e = Z.default.createElement(this.el().tagName);
				return e.classList = this.el().classList, e.classList.add("vjs-pip-container"), this.posterImage && e.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && e.appendChild(this.titleBar.el().cloneNode(!0)), e.appendChild(az("p", { className: "vjs-pip-text" }, {}, this.localize("Playing in picture-in-picture"))), X.default.documentPictureInPicture.requestWindow({
					width: this.videoWidth(),
					height: this.videoHeight()
				}).then((t) => (kz(t), this.el_.parentNode.insertBefore(e, this.el_), t.document.body.appendChild(this.el_), t.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
					type: "enterpictureinpicture",
					pipWindow: t
				}), t.addEventListener("pagehide", (t) => {
					let n = t.target.querySelector(".video-js");
					e.parentNode.replaceChild(n, e), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
				}), t));
			}
			return "pictureInPictureEnabled" in Z.default && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
		}
		exitPictureInPicture() {
			if (X.default.documentPictureInPicture && X.default.documentPictureInPicture.window) return X.default.documentPictureInPicture.window.close(), Promise.resolve();
			if ("pictureInPictureEnabled" in Z.default) return Z.default.exitPictureInPicture();
		}
		handleKeyDown(e) {
			let { userActions: t } = this.options_;
			!t || !t.hotkeys || ((e) => {
				let t = e.tagName.toLowerCase();
				return e.isContentEditable ? !0 : t === "input" ? [
					"button",
					"checkbox",
					"hidden",
					"radio",
					"reset",
					"submit"
				].indexOf(e.type) === -1 : ["textarea"].indexOf(t) !== -1;
			})(this.el_.ownerDocument.activeElement) || (typeof t.hotkeys == "function" ? t.hotkeys.call(this, e) : this.handleHotkeys(e));
		}
		handleHotkeys(e) {
			let { fullscreenKey: t = (t) => e.key.toLowerCase() === "f", muteKey: n = (t) => e.key.toLowerCase() === "m", playPauseKey: r = (t) => e.key.toLowerCase() === "k" || e.key.toLowerCase() === " " } = this.options_.userActions ? this.options_.userActions.hotkeys : {};
			if (t.call(this, e)) {
				e.preventDefault(), e.stopPropagation();
				let t = Q.getComponent("FullscreenToggle");
				Z.default[this.fsApi_.fullscreenEnabled] !== !1 && t.prototype.handleClick.call(this, e);
			} else n.call(this, e) ? (e.preventDefault(), e.stopPropagation(), Q.getComponent("MuteToggle").prototype.handleClick.call(this, e)) : r.call(this, e) && (e.preventDefault(), e.stopPropagation(), Q.getComponent("PlayToggle").prototype.handleClick.call(this, e));
		}
		canPlayType(e) {
			let t;
			for (let n = 0, r = this.options_.techOrder; n < r.length; n++) {
				let i = r[n], a = IH.getTech(i);
				if (a ||= Q.getComponent(i), !a) {
					UB.error(`The "${i}" tech is undefined. Skipped browser support check for that tech.`);
					continue;
				}
				if (a.isSupported() && (t = a.canPlayType(e), t)) return t;
			}
			return "";
		}
		selectSource(e) {
			let t = this.options_.techOrder.map((e) => [e, IH.getTech(e)]).filter(([e, t]) => t ? t.isSupported() : (UB.error(`The "${e}" tech is undefined. Skipped browser support check for that tech.`), !1)), n = function(e, t, n) {
				let r;
				return e.some((e) => t.some((t) => {
					if (r = n(e, t), r) return !0;
				})), r;
			}, r, i = (e) => (t, n) => e(n, t), a = ([e, t], n) => {
				if (t.canPlaySource(n, this.options_[e.toLowerCase()])) return {
					source: n,
					tech: e
				};
			};
			return r = this.options_.sourceOrder ? n(e, t, i(a)) : n(t, e, a), r || !1;
		}
		handleSrc_(e, t) {
			if (e === void 0) return this.cache_.src || "";
			this.resetRetryOnError_ && this.resetRetryOnError_();
			let n = KH(e);
			if (!n.length) {
				this.setTimeout(function() {
					this.error({
						code: 4,
						message: this.options_.notSupportedMessage
					});
				}, 0);
				return;
			}
			if (this.changingSrc_ = !0, t || (this.cache_.sources = n), this.updateSourceCaches_(n[0]), nB(this, n[0], (e, r) => {
				if (this.middleware_ = r, t || (this.cache_.sources = n), this.updateSourceCaches_(e), this.src_(e)) {
					if (n.length > 1) return this.handleSrc_(n.slice(1));
					this.changingSrc_ = !1, this.setTimeout(function() {
						this.error({
							code: 4,
							message: this.options_.notSupportedMessage
						});
					}, 0), this.triggerReady();
					return;
				}
				rB(r, this.tech_);
			}), n.length > 1) {
				let e = () => {
					this.error(null), this.handleSrc_(n.slice(1), !0);
				}, t = () => {
					this.off("error", e);
				};
				this.one("error", e), this.one("playing", t), this.resetRetryOnError_ = () => {
					this.off("error", e), this.off("playing", t);
				};
			}
		}
		src(e) {
			return this.handleSrc_(e, !1);
		}
		src_(e) {
			let t = this.selectSource([e]);
			return t ? QV(t.tech, this.techName_) ? (this.ready(function() {
				this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
			}, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(t.tech, t.source), this.tech_.ready(() => {
				this.changingSrc_ = !1;
			}), !1) : !0;
		}
		addSourceElement(e, t) {
			return this.tech_ ? this.tech_.addSourceElement(e, t) : !1;
		}
		removeSourceElement(e) {
			return this.tech_ ? this.tech_.removeSourceElement(e) : !1;
		}
		load() {
			if (this.tech_ && this.tech_.vhs) {
				this.src(this.currentSource());
				return;
			}
			this.techCall_("load");
		}
		reset() {
			this.paused() ? this.doReset_() : $z(this.play().then(() => this.doReset_()));
		}
		doReset_() {
			this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
				title: void 0,
				description: void 0
			}), BV(this) && this.trigger("playerreset");
		}
		resetControlBarUI_() {
			this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
		}
		resetProgressBar_() {
			this.currentTime(0);
			let { currentTimeDisplay: e, durationDisplay: t, progressControl: n, remainingTimeDisplay: r } = this.controlBar || {}, { seekBar: i } = n || {};
			e && e.updateContent(), t && t.updateContent(), r && r.updateContent(), i && (i.update(), i.loadProgressBar && i.loadProgressBar.update());
		}
		resetPlaybackRate_() {
			this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
		}
		resetVolumeBar_() {
			this.volume(1), this.trigger("volumechange");
		}
		currentSources() {
			let e = this.currentSource(), t = [];
			return Object.keys(e).length !== 0 && t.push(e), this.cache_.sources || t;
		}
		currentSource() {
			return this.cache_.source || {};
		}
		currentSrc() {
			return this.currentSource() && this.currentSource().src || "";
		}
		currentType() {
			return this.currentSource() && this.currentSource().type || "";
		}
		preload(e) {
			if (e !== void 0) {
				this.techCall_("setPreload", e), this.options_.preload = e;
				return;
			}
			return this.techGet_("preload");
		}
		autoplay(e) {
			if (e === void 0) return this.options_.autoplay || !1;
			let t;
			typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), t = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, t = t === void 0 ? this.options_.autoplay : t, this.tech_ && this.techCall_("setAutoplay", t);
		}
		playsinline(e) {
			return e !== void 0 && (this.techCall_("setPlaysinline", e), this.options_.playsinline = e), this.techGet_("playsinline");
		}
		loop(e) {
			if (e !== void 0) {
				this.techCall_("setLoop", e), this.options_.loop = e;
				return;
			}
			return this.techGet_("loop");
		}
		poster(e) {
			if (e === void 0) return this.poster_;
			e ||= "", e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
		}
		handleTechPosterChange_() {
			if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
				let e = this.tech_.poster() || "";
				e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
			}
		}
		controls(e) {
			if (e === void 0) return !!this.controls_;
			e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
		}
		usingNativeControls(e) {
			if (e === void 0) return !!this.usingNativeControls_;
			e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
		}
		error(e) {
			if (e === void 0) return this.error_ || null;
			if (NB("beforeerror").forEach((t) => {
				let n = t(this, e);
				if (!(JR(n) && !Array.isArray(n) || typeof n == "string" || typeof n == "number" || n === null)) {
					this.log.error("please return a value that MediaError expects in beforeerror hooks");
					return;
				}
				e = n;
			}), this.options_.suppressNotSupportedError && e && e.code === 4) {
				let t = function() {
					this.error(e);
				};
				this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], t), this.one("loadstart", function() {
					this.off(["click", "touchstart"], t);
				});
				return;
			}
			if (e === null) {
				this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
				return;
			}
			this.error_ = new Zz(e), this.addClass("vjs-error"), UB.error(`(CODE:${this.error_.code} ${Zz.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), NB("error").forEach((e) => e(this, this.error_));
		}
		reportUserActivity(e) {
			this.userActivity_ = !0;
		}
		userActive(e) {
			if (e === void 0) return this.userActive_;
			if (e = !!e, e !== this.userActive_) {
				if (this.userActive_ = e, this.userActive_) {
					this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
					return;
				}
				this.tech_ && this.tech_.one("mousemove", function(e) {
					e.stopPropagation(), e.preventDefault();
				}), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
			}
		}
		listenForUserActivity_() {
			let e, t, n, r = NV(this, this.reportUserActivity), i = function(e) {
				(e.screenX !== t || e.screenY !== n) && (t = e.screenX, n = e.screenY, r());
			}, a = function() {
				r(), this.clearInterval(e), e = this.setInterval(r, 250);
			}, o = function(t) {
				r(), this.clearInterval(e);
			};
			this.on("mousedown", a), this.on("mousemove", i), this.on("mouseup", o), this.on("mouseleave", o);
			let s = this.getChild("controlBar");
			s && !hV && !XB && (s.on("mouseenter", function(e) {
				this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
			}), s.on("mouseleave", function(e) {
				this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
			})), this.on("keydown", r), this.on("keyup", r);
			let c;
			this.setInterval(function() {
				if (!this.userActivity_) return;
				this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(c);
				let e = this.options_.inactivityTimeout;
				e <= 0 || (c = this.setTimeout(function() {
					this.userActivity_ || this.userActive(!1);
				}, e));
			}, 250);
		}
		playbackRate(e) {
			if (e !== void 0) {
				this.techCall_("setPlaybackRate", e);
				return;
			}
			return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
		}
		defaultPlaybackRate(e) {
			return e === void 0 ? this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1 : this.techCall_("setDefaultPlaybackRate", e);
		}
		isAudio(e) {
			if (e !== void 0) {
				this.isAudio_ = !!e;
				return;
			}
			return !!this.isAudio_;
		}
		updatePlayerHeightOnAudioOnlyMode_() {
			let e = this.getChild("ControlBar");
			!e || this.audioOnlyCache_.controlBarHeight === e.currentHeight() || (this.audioOnlyCache_.controlBarHeight = e.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
		}
		enableAudioOnlyUI_() {
			this.addClass("vjs-audio-only-mode");
			let e = this.children(), t = this.getChild("ControlBar"), n = t && t.currentHeight();
			e.forEach((e) => {
				e !== t && e.el_ && !e.hasClass("vjs-hidden") && (e.hide(), this.audioOnlyCache_.hiddenChildren.push(e));
			}), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = n, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(n), this.trigger("audioonlymodechange");
		}
		disableAudioOnlyUI_() {
			this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((e) => e.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
		}
		audioOnlyMode(e) {
			if (typeof e != "boolean" || e === this.audioOnlyMode_) return this.audioOnlyMode_;
			if (this.audioOnlyMode_ = e, e) {
				let e = [];
				return this.isInPictureInPicture() && e.push(this.exitPictureInPicture()), this.isFullscreen() && e.push(this.exitFullscreen()), this.audioPosterMode() && e.push(this.audioPosterMode(!1)), Promise.all(e).then(() => this.enableAudioOnlyUI_());
			}
			return Promise.resolve().then(() => this.disableAudioOnlyUI_());
		}
		enablePosterModeUI_() {
			(this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
		}
		disablePosterModeUI_() {
			(this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
		}
		audioPosterMode(e) {
			return typeof e != "boolean" || e === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = e, e ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
				this.enablePosterModeUI_();
			}) : Promise.resolve().then(() => {
				this.enablePosterModeUI_();
			}) : Promise.resolve().then(() => {
				this.disablePosterModeUI_();
			}));
		}
		addTextTrack(e, t, n) {
			if (this.tech_) return this.tech_.addTextTrack(e, t, n);
		}
		addRemoteTextTrack(e, t) {
			if (this.tech_) return this.tech_.addRemoteTextTrack(e, t);
		}
		removeRemoteTextTrack(e = {}) {
			let { track: t } = e;
			if (t ||= e, this.tech_) return this.tech_.removeRemoteTextTrack(t);
		}
		getVideoPlaybackQuality() {
			return this.techGet_("getVideoPlaybackQuality");
		}
		videoWidth() {
			return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
		}
		videoHeight() {
			return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
		}
		language(e) {
			if (e === void 0) return this.language_;
			this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), BV(this) && this.trigger("languagechange"));
		}
		languages() {
			return XR(e.prototype.options_.languages, this.languages_);
		}
		toJSON() {
			let e = XR(this.options_), t = e.tracks;
			e.tracks = [];
			for (let n = 0; n < t.length; n++) {
				let r = t[n];
				r = XR(r), r.player = void 0, e.tracks[n] = r;
			}
			return e;
		}
		createModal(e, t) {
			t ||= {}, t.content = e || "";
			let n = new cH(this, t);
			return this.addChild(n), n.on("dispose", () => {
				this.removeChild(n);
			}), n.open(), n;
		}
		updateCurrentBreakpoint_() {
			if (!this.responsive()) return;
			let e = this.currentBreakpoint(), t = this.currentWidth();
			for (let n = 0; n < UW.length; n++) {
				let r = UW[n];
				if (t <= this.breakpoints_[r]) {
					if (e === r) return;
					e && this.removeClass(WW[e]), this.addClass(WW[r]), this.breakpoint_ = r;
					break;
				}
			}
		}
		removeCurrentBreakpoint_() {
			let e = this.currentBreakpointClass();
			this.breakpoint_ = "", e && this.removeClass(e);
		}
		breakpoints(e) {
			return e === void 0 ? Object.assign(this.breakpoints_) : (this.removeCurrentBreakpoint_(), this.breakpoints_ = Object.assign({}, GW, e), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
		}
		responsive(e) {
			if (e === void 0) return this.responsive_;
			e = !!e;
			let t = this.responsive_;
			if (e !== t) return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
		}
		currentBreakpoint() {
			return this.breakpoint_;
		}
		currentBreakpointClass() {
			return WW[this.breakpoint_] || "";
		}
		loadMedia(e, t) {
			if (!e || typeof e != "object") return;
			let n = this.crossOrigin();
			this.reset(), this.cache_.media = XR(e);
			let { artist: r, artwork: i, description: a, poster: o, src: s, textTracks: c, title: l } = this.cache_.media;
			!i && o && (this.cache_.media.artwork = [{
				src: o,
				type: WH(o)
			}]), n && this.crossOrigin(n), s && this.src(s), o && this.poster(o), Array.isArray(c) && c.forEach((e) => this.addRemoteTextTrack(e, !1)), this.titleBar && this.titleBar.update({
				title: l,
				description: a || r || ""
			}), this.ready(t);
		}
		getMedia() {
			if (!this.cache_.media) {
				let e = this.poster(), t = {
					src: this.currentSources(),
					textTracks: Array.prototype.map.call(this.remoteTextTracks(), (e) => ({
						kind: e.kind,
						label: e.label,
						language: e.language,
						src: e.src
					}))
				};
				return e && (t.poster = e, t.artwork = [{
					src: t.poster,
					type: WH(t.poster)
				}]), t;
			}
			return XR(this.cache_.media);
		}
		static getTagSettings(e) {
			let t = {
				sources: [],
				tracks: []
			}, n = pz(e), r = n["data-setup"];
			if (cz(e, "vjs-fill") && (n.fill = !0), cz(e, "vjs-fluid") && (n.fluid = !0), r !== null) try {
				Object.assign(n, JSON.parse(r || "{}"));
			} catch (e) {
				UB.error("data-setup", e);
			}
			if (Object.assign(t, n), e.hasChildNodes()) {
				let n = e.childNodes;
				for (let e = 0, r = n.length; e < r; e++) {
					let r = n[e], i = r.nodeName.toLowerCase();
					i === "source" ? t.sources.push(pz(r)) : i === "track" && t.tracks.push(pz(r));
				}
			}
			return t;
		}
		debug(e) {
			if (e === void 0) return this.debugEnabled_;
			e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
		}
		playbackRates(e) {
			if (e === void 0) return this.cache_.playbackRates;
			Array.isArray(e) && e.every((e) => typeof e == "number") && (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
		}
	}, KW.prototype.videoTracks = () => {}, KW.prototype.audioTracks = () => {}, KW.prototype.textTracks = () => {}, KW.prototype.remoteTextTracks = () => {}, KW.prototype.remoteTextTrackEls = () => {}, FH.names.forEach(function(e) {
		let t = FH[e];
		KW.prototype[t.getterName] = function() {
			return this.tech_ ? this.tech_[t.getterName]() : (this[t.privateName] = this[t.privateName] || new t.ListClass(), this[t.privateName]);
		};
	}), KW.prototype.crossorigin = KW.prototype.crossOrigin, KW.players = {}, qW = X.default.navigator, KW.prototype.options_ = {
		techOrder: IH.defaultTechOrder_,
		html5: {},
		enableSourceset: !0,
		inactivityTimeout: 2e3,
		playbackRates: [],
		liveui: !1,
		children: [
			"mediaLoader",
			"posterImage",
			"titleBar",
			"textTrackDisplay",
			"loadingSpinner",
			"bigPlayButton",
			"liveTracker",
			"controlBar",
			"errorDisplay",
			"textTrackSettings",
			"resizeManager"
		],
		language: qW && (qW.languages && qW.languages[0] || qW.userLanguage || qW.language) || "en",
		languages: {},
		notSupportedMessage: "No compatible source was found for this media.",
		normalizeAutoplay: !1,
		fullscreen: { options: { navigationUI: "hide" } },
		breakpoints: {},
		responsive: !1,
		audioOnlyMode: !1,
		audioPosterMode: !1,
		spatialNavigation: {
			enabled: !1,
			horizontalSeek: !1
		},
		enableSmoothSeeking: !1,
		disableSeekWhileScrubbingOnMobile: !1,
		disableSeekWhileScrubbingOnSTV: !1
	}, VW.forEach(function(e) {
		KW.prototype[`handleTech${ZV(e)}_`] = function() {
			return this.trigger(e);
		};
	}), Q.registerComponent("Player", KW), JW = "plugin", YW = "activePlugins_", XW = {}, ZW = (e) => XW.hasOwnProperty(e), QW = (e) => ZW(e) ? XW[e] : void 0, $W = (e, t) => {
		e[YW] = e[YW] || {}, e[YW][t] = !0;
	}, eG = (e, t, n) => {
		let r = (n ? "before" : "") + "pluginsetup";
		e.trigger(r, t), e.trigger(r + ":" + t.name, t);
	}, tG = function(e, t) {
		let n = function() {
			eG(this, {
				name: e,
				plugin: t,
				instance: null
			}, !0);
			let n = t.apply(this, arguments);
			return $W(this, e), eG(this, {
				name: e,
				plugin: t,
				instance: n
			}), n;
		};
		return Object.keys(t).forEach(function(e) {
			n[e] = t[e];
		}), n;
	}, nG = (e, t) => (t.prototype.name = e, function(...n) {
		eG(this, {
			name: e,
			plugin: t,
			instance: null
		}, !0);
		let r = new t(this, ...n);
		return this[e] = () => r, eG(this, r.getEventHash()), r;
	}), rG = class e {
		constructor(t) {
			if (this.constructor === e) throw Error("Plugin must be sub-classed; not directly instantiated.");
			this.player = t, this.log ||= this.player.log.createLogger(this.name), Vz(this), delete this.trigger, Hz(this, this.constructor.defaultState), $W(t, this.name), this.dispose = this.dispose.bind(this), t.on("dispose", this.dispose);
		}
		version() {
			return this.constructor.VERSION;
		}
		getEventHash(e = {}) {
			return e.name = this.name, e.plugin = this.constructor, e.instance = this, e;
		}
		trigger(e, t = {}) {
			return Rz(this.eventBusEl_, e, this.getEventHash(t));
		}
		handleStateChanged(e) {}
		dispose() {
			let { name: e, player: t } = this;
			this.trigger("dispose"), this.off(), t.off("dispose", this.dispose), t[YW][e] = !1, this.player = this.state = null, t[e] = nG(e, XW[e]);
		}
		static isBasic(t) {
			let n = typeof t == "string" ? QW(t) : t;
			return typeof n == "function" && !e.prototype.isPrototypeOf(n.prototype);
		}
		static registerPlugin(t, n) {
			if (typeof t != "string") throw Error(`Illegal plugin name, "${t}", must be a string, was ${typeof t}.`);
			if (ZW(t)) UB.warn(`A plugin named "${t}" already exists. You may want to avoid re-registering plugins!`);
			else if (KW.prototype.hasOwnProperty(t)) throw Error(`Illegal plugin name, "${t}", cannot share a name with an existing player method!`);
			if (typeof n != "function") throw Error(`Illegal plugin for "${t}", must be a function, was ${typeof n}.`);
			return XW[t] = n, t !== JW && (e.isBasic(n) ? KW.prototype[t] = tG(t, n) : KW.prototype[t] = nG(t, n)), n;
		}
		static deregisterPlugin(e) {
			if (e === JW) throw Error("Cannot de-register base plugin.");
			ZW(e) && (delete XW[e], delete KW.prototype[e]);
		}
		static getPlugins(e = Object.keys(XW)) {
			let t;
			return e.forEach((e) => {
				let n = QW(e);
				n && (t ||= {}, t[e] = n);
			}), t;
		}
		static getPluginVersion(e) {
			let t = QW(e);
			return t && t.VERSION || "";
		}
	}, rG.getPlugin = QW, rG.BASE_PLUGIN_NAME = JW, rG.registerPlugin(JW, rG), KW.prototype.usingPlugin = function(e) {
		return !!this[YW] && this[YW][e] === !0;
	}, KW.prototype.hasPlugin = function(e) {
		return !!ZW(e);
	}, iG = {
		NetworkBadStatus: "networkbadstatus",
		NetworkRequestFailed: "networkrequestfailed",
		NetworkRequestAborted: "networkrequestaborted",
		NetworkRequestTimeout: "networkrequesttimeout",
		NetworkBodyParserFailed: "networkbodyparserfailed",
		StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
		StreamingDashManifestParserError: "streamingdashmanifestparsererror",
		StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
		StreamingVttParserError: "streamingvttparsererror",
		StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
		StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
		StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
		StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
		StreamingCodecsChangeError: "streamingcodecschangeerror"
	}, aG = (e) => e.indexOf("#") === 0 ? e.slice(1) : e, Y.hooks_ = MB, Y.hooks = NB, Y.hook = PB, Y.hookOnce = IB, Y.removeHook = FB, X.default.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && tz()) {
		let e = vV(".vjs-styles-defaults");
		if (!e) {
			e = wV("vjs-styles-defaults");
			let t = vV("head");
			t && t.insertBefore(e, t.firstChild), TV(e, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");
		}
	}
	Az(1, Y), Y.VERSION = jB, Y.options = KW.prototype.options_, Y.getPlayers = () => KW.players, Y.getPlayer = (e) => {
		let t = KW.players, n;
		if (typeof e == "string") {
			let r = aG(e), i = t[r];
			if (i) return i;
			n = vV("#" + r);
		} else n = e;
		if (nz(n)) {
			let { player: e, playerId: r } = n;
			if (e || t[r]) return e || t[r];
		}
	}, Y.getAllPlayers = () => Object.keys(KW.players).map((e) => KW.players[e]).filter(Boolean), Y.players = KW.players, Y.getComponent = Q.getComponent, Y.registerComponent = (e, t) => (IH.isTech(t) && UB.warn(`The ${e} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), Q.registerComponent.call(Q, e, t)), Y.getTech = IH.getTech, Y.registerTech = IH.registerTech, Y.use = tB, Object.defineProperty(Y, "middleware", {
		value: {},
		writeable: !1,
		enumerable: !0
	}), Object.defineProperty(Y.middleware, "TERMINATOR", {
		value: zH,
		writeable: !1,
		enumerable: !0
	}), Y.browser = _V, Y.obj = qB, Y.mergeOptions = xB(9, "videojs.mergeOptions", "videojs.obj.merge", XR), Y.defineLazyProperty = xB(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", QR), Y.bind = xB(9, "videojs.bind", "native Function.prototype.bind", NV), Y.registerPlugin = rG.registerPlugin, Y.deregisterPlugin = rG.deregisterPlugin, Y.plugin = (e, t) => (UB.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), rG.registerPlugin(e, t)), Y.getPlugins = rG.getPlugins, Y.getPlugin = rG.getPlugin, Y.getPluginVersion = rG.getPluginVersion, Y.addLanguage = function(e, t) {
		return e = ("" + e).toLowerCase(), Y.options.languages = XR(Y.options.languages, { [e]: t }), Y.options.languages[e];
	}, Y.log = UB, Y.createLogger = WB, Y.time = nH, Y.createTimeRange = xB(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", Kz), Y.createTimeRanges = xB(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", Kz), Y.formatTime = xB(9, "videojs.formatTime", "videojs.time.formatTime", Yz), Y.setFormatTime = xB(9, "videojs.setFormatTime", "videojs.time.setFormatTime", qz), Y.resetFormatTime = xB(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", Jz), Y.parseUrl = xB(9, "videojs.parseUrl", "videojs.url.parseUrl", SH), Y.isCrossOrigin = xB(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", TH), Y.EventTarget = RV, Y.any = Bz, Y.on = Iz, Y.one = zz, Y.off = Lz, Y.trigger = Rz, Y.xhr = DB.default, Y.TrackList = lH, Y.TextTrack = kH, Y.TextTrackList = mH, Y.AudioTrack = AH, Y.AudioTrackList = dH, Y.VideoTrack = jH, Y.VideoTrackList = pH, [
		"isEl",
		"isTextNode",
		"createEl",
		"hasClass",
		"addClass",
		"removeClass",
		"toggleClass",
		"setAttributes",
		"getAttributes",
		"emptyEl",
		"appendContent",
		"insertContent"
	].forEach((e) => {
		Y[e] = function() {
			return UB.warn(`videojs.${e}() is deprecated; use videojs.dom.${e}() instead`), bV[e].apply(null, arguments);
		};
	}), Y.computedStyle = xB(9, "videojs.computedStyle", "videojs.dom.computedStyle", Oz), Y.dom = bV, Y.fn = IV, Y.num = _U, Y.str = $V, Y.url = EH, Y.Error = iG, oG = class {
		constructor(e) {
			let t = this;
			return t.id = e.id, t.label = t.id, t.width = e.width, t.height = e.height, t.bitrate = e.bandwidth, t.frameRate = e.frameRate, t.enabled_ = e.enabled, Object.defineProperty(t, "enabled", {
				get() {
					return t.enabled_();
				},
				set(e) {
					t.enabled_(e);
				}
			}), t;
		}
	}, sG = class extends Y.EventTarget {
		constructor() {
			super();
			let e = this;
			return e.levels_ = [], e.selectedIndex_ = -1, Object.defineProperty(e, "selectedIndex", { get() {
				return e.selectedIndex_;
			} }), Object.defineProperty(e, "length", { get() {
				return e.levels_.length;
			} }), e[Symbol.iterator] = () => e.levels_.values(), e;
		}
		addQualityLevel(e) {
			let t = this.getQualityLevelById(e.id);
			if (t) return t;
			let n = this.levels_.length;
			return t = new oG(e), "" + n in this || Object.defineProperty(this, n, { get() {
				return this.levels_[n];
			} }), this.levels_.push(t), this.trigger({
				qualityLevel: t,
				type: "addqualitylevel"
			}), t;
		}
		removeQualityLevel(e) {
			let t = null;
			for (let n = 0, r = this.length; n < r; n++) if (this[n] === e) {
				t = this.levels_.splice(n, 1)[0], this.selectedIndex_ === n ? this.selectedIndex_ = -1 : this.selectedIndex_ > n && this.selectedIndex_--;
				break;
			}
			return t && this.trigger({
				qualityLevel: e,
				type: "removequalitylevel"
			}), t;
		}
		getQualityLevelById(e) {
			for (let t = 0, n = this.length; t < n; t++) {
				let n = this[t];
				if (n.id === e) return n;
			}
			return null;
		}
		dispose() {
			this.selectedIndex_ = -1, this.levels_.length = 0;
		}
	}, sG.prototype.allowedEvents_ = {
		change: "change",
		addqualitylevel: "addqualitylevel",
		removequalitylevel: "removequalitylevel"
	};
	for (let e in sG.prototype.allowedEvents_) sG.prototype["on" + e] = null;
	cG = "4.1.0", lG = function(e, t) {
		let n = e.qualityLevels, r = new sG(), i = function() {
			r.dispose(), e.qualityLevels = n, e.off("dispose", i);
		};
		return e.on("dispose", i), e.qualityLevels = () => r, e.qualityLevels.VERSION = cG, r;
	}, uG = function(e) {
		return lG(this, Y.obj.merge({}, e));
	}, Y.registerPlugin("qualityLevels", uG), uG.VERSION = cG, dG = OF, fG = (e, t) => t && t.responseURL && e !== t.responseURL ? t.responseURL : e, pG = (e) => Y.log.debug ? Y.log.debug.bind(Y, "VHS:", `${e} >`) : function() {}, mG = 1 / 30, hG = mG * 3, gG = function(e, t) {
		let n = [], r;
		if (e && e.length) for (r = 0; r < e.length; r++) t(e.start(r), e.end(r)) && n.push([e.start(r), e.end(r)]);
		return CB(n);
	}, _G = function(e, t) {
		return gG(e, function(e, n) {
			return e - hG <= t && n + hG >= t;
		});
	}, vG = function(e, t) {
		return gG(e, function(e) {
			return e - mG >= t;
		});
	}, yG = function(e) {
		if (e.length < 2) return CB();
		let t = [];
		for (let n = 1; n < e.length; n++) {
			let r = e.end(n - 1), i = e.start(n);
			t.push([r, i]);
		}
		return CB(t);
	}, bG = function(e, t) {
		let n = null, r = null, i = 0, a = [], o = [];
		if (!e || !e.length || !t || !t.length) return CB();
		let s = e.length;
		for (; s--;) a.push({
			time: e.start(s),
			type: "start"
		}), a.push({
			time: e.end(s),
			type: "end"
		});
		for (s = t.length; s--;) a.push({
			time: t.start(s),
			type: "start"
		}), a.push({
			time: t.end(s),
			type: "end"
		});
		for (a.sort(function(e, t) {
			return e.time - t.time;
		}), s = 0; s < a.length; s++) a[s].type === "start" ? (i++, i === 2 && (n = a[s].time)) : a[s].type === "end" && (i--, i === 1 && (r = a[s].time)), n !== null && r !== null && (o.push([n, r]), n = null, r = null);
		return CB(o);
	}, xG = (e) => {
		let t = [];
		if (!e || !e.length) return "";
		for (let n = 0; n < e.length; n++) t.push(e.start(n) + " => " + e.end(n));
		return t.join(", ");
	}, SG = function(e, t, n = 1) {
		return ((e.length ? e.end(e.length - 1) : 0) - t) / n;
	}, CG = (e) => {
		let t = [];
		for (let n = 0; n < e.length; n++) t.push({
			start: e.start(n),
			end: e.end(n)
		});
		return t;
	}, wG = function(e, t) {
		if (e === t) return !1;
		if (!e && t || !t && e || e.length !== t.length) return !0;
		for (let n = 0; n < e.length; n++) if (e.start(n) !== t.start(n) || e.end(n) !== t.end(n)) return !0;
		return !1;
	}, TG = function(e) {
		if (!(!e || !e.length || !e.end)) return e.end(e.length - 1);
	}, EG = function(e, t) {
		let n = 0;
		if (!e || !e.length) return n;
		for (let r = 0; r < e.length; r++) {
			let i = e.start(r), a = e.end(r);
			if (!(t > a)) {
				if (t > i && t <= a) {
					n += a - t;
					continue;
				}
				n += a - i;
			}
		}
		return n;
	}, DG = (e, t) => {
		if (!t.preload) return t.duration;
		let n = 0;
		return (t.parts || []).forEach(function(e) {
			n += e.duration;
		}), (t.preloadHints || []).forEach(function(t) {
			t.type === "PART" && (n += e.partTargetDuration);
		}), n;
	}, OG = (e) => (e.segments || []).reduce((e, t, n) => (t.parts ? t.parts.forEach(function(r, i) {
		e.push({
			duration: r.duration,
			segmentIndex: n,
			partIndex: i,
			part: r,
			segment: t
		});
	}) : e.push({
		duration: t.duration,
		segmentIndex: n,
		partIndex: null,
		segment: t,
		part: null
	}), e), []), kG = (e) => {
		let t = e.segments && e.segments.length && e.segments[e.segments.length - 1];
		return t && t.parts || [];
	}, AG = ({ preloadSegment: e }) => {
		if (!e) return;
		let { parts: t, preloadHints: n } = e, r = (n || []).reduce((e, t) => e + +(t.type === "PART"), 0);
		return r += t && t.length ? t.length : 0, r;
	}, jG = (e, t) => {
		if (t.endList) return 0;
		if (e && e.suggestedPresentationDelay) return e.suggestedPresentationDelay;
		let n = kG(t).length > 0;
		return n && t.serverControl && t.serverControl.partHoldBack ? t.serverControl.partHoldBack : n && t.partTargetDuration ? t.partTargetDuration * 3 : t.serverControl && t.serverControl.holdBack ? t.serverControl.holdBack : t.targetDuration ? t.targetDuration * 3 : 0;
	}, MG = function(e, t) {
		let n = 0, r = t - e.mediaSequence, i = e.segments[r];
		if (i) {
			if (i.start !== void 0) return {
				result: i.start,
				precise: !0
			};
			if (i.end !== void 0) return {
				result: i.end - i.duration,
				precise: !0
			};
		}
		for (; r--;) {
			if (i = e.segments[r], i.end !== void 0) return {
				result: n + i.end,
				precise: !0
			};
			if (n += DG(e, i), i.start !== void 0) return {
				result: n + i.start,
				precise: !0
			};
		}
		return {
			result: n,
			precise: !1
		};
	}, NG = function(e, t) {
		let n = 0, r, i = t - e.mediaSequence;
		for (; i < e.segments.length; i++) {
			if (r = e.segments[i], r.start !== void 0) return {
				result: r.start - n,
				precise: !0
			};
			if (n += DG(e, r), r.end !== void 0) return {
				result: r.end - n,
				precise: !0
			};
		}
		return {
			result: -1,
			precise: !1
		};
	}, PG = function(e, t, n) {
		if (t === void 0 && (t = e.mediaSequence + e.segments.length), t < e.mediaSequence) return 0;
		let r = MG(e, t);
		if (r.precise) return r.result;
		let i = NG(e, t);
		return i.precise ? i.result : r.result + n;
	}, FG = function(e, t, n) {
		if (!e) return 0;
		if (typeof n != "number" && (n = 0), t === void 0) {
			if (e.totalDuration) return e.totalDuration;
			if (!e.endList) return X.default.Infinity;
		}
		return PG(e, t, n);
	}, IG = function({ defaultDuration: e, durationList: t, startIndex: n, endIndex: r }) {
		let i = 0;
		if (n > r && ([n, r] = [r, n]), n < 0) {
			for (let t = n; t < Math.min(0, r); t++) i += e;
			n = 0;
		}
		for (let e = n; e < r; e++) i += t[e].duration;
		return i;
	}, LG = function(e, t, n, r) {
		if (!e || !e.segments) return null;
		if (e.endList) return FG(e);
		if (t === null) return null;
		t ||= 0;
		let i = PG(e, e.mediaSequence + e.segments.length, t);
		return n && (r = typeof r == "number" ? r : jG(null, e), i -= r), Math.max(0, i);
	}, RG = function(e, t, n) {
		let r = t || 0, i = LG(e, t, !0, n);
		return i === null ? CB() : (i < r && (i = r), CB(r, i));
	}, zG = function({ playlist: e, currentTime: t, startingSegmentIndex: n, startingPartIndex: r, startTime: i, exactManifestTimings: a }) {
		let o = t - i, s = OG(e), c = 0;
		for (let e = 0; e < s.length; e++) {
			let t = s[e];
			if (n === t.segmentIndex && (typeof r != "number" || typeof t.partIndex != "number" || r === t.partIndex)) {
				c = e;
				break;
			}
		}
		if (o < 0) {
			if (c > 0) for (let t = c - 1; t >= 0; t--) {
				let n = s[t];
				if (o += n.duration, a) {
					if (o < 0) continue;
				} else if (o + mG <= 0) continue;
				return {
					partIndex: n.partIndex,
					segmentIndex: n.segmentIndex,
					startTime: i - IG({
						defaultDuration: e.targetDuration,
						durationList: s,
						startIndex: c,
						endIndex: t
					})
				};
			}
			return {
				partIndex: s[0] && s[0].partIndex || null,
				segmentIndex: s[0] && s[0].segmentIndex || 0,
				startTime: t
			};
		}
		if (c < 0) {
			for (let n = c; n < 0; n++) if (o -= e.targetDuration, o < 0) return {
				partIndex: s[0] && s[0].partIndex || null,
				segmentIndex: s[0] && s[0].segmentIndex || 0,
				startTime: t
			};
			c = 0;
		}
		for (let t = c; t < s.length; t++) {
			let n = s[t];
			o -= n.duration;
			let r = n.duration > mG, l = o === 0, u = r && o + mG >= 0;
			if (!((l || u) && t !== s.length - 1)) {
				if (a) {
					if (o > 0) continue;
				} else if (o - mG >= 0) continue;
				return {
					partIndex: n.partIndex,
					segmentIndex: n.segmentIndex,
					startTime: i + IG({
						defaultDuration: e.targetDuration,
						durationList: s,
						startIndex: c,
						endIndex: t
					})
				};
			}
		}
		return {
			segmentIndex: s[s.length - 1].segmentIndex,
			partIndex: s[s.length - 1].partIndex,
			startTime: t
		};
	}, BG = function(e) {
		return e.excludeUntil && e.excludeUntil > Date.now();
	}, VG = function(e) {
		return e.excludeUntil && e.excludeUntil === Infinity;
	}, HG = function(e) {
		let t = BG(e);
		return !e.disabled && !t;
	}, UG = function(e) {
		return e.disabled;
	}, WG = function(e) {
		for (let t = 0; t < e.segments.length; t++) if (e.segments[t].key) return !0;
		return !1;
	}, GG = function(e, t) {
		return t.attributes && t.attributes[e];
	}, KG = function(e, t, n, r = 0) {
		return GG("BANDWIDTH", n) ? (e * n.attributes.BANDWIDTH - r * 8) / t : NaN;
	}, qG = (e, t) => {
		if (e.playlists.length === 1) return !0;
		let n = t.attributes.BANDWIDTH || Number.MAX_VALUE;
		return e.playlists.filter((e) => HG(e) ? (e.attributes.BANDWIDTH || 0) < n : !1).length === 0;
	}, JG = (e, t) => !e && !t || !e && t || e && !t ? !1 : !!(e === t || e.id && t.id && e.id === t.id || e.resolvedUri && t.resolvedUri && e.resolvedUri === t.resolvedUri || e.uri && t.uri && e.uri === t.uri), YG = function(e, t) {
		let n = e && e.mediaGroups && e.mediaGroups.AUDIO || {}, r = !1;
		for (let e in n) {
			for (let i in n[e]) if (r = t(n[e][i]), r) break;
			if (r) break;
		}
		return !!r;
	}, XG = (e) => {
		if (!e || !e.playlists || !e.playlists.length) return YG(e, (e) => e.playlists && e.playlists.length || e.uri);
		for (let t = 0; t < e.playlists.length; t++) {
			let n = e.playlists[t], r = n.attributes && n.attributes.CODECS;
			if (!(r && r.split(",").every((e) => tI(e))) && !YG(e, (e) => JG(n, e))) return !1;
		}
		return !0;
	}, ZG = {
		liveEdgeDelay: jG,
		duration: FG,
		seekable: RG,
		getMediaInfoForTime: zG,
		isEnabled: HG,
		isDisabled: UG,
		isExcluded: BG,
		isIncompatible: VG,
		playlistEnd: LG,
		isAes: WG,
		hasAttribute: GG,
		estimateSegmentRequestTime: KG,
		isLowestEnabledRendition: qG,
		isAudioOnly: XG,
		playlistMatch: JG,
		segmentDurationWithParts: DG
	}, {log: QG} = Y, $G = (e, t) => `${e}-${t}`, eK = (e, t, n) => `placeholder-uri-${e}-${t}-${n}`, tK = ({ onwarn: e, oninfo: t, manifestString: n, customTagParsers: r = [], customTagMappers: i = [], llhls: a }) => {
		let o = new KF();
		e && o.on("warn", e), t && o.on("info", t), r.forEach((e) => o.addParser(e)), i.forEach((e) => o.addTagMapper(e)), o.push(n), o.end();
		let s = o.manifest;
		if (a || ([
			"preloadSegment",
			"skip",
			"serverControl",
			"renditionReports",
			"partInf",
			"partTargetDuration"
		].forEach(function(e) {
			s.hasOwnProperty(e) && delete s[e];
		}), s.segments && s.segments.forEach(function(e) {
			["parts", "preloadHints"].forEach(function(t) {
				e.hasOwnProperty(t) && delete e[t];
			});
		})), !s.targetDuration) {
			let t = 10;
			s.segments && s.segments.length && (t = s.segments.reduce((e, t) => Math.max(e, t.duration), 0)), e && e({ message: `manifest has no targetDuration defaulting to ${t}` }), s.targetDuration = t;
		}
		let c = kG(s);
		if (c.length && !s.partTargetDuration) {
			let t = c.reduce((e, t) => Math.max(e, t.duration), 0);
			e && (e({ message: `manifest has no partTargetDuration defaulting to ${t}` }), QG.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), s.partTargetDuration = t;
		}
		return s;
	}, nK = (e, t) => {
		e.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((n) => {
			if (e.mediaGroups[n]) for (let r in e.mediaGroups[n]) for (let i in e.mediaGroups[n][r]) {
				let a = e.mediaGroups[n][r][i];
				t(a, n, r, i);
			}
		});
	}, rK = ({ playlist: e, uri: t, id: n }) => {
		e.id = n, e.playlistErrors_ = 0, t && (e.uri = t), e.attributes = e.attributes || {};
	}, iK = (e) => {
		let t = e.playlists.length;
		for (; t--;) {
			let n = e.playlists[t];
			rK({
				playlist: n,
				id: $G(t, n.uri)
			}), n.resolvedUri = dG(e.uri, n.uri), e.playlists[n.id] = n, e.playlists[n.uri] = n, n.attributes.BANDWIDTH || QG.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
		}
	}, aK = (e) => {
		nK(e, (t) => {
			t.uri && (t.resolvedUri = dG(e.uri, t.uri));
		});
	}, oK = (e, t) => {
		let n = $G(0, t), r = {
			mediaGroups: {
				AUDIO: {},
				VIDEO: {},
				"CLOSED-CAPTIONS": {},
				SUBTITLES: {}
			},
			uri: X.default.location.href,
			resolvedUri: X.default.location.href,
			playlists: [{
				uri: t,
				id: n,
				resolvedUri: t,
				attributes: {}
			}]
		};
		return r.playlists[n] = r.playlists[0], r.playlists[t] = r.playlists[0], r;
	}, sK = (e, t, n = eK) => {
		e.uri = t;
		for (let t = 0; t < e.playlists.length; t++) if (!e.playlists[t].uri) {
			let n = `placeholder-uri-${t}`;
			e.playlists[t].uri = n;
		}
		let r = XG(e);
		nK(e, (t, i, a, o) => {
			if (!t.playlists || !t.playlists.length) {
				if (r && i === "AUDIO" && !t.uri) for (let t = 0; t < e.playlists.length; t++) {
					let n = e.playlists[t];
					if (n.attributes && n.attributes.AUDIO && n.attributes.AUDIO === a) return;
				}
				t.playlists = [wF({}, t)];
			}
			t.playlists.forEach(function(t, r) {
				let s = n(i, a, o, t), c = $G(r, s);
				t.uri ? t.resolvedUri = t.resolvedUri || dG(e.uri, t.uri) : (t.uri = r === 0 ? s : c, t.resolvedUri = t.uri), t.id = t.id || c, t.attributes = t.attributes || {}, e.playlists[t.id] = t, e.playlists[t.uri] = t;
			});
		}), iK(e), aK(e);
	}, cK = class {
		constructor() {
			this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
		}
		setOffset(e = []) {
			if (this.offset_ !== null || !e.length) return;
			let [t] = e;
			t.programDateTime !== void 0 && (this.offset_ = t.programDateTime / 1e3);
		}
		setPendingDateRanges(e = []) {
			if (!e.length) return;
			let [t] = e, n = t.startDate.getTime();
			this.trimProcessedDateRanges_(n), this.pendingDateRanges_ = e.reduce((e, t) => (e.set(t.id, t), e), /* @__PURE__ */ new Map());
		}
		processDateRange(e) {
			this.pendingDateRanges_.delete(e.id), this.processedDateRanges_.set(e.id, e);
		}
		getDateRangesToProcess() {
			if (this.offset_ === null) return [];
			let e = {}, t = [];
			this.pendingDateRanges_.forEach((n, r) => {
				this.processedDateRanges_.has(r) || (n.startTime = n.startDate.getTime() / 1e3 - this.offset_, n.processDateRange = () => this.processDateRange(n), t.push(n), n.class && (e[n.class] ? n.classListIndex = e[n.class].push(n) - 1 : (e[n.class] = [n], n.classListIndex = 0)));
			});
			for (let n of t) {
				let t = e[n.class] || [];
				n.endTime = n.endDate ? n.endDate.getTime() / 1e3 - this.offset_ : n.endOnNext && t[n.classListIndex + 1] ? t[n.classListIndex + 1].startTime : n.duration ? n.startTime + n.duration : n.plannedDuration ? n.startTime + n.plannedDuration : n.startTime;
			}
			return t;
		}
		trimProcessedDateRanges_(e) {
			new Map(this.processedDateRanges_).forEach((t, n) => {
				t.startDate.getTime() < e && this.processedDateRanges_.delete(n);
			});
		}
	}, lK = 22, uK = ({ requestType: e, request: t, error: n, parseFailure: r }) => {
		let i = t.status < 200 || t.status > 299, a = t.status >= 400 && t.status <= 499, o = {
			uri: t.uri,
			requestType: e
		}, s = i && !a || r;
		return n && a ? (o.error = wF({}, n), o.errorType = Y.Error.NetworkRequestFailed) : t.aborted ? o.errorType = Y.Error.NetworkRequestAborted : t.timedout ? o.errorType = Y.Error.NetworkRequestTimeout : s && (o.errorType = r ? Y.Error.NetworkBodyParserFailed : Y.Error.NetworkBadStatus, o.status = t.status, o.headers = t.headers), o;
	}, dK = pG("CodecUtils"), fK = function(e) {
		let t = e.attributes || {};
		if (t.CODECS) return $F(t.CODECS);
	}, pK = (e, t) => {
		let n = t.attributes || {};
		return e && e.mediaGroups && e.mediaGroups.AUDIO && n.AUDIO && e.mediaGroups.AUDIO[n.AUDIO];
	}, mK = (e, t) => {
		if (!pK(e, t)) return !0;
		let n = t.attributes || {}, r = e.mediaGroups.AUDIO[n.AUDIO];
		for (let e in r) if (!r[e].uri && !r[e].playlists) return !0;
		return !1;
	}, hK = function(e) {
		let t = {};
		return e.forEach(({ mediaType: e, type: n, details: r }) => {
			t[e] = t[e] || [], t[e].push(QF(`${n}${r}`));
		}), Object.keys(t).forEach(function(e) {
			if (t[e].length > 1) {
				dK(`multiple ${e} codecs found as attributes: ${t[e].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), t[e] = null;
				return;
			}
			t[e] = t[e][0];
		}), t;
	}, gK = function(e) {
		let t = 0;
		return e.audio && t++, e.video && t++, t;
	}, _K = function(e, t) {
		let n = t.attributes || {}, r = hK(fK(t) || []);
		if (pK(e, t) && !r.audio && !mK(e, t)) {
			let t = hK(eI(e, n.AUDIO) || []);
			t.audio && (r.audio = t.audio);
		}
		return r;
	}, {EventTarget: vK} = Y, yK = (e, t) => {
		if (t.endList || !t.serverControl) return e;
		let n = {};
		if (t.serverControl.canBlockReload) {
			let { preloadSegment: e } = t, r = t.mediaSequence + t.segments.length;
			if (e) {
				let i = e.parts || [], a = AG(t) - 1;
				a > -1 && a !== i.length - 1 && (n._HLS_part = a), (a > -1 || i.length) && r--;
			}
			n._HLS_msn = r;
		}
		if (t.serverControl && t.serverControl.canSkipUntil && (n._HLS_skip = t.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(n).length) {
			let t = new X.default.URL(e);
			[
				"_HLS_skip",
				"_HLS_msn",
				"_HLS_part"
			].forEach(function(e) {
				n.hasOwnProperty(e) && t.searchParams.set(e, n[e]);
			}), e = t.toString();
		}
		return e;
	}, bK = (e, t) => {
		if (!e) return t;
		let n = SB(e, t);
		if (e.preloadHints && !t.preloadHints && delete n.preloadHints, e.parts && !t.parts) delete n.parts;
		else if (e.parts && t.parts) for (let r = 0; r < t.parts.length; r++) e.parts && e.parts[r] && (n.parts[r] = SB(e.parts[r], t.parts[r]));
		return !e.skipped && t.skipped && (n.skipped = !1), e.preload && !t.preload && (n.preload = !1), n;
	}, xK = (e, t, n) => {
		let r = e.slice(), i = t.slice();
		n ||= 0;
		let a = [], o;
		for (let e = 0; e < i.length; e++) {
			let t = r[e + n], s = i[e];
			t ? (o = t.map || o, a.push(bK(t, s))) : (o && !s.map && (s.map = o), a.push(s));
		}
		return a;
	}, SK = (e, t) => {
		!e.resolvedUri && e.uri && (e.resolvedUri = dG(t, e.uri)), e.key && !e.key.resolvedUri && (e.key.resolvedUri = dG(t, e.key.uri)), e.map && !e.map.resolvedUri && (e.map.resolvedUri = dG(t, e.map.uri)), e.map && e.map.key && !e.map.key.resolvedUri && (e.map.key.resolvedUri = dG(t, e.map.key.uri)), e.parts && e.parts.length && e.parts.forEach((e) => {
			e.resolvedUri ||= dG(t, e.uri);
		}), e.preloadHints && e.preloadHints.length && e.preloadHints.forEach((e) => {
			e.resolvedUri ||= dG(t, e.uri);
		});
	}, CK = function(e) {
		let t = e.segments || [], n = e.preloadSegment;
		if (n && n.parts && n.parts.length) {
			if (n.preloadHints) {
				for (let e = 0; e < n.preloadHints.length; e++) if (n.preloadHints[e].type === "MAP") return t;
			}
			n.duration = e.targetDuration, n.preload = !0, t.push(n);
		}
		return t;
	}, wK = (e, t) => e === t || e.segments && t.segments && e.segments.length === t.segments.length && e.endList === t.endList && e.mediaSequence === t.mediaSequence && e.preloadSegment === t.preloadSegment, TK = (e, t, n = wK) => {
		let r = SB(e, {}), i = r.playlists[t.id];
		if (!i || n(i, t)) return null;
		t.segments = CK(t);
		let a = SB(i, t);
		if (a.preloadSegment && !t.preloadSegment && delete a.preloadSegment, i.segments) {
			if (t.skip) {
				t.segments = t.segments || [];
				for (let e = 0; e < t.skip.skippedSegments; e++) t.segments.unshift({ skipped: !0 });
			}
			a.segments = xK(i.segments, t.segments, t.mediaSequence - i.mediaSequence);
		}
		a.segments.forEach((e) => {
			SK(e, a.resolvedUri);
		});
		for (let e = 0; e < r.playlists.length; e++) r.playlists[e].id === t.id && (r.playlists[e] = a);
		return r.playlists[t.id] = a, r.playlists[t.uri] = a, nK(e, (e, n, r, i) => {
			if (e.playlists) for (let n = 0; n < e.playlists.length; n++) t.id === e.playlists[n].id && (e.playlists[n] = a);
		}), r;
	}, EK = (e, t) => {
		let n = e.segments || [], r = n[n.length - 1], i = r && r.parts && r.parts[r.parts.length - 1], a = i && i.duration || r && r.duration;
		return t && a ? a * 1e3 : (e.partTargetDuration || e.targetDuration || 10) * 500;
	}, DK = (e, t, n) => {
		if (!e) return;
		let r = [];
		return e.forEach((e) => {
			if (!e.attributes) return;
			let { BANDWIDTH: t, RESOLUTION: n, CODECS: i } = e.attributes;
			r.push({
				id: e.id,
				bandwidth: t,
				resolution: n,
				codecs: i
			});
		}), {
			type: t,
			isLive: n,
			renditions: r
		};
	}, OK = class extends vK {
		constructor(e, t, n = {}) {
			if (super(), !e) throw Error("A non-empty playlist URL or object is required");
			this.logger_ = pG("PlaylistLoader");
			let { withCredentials: r = !1 } = n;
			this.src = e, this.vhs_ = t, this.withCredentials = r, this.addDateRangesToTextTrack_ = n.addDateRangesToTextTrack;
			let i = t.options_;
			this.customTagParsers = i && i.customTagParsers || [], this.customTagMappers = i && i.customTagMappers || [], this.llhls = i && i.llhls, this.dateRangesStorage_ = new cK(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
		}
		handleLoadedPlaylist_() {
			let e = this.media();
			if (!e) return;
			this.dateRangesStorage_.setOffset(e.segments), this.dateRangesStorage_.setPendingDateRanges(e.dateRanges);
			let t = this.dateRangesStorage_.getDateRangesToProcess();
			!t.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(t);
		}
		handleMediaupdatetimeout_() {
			if (this.state !== "HAVE_METADATA") return;
			let e = this.media(), t = dG(this.main.uri, e.uri);
			this.llhls && (t = yK(t, e)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
				uri: t,
				withCredentials: this.withCredentials,
				requestType: "hls-playlist"
			}, (e, t) => {
				if (this.request) {
					if (e) return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
					this.haveMetadata({
						playlistString: this.request.responseText,
						url: this.media().uri,
						id: this.media().id
					});
				}
			});
		}
		playlistRequestError(e, t, n) {
			let { uri: r, id: i } = t;
			this.request = null, n && (this.state = n), this.error = {
				playlist: this.main.playlists[i],
				status: e.status,
				message: `HLS playlist request error at URL: ${r}.`,
				responseText: e.responseText,
				code: e.status >= 500 ? 4 : 2,
				metadata: uK({
					requestType: e.requestType,
					request: e,
					error: e.error
				})
			}, this.trigger("error");
		}
		parseManifest_({ url: e, manifestString: t }) {
			try {
				let n = tK({
					onwarn: ({ message: t }) => this.logger_(`m3u8-parser warn for ${e}: ${t}`),
					oninfo: ({ message: t }) => this.logger_(`m3u8-parser info for ${e}: ${t}`),
					manifestString: t,
					customTagParsers: this.customTagParsers,
					customTagMappers: this.customTagMappers,
					llhls: this.llhls
				});
				return !n.playlists || !n.playlists.length || this.excludeAudioOnlyVariants(n.playlists), n;
			} catch (e) {
				this.error = e, this.error.metadata = {
					errorType: Y.Error.StreamingHlsPlaylistParserError,
					error: e
				};
			}
		}
		excludeAudioOnlyVariants(e) {
			let t = (e) => {
				let { width: t, height: n } = (e.attributes || {}).RESOLUTION || {};
				if (t && n) return !0;
				let r = fK(e) || [];
				return !!hK(r).video;
			};
			e.some(t) && e.forEach((e) => {
				t(e) || (e.excludeUntil = Infinity);
			});
		}
		haveMetadata({ playlistString: e, playlistObject: t, url: n, id: r }) {
			this.request = null, this.state = "HAVE_METADATA";
			let i = { playlistInfo: {
				type: "media",
				uri: n
			} };
			this.trigger({
				type: "playlistparsestart",
				metadata: i
			});
			let a = t || this.parseManifest_({
				url: n,
				manifestString: e
			});
			a.lastRequest = Date.now(), rK({
				playlist: a,
				uri: n,
				id: r
			});
			let o = TK(this.main, a);
			this.targetDuration = a.partTargetDuration || a.targetDuration, this.pendingMedia_ = null, o ? (this.main = o, this.media_ = this.main.playlists[r]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(EK(this.media(), !!o)), i.parsedPlaylist = DK(this.main.playlists, i.playlistInfo.type, !this.media_.endList), this.trigger({
				type: "playlistparsecomplete",
				metadata: i
			}), this.trigger("loadedplaylist");
		}
		dispose() {
			this.trigger("dispose"), this.stopRequest(), X.default.clearTimeout(this.mediaUpdateTimeout), X.default.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new cK(), this.off();
		}
		stopRequest() {
			if (this.request) {
				let e = this.request;
				this.request = null, e.onreadystatechange = null, e.abort();
			}
		}
		media(e, t) {
			if (!e) return this.media_;
			if (this.state === "HAVE_NOTHING") throw Error("Cannot switch media playlist from " + this.state);
			if (typeof e == "string") {
				if (!this.main.playlists[e]) throw Error("Unknown playlist URI: " + e);
				e = this.main.playlists[e];
			}
			if (X.default.clearTimeout(this.finalRenditionTimeout), t) {
				let t = (e.partTargetDuration || e.targetDuration) / 2 * 1e3 || 5e3;
				this.finalRenditionTimeout = X.default.setTimeout(this.media.bind(this, e, !1), t);
				return;
			}
			let n = this.state, r = !this.media_ || e.id !== this.media_.id, i = this.main.playlists[e.id];
			if (i && i.endList || e.endList && e.segments.length) {
				this.request &&= (this.request.onreadystatechange = null, this.request.abort(), null), this.state = "HAVE_METADATA", this.media_ = e, r && (this.trigger("mediachanging"), n === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
				return;
			}
			if (this.updateMediaUpdateTimeout_(EK(e, !0)), !r) return;
			if (this.state = "SWITCHING_MEDIA", this.request) {
				if (e.resolvedUri === this.request.url) return;
				this.request.onreadystatechange = null, this.request.abort(), this.request = null;
			}
			this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = e;
			let a = { playlistInfo: {
				type: "media",
				uri: e.uri
			} };
			this.trigger({
				type: "playlistrequeststart",
				metadata: a
			}), this.request = this.vhs_.xhr({
				uri: e.resolvedUri,
				withCredentials: this.withCredentials,
				requestType: "hls-playlist"
			}, (t, r) => {
				if (this.request) {
					if (e.lastRequest = Date.now(), e.resolvedUri = fG(e.resolvedUri, r), t) return this.playlistRequestError(this.request, e, n);
					this.trigger({
						type: "playlistrequestcomplete",
						metadata: a
					}), this.haveMetadata({
						playlistString: r.responseText,
						url: e.uri,
						id: e.id
					}), n === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
				}
			});
		}
		pause() {
			this.mediaUpdateTimeout &&= (X.default.clearTimeout(this.mediaUpdateTimeout), null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.state = this.media_ ? "HAVE_METADATA" : "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
		}
		load(e) {
			this.mediaUpdateTimeout &&= (X.default.clearTimeout(this.mediaUpdateTimeout), null);
			let t = this.media();
			if (e) {
				let e = t ? (t.partTargetDuration || t.targetDuration) / 2 * 1e3 : 5e3;
				this.mediaUpdateTimeout = X.default.setTimeout(() => {
					this.mediaUpdateTimeout = null, this.load();
				}, e);
				return;
			}
			if (!this.started) {
				this.start();
				return;
			}
			t && !t.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
		}
		updateMediaUpdateTimeout_(e) {
			this.mediaUpdateTimeout &&= (X.default.clearTimeout(this.mediaUpdateTimeout), null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = X.default.setTimeout(() => {
				this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(e);
			}, e));
		}
		start() {
			if (this.started = !0, typeof this.src == "object") {
				this.src.uri || (this.src.uri = X.default.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
					this.setupInitialPlaylist(this.src);
				}, 0);
				return;
			}
			let e = { playlistInfo: {
				type: "multivariant",
				uri: this.src
			} };
			this.trigger({
				type: "playlistrequeststart",
				metadata: e
			}), this.request = this.vhs_.xhr({
				uri: this.src,
				withCredentials: this.withCredentials,
				requestType: "hls-playlist"
			}, (t, n) => {
				if (!this.request) return;
				if (this.request = null, t) return this.error = {
					status: n.status,
					message: `HLS playlist request error at URL: ${this.src}.`,
					responseText: n.responseText,
					code: 2,
					metadata: uK({
						requestType: n.requestType,
						request: n,
						error: t
					})
				}, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
				this.trigger({
					type: "playlistrequestcomplete",
					metadata: e
				}), this.src = fG(this.src, n), this.trigger({
					type: "playlistparsestart",
					metadata: e
				});
				let r = this.parseManifest_({
					manifestString: n.responseText,
					url: this.src
				});
				e.parsedPlaylist = DK(r.playlists, e.playlistInfo.type, !1), this.trigger({
					type: "playlistparsecomplete",
					metadata: e
				}), this.setupInitialPlaylist(r);
			});
		}
		srcUri() {
			return typeof this.src == "string" ? this.src : this.src.uri;
		}
		setupInitialPlaylist(e) {
			if (this.state = "HAVE_MAIN_MANIFEST", e.playlists) {
				this.main = e, sK(this.main, this.srcUri()), e.playlists.forEach((e) => {
					e.segments = CK(e), e.segments.forEach((t) => {
						SK(t, e.resolvedUri);
					});
				}), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
				return;
			}
			let t = this.srcUri() || X.default.location.href;
			this.main = oK(e, t), this.haveMetadata({
				playlistObject: e,
				url: t,
				id: this.main.playlists[0].id
			}), this.trigger("loadedmetadata");
		}
		updateOrDeleteClone(e, t) {
			let n = this.main, r = e.ID, i = n.playlists.length;
			for (; i--;) {
				let a = n.playlists[i];
				if (a.attributes["PATHWAY-ID"] === r) {
					let o = a.resolvedUri, s = a.id;
					if (t) {
						let t = this.createCloneURI_(a.resolvedUri, e), o = $G(r, t), s = this.createCloneAttributes_(r, a.attributes), c = this.createClonePlaylist_(a, o, e, s);
						n.playlists[i] = c, n.playlists[o] = c, n.playlists[t] = c;
					} else n.playlists.splice(i, 1);
					delete n.playlists[s], delete n.playlists[o];
				}
			}
			this.updateOrDeleteCloneMedia(e, t);
		}
		updateOrDeleteCloneMedia(e, t) {
			let n = this.main, r = e.ID;
			[
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((e) => {
				if (!(!n.mediaGroups[e] || !n.mediaGroups[e][r])) {
					for (let t in n.mediaGroups[e]) if (t === r) {
						for (let r in n.mediaGroups[e][t]) n.mediaGroups[e][t][r].playlists.forEach((e, t) => {
							let r = n.playlists[e.id], i = r.id, a = r.resolvedUri;
							delete n.playlists[i], delete n.playlists[a];
						});
						delete n.mediaGroups[e][t];
					}
				}
			}), t && this.createClonedMediaGroups_(e);
		}
		addClonePathway(e, t = {}) {
			let n = this.main, r = n.playlists.length, i = this.createCloneURI_(t.resolvedUri, e), a = $G(e.ID, i), o = this.createCloneAttributes_(e.ID, t.attributes), s = this.createClonePlaylist_(t, a, e, o);
			n.playlists[r] = s, n.playlists[a] = s, n.playlists[i] = s, this.createClonedMediaGroups_(e);
		}
		createClonedMediaGroups_(e) {
			let t = e.ID, n = e["BASE-ID"], r = this.main;
			[
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((i) => {
				if (!(!r.mediaGroups[i] || r.mediaGroups[i][t])) for (let a in r.mediaGroups[i]) {
					if (a === n) r.mediaGroups[i][t] = {};
					else continue;
					for (let n in r.mediaGroups[i][a]) {
						let o = r.mediaGroups[i][a][n];
						r.mediaGroups[i][t][n] = wF({}, o);
						let s = r.mediaGroups[i][t][n], c = this.createCloneURI_(o.resolvedUri, e);
						s.resolvedUri = c, s.uri = c, s.playlists = [], o.playlists.forEach((a, o) => {
							let c = r.playlists[a.id], l = eK(i, t, n), u = $G(t, l);
							if (c && !r.playlists[u]) {
								let t = this.createClonePlaylist_(c, u, e), n = t.resolvedUri;
								r.playlists[u] = t, r.playlists[n] = t;
							}
							s.playlists[o] = this.createClonePlaylist_(a, u, e);
						});
					}
				}
			});
		}
		createClonePlaylist_(e, t, n, r) {
			let i = this.createCloneURI_(e.resolvedUri, n), a = {
				resolvedUri: i,
				uri: i,
				id: t
			};
			return e.segments && (a.segments = []), r && (a.attributes = r), SB(e, a);
		}
		createCloneURI_(e, t) {
			let n = new URL(e);
			n.hostname = t["URI-REPLACEMENT"].HOST;
			let r = t["URI-REPLACEMENT"].PARAMS;
			for (let e of Object.keys(r)) n.searchParams.set(e, r[e]);
			return n.href;
		}
		createCloneAttributes_(e, t) {
			let n = { "PATHWAY-ID": e };
			return [
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((r) => {
				t[r] && (n[r] = e);
			}), n;
		}
		getKeyIdSet(e) {
			let t = /* @__PURE__ */ new Set();
			if (!e || !e.contentProtection) return t;
			for (let n in e.contentProtection) if (e.contentProtection[n] && e.contentProtection[n].attributes && e.contentProtection[n].attributes.keyId) {
				let r = e.contentProtection[n].attributes.keyId;
				t.add(r.toLowerCase());
			}
			return t;
		}
	}, kK = function(e, t, n, r) {
		let i = e.responseType === "arraybuffer" ? e.response : e.responseText;
		!t && i && (e.responseTime = Date.now(), e.roundTripTime = e.responseTime - e.requestTime, e.bytesReceived = i.byteLength || i.length, e.bandwidth ||= Math.floor(e.bytesReceived / e.roundTripTime * 8 * 1e3)), n.headers && (e.responseHeaders = n.headers), t && t.code === "ETIMEDOUT" && (e.timedout = !0), !t && !e.aborted && n.statusCode !== 200 && n.statusCode !== 206 && n.statusCode !== 0 && (t = /* @__PURE__ */ Error("XHR Failed with a response of: " + (e && (i || e.responseText)))), r(t, e);
	}, AK = (e, t) => {
		if (!e || !e.size) return;
		let n = t;
		return e.forEach((e) => {
			n = e(n);
		}), n;
	}, jK = (e, t, n, r) => {
		!e || !e.size || e.forEach((e) => {
			e(t, n, r);
		});
	}, MK = function() {
		let e = function e(t, n) {
			t = SB({ timeout: 45e3 }, t);
			let r = e.beforeRequest || Y.Vhs.xhr.beforeRequest, i = e._requestCallbackSet || Y.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), a = e._responseCallbackSet || Y.Vhs.xhr._responseCallbackSet;
			r && typeof r == "function" && (Y.log.warn("beforeRequest is deprecated, use onRequest instead."), i.add(r));
			let o = Y.Vhs.xhr.original === !0 ? Y.xhr : Y.Vhs.xhr, s = AK(i, t);
			i.delete(r);
			let c = o(s || t, function(e, t) {
				return jK(a, c, e, t), kK(c, e, t, n);
			}), l = c.abort;
			return c.abort = function() {
				return c.aborted = !0, l.apply(c, arguments);
			}, c.uri = t.uri, c.requestType = t.requestType, c.requestTime = Date.now(), c;
		};
		return e.original = !0, e;
	}, NK = function(e) {
		let t, n = e.offset;
		return t = typeof e.offset == "bigint" || typeof e.length == "bigint" ? X.default.BigInt(e.offset) + X.default.BigInt(e.length) - X.default.BigInt(1) : e.offset + e.length - 1, "bytes=" + n + "-" + t;
	}, PK = function(e) {
		let t = {};
		return e.byterange && (t.Range = NK(e.byterange)), t;
	}, FK = function(e, t) {
		return e.start(t) + "-" + e.end(t);
	}, IK = function(e, t) {
		let n = e.toString(16);
		return "00".substring(0, 2 - n.length) + n + (t % 2 ? " " : "");
	}, LK = function(e) {
		return e >= 32 && e < 126 ? String.fromCharCode(e) : ".";
	}, RK = function(e) {
		let t = {};
		return Object.keys(e).forEach((n) => {
			let r = e[n];
			mI(r) ? t[n] = {
				bytes: r.buffer,
				byteOffset: r.byteOffset,
				byteLength: r.byteLength
			} : t[n] = r;
		}), t;
	}, zK = function(e) {
		let t = e.byterange || {
			length: Infinity,
			offset: 0
		};
		return [
			t.length,
			t.offset,
			e.resolvedUri
		].join(",");
	}, BK = function(e) {
		return e.resolvedUri;
	}, VK = (e) => {
		let t = Array.prototype.slice.call(e), n = "", r, i;
		for (let e = 0; e < t.length / 16; e++) r = t.slice(e * 16, e * 16 + 16).map(IK).join(""), i = t.slice(e * 16, e * 16 + 16).map(LK).join(""), n += r + " " + i + "\n";
		return n;
	}, HK = ({ bytes: e }) => VK(e), UK = (e) => {
		let t = "", n;
		for (n = 0; n < e.length; n++) t += FK(e, n) + " ";
		return t;
	}, WK = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		createTransferableMessage: RK,
		initSegmentId: zK,
		segmentKeyId: BK,
		hexDump: VK,
		tagDump: HK,
		textRanges: UK
	}), GK = .25, KK = (e, t) => {
		if (!t.dateTimeObject) return null;
		let n = t.videoTimingInfo.transmuxerPrependedSeconds, r = e - (t.videoTimingInfo.transmuxedPresentationStart + n);
		return new Date(t.dateTimeObject.getTime() + r * 1e3);
	}, qK = (e) => e.transmuxedPresentationEnd - e.transmuxedPresentationStart - e.transmuxerPrependedSeconds, JK = (e, t) => {
		let n;
		try {
			n = new Date(e);
		} catch {
			return null;
		}
		if (!t || !t.segments || t.segments.length === 0) return null;
		let r = t.segments[0];
		if (n < new Date(r.dateTimeObject)) return null;
		for (let e = 0; e < t.segments.length - 1; e++) {
			r = t.segments[e];
			let i = new Date(t.segments[e + 1].dateTimeObject);
			if (n < i) break;
		}
		let i = t.segments[t.segments.length - 1], a = i.dateTimeObject, o = i.videoTimingInfo ? qK(i.videoTimingInfo) : i.duration + i.duration * GK, s = new Date(a.getTime() + o * 1e3);
		return n > s ? null : (n > new Date(a) && (r = i), {
			segment: r,
			estimatedStart: r.videoTimingInfo ? r.videoTimingInfo.transmuxedPresentationStart : ZG.duration(t, t.mediaSequence + t.segments.indexOf(r)),
			type: r.videoTimingInfo ? "accurate" : "estimate"
		});
	}, YK = (e, t) => {
		if (!t || !t.segments || t.segments.length === 0) return null;
		let n = 0, r;
		for (let i = 0; i < t.segments.length && (r = t.segments[i], n = r.videoTimingInfo ? r.videoTimingInfo.transmuxedPresentationEnd : n + r.duration, !(e <= n)); i++);
		let i = t.segments[t.segments.length - 1];
		if (i.videoTimingInfo && i.videoTimingInfo.transmuxedPresentationEnd < e) return null;
		if (e > n) {
			if (e > n + i.duration * GK) return null;
			r = i;
		}
		return {
			segment: r,
			estimatedStart: r.videoTimingInfo ? r.videoTimingInfo.transmuxedPresentationStart : n - r.duration,
			type: r.videoTimingInfo ? "accurate" : "estimate"
		};
	}, XK = (e, t) => {
		let n, r;
		try {
			n = new Date(e), r = new Date(t);
		} catch {}
		let i = n.getTime();
		return (r.getTime() - i) / 1e3;
	}, ZK = (e) => {
		if (!e.segments || e.segments.length === 0) return !1;
		for (let t = 0; t < e.segments.length; t++) if (!e.segments[t].dateTimeObject) return !1;
		return !0;
	}, QK = ({ playlist: e, time: t = void 0, callback: n }) => {
		if (!n) throw Error("getProgramTime: callback must be provided");
		if (!e || t === void 0) return n({ message: "getProgramTime: playlist and time must be provided" });
		let r = YK(t, e);
		if (!r) return n({ message: "valid programTime was not found" });
		if (r.type === "estimate") return n({
			message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
			seekTime: r.estimatedStart
		});
		let i = { mediaSeconds: t }, a = KK(t, r.segment);
		return a && (i.programDateTime = a.toISOString()), n(null, i);
	}, $K = ({ programTime: e, playlist: t, retryCount: n = 2, seekTo: r, pauseAfterSeek: i = !0, tech: a, callback: o }) => {
		if (!o) throw Error("seekToProgramTime: callback must be provided");
		if (e === void 0 || !t || !r) return o({ message: "seekToProgramTime: programTime, seekTo and playlist must be provided" });
		if (!t.endList && !a.hasStarted_) return o({ message: "player must be playing a live stream to start buffering" });
		if (!ZK(t)) return o({ message: "programDateTime tags must be provided in the manifest " + t.resolvedUri });
		let s = JK(e, t);
		if (!s) return o({ message: `${e} was not found in the stream` });
		let c = s.segment, l = XK(c.dateTimeObject, e);
		if (s.type === "estimate") {
			if (n === 0) return o({ message: `${e} is not buffered yet. Try again` });
			r(s.estimatedStart + l), a.one("seeked", () => {
				$K({
					programTime: e,
					playlist: t,
					retryCount: n - 1,
					seekTo: r,
					pauseAfterSeek: i,
					tech: a,
					callback: o
				});
			});
			return;
		}
		let u = c.start + l;
		a.one("seeked", () => o(null, a.currentTime())), i && a.pause(), r(u);
	}, eq = (e, t) => {
		if (e.readyState === 4) return t();
	}, tq = (e, t, n, r) => {
		let i = [], a, o = !1, s = function(e, t, r, i) {
			return t.abort(), o = !0, n(e, t, r, i);
		}, c = function(e, t) {
			if (o) return;
			if (e) return e.metadata = uK({
				requestType: r,
				request: t,
				error: e
			}), s(e, t, "", i);
			let n = t.responseText.substring(i && i.byteLength || 0, t.responseText.length);
			if (i = CI(i, SI(n, !0)), a ||= lR(i), i.length < 10 || a && i.length < a + 2) return eq(t, () => s(e, t, "", i));
			let c = BR(i);
			return c === "ts" && i.length < 188 || !c && i.length < 376 ? eq(t, () => s(e, t, "", i)) : s(null, t, c, i);
		}, l = t({
			uri: e,
			beforeSend(e) {
				e.overrideMimeType("text/plain; charset=x-user-defined"), e.addEventListener("progress", function({ total: t, loaded: n }) {
					return kK(e, null, { statusCode: e.status }, c);
				});
			}
		}, function(e, t) {
			return kK(l, e, t, c);
		});
		return l;
	}, {EventTarget: nq} = Y, rq = function(e, t) {
		if (!wK(e, t) || e.sidx && t.sidx && (e.sidx.offset !== t.sidx.offset || e.sidx.length !== t.sidx.length) || !e.sidx && t.sidx || e.sidx && !t.sidx || e.segments && !t.segments || !e.segments && t.segments) return !1;
		if (!e.segments && !t.segments) return !0;
		for (let n = 0; n < e.segments.length; n++) {
			let r = e.segments[n], i = t.segments[n];
			if (r.uri !== i.uri) return !1;
			if (!r.byterange && !i.byterange) continue;
			let a = r.byterange, o = i.byterange;
			if (a && !o || !a && o || a.offset !== o.offset || a.length !== o.length) return !1;
		}
		return !0;
	}, iq = (e, t, n, r) => `placeholder-uri-${e}-${t}-${r.attributes.NAME || n}`, aq = ({ mainXml: e, srcUrl: t, clientOffset: n, sidxMapping: r, previousManifest: i }) => {
		let a = nR(e, {
			manifestUri: t,
			clientOffset: n,
			sidxMapping: r,
			previousManifest: i
		});
		return sK(a, t, iq), a;
	}, oq = (e, t) => {
		nK(e, (n, r, i, a) => {
			(!t.mediaGroups[r][i] || !(a in t.mediaGroups[r][i])) && delete e.mediaGroups[r][i][a];
		});
	}, sq = (e, t, n) => {
		let r = !0, i = SB(e, {
			duration: t.duration,
			minimumUpdatePeriod: t.minimumUpdatePeriod,
			timelineStarts: t.timelineStarts
		});
		for (let e = 0; e < t.playlists.length; e++) {
			let a = t.playlists[e];
			if (a.sidx) {
				let e = sL(a.sidx);
				n && n[e] && n[e].sidx && QI(a, n[e].sidx, a.sidx.resolvedUri);
			}
			let o = TK(i, a, rq);
			o && (i = o, r = !1);
		}
		return nK(t, (e, t, n, a) => {
			if (e.playlists && e.playlists.length) {
				let o = e.playlists[0].id, s = TK(i, e.playlists[0], rq);
				s && (i = s, a in i.mediaGroups[t][n] || (i.mediaGroups[t][n][a] = e), i.mediaGroups[t][n][a].playlists[0] = i.playlists[o], r = !1);
			}
		}), oq(i, t), t.minimumUpdatePeriod !== e.minimumUpdatePeriod && (r = !1), r ? null : i;
	}, cq = (e, t) => (!e.map && !t.map || !!(e.map && t.map && e.map.byterange.offset === t.map.byterange.offset && e.map.byterange.length === t.map.byterange.length)) && e.uri === t.uri && e.byterange.offset === t.byterange.offset && e.byterange.length === t.byterange.length, lq = (e, t) => {
		let n = {};
		for (let r in e) {
			let i = e[r].sidx;
			if (i) {
				let e = sL(i);
				if (!t[e]) break;
				let r = t[e].sidxInfo;
				cq(r, i) && (n[e] = t[e]);
			}
		}
		return n;
	}, uq = (e, t) => {
		let n = lq(e.playlists, t);
		return nK(e, (e, r, i, a) => {
			if (e.playlists && e.playlists.length) {
				let r = e.playlists;
				n = SB(n, lq(r, t));
			}
		}), n;
	}, dq = class extends nq {
		constructor(e, t, n = {}, r) {
			super(), this.isPaused_ = !0, this.mainPlaylistLoader_ = r || this, r || (this.isMain_ = !0);
			let { withCredentials: i = !1 } = n;
			if (this.vhs_ = t, this.withCredentials = i, this.addMetadataToTextTrack = n.addMetadataToTextTrack, !e) throw Error("A non-empty playlist URL or object is required");
			this.on("minimumUpdatePeriod", () => {
				this.refreshXml_();
			}), this.on("mediaupdatetimeout", () => {
				this.refreshMedia_(this.media().id);
			}), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = pG("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = e, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = e;
		}
		get isPaused() {
			return this.isPaused_;
		}
		requestErrored_(e, t, n) {
			if (!this.request) return !0;
			if (this.request = null, e) return this.error = typeof e == "object" && !(e instanceof Error) ? e : {
				status: t.status,
				message: "DASH request error at URL: " + t.uri,
				response: t.response,
				code: 2,
				metadata: e.metadata
			}, n && (this.state = n), this.trigger("error"), !0;
		}
		addSidxSegments_(e, t, n) {
			let r = e.sidx && sL(e.sidx);
			if (!e.sidx || !r || this.mainPlaylistLoader_.sidxMapping_[r]) {
				X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = X.default.setTimeout(() => n(!1), 0);
				return;
			}
			let i = fG(e.sidx.resolvedUri), a = (i, a) => {
				if (this.requestErrored_(i, a, t)) return;
				let o = this.mainPlaylistLoader_.sidxMapping_, { requestType: s } = a, c;
				try {
					c = (0, kB.default)(gI(a.response).subarray(8));
				} catch (e) {
					e.metadata = uK({
						requestType: s,
						request: a,
						parseFailure: !0
					}), this.requestErrored_(e, a, t);
					return;
				}
				return o[r] = {
					sidxInfo: e.sidx,
					sidx: c
				}, QI(e, c, e.sidx.resolvedUri), n(!0);
			};
			this.request = tq(i, this.vhs_.xhr, (t, n, r, o) => {
				if (t) return a(t, n);
				if (!r || r !== "mp4") {
					let t = r || "unknown";
					return a({
						status: n.status,
						message: `Unsupported ${t} container type for sidx segment at URL: ${i}`,
						response: "",
						playlist: e,
						internal: !0,
						playlistExclusionDuration: Infinity,
						code: 2
					}, n);
				}
				let { offset: s, length: c } = e.sidx.byterange;
				if (o.length >= c + s) return a(t, {
					response: o.subarray(s, s + c),
					status: n.status,
					uri: n.uri
				});
				this.request = this.vhs_.xhr({
					uri: i,
					responseType: "arraybuffer",
					requestType: "dash-sidx",
					headers: PK({ byterange: e.sidx.byterange })
				}, a);
			}, "dash-sidx");
		}
		dispose() {
			this.isPaused_ = !0, this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, X.default.clearTimeout(this.minimumUpdatePeriodTimeout_), X.default.clearTimeout(this.mediaRequest_), X.default.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
		}
		hasPendingRequest() {
			return this.request || this.mediaRequest_;
		}
		stopRequest() {
			if (this.request) {
				let e = this.request;
				this.request = null, e.onreadystatechange = null, e.abort();
			}
		}
		media(e) {
			if (!e) return this.media_;
			if (this.state === "HAVE_NOTHING") throw Error("Cannot switch media playlist from " + this.state);
			let t = this.state;
			if (typeof e == "string") {
				if (!this.mainPlaylistLoader_.main.playlists[e]) throw Error("Unknown playlist URI: " + e);
				e = this.mainPlaylistLoader_.main.playlists[e];
			}
			let n = !this.media_ || e.id !== this.media_.id;
			if (n && this.loadedPlaylists_[e.id] && this.loadedPlaylists_[e.id].endList) {
				this.state = "HAVE_METADATA", this.media_ = e, n && (this.trigger("mediachanging"), this.trigger("mediachange"));
				return;
			}
			n && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(e, t, (n) => {
				this.haveMetadata({
					startingState: t,
					playlist: e
				});
			}));
		}
		haveMetadata({ startingState: e, playlist: t }) {
			this.state = "HAVE_METADATA", this.loadedPlaylists_[t.id] = t, X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null, this.refreshMedia_(t.id), e === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
		}
		pause() {
			this.isPaused_ = !0, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), X.default.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (X.default.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
		}
		load(e) {
			this.isPaused_ = !1, X.default.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
			let t = this.media();
			if (e) {
				let e = t ? t.targetDuration / 2 * 1e3 : 5e3;
				this.mediaUpdateTimeout = X.default.setTimeout(() => this.load(), e);
				return;
			}
			if (!this.started) {
				this.start();
				return;
			}
			t && !t.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
		}
		start() {
			if (this.started = !0, !this.isMain_) {
				X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = X.default.setTimeout(() => this.haveMain_(), 0);
				return;
			}
			this.requestMain_((e, t) => {
				this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
			});
		}
		requestMain_(e) {
			let t = { manifestInfo: { uri: this.mainPlaylistLoader_.srcUrl } };
			this.trigger({
				type: "manifestrequeststart",
				metadata: t
			}), this.request = this.vhs_.xhr({
				uri: this.mainPlaylistLoader_.srcUrl,
				withCredentials: this.withCredentials,
				requestType: "dash-manifest"
			}, (n, r) => {
				if (n) {
					let { requestType: e } = r;
					n.metadata = uK({
						requestType: e,
						request: r,
						error: n
					});
				}
				if (this.requestErrored_(n, r)) {
					this.state === "HAVE_NOTHING" && (this.started = !1);
					return;
				}
				this.trigger({
					type: "manifestrequestcomplete",
					metadata: t
				});
				let i = r.responseText !== this.mainPlaylistLoader_.mainXml_;
				if (this.mainPlaylistLoader_.mainXml_ = r.responseText, this.mainLoaded_ = r.responseHeaders && r.responseHeaders.date ? Date.parse(r.responseHeaders.date) : Date.now(), this.mainPlaylistLoader_.srcUrl = fG(this.mainPlaylistLoader_.srcUrl, r), i) {
					this.handleMain_(), this.syncClientServerClock_(() => e(r, i));
					return;
				}
				return e(r, i);
			});
		}
		syncClientServerClock_(e) {
			let t = rR(this.mainPlaylistLoader_.mainXml_);
			if (t === null) return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
			if (t.method === "DIRECT") return this.mainPlaylistLoader_.clientOffset_ = t.value - Date.now(), e();
			this.request = this.vhs_.xhr({
				uri: dG(this.mainPlaylistLoader_.srcUrl, t.value),
				method: t.method,
				withCredentials: this.withCredentials,
				requestType: "dash-clock-sync"
			}, (n, r) => {
				if (!this.request) return;
				if (n) {
					let { requestType: t } = r;
					return this.error.metadata = uK({
						requestType: t,
						request: r,
						error: n
					}), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
				}
				let i;
				i = t.method === "HEAD" ? !r.responseHeaders || !r.responseHeaders.date ? this.mainLoaded_ : Date.parse(r.responseHeaders.date) : Date.parse(r.responseText), this.mainPlaylistLoader_.clientOffset_ = i - Date.now(), e();
			});
		}
		haveMain_() {
			this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
		}
		handleMain_() {
			X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null;
			let e = this.mainPlaylistLoader_.main, t = { manifestInfo: { uri: this.mainPlaylistLoader_.srcUrl } };
			this.trigger({
				type: "manifestparsestart",
				metadata: t
			});
			let n;
			try {
				n = aq({
					mainXml: this.mainPlaylistLoader_.mainXml_,
					srcUrl: this.mainPlaylistLoader_.srcUrl,
					clientOffset: this.mainPlaylistLoader_.clientOffset_,
					sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
					previousManifest: e
				});
			} catch (e) {
				this.error = e, this.error.metadata = {
					errorType: Y.Error.StreamingDashManifestParserError,
					error: e
				}, this.trigger("error");
			}
			e && (n = sq(e, n, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = n || e;
			let r = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
			if (r && r !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = r), (!e || n && n.minimumUpdatePeriod !== e.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(n), n) {
				let { duration: e, endList: r } = n, i = [];
				n.playlists.forEach((e) => {
					i.push({
						id: e.id,
						bandwidth: e.attributes.BANDWIDTH,
						resolution: e.attributes.RESOLUTION,
						codecs: e.attributes.CODECS
					});
				}), t.parsedManifest = {
					duration: e,
					isLive: !r,
					renditions: i
				}, this.trigger({
					type: "manifestparsecomplete",
					metadata: t
				});
			}
			return !!n;
		}
		updateMinimumUpdatePeriodTimeout_() {
			let e = this.mainPlaylistLoader_;
			e.createMupOnMedia_ &&= (e.off("loadedmetadata", e.createMupOnMedia_), null), e.minimumUpdatePeriodTimeout_ &&= (X.default.clearTimeout(e.minimumUpdatePeriodTimeout_), null);
			let t = e.main && e.main.minimumUpdatePeriod;
			if (t === 0 && (e.media() ? t = e.media().targetDuration * 1e3 : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), typeof t != "number" || t <= 0) {
				t < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${t}, not setting a timeout`);
				return;
			}
			this.createMUPTimeout_(t);
		}
		createMUPTimeout_(e) {
			let t = this.mainPlaylistLoader_;
			t.minimumUpdatePeriodTimeout_ = X.default.setTimeout(() => {
				t.minimumUpdatePeriodTimeout_ = null, t.trigger("minimumUpdatePeriod"), t.createMUPTimeout_(e);
			}, e);
		}
		refreshXml_() {
			this.requestMain_((e, t) => {
				t && (this.media_ &&= this.mainPlaylistLoader_.main.playlists[this.media_.id], this.mainPlaylistLoader_.sidxMapping_ = uq(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (e) => {
					this.refreshMedia_(this.media().id);
				}));
			});
		}
		refreshMedia_(e) {
			if (!e) throw Error("refreshMedia_ must take a media id");
			this.media_ && this.isMain_ && this.handleMain_();
			let t = this.mainPlaylistLoader_.main.playlists, n = !this.media_ || this.media_ !== t[e];
			if (n ? this.media_ = t[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
				let e = () => {
					this.media().endList || (this.mediaUpdateTimeout = X.default.setTimeout(() => {
						this.trigger("mediaupdatetimeout"), e();
					}, EK(this.media(), !!n)));
				};
				e();
			}
			this.trigger("loadedplaylist");
		}
		addEventStreamToMetadataTrack_(e) {
			if (e && this.mainPlaylistLoader_.main.eventStream) {
				let e = this.mainPlaylistLoader_.main.eventStream.map((e) => ({
					cueTime: e.start,
					frames: [{ data: e.messageData }]
				}));
				this.addMetadataToTextTrack("EventStream", e, this.mainPlaylistLoader_.main.duration);
			}
		}
		getKeyIdSet(e) {
			if (e.contentProtection) {
				let t = /* @__PURE__ */ new Set();
				for (let n in e.contentProtection) {
					let r = e.contentProtection[n].attributes["cenc:default_KID"];
					r && t.add(r.replace(/-/g, "").toLowerCase());
				}
				return t;
			}
		}
	}, fq = {
		GOAL_BUFFER_LENGTH: 30,
		MAX_GOAL_BUFFER_LENGTH: 60,
		BACK_BUFFER_LENGTH: 30,
		GOAL_BUFFER_LENGTH_RATE: 1,
		INITIAL_BANDWIDTH: 4194304,
		BANDWIDTH_VARIANCE: 1.2,
		BUFFER_LOW_WATER_LINE: 0,
		MAX_BUFFER_LOW_WATER_LINE: 30,
		EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
		BUFFER_LOW_WATER_LINE_RATE: 1,
		BUFFER_HIGH_WATER_LINE: 30
	}, pq = (e) => {
		let t = new Uint8Array(new ArrayBuffer(e.length));
		for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
		return t.buffer;
	}, mq = function(e) {
		return e.on = e.addEventListener, e.off = e.removeEventListener, e;
	}, hq = function(e) {
		try {
			return URL.createObjectURL(new Blob([e], { type: "application/javascript" }));
		} catch {
			let t = new BlobBuilder();
			return t.append(e), URL.createObjectURL(t.getBlob());
		}
	}, gq = function(e) {
		return function() {
			let t = hq(e), n = mq(new Worker(t));
			n.objURL = t;
			let r = n.terminate;
			return n.on = n.addEventListener, n.off = n.removeEventListener, n.terminate = function() {
				return URL.revokeObjectURL(t), r.call(this);
			}, n;
		};
	}, _q = function(e) {
		return `var browserWorkerPolyFill = ${mq.toString()};\nbrowserWorkerPolyFill(self);
` + e;
	}, vq = function(e) {
		return e.toString().replace(/^function.+?{/, "").slice(0, -1);
	}, yq = gq(_q(vq(function() {
		var e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, t = function() {
			this.init = function() {
				var e = {};
				this.on = function(t, n) {
					e[t] || (e[t] = []), e[t] = e[t].concat(n);
				}, this.off = function(t, n) {
					var r;
					return e[t] ? (r = e[t].indexOf(n), e[t] = e[t].slice(), e[t].splice(r, 1), r > -1) : !1;
				}, this.trigger = function(t) {
					var n = e[t], r, i, a;
					if (n) if (arguments.length === 2) for (i = n.length, r = 0; r < i; ++r) n[r].call(this, arguments[1]);
					else {
						for (a = [], r = arguments.length, r = 1; r < arguments.length; ++r) a.push(arguments[r]);
						for (i = n.length, r = 0; r < i; ++r) n[r].apply(this, a);
					}
				}, this.dispose = function() {
					e = {};
				};
			};
		};
		t.prototype.pipe = function(e) {
			return this.on("data", function(t) {
				e.push(t);
			}), this.on("done", function(t) {
				e.flush(t);
			}), this.on("partialdone", function(t) {
				e.partialFlush(t);
			}), this.on("endedtimeline", function(t) {
				e.endTimeline(t);
			}), this.on("reset", function(t) {
				e.reset(t);
			}), e;
		}, t.prototype.push = function(e) {
			this.trigger("data", e);
		}, t.prototype.flush = function(e) {
			this.trigger("done", e);
		}, t.prototype.partialFlush = function(e) {
			this.trigger("partialdone", e);
		}, t.prototype.endTimeline = function(e) {
			this.trigger("endedtimeline", e);
		}, t.prototype.reset = function(e) {
			this.trigger("reset", e);
		};
		var n = t, r = 2 ** 32, i = {
			getUint64: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n;
				return t.getBigUint64 ? (n = t.getBigUint64(0), n < 2 ** 53 - 1 ? Number(n) : n) : t.getUint32(0) * r + t.getUint32(4);
			},
			MAX_UINT32: r
		}, a = i.MAX_UINT32, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, ee, D, O, te, k, ne, re, ie, ae, A, oe, se, ce, le, j;
		(function() {
			var e;
			if (D = {
				avc1: [],
				avcC: [],
				btrt: [],
				dinf: [],
				dref: [],
				esds: [],
				ftyp: [],
				hdlr: [],
				mdat: [],
				mdhd: [],
				mdia: [],
				mfhd: [],
				minf: [],
				moof: [],
				moov: [],
				mp4a: [],
				mvex: [],
				mvhd: [],
				pasp: [],
				sdtp: [],
				smhd: [],
				stbl: [],
				stco: [],
				stsc: [],
				stsd: [],
				stsz: [],
				stts: [],
				styp: [],
				tfdt: [],
				tfhd: [],
				traf: [],
				trak: [],
				trun: [],
				trex: [],
				tkhd: [],
				vmhd: []
			}, !(typeof Uint8Array > "u")) {
				for (e in D) D.hasOwnProperty(e) && (D[e] = [
					e.charCodeAt(0),
					e.charCodeAt(1),
					e.charCodeAt(2),
					e.charCodeAt(3)
				]);
				O = new Uint8Array([
					105,
					115,
					111,
					109
				]), k = new Uint8Array([
					97,
					118,
					99,
					49
				]), te = new Uint8Array([
					0,
					0,
					0,
					1
				]), ne = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					118,
					105,
					100,
					101,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					86,
					105,
					100,
					101,
					111,
					72,
					97,
					110,
					100,
					108,
					101,
					114,
					0
				]), re = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					115,
					111,
					117,
					110,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					83,
					111,
					117,
					110,
					100,
					72,
					97,
					110,
					100,
					108,
					101,
					114,
					0
				]), ie = {
					video: ne,
					audio: re
				}, oe = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					12,
					117,
					114,
					108,
					32,
					0,
					0,
					0,
					1
				]), A = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]), se = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]), ce = se, le = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]), j = se, ae = new Uint8Array([
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]);
			}
		})(), o = function(e) {
			var t = [], n = 0, r, i, a;
			for (r = 1; r < arguments.length; r++) t.push(arguments[r]);
			for (r = t.length; r--;) n += t[r].byteLength;
			for (i = new Uint8Array(n + 8), a = new DataView(i.buffer, i.byteOffset, i.byteLength), a.setUint32(0, i.byteLength), i.set(e, 4), r = 0, n = 8; r < t.length; r++) i.set(t[r], n), n += t[r].byteLength;
			return i;
		}, s = function() {
			return o(D.dinf, o(D.dref, oe));
		}, c = function(e) {
			return o(D.esds, new Uint8Array([
				0,
				0,
				0,
				0,
				3,
				25,
				0,
				0,
				0,
				4,
				17,
				64,
				21,
				0,
				6,
				0,
				0,
				0,
				218,
				192,
				0,
				0,
				218,
				192,
				5,
				2,
				e.audioobjecttype << 3 | e.samplingfrequencyindex >>> 1,
				e.samplingfrequencyindex << 7 | e.channelcount << 3,
				6,
				1,
				2
			]));
		}, l = function() {
			return o(D.ftyp, O, te, O, k);
		}, x = function(e) {
			return o(D.hdlr, ie[e]);
		}, u = function(e) {
			return o(D.mdat, e);
		}, b = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				2,
				0,
				0,
				0,
				3,
				0,
				1,
				95,
				144,
				e.duration >>> 24 & 255,
				e.duration >>> 16 & 255,
				e.duration >>> 8 & 255,
				e.duration & 255,
				85,
				196,
				0,
				0
			]);
			return e.samplerate && (t[12] = e.samplerate >>> 24 & 255, t[13] = e.samplerate >>> 16 & 255, t[14] = e.samplerate >>> 8 & 255, t[15] = e.samplerate & 255), o(D.mdhd, t);
		}, y = function(e) {
			return o(D.mdia, b(e), x(e.type), f(e));
		}, d = function(e) {
			return o(D.mfhd, new Uint8Array([
				0,
				0,
				0,
				0,
				(e & 4278190080) >> 24,
				(e & 16711680) >> 16,
				(e & 65280) >> 8,
				e & 255
			]));
		}, f = function(e) {
			return o(D.minf, e.type === "video" ? o(D.vmhd, ae) : o(D.smhd, A), s(), C(e));
		}, p = function(e, t) {
			for (var n = [], r = t.length; r--;) n[r] = T(t[r]);
			return o.apply(null, [D.moof, d(e)].concat(n));
		}, m = function(e) {
			for (var t = e.length, n = []; t--;) n[t] = _(e[t]);
			return o.apply(null, [D.moov, g(4294967295)].concat(n, h(e)));
		}, h = function(e) {
			for (var t = e.length, n = []; t--;) n[t] = E(e[t]);
			return o.apply(null, [D.mvex].concat(n));
		}, g = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				2,
				0,
				1,
				95,
				144,
				(e & 4278190080) >> 24,
				(e & 16711680) >> 16,
				(e & 65280) >> 8,
				e & 255,
				0,
				1,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				64,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				255,
				255,
				255,
				255
			]);
			return o(D.mvhd, t);
		}, S = function(e) {
			var t = e.samples || [], n = new Uint8Array(4 + t.length), r, i;
			for (i = 0; i < t.length; i++) r = t[i].flags, n[i + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
			return o(D.sdtp, n);
		}, C = function(e) {
			return o(D.stbl, w(e), o(D.stts, j), o(D.stsc, ce), o(D.stsz, le), o(D.stco, se));
		}, (function() {
			var e, t;
			w = function(n) {
				return o(D.stsd, new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1
				]), n.type === "video" ? e(n) : t(n));
			}, e = function(e) {
				var t = e.sps || [], n = e.pps || [], r = [], i = [], a, s;
				for (a = 0; a < t.length; a++) r.push((t[a].byteLength & 65280) >>> 8), r.push(t[a].byteLength & 255), r = r.concat(Array.prototype.slice.call(t[a]));
				for (a = 0; a < n.length; a++) i.push((n[a].byteLength & 65280) >>> 8), i.push(n[a].byteLength & 255), i = i.concat(Array.prototype.slice.call(n[a]));
				if (s = [
					D.avc1,
					new Uint8Array([
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						(e.width & 65280) >> 8,
						e.width & 255,
						(e.height & 65280) >> 8,
						e.height & 255,
						0,
						72,
						0,
						0,
						0,
						72,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						19,
						118,
						105,
						100,
						101,
						111,
						106,
						115,
						45,
						99,
						111,
						110,
						116,
						114,
						105,
						98,
						45,
						104,
						108,
						115,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						24,
						17,
						17
					]),
					o(D.avcC, new Uint8Array([
						1,
						e.profileIdc,
						e.profileCompatibility,
						e.levelIdc,
						255,
						t.length
					].concat(r, [n.length], i))),
					o(D.btrt, new Uint8Array([
						0,
						28,
						156,
						128,
						0,
						45,
						198,
						192,
						0,
						45,
						198,
						192
					]))
				], e.sarRatio) {
					var c = e.sarRatio[0], l = e.sarRatio[1];
					s.push(o(D.pasp, new Uint8Array([
						(c & 4278190080) >> 24,
						(c & 16711680) >> 16,
						(c & 65280) >> 8,
						c & 255,
						(l & 4278190080) >> 24,
						(l & 16711680) >> 16,
						(l & 65280) >> 8,
						l & 255
					])));
				}
				return o.apply(null, s);
			}, t = function(e) {
				return o(D.mp4a, new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					(e.channelcount & 65280) >> 8,
					e.channelcount & 255,
					(e.samplesize & 65280) >> 8,
					e.samplesize & 255,
					0,
					0,
					0,
					0,
					(e.samplerate & 65280) >> 8,
					e.samplerate & 255,
					0,
					0
				]), c(e));
			};
		})(), v = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				7,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				(e.id & 4278190080) >> 24,
				(e.id & 16711680) >> 16,
				(e.id & 65280) >> 8,
				e.id & 255,
				0,
				0,
				0,
				0,
				(e.duration & 4278190080) >> 24,
				(e.duration & 16711680) >> 16,
				(e.duration & 65280) >> 8,
				e.duration & 255,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				64,
				0,
				0,
				0,
				(e.width & 65280) >> 8,
				e.width & 255,
				0,
				0,
				(e.height & 65280) >> 8,
				e.height & 255,
				0,
				0
			]);
			return o(D.tkhd, t);
		}, T = function(e) {
			var t = o(D.tfhd, new Uint8Array([
				0,
				0,
				0,
				58,
				(e.id & 4278190080) >> 24,
				(e.id & 16711680) >> 16,
				(e.id & 65280) >> 8,
				e.id & 255,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0
			])), n, r, i, s, c = Math.floor(e.baseMediaDecodeTime / a), l = Math.floor(e.baseMediaDecodeTime % a);
			return n = o(D.tfdt, new Uint8Array([
				1,
				0,
				0,
				0,
				c >>> 24 & 255,
				c >>> 16 & 255,
				c >>> 8 & 255,
				c & 255,
				l >>> 24 & 255,
				l >>> 16 & 255,
				l >>> 8 & 255,
				l & 255
			])), s = 92, e.type === "audio" ? (r = ee(e, s), o(D.traf, t, n, r)) : (i = S(e), r = ee(e, i.length + s), o(D.traf, t, n, r, i));
		}, _ = function(e) {
			return e.duration = e.duration || 4294967295, o(D.trak, v(e), y(e));
		}, E = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				0,
				(e.id & 4278190080) >> 24,
				(e.id & 16711680) >> 16,
				(e.id & 65280) >> 8,
				e.id & 255,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				1
			]);
			return e.type !== "video" && (t[t.length - 1] = 0), o(D.trex, t);
		}, (function() {
			var e, t, n = function(e, t) {
				var n = 0, r = 0, i = 0, a = 0;
				return e.length && (e[0].duration !== void 0 && (n = 1), e[0].size !== void 0 && (r = 2), e[0].flags !== void 0 && (i = 4), e[0].compositionTimeOffset !== void 0 && (a = 8)), [
					0,
					0,
					n | r | i | a,
					1,
					(e.length & 4278190080) >>> 24,
					(e.length & 16711680) >>> 16,
					(e.length & 65280) >>> 8,
					e.length & 255,
					(t & 4278190080) >>> 24,
					(t & 16711680) >>> 16,
					(t & 65280) >>> 8,
					t & 255
				];
			};
			t = function(e, t) {
				var r, i, a, s = e.samples || [], c, l;
				for (t += 20 + 16 * s.length, a = n(s, t), i = new Uint8Array(a.length + s.length * 16), i.set(a), r = a.length, l = 0; l < s.length; l++) c = s[l], i[r++] = (c.duration & 4278190080) >>> 24, i[r++] = (c.duration & 16711680) >>> 16, i[r++] = (c.duration & 65280) >>> 8, i[r++] = c.duration & 255, i[r++] = (c.size & 4278190080) >>> 24, i[r++] = (c.size & 16711680) >>> 16, i[r++] = (c.size & 65280) >>> 8, i[r++] = c.size & 255, i[r++] = c.flags.isLeading << 2 | c.flags.dependsOn, i[r++] = c.flags.isDependedOn << 6 | c.flags.hasRedundancy << 4 | c.flags.paddingValue << 1 | c.flags.isNonSyncSample, i[r++] = c.flags.degradationPriority & 61440, i[r++] = c.flags.degradationPriority & 15, i[r++] = (c.compositionTimeOffset & 4278190080) >>> 24, i[r++] = (c.compositionTimeOffset & 16711680) >>> 16, i[r++] = (c.compositionTimeOffset & 65280) >>> 8, i[r++] = c.compositionTimeOffset & 255;
				return o(D.trun, i);
			}, e = function(e, t) {
				var r, i, a, s = e.samples || [], c, l;
				for (t += 20 + 8 * s.length, a = n(s, t), r = new Uint8Array(a.length + s.length * 8), r.set(a), i = a.length, l = 0; l < s.length; l++) c = s[l], r[i++] = (c.duration & 4278190080) >>> 24, r[i++] = (c.duration & 16711680) >>> 16, r[i++] = (c.duration & 65280) >>> 8, r[i++] = c.duration & 255, r[i++] = (c.size & 4278190080) >>> 24, r[i++] = (c.size & 16711680) >>> 16, r[i++] = (c.size & 65280) >>> 8, r[i++] = c.size & 255;
				return o(D.trun, r);
			}, ee = function(n, r) {
				return n.type === "audio" ? e(n, r) : t(n, r);
			};
		})();
		var ue = {
			ftyp: l,
			mdat: u,
			moof: p,
			moov: m,
			initSegment: function(e) {
				var t = l(), n = m(e), r = new Uint8Array(t.byteLength + n.byteLength);
				return r.set(t), r.set(n, t.byteLength), r;
			}
		}, de = function(e) {
			var t, n, r = [], i = [];
			for (i.byteLength = 0, i.nalCount = 0, i.duration = 0, r.byteLength = 0, t = 0; t < e.length; t++) n = e[t], n.nalUnitType === "access_unit_delimiter_rbsp" ? (r.length && (r.duration = n.dts - r.dts, i.byteLength += r.byteLength, i.nalCount += r.length, i.duration += r.duration, i.push(r)), r = [n], r.byteLength = n.data.byteLength, r.pts = n.pts, r.dts = n.dts) : (n.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (r.keyFrame = !0), r.duration = n.dts - r.dts, r.byteLength += n.data.byteLength, r.push(n));
			return i.length && (!r.duration || r.duration <= 0) && (r.duration = i[i.length - 1].duration), i.byteLength += r.byteLength, i.nalCount += r.length, i.duration += r.duration, i.push(r), i;
		}, fe = function(e) {
			var t, n, r = [], i = [];
			for (r.byteLength = 0, r.nalCount = 0, r.duration = 0, r.pts = e[0].pts, r.dts = e[0].dts, i.byteLength = 0, i.nalCount = 0, i.duration = 0, i.pts = e[0].pts, i.dts = e[0].dts, t = 0; t < e.length; t++) n = e[t], n.keyFrame ? (r.length && (i.push(r), i.byteLength += r.byteLength, i.nalCount += r.nalCount, i.duration += r.duration), r = [n], r.nalCount = n.length, r.byteLength = n.byteLength, r.pts = n.pts, r.dts = n.dts, r.duration = n.duration) : (r.duration += n.duration, r.nalCount += n.length, r.byteLength += n.byteLength, r.push(n));
			return i.length && r.duration <= 0 && (r.duration = i[i.length - 1].duration), i.byteLength += r.byteLength, i.nalCount += r.nalCount, i.duration += r.duration, i.push(r), i;
		}, pe = function(e) {
			var t;
			return !e[0][0].keyFrame && e.length > 1 && (t = e.shift(), e.byteLength -= t.byteLength, e.nalCount -= t.nalCount, e[0][0].dts = t.dts, e[0][0].pts = t.pts, e[0][0].duration += t.duration), e;
		}, me = function() {
			return {
				size: 0,
				flags: {
					isLeading: 0,
					dependsOn: 1,
					isDependedOn: 0,
					hasRedundancy: 0,
					degradationPriority: 0,
					isNonSyncSample: 1
				}
			};
		}, he = function(e, t) {
			var n = me();
			return n.dataOffset = t, n.compositionTimeOffset = e.pts - e.dts, n.duration = e.duration, n.size = 4 * e.length, n.size += e.byteLength, e.keyFrame && (n.flags.dependsOn = 2, n.flags.isNonSyncSample = 0), n;
		}, ge = {
			groupNalsIntoFrames: de,
			groupFramesIntoGops: fe,
			extendFirstKeyFrame: pe,
			generateSampleTable: function(e, t) {
				var n, r, i, a, o, s = t || 0, c = [];
				for (n = 0; n < e.length; n++) for (a = e[n], r = 0; r < a.length; r++) o = a[r], i = he(o, s), s += i.size, c.push(i);
				return c;
			},
			concatenateNalData: function(e) {
				var t, n, r, i, a, o, s = 0, c = e.byteLength + 4 * e.nalCount, l = new Uint8Array(c), u = new DataView(l.buffer);
				for (t = 0; t < e.length; t++) for (i = e[t], n = 0; n < i.length; n++) for (a = i[n], r = 0; r < a.length; r++) o = a[r], u.setUint32(s, o.data.byteLength), s += 4, l.set(o.data, s), s += o.data.byteLength;
				return l;
			},
			generateSampleTableForFrame: function(e, t) {
				var n, r = t || 0, i = [];
				return n = he(e, r), i.push(n), i;
			},
			concatenateNalDataForFrame: function(e) {
				var t, n, r = 0, i = e.byteLength + 4 * e.length, a = new Uint8Array(i), o = new DataView(a.buffer);
				for (t = 0; t < e.length; t++) n = e[t], o.setUint32(r, n.data.byteLength), r += 4, a.set(n.data, r), r += n.data.byteLength;
				return a;
			}
		}, _e = [
			33,
			16,
			5,
			32,
			164,
			27
		], ve = [
			33,
			65,
			108,
			84,
			1,
			2,
			4,
			8,
			168,
			2,
			4,
			8,
			17,
			191,
			252
		], ye = function(e) {
			for (var t = []; e--;) t.push(0);
			return t;
		}, be = function(e) {
			return Object.keys(e).reduce(function(t, n) {
				return t[n] = new Uint8Array(e[n].reduce(function(e, t) {
					return e.concat(t);
				}, [])), t;
			}, {});
		}, xe, Se = function() {
			return xe ||= be({
				96e3: [
					_e,
					[227, 64],
					ye(154),
					[56]
				],
				88200: [
					_e,
					[231],
					ye(170),
					[56]
				],
				64e3: [
					_e,
					[248, 192],
					ye(240),
					[56]
				],
				48e3: [
					_e,
					[255, 192],
					ye(268),
					[
						55,
						148,
						128
					],
					ye(54),
					[112]
				],
				44100: [
					_e,
					[255, 192],
					ye(268),
					[
						55,
						163,
						128
					],
					ye(84),
					[112]
				],
				32e3: [
					_e,
					[255, 192],
					ye(268),
					[55, 234],
					ye(226),
					[112]
				],
				24e3: [
					_e,
					[255, 192],
					ye(268),
					[
						55,
						255,
						128
					],
					ye(268),
					[111, 112],
					ye(126),
					[224]
				],
				16e3: [
					_e,
					[255, 192],
					ye(268),
					[
						55,
						255,
						128
					],
					ye(268),
					[111, 255],
					ye(269),
					[223, 108],
					ye(195),
					[1, 192]
				],
				12e3: [
					ve,
					ye(268),
					[
						3,
						127,
						248
					],
					ye(268),
					[
						6,
						255,
						240
					],
					ye(268),
					[
						13,
						255,
						224
					],
					ye(268),
					[
						27,
						253,
						128
					],
					ye(259),
					[56]
				],
				11025: [
					ve,
					ye(268),
					[
						3,
						127,
						248
					],
					ye(268),
					[
						6,
						255,
						240
					],
					ye(268),
					[
						13,
						255,
						224
					],
					ye(268),
					[
						27,
						255,
						192
					],
					ye(268),
					[
						55,
						175,
						128
					],
					ye(108),
					[112]
				],
				8e3: [
					ve,
					ye(268),
					[
						3,
						121,
						16
					],
					ye(47),
					[7]
				]
			}), xe;
		}, Ce = 9e4, we = function(e) {
			return e * Ce;
		}, Te = function(e, t) {
			return e * t;
		}, Ee = function(e) {
			return e / Ce;
		}, M = function(e, t) {
			return e / t;
		}, De = {
			ONE_SECOND_IN_TS: Ce,
			secondsToVideoTs: we,
			secondsToAudioTs: Te,
			videoTsToSeconds: Ee,
			audioTsToSeconds: M,
			audioTsToVideoTs: function(e, t) {
				return we(M(e, t));
			},
			videoTsToAudioTs: function(e, t) {
				return Te(Ee(e), t);
			},
			metadataTsToSeconds: function(e, t, n) {
				return Ee(n ? e : e - t);
			}
		}, Oe = Se, ke = De, Ae = function(e) {
			var t, n, r = 0;
			for (t = 0; t < e.length; t++) n = e[t], r += n.data.byteLength;
			return r;
		}, je = {
			prefixWithSilence: function(e, t, n, r) {
				var i, a = 0, o = 0, s = 0, c = 0, l, u, d;
				if (t.length && (i = ke.audioTsToVideoTs(e.baseMediaDecodeTime, e.samplerate), a = Math.ceil(ke.ONE_SECOND_IN_TS / (e.samplerate / 1024)), n && r && (o = i - Math.max(n, r), s = Math.floor(o / a), c = s * a), !(s < 1 || c > ke.ONE_SECOND_IN_TS / 2))) {
					for (l = Oe()[e.samplerate], l ||= t[0].data, u = 0; u < s; u++) d = t[0], t.splice(0, 0, {
						data: l,
						dts: d.dts - a,
						pts: d.pts - a
					});
					return e.baseMediaDecodeTime -= Math.floor(ke.videoTsToAudioTs(c, e.samplerate)), c;
				}
			},
			trimAdtsFramesByEarliestDts: function(e, t, n) {
				return t.minSegmentDts >= n ? e : (t.minSegmentDts = Infinity, e.filter(function(e) {
					return e.dts >= n && (t.minSegmentDts = Math.min(t.minSegmentDts, e.dts), t.minSegmentPts = t.minSegmentDts, !0);
				}));
			},
			generateSampleTable: function(e) {
				var t, n, r = [];
				for (t = 0; t < e.length; t++) n = e[t], r.push({
					size: n.data.byteLength,
					duration: 1024
				});
				return r;
			},
			concatenateFrameData: function(e) {
				var t, n, r = 0, i = new Uint8Array(Ae(e));
				for (t = 0; t < e.length; t++) n = e[t], i.set(n.data, r), r += n.data.byteLength;
				return i;
			}
		}, Me = De.ONE_SECOND_IN_TS, Ne = {
			clearDtsInfo: function(e) {
				delete e.minSegmentDts, delete e.maxSegmentDts, delete e.minSegmentPts, delete e.maxSegmentPts;
			},
			calculateTrackBaseMediaDecodeTime: function(e, t) {
				var n, r, i = e.minSegmentDts;
				return t || (i -= e.timelineStartInfo.dts), n = e.timelineStartInfo.baseMediaDecodeTime, n += i, n = Math.max(0, n), e.type === "audio" && (r = e.samplerate / Me, n *= r, n = Math.floor(n)), n;
			},
			collectDtsInfo: function(e, t) {
				typeof t.pts == "number" && (e.timelineStartInfo.pts === void 0 && (e.timelineStartInfo.pts = t.pts), e.minSegmentPts = e.minSegmentPts === void 0 ? t.pts : Math.min(e.minSegmentPts, t.pts), e.maxSegmentPts = e.maxSegmentPts === void 0 ? t.pts : Math.max(e.maxSegmentPts, t.pts)), typeof t.dts == "number" && (e.timelineStartInfo.dts === void 0 && (e.timelineStartInfo.dts = t.dts), e.minSegmentDts = e.minSegmentDts === void 0 ? t.dts : Math.min(e.minSegmentDts, t.dts), e.maxSegmentDts = e.maxSegmentDts === void 0 ? t.dts : Math.max(e.maxSegmentDts, t.dts));
			}
		}, Pe = 4, N = 128, Fe = {
			parseSei: function(e) {
				for (var t = 0, n = {
					payloadType: -1,
					payloadSize: 0
				}, r = 0, i = 0; t < e.byteLength && e[t] !== N;) {
					for (; e[t] === 255;) r += 255, t++;
					for (r += e[t++]; e[t] === 255;) i += 255, t++;
					if (i += e[t++], !n.payload && r === Pe) if (String.fromCharCode(e[t + 3], e[t + 4], e[t + 5], e[t + 6]) === "GA94") {
						n.payloadType = r, n.payloadSize = i, n.payload = e.subarray(t, t + i);
						break;
					} else n.payload = void 0;
					t += i, r = 0, i = 0;
				}
				return n;
			},
			parseUserData: function(e) {
				return e.payload[0] !== 181 || (e.payload[1] << 8 | e.payload[2]) != 49 || String.fromCharCode(e.payload[3], e.payload[4], e.payload[5], e.payload[6]) !== "GA94" || e.payload[7] !== 3 ? null : e.payload.subarray(8, e.payload.length - 1);
			},
			parseCaptionPackets: function(e, t) {
				var n = [], r, i, a, o;
				if (!(t[0] & 64)) return n;
				for (i = t[0] & 31, r = 0; r < i; r++) a = r * 3, o = {
					type: t[a + 2] & 3,
					pts: e
				}, t[a + 2] & 4 && (o.ccData = t[a + 3] << 8 | t[a + 4], n.push(o));
				return n;
			},
			discardEmulationPreventionBytes: function(e) {
				for (var t = e.byteLength, n = [], r = 1, i, a; r < t - 2;) e[r] === 0 && e[r + 1] === 0 && e[r + 2] === 3 ? (n.push(r + 2), r += 2) : r++;
				if (n.length === 0) return e;
				i = t - n.length, a = new Uint8Array(i);
				var o = 0;
				for (r = 0; r < i; o++, r++) o === n[0] && (o++, n.shift()), a[r] = e[o];
				return a;
			},
			USER_DATA_REGISTERED_ITU_T_T35: Pe
		}, Ie = n, Le = Fe, Re = function(e) {
			e ||= {}, Re.prototype.init.call(this), this.parse708captions_ = typeof e.parse708captions != "boolean" || e.parse708captions, this.captionPackets_ = [], this.ccStreams_ = [
				new Xe(0, 0),
				new Xe(0, 1),
				new Xe(1, 0),
				new Xe(1, 1)
			], this.parse708captions_ && (this.cc708Stream_ = new We({ captionServices: e.captionServices })), this.reset(), this.ccStreams_.forEach(function(e) {
				e.on("data", this.trigger.bind(this, "data")), e.on("partialdone", this.trigger.bind(this, "partialdone")), e.on("done", this.trigger.bind(this, "done"));
			}, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
		};
		Re.prototype = new Ie(), Re.prototype.push = function(e) {
			var t, n, r;
			if (e.nalUnitType === "sei_rbsp" && (t = Le.parseSei(e.escapedRBSP), t.payload && t.payloadType === Le.USER_DATA_REGISTERED_ITU_T_T35 && (n = Le.parseUserData(t), n))) {
				if (e.dts < this.latestDts_) {
					this.ignoreNextEqualDts_ = !0;
					return;
				}
				if (e.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
					this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
					return;
				}
				r = Le.parseCaptionPackets(e.pts, n), this.captionPackets_ = this.captionPackets_.concat(r), this.latestDts_ !== e.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = e.dts;
			}
		}, Re.prototype.flushCCStreams = function(e) {
			this.ccStreams_.forEach(function(t) {
				return e === "flush" ? t.flush() : t.partialFlush();
			}, this);
		}, Re.prototype.flushStream = function(e) {
			if (!this.captionPackets_.length) {
				this.flushCCStreams(e);
				return;
			}
			this.captionPackets_.forEach(function(e, t) {
				e.presortIndex = t;
			}), this.captionPackets_.sort(function(e, t) {
				return e.pts === t.pts ? e.presortIndex - t.presortIndex : e.pts - t.pts;
			}), this.captionPackets_.forEach(function(e) {
				e.type < 2 ? this.dispatchCea608Packet(e) : this.dispatchCea708Packet(e);
			}, this), this.captionPackets_.length = 0, this.flushCCStreams(e);
		}, Re.prototype.flush = function() {
			return this.flushStream("flush");
		}, Re.prototype.partialFlush = function() {
			return this.flushStream("partialFlush");
		}, Re.prototype.reset = function() {
			this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(e) {
				e.reset();
			});
		}, Re.prototype.dispatchCea608Packet = function(e) {
			this.setsTextOrXDSActive(e) ? this.activeCea608Channel_[e.type] = null : this.setsChannel1Active(e) ? this.activeCea608Channel_[e.type] = 0 : this.setsChannel2Active(e) && (this.activeCea608Channel_[e.type] = 1), this.activeCea608Channel_[e.type] !== null && this.ccStreams_[(e.type << 1) + this.activeCea608Channel_[e.type]].push(e);
		}, Re.prototype.setsChannel1Active = function(e) {
			return (e.ccData & 30720) == 4096;
		}, Re.prototype.setsChannel2Active = function(e) {
			return (e.ccData & 30720) == 6144;
		}, Re.prototype.setsTextOrXDSActive = function(e) {
			return (e.ccData & 28928) == 256 || (e.ccData & 30974) == 4138 || (e.ccData & 30974) == 6186;
		}, Re.prototype.dispatchCea708Packet = function(e) {
			this.parse708captions_ && this.cc708Stream_.push(e);
		};
		var ze = {
			127: 9834,
			4128: 32,
			4129: 160,
			4133: 8230,
			4138: 352,
			4140: 338,
			4144: 9608,
			4145: 8216,
			4146: 8217,
			4147: 8220,
			4148: 8221,
			4149: 8226,
			4153: 8482,
			4154: 353,
			4156: 339,
			4157: 8480,
			4159: 376,
			4214: 8539,
			4215: 8540,
			4216: 8541,
			4217: 8542,
			4218: 9168,
			4219: 9124,
			4220: 9123,
			4221: 9135,
			4222: 9126,
			4223: 9121,
			4256: 12600
		}, Be = function(e) {
			var t = ze[e] || e;
			return e & 4096 && e === t ? "" : String.fromCharCode(t);
		}, Ve = function(e) {
			return 32 <= e && e <= 127 || 160 <= e && e <= 255;
		}, He = function(e) {
			this.windowNum = e, this.reset();
		};
		He.prototype.reset = function() {
			this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
		}, He.prototype.getText = function() {
			return this.rows.join("\n");
		}, He.prototype.clearText = function() {
			this.rows = [""], this.rowIdx = 0;
		}, He.prototype.newLine = function(e) {
			for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(e), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount;) this.rows.shift(), this.rowIdx--;
		}, He.prototype.isEmpty = function() {
			return this.rows.length === 0 || this.rows.length === 1 && this.rows[0] === "";
		}, He.prototype.addText = function(e) {
			this.rows[this.rowIdx] += e;
		}, He.prototype.backspace = function() {
			if (!this.isEmpty()) {
				var e = this.rows[this.rowIdx];
				this.rows[this.rowIdx] = e.substr(0, e.length - 1);
			}
		};
		var Ue = function(e, t, n) {
			this.serviceNum = e, this.text = "", this.currentWindow = new He(-1), this.windows = [], this.stream = n, typeof t == "string" && this.createTextDecoder(t);
		};
		Ue.prototype.init = function(e, t) {
			this.startPts = e;
			for (var n = 0; n < 8; n++) this.windows[n] = new He(n), typeof t == "function" && (this.windows[n].beforeRowOverflow = t);
		}, Ue.prototype.setCurrentWindow = function(e) {
			this.currentWindow = this.windows[e];
		}, Ue.prototype.createTextDecoder = function(e) {
			if (typeof TextDecoder > "u") this.stream.trigger("log", {
				level: "warn",
				message: "The `encoding` option is unsupported without TextDecoder support"
			});
			else try {
				this.textDecoder_ = new TextDecoder(e);
			} catch (t) {
				this.stream.trigger("log", {
					level: "warn",
					message: "TextDecoder could not be created with " + e + " encoding. " + t
				});
			}
		};
		var We = function(e) {
			e ||= {}, We.prototype.init.call(this);
			var t = this, n = e.captionServices || {}, r = {}, i;
			Object.keys(n).forEach((e) => {
				i = n[e], /^SERVICE/.test(e) && (r[e] = i.encoding);
			}), this.serviceEncodings = r, this.current708Packet = null, this.services = {}, this.push = function(e) {
				e.type === 3 ? (t.new708Packet(), t.add708Bytes(e)) : (t.current708Packet === null && t.new708Packet(), t.add708Bytes(e));
			};
		};
		We.prototype = new Ie(), We.prototype.new708Packet = function() {
			this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
				data: [],
				ptsVals: []
			};
		}, We.prototype.add708Bytes = function(e) {
			var t = e.ccData, n = t >>> 8, r = t & 255;
			this.current708Packet.ptsVals.push(e.pts), this.current708Packet.data.push(n), this.current708Packet.data.push(r);
		}, We.prototype.push708Packet = function() {
			var e = this.current708Packet, t = e.data, n = null, r = null, i = 0, a = t[i++];
			for (e.seq = a >> 6, e.sizeCode = a & 63; i < t.length; i++) a = t[i++], n = a >> 5, r = a & 31, n === 7 && r > 0 && (a = t[i++], n = a), this.pushServiceBlock(n, i, r), r > 0 && (i += r - 1);
		}, We.prototype.pushServiceBlock = function(e, t, n) {
			var r, i = t, a = this.current708Packet.data, o = this.services[e];
			for (o ||= this.initService(e, i); i < t + n && i < a.length; i++) r = a[i], Ve(r) ? i = this.handleText(i, o) : r === 24 ? i = this.multiByteCharacter(i, o) : r === 16 ? i = this.extendedCommands(i, o) : 128 <= r && r <= 135 ? i = this.setCurrentWindow(i, o) : 152 <= r && r <= 159 ? i = this.defineWindow(i, o) : r === 136 ? i = this.clearWindows(i, o) : r === 140 ? i = this.deleteWindows(i, o) : r === 137 ? i = this.displayWindows(i, o) : r === 138 ? i = this.hideWindows(i, o) : r === 139 ? i = this.toggleWindows(i, o) : r === 151 ? i = this.setWindowAttributes(i, o) : r === 144 ? i = this.setPenAttributes(i, o) : r === 145 ? i = this.setPenColor(i, o) : r === 146 ? i = this.setPenLocation(i, o) : r === 143 ? o = this.reset(i, o) : r === 8 ? o.currentWindow.backspace() : r === 12 ? o.currentWindow.clearText() : r === 13 ? o.currentWindow.pendingNewLine = !0 : r === 14 ? o.currentWindow.clearText() : r === 141 && i++;
		}, We.prototype.extendedCommands = function(e, t) {
			var n = this.current708Packet.data[++e];
			return Ve(n) && (e = this.handleText(e, t, { isExtended: !0 })), e;
		}, We.prototype.getPts = function(e) {
			return this.current708Packet.ptsVals[Math.floor(e / 2)];
		}, We.prototype.initService = function(e, t) {
			var n = "SERVICE" + e, r = this, n, i;
			return n in this.serviceEncodings && (i = this.serviceEncodings[n]), this.services[e] = new Ue(e, i, r), this.services[e].init(this.getPts(t), function(t) {
				r.flushDisplayed(t, r.services[e]);
			}), this.services[e];
		}, We.prototype.handleText = function(e, t, n) {
			var r = n && n.isExtended, i = n && n.isMultiByte, a = this.current708Packet.data, o = r ? 4096 : 0, s = a[e], c = a[e + 1], l = t.currentWindow, u, d;
			function f(e) {
				return e.map((e) => ("0" + (e & 255).toString(16)).slice(-2)).join("");
			}
			if (i ? (d = [s, c], e++) : d = [s], t.textDecoder_ && !r) u = t.textDecoder_.decode(new Uint8Array(d));
			else if (i) {
				let e = f(d);
				u = String.fromCharCode(parseInt(e, 16));
			} else u = Be(o | s);
			return l.pendingNewLine && !l.isEmpty() && l.newLine(this.getPts(e)), l.pendingNewLine = !1, l.addText(u), e;
		}, We.prototype.multiByteCharacter = function(e, t) {
			var n = this.current708Packet.data, r = n[e + 1], i = n[e + 2];
			return Ve(r) && Ve(i) && (e = this.handleText(++e, t, { isMultiByte: !0 })), e;
		}, We.prototype.setCurrentWindow = function(e, t) {
			var n = this.current708Packet.data[e] & 7;
			return t.setCurrentWindow(n), e;
		}, We.prototype.defineWindow = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = r & 7;
			t.setCurrentWindow(i);
			var a = t.currentWindow;
			return r = n[++e], a.visible = (r & 32) >> 5, a.rowLock = (r & 16) >> 4, a.columnLock = (r & 8) >> 3, a.priority = r & 7, r = n[++e], a.relativePositioning = (r & 128) >> 7, a.anchorVertical = r & 127, r = n[++e], a.anchorHorizontal = r, r = n[++e], a.anchorPoint = (r & 240) >> 4, a.rowCount = r & 15, r = n[++e], a.columnCount = r & 63, r = n[++e], a.windowStyle = (r & 56) >> 3, a.penStyle = r & 7, a.virtualRowCount = a.rowCount + 1, e;
		}, We.prototype.setWindowAttributes = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.winAttr;
			return r = n[++e], i.fillOpacity = (r & 192) >> 6, i.fillRed = (r & 48) >> 4, i.fillGreen = (r & 12) >> 2, i.fillBlue = r & 3, r = n[++e], i.borderType = (r & 192) >> 6, i.borderRed = (r & 48) >> 4, i.borderGreen = (r & 12) >> 2, i.borderBlue = r & 3, r = n[++e], i.borderType += (r & 128) >> 5, i.wordWrap = (r & 64) >> 6, i.printDirection = (r & 48) >> 4, i.scrollDirection = (r & 12) >> 2, i.justify = r & 3, r = n[++e], i.effectSpeed = (r & 240) >> 4, i.effectDirection = (r & 12) >> 2, i.displayEffect = r & 3, e;
		}, We.prototype.flushDisplayed = function(e, t) {
			for (var n = [], r = 0; r < 8; r++) t.windows[r].visible && !t.windows[r].isEmpty() && n.push(t.windows[r].getText());
			t.endPts = e, t.text = n.join("\n\n"), this.pushCaption(t), t.startPts = e;
		}, We.prototype.pushCaption = function(e) {
			e.text !== "" && (this.trigger("data", {
				startPts: e.startPts,
				endPts: e.endPts,
				text: e.text,
				stream: "cc708_" + e.serviceNum
			}), e.text = "", e.startPts = e.endPts);
		}, We.prototype.displayWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && (t.windows[i].visible = 1);
			return e;
		}, We.prototype.hideWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && (t.windows[i].visible = 0);
			return e;
		}, We.prototype.toggleWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && (t.windows[i].visible ^= 1);
			return e;
		}, We.prototype.clearWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && t.windows[i].clearText();
			return e;
		}, We.prototype.deleteWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && t.windows[i].reset();
			return e;
		}, We.prototype.setPenAttributes = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.penAttr;
			return r = n[++e], i.textTag = (r & 240) >> 4, i.offset = (r & 12) >> 2, i.penSize = r & 3, r = n[++e], i.italics = (r & 128) >> 7, i.underline = (r & 64) >> 6, i.edgeType = (r & 56) >> 3, i.fontStyle = r & 7, e;
		}, We.prototype.setPenColor = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.penColor;
			return r = n[++e], i.fgOpacity = (r & 192) >> 6, i.fgRed = (r & 48) >> 4, i.fgGreen = (r & 12) >> 2, i.fgBlue = r & 3, r = n[++e], i.bgOpacity = (r & 192) >> 6, i.bgRed = (r & 48) >> 4, i.bgGreen = (r & 12) >> 2, i.bgBlue = r & 3, r = n[++e], i.edgeRed = (r & 48) >> 4, i.edgeGreen = (r & 12) >> 2, i.edgeBlue = r & 3, e;
		}, We.prototype.setPenLocation = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.penLoc;
			return t.currentWindow.pendingNewLine = !0, r = n[++e], i.row = r & 15, r = n[++e], i.column = r & 63, e;
		}, We.prototype.reset = function(e, t) {
			var n = this.getPts(e);
			return this.flushDisplayed(n, t), this.initService(t.serviceNum, e);
		};
		var Ge = {
			42: 225,
			92: 233,
			94: 237,
			95: 243,
			96: 250,
			123: 231,
			124: 247,
			125: 209,
			126: 241,
			127: 9608,
			304: 174,
			305: 176,
			306: 189,
			307: 191,
			308: 8482,
			309: 162,
			310: 163,
			311: 9834,
			312: 224,
			313: 160,
			314: 232,
			315: 226,
			316: 234,
			317: 238,
			318: 244,
			319: 251,
			544: 193,
			545: 201,
			546: 211,
			547: 218,
			548: 220,
			549: 252,
			550: 8216,
			551: 161,
			552: 42,
			553: 39,
			554: 8212,
			555: 169,
			556: 8480,
			557: 8226,
			558: 8220,
			559: 8221,
			560: 192,
			561: 194,
			562: 199,
			563: 200,
			564: 202,
			565: 203,
			566: 235,
			567: 206,
			568: 207,
			569: 239,
			570: 212,
			571: 217,
			572: 249,
			573: 219,
			574: 171,
			575: 187,
			800: 195,
			801: 227,
			802: 205,
			803: 204,
			804: 236,
			805: 210,
			806: 242,
			807: 213,
			808: 245,
			809: 123,
			810: 125,
			811: 92,
			812: 94,
			813: 95,
			814: 124,
			815: 126,
			816: 196,
			817: 228,
			818: 214,
			819: 246,
			820: 223,
			821: 165,
			822: 164,
			823: 9474,
			824: 197,
			825: 229,
			826: 216,
			827: 248,
			828: 9484,
			829: 9488,
			830: 9492,
			831: 9496
		}, Ke = function(e) {
			return e === null ? "" : (e = Ge[e] || e, String.fromCharCode(e));
		}, qe = 14, Je = [
			4352,
			4384,
			4608,
			4640,
			5376,
			5408,
			5632,
			5664,
			5888,
			5920,
			4096,
			4864,
			4896,
			5120,
			5152
		], Ye = function() {
			for (var e = [], t = qe + 1; t--;) e.push({
				text: "",
				indent: 0,
				offset: 0
			});
			return e;
		}, Xe = function(e, t) {
			Xe.prototype.init.call(this), this.field_ = e || 0, this.dataChannel_ = t || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(e) {
				var t = e.ccData & 32639, n, r, i, a;
				if (t === this.lastControlCode_) {
					this.lastControlCode_ = null;
					return;
				}
				if ((t & 61440) == 4096 ? this.lastControlCode_ = t : t !== this.PADDING_ && (this.lastControlCode_ = null), r = t >>> 8, i = t & 255, t !== this.PADDING_) if (t === this.RESUME_CAPTION_LOADING_) this.mode_ = "popOn";
				else if (t === this.END_OF_CAPTION_) this.mode_ = "popOn", this.clearFormatting(e.pts), this.flushDisplayed(e.pts), n = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = n, this.startPts_ = e.pts;
				else if (t === this.ROLL_UP_2_ROWS_) this.rollUpRows_ = 2, this.setRollUp(e.pts);
				else if (t === this.ROLL_UP_3_ROWS_) this.rollUpRows_ = 3, this.setRollUp(e.pts);
				else if (t === this.ROLL_UP_4_ROWS_) this.rollUpRows_ = 4, this.setRollUp(e.pts);
				else if (t === this.CARRIAGE_RETURN_) this.clearFormatting(e.pts), this.flushDisplayed(e.pts), this.shiftRowsUp_(), this.startPts_ = e.pts;
				else if (t === this.BACKSPACE_) this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
				else if (t === this.ERASE_DISPLAYED_MEMORY_) this.flushDisplayed(e.pts), this.displayed_ = Ye();
				else if (t === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = Ye();
				else if (t === this.RESUME_DIRECT_CAPTIONING_) this.mode_ !== "paintOn" && (this.flushDisplayed(e.pts), this.displayed_ = Ye()), this.mode_ = "paintOn", this.startPts_ = e.pts;
				else if (this.isSpecialCharacter(r, i)) r = (r & 3) << 8, a = Ke(r | i), this[this.mode_](e.pts, a), this.column_++;
				else if (this.isExtCharacter(r, i)) this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), r = (r & 3) << 8, a = Ke(r | i), this[this.mode_](e.pts, a), this.column_++;
				else if (this.isMidRowCode(r, i)) this.clearFormatting(e.pts), this[this.mode_](e.pts, " "), this.column_++, (i & 14) == 14 && this.addFormatting(e.pts, ["i"]), (i & 1) == 1 && this.addFormatting(e.pts, ["u"]);
				else if (this.isOffsetControlCode(r, i)) {
					let e = i & 3;
					this.nonDisplayed_[this.row_].offset = e, this.column_ += e;
				} else if (this.isPAC(r, i)) {
					var o = Je.indexOf(t & 7968);
					if (this.mode_ === "rollUp" && (o - this.rollUpRows_ + 1 < 0 && (o = this.rollUpRows_ - 1), this.setRollUp(e.pts, o)), o !== this.row_ && o >= 0 && o <= 14 && (this.clearFormatting(e.pts), this.row_ = o), i & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(e.pts, ["u"]), (t & 16) == 16) {
						let e = (t & 14) >> 1;
						this.column_ = e * 4, this.nonDisplayed_[this.row_].indent += e;
					}
					this.isColorPAC(i) && (i & 14) == 14 && this.addFormatting(e.pts, ["i"]);
				} else this.isNormalChar(r) && (i === 0 && (i = null), a = Ke(r), a += Ke(i), this[this.mode_](e.pts, a), this.column_ += a.length);
			};
		};
		Xe.prototype = new Ie(), Xe.prototype.flushDisplayed = function(e) {
			let t = (e) => {
				this.trigger("log", {
					level: "warn",
					message: "Skipping a malformed 608 caption at index " + e + "."
				});
			}, n = [];
			this.displayed_.forEach((e, r) => {
				if (e && e.text && e.text.length) {
					try {
						e.text = e.text.trim();
					} catch {
						t(r);
					}
					e.text.length && n.push({
						text: e.text,
						line: r + 1,
						position: 10 + Math.min(70, e.indent * 10) + e.offset * 2.5
					});
				} else e ?? t(r);
			}), n.length && this.trigger("data", {
				startPts: this.startPts_,
				endPts: e,
				content: n,
				stream: this.name_
			});
		}, Xe.prototype.reset = function() {
			this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Ye(), this.nonDisplayed_ = Ye(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = qe, this.rollUpRows_ = 2, this.formatting_ = [];
		}, Xe.prototype.setConstants = function() {
			this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
		}, Xe.prototype.isSpecialCharacter = function(e, t) {
			return e === this.EXT_ && t >= 48 && t <= 63;
		}, Xe.prototype.isExtCharacter = function(e, t) {
			return (e === this.EXT_ + 1 || e === this.EXT_ + 2) && t >= 32 && t <= 63;
		}, Xe.prototype.isMidRowCode = function(e, t) {
			return e === this.EXT_ && t >= 32 && t <= 47;
		}, Xe.prototype.isOffsetControlCode = function(e, t) {
			return e === this.OFFSET_ && t >= 33 && t <= 35;
		}, Xe.prototype.isPAC = function(e, t) {
			return e >= this.BASE_ && e < this.BASE_ + 8 && t >= 64 && t <= 127;
		}, Xe.prototype.isColorPAC = function(e) {
			return e >= 64 && e <= 79 || e >= 96 && e <= 127;
		}, Xe.prototype.isNormalChar = function(e) {
			return e >= 32 && e <= 127;
		}, Xe.prototype.setRollUp = function(e, t) {
			if (this.mode_ !== "rollUp" && (this.row_ = qe, this.mode_ = "rollUp", this.flushDisplayed(e), this.nonDisplayed_ = Ye(), this.displayed_ = Ye()), t !== void 0 && t !== this.row_) for (var n = 0; n < this.rollUpRows_; n++) this.displayed_[t - n] = this.displayed_[this.row_ - n], this.displayed_[this.row_ - n] = {
				text: "",
				indent: 0,
				offset: 0
			};
			t === void 0 && (t = this.row_), this.topRow_ = t - this.rollUpRows_ + 1;
		}, Xe.prototype.addFormatting = function(e, t) {
			this.formatting_ = this.formatting_.concat(t);
			var n = t.reduce(function(e, t) {
				return e + "<" + t + ">";
			}, "");
			this[this.mode_](e, n);
		}, Xe.prototype.clearFormatting = function(e) {
			if (this.formatting_.length) {
				var t = this.formatting_.reverse().reduce(function(e, t) {
					return e + "</" + t + ">";
				}, "");
				this.formatting_ = [], this[this.mode_](e, t);
			}
		}, Xe.prototype.popOn = function(e, t) {
			var n = this.nonDisplayed_[this.row_].text;
			n += t, this.nonDisplayed_[this.row_].text = n;
		}, Xe.prototype.rollUp = function(e, t) {
			var n = this.displayed_[this.row_].text;
			n += t, this.displayed_[this.row_].text = n;
		}, Xe.prototype.shiftRowsUp_ = function() {
			var e;
			for (e = 0; e < this.topRow_; e++) this.displayed_[e] = {
				text: "",
				indent: 0,
				offset: 0
			};
			for (e = this.row_ + 1; e < qe + 1; e++) this.displayed_[e] = {
				text: "",
				indent: 0,
				offset: 0
			};
			for (e = this.topRow_; e < this.row_; e++) this.displayed_[e] = this.displayed_[e + 1];
			this.displayed_[this.row_] = {
				text: "",
				indent: 0,
				offset: 0
			};
		}, Xe.prototype.paintOn = function(e, t) {
			var n = this.displayed_[this.row_].text;
			n += t, this.displayed_[this.row_].text = n;
		};
		var Ze = {
			CaptionStream: Re,
			Cea608Stream: Xe,
			Cea708Stream: We
		}, Qe = {
			H264_STREAM_TYPE: 27,
			ADTS_STREAM_TYPE: 15,
			METADATA_STREAM_TYPE: 21
		}, $e = n, et = 8589934592, tt = 4294967296, nt = "shared", rt = function(e, t) {
			var n = 1;
			for (e > t && (n = -1); Math.abs(t - e) > tt;) e += n * et;
			return e;
		}, it = function(e) {
			var t, n;
			it.prototype.init.call(this), this.type_ = e || nt, this.push = function(e) {
				if (e.type === "metadata") {
					this.trigger("data", e);
					return;
				}
				(this.type_ === nt || e.type === this.type_) && (n === void 0 && (n = e.dts), e.dts = rt(e.dts, n), e.pts = rt(e.pts, n), t = e.dts, this.trigger("data", e));
			}, this.flush = function() {
				n = t, this.trigger("done");
			}, this.endTimeline = function() {
				this.flush(), this.trigger("endedtimeline");
			}, this.discontinuity = function() {
				n = void 0, t = void 0;
			}, this.reset = function() {
				this.discontinuity(), this.trigger("reset");
			};
		};
		it.prototype = new $e();
		var at = {
			TimestampRolloverStream: it,
			handleRollover: rt
		}, ot = { typedArrayIndexOf: (e, t, n) => {
			if (!e) return -1;
			for (var r = n; r < e.length; r++) if (e[r] === t) return r;
			return -1;
		} }.typedArrayIndexOf, st = {
			Iso88591: 0,
			Utf16: 1,
			Utf16be: 2,
			Utf8: 3
		}, ct = function(e, t, n) {
			var r, i = "";
			for (r = t; r < n; r++) i += "%" + ("00" + e[r].toString(16)).slice(-2);
			return i;
		}, lt = function(e, t, n) {
			return decodeURIComponent(ct(e, t, n));
		}, ut = function(e, t, n) {
			return unescape(ct(e, t, n));
		}, dt = function(e) {
			return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
		}, ft = {
			APIC: function(e) {
				var t = 1, n, r;
				e.data[0] === st.Utf8 && (n = ot(e.data, 0, t), !(n < 0) && (e.mimeType = ut(e.data, t, n), t = n + 1, e.pictureType = e.data[t], t++, r = ot(e.data, 0, t), !(r < 0) && (e.description = lt(e.data, t, r), t = r + 1, e.mimeType === "-->" ? e.url = ut(e.data, t, e.data.length) : e.pictureData = e.data.subarray(t, e.data.length))));
			},
			"T*": function(e) {
				e.data[0] === st.Utf8 && (e.value = lt(e.data, 1, e.data.length).replace(/\0*$/, ""), e.values = e.value.split("\0"));
			},
			TXXX: function(e) {
				var t;
				e.data[0] === st.Utf8 && (t = ot(e.data, 0, 1), t !== -1 && (e.description = lt(e.data, 1, t), e.value = lt(e.data, t + 1, e.data.length).replace(/\0*$/, ""), e.data = e.value));
			},
			"W*": function(e) {
				e.url = ut(e.data, 0, e.data.length).replace(/\0.*$/, "");
			},
			WXXX: function(e) {
				var t;
				e.data[0] === st.Utf8 && (t = ot(e.data, 0, 1), t !== -1 && (e.description = lt(e.data, 1, t), e.url = ut(e.data, t + 1, e.data.length).replace(/\0.*$/, "")));
			},
			PRIV: function(e) {
				var t;
				for (t = 0; t < e.data.length; t++) if (e.data[t] === 0) {
					e.owner = ut(e.data, 0, t);
					break;
				}
				e.privateData = e.data.subarray(t + 1), e.data = e.privateData;
			}
		}, pt = {
			parseId3Frames: function(e) {
				var t, n, r = 10, i = 0, a = [];
				if (!(e.length < 10 || e[0] !== 73 || e[1] !== 68 || e[2] !== 51)) {
					i = dt(e.subarray(6, 10)), i += 10, e[5] & 64 && (r += 4, r += dt(e.subarray(10, 14)), i -= dt(e.subarray(16, 20)));
					do {
						if (t = dt(e.subarray(r + 4, r + 8)), t < 1) break;
						n = String.fromCharCode(e[r], e[r + 1], e[r + 2], e[r + 3]);
						var o = {
							id: n,
							data: e.subarray(r + 10, r + t + 10)
						};
						o.key = o.id, ft[o.id] ? ft[o.id](o) : o.id[0] === "T" ? ft["T*"](o) : o.id[0] === "W" && ft["W*"](o), a.push(o), r += 10, r += t;
					} while (r < i);
					return a;
				}
			},
			parseSyncSafeInteger: dt,
			frameParsers: ft
		}, mt = n, ht = Qe, gt = pt, _t = function(e) {
			var t = { descriptor: e && e.descriptor }, n = 0, r = [], i = 0, a;
			if (_t.prototype.init.call(this), this.dispatchType = ht.METADATA_STREAM_TYPE.toString(16), t.descriptor) for (a = 0; a < t.descriptor.length; a++) this.dispatchType += ("00" + t.descriptor[a].toString(16)).slice(-2);
			this.push = function(e) {
				var t, a, o, s, c, l;
				if (e.type === "timed-metadata") {
					if (e.dataAlignmentIndicator && (i = 0, r.length = 0), r.length === 0 && (e.data.length < 10 || e.data[0] !== 73 || e.data[1] !== 68 || e.data[2] !== 51)) {
						this.trigger("log", {
							level: "warn",
							message: "Skipping unrecognized metadata packet"
						});
						return;
					}
					if (r.push(e), i += e.data.byteLength, r.length === 1 && (n = gt.parseSyncSafeInteger(e.data.subarray(6, 10)), n += 10), !(i < n)) {
						for (t = {
							data: new Uint8Array(n),
							frames: [],
							pts: r[0].pts,
							dts: r[0].dts
						}, c = 0; c < n;) t.data.set(r[0].data.subarray(0, n - c), c), c += r[0].data.byteLength, i -= r[0].data.byteLength, r.shift();
						a = 10, t.data[5] & 64 && (a += 4, a += gt.parseSyncSafeInteger(t.data.subarray(10, 14)), n -= gt.parseSyncSafeInteger(t.data.subarray(16, 20)));
						do {
							if (o = gt.parseSyncSafeInteger(t.data.subarray(a + 4, a + 8)), o < 1) {
								this.trigger("log", {
									level: "warn",
									message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
								});
								break;
							}
							if (l = String.fromCharCode(t.data[a], t.data[a + 1], t.data[a + 2], t.data[a + 3]), s = {
								id: l,
								data: t.data.subarray(a + 10, a + o + 10)
							}, s.key = s.id, gt.frameParsers[s.id] ? gt.frameParsers[s.id](s) : s.id[0] === "T" ? gt.frameParsers["T*"](s) : s.id[0] === "W" && gt.frameParsers["W*"](s), s.owner === "com.apple.streaming.transportStreamTimestamp") {
								var u = s.data, d = (u[3] & 1) << 30 | u[4] << 22 | u[5] << 14 | u[6] << 6 | u[7] >>> 2;
								d *= 4, d += u[7] & 3, s.timeStamp = d, t.pts === void 0 && t.dts === void 0 && (t.pts = s.timeStamp, t.dts = s.timeStamp), this.trigger("timestamp", s);
							}
							t.frames.push(s), a += 10, a += o;
						} while (a < n);
						this.trigger("data", t);
					}
				}
			};
		};
		_t.prototype = new mt();
		var vt = _t, yt = n, bt = Ze, xt = Qe, St = at.TimestampRolloverStream, Ct, wt, Tt, Et = 188, Dt = 71;
		Ct = function() {
			var e = new Uint8Array(Et), t = 0;
			Ct.prototype.init.call(this), this.push = function(n) {
				var r = 0, i = Et, a;
				for (t ? (a = new Uint8Array(n.byteLength + t), a.set(e.subarray(0, t)), a.set(n, t), t = 0) : a = n; i < a.byteLength;) {
					if (a[r] === Dt && a[i] === Dt) {
						this.trigger("data", a.subarray(r, i)), r += Et, i += Et;
						continue;
					}
					r++, i++;
				}
				r < a.byteLength && (e.set(a.subarray(r), 0), t = a.byteLength - r);
			}, this.flush = function() {
				t === Et && e[0] === Dt && (this.trigger("data", e), t = 0), this.trigger("done");
			}, this.endTimeline = function() {
				this.flush(), this.trigger("endedtimeline");
			}, this.reset = function() {
				t = 0, this.trigger("reset");
			};
		}, Ct.prototype = new yt(), wt = function() {
			var e, t, n, r;
			wt.prototype.init.call(this), r = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, e = function(e, r) {
				var i = 0;
				r.payloadUnitStartIndicator && (i += e[i] + 1), r.type === "pat" ? t(e.subarray(i), r) : n(e.subarray(i), r);
			}, t = function(e, t) {
				t.section_number = e[7], t.last_section_number = e[8], r.pmtPid = (e[10] & 31) << 8 | e[11], t.pmtPid = r.pmtPid;
			}, n = function(e, t) {
				var n, i, a, o;
				if (e[5] & 1) {
					for (r.programMapTable = {
						video: null,
						audio: null,
						"timed-metadata": {}
					}, n = (e[1] & 15) << 8 | e[2], i = 3 + n - 4, a = (e[10] & 15) << 8 | e[11], o = 12 + a; o < i;) {
						var s = e[o], c = (e[o + 1] & 31) << 8 | e[o + 2];
						s === xt.H264_STREAM_TYPE && r.programMapTable.video === null ? r.programMapTable.video = c : s === xt.ADTS_STREAM_TYPE && r.programMapTable.audio === null ? r.programMapTable.audio = c : s === xt.METADATA_STREAM_TYPE && (r.programMapTable["timed-metadata"][c] = s), o += ((e[o + 3] & 15) << 8 | e[o + 4]) + 5;
					}
					t.programMapTable = r.programMapTable;
				}
			}, this.push = function(t) {
				var n = {}, r = 4;
				if (n.payloadUnitStartIndicator = !!(t[1] & 64), n.pid = t[1] & 31, n.pid <<= 8, n.pid |= t[2], (t[3] & 48) >>> 4 > 1 && (r += t[r] + 1), n.pid === 0) n.type = "pat", e(t.subarray(r), n), this.trigger("data", n);
				else if (n.pid === this.pmtPid) for (n.type = "pmt", e(t.subarray(r), n), this.trigger("data", n); this.packetsWaitingForPmt.length;) this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
				else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([
					t,
					r,
					n
				]) : this.processPes_(t, r, n);
			}, this.processPes_ = function(e, t, n) {
				n.streamType = n.pid === this.programMapTable.video ? xt.H264_STREAM_TYPE : n.pid === this.programMapTable.audio ? xt.ADTS_STREAM_TYPE : this.programMapTable["timed-metadata"][n.pid], n.type = "pes", n.data = e.subarray(t), this.trigger("data", n);
			};
		}, wt.prototype = new yt(), wt.STREAM_TYPES = {
			h264: 27,
			adts: 15
		}, Tt = function() {
			var e = this, t = !1, n = {
				data: [],
				size: 0
			}, r = {
				data: [],
				size: 0
			}, i = {
				data: [],
				size: 0
			}, a, o = function(e, t) {
				var n;
				let r = e[0] << 16 | e[1] << 8 | e[2];
				t.data = /* @__PURE__ */ new Uint8Array(), r === 1 && (t.packetLength = 6 + (e[4] << 8 | e[5]), t.dataAlignmentIndicator = !!(e[6] & 4), n = e[7], n & 192 && (t.pts = (e[9] & 14) << 27 | (e[10] & 255) << 20 | (e[11] & 254) << 12 | (e[12] & 255) << 5 | (e[13] & 254) >>> 3, t.pts *= 4, t.pts += (e[13] & 6) >>> 1, t.dts = t.pts, n & 64 && (t.dts = (e[14] & 14) << 27 | (e[15] & 255) << 20 | (e[16] & 254) << 12 | (e[17] & 255) << 5 | (e[18] & 254) >>> 3, t.dts *= 4, t.dts += (e[18] & 6) >>> 1)), t.data = e.subarray(9 + e[8]));
			}, s = function(t, n, r) {
				var i = new Uint8Array(t.size), a = { type: n }, s = 0, c = 0, l = !1, u;
				if (!(!t.data.length || t.size < 9)) {
					for (a.trackId = t.data[0].pid, s = 0; s < t.data.length; s++) u = t.data[s], i.set(u.data, c), c += u.data.byteLength;
					o(i, a), l = n === "video" || a.packetLength <= t.size, (r || l) && (t.size = 0, t.data.length = 0), l && e.trigger("data", a);
				}
			};
			Tt.prototype.init.call(this), this.push = function(o) {
				({
					pat: function() {},
					pes: function() {
						var e, t;
						switch (o.streamType) {
							case xt.H264_STREAM_TYPE:
								e = n, t = "video";
								break;
							case xt.ADTS_STREAM_TYPE:
								e = r, t = "audio";
								break;
							case xt.METADATA_STREAM_TYPE:
								e = i, t = "timed-metadata";
								break;
							default: return;
						}
						o.payloadUnitStartIndicator && s(e, t, !0), e.data.push(o), e.size += o.data.byteLength;
					},
					pmt: function() {
						var n = {
							type: "metadata",
							tracks: []
						};
						a = o.programMapTable, a.video !== null && n.tracks.push({
							timelineStartInfo: { baseMediaDecodeTime: 0 },
							id: +a.video,
							codec: "avc",
							type: "video"
						}), a.audio !== null && n.tracks.push({
							timelineStartInfo: { baseMediaDecodeTime: 0 },
							id: +a.audio,
							codec: "adts",
							type: "audio"
						}), t = !0, e.trigger("data", n);
					}
				})[o.type]();
			}, this.reset = function() {
				n.size = 0, n.data.length = 0, r.size = 0, r.data.length = 0, this.trigger("reset");
			}, this.flushStreams_ = function() {
				s(n, "video"), s(r, "audio"), s(i, "timed-metadata");
			}, this.flush = function() {
				if (!t && a) {
					var n = {
						type: "metadata",
						tracks: []
					};
					a.video !== null && n.tracks.push({
						timelineStartInfo: { baseMediaDecodeTime: 0 },
						id: +a.video,
						codec: "avc",
						type: "video"
					}), a.audio !== null && n.tracks.push({
						timelineStartInfo: { baseMediaDecodeTime: 0 },
						id: +a.audio,
						codec: "adts",
						type: "audio"
					}), e.trigger("data", n);
				}
				t = !1, this.flushStreams_(), this.trigger("done");
			};
		}, Tt.prototype = new yt();
		var Ot = {
			PAT_PID: 0,
			MP2T_PACKET_LENGTH: Et,
			TransportPacketStream: Ct,
			TransportParseStream: wt,
			ElementaryStream: Tt,
			TimestampRolloverStream: St,
			CaptionStream: bt.CaptionStream,
			Cea608Stream: bt.Cea608Stream,
			Cea708Stream: bt.Cea708Stream,
			MetadataStream: vt
		};
		for (var kt in xt) xt.hasOwnProperty(kt) && (Ot[kt] = xt[kt]);
		var At = Ot, jt = n, Mt = De.ONE_SECOND_IN_TS, Nt, Pt = [
			96e3,
			88200,
			64e3,
			48e3,
			44100,
			32e3,
			24e3,
			22050,
			16e3,
			12e3,
			11025,
			8e3,
			7350
		];
		Nt = function(e) {
			var t, n = 0;
			Nt.prototype.init.call(this), this.skipWarn_ = function(e, t) {
				this.trigger("log", {
					level: "warn",
					message: `adts skiping bytes ${e} to ${t} in frame ${n} outside syncword`
				});
			}, this.push = function(r) {
				var i = 0, a, o, s, c, l;
				if (e || (n = 0), r.type === "audio") {
					t && t.length ? (s = t, t = new Uint8Array(s.byteLength + r.data.byteLength), t.set(s), t.set(r.data, s.byteLength)) : t = r.data;
					for (var u; i + 7 < t.length;) {
						if (t[i] !== 255 || (t[i + 1] & 246) != 240) {
							typeof u != "number" && (u = i), i++;
							continue;
						}
						if (typeof u == "number" && (this.skipWarn_(u, i), u = null), o = (~t[i + 1] & 1) * 2, a = (t[i + 3] & 3) << 11 | t[i + 4] << 3 | (t[i + 5] & 224) >> 5, c = ((t[i + 6] & 3) + 1) * 1024, l = c * Mt / Pt[(t[i + 2] & 60) >>> 2], t.byteLength - i < a) break;
						this.trigger("data", {
							pts: r.pts + n * l,
							dts: r.dts + n * l,
							sampleCount: c,
							audioobjecttype: (t[i + 2] >>> 6 & 3) + 1,
							channelcount: (t[i + 2] & 1) << 2 | (t[i + 3] & 192) >>> 6,
							samplerate: Pt[(t[i + 2] & 60) >>> 2],
							samplingfrequencyindex: (t[i + 2] & 60) >>> 2,
							samplesize: 16,
							data: t.subarray(i + 7 + o, i + a)
						}), n++, i += a;
					}
					typeof u == "number" && (this.skipWarn_(u, i), u = null), t = t.subarray(i);
				}
			}, this.flush = function() {
				n = 0, this.trigger("done");
			}, this.reset = function() {
				t = void 0, this.trigger("reset");
			}, this.endTimeline = function() {
				t = void 0, this.trigger("endedtimeline");
			};
		}, Nt.prototype = new jt();
		var Ft = Nt, It = function(e) {
			var t = e.byteLength, n = 0, r = 0;
			this.length = function() {
				return 8 * t;
			}, this.bitsAvailable = function() {
				return 8 * t + r;
			}, this.loadWord = function() {
				var i = e.byteLength - t, a = /* @__PURE__ */ new Uint8Array(4), o = Math.min(4, t);
				if (o === 0) throw Error("no bytes available");
				a.set(e.subarray(i, i + o)), n = new DataView(a.buffer).getUint32(0), r = o * 8, t -= o;
			}, this.skipBits = function(e) {
				var i;
				r > e ? (n <<= e, r -= e) : (e -= r, i = Math.floor(e / 8), e -= i * 8, t -= i, this.loadWord(), n <<= e, r -= e);
			}, this.readBits = function(e) {
				var i = Math.min(r, e), a = n >>> 32 - i;
				return r -= i, r > 0 ? n <<= i : t > 0 && this.loadWord(), i = e - i, i > 0 ? a << i | this.readBits(i) : a;
			}, this.skipLeadingZeros = function() {
				var e;
				for (e = 0; e < r; ++e) if (n & 2147483648 >>> e) return n <<= e, r -= e, e;
				return this.loadWord(), e + this.skipLeadingZeros();
			}, this.skipUnsignedExpGolomb = function() {
				this.skipBits(1 + this.skipLeadingZeros());
			}, this.skipExpGolomb = function() {
				this.skipBits(1 + this.skipLeadingZeros());
			}, this.readUnsignedExpGolomb = function() {
				var e = this.skipLeadingZeros();
				return this.readBits(e + 1) - 1;
			}, this.readExpGolomb = function() {
				var e = this.readUnsignedExpGolomb();
				return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
			}, this.readBoolean = function() {
				return this.readBits(1) === 1;
			}, this.readUnsignedByte = function() {
				return this.readBits(8);
			}, this.loadWord();
		}, Lt = n, Rt = It, zt, Bt = function() {
			var e = 0, t, n;
			Bt.prototype.init.call(this), this.push = function(r) {
				var i;
				n ? (i = new Uint8Array(n.byteLength + r.data.byteLength), i.set(n), i.set(r.data, n.byteLength), n = i) : n = r.data;
				for (var a = n.byteLength; e < a - 3; e++) if (n[e + 2] === 1) {
					t = e + 5;
					break;
				}
				for (; t < a;) switch (n[t]) {
					case 0:
						if (n[t - 1] !== 0) {
							t += 2;
							break;
						}
						if (n[t - 2] !== 0) {
							t++;
							break;
						}
						e + 3 !== t - 2 && this.trigger("data", n.subarray(e + 3, t - 2));
						do
							t++;
						while (n[t] !== 1 && t < a);
						e = t - 2, t += 3;
						break;
					case 1:
						if (n[t - 1] !== 0 || n[t - 2] !== 0) {
							t += 3;
							break;
						}
						this.trigger("data", n.subarray(e + 3, t - 2)), e = t - 2, t += 3;
						break;
					default: t += 3;
				}
				n = n.subarray(e), t -= e, e = 0;
			}, this.reset = function() {
				n = null, e = 0, this.trigger("reset");
			}, this.flush = function() {
				n && n.byteLength > 3 && this.trigger("data", n.subarray(e + 3)), n = null, e = 0, this.trigger("done");
			}, this.endTimeline = function() {
				this.flush(), this.trigger("endedtimeline");
			};
		}, Vt;
		Bt.prototype = new Lt(), Vt = {
			100: !0,
			110: !0,
			122: !0,
			244: !0,
			44: !0,
			83: !0,
			86: !0,
			118: !0,
			128: !0,
			138: !0,
			139: !0,
			134: !0
		}, zt = function() {
			var e = new Bt(), t, n, r, i, a, o, s;
			zt.prototype.init.call(this), t = this, this.push = function(t) {
				t.type === "video" && (n = t.trackId, r = t.pts, i = t.dts, e.push(t));
			}, e.on("data", function(e) {
				var s = {
					trackId: n,
					pts: r,
					dts: i,
					data: e,
					nalUnitTypeCode: e[0] & 31
				};
				switch (s.nalUnitTypeCode) {
					case 5:
						s.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
						break;
					case 6:
						s.nalUnitType = "sei_rbsp", s.escapedRBSP = a(e.subarray(1));
						break;
					case 7:
						s.nalUnitType = "seq_parameter_set_rbsp", s.escapedRBSP = a(e.subarray(1)), s.config = o(s.escapedRBSP);
						break;
					case 8:
						s.nalUnitType = "pic_parameter_set_rbsp";
						break;
					case 9: s.nalUnitType = "access_unit_delimiter_rbsp";
				}
				t.trigger("data", s);
			}), e.on("done", function() {
				t.trigger("done");
			}), e.on("partialdone", function() {
				t.trigger("partialdone");
			}), e.on("reset", function() {
				t.trigger("reset");
			}), e.on("endedtimeline", function() {
				t.trigger("endedtimeline");
			}), this.flush = function() {
				e.flush();
			}, this.partialFlush = function() {
				e.partialFlush();
			}, this.reset = function() {
				e.reset();
			}, this.endTimeline = function() {
				e.endTimeline();
			}, s = function(e, t) {
				var n = 8, r = 8, i, a;
				for (i = 0; i < e; i++) r !== 0 && (a = t.readExpGolomb(), r = (n + a + 256) % 256), n = r === 0 ? n : r;
			}, a = function(e) {
				for (var t = e.byteLength, n = [], r = 1, i, a; r < t - 2;) e[r] === 0 && e[r + 1] === 0 && e[r + 2] === 3 ? (n.push(r + 2), r += 2) : r++;
				if (n.length === 0) return e;
				i = t - n.length, a = new Uint8Array(i);
				var o = 0;
				for (r = 0; r < i; o++, r++) o === n[0] && (o++, n.shift()), a[r] = e[o];
				return a;
			}, o = function(e) {
				var t = 0, n = 0, r = 0, i = 0, a, o, c, l, u, d, f, p, m, h, g, _ = [1, 1], v, y;
				if (a = new Rt(e), o = a.readUnsignedByte(), l = a.readUnsignedByte(), c = a.readUnsignedByte(), a.skipUnsignedExpGolomb(), Vt[o] && (u = a.readUnsignedExpGolomb(), u === 3 && a.skipBits(1), a.skipUnsignedExpGolomb(), a.skipUnsignedExpGolomb(), a.skipBits(1), a.readBoolean())) for (g = u === 3 ? 12 : 8, y = 0; y < g; y++) a.readBoolean() && s(y < 6 ? 16 : 64, a);
				if (a.skipUnsignedExpGolomb(), d = a.readUnsignedExpGolomb(), d === 0) a.readUnsignedExpGolomb();
				else if (d === 1) for (a.skipBits(1), a.skipExpGolomb(), a.skipExpGolomb(), f = a.readUnsignedExpGolomb(), y = 0; y < f; y++) a.skipExpGolomb();
				if (a.skipUnsignedExpGolomb(), a.skipBits(1), p = a.readUnsignedExpGolomb(), m = a.readUnsignedExpGolomb(), h = a.readBits(1), h === 0 && a.skipBits(1), a.skipBits(1), a.readBoolean() && (t = a.readUnsignedExpGolomb(), n = a.readUnsignedExpGolomb(), r = a.readUnsignedExpGolomb(), i = a.readUnsignedExpGolomb()), a.readBoolean() && a.readBoolean()) {
					switch (v = a.readUnsignedByte(), v) {
						case 1:
							_ = [1, 1];
							break;
						case 2:
							_ = [12, 11];
							break;
						case 3:
							_ = [10, 11];
							break;
						case 4:
							_ = [16, 11];
							break;
						case 5:
							_ = [40, 33];
							break;
						case 6:
							_ = [24, 11];
							break;
						case 7:
							_ = [20, 11];
							break;
						case 8:
							_ = [32, 11];
							break;
						case 9:
							_ = [80, 33];
							break;
						case 10:
							_ = [18, 11];
							break;
						case 11:
							_ = [15, 11];
							break;
						case 12:
							_ = [64, 33];
							break;
						case 13:
							_ = [160, 99];
							break;
						case 14:
							_ = [4, 3];
							break;
						case 15:
							_ = [3, 2];
							break;
						case 16:
							_ = [2, 1];
							break;
						case 255: _ = [a.readUnsignedByte() << 8 | a.readUnsignedByte(), a.readUnsignedByte() << 8 | a.readUnsignedByte()];
					}
					_ && _[0] / _[1];
				}
				return {
					profileIdc: o,
					levelIdc: c,
					profileCompatibility: l,
					width: (p + 1) * 16 - t * 2 - n * 2,
					height: (2 - h) * (m + 1) * 16 - r * 2 - i * 2,
					sarRatio: _
				};
			};
		}, zt.prototype = new Lt();
		var Ht = {
			H264Stream: zt,
			NalByteStream: Bt
		}, Ut = [
			96e3,
			88200,
			64e3,
			48e3,
			44100,
			32e3,
			24e3,
			22050,
			16e3,
			12e3,
			11025,
			8e3,
			7350
		], Wt = function(e, t) {
			var n = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9], r = (e[t + 5] & 16) >> 4;
			return n = n >= 0 ? n : 0, r ? n + 20 : n + 10;
		}, Gt = function(e, t) {
			return e.length - t < 10 || e[t] !== 73 || e[t + 1] !== 68 || e[t + 2] !== 51 ? t : (t += Wt(e, t), Gt(e, t));
		}, Kt = function(e) {
			var t = Gt(e, 0);
			return e.length >= t + 2 && (e[t] & 255) == 255 && (e[t + 1] & 240) == 240 && (e[t + 1] & 22) == 16;
		}, qt = function(e) {
			return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
		}, Jt = function(e, t, n) {
			var r, i = "";
			for (r = t; r < n; r++) i += "%" + ("00" + e[r].toString(16)).slice(-2);
			return i;
		}, Yt = function(e, t, n) {
			return unescape(Jt(e, t, n));
		}, Xt = {
			isLikelyAacData: Kt,
			parseId3TagSize: Wt,
			parseAdtsSize: function(e, t) {
				var n = (e[t + 5] & 224) >> 5, r = e[t + 4] << 3;
				return e[t + 3] & 6144 | r | n;
			},
			parseType: function(e, t) {
				return e[t] === 73 && e[t + 1] === 68 && e[t + 2] === 51 ? "timed-metadata" : e[t] & !0 && (e[t + 1] & 240) == 240 ? "audio" : null;
			},
			parseSampleRate: function(e) {
				for (var t = 0; t + 5 < e.length;) {
					if (e[t] !== 255 || (e[t + 1] & 246) != 240) {
						t++;
						continue;
					}
					return Ut[(e[t + 2] & 60) >>> 2];
				}
				return null;
			},
			parseAacTimestamp: function(e) {
				var t = 10, n, r, i;
				e[5] & 64 && (t += 4, t += qt(e.subarray(10, 14)));
				do {
					if (n = qt(e.subarray(t + 4, t + 8)), n < 1) return null;
					if (i = String.fromCharCode(e[t], e[t + 1], e[t + 2], e[t + 3]), i === "PRIV") {
						r = e.subarray(t + 10, t + n + 10);
						for (var a = 0; a < r.byteLength; a++) if (r[a] === 0) {
							if (Yt(r, 0, a) === "com.apple.streaming.transportStreamTimestamp") {
								var o = r.subarray(a + 1), s = (o[3] & 1) << 30 | o[4] << 22 | o[5] << 14 | o[6] << 6 | o[7] >>> 2;
								return s *= 4, s += o[7] & 3, s;
							}
							break;
						}
					}
					t += 10, t += n;
				} while (t < e.byteLength);
				return null;
			}
		}, Zt = n, Qt = Xt, $t = function() {
			var e = /* @__PURE__ */ new Uint8Array(), t = 0;
			$t.prototype.init.call(this), this.setTimestamp = function(e) {
				t = e;
			}, this.push = function(n) {
				var r = 0, i = 0, a, o, s, c;
				for (e.length ? (c = e.length, e = new Uint8Array(n.byteLength + c), e.set(e.subarray(0, c)), e.set(n, c)) : e = n; e.length - i >= 3;) {
					if (e[i] === 73 && e[i + 1] === 68 && e[i + 2] === 51) {
						if (e.length - i < 10 || (r = Qt.parseId3TagSize(e, i), i + r > e.length)) break;
						o = {
							type: "timed-metadata",
							data: e.subarray(i, i + r)
						}, this.trigger("data", o), i += r;
						continue;
					}
					if ((e[i] & 255) == 255 && (e[i + 1] & 240) == 240) {
						if (e.length - i < 7 || (r = Qt.parseAdtsSize(e, i), i + r > e.length)) break;
						s = {
							type: "audio",
							data: e.subarray(i, i + r),
							pts: t,
							dts: t
						}, this.trigger("data", s), i += r;
						continue;
					}
					i++;
				}
				a = e.length - i, e = a > 0 ? e.subarray(i) : /* @__PURE__ */ new Uint8Array();
			}, this.reset = function() {
				e = /* @__PURE__ */ new Uint8Array(), this.trigger("reset");
			}, this.endTimeline = function() {
				e = /* @__PURE__ */ new Uint8Array(), this.trigger("endedtimeline");
			};
		};
		$t.prototype = new Zt();
		var en = $t, tn = [
			"audioobjecttype",
			"channelcount",
			"samplerate",
			"samplingfrequencyindex",
			"samplesize"
		], nn = [
			"width",
			"height",
			"profileIdc",
			"levelIdc",
			"profileCompatibility",
			"sarRatio"
		], rn = n, an = ue, on = ge, sn = je, cn = Ne, ln = At, un = De, dn = Ft, fn = Ht.H264Stream, pn = en, mn = Xt.isLikelyAacData, hn = De.ONE_SECOND_IN_TS, gn = tn, _n = nn, P, vn, yn, bn, xn = function(e, t) {
			t.stream = e, this.trigger("log", t);
		}, F = function(e, t) {
			for (var n = Object.keys(t), r = 0; r < n.length; r++) {
				var i = n[r];
				i === "headOfPipeline" || !t[i].on || t[i].on("log", xn.bind(e, i));
			}
		}, Sn = function(e, t) {
			var n;
			if (e.length !== t.length) return !1;
			for (n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
			return !0;
		}, Cn = function(e, t, n, r, i, a) {
			var o = n - t, s = r - t, c = i - n;
			return {
				start: {
					dts: e,
					pts: e + o
				},
				end: {
					dts: e + s,
					pts: e + c
				},
				prependedContentDuration: a,
				baseMediaDecodeTime: e
			};
		};
		vn = function(e, t) {
			var n = [], r, i = 0, a = 0, o = Infinity;
			t ||= {}, r = t.firstSequenceNumber || 0, vn.prototype.init.call(this), this.push = function(t) {
				cn.collectDtsInfo(e, t), e && gn.forEach(function(n) {
					e[n] = t[n];
				}), n.push(t);
			}, this.setEarliestDts = function(e) {
				i = e;
			}, this.setVideoBaseMediaDecodeTime = function(e) {
				o = e;
			}, this.setAudioAppendStart = function(e) {
				a = e;
			}, this.flush = function() {
				var s, c, l, u, d, f, p;
				if (n.length === 0) {
					this.trigger("done", "AudioSegmentStream");
					return;
				}
				s = sn.trimAdtsFramesByEarliestDts(n, e, i), e.baseMediaDecodeTime = cn.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), p = sn.prefixWithSilence(e, s, a, o), e.samples = sn.generateSampleTable(s), l = an.mdat(sn.concatenateFrameData(s)), n = [], c = an.moof(r, [e]), u = new Uint8Array(c.byteLength + l.byteLength), r++, u.set(c), u.set(l, c.byteLength), cn.clearDtsInfo(e), d = Math.ceil(hn * 1024 / e.samplerate), s.length && (f = s.length * d, this.trigger("segmentTimingInfo", Cn(un.audioTsToVideoTs(e.baseMediaDecodeTime, e.samplerate), s[0].dts, s[0].pts, s[0].dts + f, s[0].pts + f, p || 0)), this.trigger("timingInfo", {
					start: s[0].pts,
					end: s[0].pts + f
				})), this.trigger("data", {
					track: e,
					boxes: u
				}), this.trigger("done", "AudioSegmentStream");
			}, this.reset = function() {
				cn.clearDtsInfo(e), n = [], this.trigger("reset");
			};
		}, vn.prototype = new rn(), P = function(e, t) {
			var n, r = [], i = [], a, o;
			t ||= {}, n = t.firstSequenceNumber || 0, P.prototype.init.call(this), delete e.minPTS, this.gopCache_ = [], this.push = function(t) {
				cn.collectDtsInfo(e, t), t.nalUnitType === "seq_parameter_set_rbsp" && !a && (a = t.config, e.sps = [t.data], _n.forEach(function(t) {
					e[t] = a[t];
				}, this)), t.nalUnitType === "pic_parameter_set_rbsp" && !o && (o = t.data, e.pps = [t.data]), r.push(t);
			}, this.flush = function() {
				for (var a, o, s, c, l, u, d = 0, f, p; r.length && r[0].nalUnitType !== "access_unit_delimiter_rbsp";) r.shift();
				if (r.length === 0) {
					this.resetStream_(), this.trigger("done", "VideoSegmentStream");
					return;
				}
				if (a = on.groupNalsIntoFrames(r), s = on.groupFramesIntoGops(a), s[0][0].keyFrame || (o = this.getGopForFusion_(r[0], e), o ? (d = o.duration, s.unshift(o), s.byteLength += o.byteLength, s.nalCount += o.nalCount, s.pts = o.pts, s.dts = o.dts, s.duration += o.duration) : s = on.extendFirstKeyFrame(s)), i.length) {
					var m = t.alignGopsAtEnd ? this.alignGopsAtEnd_(s) : this.alignGopsAtStart_(s);
					if (!m) {
						this.gopCache_.unshift({
							gop: s.pop(),
							pps: e.pps,
							sps: e.sps
						}), this.gopCache_.length = Math.min(6, this.gopCache_.length), r = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
						return;
					}
					cn.clearDtsInfo(e), s = m;
				}
				cn.collectDtsInfo(e, s), e.samples = on.generateSampleTable(s), l = an.mdat(on.concatenateNalData(s)), e.baseMediaDecodeTime = cn.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), this.trigger("processedGopsInfo", s.map(function(e) {
					return {
						pts: e.pts,
						dts: e.dts,
						byteLength: e.byteLength
					};
				})), f = s[0], p = s[s.length - 1], this.trigger("segmentTimingInfo", Cn(e.baseMediaDecodeTime, f.dts, f.pts, p.dts + p.duration, p.pts + p.duration, d)), this.trigger("timingInfo", {
					start: s[0].pts,
					end: s[s.length - 1].pts + s[s.length - 1].duration
				}), this.gopCache_.unshift({
					gop: s.pop(),
					pps: e.pps,
					sps: e.sps
				}), this.gopCache_.length = Math.min(6, this.gopCache_.length), r = [], this.trigger("baseMediaDecodeTime", e.baseMediaDecodeTime), this.trigger("timelineStartInfo", e.timelineStartInfo), c = an.moof(n, [e]), u = new Uint8Array(c.byteLength + l.byteLength), n++, u.set(c), u.set(l, c.byteLength), this.trigger("data", {
					track: e,
					boxes: u
				}), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
			}, this.reset = function() {
				this.resetStream_(), r = [], this.gopCache_.length = 0, i.length = 0, this.trigger("reset");
			}, this.resetStream_ = function() {
				cn.clearDtsInfo(e), a = void 0, o = void 0;
			}, this.getGopForFusion_ = function(t) {
				var n = 45e3, r = 1e4, i = Infinity, a, o, s, c, l;
				for (l = 0; l < this.gopCache_.length; l++) c = this.gopCache_[l], s = c.gop, !(!(e.pps && Sn(e.pps[0], c.pps[0])) || !(e.sps && Sn(e.sps[0], c.sps[0]))) && (s.dts < e.timelineStartInfo.dts || (a = t.dts - s.dts - s.duration, a >= -r && a <= n && (!o || i > a) && (o = c, i = a)));
				return o ? o.gop : null;
			}, this.alignGopsAtStart_ = function(e) {
				var t, n, r, a, o = e.byteLength, s = e.nalCount, c = e.duration, l;
				for (t = n = 0; t < i.length && n < e.length && (r = i[t], a = e[n], r.pts !== a.pts);) {
					if (a.pts > r.pts) {
						t++;
						continue;
					}
					n++, o -= a.byteLength, s -= a.nalCount, c -= a.duration;
				}
				return n === 0 ? e : n === e.length ? null : (l = e.slice(n), l.byteLength = o, l.duration = c, l.nalCount = s, l.pts = l[0].pts, l.dts = l[0].dts, l);
			}, this.alignGopsAtEnd_ = function(e) {
				for (var t = i.length - 1, n = e.length - 1, r, a, o = null, s = !1; t >= 0 && n >= 0;) {
					if (r = i[t], a = e[n], r.pts === a.pts) {
						s = !0;
						break;
					}
					if (r.pts > a.pts) {
						t--;
						continue;
					}
					t === i.length - 1 && (o = n), n--;
				}
				if (!s && o === null) return null;
				var c = s ? n : o;
				if (c === 0) return e;
				var l = e.slice(c), u = l.reduce(function(e, t) {
					return e.byteLength += t.byteLength, e.duration += t.duration, e.nalCount += t.nalCount, e;
				}, {
					byteLength: 0,
					duration: 0,
					nalCount: 0
				});
				return l.byteLength = u.byteLength, l.duration = u.duration, l.nalCount = u.nalCount, l.pts = l[0].pts, l.dts = l[0].dts, l;
			}, this.alignGopsWith = function(e) {
				i = e;
			};
		}, P.prototype = new rn(), bn = function(e, t) {
			this.numberOfTracks = 0, this.metadataStream = t, e ||= {}, this.remuxTracks = e.remux === void 0 || !!e.remux, this.keepOriginalTimestamps = typeof e.keepOriginalTimestamps == "boolean" && e.keepOriginalTimestamps, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, bn.prototype.init.call(this), this.push = function(e) {
				if (e.content || e.text) return this.pendingCaptions.push(e);
				if (e.frames) return this.pendingMetadata.push(e);
				this.pendingTracks.push(e.track), this.pendingBytes += e.boxes.byteLength, e.track.type === "video" && (this.videoTrack = e.track, this.pendingBoxes.push(e.boxes)), e.track.type === "audio" && (this.audioTrack = e.track, this.pendingBoxes.unshift(e.boxes));
			};
		}, bn.prototype = new rn(), bn.prototype.flush = function(e) {
			var t = 0, n = {
				captions: [],
				captionStreams: {},
				metadata: [],
				info: {}
			}, r, i, a, o = 0, s;
			if (this.pendingTracks.length < this.numberOfTracks) {
				if (e !== "VideoSegmentStream" && e !== "AudioSegmentStream" || this.remuxTracks) return;
				if (this.pendingTracks.length === 0) {
					this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
					return;
				}
			}
			if (this.videoTrack ? (o = this.videoTrack.timelineStartInfo.pts, _n.forEach(function(e) {
				n.info[e] = this.videoTrack[e];
			}, this)) : this.audioTrack && (o = this.audioTrack.timelineStartInfo.pts, gn.forEach(function(e) {
				n.info[e] = this.audioTrack[e];
			}, this)), this.videoTrack || this.audioTrack) {
				for (n.type = this.pendingTracks.length === 1 ? this.pendingTracks[0].type : "combined", this.emittedTracks += this.pendingTracks.length, a = an.initSegment(this.pendingTracks), n.initSegment = new Uint8Array(a.byteLength), n.initSegment.set(a), n.data = new Uint8Array(this.pendingBytes), s = 0; s < this.pendingBoxes.length; s++) n.data.set(this.pendingBoxes[s], t), t += this.pendingBoxes[s].byteLength;
				for (s = 0; s < this.pendingCaptions.length; s++) r = this.pendingCaptions[s], r.startTime = un.metadataTsToSeconds(r.startPts, o, this.keepOriginalTimestamps), r.endTime = un.metadataTsToSeconds(r.endPts, o, this.keepOriginalTimestamps), n.captionStreams[r.stream] = !0, n.captions.push(r);
				for (s = 0; s < this.pendingMetadata.length; s++) i = this.pendingMetadata[s], i.cueTime = un.metadataTsToSeconds(i.pts, o, this.keepOriginalTimestamps), n.metadata.push(i);
				for (n.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", n), s = 0; s < n.captions.length; s++) r = n.captions[s], this.trigger("caption", r);
				for (s = 0; s < n.metadata.length; s++) i = n.metadata[s], this.trigger("id3Frame", i);
			}
			this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
		}, bn.prototype.setRemux = function(e) {
			this.remuxTracks = e;
		}, yn = function(e) {
			var t = this, n = !0, r, i;
			yn.prototype.init.call(this), e ||= {}, this.baseMediaDecodeTime = e.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
				var n = {};
				this.transmuxPipeline_ = n, n.type = "aac", n.metadataStream = new ln.MetadataStream(), n.aacStream = new pn(), n.audioTimestampRolloverStream = new ln.TimestampRolloverStream("audio"), n.timedMetadataTimestampRolloverStream = new ln.TimestampRolloverStream("timed-metadata"), n.adtsStream = new dn(), n.coalesceStream = new bn(e, n.metadataStream), n.headOfPipeline = n.aacStream, n.aacStream.pipe(n.audioTimestampRolloverStream).pipe(n.adtsStream), n.aacStream.pipe(n.timedMetadataTimestampRolloverStream).pipe(n.metadataStream).pipe(n.coalesceStream), n.metadataStream.on("timestamp", function(e) {
					n.aacStream.setTimestamp(e.timeStamp);
				}), n.aacStream.on("data", function(a) {
					a.type !== "timed-metadata" && a.type !== "audio" || n.audioSegmentStream || (i ||= {
						timelineStartInfo: { baseMediaDecodeTime: t.baseMediaDecodeTime },
						codec: "adts",
						type: "audio"
					}, n.coalesceStream.numberOfTracks++, n.audioSegmentStream = new vn(i, e), n.audioSegmentStream.on("log", t.getLogTrigger_("audioSegmentStream")), n.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), n.adtsStream.pipe(n.audioSegmentStream).pipe(n.coalesceStream), t.trigger("trackinfo", {
						hasAudio: !!i,
						hasVideo: !!r
					}));
				}), n.coalesceStream.on("data", this.trigger.bind(this, "data")), n.coalesceStream.on("done", this.trigger.bind(this, "done")), F(this, n);
			}, this.setupTsPipeline = function() {
				var n = {};
				this.transmuxPipeline_ = n, n.type = "ts", n.metadataStream = new ln.MetadataStream(), n.packetStream = new ln.TransportPacketStream(), n.parseStream = new ln.TransportParseStream(), n.elementaryStream = new ln.ElementaryStream(), n.timestampRolloverStream = new ln.TimestampRolloverStream(), n.adtsStream = new dn(), n.h264Stream = new fn(), n.captionStream = new ln.CaptionStream(e), n.coalesceStream = new bn(e, n.metadataStream), n.headOfPipeline = n.packetStream, n.packetStream.pipe(n.parseStream).pipe(n.elementaryStream).pipe(n.timestampRolloverStream), n.timestampRolloverStream.pipe(n.h264Stream), n.timestampRolloverStream.pipe(n.adtsStream), n.timestampRolloverStream.pipe(n.metadataStream).pipe(n.coalesceStream), n.h264Stream.pipe(n.captionStream).pipe(n.coalesceStream), n.elementaryStream.on("data", function(a) {
					var o;
					if (a.type === "metadata") {
						for (o = a.tracks.length; o--;) !r && a.tracks[o].type === "video" ? (r = a.tracks[o], r.timelineStartInfo.baseMediaDecodeTime = t.baseMediaDecodeTime) : !i && a.tracks[o].type === "audio" && (i = a.tracks[o], i.timelineStartInfo.baseMediaDecodeTime = t.baseMediaDecodeTime);
						r && !n.videoSegmentStream && (n.coalesceStream.numberOfTracks++, n.videoSegmentStream = new P(r, e), n.videoSegmentStream.on("log", t.getLogTrigger_("videoSegmentStream")), n.videoSegmentStream.on("timelineStartInfo", function(r) {
							i && !e.keepOriginalTimestamps && (i.timelineStartInfo = r, n.audioSegmentStream.setEarliestDts(r.dts - t.baseMediaDecodeTime));
						}), n.videoSegmentStream.on("processedGopsInfo", t.trigger.bind(t, "gopInfo")), n.videoSegmentStream.on("segmentTimingInfo", t.trigger.bind(t, "videoSegmentTimingInfo")), n.videoSegmentStream.on("baseMediaDecodeTime", function(e) {
							i && n.audioSegmentStream.setVideoBaseMediaDecodeTime(e);
						}), n.videoSegmentStream.on("timingInfo", t.trigger.bind(t, "videoTimingInfo")), n.h264Stream.pipe(n.videoSegmentStream).pipe(n.coalesceStream)), i && !n.audioSegmentStream && (n.coalesceStream.numberOfTracks++, n.audioSegmentStream = new vn(i, e), n.audioSegmentStream.on("log", t.getLogTrigger_("audioSegmentStream")), n.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), n.audioSegmentStream.on("segmentTimingInfo", t.trigger.bind(t, "audioSegmentTimingInfo")), n.adtsStream.pipe(n.audioSegmentStream).pipe(n.coalesceStream)), t.trigger("trackinfo", {
							hasAudio: !!i,
							hasVideo: !!r
						});
					}
				}), n.coalesceStream.on("data", this.trigger.bind(this, "data")), n.coalesceStream.on("id3Frame", function(e) {
					e.dispatchType = n.metadataStream.dispatchType, t.trigger("id3Frame", e);
				}), n.coalesceStream.on("caption", this.trigger.bind(this, "caption")), n.coalesceStream.on("done", this.trigger.bind(this, "done")), F(this, n);
			}, this.setBaseMediaDecodeTime = function(t) {
				var n = this.transmuxPipeline_;
				e.keepOriginalTimestamps || (this.baseMediaDecodeTime = t), i && (i.timelineStartInfo.dts = void 0, i.timelineStartInfo.pts = void 0, cn.clearDtsInfo(i), n.audioTimestampRolloverStream && n.audioTimestampRolloverStream.discontinuity()), r && (n.videoSegmentStream && (n.videoSegmentStream.gopCache_ = []), r.timelineStartInfo.dts = void 0, r.timelineStartInfo.pts = void 0, cn.clearDtsInfo(r), n.captionStream.reset()), n.timestampRolloverStream && n.timestampRolloverStream.discontinuity();
			}, this.setAudioAppendStart = function(e) {
				i && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(e);
			}, this.setRemux = function(t) {
				var n = this.transmuxPipeline_;
				e.remux = t, n && n.coalesceStream && n.coalesceStream.setRemux(t);
			}, this.alignGopsWith = function(e) {
				r && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(e);
			}, this.getLogTrigger_ = function(e) {
				var t = this;
				return function(n) {
					n.stream = e, t.trigger("log", n);
				};
			}, this.push = function(e) {
				if (n) {
					var t = mn(e);
					t && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !t && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), n = !1;
				}
				this.transmuxPipeline_.headOfPipeline.push(e);
			}, this.flush = function() {
				n = !0, this.transmuxPipeline_.headOfPipeline.flush();
			}, this.endTimeline = function() {
				this.transmuxPipeline_.headOfPipeline.endTimeline();
			}, this.reset = function() {
				this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
			}, this.resetCaptions = function() {
				this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
			};
		}, yn.prototype = new rn();
		var wn = {
			Transmuxer: yn,
			VideoSegmentStream: P,
			AudioSegmentStream: vn,
			AUDIO_PROPERTIES: gn,
			VIDEO_PROPERTIES: _n,
			generateSegmentTimingInfo: Cn
		}, Tn = {
			toUnsigned: function(e) {
				return e >>> 0;
			},
			toHexString: function(e) {
				return ("00" + e.toString(16)).slice(-2);
			}
		}, En = function(e) {
			var t = "";
			return t += String.fromCharCode(e[0]), t += String.fromCharCode(e[1]), t += String.fromCharCode(e[2]), t += String.fromCharCode(e[3]), t;
		}, Dn = Tn.toUnsigned, On = En, kn = function(e, t) {
			var n = [], r, i, a, o, s;
			if (!t.length) return null;
			for (r = 0; r < e.byteLength;) i = Dn(e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]), a = On(e.subarray(r + 4, r + 8)), o = i > 1 ? r + i : e.byteLength, a === t[0] && (t.length === 1 ? n.push(e.subarray(r + 8, o)) : (s = kn(e.subarray(r + 8, o), t.slice(1)), s.length && (n = n.concat(s)))), r = o;
			return n;
		}, An = kn, jn = Tn.toUnsigned, Mn = i.getUint64, Nn = function(e) {
			var t = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4))
			};
			return t.baseMediaDecodeTime = t.version === 1 ? Mn(e.subarray(4)) : jn(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]), t;
		}, Pn = function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4)),
				trackId: t.getUint32(4)
			}, r = n.flags[2] & 1, i = n.flags[2] & 2, a = n.flags[2] & 8, o = n.flags[2] & 16, s = n.flags[2] & 32, c = n.flags[0] & 65536, l = n.flags[0] & 131072, u = 8;
			return r && (u += 4, n.baseDataOffset = t.getUint32(12), u += 4), i && (n.sampleDescriptionIndex = t.getUint32(u), u += 4), a && (n.defaultSampleDuration = t.getUint32(u), u += 4), o && (n.defaultSampleSize = t.getUint32(u), u += 4), s && (n.defaultSampleFlags = t.getUint32(u)), c && (n.durationIsEmpty = !0), !r && l && (n.baseDataOffsetIsMoof = !0), n;
		}, Fn = i.getUint64, In = function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4)),
				references: [],
				referenceId: t.getUint32(4),
				timescale: t.getUint32(8)
			}, r = 12;
			n.version === 0 ? (n.earliestPresentationTime = t.getUint32(r), n.firstOffset = t.getUint32(r + 4), r += 8) : (n.earliestPresentationTime = Fn(e.subarray(r)), n.firstOffset = Fn(e.subarray(r + 8)), r += 16), r += 2;
			var i = t.getUint16(r);
			for (r += 2; i > 0; r += 12, i--) n.references.push({
				referenceType: (e[r] & 128) >>> 7,
				referencedSize: t.getUint32(r) & 2147483647,
				subsegmentDuration: t.getUint32(r + 4),
				startsWithSap: !!(e[r + 8] & 128),
				sapType: (e[r + 8] & 112) >>> 4,
				sapDeltaTime: t.getUint32(r + 8) & 268435455
			});
			return n;
		}, Ln = function(e) {
			return {
				isLeading: (e[0] & 12) >>> 2,
				dependsOn: e[0] & 3,
				isDependedOn: (e[1] & 192) >>> 6,
				hasRedundancy: (e[1] & 48) >>> 4,
				paddingValue: (e[1] & 14) >>> 1,
				isNonSyncSample: e[1] & 1,
				degradationPriority: e[2] << 8 | e[3]
			};
		}, Rn = function(e) {
			var t = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4)),
				samples: []
			}, n = new DataView(e.buffer, e.byteOffset, e.byteLength), r = t.flags[2] & 1, i = t.flags[2] & 4, a = t.flags[1] & 1, o = t.flags[1] & 2, s = t.flags[1] & 4, c = t.flags[1] & 8, l = n.getUint32(4), u = 8, d;
			for (r && (t.dataOffset = n.getInt32(u), u += 4), i && l && (d = { flags: Ln(e.subarray(u, u + 4)) }, u += 4, a && (d.duration = n.getUint32(u), u += 4), o && (d.size = n.getUint32(u), u += 4), c && (t.version === 1 ? d.compositionTimeOffset = n.getInt32(u) : d.compositionTimeOffset = n.getUint32(u), u += 4), t.samples.push(d), l--); l--;) d = {}, a && (d.duration = n.getUint32(u), u += 4), o && (d.size = n.getUint32(u), u += 4), s && (d.flags = Ln(e.subarray(u, u + 4)), u += 4), c && (t.version === 1 ? d.compositionTimeOffset = n.getInt32(u) : d.compositionTimeOffset = n.getUint32(u), u += 4), t.samples.push(d);
			return t;
		}, zn = i.getUint64, Bn, Vn, Hn = function(e) {
			return /* @__PURE__ */ new Date(e * 1e3 - 20828448e5);
		}, Un = En, Wn = An, Gn = function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = [], r, i;
			for (r = 0; r + 4 < e.length; r += i) {
				if (i = t.getUint32(r), r += 4, i <= 0) {
					n.push("<span style='color:red;'>MALFORMED DATA</span>");
					continue;
				}
				switch (e[r] & 31) {
					case 1:
						n.push("slice_layer_without_partitioning_rbsp");
						break;
					case 5:
						n.push("slice_layer_without_partitioning_rbsp_idr");
						break;
					case 6:
						n.push("sei_rbsp");
						break;
					case 7:
						n.push("seq_parameter_set_rbsp");
						break;
					case 8:
						n.push("pic_parameter_set_rbsp");
						break;
					case 9:
						n.push("access_unit_delimiter_rbsp");
						break;
					default: n.push("UNKNOWN NAL - " + e[r] & 31);
				}
			}
			return n;
		}, Kn = {
			avc1: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					dataReferenceIndex: t.getUint16(6),
					width: t.getUint16(24),
					height: t.getUint16(26),
					horizresolution: t.getUint16(28) + t.getUint16(30) / 16,
					vertresolution: t.getUint16(32) + t.getUint16(34) / 16,
					frameCount: t.getUint16(40),
					depth: t.getUint16(74),
					config: Bn(e.subarray(78, e.byteLength))
				};
			},
			avcC: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					configurationVersion: e[0],
					avcProfileIndication: e[1],
					profileCompatibility: e[2],
					avcLevelIndication: e[3],
					lengthSizeMinusOne: e[4] & 3,
					sps: [],
					pps: []
				}, r = e[5] & 31, i, a, o = 6, s;
				for (s = 0; s < r; s++) a = t.getUint16(o), o += 2, n.sps.push(new Uint8Array(e.subarray(o, o + a))), o += a;
				for (i = e[o], o++, s = 0; s < i; s++) a = t.getUint16(o), o += 2, n.pps.push(new Uint8Array(e.subarray(o, o + a))), o += a;
				return n;
			},
			btrt: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					bufferSizeDB: t.getUint32(0),
					maxBitrate: t.getUint32(4),
					avgBitrate: t.getUint32(8)
				};
			},
			edts: function(e) {
				return { boxes: Bn(e) };
			},
			elst: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					edits: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; r--) n.version === 0 ? (n.edits.push({
					segmentDuration: t.getUint32(i),
					mediaTime: t.getInt32(i + 4),
					mediaRate: t.getUint16(i + 8) + t.getUint16(i + 10) / 65536
				}), i += 12) : (n.edits.push({
					segmentDuration: zn(e.subarray(i)),
					mediaTime: zn(e.subarray(i + 8)),
					mediaRate: t.getUint16(i + 16) + t.getUint16(i + 18) / 65536
				}), i += 20);
				return n;
			},
			esds: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					esId: e[6] << 8 | e[7],
					streamPriority: e[8] & 31,
					decoderConfig: {
						objectProfileIndication: e[11],
						streamType: e[12] >>> 2 & 63,
						bufferSize: e[13] << 16 | e[14] << 8 | e[15],
						maxBitrate: e[16] << 24 | e[17] << 16 | e[18] << 8 | e[19],
						avgBitrate: e[20] << 24 | e[21] << 16 | e[22] << 8 | e[23],
						decoderConfigDescriptor: {
							tag: e[24],
							length: e[25],
							audioObjectType: e[26] >>> 3 & 31,
							samplingFrequencyIndex: (e[26] & 7) << 1 | e[27] >>> 7 & 1,
							channelConfiguration: e[27] >>> 3 & 15
						}
					}
				};
			},
			ftyp: function(e) {
				for (var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					majorBrand: Un(e.subarray(0, 4)),
					minorVersion: t.getUint32(4),
					compatibleBrands: []
				}, r = 8; r < e.byteLength;) n.compatibleBrands.push(Un(e.subarray(r, r + 4))), r += 4;
				return n;
			},
			dinf: function(e) {
				return { boxes: Bn(e) };
			},
			dref: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					dataReferences: Bn(e.subarray(8))
				};
			},
			hdlr: function(e) {
				var t = {
					version: new DataView(e.buffer, e.byteOffset, e.byteLength).getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					handlerType: Un(e.subarray(8, 12)),
					name: ""
				}, n = 8;
				for (n = 24; n < e.byteLength; n++) {
					if (e[n] === 0) {
						n++;
						break;
					}
					t.name += String.fromCharCode(e[n]);
				}
				return t.name = decodeURIComponent(escape(t.name)), t;
			},
			mdat: function(e) {
				return {
					byteLength: e.byteLength,
					nals: Gn(e)
				};
			},
			mdhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = 4, r, i = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					language: ""
				};
				return i.version === 1 ? (n += 4, i.creationTime = Hn(t.getUint32(n)), n += 8, i.modificationTime = Hn(t.getUint32(n)), n += 4, i.timescale = t.getUint32(n), n += 8, i.duration = t.getUint32(n)) : (i.creationTime = Hn(t.getUint32(n)), n += 4, i.modificationTime = Hn(t.getUint32(n)), n += 4, i.timescale = t.getUint32(n), n += 4, i.duration = t.getUint32(n)), n += 4, r = t.getUint16(n), i.language += String.fromCharCode((r >> 10) + 96), i.language += String.fromCharCode(((r & 992) >> 5) + 96), i.language += String.fromCharCode((r & 31) + 96), i;
			},
			mdia: function(e) {
				return { boxes: Bn(e) };
			},
			mfhd: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sequenceNumber: e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]
				};
			},
			minf: function(e) {
				return { boxes: Bn(e) };
			},
			mp4a: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					dataReferenceIndex: t.getUint16(6),
					channelcount: t.getUint16(16),
					samplesize: t.getUint16(18),
					samplerate: t.getUint16(24) + t.getUint16(26) / 65536
				};
				return e.byteLength > 28 && (n.streamDescriptor = Bn(e.subarray(28))[0]), n;
			},
			moof: function(e) {
				return { boxes: Bn(e) };
			},
			moov: function(e) {
				return { boxes: Bn(e) };
			},
			mvex: function(e) {
				return { boxes: Bn(e) };
			},
			mvhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = 4, r = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4))
				};
				return r.version === 1 ? (n += 4, r.creationTime = Hn(t.getUint32(n)), n += 8, r.modificationTime = Hn(t.getUint32(n)), n += 4, r.timescale = t.getUint32(n), n += 8, r.duration = t.getUint32(n)) : (r.creationTime = Hn(t.getUint32(n)), n += 4, r.modificationTime = Hn(t.getUint32(n)), n += 4, r.timescale = t.getUint32(n), n += 4, r.duration = t.getUint32(n)), n += 4, r.rate = t.getUint16(n) + t.getUint16(n + 2) / 16, n += 4, r.volume = t.getUint8(n) + t.getUint8(n + 1) / 8, n += 2, n += 2, n += 8, r.matrix = new Uint32Array(e.subarray(n, n + 36)), n += 36, n += 24, r.nextTrackId = t.getUint32(n), r;
			},
			pdin: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					rate: t.getUint32(4),
					initialDelay: t.getUint32(8)
				};
			},
			sdtp: function(e) {
				var t = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					samples: []
				}, n;
				for (n = 4; n < e.byteLength; n++) t.samples.push({
					dependsOn: (e[n] & 48) >> 4,
					isDependedOn: (e[n] & 12) >> 2,
					hasRedundancy: e[n] & 3
				});
				return t;
			},
			sidx: In,
			smhd: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					balance: e[4] + e[5] / 256
				};
			},
			stbl: function(e) {
				return { boxes: Bn(e) };
			},
			ctts: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					compositionOffsets: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 8, r--) n.compositionOffsets.push({
					sampleCount: t.getUint32(i),
					sampleOffset: t[n.version === 0 ? "getUint32" : "getInt32"](i + 4)
				});
				return n;
			},
			stss: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					syncSamples: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 4, r--) n.syncSamples.push(t.getUint32(i));
				return n;
			},
			stco: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					chunkOffsets: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 4, r--) n.chunkOffsets.push(t.getUint32(i));
				return n;
			},
			stsc: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = t.getUint32(4), r = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sampleToChunks: []
				}, i;
				for (i = 8; n; i += 12, n--) r.sampleToChunks.push({
					firstChunk: t.getUint32(i),
					samplesPerChunk: t.getUint32(i + 4),
					sampleDescriptionIndex: t.getUint32(i + 8)
				});
				return r;
			},
			stsd: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sampleDescriptions: Bn(e.subarray(8))
				};
			},
			stsz: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sampleSize: t.getUint32(4),
					entries: []
				}, r;
				for (r = 12; r < e.byteLength; r += 4) n.entries.push(t.getUint32(r));
				return n;
			},
			stts: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					timeToSamples: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 8, r--) n.timeToSamples.push({
					sampleCount: t.getUint32(i),
					sampleDelta: t.getUint32(i + 4)
				});
				return n;
			},
			styp: function(e) {
				return Kn.ftyp(e);
			},
			tfdt: Nn,
			tfhd: Pn,
			tkhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = 4, r = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4))
				};
				return r.version === 1 ? (n += 4, r.creationTime = Hn(t.getUint32(n)), n += 8, r.modificationTime = Hn(t.getUint32(n)), n += 4, r.trackId = t.getUint32(n), n += 4, n += 8, r.duration = t.getUint32(n)) : (r.creationTime = Hn(t.getUint32(n)), n += 4, r.modificationTime = Hn(t.getUint32(n)), n += 4, r.trackId = t.getUint32(n), n += 4, n += 4, r.duration = t.getUint32(n)), n += 4, n += 8, r.layer = t.getUint16(n), n += 2, r.alternateGroup = t.getUint16(n), n += 2, r.volume = t.getUint8(n) + t.getUint8(n + 1) / 8, n += 2, n += 2, r.matrix = new Uint32Array(e.subarray(n, n + 36)), n += 36, r.width = t.getUint16(n) + t.getUint16(n + 2) / 65536, n += 4, r.height = t.getUint16(n) + t.getUint16(n + 2) / 65536, r;
			},
			traf: function(e) {
				return { boxes: Bn(e) };
			},
			trak: function(e) {
				return { boxes: Bn(e) };
			},
			trex: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					trackId: t.getUint32(4),
					defaultSampleDescriptionIndex: t.getUint32(8),
					defaultSampleDuration: t.getUint32(12),
					defaultSampleSize: t.getUint32(16),
					sampleDependsOn: e[20] & 3,
					sampleIsDependedOn: (e[21] & 192) >> 6,
					sampleHasRedundancy: (e[21] & 48) >> 4,
					samplePaddingValue: (e[21] & 14) >> 1,
					sampleIsDifferenceSample: !!(e[21] & 1),
					sampleDegradationPriority: t.getUint16(22)
				};
			},
			trun: Rn,
			"url ": function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4))
				};
			},
			vmhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					graphicsmode: t.getUint16(4),
					opcolor: new Uint16Array([
						t.getUint16(6),
						t.getUint16(8),
						t.getUint16(10)
					])
				};
			}
		};
		Bn = function(e) {
			for (var t = 0, n = [], r, i, a, o, s, c = new ArrayBuffer(e.length), l = new Uint8Array(c), u = 0; u < e.length; ++u) l[u] = e[u];
			for (r = new DataView(c); t < e.byteLength;) i = r.getUint32(t), a = Un(e.subarray(t + 4, t + 8)), o = i > 1 ? t + i : e.byteLength, s = (Kn[a] || function(e) {
				return { data: e };
			})(e.subarray(t + 8, o)), s.size = i, s.type = a, n.push(s), t = o;
			return n;
		}, Vn = function(e, t) {
			var n;
			return t ||= 0, n = Array(t * 2 + 1).join(" "), e.map(function(e, r) {
				return n + e.type + "\n" + Object.keys(e).filter(function(e) {
					return e !== "type" && e !== "boxes";
				}).map(function(t) {
					var r = n + "  " + t + ": ", i = e[t];
					if (i instanceof Uint8Array || i instanceof Uint32Array) {
						var a = Array.prototype.slice.call(new Uint8Array(i.buffer, i.byteOffset, i.byteLength)).map(function(e) {
							return " " + ("00" + e.toString(16)).slice(-2);
						}).join("").match(/.{1,24}/g);
						return a ? a.length === 1 ? r + "<" + a.join("").slice(1) + ">" : r + "<\n" + a.map(function(e) {
							return n + "  " + e;
						}).join("\n") + "\n" + n + "  >" : r + "<>";
					}
					return r + JSON.stringify(i, null, 2).split("\n").map(function(e, t) {
						return t === 0 ? e : n + "  " + e;
					}).join("\n");
				}).join("\n") + (e.boxes ? "\n" + Vn(e.boxes, t + 1) : "");
			}).join("\n");
		};
		var qn = {
			inspect: Bn,
			textify: Vn,
			parseType: Un,
			findBox: Wn,
			parseTraf: Kn.traf,
			parseTfdt: Kn.tfdt,
			parseHdlr: Kn.hdlr,
			parseTfhd: Kn.tfhd,
			parseTrun: Kn.trun,
			parseSidx: Kn.sidx
		}, Jn = { uint8ToCString: function(e) {
			for (var t = 0, n = String.fromCharCode(e[t]), r = ""; n !== "\0";) r += n, t++, n = String.fromCharCode(e[t]);
			return r += n, r;
		} }.uint8ToCString, Yn = i.getUint64, Xn = function(e) {
			var t = 4, n = e[0], r, i, a, o, s, c, l, u;
			if (n === 0) {
				r = Jn(e.subarray(t)), t += r.length, i = Jn(e.subarray(t)), t += i.length;
				var d = new DataView(e.buffer);
				a = d.getUint32(t), t += 4, s = d.getUint32(t), t += 4, c = d.getUint32(t), t += 4, l = d.getUint32(t), t += 4;
			} else if (n === 1) {
				var d = new DataView(e.buffer);
				a = d.getUint32(t), t += 4, o = Yn(e.subarray(t)), t += 8, c = d.getUint32(t), t += 4, l = d.getUint32(t), t += 4, r = Jn(e.subarray(t)), t += r.length, i = Jn(e.subarray(t)), t += i.length;
			}
			u = new Uint8Array(e.subarray(t, e.byteLength));
			var f = {
				scheme_id_uri: r,
				value: i,
				timescale: a || 1,
				presentation_time: o,
				presentation_time_delta: s,
				event_duration: c,
				id: l,
				message_data: u
			};
			return Qn(n, f) ? f : void 0;
		}, Zn = function(e, t, n, r) {
			return e || e === 0 ? e / t : r + n / t;
		}, Qn = function(e, t) {
			var n = t.scheme_id_uri !== "\0", r = e === 0 && $n(t.presentation_time_delta) && n, i = e === 1 && $n(t.presentation_time) && n;
			return !(e > 1) && r || i;
		}, $n = function(e) {
			return e !== void 0 || e !== null;
		}, er = {
			parseEmsgBox: Xn,
			scaleTime: Zn
		}, tr = typeof window < "u" ? window : e === void 0 ? typeof self < "u" ? self : {} : e, nr = Tn.toUnsigned, rr = Tn.toHexString, ir = An, ar = En, or = er, sr = Pn, cr = Rn, lr = Nn, ur = i.getUint64, dr, fr, pr, mr, hr, gr, _r, vr = tr, yr = pt.parseId3Frames;
		dr = function(e) {
			return ir(e, ["moov", "trak"]).reduce(function(e, t) {
				var n = ir(t, ["tkhd"])[0], r, i, a, o;
				return !n || (r = n[0], i = r === 0 ? 12 : 20, a = nr(n[i] << 24 | n[i + 1] << 16 | n[i + 2] << 8 | n[i + 3]), o = ir(t, ["mdia", "mdhd"])[0], !o) ? null : (r = o[0], i = r === 0 ? 12 : 20, e[a] = nr(o[i] << 24 | o[i + 1] << 16 | o[i + 2] << 8 | o[i + 3]), e);
			}, {});
		}, fr = function(e, t) {
			var n = ir(t, ["moof", "traf"]).reduce(function(t, n) {
				var r = ir(n, ["tfhd"])[0], i = e[nr(r[4] << 24 | r[5] << 16 | r[6] << 8 | r[7])] || 9e4, a = ir(n, ["tfdt"])[0], o = new DataView(a.buffer, a.byteOffset, a.byteLength), s = a[0] === 1 ? ur(a.subarray(4, 12)) : o.getUint32(4);
				let c;
				return typeof s == "bigint" ? c = s / vr.BigInt(i) : typeof s == "number" && !isNaN(s) && (c = s / i), c < 2 ** 53 - 1 && (c = Number(c)), c < t && (t = c), t;
			}, Infinity);
			return typeof n == "bigint" || isFinite(n) ? n : 0;
		}, pr = function(e, t) {
			var n = ir(t, ["moof", "traf"]), r = 0, i = 0, a;
			if (n && n.length) {
				var o = ir(n[0], ["tfhd"])[0], s = ir(n[0], ["trun"])[0], c = ir(n[0], ["tfdt"])[0];
				if (o && (a = sr(o).trackId), c && (r = lr(c).baseMediaDecodeTime), s) {
					var l = cr(s);
					l.samples && l.samples.length && (i = l.samples[0].compositionTimeOffset || 0);
				}
			}
			var u = e[a] || 9e4;
			typeof r == "bigint" && (i = vr.BigInt(i), u = vr.BigInt(u));
			var d = (r + i) / u;
			return typeof d == "bigint" && d < 2 ** 53 - 1 && (d = Number(d)), d;
		}, mr = function(e) {
			var t = ir(e, ["moov", "trak"]), n = [];
			return t.forEach(function(e) {
				var t = ir(e, ["mdia", "hdlr"]), r = ir(e, ["tkhd"]);
				t.forEach(function(e, t) {
					var i = ar(e.subarray(8, 12)), a = r[t], o, s, c;
					i === "vide" && (o = new DataView(a.buffer, a.byteOffset, a.byteLength), s = o.getUint8(0), c = s === 0 ? o.getUint32(12) : o.getUint32(20), n.push(c));
				});
			}), n;
		}, gr = function(e) {
			var t = e[0] === 0 ? 12 : 20;
			return nr(e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]);
		}, hr = function(e) {
			var t = ir(e, ["moov", "trak"]), n = [];
			return t.forEach(function(e) {
				var t = {}, r = ir(e, ["tkhd"])[0], i, a;
				r && (i = new DataView(r.buffer, r.byteOffset, r.byteLength), a = i.getUint8(0), t.id = a === 0 ? i.getUint32(12) : i.getUint32(20));
				var o = ir(e, ["mdia", "hdlr"])[0];
				if (o) {
					var s = ar(o.subarray(8, 12));
					t.type = s === "vide" ? "video" : s === "soun" ? "audio" : s;
				}
				var c = ir(e, [
					"mdia",
					"minf",
					"stbl",
					"stsd"
				])[0];
				if (c) {
					var l = c.subarray(8);
					t.codec = ar(l.subarray(4, 8));
					var u = ir(l, [t.codec])[0], d, f;
					u && (/^[asm]vc[1-9]$/i.test(t.codec) ? (d = u.subarray(78), f = ar(d.subarray(4, 8)), f === "avcC" && d.length > 11 ? (t.codec += ".", t.codec += rr(d[9]), t.codec += rr(d[10]), t.codec += rr(d[11])) : t.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(t.codec) ? (d = u.subarray(28), f = ar(d.subarray(4, 8)), f === "esds" && d.length > 20 && d[19] !== 0 ? (t.codec += "." + rr(d[19]), t.codec += "." + rr(d[20] >>> 2 & 63).replace(/^0/, "")) : t.codec = "mp4a.40.2") : t.codec = t.codec.toLowerCase());
				}
				var p = ir(e, ["mdia", "mdhd"])[0];
				p && (t.timescale = gr(p)), n.push(t);
			}), n;
		}, _r = function(e, t = 0) {
			return ir(e, ["emsg"]).map((e) => {
				var n = or.parseEmsgBox(new Uint8Array(e)), r = yr(n.message_data);
				return {
					cueTime: or.scaleTime(n.presentation_time, n.timescale, n.presentation_time_delta, t),
					duration: or.scaleTime(n.event_duration, n.timescale),
					frames: r
				};
			});
		};
		var br = {
			findBox: ir,
			parseType: ar,
			timescale: dr,
			startTime: fr,
			compositionStartTime: pr,
			videoTrackIds: mr,
			tracks: hr,
			getTimescaleFromMediaHeader: gr,
			getEmsgID3: _r
		};
		let { parseTrun: xr } = qn, { findBox: Sr } = br;
		var Cr = tr, I = {
			getMdatTrafPairs: function(e) {
				var t = Sr(e, ["moof", "traf"]), n = Sr(e, ["mdat"]), r = [];
				return n.forEach(function(e, n) {
					var i = t[n];
					r.push({
						mdat: e,
						traf: i
					});
				}), r;
			},
			parseSamples: function(e, t, n) {
				var r = t, i = n.defaultSampleDuration || 0, a = n.defaultSampleSize || 0, o = n.trackId, s = [];
				return e.forEach(function(e) {
					var t = xr(e).samples;
					t.forEach(function(e) {
						e.duration === void 0 && (e.duration = i), e.size === void 0 && (e.size = a), e.trackId = o, e.dts = r, e.compositionTimeOffset === void 0 && (e.compositionTimeOffset = 0), typeof r == "bigint" ? (e.pts = r + Cr.BigInt(e.compositionTimeOffset), r += Cr.BigInt(e.duration)) : (e.pts = r + e.compositionTimeOffset, r += e.duration);
					}), s = s.concat(t);
				}), s;
			}
		}, wr = Fe.discardEmulationPreventionBytes, Tr = Ze.CaptionStream, Er = An, Dr = Nn, Or = Pn, { getMdatTrafPairs: kr, parseSamples: Ar } = I, jr = function(e, t) {
			for (var n = e, r = 0; r < t.length; r++) {
				var i = t[r];
				if (n < i.size) return i;
				n -= i.size;
			}
			return null;
		}, Mr = function(e, t, n) {
			var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
				logs: [],
				seiNals: []
			}, a, o, s, c;
			for (o = 0; o + 4 < e.length; o += s) if (s = r.getUint32(o), o += 4, !(s <= 0)) switch (e[o] & 31) {
				case 6:
					var l = e.subarray(o + 1, o + 1 + s), u = jr(o, t);
					if (a = {
						nalUnitType: "sei_rbsp",
						size: s,
						data: l,
						escapedRBSP: wr(l),
						trackId: n
					}, u) a.pts = u.pts, a.dts = u.dts, c = u;
					else if (c) a.pts = c.pts, a.dts = c.dts;
					else {
						i.logs.push({
							level: "warn",
							message: "We've encountered a nal unit without data at " + o + " for trackId " + n + ". See mux.js#223."
						});
						break;
					}
					i.seiNals.push(a);
			}
			return i;
		}, Nr = function(e, t) {
			var n = {};
			return kr(e).forEach(function(e) {
				var r = e.mdat, i = e.traf, a = Or(Er(i, ["tfhd"])[0]), o = a.trackId, s = Er(i, ["tfdt"]), c = s.length > 0 ? Dr(s[0]).baseMediaDecodeTime : 0, l = Er(i, ["trun"]), u, d;
				t === o && l.length > 0 && (u = Ar(l, c, a), d = Mr(r, u, o), n[o] || (n[o] = {
					seiNals: [],
					logs: []
				}), n[o].seiNals = n[o].seiNals.concat(d.seiNals), n[o].logs = n[o].logs.concat(d.logs));
			}), n;
		}, Pr = function(e, t, n) {
			var r;
			if (t === null) return null;
			r = Nr(e, t);
			var i = r[t] || {};
			return {
				seiNals: i.seiNals,
				logs: i.logs,
				timescale: n
			};
		}, Fr = function() {
			var e = !1, t, n, r, i, a, o;
			this.isInitialized = function() {
				return e;
			}, this.init = function(n) {
				t = new Tr(), e = !0, o = n ? n.isPartial : !1, t.on("data", function(e) {
					e.startTime = e.startPts / i, e.endTime = e.endPts / i, a.captions.push(e), a.captionStreams[e.stream] = !0;
				}), t.on("log", function(e) {
					a.logs.push(e);
				});
			}, this.isNewInit = function(e, t) {
				return e && e.length === 0 || t && typeof t == "object" && Object.keys(t).length === 0 ? !1 : r !== e[0] || i !== t[r];
			}, this.parse = function(e, t, o) {
				var s;
				if (!this.isInitialized() || !t || !o) return null;
				if (this.isNewInit(t, o)) r = t[0], i = o[r];
				else if (r === null || !i) return n.push(e), null;
				for (; n.length > 0;) {
					var c = n.shift();
					this.parse(c, t, o);
				}
				return s = Pr(e, r, i), s && s.logs && (a.logs = a.logs.concat(s.logs)), s === null || !s.seiNals ? a.logs.length ? {
					logs: a.logs,
					captions: [],
					captionStreams: []
				} : null : (this.pushNals(s.seiNals), this.flushStream(), a);
			}, this.pushNals = function(e) {
				if (!this.isInitialized() || !e || e.length === 0) return null;
				e.forEach(function(e) {
					t.push(e);
				});
			}, this.flushStream = function() {
				if (!this.isInitialized()) return null;
				o ? t.partialFlush() : t.flush();
			}, this.clearParsedCaptions = function() {
				a.captions = [], a.captionStreams = {}, a.logs = [];
			}, this.resetCaptionStream = function() {
				if (!this.isInitialized()) return null;
				t.reset();
			}, this.clearAllCaptions = function() {
				this.clearParsedCaptions(), this.resetCaptionStream();
			}, this.reset = function() {
				n = [], r = null, i = null, a ? this.clearParsedCaptions() : a = {
					captions: [],
					captionStreams: {},
					logs: []
				}, this.resetCaptionStream();
			}, this.reset();
		};
		let { parseTfdt: Ir } = qn, Lr = An, { getTimescaleFromMediaHeader: Rr } = br, { parseSamples: zr, getMdatTrafPairs: Br } = I;
		var Vr = function() {
			let e = 9e4;
			this.init = function(t) {
				let n = Lr(t, [
					"moov",
					"trak",
					"mdia",
					"mdhd"
				])[0];
				n && (e = Rr(n));
			}, this.parseSegment = function(t) {
				let n = [], r = Br(t), i = 0;
				return r.forEach(function(t) {
					let r = t.mdat, a = t.traf, o = Lr(a, ["tfdt"])[0], s = Lr(a, ["tfhd"])[0], c = Lr(a, ["trun"]);
					if (o && (i = Ir(o).baseMediaDecodeTime), c.length && s) {
						let t = zr(c, i, s), a = 0;
						t.forEach(function(t) {
							let i = new TextDecoder("utf-8"), o = r.slice(a, a + t.size);
							if (Lr(o, ["vtte"])[0]) {
								a += t.size;
								return;
							}
							Lr(o, ["vttc"]).forEach(function(r) {
								let a = Lr(r, ["payl"])[0], o = Lr(r, ["sttg"])[0], s = t.pts / e, c = (t.pts + t.duration) / e, l, u;
								if (a) try {
									l = i.decode(a);
								} catch (e) {
									console.error(e);
								}
								if (o) try {
									u = i.decode(o);
								} catch (e) {
									console.error(e);
								}
								t.duration && l && n.push({
									cueText: l,
									start: s,
									end: c,
									settings: u
								});
							}), a += t.size;
						});
					}
				}), n;
			};
		}, Hr = Qe, Ur = function(e) {
			var t = e[1] & 31;
			return t <<= 8, t |= e[2], t;
		}, Wr = function(e) {
			return !!(e[1] & 64);
		}, Gr = function(e) {
			var t = 0;
			return (e[3] & 48) >>> 4 > 1 && (t += e[4] + 1), t;
		}, Kr = function(e, t) {
			var n = Ur(e);
			return n === 0 ? "pat" : n === t ? "pmt" : t ? "pes" : null;
		}, qr = function(e) {
			var t = Wr(e), n = 4 + Gr(e);
			return t && (n += e[n] + 1), (e[n + 10] & 31) << 8 | e[n + 11];
		}, Jr = function(e) {
			var t = {}, n = Wr(e), r = 4 + Gr(e);
			if (n && (r += e[r] + 1), e[r + 5] & 1) {
				for (var i = 3 + ((e[r + 1] & 15) << 8 | e[r + 2]) - 4, a = 12 + ((e[r + 10] & 15) << 8 | e[r + 11]); a < i;) {
					var o = r + a;
					t[(e[o + 1] & 31) << 8 | e[o + 2]] = e[o], a += ((e[o + 3] & 15) << 8 | e[o + 4]) + 5;
				}
				return t;
			}
		}, Yr = function(e, t) {
			switch (t[Ur(e)]) {
				case Hr.H264_STREAM_TYPE: return "video";
				case Hr.ADTS_STREAM_TYPE: return "audio";
				case Hr.METADATA_STREAM_TYPE: return "timed-metadata";
				default: return null;
			}
		}, Xr = function(e) {
			if (!Wr(e)) return null;
			var t = 4 + Gr(e);
			if (t >= e.byteLength) return null;
			var n = null, r = e[t + 7];
			return r & 192 && (n = {}, n.pts = (e[t + 9] & 14) << 27 | (e[t + 10] & 255) << 20 | (e[t + 11] & 254) << 12 | (e[t + 12] & 255) << 5 | (e[t + 13] & 254) >>> 3, n.pts *= 4, n.pts += (e[t + 13] & 6) >>> 1, n.dts = n.pts, r & 64 && (n.dts = (e[t + 14] & 14) << 27 | (e[t + 15] & 255) << 20 | (e[t + 16] & 254) << 12 | (e[t + 17] & 255) << 5 | (e[t + 18] & 254) >>> 3, n.dts *= 4, n.dts += (e[t + 18] & 6) >>> 1)), n;
		}, Zr = function(e) {
			switch (e) {
				case 5: return "slice_layer_without_partitioning_rbsp_idr";
				case 6: return "sei_rbsp";
				case 7: return "seq_parameter_set_rbsp";
				case 8: return "pic_parameter_set_rbsp";
				case 9: return "access_unit_delimiter_rbsp";
				default: return null;
			}
		}, Qr = {
			parseType: Kr,
			parsePat: qr,
			parsePmt: Jr,
			parsePayloadUnitStartIndicator: Wr,
			parsePesType: Yr,
			parsePesTime: Xr,
			videoPacketContainsKeyFrame: function(e) {
				for (var t = 4 + Gr(e), n = e.subarray(t), r = 0, i = 0, a = !1, o; i < n.byteLength - 3; i++) if (n[i + 2] === 1) {
					r = i + 5;
					break;
				}
				for (; r < n.byteLength;) switch (n[r]) {
					case 0:
						if (n[r - 1] !== 0) {
							r += 2;
							break;
						}
						if (n[r - 2] !== 0) {
							r++;
							break;
						}
						i + 3 !== r - 2 && (o = Zr(n[i + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0));
						do
							r++;
						while (n[r] !== 1 && r < n.length);
						i = r - 2, r += 3;
						break;
					case 1:
						if (n[r - 1] !== 0 || n[r - 2] !== 0) {
							r += 3;
							break;
						}
						o = Zr(n[i + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0), i = r - 2, r += 3;
						break;
					default: r += 3;
				}
				return n = n.subarray(i), r -= i, i = 0, n && n.byteLength > 3 && (o = Zr(n[i + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0)), a;
			}
		}, $r = Qe, ei = at.handleRollover, ti = {};
		ti.ts = Qr, ti.aac = Xt;
		var ni = De.ONE_SECOND_IN_TS, ri = 188, ii = 71, ai = function(e, t) {
			for (var n = 0, r = ri, i, a; r < e.byteLength;) {
				if (e[n] === ii && e[r] === ii) {
					switch (i = e.subarray(n, r), a = ti.ts.parseType(i, t.pid), a) {
						case "pat":
							t.pid = ti.ts.parsePat(i);
							break;
						case "pmt":
							var o = ti.ts.parsePmt(i);
							t.table = t.table || {}, Object.keys(o).forEach(function(e) {
								t.table[e] = o[e];
							});
					}
					n += ri, r += ri;
					continue;
				}
				n++, r++;
			}
		}, oi = function(e, t, n) {
			for (var r = 0, i = ri, a, o, s, c, l, u = !1; i <= e.byteLength;) {
				if (e[r] === ii && (e[i] === ii || i === e.byteLength)) {
					if (a = e.subarray(r, i), o = ti.ts.parseType(a, t.pid), o === "pes" && (s = ti.ts.parsePesType(a, t.table), c = ti.ts.parsePayloadUnitStartIndicator(a), s === "audio" && c && (l = ti.ts.parsePesTime(a), l && (l.type = "audio", n.audio.push(l), u = !0))), u) break;
					r += ri, i += ri;
					continue;
				}
				r++, i++;
			}
			for (i = e.byteLength, r = i - ri, u = !1; r >= 0;) {
				if (e[r] === ii && (e[i] === ii || i === e.byteLength)) {
					if (a = e.subarray(r, i), o = ti.ts.parseType(a, t.pid), o === "pes" && (s = ti.ts.parsePesType(a, t.table), c = ti.ts.parsePayloadUnitStartIndicator(a), s === "audio" && c && (l = ti.ts.parsePesTime(a), l && (l.type = "audio", n.audio.push(l), u = !0))), u) break;
					r -= ri, i -= ri;
					continue;
				}
				r--, i--;
			}
		}, si = function(e, t, n) {
			for (var r = 0, i = ri, a, o, s, c, l, u, d, f, p = !1, m = {
				data: [],
				size: 0
			}; i < e.byteLength;) {
				if (e[r] === ii && e[i] === ii) {
					if (a = e.subarray(r, i), o = ti.ts.parseType(a, t.pid), o === "pes" && (s = ti.ts.parsePesType(a, t.table), c = ti.ts.parsePayloadUnitStartIndicator(a), s === "video" && (c && !p && (l = ti.ts.parsePesTime(a), l && (l.type = "video", n.video.push(l), p = !0)), !n.firstKeyFrame))) {
						if (c && m.size !== 0) {
							for (u = new Uint8Array(m.size), d = 0; m.data.length;) f = m.data.shift(), u.set(f, d), d += f.byteLength;
							if (ti.ts.videoPacketContainsKeyFrame(u)) {
								var h = ti.ts.parsePesTime(u);
								h ? (n.firstKeyFrame = h, n.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
							}
							m.size = 0;
						}
						m.data.push(a), m.size += a.byteLength;
					}
					if (p && n.firstKeyFrame) break;
					r += ri, i += ri;
					continue;
				}
				r++, i++;
			}
			for (i = e.byteLength, r = i - ri, p = !1; r >= 0;) {
				if (e[r] === ii && e[i] === ii) {
					if (a = e.subarray(r, i), o = ti.ts.parseType(a, t.pid), o === "pes" && (s = ti.ts.parsePesType(a, t.table), c = ti.ts.parsePayloadUnitStartIndicator(a), s === "video" && c && (l = ti.ts.parsePesTime(a), l && (l.type = "video", n.video.push(l), p = !0))), p) break;
					r -= ri, i -= ri;
					continue;
				}
				r--, i--;
			}
		}, ci = function(e, t) {
			if (e.audio && e.audio.length) {
				var n = t;
				(n === void 0 || isNaN(n)) && (n = e.audio[0].dts), e.audio.forEach(function(e) {
					e.dts = ei(e.dts, n), e.pts = ei(e.pts, n), e.dtsTime = e.dts / ni, e.ptsTime = e.pts / ni;
				});
			}
			if (e.video && e.video.length) {
				var r = t;
				if ((r === void 0 || isNaN(r)) && (r = e.video[0].dts), e.video.forEach(function(e) {
					e.dts = ei(e.dts, r), e.pts = ei(e.pts, r), e.dtsTime = e.dts / ni, e.ptsTime = e.pts / ni;
				}), e.firstKeyFrame) {
					var i = e.firstKeyFrame;
					i.dts = ei(i.dts, r), i.pts = ei(i.pts, r), i.dtsTime = i.dts / ni, i.ptsTime = i.pts / ni;
				}
			}
		}, li = function(e) {
			for (var t = !1, n = 0, r = null, i = null, a = 0, o = 0, s; e.length - o >= 3;) {
				switch (ti.aac.parseType(e, o)) {
					case "timed-metadata":
						if (e.length - o < 10) {
							t = !0;
							break;
						}
						if (a = ti.aac.parseId3TagSize(e, o), a > e.length) {
							t = !0;
							break;
						}
						i === null && (s = e.subarray(o, o + a), i = ti.aac.parseAacTimestamp(s)), o += a;
						break;
					case "audio":
						if (e.length - o < 7) {
							t = !0;
							break;
						}
						if (a = ti.aac.parseAdtsSize(e, o), a > e.length) {
							t = !0;
							break;
						}
						r === null && (s = e.subarray(o, o + a), r = ti.aac.parseSampleRate(s)), n++, o += a;
						break;
					default: o++;
				}
				if (t) return null;
			}
			if (r === null || i === null) return null;
			var c = ni / r;
			return { audio: [{
				type: "audio",
				dts: i,
				pts: i
			}, {
				type: "audio",
				dts: i + n * 1024 * c,
				pts: i + n * 1024 * c
			}] };
		}, ui = function(e) {
			var t = {
				pid: null,
				table: null
			}, n = {};
			for (var r in ai(e, t), t.table) if (t.table.hasOwnProperty(r)) switch (t.table[r]) {
				case $r.H264_STREAM_TYPE:
					n.video = [], si(e, t, n), n.video.length === 0 && delete n.video;
					break;
				case $r.ADTS_STREAM_TYPE: n.audio = [], oi(e, t, n), n.audio.length === 0 && delete n.audio;
			}
			return n;
		}, L = {
			inspect: function(e, t) {
				var n = ti.aac.isLikelyAacData(e) ? li(e) : ui(e);
				return !n || !n.audio && !n.video ? null : (ci(n, t), n);
			},
			parseAudioPes_: oi
		};
		let di = function(e, t) {
			t.on("data", function(t) {
				let n = t.initSegment;
				t.initSegment = {
					data: n.buffer,
					byteOffset: n.byteOffset,
					byteLength: n.byteLength
				};
				let r = t.data;
				t.data = r.buffer, e.postMessage({
					action: "data",
					segment: t,
					byteOffset: r.byteOffset,
					byteLength: r.byteLength
				}, [t.data]);
			}), t.on("done", function(t) {
				e.postMessage({ action: "done" });
			}), t.on("gopInfo", function(t) {
				e.postMessage({
					action: "gopInfo",
					gopInfo: t
				});
			}), t.on("videoSegmentTimingInfo", function(t) {
				let n = {
					start: {
						decode: De.videoTsToSeconds(t.start.dts),
						presentation: De.videoTsToSeconds(t.start.pts)
					},
					end: {
						decode: De.videoTsToSeconds(t.end.dts),
						presentation: De.videoTsToSeconds(t.end.pts)
					},
					baseMediaDecodeTime: De.videoTsToSeconds(t.baseMediaDecodeTime)
				};
				t.prependedContentDuration && (n.prependedContentDuration = De.videoTsToSeconds(t.prependedContentDuration)), e.postMessage({
					action: "videoSegmentTimingInfo",
					videoSegmentTimingInfo: n
				});
			}), t.on("audioSegmentTimingInfo", function(t) {
				let n = {
					start: {
						decode: De.videoTsToSeconds(t.start.dts),
						presentation: De.videoTsToSeconds(t.start.pts)
					},
					end: {
						decode: De.videoTsToSeconds(t.end.dts),
						presentation: De.videoTsToSeconds(t.end.pts)
					},
					baseMediaDecodeTime: De.videoTsToSeconds(t.baseMediaDecodeTime)
				};
				t.prependedContentDuration && (n.prependedContentDuration = De.videoTsToSeconds(t.prependedContentDuration)), e.postMessage({
					action: "audioSegmentTimingInfo",
					audioSegmentTimingInfo: n
				});
			}), t.on("id3Frame", function(t) {
				e.postMessage({
					action: "id3Frame",
					id3Frame: t
				});
			}), t.on("caption", function(t) {
				e.postMessage({
					action: "caption",
					caption: t
				});
			}), t.on("trackinfo", function(t) {
				e.postMessage({
					action: "trackinfo",
					trackInfo: t
				});
			}), t.on("audioTimingInfo", function(t) {
				e.postMessage({
					action: "audioTimingInfo",
					audioTimingInfo: {
						start: De.videoTsToSeconds(t.start),
						end: De.videoTsToSeconds(t.end)
					}
				});
			}), t.on("videoTimingInfo", function(t) {
				e.postMessage({
					action: "videoTimingInfo",
					videoTimingInfo: {
						start: De.videoTsToSeconds(t.start),
						end: De.videoTsToSeconds(t.end)
					}
				});
			}), t.on("log", function(t) {
				e.postMessage({
					action: "log",
					log: t
				});
			});
		};
		class fi {
			constructor(e, t) {
				this.options = t || {}, this.self = e, this.init();
			}
			init() {
				this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new wn.Transmuxer(this.options), di(this.self, this.transmuxer);
			}
			pushMp4Captions(e) {
				this.captionParser || (this.captionParser = new Fr(), this.captionParser.init());
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength), n = this.captionParser.parse(t, e.trackIds, e.timescales);
				this.self.postMessage({
					action: "mp4Captions",
					captions: n && n.captions || [],
					logs: n && n.logs || [],
					data: t.buffer
				}, [t.buffer]);
			}
			initMp4WebVttParser(e) {
				this.webVttParser ||= new Vr();
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength);
				this.webVttParser.init(t);
			}
			getMp4WebVttText(e) {
				this.webVttParser ||= new Vr();
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength), n = this.webVttParser.parseSegment(t);
				this.self.postMessage({
					action: "getMp4WebVttText",
					mp4VttCues: n || [],
					data: t.buffer
				}, [t.buffer]);
			}
			probeMp4StartTime({ timescales: e, data: t }) {
				let n = br.startTime(e, t);
				this.self.postMessage({
					action: "probeMp4StartTime",
					startTime: n,
					data: t
				}, [t.buffer]);
			}
			probeMp4Tracks({ data: e }) {
				let t = br.tracks(e);
				this.self.postMessage({
					action: "probeMp4Tracks",
					tracks: t,
					data: e
				}, [e.buffer]);
			}
			probeEmsgID3({ data: e, offset: t }) {
				let n = br.getEmsgID3(e, t);
				this.self.postMessage({
					action: "probeEmsgID3",
					id3Frames: n,
					emsgData: e
				}, [e.buffer]);
			}
			probeTs({ data: e, baseStartTime: t }) {
				let n = typeof t == "number" && !isNaN(t) ? t * De.ONE_SECOND_IN_TS : void 0, r = L.inspect(e, n), i = null;
				r && (i = {
					hasVideo: r.video && r.video.length === 2 || !1,
					hasAudio: r.audio && r.audio.length === 2 || !1
				}, i.hasVideo && (i.videoStart = r.video[0].ptsTime), i.hasAudio && (i.audioStart = r.audio[0].ptsTime)), this.self.postMessage({
					action: "probeTs",
					result: i,
					data: e
				}, [e.buffer]);
			}
			clearAllMp4Captions() {
				this.captionParser && this.captionParser.clearAllCaptions();
			}
			clearParsedMp4Captions() {
				this.captionParser && this.captionParser.clearParsedCaptions();
			}
			push(e) {
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength);
				this.transmuxer.push(t);
			}
			reset() {
				this.transmuxer.reset();
			}
			setTimestampOffset(e) {
				let t = e.timestampOffset || 0;
				this.transmuxer.setBaseMediaDecodeTime(Math.round(De.secondsToVideoTs(t)));
			}
			setAudioAppendStart(e) {
				this.transmuxer.setAudioAppendStart(Math.ceil(De.secondsToVideoTs(e.appendStart)));
			}
			setRemux(e) {
				this.transmuxer.setRemux(e.remux);
			}
			flush(e) {
				this.transmuxer.flush(), self.postMessage({
					action: "done",
					type: "transmuxed"
				});
			}
			endTimeline() {
				this.transmuxer.endTimeline(), self.postMessage({
					action: "endedtimeline",
					type: "transmuxed"
				});
			}
			alignGopsWith(e) {
				this.transmuxer.alignGopsWith(e.gopsToAlignWith.slice());
			}
		}
		self.onmessage = function(e) {
			if (e.data.action === "init" && e.data.options) {
				this.messageHandlers = new fi(self, e.data.options);
				return;
			}
			this.messageHandlers ||= new fi(self), e.data && e.data.action && e.data.action !== "init" && this.messageHandlers[e.data.action] && this.messageHandlers[e.data.action](e.data);
		};
	}))), bq = (e, t, n) => {
		let { type: r, initSegment: i, captions: a, captionStreams: o, metadata: s, videoFrameDtsTime: c, videoFramePtsTime: l } = e.data.segment;
		t.buffer.push({
			captions: a,
			captionStreams: o,
			metadata: s
		});
		let u = e.data.segment.boxes || { data: e.data.segment.data }, d = {
			type: r,
			data: new Uint8Array(u.data, u.data.byteOffset, u.data.byteLength),
			initSegment: new Uint8Array(i.data, i.byteOffset, i.byteLength)
		};
		c !== void 0 && (d.videoFrameDtsTime = c), l !== void 0 && (d.videoFramePtsTime = l), n(d);
	}, xq = ({ transmuxedData: e, callback: t }) => {
		e.buffer = [], t(e);
	}, Sq = (e, t) => {
		t.gopInfo = e.data.gopInfo;
	}, Cq = (e) => {
		let { transmuxer: t, bytes: n, audioAppendStart: r, gopsToAlignWith: i, remux: a, onData: o, onTrackInfo: s, onAudioTimingInfo: c, onVideoTimingInfo: l, onVideoSegmentTimingInfo: u, onAudioSegmentTimingInfo: d, onId3: f, onCaptions: p, onDone: m, onEndedTimeline: h, onTransmuxerLog: g, isEndOfTimeline: _, segment: v, triggerSegmentEventFn: y } = e, b = { buffer: [] }, x = _;
		if (t.onmessage = (n) => {
			t.currentTransmux === e && (n.data.action === "data" && bq(n, b, o), n.data.action === "trackinfo" && s(n.data.trackInfo), n.data.action === "gopInfo" && Sq(n, b), n.data.action === "audioTimingInfo" && c(n.data.audioTimingInfo), n.data.action === "videoTimingInfo" && l(n.data.videoTimingInfo), n.data.action === "videoSegmentTimingInfo" && u(n.data.videoSegmentTimingInfo), n.data.action === "audioSegmentTimingInfo" && d(n.data.audioSegmentTimingInfo), n.data.action === "id3Frame" && f([n.data.id3Frame], n.data.id3Frame.dispatchType), n.data.action === "caption" && p(n.data.caption), n.data.action === "endedtimeline" && (x = !1, h()), n.data.action === "log" && g(n.data.log), n.data.type === "transmuxed" && (x || (t.onmessage = null, xq({
				transmuxedData: b,
				callback: m
			}), wq(t))));
		}, t.onerror = () => {
			let e = {
				message: "Received an error message from the transmuxer worker",
				metadata: {
					errorType: Y.Error.StreamingFailedToTransmuxSegment,
					segmentInfo: HJ({ segment: v })
				}
			};
			m(null, e);
		}, r && t.postMessage({
			action: "setAudioAppendStart",
			appendStart: r
		}), Array.isArray(i) && t.postMessage({
			action: "alignGopsWith",
			gopsToAlignWith: i
		}), a !== void 0 && t.postMessage({
			action: "setRemux",
			remux: a
		}), n.byteLength) {
			let e = n instanceof ArrayBuffer ? n : n.buffer, r = n instanceof ArrayBuffer ? 0 : n.byteOffset;
			y({
				type: "segmenttransmuxingstart",
				segment: v
			}), t.postMessage({
				action: "push",
				data: e,
				byteOffset: r,
				byteLength: n.byteLength
			}, [e]);
		}
		_ && t.postMessage({ action: "endTimeline" }), t.postMessage({ action: "flush" });
	}, wq = (e) => {
		e.currentTransmux = null, e.transmuxQueue.length && (e.currentTransmux = e.transmuxQueue.shift(), typeof e.currentTransmux == "function" ? e.currentTransmux() : Cq(e.currentTransmux));
	}, Tq = (e, t) => {
		e.postMessage({ action: t }), wq(e);
	}, Eq = (e, t) => {
		if (!t.currentTransmux) {
			t.currentTransmux = e, Tq(t, e);
			return;
		}
		t.transmuxQueue.push(Tq.bind(null, t, e));
	}, Dq = (e) => {
		Eq("reset", e);
	}, Oq = (e) => {
		Eq("endTimeline", e);
	}, kq = (e) => {
		if (!e.transmuxer.currentTransmux) {
			e.transmuxer.currentTransmux = e, Cq(e);
			return;
		}
		e.transmuxer.transmuxQueue.push(e);
	}, Aq = (e) => {
		let t = new yq();
		t.currentTransmux = null, t.transmuxQueue = [];
		let n = t.terminate;
		return t.terminate = () => (t.currentTransmux = null, t.transmuxQueue.length = 0, n.call(t)), t.postMessage({
			action: "init",
			options: e
		}), t;
	}, jq = {
		reset: Dq,
		endTimeline: Oq,
		transmux: kq,
		createTransmuxer: Aq
	}, Mq = function(e) {
		let t = e.transmuxer, n = e.endAction || e.action, r = e.callback, i = wF({}, e, {
			endAction: null,
			transmuxer: null,
			callback: null
		}), a = (i) => {
			i.data.action === n && (t.removeEventListener("message", a), i.data.data && (i.data.data = new Uint8Array(i.data.data, e.byteOffset || 0, e.byteLength || i.data.data.byteLength), e.data &&= i.data.data), r(i.data));
		};
		if (t.addEventListener("message", a), e.data) {
			let n = e.data instanceof ArrayBuffer;
			i.byteOffset = n ? 0 : e.data.byteOffset, i.byteLength = e.data.byteLength;
			let r = [n ? e.data : e.data.buffer];
			t.postMessage(i, r);
		} else t.postMessage(i);
	}, Nq = {
		FAILURE: 2,
		TIMEOUT: -101,
		ABORTED: -102
	}, Pq = "wvtt", Fq = (e) => {
		e.forEach((e) => {
			e.abort();
		});
	}, Iq = (e) => ({
		bandwidth: e.bandwidth,
		bytesReceived: e.bytesReceived || 0,
		roundTripTime: e.roundTripTime || 0
	}), Lq = (e) => {
		let t = e.target, n = {
			bandwidth: Infinity,
			bytesReceived: 0,
			roundTripTime: Date.now() - t.requestTime || 0
		};
		return n.bytesReceived = e.loaded, n.bandwidth = Math.floor(n.bytesReceived / n.roundTripTime * 8 * 1e3), n;
	}, Rq = (e, t) => {
		let { requestType: n } = t, r = uK({
			requestType: n,
			request: t,
			error: e
		});
		return t.timedout ? {
			status: t.status,
			message: "HLS request timed-out at URL: " + t.uri,
			code: Nq.TIMEOUT,
			xhr: t,
			metadata: r
		} : t.aborted ? {
			status: t.status,
			message: "HLS request aborted at URL: " + t.uri,
			code: Nq.ABORTED,
			xhr: t,
			metadata: r
		} : e ? {
			status: t.status,
			message: "HLS request errored at URL: " + t.uri,
			code: Nq.FAILURE,
			xhr: t,
			metadata: r
		} : t.responseType === "arraybuffer" && t.response.byteLength === 0 ? {
			status: t.status,
			message: "Empty HLS response at URL: " + t.uri,
			code: Nq.FAILURE,
			xhr: t,
			metadata: r
		} : null;
	}, zq = (e, t, n, r) => (i, a) => {
		let o = a.response, s = Rq(i, a);
		if (s) return n(s, e);
		if (o.byteLength !== 16) return n({
			status: a.status,
			message: "Invalid HLS key at URL: " + a.uri,
			code: Nq.FAILURE,
			xhr: a
		}, e);
		let c = new DataView(o), l = new Uint32Array([
			c.getUint32(0),
			c.getUint32(4),
			c.getUint32(8),
			c.getUint32(12)
		]);
		for (let e = 0; e < t.length; e++) t[e].bytes = l;
		return r({
			type: "segmentkeyloadcomplete",
			segment: e,
			keyInfo: { uri: a.uri }
		}), n(null, e);
	}, Bq = (e, t) => {
		t === Pq && e.transmuxer.postMessage({
			action: "initMp4WebVttParser",
			data: e.map.bytes
		});
	}, Vq = (e, t, n) => {
		t === Pq && Mq({
			action: "getMp4WebVttText",
			data: e.bytes,
			transmuxer: e.transmuxer,
			callback: ({ data: t, mp4VttCues: r }) => {
				e.bytes = t, n(null, e, { mp4VttCues: r });
			}
		});
	}, Hq = (e, t) => {
		let n = BR(e.map.bytes);
		if (n !== "mp4") {
			let r = e.map.resolvedUri || e.map.uri, i = n || "unknown";
			return t({
				internal: !0,
				message: `Found unsupported ${i} container for initialization segment at URL: ${r}`,
				code: Nq.FAILURE,
				metadata: { mediaType: i }
			});
		}
		Mq({
			action: "probeMp4Tracks",
			data: e.map.bytes,
			transmuxer: e.transmuxer,
			callback: ({ tracks: n, data: r }) => (e.map.bytes = r, n.forEach(function(t) {
				e.map.tracks = e.map.tracks || {}, !e.map.tracks[t.type] && (e.map.tracks[t.type] = t, typeof t.id == "number" && t.timescale && (e.map.timescales = e.map.timescales || {}, e.map.timescales[t.id] = t.timescale), t.type === "text" && Bq(e, t.codec));
			}), t(null))
		});
	}, Uq = ({ segment: e, finishProcessingFn: t, triggerSegmentEventFn: n }) => (r, i) => {
		let a = Rq(r, i);
		if (a) return t(a, e);
		let o = new Uint8Array(i.response);
		if (n({
			type: "segmentloaded",
			segment: e
		}), e.map.key) return e.map.encryptedBytes = o, t(null, e);
		e.map.bytes = o, Hq(e, function(n) {
			if (n) return n.xhr = i, n.status = i.status, t(n, e);
			t(null, e);
		});
	}, Wq = ({ segment: e, finishProcessingFn: t, responseType: n, triggerSegmentEventFn: r }) => (i, a) => {
		let o = Rq(i, a);
		if (o) return t(o, e);
		r({
			type: "segmentloaded",
			segment: e
		});
		let s = n === "arraybuffer" || !a.responseText ? a.response : pq(a.responseText.substring(e.lastReachedChar || 0));
		return e.stats = Iq(a), e.key ? e.encryptedBytes = new Uint8Array(s) : e.bytes = new Uint8Array(s), t(null, e);
	}, Gq = ({ segment: e, bytes: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		let m = e.map && e.map.tracks || {}, h = !!(m.audio && m.video), g = r.bind(null, e, "audio", "start"), _ = r.bind(null, e, "audio", "end"), v = r.bind(null, e, "video", "start"), y = r.bind(null, e, "video", "end"), b = () => kq({
			bytes: t,
			transmuxer: e.transmuxer,
			audioAppendStart: e.audioAppendStart,
			gopsToAlignWith: e.gopsToAlignWith,
			remux: h,
			onData: (t) => {
				t.type = t.type === "combined" ? "video" : t.type, u(e, t);
			},
			onTrackInfo: (t) => {
				n && (h && (t.isMuxed = !0), n(e, t));
			},
			onAudioTimingInfo: (e) => {
				g && e.start !== void 0 && (g(e.start), g = null), _ && e.end !== void 0 && _(e.end);
			},
			onVideoTimingInfo: (e) => {
				v && e.start !== void 0 && (v(e.start), v = null), y && e.end !== void 0 && y(e.end);
			},
			onVideoSegmentTimingInfo: (t) => {
				p({
					type: "segmenttransmuxingtiminginfoavailable",
					segment: e,
					timingInfo: {
						pts: {
							start: t.start.presentation,
							end: t.end.presentation
						},
						dts: {
							start: t.start.decode,
							end: t.end.decode
						}
					}
				}), i(t);
			},
			onAudioSegmentTimingInfo: (t) => {
				p({
					type: "segmenttransmuxingtiminginfoavailable",
					segment: e,
					timingInfo: {
						pts: {
							start: t.start.pts,
							end: t.end.pts
						},
						dts: {
							start: t.start.dts,
							end: t.end.dts
						}
					}
				}), a(t);
			},
			onId3: (t, n) => {
				o(e, t, n);
			},
			onCaptions: (t) => {
				s(e, [t]);
			},
			isEndOfTimeline: c,
			onEndedTimeline: () => {
				l();
			},
			onTransmuxerLog: f,
			onDone: (t, n) => {
				d && (t.type = t.type === "combined" ? "video" : t.type, p({
					type: "segmenttransmuxingcomplete",
					segment: e
				}), d(n, e, t));
			},
			segment: e,
			triggerSegmentEventFn: p
		});
		Mq({
			action: "probeTs",
			transmuxer: e.transmuxer,
			data: t,
			baseStartTime: e.baseStartTime,
			callback: (r) => {
				e.bytes = t = r.data;
				let i = r.result;
				i && (n(e, {
					hasAudio: i.hasAudio,
					hasVideo: i.hasVideo,
					isMuxed: h
				}), n = null), b();
			}
		});
	}, Kq = ({ segment: e, bytes: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		let m = new Uint8Array(t);
		if (VR(m)) {
			e.isFmp4 = !0;
			let { tracks: i } = e.map;
			if (i.text && (!i.audio || !i.video)) {
				u(e, {
					data: m,
					type: "text"
				}), Vq(e, i.text.codec, d);
				return;
			}
			let a = {
				isFmp4: !0,
				hasVideo: !!i.video,
				hasAudio: !!i.audio
			};
			i.audio && i.audio.codec && i.audio.codec !== "enca" && (a.audioCodec = i.audio.codec), i.video && i.video.codec && i.video.codec !== "encv" && (a.videoCodec = i.video.codec), i.video && i.audio && (a.isMuxed = !0), n(e, a);
			let c = (t, n) => {
				u(e, {
					data: m,
					type: a.hasAudio && !a.isMuxed ? "audio" : "video"
				}), n && n.length && o(e, n), t && t.length && s(e, t), d(null, e, {});
			};
			Mq({
				action: "probeMp4StartTime",
				timescales: e.map.timescales,
				data: m,
				transmuxer: e.transmuxer,
				callback: ({ data: n, startTime: o }) => {
					t = n.buffer, e.bytes = m = n, a.hasAudio && !a.isMuxed && r(e, "audio", "start", o), a.hasVideo && r(e, "video", "start", o), Mq({
						action: "probeEmsgID3",
						data: m,
						transmuxer: e.transmuxer,
						offset: o,
						callback: ({ emsgData: n, id3Frames: r }) => {
							if (t = n.buffer, e.bytes = m = n, !i.video || !n.byteLength || !e.transmuxer) {
								c(void 0, r);
								return;
							}
							Mq({
								action: "pushMp4Captions",
								endAction: "mp4Captions",
								transmuxer: e.transmuxer,
								data: m,
								timescales: e.map.timescales,
								trackIds: [i.video.id],
								callback: (n) => {
									t = n.data.buffer, e.bytes = m = n.data, n.logs.forEach(function(e) {
										f(SB(e, { stream: "mp4CaptionParser" }));
									}), c(n.captions, r);
								}
							});
						}
					});
				}
			});
			return;
		}
		if (!e.transmuxer) {
			d(null, e, {});
			return;
		}
		if (e.container === void 0 && (e.container = BR(m)), e.container !== "ts" && e.container !== "aac") {
			n(e, {
				hasAudio: !1,
				hasVideo: !1
			}), d(null, e, {});
			return;
		}
		Gq({
			segment: e,
			bytes: t,
			trackInfoFn: n,
			timingInfoFn: r,
			videoSegmentTimingInfoFn: i,
			audioSegmentTimingInfoFn: a,
			id3Fn: o,
			captionsFn: s,
			isEndOfTimeline: c,
			endedTimelineFn: l,
			dataFn: u,
			doneFn: d,
			onTransmuxerLog: f,
			triggerSegmentEventFn: p
		});
	}, qq = function({ id: e, key: t, encryptedBytes: n, decryptionWorker: r, segment: i, doneFn: a }, o) {
		let s = (t) => {
			if (t.data.source === e) {
				r.removeEventListener("message", s);
				let e = t.data.decrypted;
				o(new Uint8Array(e.bytes, e.byteOffset, e.byteLength));
			}
		};
		r.onerror = () => {
			let e = "An error occurred in the decryption worker", t = HJ({ segment: i });
			a({
				message: e,
				metadata: {
					error: /* @__PURE__ */ Error(e),
					errorType: Y.Error.StreamingFailedToDecryptSegment,
					segmentInfo: t,
					keyInfo: { uri: i.key.resolvedUri || i.map.key.resolvedUri }
				}
			}, i);
		}, r.addEventListener("message", s);
		let c;
		c = t.bytes.slice ? t.bytes.slice() : new Uint32Array(Array.prototype.slice.call(t.bytes)), r.postMessage(RK({
			source: e,
			encrypted: n,
			key: c,
			iv: t.iv
		}), [n.buffer, c.buffer]);
	}, Jq = ({ decryptionWorker: e, segment: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		p({ type: "segmentdecryptionstart" }), qq({
			id: t.requestId,
			key: t.key,
			encryptedBytes: t.encryptedBytes,
			decryptionWorker: e,
			segment: t,
			doneFn: d
		}, (e) => {
			t.bytes = e, p({
				type: "segmentdecryptioncomplete",
				segment: t
			}), Kq({
				segment: t,
				bytes: t.bytes,
				trackInfoFn: n,
				timingInfoFn: r,
				videoSegmentTimingInfoFn: i,
				audioSegmentTimingInfoFn: a,
				id3Fn: o,
				captionsFn: s,
				isEndOfTimeline: c,
				endedTimelineFn: l,
				dataFn: u,
				doneFn: d,
				onTransmuxerLog: f,
				triggerSegmentEventFn: p
			});
		});
	}, Yq = ({ activeXhrs: e, decryptionWorker: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		let m = 0, h = !1;
		return (g, _) => {
			if (!h) {
				if (g) return h = !0, Fq(e), d(g, _);
				if (m += 1, m === e.length) {
					let m = function() {
						if (_.encryptedBytes) return Jq({
							decryptionWorker: t,
							segment: _,
							trackInfoFn: n,
							timingInfoFn: r,
							videoSegmentTimingInfoFn: i,
							audioSegmentTimingInfoFn: a,
							id3Fn: o,
							captionsFn: s,
							isEndOfTimeline: c,
							endedTimelineFn: l,
							dataFn: u,
							doneFn: d,
							onTransmuxerLog: f,
							triggerSegmentEventFn: p
						});
						Kq({
							segment: _,
							bytes: _.bytes,
							trackInfoFn: n,
							timingInfoFn: r,
							videoSegmentTimingInfoFn: i,
							audioSegmentTimingInfoFn: a,
							id3Fn: o,
							captionsFn: s,
							isEndOfTimeline: c,
							endedTimelineFn: l,
							dataFn: u,
							doneFn: d,
							onTransmuxerLog: f,
							triggerSegmentEventFn: p
						});
					};
					if (_.endOfAllRequests = Date.now(), _.map && _.map.encryptedBytes && !_.map.bytes) return p({
						type: "segmentdecryptionstart",
						segment: _
					}), qq({
						decryptionWorker: t,
						id: _.requestId + "-init",
						encryptedBytes: _.map.encryptedBytes,
						key: _.map.key,
						segment: _,
						doneFn: d
					}, (t) => {
						_.map.bytes = t, p({
							type: "segmentdecryptioncomplete",
							segment: _
						}), Hq(_, (t) => {
							if (t) return Fq(e), d(t, _);
							m();
						});
					});
					m();
				}
			}
		};
	}, Xq = ({ loadendState: e, abortFn: t }) => (n) => {
		n.target.aborted && t && !e.calledAbortFn && (t(), e.calledAbortFn = !0);
	}, Zq = ({ segment: e, progressFn: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u }) => (n) => {
		if (!n.target.aborted) return e.stats = SB(e.stats, Lq(n)), !e.stats.firstBytesReceivedAt && e.stats.bytesReceived && (e.stats.firstBytesReceivedAt = Date.now()), t(n, e);
	}, Qq = ({ xhr: e, xhrOptions: t, decryptionWorker: n, segment: r, abortFn: i, progressFn: a, trackInfoFn: o, timingInfoFn: s, videoSegmentTimingInfoFn: c, audioSegmentTimingInfoFn: l, id3Fn: u, captionsFn: d, isEndOfTimeline: f, endedTimelineFn: p, dataFn: m, doneFn: h, onTransmuxerLog: g, triggerSegmentEventFn: _ }) => {
		let v = [], y = Yq({
			activeXhrs: v,
			decryptionWorker: n,
			trackInfoFn: o,
			timingInfoFn: s,
			videoSegmentTimingInfoFn: c,
			audioSegmentTimingInfoFn: l,
			id3Fn: u,
			captionsFn: d,
			isEndOfTimeline: f,
			endedTimelineFn: p,
			dataFn: m,
			doneFn: h,
			onTransmuxerLog: g,
			triggerSegmentEventFn: _
		});
		if (r.key && !r.key.bytes) {
			let n = [r.key];
			r.map && !r.map.bytes && r.map.key && r.map.key.resolvedUri === r.key.resolvedUri && n.push(r.map.key);
			let i = SB(t, {
				uri: r.key.resolvedUri,
				responseType: "arraybuffer",
				requestType: "segment-key"
			}), a = zq(r, n, y, _);
			_({
				type: "segmentkeyloadstart",
				segment: r,
				keyInfo: { uri: r.key.resolvedUri }
			});
			let o = e(i, a);
			v.push(o);
		}
		if (r.map && !r.map.bytes) {
			if (r.map.key && (!r.key || r.key.resolvedUri !== r.map.key.resolvedUri)) {
				let n = SB(t, {
					uri: r.map.key.resolvedUri,
					responseType: "arraybuffer",
					requestType: "segment-key"
				}), i = zq(r, [r.map.key], y, _);
				_({
					type: "segmentkeyloadstart",
					segment: r,
					keyInfo: { uri: r.map.key.resolvedUri }
				});
				let a = e(n, i);
				v.push(a);
			}
			let n = SB(t, {
				uri: r.map.resolvedUri,
				responseType: "arraybuffer",
				headers: PK(r.map),
				requestType: "segment-media-initialization"
			}), i = Uq({
				segment: r,
				finishProcessingFn: y,
				triggerSegmentEventFn: _
			});
			_({
				type: "segmentloadstart",
				segment: r
			});
			let a = e(n, i);
			v.push(a);
		}
		let b = SB(t, {
			uri: r.part && r.part.resolvedUri || r.resolvedUri,
			responseType: "arraybuffer",
			headers: PK(r),
			requestType: "segment"
		}), x = Wq({
			segment: r,
			finishProcessingFn: y,
			responseType: b.responseType,
			triggerSegmentEventFn: _
		});
		_({
			type: "segmentloadstart",
			segment: r
		});
		let S = e(b, x);
		S.addEventListener("progress", Zq({
			segment: r,
			progressFn: a,
			trackInfoFn: o,
			timingInfoFn: s,
			videoSegmentTimingInfoFn: c,
			audioSegmentTimingInfoFn: l,
			id3Fn: u,
			captionsFn: d,
			isEndOfTimeline: f,
			endedTimelineFn: p,
			dataFn: m
		})), v.push(S);
		let C = {};
		return v.forEach((e) => {
			e.addEventListener("loadend", Xq({
				loadendState: C,
				abortFn: i
			}));
		}), () => Fq(v);
	}, $q = pG("PlaylistSelector"), eJ = function(e) {
		if (!e || !e.playlist) return;
		let t = e.playlist;
		return JSON.stringify({
			id: t.id,
			bandwidth: e.bandwidth,
			width: e.width,
			height: e.height,
			codecs: t.attributes && t.attributes.CODECS || ""
		});
	}, tJ = function(e, t) {
		if (!e) return "";
		let n = X.default.getComputedStyle(e);
		return n ? n[t] : "";
	}, nJ = function(e, t) {
		let n = e.slice();
		e.sort(function(e, r) {
			let i = t(e, r);
			return i === 0 ? n.indexOf(e) - n.indexOf(r) : i;
		});
	}, rJ = function(e, t) {
		let n, r;
		return e.attributes.BANDWIDTH && (n = e.attributes.BANDWIDTH), n ||= X.default.Number.MAX_VALUE, t.attributes.BANDWIDTH && (r = t.attributes.BANDWIDTH), r ||= X.default.Number.MAX_VALUE, n - r;
	}, iJ = function(e, t) {
		let n, r;
		return e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (n = e.attributes.RESOLUTION.width), n ||= X.default.Number.MAX_VALUE, t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (r = t.attributes.RESOLUTION.width), r ||= X.default.Number.MAX_VALUE, n === r && e.attributes.BANDWIDTH && t.attributes.BANDWIDTH ? e.attributes.BANDWIDTH - t.attributes.BANDWIDTH : n - r;
	}, aJ = function(e) {
		let { main: t, bandwidth: n, playerWidth: r, playerHeight: i, playerObjectFit: a, limitRenditionByPlayerDimensions: o, playlistController: s } = e;
		if (!t) return;
		let c = {
			bandwidth: n,
			width: r,
			height: i,
			limitRenditionByPlayerDimensions: o
		}, l = t.playlists;
		ZG.isAudioOnly(t) && (l = s.getAudioTrackPlaylists_(), c.audioOnly = !0);
		let u = l.map((e) => {
			let t, n = e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.width, r = e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.height;
			return t = e.attributes && e.attributes.BANDWIDTH, t ||= X.default.Number.MAX_VALUE, {
				bandwidth: t,
				width: n,
				height: r,
				playlist: e
			};
		});
		nJ(u, (e, t) => e.bandwidth - t.bandwidth), u = u.filter((e) => !ZG.isIncompatible(e.playlist));
		let d = u.filter((e) => ZG.isEnabled(e.playlist));
		d.length || (d = u.filter((e) => !ZG.isDisabled(e.playlist)));
		let f = d.filter((e) => e.bandwidth * fq.BANDWIDTH_VARIANCE < n), p = f[f.length - 1], m = f.filter((e) => e.bandwidth === p.bandwidth)[0];
		if (o === !1) {
			let e = m || d[0] || u[0];
			if (e && e.playlist) {
				let t = "sortedPlaylistReps";
				return m && (t = "bandwidthBestRep"), d[0] && (t = "enabledPlaylistReps"), $q(`choosing ${eJ(e)} using ${t} with options`, c), e.playlist;
			}
			return $q("could not choose a playlist with options", c), null;
		}
		let h = f.filter((e) => e.width && e.height);
		nJ(h, (e, t) => e.width - t.width);
		let g = h.filter((e) => e.width === r && e.height === i);
		p = g[g.length - 1];
		let _ = g.filter((e) => e.bandwidth === p.bandwidth)[0], v, y, b;
		_ || (v = h.filter((e) => a === "cover" ? e.width > r && e.height > i : e.width > r || e.height > i), y = v.filter((e) => e.width === v[0].width && e.height === v[0].height), p = y[y.length - 1], b = y.filter((e) => e.bandwidth === p.bandwidth)[0]);
		let x;
		if (s.leastPixelDiffSelector) {
			let e = h.map((e) => (e.pixelDiff = Math.abs(e.width - r) + Math.abs(e.height - i), e));
			nJ(e, (e, t) => e.pixelDiff === t.pixelDiff ? t.bandwidth - e.bandwidth : e.pixelDiff - t.pixelDiff), x = e[0];
		}
		let S = x || b || _ || m || d[0] || u[0];
		if (S && S.playlist) {
			let e = "sortedPlaylistReps";
			return x ? e = "leastPixelDiffRep" : b ? e = "resolutionPlusOneRep" : _ ? e = "resolutionBestRep" : m ? e = "bandwidthBestRep" : d[0] && (e = "enabledPlaylistReps"), $q(`choosing ${eJ(S)} using ${e} with options`, c), S.playlist;
		}
		return $q("could not choose a playlist with options", c), null;
	}, oJ = function() {
		let e = this.useDevicePixelRatio && X.default.devicePixelRatio || 1;
		return isNaN(this.customPixelRatio) || (e = this.customPixelRatio), aJ({
			main: this.playlists.main,
			bandwidth: this.systemBandwidth,
			playerWidth: parseInt(tJ(this.tech_.el(), "width"), 10) * e,
			playerHeight: parseInt(tJ(this.tech_.el(), "height"), 10) * e,
			playerObjectFit: this.usePlayerObjectFit ? tJ(this.tech_.el(), "objectFit") : "",
			limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
			playlistController: this.playlistController_
		});
	}, sJ = function(e) {
		let t = -1, n = -1;
		if (e < 0 || e > 1) throw Error("Moving average bandwidth decay must be between 0 and 1.");
		return function() {
			let r = this.useDevicePixelRatio && X.default.devicePixelRatio || 1;
			return isNaN(this.customPixelRatio) || (r = this.customPixelRatio), t < 0 && (t = this.systemBandwidth, n = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== n && (t = e * this.systemBandwidth + (1 - e) * t, n = this.systemBandwidth), aJ({
				main: this.playlists.main,
				bandwidth: t,
				playerWidth: parseInt(tJ(this.tech_.el(), "width"), 10) * r,
				playerHeight: parseInt(tJ(this.tech_.el(), "height"), 10) * r,
				playerObjectFit: this.usePlayerObjectFit ? tJ(this.tech_.el(), "objectFit") : "",
				limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
				playlistController: this.playlistController_
			});
		};
	}, cJ = function(e) {
		let { main: t, currentTime: n, bandwidth: r, duration: i, segmentDuration: a, timeUntilRebuffer: o, currentTimeline: s, syncController: c } = e, l = t.playlists.filter((e) => !ZG.isIncompatible(e)), u = l.filter(ZG.isEnabled);
		u.length || (u = l.filter((e) => !ZG.isDisabled(e)));
		let d = u.filter(ZG.hasAttribute.bind(null, "BANDWIDTH")).map((e) => {
			let t = c.getSyncPoint(e, i, s, n) ? 1 : 2;
			return {
				playlist: e,
				rebufferingImpact: ZG.estimateSegmentRequestTime(a, r, e) * t - o
			};
		}), f = d.filter((e) => e.rebufferingImpact <= 0);
		return nJ(f, (e, t) => rJ(t.playlist, e.playlist)), f.length ? f[0] : (nJ(d, (e, t) => e.rebufferingImpact - t.rebufferingImpact), d[0] || null);
	}, lJ = function() {
		let e = this.playlists.main.playlists.filter(ZG.isEnabled);
		return nJ(e, (e, t) => rJ(e, t)), e.filter((e) => !!_K(this.playlists.main, e).video)[0] || null;
	}, uJ = (e) => {
		let t = 0, n;
		return e.bytes && (n = new Uint8Array(e.bytes), e.segments.forEach((e) => {
			n.set(e, t), t += e.byteLength;
		})), n;
	}, dJ = function(e, t, n) {
		if (!e[n]) {
			t.trigger({
				type: "usage",
				name: "vhs-608"
			});
			let r = n;
			/^cc708_/.test(n) && (r = "SERVICE" + n.split("_")[1]);
			let i = t.textTracks().getTrackById(r);
			if (i) e[n] = i;
			else {
				let i = t.options_.vhs && t.options_.vhs.captionServices || {}, a = n, o = n, s = !1, c = i[r];
				c && (a = c.label, o = c.language, s = c.default), e[n] = t.addRemoteTextTrack({
					kind: "captions",
					id: r,
					default: s,
					label: a,
					language: o
				}, !1).track;
			}
		}
	}, fJ = function({ inbandTextTracks: e, captionArray: t, timestampOffset: n }) {
		if (!t) return;
		let r = X.default.WebKitDataCue || X.default.VTTCue;
		t.forEach((t) => {
			let i = t.stream;
			t.content ? t.content.forEach((a) => {
				let o = new r(t.startTime + n, t.endTime + n, a.text);
				o.line = a.line, o.align = "left", o.position = a.position, o.positionAlign = "line-left", e[i].addCue(o);
			}) : e[i].addCue(new r(t.startTime + n, t.endTime + n, t.text));
		});
	}, pJ = function(e) {
		Object.defineProperties(e.frame, {
			id: { get() {
				return Y.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), e.value.key;
			} },
			value: { get() {
				return Y.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), e.value.data;
			} },
			privateData: { get() {
				return Y.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), e.value.data;
			} }
		});
	}, mJ = ({ inbandTextTracks: e, metadataArray: t, timestampOffset: n, videoDuration: r }) => {
		if (!t) return;
		let i = X.default.WebKitDataCue || X.default.VTTCue, a = e.metadataTrack_;
		if (!a || (t.forEach((e) => {
			let t = e.cueTime + n;
			typeof t != "number" || X.default.isNaN(t) || t < 0 || !(t < Infinity) || !e.frames || !e.frames.length || e.frames.forEach((e) => {
				let n = new i(t, t, e.value || e.url || e.data || "");
				n.frame = e, n.value = e, pJ(n), a.addCue(n);
			});
		}), !a.cues || !a.cues.length)) return;
		let o = a.cues, s = [];
		for (let e = 0; e < o.length; e++) o[e] && s.push(o[e]);
		let c = s.reduce((e, t) => {
			let n = e[t.startTime] || [];
			return n.push(t), e[t.startTime] = n, e;
		}, {}), l = Object.keys(c).sort((e, t) => Number(e) - Number(t));
		l.forEach((e, t) => {
			let n = c[e], i = isFinite(r) ? r : e, a = Number(l[t + 1]) || i;
			n.forEach((e) => {
				e.endTime = a;
			});
		});
	}, hJ = {
		id: "ID",
		class: "CLASS",
		startDate: "START-DATE",
		duration: "DURATION",
		endDate: "END-DATE",
		endOnNext: "END-ON-NEXT",
		plannedDuration: "PLANNED-DURATION",
		scte35Out: "SCTE35-OUT",
		scte35In: "SCTE35-IN"
	}, gJ = /* @__PURE__ */ new Set([
		"id",
		"class",
		"startDate",
		"duration",
		"endDate",
		"endOnNext",
		"startTime",
		"endTime",
		"processDateRange"
	]), _J = ({ inbandTextTracks: e, dateRanges: t }) => {
		let n = e.metadataTrack_;
		if (!n) return;
		let r = X.default.WebKitDataCue || X.default.VTTCue;
		t.forEach((e) => {
			for (let t of Object.keys(e)) {
				if (gJ.has(t)) continue;
				let i = new r(e.startTime, e.endTime, "");
				i.id = e.id, i.type = "com.apple.quicktime.HLS", i.value = {
					key: hJ[t],
					data: e[t]
				}, (t === "scte35Out" || t === "scte35In") && (i.value.data = new Uint8Array(i.value.data.match(/[\da-f]{2}/gi)).buffer), n.addCue(i);
			}
			e.processDateRange();
		});
	}, vJ = (e, t, n) => {
		e.metadataTrack_ || (e.metadataTrack_ = n.addRemoteTextTrack({
			kind: "metadata",
			label: "Timed Metadata"
		}, !1).track, Y.browser.IS_ANY_SAFARI || (e.metadataTrack_.inBandMetadataTrackDispatchType = t));
	}, yJ = function(e, t, n) {
		let r, i;
		if (n && n.cues) for (r = n.cues.length; r--;) i = n.cues[r], i.startTime >= e && i.endTime <= t && n.removeCue(i);
	}, bJ = function(e) {
		let t = e.cues;
		if (!t) return;
		let n = {};
		for (let r = t.length - 1; r >= 0; r--) {
			let i = t[r], a = `${i.startTime}-${i.endTime}-${i.text}`;
			n[a] ? e.removeCue(i) : n[a] = i;
		}
	}, xJ = (e, t, n) => {
		if (t == null || !e.length) return [];
		let r = Math.ceil((t - n + 3) * AB.ONE_SECOND_IN_TS), i;
		for (i = 0; i < e.length && !(e[i].pts > r); i++);
		return e.slice(i);
	}, SJ = (e, t, n) => {
		if (!t.length) return e;
		if (n) return t.slice();
		let r = t[0].pts, i = 0;
		for (; i < e.length && !(e[i].pts >= r); i++);
		return e.slice(0, i).concat(t);
	}, CJ = (e, t, n, r) => {
		let i = Math.ceil((t - r) * AB.ONE_SECOND_IN_TS), a = Math.ceil((n - r) * AB.ONE_SECOND_IN_TS), o = e.slice(), s = e.length;
		for (; s-- && !(e[s].pts <= a););
		if (s === -1) return o;
		let c = s + 1;
		for (; c-- && !(e[c].pts <= i););
		return c = Math.max(c, 0), o.splice(c, s - c + 1), o;
	}, wJ = function(e, t) {
		if (!e && !t || !e && t || e && !t) return !1;
		if (e === t) return !0;
		let n = Object.keys(e).sort(), r = Object.keys(t).sort();
		if (n.length !== r.length) return !1;
		for (let i = 0; i < n.length; i++) {
			let a = n[i];
			if (a !== r[i] || e[a] !== t[a]) return !1;
		}
		return !0;
	}, TJ = function(e, t, n) {
		t ||= [];
		let r = [], i = 0;
		for (let a = 0; a < t.length; a++) {
			let o = t[a];
			if (e === o.timeline && (r.push(a), i += o.duration, i > n)) return a;
		}
		return r.length === 0 ? 0 : r[r.length - 1];
	}, EJ = 1, DJ = 500, OJ = (e) => typeof e == "number" && isFinite(e), kJ = 1 / 60, AJ = (e, t, n) => e !== "main" || !t || !n ? null : !n.hasAudio && !n.hasVideo ? "Neither audio nor video found in segment." : t.hasVideo && !n.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !t.hasVideo && n.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, jJ = (e, t, n) => {
		let r = t - fq.BACK_BUFFER_LENGTH;
		e.length && (r = Math.max(r, e.start(0)));
		let i = t - n;
		return Math.min(i, r);
	}, MJ = (e) => {
		let { startOfSegment: t, duration: n, segment: r, part: i, playlist: { mediaSequence: a, id: o, segments: s = [] }, mediaIndex: c, partIndex: l, timeline: u } = e, d = s.length - 1, f = "mediaIndex/partIndex increment";
		e.getMediaInfoForTime ? f = `getMediaInfoForTime (${e.getMediaInfoForTime})` : e.isSyncRequest && (f = "getSyncSegmentCandidate (isSyncRequest)"), e.independent && (f += ` with independent ${e.independent}`);
		let p = typeof l == "number", m = e.segment.uri ? "segment" : "pre-segment", h = p ? AG({ preloadSegment: r }) - 1 : 0;
		return `${m} [${a + c}/${a + d}]` + (p ? ` part [${l}/${h}]` : "") + ` segment start/end [${r.start} => ${r.end}]` + (p ? ` part start/end [${i.start} => ${i.end}]` : "") + ` startOfSegment [${t}] duration [${n}] timeline [${u}] selected by [${f}] playlist [${o}]`;
	}, NJ = (e) => `${e}TimingInfo`, PJ = ({ segmentTimeline: e, currentTimeline: t, startOfSegment: n, buffered: r, overrideCheck: i }) => !i && e === t ? null : e < t ? n : r.length ? r.end(r.length - 1) : n, FJ = ({ timelineChangeController: e, currentTimeline: t, segmentTimeline: n, loaderType: r, audioDisabled: i }) => {
		if (t === n) return !1;
		if (r === "audio") {
			let t = e.lastTimelineChange({ type: "main" });
			return !t || t.to !== n;
		}
		if (r === "main" && i) {
			let t = e.pendingTimelineChange({ type: "audio" });
			return !(t && t.to === n);
		}
		return !1;
	}, IJ = (e) => {
		if (!e) return !1;
		let t = e.pendingTimelineChange({ type: "audio" }), n = e.pendingTimelineChange({ type: "main" }), r = t && n, i = r && t.to !== n.to;
		return !!(r && t.from !== -1 && n.from !== -1 && i);
	}, LJ = (e) => {
		let t = e.timelineChangeController_.pendingTimelineChange({ type: "audio" }), n = e.timelineChangeController_.pendingTimelineChange({ type: "main" });
		return t && n && t.to < n.to;
	}, RJ = (e) => {
		let t = e.pendingSegment_;
		if (t && FJ({
			timelineChangeController: e.timelineChangeController_,
			currentTimeline: e.currentTimeline_,
			segmentTimeline: t.timeline,
			loaderType: e.loaderType_,
			audioDisabled: e.audioDisabled_
		}) && IJ(e.timelineChangeController_)) {
			if (LJ(e)) {
				e.timelineChangeController_.trigger("audioTimelineBehind");
				return;
			}
			e.timelineChangeController_.trigger("fixBadTimelineChange");
		}
	}, zJ = (e) => {
		let t = 0;
		return ["video", "audio"].forEach(function(n) {
			let r = e[`${n}TimingInfo`];
			if (!r) return;
			let { start: i, end: a } = r, o;
			typeof i == "bigint" || typeof a == "bigint" ? o = X.default.BigInt(a) - X.default.BigInt(i) : typeof i == "number" && typeof a == "number" && (o = a - i), o !== void 0 && o > t && (t = o);
		}), typeof t == "bigint" && t < 2 ** 53 - 1 && (t = Number(t)), t;
	}, BJ = ({ segmentDuration: e, maxDuration: t }) => e ? Math.round(e) > t + mG : !1, VJ = (e, t) => {
		if (t !== "hls") return null;
		let n = zJ({
			audioTimingInfo: e.audioTimingInfo,
			videoTimingInfo: e.videoTimingInfo
		});
		if (!n) return null;
		let r = e.playlist.targetDuration, i = BJ({
			segmentDuration: n,
			maxDuration: r * 2
		}), a = BJ({
			segmentDuration: n,
			maxDuration: r
		}), o = `Segment with index ${e.mediaIndex} from playlist ${e.playlist.id} has a duration of ${n} when the reported duration is ${e.duration} and the target duration is ${r}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
		return i || a ? {
			severity: i ? "warn" : "info",
			message: o
		} : null;
	}, HJ = ({ type: e, segment: t }) => {
		if (!t) return;
		let n = !!(t.key || t.map && t.map.ke), r = !!(t.map && !t.map.bytes), i = t.startOfSegment === void 0 ? t.start : t.startOfSegment;
		return {
			type: e || t.type,
			uri: t.resolvedUri || t.uri,
			start: i,
			duration: t.duration,
			isEncrypted: n,
			isMediaInitialization: r
		};
	}, UJ = class extends Y.EventTarget {
		constructor(e, t = {}) {
			if (super(), !e) throw TypeError("Initialization settings are required");
			if (typeof e.currentTime != "function") throw TypeError("No currentTime getter specified");
			if (!e.mediaSource) throw TypeError("No MediaSource specified");
			this.bandwidth = e.bandwidth, this.throughput = {
				rate: 0,
				count: 0
			}, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = e.hasPlayed, this.currentTime_ = e.currentTime, this.seekable_ = e.seekable, this.seeking_ = e.seeking, this.duration_ = e.duration, this.mediaSource_ = e.mediaSource, this.vhs_ = e.vhs, this.loaderType_ = e.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = e.segmentMetadataTrack, this.goalBufferLength_ = e.goalBufferLength, this.sourceType_ = e.sourceType, this.sourceUpdater_ = e.sourceUpdater, this.inbandTextTracks_ = e.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = e.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = e.parse708captions, this.useDtsForTimestampOffset_ = e.useDtsForTimestampOffset, this.captionServices_ = e.captionServices, this.exactManifestTimings = e.exactManifestTimings, this.addMetadataToTextTrack = e.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}, this.playlistOfLastInitSegment_ = {
				audio: null,
				video: null
			}, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
				id3: [],
				caption: []
			}, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = e.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = e.decrypter, this.syncController_ = e.syncController, this.syncPoint_ = {
				segmentIndex: 0,
				time: 0
			}, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
				this.isEndOfStream_() || (this.ended_ = !1);
			}), this.fetchAtBuffer_ = !1, this.logger_ = pG(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
				get() {
					return this.state_;
				},
				set(e) {
					e !== this.state_ && (this.logger_(`${this.state_} -> ${e}`), this.state_ = e, this.trigger("statechange"));
				}
			}), this.sourceUpdater_.on("ready", () => {
				this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : RJ(this);
			}), this.sourceUpdater_.on("codecschange", (e) => {
				this.trigger(wF({ type: "codecschange" }, e));
			}), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
				this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : RJ(this);
			}), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (e) => {
				this.trigger(wF({ type: "timelinechange" }, e)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : RJ(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : RJ(this);
			});
		}
		get mediaSequenceSync_() {
			return this.syncController_.getMediaSequenceSync(this.loaderType_);
		}
		createTransmuxer_() {
			return jq.createTransmuxer({
				remux: !1,
				alignGopsAtEnd: this.safeAppend_,
				keepOriginalTimestamps: !0,
				parse708captions: this.parse708captions_,
				captionServices: this.captionServices_
			});
		}
		resetStats_() {
			this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
		}
		dispose() {
			this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && X.default.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
		}
		setAudio(e) {
			this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
		}
		abort() {
			if (this.state !== "WAITING") {
				this.pendingSegment_ &&= null, this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
				return;
			}
			this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
		}
		abort_() {
			this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, X.default.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
		}
		checkForAbort_(e) {
			return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== e;
		}
		error(e) {
			return e !== void 0 && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_;
		}
		endOfStream() {
			this.ended_ = !0, this.transmuxer_ && jq.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
		}
		buffered_() {
			let e = this.getMediaInfo_();
			if (!this.sourceUpdater_ || !e) return CB();
			if (this.loaderType_ === "main") {
				let { hasAudio: t, hasVideo: n, isMuxed: r } = e;
				if (n && t && !this.audioDisabled_ && !r) return this.sourceUpdater_.buffered();
				if (n) return this.sourceUpdater_.videoBuffered();
			}
			return this.sourceUpdater_.audioBuffered();
		}
		initSegmentForMap(e, t = !1) {
			if (!e) return null;
			let n = zK(e), r = this.initSegments_[n];
			return t && !r && e.bytes && (this.initSegments_[n] = r = {
				resolvedUri: e.resolvedUri,
				byterange: e.byterange,
				bytes: e.bytes,
				tracks: e.tracks,
				timescales: e.timescales
			}), r || e;
		}
		segmentKey(e, t = !1) {
			if (!e) return null;
			let n = BK(e), r = this.keyCache_[n];
			this.cacheEncryptionKeys_ && t && !r && e.bytes && (this.keyCache_[n] = r = {
				resolvedUri: e.resolvedUri,
				bytes: e.bytes
			});
			let i = { resolvedUri: (r || e).resolvedUri };
			return r && (i.bytes = r.bytes), i;
		}
		couldBeginLoading_() {
			return this.playlist_ && !this.paused();
		}
		load() {
			if (this.monitorBuffer_(), this.playlist_) {
				if (this.state === "INIT" && this.couldBeginLoading_()) return this.init_();
				!this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
			}
		}
		init_() {
			return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
		}
		playlist(e, t = {}) {
			if (!e || this.playlist_ && this.playlist_.endList && e.endList && this.playlist_.uri === e.uri) return;
			let n = this.playlist_, r = this.pendingSegment_;
			this.playlist_ = e, this.xhrOptions_ = t, this.state === "INIT" && (e.syncInfo = {
				mediaSequence: e.mediaSequence,
				time: 0
			}, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(e));
			let i = null;
			if (n && (n.id ? i = n.id : n.uri && (i = n.uri)), this.logger_(`playlist update [${i} => ${e.id || e.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(e, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${TG(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_()) return this.init_();
			if (!n || n.uri !== e.uri) {
				this.mediaIndex !== null && (!e.endList && typeof e.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
				return;
			}
			let a = e.mediaSequence - n.mediaSequence;
			if (this.logger_(`live window shift [${a}]`), this.mediaIndex !== null) if (this.mediaIndex -= a, this.mediaIndex < 0) this.mediaIndex = null, this.partIndex = null;
			else {
				let e = this.playlist_.segments[this.mediaIndex];
				if (this.partIndex && (!e.parts || !e.parts.length || !e.parts[this.partIndex])) {
					let e = this.mediaIndex;
					this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = e;
				}
			}
			r && (r.mediaIndex -= a, r.mediaIndex < 0 ? (r.mediaIndex = null, r.partIndex = null) : (r.mediaIndex >= 0 && (r.segment = e.segments[r.mediaIndex]), r.partIndex >= 0 && r.segment.parts && (r.part = r.segment.parts[r.partIndex]))), this.syncController_.saveExpiredSegmentInfo(n, e);
		}
		pause() {
			this.checkBufferTimeout_ &&= (X.default.clearTimeout(this.checkBufferTimeout_), null);
		}
		paused() {
			return this.checkBufferTimeout_ === null;
		}
		resetEverything(e) {
			this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}, this.resetLoader(), this.remove(0, Infinity, e), this.transmuxer_ && (this.transmuxer_.postMessage({ action: "clearAllMp4Captions" }), this.transmuxer_.postMessage({ action: "reset" }));
		}
		resetLoader() {
			this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
		}
		resyncLoader() {
			this.transmuxer_ && jq.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
			let e = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
			this.sourceType_ === "hls" && !e && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({ action: "clearParsedMp4Captions" });
		}
		remove(e, t, n = () => {}, r = !1) {
			if (t === Infinity && (t = this.duration_()), t <= e) {
				this.logger_("skipping remove because end ${end} is <= start ${start}");
				return;
			}
			if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
				this.logger_("skipping remove because no source updater or starting media info");
				return;
			}
			let i = 1, a = () => {
				i--, i === 0 && n();
			};
			(r || !this.audioDisabled_) && (i++, this.sourceUpdater_.removeAudio(e, t, a)), (r || this.loaderType_ === "main") && (this.gopBuffer_ = CJ(this.gopBuffer_, e, t, this.timeMapping_), i++, this.sourceUpdater_.removeVideo(e, t, a));
			for (let n in this.inbandTextTracks_) yJ(e, t, this.inbandTextTracks_[n]);
			yJ(e, t, this.segmentMetadataTrack_), a();
		}
		monitorBuffer_() {
			this.checkBufferTimeout_ && X.default.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = X.default.setTimeout(this.monitorBufferTick_.bind(this), 1);
		}
		monitorBufferTick_() {
			this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && X.default.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = X.default.setTimeout(this.monitorBufferTick_.bind(this), DJ);
		}
		fillBuffer_() {
			if (this.sourceUpdater_.updating()) return;
			let e = this.chooseNextRequest_();
			if (!e) return;
			let t = { segmentInfo: HJ({
				type: this.loaderType_,
				segment: e
			}) };
			this.trigger({
				type: "segmentselected",
				metadata: t
			}), typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
				type: this.loaderType_,
				from: this.currentTimeline_,
				to: e.timeline
			})), this.loadSegment_(e);
		}
		isEndOfStream_(e = this.mediaIndex, t = this.playlist_, n = this.partIndex) {
			if (!t || !this.mediaSource_) return !1;
			let r = typeof e == "number" && t.segments[e], i = e + 1 === t.segments.length, a = !r || !r.parts || n + 1 === r.parts.length;
			return t.endList && this.mediaSource_.readyState === "open" && i && a;
		}
		chooseNextRequest_() {
			let e = this.buffered_(), t = TG(e) || 0, n = EG(e, this.currentTime_()), r = !this.hasPlayed_() && n >= 1, i = n >= this.goalBufferLength_(), a = this.playlist_.segments;
			if (!a.length || r || i) return null;
			this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
			let o = {
				partIndex: null,
				mediaIndex: null,
				startOfSegment: null,
				playlist: this.playlist_,
				isSyncRequest: !this.syncPoint_
			};
			if (o.isSyncRequest) o.mediaIndex = TJ(this.currentTimeline_, a, t), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${o.mediaIndex}`);
			else if (this.mediaIndex !== null) {
				let e = a[this.mediaIndex], n = typeof this.partIndex == "number" ? this.partIndex : -1;
				o.startOfSegment = e.end ? e.end : t, e.parts && e.parts[n + 1] ? (o.mediaIndex = this.mediaIndex, o.partIndex = n + 1) : o.mediaIndex = this.mediaIndex + 1;
			} else {
				let e, n, r, i = this.fetchAtBuffer_ ? t : this.currentTime_();
				if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${i}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${t}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
					let t = this.getSyncInfoFromMediaSequenceSync_(i);
					if (!t) {
						let e = "No sync info found while using media sequence sync";
						return this.error({
							message: e,
							metadata: {
								errorType: Y.Error.StreamingFailedToSelectNextSegment,
								error: /* @__PURE__ */ Error(e)
							}
						}), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
					}
					this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${t.start} --> ${t.end})`), e = t.segmentIndex, n = t.partIndex, r = t.start;
				} else {
					this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
					let t = ZG.getMediaInfoForTime({
						exactManifestTimings: this.exactManifestTimings,
						playlist: this.playlist_,
						currentTime: i,
						startingPartIndex: this.syncPoint_.partIndex,
						startingSegmentIndex: this.syncPoint_.segmentIndex,
						startTime: this.syncPoint_.time
					});
					e = t.segmentIndex, n = t.partIndex, r = t.startTime;
				}
				o.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${i}` : `currentTime ${i}`, o.mediaIndex = e, o.startOfSegment = r, o.partIndex = n, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${o.mediaIndex} `);
			}
			let s = a[o.mediaIndex], c = s && typeof o.partIndex == "number" && s.parts && s.parts[o.partIndex];
			if (!s || typeof o.partIndex == "number" && !c) return null;
			typeof o.partIndex != "number" && s.parts && (o.partIndex = 0, c = s.parts[0]);
			let l = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
			if (!n && c && !l && !c.independent) if (o.partIndex === 0) {
				let e = a[o.mediaIndex - 1], t = e.parts && e.parts.length && e.parts[e.parts.length - 1];
				t && t.independent && (--o.mediaIndex, o.partIndex = e.parts.length - 1, o.independent = "previous segment");
			} else s.parts[o.partIndex - 1].independent && (--o.partIndex, o.independent = "previous part");
			let u = this.mediaSource_ && this.mediaSource_.readyState === "ended";
			return o.mediaIndex >= a.length - 1 && u && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, o.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(o));
		}
		getSyncInfoFromMediaSequenceSync_(e) {
			if (!this.mediaSequenceSync_) return null;
			let t = Math.max(e, this.mediaSequenceSync_.start);
			e !== t && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${e} to ${t}`);
			let n = this.mediaSequenceSync_.getSyncInfoForTime(t);
			if (!n) return null;
			if (!n.isAppended) return n;
			let r = this.mediaSequenceSync_.getSyncInfoForTime(n.end);
			return r ? (r.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), r) : null;
		}
		generateSegmentInfo_(e) {
			let { independent: t, playlist: n, mediaIndex: r, startOfSegment: i, isSyncRequest: a, partIndex: o, forceTimestampOffset: s, getMediaInfoForTime: c } = e, l = n.segments[r], u = typeof o == "number" && l.parts[o], d = {
				requestId: "segment-loader-" + Math.random(),
				uri: u && u.resolvedUri || l.resolvedUri,
				mediaIndex: r,
				partIndex: u ? o : null,
				isSyncRequest: a,
				startOfSegment: i,
				playlist: n,
				bytes: null,
				encryptedBytes: null,
				timestampOffset: null,
				timeline: l.timeline,
				duration: u && u.duration || l.duration,
				segment: l,
				part: u,
				byteLength: 0,
				transmuxer: this.transmuxer_,
				getMediaInfoForTime: c,
				independent: t
			}, f = s === void 0 ? this.isPendingTimestampOffset_ : s;
			d.timestampOffset = this.timestampOffsetForSegment_({
				segmentTimeline: l.timeline,
				currentTimeline: this.currentTimeline_,
				startOfSegment: i,
				buffered: this.buffered_(),
				overrideCheck: f
			});
			let p = TG(this.sourceUpdater_.audioBuffered());
			return typeof p == "number" && (d.audioAppendStart = p - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (d.gopsToAlignWith = xJ(this.gopBuffer_, this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_)), d;
		}
		timestampOffsetForSegment_(e) {
			return PJ(e);
		}
		earlyAbortWhenNeeded_(e) {
			if (this.vhs_.tech_.paused() || !this.xhrOptions_.timeout || !this.playlist_.attributes.BANDWIDTH || Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3) return;
			let t = this.currentTime_(), n = e.bandwidth, r = this.pendingSegment_.duration, i = ZG.estimateSegmentRequestTime(r, n, this.playlist_, e.bytesReceived), a = SG(this.buffered_(), t, this.vhs_.tech_.playbackRate()) - 1;
			if (i <= a) return;
			let o = cJ({
				main: this.vhs_.playlists.main,
				currentTime: t,
				bandwidth: n,
				duration: this.duration_(),
				segmentDuration: r,
				timeUntilRebuffer: a,
				currentTimeline: this.currentTimeline_,
				syncController: this.syncController_
			});
			if (!o) return;
			let s = i - a - o.rebufferingImpact, c = .5;
			a <= mG && (c = 1), !(!o.playlist || o.playlist.uri === this.playlist_.uri || s < c) && (this.bandwidth = o.playlist.attributes.BANDWIDTH * fq.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
		}
		handleAbort_(e) {
			this.logger_(`Aborting ${MJ(e)}`), this.mediaRequestsAborted += 1;
		}
		handleProgress_(e, t) {
			this.earlyAbortWhenNeeded_(t.stats), !this.checkForAbort_(t.requestId) && this.trigger("progress");
		}
		handleTrackInfo_(e, t) {
			let { hasAudio: n, hasVideo: r } = t, i = {
				segmentInfo: HJ({
					type: this.loaderType_,
					segment: e
				}),
				trackInfo: {
					hasAudio: n,
					hasVideo: r
				}
			};
			this.trigger({
				type: "segmenttransmuxingtrackinfoavailable",
				metadata: i
			}), this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId) && (this.checkForIllegalMediaSwitch(t) || (t ||= {}, wJ(this.currentMediaInfo_, t) || (this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}, this.startingMediaInfo_ = t, this.currentMediaInfo_ = t, this.logger_("trackinfo update", t), this.trigger("trackinfo")), !this.checkForAbort_(e.requestId) && (this.pendingSegment_.trackInfo = t, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : RJ(this))));
		}
		handleTimingInfo_(e, t, n, r) {
			if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId)) return;
			let i = this.pendingSegment_, a = NJ(t);
			i[a] = i[a] || {}, i[a][n] = r, this.logger_(`timinginfo: ${t} - ${n} - ${r}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : RJ(this);
		}
		handleCaptions_(e, t) {
			if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId)) return;
			if (t.length === 0) {
				this.logger_("SegmentLoader received no captions from a caption event");
				return;
			}
			if (!this.pendingSegment_.hasAppendedData_) {
				this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, t));
				return;
			}
			let n = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), r = {};
			t.forEach((e) => {
				r[e.stream] = r[e.stream] || {
					startTime: Infinity,
					captions: [],
					endTime: 0
				};
				let t = r[e.stream];
				t.startTime = Math.min(t.startTime, e.startTime + n), t.endTime = Math.max(t.endTime, e.endTime + n), t.captions.push(e);
			}), Object.keys(r).forEach((e) => {
				let { startTime: t, endTime: i, captions: a } = r[e], o = this.inbandTextTracks_;
				this.logger_(`adding cues from ${t} -> ${i} for ${e}`), dJ(o, this.vhs_.tech_, e), yJ(t, i, o[e]), fJ({
					captionArray: a,
					inbandTextTracks: o,
					timestampOffset: n
				});
			}), this.transmuxer_ && this.transmuxer_.postMessage({ action: "clearParsedMp4Captions" });
		}
		handleId3_(e, t, n) {
			if (this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId)) {
				if (!this.pendingSegment_.hasAppendedData_) {
					this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, t, n));
					return;
				}
				this.addMetadataToTextTrack(n, t, this.duration_());
			}
		}
		processMetadataQueue_() {
			this.metadataQueue_.id3.forEach((e) => e()), this.metadataQueue_.caption.forEach((e) => e()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
		}
		processCallQueue_() {
			let e = this.callQueue_;
			this.callQueue_ = [], e.forEach((e) => e());
		}
		processLoadQueue_() {
			let e = this.loadQueue_;
			this.loadQueue_ = [], e.forEach((e) => e());
		}
		hasEnoughInfoToLoad_() {
			if (this.loaderType_ !== "audio") return !0;
			let e = this.pendingSegment_;
			return e ? !this.getCurrentMediaInfo_() || !FJ({
				timelineChangeController: this.timelineChangeController_,
				currentTimeline: this.currentTimeline_,
				segmentTimeline: e.timeline,
				loaderType: this.loaderType_,
				audioDisabled: this.audioDisabled_
			}) : !1;
		}
		getCurrentMediaInfo_(e = this.pendingSegment_) {
			return e && e.trackInfo || this.currentMediaInfo_;
		}
		getMediaInfo_(e = this.pendingSegment_) {
			return this.getCurrentMediaInfo_(e) || this.startingMediaInfo_;
		}
		getPendingSegmentPlaylist() {
			return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
		}
		hasEnoughInfoToAppend_() {
			if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) return !1;
			let e = this.pendingSegment_, t = this.getCurrentMediaInfo_();
			if (!e || !t) return !1;
			let { hasAudio: n, hasVideo: r, isMuxed: i } = t;
			return !(r && !e.videoTimingInfo || n && !this.audioDisabled_ && !i && !e.audioTimingInfo || FJ({
				timelineChangeController: this.timelineChangeController_,
				currentTimeline: this.currentTimeline_,
				segmentTimeline: e.timeline,
				loaderType: this.loaderType_,
				audioDisabled: this.audioDisabled_
			}));
		}
		handleData_(e, t) {
			if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId)) return;
			if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
				RJ(this), this.callQueue_.push(this.handleData_.bind(this, e, t));
				return;
			}
			let n = this.pendingSegment_;
			if (this.setTimeMapping_(n.timeline), this.updateMediaSecondsLoaded_(n.part || n.segment), this.mediaSource_.readyState !== "closed") {
				if (e.map && (e.map = this.initSegmentForMap(e.map, !0), n.segment.map = e.map), e.key && this.segmentKey(e.key, !0), n.isFmp4 = e.isFmp4, n.timingInfo = n.timingInfo || {}, n.isFmp4) this.trigger("fmp4"), n.timingInfo.start = n[NJ(t.type)].start;
				else {
					let e = this.getCurrentMediaInfo_(), t = this.loaderType_ === "main" && e && e.hasVideo, r;
					t && (r = n.videoTimingInfo.start), n.timingInfo.start = this.trueSegmentStart_({
						currentStart: n.timingInfo.start,
						playlist: n.playlist,
						mediaIndex: n.mediaIndex,
						currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
						useVideoTimingInfo: t,
						firstVideoFrameTimeForData: r,
						videoTimingInfo: n.videoTimingInfo,
						audioTimingInfo: n.audioTimingInfo
					});
				}
				if (this.updateAppendInitSegmentStatus(n, t.type), this.updateSourceBufferTimestampOffset_(n), n.isSyncRequest) {
					this.updateTimingInfoEnd_(n), this.syncController_.saveSegmentTimingInfo({
						segmentInfo: n,
						shouldSaveTimelineMapping: this.loaderType_ === "main"
					});
					let e = this.chooseNextRequest_();
					if (e.mediaIndex !== n.mediaIndex || e.partIndex !== n.partIndex) {
						this.logger_("sync segment was incorrect, not appending");
						return;
					}
					this.logger_("sync segment was correct, appending");
				}
				n.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(n, t);
			}
		}
		updateAppendInitSegmentStatus(e, t) {
			this.loaderType_ === "main" && typeof e.timestampOffset == "number" && !e.changedTimestampOffset && (this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}), this.playlistOfLastInitSegment_[t] !== e.playlist && (this.appendInitSegment_[t] = !0);
		}
		getInitSegmentAndUpdateState_({ type: e, initSegment: t, map: n, playlist: r }) {
			if (n) {
				let e = zK(n);
				if (this.activeInitSegmentId_ === e) return null;
				t = this.initSegmentForMap(n, !0).bytes, this.activeInitSegmentId_ = e;
			}
			return t && this.appendInitSegment_[e] ? (this.playlistOfLastInitSegment_[e] = r, this.appendInitSegment_[e] = !1, this.activeInitSegmentId_ = null, t) : null;
		}
		handleQuotaExceededError_({ segmentInfo: e, type: t, bytes: n }, r) {
			let i = this.sourceUpdater_.audioBuffered(), a = this.sourceUpdater_.videoBuffered();
			i.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + CG(i).join(", ")), a.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + CG(a).join(", "));
			let o = i.length ? i.start(0) : 0, s = i.length ? i.end(i.length - 1) : 0, c = a.length ? a.start(0) : 0, l = a.length ? a.end(a.length - 1) : 0;
			if (s - o <= EJ && l - c <= EJ) {
				this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${n.byteLength}, audio buffer: ${CG(i).join(", ")}, video buffer: ${CG(a).join(", ")}, `), this.error({
					message: "Quota exceeded error with append of a single segment of content",
					excludeUntil: Infinity
				}), this.trigger("error");
				return;
			}
			this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
				segmentInfo: e,
				type: t,
				bytes: n
			}));
			let u = this.currentTime_() - EJ;
			this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${u}`), this.remove(0, u, () => {
				this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${EJ}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = X.default.setTimeout(() => {
					this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
				}, EJ * 1e3);
			}, !0);
		}
		handleAppendError_({ segmentInfo: e, type: t, bytes: n }, r) {
			if (r) {
				if (r.code === lK) {
					this.handleQuotaExceededError_({
						segmentInfo: e,
						type: t,
						bytes: n
					});
					return;
				}
				this.logger_("Received non QUOTA_EXCEEDED_ERR on append", r), this.error({
					message: `${t} append of ${n.length}b failed for segment #${e.mediaIndex} in playlist ${e.playlist.id}`,
					metadata: { errorType: Y.Error.StreamingFailedToAppendSegment }
				}), this.trigger("appenderror");
			}
		}
		appendToSourceBuffer_({ segmentInfo: e, type: t, initSegment: n, data: r, bytes: i }) {
			if (!i) {
				let e = [r], t = r.byteLength;
				n && (e.unshift(n), t += n.byteLength), i = uJ({
					bytes: t,
					segments: e
				});
			}
			let a = { segmentInfo: HJ({
				type: this.loaderType_,
				segment: e
			}) };
			this.trigger({
				type: "segmentappendstart",
				metadata: a
			}), this.sourceUpdater_.appendBuffer({
				segmentInfo: e,
				type: t,
				bytes: i
			}, this.handleAppendError_.bind(this, {
				segmentInfo: e,
				type: t,
				bytes: i
			}));
		}
		handleSegmentTimingInfo_(e, t, n) {
			if (!this.pendingSegment_ || t !== this.pendingSegment_.requestId) return;
			let r = this.pendingSegment_.segment, i = `${e}TimingInfo`;
			r[i] || (r[i] = {}), r[i].transmuxerPrependedSeconds = n.prependedContentDuration || 0, r[i].transmuxedPresentationStart = n.start.presentation, r[i].transmuxedDecodeStart = n.start.decode, r[i].transmuxedPresentationEnd = n.end.presentation, r[i].transmuxedDecodeEnd = n.end.decode, r[i].baseMediaDecodeTime = n.baseMediaDecodeTime;
		}
		appendData_(e, t) {
			let { type: n, data: r } = t;
			if (!r || !r.byteLength || n === "audio" && this.audioDisabled_) return;
			let i = this.getInitSegmentAndUpdateState_({
				type: n,
				initSegment: t.initSegment,
				playlist: e.playlist,
				map: e.isFmp4 ? e.segment.map : null
			});
			this.appendToSourceBuffer_({
				segmentInfo: e,
				type: n,
				initSegment: i,
				data: r
			});
		}
		loadSegment_(e) {
			if (this.state = "WAITING", this.pendingSegment_ = e, this.trimBackBuffer_(e), typeof e.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({ action: "clearAllMp4Captions" }), !this.hasEnoughInfoToLoad_()) {
				RJ(this), this.loadQueue_.push(() => {
					let t = wF({}, e, { forceTimestampOffset: !0 });
					wF(e, this.generateSegmentInfo_(t)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(e);
				});
				return;
			}
			this.updateTransmuxerAndRequestSegment_(e);
		}
		updateTransmuxerAndRequestSegment_(e) {
			this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({ action: "reset" }), this.transmuxer_.postMessage({
				action: "setTimestampOffset",
				timestampOffset: e.timestampOffset
			}));
			let t = this.createSimplifiedSegmentObj_(e), n = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex), r = this.mediaIndex !== null, i = e.timeline !== this.currentTimeline_ && e.timeline > 0, a = n || r && i;
			this.logger_(`Requesting
${TB(e.uri)}
${MJ(e)}`), t.map && !t.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
				video: !0,
				audio: !0
			}), e.abortRequests = Qq({
				xhr: this.vhs_.xhr,
				xhrOptions: this.xhrOptions_,
				decryptionWorker: this.decrypter_,
				segment: t,
				abortFn: this.handleAbort_.bind(this, e),
				progressFn: this.handleProgress_.bind(this),
				trackInfoFn: this.handleTrackInfo_.bind(this),
				timingInfoFn: this.handleTimingInfo_.bind(this),
				videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
				audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
				captionsFn: this.handleCaptions_.bind(this),
				isEndOfTimeline: a,
				endedTimelineFn: () => {
					this.logger_("received endedtimeline callback");
				},
				id3Fn: this.handleId3_.bind(this),
				dataFn: this.handleData_.bind(this),
				doneFn: this.segmentRequestFinished_.bind(this),
				onTransmuxerLog: ({ message: t, level: n, stream: r }) => {
					this.logger_(`${MJ(e)} logged from transmuxer stream ${r} as a ${n}: ${t}`);
				},
				triggerSegmentEventFn: ({ type: e, segment: t, keyInfo: n, trackInfo: r, timingInfo: i }) => {
					let a = { segmentInfo: HJ({ segment: t }) };
					n && (a.keyInfo = n), r && (a.trackInfo = r), i && (a.timingInfo = i), this.trigger({
						type: e,
						metadata: a
					});
				}
			});
		}
		trimBackBuffer_(e) {
			let t = jJ(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
			t > 0 && this.remove(0, t);
		}
		createSimplifiedSegmentObj_(e) {
			let t = e.segment, n = e.part, r = e.segment.key || e.segment.map && e.segment.map.key, i = e.segment.map && !e.segment.map.bytes, a = {
				resolvedUri: n ? n.resolvedUri : t.resolvedUri,
				byterange: n ? n.byterange : t.byterange,
				requestId: e.requestId,
				transmuxer: e.transmuxer,
				audioAppendStart: e.audioAppendStart,
				gopsToAlignWith: e.gopsToAlignWith,
				part: e.part,
				type: this.loaderType_,
				start: e.startOfSegment,
				duration: e.duration,
				isEncrypted: r,
				isMediaInitialization: i
			}, o = e.playlist.segments[e.mediaIndex - 1];
			if (o && o.timeline === t.timeline && (o.videoTimingInfo ? a.baseStartTime = o.videoTimingInfo.transmuxedDecodeEnd : o.audioTimingInfo && (a.baseStartTime = o.audioTimingInfo.transmuxedDecodeEnd)), t.key) {
				let n = t.key.iv || new Uint32Array([
					0,
					0,
					0,
					e.mediaIndex + e.playlist.mediaSequence
				]);
				a.key = this.segmentKey(t.key), a.key.iv = n;
			}
			return t.map && (a.map = this.initSegmentForMap(t.map)), a;
		}
		saveTransferStats_(e) {
			this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime);
		}
		saveBandwidthRelatedStats_(e, t) {
			if (this.pendingSegment_.byteLength = t.bytesReceived, e < kJ) {
				this.logger_(`Ignoring segment's bandwidth because its duration of ${e} is less than the min to record ${kJ}`);
				return;
			}
			let n = { bandwidthInfo: {
				from: this.bandwidth,
				to: t.bandwidth
			} };
			this.trigger({
				type: "bandwidthupdated",
				metadata: n
			}), this.bandwidth = t.bandwidth, this.roundTrip = t.roundTripTime;
		}
		handleTimeout_() {
			this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
		}
		segmentRequestFinished_(e, t, n) {
			if (this.callQueue_.length) {
				this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, t, n));
				return;
			}
			if (this.saveTransferStats_(t.stats), !this.pendingSegment_ || t.requestId !== this.pendingSegment_.requestId) return;
			if (e) {
				if (this.pendingSegment_ = null, this.state = "READY", e.code === Nq.ABORTED) return;
				if (this.pause(), e.code === Nq.TIMEOUT) {
					this.handleTimeout_();
					return;
				}
				this.mediaRequestsErrored += 1, this.error(e), this.trigger("error");
				return;
			}
			let r = this.pendingSegment_;
			this.saveBandwidthRelatedStats_(r.duration, t.stats), r.endOfAllRequests = t.endOfAllRequests, n.gopInfo && (this.gopBuffer_ = SJ(this.gopBuffer_, n.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(r);
		}
		setTimeMapping_(e) {
			let t = this.syncController_.mappingForTimeline(e);
			t !== null && (this.timeMapping_ = t);
		}
		updateMediaSecondsLoaded_(e) {
			typeof e.start == "number" && typeof e.end == "number" ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration;
		}
		shouldUpdateTransmuxerTimestampOffset_(e) {
			return e === null ? !1 : this.loaderType_ === "main" && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset();
		}
		trueSegmentStart_({ currentStart: e, playlist: t, mediaIndex: n, firstVideoFrameTimeForData: r, currentVideoTimestampOffset: i, useVideoTimingInfo: a, videoTimingInfo: o, audioTimingInfo: s }) {
			if (e !== void 0) return e;
			if (!a) return s.start;
			let c = t.segments[n - 1];
			return n === 0 || !c || c.start === void 0 || c.end !== r + i ? r : o.start;
		}
		waitForAppendsToComplete_(e) {
			let t = this.getCurrentMediaInfo_(e);
			if (!t) {
				this.error({
					message: "No starting media returned, likely due to an unsupported media format.",
					playlistExclusionDuration: Infinity
				}), this.trigger("error");
				return;
			}
			let { hasAudio: n, hasVideo: r, isMuxed: i } = t, a = this.loaderType_ === "main" && r, o = !this.audioDisabled_ && n && !i;
			if (e.waitingOnAppends = 0, !e.hasAppendedData_) {
				!e.timingInfo && typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), e.timingInfo = { start: 0 }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), this.checkAppendsDone_(e);
				return;
			}
			a && e.waitingOnAppends++, o && e.waitingOnAppends++, a && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), o && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e));
		}
		checkAppendsDone_(e) {
			this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, e.waitingOnAppends === 0 && this.handleAppendsDone_());
		}
		checkForIllegalMediaSwitch(e) {
			let t = AJ(this.loaderType_, this.getCurrentMediaInfo_(), e);
			return t ? (this.error({
				message: t,
				playlistExclusionDuration: Infinity
			}), this.trigger("error"), !0) : !1;
		}
		updateSourceBufferTimestampOffset_(e) {
			if (e.timestampOffset === null || typeof e.timingInfo.start != "number" || e.changedTimestampOffset || this.loaderType_ !== "main") return;
			let t = !1;
			e.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
				videoTimingInfo: e.segment.videoTimingInfo,
				audioTimingInfo: e.segment.audioTimingInfo,
				timingInfo: e.timingInfo
			}), e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), t = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), t = !0), t && this.trigger("timestampoffset");
		}
		getSegmentStartTimeForTimestampOffsetCalculation_({ videoTimingInfo: e, audioTimingInfo: t, timingInfo: n }) {
			return this.useDtsForTimestampOffset_ ? e && typeof e.transmuxedDecodeStart == "number" ? e.transmuxedDecodeStart : t && typeof t.transmuxedDecodeStart == "number" ? t.transmuxedDecodeStart : n.start : n.start;
		}
		updateTimingInfoEnd_(e) {
			e.timingInfo = e.timingInfo || {};
			let t = this.getMediaInfo_(), n = this.loaderType_ === "main" && t && t.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
			n && (e.timingInfo.end = typeof n.end == "number" ? n.end : n.start + e.duration);
		}
		handleAppendsDone_() {
			if (this.pendingSegment_) {
				let e = { segmentInfo: HJ({
					type: this.loaderType_,
					segment: this.pendingSegment_
				}) };
				this.trigger({
					type: "appendsdone",
					metadata: e
				});
			}
			if (!this.pendingSegment_) {
				this.state = "READY", this.paused() || this.monitorBuffer_();
				return;
			}
			let e = this.pendingSegment_;
			e.part && e.part.syncInfo ? e.part.syncInfo.markAppended() : e.segment.syncInfo && e.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
				segmentInfo: e,
				shouldSaveTimelineMapping: this.loaderType_ === "main"
			});
			let t = VJ(e, this.sourceType_);
			if (t && (t.severity === "warn" ? Y.log.warn(t.message) : this.logger_(t.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest && (this.trigger("syncinfoupdate"), !e.hasAppendedData_)) {
				this.logger_(`Throwing away un-appended sync request ${MJ(e)}`);
				return;
			}
			this.logger_(`Appended ${MJ(e)}`), this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
				type: this.loaderType_,
				from: this.currentTimeline_,
				to: e.timeline
			}), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
				type: "audio",
				from: this.currentTimeline_,
				to: e.timeline
			})), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
			let n = e.segment, r = e.part, i = n.end && this.currentTime_() - n.end > e.playlist.targetDuration * 3, a = r && r.end && this.currentTime_() - r.end > e.playlist.partTargetDuration * 3;
			if (i || a) {
				this.logger_(`bad ${i ? "segment" : "part"} ${MJ(e)}`), this.resetEverything();
				return;
			}
			this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), e.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
		}
		recordThroughput_(e) {
			if (e.duration < kJ) {
				this.logger_(`Ignoring segment's throughput because its duration of ${e.duration} is less than the min to record ${kJ}`);
				return;
			}
			let t = this.throughput.rate, n = Date.now() - e.endOfAllRequests + 1, r = Math.floor(e.byteLength / n * 8 * 1e3);
			this.throughput.rate += (r - t) / ++this.throughput.count;
		}
		addSegmentMetadataCue_(e) {
			if (!this.segmentMetadataTrack_) return;
			let t = e.segment, n = t.start, r = t.end;
			if (!OJ(n) || !OJ(r)) return;
			yJ(n, r, this.segmentMetadataTrack_);
			let i = X.default.WebKitDataCue || X.default.VTTCue, a = {
				custom: t.custom,
				dateTimeObject: t.dateTimeObject,
				dateTimeString: t.dateTimeString,
				programDateTime: t.programDateTime,
				bandwidth: e.playlist.attributes.BANDWIDTH,
				resolution: e.playlist.attributes.RESOLUTION,
				codecs: e.playlist.attributes.CODECS,
				byteLength: e.byteLength,
				uri: e.uri,
				timeline: e.timeline,
				playlist: e.playlist.id,
				start: n,
				end: r
			}, o = new i(n, r, JSON.stringify(a));
			o.value = a, this.segmentMetadataTrack_.addCue(o);
		}
	}, WJ = function(e) {
		return typeof e == "string" ? e.replace(/./, (e) => e.toUpperCase()) : e;
	}, GJ = ["video", "audio"], KJ = (e, t) => {
		let n = t[`${e}Buffer`];
		return n && n.updating || t.queuePending[e];
	}, qJ = (e, t) => {
		for (let n = 0; n < t.length; n++) {
			let r = t[n];
			if (r.type === "mediaSource") return null;
			if (r.type === e) return n;
		}
		return null;
	}, JJ = (e, t) => {
		if (t.queue.length === 0) return;
		let n = 0, r = t.queue[n];
		if (r.type === "mediaSource") {
			!t.updating() && t.mediaSource.readyState !== "closed" && (t.queue.shift(), r.action(t), r.doneFn && r.doneFn(), JJ("audio", t), JJ("video", t));
			return;
		}
		if (e !== "mediaSource" && !(!t.ready() || t.mediaSource.readyState === "closed" || KJ(e, t))) {
			if (r.type !== e) {
				if (n = qJ(e, t.queue), n === null) return;
				r = t.queue[n];
			}
			if (t.queue.splice(n, 1), t.queuePending[e] = r, r.action(e, t), !r.doneFn) {
				t.queuePending[e] = null, JJ(e, t);
				return;
			}
		}
	}, YJ = (e, t) => {
		let n = t[`${e}Buffer`], r = WJ(e);
		n && (n.removeEventListener("updateend", t[`on${r}UpdateEnd_`]), n.removeEventListener("error", t[`on${r}Error_`]), t.codecs[e] = null, t[`${e}Buffer`] = null);
	}, XJ = (e, t) => e && t && Array.prototype.indexOf.call(e.sourceBuffers, t) !== -1, ZJ = {
		appendBuffer: (e, t, n) => (r, i) => {
			let a = i[`${r}Buffer`];
			if (XJ(i.mediaSource, a)) {
				i.logger_(`Appending segment ${t.mediaIndex}'s ${e.length} bytes to ${r}Buffer`);
				try {
					a.appendBuffer(e);
				} catch (e) {
					i.logger_(`Error with code ${e.code} ` + (e.code === lK ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${t.mediaIndex} to ${r}Buffer`), i.queuePending[r] = null, n(e);
				}
			}
		},
		remove: (e, t) => (n, r) => {
			let i = r[`${n}Buffer`];
			if (XJ(r.mediaSource, i)) {
				r.logger_(`Removing ${e} to ${t} from ${n}Buffer`);
				try {
					i.remove(e, t);
				} catch {
					r.logger_(`Remove ${e} to ${t} from ${n}Buffer failed`);
				}
			}
		},
		timestampOffset: (e) => (t, n) => {
			let r = n[`${t}Buffer`];
			XJ(n.mediaSource, r) && (n.logger_(`Setting ${t}timestampOffset to ${e}`), r.timestampOffset = e);
		},
		callback: (e) => (t, n) => {
			e();
		},
		endOfStream: (e) => (t) => {
			if (t.mediaSource.readyState === "open") {
				t.logger_(`Calling mediaSource endOfStream(${e || ""})`);
				try {
					t.mediaSource.endOfStream(e);
				} catch (e) {
					Y.log.warn("Failed to call media source endOfStream", e);
				}
			}
		},
		duration: (e) => (t) => {
			t.logger_(`Setting mediaSource duration to ${e}`);
			try {
				t.mediaSource.duration = e;
			} catch (e) {
				Y.log.warn("Failed to set media source duration", e);
			}
		},
		abort: () => (e, t) => {
			if (t.mediaSource.readyState !== "open") return;
			let n = t[`${e}Buffer`];
			if (XJ(t.mediaSource, n)) {
				t.logger_(`calling abort on ${e}Buffer`);
				try {
					n.abort();
				} catch (t) {
					Y.log.warn(`Failed to abort on ${e}Buffer`, t);
				}
			}
		},
		addSourceBuffer: (e, t) => (n) => {
			let r = WJ(e), i = rI(t);
			n.logger_(`Adding ${e}Buffer with codec ${t} to mediaSource`);
			let a = n.mediaSource.addSourceBuffer(i);
			a.addEventListener("updateend", n[`on${r}UpdateEnd_`]), a.addEventListener("error", n[`on${r}Error_`]), n.codecs[e] = t, n[`${e}Buffer`] = a;
		},
		removeSourceBuffer: (e) => (t) => {
			let n = t[`${e}Buffer`];
			if (YJ(e, t), XJ(t.mediaSource, n)) {
				t.logger_(`Removing ${e}Buffer with codec ${t.codecs[e]} from mediaSource`);
				try {
					t.mediaSource.removeSourceBuffer(n);
				} catch (t) {
					Y.log.warn(`Failed to removeSourceBuffer ${e}Buffer`, t);
				}
			}
		},
		changeType: (e) => (t, n) => {
			let r = n[`${t}Buffer`], i = rI(e);
			if (!XJ(n.mediaSource, r)) return;
			let a = e.substring(0, e.indexOf(".")), o = n.codecs[t];
			if (o.substring(0, o.indexOf(".")) === a) return;
			let s = { codecsChangeInfo: {
				from: o,
				to: e
			} };
			n.trigger({
				type: "codecschange",
				metadata: s
			}), n.logger_(`changing ${t}Buffer codec from ${o} to ${e}`);
			try {
				r.changeType(i), n.codecs[t] = e;
			} catch (e) {
				s.errorType = Y.Error.StreamingCodecsChangeError, s.error = e, e.metadata = s, n.error_ = e, n.trigger("error"), Y.log.warn(`Failed to changeType on ${t}Buffer`, e);
			}
		}
	}, QJ = ({ type: e, sourceUpdater: t, action: n, doneFn: r, name: i }) => {
		t.queue.push({
			type: e,
			action: n,
			doneFn: r,
			name: i
		}), JJ(e, t);
	}, $J = (e, t) => (n) => {
		let r = wB(t[`${e}Buffered`]());
		if (t.logger_(`received "updateend" event for ${e} Source Buffer: `, r), t.queuePending[e]) {
			let n = t.queuePending[e].doneFn;
			t.queuePending[e] = null, n && n(t[`${e}Error_`]);
		}
		JJ(e, t);
	}, eY = class extends Y.EventTarget {
		constructor(e) {
			super(), this.mediaSource = e, this.sourceopenListener_ = () => JJ("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = pG("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
				audio: null,
				video: null
			}, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = $J("video", this), this.onAudioUpdateEnd_ = $J("audio", this), this.onVideoError_ = (e) => {
				this.videoError_ = e;
			}, this.onAudioError_ = (e) => {
				this.audioError_ = e;
			}, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
		}
		initializedEme() {
			this.initializedEme_ = !0, this.triggerReady();
		}
		hasCreatedSourceBuffers() {
			return this.createdSourceBuffers_;
		}
		hasInitializedAnyEme() {
			return this.initializedEme_;
		}
		ready() {
			return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
		}
		createSourceBuffers(e) {
			this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
		}
		triggerReady() {
			this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
		}
		addSourceBuffer(e, t) {
			QJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: ZJ.addSourceBuffer(e, t),
				name: "addSourceBuffer"
			});
		}
		abort(e) {
			QJ({
				type: e,
				sourceUpdater: this,
				action: ZJ.abort(e),
				name: "abort"
			});
		}
		removeSourceBuffer(e) {
			if (!this.canRemoveSourceBuffer()) {
				Y.log.error("removeSourceBuffer is not supported!");
				return;
			}
			QJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: ZJ.removeSourceBuffer(e),
				name: "removeSourceBuffer"
			});
		}
		canRemoveSourceBuffer() {
			return !Y.browser.IS_FIREFOX && X.default.MediaSource && X.default.MediaSource.prototype && typeof X.default.MediaSource.prototype.removeSourceBuffer == "function";
		}
		static canChangeType() {
			return X.default.SourceBuffer && X.default.SourceBuffer.prototype && typeof X.default.SourceBuffer.prototype.changeType == "function";
		}
		canChangeType() {
			return this.constructor.canChangeType();
		}
		changeType(e, t) {
			if (!this.canChangeType()) {
				Y.log.error("changeType is not supported!");
				return;
			}
			QJ({
				type: e,
				sourceUpdater: this,
				action: ZJ.changeType(t),
				name: "changeType"
			});
		}
		addOrChangeSourceBuffers(e) {
			if (!e || typeof e != "object" || Object.keys(e).length === 0) throw Error("Cannot addOrChangeSourceBuffers to undefined codecs");
			Object.keys(e).forEach((t) => {
				let n = e[t];
				if (!this.hasCreatedSourceBuffers()) return this.addSourceBuffer(t, n);
				this.canChangeType() && this.changeType(t, n);
			});
		}
		appendBuffer(e, t) {
			let { segmentInfo: n, type: r, bytes: i } = e;
			if (this.processedAppend_ = !0, r === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
				this.delayedAudioAppendQueue_.push([e, t]), this.logger_(`delayed audio append of ${i.length} until video append`);
				return;
			}
			let a = t;
			if (QJ({
				type: r,
				sourceUpdater: this,
				action: ZJ.appendBuffer(i, n || { mediaIndex: -1 }, a),
				doneFn: t,
				name: "appendBuffer"
			}), r === "video") {
				if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length) return;
				let e = this.delayedAudioAppendQueue_.slice();
				this.logger_(`queuing delayed audio ${e.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, e.forEach((e) => {
					this.appendBuffer.apply(this, e);
				});
			}
		}
		audioBuffered() {
			return XJ(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : CB();
		}
		videoBuffered() {
			return XJ(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : CB();
		}
		buffered() {
			let e = XJ(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, t = XJ(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
			return t && !e ? this.audioBuffered() : e && !t ? this.videoBuffered() : bG(this.audioBuffered(), this.videoBuffered());
		}
		setDuration(e, t = EB) {
			QJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: ZJ.duration(e),
				name: "duration",
				doneFn: t
			});
		}
		endOfStream(e = null, t = EB) {
			typeof e != "string" && (e = void 0), QJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: ZJ.endOfStream(e),
				name: "endOfStream",
				doneFn: t
			});
		}
		removeAudio(e, t, n = EB) {
			if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
				n();
				return;
			}
			QJ({
				type: "audio",
				sourceUpdater: this,
				action: ZJ.remove(e, t),
				doneFn: n,
				name: "remove"
			});
		}
		removeVideo(e, t, n = EB) {
			if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
				n();
				return;
			}
			QJ({
				type: "video",
				sourceUpdater: this,
				action: ZJ.remove(e, t),
				doneFn: n,
				name: "remove"
			});
		}
		updating() {
			return !!(KJ("audio", this) || KJ("video", this));
		}
		audioTimestampOffset(e) {
			return e !== void 0 && this.audioBuffer && this.audioTimestampOffset_ !== e && (QJ({
				type: "audio",
				sourceUpdater: this,
				action: ZJ.timestampOffset(e),
				name: "timestampOffset"
			}), this.audioTimestampOffset_ = e), this.audioTimestampOffset_;
		}
		videoTimestampOffset(e) {
			return e !== void 0 && this.videoBuffer && this.videoTimestampOffset_ !== e && (QJ({
				type: "video",
				sourceUpdater: this,
				action: ZJ.timestampOffset(e),
				name: "timestampOffset"
			}), this.videoTimestampOffset_ = e), this.videoTimestampOffset_;
		}
		audioQueueCallback(e) {
			this.audioBuffer && QJ({
				type: "audio",
				sourceUpdater: this,
				action: ZJ.callback(e),
				name: "callback"
			});
		}
		videoQueueCallback(e) {
			this.videoBuffer && QJ({
				type: "video",
				sourceUpdater: this,
				action: ZJ.callback(e),
				name: "callback"
			});
		}
		dispose() {
			this.trigger("dispose"), GJ.forEach((e) => {
				this.abort(e), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(e) : this[`${e}QueueCallback`](() => YJ(e, this));
			}), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
		}
	}, tY = (e) => decodeURIComponent(escape(String.fromCharCode.apply(null, e))), nY = (e) => {
		let t = new Uint8Array(e);
		return Array.from(t).map((e) => e.toString(16).padStart(2, "0")).join("");
	}, rY = new Uint8Array("\n\n".split("").map((e) => e.charCodeAt(0))), iY = class extends Error {
		constructor() {
			super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
		}
	}, aY = class extends UJ {
		constructor(e, t = {}) {
			super(e, t), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = e.featuresNativeTextTracks, this.loadVttJs = e.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
		}
		buffered_() {
			if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) return CB();
			let e = this.subtitlesTrack_.cues, t = e[0].startTime, n = e[e.length - 1].startTime;
			return CB([[t, n]]);
		}
		initSegmentForMap(e, t = !1) {
			if (!e) return null;
			let n = zK(e), r = this.initSegments_[n];
			if (t && !r && e.bytes) {
				let t = rY.byteLength + e.bytes.byteLength, i = new Uint8Array(t);
				i.set(e.bytes), i.set(rY, e.bytes.byteLength), this.initSegments_[n] = r = {
					resolvedUri: e.resolvedUri,
					byterange: e.byterange,
					bytes: i
				};
			}
			return r || e;
		}
		couldBeginLoading_() {
			return this.playlist_ && this.subtitlesTrack_ && !this.paused();
		}
		init_() {
			return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
		}
		track(e) {
			return e === void 0 ? this.subtitlesTrack_ : (this.subtitlesTrack_ = e, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
		}
		remove(e, t) {
			yJ(e, t, this.subtitlesTrack_);
		}
		fillBuffer_() {
			let e = this.chooseNextRequest_();
			if (e) {
				if (this.syncController_.timestampOffsetForTimeline(e.timeline) === null) {
					this.syncController_.one("timestampoffset", () => {
						this.state = "READY", this.paused() || this.monitorBuffer_();
					}), this.state = "WAITING_ON_TIMELINE";
					return;
				}
				this.loadSegment_(e);
			}
		}
		timestampOffsetForSegment_() {
			return null;
		}
		chooseNextRequest_() {
			return this.skipEmptySegments_(super.chooseNextRequest_());
		}
		skipEmptySegments_(e) {
			for (; e && e.segment.empty;) {
				if (e.mediaIndex + 1 >= e.playlist.segments.length) {
					e = null;
					break;
				}
				e = this.generateSegmentInfo_({
					playlist: e.playlist,
					mediaIndex: e.mediaIndex + 1,
					startOfSegment: e.startOfSegment + e.duration,
					isSyncRequest: e.isSyncRequest
				});
			}
			return e;
		}
		stopForError(e) {
			this.error(e), this.state = "READY", this.pause(), this.trigger("error");
		}
		segmentRequestFinished_(e, t, n) {
			if (!this.subtitlesTrack_) {
				this.state = "READY";
				return;
			}
			if (this.saveTransferStats_(t.stats), !this.pendingSegment_) {
				this.state = "READY", this.mediaRequestsAborted += 1;
				return;
			}
			if (e) {
				e.code === Nq.TIMEOUT && this.handleTimeout_(), e.code === Nq.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(e);
				return;
			}
			let r = this.pendingSegment_, i = n.mp4VttCues && n.mp4VttCues.length;
			i && (r.mp4VttCues = n.mp4VttCues), this.saveBandwidthRelatedStats_(r.duration, t.stats), t.key && this.segmentKey(t.key, !0), this.state = "APPENDING", this.trigger("appending");
			let a = r.segment;
			if (a.map && (a.map.bytes = t.map.bytes), r.bytes = t.bytes, typeof X.default.WebVTT != "function" && typeof this.loadVttJs == "function") {
				this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(e, t, n), () => this.stopForError({ message: "Error loading vtt.js" }));
				return;
			}
			a.requested = !0;
			try {
				this.parseVTTCues_(r);
			} catch (e) {
				this.stopForError({
					message: e.message,
					metadata: {
						errorType: Y.Error.StreamingVttParserError,
						error: e
					}
				});
				return;
			}
			if (i || this.updateTimeMapping_(r, this.syncController_.timelines[r.timeline], this.playlist_), r.timingInfo = r.cues.length ? {
				start: r.cues[0].startTime,
				end: r.cues[r.cues.length - 1].endTime
			} : {
				start: r.startOfSegment,
				end: r.startOfSegment + r.duration
			}, r.isSyncRequest) {
				this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
				return;
			}
			r.byteLength = r.bytes.byteLength, this.mediaSecondsLoaded += a.duration, r.cues.forEach((e) => {
				this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new X.default.VTTCue(e.startTime, e.endTime, e.text) : e);
			}), bJ(this.subtitlesTrack_), this.handleAppendsDone_();
		}
		handleData_(e, t) {
			let n = e && e.type === "vtt", r = t && t.type === "text";
			n && r && super.handleData_(e, t);
		}
		updateTimingInfoEnd_() {}
		parseMp4VttCues_(e) {
			let t = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
			e.mp4VttCues.forEach((n) => {
				let r = n.start + t, i = n.end + t, a = new X.default.VTTCue(r, i, n.cueText);
				n.settings && n.settings.split(" ").forEach((e) => {
					let t = e.split(":"), n = t[0], r = t[1];
					a[n] = isNaN(r) ? r : Number(r);
				}), e.cues.push(a);
			});
		}
		parseVTTCues_(e) {
			let t, n = !1;
			if (typeof X.default.WebVTT != "function") throw new iY();
			if (e.cues = [], e.timestampmap = {
				MPEGTS: 0,
				LOCAL: 0
			}, e.mp4VttCues) {
				this.parseMp4VttCues_(e);
				return;
			}
			typeof X.default.TextDecoder == "function" ? t = new X.default.TextDecoder("utf8") : (t = X.default.WebVTT.StringDecoder(), n = !0);
			let r = new X.default.WebVTT.Parser(X.default, X.default.vttjs, t);
			if (r.oncue = e.cues.push.bind(e.cues), r.ontimestampmap = (t) => {
				e.timestampmap = t;
			}, r.onparsingerror = (e) => {
				Y.log.warn("Error encountered when parsing cues: " + e.message);
			}, e.segment.map) {
				let t = e.segment.map.bytes;
				n && (t = tY(t)), r.parse(t);
			}
			let i = e.bytes;
			n && (i = tY(i)), r.parse(i), r.flush();
		}
		updateTimeMapping_(e, t, n) {
			let r = e.segment;
			if (!t) return;
			if (!e.cues.length) {
				r.empty = !0;
				return;
			}
			let { MPEGTS: i, LOCAL: a } = e.timestampmap, o = i / AB.ONE_SECOND_IN_TS - a + t.mapping;
			if (e.cues.forEach((e) => {
				let n = e.endTime - e.startTime, r = this.handleRollover_(e.startTime + o, t.time);
				e.startTime = Math.max(r, 0), e.endTime = Math.max(r + n, 0);
			}), !n.syncInfo) {
				let t = e.cues[0].startTime, i = e.cues[e.cues.length - 1].startTime;
				n.syncInfo = {
					mediaSequence: n.mediaSequence + e.mediaIndex,
					time: Math.min(t, i - r.duration)
				};
			}
		}
		handleRollover_(e, t) {
			if (t === null) return e;
			let n = e * AB.ONE_SECOND_IN_TS, r = t * AB.ONE_SECOND_IN_TS, i;
			for (i = r < n ? -8589934592 : 8589934592; Math.abs(n - r) > 4294967296;) n += i;
			return n / AB.ONE_SECOND_IN_TS;
		}
	}, oY = function(e, t) {
		let n = e.cues;
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			if (t >= r.adStartTime && t <= r.adEndTime) return r;
		}
		return null;
	}, sY = function(e, t, n = 0) {
		if (!e.segments) return;
		let r = n, i;
		for (let n = 0; n < e.segments.length; n++) {
			let a = e.segments[n];
			if (i ||= oY(t, r + a.duration / 2), i) {
				if ("cueIn" in a) {
					i.endTime = r, i.adEndTime = r, r += a.duration, i = null;
					continue;
				}
				if (r < i.endTime) {
					r += a.duration;
					continue;
				}
				i.endTime += a.duration;
			} else if ("cueOut" in a && (i = new X.default.VTTCue(r, r + a.duration, a.cueOut), i.adStartTime = r, i.adEndTime = r + parseFloat(a.cueOut), t.addCue(i)), "cueOutCont" in a) {
				let [e, n] = a.cueOutCont.split("/").map(parseFloat);
				i = new X.default.VTTCue(r, r + a.duration, ""), i.adStartTime = r - e, i.adEndTime = i.adStartTime + n, t.addCue(i);
			}
			r += a.duration;
		}
	}, cY = class {
		constructor({ start: e, end: t, segmentIndex: n, partIndex: r = null, appended: i = !1 }) {
			this.start_ = e, this.end_ = t, this.segmentIndex_ = n, this.partIndex_ = r, this.appended_ = i;
		}
		isInRange(e) {
			return e >= this.start && e < this.end;
		}
		markAppended() {
			this.appended_ = !0;
		}
		resetAppendedStatus() {
			this.appended_ = !1;
		}
		get isAppended() {
			return this.appended_;
		}
		get start() {
			return this.start_;
		}
		get end() {
			return this.end_;
		}
		get segmentIndex() {
			return this.segmentIndex_;
		}
		get partIndex() {
			return this.partIndex_;
		}
	}, lY = class {
		constructor(e, t = []) {
			this.segmentSyncInfo_ = e, this.partsSyncInfo_ = t;
		}
		get segmentSyncInfo() {
			return this.segmentSyncInfo_;
		}
		get partsSyncInfo() {
			return this.partsSyncInfo_;
		}
		get hasPartsSyncInfo() {
			return this.partsSyncInfo_.length > 0;
		}
		resetAppendStatus() {
			this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((e) => e.resetAppendedStatus());
		}
	}, uY = class {
		constructor() {
			this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -Infinity, this.end_ = Infinity;
		}
		get start() {
			return this.start_;
		}
		get end() {
			return this.end_;
		}
		get diagnostics() {
			return this.diagnostics_;
		}
		get isReliable() {
			return this.isReliable_;
		}
		resetAppendedStatus() {
			this.storage_.forEach((e) => e.resetAppendStatus());
		}
		update(e, t) {
			let { mediaSequence: n, segments: r } = e;
			if (this.isReliable_ = this.isReliablePlaylist_(n, r), this.isReliable_) return this.updateStorage_(r, n, this.calculateBaseTime_(n, r, t));
		}
		getSyncInfoForTime(e) {
			for (let { segmentSyncInfo: t, partsSyncInfo: n } of this.storage_.values()) if (n.length) {
				for (let t of n) if (t.isInRange(e)) return t;
			} else if (t.isInRange(e)) return t;
			return null;
		}
		getSyncInfoForMediaSequence(e) {
			return this.storage_.get(e);
		}
		updateStorage_(e, t, n) {
			let r = /* @__PURE__ */ new Map(), i = "\n", a = n, o = t;
			this.start_ = a, e.forEach((e, t) => {
				let n = this.storage_.get(o), s = a, c = s + e.duration, l = !!(n && n.segmentSyncInfo && n.segmentSyncInfo.isAppended), u = new cY({
					start: s,
					end: c,
					appended: l,
					segmentIndex: t
				});
				e.syncInfo = u;
				let d = a, f = (e.parts || []).map((e, r) => {
					let a = d, s = d + e.duration, c = !!(n && n.partsSyncInfo && n.partsSyncInfo[r] && n.partsSyncInfo[r].isAppended), l = new cY({
						start: a,
						end: s,
						appended: c,
						segmentIndex: t,
						partIndex: r
					});
					return d = s, i += `Media Sequence: ${o}.${r} | Range: ${a} --> ${s} | Appended: ${c}\n`, e.syncInfo = l, l;
				});
				r.set(o, new lY(u, f)), i += `${TB(e.resolvedUri)} | Media Sequence: ${o} | Range: ${s} --> ${c} | Appended: ${l}\n`, o++, a = c;
			}), this.end_ = a, this.storage_ = r, this.diagnostics_ = i;
		}
		calculateBaseTime_(e, t, n) {
			if (!this.storage_.size) return 0;
			if (this.storage_.has(e)) return this.storage_.get(e).segmentSyncInfo.start;
			let r = Math.min(...this.storage_.keys());
			if (e < r) {
				let n = r - e, i = this.storage_.get(r).segmentSyncInfo.start;
				for (let e = 0; e < n; e++) {
					let n = t[e];
					i -= n.duration;
				}
				return i;
			}
			return n;
		}
		isReliablePlaylist_(e, t) {
			return e != null && Array.isArray(t) && t.length;
		}
	}, dY = class extends uY {
		constructor(e) {
			super(), this.parent_ = e;
		}
		calculateBaseTime_(e, t, n) {
			if (!this.storage_.size) {
				let t = this.parent_.getSyncInfoForMediaSequence(e);
				return t ? t.segmentSyncInfo.start : 0;
			}
			return super.calculateBaseTime_(e, t, n);
		}
	}, fY = 86400, pY = [
		{
			name: "VOD",
			run: (e, t, n, r, i) => n === Infinity ? null : {
				time: 0,
				segmentIndex: 0,
				partIndex: null
			}
		},
		{
			name: "MediaSequence",
			run: (e, t, n, r, i, a) => {
				let o = e.getMediaSequenceSync(a);
				if (!o || !o.isReliable) return null;
				let s = o.getSyncInfoForTime(i);
				return s ? {
					time: s.start,
					partIndex: s.partIndex,
					segmentIndex: s.segmentIndex
				} : null;
			}
		},
		{
			name: "ProgramDateTime",
			run: (e, t, n, r, i) => {
				if (!Object.keys(e.timelineToDatetimeMappings).length) return null;
				let a = null, o = null, s = OG(t);
				i ||= 0;
				for (let n = 0; n < s.length; n++) {
					let r = s[t.endList || i === 0 ? n : s.length - (n + 1)], c = r.segment, l = e.timelineToDatetimeMappings[c.timeline];
					if (!l || !c.dateTimeObject) continue;
					let u = c.dateTimeObject.getTime() / 1e3 + l;
					if (c.parts && typeof r.partIndex == "number") for (let e = 0; e < r.partIndex; e++) u += c.parts[e].duration;
					let d = Math.abs(i - u);
					if (o !== null && (d === 0 || o < d)) break;
					o = d, a = {
						time: u,
						segmentIndex: r.segmentIndex,
						partIndex: r.partIndex
					};
				}
				return a;
			}
		},
		{
			name: "Segment",
			run: (e, t, n, r, i) => {
				let a = null, o = null;
				i ||= 0;
				let s = OG(t);
				for (let e = 0; e < s.length; e++) {
					let n = s[t.endList || i === 0 ? e : s.length - (e + 1)], c = n.segment, l = n.part && n.part.start || c && c.start;
					if (c.timeline === r && l !== void 0) {
						let e = Math.abs(i - l);
						if (o !== null && o < e) break;
						(!a || o === null || o >= e) && (o = e, a = {
							time: l,
							segmentIndex: n.segmentIndex,
							partIndex: n.partIndex
						});
					}
				}
				return a;
			}
		},
		{
			name: "Discontinuity",
			run: (e, t, n, r, i) => {
				let a = null;
				if (i ||= 0, t.discontinuityStarts && t.discontinuityStarts.length) {
					let n = null;
					for (let r = 0; r < t.discontinuityStarts.length; r++) {
						let o = t.discontinuityStarts[r], s = t.discontinuitySequence + r + 1, c = e.discontinuities[s];
						if (c) {
							let e = Math.abs(i - c.time);
							if (n !== null && n < e) break;
							(!a || n === null || n >= e) && (n = e, a = {
								time: c.time,
								segmentIndex: o,
								partIndex: null
							});
						}
					}
				}
				return a;
			}
		},
		{
			name: "Playlist",
			run: (e, t, n, r, i) => t.syncInfo ? {
				time: t.syncInfo.time,
				segmentIndex: t.syncInfo.mediaSequence - t.mediaSequence,
				partIndex: null
			} : null
		}
	], mY = class extends Y.EventTarget {
		constructor(e = {}) {
			super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
			let t = new uY(), n = new dY(t), r = new dY(t);
			this.mediaSequenceStorage_ = {
				main: t,
				audio: n,
				vtt: r
			}, this.logger_ = pG("SyncController");
		}
		getMediaSequenceSync(e) {
			return this.mediaSequenceStorage_[e] || null;
		}
		getSyncPoint(e, t, n, r, i) {
			if (t !== Infinity) return pY.find(({ name: e }) => e === "VOD").run(this, e, t);
			let a = this.runStrategies_(e, t, n, r, i);
			if (!a.length) return null;
			for (let t of a) {
				let { syncPoint: n, strategy: i } = t, { segmentIndex: a, time: o } = n;
				if (a < 0) continue;
				let s = e.segments[a], c = o, l = c + s.duration;
				if (this.logger_(`Strategy: ${i}. Current time: ${r}. selected segment: ${a}. Time: [${c} -> ${l}]}`), r >= c && r < l) return this.logger_("Found sync point with exact match: ", n), n;
			}
			return this.selectSyncPoint_(a, {
				key: "time",
				value: r
			});
		}
		getExpiredTime(e, t) {
			if (!e || !e.segments) return null;
			let n = this.runStrategies_(e, t, e.discontinuitySequence, 0);
			if (!n.length) return null;
			let r = this.selectSyncPoint_(n, {
				key: "segmentIndex",
				value: 0
			});
			return r.segmentIndex > 0 && (r.time *= -1), Math.abs(r.time + IG({
				defaultDuration: e.targetDuration,
				durationList: e.segments,
				startIndex: r.segmentIndex,
				endIndex: 0
			}));
		}
		runStrategies_(e, t, n, r, i) {
			let a = [];
			for (let o = 0; o < pY.length; o++) {
				let s = pY[o], c = s.run(this, e, t, n, r, i);
				c && (c.strategy = s.name, a.push({
					strategy: s.name,
					syncPoint: c
				}));
			}
			return a;
		}
		selectSyncPoint_(e, t) {
			let n = e[0].syncPoint, r = Math.abs(e[0].syncPoint[t.key] - t.value), i = e[0].strategy;
			for (let a = 1; a < e.length; a++) {
				let o = Math.abs(e[a].syncPoint[t.key] - t.value);
				o < r && (r = o, n = e[a].syncPoint, i = e[a].strategy);
			}
			return this.logger_(`syncPoint for [${t.key}: ${t.value}] chosen with strategy [${i}]: [time:${n.time}, segmentIndex:${n.segmentIndex}` + (typeof n.partIndex == "number" ? `,partIndex:${n.partIndex}` : "") + "]"), n;
		}
		saveExpiredSegmentInfo(e, t) {
			let n = t.mediaSequence - e.mediaSequence;
			if (n > fY) {
				Y.log.warn(`Not saving expired segment info. Media sequence gap ${n} is too large.`);
				return;
			}
			for (let r = n - 1; r >= 0; r--) {
				let n = e.segments[r];
				if (n && n.start !== void 0) {
					t.syncInfo = {
						mediaSequence: e.mediaSequence + r,
						time: n.start
					}, this.logger_(`playlist refresh sync: [time:${t.syncInfo.time}, mediaSequence: ${t.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
					break;
				}
			}
		}
		setDateTimeMappingForStart(e) {
			if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
				let t = e.segments[0], n = t.dateTimeObject.getTime() / 1e3;
				this.timelineToDatetimeMappings[t.timeline] = -n;
			}
		}
		saveSegmentTimingInfo({ segmentInfo: e, shouldSaveTimelineMapping: t }) {
			let n = this.calculateSegmentTimeMapping_(e, e.timingInfo, t), r = e.segment;
			n && (this.saveDiscontinuitySyncInfo_(e), e.playlist.syncInfo || (e.playlist.syncInfo = {
				mediaSequence: e.playlist.mediaSequence + e.mediaIndex,
				time: r.start
			}));
			let i = r.dateTimeObject;
			r.discontinuity && t && i && (this.timelineToDatetimeMappings[r.timeline] = -(i.getTime() / 1e3));
		}
		timestampOffsetForTimeline(e) {
			return this.timelines[e] === void 0 ? null : this.timelines[e].time;
		}
		mappingForTimeline(e) {
			return this.timelines[e] === void 0 ? null : this.timelines[e].mapping;
		}
		calculateSegmentTimeMapping_(e, t, n) {
			let r = e.segment, i = e.part, a = this.timelines[e.timeline], o, s;
			if (typeof e.timestampOffset == "number") a = {
				time: e.startOfSegment,
				mapping: e.startOfSegment - t.start
			}, n && (this.timelines[e.timeline] = a, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${e.timeline}: [time: ${a.time}] [mapping: ${a.mapping}]`)), o = e.startOfSegment, s = t.end + a.mapping;
			else if (a) o = t.start + a.mapping, s = t.end + a.mapping;
			else return !1;
			return i && (i.start = o, i.end = s), (!r.start || o < r.start) && (r.start = o), r.end = s, !0;
		}
		saveDiscontinuitySyncInfo_(e) {
			let t = e.playlist, n = e.segment;
			if (n.discontinuity) this.discontinuities[n.timeline] = {
				time: n.start,
				accuracy: 0
			};
			else if (t.discontinuityStarts && t.discontinuityStarts.length) for (let r = 0; r < t.discontinuityStarts.length; r++) {
				let i = t.discontinuityStarts[r], a = t.discontinuitySequence + r + 1, o = i - e.mediaIndex, s = Math.abs(o);
				if (!this.discontinuities[a] || this.discontinuities[a].accuracy > s) {
					let r;
					r = o < 0 ? n.start - IG({
						defaultDuration: t.targetDuration,
						durationList: t.segments,
						startIndex: e.mediaIndex,
						endIndex: i
					}) : n.end + IG({
						defaultDuration: t.targetDuration,
						durationList: t.segments,
						startIndex: e.mediaIndex + 1,
						endIndex: i
					}), this.discontinuities[a] = {
						time: r,
						accuracy: s
					};
				}
			}
		}
		dispose() {
			this.trigger("dispose"), this.off();
		}
	}, hY = class extends Y.EventTarget {
		constructor() {
			super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
		}
		clearPendingTimelineChange(e) {
			this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange");
		}
		pendingTimelineChange({ type: e, from: t, to: n }) {
			return typeof t == "number" && typeof n == "number" && (this.pendingTimelineChanges_[e] = {
				type: e,
				from: t,
				to: n
			}, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[e];
		}
		lastTimelineChange({ type: e, from: t, to: n }) {
			if (typeof t == "number" && typeof n == "number") {
				this.lastTimelineChanges_[e] = {
					type: e,
					from: t,
					to: n
				}, delete this.pendingTimelineChanges_[e];
				let r = { timelineChangeInfo: {
					from: t,
					to: n
				} };
				this.trigger({
					type: "timelinechange",
					metadata: r
				});
			}
			return this.lastTimelineChanges_[e];
		}
		dispose() {
			this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
		}
	}, gY = gq(_q(vq(function() {
		var e = /*#__PURE__*/ function() {
			function e() {
				this.listeners = {};
			}
			var t = e.prototype;
			return t.on = function(e, t) {
				this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
			}, t.off = function(e, t) {
				if (!this.listeners[e]) return !1;
				var n = this.listeners[e].indexOf(t);
				return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(n, 1), n > -1;
			}, t.trigger = function(e) {
				var t = this.listeners[e];
				if (t) if (arguments.length === 2) for (var n = t.length, r = 0; r < n; ++r) t[r].call(this, arguments[1]);
				else for (var i = Array.prototype.slice.call(arguments, 1), a = t.length, o = 0; o < a; ++o) t[o].apply(this, i);
			}, t.dispose = function() {
				this.listeners = {};
			}, t.pipe = function(e) {
				this.on("data", function(t) {
					e.push(t);
				});
			}, e;
		}();
		function t(e) {
			return e.subarray(0, e.byteLength - e[e.byteLength - 1]);
		}
		let n = function() {
			let e = [[
				[],
				[],
				[],
				[],
				[]
			], [
				[],
				[],
				[],
				[],
				[]
			]], t = e[0], n = e[1], r = t[4], i = n[4], a, o, s, c = [], l = [], u, d, f, p, m, h;
			for (a = 0; a < 256; a++) l[(c[a] = a << 1 ^ (a >> 7) * 283) ^ a] = a;
			for (o = s = 0; !r[o]; o ^= u || 1, s = l[s] || 1) for (p = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4, p = p >> 8 ^ p & 255 ^ 99, r[o] = p, i[p] = o, f = c[d = c[u = c[o]]], h = f * 16843009 ^ d * 65537 ^ u * 257 ^ o * 16843008, m = c[p] * 257 ^ p * 16843008, a = 0; a < 4; a++) t[a][o] = m = m << 24 ^ m >>> 8, n[a][p] = h = h << 24 ^ h >>> 8;
			for (a = 0; a < 5; a++) t[a] = t[a].slice(0), n[a] = n[a].slice(0);
			return e;
		}, r = null;
		class i {
			constructor(e) {
				r ||= n(), this._tables = [[
					r[0][0].slice(),
					r[0][1].slice(),
					r[0][2].slice(),
					r[0][3].slice(),
					r[0][4].slice()
				], [
					r[1][0].slice(),
					r[1][1].slice(),
					r[1][2].slice(),
					r[1][3].slice(),
					r[1][4].slice()
				]];
				let t, i, a, o = this._tables[0][4], s = this._tables[1], c = e.length, l = 1;
				if (c !== 4 && c !== 6 && c !== 8) throw Error("Invalid aes key size");
				let u = e.slice(0), d = [];
				for (this._key = [u, d], t = c; t < 4 * c + 28; t++) a = u[t - 1], (t % c === 0 || c === 8 && t % c === 4) && (a = o[a >>> 24] << 24 ^ o[a >> 16 & 255] << 16 ^ o[a >> 8 & 255] << 8 ^ o[a & 255], t % c === 0 && (a = a << 8 ^ a >>> 24 ^ l << 24, l = l << 1 ^ (l >> 7) * 283)), u[t] = u[t - c] ^ a;
				for (i = 0; t; i++, t--) a = u[i & 3 ? t : t - 4], t <= 4 || i < 4 ? d[i] = a : d[i] = s[0][o[a >>> 24]] ^ s[1][o[a >> 16 & 255]] ^ s[2][o[a >> 8 & 255]] ^ s[3][o[a & 255]];
			}
			decrypt(e, t, n, r, i, a) {
				let o = this._key[1], s = e ^ o[0], c = r ^ o[1], l = n ^ o[2], u = t ^ o[3], d, f, p, m = o.length / 4 - 2, h, g = 4, _ = this._tables[1], v = _[0], y = _[1], b = _[2], x = _[3], S = _[4];
				for (h = 0; h < m; h++) d = v[s >>> 24] ^ y[c >> 16 & 255] ^ b[l >> 8 & 255] ^ x[u & 255] ^ o[g], f = v[c >>> 24] ^ y[l >> 16 & 255] ^ b[u >> 8 & 255] ^ x[s & 255] ^ o[g + 1], p = v[l >>> 24] ^ y[u >> 16 & 255] ^ b[s >> 8 & 255] ^ x[c & 255] ^ o[g + 2], u = v[u >>> 24] ^ y[s >> 16 & 255] ^ b[c >> 8 & 255] ^ x[l & 255] ^ o[g + 3], g += 4, s = d, c = f, l = p;
				for (h = 0; h < 4; h++) i[(3 & -h) + a] = S[s >>> 24] << 24 ^ S[c >> 16 & 255] << 16 ^ S[l >> 8 & 255] << 8 ^ S[u & 255] ^ o[g++], d = s, s = c, c = l, l = u, u = d;
			}
		}
		class a extends e {
			constructor() {
				super(e), this.jobs = [], this.delay = 1, this.timeout_ = null;
			}
			processJob_() {
				this.jobs.shift()(), this.timeout_ = this.jobs.length ? setTimeout(this.processJob_.bind(this), this.delay) : null;
			}
			push(e) {
				this.jobs.push(e), this.timeout_ ||= setTimeout(this.processJob_.bind(this), this.delay);
			}
		}
		let o = function(e) {
			return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
		}, s = function(e, t, n) {
			let r = new Int32Array(e.buffer, e.byteOffset, e.byteLength >> 2), a = new i(Array.prototype.slice.call(t)), s = new Uint8Array(e.byteLength), c = new Int32Array(s.buffer), l, u, d, f, p, m, h, g, _;
			for (l = n[0], u = n[1], d = n[2], f = n[3], _ = 0; _ < r.length; _ += 4) p = o(r[_]), m = o(r[_ + 1]), h = o(r[_ + 2]), g = o(r[_ + 3]), a.decrypt(p, m, h, g, c, _), c[_] = o(c[_] ^ l), c[_ + 1] = o(c[_ + 1] ^ u), c[_ + 2] = o(c[_ + 2] ^ d), c[_ + 3] = o(c[_ + 3] ^ f), l = p, u = m, d = h, f = g;
			return s;
		};
		class c {
			constructor(e, n, r, i) {
				let s = c.STEP, l = new Int32Array(e.buffer), u = new Uint8Array(e.byteLength), d = 0;
				for (this.asyncStream_ = new a(), this.asyncStream_.push(this.decryptChunk_(l.subarray(d, d + s), n, r, u)), d = s; d < l.length; d += s) r = new Uint32Array([
					o(l[d - 4]),
					o(l[d - 3]),
					o(l[d - 2]),
					o(l[d - 1])
				]), this.asyncStream_.push(this.decryptChunk_(l.subarray(d, d + s), n, r, u));
				this.asyncStream_.push(function() {
					i(null, t(u));
				});
			}
			static get STEP() {
				return 32e3;
			}
			decryptChunk_(e, t, n, r) {
				return function() {
					let i = s(e, t, n);
					r.set(i, e.byteOffset);
				};
			}
		}
		var l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, u = typeof window < "u" ? window : l === void 0 ? typeof self < "u" ? self : {} : l, d = function(e) {
			return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
		}, f = u.BigInt || Number;
		f("0x1"), f("0x100"), f("0x10000"), f("0x1000000"), f("0x100000000"), f("0x10000000000"), f("0x1000000000000"), f("0x100000000000000"), f("0x10000000000000000"), (function() {
			var e = new Uint16Array([65484]), t = new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
			return t[0] === 255 ? "big" : t[0] === 204 ? "little" : "unknown";
		})();
		let p = function(e) {
			let t = {};
			return Object.keys(e).forEach((n) => {
				let r = e[n];
				d(r) ? t[n] = {
					bytes: r.buffer,
					byteOffset: r.byteOffset,
					byteLength: r.byteLength
				} : t[n] = r;
			}), t;
		};
		self.onmessage = function(e) {
			let t = e.data, n = new Uint8Array(t.encrypted.bytes, t.encrypted.byteOffset, t.encrypted.byteLength), r = new Uint32Array(t.key.bytes, t.key.byteOffset, t.key.byteLength / 4), i = new Uint32Array(t.iv.bytes, t.iv.byteOffset, t.iv.byteLength / 4);
			new c(n, r, i, function(e, n) {
				self.postMessage(p({
					source: t.source,
					decrypted: n
				}), [n.buffer]);
			});
		};
	}))), _Y = (e) => {
		let t = e.default ? "main" : "alternative";
		return e.characteristics && e.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (t = "main-desc"), t;
	}, vY = (e, t) => {
		e.abort(), e.pause(), t && t.activePlaylistLoader && (t.activePlaylistLoader.pause(), t.activePlaylistLoader = null);
	}, yY = (e, t) => {
		t.activePlaylistLoader = e, e.load();
	}, bY = (e, t) => () => {
		let { segmentLoaders: { [e]: n, main: r }, mediaTypes: { [e]: i } } = t, a = i.activeTrack(), o = i.getActiveGroup(), s = i.activePlaylistLoader, c = i.lastGroup_;
		if (!(o && c && o.id === c.id) && (i.lastGroup_ = o, i.lastTrack_ = a, vY(n, i), !(!o || o.isMainPlaylist))) {
			if (!o.playlistLoader) {
				s && r.resetEverything();
				return;
			}
			n.resyncLoader(), yY(o.playlistLoader, i);
		}
	}, xY = (e, t) => () => {
		let { segmentLoaders: { [e]: n }, mediaTypes: { [e]: r } } = t;
		r.lastGroup_ = null, n.abort(), n.pause();
	}, SY = (e, t) => () => {
		let { mainPlaylistLoader: n, segmentLoaders: { [e]: r, main: i }, mediaTypes: { [e]: a } } = t, o = a.activeTrack(), s = a.getActiveGroup(), c = a.activePlaylistLoader, l = a.lastTrack_;
		if (!(l && o && l.id === o.id) && (a.lastGroup_ = s, a.lastTrack_ = o, vY(r, a), s)) {
			if (s.isMainPlaylist) {
				if (!o || !l || o.id === l.id) return;
				let e = t.vhs.playlistController_, r = e.selectPlaylist();
				if (e.media() === r) return;
				a.logger_(`track change. Switching main audio from ${l.id} to ${o.id}`), n.pause(), i.resetEverything(), e.fastQualityChange_(r);
				return;
			}
			if (e === "AUDIO") {
				if (!s.playlistLoader) {
					i.setAudio(!0), i.resetEverything();
					return;
				}
				r.setAudio(!0), i.setAudio(!1);
			}
			if (c === s.playlistLoader) {
				yY(s.playlistLoader, a);
				return;
			}
			r.track && r.track(o), r.resetEverything(), yY(s.playlistLoader, a);
		}
	}, CY = {
		AUDIO: (e, t) => () => {
			let { mediaTypes: { [e]: n }, excludePlaylist: r } = t, i = n.activeTrack(), a = n.activeGroup(), o = (a.filter((e) => e.default)[0] || a[0]).id, s = n.tracks[o];
			if (i === s) {
				r({ error: { message: "Problem encountered loading the default audio track." } });
				return;
			}
			Y.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
			for (let e in n.tracks) n.tracks[e].enabled = n.tracks[e] === s;
			n.onTrackChanged();
		},
		SUBTITLES: (e, t) => () => {
			let { mediaTypes: { [e]: n } } = t;
			Y.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
			let r = n.activeTrack();
			r && (r.mode = "disabled"), n.onTrackChanged();
		}
	}, wY = {
		AUDIO: (e, t, n) => {
			if (!t) return;
			let { tech: r, requestOptions: i, segmentLoaders: { [e]: a } } = n;
			t.on("loadedmetadata", () => {
				let e = t.media();
				a.playlist(e, i), (!r.paused() || e.endList && r.preload() !== "none") && a.load();
			}), t.on("loadedplaylist", () => {
				a.playlist(t.media(), i), r.paused() || a.load();
			}), t.on("error", CY[e](e, n));
		},
		SUBTITLES: (e, t, n) => {
			let { tech: r, requestOptions: i, segmentLoaders: { [e]: a }, mediaTypes: { [e]: o } } = n;
			t.on("loadedmetadata", () => {
				let e = t.media();
				a.playlist(e, i), a.track(o.activeTrack()), (!r.paused() || e.endList && r.preload() !== "none") && a.load();
			}), t.on("loadedplaylist", () => {
				a.playlist(t.media(), i), r.paused() || a.load();
			}), t.on("error", CY[e](e, n));
		}
	}, TY = {
		AUDIO: (e, t) => {
			let { vhs: n, sourceType: r, segmentLoaders: { [e]: i }, requestOptions: a, main: { mediaGroups: o }, mediaTypes: { [e]: { groups: s, tracks: c, logger_: l } }, mainPlaylistLoader: u } = t, d = XG(u.main);
			(!o[e] || Object.keys(o[e]).length === 0) && (o[e] = { main: { default: { default: !0 } } }, d && (o[e].main.default.playlists = u.main.playlists));
			for (let i in o[e]) {
				s[i] || (s[i] = []);
				for (let f in o[e][i]) {
					let p = o[e][i][f], m;
					d ? (l(`AUDIO group '${i}' label '${f}' is a main playlist`), p.isMainPlaylist = !0, m = null) : m = r === "vhs-json" && p.playlists ? new OK(p.playlists[0], n, a) : p.resolvedUri ? new OK(p.resolvedUri, n, a) : p.playlists && r === "dash" ? new dq(p.playlists[0], n, a, u) : null, p = SB({
						id: f,
						playlistLoader: m
					}, p), wY[e](e, p.playlistLoader, t), s[i].push(p), c[f] === void 0 && (c[f] = new Y.AudioTrack({
						id: f,
						kind: _Y(p),
						enabled: !1,
						language: p.language,
						default: p.default,
						label: f
					}));
				}
			}
			i.on("error", CY[e](e, t));
		},
		SUBTITLES: (e, t) => {
			let { tech: n, vhs: r, sourceType: i, segmentLoaders: { [e]: a }, requestOptions: o, main: { mediaGroups: s }, mediaTypes: { [e]: { groups: c, tracks: l } }, mainPlaylistLoader: u } = t;
			for (let a in s[e]) {
				c[a] || (c[a] = []);
				for (let d in s[e][a]) {
					if (!r.options_.useForcedSubtitles && s[e][a][d].forced) continue;
					let f = s[e][a][d], p;
					if (i === "hls") p = new OK(f.resolvedUri, r, o);
					else if (i === "dash") {
						if (!f.playlists.filter((e) => e.excludeUntil !== Infinity).length) return;
						p = new dq(f.playlists[0], r, o, u);
					} else i === "vhs-json" && (p = new OK(f.playlists ? f.playlists[0] : f.resolvedUri, r, o));
					f = SB({
						id: d,
						playlistLoader: p
					}, f), wY[e](e, f.playlistLoader, t), c[a].push(f), l[d] === void 0 && (l[d] = n.addRemoteTextTrack({
						id: d,
						kind: "subtitles",
						default: f.default && f.autoselect,
						language: f.language,
						label: d
					}, !1).track);
				}
			}
			a.on("error", CY[e](e, t));
		},
		"CLOSED-CAPTIONS": (e, t) => {
			let { tech: n, main: { mediaGroups: r }, mediaTypes: { [e]: { groups: i, tracks: a } } } = t;
			for (let t in r[e]) {
				i[t] || (i[t] = []);
				for (let o in r[e][t]) {
					let s = r[e][t][o];
					if (!/^(?:CC|SERVICE)/.test(s.instreamId)) continue;
					let c = n.options_.vhs && n.options_.vhs.captionServices || {}, l = {
						label: o,
						language: s.language,
						instreamId: s.instreamId,
						default: s.default && s.autoselect
					};
					c[l.instreamId] && (l = SB(l, c[l.instreamId])), l.default === void 0 && delete l.default, i[t].push(SB({ id: o }, s)), a[o] === void 0 && (a[o] = n.addRemoteTextTrack({
						id: l.instreamId,
						kind: "captions",
						default: l.default,
						language: l.language,
						label: l.label
					}, !1).track);
				}
			}
		}
	}, EY = (e, t) => {
		for (let n = 0; n < e.length; n++) if (JG(t, e[n]) || e[n].playlists && EY(e[n].playlists, t)) return !0;
		return !1;
	}, DY = (e, t) => (n) => {
		let { mainPlaylistLoader: r, mediaTypes: { [e]: { groups: i } } } = t, a = r.media();
		if (!a) return null;
		let o = null;
		a.attributes[e] && (o = i[a.attributes[e]]);
		let s = Object.keys(i);
		if (!o) if (e === "AUDIO" && s.length > 1 && XG(t.main)) for (let e = 0; e < s.length; e++) {
			let t = i[s[e]];
			if (EY(t, a)) {
				o = t;
				break;
			}
		}
		else i.main ? o = i.main : s.length === 1 && (o = i[s[0]]);
		return n === void 0 ? o : n === null || !o ? null : o.filter((e) => e.id === n.id)[0] || null;
	}, OY = {
		AUDIO: (e, t) => () => {
			let { mediaTypes: { [e]: { tracks: n } } } = t;
			for (let e in n) if (n[e].enabled) return n[e];
			return null;
		},
		SUBTITLES: (e, t) => () => {
			let { mediaTypes: { [e]: { tracks: n } } } = t;
			for (let e in n) if (n[e].mode === "showing" || n[e].mode === "hidden") return n[e];
			return null;
		}
	}, kY = (e, { mediaTypes: t }) => () => {
		let n = t[e].activeTrack();
		return n ? t[e].activeGroup(n) : null;
	}, AY = (e) => {
		[
			"AUDIO",
			"SUBTITLES",
			"CLOSED-CAPTIONS"
		].forEach((t) => {
			TY[t](t, e);
		});
		let { mediaTypes: t, mainPlaylistLoader: n, tech: r, vhs: i, segmentLoaders: { AUDIO: a, main: o } } = e;
		["AUDIO", "SUBTITLES"].forEach((n) => {
			t[n].activeGroup = DY(n, e), t[n].activeTrack = OY[n](n, e), t[n].onGroupChanged = bY(n, e), t[n].onGroupChanging = xY(n, e), t[n].onTrackChanged = SY(n, e), t[n].getActiveGroup = kY(n, e);
		});
		let s = t.AUDIO.activeGroup();
		if (s) {
			let e = (s.filter((e) => e.default)[0] || s[0]).id;
			t.AUDIO.tracks[e].enabled = !0, t.AUDIO.onGroupChanged(), t.AUDIO.onTrackChanged(), t.AUDIO.getActiveGroup().playlistLoader ? (o.setAudio(!1), a.setAudio(!0)) : o.setAudio(!0);
		}
		n.on("mediachange", () => {
			["AUDIO", "SUBTITLES"].forEach((e) => t[e].onGroupChanged());
		}), n.on("mediachanging", () => {
			["AUDIO", "SUBTITLES"].forEach((e) => t[e].onGroupChanging());
		});
		let c = () => {
			t.AUDIO.onTrackChanged(), r.trigger({
				type: "usage",
				name: "vhs-audio-change"
			});
		};
		r.audioTracks().addEventListener("change", c), r.remoteTextTracks().addEventListener("change", t.SUBTITLES.onTrackChanged), i.on("dispose", () => {
			r.audioTracks().removeEventListener("change", c), r.remoteTextTracks().removeEventListener("change", t.SUBTITLES.onTrackChanged);
		}), r.clearTracks("audio");
		for (let e in t.AUDIO.tracks) r.audioTracks().addTrack(t.AUDIO.tracks[e]);
	}, jY = () => {
		let e = {};
		return [
			"AUDIO",
			"SUBTITLES",
			"CLOSED-CAPTIONS"
		].forEach((t) => {
			e[t] = {
				groups: {},
				tracks: {},
				activePlaylistLoader: null,
				activeGroup: EB,
				activeTrack: EB,
				getActiveGroup: EB,
				onGroupChanged: EB,
				onTrackChanged: EB,
				lastTrack_: null,
				logger_: pG(`MediaGroups[${t}]`)
			};
		}), e;
	}, MY = class {
		constructor() {
			this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
		}
		set version(e) {
			e === 1 && (this.version_ = e);
		}
		set ttl(e) {
			this.ttl_ = e || 300;
		}
		set reloadUri(e) {
			e && (this.reloadUri_ = dG(this.reloadUri_, e));
		}
		set priority(e) {
			e && e.length && (this.priority_ = e);
		}
		set pathwayClones(e) {
			e && e.length && (this.pathwayClones_ = new Map(e.map((e) => [e.ID, e])));
		}
		get version() {
			return this.version_;
		}
		get ttl() {
			return this.ttl_;
		}
		get reloadUri() {
			return this.reloadUri_;
		}
		get priority() {
			return this.priority_;
		}
		get pathwayClones() {
			return this.pathwayClones_;
		}
	}, NY = class extends Y.EventTarget {
		constructor(e, t) {
			super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new MY(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = pG("Content Steering"), this.xhr_ = e, this.getBandwidth_ = t;
		}
		assignTagProperties(e, t) {
			this.manifestType_ = t.serverUri ? "HLS" : "DASH";
			let n = t.serverUri || t.serverURL;
			if (!n) {
				this.logger_(`steering manifest URL is ${n}, cannot request steering manifest.`), this.trigger("error");
				return;
			}
			if (n.startsWith("data:")) {
				this.decodeDataUriManifest_(n.substring(n.indexOf(",") + 1));
				return;
			}
			this.steeringManifest.reloadUri = dG(e, n), this.defaultPathway = t.pathwayId || t.defaultServiceLocation, this.queryBeforeStart = t.queryBeforeStart, this.proxyServerUrl_ = t.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
		}
		requestSteeringManifest(e) {
			let t = this.steeringManifest.reloadUri;
			if (!t) return;
			let n = e ? t : this.getRequestURI(t);
			if (!n) {
				this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
				return;
			}
			let r = { contentSteeringInfo: { uri: n } };
			this.trigger({
				type: "contentsteeringloadstart",
				metadata: r
			}), this.request_ = this.xhr_({
				uri: n,
				requestType: "content-steering-manifest"
			}, (e, t) => {
				if (e) {
					if (t.status === 410) {
						this.logger_(`manifest request 410 ${e}.`), this.logger_(`There will be no more content steering requests to ${n} this session.`), this.excludedSteeringManifestURLs.add(n);
						return;
					}
					if (t.status === 429) {
						let n = t.responseHeaders["retry-after"];
						this.logger_(`manifest request 429 ${e}.`), this.logger_(`content steering will retry in ${n} seconds.`), this.startTTLTimeout_(parseInt(n, 10));
						return;
					}
					this.logger_(`manifest failed to load ${e}.`), this.startTTLTimeout_();
					return;
				}
				this.trigger({
					type: "contentsteeringloadcomplete",
					metadata: r
				});
				let i;
				try {
					i = JSON.parse(this.request_.responseText);
				} catch (e) {
					let t = {
						errorType: Y.Error.StreamingContentSteeringParserError,
						error: e
					};
					this.trigger({
						type: "error",
						metadata: t
					});
				}
				this.assignSteeringProperties_(i);
				let a = {
					contentSteeringInfo: r.contentSteeringInfo,
					contentSteeringManifest: {
						version: this.steeringManifest.version,
						reloadUri: this.steeringManifest.reloadUri,
						priority: this.steeringManifest.priority
					}
				};
				this.trigger({
					type: "contentsteeringparsed",
					metadata: a
				}), this.startTTLTimeout_();
			});
		}
		setProxyServerUrl_(e) {
			let t = new X.default.URL(e), n = new X.default.URL(this.proxyServerUrl_);
			return n.searchParams.set("url", encodeURI(t.toString())), this.setSteeringParams_(n.toString());
		}
		decodeDataUriManifest_(e) {
			let t = JSON.parse(X.default.atob(e));
			this.assignSteeringProperties_(t);
		}
		setSteeringParams_(e) {
			let t = new X.default.URL(e), n = this.getPathway(), r = this.getBandwidth_();
			if (n) {
				let e = `_${this.manifestType_}_pathway`;
				t.searchParams.set(e, n);
			}
			if (r) {
				let e = `_${this.manifestType_}_throughput`;
				t.searchParams.set(e, r);
			}
			return t.toString();
		}
		assignSteeringProperties_(e) {
			if (this.steeringManifest.version = e.VERSION, !this.steeringManifest.version) {
				this.logger_(`manifest version is ${e.VERSION}, which is not supported.`), this.trigger("error");
				return;
			}
			this.steeringManifest.ttl = e.TTL, this.steeringManifest.reloadUri = e["RELOAD-URI"], this.steeringManifest.priority = e["PATHWAY-PRIORITY"] || e["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = e["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
			let t = ((e) => {
				for (let t of e) if (this.availablePathways_.has(t)) return t;
				return [...this.availablePathways_][0];
			})(this.steeringManifest.priority);
			this.currentPathway !== t && (this.currentPathway = t, this.trigger("content-steering"));
		}
		getPathway() {
			return this.currentPathway || this.defaultPathway;
		}
		getRequestURI(e) {
			if (!e) return null;
			let t = (e) => this.excludedSteeringManifestURLs.has(e);
			if (this.proxyServerUrl_) {
				let n = this.setProxyServerUrl_(e);
				if (!t(n)) return n;
			}
			let n = this.setSteeringParams_(e);
			return t(n) ? null : n;
		}
		startTTLTimeout_(e = this.steeringManifest.ttl) {
			let t = e * 1e3;
			this.ttlTimeout_ = X.default.setTimeout(() => {
				this.requestSteeringManifest();
			}, t);
		}
		clearTTLTimeout_() {
			X.default.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
		}
		abort() {
			this.request_ && this.request_.abort(), this.request_ = null;
		}
		dispose() {
			this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new MY();
		}
		addAvailablePathway(e) {
			e && this.availablePathways_.add(e);
		}
		clearAvailablePathways() {
			this.availablePathways_.clear();
		}
		excludePathway(e) {
			return this.availablePathways_.delete(e);
		}
		didDASHTagChange(e, t) {
			return !t && this.steeringManifest.reloadUri || t && (dG(e, t.serverURL) !== this.steeringManifest.reloadUri || t.defaultServiceLocation !== this.defaultPathway || t.queryBeforeStart !== this.queryBeforeStart || t.proxyServerURL !== this.proxyServerUrl_);
		}
		getAvailablePathways() {
			return this.availablePathways_;
		}
	}, PY = (e, t) => {
		let n = null;
		return (...r) => {
			clearTimeout(n), n = setTimeout(() => {
				e.apply(null, r);
			}, t);
		};
	}, FY = 10, LY = [
		"mediaRequests",
		"mediaRequestsAborted",
		"mediaRequestsTimedout",
		"mediaRequestsErrored",
		"mediaTransferDuration",
		"mediaBytesTransferred",
		"mediaAppends"
	], RY = function(e) {
		return this.audioSegmentLoader_[e] + this.mainSegmentLoader_[e];
	}, zY = function({ currentPlaylist: e, buffered: t, currentTime: n, nextPlaylist: r, bufferLowWaterLine: i, bufferHighWaterLine: a, duration: o, bufferBasedABR: s, log: c }) {
		if (!r) return Y.log.warn("We received no playlist to switch to. Please check your stream."), !1;
		let l = `allowing switch ${e && e.id || "null"} -> ${r.id}`;
		if (!e) return c(`${l} as current playlist is not set`), !0;
		if (r.id === e.id) return !1;
		let u = !!_G(t, n).length;
		if (!e.endList) return !u && typeof e.partTargetDuration == "number" ? (c(`not ${l} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (c(`${l} as current playlist is live`), !0);
		let d = EG(t, n), f = s ? fq.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : fq.MAX_BUFFER_LOW_WATER_LINE;
		if (o < f) return c(`${l} as duration < max low water line (${o} < ${f})`), !0;
		let p = r.attributes.BANDWIDTH, m = e.attributes.BANDWIDTH;
		if (p < m && (!s || d < a)) {
			let e = `${l} as next bandwidth < current bandwidth (${p} < ${m})`;
			return s && (e += ` and forwardBuffer < bufferHighWaterLine (${d} < ${a})`), c(e), !0;
		}
		if ((!s || p > m) && d >= i) {
			let e = `${l} as forwardBuffer >= bufferLowWaterLine (${d} >= ${i})`;
			return s && (e += ` and next bandwidth > current bandwidth (${p} > ${m})`), c(e), !0;
		}
		return c(`not ${l} as no switching criteria met`), !1;
	}, BY = class extends Y.EventTarget {
		constructor(e) {
			super(), this.fastQualityChange_ = PY(this.fastQualityChange_.bind(this), 100);
			let { src: t, withCredentials: n, tech: r, bandwidth: i, externVhs: a, useCueTags: o, playlistExclusionDuration: s, enableLowInitialPlaylist: c, sourceType: l, cacheEncryptionKeys: u, bufferBasedABR: d, leastPixelDiffSelector: f, captionServices: p, experimentalUseMMS: m } = e;
			if (!t) throw Error("A non-empty playlist URL or JSON manifest string is required");
			let { maxPlaylistRetries: h } = e;
			h ??= Infinity, IY = a, this.bufferBasedABR = !!d, this.leastPixelDiffSelector = !!f, this.withCredentials = n, this.tech_ = r, this.vhs_ = r.vhs, this.player_ = e.player_, this.sourceType_ = l, this.useCueTags_ = o, this.playlistExclusionDuration = s, this.maxPlaylistRetries = h, this.enableLowInitialPlaylist = c, this.usingManagedMediaSource_ = !1, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
				withCredentials: n,
				maxPlaylistRetries: h,
				timeout: null
			}, this.on("error", this.pauseLoading), this.mediaTypes_ = jY(), m && X.default.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new X.default.ManagedMediaSource(), this.usingManagedMediaSource_ = !0, Y.log("Using ManagedMediaSource")) : X.default.MediaSource && (this.mediaSource = new X.default.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = CB(), this.hasPlayed_ = !1, this.syncController_ = new mY(e), this.segmentMetadataTrack_ = r.addRemoteTextTrack({
				kind: "metadata",
				label: "segment-metadata"
			}, !1).track, this.segmentMetadataTrack_.mode = "hidden", this.decrypter_ = new gY(), this.sourceUpdater_ = new eY(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new hY(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
			let g = {
				vhs: this.vhs_,
				parse708captions: e.parse708captions,
				useDtsForTimestampOffset: e.useDtsForTimestampOffset,
				captionServices: p,
				mediaSource: this.mediaSource,
				currentTime: this.tech_.currentTime.bind(this.tech_),
				seekable: () => this.seekable(),
				seeking: () => this.tech_.seeking(),
				duration: () => this.duration(),
				hasPlayed: () => this.hasPlayed_,
				goalBufferLength: () => this.goalBufferLength(),
				bandwidth: i,
				syncController: this.syncController_,
				decrypter: this.decrypter_,
				sourceType: this.sourceType_,
				inbandTextTracks: this.inbandTextTracks_,
				cacheEncryptionKeys: u,
				sourceUpdater: this.sourceUpdater_,
				timelineChangeController: this.timelineChangeController_,
				exactManifestTimings: e.exactManifestTimings,
				addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
			};
			this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new dq(t, this.vhs_, SB(this.requestOptions_, { addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this) })) : new OK(t, this.vhs_, SB(this.requestOptions_, { addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this) })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new UJ(SB(g, {
				segmentMetadataTrack: this.segmentMetadataTrack_,
				loaderType: "main"
			}), e), this.audioSegmentLoader_ = new UJ(SB(g, { loaderType: "audio" }), e), this.subtitleSegmentLoader_ = new aY(SB(g, {
				loaderType: "vtt",
				featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
				loadVttJs: () => new Promise((e, t) => {
					function n() {
						r.off("vttjserror", i), e();
					}
					function i() {
						r.off("vttjsloaded", n), t();
					}
					r.one("vttjsloaded", n), r.one("vttjserror", i), r.addWebVttScript_();
				})
			}), e);
			let _ = () => this.mainSegmentLoader_.bandwidth;
			this.contentSteeringController_ = new NY(this.vhs_.xhr, _), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), LY.forEach((e) => {
				this[e + "_"] = RY.bind(this, e);
			}), this.logger_ = pG("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
				this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
			}, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
			let v = this.tech_.preload() === "none" ? "play" : "loadstart";
			this.tech_.one(v, () => {
				let e = Date.now();
				this.tech_.one("loadeddata", () => {
					this.timeToLoadedData__ = Date.now() - e, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
				});
			});
		}
		mainAppendsToLoadedData_() {
			return this.mainAppendsToLoadedData__;
		}
		audioAppendsToLoadedData_() {
			return this.audioAppendsToLoadedData__;
		}
		appendsToLoadedData_() {
			let e = this.mainAppendsToLoadedData_(), t = this.audioAppendsToLoadedData_();
			return e === -1 || t === -1 ? -1 : e + t;
		}
		timeToLoadedData_() {
			return this.timeToLoadedData__;
		}
		checkABR_(e = "abr") {
			let t = this.selectPlaylist();
			t && this.shouldSwitchToMedia_(t) && this.switchMedia_(t, e);
		}
		switchMedia_(e, t, n) {
			let r = this.media(), i = r && (r.id || r.uri), a = e && (e.id || e.uri);
			if (i && i !== a) {
				this.logger_(`switch media ${i} -> ${a} from ${t}`);
				let n = {
					renditionInfo: {
						id: a,
						bandwidth: e.attributes.BANDWIDTH,
						resolution: e.attributes.RESOLUTION,
						codecs: e.attributes.CODECS
					},
					cause: t
				};
				this.trigger({
					type: "renditionselected",
					metadata: n
				}), this.tech_.trigger({
					type: "usage",
					name: `vhs-rendition-change-${t}`
				});
			}
			this.mainPlaylistLoader_.media(e, n);
		}
		switchMediaForDASHContentSteering_() {
			[
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((e) => {
				let t = this.mediaTypes_[e], n = t ? t.activeGroup() : null, r = this.contentSteeringController_.getPathway();
				if (n && r) {
					let t = (n.length ? n[0].playlists : n.playlists).filter((e) => e.attributes.serviceLocation === r);
					t.length && this.mediaTypes_[e].activePlaylistLoader.media(t[0]);
				}
			});
		}
		startABRTimer_() {
			this.stopABRTimer_(), this.abrTimer_ = X.default.setInterval(() => this.checkABR_(), 250);
		}
		stopABRTimer_() {
			this.tech_.scrubbing && this.tech_.scrubbing() || (X.default.clearInterval(this.abrTimer_), this.abrTimer_ = null);
		}
		getAudioTrackPlaylists_() {
			let e = this.main(), t = e && e.playlists || [];
			if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO) return t;
			let n = e.mediaGroups.AUDIO, r = Object.keys(n), i;
			if (Object.keys(this.mediaTypes_.AUDIO.groups).length) i = this.mediaTypes_.AUDIO.activeTrack();
			else {
				let e = n.main || r.length && n[r[0]];
				for (let t in e) if (e[t].default) {
					i = { label: t };
					break;
				}
			}
			if (!i) return t;
			let a = [];
			for (let t in n) if (n[t][i.label]) {
				let r = n[t][i.label];
				if (r.playlists && r.playlists.length) a.push.apply(a, r.playlists);
				else if (r.uri) a.push(r);
				else if (e.playlists.length) for (let n = 0; n < e.playlists.length; n++) {
					let r = e.playlists[n];
					r.attributes && r.attributes.AUDIO && r.attributes.AUDIO === t && a.push(r);
				}
			}
			return a.length ? a : t;
		}
		setupMainPlaylistLoaderListeners_() {
			this.mainPlaylistLoader_.on("loadedmetadata", () => {
				let e = this.mainPlaylistLoader_.media(), t = e.targetDuration * 1.5 * 1e3;
				qG(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = t, e.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.mainSegmentLoader_.load()), AY({
					sourceType: this.sourceType_,
					segmentLoaders: {
						AUDIO: this.audioSegmentLoader_,
						SUBTITLES: this.subtitleSegmentLoader_,
						main: this.mainSegmentLoader_
					},
					tech: this.tech_,
					requestOptions: this.requestOptions_,
					mainPlaylistLoader: this.mainPlaylistLoader_,
					vhs: this.vhs_,
					main: this.main(),
					mediaTypes: this.mediaTypes_,
					excludePlaylist: this.excludePlaylist.bind(this)
				}), this.triggerPresenceUsage_(this.main(), e), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
					this.trigger("selectedinitialmedia");
				});
			}), this.mainPlaylistLoader_.on("loadedplaylist", () => {
				this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
				let e = this.mainPlaylistLoader_.media();
				if (!e) {
					this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
					let t;
					if (this.enableLowInitialPlaylist && (t = this.selectInitialPlaylist()), t ||= this.selectPlaylist(), !t || !this.shouldSwitchToMedia_(t) || (this.initialMedia_ = t, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments))) return;
					e = this.initialMedia_;
				}
				this.handleUpdatedMediaPlaylist(e);
			}), this.mainPlaylistLoader_.on("error", () => {
				let e = this.mainPlaylistLoader_.error;
				this.excludePlaylist({
					playlistToExclude: e.playlist,
					error: e
				});
			}), this.mainPlaylistLoader_.on("mediachanging", () => {
				this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
			}), this.mainPlaylistLoader_.on("mediachange", () => {
				let e = this.mainPlaylistLoader_.media(), t = e.targetDuration * 1.5 * 1e3;
				qG(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = t, this.sourceType_ === "dash" && this.mainPlaylistLoader_.isPaused && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
					type: "mediachange",
					bubbles: !0
				});
			}), this.mainPlaylistLoader_.on("playlistunchanged", () => {
				let e = this.mainPlaylistLoader_.media();
				e.lastExcludeReason_ !== "playlist-unchanged" && this.stuckAtPlaylistEnd_(e) && (this.excludePlaylist({ error: {
					message: "Playlist no longer updating.",
					reason: "playlist-unchanged"
				} }), this.tech_.trigger("playliststuck"));
			}), this.mainPlaylistLoader_.on("renditiondisabled", () => {
				this.tech_.trigger({
					type: "usage",
					name: "vhs-rendition-disabled"
				});
			}), this.mainPlaylistLoader_.on("renditionenabled", () => {
				this.tech_.trigger({
					type: "usage",
					name: "vhs-rendition-enabled"
				});
			}), [
				"manifestrequeststart",
				"manifestrequestcomplete",
				"manifestparsestart",
				"manifestparsecomplete",
				"playlistrequeststart",
				"playlistrequestcomplete",
				"playlistparsestart",
				"playlistparsecomplete",
				"renditiondisabled",
				"renditionenabled"
			].forEach((e) => {
				this.mainPlaylistLoader_.on(e, (e) => {
					this.player_.trigger(wF({}, e));
				});
			});
		}
		handleUpdatedMediaPlaylist(e) {
			this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
		}
		triggerPresenceUsage_(e, t) {
			let n = e.mediaGroups || {}, r = !0, i = Object.keys(n.AUDIO);
			for (let e in n.AUDIO) for (let t in n.AUDIO[e]) n.AUDIO[e][t].uri || (r = !1);
			r && this.tech_.trigger({
				type: "usage",
				name: "vhs-demuxed"
			}), Object.keys(n.SUBTITLES).length && this.tech_.trigger({
				type: "usage",
				name: "vhs-webvtt"
			}), IY.Playlist.isAes(t) && this.tech_.trigger({
				type: "usage",
				name: "vhs-aes"
			}), i.length && Object.keys(n.AUDIO[i[0]]).length > 1 && this.tech_.trigger({
				type: "usage",
				name: "vhs-alternate-audio"
			}), this.useCueTags_ && this.tech_.trigger({
				type: "usage",
				name: "vhs-playlist-cue-tags"
			});
		}
		shouldSwitchToMedia_(e) {
			let t = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, n = this.tech_.currentTime(), r = this.bufferLowWaterLine(), i = this.bufferHighWaterLine(), a = this.tech_.buffered();
			return zY({
				buffered: a,
				currentTime: n,
				currentPlaylist: t,
				nextPlaylist: e,
				bufferLowWaterLine: r,
				bufferHighWaterLine: i,
				duration: this.duration(),
				bufferBasedABR: this.bufferBasedABR,
				log: this.logger_
			});
		}
		setupSegmentLoaderListeners_() {
			this.mainSegmentLoader_.on("bandwidthupdate", () => {
				this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
			}), this.mainSegmentLoader_.on("timeout", () => {
				this.bufferBasedABR && this.mainSegmentLoader_.load();
			}), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
				this.trigger("progress");
			}), this.mainSegmentLoader_.on("error", () => {
				let e = this.mainSegmentLoader_.error();
				this.excludePlaylist({
					playlistToExclude: e.playlist,
					error: e
				});
			}), this.mainSegmentLoader_.on("appenderror", () => {
				this.error = this.mainSegmentLoader_.error_, this.trigger("error");
			}), this.mainSegmentLoader_.on("syncinfoupdate", () => {
				this.onSyncInfoUpdate_();
			}), this.mainSegmentLoader_.on("timestampoffset", () => {
				this.tech_.trigger({
					type: "usage",
					name: "vhs-timestamp-offset"
				});
			}), this.audioSegmentLoader_.on("syncinfoupdate", () => {
				this.onSyncInfoUpdate_();
			}), this.audioSegmentLoader_.on("appenderror", () => {
				this.error = this.audioSegmentLoader_.error_, this.trigger("error");
			}), this.mainSegmentLoader_.on("ended", () => {
				this.logger_("main segment loader ended"), this.onEndOfStream();
			}), this.timelineChangeController_.on("audioTimelineBehind", () => {
				let e = this.audioSegmentLoader_.pendingSegment_;
				if (!e || !e.segment || !e.segment.syncInfo) return;
				let t = e.segment.syncInfo.end + .01;
				this.tech_.setCurrentTime(t);
			}), this.timelineChangeController_.on("fixBadTimelineChange", () => {
				this.logger_("Fix bad timeline change. Restarting al segment loaders..."), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
			}), this.mainSegmentLoader_.on("earlyabort", (e) => {
				this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
					error: { message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering." },
					playlistExclusionDuration: FY
				}));
			});
			let e = () => {
				if (!this.sourceUpdater_.hasCreatedSourceBuffers()) return this.tryToCreateSourceBuffers_();
				let e = this.getCodecsOrExclude_();
				e && this.sourceUpdater_.addOrChangeSourceBuffers(e);
			};
			this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", () => {
				this.triggeredFmp4Usage ||= (this.tech_.trigger({
					type: "usage",
					name: "vhs-fmp4"
				}), !0);
			}), this.audioSegmentLoader_.on("fmp4", () => {
				this.triggeredFmp4Usage ||= (this.tech_.trigger({
					type: "usage",
					name: "vhs-fmp4"
				}), !0);
			}), this.audioSegmentLoader_.on("ended", () => {
				this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
			}), [
				"segmentselected",
				"segmentloadstart",
				"segmentloaded",
				"segmentkeyloadstart",
				"segmentkeyloadcomplete",
				"segmentdecryptionstart",
				"segmentdecryptioncomplete",
				"segmenttransmuxingstart",
				"segmenttransmuxingcomplete",
				"segmenttransmuxingtrackinfoavailable",
				"segmenttransmuxingtiminginfoavailable",
				"segmentappendstart",
				"appendsdone",
				"bandwidthupdated",
				"timelinechange",
				"codecschange"
			].forEach((e) => {
				this.mainSegmentLoader_.on(e, (e) => {
					this.player_.trigger(wF({}, e));
				}), this.audioSegmentLoader_.on(e, (e) => {
					this.player_.trigger(wF({}, e));
				}), this.subtitleSegmentLoader_.on(e, (e) => {
					this.player_.trigger(wF({}, e));
				});
			});
		}
		mediaSecondsLoaded_() {
			return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
		}
		load() {
			this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
		}
		pause() {
			this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
		}
		fastQualityChange_(e = this.selectPlaylist()) {
			if (e && e === this.mainPlaylistLoader_.media()) {
				this.logger_("skipping fastQualityChange because new media is same as old");
				return;
			}
			this.switchMedia_(e, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
		}
		runFastQualitySwitch_() {
			this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
		}
		play() {
			if (this.setupFirstPlay()) return;
			this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
			let e = this.tech_.seekable();
			if (this.tech_.duration() === Infinity && this.tech_.currentTime() < e.start(0)) return this.tech_.setCurrentTime(e.end(e.length - 1));
		}
		setupFirstPlay() {
			let e = this.mainPlaylistLoader_.media();
			if (!e || this.tech_.paused() || this.hasPlayed_) return !1;
			if (!e.endList || e.start) {
				let t = this.seekable();
				if (!t.length) return !1;
				let n = t.end(0), r = n;
				if (e.start) {
					let i = e.start.timeOffset;
					if (i < 0) {
						let a = this.mainPlaylistLoader_.main, o = n + IY.Playlist.liveEdgeDelay(a, e);
						r = Math.max(Math.min(o + i, n), t.start(0));
					} else r = Math.min(n, i);
				}
				this.trigger("firstplay"), this.tech_.setCurrentTime(r);
			}
			return this.hasPlayed_ = !0, this.load(), !0;
		}
		handleSourceOpen_() {
			if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
				let e = this.tech_.play();
				e !== void 0 && typeof e.then == "function" && e.then(null, (e) => {});
			}
			this.trigger("sourceopen");
		}
		handleSourceEnded_() {
			if (!this.inbandTextTracks_.metadataTrack_) return;
			let e = this.inbandTextTracks_.metadataTrack_.cues;
			if (!e || !e.length) return;
			let t = this.duration();
			e[e.length - 1].endTime = isNaN(t) || Math.abs(t) === Infinity ? Number.MAX_VALUE : t;
		}
		handleDurationChange_() {
			this.tech_.trigger("durationchange");
		}
		onEndOfStream() {
			let e = this.mainSegmentLoader_.ended_;
			if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
				let t = this.mainSegmentLoader_.getCurrentMediaInfo_();
				!t || t.hasVideo ? e &&= this.audioSegmentLoader_.ended_ : e = this.audioSegmentLoader_.ended_;
			}
			e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
		}
		stuckAtPlaylistEnd_(e) {
			if (!this.seekable().length) return !1;
			let t = this.syncController_.getExpiredTime(e, this.duration());
			if (t === null) return !1;
			let n = IY.Playlist.playlistEnd(e, t), r = this.tech_.currentTime(), i = this.tech_.buffered();
			if (!i.length) return n - r <= hG;
			let a = i.end(i.length - 1);
			return a - r <= hG && n - a <= hG;
		}
		excludePlaylist({ playlistToExclude: e = this.mainPlaylistLoader_.media(), error: t = {}, playlistExclusionDuration: n }) {
			if (e ||= this.mainPlaylistLoader_.media(), n = n || t.playlistExclusionDuration || this.playlistExclusionDuration, !e) {
				this.error = t, this.mediaSource.readyState === "open" ? this.sourceUpdater_.endOfStream("network") : this.trigger("error");
				return;
			}
			e.playlistErrors_++;
			let r = this.mainPlaylistLoader_.main.playlists, i = r.filter(HG), a = i.length === 1 && i[0] === e;
			if (r.length === 1 && n !== Infinity) return Y.log.warn(`Problem encountered with playlist ${e.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(a);
			if (a) {
				if (this.main().contentSteering) {
					let t = this.pathwayAttribute_(e), n = this.contentSteeringController_.steeringManifest.ttl * 1e3;
					this.contentSteeringController_.excludePathway(t), this.excludeThenChangePathway_(), setTimeout(() => {
						this.contentSteeringController_.addAvailablePathway(t);
					}, n);
					return;
				}
				let t = !1;
				r.forEach((n) => {
					if (n === e) return;
					let r = n.excludeUntil;
					r !== void 0 && r !== Infinity && (t = !0, delete n.excludeUntil);
				}), t && (Y.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
			}
			let o;
			o = e.playlistErrors_ > this.maxPlaylistRetries ? Infinity : Date.now() + n * 1e3, e.excludeUntil = o, t.reason && (e.lastExcludeReason_ = t.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
				type: "usage",
				name: "vhs-rendition-excluded"
			});
			let s = this.selectPlaylist();
			if (!s) {
				this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
				return;
			}
			let c = t.internal ? this.logger_ : Y.log.warn, l = t.message ? " " + t.message : "";
			c(`${t.internal ? "Internal problem" : "Problem"} encountered with playlist ${e.id}.${l} Switching to playlist ${s.id}.`), s.attributes.AUDIO !== e.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), s.attributes.SUBTITLES !== e.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
			let u = s.targetDuration / 2 * 1e3 || 5e3, d = typeof s.lastRequest == "number" && Date.now() - s.lastRequest <= u;
			return this.switchMedia_(s, "exclude", a || d);
		}
		pauseLoading() {
			this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
		}
		delegateLoaders_(e, t) {
			let n = [], r = e === "all";
			(r || e === "main") && n.push(this.mainPlaylistLoader_);
			let i = [];
			(r || e === "audio") && i.push("AUDIO"), (r || e === "subtitle") && (i.push("CLOSED-CAPTIONS"), i.push("SUBTITLES")), i.forEach((e) => {
				let t = this.mediaTypes_[e] && this.mediaTypes_[e].activePlaylistLoader;
				t && n.push(t);
			}), [
				"main",
				"audio",
				"subtitle"
			].forEach((t) => {
				let r = this[`${t}SegmentLoader_`];
				r && (e === t || e === "all") && n.push(r);
			}), n.forEach((e) => t.forEach((t) => {
				typeof e[t] == "function" && e[t]();
			}));
		}
		setCurrentTime(e) {
			let t = _G(this.tech_.buffered(), e);
			if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments) return 0;
			if (t && t.length) return e;
			this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
		}
		duration() {
			if (!this.mainPlaylistLoader_) return 0;
			let e = this.mainPlaylistLoader_.media();
			return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : IY.Playlist.duration(e) : Infinity : 0;
		}
		seekable() {
			return this.seekable_;
		}
		getSeekableRange_(e, t) {
			let n = e.media();
			if (!n) return null;
			let r = this.syncController_.getMediaSequenceSync(t);
			if (r && r.isReliable) {
				let e = r.start, t = r.end;
				if (!isFinite(e) || !isFinite(t)) return null;
				let i = IY.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, n);
				return CB([[e, Math.max(e, t - i)]]);
			}
			let i = this.syncController_.getExpiredTime(n, this.duration());
			if (i === null) return null;
			let a = IY.Playlist.seekable(n, i, IY.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, n));
			return a.length ? a : null;
		}
		computeFinalSeekable_(e, t) {
			if (!t) return e;
			let n = e.start(0), r = e.end(0), i = t.start(0), a = t.end(0);
			return i > r || n > a ? e : CB([[Math.max(n, i), Math.min(r, a)]]);
		}
		onSyncInfoUpdate_() {
			if (!this.mainPlaylistLoader_) return;
			let e = this.getSeekableRange_(this.mainPlaylistLoader_, "main");
			if (!e) return;
			let t;
			if (this.mediaTypes_.AUDIO.activePlaylistLoader && (t = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, "audio"), !t)) return;
			let n = this.seekable_;
			if (this.seekable_ = this.computeFinalSeekable_(e, t), !this.seekable_ || n && n.length && this.seekable_.length && n.start(0) === this.seekable_.start(0) && n.end(0) === this.seekable_.end(0)) return;
			this.logger_(`seekable updated [${xG(this.seekable_)}]`);
			let r = { seekableRanges: this.seekable_ };
			this.trigger({
				type: "seekablerangeschanged",
				metadata: r
			}), this.tech_.trigger("seekablechanged");
		}
		updateDuration(e) {
			if (this.updateDuration_ &&= (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), null), this.mediaSource.readyState !== "open") {
				this.updateDuration_ = this.updateDuration.bind(this, e), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
				return;
			}
			if (e) {
				let e = this.seekable();
				if (!e.length) return;
				(isNaN(this.mediaSource.duration) || this.mediaSource.duration < e.end(e.length - 1)) && this.sourceUpdater_.setDuration(e.end(e.length - 1));
				return;
			}
			let t = this.tech_.buffered(), n = IY.Playlist.duration(this.mainPlaylistLoader_.media());
			t.length > 0 && (n = Math.max(n, t.end(t.length - 1))), this.mediaSource.duration !== n && this.sourceUpdater_.setDuration(n);
		}
		dispose() {
			this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((e) => {
				let t = this.mediaTypes_[e].groups;
				for (let e in t) t[e].forEach((e) => {
					e.playlistLoader && e.playlistLoader.dispose();
				});
			}), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
		}
		main() {
			return this.mainPlaylistLoader_.main;
		}
		media() {
			return this.mainPlaylistLoader_.media() || this.initialMedia_;
		}
		areMediaTypesKnown_() {
			let e = !!this.mediaTypes_.AUDIO.activePlaylistLoader, t = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), n = !e || !!this.audioSegmentLoader_.getCurrentMediaInfo_();
			return !(!t || !n);
		}
		getCodecsOrExclude_() {
			let e = {
				main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
				audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
			}, t = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
			e.video = e.main;
			let n = _K(this.main(), t), r = {}, i = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
			if (e.main.hasVideo && (r.video = n.video || e.main.videoCodec || "avc1.4d400d"), e.main.isMuxed && (r.video += `,${n.audio || e.main.audioCodec || "mp4a.40.2"}`), (e.main.hasAudio && !e.main.isMuxed || e.audio.hasAudio || i) && (r.audio = n.audio || e.main.audioCodec || e.audio.audioCodec || "mp4a.40.2", e.audio.isFmp4 = e.main.hasAudio && !e.main.isMuxed ? e.main.isFmp4 : e.audio.isFmp4), !r.audio && !r.video) {
				this.excludePlaylist({
					playlistToExclude: t,
					error: { message: "Could not determine codecs for playlist." },
					playlistExclusionDuration: Infinity
				});
				return;
			}
			let a = (e, t) => e ? iI(t, this.usingManagedMediaSource_) : aI(t), o = {}, s;
			if (["video", "audio"].forEach(function(t) {
				if (r.hasOwnProperty(t) && !a(e[t].isFmp4, r[t])) {
					let n = e[t].isFmp4 ? "browser" : "muxer";
					o[n] = o[n] || [], o[n].push(r[t]), t === "audio" && (s = n);
				}
			}), i && s && t.attributes.AUDIO) {
				let e = t.attributes.AUDIO;
				this.main().playlists.forEach((n) => {
					(n.attributes && n.attributes.AUDIO) === e && n !== t && (n.excludeUntil = Infinity);
				}), this.logger_(`excluding audio group ${e} as ${s} does not support codec(s): "${r.audio}"`);
			}
			if (Object.keys(o).length) {
				let e = Object.keys(o).reduce((e, t) => (e && (e += ", "), e += `${t} does not support codec(s): "${o[t].join(",")}"`, e), "") + ".";
				this.excludePlaylist({
					playlistToExclude: t,
					error: {
						internal: !0,
						message: e
					},
					playlistExclusionDuration: Infinity
				});
				return;
			}
			if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
				let e = [];
				if (["video", "audio"].forEach((t) => {
					let n = ($F(this.sourceUpdater_.codecs[t] || "")[0] || {}).type, i = ($F(r[t] || "")[0] || {}).type;
					n && i && n.toLowerCase() !== i.toLowerCase() && e.push(`"${this.sourceUpdater_.codecs[t]}" -> "${r[t]}"`);
				}), e.length) {
					this.excludePlaylist({
						playlistToExclude: t,
						error: {
							message: `Codec switching not supported: ${e.join(", ")}.`,
							internal: !0
						},
						playlistExclusionDuration: Infinity
					});
					return;
				}
			}
			return r;
		}
		tryToCreateSourceBuffers_() {
			if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_()) return;
			let e = this.getCodecsOrExclude_();
			if (!e) return;
			this.sourceUpdater_.createSourceBuffers(e);
			let t = [e.video, e.audio].filter(Boolean).join(",");
			this.excludeIncompatibleVariants_(t);
		}
		excludeUnsupportedVariants_() {
			let e = this.main().playlists, t = [];
			Object.keys(e).forEach((n) => {
				let r = e[n];
				if (t.indexOf(r.id) !== -1) return;
				t.push(r.id);
				let i = _K(this.main, r), a = [];
				i.audio && !aI(i.audio) && !iI(i.audio, this.usingManagedMediaSource_) && a.push(`audio codec ${i.audio}`), i.video && !aI(i.video) && !iI(i.video, this.usingManagedMediaSource_) && a.push(`video codec ${i.video}`), i.text && i.text === "stpp.ttml.im1t" && a.push(`text codec ${i.text}`), a.length && (r.excludeUntil = Infinity, this.logger_(`excluding ${r.id} for unsupported: ${a.join(", ")}`));
			});
		}
		excludeIncompatibleVariants_(e) {
			let t = [], n = this.main().playlists, r = hK($F(e)), i = gK(r), a = r.video && $F(r.video)[0] || null, o = r.audio && $F(r.audio)[0] || null;
			Object.keys(n).forEach((e) => {
				let r = n[e];
				if (t.indexOf(r.id) !== -1 || r.excludeUntil === Infinity) return;
				t.push(r.id);
				let s = [], c = _K(this.mainPlaylistLoader_.main, r), l = gK(c);
				if (!(!c.audio && !c.video)) {
					if (l !== i && s.push(`codec count "${l}" !== "${i}"`), !this.sourceUpdater_.canChangeType()) {
						let e = c.video && $F(c.video)[0] || null, t = c.audio && $F(c.audio)[0] || null;
						e && a && e.type.toLowerCase() !== a.type.toLowerCase() && s.push(`video codec "${e.type}" !== "${a.type}"`), t && o && t.type.toLowerCase() !== o.type.toLowerCase() && s.push(`audio codec "${t.type}" !== "${o.type}"`);
					}
					s.length && (r.excludeUntil = Infinity, this.logger_(`excluding ${r.id}: ${s.join(" && ")}`));
				}
			});
		}
		updateAdCues_(e) {
			let t = 0, n = this.seekable();
			n.length && (t = n.start(0)), sY(e, this.cueTagsTrack_, t);
		}
		goalBufferLength() {
			let e = this.tech_.currentTime(), t = fq.GOAL_BUFFER_LENGTH, n = fq.GOAL_BUFFER_LENGTH_RATE, r = Math.max(t, fq.MAX_GOAL_BUFFER_LENGTH);
			return Math.min(t + e * n, r);
		}
		bufferLowWaterLine() {
			let e = this.tech_.currentTime(), t = fq.BUFFER_LOW_WATER_LINE, n = fq.BUFFER_LOW_WATER_LINE_RATE, r = Math.max(t, fq.MAX_BUFFER_LOW_WATER_LINE), i = Math.max(t, fq.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
			return Math.min(t + e * n, this.bufferBasedABR ? i : r);
		}
		bufferHighWaterLine() {
			return fq.BUFFER_HIGH_WATER_LINE;
		}
		addDateRangesToTextTrack_(e) {
			vJ(this.inbandTextTracks_, "com.apple.streaming", this.tech_), _J({
				inbandTextTracks: this.inbandTextTracks_,
				dateRanges: e
			});
		}
		addMetadataToTextTrack(e, t, n) {
			let r = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
			vJ(this.inbandTextTracks_, e, this.tech_), mJ({
				inbandTextTracks: this.inbandTextTracks_,
				metadataArray: t,
				timestampOffset: r,
				videoDuration: n
			});
		}
		pathwayAttribute_(e) {
			return e.attributes["PATHWAY-ID"] || e.attributes.serviceLocation;
		}
		initContentSteeringController_() {
			let e = this.main();
			if (e.contentSteering) {
				for (let t of e.playlists) this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(t));
				if (this.contentSteeringController_.assignTagProperties(e.uri, e.contentSteering), this.contentSteeringController_.queryBeforeStart) {
					this.contentSteeringController_.requestSteeringManifest(!0);
					return;
				}
				this.tech_.one("canplay", () => {
					this.contentSteeringController_.requestSteeringManifest();
				});
			}
		}
		resetContentSteeringController_() {
			this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
		}
		attachContentSteeringListeners_() {
			this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), [
				"contentsteeringloadstart",
				"contentsteeringloadcomplete",
				"contentsteeringparsed"
			].forEach((e) => {
				this.contentSteeringController_.on(e, (e) => {
					this.trigger(wF({}, e));
				});
			}), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
				let e = this.main();
				(this.contentSteeringController_.didDASHTagChange(e.uri, e.contentSteering) || (() => {
					let t = this.contentSteeringController_.getAvailablePathways(), n = [];
					for (let r of e.playlists) {
						let e = r.attributes.serviceLocation;
						if (e && (n.push(e), !t.has(e))) return !0;
					}
					return !!(!n.length && t.size);
				})()) && this.resetContentSteeringController_();
			});
		}
		excludeThenChangePathway_() {
			let e = this.contentSteeringController_.getPathway();
			if (!e) return;
			this.handlePathwayClones_();
			let t = this.main().playlists, n = /* @__PURE__ */ new Set(), r = !1;
			Object.keys(t).forEach((i) => {
				let a = t[i], o = this.pathwayAttribute_(a), s = o && e !== o;
				a.excludeUntil === Infinity && a.lastExcludeReason_ === "content-steering" && !s && (delete a.excludeUntil, delete a.lastExcludeReason_, r = !0);
				let c = !a.excludeUntil && a.excludeUntil !== Infinity;
				!n.has(a.id) && s && c && (n.add(a.id), a.excludeUntil = Infinity, a.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${a.id} for ${a.lastExcludeReason_}`));
			}), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((t) => {
				let n = this.mediaTypes_[t];
				if (n.activePlaylistLoader) {
					let t = n.activePlaylistLoader.media_;
					t && t.attributes.serviceLocation !== e && (r = !0);
				}
			}), r && this.changeSegmentPathway_();
		}
		handlePathwayClones_() {
			let e = this.main().playlists, t = this.contentSteeringController_.currentPathwayClones, n = this.contentSteeringController_.nextPathwayClones;
			if (t && t.size || n && n.size) {
				for (let [e, r] of t.entries()) n.get(e) || (this.mainPlaylistLoader_.updateOrDeleteClone(r), this.contentSteeringController_.excludePathway(e));
				for (let [r, i] of n.entries()) {
					let n = t.get(r);
					if (!n) {
						e.filter((e) => e.attributes["PATHWAY-ID"] === i["BASE-ID"]).forEach((e) => {
							this.mainPlaylistLoader_.addClonePathway(i, e);
						}), this.contentSteeringController_.addAvailablePathway(r);
						continue;
					}
					this.equalPathwayClones_(n, i) || (this.mainPlaylistLoader_.updateOrDeleteClone(i, !0), this.contentSteeringController_.addAvailablePathway(r));
				}
				this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...n])));
			}
		}
		equalPathwayClones_(e, t) {
			if (e["BASE-ID"] !== t["BASE-ID"] || e.ID !== t.ID || e["URI-REPLACEMENT"].HOST !== t["URI-REPLACEMENT"].HOST) return !1;
			let n = e["URI-REPLACEMENT"].PARAMS, r = t["URI-REPLACEMENT"].PARAMS;
			for (let e in n) if (n[e] !== r[e]) return !1;
			for (let e in r) if (n[e] !== r[e]) return !1;
			return !0;
		}
		changeSegmentPathway_() {
			let e = this.selectPlaylist();
			this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(e, "content-steering");
		}
		excludeNonUsablePlaylistsByKeyId_() {
			if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main) return;
			let e = 0, t = "non-usable";
			this.mainPlaylistLoader_.main.playlists.forEach((n) => {
				let r = this.mainPlaylistLoader_.getKeyIdSet(n);
				!r || !r.size || r.forEach((r) => {
					let i = "usable", a = this.keyStatusMap_.has(r) && this.keyStatusMap_.get(r) === i, o = n.lastExcludeReason_ === t && n.excludeUntil === Infinity;
					a ? a && o && (delete n.excludeUntil, delete n.lastExcludeReason_, this.logger_(`enabling playlist ${n.id} because key ID ${r} is ${i}`)) : (n.excludeUntil !== Infinity && n.lastExcludeReason_ !== t && (n.excludeUntil = Infinity, n.lastExcludeReason_ = t, this.logger_(`excluding playlist ${n.id} because the key ID ${r} doesn't exist in the keyStatusMap or is not ${i}`)), e++);
				});
			}), e >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((e) => {
				let n = e && e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.height < 720, r = e.excludeUntil === Infinity && e.lastExcludeReason_ === t;
				n && r && (delete e.excludeUntil, Y.log.warn(`enabling non-HD playlist ${e.id} because all playlists were excluded due to ${t} key IDs`));
			});
		}
		addKeyStatus_(e, t) {
			let n = (typeof e == "string" ? e : nY(e)).slice(0, 32).toLowerCase();
			this.logger_(`KeyStatus '${t}' with key ID ${n} added to the keyStatusMap`), this.keyStatusMap_.set(n, t);
		}
		updatePlaylistByKeyStatus(e, t) {
			this.addKeyStatus_(e, t), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
		}
		excludeNonUsableThenChangePlaylist_() {
			this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
		}
	}, VY = (e, t, n) => (r) => {
		let i = e.main.playlists[t], a = VG(i), o = HG(i);
		if (r === void 0) return o;
		r ? delete i.disabled : i.disabled = !0;
		let s = {
			renditionInfo: {
				id: t,
				bandwidth: i.attributes.BANDWIDTH,
				resolution: i.attributes.RESOLUTION,
				codecs: i.attributes.CODECS
			},
			cause: "fast-quality"
		};
		return r !== o && !a && (r ? (n(i), e.trigger({
			type: "renditionenabled",
			metadata: s
		})) : e.trigger({
			type: "renditiondisabled",
			metadata: s
		})), r;
	}, HY = class {
		constructor(e, t, n) {
			let { playlistController_: r } = e, i = r.fastQualityChange_.bind(r);
			if (t.attributes) {
				let e = t.attributes.RESOLUTION;
				this.width = e && e.width, this.height = e && e.height, this.bandwidth = t.attributes.BANDWIDTH, this.frameRate = t.attributes["FRAME-RATE"];
			}
			this.codecs = _K(r.main(), t), this.playlist = t, this.id = n, this.enabled = VY(e.playlists, t.id, i);
		}
	}, UY = function(e) {
		e.representations = () => {
			let t = e.playlistController_.main(), n = XG(t) ? e.playlistController_.getAudioTrackPlaylists_() : t.playlists;
			return n ? n.filter((e) => !VG(e)).map((t, n) => new HY(e, t, t.id)) : [];
		};
	}, WY = [
		"seeking",
		"seeked",
		"pause",
		"playing",
		"error"
	], GY = class extends Y.EventTarget {
		constructor(e) {
			super(), this.playlistController_ = e.playlistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = pG("PlaybackWatcher"), this.logger_("initialize");
			let t = () => this.monitorCurrentTime_(), n = () => this.monitorCurrentTime_(), r = () => this.techWaiting_(), i = () => this.resetTimeUpdate_(), a = this.playlistController_, o = [
				"main",
				"subtitle",
				"audio"
			], s = {};
			o.forEach((e) => {
				s[e] = {
					reset: () => this.resetSegmentDownloads_(e),
					updateend: () => this.checkSegmentDownloads_(e)
				}, a[`${e}SegmentLoader_`].on("appendsdone", s[e].updateend), a[`${e}SegmentLoader_`].on("playlistupdate", s[e].reset), this.tech_.on(["seeked", "seeking"], s[e].reset);
			});
			let c = (e) => {
				["main", "audio"].forEach((t) => {
					a[`${t}SegmentLoader_`][e]("appended", this.seekingAppendCheck_);
				});
			};
			this.seekingAppendCheck_ = () => {
				this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), c("off"));
			}, this.clearSeekingAppendCheck_ = () => c("off"), this.watchForBadSeeking_ = () => {
				this.clearSeekingAppendCheck_(), c("on");
			}, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", r), this.tech_.on(WY, i), this.tech_.on("canplay", n), this.tech_.one("play", t), this.dispose = () => {
				this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", r), this.tech_.off(WY, i), this.tech_.off("canplay", n), this.tech_.off("play", t), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), o.forEach((e) => {
					a[`${e}SegmentLoader_`].off("appendsdone", s[e].updateend), a[`${e}SegmentLoader_`].off("playlistupdate", s[e].reset), this.tech_.off(["seeked", "seeking"], s[e].reset);
				}), this.checkCurrentTimeTimeout_ && X.default.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
			};
		}
		monitorCurrentTime_() {
			this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && X.default.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = X.default.setTimeout(this.monitorCurrentTime_.bind(this), 250);
		}
		resetSegmentDownloads_(e) {
			let t = this.playlistController_[`${e}SegmentLoader_`];
			this[`${e}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${e} loader`), this[`${e}StalledDownloads_`] = 0, this[`${e}Buffered_`] = t.buffered_();
		}
		checkSegmentDownloads_(e) {
			let t = this.playlistController_, n = t[`${e}SegmentLoader_`], r = n.buffered_(), i = wG(this[`${e}Buffered_`], r);
			if (this[`${e}Buffered_`] = r, i) {
				let n = { bufferedRanges: r };
				t.trigger({
					type: "bufferedrangeschanged",
					metadata: n
				}), this.resetSegmentDownloads_(e);
				return;
			}
			this[`${e}StalledDownloads_`]++, this.logger_(`found #${this[`${e}StalledDownloads_`]} ${e} appends that did not increase buffer (possible stalled download)`, {
				playlistId: n.playlist_ && n.playlist_.id,
				buffered: CG(r)
			}), !(this[`${e}StalledDownloads_`] < 10) && (this.logger_(`${e} loader stalled download exclusion`), this.resetSegmentDownloads_(e), this.tech_.trigger({
				type: "usage",
				name: `vhs-${e}-download-exclusion`
			}), e !== "subtitle" && t.excludePlaylist({
				error: { message: `Excessive ${e} segment downloading detected.` },
				playlistExclusionDuration: Infinity
			}));
		}
		checkCurrentTime_() {
			if (this.tech_.paused() || this.tech_.seeking()) return;
			let e = this.tech_.currentTime(), t = this.tech_.buffered();
			if (this.lastRecordedTime === e && (!t.length || e + hG >= t.end(t.length - 1))) return this.techWaiting_();
			if (this.consecutiveUpdates >= 5 && e === this.lastRecordedTime) this.consecutiveUpdates++, this.waiting_();
			else if (e === this.lastRecordedTime) this.consecutiveUpdates++;
			else {
				this.playedRanges_.push(CB([this.lastRecordedTime, e]));
				let t = { playedRanges: this.playedRanges_ };
				this.playlistController_.trigger({
					type: "playedrangeschanged",
					metadata: t
				}), this.consecutiveUpdates = 0, this.lastRecordedTime = e;
			}
		}
		resetTimeUpdate_() {
			this.consecutiveUpdates = 0;
		}
		fixesBadSeeks_() {
			if (!this.tech_.seeking()) return !1;
			let e = this.seekable(), t = this.tech_.currentTime(), n = this.afterSeekableWindow_(e, t, this.media(), this.allowSeeksWithinUnsafeLiveWindow), r;
			if (n && (r = e.end(e.length - 1)), this.beforeSeekableWindow_(e, t)) {
				let t = e.start(0);
				r = t + (t === e.end(0) ? 0 : hG);
			}
			if (r !== void 0) return this.logger_(`Trying to seek outside of seekable at time ${t} with seekable range ${xG(e)}. Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0;
			let i = this.playlistController_.sourceUpdater_, a = this.tech_.buffered(), o = i.audioBuffer ? i.audioBuffered() : null, s = i.videoBuffer ? i.videoBuffered() : null, c = this.media(), l = c.partTargetDuration ? c.partTargetDuration : (c.targetDuration - mG) * 2, u = [o, s];
			for (let e = 0; e < u.length; e++) if (u[e] && EG(u[e], t) < l) return !1;
			let d = vG(a, t);
			return d.length !== 0 && (r = d.start(0) + hG, this.logger_(`Buffered region starts (${d.start(0)})  just beyond seek point (${t}). Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0);
		}
		waiting_() {
			if (this.techWaiting_()) return;
			let e = this.tech_.currentTime(), t = this.tech_.buffered(), n = _G(t, e);
			if (n.length && e + 3 <= n.end(0)) {
				this.resetTimeUpdate_(), this.tech_.setCurrentTime(e), this.logger_(`Stopped at ${e} while inside a buffered region [${n.start(0)} -> ${n.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
					type: "usage",
					name: "vhs-unknown-waiting"
				});
				return;
			}
		}
		techWaiting_() {
			let e = this.seekable(), t = this.tech_.currentTime();
			if (this.tech_.seeking()) return !0;
			if (this.beforeSeekableWindow_(e, t)) {
				let n = e.end(e.length - 1);
				return this.logger_(`Fell out of live window at time ${t}. Seeking to live point (seekable end) ${n}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(n), this.tech_.trigger({
					type: "usage",
					name: "vhs-live-resync"
				}), !0;
			}
			let n = this.tech_.vhs.playlistController_.sourceUpdater_, r = this.tech_.buffered();
			if (this.videoUnderflow_({
				audioBuffered: n.audioBuffered(),
				videoBuffered: n.videoBuffered(),
				currentTime: t
			})) return this.resetTimeUpdate_(), this.tech_.setCurrentTime(t), this.tech_.trigger({
				type: "usage",
				name: "vhs-video-underflow"
			}), !0;
			let i = vG(r, t);
			return i.length > 0 && (this.logger_(`Stopped at ${t} and seeking to ${i.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(t), !0);
		}
		afterSeekableWindow_(e, t, n, r = !1) {
			if (!e.length) return !1;
			let i = e.end(e.length - 1) + hG, a = !n.endList, o = typeof n.partTargetDuration == "number";
			return a && (o || r) && (i = e.end(e.length - 1) + n.targetDuration * 3), t > i;
		}
		beforeSeekableWindow_(e, t) {
			return !!(e.length && e.start(0) > 0 && t < e.start(0) - this.liveRangeSafeTimeDelta);
		}
		videoUnderflow_({ videoBuffered: e, audioBuffered: t, currentTime: n }) {
			if (!e) return;
			let r;
			if (e.length && t.length) {
				let i = _G(e, n - 3), a = _G(e, n), o = _G(t, n);
				o.length && !a.length && i.length && (r = {
					start: i.end(0),
					end: o.end(0)
				});
			} else vG(e, n).length || (r = this.gapFromVideoUnderflow_(e, n));
			return r ? (this.logger_(`Encountered a gap in video from ${r.start} to ${r.end}. Seeking to current time ${n}`), !0) : !1;
		}
		skipTheGap_(e) {
			let t = this.tech_.buffered(), n = this.tech_.currentTime(), r = vG(t, n);
			if (this.resetTimeUpdate_(), r.length === 0 || n !== e) return;
			this.logger_("skipTheGap_:", "currentTime:", n, "scheduled currentTime:", e, "nextRange start:", r.start(0)), this.tech_.setCurrentTime(r.start(0) + mG);
			let i = { gapInfo: {
				from: n,
				to: r.start(0)
			} };
			this.playlistController_.trigger({
				type: "gapjumped",
				metadata: i
			}), this.tech_.trigger({
				type: "usage",
				name: "vhs-gap-skip"
			});
		}
		gapFromVideoUnderflow_(e, t) {
			let n = yG(e);
			for (let e = 0; e < n.length; e++) {
				let r = n.start(e), i = n.end(e);
				if (t - r < 4 && t - r > 2) return {
					start: r,
					end: i
				};
			}
			return null;
		}
	}, KY = {
		errorInterval: 30,
		getSource(e) {
			return e(this.tech({ IWillNotUseThisInPlugins: !0 }).currentSource_ || this.currentSource());
		}
	}, qY = function(e, t) {
		let n = 0, r = 0, i = SB(KY, t);
		e.ready(() => {
			e.trigger({
				type: "usage",
				name: "vhs-error-reload-initialized"
			});
		});
		let a = function() {
			r && e.currentTime(r);
		}, o = function(t) {
			t != null && (r = e.duration() !== Infinity && e.currentTime() || 0, e.one("loadedmetadata", a), e.src(t), e.trigger({
				type: "usage",
				name: "vhs-error-reload"
			}), e.play());
		}, s = function() {
			if (Date.now() - n < i.errorInterval * 1e3) {
				e.trigger({
					type: "usage",
					name: "vhs-error-reload-canceled"
				});
				return;
			}
			if (!i.getSource || typeof i.getSource != "function") {
				Y.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
				return;
			}
			return n = Date.now(), i.getSource.call(e, o);
		}, c = function() {
			e.off("loadedmetadata", a), e.off("error", s), e.off("dispose", c);
		};
		e.on("error", s), e.on("dispose", c), e.reloadSourceOnError = function(t) {
			c(), qY(e, t);
		};
	}, JY = function(e) {
		qY(this, e);
	}, YY = "3.17.5", XY = "7.1.0", ZY = "1.4.0", QY = "7.2.0", $Y = "4.0.2", eX = {
		PlaylistLoader: OK,
		Playlist: ZG,
		utils: WK,
		STANDARD_PLAYLIST_SELECTOR: oJ,
		INITIAL_PLAYLIST_SELECTOR: lJ,
		lastBandwidthSelector: oJ,
		movingAverageBandwidthSelector: sJ,
		comparePlaylistBandwidth: rJ,
		comparePlaylistResolution: iJ,
		xhr: MK()
	}, Object.keys(fq).forEach((e) => {
		Object.defineProperty(eX, e, {
			get() {
				return Y.log.warn(`using Vhs.${e} is UNSAFE be sure you know what you are doing`), fq[e];
			},
			set(t) {
				if (Y.log.warn(`using Vhs.${e} is UNSAFE be sure you know what you are doing`), typeof t != "number" || t < 0) {
					Y.log.warn(`value of Vhs.${e} must be greater than or equal to 0`);
					return;
				}
				fq[e] = t;
			}
		});
	}), tX = "videojs-vhs", nX = function(e, t) {
		let n = t.media(), r = -1;
		for (let t = 0; t < e.length; t++) if (e[t].id === n.id) {
			r = t;
			break;
		}
		e.selectedIndex_ = r, e.trigger({
			selectedIndex: r,
			type: "change"
		});
	}, rX = function(e, t) {
		t.representations().forEach((t) => {
			e.addQualityLevel(t);
		}), nX(e, t.playlists);
	}, eX.canPlaySource = function() {
		return Y.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
	}, iX = (e, t, n) => {
		if (!e) return e;
		let r = {};
		t && t.attributes && t.attributes.CODECS && (r = hK($F(t.attributes.CODECS))), n && n.attributes && n.attributes.CODECS && (r.audio = n.attributes.CODECS);
		let i = rI(r.video), a = rI(r.audio), o = {};
		for (let n in e) o[n] = {}, a && (o[n].audioContentType = a), i && (o[n].videoContentType = i), t.contentProtection && t.contentProtection[n] && t.contentProtection[n].pssh && (o[n].pssh = t.contentProtection[n].pssh), typeof e[n] == "string" && (o[n].url = e[n]);
		return SB(e, o);
	}, aX = (e, t) => e.reduce((e, n) => {
		if (!n.contentProtection) return e;
		let r = t.reduce((e, t) => {
			let r = n.contentProtection[t];
			return r && r.pssh && (e[t] = { pssh: r.pssh }), e;
		}, {});
		return Object.keys(r).length && e.push(r), e;
	}, []), oX = ({ player: e, sourceKeySystems: t, audioMedia: n, mainPlaylists: r }) => {
		if (!e.eme.initializeMediaKeys) return Promise.resolve();
		let i = n ? r.concat([n]) : r, a = aX(i, Object.keys(t)), o = [], s = [];
		return a.forEach((t) => {
			s.push(new Promise((t, n) => {
				e.tech_.one("keysessioncreated", t);
			})), o.push(new Promise((n, r) => {
				e.eme.initializeMediaKeys({ keySystems: t }, (e) => {
					if (e) {
						r(e);
						return;
					}
					n();
				});
			}));
		}), Promise.race([Promise.all(o), Promise.race(s)]);
	}, sX = ({ player: e, sourceKeySystems: t, media: n, audioMedia: r }) => {
		let i = iX(t, n, r);
		return i ? (e.currentSource().keySystems = i, i && !e.eme ? (Y.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
	}, cX = () => {
		if (!X.default.localStorage) return null;
		let e = X.default.localStorage.getItem(tX);
		if (!e) return null;
		try {
			return JSON.parse(e);
		} catch {
			return null;
		}
	}, lX = (e) => {
		if (!X.default.localStorage) return !1;
		let t = cX();
		t = t ? SB(t, e) : e;
		try {
			X.default.localStorage.setItem(tX, JSON.stringify(t));
		} catch {
			return !1;
		}
		return t;
	}, uX = (e) => e.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(e.substring(e.indexOf(",") + 1)) : e, dX = (e, t) => {
		e._requestCallbackSet ||= /* @__PURE__ */ new Set(), e._requestCallbackSet.add(t);
	}, fX = (e, t) => {
		e._responseCallbackSet ||= /* @__PURE__ */ new Set(), e._responseCallbackSet.add(t);
	}, pX = (e, t) => {
		e._requestCallbackSet && (e._requestCallbackSet.delete(t), e._requestCallbackSet.size || delete e._requestCallbackSet);
	}, mX = (e, t) => {
		e._responseCallbackSet && (e._responseCallbackSet.delete(t), e._responseCallbackSet.size || delete e._responseCallbackSet);
	}, eX.supportsNativeHls = function() {
		if (!Z.default || !Z.default.createElement) return !1;
		let e = Z.default.createElement("video");
		return Y.getTech("Html5").isSupported() ? [
			"application/vnd.apple.mpegurl",
			"audio/mpegurl",
			"audio/x-mpegurl",
			"application/x-mpegurl",
			"video/x-mpegurl",
			"video/mpegurl",
			"application/mpegurl"
		].some(function(t) {
			return /maybe|probably/i.test(e.canPlayType(t));
		}) : !1;
	}(), eX.supportsNativeDash = function() {
		return !Z.default || !Z.default.createElement || !Y.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(Z.default.createElement("video").canPlayType("application/dash+xml"));
	}(), eX.supportsTypeNatively = (e) => e === "hls" ? eX.supportsNativeHls : e === "dash" && eX.supportsNativeDash, eX.isSupported = function() {
		return Y.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
	}, eX.xhr.onRequest = function(e) {
		dX(eX.xhr, e);
	}, eX.xhr.onResponse = function(e) {
		fX(eX.xhr, e);
	}, eX.xhr.offRequest = function(e) {
		pX(eX.xhr, e);
	}, eX.xhr.offResponse = function(e) {
		mX(eX.xhr, e);
	}, hX = Y.getComponent("Component"), gX = class extends hX {
		constructor(e, t, n) {
			if (super(t, n.vhs), typeof n.initialBandwidth == "number" && (this.options_.bandwidth = n.initialBandwidth), this.logger_ = pG("VhsHandler"), t.options_ && t.options_.playerId) {
				let e = Y.getPlayer(t.options_.playerId);
				this.player_ = e;
			}
			if (this.tech_ = t, this.source_ = e, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && t.overrideNativeAudioTracks && t.overrideNativeVideoTracks) t.overrideNativeAudioTracks(!0), t.overrideNativeVideoTracks(!0);
			else if (this.options_.overrideNative && (t.featuresNativeVideoTracks || t.featuresNativeAudioTracks)) throw Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
			this.on(Z.default, [
				"fullscreenchange",
				"webkitfullscreenchange",
				"mozfullscreenchange",
				"MSFullscreenChange"
			], (e) => {
				let t = Z.default.fullscreenElement || Z.default.webkitFullscreenElement || Z.default.mozFullScreenElement || Z.default.msFullscreenElement;
				t && t.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
			}), this.on(this.tech_, "seeking", function() {
				if (this.ignoreNextSeekingEvent_) {
					this.ignoreNextSeekingEvent_ = !1;
					return;
				}
				this.setCurrentTime(this.tech_.currentTime());
			}), this.on(this.tech_, "error", function() {
				this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
			}), this.on(this.tech_, "play", this.play);
		}
		setOptions_(e = {}) {
			if (this.options_ = SB(this.options_, e), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.usePlayerObjectFit = this.options_.usePlayerObjectFit || !1, this.options_.useBandwidthFromLocalStorage = this.source_.useBandwidthFromLocalStorage === void 0 ? this.options_.useBandwidthFromLocalStorage || !1 : this.source_.useBandwidthFromLocalStorage, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi === void 0 || this.options_.useNetworkInformationApi, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
				let e = cX();
				e && e.bandwidth && (this.options_.bandwidth = e.bandwidth, this.tech_.trigger({
					type: "usage",
					name: "vhs-bandwidth-from-local-storage"
				})), e && e.throughput && (this.options_.throughput = e.throughput, this.tech_.trigger({
					type: "usage",
					name: "vhs-throughput-from-local-storage"
				}));
			}
			typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = fq.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === fq.INITIAL_BANDWIDTH, [
				"withCredentials",
				"useDevicePixelRatio",
				"usePlayerObjectFit",
				"customPixelRatio",
				"limitRenditionByPlayerDimensions",
				"bandwidth",
				"customTagParsers",
				"customTagMappers",
				"cacheEncryptionKeys",
				"playlistSelector",
				"initialPlaylistSelector",
				"bufferBasedABR",
				"liveRangeSafeTimeDelta",
				"llhls",
				"useForcedSubtitles",
				"useNetworkInformationApi",
				"useDtsForTimestampOffset",
				"exactManifestTimings",
				"leastPixelDiffSelector"
			].forEach((e) => {
				this.source_[e] !== void 0 && (this.options_[e] = this.source_[e]);
			}), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio, this.usePlayerObjectFit = this.options_.usePlayerObjectFit;
			let t = this.options_.customPixelRatio;
			typeof t == "number" && t >= 0 && (this.customPixelRatio = t);
		}
		setOptions(e = {}) {
			this.setOptions_(e);
		}
		src(e, t) {
			if (!e) return;
			this.setOptions_(), this.options_.src = uX(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = eX, this.options_.sourceType = lI(t), this.options_.seekTo = (e) => {
				this.tech_.setCurrentTime(e);
			}, this.options_.player_ = this.player_, this.playlistController_ = new BY(this.options_);
			let n = SB({ liveRangeSafeTimeDelta: hG }, this.options_, {
				seekable: () => this.seekable(),
				media: () => this.playlistController_.media(),
				playlistController: this.playlistController_
			});
			this.playbackWatcher_ = new GY(n), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
				let e = Y.players[this.tech_.options_.playerId], t = this.playlistController_.error;
				typeof t == "object" && !t.code ? t.code = 3 : typeof t == "string" && (t = {
					message: t,
					code: 3
				}), e.error(t);
			});
			let r = this.options_.bufferBasedABR ? eX.movingAverageBandwidthSelector(.55) : eX.STANDARD_PLAYLIST_SELECTOR;
			this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : r.bind(this), this.playlistController_.selectInitialPlaylist = eX.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
				selectPlaylist: {
					get() {
						return this.playlistController_.selectPlaylist;
					},
					set(e) {
						this.playlistController_.selectPlaylist = e.bind(this);
					}
				},
				throughput: {
					get() {
						return this.playlistController_.mainSegmentLoader_.throughput.rate;
					},
					set(e) {
						this.playlistController_.mainSegmentLoader_.throughput.rate = e, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
					}
				},
				bandwidth: {
					get() {
						let e = this.playlistController_.mainSegmentLoader_.bandwidth, t = X.default.navigator.connection || X.default.navigator.mozConnection || X.default.navigator.webkitConnection, n = 1e7;
						if (this.options_.useNetworkInformationApi && t) {
							let r = t.downlink * 1e3 * 1e3;
							e = r >= n && e >= n ? Math.max(e, r) : r;
						}
						return e;
					},
					set(e) {
						this.playlistController_.mainSegmentLoader_.bandwidth = e, this.playlistController_.mainSegmentLoader_.throughput = {
							rate: 0,
							count: 0
						};
					}
				},
				systemBandwidth: {
					get() {
						let e = 1 / (this.bandwidth || 1), t;
						return t = this.throughput > 0 ? 1 / this.throughput : 0, Math.floor(1 / (e + t));
					},
					set() {
						Y.log.error("The \"systemBandwidth\" property is read-only");
					}
				}
			}), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
				bandwidth: {
					get: () => this.bandwidth || 0,
					enumerable: !0
				},
				mediaRequests: {
					get: () => this.playlistController_.mediaRequests_() || 0,
					enumerable: !0
				},
				mediaRequestsAborted: {
					get: () => this.playlistController_.mediaRequestsAborted_() || 0,
					enumerable: !0
				},
				mediaRequestsTimedout: {
					get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
					enumerable: !0
				},
				mediaRequestsErrored: {
					get: () => this.playlistController_.mediaRequestsErrored_() || 0,
					enumerable: !0
				},
				mediaTransferDuration: {
					get: () => this.playlistController_.mediaTransferDuration_() || 0,
					enumerable: !0
				},
				mediaBytesTransferred: {
					get: () => this.playlistController_.mediaBytesTransferred_() || 0,
					enumerable: !0
				},
				mediaSecondsLoaded: {
					get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
					enumerable: !0
				},
				mediaAppends: {
					get: () => this.playlistController_.mediaAppends_() || 0,
					enumerable: !0
				},
				mainAppendsToLoadedData: {
					get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
					enumerable: !0
				},
				audioAppendsToLoadedData: {
					get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
					enumerable: !0
				},
				appendsToLoadedData: {
					get: () => this.playlistController_.appendsToLoadedData_() || 0,
					enumerable: !0
				},
				timeToLoadedData: {
					get: () => this.playlistController_.timeToLoadedData_() || 0,
					enumerable: !0
				},
				buffered: {
					get: () => CG(this.tech_.buffered()),
					enumerable: !0
				},
				currentTime: {
					get: () => this.tech_.currentTime(),
					enumerable: !0
				},
				currentSource: {
					get: () => this.tech_.currentSource_,
					enumerable: !0
				},
				currentTech: {
					get: () => this.tech_.name_,
					enumerable: !0
				},
				duration: {
					get: () => this.tech_.duration(),
					enumerable: !0
				},
				main: {
					get: () => this.playlists.main,
					enumerable: !0
				},
				playerDimensions: {
					get: () => this.tech_.currentDimensions(),
					enumerable: !0
				},
				seekable: {
					get: () => CG(this.tech_.seekable()),
					enumerable: !0
				},
				timestamp: {
					get: () => Date.now(),
					enumerable: !0
				},
				videoPlaybackQuality: {
					get: () => this.tech_.getVideoPlaybackQuality(),
					enumerable: !0
				}
			}), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
				this.options_.useBandwidthFromLocalStorage && lX({
					bandwidth: this.bandwidth,
					throughput: Math.round(this.throughput)
				});
			}), this.playlistController_.on("selectedinitialmedia", () => {
				UY(this);
			}), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
				this.setupEme_();
			}), this.on(this.playlistController_, "progress", function() {
				this.tech_.trigger("progress");
			}), this.on(this.playlistController_, "firstplay", function() {
				this.ignoreNextSeekingEvent_ = !0;
			}), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = X.default.URL.createObjectURL(this.playlistController_.mediaSource), (Y.browser.IS_ANY_SAFARI || Y.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
		}
		createKeySessions_() {
			let e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
			this.logger_("waiting for EME key session creation"), oX({
				player: this.player_,
				sourceKeySystems: this.source_.keySystems,
				audioMedia: e && e.media(),
				mainPlaylists: this.playlists.main.playlists
			}).then(() => {
				this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
			}).catch((e) => {
				this.logger_("error while creating EME key session", e), this.player_.error({
					message: "Failed to initialize media keys for EME",
					code: 3
				});
			});
		}
		handleWaitingForKey_() {
			this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
		}
		setupEme_() {
			let e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, t = sX({
				player: this.player_,
				sourceKeySystems: this.source_.keySystems,
				media: this.playlists.media(),
				audioMedia: e && e.media()
			});
			if (this.player_.tech_.on("keystatuschange", (e) => {
				this.playlistController_.updatePlaylistByKeyStatus(e.keyId, e.status);
			}), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !t) {
				this.playlistController_.sourceUpdater_.initializedEme();
				return;
			}
			this.createKeySessions_();
		}
		setupQualityLevels_() {
			let e = Y.players[this.tech_.options_.playerId];
			!e || !e.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = e.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
				rX(this.qualityLevels_, this);
			}), this.playlists.on("mediachange", () => {
				nX(this.qualityLevels_, this.playlists);
			}));
		}
		static version() {
			return {
				"@videojs/http-streaming": YY,
				"mux.js": XY,
				"mpd-parser": ZY,
				"m3u8-parser": QY,
				"aes-decrypter": $Y
			};
		}
		version() {
			return this.constructor.version();
		}
		canChangeType() {
			return eY.canChangeType();
		}
		play() {
			this.playlistController_.play();
		}
		setCurrentTime(e) {
			this.playlistController_.setCurrentTime(e);
		}
		duration() {
			return this.playlistController_.duration();
		}
		seekable() {
			return this.playlistController_.seekable();
		}
		dispose() {
			this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && X.default.URL.revokeObjectURL && (X.default.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
		}
		convertToProgramTime(e, t) {
			return QK({
				playlist: this.playlistController_.media(),
				time: e,
				callback: t
			});
		}
		seekToProgramTime(e, t, n = !0, r = 2) {
			return $K({
				programTime: e,
				playlist: this.playlistController_.media(),
				retryCount: r,
				pauseAfterSeek: n,
				seekTo: this.options_.seekTo,
				tech: this.options_.tech,
				callback: t
			});
		}
		setupXhrHooks_() {
			this.xhr.onRequest = (e) => {
				dX(this.xhr, e);
			}, this.xhr.onResponse = (e) => {
				fX(this.xhr, e);
			}, this.xhr.offRequest = (e) => {
				pX(this.xhr, e);
			}, this.xhr.offResponse = (e) => {
				mX(this.xhr, e);
			}, this.player_.trigger("xhr-hooks-ready");
		}
		attachStreamingEventListeners_() {
			[
				"seekablerangeschanged",
				"bufferedrangeschanged",
				"contentsteeringloadstart",
				"contentsteeringloadcomplete",
				"contentsteeringparsed"
			].forEach((e) => {
				this.playlistController_.on(e, (e) => {
					this.player_.trigger(wF({}, e));
				});
			}), ["gapjumped", "playedrangeschanged"].forEach((e) => {
				this.playbackWatcher_.on(e, (e) => {
					this.player_.trigger(wF({}, e));
				});
			});
		}
	}, _X = {
		name: "videojs-http-streaming",
		VERSION: YY,
		canHandleSource(e, t = {}) {
			let n = SB(Y.options, t);
			return !n.vhs.experimentalUseMMS && !iI("avc1.4d400d,mp4a.40.2", !1) ? !1 : _X.canPlayType(e.type, n);
		},
		handleSource(e, t, n = {}) {
			let r = SB(Y.options, n);
			return t.vhs = new gX(e, t, r), t.vhs.xhr = MK(), t.vhs.setupXhrHooks_(), t.vhs.src(e.src, e.type), t.vhs;
		},
		canPlayType(e, t) {
			let n = lI(e);
			if (!n) return "";
			let r = _X.getOverrideNative(t);
			return !eX.supportsTypeNatively(n) || r ? "maybe" : "";
		},
		getOverrideNative(e = {}) {
			let { vhs: t = {} } = e, n = !(Y.browser.IS_ANY_SAFARI || Y.browser.IS_IOS), { overrideNative: r = n } = t;
			return r;
		}
	}, vX = () => iI("avc1.4d400d,mp4a.40.2", !0), vX() && Y.getTech("Html5").registerSourceHandler(_X, 0), Y.VhsHandler = gX, Y.VhsSourceHandler = _X, Y.Vhs = eX, Y.use || Y.registerComponent("Vhs", eX), Y.options.vhs = Y.options.vhs || {}, (!Y.getPlugin || !Y.getPlugin("reloadSourceOnError")) && Y.registerPlugin("reloadSourceOnError", JY);
}));
//#endregion
//#region src/components/interview/report/VideoPanel.vue
yX(), Y.registerPlugin && (Y.plugin = Y.registerPlugin), Y.obj?.merge && (Y.mergeOptions = Y.obj.merge), Y.dom?.createEl && (Y.createEl = Y.dom.createEl), (/* @__PURE__ */ s(((e) => {
	(function(t, n) {
		e === void 0 ? (n(t.videojs), t.videojsMarkers = { exports: {} }.exports) : n((yX(), d(WR)));
	})(e, function(e) {
		var t = n(e);
		function n(e) {
			return e && e.__esModule ? e : { default: e };
		}
		var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, i = {
			markerStyle: {
				width: "7px",
				"border-radius": "30%",
				"background-color": "red"
			},
			markerTip: {
				display: !0,
				text: function(e) {
					return "Break: " + e.text;
				},
				time: function(e) {
					return e.time;
				}
			},
			breakOverlay: {
				display: !1,
				displayTime: 3,
				text: function(e) {
					return "Break overlay: " + e.overlayText;
				},
				style: {
					width: "100%",
					height: "20%",
					"background-color": "rgba(0,0,0,0.7)",
					color: "white",
					"font-size": "17px"
				}
			},
			onMarkerClick: function(e) {},
			onMarkerReached: function(e, t) {},
			markers: []
		};
		function a() {
			var e = (/* @__PURE__ */ new Date()).getTime();
			return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
				var n = (e + Math.random() * 16) % 16 | 0;
				return e = Math.floor(e / 16), (t == "x" ? n : n & 3 | 8).toString(16);
			});
		}
		function o(e) {
			var t, n = {
				top: 0,
				bottom: 0,
				left: 0,
				width: 0,
				height: 0,
				right: 0
			};
			try {
				t = e.getBoundingClientRect();
			} catch {
				t = n;
			}
			return t;
		}
		var s = -1;
		function c(e) {
			if (!t.default.mergeOptions) {
				var n = function(e) {
					return !!e && (e === void 0 ? "undefined" : r(e)) === "object" && toString.call(e) === "[object Object]" && e.constructor === Object;
				}, c = function e(t, r) {
					var i = {};
					return [t, r].forEach(function(t) {
						t && Object.keys(t).forEach(function(r) {
							var a = t[r];
							if (!n(a)) {
								i[r] = a;
								return;
							}
							n(i[r]) || (i[r] = {}), i[r] = e(i[r], a);
						});
					}), i;
				};
				t.default.mergeOptions = c;
			}
			t.default.createEl || (t.default.createEl = function(e, n, r) {
				var i = t.default.Player.prototype.createEl(e, n);
				return r && Object.keys(r).forEach(function(e) {
					i.setAttribute(e, r[e]);
				}), i;
			});
			var l = t.default.mergeOptions(i, e), u = {}, d = [], f = s, p = this, m = null, h = null, g = s;
			function _() {
				d.sort(function(e, t) {
					return l.markerTip.time(e) - l.markerTip.time(t);
				});
			}
			function v(e) {
				e.forEach(function(e) {
					e.key = a(), p.el().querySelector(".vjs-progress-holder").appendChild(x(e)), u[e.key] = e, d.push(e);
				}), _();
			}
			function y(e) {
				return l.markerTip.time(e) / p.duration() * 100;
			}
			function b(e, t) {
				t.className = "vjs-marker " + (e.class || ""), Object.keys(l.markerStyle).forEach(function(e) {
					t.style[e] = l.markerStyle[e];
				});
				var n = e.time / p.duration();
				if ((n < 0 || n > 1) && (t.style.display = "none"), t.style.left = y(e) + "%", e.duration) t.style.width = e.duration / p.duration() * 100 + "%", t.style.marginLeft = "0px";
				else {
					var r = o(t);
					t.style.marginLeft = r.width / 2 + "px";
				}
			}
			function x(e) {
				var n = t.default.createEl("div", {}, {
					"data-marker-key": e.key,
					"data-marker-time": l.markerTip.time(e)
				});
				return b(e, n), n.addEventListener("click", function(t) {
					var n = !1;
					if (typeof l.onMarkerClick == "function" && (n = l.onMarkerClick(e) === !1), !n) {
						var r = this.getAttribute("data-marker-key");
						p.currentTime(l.markerTip.time(u[r]));
					}
				}), l.markerTip.display && w(n), n;
			}
			function S(e) {
				d.forEach(function(t) {
					var n = p.el().querySelector(".vjs-marker[data-marker-key='" + t.key + "']"), r = l.markerTip.time(t);
					(e || n.getAttribute("data-marker-time") !== r) && (b(t, n), n.setAttribute("data-marker-time", r));
				}), _();
			}
			function C(e) {
				h && (g = s, h.style.visibility = "hidden"), f = s;
				var t = [];
				e.forEach(function(e) {
					var n = d[e];
					if (n) {
						delete u[n.key], t.push(e);
						var r = p.el().querySelector(".vjs-marker[data-marker-key='" + n.key + "']");
						r && r.parentNode.removeChild(r);
					}
				}), t.reverse(), t.forEach(function(e) {
					d.splice(e, 1);
				}), _();
			}
			function w(e) {
				e.addEventListener("mouseover", function() {
					var t = u[e.getAttribute("data-marker-key")];
					if (m) {
						m.querySelector(".vjs-tip-inner").innerText = l.markerTip.text(t), m.style.left = y(t) + "%";
						var n = o(m), r = o(e);
						m.style.marginLeft = -parseFloat(n.width / 2) + parseFloat(r.width / 4) + "px", m.style.visibility = "visible";
					}
				}), e.addEventListener("mouseout", function() {
					m && (m.style.visibility = "hidden");
				});
			}
			function T() {
				m = t.default.createEl("div", {
					className: "vjs-tip",
					innerHTML: "<div class='vjs-tip-arrow'></div><div class='vjs-tip-inner'></div>"
				}), p.el().querySelector(".vjs-progress-holder").appendChild(m);
			}
			function E() {
				if (!(!l.breakOverlay.display || f < 0)) {
					var e = p.currentTime(), t = d[f], n = l.markerTip.time(t);
					e >= n && e <= n + l.breakOverlay.displayTime ? (g !== f && (g = f, h && (h.querySelector(".vjs-break-overlay-text").innerHTML = l.breakOverlay.text(t))), h && (h.style.visibility = "visible")) : (g = s, h && (h.style.visibility = "hidden"));
				}
			}
			function ee() {
				h = t.default.createEl("div", {
					className: "vjs-break-overlay",
					innerHTML: "<div class='vjs-break-overlay-text'></div>"
				}), Object.keys(l.breakOverlay.style).forEach(function(e) {
					h && (h.style[e] = l.breakOverlay.style[e]);
				}), p.el().appendChild(h), g = s;
			}
			function D() {
				O(), E(), e.onTimeUpdateAfterMarkerUpdate && e.onTimeUpdateAfterMarkerUpdate();
			}
			function O() {
				if (d.length) {
					var t = function(e) {
						return e < d.length - 1 ? l.markerTip.time(d[e + 1]) : p.duration();
					}, n = p.currentTime(), r = s;
					if (f !== s) {
						var i = t(f);
						if (n >= l.markerTip.time(d[f]) && n < i || f === d.length - 1 && n === p.duration()) return;
					}
					if (n < l.markerTip.time(d[0])) r = s;
					else for (var a = 0; a < d.length; a++) if (i = t(a), n >= l.markerTip.time(d[a]) && n < i) {
						r = a;
						break;
					}
					r !== f && (r !== s && e.onMarkerReached && e.onMarkerReached(d[r], r), f = r);
				}
			}
			function te() {
				l.markerTip.display && T(), p.markers.removeAll(), v(l.markers), l.breakOverlay.display && ee(), D(), p.on("timeupdate", D), p.off("loadedmetadata");
			}
			p.on("loadedmetadata", function() {
				te();
			}), p.markers = {
				getMarkers: function() {
					return d;
				},
				next: function() {
					for (var e = p.currentTime(), t = 0; t < d.length; t++) {
						var n = l.markerTip.time(d[t]);
						if (n > e) {
							p.currentTime(n);
							break;
						}
					}
				},
				prev: function() {
					for (var e = p.currentTime(), t = d.length - 1; t >= 0; t--) {
						var n = l.markerTip.time(d[t]);
						if (n + .5 < e) {
							p.currentTime(n);
							return;
						}
					}
				},
				add: function(e) {
					v(e);
				},
				remove: function(e) {
					C(e);
				},
				removeAll: function() {
					for (var e = [], t = 0; t < d.length; t++) e.push(t);
					C(e);
				},
				updateTime: function(e) {
					S(e);
				},
				reset: function(e) {
					p.markers.removeAll(), v(e);
				},
				destroy: function() {
					p.markers.removeAll(), h && h.remove(), m && m.remove(), p.off("timeupdate", E), delete p.markers;
				}
			};
		}
		t.default.plugin("markers", c);
	});
})))(), yX();
var bX = { class: "video-panel h-full" }, xX = {
	key: 0,
	role: "status",
	"aria-live": "polite",
	class: "video-fallback h-full flex flex-col items-center justify-center gap-2"
}, SX = {
	key: 1,
	class: "video-fallback h-full flex flex-col items-center justify-center gap-2"
}, CX = {
	key: 2,
	class: "video-fallback h-full flex flex-col items-center justify-center gap-2 p-4"
}, wX = ["href"], TX = /*#__PURE__*/ pT({
	__name: "VideoPanel",
	props: {
		videoSrc: {
			type: String,
			default: null
		},
		recordings: {
			type: Array,
			default: () => []
		},
		markers: {
			type: Array,
			default: () => []
		},
		rotation: {
			type: Number,
			default: 0
		},
		isLoading: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:rotation", "playback-error"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = /* @__PURE__ */ P(null), o = /* @__PURE__ */ P(!1), s = /* @__PURE__ */ P(0), c = null, l = null, u = null, d = null, f = null, p = null, m = null, h = !1, g = !0;
		function _() {
			return r.recordings.length > 0 ? r.recordings.map((e) => ({
				src: e.recording_url,
				type: e.content_type || "video/webm"
			})) : r.videoSrc ? [{
				src: r.videoSrc,
				type: "video/webm"
			}] : [];
		}
		function v() {
			if (!a.value || l) {
				console.debug("[VideoPanel] setupAudioDownmix skipped — videoEl:", !!a.value, "audioCtx already exists:", !!l);
				return;
			}
			let e = a.value;
			e.crossOrigin = "anonymous", console.debug("[VideoPanel] Setting crossOrigin=\"anonymous\" on <video> element"), l = new (window.AudioContext || window.webkitAudioContext)(), u = l.createMediaElementSource(e), d = l.createChannelSplitter(2), m = l.createChannelMerger(1), f = l.createGain(), f.gain.value = .5, p = l.createGain(), p.gain.value = .5, u.connect(d), d.connect(f, 0), d.connect(p, 1), f.connect(m, 0, 0), p.connect(m, 0, 0), m.connect(l.destination), console.debug("[VideoPanel] Audio downmix pipeline connected (stereo→mono). AudioContext state:", l.state), e.addEventListener("play", y), e.addEventListener("pause", b), e.addEventListener("ended", b);
		}
		function y() {
			console.debug("[VideoPanel] play event — AudioContext state:", l?.state ?? "no audioCtx"), l?.state === "suspended" && l.resume();
		}
		function b() {
			l?.state === "running" && l.suspend();
		}
		function x() {
			a.value && (a.value.removeEventListener("play", y), a.value.removeEventListener("pause", b), a.value.removeEventListener("ended", b)), u?.disconnect(), d?.disconnect(), f?.disconnect(), p?.disconnect(), m?.disconnect(), l?.close(), l = null, u = null, d = null, f = null, p = null, m = null;
		}
		function S() {
			x(), c &&= (c.dispose(), null);
		}
		function C() {
			if (Y.getComponent("RotateButton")) return;
			let e = Y.getComponent("Button");
			class t extends e {
				constructor(e, t) {
					super(e, t), this.addClass("vjs-rotate-button"), this.controlText("Rotate video");
				}
				buildCSSClass() {
					return `vjs-rotate-button ${super.buildCSSClass()}`;
				}
				handleClick() {
					this.options_?.onRotate && this.options_.onRotate();
				}
				createEl() {
					let e = super.createEl(), t = e.querySelector(".vjs-icon-placeholder");
					return t && (t.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8\"/><path d=\"M21 3v5h-5\"/></svg>"), e;
				}
			}
			Y.registerComponent("RotateButton", t);
		}
		function w() {
			let e = ((r.rotation || 0) + 90) % 360;
			T(e), i("update:rotation", e);
		}
		function T(e) {
			let t = c?.el()?.querySelector("video") || a.value;
			t && (t.style.transform = `rotate(${e}deg)`, t.style.transition = "transform 0.3s ease", t.style.transformOrigin = "center center");
		}
		function E() {
			if (c) return;
			let e = _();
			if (!e.length || !a.value) return;
			if (C(), console.debug("[VideoPanel] initPlayer — audioDownmixEnabled:", g), g) try {
				v();
			} catch (e) {
				console.warn("[VideoPanel] setupAudioDownmix threw — disabling downmix:", e), g = !1, x();
			}
			else console.debug("[VideoPanel] Skipping audio downmix (disabled by previous CORS failure)");
			let t = {
				controls: !0,
				responsive: !0,
				fill: !0,
				playbackRates: [
					.5,
					.75,
					1,
					1.25,
					1.5,
					2
				],
				controlBar: {
					children: [
						"playToggle",
						"volumePanel",
						"currentTimeDisplay",
						"timeDivider",
						"durationDisplay",
						"progressControl",
						"RotateButton",
						"playbackRateMenuButton",
						"fullscreenToggle"
					],
					RotateButton: { onRotate: w }
				},
				sources: e
			};
			c = Y(a.value, t), c.on("error", () => {
				let e = c.error();
				if (console.warn("[VideoPanel] player error — code:", e?.code, "message:", e?.message, "audioDownmixEnabled:", g), g && e && (e.code === 2 || e.code === 4)) {
					console.warn("[VideoPanel] CORS failure detected — retrying WITHOUT audio downmix"), g = !1, S(), s.value++, or(() => E());
					return;
				}
				o.value = !0;
			}), c.ready(() => {
				ee(), r.rotation && !h && (h = !0, T(r.rotation));
			});
		}
		function ee() {
			!c || typeof c.markers != "function" || c.markers({
				markers: r.markers || [],
				markerStyle: {
					width: "8px",
					backgroundColor: "red",
					"border-radius": "50%"
				},
				onMarkerClick: (e) => c.currentTime(e.time),
				markerTip: {
					display: !0,
					text: (e) => e.text || ""
				}
			});
		}
		function D(e) {
			c && !o.value && (c.currentTime(e), c.play()?.catch((e) => {
				e?.name !== "AbortError" && (console.warn("[VideoPanel] play() failed —", e?.name, e?.message), i("playback-error", e));
			}));
		}
		function O() {
			c && !c.paused() && c.pause();
		}
		return t({
			jumpToTime: D,
			pause: O
		}), Pr(() => [
			r.videoSrc,
			r.recordings,
			r.isLoading
		], async () => {
			!r.isLoading && _().length > 0 && !c && (await or(), E());
		}, { deep: !0 }), Pr(() => r.markers, (e) => {
			!c || typeof c.markers != "function" || (c.markers.removeAll && c.markers.removeAll(), e?.length && c.markers.add && c.markers.add(e));
		}), Pr(() => r.rotation, (e) => {
			c && T(e);
		}), ra(async () => {
			await or(), _().length > 0 && !c && E();
		}), oa(() => {
			S();
		}), (t, n) => (V(), H("div", bX, [e.isLoading ? (V(), H("div", xX, [G(F(_f), { class: "size-8 text-white/30 animate-spin" }), n[0] ||= W("span", { class: "sr-only" }, "Loading video", -1)])) : !e.videoSrc && e.recordings.length === 0 ? (V(), H("div", SX, [G(F(Pf), { class: "size-8 text-white/30" }), n[1] ||= W("p", { class: "text-sm text-white/40" }, "No video available", -1)])) : o.value ? (V(), H("div", CX, [
			G(F(Pf), { class: "size-8 text-white/30" }),
			n[2] ||= W("p", { class: "text-sm text-white/40" }, "Video cannot be played in this browser", -1),
			W("a", {
				href: e.videoSrc || e.recordings[0] && e.recordings[0].recording_url,
				target: "_blank",
				rel: "noopener noreferrer",
				class: "text-sm text-primary hover:underline"
			}, " Open video in new tab ", 8, wX)
		])) : (V(), H("div", {
			key: s.value,
			class: "video-container"
		}, [W("video", {
			ref_key: "videoEl",
			ref: a,
			class: "video-js",
			preload: "auto"
		}, [...n[3] ||= [W("track", {
			kind: "captions",
			srclang: "en"
		}, null, -1)]], 512)]))]));
	}
}, [["__scopeId", "data-v-df795950"]]), EX = {
	key: 3,
	class: "mt-4"
}, DX = {
	__name: "EmptyState",
	props: {
		title: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: "md",
			validator: (e) => [
				"sm",
				"md",
				"lg"
			].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => ["flex flex-col items-center justify-center text-center", {
			sm: "py-6",
			md: "py-12",
			lg: "py-16"
		}[t.size]]), r = J(() => ["rounded-full bg-muted flex items-center justify-center mb-4", {
			sm: "p-3",
			md: "p-4",
			lg: "p-5"
		}[t.size]]), i = J(() => ["text-placeholder", {
			sm: "size-6",
			md: "size-8",
			lg: "size-10"
		}[t.size]]), a = J(() => ["text-sm font-medium text-body", {
			sm: "mb-0.5",
			md: "mb-1",
			lg: "mb-2"
		}[t.size]]), o = J(() => ["text-muted-foreground", "text-sm"]);
		return (t, s) => (V(), H("div", { class: M(n.value) }, [
			t.$slots.icon ? (V(), H("div", {
				key: 0,
				class: M(r.value)
			}, [z(t.$slots, "icon", { iconClass: i.value.join(" ") })], 2)) : q("", !0),
			e.title ? (V(), H("p", {
				key: 1,
				class: M(a.value)
			}, N(e.title), 3)) : q("", !0),
			e.description ? (V(), H("p", {
				key: 2,
				class: M(o.value)
			}, N(e.description), 3)) : q("", !0),
			t.$slots.actions ? (V(), H("div", EX, [z(t.$slots, "actions")])) : q("", !0)
		], 2));
	}
}, OX = {
	__name: "ScrollBar",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "vertical"
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = eh(t, "class");
		return (r, i) => (V(), U(F(yx), gs(F(n), { class: F(hm)("flex touch-none select-none z-50 transition-opacity duration-150", "data-[state=hidden]:opacity-0 data-[state=visible]:opacity-100", e.orientation === "vertical" && "absolute right-0 top-0 h-full w-2 p-px", e.orientation === "horizontal" && "absolute bottom-0 left-0 h-2 w-full flex-col p-px", t.class) }), {
			default: I(() => [G(F(wx), { class: "relative flex-1 rounded-full bg-foreground/30 hover:bg-foreground/50 transition-colors" })]),
			_: 1
		}, 16, ["class"]));
	}
}, kX = {
	__name: "ScrollArea",
	props: {
		type: {
			type: String,
			required: !1,
			default: "scroll"
		},
		dir: {
			type: String,
			required: !1
		},
		scrollHideDelay: {
			type: Number,
			required: !1,
			default: 600
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		viewportClass: {
			type: null,
			required: !1
		}
	},
	emits: ["scroll"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = eh(n, "class", "viewportClass");
		return (t, a) => (V(), U(F(ex), gs(F(i), { class: F(hm)("relative overflow-hidden", n.class) }), {
			default: I(() => [
				G(F(Tx), {
					class: M(F(hm)("h-full w-full rounded-[inherit]", e.viewportClass)),
					onScroll: a[0] ||= (e) => r("scroll", e)
				}, {
					default: I(() => [z(t.$slots, "default")]),
					_: 3
				}, 8, ["class"]),
				G(OX),
				G(F(nx))
			]),
			_: 3
		}, 16, ["class"]));
	}
}, AX = { class: "flex items-center gap-2" }, jX = { class: "flex gap-2" }, MX = ["data-search-match-active"], NX = {
	__name: "TranscriptEntry",
	props: {
		entry: {
			type: Object,
			required: !0
		},
		allowJump: {
			type: Boolean,
			default: !1
		},
		isHighlighted: {
			type: Boolean,
			default: !1
		},
		searchMatches: {
			type: Array,
			default: () => []
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.entry.is_assistant && n.entry.role === "Assistant" ? "Interviewer" : (n.entry.role || "Candidate").trim().split(" ")[0]), a = J(() => {
			let e = n.entry.text;
			return Array.isArray(e) ? e.join(" ") : e || "";
		}), o = J(() => {
			let e = a.value, t = n.searchMatches;
			if (!t || t.length === 0) return [{
				text: e,
				mark: !1
			}];
			let r = [], i = 0;
			for (let n of t) n.start > i && r.push({
				text: e.slice(i, n.start),
				mark: !1
			}), r.push({
				text: e.slice(n.start, n.end),
				mark: !0,
				isActive: !!n.isActive
			}), i = n.end;
			return i < e.length && r.push({
				text: e.slice(i),
				mark: !1
			}), r;
		}), s = () => {
			n.allowJump && n.entry.seconds !== void 0 && r("jump", n.entry.seconds);
		};
		return (t, n) => (V(), H("div", {
			class: M(["flex flex-col gap-1 -mx-4 px-4 py-1.5 group", e.allowJump ? "cursor-pointer" : ""]),
			onClick: s
		}, [W("div", AX, [
			W("span", { class: M(["text-[14px] tabular-nums shrink-0 w-12", e.allowJump ? "text-muted-foreground group-hover:text-foreground group-hover:underline" : e.entry.is_assistant ? "text-placeholder" : "text-foreground"]) }, N(e.entry.duration), 3),
			W("span", { class: M(["text-[14px] font-semibold", e.entry.is_assistant ? "text-body" : "text-foreground"]) }, N(i.value), 3),
			e.entry.agent_could_not_answer && e.entry.is_assistant ? (V(), U(F(uS), { key: 0 }, {
				default: I(() => [G(F(pS), { "as-child": "" }, {
					default: I(() => [G(F(Qd), { class: "size-4 text-warning-foreground shrink-0" })]),
					_: 1
				}), e.entry.agent_could_not_answer_tooltip ? (V(), U(F(dS), { key: 0 }, {
					default: I(() => [K(N(e.entry.agent_could_not_answer_tooltip), 1)]),
					_: 1
				})) : q("", !0)]),
				_: 1
			})) : q("", !0)
		]), W("div", jX, [n[0] ||= W("div", { class: "shrink-0 w-12" }, null, -1), W("div", { class: M([
			"flex-1 leading-relaxed response-text",
			e.entry.is_assistant ? "text-[14px] text-body rounded-lg" : "text-[14px] p-3 text-foreground",
			!e.entry.is_assistant && e.isHighlighted ? "bg-destructive/5 border-l-2 border-destructive rounded-r-md" : e.entry.is_assistant ? "" : "bg-muted rounded-lg"
		]) }, [(V(!0), H(B, null, R(o.value, (e, t) => (V(), H(B, { key: t }, [e.mark ? (V(), H("mark", {
			key: 0,
			"data-search-match-active": e.isActive ? "true" : null,
			class: M(["rounded-sm px-0.5", e.isActive ? "bg-warning text-warning-foreground" : "bg-warning/30 text-foreground"])
		}, N(e.text), 11, MX)) : (V(), H(B, { key: 1 }, [K(N(e.text), 1)], 64))], 64))), 128))], 2)])], 2));
	}
}, PX = {
	key: 0,
	class: "relative w-full"
}, FX = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Input",
	props: {
		defaultValue: {
			type: [String, Number],
			required: !1
		},
		modelValue: {
			type: [String, Number],
			required: !1
		},
		size: {
			type: String,
			default: "default"
		},
		clearable: {
			type: Boolean,
			default: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = wm("flex w-full rounded-md text-foreground transition-colors file:border-0 file:bg-transparent file:font-medium placeholder:text-placeholder focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-muted! disabled:opacity-50", {
			variants: { size: {
				default: "h-9 px-3 py-1 text-sm file:text-sm",
				sm: "h-8 px-2 py-1 text-sm file:text-sm"
			} },
			defaultVariants: { size: "default" }
		}), r = e, i = kh(r, "modelValue", t, {
			passive: !0,
			defaultValue: r.defaultValue
		}), a = J(() => r.clearable && i.value != null && i.value !== "");
		function o() {
			i.value = "";
		}
		return (t, s) => e.clearable ? (V(), H("div", PX, [wr(W("input", gs(t.$attrs, {
			"onUpdate:modelValue": s[0] ||= (e) => /* @__PURE__ */ _n(i) ? i.value = e : null,
			class: F(hm)(F(n)({ size: e.size }), "pr-8", r.class),
			style: {
				"background-color": "var(--color-form-background)",
				border: "var(--form-border-width) solid var(--color-form-border)",
				"--tw-ring-offset-width": "var(--color-form-focus-ring-offset)"
			}
		}), null, 16), [[Bl, F(i)]]), a.value ? (V(), H("button", {
			key: 0,
			type: "button",
			class: "absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors",
			onClick: o
		}, [G(F(Ff), { class: "size-4" })])) : q("", !0)])) : wr((V(), H("input", gs({ key: 1 }, t.$attrs, {
			"onUpdate:modelValue": s[1] ||= (e) => /* @__PURE__ */ _n(i) ? i.value = e : null,
			class: F(hm)(F(n)({ size: e.size }), r.class),
			style: {
				"background-color": "var(--color-form-background)",
				border: "var(--form-border-width) solid var(--color-form-border)",
				"--tw-ring-offset-width": "var(--color-form-focus-ring-offset)"
			}
		}), null, 16)), [[Bl, F(i)]]);
	}
}), IX = { class: "flex items-center gap-2 min-w-0" }, LX = { class: "relative min-w-0 w-64" }, RX = {
	key: 0,
	class: "absolute right-10 top-1/2 -translate-y-1/2 text-xs text-placeholder tabular-nums pointer-events-none z-10",
	"aria-live": "polite"
}, zX = { class: "flex items-center shrink-0" }, BX = {
	__name: "TranscriptSearchBar",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		currentMatch: {
			type: Number,
			default: 0
		},
		totalMatches: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:modelValue",
		"next",
		"previous"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J({
			get: () => n.modelValue,
			set: (e) => r("update:modelValue", e)
		});
		function a(e) {
			n.totalMatches && (e.shiftKey ? r("previous") : r("next"));
		}
		function o() {
			i.value = "";
		}
		return (t, n) => (V(), H("div", IX, [W("div", LX, [
			G(F(Cf), { class: "absolute left-2 top-1/2 -translate-y-1/2 size-4 text-placeholder z-10 pointer-events-none" }),
			G(F(FX), {
				modelValue: i.value,
				"onUpdate:modelValue": n[0] ||= (e) => i.value = e,
				disabled: e.disabled,
				size: "sm",
				clearable: "",
				placeholder: "Find in transcript",
				class: "pl-7 pr-28",
				"aria-label": "Find in transcript",
				onKeydown: [Jl(Kl(a, ["prevent"]), ["enter"]), Jl(Kl(o, ["prevent"]), ["escape"])]
			}, null, 8, [
				"modelValue",
				"disabled",
				"onKeydown"
			]),
			e.totalMatches ? (V(), H("span", RX, N(e.currentMatch) + " of " + N(e.totalMatches), 1)) : q("", !0)
		]), W("div", zX, [G(F(Jx), {
			variant: "ghost",
			size: "icon-sm",
			disabled: e.disabled || !e.totalMatches,
			"aria-label": "Previous match",
			onClick: n[1] ||= (e) => r("previous")
		}, {
			default: I(() => [G(F(Zd), { class: "size-4" })]),
			_: 1
		}, 8, ["disabled"]), G(F(Jx), {
			variant: "ghost",
			size: "icon-sm",
			disabled: e.disabled || !e.totalMatches,
			"aria-label": "Next match",
			onClick: n[2] ||= (e) => r("next")
		}, {
			default: I(() => [G(F(Yd), { class: "size-4" })]),
			_: 1
		}, 8, ["disabled"])])]));
	}
}, VX = /[.*+?^${}()|[\]\\]/g, HX = 150, UX = 2;
function WX(e) {
	return e.replace(VX, "\\$&");
}
function GX(e) {
	let t = e?.text;
	return Array.isArray(t) ? t.join(" ") : t || "";
}
function KX(e) {
	let t = /* @__PURE__ */ P(""), n = /* @__PURE__ */ P(""), r = /* @__PURE__ */ P(0), i = nh((e) => {
		n.value = e;
	}, HX);
	Pr(t, (e) => {
		i(e);
	});
	let a = J(() => {
		let t = n.value.trim();
		if (t.length < UX) return [];
		let r = e.value || [];
		if (!r.length) return [];
		let i = new RegExp(WX(t), "gi"), a = [];
		return r.forEach((e, t) => {
			let n = GX(e);
			if (!n) return;
			i.lastIndex = 0;
			let r;
			for (; (r = i.exec(n)) !== null;) a.push({
				entryIndex: t,
				start: r.index,
				end: r.index + r[0].length
			}), r[0].length === 0 && (i.lastIndex += 1);
		}), a;
	}), o = J(() => a.value.length), s = J(() => o.value ? r.value + 1 : 0), c = J(() => {
		let e = /* @__PURE__ */ new Map(), t = r.value;
		return a.value.forEach((n, r) => {
			let i = e.get(n.entryIndex) || [];
			i.push({
				start: n.start,
				end: n.end,
				isActive: r === t
			}), e.set(n.entryIndex, i);
		}), e;
	});
	function l() {
		o.value && (r.value = (r.value + 1) % o.value);
	}
	function u() {
		o.value && (r.value = (r.value - 1 + o.value) % o.value);
	}
	function d() {
		t.value = "", n.value = "", r.value = 0;
	}
	return Pr([n, () => e.value], () => {
		r.value = 0;
	}), {
		query: t,
		debouncedQuery: n,
		activeIndex: r,
		matches: a,
		matchesByEntry: c,
		totalMatches: o,
		currentMatchNumber: s,
		next: l,
		previous: u,
		reset: d
	};
}
//#endregion
//#region src/components/interview/report/TranscriptPanel.vue
var qX = { class: "flex items-center gap-2 shrink-0" }, JX = { class: "flex items-center gap-2 min-w-0" }, YX = {
	key: 0,
	class: "space-y-2 shrink-0"
}, XX = {
	key: 0,
	"data-testid": "confirmation-note",
	class: "rounded-lg bg-muted p-3 text-sm"
}, ZX = { class: "ml-1" }, QX = { class: "pb-4" }, $X = {
	key: 1,
	class: "space-y-2 mb-2"
}, eZ = {
	key: 0,
	"data-testid": "confirmation-note",
	class: "rounded-lg bg-muted p-3 text-sm"
}, tZ = { class: "ml-1" }, nZ = {
	key: 1,
	class: "space-y-4"
}, rZ = {
	key: 2,
	class: "flex items-center gap-3 text-destructive"
}, iZ = {
	key: 4,
	class: "flex flex-col gap-2"
}, aZ = {
	__name: "TranscriptPanel",
	props: {
		transcription: {
			type: Array,
			default: () => []
		},
		languages: {
			type: Array,
			default: () => []
		},
		selectedLanguage: {
			type: String,
			default: "en"
		},
		isLoading: {
			type: Boolean,
			default: !1
		},
		isTranslating: {
			type: Boolean,
			default: !1
		},
		error: {
			type: String,
			default: null
		},
		unconfirmedTranscription: {
			type: Boolean,
			default: !1
		},
		confirmationMessage: {
			type: Object,
			default: null
		},
		allowJump: {
			type: Boolean,
			default: !0
		},
		scrollToSeconds: {
			type: Number,
			default: null
		},
		hideHeader: {
			type: Boolean,
			default: !1
		},
		hideTitleBar: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["languageChange", "jump"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = J(() => r.languages.find((e) => e.codename === r.selectedLanguage)?.name || "Language"), o = (e) => {
			i("languageChange", e);
		}, s = (e) => {
			i("jump", e);
		}, c = J(() => r.transcription.map((e, t) => {
			if (t === 0) return e;
			let n = r.transcription[t - 1], i = n && !n.is_assistant && n.agent_could_not_answer;
			return e.is_assistant && i ? {
				...e,
				agent_could_not_answer: !0,
				agent_could_not_answer_tooltip: e.agent_could_not_answer_tooltip || n.agent_could_not_answer_tooltip
			} : e;
		})), l = /* @__PURE__ */ P(null), u = /* @__PURE__ */ P({}), { query: d, matches: f, matchesByEntry: p, totalMatches: m, currentMatchNumber: h, activeIndex: g, next: _, previous: v, reset: y } = KX(c), b = J(() => !r.isLoading && !r.isTranslating && !r.error && !r.unconfirmedTranscription && c.value.length > 0), x = (e, t) => {
			e && (u.value ||= {}, u.value[t] = e);
		};
		function S(e) {
			let t = 0, n = Infinity;
			return r.transcription.forEach((r, i) => {
				let a = r.seconds;
				if (a !== void 0) {
					let r = e - a;
					r >= 0 && r < n && (n = r, t = i);
				}
			}), t;
		}
		function C() {
			l.value = null;
		}
		function w(e) {
			let t = u.value[e];
			t?.$el && (l.value = e, t.$el.scrollIntoView({
				behavior: "smooth",
				block: "center"
			}));
		}
		let T = async (e) => {
			if (!r.transcription || r.transcription.length === 0) return;
			let t = S(e);
			await or(), w(t);
		};
		Pr([() => r.scrollToSeconds, () => r.transcription.length], async ([e, t]) => {
			e == null || !t || (await or(), w(S(e)));
		}, {
			immediate: !0,
			flush: "post"
		}), Pr([() => g.value, () => f.value.length], async () => {
			if (!f.value.length) return;
			await or();
			let e = f.value[g.value]?.entryIndex;
			if (e == null) return;
			let t = u.value[e]?.$el;
			(t?.querySelector("[data-search-match-active=\"true\"]") || t)?.scrollIntoView({
				behavior: "smooth",
				block: "center"
			});
		});
		let E = /* @__PURE__ */ P(null), ee = /* @__PURE__ */ P(!1), D = null, O = null, te = null, k = null, ne = /* @__PURE__ */ P(null), re = /* @__PURE__ */ P(0), ie = null;
		function ae() {
			re.value = r.hideHeader ? 0 : ne.value?.offsetHeight ?? 0;
		}
		function A() {
			let e = D?.scrollTop ?? 0, t = O?.scrollTop ?? 0;
			ee.value = e > 0 || t > 0;
		}
		function oe() {
			D = E.value?.querySelector("[data-reka-scroll-area-viewport]"), D && (te = A, D.addEventListener("scroll", te, { passive: !0 })), O = E.value?.closest(".overflow-y-auto"), O && (k = A, O.addEventListener("scroll", k, { passive: !0 })), A();
		}
		return ra(() => {
			oe(), ae(), ne.value && typeof ResizeObserver < "u" && (ie = new ResizeObserver(ae), ie.observe(ne.value));
		}), oa(() => {
			D && te && D.removeEventListener("scroll", te), O && k && O.removeEventListener("scroll", k), ie?.disconnect();
		}), t({
			scrollToTimestamp: T,
			clearHighlight: C,
			resetSearch: y,
			searchQuery: d,
			totalMatches: m,
			currentMatchNumber: h,
			nextMatch: _,
			previousMatch: v,
			searchAvailable: b
		}), (t, n) => (V(), H("div", {
			ref_key: "rootEl",
			ref: E,
			class: "flex flex-col gap-2 h-full"
		}, [
			!e.hideHeader && !e.hideTitleBar ? (V(), H("div", {
				key: 0,
				ref_key: "headerEl",
				ref: ne,
				class: M(["transcript-sticky-header relative sticky top-0 z-20 bg-card flex items-center justify-between shrink-0 gap-3 px-4 py-3 border-b transition-colors before:content-[''] before:absolute before:left-0 before:right-0 before:bottom-full before:h-6 before:bg-card", ee.value ? "border-border-light" : "border-transparent"])
			}, [W("div", qX, [G(F(Rf), { class: "size-5 text-foreground" }), n[2] ||= W("h2", { class: "text-base text-foreground" }, "Transcript", -1)]), W("div", JX, [b.value ? (V(), U(BX, {
				key: 0,
				modelValue: F(d),
				"onUpdate:modelValue": n[0] ||= (e) => /* @__PURE__ */ _n(d) ? d.value = e : null,
				"current-match": F(h),
				"total-matches": F(m),
				onNext: F(_),
				onPrevious: F(v)
			}, null, 8, [
				"modelValue",
				"current-match",
				"total-matches",
				"onNext",
				"onPrevious"
			])) : q("", !0), r.languages.length > 1 ? (V(), U(F(gk), { key: 1 }, {
				default: I(() => [G(F(xk), { "as-child": "" }, {
					default: I(() => [G(F(Jx), {
						variant: "outline",
						size: "sm",
						class: "h-8 gap-2 font-normal",
						disabled: r.isTranslating
					}, {
						default: I(() => [
							G(F(mf), { class: "size-4" }),
							W("span", null, N(a.value), 1),
							G(F(Yd), { class: "size-3 text-body" })
						]),
						_: 1
					}, 8, ["disabled"])]),
					_: 1
				}), G(F(yk), { align: "end" }, {
					default: I(() => [(V(!0), H(B, null, R(r.languages, (e) => (V(), U(F(bk), {
						key: e.codename,
						class: "flex items-center justify-between gap-4",
						onClick: (t) => o(e.codename)
					}, {
						default: I(() => [W("span", null, N(e.name || e.codename), 1), r.selectedLanguage === e.codename ? (V(), U(F(Jd), {
							key: 0,
							class: "size-4 text-primary"
						})) : q("", !0)]),
						_: 2
					}, 1032, ["onClick"]))), 128))]),
					_: 1
				})]),
				_: 1
			})) : q("", !0)])], 2)) : q("", !0),
			e.hideHeader ? q("", !0) : (V(), H(B, { key: 1 }, [z(t.$slots, "after-header", { stickyTop: re.value }), e.confirmationMessage ? (V(), H("div", YX, [G(F(xE), {
				"data-testid": "confirmation-banner",
				variant: e.confirmationMessage.variant === "warning" ? "warning" : "success"
			}, {
				default: I(() => [e.confirmationMessage.variant === "warning" ? (V(), U(F(Qd), {
					key: 0,
					class: "size-4"
				})) : (V(), U(F(ef), {
					key: 1,
					class: "size-4"
				})), W("span", null, N(e.confirmationMessage.text), 1)]),
				_: 1
			}, 8, ["variant"]), e.confirmationMessage.note ? (V(), H("div", XX, [n[3] ||= W("span", { class: "font-semibold" }, "Note:", -1), W("span", ZX, "\"" + N(e.confirmationMessage.note) + "\"", 1)])) : q("", !0)])) : q("", !0)], 64)),
			G(F(kX), { class: "flex-1 px-4" }, {
				default: I(() => [W("div", QX, [e.hideHeader ? (V(), H(B, { key: 0 }, [
					b.value ? (V(), U(BX, {
						key: 0,
						modelValue: F(d),
						"onUpdate:modelValue": n[1] ||= (e) => /* @__PURE__ */ _n(d) ? d.value = e : null,
						"current-match": F(h),
						"total-matches": F(m),
						class: M(["sticky top-0 z-20 bg-background py-2 mb-2", ee.value && "border-b border-border"]),
						onNext: F(_),
						onPrevious: F(v)
					}, null, 8, [
						"modelValue",
						"current-match",
						"total-matches",
						"class",
						"onNext",
						"onPrevious"
					])) : q("", !0),
					z(t.$slots, "after-header", { stickyTop: 0 }),
					e.confirmationMessage ? (V(), H("div", $X, [G(F(xE), {
						"data-testid": "confirmation-banner",
						variant: e.confirmationMessage.variant === "warning" ? "warning" : "success"
					}, {
						default: I(() => [e.confirmationMessage.variant === "warning" ? (V(), U(F(Qd), {
							key: 0,
							class: "size-4"
						})) : (V(), U(F(ef), {
							key: 1,
							class: "size-4"
						})), W("span", null, N(e.confirmationMessage.text), 1)]),
						_: 1
					}, 8, ["variant"]), e.confirmationMessage.note ? (V(), H("div", eZ, [n[4] ||= W("span", { class: "font-semibold" }, "Note:", -1), W("span", tZ, "\"" + N(e.confirmationMessage.note) + "\"", 1)])) : q("", !0)])) : q("", !0)
				], 64)) : q("", !0), r.isLoading || r.isTranslating ? (V(), H("div", nZ, [(V(), H(B, null, R(5, (e) => W("div", {
					key: e,
					class: "space-y-2"
				}, [
					G(F(xm), { class: "h-4 w-16" }),
					G(F(xm), { class: "h-4 w-24" }),
					G(F(xm), { class: "h-16 w-full" })
				])), 64))])) : r.error ? (V(), H("div", rZ, [G(F(Qd), { class: "size-5" }), W("p", null, N(r.error), 1)])) : r.unconfirmedTranscription ? (V(), U(F(DX), {
					key: 3,
					title: "The transcription and quotes won't appear.",
					description: "The interview was completed, but the candidate didn't confirm the transcription.",
					size: "lg"
				}, {
					icon: I(({ iconClass: e }) => [G(F(xf), { class: M(e) }, null, 8, ["class"])]),
					_: 1
				})) : (V(), H("div", iZ, [(V(!0), H(B, null, R(c.value, (e, t) => (V(), U(NX, {
					key: e.timestamp || t,
					ref_for: !0,
					ref: (e) => x(e, t),
					entry: e,
					"allow-jump": r.allowJump,
					"is-highlighted": l.value === t,
					"search-matches": F(p).get(t) || [],
					onJump: s
				}, null, 8, [
					"entry",
					"allow-jump",
					"is-highlighted",
					"search-matches"
				]))), 128)), r.transcription.length === 0 ? (V(), U(F(DX), {
					key: 0,
					title: "No transcript available"
				}, {
					icon: I(({ iconClass: e }) => [G(F(xf), { class: M(e) }, null, 8, ["class"])]),
					_: 1
				})) : q("", !0)]))])]),
				_: 3
			})
		], 512));
	}
};
//#endregion
//#region src/services/core/widgetApiFetch.js
function oZ(e, t) {
	return !e || typeof e != "object" || Array.isArray(e) ? `API Error: ${t}` : e.detail || e.message || e.error || (Array.isArray(e.non_field_errors) ? e.non_field_errors[0] : null) || `API Error: ${t}`;
}
function sZ(e) {
	let t = e.trim().slice(0, 64).toLowerCase();
	return t.startsWith("<!doctype") || t.startsWith("<html");
}
function cZ(e, t, n) {
	return sZ(e) ? `Expected JSON but received HTML (status ${t}, content-type ${n || "unknown"}). This usually means the request hit a login page, a CORS proxy, or a gateway error — verify apiHost points to the API root and bearerToken is valid.` : `Expected JSON but received "${e.length > 120 ? `${e.slice(0, 120)}…` : e}" (status ${t}, content-type ${n || "unknown"}).`;
}
async function lZ(e) {
	let t = e.headers.get("content-type") || "", n = await e.text().catch(() => "");
	if (t.includes("application/json") && n) try {
		return {
			message: oZ(JSON.parse(n), e.status),
			raw: n
		};
	} catch {}
	if (n && sZ(n)) return {
		message: cZ(n, e.status, t),
		raw: n
	};
	if (n) {
		let t = n.length > 200 ? `${n.slice(0, 200)}…` : n;
		return {
			message: `API Error ${e.status}: ${t}`,
			raw: n
		};
	}
	return {
		message: `API Error ${e.status}`,
		raw: ""
	};
}
async function uZ(e, t, n = {}) {
	if (!t?.apiHost) throw Error("CrosschqWidget: apiHost is required");
	if (!t?.bearerToken) throw Error("CrosschqWidget: bearerToken is required");
	let r = `${t.apiHost.replace(/\/$/, "")}${e.startsWith("/") ? e : `/${e}`}`, i = {
		"Content-Type": "application/json",
		Authorization: `Bearer ${t.bearerToken}`,
		...n.headers
	}, a;
	try {
		a = await fetch(r, {
			...n,
			headers: i
		});
	} catch (e) {
		let t = /* @__PURE__ */ Error(`Network error calling ${r}: ${e.message}. Possible causes: CORS not configured for this origin, apiHost unreachable, or DNS failure.`);
		throw t.cause = e, t.status = 0, t;
	}
	if (!a.ok) {
		let { message: e, raw: t } = await lZ(a), n = Error(e);
		throw n.status = a.status, n.responseBody = t, n;
	}
	if (a.status === 204) return null;
	let o = a.headers.get("content-type") || "", s = await a.text();
	if (!s) return null;
	if (o.includes("application/json")) try {
		return JSON.parse(s);
	} catch (e) {
		let t = /* @__PURE__ */ Error(`API claimed JSON but body was not parseable: ${e.message}. First 200 chars: ${s.slice(0, 200)}`);
		throw t.status = a.status, t;
	}
	try {
		return JSON.parse(s);
	} catch {
		if (sZ(s)) {
			let e = Error(cZ(s, a.status, o));
			throw e.status = a.status, e.responseBody = s, e;
		}
		return s;
	}
}
//#endregion
//#region src/utils/transcription/transcriptionProcessing.js
function dZ(e, t = "ai") {
	return e.reduce((e, n) => {
		let r = e.length > 0 ? e[e.length - 1] : null;
		if (t === "human" ? r && r.role === n.role : r && r.is_assistant === n.is_assistant) return r.text.push(n.text), n.agent_could_not_answer && (r.agent_could_not_answer = !0, !r.agent_could_not_answer_tooltip && n.agent_could_not_answer_tooltip && (r.agent_could_not_answer_tooltip = n.agent_could_not_answer_tooltip)), e;
		let i = (n.duration || "").split(":").map((e) => Number(e) || 0), a = 0;
		return a = i.length === 3 ? i[0] * 3600 + i[1] * 60 + i[2] : (i[0] || 0) * 60 + (i[1] || 0), [...e, {
			...n,
			text: [n.text],
			seconds: a
		}];
	}, []);
}
//#endregion
//#region src/widget/composables/useWidgetConfig.js
var fZ = "cq:widget-config";
function pZ() {
	let e = Dr(fZ);
	if (!e) throw Error("useWidgetConfig() must be used inside <WidgetShell>");
	return e;
}
//#endregion
//#region src/widget/composables/useWidgetTranscription.js
function mZ(e) {
	let t = pZ(), n = J(() => t.transcriptionData || null), r = J(() => !!(t.apiHost && t.bearerToken)), i = J(() => !n.value && r.value), a = Md({
		queryKey: [
			"cq-widget",
			"transcription",
			e
		],
		queryFn: () => uZ(`/v2/interviews/${e}/transcription`, t),
		enabled: i,
		staleTime: 6e4,
		retry: !1
	}), o = J(() => n.value || a.data?.value || null), s = J(() => o.value?.interview_type || "ai"), c = J(() => {
		let e = o.value?.transcription;
		return !Array.isArray(e) || e.length === 0 ? [] : dZ(e, s.value);
	}), l = J(() => {
		let e = o.value?.recording_urls;
		return Array.isArray(e) ? e.map((e) => ({
			recording_url: e,
			content_type: "video/webm"
		})) : [];
	}), u = J(() => l.value.length > 0 ? l.value[0].recording_url : o.value?.recording_url || null), d = J(() => s.value === "human" ? [] : c.value.filter((e) => e.is_assistant).map((e) => ({
		time: e.seconds,
		text: e.duration
	}))), f = J(() => o.value?.recording_rotation || 0), p = J(() => {
		let e = o.value;
		if (!e) return !1;
		let t = Array.isArray(e.transcription) && e.transcription.length > 0, n = !!e.recording_url || Array.isArray(e.recording_urls) && e.recording_urls.length > 0;
		return t || n;
	}), m = J(() => n.value ? p.value : r.value ? a.isLoading?.value ? !0 : !a.error?.value && p.value : !1);
	return {
		transcription: c,
		videoSrc: u,
		recordings: l,
		markers: d,
		recordingRotation: f,
		interviewType: s,
		isLoading: J(() => !n.value && !!a.isLoading?.value),
		error: J(() => n.value ? null : a.error?.value || null),
		isAvailable: m,
		refetch: a.refetch || (() => Promise.resolve())
	};
}
//#endregion
//#region src/widget/EmbeddedVideoTranscript.vue
var hZ = { class: "space-y-4" }, gZ = {
	key: 0,
	role: "status",
	"aria-busy": "true",
	"aria-live": "polite",
	"aria-label": "Loading transcription",
	class: "space-y-4"
}, _Z = { class: "space-y-3" }, vZ = {
	key: 1,
	role: "alert",
	class: "text-center py-12"
}, yZ = { class: "text-body mt-1" }, bZ = { class: "video-wrapper" }, xZ = /*#__PURE__*/ pT({
	__name: "EmbeddedVideoTranscript",
	props: {
		id: {
			type: String,
			required: !0
		},
		scrollToSeconds: {
			type: Number,
			default: null
		}
	},
	setup(e) {
		let { transcription: t, videoSrc: n, recordings: r, markers: i, recordingRotation: a, isLoading: o, error: s, refetch: c } = mZ(e.id), l = /* @__PURE__ */ P(null);
		function u(e) {
			l.value?.jumpToTime?.(e);
		}
		return (d, f) => (V(), H("div", hZ, [F(o) ? (V(), H("div", gZ, [G(F(xm), { class: "w-full aspect-video rounded-lg" }), W("div", _Z, [(V(), H(B, null, R(4, (e) => G(F(xm), {
			key: e,
			class: "h-12 w-full rounded"
		})), 64))])])) : F(s) ? (V(), H("div", vZ, [
			G(F(Qd), { class: "h-12 w-12 mx-auto text-destructive mb-4" }),
			f[1] ||= W("h2", { class: "text-lg font-semibold" }, "Unable to load transcription", -1),
			W("p", yZ, N(F(s).message || "Failed to load transcription"), 1),
			G(F(Jx), {
				class: "mt-4",
				onClick: F(c)
			}, {
				default: I(() => [...f[0] ||= [K("Retry", -1)]]),
				_: 1
			}, 8, ["onClick"])
		])) : (V(), H(B, { key: 2 }, [W("div", bZ, [G(TX, {
			ref_key: "videoPanelRef",
			ref: l,
			"video-src": F(n),
			recordings: F(r),
			markers: F(i),
			rotation: F(a),
			"is-loading": !1
		}, null, 8, [
			"video-src",
			"recordings",
			"markers",
			"rotation"
		])]), G(aZ, {
			transcription: F(t),
			languages: [],
			"selected-language": "en",
			"is-loading": !1,
			"is-translating": !1,
			error: null,
			"allow-jump": !0,
			"scroll-to-seconds": e.scrollToSeconds,
			"hide-header": "",
			onJump: u
		}, null, 8, ["transcription", "scroll-to-seconds"])], 64))]));
	}
}, [["__scopeId", "data-v-0a67b01c"]]);
//#endregion
//#region src/widget/composables/useWidgetReport.js
function SZ(e) {
	let t = pZ();
	return t.reportData == null ? Md({
		queryKey: [
			"cq-widget",
			"report",
			e
		],
		queryFn: () => uZ(`/interviews/${e}/report/`, t),
		staleTime: 6e4,
		retry: !1
	}) : {
		data: /* @__PURE__ */ An(t, "reportData"),
		isLoading: /* @__PURE__ */ P(!1),
		error: /* @__PURE__ */ P(null),
		refetch: () => Promise.resolve()
	};
}
//#endregion
//#region src/widget/EmbeddedReport.vue
var CZ = { class: "space-y-4" }, wZ = {
	key: 0,
	role: "status",
	"aria-busy": "true",
	"aria-live": "polite",
	"aria-label": "Loading interview report",
	class: "space-y-4"
}, TZ = { class: "flex flex-wrap items-stretch gap-4 mb-6" }, EZ = { class: "flex items-center gap-2 pb-3 mb-3 border-b border-border" }, DZ = { class: "space-y-4" }, OZ = {
	key: 1,
	role: "alert",
	class: "text-center py-12"
}, kZ = { class: "text-body mt-1" }, AZ = { class: "cq-tab-header flex items-center justify-between pb-4 mb-4 border-b border-border-light" }, jZ = {
	key: 0,
	class: "cq-tab-header__date text-sm"
}, MZ = { class: "ml-2 font-medium text-foreground" }, NZ = { class: "space-y-6" }, PZ = {
	key: 0,
	class: "flex items-center justify-end pb-4 mb-4 border-b border-border-light text-sm"
}, FZ = { class: "ml-2 font-medium text-foreground" }, IZ = { class: "space-y-6" }, LZ = {
	__name: "EmbeddedReport",
	props: { id: {
		type: String,
		required: !0
	} },
	setup(e) {
		let t = (e, { attrs: t }) => Hs(Rf, {
			mono: !0,
			...t
		}), n = e, { data: r, isLoading: i, error: a, refetch: o } = SZ(n.id), { isAvailable: s } = mZ(n.id), c = J(() => r.value?.report_data?.sections || []), l = J(() => r.value?.completed_at || r.value?.interview_details?.completed_at || null), u = /* @__PURE__ */ P("report"), d = /* @__PURE__ */ P(null);
		function f(e) {
			s.value && (d.value = e, u.value = "video");
		}
		return (n, p) => (V(), H("div", CZ, [F(i) ? (V(), H("div", wZ, [G(F(_m), null, {
			default: I(() => [G(F(vm), null, {
				default: I(() => [
					W("div", TZ, [(V(), H(B, null, R(4, (e) => W("div", {
						key: `kpi-${e}`,
						class: "flex-1 min-w-[5rem] space-y-2"
					}, [
						G(F(xm), { class: "h-3 w-full max-w-24" }),
						G(F(xm), { class: "h-7 w-16" }),
						G(F(xm), { class: "h-3 w-full max-w-20" })
					])), 64))]),
					G(F(xm), { class: "h-28 w-full rounded-xl mb-6" }),
					(V(), H(B, null, R(3, (e) => W("div", {
						key: `section-${e}`,
						class: "mb-4"
					}, [G(F(_m), { bordered: "" }, {
						default: I(() => [G(F(vm), null, {
							default: I(() => [W("div", EZ, [G(F(xm), { class: "size-5 rounded" }), G(F(xm), { class: "h-4 w-40 max-w-full" })]), W("div", DZ, [(V(), H(B, null, R(2, (t) => W("div", {
								key: `row-${e}-${t}`,
								class: "flex gap-4"
							}, [G(F(xm), { class: "h-4 flex-1" }), G(F(xm), { class: "h-4 flex-1" })])), 64))])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)])), 64))
				]),
				_: 1
			})]),
			_: 1
		})])) : F(a) ? (V(), H("div", OZ, [
			G(F(Qd), { class: "h-12 w-12 mx-auto text-destructive mb-4" }),
			p[2] ||= W("h2", { class: "text-lg font-semibold" }, "Unable to load report", -1),
			W("p", kZ, N(F(a).message || "Failed to load report"), 1),
			G(F(Jx), {
				class: "mt-4",
				onClick: F(o)
			}, {
				default: I(() => [...p[1] ||= [K("Retry", -1)]]),
				_: 1
			}, 8, ["onClick"])
		])) : F(r) ? (V(), H(B, { key: 2 }, [F(s) ? (V(), U(F(Xx), {
			key: 0,
			modelValue: u.value,
			"onUpdate:modelValue": p[0] ||= (e) => u.value = e
		}, {
			default: I(() => [G(F(_m), null, {
				default: I(() => [G(F(vm), null, {
					default: I(() => [
						W("div", AZ, [G(F(Qx), { class: "cq-tab-header__tabs" }, {
							default: I(() => [G(F(eS), {
								value: "report",
								icon: F(sf)
							}, {
								default: I(() => [...p[3] ||= [K(" Scorecard ", -1)]]),
								_: 1
							}, 8, ["icon"]), G(F(eS), {
								value: "video",
								icon: t
							}, {
								default: I(() => [...p[4] ||= [K(" Video & Transcript ", -1)]]),
								_: 1
							})]),
							_: 1
						}), l.value ? (V(), H("div", jZ, [p[5] ||= W("span", { class: "text-body" }, "Completion Date:", -1), W("span", MZ, N(l.value), 1)])) : q("", !0)]),
						G(F(Zx), {
							value: "report",
							class: "mt-0"
						}, {
							default: I(() => [W("div", NZ, [(V(!0), H(B, null, R(c.value, (e, t) => (V(), U(uF, {
								key: t,
								section: e,
								onJump: f
							}, null, 8, ["section"]))), 128))])]),
							_: 1
						}),
						G(F(Zx), {
							value: "video",
							class: "mt-0"
						}, {
							default: I(() => [G(xZ, {
								id: e.id,
								"scroll-to-seconds": d.value
							}, null, 8, ["id", "scroll-to-seconds"])]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])) : (V(), U(F(_m), { key: 1 }, {
			default: I(() => [G(F(vm), null, {
				default: I(() => [l.value ? (V(), H("div", PZ, [p[6] ||= W("span", { class: "text-body" }, "Completion Date:", -1), W("span", FZ, N(l.value), 1)])) : q("", !0), W("div", IZ, [(V(!0), H(B, null, R(c.value, (e, t) => (V(), U(uF, {
					key: t,
					section: e
				}, null, 8, ["section"]))), 128))])]),
				_: 1
			})]),
			_: 1
		}))], 64)) : q("", !0)]));
	}
}, RZ = {
	class: "crosschq-widget",
	"data-cq-widget": ""
}, zZ = {
	__name: "WidgetShell",
	props: {
		interviewId: {
			type: String,
			required: !0
		},
		apiHost: {
			type: String,
			default: null
		},
		bearerToken: {
			type: String,
			default: null
		},
		reportData: {
			type: Object,
			default: null
		},
		transcriptionData: {
			type: Object,
			default: null
		}
	},
	setup(e) {
		let t = e, n = /* @__PURE__ */ rn({
			apiHost: t.apiHost,
			bearerToken: t.bearerToken,
			reportData: t.reportData,
			transcriptionData: t.transcriptionData
		});
		return jr(() => {
			n.apiHost = t.apiHost, n.bearerToken = t.bearerToken, n.reportData = t.reportData, n.transcriptionData = t.transcriptionData;
		}), Er(fZ, n), (t, n) => (V(), H("div", RZ, [G(LZ, { id: e.interviewId }, null, 8, ["id"])]));
	}
}, BZ = "0.5.0";
function VZ(e = {}) {
	let { interviewID: t, target: n, reportData: r, transcriptionData: i, apiHost: a, bearerToken: o } = e;
	if (!t) throw Error("CrosschqWidget.render: interviewID is required");
	if (!n) throw Error("CrosschqWidget.render: target is required");
	let s = r != null, c = i != null, l = !!(a && o);
	if (!s && !l) throw Error("CrosschqWidget.render: provide either reportData (push mode) or apiHost + bearerToken (pull mode)");
	let u = new kd({ defaultOptions: { queries: {
		staleTime: 6e4,
		retry: !1,
		refetchOnWindowFocus: !1
	} } }), d = nu(zZ, {
		interviewId: t,
		apiHost: l ? a : null,
		bearerToken: l ? o : null,
		reportData: s ? r : null,
		transcriptionData: c ? i : null
	}), f = document.createElement("div");
	f.className = "crosschq-widget-portal", document.body.appendChild(f), d.provide(Nd, f), d.use(Ad, { queryClient: u }), d.mount(n);
	function p() {
		d.unmount(), u.clear(), f.remove();
	}
	return {
		destroy: p,
		update(t = {}) {
			return p(), VZ({
				...e,
				...t
			});
		}
	};
}
typeof window < "u" && (window.CrosschqWidget = {
	render: VZ,
	version: BZ
});
//#endregion
export { VZ as render, BZ as version };
